import { gql } from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: T[SubKey] };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: T[SubKey] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** Arbitrary object */
  Object: any;
};

export type AfpaFiltreModel = {
  __typename?: 'AFPAFiltreModel';
  Activite?: ActiviteBaseModel;
  ListeArticles?: ArrayOfArticleWithProduitModel;
  ListeFamilles?: ArrayOfFamilleWithActiviteModel;
  ListeProduit?: ArrayOfProduitBaseAvecIdFamilleModel;
};

export type AfpaFiltreModelInput = {
  Activite?: ActiviteBaseModelInput;
  ListeArticles?: ArrayOfArticleWithProduitModelInput;
  ListeFamilles?: ArrayOfFamilleWithActiviteModelInput;
  ListeProduit?: ArrayOfProduitBaseAvecIdFamilleModelInput;
};

export type AncvModeEnvoiDto = {
  __typename?: 'ANCVModeEnvoiDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AncvModeEnvoiDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AbondementEnregistrementAbondementInput = {
  DateEcriture?: any;
  IdCECible?: number;
  IdCECreePar?: number;
  IdCESource?: number;
  IdCaisse?: number;
  IdDossier?: number;
  IdEcriture?: number;
  IdJournal?: number;
  IdUtilisateur?: number;
  IsManuelle?: boolean;
  Libelle?: string;
  Montant?: number;
  Remarque?: string;
  TypeEcriture?: TypeEcritureInput;
};

export type AchatArticleGeneriqueModelDtoInput = {
  DateDebut?: any;
  DateFin?: any;
  IdActivite?: number;
  IdArticle?: number;
  IdFournisseur?: number;
  IsArticleChequierDynamique?: boolean;
  SelectedOperateur?: string;
};

export type AchatDevisCdeModelDto = {
  __typename?: 'AchatDevisCdeModelDTO';
  DateCommande?: any;
  ExerciceModel?: ExerciceModelDto;
  FraisCommissionFour?: number;
  IdCE?: number;
  IdCaisse?: number;
  IdCommande?: number;
  IdFournisseur?: number;
  IdOrigineCde?: number;
  IdPV?: number;
  ListeLigneCdeModel?: ArrayOfAchatLigneCdeModelDto;
  MontantFraiEnvoi?: number;
  MontantRG?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Objet?: string;
  RemarquePrive?: string;
  RemarquePublic?: string;
  Status?: StatusDtoEnum;
  TotalCde?: number;
  TypeFonc?: string;
};

export type AchatDevisCdeModelDtoInput = {
  DateCommande?: any;
  ExerciceModel?: ExerciceModelDtoInput;
  FraisCommissionFour?: number;
  IdCE?: number;
  IdCaisse?: number;
  IdCommande?: number;
  IdFournisseur?: number;
  IdOrigineCde?: number;
  IdPV?: number;
  ListeLigneCdeModel?: ArrayOfAchatLigneCdeModelDtoInput;
  MontantFraiEnvoi?: number;
  MontantRG?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Objet?: string;
  RemarquePrive?: string;
  RemarquePublic?: string;
  Status?: StatusDtoEnum;
  TotalCde?: number;
  TypeFonc?: string;
};

export type AchatFournisseurFinalModelDtoInput = {
  AchatDevisCdeModele?: AchatDevisCdeModelDtoInput;
  CompteAchatFourModel?: CompteModelDtoInput;
  CompteCollectifFourModel?: CompteModelDtoInput;
  DateDevis?: any;
  FraisCommission?: number;
  IdActivite?: number;
  IdCommandeUpdated?: number;
  IdCompteFraisCommission?: number;
  IdFournisseur?: number;
  IdStock?: number;
  JournalAchatModel?: JournalModelDtoInput;
  ListeAcompteModele?: ArrayOfReglementModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NumPiece?: string;
  Status?: StatusDtoEnum;
  TypeCommande?: string;
};

export type AchatFournisseurInitModelDto = {
  __typename?: 'AchatFournisseurInitModelDTO';
  AchatDevisCdeModele?: AchatDevisCdeModelDto;
  IdAcompte?: number;
  IdEcritureReglement?: number;
  IdStock?: number;
  IsCommandeFourLibre?: boolean;
  ListeAchatArticleModel?: ArrayOfArticleModelDto;
  ListeAchatFourModel?: ArrayOfFournisseurModelDto;
  ListeLigneDevisUpdate?: ArrayOfAchatLigneCdeModelDto;
  MontantAcompte?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AchatFournisseurInitModelDtoInput = {
  AchatDevisCdeModele?: AchatDevisCdeModelDtoInput;
  IdAcompte?: number;
  IdEcritureReglement?: number;
  IdStock?: number;
  IsCommandeFourLibre?: boolean;
  ListeAchatArticleModel?: ArrayOfArticleModelDtoInput;
  ListeAchatFourModel?: ArrayOfFournisseurModelDtoInput;
  ListeLigneDevisUpdate?: ArrayOfAchatLigneCdeModelDtoInput;
  MontantAcompte?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AchatLigneCdeModelDto = {
  __typename?: 'AchatLigneCdeModelDTO';
  IdArticle?: number;
  IdLigne?: number;
  IdLigneCmdClient?: number;
  IsArticleChequierDynamique?: boolean;
  IsCanExportCde?: boolean;
  IsCommandeReappro?: boolean;
  IsRemiseCumulable?: boolean;
  IsTransformeLgeDTO?: boolean;
  Libelle?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelllePrd?: string;
  ListeIdStkMvtReap?: ArrayOfdecimal;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixAchatUnitaire?: number;
  QuantiteCmd?: number;
  QuantiteLivre?: number;
  ReferenceLigneCmd?: string;
  RemarquePrive?: string;
  RemarquePublic?: string;
  RemiseGlobalFour?: number;
  RemiseUnitaireArticle?: number;
  Status?: StatusDtoEnum;
};

export type AchatLigneCdeModelDtoInput = {
  IdArticle?: number;
  IdLigne?: number;
  IdLigneCmdClient?: number;
  IsArticleChequierDynamique?: boolean;
  IsCanExportCde?: boolean;
  IsCommandeReappro?: boolean;
  IsRemiseCumulable?: boolean;
  IsTransformeLgeDTO?: boolean;
  Libelle?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelllePrd?: string;
  ListeIdStkMvtReap?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixAchatUnitaire?: number;
  QuantiteCmd?: number;
  QuantiteLivre?: number;
  ReferenceLigneCmd?: string;
  RemarquePrive?: string;
  RemarquePublic?: string;
  RemiseGlobalFour?: number;
  RemiseUnitaireArticle?: number;
  Status?: StatusDtoEnum;
};

export type AcompteModelDto = {
  __typename?: 'AcompteModelDTO';
  IdAcompte?: number;
  IdReglement?: number;
  IsImprimableLettreCheque?: boolean;
  JournalModel?: JournalModelDto;
  Libelle?: string;
  Montant?: number;
  MoyenPayementModel?: MoyenPayementModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AcompteModelDtoInput = {
  IdAcompte?: number;
  IdReglement?: number;
  IsImprimableLettreCheque?: boolean;
  JournalModel?: JournalModelDtoInput;
  Libelle?: string;
  Montant?: number;
  MoyenPayementModel?: MoyenPayementModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActionAExecuterModel = {
  __typename?: 'ActionAExecuterModel';
  EmailCopie?: string;
  EmailDestinataire?: string;
  IdAction?: number;
  IdModeleMailSelected?: number;
  IsSelected?: boolean;
  ListeCommission?: ArrayOfCommissionCommissionModel;
  ListeCommissionCopieCheck?: ArrayOfCommissionCommissionModel;
  ListeCommissionDestCheck?: ArrayOfCommissionCommissionModel;
  ListeIndexCommissionCopieCheck?: ArrayOfint;
  ListeIndexCommissionDestCheck?: ArrayOfint;
  ListeIndexUtilisateurCopieCheck?: ArrayOfint;
  ListeIndexUtilisateurDestCheck?: ArrayOfint;
  ListeModeleMail?: ArrayOfModelEmailModelEmailClotureModel;
  ListeStatutDisponible?: ArrayOfStatutPersoModel;
  ListeUtilisateur?: ArrayOfUserBaseModel;
  ListeUtilisateurCopieCheck?: ArrayOfUserBaseModel;
  ListeUtilisateurDestCheck?: ArrayOfUserBaseModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StatutSelected?: StatutPersoModel;
  TypeAction?: StatutPersoActionTypeModel;
  TypeEnvoiMail?: string;
};

export type ActionAExecuterModelInput = {
  EmailCopie?: string;
  EmailDestinataire?: string;
  IdAction?: number;
  IdModeleMailSelected?: number;
  IsSelected?: boolean;
  ListeCommission?: ArrayOfCommissionCommissionModelInput;
  ListeCommissionCopieCheck?: ArrayOfCommissionCommissionModelInput;
  ListeCommissionDestCheck?: ArrayOfCommissionCommissionModelInput;
  ListeIndexCommissionCopieCheck?: ArrayOfintInput;
  ListeIndexCommissionDestCheck?: ArrayOfintInput;
  ListeIndexUtilisateurCopieCheck?: ArrayOfintInput;
  ListeIndexUtilisateurDestCheck?: ArrayOfintInput;
  ListeModeleMail?: ArrayOfModelEmailModelEmailClotureModelInput;
  ListeStatutDisponible?: ArrayOfStatutPersoModelInput;
  ListeUtilisateur?: ArrayOfUserBaseModelInput;
  ListeUtilisateurCopieCheck?: ArrayOfUserBaseModelInput;
  ListeUtilisateurDestCheck?: ArrayOfUserBaseModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StatutSelected?: StatutPersoModelInput;
  TypeAction?: StatutPersoActionTypeModelInput;
  TypeEnvoiMail?: string;
};

export type ActionCommandesConcerneesModel = {
  __typename?: 'ActionCommandesConcerneesModel';
  IdActivite?: number;
  IdModelePublipostageBase?: number;
  IdTrigger?: number;
  ModelePublipostageCommandeConcernnee?: Union_33818115703809269357;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActionCommandesConcerneesModelInput = {
  IdActivite?: number;
  IdModelePublipostageBase?: number;
  IdTrigger?: number;
  ModelePublipostageCommandeConcernnee?: RequetePubliRequeteAvecCriteresModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActionDeclencheurModel = {
  __typename?: 'ActionDeclencheurModel';
  IdSelectedDeclencheur?: number;
  IsSelected?: boolean;
  ListeDeclencheursDisponibles?: ArrayOfRequetePubliRequeteBaseModel;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreJours?: number;
  Status?: StatusDtoEnum;
  Trigger?: StatutPersoTriggerTypeBaseModel;
};

export type ActionDeclencheurModelInput = {
  IdSelectedDeclencheur?: number;
  IsSelected?: boolean;
  ListeDeclencheursDisponibles?: ArrayOfRequetePubliRequeteBaseModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreJours?: number;
  Status?: StatusDtoEnum;
  Trigger?: StatutPersoTriggerTypeBaseModelInput;
};

export type ActionGroupesModelInput = {
  Cloturer?: boolean;
  DateDebutVente?: any;
  DateFinVente?: any;
  DateFinVenteIsNothing?: boolean;
  DeCloturer?: boolean;
  ListeIdArticle?: ArrayOfdecimalInput;
};

export type ActionReceptionPartielleMdkModelInput = {
  Action?: string;
  Auteur?: string;
  CodeExemplaire?: string;
  IdLigneCessionStock?: number;
  LibelleMedia?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeMedia?: string;
};

export type ActionStatutModel = {
  __typename?: 'ActionStatutModel';
  CommandesConcernees?: ActionCommandesConcerneesModel;
  IdActivite?: number;
  IdStatut?: number;
  IdTrigger?: number;
  IsStatutPerso?: boolean;
  ListeActionsAExecuter?: ArrayOfActionAExecuterModel;
  ListeActionsDeclencheur?: ArrayOfActionDeclencheurModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActionStatutModelInput = {
  CommandesConcernees?: ActionCommandesConcerneesModelInput;
  IdActivite?: number;
  IdStatut?: number;
  IdTrigger?: number;
  IsStatutPerso?: boolean;
  ListeActionsAExecuter?: ArrayOfActionAExecuterModelInput;
  ListeActionsDeclencheur?: ArrayOfActionDeclencheurModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActionsAnnulationReservation = {
  __typename?: 'ActionsAnnulationReservation';
  NeedGenererAvoir?: boolean;
  NeedSupprimerFacture?: boolean;
};

export type ActionsAnnulationReservationInput = {
  NeedGenererAvoir?: boolean;
  NeedSupprimerFacture?: boolean;
};

export type ActionsGroupeesCommandesModelInput = {
  DateFacturation?: any;
  IdExerciceOD?: number;
  IdJournal?: number;
  IdProchainStatut?: number;
  IsChangementStatut?: boolean;
  IsFacturationCommandes?: boolean;
  IsStatutPerso?: boolean;
  IsValidationCommandes?: boolean;
  ListeIdCommandes?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActionsGroupeesDossierPrestationModelDto = {
  __typename?: 'ActionsGroupeesDossierPrestationModelDTO';
  IdActivite?: number;
  IdCompteBancaire?: number;
  IdJournal?: number;
  IdJournalBeneficiaireParDefaut?: number;
  IdMoyenPaiement?: number;
  IsModuleSEPAActivated?: boolean;
  ListeCompteBancaire?: ArrayOfCompteBancaireModelDto;
  ListeEntetesDossierPrestation?: ArrayOfEnteteDevisCommandeModel;
  ListeIdDossierPrestation?: ArrayOfdecimal;
  ListeJournaux?: ArrayOfJournalModelDto;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementForVenteModeleDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActionsGroupeesDossierPrestationModelDtoInput = {
  IdActivite?: number;
  IdCompteBancaire?: number;
  IdJournal?: number;
  IdJournalBeneficiaireParDefaut?: number;
  IdMoyenPaiement?: number;
  IsModuleSEPAActivated?: boolean;
  ListeCompteBancaire?: ArrayOfCompteBancaireModelDtoInput;
  ListeEntetesDossierPrestation?: ArrayOfEnteteDevisCommandeModelInput;
  ListeIdDossierPrestation?: ArrayOfdecimalInput;
  ListeJournaux?: ArrayOfJournalModelDtoInput;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementForVenteModeleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActionsGroupeesModelInput = {
  GenererCommande?: boolean;
  GenererEcheancier?: boolean;
  IdCompteCollectif?: number;
  IdCompteCollectifPMV?: number;
  IdJournalOD?: number;
  ListeIdDossier?: ArrayOfdecimalInput;
  ListeIdDossierReglementComptant?: ArrayOfdecimalInput;
  ReglerFacturesCommande?: boolean;
  ValiderDossiers?: boolean;
};

export type ActionsGroupeesPretsEtDonsModelInput = {
  ActionSurPJDossierEnAttente?: TypeActionReglesEtPjEnum;
  ActionSurRegleDossierEnAttente?: TypeActionReglesEtPjEnum;
  IsAccepterDossiersEnAttente?: boolean;
  IsGenererReglementCE?: boolean;
  IsGenererTableauEcheancier?: boolean;
  ListeIdDossier?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActiviteAndCodeModel = {
  __typename?: 'ActiviteAndCodeModel';
  CodeActivite?: string;
  Id?: number;
  Libelle?: string;
};

export type ActiviteAndCodeModelInput = {
  CodeActivite?: string;
  Id?: number;
  Libelle?: string;
};

export type ActiviteBaseCodeModel = {
  __typename?: 'ActiviteBaseCodeModel';
  CodeActivite?: string;
  IdActivite?: number;
};

export type ActiviteBaseCodeModelInput = {
  CodeActivite?: string;
  IdActivite?: number;
};

export type ActiviteBaseModel = {
  __typename?: 'ActiviteBaseModel';
  Id?: number;
  Libelle?: string;
};

export type ActiviteBaseModelInput = {
  Id?: number;
  Libelle?: string;
};

export type ActiviteCompteBancaireDto = {
  __typename?: 'ActiviteCompteBancaireDTO';
  Activite?: ActiviteDto;
  ActiviteCompteBancaireType?: ActiviteCompteBancaireTypeDto;
  CeDelegation?: CeDelegationDto;
  CompteBancaire?: CompteBancaireDto;
  Id?: number;
  MoyenPaiement?: MoyenPaiementDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActiviteCompteBancaireDtoInput = {
  Activite?: ActiviteDtoInput;
  ActiviteCompteBancaireType?: ActiviteCompteBancaireTypeDtoInput;
  CeDelegation?: CeDelegationDtoInput;
  CompteBancaire?: CompteBancaireDtoInput;
  Id?: number;
  MoyenPaiement?: MoyenPaiementDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActiviteCompteBancaireModelDto = {
  __typename?: 'ActiviteCompteBancaireModelDTO';
  IdActivite?: number;
  IdActiviteCompteBancaireType?: number;
  IdCompteBancaire?: number;
  IdDelegation?: number;
  IdMoyenPaiement?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActiviteCompteBancaireModelDtoInput = {
  IdActivite?: number;
  IdActiviteCompteBancaireType?: number;
  IdCompteBancaire?: number;
  IdDelegation?: number;
  IdMoyenPaiement?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActiviteCompteBancaireTypeDto = {
  __typename?: 'ActiviteCompteBancaireTypeDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActiviteCompteBancaireTypeDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActiviteDto = {
  __typename?: 'ActiviteDTO';
  AfficherMention?: boolean;
  AutoriserAvoirAutreActivite?: boolean;
  AutoriserPaiementDiffereDirecto?: boolean;
  AutoriserPaiementDiffereGestion?: boolean;
  CEDelegationProprietaire?: CeDelegationDto;
  Code?: string;
  Commission?: CommissionDto;
  CompteCollectifAcompteClient?: CompteDto;
  CompteCollectifAcompteFour?: CompteDto;
  CompteCollectifClient?: CompteDto;
  CompteCollectifFourniseur?: CompteDto;
  CompteFraisPortAchat?: CompteDto;
  CompteFraisPortVente?: CompteDto;
  CptTropPercu?: CompteDto;
  Enveloppe?: EnveloppeQuotaDto;
  FichierVenteGen?: FichierModel;
  Id?: number;
  IdcDirectoVisible?: boolean;
  ImageActivite?: FichierModel;
  IsActivitePrivee?: boolean;
  IsCloture?: boolean;
  IsFacturationCentralise?: boolean;
  IsTVA?: boolean;
  Journal3?: JournalDto;
  JournalAchat?: JournalDto;
  JournalVente?: JournalDto;
  Libelle?: string;
  ListeActiviteCompteBancaire?: ArrayOfActiviteCompteBancaireDto;
  ListeCEDelegation?: ArrayOfCeDelegationDto;
  ListeChamps?: ArrayOfChampDto;
  ListeChampsValeur?: ArrayOfChampValeurDto;
  ListeCompteursPoints?: ArrayOfCompteurPointAfpaModel;
  ListeEnvImpActivite?: ArrayOfEnvImpActiviteDto;
  ListeFacture?: ArrayOfFactureDto;
  ListeFamille?: ArrayOfFamilleProduitDto;
  ListeMenus?: ArrayOfMenuDto;
  ListeMoteurRegleHeriatgeActivite?: ArrayOfMoteurRegleHeritageActiviteDto;
  ListeMoteurRegleUseActivite?: ArrayOfMoteurRegleUseActiviteDto;
  ListeMoyenPaiementActivite?: ArrayOfMoyenPaiementActiviteDto;
  ListePV?: ArrayOfPointVenteDto;
  MentionLegale?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NBChoix?: number;
  Picto?: FichierModel;
  PrestaLibelleCadeauxEnLigne?: string;
  PrestaLibellePACEnLigne?: string;
  PrestaLibelleRemboursementEnLigne?: string;
  PrestaLibelleRmbMensuelEnLigne?: string;
  Status?: StatusDtoEnum;
  TypeActivite?: TypeActiviteDto;
};

export type ActiviteDtoInput = {
  AfficherMention?: boolean;
  AutoriserAvoirAutreActivite?: boolean;
  AutoriserPaiementDiffereDirecto?: boolean;
  AutoriserPaiementDiffereGestion?: boolean;
  CEDelegationProprietaire?: CeDelegationDtoInput;
  Code?: string;
  Commission?: CommissionDtoInput;
  CompteCollectifAcompteClient?: CompteDtoInput;
  CompteCollectifAcompteFour?: CompteDtoInput;
  CompteCollectifClient?: CompteDtoInput;
  CompteCollectifFourniseur?: CompteDtoInput;
  CompteFraisPortAchat?: CompteDtoInput;
  CompteFraisPortVente?: CompteDtoInput;
  CptTropPercu?: CompteDtoInput;
  Enveloppe?: EnveloppeQuotaDtoInput;
  FichierVenteGen?: FichierModelInput;
  Id?: number;
  IdcDirectoVisible?: boolean;
  ImageActivite?: FichierModelInput;
  IsActivitePrivee?: boolean;
  IsCloture?: boolean;
  IsFacturationCentralise?: boolean;
  IsTVA?: boolean;
  Journal3?: JournalDtoInput;
  JournalAchat?: JournalDtoInput;
  JournalVente?: JournalDtoInput;
  Libelle?: string;
  ListeActiviteCompteBancaire?: ArrayOfActiviteCompteBancaireDtoInput;
  ListeCEDelegation?: ArrayOfCeDelegationDtoInput;
  ListeChamps?: ArrayOfChampDtoInput;
  ListeChampsValeur?: ArrayOfChampValeurDtoInput;
  ListeCompteursPoints?: ArrayOfCompteurPointAfpaModelInput;
  ListeEnvImpActivite?: ArrayOfEnvImpActiviteDtoInput;
  ListeFacture?: ArrayOfFactureDtoInput;
  ListeFamille?: ArrayOfFamilleProduitDtoInput;
  ListeMenus?: ArrayOfMenuDtoInput;
  ListeMoteurRegleHeriatgeActivite?: ArrayOfMoteurRegleHeritageActiviteDtoInput;
  ListeMoteurRegleUseActivite?: ArrayOfMoteurRegleUseActiviteDtoInput;
  ListeMoyenPaiementActivite?: ArrayOfMoyenPaiementActiviteDtoInput;
  ListePV?: ArrayOfPointVenteDtoInput;
  MentionLegale?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NBChoix?: number;
  Picto?: FichierModelInput;
  PrestaLibelleCadeauxEnLigne?: string;
  PrestaLibellePACEnLigne?: string;
  PrestaLibelleRemboursementEnLigne?: string;
  PrestaLibelleRmbMensuelEnLigne?: string;
  Status?: StatusDtoEnum;
  TypeActivite?: TypeActiviteDtoInput;
};

export type ActiviteFamillesLienDirectoModelDto = {
  __typename?: 'ActiviteFamillesLienDirectoModelDTO';
  IdActivite?: number;
  IdLien?: number;
  LibelleActivite?: string;
  ListeFamille?: ArrayOfFamilleProduitSimpleModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActiviteFamillesLienDirectoModelDtoInput = {
  IdActivite?: number;
  IdLien?: number;
  LibelleActivite?: string;
  ListeFamille?: ArrayOfFamilleProduitSimpleModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActiviteJournauxModel = {
  __typename?: 'ActiviteJournauxModel';
  IdActivite?: number;
  IdJournalAchat?: number;
  IdJournalRemboursement?: number;
  IdJournalVente?: number;
  LibelleActivite?: string;
};

export type ActiviteJournauxModelInput = {
  IdActivite?: number;
  IdJournalAchat?: number;
  IdJournalRemboursement?: number;
  IdJournalVente?: number;
  LibelleActivite?: string;
};

export type ActiviteLightModel = {
  __typename?: 'ActiviteLightModel';
  Id?: number;
  Libelle?: string;
};

export type ActiviteLightModelInput = {
  Id?: number;
  Libelle?: string;
};

export type ActiviteModel = {
  __typename?: 'ActiviteModel';
  ID?: number;
  IsCloture?: boolean;
  Libelle?: string;
  ListFamille?: ArrayOfFamilleProduitModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActiviteModelInput = {
  ID?: number;
  IsCloture?: boolean;
  Libelle?: string;
  ListFamille?: ArrayOfFamilleProduitModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ActiviteParamAfpaModel = {
  __typename?: 'ActiviteParamAFPAModel';
  CodeTypeActivite?: string;
  IdActivite?: number;
  IdDelegationProprietaire?: number;
  LibelleActivite?: string;
};

export type ActiviteParamAfpaModelInput = {
  CodeTypeActivite?: string;
  IdActivite?: number;
  IdDelegationProprietaire?: number;
  LibelleActivite?: string;
};

export type ActualiteMobileEditionModelDto = {
  __typename?: 'ActualiteMobileEditionModelDTO';
  Corps?: string;
  DateCreation?: any;
  DateEnvoi?: any;
  IdActu?: number;
  IdCE?: number;
  IdImage?: number;
  IdUserCreation?: number;
  IdUserModification?: number;
  Image?: FichierModel;
  IsClos?: boolean;
  IsEnvoyee?: boolean;
  IsResumePerso?: boolean;
  IsVisible?: boolean;
  ListeIdImagesEmbarqueesAjoutees?: ArrayOfint;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TexteBrut?: string;
  Titre?: string;
  UserNomCreation?: string;
  UserNomEnvoi?: string;
  UserPrenomCreation?: string;
  UserPrenomEnvoi?: string;
};

export type ActualiteMobileEditionModelDtoInput = {
  Corps?: string;
  DateCreation?: any;
  DateEnvoi?: any;
  IdActu?: number;
  IdCE?: number;
  IdImage?: number;
  IdUserCreation?: number;
  IdUserModification?: number;
  Image?: FichierModelInput;
  IsClos?: boolean;
  IsEnvoyee?: boolean;
  IsResumePerso?: boolean;
  IsVisible?: boolean;
  ListeIdImagesEmbarqueesAjoutees?: ArrayOfintInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TexteBrut?: string;
  Titre?: string;
  UserNomCreation?: string;
  UserNomEnvoi?: string;
  UserPrenomCreation?: string;
  UserPrenomEnvoi?: string;
};

export type ActualiteMobileListeModelDto = {
  __typename?: 'ActualiteMobileListeModelDTO';
  DateEnvoi?: any;
  IdActu?: number;
  IdDelegation?: number;
  IsCloturee?: boolean;
  IsDelegationGlobale?: boolean;
  IsEnCoursEnvoi?: boolean;
  IsEnvoyee?: boolean;
  IsVisible?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
};

export type ActualiteMobileListeModelDtoInput = {
  DateEnvoi?: any;
  IdActu?: number;
  IdDelegation?: number;
  IsCloturee?: boolean;
  IsDelegationGlobale?: boolean;
  IsEnCoursEnvoi?: boolean;
  IsEnvoyee?: boolean;
  IsVisible?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
};

export type AdresseDto = {
  __typename?: 'AdresseDTO';
  CodePostal?: string;
  Id?: number;
  IdVille?: number;
  IsCloture?: boolean;
  Latitude?: number;
  Ligne1?: string;
  Ligne2?: string;
  Ligne3?: string;
  Ligne4?: string;
  Longitude?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Ville?: VilleDto;
};

export type AdresseDtoInput = {
  CodePostal?: string;
  Id?: number;
  IdVille?: number;
  IsCloture?: boolean;
  Latitude?: number;
  Ligne1?: string;
  Ligne2?: string;
  Ligne3?: string;
  Ligne4?: string;
  Longitude?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Ville?: VilleDtoInput;
};

export type AdresseFigeDto = {
  __typename?: 'AdresseFigeDTO';
  Adr1?: string;
  Adr2?: string;
  Adr3?: string;
  Adr4?: string;
  Adr5?: string;
  Adr6?: string;
  Adr7?: string;
  Adr8?: string;
  Adr9?: string;
  Adr10?: string;
  Adr11?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AdresseFigeDtoInput = {
  Adr1?: string;
  Adr2?: string;
  Adr3?: string;
  Adr4?: string;
  Adr5?: string;
  Adr6?: string;
  Adr7?: string;
  Adr8?: string;
  Adr9?: string;
  Adr10?: string;
  Adr11?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export enum AffichagePlanComptableEnum {
  F = 'F',
  S = 'S',
  Sf = 'SF'
}

export type AgendaDto = {
  __typename?: 'AgendaDTO';
  CEDelegation?: CeDelegationDto;
  DateEvent?: any;
  Description?: string;
  Id?: number;
  IsAgendaEnLigne?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
  User?: UsersDto;
};

export type AgendaDtoInput = {
  CEDelegation?: CeDelegationDtoInput;
  DateEvent?: any;
  Description?: string;
  Id?: number;
  IsAgendaEnLigne?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
  User?: UsersDtoInput;
};

export type AjoutLigneCommandePrestationModelDtoInput = {
  DateDebutActivite?: any;
  DateFacture?: any;
  DateFinActivite?: any;
  IdBenef?: number;
  IdDossierPrestation?: number;
  IdFormule?: number;
  IsAccepte?: boolean;
  ListePieceJustificative?: ArrayOfPieceJustificativeBenefModelInput;
  ListeSubComplementaire?: ArrayOfSubventionAccordeeModelDtoInput;
  MontantPresente?: number;
  MontantPrisEnCompte?: number;
  MontantRembourse?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreUnitePresente?: number;
  NombreUnitePrisEnCompte?: number;
  QuantitePresente?: number;
  QuantitePrisEnCompte?: number;
  QuantiteRemboursee?: number;
  ReferenceFacture?: string;
  Status?: StatusDtoEnum;
  TextBenef?: string;
};

export type AjoutOuSupCptSectionAnaPosteBudgetaireModelDtoInput = {
  IdBudget?: number;
  IdPosteBDG?: number;
  IsCompta?: boolean;
  ListeIdCptOrSectionAna?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export enum AjouterLigneCdeRetourStockEnum {
  AnneeReferenceNonTrouvee = 'AnneeReferenceNonTrouvee',
  ArticleChqDynaErreurParam = 'ArticleChqDynaErreurParam',
  ArticleChqDynaSubEpuise = 'ArticleChqDynaSubEpuise',
  ArticleDateReapproVide = 'ArticleDateReapproVide',
  ArticleGeneriqueNonRenseigne = 'ArticleGeneriqueNonRenseigne',
  CommandeEnCoursDePaiement = 'CommandeEnCoursDePaiement',
  DatesArticleNonValides = 'DatesArticleNonValides',
  DepassementStockAutoriseAvecAvertissement = 'DepassementStockAutoriseAvecAvertissement',
  DestockageArticleImpossible = 'DestockageArticleImpossible',
  FormulaireNonRempli = 'FormulaireNonRempli',
  None = 'None',
  PrixVenteVide = 'PrixVenteVide',
  ProduitCommandeGroupeDifferent = 'ProduitCommandeGroupeDifferent',
  SessionChoixComplete = 'SessionChoixComplete',
  SubventionBaseIncorrecte = 'SubventionBaseIncorrecte',
  SubventionComplementaireIncorrecte = 'SubventionComplementaireIncorrecte'
}

export type AjouterModifierNewsletterThemeModelInput = {
  Description?: string;
  Id?: number;
  IdCe?: number;
  Libelle?: string;
};

export type AlertesDto = {
  __typename?: 'AlertesDTO';
  Code?: string;
  Description?: string;
  Id?: number;
  IsChecked?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AlertesDtoInput = {
  Code?: string;
  Description?: string;
  Id?: number;
  IsChecked?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AnneeReferenceBaseModel = {
  __typename?: 'AnneeReferenceBaseModel';
  Id?: number;
  IsAnneeRefCourante?: boolean;
  Valeur?: string;
};

export type AnneeReferenceBaseModelInput = {
  Id?: number;
  IsAnneeRefCourante?: boolean;
  Valeur?: string;
};

export type AnneeReferenceDto = {
  __typename?: 'AnneeReferenceDTO';
  Code?: string;
  DateArchive?: any;
  DateDeb?: any;
  DateFin?: any;
  Id?: number;
  IsArchive?: boolean;
  ListeAnneeReferenceValidation?: ArrayOfAnneeReferenceValidationBenefDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AnneeReferenceDtoInput = {
  Code?: string;
  DateArchive?: any;
  DateDeb?: any;
  DateFin?: any;
  Id?: number;
  IsArchive?: boolean;
  ListeAnneeReferenceValidation?: ArrayOfAnneeReferenceValidationBenefDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AnneeReferenceReportAnneeReferenceModelInput = {
  CodeActionDonneeExistante?: string;
  IdAnneeCible?: number;
  IdAnneeSource?: number;
  IdUtilisateur?: number;
  ListeIdCriteresSociaux?: ArrayOfdecimalInput;
  ValidateAnneeCibleData?: number;
};

export type AnneeReferenceValidationBenefDto = {
  __typename?: 'AnneeReferenceValidationBenefDTO';
  AnneeReference?: AnneeReferenceDto;
  Benef?: BenefDto;
  DateValide?: any;
  IsValide?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AnneeReferenceValidationBenefDtoInput = {
  AnneeReference?: AnneeReferenceDtoInput;
  Benef?: BenefDtoInput;
  DateValide?: any;
  IsValide?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AnneeReferenceValideModel = {
  __typename?: 'AnneeReferenceValideModel';
  DateArchivage?: any;
  DateDebut?: any;
  DateFin?: any;
  Id?: number;
  IsAnneeRefCourante?: boolean;
  IsAnneeValide?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type AnneeReferenceValideModelInput = {
  DateArchivage?: any;
  DateDebut?: any;
  DateFin?: any;
  Id?: number;
  IsAnneeRefCourante?: boolean;
  IsAnneeValide?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type AnnonceBenefContactDto = {
  __typename?: 'AnnonceBenefContactDTO';
  Annonce?: AnnonceDto;
  Beneficiaire?: BenefDto;
  DateContact?: any;
  EmailReponse?: string;
  Message?: string;
  MotifContact?: ChampListeValeurDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AnnonceBenefContactDtoInput = {
  Annonce?: AnnonceDtoInput;
  Beneficiaire?: BenefDtoInput;
  DateContact?: any;
  EmailReponse?: string;
  Message?: string;
  MotifContact?: ChampListeValeurDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AnnonceCategChampDto = {
  __typename?: 'AnnonceCategChampDTO';
  AnnonceCategorie?: AnnonceCategorieDto;
  Champ?: ChampDto;
  EstObligatoire?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AnnonceCategChampDtoInput = {
  AnnonceCategorie?: AnnonceCategorieDtoInput;
  Champ?: ChampDtoInput;
  EstObligatoire?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AnnonceCategorieDto = {
  __typename?: 'AnnonceCategorieDTO';
  AnnonceCategChamp?: ArrayOfAnnonceCategChampDto;
  AnnonceCategorieUserGest?: ArrayOfAnnonceCategorieUserGestDto;
  AnnoncePrix?: ArrayOfAnnoncePrixDto;
  CeDelegation?: CeDelegationDto;
  Code?: string;
  DateCloture?: any;
  DateMiseAJour?: any;
  Description?: string;
  Id?: number;
  Image?: FichierModel;
  IsClos?: boolean;
  IsValidationAuto?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Picto?: FichierModel;
  Status?: StatusDtoEnum;
  User?: UsersDto;
};

export type AnnonceCategorieDtoInput = {
  AnnonceCategChamp?: ArrayOfAnnonceCategChampDtoInput;
  AnnonceCategorieUserGest?: ArrayOfAnnonceCategorieUserGestDtoInput;
  AnnoncePrix?: ArrayOfAnnoncePrixDtoInput;
  CeDelegation?: CeDelegationDtoInput;
  Code?: string;
  DateCloture?: any;
  DateMiseAJour?: any;
  Description?: string;
  Id?: number;
  Image?: FichierModelInput;
  IsClos?: boolean;
  IsValidationAuto?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Picto?: FichierModelInput;
  Status?: StatusDtoEnum;
  User?: UsersDtoInput;
};

export type AnnonceCategorieUserGestDto = {
  __typename?: 'AnnonceCategorieUserGestDTO';
  AnnonceCategorie?: AnnonceCategorieDto;
  IsEnvoiEmailCreation?: boolean;
  IsEnvoiEmailMaj?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: UsersDto;
};

export type AnnonceCategorieUserGestDtoInput = {
  AnnonceCategorie?: AnnonceCategorieDtoInput;
  IsEnvoiEmailCreation?: boolean;
  IsEnvoiEmailMaj?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: UsersDtoInput;
};

export type AnnonceChampValeurDto = {
  __typename?: 'AnnonceChampValeurDTO';
  Annonce?: AnnonceDto;
  Champ?: ChampDto;
  ChampListValeur?: ChampListeValeurDto;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type AnnonceChampValeurDtoInput = {
  Annonce?: AnnonceDtoInput;
  Champ?: ChampDtoInput;
  ChampListValeur?: ChampListeValeurDtoInput;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type AnnonceChampValeurModelDto = {
  __typename?: 'AnnonceChampValeurModelDTO';
  Intitule?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
  ValeurListeVal?: string;
};

export type AnnonceChampValeurModelDtoInput = {
  Intitule?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
  ValeurListeVal?: string;
};

export type AnnonceDto = {
  __typename?: 'AnnonceDTO';
  AdresseArrivee?: AdresseDto;
  AdresseDepart?: AdresseDto;
  Beneficiaire?: BenefDto;
  Categorie?: AnnonceCategorieDto;
  ContrePartieProposee?: string;
  DatMajUser?: any;
  DateCloture?: any;
  DateCreation?: any;
  DateDebutPublication?: any;
  DateFinPublication?: any;
  DateMajBenef?: any;
  DateValidation?: any;
  Description?: string;
  Email?: string;
  Id?: number;
  IsAdresseAffichee?: boolean;
  IsAnnonceValidee?: boolean;
  IsClos?: boolean;
  IsContactEmailPossible?: boolean;
  IsContactTelephonePossible?: boolean;
  IsEmailVisible?: boolean;
  IsNomPrenomVisible?: boolean;
  ListeAnnonceChampVal?: ArrayOfAnnonceChampValeurDto;
  ListeAnnonceDocuments?: ArrayOfFichierModel;
  ListeBenefContact?: ArrayOfAnnonceBenefContactDto;
  MontantPropose?: number;
  MotifCloture?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroTelephoneBureau?: string;
  NumeroTelephoneDomicile?: string;
  NumeroTelephoneGSM?: string;
  OffreDemande?: string;
  PrixAPayerPourBenef?: number;
  RemarqueDisponibilites?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
  TypeAnnonce?: AnnonceTypeDto;
  UserMaj?: UsersDto;
  UserValidation?: UsersDto;
};

export type AnnonceDtoInput = {
  AdresseArrivee?: AdresseDtoInput;
  AdresseDepart?: AdresseDtoInput;
  Beneficiaire?: BenefDtoInput;
  Categorie?: AnnonceCategorieDtoInput;
  ContrePartieProposee?: string;
  DatMajUser?: any;
  DateCloture?: any;
  DateCreation?: any;
  DateDebutPublication?: any;
  DateFinPublication?: any;
  DateMajBenef?: any;
  DateValidation?: any;
  Description?: string;
  Email?: string;
  Id?: number;
  IsAdresseAffichee?: boolean;
  IsAnnonceValidee?: boolean;
  IsClos?: boolean;
  IsContactEmailPossible?: boolean;
  IsContactTelephonePossible?: boolean;
  IsEmailVisible?: boolean;
  IsNomPrenomVisible?: boolean;
  ListeAnnonceChampVal?: ArrayOfAnnonceChampValeurDtoInput;
  ListeAnnonceDocuments?: ArrayOfFichierModelInput;
  ListeBenefContact?: ArrayOfAnnonceBenefContactDtoInput;
  MontantPropose?: number;
  MotifCloture?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroTelephoneBureau?: string;
  NumeroTelephoneDomicile?: string;
  NumeroTelephoneGSM?: string;
  OffreDemande?: string;
  PrixAPayerPourBenef?: number;
  RemarqueDisponibilites?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
  TypeAnnonce?: AnnonceTypeDtoInput;
  UserMaj?: UsersDtoInput;
  UserValidation?: UsersDtoInput;
};

export type AnnonceDetailsModelDto = {
  __typename?: 'AnnonceDetailsModelDTO';
  AdresseLigne1?: string;
  AdresseLigne2?: string;
  AdresseLigne3?: string;
  AdresseLigne4?: string;
  AnnonceContrePartie?: string;
  AnnonceDateMiseEnLigne?: any;
  AnnonceDescription?: string;
  AnnonceId?: number;
  AnnonceMontant?: number;
  AnnonceTitre?: string;
  AnnonceurEmail?: string;
  AnnonceurMatricule?: string;
  AnnonceurNom?: string;
  AnnonceurPrenom?: string;
  AnnonceurTelephoneFixe?: string;
  AnnonceurTelephoneMobile?: string;
  Categorie?: string;
  CategorieImage?: string;
  CodePostal?: string;
  ListeChampsValeurs?: ArrayOfAnnonceChampValeurModelDto;
  ListeDocuments?: ArrayOfFichierModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Ville?: string;
};

export type AnnonceDetailsModelDtoInput = {
  AdresseLigne1?: string;
  AdresseLigne2?: string;
  AdresseLigne3?: string;
  AdresseLigne4?: string;
  AnnonceContrePartie?: string;
  AnnonceDateMiseEnLigne?: any;
  AnnonceDescription?: string;
  AnnonceId?: number;
  AnnonceMontant?: number;
  AnnonceTitre?: string;
  AnnonceurEmail?: string;
  AnnonceurMatricule?: string;
  AnnonceurNom?: string;
  AnnonceurPrenom?: string;
  AnnonceurTelephoneFixe?: string;
  AnnonceurTelephoneMobile?: string;
  Categorie?: string;
  CategorieImage?: string;
  CodePostal?: string;
  ListeChampsValeurs?: ArrayOfAnnonceChampValeurModelDtoInput;
  ListeDocuments?: ArrayOfFichierModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Ville?: string;
};

export type AnnoncePrixDto = {
  __typename?: 'AnnoncePrixDTO';
  Categorie?: AnnonceCategorieDto;
  Id?: number;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypePeriode?: string;
};

export type AnnoncePrixDtoInput = {
  Categorie?: AnnonceCategorieDtoInput;
  Id?: number;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypePeriode?: string;
};

export type AnnonceTypeDto = {
  __typename?: 'AnnonceTypeDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AnnonceTypeDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AnnulationReservationModelInput = {
  AnnulerCommandeModel?: any;
  InfosCreationAvoir?: any;
};

export type AnnulerCommandeADateModelInput = {
  DateAnnulation?: any;
  IdCommande?: number;
  IdUtilisateur?: number;
  RemarquePrivee?: string;
};

export type AnnulerCommandeBaseModelInput = {
  IdCommande?: number;
  RemarquePrivee?: string;
};

export type AnnulerCommandeModelInput = {
  DateAnnulation?: any;
  IdCommande?: number;
  IdCurrentDeleg?: number;
  IdUtilisateur?: number;
  IsComptaSeparee?: boolean;
  NeedGenererAvoir?: boolean;
  NeedSupprimerFacture?: boolean;
  RemarquePrivee?: string;
};

export type AppMobileInfosModel = {
  __typename?: 'AppMobileInfosModel';
  Identification?: number;
  IsCodeBarres?: boolean;
  ListeIdentificationAndLibelle?: ArrayOfKeyValueOfdecimalstring;
  MustValidate?: boolean;
  MyGuid?: string;
  NomCE?: string;
  Status?: StatusDtoEnum;
};

export type AppMobileInfosModelInput = {
  Identification?: number;
  IsCodeBarres?: boolean;
  ListeIdentificationAndLibelle?: ArrayOfKeyValueOfdecimalstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NomCE?: string;
  Status?: StatusDtoEnum;
};

export type AppMobileNombreInscritsModelDto = {
  __typename?: 'AppMobileNombreInscritsModelDTO';
  NbBenef?: number;
  NbDevices?: number;
};

export type AppMobileNombreInscritsModelDtoInput = {
  NbBenef?: number;
  NbDevices?: number;
};

export type AppelComplementaireReglementModelDto = {
  __typename?: 'AppelComplementaireReglementModelDTO';
  ListeCompte?: ArrayOfCompteDto;
  ListeCompteBancaire?: ArrayOfCompteBancaireDto;
  ListeCompteJournalPRMAuto?: ArrayOfCompteJournalPrmAutoDto;
  ListeCompteJournalPRMAutoFidu?: ArrayOfCompteJournalPrmAutoFiduDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AppelComplementaireReglementModelDtoInput = {
  ListeCompte?: ArrayOfCompteDtoInput;
  ListeCompteBancaire?: ArrayOfCompteBancaireDtoInput;
  ListeCompteJournalPRMAuto?: ArrayOfCompteJournalPrmAutoDtoInput;
  ListeCompteJournalPRMAutoFidu?: ArrayOfCompteJournalPrmAutoFiduDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ArrayOfAncvModeEnvoiDto = {
  __typename?: 'ArrayOfANCVModeEnvoiDTO';
  ANCVModeEnvoiDTO?: Array<AncvModeEnvoiDto>;
};

export type ArrayOfAncvModeEnvoiDtoInput = {
  ANCVModeEnvoiDTO?: Array<AncvModeEnvoiDtoInput>;
};

export type ArrayOfAchatLigneCdeModelDto = {
  __typename?: 'ArrayOfAchatLigneCdeModelDTO';
  AchatLigneCdeModelDTO?: Array<AchatLigneCdeModelDto>;
};

export type ArrayOfAchatLigneCdeModelDtoInput = {
  AchatLigneCdeModelDTO?: Array<AchatLigneCdeModelDtoInput>;
};

export type ArrayOfAcompteModelDto = {
  __typename?: 'ArrayOfAcompteModelDTO';
  AcompteModelDTO?: Array<AcompteModelDto>;
};

export type ArrayOfAcompteModelDtoInput = {
  AcompteModelDTO?: Array<AcompteModelDtoInput>;
};

export type ArrayOfActionAExecuterModel = {
  __typename?: 'ArrayOfActionAExecuterModel';
  ActionAExecuterModel?: Array<ActionAExecuterModel>;
};

export type ArrayOfActionAExecuterModelInput = {
  ActionAExecuterModel?: Array<ActionAExecuterModelInput>;
};

export type ArrayOfActionDeclencheurModel = {
  __typename?: 'ArrayOfActionDeclencheurModel';
  ActionDeclencheurModel?: Array<ActionDeclencheurModel>;
};

export type ArrayOfActionDeclencheurModelInput = {
  ActionDeclencheurModel?: Array<ActionDeclencheurModelInput>;
};

export type ArrayOfActionReceptionPartielleMdkModelInput = {
  ActionReceptionPartielleMDKModel?: Array<ActionReceptionPartielleMdkModelInput>;
};

export type ArrayOfActiviteAndCodeModel = {
  __typename?: 'ArrayOfActiviteAndCodeModel';
  ActiviteAndCodeModel?: Array<ActiviteAndCodeModel>;
};

export type ArrayOfActiviteAndCodeModelInput = {
  ActiviteAndCodeModel?: Array<ActiviteAndCodeModelInput>;
};

export type ArrayOfActiviteBaseCodeModel = {
  __typename?: 'ArrayOfActiviteBaseCodeModel';
  ActiviteBaseCodeModel?: Array<ActiviteBaseCodeModel>;
};

export type ArrayOfActiviteBaseCodeModelInput = {
  ActiviteBaseCodeModel?: Array<ActiviteBaseCodeModelInput>;
};

export type ArrayOfActiviteBaseModel = {
  __typename?: 'ArrayOfActiviteBaseModel';
  ActiviteBaseModel?: Array<ActiviteBaseModel>;
};

export type ArrayOfActiviteBaseModelInput = {
  ActiviteBaseModel?: Array<ActiviteBaseModelInput>;
};

export type ArrayOfActiviteCompteBancaireDto = {
  __typename?: 'ArrayOfActiviteCompteBancaireDTO';
  ActiviteCompteBancaireDTO?: Array<ActiviteCompteBancaireDto>;
};

export type ArrayOfActiviteCompteBancaireDtoInput = {
  ActiviteCompteBancaireDTO?: Array<ActiviteCompteBancaireDtoInput>;
};

export type ArrayOfActiviteCompteBancaireModelDto = {
  __typename?: 'ArrayOfActiviteCompteBancaireModelDTO';
  ActiviteCompteBancaireModelDTO?: Array<ActiviteCompteBancaireModelDto>;
};

export type ArrayOfActiviteCompteBancaireModelDtoInput = {
  ActiviteCompteBancaireModelDTO?: Array<ActiviteCompteBancaireModelDtoInput>;
};

export type ArrayOfActiviteCompteBancaireTypeDto = {
  __typename?: 'ArrayOfActiviteCompteBancaireTypeDTO';
  ActiviteCompteBancaireTypeDTO?: Array<ActiviteCompteBancaireTypeDto>;
};

export type ArrayOfActiviteCompteBancaireTypeDtoInput = {
  ActiviteCompteBancaireTypeDTO?: Array<ActiviteCompteBancaireTypeDtoInput>;
};

export type ArrayOfActiviteDto = {
  __typename?: 'ArrayOfActiviteDTO';
  ActiviteDTO?: Array<ActiviteDto>;
};

export type ArrayOfActiviteDtoInput = {
  ActiviteDTO?: Array<ActiviteDtoInput>;
};

export type ArrayOfActiviteFamillesLienDirectoModelDto = {
  __typename?: 'ArrayOfActiviteFamillesLienDirectoModelDTO';
  ActiviteFamillesLienDirectoModelDTO?: Array<ActiviteFamillesLienDirectoModelDto>;
};

export type ArrayOfActiviteFamillesLienDirectoModelDtoInput = {
  ActiviteFamillesLienDirectoModelDTO?: Array<ActiviteFamillesLienDirectoModelDtoInput>;
};

export type ArrayOfActiviteLightModel = {
  __typename?: 'ArrayOfActiviteLightModel';
  ActiviteLightModel?: Array<ActiviteLightModel>;
};

export type ArrayOfActiviteLightModelInput = {
  ActiviteLightModel?: Array<ActiviteLightModelInput>;
};

export type ArrayOfActiviteModel = {
  __typename?: 'ArrayOfActiviteModel';
  ActiviteModel?: Array<ActiviteModel>;
};

export type ArrayOfActiviteModelInput = {
  ActiviteModel?: Array<ActiviteModelInput>;
};

export type ArrayOfActualiteMobileListeModelDto = {
  __typename?: 'ArrayOfActualiteMobileListeModelDTO';
  ActualiteMobileListeModelDTO?: Array<ActualiteMobileListeModelDto>;
};

export type ArrayOfActualiteMobileListeModelDtoInput = {
  ActualiteMobileListeModelDTO?: Array<ActualiteMobileListeModelDtoInput>;
};

export type ArrayOfAdresseDto = {
  __typename?: 'ArrayOfAdresseDTO';
  AdresseDTO?: Array<AdresseDto>;
};

export type ArrayOfAdresseDtoInput = {
  AdresseDTO?: Array<AdresseDtoInput>;
};

export type ArrayOfAgendaDto = {
  __typename?: 'ArrayOfAgendaDTO';
  AgendaDTO?: Array<AgendaDto>;
};

export type ArrayOfAgendaDtoInput = {
  AgendaDTO?: Array<AgendaDtoInput>;
};

export type ArrayOfAlertesDto = {
  __typename?: 'ArrayOfAlertesDTO';
  AlertesDTO?: Array<AlertesDto>;
};

export type ArrayOfAlertesDtoInput = {
  AlertesDTO?: Array<AlertesDtoInput>;
};

export type ArrayOfAnneeReferenceBaseModel = {
  __typename?: 'ArrayOfAnneeReferenceBaseModel';
  AnneeReferenceBaseModel?: Array<AnneeReferenceBaseModel>;
};

export type ArrayOfAnneeReferenceBaseModelInput = {
  AnneeReferenceBaseModel?: Array<AnneeReferenceBaseModelInput>;
};

export type ArrayOfAnneeReferenceDto = {
  __typename?: 'ArrayOfAnneeReferenceDTO';
  AnneeReferenceDTO?: Array<AnneeReferenceDto>;
};

export type ArrayOfAnneeReferenceDtoInput = {
  AnneeReferenceDTO?: Array<AnneeReferenceDtoInput>;
};

export type ArrayOfAnneeReferenceValidationBenefDto = {
  __typename?: 'ArrayOfAnneeReferenceValidationBenefDTO';
  AnneeReferenceValidationBenefDTO?: Array<AnneeReferenceValidationBenefDto>;
};

export type ArrayOfAnneeReferenceValidationBenefDtoInput = {
  AnneeReferenceValidationBenefDTO?: Array<AnneeReferenceValidationBenefDtoInput>;
};

export type ArrayOfAnneeReferenceValideModel = {
  __typename?: 'ArrayOfAnneeReferenceValideModel';
  AnneeReferenceValideModel?: Array<AnneeReferenceValideModel>;
};

export type ArrayOfAnneeReferenceValideModelInput = {
  AnneeReferenceValideModel?: Array<AnneeReferenceValideModelInput>;
};

export type ArrayOfAnnonceBenefContactDto = {
  __typename?: 'ArrayOfAnnonceBenefContactDTO';
  AnnonceBenefContactDTO?: Array<AnnonceBenefContactDto>;
};

export type ArrayOfAnnonceBenefContactDtoInput = {
  AnnonceBenefContactDTO?: Array<AnnonceBenefContactDtoInput>;
};

export type ArrayOfAnnonceCategChampDto = {
  __typename?: 'ArrayOfAnnonceCategChampDTO';
  AnnonceCategChampDTO?: Array<AnnonceCategChampDto>;
};

export type ArrayOfAnnonceCategChampDtoInput = {
  AnnonceCategChampDTO?: Array<AnnonceCategChampDtoInput>;
};

export type ArrayOfAnnonceCategorieDto = {
  __typename?: 'ArrayOfAnnonceCategorieDTO';
  AnnonceCategorieDTO?: Array<AnnonceCategorieDto>;
};

export type ArrayOfAnnonceCategorieDtoInput = {
  AnnonceCategorieDTO?: Array<AnnonceCategorieDtoInput>;
};

export type ArrayOfAnnonceCategorieUserGestDto = {
  __typename?: 'ArrayOfAnnonceCategorieUserGestDTO';
  AnnonceCategorieUserGestDTO?: Array<AnnonceCategorieUserGestDto>;
};

export type ArrayOfAnnonceCategorieUserGestDtoInput = {
  AnnonceCategorieUserGestDTO?: Array<AnnonceCategorieUserGestDtoInput>;
};

export type ArrayOfAnnonceChampValeurDto = {
  __typename?: 'ArrayOfAnnonceChampValeurDTO';
  AnnonceChampValeurDTO?: Array<AnnonceChampValeurDto>;
};

export type ArrayOfAnnonceChampValeurDtoInput = {
  AnnonceChampValeurDTO?: Array<AnnonceChampValeurDtoInput>;
};

export type ArrayOfAnnonceChampValeurModelDto = {
  __typename?: 'ArrayOfAnnonceChampValeurModelDTO';
  AnnonceChampValeurModelDTO?: Array<AnnonceChampValeurModelDto>;
};

export type ArrayOfAnnonceChampValeurModelDtoInput = {
  AnnonceChampValeurModelDTO?: Array<AnnonceChampValeurModelDtoInput>;
};

export type ArrayOfAnnonceDto = {
  __typename?: 'ArrayOfAnnonceDTO';
  AnnonceDTO?: Array<AnnonceDto>;
};

export type ArrayOfAnnonceDtoInput = {
  AnnonceDTO?: Array<AnnonceDtoInput>;
};

export type ArrayOfAnnoncePrixDto = {
  __typename?: 'ArrayOfAnnoncePrixDTO';
  AnnoncePrixDTO?: Array<AnnoncePrixDto>;
};

export type ArrayOfAnnoncePrixDtoInput = {
  AnnoncePrixDTO?: Array<AnnoncePrixDtoInput>;
};

export type ArrayOfArrayOfPermHeureDtoInput = {
  ArrayOfPermHeureDTO?: Array<ArrayOfPermHeureDtoInput>;
};

export type ArrayOfArrayOfstring = {
  __typename?: 'ArrayOfArrayOfstring';
  ArrayOfstring?: Array<ArrayOfstring>;
};

export type ArrayOfArrayOfstringInput = {
  ArrayOfstring?: Array<ArrayOfstringInput>;
};

export type ArrayOfArreteCaisseLigneArreteCaisseEtatModelInput = {
  ArreteCaisseLigneArreteCaisseEtatModel?: Array<ArreteCaisseLigneArreteCaisseEtatModelInput>;
};

export type ArrayOfArreteCaisseLigneArreteCaisseNonFiduModel = {
  __typename?: 'ArrayOfArreteCaisseLigneArreteCaisseNonFiduModel';
  ArreteCaisseLigneArreteCaisseNonFiduModel?: Array<Union_3065088916602497858>;
};

export type ArrayOfArreteCaisseLigneArreteCaisseNonFiduModelInput = {
  ArreteCaisseLigneArreteCaisseNonFiduModel?: Array<ArreteCaisseLigneArreteCaisseNonFiduModelInput>;
};

export type ArrayOfArreteCaisseMoyenPaiementEtatModelInput = {
  ArreteCaisseMoyenPaiementEtatModel?: Array<ArreteCaisseMoyenPaiementEtatModelInput>;
};

export type ArrayOfArreteCaisseRecapitulatifMoyenPaiementModel = {
  __typename?: 'ArrayOfArreteCaisseRecapitulatifMoyenPaiementModel';
  ArreteCaisseRecapitulatifMoyenPaiementModel?: Array<ArreteCaisseRecapitulatifMoyenPaiementModel>;
};

export type ArrayOfArreteCaisseRecapitulatifMoyenPaiementModelInput = {
  ArreteCaisseRecapitulatifMoyenPaiementModel?: Array<ArreteCaisseRecapitulatifMoyenPaiementModelInput>;
};

export type ArrayOfArreteEtRemiseCaisseListerModel = {
  __typename?: 'ArrayOfArreteEtRemiseCaisseListerModel';
  ArreteEtRemiseCaisseListerModel?: Array<ArreteEtRemiseCaisseListerModel>;
};

export type ArrayOfArreteEtRemiseCaisseListerModelInput = {
  ArreteEtRemiseCaisseListerModel?: Array<ArreteEtRemiseCaisseListerModelInput>;
};

export type ArrayOfArticleActiviteBaseModel = {
  __typename?: 'ArrayOfArticleActiviteBaseModel';
  ArticleActiviteBaseModel?: Array<ArticleActiviteBaseModel>;
};

export type ArrayOfArticleActiviteBaseModelInput = {
  ArticleActiviteBaseModel?: Array<ArticleActiviteBaseModelInput>;
};

export type ArrayOfArticleAttributionAuto = {
  __typename?: 'ArrayOfArticleAttributionAuto';
  ArticleAttributionAuto?: Array<Union_6304623401004649514>;
};

export type ArrayOfArticleAttributionAutoInput = {
  ArticleAttributionAuto?: Array<ArticleAttributionAutoInput>;
};

export type ArrayOfArticleChequierBorneModel = {
  __typename?: 'ArrayOfArticleChequierBorneModel';
  ArticleChequierBorneModel?: Array<ArticleChequierBorneModel>;
};

export type ArrayOfArticleChequierBorneModelInput = {
  ArticleChequierBorneModel?: Array<ArticleChequierBorneModelInput>;
};

export type ArrayOfArticleChequierDto = {
  __typename?: 'ArrayOfArticleChequierDTO';
  ArticleChequierDTO?: Array<ArticleChequierDto>;
};

export type ArrayOfArticleChequierDtoInput = {
  ArticleChequierDTO?: Array<ArticleChequierDtoInput>;
};

export type ArrayOfArticleChequierModel = {
  __typename?: 'ArrayOfArticleChequierModel';
  ArticleChequierModel?: Array<ArticleChequierModel>;
};

export type ArrayOfArticleChequierModelInput = {
  ArticleChequierModel?: Array<ArticleChequierModelInput>;
};

export type ArrayOfArticleClotureModel = {
  __typename?: 'ArrayOfArticleClotureModel';
  ArticleClotureModel?: Array<ArticleClotureModel>;
};

export type ArrayOfArticleClotureModelInput = {
  ArticleClotureModel?: Array<ArticleClotureModelInput>;
};

export type ArrayOfArticleCompteurPointDto = {
  __typename?: 'ArrayOfArticleCompteurPointDTO';
  ArticleCompteurPointDTO?: Array<ArticleCompteurPointDto>;
};

export type ArrayOfArticleCompteurPointDtoInput = {
  ArticleCompteurPointDTO?: Array<ArticleCompteurPointDtoInput>;
};

export type ArrayOfArticleDto = {
  __typename?: 'ArrayOfArticleDTO';
  ArticleDTO?: Array<ArticleDto>;
};

export type ArrayOfArticleDtoInput = {
  ArticleDTO?: Array<ArticleDtoInput>;
};

export type ArrayOfArticleEditorialWithStatutModel = {
  __typename?: 'ArrayOfArticleEditorialWithStatutModel';
  ArticleEditorialWithStatutModel?: Array<ArticleEditorialWithStatutModel>;
};

export type ArrayOfArticleEditorialWithStatutModelInput = {
  ArticleEditorialWithStatutModel?: Array<ArticleEditorialWithStatutModelInput>;
};

export type ArrayOfArticleEditorielLightModel = {
  __typename?: 'ArrayOfArticleEditorielLightModel';
  ArticleEditorielLightModel?: Array<ArticleEditorielLightModel>;
};

export type ArrayOfArticleEditorielLightModelInput = {
  ArticleEditorielLightModel?: Array<ArticleEditorielLightModelInput>;
};

export type ArrayOfArticleEditorielPortletModel = {
  __typename?: 'ArrayOfArticleEditorielPortletModel';
  ArticleEditorielPortletModel?: Array<ArticleEditorielPortletModel>;
};

export type ArrayOfArticleEditorielPortletModelInput = {
  ArticleEditorielPortletModel?: Array<ArticleEditorielPortletModelInput>;
};

export type ArrayOfArticleFournisseurDto = {
  __typename?: 'ArrayOfArticleFournisseurDTO';
  ArticleFournisseurDTO?: Array<ArticleFournisseurDto>;
};

export type ArrayOfArticleFournisseurDtoInput = {
  ArticleFournisseurDTO?: Array<ArticleFournisseurDtoInput>;
};

export type ArrayOfArticleFournisseurFpaPrixRemiseModel = {
  __typename?: 'ArrayOfArticleFournisseurFpaPrixRemiseModel';
  ArticleFournisseurFpaPrixRemiseModel?: Array<ArticleFournisseurFpaPrixRemiseModel>;
};

export type ArrayOfArticleFournisseurFpaPrixRemiseModelInput = {
  ArticleFournisseurFpaPrixRemiseModel?: Array<ArticleFournisseurFpaPrixRemiseModelInput>;
};

export type ArrayOfArticleImputationEnErreurModel = {
  __typename?: 'ArrayOfArticleImputationEnErreurModel';
  ArticleImputationEnErreurModel?: Array<ArticleImputationEnErreurModel>;
};

export type ArrayOfArticleImputationEnErreurModelInput = {
  ArticleImputationEnErreurModel?: Array<ArticleImputationEnErreurModelInput>;
};

export type ArrayOfArticleLightModel = {
  __typename?: 'ArrayOfArticleLightModel';
  ArticleLightModel?: Array<ArticleLightModel>;
};

export type ArrayOfArticleLightModelInput = {
  ArticleLightModel?: Array<ArticleLightModelInput>;
};

export type ArrayOfArticleLigneAvoirModelDto = {
  __typename?: 'ArrayOfArticleLigneAvoirModelDTO';
  ArticleLigneAvoirModelDTO?: Array<ArticleLigneAvoirModelDto>;
};

export type ArrayOfArticleLigneAvoirModelDtoInput = {
  ArticleLigneAvoirModelDTO?: Array<ArticleLigneAvoirModelDtoInput>;
};

export type ArrayOfArticleLocationModel = {
  __typename?: 'ArrayOfArticleLocationModel';
  ArticleLocationModel?: Array<ArticleLocationModel>;
};

export type ArrayOfArticleLocationModelInput = {
  ArticleLocationModel?: Array<ArticleLocationModelInput>;
};

export type ArrayOfArticleMagazineModel = {
  __typename?: 'ArrayOfArticleMagazineModel';
  ArticleMagazineModel?: Array<ArticleMagazineModel>;
};

export type ArrayOfArticleMagazineModelInput = {
  ArticleMagazineModel?: Array<ArticleMagazineModelInput>;
};

export type ArrayOfArticleModeLivraisonDto = {
  __typename?: 'ArrayOfArticleModeLivraisonDTO';
  ArticleModeLivraisonDTO?: Array<ArticleModeLivraisonDto>;
};

export type ArrayOfArticleModeLivraisonDtoInput = {
  ArticleModeLivraisonDTO?: Array<ArticleModeLivraisonDtoInput>;
};

export type ArrayOfArticleModel = {
  __typename?: 'ArrayOfArticleModel';
  ArticleModel?: Array<ArticleModel>;
};

export type ArrayOfArticleModelDto = {
  __typename?: 'ArrayOfArticleModelDTO';
  ArticleModelDTO?: Array<ArticleModelDto>;
};

export type ArrayOfArticleModelDtoInput = {
  ArticleModelDTO?: Array<ArticleModelDtoInput>;
};

export type ArrayOfArticleModelInput = {
  ArticleModel?: Array<ArticleModelInput>;
};

export type ArrayOfArticleModeleEpargneModel = {
  __typename?: 'ArrayOfArticleModeleEpargneModel';
  ArticleModeleEpargneModel?: Array<Union_16949638073194317644>;
};

export type ArrayOfArticleModeleEpargneModelInput = {
  ArticleModeleEpargneModel?: Array<ArticleModeleEpargneModelInput>;
};

export type ArrayOfArticleMoyenPaiementModel = {
  __typename?: 'ArrayOfArticleMoyenPaiementModel';
  ArticleMoyenPaiementModel?: Array<ArticleMoyenPaiementModel>;
};

export type ArrayOfArticleMoyenPaiementModelInput = {
  ArticleMoyenPaiementModel?: Array<ArticleMoyenPaiementModelInput>;
};

export type ArrayOfArticlePrixVenteDto = {
  __typename?: 'ArrayOfArticlePrixVenteDTO';
  ArticlePrixVenteDTO?: Array<ArticlePrixVenteDto>;
};

export type ArrayOfArticlePrixVenteDtoInput = {
  ArticlePrixVenteDTO?: Array<ArticlePrixVenteDtoInput>;
};

export type ArrayOfArticleSectionAnalytiqueDto = {
  __typename?: 'ArrayOfArticleSectionAnalytiqueDTO';
  ArticleSectionAnalytiqueDTO?: Array<ArticleSectionAnalytiqueDto>;
};

export type ArrayOfArticleSectionAnalytiqueDtoInput = {
  ArticleSectionAnalytiqueDTO?: Array<ArticleSectionAnalytiqueDtoInput>;
};

export type ArrayOfArticleVenteModeleDto = {
  __typename?: 'ArrayOfArticleVenteModeleDTO';
  ArticleVenteModeleDTO?: Array<ArticleVenteModeleDto>;
};

export type ArrayOfArticleVenteModeleDtoInput = {
  ArticleVenteModeleDTO?: Array<ArticleVenteModeleDtoInput>;
};

export type ArrayOfArticleWithFamilleEtActiviteModel = {
  __typename?: 'ArrayOfArticleWithFamilleEtActiviteModel';
  ArticleWithFamilleEtActiviteModel?: Array<ArticleWithFamilleEtActiviteModel>;
};

export type ArrayOfArticleWithFamilleEtActiviteModelInput = {
  ArticleWithFamilleEtActiviteModel?: Array<ArticleWithFamilleEtActiviteModelInput>;
};

export type ArrayOfArticleWithProduitModel = {
  __typename?: 'ArrayOfArticleWithProduitModel';
  ArticleWithProduitModel?: Array<ArticleWithProduitModel>;
};

export type ArrayOfArticleWithProduitModelInput = {
  ArticleWithProduitModel?: Array<ArticleWithProduitModelInput>;
};

export type ArrayOfAttributionAutoModelDto = {
  __typename?: 'ArrayOfAttributionAutoModelDTO';
  AttributionAutoModelDTO?: Array<AttributionAutoModelDto>;
};

export type ArrayOfAttributionAutoModelDtoInput = {
  AttributionAutoModelDTO?: Array<AttributionAutoModelDtoInput>;
};

export type ArrayOfAttributionBenefDto = {
  __typename?: 'ArrayOfAttributionBenefDTO';
  AttributionBenefDTO?: Array<AttributionBenefDto>;
};

export type ArrayOfAttributionBenefDtoInput = {
  AttributionBenefDTO?: Array<AttributionBenefDtoInput>;
};

export type ArrayOfAttributionBenefExecModelDtoInput = {
  AttributionBenefExecModelDTO?: Array<AttributionBenefExecModelDtoInput>;
};

export type ArrayOfAttributionBenefModelDto = {
  __typename?: 'ArrayOfAttributionBenefModelDTO';
  AttributionBenefModelDTO?: Array<AttributionBenefModelDto>;
};

export type ArrayOfAttributionBenefModelDtoInput = {
  AttributionBenefModelDTO?: Array<AttributionBenefModelDtoInput>;
};

export type ArrayOfAttributionBudgetModelDto = {
  __typename?: 'ArrayOfAttributionBudgetModelDTO';
  AttributionBudgetModelDTO?: Array<AttributionBudgetModelDto>;
};

export type ArrayOfAttributionBudgetModelDtoInput = {
  AttributionBudgetModelDTO?: Array<AttributionBudgetModelDtoInput>;
};

export type ArrayOfAttributionCdeLigneDto = {
  __typename?: 'ArrayOfAttributionCDELigneDTO';
  AttributionCDELigneDTO?: Array<AttributionCdeLigneDto>;
};

export type ArrayOfAttributionCdeLigneDtoInput = {
  AttributionCDELigneDTO?: Array<AttributionCdeLigneDtoInput>;
};

export type ArrayOfAttributionRanModelDto = {
  __typename?: 'ArrayOfAttributionRanModelDTO';
  AttributionRanModelDTO?: Array<AttributionRanModelDto>;
};

export type ArrayOfAttributionRanModelDtoInput = {
  AttributionRanModelDTO?: Array<AttributionRanModelDtoInput>;
};

export type ArrayOfAttributionSubventionForEnveloppeModel = {
  __typename?: 'ArrayOfAttributionSubventionForEnveloppeModel';
  AttributionSubventionForEnveloppeModel?: Array<AttributionSubventionForEnveloppeModel>;
};

export type ArrayOfAttributionSubventionForEnveloppeModelInput = {
  AttributionSubventionForEnveloppeModel?: Array<AttributionSubventionForEnveloppeModelInput>;
};

export type ArrayOfAttributionTriDto = {
  __typename?: 'ArrayOfAttributionTriDTO';
  AttributionTriDTO?: Array<AttributionTriDto>;
};

export type ArrayOfAttributionTriDtoInput = {
  AttributionTriDTO?: Array<AttributionTriDtoInput>;
};

export type ArrayOfAttributionsLigneCommandeAttributionModel = {
  __typename?: 'ArrayOfAttributionsLigneCommandeAttributionModel';
  AttributionsLigneCommandeAttributionModel?: Array<AttributionsLigneCommandeAttributionModel>;
};

export type ArrayOfAttributionsLigneCommandeAttributionModelInput = {
  AttributionsLigneCommandeAttributionModel?: Array<AttributionsLigneCommandeAttributionModelInput>;
};

export type ArrayOfAvoirAcompteModelDto = {
  __typename?: 'ArrayOfAvoirAcompteModelDTO';
  AvoirAcompteModelDTO?: Array<AvoirAcompteModelDto>;
};

export type ArrayOfAvoirAcompteModelDtoInput = {
  AvoirAcompteModelDTO?: Array<AvoirAcompteModelDtoInput>;
};

export type ArrayOfAyantDroitModelDto = {
  __typename?: 'ArrayOfAyantDroitModelDTO';
  AyantDroitModelDTO?: Array<AyantDroitModelDto>;
};

export type ArrayOfAyantDroitModelDtoInput = {
  AyantDroitModelDTO?: Array<AyantDroitModelDtoInput>;
};

export type ArrayOfBlbrLigneModele = {
  __typename?: 'ArrayOfBLBRLigneModele';
  BLBRLigneModele?: Array<BlbrLigneModele>;
};

export type ArrayOfBlbrLigneModeleInput = {
  BLBRLigneModele?: Array<BlbrLigneModeleInput>;
};

export type ArrayOfBlbrListModel = {
  __typename?: 'ArrayOfBLBRListModel';
  BLBRListModel?: Array<BlbrListModel>;
};

export type ArrayOfBlbrListModelInput = {
  BLBRListModel?: Array<BlbrListModelInput>;
};

export type ArrayOfBlbrModele = {
  __typename?: 'ArrayOfBLBRModele';
  BLBRModele?: Array<BlbrModele>;
};

export type ArrayOfBlbrModeleInput = {
  BLBRModele?: Array<BlbrModeleInput>;
};

export type ArrayOfBanqueDto = {
  __typename?: 'ArrayOfBanqueDTO';
  BanqueDTO?: Array<BanqueDto>;
};

export type ArrayOfBanqueDtoInput = {
  BanqueDTO?: Array<BanqueDtoInput>;
};

export type ArrayOfBanqueLightModel = {
  __typename?: 'ArrayOfBanqueLightModel';
  BanqueLightModel?: Array<BanqueLightModel>;
};

export type ArrayOfBanqueLightModelInput = {
  BanqueLightModel?: Array<BanqueLightModelInput>;
};

export type ArrayOfBanqueLigneRemiseDto = {
  __typename?: 'ArrayOfBanqueLigneRemiseDTO';
  BanqueLigneRemiseDTO?: Array<BanqueLigneRemiseDto>;
};

export type ArrayOfBanqueLigneRemiseDtoInput = {
  BanqueLigneRemiseDTO?: Array<BanqueLigneRemiseDtoInput>;
};

export type ArrayOfBanqueRemiseDto = {
  __typename?: 'ArrayOfBanqueRemiseDTO';
  BanqueRemiseDTO?: Array<BanqueRemiseDto>;
};

export type ArrayOfBanqueRemiseDtoInput = {
  BanqueRemiseDTO?: Array<BanqueRemiseDtoInput>;
};

export type ArrayOfBaseHomeNotification = {
  __typename?: 'ArrayOfBaseHomeNotification';
  BaseHomeNotification?: Array<Union_3803064933304944068>;
};

export type ArrayOfBaseHomeNotificationInput = {
  BaseHomeNotification?: Array<BaseHomeNotificationInput>;
};

export type ArrayOfBaseV2Model = {
  __typename?: 'ArrayOfBaseV2Model';
  BaseV2Model?: Array<BaseV2Model>;
};

export type ArrayOfBaseV2ModelInput = {
  BaseV2Model?: Array<BaseV2ModelInput>;
};

export type ArrayOfBenefAdresseDto = {
  __typename?: 'ArrayOfBenefAdresseDTO';
  BenefAdresseDTO?: Array<BenefAdresseDto>;
};

export type ArrayOfBenefAdresseDtoInput = {
  BenefAdresseDTO?: Array<BenefAdresseDtoInput>;
};

export type ArrayOfBenefBenefBaseModel = {
  __typename?: 'ArrayOfBenefBenefBaseModel';
  BenefBenefBaseModel?: Array<BenefBenefBaseModel>;
};

export type ArrayOfBenefBenefBaseModelInput = {
  BenefBenefBaseModel?: Array<BenefBenefBaseModelInput>;
};

export type ArrayOfBenefBenefMatriculeModel = {
  __typename?: 'ArrayOfBenefBenefMatriculeModel';
  BenefBenefMatriculeModel?: Array<BenefBenefMatriculeModel>;
};

export type ArrayOfBenefBenefMatriculeModelInput = {
  BenefBenefMatriculeModel?: Array<BenefBenefMatriculeModelInput>;
};

export type ArrayOfBenefCeDelegationDto = {
  __typename?: 'ArrayOfBenefCEDelegationDTO';
  BenefCEDelegationDTO?: Array<BenefCeDelegationDto>;
};

export type ArrayOfBenefCeDelegationDtoInput = {
  BenefCEDelegationDTO?: Array<BenefCeDelegationDtoInput>;
};

export type ArrayOfBenefChampHistoriqueModel = {
  __typename?: 'ArrayOfBenefChampHistoriqueModel';
  BenefChampHistoriqueModel?: Array<BenefChampHistoriqueModel>;
};

export type ArrayOfBenefChampHistoriqueModelInput = {
  BenefChampHistoriqueModel?: Array<BenefChampHistoriqueModelInput>;
};

export type ArrayOfBenefComboModel = {
  __typename?: 'ArrayOfBenefComboModel';
  BenefComboModel?: Array<BenefComboModel>;
};

export type ArrayOfBenefComboModelInput = {
  BenefComboModel?: Array<BenefComboModelInput>;
};

export type ArrayOfBenefCommentaireModel = {
  __typename?: 'ArrayOfBenefCommentaireModel';
  BenefCommentaireModel?: Array<BenefCommentaireModel>;
};

export type ArrayOfBenefCommentaireModelInput = {
  BenefCommentaireModel?: Array<BenefCommentaireModelInput>;
};

export type ArrayOfBenefCriteresSociauxModel = {
  __typename?: 'ArrayOfBenefCriteresSociauxModel';
  BenefCriteresSociauxModel?: Array<Union_37769932661730027886>;
};

export type ArrayOfBenefCriteresSociauxModelInput = {
  BenefCriteresSociauxModel?: Array<BenefCriteresSociauxModelInput>;
};

export type ArrayOfBenefDto = {
  __typename?: 'ArrayOfBenefDTO';
  BenefDTO?: Array<BenefDto>;
};

export type ArrayOfBenefDtoInput = {
  BenefDTO?: Array<BenefDtoInput>;
};

export type ArrayOfBenefDelegationHistoModel = {
  __typename?: 'ArrayOfBenefDelegationHistoModel';
  BenefDelegationHistoModel?: Array<BenefDelegationHistoModel>;
};

export type ArrayOfBenefDelegationHistoModelInput = {
  BenefDelegationHistoModel?: Array<BenefDelegationHistoModelInput>;
};

export type ArrayOfBenefEmpruntModelDto = {
  __typename?: 'ArrayOfBenefEmpruntModelDTO';
  BenefEmpruntModelDTO?: Array<BenefEmpruntModelDto>;
};

export type ArrayOfBenefEmpruntModelDtoInput = {
  BenefEmpruntModelDTO?: Array<BenefEmpruntModelDtoInput>;
};

export type ArrayOfBenefMandatModel = {
  __typename?: 'ArrayOfBenefMandatModel';
  BenefMandatModel?: Array<BenefMandatModel>;
};

export type ArrayOfBenefMandatModelInput = {
  BenefMandatModel?: Array<BenefMandatModelInput>;
};

export type ArrayOfBenefOdadModel = {
  __typename?: 'ArrayOfBenefODADModel';
  BenefODADModel?: Array<BenefOdadModel>;
};

export type ArrayOfBenefOdadModelInput = {
  BenefODADModel?: Array<BenefOdadModelInput>;
};

export type ArrayOfBenefOrganisationDto = {
  __typename?: 'ArrayOfBenefOrganisationDTO';
  BenefOrganisationDTO?: Array<BenefOrganisationDto>;
};

export type ArrayOfBenefOrganisationDtoInput = {
  BenefOrganisationDTO?: Array<BenefOrganisationDtoInput>;
};

export type ArrayOfBenefSiteDto = {
  __typename?: 'ArrayOfBenefSiteDTO';
  BenefSiteDTO?: Array<BenefSiteDto>;
};

export type ArrayOfBenefSiteDtoInput = {
  BenefSiteDTO?: Array<BenefSiteDtoInput>;
};

export type ArrayOfBenefSiteOrgaModel = {
  __typename?: 'ArrayOfBenefSiteOrgaModel';
  BenefSiteOrgaModel?: Array<BenefSiteOrgaModel>;
};

export type ArrayOfBenefSiteOrgaModelInput = {
  BenefSiteOrgaModel?: Array<BenefSiteOrgaModelInput>;
};

export type ArrayOfBenefSynchroModelDto = {
  __typename?: 'ArrayOfBenefSynchroModelDTO';
  BenefSynchroModelDTO?: Array<BenefSynchroModelDto>;
};

export type ArrayOfBenefSynchroModelDtoInput = {
  BenefSynchroModelDTO?: Array<BenefSynchroModelDtoInput>;
};

export type ArrayOfBenefSynchroSynapse = {
  __typename?: 'ArrayOfBenefSynchroSynapse';
  BenefSynchroSynapse?: Array<BenefSynchroSynapse>;
};

export type ArrayOfBenefSynchroSynapseInput = {
  BenefSynchroSynapse?: Array<BenefSynchroSynapseInput>;
};

export type ArrayOfBeneficiaireAvecMailsModel = {
  __typename?: 'ArrayOfBeneficiaireAvecMailsModel';
  BeneficiaireAvecMailsModel?: Array<BeneficiaireAvecMailsModel>;
};

export type ArrayOfBeneficiaireAvecMailsModelInput = {
  BeneficiaireAvecMailsModel?: Array<BeneficiaireAvecMailsModelInput>;
};

export type ArrayOfBlBrDto = {
  __typename?: 'ArrayOfBlBrDTO';
  BlBrDTO?: Array<BlBrDto>;
};

export type ArrayOfBlBrDtoInput = {
  BlBrDTO?: Array<BlBrDtoInput>;
};

export type ArrayOfBlocCelluleModeleDto = {
  __typename?: 'ArrayOfBlocCelluleModeleDTO';
  BlocCelluleModeleDTO?: Array<BlocCelluleModeleDto>;
};

export type ArrayOfBlocCelluleModeleDtoInput = {
  BlocCelluleModeleDTO?: Array<BlocCelluleModeleDtoInput>;
};

export type ArrayOfBlocModelDto = {
  __typename?: 'ArrayOfBlocModelDTO';
  BlocModelDTO?: Array<BlocModelDto>;
};

export type ArrayOfBlocModelDtoInput = {
  BlocModelDTO?: Array<BlocModelDtoInput>;
};

export type ArrayOfBlocageExemplaireModel = {
  __typename?: 'ArrayOfBlocageExemplaireModel';
  BlocageExemplaireModel?: Array<BlocageExemplaireModel>;
};

export type ArrayOfBlocageExemplaireModelInput = {
  BlocageExemplaireModel?: Array<BlocageExemplaireModelInput>;
};

export type ArrayOfBorneDto = {
  __typename?: 'ArrayOfBorneDTO';
  BorneDTO?: Array<BorneDto>;
};

export type ArrayOfBorneDtoInput = {
  BorneDTO?: Array<BorneDtoInput>;
};

export type ArrayOfBorneStatWithBornesModel = {
  __typename?: 'ArrayOfBorneStatWithBornesModel';
  BorneStatWithBornesModel?: Array<BorneStatWithBornesModel>;
};

export type ArrayOfBorneStatWithBornesModelInput = {
  BorneStatWithBornesModel?: Array<BorneStatWithBornesModelInput>;
};

export type ArrayOfBudgetDto = {
  __typename?: 'ArrayOfBudgetDTO';
  BudgetDTO?: Array<BudgetDto>;
};

export type ArrayOfBudgetDtoInput = {
  BudgetDTO?: Array<BudgetDtoInput>;
};

export type ArrayOfBudgetListingModel = {
  __typename?: 'ArrayOfBudgetListingModel';
  BudgetListingModel?: Array<Union_66859388350133979>;
};

export type ArrayOfBudgetListingModelInput = {
  BudgetListingModel?: Array<BudgetListingModelInput>;
};

export type ArrayOfBudgetModelDto = {
  __typename?: 'ArrayOfBudgetModelDTO';
  BudgetModelDTO?: Array<BudgetModelDto>;
};

export type ArrayOfBudgetModelDtoInput = {
  BudgetModelDTO?: Array<BudgetModelDtoInput>;
};

export type ArrayOfCeDelegIsGlobaleModel = {
  __typename?: 'ArrayOfCEDelegIsGlobaleModel';
  CEDelegIsGlobaleModel?: Array<Union_4045752991927786863>;
};

export type ArrayOfCeDelegIsGlobaleModelInput = {
  CEDelegIsGlobaleModel?: Array<CeDelegIsGlobaleModelInput>;
};

export type ArrayOfCeDelegationDto = {
  __typename?: 'ArrayOfCEDelegationDTO';
  CEDelegationDTO?: Array<CeDelegationDto>;
};

export type ArrayOfCeDelegationDtoInput = {
  CEDelegationDTO?: Array<CeDelegationDtoInput>;
};

export type ArrayOfCadeauFpaModel = {
  __typename?: 'ArrayOfCadeauFPAModel';
  CadeauFPAModel?: Array<Union_1112417812603935575>;
};

export type ArrayOfCadeauFpaModelInput = {
  CadeauFPAModel?: Array<CadeauFpaModelInput>;
};

export type ArrayOfCaisseArreteDto = {
  __typename?: 'ArrayOfCaisseArreteDTO';
  CaisseArreteDTO?: Array<CaisseArreteDto>;
};

export type ArrayOfCaisseArreteDtoInput = {
  CaisseArreteDTO?: Array<CaisseArreteDtoInput>;
};

export type ArrayOfCaisseCaisseBaseModel = {
  __typename?: 'ArrayOfCaisseCaisseBaseModel';
  CaisseCaisseBaseModel?: Array<CaisseCaisseBaseModel>;
};

export type ArrayOfCaisseCaisseBaseModelInput = {
  CaisseCaisseBaseModel?: Array<CaisseCaisseBaseModelInput>;
};

export type ArrayOfCaisseCaisseJournauxReglementFiduModel = {
  __typename?: 'ArrayOfCaisseCaisseJournauxReglementFiduModel';
  CaisseCaisseJournauxReglementFiduModel?: Array<CaisseCaisseJournauxReglementFiduModel>;
};

export type ArrayOfCaisseCaisseJournauxReglementFiduModelInput = {
  CaisseCaisseJournauxReglementFiduModel?: Array<CaisseCaisseJournauxReglementFiduModelInput>;
};

export type ArrayOfCaisseDto = {
  __typename?: 'ArrayOfCaisseDTO';
  CaisseDTO?: Array<CaisseDto>;
};

export type ArrayOfCaisseDtoInput = {
  CaisseDTO?: Array<CaisseDtoInput>;
};

export type ArrayOfCaisseSectionAnalytiqueDto = {
  __typename?: 'ArrayOfCaisseSectionAnalytiqueDTO';
  CaisseSectionAnalytiqueDTO?: Array<CaisseSectionAnalytiqueDto>;
};

export type ArrayOfCaisseSectionAnalytiqueDtoInput = {
  CaisseSectionAnalytiqueDTO?: Array<CaisseSectionAnalytiqueDtoInput>;
};

export type ArrayOfCalculRegleAvanceeModelDto = {
  __typename?: 'ArrayOfCalculRegleAvanceeModelDTO';
  CalculRegleAvanceeModelDTO?: Array<CalculRegleAvanceeModelDto>;
};

export type ArrayOfCalculRegleAvanceeModelDtoInput = {
  CalculRegleAvanceeModelDTO?: Array<CalculRegleAvanceeModelDtoInput>;
};

export type ArrayOfCessionStockBaseModel = {
  __typename?: 'ArrayOfCessionStockBaseModel';
  CessionStockBaseModel?: Array<CessionStockBaseModel>;
};

export type ArrayOfCessionStockBaseModelInput = {
  CessionStockBaseModel?: Array<CessionStockBaseModelInput>;
};

export type ArrayOfCessionStockInfosHistoriqueModel = {
  __typename?: 'ArrayOfCessionStockInfosHistoriqueModel';
  CessionStockInfosHistoriqueModel?: Array<CessionStockInfosHistoriqueModel>;
};

export type ArrayOfCessionStockInfosHistoriqueModelInput = {
  CessionStockInfosHistoriqueModel?: Array<CessionStockInfosHistoriqueModelInput>;
};

export type ArrayOfChampChampTypeModel = {
  __typename?: 'ArrayOfChampChampTypeModel';
  ChampChampTypeModel?: Array<ChampChampTypeModel>;
};

export type ArrayOfChampChampTypeModelInput = {
  ChampChampTypeModel?: Array<ChampChampTypeModelInput>;
};

export type ArrayOfChampDto = {
  __typename?: 'ArrayOfChampDTO';
  ChampDTO?: Array<ChampDto>;
};

export type ArrayOfChampDtoInput = {
  ChampDTO?: Array<ChampDtoInput>;
};

export type ArrayOfChampEditerChampPersoFpa = {
  __typename?: 'ArrayOfChampEditerChampPersoFPA';
  ChampEditerChampPersoFPA?: Array<ChampEditerChampPersoFpa>;
};

export type ArrayOfChampEditerChampPersoFpaInput = {
  ChampEditerChampPersoFPA?: Array<ChampEditerChampPersoFpaInput>;
};

export type ArrayOfChampFormulaireLibelleModel = {
  __typename?: 'ArrayOfChampFormulaireLibelleModel';
  ChampFormulaireLibelleModel?: Array<ChampFormulaireLibelleModel>;
};

export type ArrayOfChampFormulaireLibelleModelInput = {
  ChampFormulaireLibelleModel?: Array<ChampFormulaireLibelleModelInput>;
};

export type ArrayOfChampFormulaireListingModel = {
  __typename?: 'ArrayOfChampFormulaireListingModel';
  ChampFormulaireListingModel?: Array<ChampFormulaireListingModel>;
};

export type ArrayOfChampFormulaireListingModelInput = {
  ChampFormulaireListingModel?: Array<ChampFormulaireListingModelInput>;
};

export type ArrayOfChampFormulaireParametrageModel = {
  __typename?: 'ArrayOfChampFormulaireParametrageModel';
  ChampFormulaireParametrageModel?: Array<ChampFormulaireParametrageModel>;
};

export type ArrayOfChampFormulaireParametrageModelInput = {
  ChampFormulaireParametrageModel?: Array<ChampFormulaireParametrageModelInput>;
};

export type ArrayOfChampLibelleModel = {
  __typename?: 'ArrayOfChampLibelleModel';
  ChampLibelleModel?: Array<ChampLibelleModel>;
};

export type ArrayOfChampLibelleModelInput = {
  ChampLibelleModel?: Array<ChampLibelleModelInput>;
};

export type ArrayOfChampListeValModel = {
  __typename?: 'ArrayOfChampListeValModel';
  ChampListeValModel?: Array<ChampListeValModel>;
};

export type ArrayOfChampListeValModelInput = {
  ChampListeValModel?: Array<ChampListeValModelInput>;
};

export type ArrayOfChampListeValeurChampListeValeurLightModel = {
  __typename?: 'ArrayOfChampListeValeurChampListeValeurLightModel';
  ChampListeValeurChampListeValeurLightModel?: Array<ChampListeValeurChampListeValeurLightModel>;
};

export type ArrayOfChampListeValeurChampListeValeurLightModelInput = {
  ChampListeValeurChampListeValeurLightModel?: Array<ChampListeValeurChampListeValeurLightModelInput>;
};

export type ArrayOfChampListeValeurChampListeValeurModel = {
  __typename?: 'ArrayOfChampListeValeurChampListeValeurModel';
  ChampListeValeurChampListeValeurModel?: Array<ChampListeValeurChampListeValeurModel>;
};

export type ArrayOfChampListeValeurChampListeValeurModelInput = {
  ChampListeValeurChampListeValeurModel?: Array<ChampListeValeurChampListeValeurModelInput>;
};

export type ArrayOfChampListeValeurDto = {
  __typename?: 'ArrayOfChampListeValeurDTO';
  ChampListeValeurDTO?: Array<ChampListeValeurDto>;
};

export type ArrayOfChampListeValeurDtoInput = {
  ChampListeValeurDTO?: Array<ChampListeValeurDtoInput>;
};

export type ArrayOfChampListeValeurEditerValeurChampListeModel = {
  __typename?: 'ArrayOfChampListeValeurEditerValeurChampListeModel';
  ChampListeValeurEditerValeurChampListeModel?: Array<ChampListeValeurEditerValeurChampListeModel>;
};

export type ArrayOfChampListeValeurEditerValeurChampListeModelInput = {
  ChampListeValeurEditerValeurChampListeModel?: Array<ChampListeValeurEditerValeurChampListeModelInput>;
};

export type ArrayOfChampPersoBeneficiaireModel = {
  __typename?: 'ArrayOfChampPersoBeneficiaireModel';
  ChampPersoBeneficiaireModel?: Array<Union_17133887752228243661>;
};

export type ArrayOfChampPersoBeneficiaireModelInput = {
  ChampPersoBeneficiaireModel?: Array<ChampPersoBeneficiaireModelInput>;
};

export type ArrayOfChampTypeDataCodeModel = {
  __typename?: 'ArrayOfChampTypeDataCodeModel';
  ChampTypeDataCodeModel?: Array<ChampTypeDataCodeModel>;
};

export type ArrayOfChampTypeDataCodeModelInput = {
  ChampTypeDataCodeModel?: Array<ChampTypeDataCodeModelInput>;
};

export type ArrayOfChampTypeDonneeDto = {
  __typename?: 'ArrayOfChampTypeDonneeDTO';
  ChampTypeDonneeDTO?: Array<ChampTypeDonneeDto>;
};

export type ArrayOfChampTypeDonneeDtoInput = {
  ChampTypeDonneeDTO?: Array<ChampTypeDonneeDtoInput>;
};

export type ArrayOfChampValeurDto = {
  __typename?: 'ArrayOfChampValeurDTO';
  ChampValeurDTO?: Array<ChampValeurDto>;
};

export type ArrayOfChampValeurDtoInput = {
  ChampValeurDTO?: Array<ChampValeurDtoInput>;
};

export type ArrayOfChampsCritereListeValeursPubliChampsModel = {
  __typename?: 'ArrayOfChampsCritereListeValeursPubliChampsModel';
  ChampsCritereListeValeursPubliChampsModel?: Array<Union_18613001183674656693>;
};

export type ArrayOfChampsCritereListeValeursPubliChampsModelInput = {
  ChampsCritereListeValeursPubliChampsModel?: Array<ChampsCritereListeValeursPubliChampsModelInput>;
};

export type ArrayOfChampsCriterePubliChampsModel = {
  __typename?: 'ArrayOfChampsCriterePubliChampsModel';
  ChampsCriterePubliChampsModel?: Array<ChampsCriterePubliChampsModel>;
};

export type ArrayOfChampsCriterePubliChampsModelInput = {
  ChampsCriterePubliChampsModel?: Array<ChampsCriterePubliChampsModelInput>;
};

export type ArrayOfChampsSectionFormulaireFullModel = {
  __typename?: 'ArrayOfChampsSectionFormulaireFullModel';
  ChampsSectionFormulaireFullModel?: Array<ChampsSectionFormulaireFullModel>;
};

export type ArrayOfChampsSectionFormulaireFullModelInput = {
  ChampsSectionFormulaireFullModel?: Array<ChampsSectionFormulaireFullModelInput>;
};

export type ArrayOfChequierDto = {
  __typename?: 'ArrayOfChequierDTO';
  ChequierDTO?: Array<ChequierDto>;
};

export type ArrayOfChequierDtoInput = {
  ChequierDTO?: Array<ChequierDtoInput>;
};

export type ArrayOfChequierModel = {
  __typename?: 'ArrayOfChequierModel';
  ChequierModel?: Array<ChequierModel>;
};

export type ArrayOfChequierModelInput = {
  ChequierModel?: Array<ChequierModelInput>;
};

export type ArrayOfChoixItemDto = {
  __typename?: 'ArrayOfChoixItemDTO';
  ChoixItemDTO?: Array<ChoixItemDto>;
};

export type ArrayOfChoixItemDtoInput = {
  ChoixItemDTO?: Array<ChoixItemDtoInput>;
};

export type ArrayOfCleRepartitionModel = {
  __typename?: 'ArrayOfCleRepartitionModel';
  CleRepartitionModel?: Array<Union_41558956911207852964>;
};

export type ArrayOfCleRepartitionModelDto = {
  __typename?: 'ArrayOfCleRepartitionModelDTO';
  CleRepartitionModelDTO?: Array<CleRepartitionModelDto>;
};

export type ArrayOfCleRepartitionModelDtoInput = {
  CleRepartitionModelDTO?: Array<CleRepartitionModelDtoInput>;
};

export type ArrayOfCleRepartitionModelInput = {
  CleRepartitionModel?: Array<CleRepartitionModelInput>;
};

export type ArrayOfClotureReportDesTiersModel = {
  __typename?: 'ArrayOfClotureReportDesTiersModel';
  ClotureReportDesTiersModel?: Array<ClotureReportDesTiersModel>;
};

export type ArrayOfClotureReportDesTiersModelInput = {
  ClotureReportDesTiersModel?: Array<ClotureReportDesTiersModelInput>;
};

export type ArrayOfClotureVariationStockModel = {
  __typename?: 'ArrayOfClotureVariationStockModel';
  ClotureVariationStockModel?: Array<ClotureVariationStockModel>;
};

export type ArrayOfClotureVariationStockModelInput = {
  ClotureVariationStockModel?: Array<ClotureVariationStockModelInput>;
};

export type ArrayOfComboBoxStatutsModel = {
  __typename?: 'ArrayOfComboBoxStatutsModel';
  ComboBoxStatutsModel?: Array<ComboBoxStatutsModel>;
};

export type ArrayOfComboBoxStatutsModelInput = {
  ComboBoxStatutsModel?: Array<ComboBoxStatutsModelInput>;
};

export type ArrayOfCommandeBeneficiairePartAChargeListingModel = {
  __typename?: 'ArrayOfCommandeBeneficiairePartAChargeListingModel';
  CommandeBeneficiairePartAChargeListingModel?: Array<CommandeBeneficiairePartAChargeListingModel>;
};

export type ArrayOfCommandeBeneficiairePartAChargeListingModelInput = {
  CommandeBeneficiairePartAChargeListingModel?: Array<CommandeBeneficiairePartAChargeListingModelInput>;
};

export type ArrayOfCommandeFournisseurListingModel = {
  __typename?: 'ArrayOfCommandeFournisseurListingModel';
  CommandeFournisseurListingModel?: Array<CommandeFournisseurListingModel>;
};

export type ArrayOfCommandeFournisseurListingModelInput = {
  CommandeFournisseurListingModel?: Array<CommandeFournisseurListingModelInput>;
};

export type ArrayOfCommandeFournisseurPartAChargeListingModel = {
  __typename?: 'ArrayOfCommandeFournisseurPartAChargeListingModel';
  CommandeFournisseurPartAChargeListingModel?: Array<CommandeFournisseurPartAChargeListingModel>;
};

export type ArrayOfCommandeFournisseurPartAChargeListingModelInput = {
  CommandeFournisseurPartAChargeListingModel?: Array<CommandeFournisseurPartAChargeListingModelInput>;
};

export type ArrayOfCommandeLivraisonModel = {
  __typename?: 'ArrayOfCommandeLivraisonModel';
  CommandeLivraisonModel?: Array<CommandeLivraisonModel>;
};

export type ArrayOfCommandeLivraisonModelInput = {
  CommandeLivraisonModel?: Array<CommandeLivraisonModelInput>;
};

export type ArrayOfCommentaireModerationModel = {
  __typename?: 'ArrayOfCommentaireModerationModel';
  CommentaireModerationModel?: Array<CommentaireModerationModel>;
};

export type ArrayOfCommentaireModerationModelInput = {
  CommentaireModerationModel?: Array<CommentaireModerationModelInput>;
};

export type ArrayOfCommissionCommissionModel = {
  __typename?: 'ArrayOfCommissionCommissionModel';
  CommissionCommissionModel?: Array<CommissionCommissionModel>;
};

export type ArrayOfCommissionCommissionModelInput = {
  CommissionCommissionModel?: Array<CommissionCommissionModelInput>;
};

export type ArrayOfCommissionDto = {
  __typename?: 'ArrayOfCommissionDTO';
  CommissionDTO?: Array<CommissionDto>;
};

export type ArrayOfCommissionDtoInput = {
  CommissionDTO?: Array<CommissionDtoInput>;
};

export type ArrayOfCommissionMailModel = {
  __typename?: 'ArrayOfCommissionMailModel';
  CommissionMailModel?: Array<CommissionMailModel>;
};

export type ArrayOfCommissionMailModelInput = {
  CommissionMailModel?: Array<CommissionMailModelInput>;
};

export type ArrayOfCommissionModelWithclos = {
  __typename?: 'ArrayOfCommissionModelWithclos';
  CommissionModelWithclos?: Array<CommissionModelWithclos>;
};

export type ArrayOfCommissionModelWithclosInput = {
  CommissionModelWithclos?: Array<CommissionModelWithclosInput>;
};

export type ArrayOfCommunActiviteDirectoModel = {
  __typename?: 'ArrayOfCommunActiviteDirectoModel';
  CommunActiviteDirectoModel?: Array<CommunActiviteDirectoModel>;
};

export type ArrayOfCommunActiviteDirectoModelInput = {
  CommunActiviteDirectoModel?: Array<CommunActiviteDirectoModelInput>;
};

export type ArrayOfCommunArticleActivitePortailModel = {
  __typename?: 'ArrayOfCommunArticleActivitePortailModel';
  CommunArticleActivitePortailModel?: Array<CommunArticleActivitePortailModel>;
};

export type ArrayOfCommunArticleActivitePortailModelInput = {
  CommunArticleActivitePortailModel?: Array<CommunArticleActivitePortailModelInput>;
};

export type ArrayOfCommunArticleEditorialPortailModel = {
  __typename?: 'ArrayOfCommunArticleEditorialPortailModel';
  CommunArticleEditorialPortailModel?: Array<CommunArticleEditorialPortailModel>;
};

export type ArrayOfCommunArticleEditorialPortailModelInput = {
  CommunArticleEditorialPortailModel?: Array<CommunArticleEditorialPortailModelInput>;
};

export type ArrayOfCommunCeDelegationModel = {
  __typename?: 'ArrayOfCommunCEDelegationModel';
  CommunCEDelegationModel?: Array<CommunCeDelegationModel>;
};

export type ArrayOfCommunCeDelegationModelInput = {
  CommunCEDelegationModel?: Array<CommunCeDelegationModelInput>;
};

export type ArrayOfCommunFamilleDirectoModel = {
  __typename?: 'ArrayOfCommunFamilleDirectoModel';
  CommunFamilleDirectoModel?: Array<CommunFamilleDirectoModel>;
};

export type ArrayOfCommunFamilleDirectoModelInput = {
  CommunFamilleDirectoModel?: Array<CommunFamilleDirectoModelInput>;
};

export type ArrayOfCommunProduitPortailModel = {
  __typename?: 'ArrayOfCommunProduitPortailModel';
  CommunProduitPortailModel?: Array<CommunProduitPortailModel>;
};

export type ArrayOfCommunProduitPortailModelInput = {
  CommunProduitPortailModel?: Array<CommunProduitPortailModelInput>;
};

export type ArrayOfComptaCaisseModelDto = {
  __typename?: 'ArrayOfComptaCaisseModelDTO';
  ComptaCaisseModelDTO?: Array<ComptaCaisseModelDto>;
};

export type ArrayOfComptaCaisseModelDtoInput = {
  ComptaCaisseModelDTO?: Array<ComptaCaisseModelDtoInput>;
};

export type ArrayOfComptaCompteBancaireModelDto = {
  __typename?: 'ArrayOfComptaCompteBancaireModelDTO';
  ComptaCompteBancaireModelDTO?: Array<ComptaCompteBancaireModelDto>;
};

export type ArrayOfComptaCompteBancaireModelDtoInput = {
  ComptaCompteBancaireModelDTO?: Array<ComptaCompteBancaireModelDtoInput>;
};

export type ArrayOfComptaCompteModelDto = {
  __typename?: 'ArrayOfComptaCompteModelDTO';
  ComptaCompteModelDTO?: Array<ComptaCompteModelDto>;
};

export type ArrayOfComptaCompteModelDtoInput = {
  ComptaCompteModelDTO?: Array<ComptaCompteModelDtoInput>;
};

export type ArrayOfComptaExerciceModelDto = {
  __typename?: 'ArrayOfComptaExerciceModelDTO';
  ComptaExerciceModelDTO?: Array<ComptaExerciceModelDto>;
};

export type ArrayOfComptaExerciceModelDtoInput = {
  ComptaExerciceModelDTO?: Array<ComptaExerciceModelDtoInput>;
};

export type ArrayOfComptaJournalModel = {
  __typename?: 'ArrayOfComptaJournalModel';
  ComptaJournalModel?: Array<ComptaJournalModel>;
};

export type ArrayOfComptaJournalModelInput = {
  ComptaJournalModel?: Array<ComptaJournalModelInput>;
};

export type ArrayOfComptaMouvementComptableModelDto = {
  __typename?: 'ArrayOfComptaMouvementComptableModelDTO';
  ComptaMouvementComptableModelDTO?: Array<ComptaMouvementComptableModelDto>;
};

export type ArrayOfComptaMouvementComptableModelDtoInput = {
  ComptaMouvementComptableModelDTO?: Array<ComptaMouvementComptableModelDtoInput>;
};

export type ArrayOfComptaMoyenPaiementModelDto = {
  __typename?: 'ArrayOfComptaMoyenPaiementModelDTO';
  ComptaMoyenPaiementModelDTO?: Array<ComptaMoyenPaiementModelDto>;
};

export type ArrayOfComptaMoyenPaiementModelDtoInput = {
  ComptaMoyenPaiementModelDTO?: Array<ComptaMoyenPaiementModelDtoInput>;
};

export type ArrayOfComptaPjComptableConsultationModel = {
  __typename?: 'ArrayOfComptaPJComptableConsultationModel';
  ComptaPJComptableConsultationModel?: Array<ComptaPjComptableConsultationModel>;
};

export type ArrayOfComptaPjComptableConsultationModelInput = {
  ComptaPJComptableConsultationModel?: Array<ComptaPjComptableConsultationModelInput>;
};

export type ArrayOfComptaPjComptablesModel = {
  __typename?: 'ArrayOfComptaPJComptablesModel';
  ComptaPJComptablesModel?: Array<ComptaPjComptablesModel>;
};

export type ArrayOfComptaPjComptablesModelInput = {
  ComptaPJComptablesModel?: Array<ComptaPjComptablesModelInput>;
};

export type ArrayOfCompte511AgregCompte511AgregModel = {
  __typename?: 'ArrayOfCompte511AgregCompte511AgregModel';
  Compte511AgregCompte511AgregModel?: Array<Compte511AgregCompte511AgregModel>;
};

export type ArrayOfCompte511AgregCompte511AgregModelInput = {
  Compte511AgregCompte511AgregModel?: Array<Compte511AgregCompte511AgregModelInput>;
};

export type ArrayOfCompte511AgregDto = {
  __typename?: 'ArrayOfCompte511AgregDTO';
  Compte511AgregDTO?: Array<Compte511AgregDto>;
};

export type ArrayOfCompte511AgregDtoInput = {
  Compte511AgregDTO?: Array<Compte511AgregDtoInput>;
};

export type ArrayOfCompte511Compte511BaseModelInput = {
  Compte511Compte511BaseModel?: Array<Compte511Compte511BaseModelInput>;
};

export type ArrayOfCompte511Compte511ParametrageModel = {
  __typename?: 'ArrayOfCompte511Compte511ParametrageModel';
  Compte511Compte511ParametrageModel?: Array<Compte511Compte511ParametrageModel>;
};

export type ArrayOfCompte511Compte511ParametrageModelInput = {
  Compte511Compte511ParametrageModel?: Array<Compte511Compte511ParametrageModelInput>;
};

export type ArrayOfCompteAssociationTvaModel = {
  __typename?: 'ArrayOfCompteAssociationTVAModel';
  CompteAssociationTVAModel?: Array<CompteAssociationTvaModel>;
};

export type ArrayOfCompteAssociationTvaModelInput = {
  CompteAssociationTVAModel?: Array<CompteAssociationTvaModelInput>;
};

export type ArrayOfCompteBancaireCompteBancaireBaseModel = {
  __typename?: 'ArrayOfCompteBancaireCompteBancaireBaseModel';
  CompteBancaireCompteBancaireBaseModel?: Array<CompteBancaireCompteBancaireBaseModel>;
};

export type ArrayOfCompteBancaireCompteBancaireBaseModelInput = {
  CompteBancaireCompteBancaireBaseModel?: Array<CompteBancaireCompteBancaireBaseModelInput>;
};

export type ArrayOfCompteBancaireDto = {
  __typename?: 'ArrayOfCompteBancaireDTO';
  CompteBancaireDTO?: Array<CompteBancaireDto>;
};

export type ArrayOfCompteBancaireDtoInput = {
  CompteBancaireDTO?: Array<CompteBancaireDtoInput>;
};

export type ArrayOfCompteBancaireModelDto = {
  __typename?: 'ArrayOfCompteBancaireModelDTO';
  CompteBancaireModelDTO?: Array<CompteBancaireModelDto>;
};

export type ArrayOfCompteBancaireModelDtoInput = {
  CompteBancaireModelDTO?: Array<CompteBancaireModelDtoInput>;
};

export type ArrayOfCompteBancaireWithIcs = {
  __typename?: 'ArrayOfCompteBancaireWithICS';
  CompteBancaireWithICS?: Array<CompteBancaireWithIcs>;
};

export type ArrayOfCompteBancaireWithIcsInput = {
  CompteBancaireWithICS?: Array<CompteBancaireWithIcsInput>;
};

export type ArrayOfCompteBaseModel = {
  __typename?: 'ArrayOfCompteBaseModel';
  CompteBaseModel?: Array<CompteBaseModel>;
};

export type ArrayOfCompteBaseModelInput = {
  CompteBaseModel?: Array<CompteBaseModelInput>;
};

export type ArrayOfCompteClasseDto = {
  __typename?: 'ArrayOfCompteClasseDTO';
  CompteClasseDTO?: Array<CompteClasseDto>;
};

export type ArrayOfCompteClasseDtoInput = {
  CompteClasseDTO?: Array<CompteClasseDtoInput>;
};

export type ArrayOfCompteClotureForTresorie = {
  __typename?: 'ArrayOfCompteClotureForTresorie';
  CompteClotureForTresorie?: Array<CompteClotureForTresorie>;
};

export type ArrayOfCompteClotureForTresorieInput = {
  CompteClotureForTresorie?: Array<CompteClotureForTresorieInput>;
};

export type ArrayOfCompteCollectifModel = {
  __typename?: 'ArrayOfCompteCollectifModel';
  CompteCollectifModel?: Array<CompteCollectifModel>;
};

export type ArrayOfCompteCollectifModelInput = {
  CompteCollectifModel?: Array<CompteCollectifModelInput>;
};

export type ArrayOfCompteCourantADebiterOuCrediterModelDto = {
  __typename?: 'ArrayOfCompteCourantADebiterOuCrediterModelDTO';
  CompteCourantADebiterOuCrediterModelDTO?: Array<CompteCourantADebiterOuCrediterModelDto>;
};

export type ArrayOfCompteCourantADebiterOuCrediterModelDtoInput = {
  CompteCourantADebiterOuCrediterModelDTO?: Array<CompteCourantADebiterOuCrediterModelDtoInput>;
};

export type ArrayOfCompteDto = {
  __typename?: 'ArrayOfCompteDTO';
  CompteDTO?: Array<CompteDto>;
};

export type ArrayOfCompteDtoInput = {
  CompteDTO?: Array<CompteDtoInput>;
};

export type ArrayOfCompteEcritureDto = {
  __typename?: 'ArrayOfCompteEcritureDTO';
  CompteEcritureDTO?: Array<CompteEcritureDto>;
};

export type ArrayOfCompteEcritureDtoInput = {
  CompteEcritureDTO?: Array<CompteEcritureDtoInput>;
};

export type ArrayOfCompteEcritureFactureDto = {
  __typename?: 'ArrayOfCompteEcritureFactureDTO';
  CompteEcritureFactureDTO?: Array<CompteEcritureFactureDto>;
};

export type ArrayOfCompteEcritureFactureDtoInput = {
  CompteEcritureFactureDTO?: Array<CompteEcritureFactureDtoInput>;
};

export type ArrayOfCompteForListeCompteModel = {
  __typename?: 'ArrayOfCompteForListeCompteModel';
  CompteForListeCompteModel?: Array<CompteForListeCompteModel>;
};

export type ArrayOfCompteForListeCompteModelInput = {
  CompteForListeCompteModel?: Array<CompteForListeCompteModelInput>;
};

export type ArrayOfCompteJournalPrmAutoDto = {
  __typename?: 'ArrayOfCompteJournalPRMAutoDTO';
  CompteJournalPRMAutoDTO?: Array<CompteJournalPrmAutoDto>;
};

export type ArrayOfCompteJournalPrmAutoDtoInput = {
  CompteJournalPRMAutoDTO?: Array<CompteJournalPrmAutoDtoInput>;
};

export type ArrayOfCompteJournalPrmAutoFiduDto = {
  __typename?: 'ArrayOfCompteJournalPRMAutoFiduDTO';
  CompteJournalPRMAutoFiduDTO?: Array<CompteJournalPrmAutoFiduDto>;
};

export type ArrayOfCompteJournalPrmAutoFiduDtoInput = {
  CompteJournalPRMAutoFiduDTO?: Array<CompteJournalPrmAutoFiduDtoInput>;
};

export type ArrayOfCompteLightClosModel = {
  __typename?: 'ArrayOfCompteLightClosModel';
  CompteLightClosModel?: Array<CompteLightClosModel>;
};

export type ArrayOfCompteLightClosModelInput = {
  CompteLightClosModel?: Array<CompteLightClosModelInput>;
};

export type ArrayOfCompteLightModel = {
  __typename?: 'ArrayOfCompteLightModel';
  CompteLightModel?: Array<CompteLightModel>;
};

export type ArrayOfCompteLightModelInput = {
  CompteLightModel?: Array<CompteLightModelInput>;
};

export type ArrayOfCompteLightVisibleEnLigneModel = {
  __typename?: 'ArrayOfCompteLightVisibleEnLigneModel';
  CompteLightVisibleEnLigneModel?: Array<CompteLightVisibleEnLigneModel>;
};

export type ArrayOfCompteLightVisibleEnLigneModelInput = {
  CompteLightVisibleEnLigneModel?: Array<CompteLightVisibleEnLigneModelInput>;
};

export type ArrayOfCompteModelDto = {
  __typename?: 'ArrayOfCompteModelDTO';
  CompteModelDTO?: Array<CompteModelDto>;
};

export type ArrayOfCompteModelDtoInput = {
  CompteModelDTO?: Array<CompteModelDtoInput>;
};

export type ArrayOfCompteReglementFiduciaireDto = {
  __typename?: 'ArrayOfCompteReglementFiduciaireDTO';
  CompteReglementFiduciaireDTO?: Array<CompteReglementFiduciaireDto>;
};

export type ArrayOfCompteReglementFiduciaireDtoInput = {
  CompteReglementFiduciaireDTO?: Array<CompteReglementFiduciaireDtoInput>;
};

export type ArrayOfCompteReglementFiduciaireModelDto = {
  __typename?: 'ArrayOfCompteReglementFiduciaireModelDTO';
  CompteReglementFiduciaireModelDTO?: Array<CompteReglementFiduciaireModelDto>;
};

export type ArrayOfCompteReglementFiduciaireModelDtoInput = {
  CompteReglementFiduciaireModelDTO?: Array<CompteReglementFiduciaireModelDtoInput>;
};

export type ArrayOfCompteSectionDto = {
  __typename?: 'ArrayOfCompteSectionDTO';
  CompteSectionDTO?: Array<CompteSectionDto>;
};

export type ArrayOfCompteSectionDtoInput = {
  CompteSectionDTO?: Array<CompteSectionDtoInput>;
};

export type ArrayOfCompteSimplifieModelDto = {
  __typename?: 'ArrayOfCompteSimplifieModelDTO';
  CompteSimplifieModelDTO?: Array<CompteSimplifieModelDto>;
};

export type ArrayOfCompteSimplifieModelDtoInput = {
  CompteSimplifieModelDTO?: Array<CompteSimplifieModelDtoInput>;
};

export type ArrayOfCompteSousClasseDto = {
  __typename?: 'ArrayOfCompteSousClasseDTO';
  CompteSousClasseDTO?: Array<CompteSousClasseDto>;
};

export type ArrayOfCompteSousClasseDtoInput = {
  CompteSousClasseDTO?: Array<CompteSousClasseDtoInput>;
};

export type ArrayOfComptesBancairesCompteBancaireLightModel = {
  __typename?: 'ArrayOfComptesBancairesCompteBancaireLightModel';
  ComptesBancairesCompteBancaireLightModel?: Array<ComptesBancairesCompteBancaireLightModel>;
};

export type ArrayOfComptesBancairesCompteBancaireLightModelInput = {
  ComptesBancairesCompteBancaireLightModel?: Array<ComptesBancairesCompteBancaireLightModelInput>;
};

export type ArrayOfComptesPlanCompteModel = {
  __typename?: 'ArrayOfComptesPlanCompteModel';
  ComptesPlanCompteModel?: Array<ComptesPlanCompteModel>;
};

export type ArrayOfComptesPlanCompteModelInput = {
  ComptesPlanCompteModel?: Array<ComptesPlanCompteModelInput>;
};

export type ArrayOfCompteurImputNbPointModelInput = {
  CompteurImputNbPointModel?: Array<CompteurImputNbPointModelInput>;
};

export type ArrayOfCompteurPointAfpaModel = {
  __typename?: 'ArrayOfCompteurPointAFPAModel';
  CompteurPointAFPAModel?: Array<CompteurPointAfpaModel>;
};

export type ArrayOfCompteurPointAfpaModelInput = {
  CompteurPointAFPAModel?: Array<CompteurPointAfpaModelInput>;
};

export type ArrayOfCompteurPointBaseModel = {
  __typename?: 'ArrayOfCompteurPointBaseModel';
  CompteurPointBaseModel?: Array<CompteurPointBaseModel>;
};

export type ArrayOfCompteurPointBaseModelInput = {
  CompteurPointBaseModel?: Array<CompteurPointBaseModelInput>;
};

export type ArrayOfCompteurPointDto = {
  __typename?: 'ArrayOfCompteurPointDTO';
  CompteurPointDTO?: Array<CompteurPointDto>;
};

export type ArrayOfCompteurPointDtoInput = {
  CompteurPointDTO?: Array<CompteurPointDtoInput>;
};

export type ArrayOfConsoBenefSynchroModelDto = {
  __typename?: 'ArrayOfConsoBenefSynchroModelDTO';
  ConsoBenefSynchroModelDTO?: Array<ConsoBenefSynchroModelDto>;
};

export type ArrayOfConsoBenefSynchroModelDtoInput = {
  ConsoBenefSynchroModelDTO?: Array<ConsoBenefSynchroModelDtoInput>;
};

export type ArrayOfConsoMouvementCptPointDto = {
  __typename?: 'ArrayOfConsoMouvementCptPointDTO';
  ConsoMouvementCptPointDTO?: Array<ConsoMouvementCptPointDto>;
};

export type ArrayOfConsoMouvementCptPointDtoInput = {
  ConsoMouvementCptPointDTO?: Array<ConsoMouvementCptPointDtoInput>;
};

export type ArrayOfConsoMouvementDto = {
  __typename?: 'ArrayOfConsoMouvementDTO';
  ConsoMouvementDTO?: Array<ConsoMouvementDto>;
};

export type ArrayOfConsoMouvementDtoInput = {
  ConsoMouvementDTO?: Array<ConsoMouvementDtoInput>;
};

export type ArrayOfConsoMouvementEnveloppeQuotaDto = {
  __typename?: 'ArrayOfConsoMouvementEnveloppeQuotaDTO';
  ConsoMouvementEnveloppeQuotaDTO?: Array<ConsoMouvementEnveloppeQuotaDto>;
};

export type ArrayOfConsoMouvementEnveloppeQuotaDtoInput = {
  ConsoMouvementEnveloppeQuotaDTO?: Array<ConsoMouvementEnveloppeQuotaDtoInput>;
};

export type ArrayOfConstantes_StatutsMediathquesLigneReservationModel = {
  __typename?: 'ArrayOfConstantes_StatutsMediathquesLigneReservationModel';
  Constantes_StatutsMediathquesLigneReservationModel?: Array<Constantes_StatutsMediathquesLigneReservationModel>;
};

export type ArrayOfConstantes_StatutsMediathquesLigneReservationModelInput = {
  Constantes_StatutsMediathquesLigneReservationModel?: Array<Constantes_StatutsMediathquesLigneReservationModelInput>;
};

export type ArrayOfConsultationArticleLocationModel = {
  __typename?: 'ArrayOfConsultationArticleLocationModel';
  ConsultationArticleLocationModel?: Array<ConsultationArticleLocationModel>;
};

export type ArrayOfConsultationArticleLocationModelInput = {
  ConsultationArticleLocationModel?: Array<ConsultationArticleLocationModelInput>;
};

export type ArrayOfConsultationMouvementConsommationModel = {
  __typename?: 'ArrayOfConsultationMouvementConsommationModel';
  ConsultationMouvementConsommationModel?: Array<ConsultationMouvementConsommationModel>;
};

export type ArrayOfConsultationMouvementConsommationModelInput = {
  ConsultationMouvementConsommationModel?: Array<ConsultationMouvementConsommationModelInput>;
};

export type ArrayOfContactDto = {
  __typename?: 'ArrayOfContactDTO';
  ContactDTO?: Array<ContactDto>;
};

export type ArrayOfContactDtoInput = {
  ContactDTO?: Array<ContactDtoInput>;
};

export type ArrayOfCorrectionImputationArticleModel = {
  __typename?: 'ArrayOfCorrectionImputationArticleModel';
  CorrectionImputationArticleModel?: Array<CorrectionImputationArticleModel>;
};

export type ArrayOfCorrectionImputationArticleModelInput = {
  CorrectionImputationArticleModel?: Array<CorrectionImputationArticleModelInput>;
};

export type ArrayOfCorrectionMontantMouvementModel = {
  __typename?: 'ArrayOfCorrectionMontantMouvementModel';
  CorrectionMontantMouvementModel?: Array<CorrectionMontantMouvementModel>;
};

export type ArrayOfCorrectionMontantMouvementModelInput = {
  CorrectionMontantMouvementModel?: Array<CorrectionMontantMouvementModelInput>;
};

export type ArrayOfCorrectionRepartitionAnalytiqueModel = {
  __typename?: 'ArrayOfCorrectionRepartitionAnalytiqueModel';
  CorrectionRepartitionAnalytiqueModel?: Array<CorrectionRepartitionAnalytiqueModel>;
};

export type ArrayOfCorrectionRepartitionAnalytiqueModelInput = {
  CorrectionRepartitionAnalytiqueModel?: Array<CorrectionRepartitionAnalytiqueModelInput>;
};

export type ArrayOfCourrierBaseWithCodeTypeModel = {
  __typename?: 'ArrayOfCourrierBaseWithCodeTypeModel';
  CourrierBaseWithCodeTypeModel?: Array<CourrierBaseWithCodeTypeModel>;
};

export type ArrayOfCourrierBaseWithCodeTypeModelInput = {
  CourrierBaseWithCodeTypeModel?: Array<CourrierBaseWithCodeTypeModelInput>;
};

export type ArrayOfCourrierCourrierEnvoiLigneModel = {
  __typename?: 'ArrayOfCourrierCourrierEnvoiLigneModel';
  CourrierCourrierEnvoiLigneModel?: Array<CourrierCourrierEnvoiLigneModel>;
};

export type ArrayOfCourrierCourrierEnvoiLigneModelInput = {
  CourrierCourrierEnvoiLigneModel?: Array<CourrierCourrierEnvoiLigneModelInput>;
};

export type ArrayOfCourrierCourrierEnvoiModel = {
  __typename?: 'ArrayOfCourrierCourrierEnvoiModel';
  CourrierCourrierEnvoiModel?: Array<CourrierCourrierEnvoiModel>;
};

export type ArrayOfCourrierCourrierEnvoiModelInput = {
  CourrierCourrierEnvoiModel?: Array<CourrierCourrierEnvoiModelInput>;
};

export type ArrayOfCourrierDto = {
  __typename?: 'ArrayOfCourrierDTO';
  CourrierDTO?: Array<CourrierDto>;
};

export type ArrayOfCourrierDtoInput = {
  CourrierDTO?: Array<CourrierDtoInput>;
};

export type ArrayOfCourrierEnvoiLightModel = {
  __typename?: 'ArrayOfCourrierEnvoiLightModel';
  CourrierEnvoiLightModel?: Array<CourrierEnvoiLightModel>;
};

export type ArrayOfCourrierEnvoiLightModelInput = {
  CourrierEnvoiLightModel?: Array<CourrierEnvoiLightModelInput>;
};

export type ArrayOfCourrierHistoEnvoiDto = {
  __typename?: 'ArrayOfCourrierHistoEnvoiDTO';
  CourrierHistoEnvoiDTO?: Array<CourrierHistoEnvoiDto>;
};

export type ArrayOfCourrierHistoEnvoiDtoInput = {
  CourrierHistoEnvoiDTO?: Array<CourrierHistoEnvoiDtoInput>;
};

export type ArrayOfCourrierLigneHistoEnvoiDto = {
  __typename?: 'ArrayOfCourrierLigneHistoEnvoiDTO';
  CourrierLigneHistoEnvoiDTO?: Array<CourrierLigneHistoEnvoiDto>;
};

export type ArrayOfCourrierLigneHistoEnvoiDtoInput = {
  CourrierLigneHistoEnvoiDTO?: Array<CourrierLigneHistoEnvoiDtoInput>;
};

export type ArrayOfCreationCompteModelInput = {
  CreationCompteModel?: Array<CreationCompteModelInput>;
};

export type ArrayOfCritereSyncAdModelDto = {
  __typename?: 'ArrayOfCritereSyncAdModelDTO';
  CritereSyncAdModelDTO?: Array<CritereSyncAdModelDto>;
};

export type ArrayOfCritereSyncAdModelDtoInput = {
  CritereSyncAdModelDTO?: Array<CritereSyncAdModelDtoInput>;
};

export type ArrayOfDelegationBaseModel = {
  __typename?: 'ArrayOfDelegationBaseModel';
  DelegationBaseModel?: Array<DelegationBaseModel>;
};

export type ArrayOfDelegationBaseModelInput = {
  DelegationBaseModel?: Array<DelegationBaseModelInput>;
};

export type ArrayOfDepartementDto = {
  __typename?: 'ArrayOfDepartementDTO';
  DepartementDTO?: Array<DepartementDto>;
};

export type ArrayOfDepartementDtoInput = {
  DepartementDTO?: Array<DepartementDtoInput>;
};

export type ArrayOfDestinataireMailModelDtoInput = {
  DestinataireMailModelDTO?: Array<DestinataireMailModelDtoInput>;
};

export type ArrayOfDetailEcrituresAnnulationDossierPretsEtDonsModelDto = {
  __typename?: 'ArrayOfDetailEcrituresAnnulationDossierPretsEtDonsModelDTO';
  DetailEcrituresAnnulationDossierPretsEtDonsModelDTO?: Array<DetailEcrituresAnnulationDossierPretsEtDonsModelDto>;
};

export type ArrayOfDetailEcrituresAnnulationDossierPretsEtDonsModelDtoInput = {
  DetailEcrituresAnnulationDossierPretsEtDonsModelDTO?: Array<DetailEcrituresAnnulationDossierPretsEtDonsModelDtoInput>;
};

export type ArrayOfDevisCommandeDto = {
  __typename?: 'ArrayOfDevisCommandeDTO';
  DevisCommandeDTO?: Array<DevisCommandeDto>;
};

export type ArrayOfDevisCommandeDtoInput = {
  DevisCommandeDTO?: Array<DevisCommandeDtoInput>;
};

export type ArrayOfDevisCommandeInfosCommandeNonLivreePartiellementLivreeModel = {
  __typename?: 'ArrayOfDevisCommandeInfosCommandeNonLivreePartiellementLivreeModel';
  DevisCommandeInfosCommandeNonLivreePartiellementLivreeModel?: Array<DevisCommandeInfosCommandeNonLivreePartiellementLivreeModel>;
};

export type ArrayOfDevisCommandeInfosCommandeNonLivreePartiellementLivreeModelInput = {
  DevisCommandeInfosCommandeNonLivreePartiellementLivreeModel?: Array<DevisCommandeInfosCommandeNonLivreePartiellementLivreeModelInput>;
};

export type ArrayOfDevisCommandeInfosReglMasModel = {
  __typename?: 'ArrayOfDevisCommandeInfosReglMasModel';
  DevisCommandeInfosReglMasModel?: Array<DevisCommandeInfosReglMasModel>;
};

export type ArrayOfDevisCommandeInfosReglMasModelInput = {
  DevisCommandeInfosReglMasModel?: Array<DevisCommandeInfosReglMasModelInput>;
};

export type ArrayOfDevisCommandeListingModel = {
  __typename?: 'ArrayOfDevisCommandeListingModel';
  DevisCommandeListingModel?: Array<DevisCommandeListingModel>;
};

export type ArrayOfDevisCommandeListingModelInput = {
  DevisCommandeListingModel?: Array<DevisCommandeListingModelInput>;
};

export type ArrayOfDevisCommandeModelDto = {
  __typename?: 'ArrayOfDevisCommandeModelDTO';
  DevisCommandeModelDTO?: Array<DevisCommandeModelDto>;
};

export type ArrayOfDevisCommandeModelDtoInput = {
  DevisCommandeModelDTO?: Array<DevisCommandeModelDtoInput>;
};

export type ArrayOfDispoCategorieRessourcesPartageesModel = {
  __typename?: 'ArrayOfDispoCategorieRessourcesPartageesModel';
  DispoCategorieRessourcesPartageesModel?: Array<DispoCategorieRessourcesPartageesModel>;
};

export type ArrayOfDispoCategorieRessourcesPartageesModelInput = {
  DispoCategorieRessourcesPartageesModel?: Array<DispoCategorieRessourcesPartageesModelInput>;
};

export type ArrayOfDisponibilitesRessourcesPartageesModel = {
  __typename?: 'ArrayOfDisponibilitesRessourcesPartageesModel';
  DisponibilitesRessourcesPartageesModel?: Array<DisponibilitesRessourcesPartageesModel>;
};

export type ArrayOfDisponibilitesRessourcesPartageesModelInput = {
  DisponibilitesRessourcesPartageesModel?: Array<DisponibilitesRessourcesPartageesModelInput>;
};

export type ArrayOfDocumentBaseModelInput = {
  DocumentBaseModel?: Array<DocumentBaseModelInput>;
};

export type ArrayOfDossierEpargneListerModel = {
  __typename?: 'ArrayOfDossierEpargneListerModel';
  DossierEpargneListerModel?: Array<DossierEpargneListerModel>;
};

export type ArrayOfDossierEpargneListerModelInput = {
  DossierEpargneListerModel?: Array<DossierEpargneListerModelInput>;
};

export type ArrayOfDossierPrestationInfosPjBaseModelDto = {
  __typename?: 'ArrayOfDossierPrestationInfosPJBaseModelDTO';
  DossierPrestationInfosPJBaseModelDTO?: Array<DossierPrestationInfosPjBaseModelDto>;
};

export type ArrayOfDossierPrestationInfosPjBaseModelDtoInput = {
  DossierPrestationInfosPJBaseModelDTO?: Array<DossierPrestationInfosPjBaseModelDtoInput>;
};

export type ArrayOfDossierPrestationLigneDossierPrestationModelDto = {
  __typename?: 'ArrayOfDossierPrestationLigneDossierPrestationModelDTO';
  DossierPrestationLigneDossierPrestationModelDTO?: Array<DossierPrestationLigneDossierPrestationModelDto>;
};

export type ArrayOfDossierPrestationLigneDossierPrestationModelDtoInput = {
  DossierPrestationLigneDossierPrestationModelDTO?: Array<DossierPrestationLigneDossierPrestationModelDtoInput>;
};

export type ArrayOfDossierPrestationPieceJustificativeForRechercheModelDto = {
  __typename?: 'ArrayOfDossierPrestationPieceJustificativeForRechercheModelDTO';
  DossierPrestationPieceJustificativeForRechercheModelDTO?: Array<Union_19883118252375799467>;
};

export type ArrayOfDossierPrestationPieceJustificativeForRechercheModelDtoInput = {
  DossierPrestationPieceJustificativeForRechercheModelDTO?: Array<DossierPrestationPieceJustificativeForRechercheModelDtoInput>;
};

export type ArrayOfDossierPrestationPieceJustificativeForWidgetModelDto = {
  __typename?: 'ArrayOfDossierPrestationPieceJustificativeForWidgetModelDTO';
  DossierPrestationPieceJustificativeForWidgetModelDTO?: Array<DossierPrestationPieceJustificativeForWidgetModelDto>;
};

export type ArrayOfDossierPrestationPieceJustificativeForWidgetModelDtoInput = {
  DossierPrestationPieceJustificativeForWidgetModelDTO?: Array<DossierPrestationPieceJustificativeForWidgetModelDtoInput>;
};

export type ArrayOfDossierPrestationPieceJustificativeModelDto = {
  __typename?: 'ArrayOfDossierPrestationPieceJustificativeModelDTO';
  DossierPrestationPieceJustificativeModelDTO?: Array<DossierPrestationPieceJustificativeModelDto>;
};

export type ArrayOfDossierPrestationPieceJustificativeModelDtoInput = {
  DossierPrestationPieceJustificativeModelDTO?: Array<DossierPrestationPieceJustificativeModelDtoInput>;
};

export type ArrayOfDossierPrestationValiderPieceJustificativeModelDtoInput = {
  DossierPrestationValiderPieceJustificativeModelDTO?: Array<DossierPrestationValiderPieceJustificativeModelDtoInput>;
};

export type ArrayOfDroitPortailModel = {
  __typename?: 'ArrayOfDroitPortailModel';
  DroitPortailModel?: Array<DroitPortailModel>;
};

export type ArrayOfDroitPortailModelInput = {
  DroitPortailModel?: Array<DroitPortailModelInput>;
};

export type ArrayOfEcheanceModelDto = {
  __typename?: 'ArrayOfEcheanceModelDTO';
  EcheanceModelDTO?: Array<EcheanceModelDto>;
};

export type ArrayOfEcheanceModelDtoInput = {
  EcheanceModelDTO?: Array<EcheanceModelDtoInput>;
};

export type ArrayOfEcheancierModelDto = {
  __typename?: 'ArrayOfEcheancierModelDTO';
  EcheancierModelDTO?: Array<EcheancierModelDto>;
};

export type ArrayOfEcheancierModelDtoInput = {
  EcheancierModelDTO?: Array<EcheancierModelDtoInput>;
};

export type ArrayOfEcheancierModeleActiviteModel = {
  __typename?: 'ArrayOfEcheancierModeleActiviteModel';
  EcheancierModeleActiviteModel?: Array<EcheancierModeleActiviteModel>;
};

export type ArrayOfEcheancierModeleActiviteModelInput = {
  EcheancierModeleActiviteModel?: Array<EcheancierModeleActiviteModelInput>;
};

export type ArrayOfEcritureAnalytiqueEnErreurModel = {
  __typename?: 'ArrayOfEcritureAnalytiqueEnErreurModel';
  EcritureAnalytiqueEnErreurModel?: Array<EcritureAnalytiqueEnErreurModel>;
};

export type ArrayOfEcritureAnalytiqueEnErreurModelInput = {
  EcritureAnalytiqueEnErreurModel?: Array<EcritureAnalytiqueEnErreurModelInput>;
};

export type ArrayOfEcritureBalanceOuvertureModel = {
  __typename?: 'ArrayOfEcritureBalanceOuvertureModel';
  EcritureBalanceOuvertureModel?: Array<EcritureBalanceOuvertureModel>;
};

export type ArrayOfEcritureBalanceOuvertureModelInput = {
  EcritureBalanceOuvertureModel?: Array<EcritureBalanceOuvertureModelInput>;
};

export type ArrayOfEcritureDesequilibreeModel = {
  __typename?: 'ArrayOfEcritureDesequilibreeModel';
  EcritureDesequilibreeModel?: Array<EcritureDesequilibreeModel>;
};

export type ArrayOfEcritureDesequilibreeModelInput = {
  EcritureDesequilibreeModel?: Array<EcritureDesequilibreeModelInput>;
};

export type ArrayOfEcritureExportModel = {
  __typename?: 'ArrayOfEcritureExportModel';
  EcritureExportModel?: Array<Union_5765410771066838971>;
};

export type ArrayOfEcritureExportModelInput = {
  EcritureExportModel?: Array<EcritureExportModelInput>;
};

export type ArrayOfEcritureListingModel = {
  __typename?: 'ArrayOfEcritureListingModel';
  EcritureListingModel?: Array<Union_5765410771066838971>;
};

export type ArrayOfEcritureListingModelInput = {
  EcritureListingModel?: Array<EcritureListingModelInput>;
};

export type ArrayOfEcritureTransactionBancairePoco = {
  __typename?: 'ArrayOfEcritureTransactionBancairePOCO';
  EcritureTransactionBancairePOCO?: Array<EcritureTransactionBancairePoco>;
};

export type ArrayOfEcritureTransactionBancairePocoInput = {
  EcritureTransactionBancairePOCO?: Array<EcritureTransactionBancairePocoInput>;
};

export type ArrayOfEcritureVerificationConformiteTva = {
  __typename?: 'ArrayOfEcritureVerificationConformiteTVA';
  EcritureVerificationConformiteTVA?: Array<EcritureVerificationConformiteTva>;
};

export type ArrayOfEcritureVerificationConformiteTvaInput = {
  EcritureVerificationConformiteTVA?: Array<EcritureVerificationConformiteTvaInput>;
};

export type ArrayOfEditAlbumLightModel = {
  __typename?: 'ArrayOfEditAlbumLightModel';
  EditAlbumLightModel?: Array<EditAlbumLightModel>;
};

export type ArrayOfEditAlbumLightModelInput = {
  EditAlbumLightModel?: Array<EditAlbumLightModelInput>;
};

export type ArrayOfEditerBlocDescriptionModel = {
  __typename?: 'ArrayOfEditerBlocDescriptionModel';
  EditerBlocDescriptionModel?: Array<EditerBlocDescriptionModel>;
};

export type ArrayOfEditerBlocDescriptionModelInput = {
  EditerBlocDescriptionModel?: Array<EditerBlocDescriptionModelInput>;
};

export type ArrayOfEditerIbanTiers = {
  __typename?: 'ArrayOfEditerIbanTiers';
  EditerIbanTiers?: Array<EditerIbanTiers>;
};

export type ArrayOfEditerIbanTiersInput = {
  EditerIbanTiers?: Array<EditerIbanTiersInput>;
};

export type ArrayOfEditerMouvementAnalytiqueModel = {
  __typename?: 'ArrayOfEditerMouvementAnalytiqueModel';
  EditerMouvementAnalytiqueModel?: Array<EditerMouvementAnalytiqueModel>;
};

export type ArrayOfEditerMouvementAnalytiqueModelInput = {
  EditerMouvementAnalytiqueModel?: Array<EditerMouvementAnalytiqueModelInput>;
};

export type ArrayOfEditerMouvementAnalytiqueWithSectionAnalytiqueModel = {
  __typename?: 'ArrayOfEditerMouvementAnalytiqueWithSectionAnalytiqueModel';
  EditerMouvementAnalytiqueWithSectionAnalytiqueModel?: Array<EditerMouvementAnalytiqueWithSectionAnalytiqueModel>;
};

export type ArrayOfEditerMouvementAnalytiqueWithSectionAnalytiqueModelInput = {
  EditerMouvementAnalytiqueWithSectionAnalytiqueModel?: Array<EditerMouvementAnalytiqueWithSectionAnalytiqueModelInput>;
};

export type ArrayOfEditerProduitClotureModel = {
  __typename?: 'ArrayOfEditerProduitClotureModel';
  EditerProduitClotureModel?: Array<EditerProduitClotureModel>;
};

export type ArrayOfEditerProduitClotureModelInput = {
  EditerProduitClotureModel?: Array<EditerProduitClotureModelInput>;
};

export type ArrayOfEditerSectionAnalytiqueSurMouvementInput = {
  EditerSectionAnalytiqueSurMouvement?: Array<EditerSectionAnalytiqueSurMouvementInput>;
};

export type ArrayOfElementAssocieDocModel = {
  __typename?: 'ArrayOfElementAssocieDocModel';
  ElementAssocieDocModel?: Array<ElementAssocieDocModel>;
};

export type ArrayOfElementAssocieDocModelInput = {
  ElementAssocieDocModel?: Array<ElementAssocieDocModelInput>;
};

export type ArrayOfEngagementBudgetModelDto = {
  __typename?: 'ArrayOfEngagementBudgetModelDTO';
  EngagementBudgetModelDTO?: Array<EngagementBudgetModelDto>;
};

export type ArrayOfEngagementBudgetModelDtoInput = {
  EngagementBudgetModelDTO?: Array<EngagementBudgetModelDtoInput>;
};

export type ArrayOfEnteteBaremeDto = {
  __typename?: 'ArrayOfEnteteBaremeDTO';
  EnteteBaremeDTO?: Array<EnteteBaremeDto>;
};

export type ArrayOfEnteteBaremeDtoInput = {
  EnteteBaremeDTO?: Array<EnteteBaremeDtoInput>;
};

export type ArrayOfEnteteDevisCommandeModel = {
  __typename?: 'ArrayOfEnteteDevisCommandeModel';
  EnteteDevisCommandeModel?: Array<EnteteDevisCommandeModel>;
};

export type ArrayOfEnteteDevisCommandeModelInput = {
  EnteteDevisCommandeModel?: Array<EnteteDevisCommandeModelInput>;
};

export type ArrayOfEnvImpActiviteDto = {
  __typename?: 'ArrayOfEnvImpActiviteDTO';
  EnvImpActiviteDTO?: Array<EnvImpActiviteDto>;
};

export type ArrayOfEnvImpActiviteDtoInput = {
  EnvImpActiviteDTO?: Array<EnvImpActiviteDtoInput>;
};

export type ArrayOfEnvImpArticleDto = {
  __typename?: 'ArrayOfEnvImpArticleDTO';
  EnvImpArticleDTO?: Array<EnvImpArticleDto>;
};

export type ArrayOfEnvImpArticleDtoInput = {
  EnvImpArticleDTO?: Array<EnvImpArticleDtoInput>;
};

export type ArrayOfEnvImpFamilleDto = {
  __typename?: 'ArrayOfEnvImpFamilleDTO';
  EnvImpFamilleDTO?: Array<EnvImpFamilleDto>;
};

export type ArrayOfEnvImpFamilleDtoInput = {
  EnvImpFamilleDTO?: Array<EnvImpFamilleDtoInput>;
};

export type ArrayOfEnvImpProduitDto = {
  __typename?: 'ArrayOfEnvImpProduitDTO';
  EnvImpProduitDTO?: Array<EnvImpProduitDto>;
};

export type ArrayOfEnvImpProduitDtoInput = {
  EnvImpProduitDTO?: Array<EnvImpProduitDtoInput>;
};

export type ArrayOfEnveloppeAfpaModel = {
  __typename?: 'ArrayOfEnveloppeAFPAModel';
  EnveloppeAFPAModel?: Array<EnveloppeAfpaModel>;
};

export type ArrayOfEnveloppeAfpaModelInput = {
  EnveloppeAFPAModel?: Array<EnveloppeAfpaModelInput>;
};

export type ArrayOfEnveloppeBaseModel = {
  __typename?: 'ArrayOfEnveloppeBaseModel';
  EnveloppeBaseModel?: Array<EnveloppeBaseModel>;
};

export type ArrayOfEnveloppeBaseModelInput = {
  EnveloppeBaseModel?: Array<EnveloppeBaseModelInput>;
};

export type ArrayOfEnveloppeBaseSelectedModel = {
  __typename?: 'ArrayOfEnveloppeBaseSelectedModel';
  EnveloppeBaseSelectedModel?: Array<Union_29326972383394260837>;
};

export type ArrayOfEnveloppeBaseSelectedModelInput = {
  EnveloppeBaseSelectedModel?: Array<EnveloppeBaseSelectedModelInput>;
};

export type ArrayOfEnveloppeQuotaDto = {
  __typename?: 'ArrayOfEnveloppeQuotaDTO';
  EnveloppeQuotaDTO?: Array<EnveloppeQuotaDto>;
};

export type ArrayOfEnveloppeQuotaDtoInput = {
  EnveloppeQuotaDTO?: Array<EnveloppeQuotaDtoInput>;
};

export type ArrayOfErreurValidationInput = {
  ErreurValidation?: Array<ErreurValidationInput>;
};

export type ArrayOfExemplaireMediaTransfertStockModel = {
  __typename?: 'ArrayOfExemplaireMediaTransfertStockModel';
  ExemplaireMediaTransfertStockModel?: Array<ExemplaireMediaTransfertStockModel>;
};

export type ArrayOfExemplaireMediaTransfertStockModelInput = {
  ExemplaireMediaTransfertStockModel?: Array<ExemplaireMediaTransfertStockModelInput>;
};

export type ArrayOfExemplaireMediathequeRechercheMediaModelDto = {
  __typename?: 'ArrayOfExemplaireMediathequeRechercheMediaModelDTO';
  ExemplaireMediathequeRechercheMediaModelDTO?: Array<Union_23800276143883885461>;
};

export type ArrayOfExemplaireMediathequeRechercheMediaModelDtoInput = {
  ExemplaireMediathequeRechercheMediaModelDTO?: Array<ExemplaireMediathequeRechercheMediaModelDtoInput>;
};

export type ArrayOfExerciceClotureModel = {
  __typename?: 'ArrayOfExerciceClotureModel';
  ExerciceClotureModel?: Array<ExerciceClotureModel>;
};

export type ArrayOfExerciceClotureModelInput = {
  ExerciceClotureModel?: Array<ExerciceClotureModelInput>;
};

export type ArrayOfExerciceDto = {
  __typename?: 'ArrayOfExerciceDTO';
  ExerciceDTO?: Array<ExerciceDto>;
};

export type ArrayOfExerciceDtoInput = {
  ExerciceDTO?: Array<ExerciceDtoInput>;
};

export type ArrayOfExerciceInfos = {
  __typename?: 'ArrayOfExerciceInfos';
  ExerciceInfos?: Array<ExerciceInfos>;
};

export type ArrayOfExerciceInfosInput = {
  ExerciceInfos?: Array<ExerciceInfosInput>;
};

export type ArrayOfExerciceModelDto = {
  __typename?: 'ArrayOfExerciceModelDTO';
  ExerciceModelDTO?: Array<ExerciceModelDto>;
};

export type ArrayOfExerciceModelDtoInput = {
  ExerciceModelDTO?: Array<ExerciceModelDtoInput>;
};

export type ArrayOfFpaPrestaArticleCadeauModel = {
  __typename?: 'ArrayOfFPAPrestaArticleCadeauModel';
  FPAPrestaArticleCadeauModel?: Array<FpaPrestaArticleCadeauModel>;
};

export type ArrayOfFpaPrestaArticleCadeauModelInput = {
  FPAPrestaArticleCadeauModel?: Array<FpaPrestaArticleCadeauModelInput>;
};

export type ArrayOfFpaSectionAnalytiqueModelDto = {
  __typename?: 'ArrayOfFPASectionAnalytiqueModelDTO';
  FPASectionAnalytiqueModelDTO?: Array<FpaSectionAnalytiqueModelDto>;
};

export type ArrayOfFpaSectionAnalytiqueModelDtoInput = {
  FPASectionAnalytiqueModelDTO?: Array<FpaSectionAnalytiqueModelDtoInput>;
};

export type ArrayOfFactureAPayerModelDto = {
  __typename?: 'ArrayOfFactureAPayerModelDTO';
  FactureAPayerModelDTO?: Array<FactureAPayerModelDto>;
};

export type ArrayOfFactureAPayerModelDtoInput = {
  FactureAPayerModelDTO?: Array<FactureAPayerModelDtoInput>;
};

export type ArrayOfFactureDto = {
  __typename?: 'ArrayOfFactureDTO';
  FactureDTO?: Array<FactureDto>;
};

export type ArrayOfFactureDtoInput = {
  FactureDTO?: Array<FactureDtoInput>;
};

export type ArrayOfFactureEcheancierModelDto = {
  __typename?: 'ArrayOfFactureEcheancierModelDTO';
  FactureEcheancierModelDTO?: Array<FactureEcheancierModelDto>;
};

export type ArrayOfFactureEcheancierModelDtoInput = {
  FactureEcheancierModelDTO?: Array<FactureEcheancierModelDtoInput>;
};

export type ArrayOfFactureHistoriqueModel = {
  __typename?: 'ArrayOfFactureHistoriqueModel';
  FactureHistoriqueModel?: Array<FactureHistoriqueModel>;
};

export type ArrayOfFactureHistoriqueModelInput = {
  FactureHistoriqueModel?: Array<FactureHistoriqueModelInput>;
};

export type ArrayOfFactureImputationAcompteAvoirDto = {
  __typename?: 'ArrayOfFactureImputationAcompteAvoirDTO';
  FactureImputationAcompteAvoirDTO?: Array<FactureImputationAcompteAvoirDto>;
};

export type ArrayOfFactureImputationAcompteAvoirDtoInput = {
  FactureImputationAcompteAvoirDTO?: Array<FactureImputationAcompteAvoirDtoInput>;
};

export type ArrayOfFactureInfosFactureAcompteFourPrestaModel = {
  __typename?: 'ArrayOfFactureInfosFactureAcompteFourPrestaModel';
  FactureInfosFactureAcompteFourPrestaModel?: Array<FactureInfosFactureAcompteFourPrestaModel>;
};

export type ArrayOfFactureInfosFactureAcompteFourPrestaModelInput = {
  FactureInfosFactureAcompteFourPrestaModel?: Array<FactureInfosFactureAcompteFourPrestaModelInput>;
};

export type ArrayOfFactureInfosFactureForReglementWorkFlow = {
  __typename?: 'ArrayOfFactureInfosFactureForReglementWorkFlow';
  FactureInfosFactureForReglementWorkFlow?: Array<FactureInfosFactureForReglementWorkFlow>;
};

export type ArrayOfFactureInfosFactureForReglementWorkFlowInput = {
  FactureInfosFactureForReglementWorkFlow?: Array<FactureInfosFactureForReglementWorkFlowInput>;
};

export type ArrayOfFactureInfosFactureModel = {
  __typename?: 'ArrayOfFactureInfosFactureModel';
  FactureInfosFactureModel?: Array<FactureInfosFactureModel>;
};

export type ArrayOfFactureInfosFactureModelInput = {
  FactureInfosFactureModel?: Array<FactureInfosFactureModelInput>;
};

export type ArrayOfFactureStatutFactureOuCdeModel = {
  __typename?: 'ArrayOfFactureStatutFactureOuCdeModel';
  FactureStatutFactureOuCdeModel?: Array<FactureStatutFactureOuCdeModel>;
};

export type ArrayOfFactureStatutFactureOuCdeModelInput = {
  FactureStatutFactureOuCdeModel?: Array<FactureStatutFactureOuCdeModelInput>;
};

export type ArrayOfFamilleBaseModel = {
  __typename?: 'ArrayOfFamilleBaseModel';
  FamilleBaseModel?: Array<FamilleBaseModel>;
};

export type ArrayOfFamilleBaseModelInput = {
  FamilleBaseModel?: Array<FamilleBaseModelInput>;
};

export type ArrayOfFamilleImportModelDto = {
  __typename?: 'ArrayOfFamilleImportModelDTO';
  FamilleImportModelDTO?: Array<FamilleImportModelDto>;
};

export type ArrayOfFamilleImportModelDtoInput = {
  FamilleImportModelDTO?: Array<FamilleImportModelDtoInput>;
};

export type ArrayOfFamilleLightModel = {
  __typename?: 'ArrayOfFamilleLightModel';
  FamilleLightModel?: Array<FamilleLightModel>;
};

export type ArrayOfFamilleLightModelInput = {
  FamilleLightModel?: Array<FamilleLightModelInput>;
};

export type ArrayOfFamilleModel = {
  __typename?: 'ArrayOfFamilleModel';
  FamilleModel?: Array<FamilleModel>;
};

export type ArrayOfFamilleModelInput = {
  FamilleModel?: Array<FamilleModelInput>;
};

export type ArrayOfFamilleProduitDto = {
  __typename?: 'ArrayOfFamilleProduitDTO';
  FamilleProduitDTO?: Array<FamilleProduitDto>;
};

export type ArrayOfFamilleProduitDtoInput = {
  FamilleProduitDTO?: Array<FamilleProduitDtoInput>;
};

export type ArrayOfFamilleProduitModeLivraisonDto = {
  __typename?: 'ArrayOfFamilleProduitModeLivraisonDTO';
  FamilleProduitModeLivraisonDTO?: Array<FamilleProduitModeLivraisonDto>;
};

export type ArrayOfFamilleProduitModeLivraisonDtoInput = {
  FamilleProduitModeLivraisonDTO?: Array<FamilleProduitModeLivraisonDtoInput>;
};

export type ArrayOfFamilleProduitModel = {
  __typename?: 'ArrayOfFamilleProduitModel';
  FamilleProduitModel?: Array<FamilleProduitModel>;
};

export type ArrayOfFamilleProduitModelInput = {
  FamilleProduitModel?: Array<FamilleProduitModelInput>;
};

export type ArrayOfFamilleProduitSectionAnalytiqueDto = {
  __typename?: 'ArrayOfFamilleProduitSectionAnalytiqueDTO';
  FamilleProduitSectionAnalytiqueDTO?: Array<FamilleProduitSectionAnalytiqueDto>;
};

export type ArrayOfFamilleProduitSectionAnalytiqueDtoInput = {
  FamilleProduitSectionAnalytiqueDTO?: Array<FamilleProduitSectionAnalytiqueDtoInput>;
};

export type ArrayOfFamilleProduitSimpleModelDto = {
  __typename?: 'ArrayOfFamilleProduitSimpleModelDTO';
  FamilleProduitSimpleModelDTO?: Array<FamilleProduitSimpleModelDto>;
};

export type ArrayOfFamilleProduitSimpleModelDtoInput = {
  FamilleProduitSimpleModelDTO?: Array<FamilleProduitSimpleModelDtoInput>;
};

export type ArrayOfFamilleWithActiviteModel = {
  __typename?: 'ArrayOfFamilleWithActiviteModel';
  FamilleWithActiviteModel?: Array<FamilleWithActiviteModel>;
};

export type ArrayOfFamilleWithActiviteModelInput = {
  FamilleWithActiviteModel?: Array<FamilleWithActiviteModelInput>;
};

export type ArrayOfFicheProfilCelluleDirectoModelDto = {
  __typename?: 'ArrayOfFicheProfilCelluleDirectoModelDTO';
  FicheProfilCelluleDirectoModelDTO?: Array<FicheProfilCelluleDirectoModelDto>;
};

export type ArrayOfFicheProfilCelluleDirectoModelDtoInput = {
  FicheProfilCelluleDirectoModelDTO?: Array<FicheProfilCelluleDirectoModelDtoInput>;
};

export type ArrayOfFicheProfilDataDirectoDto = {
  __typename?: 'ArrayOfFicheProfilDataDirectoDTO';
  FicheProfilDataDirectoDTO?: Array<FicheProfilDataDirectoDto>;
};

export type ArrayOfFicheProfilDataDirectoDtoInput = {
  FicheProfilDataDirectoDTO?: Array<FicheProfilDataDirectoDtoInput>;
};

export type ArrayOfFicheProfilDataDirectoImportModeleTypeDto = {
  __typename?: 'ArrayOfFicheProfilDataDirectoImportModeleTypeDTO';
  FicheProfilDataDirectoImportModeleTypeDTO?: Array<FicheProfilDataDirectoImportModeleTypeDto>;
};

export type ArrayOfFicheProfilDataDirectoImportModeleTypeDtoInput = {
  FicheProfilDataDirectoImportModeleTypeDTO?: Array<FicheProfilDataDirectoImportModeleTypeDtoInput>;
};

export type ArrayOfFicheProfilDataDirectoModelDto = {
  __typename?: 'ArrayOfFicheProfilDataDirectoModelDTO';
  FicheProfilDataDirectoModelDTO?: Array<FicheProfilDataDirectoModelDto>;
};

export type ArrayOfFicheProfilDataDirectoModelDtoInput = {
  FicheProfilDataDirectoModelDTO?: Array<FicheProfilDataDirectoModelDtoInput>;
};

export type ArrayOfFicheProfilInfosAffichageOnglet = {
  __typename?: 'ArrayOfFicheProfilInfosAffichageOnglet';
  FicheProfilInfosAffichageOnglet?: Array<FicheProfilInfosAffichageOnglet>;
};

export type ArrayOfFicheProfilInfosAffichageOngletInput = {
  FicheProfilInfosAffichageOnglet?: Array<FicheProfilInfosAffichageOngletInput>;
};

export type ArrayOfFichierCommandeModel = {
  __typename?: 'ArrayOfFichierCommandeModel';
  FichierCommandeModel?: Array<FichierCommandeModel>;
};

export type ArrayOfFichierCommandeModelInput = {
  FichierCommandeModel?: Array<FichierCommandeModelInput>;
};

export type ArrayOfFichierCompletModel = {
  __typename?: 'ArrayOfFichierCompletModel';
  FichierCompletModel?: Array<FichierCompletModel>;
};

export type ArrayOfFichierCompletModelInput = {
  FichierCompletModel?: Array<FichierCompletModelInput>;
};

export type ArrayOfFichierModel = {
  __typename?: 'ArrayOfFichierModel';
  FichierModel?: Array<FichierModel>;
};

export type ArrayOfFichierModelInput = {
  FichierModel?: Array<FichierModelInput>;
};

export type ArrayOfFichierTypeModel = {
  __typename?: 'ArrayOfFichierTypeModel';
  FichierTypeModel?: Array<FichierTypeModel>;
};

export type ArrayOfFichierTypeModelInput = {
  FichierTypeModel?: Array<FichierTypeModelInput>;
};

export type ArrayOfFonctionnalitesProfilModel = {
  __typename?: 'ArrayOfFonctionnalitesProfilModel';
  FonctionnalitesProfilModel?: Array<FonctionnalitesProfilModel>;
};

export type ArrayOfFonctionnalitesProfilModelInput = {
  FonctionnalitesProfilModel?: Array<FonctionnalitesProfilModelInput>;
};

export type ArrayOfFormulaireCommandeClotureModel = {
  __typename?: 'ArrayOfFormulaireCommandeClotureModel';
  FormulaireCommandeClotureModel?: Array<FormulaireCommandeClotureModel>;
};

export type ArrayOfFormulaireCommandeClotureModelInput = {
  FormulaireCommandeClotureModel?: Array<FormulaireCommandeClotureModelInput>;
};

export type ArrayOfFormulaireDto = {
  __typename?: 'ArrayOfFormulaireDTO';
  FormulaireDTO?: Array<FormulaireDto>;
};

export type ArrayOfFormulaireDtoInput = {
  FormulaireDTO?: Array<FormulaireDtoInput>;
};

export type ArrayOfFormulaireSectionGestionModel = {
  __typename?: 'ArrayOfFormulaireSectionGestionModel';
  FormulaireSectionGestionModel?: Array<FormulaireSectionGestionModel>;
};

export type ArrayOfFormulaireSectionGestionModelInput = {
  FormulaireSectionGestionModel?: Array<FormulaireSectionGestionModelInput>;
};

export type ArrayOfFormulePrestationModelDto = {
  __typename?: 'ArrayOfFormulePrestationModelDTO';
  FormulePrestationModelDTO?: Array<FormulePrestationModelDto>;
};

export type ArrayOfFormulePrestationModelDtoInput = {
  FormulePrestationModelDTO?: Array<FormulePrestationModelDtoInput>;
};

export type ArrayOfFournisseurBaseModel = {
  __typename?: 'ArrayOfFournisseurBaseModel';
  FournisseurBaseModel?: Array<FournisseurBaseModel>;
};

export type ArrayOfFournisseurBaseModelInput = {
  FournisseurBaseModel?: Array<FournisseurBaseModelInput>;
};

export type ArrayOfFournisseurDto = {
  __typename?: 'ArrayOfFournisseurDTO';
  FournisseurDTO?: Array<FournisseurDto>;
};

export type ArrayOfFournisseurDtoInput = {
  FournisseurDTO?: Array<FournisseurDtoInput>;
};

export type ArrayOfFournisseurModelDto = {
  __typename?: 'ArrayOfFournisseurModelDTO';
  FournisseurModelDTO?: Array<FournisseurModelDto>;
};

export type ArrayOfFournisseurModelDtoInput = {
  FournisseurModelDTO?: Array<FournisseurModelDtoInput>;
};

export type ArrayOfFournisseurRemiseGlobaleModel = {
  __typename?: 'ArrayOfFournisseurRemiseGlobaleModel';
  FournisseurRemiseGlobaleModel?: Array<FournisseurRemiseGlobaleModel>;
};

export type ArrayOfFournisseurRemiseGlobaleModelInput = {
  FournisseurRemiseGlobaleModel?: Array<FournisseurRemiseGlobaleModelInput>;
};

export type ArrayOfFraisAnnulationBaseModel = {
  __typename?: 'ArrayOfFraisAnnulationBaseModel';
  FraisAnnulationBaseModel?: Array<FraisAnnulationBaseModel>;
};

export type ArrayOfFraisAnnulationBaseModelInput = {
  FraisAnnulationBaseModel?: Array<FraisAnnulationBaseModelInput>;
};

export type ArrayOfFraisAnnulationSupprimableModel = {
  __typename?: 'ArrayOfFraisAnnulationSupprimableModel';
  FraisAnnulationSupprimableModel?: Array<Union_14140848403245432200>;
};

export type ArrayOfFraisAnnulationSupprimableModelInput = {
  FraisAnnulationSupprimableModel?: Array<FraisAnnulationSupprimableModelInput>;
};

export type ArrayOfGenerationArticleLocationModelInput = {
  GenerationArticleLocationModel?: Array<GenerationArticleLocationModelInput>;
};

export type ArrayOfGestionnaireDto = {
  __typename?: 'ArrayOfGestionnaireDTO';
  GestionnaireDTO?: Array<GestionnaireDto>;
};

export type ArrayOfGestionnaireDtoInput = {
  GestionnaireDTO?: Array<GestionnaireDtoInput>;
};

export type ArrayOfGraphiqueModelDto = {
  __typename?: 'ArrayOfGraphiqueModelDTO';
  GraphiqueModelDTO?: Array<GraphiqueModelDto>;
};

export type ArrayOfGraphiqueModelDtoInput = {
  GraphiqueModelDTO?: Array<GraphiqueModelDtoInput>;
};

export type ArrayOfGroupeRoomingListModel = {
  __typename?: 'ArrayOfGroupeRoomingListModel';
  GroupeRoomingListModel?: Array<GroupeRoomingListModel>;
};

export type ArrayOfGroupeRoomingListModelInput = {
  GroupeRoomingListModel?: Array<GroupeRoomingListModelInput>;
};

export type ArrayOfHeureModel = {
  __typename?: 'ArrayOfHeureModel';
  HeureModel?: Array<HeureModel>;
};

export type ArrayOfHeureModelInput = {
  HeureModel?: Array<HeureModelInput>;
};

export type ArrayOfHistoStatutCommandeDto = {
  __typename?: 'ArrayOfHistoStatutCommandeDTO';
  HistoStatutCommandeDTO?: Array<HistoStatutCommandeDto>;
};

export type ArrayOfHistoStatutCommandeDtoInput = {
  HistoStatutCommandeDTO?: Array<HistoStatutCommandeDtoInput>;
};

export type ArrayOfHistoStatutFactureDto = {
  __typename?: 'ArrayOfHistoStatutFactureDTO';
  HistoStatutFactureDTO?: Array<HistoStatutFactureDto>;
};

export type ArrayOfHistoStatutFactureDtoInput = {
  HistoStatutFactureDTO?: Array<HistoStatutFactureDtoInput>;
};

export type ArrayOfHistoriqueCourrierHistoriquePublipostageModel = {
  __typename?: 'ArrayOfHistoriqueCourrierHistoriquePublipostageModel';
  HistoriqueCourrierHistoriquePublipostageModel?: Array<HistoriqueCourrierHistoriquePublipostageModel>;
};

export type ArrayOfHistoriqueCourrierHistoriquePublipostageModelInput = {
  HistoriqueCourrierHistoriquePublipostageModel?: Array<HistoriqueCourrierHistoriquePublipostageModelInput>;
};

export type ArrayOfHistoriqueImpressionCourrierDto = {
  __typename?: 'ArrayOfHistoriqueImpressionCourrierDTO';
  HistoriqueImpressionCourrierDTO?: Array<HistoriqueImpressionCourrierDto>;
};

export type ArrayOfHistoriqueImpressionCourrierDtoInput = {
  HistoriqueImpressionCourrierDTO?: Array<HistoriqueImpressionCourrierDtoInput>;
};

export type ArrayOfHistoriqueModifBenefsHistoriqueModifBenefForAffichageModel = {
  __typename?: 'ArrayOfHistoriqueModifBenefsHistoriqueModifBenefForAffichageModel';
  HistoriqueModifBenefsHistoriqueModifBenefForAffichageModel?: Array<HistoriqueModifBenefsHistoriqueModifBenefForAffichageModel>;
};

export type ArrayOfHistoriqueModifBenefsHistoriqueModifBenefForAffichageModelInput = {
  HistoriqueModifBenefsHistoriqueModifBenefForAffichageModel?: Array<HistoriqueModifBenefsHistoriqueModifBenefForAffichageModelInput>;
};

export type ArrayOfIbanMandatLightModel = {
  __typename?: 'ArrayOfIBANMandatLightModel';
  IBANMandatLightModel?: Array<IbanMandatLightModel>;
};

export type ArrayOfIbanMandatLightModelInput = {
  IBANMandatLightModel?: Array<IbanMandatLightModelInput>;
};

export type ArrayOfIbanBeneficiaireModel = {
  __typename?: 'ArrayOfIbanBeneficiaireModel';
  IbanBeneficiaireModel?: Array<Union_6816468911052124524>;
};

export type ArrayOfIbanBeneficiaireModelInput = {
  IbanBeneficiaireModel?: Array<IbanBeneficiaireModelInput>;
};

export type ArrayOfIbanParametrageBaseModel = {
  __typename?: 'ArrayOfIbanParametrageBaseModel';
  IbanParametrageBaseModel?: Array<Union_11709815821493216246>;
};

export type ArrayOfIbanParametrageBaseModelInput = {
  IbanParametrageBaseModel?: Array<IbanParametrageBaseModelInput>;
};

export type ArrayOfIbanWithBanqueModel = {
  __typename?: 'ArrayOfIbanWithBanqueModel';
  IbanWithBanqueModel?: Array<IbanWithBanqueModel>;
};

export type ArrayOfIbanWithBanqueModelInput = {
  IbanWithBanqueModel?: Array<IbanWithBanqueModelInput>;
};

export type ArrayOfImpayesAvoirsAcomptesModel = {
  __typename?: 'ArrayOfImpayesAvoirsAcomptesModel';
  ImpayesAvoirsAcomptesModel?: Array<ImpayesAvoirsAcomptesModel>;
};

export type ArrayOfImpayesAvoirsAcomptesModelInput = {
  ImpayesAvoirsAcomptesModel?: Array<ImpayesAvoirsAcomptesModelInput>;
};

export type ArrayOfImportColMappingDto = {
  __typename?: 'ArrayOfImportColMappingDTO';
  ImportColMappingDTO?: Array<ImportColMappingDto>;
};

export type ArrayOfImportColMappingDtoInput = {
  ImportColMappingDTO?: Array<ImportColMappingDtoInput>;
};

export type ArrayOfImportColonneAMapperValeurModel = {
  __typename?: 'ArrayOfImportColonneAMapperValeurModel';
  ImportColonneAMapperValeurModel?: Array<ImportColonneAMapperValeurModel>;
};

export type ArrayOfImportColonneAMapperValeurModelInput = {
  ImportColonneAMapperValeurModel?: Array<ImportColonneAMapperValeurModelInput>;
};

export type ArrayOfImportHistoColonneArchiveDto = {
  __typename?: 'ArrayOfImportHistoColonneArchiveDTO';
  ImportHistoColonneArchiveDTO?: Array<ImportHistoColonneArchiveDto>;
};

export type ArrayOfImportHistoColonneArchiveDtoInput = {
  ImportHistoColonneArchiveDTO?: Array<ImportHistoColonneArchiveDtoInput>;
};

export type ArrayOfImportHistoColonneDto = {
  __typename?: 'ArrayOfImportHistoColonneDTO';
  ImportHistoColonneDTO?: Array<ImportHistoColonneDto>;
};

export type ArrayOfImportHistoColonneDtoInput = {
  ImportHistoColonneDTO?: Array<ImportHistoColonneDtoInput>;
};

export type ArrayOfImportHistoDto = {
  __typename?: 'ArrayOfImportHistoDTO';
  ImportHistoDTO?: Array<ImportHistoDto>;
};

export type ArrayOfImportHistoDtoInput = {
  ImportHistoDTO?: Array<ImportHistoDtoInput>;
};

export type ArrayOfImportHistoDetailsModelDto = {
  __typename?: 'ArrayOfImportHistoDetailsModelDTO';
  ImportHistoDetailsModelDTO?: Array<ImportHistoDetailsModelDto>;
};

export type ArrayOfImportHistoDetailsModelDtoInput = {
  ImportHistoDetailsModelDTO?: Array<ImportHistoDetailsModelDtoInput>;
};

export type ArrayOfImportHistoLigneArchiveDto = {
  __typename?: 'ArrayOfImportHistoLigneArchiveDTO';
  ImportHistoLigneArchiveDTO?: Array<ImportHistoLigneArchiveDto>;
};

export type ArrayOfImportHistoLigneArchiveDtoInput = {
  ImportHistoLigneArchiveDTO?: Array<ImportHistoLigneArchiveDtoInput>;
};

export type ArrayOfImportHistoLigneDto = {
  __typename?: 'ArrayOfImportHistoLigneDTO';
  ImportHistoLigneDTO?: Array<ImportHistoLigneDto>;
};

export type ArrayOfImportHistoLigneDtoInput = {
  ImportHistoLigneDTO?: Array<ImportHistoLigneDtoInput>;
};

export type ArrayOfImportHistoStatutDto = {
  __typename?: 'ArrayOfImportHistoStatutDTO';
  ImportHistoStatutDTO?: Array<ImportHistoStatutDto>;
};

export type ArrayOfImportHistoStatutDtoInput = {
  ImportHistoStatutDTO?: Array<ImportHistoStatutDtoInput>;
};

export type ArrayOfImportLogDetailsDto = {
  __typename?: 'ArrayOfImportLogDetailsDTO';
  ImportLogDetailsDTO?: Array<ImportLogDetailsDto>;
};

export type ArrayOfImportLogDetailsDtoInput = {
  ImportLogDetailsDTO?: Array<ImportLogDetailsDtoInput>;
};

export type ArrayOfImportLogGeneralDto = {
  __typename?: 'ArrayOfImportLogGeneralDTO';
  ImportLogGeneralDTO?: Array<ImportLogGeneralDto>;
};

export type ArrayOfImportLogGeneralDtoInput = {
  ImportLogGeneralDTO?: Array<ImportLogGeneralDtoInput>;
};

export type ArrayOfImportLogsDetaillesModelDto = {
  __typename?: 'ArrayOfImportLogsDetaillesModelDTO';
  ImportLogsDetaillesModelDTO?: Array<ImportLogsDetaillesModelDto>;
};

export type ArrayOfImportLogsDetaillesModelDtoInput = {
  ImportLogsDetaillesModelDTO?: Array<ImportLogsDetaillesModelDtoInput>;
};

export type ArrayOfImportModeleColDto = {
  __typename?: 'ArrayOfImportModeleColDTO';
  ImportModeleColDTO?: Array<ImportModeleColDto>;
};

export type ArrayOfImportModeleColDtoInput = {
  ImportModeleColDTO?: Array<ImportModeleColDtoInput>;
};

export type ArrayOfImportModeleDto = {
  __typename?: 'ArrayOfImportModeleDTO';
  ImportModeleDTO?: Array<ImportModeleDto>;
};

export type ArrayOfImportModeleDtoInput = {
  ImportModeleDTO?: Array<ImportModeleDtoInput>;
};

export type ArrayOfImportModeleTypeDto = {
  __typename?: 'ArrayOfImportModeleTypeDTO';
  ImportModeleTypeDTO?: Array<ImportModeleTypeDto>;
};

export type ArrayOfImportModeleTypeDtoInput = {
  ImportModeleTypeDTO?: Array<ImportModeleTypeDtoInput>;
};

export type ArrayOfImportReqPrepostDto = {
  __typename?: 'ArrayOfImportReqPrepostDTO';
  ImportReqPrepostDTO?: Array<ImportReqPrepostDto>;
};

export type ArrayOfImportReqPrepostDtoInput = {
  ImportReqPrepostDTO?: Array<ImportReqPrepostDtoInput>;
};

export type ArrayOfImportTraitDonneesDto = {
  __typename?: 'ArrayOfImportTraitDonneesDTO';
  ImportTraitDonneesDTO?: Array<ImportTraitDonneesDto>;
};

export type ArrayOfImportTraitDonneesDtoInput = {
  ImportTraitDonneesDTO?: Array<ImportTraitDonneesDtoInput>;
};

export type ArrayOfInfoColDataGridModelDto = {
  __typename?: 'ArrayOfInfoColDataGridModelDTO';
  InfoColDataGridModelDTO?: Array<InfoColDataGridModelDto>;
};

export type ArrayOfInfoColDataGridModelDtoInput = {
  InfoColDataGridModelDTO?: Array<InfoColDataGridModelDtoInput>;
};

export type ArrayOfInfoEmpruntModelDto = {
  __typename?: 'ArrayOfInfoEmpruntModelDTO';
  InfoEmpruntModelDTO?: Array<InfoEmpruntModelDto>;
};

export type ArrayOfInfoEmpruntModelDtoInput = {
  InfoEmpruntModelDTO?: Array<InfoEmpruntModelDtoInput>;
};

export type ArrayOfInfoStatutModel = {
  __typename?: 'ArrayOfInfoStatutModel';
  InfoStatutModel?: Array<InfoStatutModel>;
};

export type ArrayOfInfoStatutModelInput = {
  InfoStatutModel?: Array<InfoStatutModelInput>;
};

export type ArrayOfInfosArticleCadeaux = {
  __typename?: 'ArrayOfInfosArticleCadeaux';
  InfosArticleCadeaux?: Array<Union_28547402483733559094>;
};

export type ArrayOfInfosArticleCadeauxInput = {
  InfosArticleCadeaux?: Array<InfosArticleCadeauxInput>;
};

export type ArrayOfInfosAstucesNouveautesModelDto = {
  __typename?: 'ArrayOfInfosAstucesNouveautesModelDTO';
  InfosAstucesNouveautesModelDTO?: Array<InfosAstucesNouveautesModelDto>;
};

export type ArrayOfInfosAstucesNouveautesModelDtoInput = {
  InfosAstucesNouveautesModelDTO?: Array<InfosAstucesNouveautesModelDtoInput>;
};

export type ArrayOfInfosBeneficiairesModelDto = {
  __typename?: 'ArrayOfInfosBeneficiairesModelDTO';
  InfosBeneficiairesModelDTO?: Array<InfosBeneficiairesModelDto>;
};

export type ArrayOfInfosBeneficiairesModelDtoInput = {
  InfosBeneficiairesModelDTO?: Array<InfosBeneficiairesModelDtoInput>;
};

export type ArrayOfInfosDevisCdeInscriptionGroupeModel = {
  __typename?: 'ArrayOfInfosDevisCdeInscriptionGroupeModel';
  InfosDevisCdeInscriptionGroupeModel?: Array<InfosDevisCdeInscriptionGroupeModel>;
};

export type ArrayOfInfosDevisCdeInscriptionGroupeModelInput = {
  InfosDevisCdeInscriptionGroupeModel?: Array<InfosDevisCdeInscriptionGroupeModelInput>;
};

export type ArrayOfInfosDossiersPretsEtDonsHistoriqueModelDto = {
  __typename?: 'ArrayOfInfosDossiersPretsEtDonsHistoriqueModelDTO';
  InfosDossiersPretsEtDonsHistoriqueModelDTO?: Array<InfosDossiersPretsEtDonsHistoriqueModelDto>;
};

export type ArrayOfInfosDossiersPretsEtDonsHistoriqueModelDtoInput = {
  InfosDossiersPretsEtDonsHistoriqueModelDTO?: Array<InfosDossiersPretsEtDonsHistoriqueModelDtoInput>;
};

export type ArrayOfInfosEcritureAffichageBaseModel = {
  __typename?: 'ArrayOfInfosEcritureAffichageBaseModel';
  InfosEcritureAffichageBaseModel?: Array<InfosEcritureAffichageBaseModel>;
};

export type ArrayOfInfosEcritureAffichageBaseModelInput = {
  InfosEcritureAffichageBaseModel?: Array<InfosEcritureAffichageBaseModelInput>;
};

export type ArrayOfInfosMouvementLettrageAutoModel = {
  __typename?: 'ArrayOfInfosMouvementLettrageAutoModel';
  InfosMouvementLettrageAutoModel?: Array<InfosMouvementLettrageAutoModel>;
};

export type ArrayOfInfosMouvementLettrageAutoModelInput = {
  InfosMouvementLettrageAutoModel?: Array<InfosMouvementLettrageAutoModelInput>;
};

export type ArrayOfInfosPjTypeModel = {
  __typename?: 'ArrayOfInfosPJTypeModel';
  InfosPJTypeModel?: Array<InfosPjTypeModel>;
};

export type ArrayOfInfosPjTypeModelInput = {
  InfosPJTypeModel?: Array<InfosPjTypeModelInput>;
};

export type ArrayOfInventaireDto = {
  __typename?: 'ArrayOfInventaireDTO';
  InventaireDTO?: Array<InventaireDto>;
};

export type ArrayOfInventaireDtoInput = {
  InventaireDTO?: Array<InventaireDtoInput>;
};

export type ArrayOfJourModelInput = {
  JourModel?: Array<JourModelInput>;
};

export type ArrayOfJournalBaseModel = {
  __typename?: 'ArrayOfJournalBaseModel';
  JournalBaseModel?: Array<JournalBaseModel>;
};

export type ArrayOfJournalBaseModelInput = {
  JournalBaseModel?: Array<JournalBaseModelInput>;
};

export type ArrayOfJournalDto = {
  __typename?: 'ArrayOfJournalDTO';
  JournalDTO?: Array<JournalDto>;
};

export type ArrayOfJournalDtoInput = {
  JournalDTO?: Array<JournalDtoInput>;
};

export type ArrayOfJournalEcritureModel = {
  __typename?: 'ArrayOfJournalEcritureModel';
  JournalEcritureModel?: Array<JournalEcritureModel>;
};

export type ArrayOfJournalEcritureModelInput = {
  JournalEcritureModel?: Array<JournalEcritureModelInput>;
};

export type ArrayOfJournalLightModel = {
  __typename?: 'ArrayOfJournalLightModel';
  JournalLightModel?: Array<JournalLightModel>;
};

export type ArrayOfJournalLightModelInput = {
  JournalLightModel?: Array<JournalLightModelInput>;
};

export type ArrayOfJournalModelDto = {
  __typename?: 'ArrayOfJournalModelDTO';
  JournalModelDTO?: Array<JournalModelDto>;
};

export type ArrayOfJournalModelDtoInput = {
  JournalModelDTO?: Array<JournalModelDtoInput>;
};

export type ArrayOfJournalTypeDto = {
  __typename?: 'ArrayOfJournalTypeDTO';
  JournalTypeDTO?: Array<JournalTypeDto>;
};

export type ArrayOfJournalTypeDtoInput = {
  JournalTypeDTO?: Array<JournalTypeDtoInput>;
};

export type ArrayOfKeyValueModelDto = {
  __typename?: 'ArrayOfKeyValueModelDTO';
  KeyValueModelDTO?: Array<KeyValueModelDto>;
};

export type ArrayOfKeyValueModelDtoInput = {
  KeyValueModelDTO?: Array<KeyValueModelDtoInput>;
};

export type ArrayOfKeyValueOfdecimalNullableOfdateTimeU6ho3Bhd = {
  __typename?: 'ArrayOfKeyValueOfdecimalNullableOfdateTimeU6ho3Bhd';
  KeyValueOfdecimalNullableOfdateTimeU6ho3Bhd?: Array<KeyValueOfdecimalNullableOfdateTimeU6ho3Bhd>;
};

export type ArrayOfKeyValueOfdecimalNullableOfdateTimeU6ho3BhdInput = {
  KeyValueOfdecimalNullableOfdateTimeU6ho3Bhd?: Array<KeyValueOfdecimalNullableOfdateTimeU6ho3BhdInput>;
};

export type ArrayOfKeyValueOfdecimalNullableOfdecimalU6ho3BhdInput = {
  KeyValueOfdecimalNullableOfdecimalU6ho3Bhd?: Array<KeyValueOfdecimalNullableOfdecimalU6ho3BhdInput>;
};

export type ArrayOfKeyValueOfdecimalint = {
  __typename?: 'ArrayOfKeyValueOfdecimalint';
  KeyValueOfdecimalint?: Array<KeyValueOfdecimalint>;
};

export type ArrayOfKeyValueOfdecimalintInput = {
  KeyValueOfdecimalint?: Array<KeyValueOfdecimalintInput>;
};

export type ArrayOfKeyValueOfdecimalstring = {
  __typename?: 'ArrayOfKeyValueOfdecimalstring';
  KeyValueOfdecimalstring?: Array<KeyValueOfdecimalstring>;
};

export type ArrayOfKeyValueOfdecimalstringInput = {
  KeyValueOfdecimalstring?: Array<KeyValueOfdecimalstringInput>;
};

export type ArrayOfKeyValueOfintstring = {
  __typename?: 'ArrayOfKeyValueOfintstring';
  KeyValueOfintstring?: Array<KeyValueOfintstring>;
};

export type ArrayOfKeyValueOfintstringInput = {
  KeyValueOfintstring?: Array<KeyValueOfintstringInput>;
};

export type ArrayOfKeyValueOfstringFactureDtoOsihyJcl = {
  __typename?: 'ArrayOfKeyValueOfstringFactureDTOOsihyJcl';
  KeyValueOfstringFactureDTOOsihyJcl?: Array<KeyValueOfstringFactureDtoOsihyJcl>;
};

export type ArrayOfKeyValueOfstringFactureDtoOsihyJclInput = {
  KeyValueOfstringFactureDTOOsihyJcl?: Array<KeyValueOfstringFactureDtoOsihyJclInput>;
};

export type ArrayOfKeyValueOfstringanyTypeInput = {
  KeyValueOfstringanyType?: Array<KeyValueOfstringanyTypeInput>;
};

export type ArrayOfKeyValueOfstringdecimal = {
  __typename?: 'ArrayOfKeyValueOfstringdecimal';
  KeyValueOfstringdecimal?: Array<KeyValueOfstringdecimal>;
};

export type ArrayOfKeyValueOfstringdecimalInput = {
  KeyValueOfstringdecimal?: Array<KeyValueOfstringdecimalInput>;
};

export type ArrayOfKeyValueOfstringstring = {
  __typename?: 'ArrayOfKeyValueOfstringstring';
  KeyValueOfstringstring?: Array<KeyValueOfstringstring>;
};

export type ArrayOfKeyValueOfstringstringInput = {
  KeyValueOfstringstring?: Array<KeyValueOfstringstringInput>;
};

export type ArrayOfLettrageModel = {
  __typename?: 'ArrayOfLettrageModel';
  LettrageModel?: Array<LettrageModel>;
};

export type ArrayOfLettrageModelInput = {
  LettrageModel?: Array<LettrageModelInput>;
};

export type ArrayOfLibTypePjBaseModel = {
  __typename?: 'ArrayOfLibTypePJBaseModel';
  LibTypePJBaseModel?: Array<LibTypePjBaseModel>;
};

export type ArrayOfLibTypePjBaseModelInput = {
  LibTypePJBaseModel?: Array<LibTypePjBaseModelInput>;
};

export type ArrayOfLibellesAfpaModel = {
  __typename?: 'ArrayOfLibellesAFPAModel';
  LibellesAFPAModel?: Array<LibellesAfpaModel>;
};

export type ArrayOfLibellesAfpaModelInput = {
  LibellesAFPAModel?: Array<LibellesAfpaModelInput>;
};

export type ArrayOfLienDirectoDto = {
  __typename?: 'ArrayOfLienDirectoDTO';
  LienDirectoDTO?: Array<LienDirectoDto>;
};

export type ArrayOfLienDirectoDtoInput = {
  LienDirectoDTO?: Array<LienDirectoDtoInput>;
};

export type ArrayOfLienDirectoModelDto = {
  __typename?: 'ArrayOfLienDirectoModelDTO';
  LienDirectoModelDTO?: Array<LienDirectoModelDto>;
};

export type ArrayOfLienDirectoModelDtoInput = {
  LienDirectoModelDTO?: Array<LienDirectoModelDtoInput>;
};

export type ArrayOfLieuDto = {
  __typename?: 'ArrayOfLieuDTO';
  LieuDTO?: Array<LieuDto>;
};

export type ArrayOfLieuDtoInput = {
  LieuDTO?: Array<LieuDtoInput>;
};

export type ArrayOfLieuModelDto = {
  __typename?: 'ArrayOfLieuModelDTO';
  LieuModelDTO?: Array<LieuModelDto>;
};

export type ArrayOfLieuModelDtoInput = {
  LieuModelDTO?: Array<LieuModelDtoInput>;
};

export type ArrayOfLigneAttributionModelDto = {
  __typename?: 'ArrayOfLigneAttributionModelDTO';
  LigneAttributionModelDTO?: Array<LigneAttributionModelDto>;
};

export type ArrayOfLigneAttributionModelDtoInput = {
  LigneAttributionModelDTO?: Array<LigneAttributionModelDtoInput>;
};

export type ArrayOfLigneAvoirModelDto = {
  __typename?: 'ArrayOfLigneAvoirModelDTO';
  LigneAvoirModelDTO?: Array<LigneAvoirModelDto>;
};

export type ArrayOfLigneAvoirModelDtoInput = {
  LigneAvoirModelDTO?: Array<LigneAvoirModelDtoInput>;
};

export type ArrayOfLigneBlBrDto = {
  __typename?: 'ArrayOfLigneBlBrDTO';
  LigneBlBrDTO?: Array<LigneBlBrDto>;
};

export type ArrayOfLigneBlBrDtoInput = {
  LigneBlBrDTO?: Array<LigneBlBrDtoInput>;
};

export type ArrayOfLigneCdeFourArticleReapproModelDto = {
  __typename?: 'ArrayOfLigneCdeFourArticleReapproModelDTO';
  LigneCdeFourArticleReapproModelDTO?: Array<LigneCdeFourArticleReapproModelDto>;
};

export type ArrayOfLigneCdeFourArticleReapproModelDtoInput = {
  LigneCdeFourArticleReapproModelDTO?: Array<LigneCdeFourArticleReapproModelDtoInput>;
};

export type ArrayOfLigneCessionStockDetailModel = {
  __typename?: 'ArrayOfLigneCessionStockDetailModel';
  LigneCessionStockDetailModel?: Array<LigneCessionStockDetailModel>;
};

export type ArrayOfLigneCessionStockDetailModelInput = {
  LigneCessionStockDetailModel?: Array<LigneCessionStockDetailModelInput>;
};

export type ArrayOfLigneCessionStockTransfertStockModel = {
  __typename?: 'ArrayOfLigneCessionStockTransfertStockModel';
  LigneCessionStockTransfertStockModel?: Array<Union_1767873430737490976>;
};

export type ArrayOfLigneCessionStockTransfertStockModelInput = {
  LigneCessionStockTransfertStockModel?: Array<LigneCessionStockTransfertStockModelInput>;
};

export type ArrayOfLigneCommandeDto = {
  __typename?: 'ArrayOfLigneCommandeDTO';
  LigneCommandeDTO?: Array<LigneCommandeDto>;
};

export type ArrayOfLigneCommandeDtoInput = {
  LigneCommandeDTO?: Array<LigneCommandeDtoInput>;
};

export type ArrayOfLigneCommandeFormulaireModel = {
  __typename?: 'ArrayOfLigneCommandeFormulaireModel';
  LigneCommandeFormulaireModel?: Array<LigneCommandeFormulaireModel>;
};

export type ArrayOfLigneCommandeFormulaireModelInput = {
  LigneCommandeFormulaireModel?: Array<LigneCommandeFormulaireModelInput>;
};

export type ArrayOfLigneCommandeHistoriqueReservationRpModel = {
  __typename?: 'ArrayOfLigneCommandeHistoriqueReservationRPModel';
  LigneCommandeHistoriqueReservationRPModel?: Array<Union_42311842012658979327>;
};

export type ArrayOfLigneCommandeHistoriqueReservationRpModelInput = {
  LigneCommandeHistoriqueReservationRPModel?: Array<LigneCommandeHistoriqueReservationRpModelInput>;
};

export type ArrayOfLigneCommandeLibreModelDto = {
  __typename?: 'ArrayOfLigneCommandeLibreModelDTO';
  LigneCommandeLibreModelDTO?: Array<LigneCommandeLibreModelDto>;
};

export type ArrayOfLigneCommandeLibreModelDtoInput = {
  LigneCommandeLibreModelDTO?: Array<LigneCommandeLibreModelDtoInput>;
};

export type ArrayOfLigneCommandeValidationAncvConnectModel = {
  __typename?: 'ArrayOfLigneCommandeValidationANCVConnectModel';
  LigneCommandeValidationANCVConnectModel?: Array<LigneCommandeValidationAncvConnectModel>;
};

export type ArrayOfLigneCommandeValidationAncvConnectModelInput = {
  LigneCommandeValidationANCVConnectModel?: Array<LigneCommandeValidationAncvConnectModelInput>;
};

export type ArrayOfLigneDevisModeleDto = {
  __typename?: 'ArrayOfLigneDevisModeleDTO';
  LigneDevisModeleDTO?: Array<LigneDevisModeleDto>;
};

export type ArrayOfLigneDevisModeleDtoInput = {
  LigneDevisModeleDTO?: Array<LigneDevisModeleDtoInput>;
};

export type ArrayOfLigneDossierPrestationModelDto = {
  __typename?: 'ArrayOfLigneDossierPrestationModelDTO';
  LigneDossierPrestationModelDTO?: Array<LigneDossierPrestationModelDto>;
};

export type ArrayOfLigneDossierPrestationModelDtoInput = {
  LigneDossierPrestationModelDTO?: Array<LigneDossierPrestationModelDtoInput>;
};

export type ArrayOfLigneFactureDto = {
  __typename?: 'ArrayOfLigneFactureDTO';
  LigneFactureDTO?: Array<LigneFactureDto>;
};

export type ArrayOfLigneFactureDtoInput = {
  LigneFactureDTO?: Array<LigneFactureDtoInput>;
};

export type ArrayOfLigneFactureSectionAnalytiqueDto = {
  __typename?: 'ArrayOfLigneFactureSectionAnalytiqueDTO';
  LigneFactureSectionAnalytiqueDTO?: Array<LigneFactureSectionAnalytiqueDto>;
};

export type ArrayOfLigneFactureSectionAnalytiqueDtoInput = {
  LigneFactureSectionAnalytiqueDTO?: Array<LigneFactureSectionAnalytiqueDtoInput>;
};

export type ArrayOfLigneFraisAnnulationModel = {
  __typename?: 'ArrayOfLigneFraisAnnulationModel';
  LigneFraisAnnulationModel?: Array<LigneFraisAnnulationModel>;
};

export type ArrayOfLigneFraisAnnulationModelInput = {
  LigneFraisAnnulationModel?: Array<LigneFraisAnnulationModelInput>;
};

export type ArrayOfLigneFraisPortDto = {
  __typename?: 'ArrayOfLigneFraisPortDTO';
  LigneFraisPortDTO?: Array<LigneFraisPortDto>;
};

export type ArrayOfLigneFraisPortDtoInput = {
  LigneFraisPortDTO?: Array<LigneFraisPortDtoInput>;
};

export type ArrayOfLigneInventaireDto = {
  __typename?: 'ArrayOfLigneInventaireDTO';
  LigneInventaireDTO?: Array<LigneInventaireDto>;
};

export type ArrayOfLigneInventaireDtoInput = {
  LigneInventaireDTO?: Array<LigneInventaireDtoInput>;
};

export type ArrayOfLigneInventaireStockModel = {
  __typename?: 'ArrayOfLigneInventaireStockModel';
  LigneInventaireStockModel?: Array<LigneInventaireStockModel>;
};

export type ArrayOfLigneInventaireStockModelInput = {
  LigneInventaireStockModel?: Array<LigneInventaireStockModelInput>;
};

export type ArrayOfLigneReceptionCessionStockModel = {
  __typename?: 'ArrayOfLigneReceptionCessionStockModel';
  LigneReceptionCessionStockModel?: Array<LigneReceptionCessionStockModel>;
};

export type ArrayOfLigneReceptionCessionStockModelInput = {
  LigneReceptionCessionStockModel?: Array<LigneReceptionCessionStockModelInput>;
};

export type ArrayOfLigneRemiseEnBanqueModel = {
  __typename?: 'ArrayOfLigneRemiseEnBanqueModel';
  LigneRemiseEnBanqueModel?: Array<LigneRemiseEnBanqueModel>;
};

export type ArrayOfLigneRemiseEnBanqueModelInput = {
  LigneRemiseEnBanqueModel?: Array<LigneRemiseEnBanqueModelInput>;
};

export type ArrayOfLigneRemiseEnCaisseForValidationNonFiduModel = {
  __typename?: 'ArrayOfLigneRemiseEnCaisseForValidationNonFiduModel';
  LigneRemiseEnCaisseForValidationNonFiduModel?: Array<LigneRemiseEnCaisseForValidationNonFiduModel>;
};

export type ArrayOfLigneRemiseEnCaisseForValidationNonFiduModelInput = {
  LigneRemiseEnCaisseForValidationNonFiduModel?: Array<LigneRemiseEnCaisseForValidationNonFiduModelInput>;
};

export type ArrayOfLigneRepartitionCompteAnaSecModelDto = {
  __typename?: 'ArrayOfLigneRepartitionCompteAnaSecModelDTO';
  LigneRepartitionCompteAnaSecModelDTO?: Array<LigneRepartitionCompteAnaSecModelDto>;
};

export type ArrayOfLigneRepartitionCompteAnaSecModelDtoInput = {
  LigneRepartitionCompteAnaSecModelDTO?: Array<LigneRepartitionCompteAnaSecModelDtoInput>;
};

export type ArrayOfLigneResultatImportArticle = {
  __typename?: 'ArrayOfLigneResultatImportArticle';
  LigneResultatImportArticle?: Array<LigneResultatImportArticle>;
};

export type ArrayOfLigneResultatImportArticleInput = {
  LigneResultatImportArticle?: Array<LigneResultatImportArticleInput>;
};

export type ArrayOfLignesEnvoiModelDto = {
  __typename?: 'ArrayOfLignesEnvoiModelDTO';
  LignesEnvoiModelDTO?: Array<LignesEnvoiModelDto>;
};

export type ArrayOfLignesEnvoiModelDtoInput = {
  LignesEnvoiModelDTO?: Array<LignesEnvoiModelDtoInput>;
};

export type ArrayOfListeActualiteMobileModel = {
  __typename?: 'ArrayOfListeActualiteMobileModel';
  ListeActualiteMobileModel?: Array<ListeActualiteMobileModel>;
};

export type ArrayOfListeActualiteMobileModelInput = {
  ListeActualiteMobileModel?: Array<ListeActualiteMobileModelInput>;
};

export type ArrayOfListeHomeNotification = {
  __typename?: 'ArrayOfListeHomeNotification';
  ListeHomeNotification?: Array<ListeHomeNotification>;
};

export type ArrayOfListeHomeNotificationInput = {
  ListeHomeNotification?: Array<ListeHomeNotificationInput>;
};

export type ArrayOfListerCourrierModel = {
  __typename?: 'ArrayOfListerCourrierModel';
  ListerCourrierModel?: Array<ListerCourrierModel>;
};

export type ArrayOfListerCourrierModelInput = {
  ListerCourrierModel?: Array<ListerCourrierModelInput>;
};

export type ArrayOfListerRessourceModel = {
  __typename?: 'ArrayOfListerRessourceModel';
  ListerRessourceModel?: Array<ListerRessourceModel>;
};

export type ArrayOfListerRessourceModelInput = {
  ListerRessourceModel?: Array<ListerRessourceModelInput>;
};

export type ArrayOfListerRoomingListModel = {
  __typename?: 'ArrayOfListerRoomingListModel';
  ListerRoomingListModel?: Array<ListerRoomingListModel>;
};

export type ArrayOfListerRoomingListModelInput = {
  ListerRoomingListModel?: Array<ListerRoomingListModelInput>;
};

export type ArrayOfLivraisonsCommandesInfosLivraisonBaseModel = {
  __typename?: 'ArrayOfLivraisonsCommandesInfosLivraisonBaseModel';
  LivraisonsCommandesInfosLivraisonBaseModel?: Array<Union_33497648392782579495>;
};

export type ArrayOfLivraisonsCommandesInfosLivraisonBaseModelInput = {
  LivraisonsCommandesInfosLivraisonBaseModel?: Array<LivraisonsCommandesInfosLivraisonBaseModelInput>;
};

export type ArrayOfLivraisonsInfosLigneCdeForLivraisonReceptionModeleInput = {
  LivraisonsInfosLigneCdeForLivraisonReceptionModele?: Array<LivraisonsInfosLigneCdeForLivraisonReceptionModeleInput>;
};

export type ArrayOfLocationTauxOccupationModel = {
  __typename?: 'ArrayOfLocationTauxOccupationModel';
  LocationTauxOccupationModel?: Array<Union_6714739481622726207>;
};

export type ArrayOfLocationTauxOccupationModelInput = {
  LocationTauxOccupationModel?: Array<LocationTauxOccupationModelInput>;
};

export type ArrayOfLogAfpaHistoriqueModel = {
  __typename?: 'ArrayOfLogAFPAHistoriqueModel';
  LogAFPAHistoriqueModel?: Array<LogAfpaHistoriqueModel>;
};

export type ArrayOfLogAfpaHistoriqueModelInput = {
  LogAFPAHistoriqueModel?: Array<LogAfpaHistoriqueModelInput>;
};

export type ArrayOfMandatUseModel = {
  __typename?: 'ArrayOfMandatUseModel';
  MandatUseModel?: Array<MandatUseModel>;
};

export type ArrayOfMandatUseModelInput = {
  MandatUseModel?: Array<MandatUseModelInput>;
};

export type ArrayOfMediaImportModelInput = {
  MediaImportModel?: Array<MediaImportModelInput>;
};

export type ArrayOfMediathequeExemplaireCatalogueMediaModel = {
  __typename?: 'ArrayOfMediathequeExemplaireCatalogueMediaModel';
  MediathequeExemplaireCatalogueMediaModel?: Array<Union_2735844942145325600>;
};

export type ArrayOfMediathequeExemplaireCatalogueMediaModelInput = {
  MediathequeExemplaireCatalogueMediaModel?: Array<MediathequeExemplaireCatalogueMediaModelInput>;
};

export type ArrayOfMediathequeFamilleLightModel = {
  __typename?: 'ArrayOfMediathequeFamilleLightModel';
  MediathequeFamilleLightModel?: Array<MediathequeFamilleLightModel>;
};

export type ArrayOfMediathequeFamilleLightModelInput = {
  MediathequeFamilleLightModel?: Array<MediathequeFamilleLightModelInput>;
};

export type ArrayOfMediathequeListeCatalogueMediaModel = {
  __typename?: 'ArrayOfMediathequeListeCatalogueMediaModel';
  MediathequeListeCatalogueMediaModel?: Array<MediathequeListeCatalogueMediaModel>;
};

export type ArrayOfMediathequeListeCatalogueMediaModelInput = {
  MediathequeListeCatalogueMediaModel?: Array<MediathequeListeCatalogueMediaModelInput>;
};

export type ArrayOfMenuDto = {
  __typename?: 'ArrayOfMenuDTO';
  MenuDTO?: Array<MenuDto>;
};

export type ArrayOfMenuDtoInput = {
  MenuDTO?: Array<MenuDtoInput>;
};

export type ArrayOfMenuPageDto = {
  __typename?: 'ArrayOfMenuPageDTO';
  MenuPageDTO?: Array<MenuPageDto>;
};

export type ArrayOfMenuPageDtoInput = {
  MenuPageDTO?: Array<MenuPageDtoInput>;
};

export type ArrayOfMenuPageParamDto = {
  __typename?: 'ArrayOfMenuPageParamDTO';
  MenuPageParamDTO?: Array<MenuPageParamDto>;
};

export type ArrayOfMenuPageParamDtoInput = {
  MenuPageParamDTO?: Array<MenuPageParamDtoInput>;
};

export type ArrayOfMenusArticleTreeViewModuleGestionMenusModel = {
  __typename?: 'ArrayOfMenusArticleTreeViewModuleGestionMenusModel';
  MenusArticleTreeViewModuleGestionMenusModel?: Array<MenusArticleTreeViewModuleGestionMenusModel>;
};

export type ArrayOfMenusArticleTreeViewModuleGestionMenusModelInput = {
  MenusArticleTreeViewModuleGestionMenusModel?: Array<MenusArticleTreeViewModuleGestionMenusModelInput>;
};

export type ArrayOfMessageAppliDto = {
  __typename?: 'ArrayOfMessageAppliDTO';
  MessageAppliDTO?: Array<MessageAppliDto>;
};

export type ArrayOfMessageAppliDtoInput = {
  MessageAppliDTO?: Array<MessageAppliDtoInput>;
};

export type ArrayOfModeEnvoiAncvModel = {
  __typename?: 'ArrayOfModeEnvoiANCVModel';
  ModeEnvoiANCVModel?: Array<ModeEnvoiAncvModel>;
};

export type ArrayOfModeEnvoiAncvModelInput = {
  ModeEnvoiANCVModel?: Array<ModeEnvoiAncvModelInput>;
};

export type ArrayOfModeLivraisonDto = {
  __typename?: 'ArrayOfModeLivraisonDTO';
  ModeLivraisonDTO?: Array<ModeLivraisonDto>;
};

export type ArrayOfModeLivraisonDtoInput = {
  ModeLivraisonDTO?: Array<ModeLivraisonDtoInput>;
};

export type ArrayOfModeLivraisonFpaModel = {
  __typename?: 'ArrayOfModeLivraisonFPAModel';
  ModeLivraisonFPAModel?: Array<ModeLivraisonFpaModel>;
};

export type ArrayOfModeLivraisonFpaModelInput = {
  ModeLivraisonFPAModel?: Array<ModeLivraisonFpaModelInput>;
};

export type ArrayOfModeLivraisonFraisPortDto = {
  __typename?: 'ArrayOfModeLivraisonFraisPortDTO';
  ModeLivraisonFraisPortDTO?: Array<ModeLivraisonFraisPortDto>;
};

export type ArrayOfModeLivraisonFraisPortDtoInput = {
  ModeLivraisonFraisPortDTO?: Array<ModeLivraisonFraisPortDtoInput>;
};

export type ArrayOfModeLivraisonModeleDto = {
  __typename?: 'ArrayOfModeLivraisonModeleDTO';
  ModeLivraisonModeleDTO?: Array<ModeLivraisonModeleDto>;
};

export type ArrayOfModeLivraisonModeleDtoInput = {
  ModeLivraisonModeleDTO?: Array<ModeLivraisonModeleDtoInput>;
};

export type ArrayOfModelEmailModelEmailClotureModel = {
  __typename?: 'ArrayOfModelEmailModelEmailClotureModel';
  ModelEmailModelEmailClotureModel?: Array<ModelEmailModelEmailClotureModel>;
};

export type ArrayOfModelEmailModelEmailClotureModelInput = {
  ModelEmailModelEmailClotureModel?: Array<ModelEmailModelEmailClotureModelInput>;
};

export type ArrayOfModelEmailModelEmailVuePubliModel = {
  __typename?: 'ArrayOfModelEmailModelEmailVuePubliModel';
  ModelEmailModelEmailVuePubliModel?: Array<ModelEmailModelEmailVuePubliModel>;
};

export type ArrayOfModelEmailModelEmailVuePubliModelInput = {
  ModelEmailModelEmailVuePubliModel?: Array<ModelEmailModelEmailVuePubliModelInput>;
};

export type ArrayOfModelEmailModelEmailVuePubliModelLight = {
  __typename?: 'ArrayOfModelEmailModelEmailVuePubliModelLight';
  ModelEmailModelEmailVuePubliModelLight?: Array<ModelEmailModelEmailVuePubliModelLight>;
};

export type ArrayOfModelEmailModelEmailVuePubliModelLightInput = {
  ModelEmailModelEmailVuePubliModelLight?: Array<ModelEmailModelEmailVuePubliModelLightInput>;
};

export type ArrayOfModeleAdresseBaseModel = {
  __typename?: 'ArrayOfModeleAdresseBaseModel';
  ModeleAdresseBaseModel?: Array<ModeleAdresseBaseModel>;
};

export type ArrayOfModeleAdresseBaseModelInput = {
  ModeleAdresseBaseModel?: Array<ModeleAdresseBaseModelInput>;
};

export type ArrayOfModeleAdresseModelDto = {
  __typename?: 'ArrayOfModeleAdresseModelDTO';
  ModeleAdresseModelDTO?: Array<ModeleAdresseModelDto>;
};

export type ArrayOfModeleAdresseModelDtoInput = {
  ModeleAdresseModelDTO?: Array<ModeleAdresseModelDtoInput>;
};

export type ArrayOfModeleConsoEnvQuotaDto = {
  __typename?: 'ArrayOfModeleConsoEnvQuotaDTO';
  ModeleConsoEnvQuotaDTO?: Array<ModeleConsoEnvQuotaDto>;
};

export type ArrayOfModeleConsoEnvQuotaDtoInput = {
  ModeleConsoEnvQuotaDTO?: Array<ModeleConsoEnvQuotaDtoInput>;
};

export type ArrayOfModeleEchancierListingModel = {
  __typename?: 'ArrayOfModeleEchancierListingModel';
  ModeleEchancierListingModel?: Array<Union_11308712901971539728>;
};

export type ArrayOfModeleEchancierListingModelInput = {
  ModeleEchancierListingModel?: Array<ModeleEchancierListingModelInput>;
};

export type ArrayOfModeleEcheancierBaseModel = {
  __typename?: 'ArrayOfModeleEcheancierBaseModel';
  ModeleEcheancierBaseModel?: Array<ModeleEcheancierBaseModel>;
};

export type ArrayOfModeleEcheancierBaseModelInput = {
  ModeleEcheancierBaseModel?: Array<ModeleEcheancierBaseModelInput>;
};

export type ArrayOfModeleEcheancierDefautModel = {
  __typename?: 'ArrayOfModeleEcheancierDefautModel';
  ModeleEcheancierDefautModel?: Array<ModeleEcheancierDefautModel>;
};

export type ArrayOfModeleEcheancierDefautModelInput = {
  ModeleEcheancierDefautModel?: Array<ModeleEcheancierDefautModelInput>;
};

export type ArrayOfModeleEcheancierFpaModel = {
  __typename?: 'ArrayOfModeleEcheancierFPAModel';
  ModeleEcheancierFPAModel?: Array<ModeleEcheancierFpaModel>;
};

export type ArrayOfModeleEcheancierFpaModelInput = {
  ModeleEcheancierFPAModel?: Array<ModeleEcheancierFpaModelInput>;
};

export type ArrayOfModeleEcheancierGeneriqueModel = {
  __typename?: 'ArrayOfModeleEcheancierGeneriqueModel';
  ModeleEcheancierGeneriqueModel?: Array<ModeleEcheancierGeneriqueModel>;
};

export type ArrayOfModeleEcheancierGeneriqueModelInput = {
  ModeleEcheancierGeneriqueModel?: Array<ModeleEcheancierGeneriqueModelInput>;
};

export type ArrayOfModeleEcheancierMntMinModel = {
  __typename?: 'ArrayOfModeleEcheancierMntMinModel';
  ModeleEcheancierMntMinModel?: Array<ModeleEcheancierMntMinModel>;
};

export type ArrayOfModeleEcheancierMntMinModelInput = {
  ModeleEcheancierMntMinModel?: Array<ModeleEcheancierMntMinModelInput>;
};

export type ArrayOfModeleEnveloppeDto = {
  __typename?: 'ArrayOfModeleEnveloppeDTO';
  ModeleEnveloppeDTO?: Array<ModeleEnveloppeDto>;
};

export type ArrayOfModeleEnveloppeDtoInput = {
  ModeleEnveloppeDTO?: Array<ModeleEnveloppeDtoInput>;
};

export type ArrayOfModeleHistoRaprpochementDto = {
  __typename?: 'ArrayOfModeleHistoRaprpochementDTO';
  ModeleHistoRaprpochementDTO?: Array<ModeleHistoRaprpochementDto>;
};

export type ArrayOfModeleHistoRaprpochementDtoInput = {
  ModeleHistoRaprpochementDTO?: Array<ModeleHistoRaprpochementDtoInput>;
};

export type ArrayOfModeleLocationBaseModel = {
  __typename?: 'ArrayOfModeleLocationBaseModel';
  ModeleLocationBaseModel?: Array<ModeleLocationBaseModel>;
};

export type ArrayOfModeleLocationBaseModelInput = {
  ModeleLocationBaseModel?: Array<ModeleLocationBaseModelInput>;
};

export type ArrayOfModeleLocationPlageDateModel = {
  __typename?: 'ArrayOfModeleLocationPlageDateModel';
  ModeleLocationPlageDateModel?: Array<ModeleLocationPlageDateModel>;
};

export type ArrayOfModeleLocationPlageDateModelInput = {
  ModeleLocationPlageDateModel?: Array<ModeleLocationPlageDateModelInput>;
};

export type ArrayOfModeleLocationReglesSubModel = {
  __typename?: 'ArrayOfModeleLocationReglesSubModel';
  ModeleLocationReglesSubModel?: Array<ModeleLocationReglesSubModel>;
};

export type ArrayOfModeleLocationReglesSubModelInput = {
  ModeleLocationReglesSubModel?: Array<ModeleLocationReglesSubModelInput>;
};

export type ArrayOfModeleRegleAccChpListValModeGuide = {
  __typename?: 'ArrayOfModeleRegleAccChpListValModeGuide';
  ModeleRegleAccChpListValModeGuide?: Array<ModeleRegleAccChpListValModeGuide>;
};

export type ArrayOfModeleRegleAccChpListValModeGuideInput = {
  ModeleRegleAccChpListValModeGuide?: Array<ModeleRegleAccChpListValModeGuideInput>;
};

export type ArrayOfModeleRegleSubQuotaValCritereDto = {
  __typename?: 'ArrayOfModeleRegleSubQuotaValCritereDTO';
  ModeleRegleSubQuotaValCritereDTO?: Array<ModeleRegleSubQuotaValCritereDto>;
};

export type ArrayOfModeleRegleSubQuotaValCritereDtoInput = {
  ModeleRegleSubQuotaValCritereDTO?: Array<ModeleRegleSubQuotaValCritereDtoInput>;
};

export type ArrayOfModeleRetourExportAncvCesuDto = {
  __typename?: 'ArrayOfModeleRetourExportAncvCesuDTO';
  ModeleRetourExportAncvCesuDTO?: Array<ModeleRetourExportAncvCesuDto>;
};

export type ArrayOfModeleRetourExportAncvCesuDtoInput = {
  ModeleRetourExportAncvCesuDTO?: Array<ModeleRetourExportAncvCesuDtoInput>;
};

export type ArrayOfModeleSaisieEcritureEcritureModeleSaisieEcritureModelDto = {
  __typename?: 'ArrayOfModeleSaisieEcritureEcritureModeleSaisieEcritureModelDTO';
  ModeleSaisieEcritureEcritureModeleSaisieEcritureModelDTO?: Array<ModeleSaisieEcritureEcritureModeleSaisieEcritureModelDto>;
};

export type ArrayOfModeleSaisieEcritureEcritureModeleSaisieEcritureModelDtoInput = {
  ModeleSaisieEcritureEcritureModeleSaisieEcritureModelDTO?: Array<ModeleSaisieEcritureEcritureModeleSaisieEcritureModelDtoInput>;
};

export type ArrayOfModeleSaisieEcritureModeleSaisieEcritureModelDto = {
  __typename?: 'ArrayOfModeleSaisieEcritureModeleSaisieEcritureModelDTO';
  ModeleSaisieEcritureModeleSaisieEcritureModelDTO?: Array<ModeleSaisieEcritureModeleSaisieEcritureModelDto>;
};

export type ArrayOfModeleSaisieEcritureModeleSaisieEcritureModelDtoInput = {
  ModeleSaisieEcritureModeleSaisieEcritureModelDTO?: Array<ModeleSaisieEcritureModeleSaisieEcritureModelDtoInput>;
};

export type ArrayOfModeleSaisieEcritureMouvementModeleSaisieEcritureModelDto = {
  __typename?: 'ArrayOfModeleSaisieEcritureMouvementModeleSaisieEcritureModelDTO';
  ModeleSaisieEcritureMouvementModeleSaisieEcritureModelDTO?: Array<ModeleSaisieEcritureMouvementModeleSaisieEcritureModelDto>;
};

export type ArrayOfModeleSaisieEcritureMouvementModeleSaisieEcritureModelDtoInput = {
  ModeleSaisieEcritureMouvementModeleSaisieEcritureModelDTO?: Array<ModeleSaisieEcritureMouvementModeleSaisieEcritureModelDtoInput>;
};

export type ArrayOfModeleSaisieLibreCompteAnaSecDto = {
  __typename?: 'ArrayOfModeleSaisieLibreCompteAnaSecDTO';
  ModeleSaisieLibreCompteAnaSecDTO?: Array<ModeleSaisieLibreCompteAnaSecDto>;
};

export type ArrayOfModeleSaisieLibreCompteAnaSecDtoInput = {
  ModeleSaisieLibreCompteAnaSecDTO?: Array<ModeleSaisieLibreCompteAnaSecDtoInput>;
};

export type ArrayOfModeleSaisieLibreDto = {
  __typename?: 'ArrayOfModeleSaisieLibreDTO';
  ModeleSaisieLibreDTO?: Array<ModeleSaisieLibreDto>;
};

export type ArrayOfModeleSaisieLibreDtoInput = {
  ModeleSaisieLibreDTO?: Array<ModeleSaisieLibreDtoInput>;
};

export type ArrayOfModeleSaisieSectionAnaParPlanModelDtoInput = {
  ModeleSaisieSectionAnaParPlanModelDTO?: Array<ModeleSaisieSectionAnaParPlanModelDtoInput>;
};

export type ArrayOfModeleSuppressionAcompteDto = {
  __typename?: 'ArrayOfModeleSuppressionAcompteDTO';
  ModeleSuppressionAcompteDTO?: Array<ModeleSuppressionAcompteDto>;
};

export type ArrayOfModeleSuppressionAcompteDtoInput = {
  ModeleSuppressionAcompteDTO?: Array<ModeleSuppressionAcompteDtoInput>;
};

export type ArrayOfModeleTvafpaModel = {
  __typename?: 'ArrayOfModeleTVAFPAModel';
  ModeleTVAFPAModel?: Array<ModeleTvafpaModel>;
};

export type ArrayOfModeleTvafpaModelInput = {
  ModeleTVAFPAModel?: Array<ModeleTvafpaModelInput>;
};

export type ArrayOfModeleTvaLightModel = {
  __typename?: 'ArrayOfModeleTVALightModel';
  ModeleTVALightModel?: Array<ModeleTvaLightModel>;
};

export type ArrayOfModeleTvaLightModelInput = {
  ModeleTVALightModel?: Array<ModeleTvaLightModelInput>;
};

export type ArrayOfModelesModeleEcheancierArticlesModel = {
  __typename?: 'ArrayOfModelesModeleEcheancierArticlesModel';
  ModelesModeleEcheancierArticlesModel?: Array<Union_31594117503382787490>;
};

export type ArrayOfModelesModeleEcheancierArticlesModelInput = {
  ModelesModeleEcheancierArticlesModel?: Array<ModelesModeleEcheancierArticlesModelInput>;
};

export type ArrayOfModuleInfoDto = {
  __typename?: 'ArrayOfModuleInfoDTO';
  ModuleInfoDTO?: Array<ModuleInfoDto>;
};

export type ArrayOfModuleInfoDtoInput = {
  ModuleInfoDTO?: Array<ModuleInfoDtoInput>;
};

export type ArrayOfMoleculeRegleAvanceeModelDto = {
  __typename?: 'ArrayOfMoleculeRegleAvanceeModelDTO';
  MoleculeRegleAvanceeModelDTO?: Array<MoleculeRegleAvanceeModelDto>;
};

export type ArrayOfMoleculeRegleAvanceeModelDtoInput = {
  MoleculeRegleAvanceeModelDTO?: Array<MoleculeRegleAvanceeModelDtoInput>;
};

export type ArrayOfMoteurCalculDto = {
  __typename?: 'ArrayOfMoteurCalculDTO';
  MoteurCalculDTO?: Array<MoteurCalculDto>;
};

export type ArrayOfMoteurCalculDtoInput = {
  MoteurCalculDTO?: Array<MoteurCalculDtoInput>;
};

export type ArrayOfMoteurCritereDto = {
  __typename?: 'ArrayOfMoteurCritereDTO';
  MoteurCritereDTO?: Array<MoteurCritereDto>;
};

export type ArrayOfMoteurCritereDtoInput = {
  MoteurCritereDTO?: Array<MoteurCritereDtoInput>;
};

export type ArrayOfMoteurOperateurDto = {
  __typename?: 'ArrayOfMoteurOperateurDTO';
  MoteurOperateurDTO?: Array<MoteurOperateurDto>;
};

export type ArrayOfMoteurOperateurDtoInput = {
  MoteurOperateurDTO?: Array<MoteurOperateurDtoInput>;
};

export type ArrayOfMoteurParamCritereDto = {
  __typename?: 'ArrayOfMoteurParamCritereDTO';
  MoteurParamCritereDTO?: Array<MoteurParamCritereDto>;
};

export type ArrayOfMoteurParamCritereDtoInput = {
  MoteurParamCritereDTO?: Array<MoteurParamCritereDtoInput>;
};

export type ArrayOfMoteurRegleDto = {
  __typename?: 'ArrayOfMoteurRegleDTO';
  MoteurRegleDTO?: Array<MoteurRegleDto>;
};

export type ArrayOfMoteurRegleDtoInput = {
  MoteurRegleDTO?: Array<MoteurRegleDtoInput>;
};

export type ArrayOfMoteurRegleHeritageActiviteDto = {
  __typename?: 'ArrayOfMoteurRegleHeritageActiviteDTO';
  MoteurRegleHeritageActiviteDTO?: Array<MoteurRegleHeritageActiviteDto>;
};

export type ArrayOfMoteurRegleHeritageActiviteDtoInput = {
  MoteurRegleHeritageActiviteDTO?: Array<MoteurRegleHeritageActiviteDtoInput>;
};

export type ArrayOfMoteurRegleHeritageFamilleDto = {
  __typename?: 'ArrayOfMoteurRegleHeritageFamilleDTO';
  MoteurRegleHeritageFamilleDTO?: Array<MoteurRegleHeritageFamilleDto>;
};

export type ArrayOfMoteurRegleHeritageFamilleDtoInput = {
  MoteurRegleHeritageFamilleDTO?: Array<MoteurRegleHeritageFamilleDtoInput>;
};

export type ArrayOfMoteurRegleHeritageProduitDto = {
  __typename?: 'ArrayOfMoteurRegleHeritageProduitDTO';
  MoteurRegleHeritageProduitDTO?: Array<MoteurRegleHeritageProduitDto>;
};

export type ArrayOfMoteurRegleHeritageProduitDtoInput = {
  MoteurRegleHeritageProduitDTO?: Array<MoteurRegleHeritageProduitDtoInput>;
};

export type ArrayOfMoteurRegleModelDto = {
  __typename?: 'ArrayOfMoteurRegleModelDTO';
  MoteurRegleModelDTO?: Array<MoteurRegleModelDto>;
};

export type ArrayOfMoteurRegleModelDtoInput = {
  MoteurRegleModelDTO?: Array<MoteurRegleModelDtoInput>;
};

export type ArrayOfMoteurRegleTypeDateRefDto = {
  __typename?: 'ArrayOfMoteurRegleTypeDateRefDTO';
  MoteurRegleTypeDateRefDTO?: Array<MoteurRegleTypeDateRefDto>;
};

export type ArrayOfMoteurRegleTypeDateRefDtoInput = {
  MoteurRegleTypeDateRefDTO?: Array<MoteurRegleTypeDateRefDtoInput>;
};

export type ArrayOfMoteurRegleUseActiviteDto = {
  __typename?: 'ArrayOfMoteurRegleUseActiviteDTO';
  MoteurRegleUseActiviteDTO?: Array<MoteurRegleUseActiviteDto>;
};

export type ArrayOfMoteurRegleUseActiviteDtoInput = {
  MoteurRegleUseActiviteDTO?: Array<MoteurRegleUseActiviteDtoInput>;
};

export type ArrayOfMoteurRegleUseArticleDto = {
  __typename?: 'ArrayOfMoteurRegleUseArticleDTO';
  MoteurRegleUseArticleDTO?: Array<MoteurRegleUseArticleDto>;
};

export type ArrayOfMoteurRegleUseArticleDtoInput = {
  MoteurRegleUseArticleDTO?: Array<MoteurRegleUseArticleDtoInput>;
};

export type ArrayOfMoteurRegleUseFamilleDto = {
  __typename?: 'ArrayOfMoteurRegleUseFamilleDTO';
  MoteurRegleUseFamilleDTO?: Array<MoteurRegleUseFamilleDto>;
};

export type ArrayOfMoteurRegleUseFamilleDtoInput = {
  MoteurRegleUseFamilleDTO?: Array<MoteurRegleUseFamilleDtoInput>;
};

export type ArrayOfMoteurRegleUseProduitDto = {
  __typename?: 'ArrayOfMoteurRegleUseProduitDTO';
  MoteurRegleUseProduitDTO?: Array<MoteurRegleUseProduitDto>;
};

export type ArrayOfMoteurRegleUseProduitDtoInput = {
  MoteurRegleUseProduitDTO?: Array<MoteurRegleUseProduitDtoInput>;
};

export type ArrayOfMouvementAnalytiqueDto = {
  __typename?: 'ArrayOfMouvementAnalytiqueDTO';
  MouvementAnalytiqueDTO?: Array<MouvementAnalytiqueDto>;
};

export type ArrayOfMouvementAnalytiqueDtoInput = {
  MouvementAnalytiqueDTO?: Array<MouvementAnalytiqueDtoInput>;
};

export type ArrayOfMouvementAnalytiqueEnErreurModel = {
  __typename?: 'ArrayOfMouvementAnalytiqueEnErreurModel';
  MouvementAnalytiqueEnErreurModel?: Array<MouvementAnalytiqueEnErreurModel>;
};

export type ArrayOfMouvementAnalytiqueEnErreurModelInput = {
  MouvementAnalytiqueEnErreurModel?: Array<MouvementAnalytiqueEnErreurModelInput>;
};

export type ArrayOfMouvementAnalytiqueModelDto = {
  __typename?: 'ArrayOfMouvementAnalytiqueModelDTO';
  MouvementAnalytiqueModelDTO?: Array<MouvementAnalytiqueModelDto>;
};

export type ArrayOfMouvementAnalytiqueModelDtoInput = {
  MouvementAnalytiqueModelDTO?: Array<MouvementAnalytiqueModelDtoInput>;
};

export type ArrayOfMouvementCollectifSansTiersModel = {
  __typename?: 'ArrayOfMouvementCollectifSansTiersModel';
  MouvementCollectifSansTiersModel?: Array<MouvementCollectifSansTiersModel>;
};

export type ArrayOfMouvementCollectifSansTiersModelInput = {
  MouvementCollectifSansTiersModel?: Array<MouvementCollectifSansTiersModelInput>;
};

export type ArrayOfMouvementComptableCleRepartitionModelDtoInput = {
  MouvementComptableCleRepartitionModelDTO?: Array<MouvementComptableCleRepartitionModelDtoInput>;
};

export type ArrayOfMouvementComptableDto = {
  __typename?: 'ArrayOfMouvementComptableDTO';
  MouvementComptableDTO?: Array<MouvementComptableDto>;
};

export type ArrayOfMouvementComptableDtoInput = {
  MouvementComptableDTO?: Array<MouvementComptableDtoInput>;
};

export type ArrayOfMouvementComptableInfosGeneralesModel = {
  __typename?: 'ArrayOfMouvementComptableInfosGeneralesModel';
  MouvementComptableInfosGeneralesModel?: Array<MouvementComptableInfosGeneralesModel>;
};

export type ArrayOfMouvementComptableInfosGeneralesModelInput = {
  MouvementComptableInfosGeneralesModel?: Array<MouvementComptableInfosGeneralesModelInput>;
};

export type ArrayOfMouvementComptableModificationRibMandatModel = {
  __typename?: 'ArrayOfMouvementComptableModificationRibMandatModel';
  MouvementComptableModificationRibMandatModel?: Array<MouvementComptableModificationRibMandatModel>;
};

export type ArrayOfMouvementComptableModificationRibMandatModelInput = {
  MouvementComptableModificationRibMandatModel?: Array<MouvementComptableModificationRibMandatModelInput>;
};

export type ArrayOfMouvementComptableRemiseBanqueModele = {
  __typename?: 'ArrayOfMouvementComptableRemiseBanqueModele';
  MouvementComptableRemiseBanqueModele?: Array<MouvementComptableRemiseBanqueModele>;
};

export type ArrayOfMouvementComptableRemiseBanqueModeleInput = {
  MouvementComptableRemiseBanqueModele?: Array<MouvementComptableRemiseBanqueModeleInput>;
};

export type ArrayOfMouvementConsoPointHistoriqueModel = {
  __typename?: 'ArrayOfMouvementConsoPointHistoriqueModel';
  MouvementConsoPointHistoriqueModel?: Array<MouvementConsoPointHistoriqueModel>;
};

export type ArrayOfMouvementConsoPointHistoriqueModelInput = {
  MouvementConsoPointHistoriqueModel?: Array<MouvementConsoPointHistoriqueModelInput>;
};

export type ArrayOfMouvementReglementModel = {
  __typename?: 'ArrayOfMouvementReglementModel';
  MouvementReglementModel?: Array<MouvementReglementModel>;
};

export type ArrayOfMouvementReglementModelInput = {
  MouvementReglementModel?: Array<MouvementReglementModelInput>;
};

export type ArrayOfMouvementSansTiersDetailModel = {
  __typename?: 'ArrayOfMouvementSansTiersDetailModel';
  MouvementSansTiersDetailModel?: Array<MouvementSansTiersDetailModel>;
};

export type ArrayOfMouvementSansTiersDetailModelInput = {
  MouvementSansTiersDetailModel?: Array<MouvementSansTiersDetailModelInput>;
};

export type ArrayOfMouvementStockDto = {
  __typename?: 'ArrayOfMouvementStockDTO';
  MouvementStockDTO?: Array<MouvementStockDto>;
};

export type ArrayOfMouvementStockDtoInput = {
  MouvementStockDTO?: Array<MouvementStockDtoInput>;
};

export type ArrayOfMouvementStockModelDto = {
  __typename?: 'ArrayOfMouvementStockModelDTO';
  MouvementStockModelDTO?: Array<MouvementStockModelDto>;
};

export type ArrayOfMouvementStockModelDtoInput = {
  MouvementStockModelDTO?: Array<MouvementStockModelDtoInput>;
};

export type ArrayOfMouvementsMouvementConsultationModel = {
  __typename?: 'ArrayOfMouvementsMouvementConsultationModel';
  MouvementsMouvementConsultationModel?: Array<MouvementsMouvementConsultationModel>;
};

export type ArrayOfMouvementsMouvementConsultationModelInput = {
  MouvementsMouvementConsultationModel?: Array<MouvementsMouvementConsultationModelInput>;
};

export type ArrayOfMouvementsMouvementEpargne = {
  __typename?: 'ArrayOfMouvementsMouvementEpargne';
  MouvementsMouvementEpargne?: Array<MouvementsMouvementEpargne>;
};

export type ArrayOfMouvementsMouvementEpargneInput = {
  MouvementsMouvementEpargne?: Array<MouvementsMouvementEpargneInput>;
};

export type ArrayOfMoyenPaiementAfpaModel = {
  __typename?: 'ArrayOfMoyenPaiementAFPAModel';
  MoyenPaiementAFPAModel?: Array<MoyenPaiementAfpaModel>;
};

export type ArrayOfMoyenPaiementAfpaModelInput = {
  MoyenPaiementAFPAModel?: Array<MoyenPaiementAfpaModelInput>;
};

export type ArrayOfMoyenPaiementActiviteDto = {
  __typename?: 'ArrayOfMoyenPaiementActiviteDTO';
  MoyenPaiementActiviteDTO?: Array<MoyenPaiementActiviteDto>;
};

export type ArrayOfMoyenPaiementActiviteDtoInput = {
  MoyenPaiementActiviteDTO?: Array<MoyenPaiementActiviteDtoInput>;
};

export type ArrayOfMoyenPaiementDto = {
  __typename?: 'ArrayOfMoyenPaiementDTO';
  MoyenPaiementDTO?: Array<MoyenPaiementDto>;
};

export type ArrayOfMoyenPaiementDtoInput = {
  MoyenPaiementDTO?: Array<MoyenPaiementDtoInput>;
};

export type ArrayOfMoyenPaiementDefautModel = {
  __typename?: 'ArrayOfMoyenPaiementDefautModel';
  MoyenPaiementDefautModel?: Array<MoyenPaiementDefautModel>;
};

export type ArrayOfMoyenPaiementDefautModelInput = {
  MoyenPaiementDefautModel?: Array<MoyenPaiementDefautModelInput>;
};

export type ArrayOfMoyenPaiementFpaModel = {
  __typename?: 'ArrayOfMoyenPaiementFPAModel';
  MoyenPaiementFPAModel?: Array<MoyenPaiementFpaModel>;
};

export type ArrayOfMoyenPaiementFpaModelInput = {
  MoyenPaiementFPAModel?: Array<MoyenPaiementFpaModelInput>;
};

export type ArrayOfMoyenPaiementForVenteModeleDto = {
  __typename?: 'ArrayOfMoyenPaiementForVenteModeleDTO';
  MoyenPaiementForVenteModeleDTO?: Array<MoyenPaiementForVenteModeleDto>;
};

export type ArrayOfMoyenPaiementForVenteModeleDtoInput = {
  MoyenPaiementForVenteModeleDTO?: Array<MoyenPaiementForVenteModeleDtoInput>;
};

export type ArrayOfMoyenPaiementMoyenPaiementSelectionableModel = {
  __typename?: 'ArrayOfMoyenPaiementMoyenPaiementSelectionableModel';
  MoyenPaiementMoyenPaiementSelectionableModel?: Array<Union_13632114401662173441>;
};

export type ArrayOfMoyenPaiementMoyenPaiementSelectionableModelInput = {
  MoyenPaiementMoyenPaiementSelectionableModel?: Array<MoyenPaiementMoyenPaiementSelectionableModelInput>;
};

export type ArrayOfMoyenPayementModelDto = {
  __typename?: 'ArrayOfMoyenPayementModelDTO';
  MoyenPayementModelDTO?: Array<MoyenPayementModelDto>;
};

export type ArrayOfMoyenPayementModelDtoInput = {
  MoyenPayementModelDTO?: Array<MoyenPayementModelDtoInput>;
};

export type ArrayOfMoyensPaiementMoyenPaiementBaseModele = {
  __typename?: 'ArrayOfMoyensPaiementMoyenPaiementBaseModele';
  MoyensPaiementMoyenPaiementBaseModele?: Array<MoyensPaiementMoyenPaiementBaseModele>;
};

export type ArrayOfMoyensPaiementMoyenPaiementBaseModeleInput = {
  MoyensPaiementMoyenPaiementBaseModele?: Array<MoyensPaiementMoyenPaiementBaseModeleInput>;
};

export type ArrayOfMoyensPaiementMoyenPaiementLightModel = {
  __typename?: 'ArrayOfMoyensPaiementMoyenPaiementLightModel';
  MoyensPaiementMoyenPaiementLightModel?: Array<MoyensPaiementMoyenPaiementLightModel>;
};

export type ArrayOfMoyensPaiementMoyenPaiementLightModelInput = {
  MoyensPaiementMoyenPaiementLightModel?: Array<MoyensPaiementMoyenPaiementLightModelInput>;
};

export type ArrayOfNatureMouvementStockDto = {
  __typename?: 'ArrayOfNatureMouvementStockDTO';
  NatureMouvementStockDTO?: Array<NatureMouvementStockDto>;
};

export type ArrayOfNatureMouvementStockDtoInput = {
  NatureMouvementStockDTO?: Array<NatureMouvementStockDtoInput>;
};

export type ArrayOfNewsletterNewsletterModeleModel = {
  __typename?: 'ArrayOfNewsletterNewsletterModeleModel';
  NewsletterNewsletterModeleModel?: Array<NewsletterNewsletterModeleModel>;
};

export type ArrayOfNewsletterNewsletterModeleModelInput = {
  NewsletterNewsletterModeleModel?: Array<NewsletterNewsletterModeleModelInput>;
};

export type ArrayOfNewsletterNewsletterThemeModel = {
  __typename?: 'ArrayOfNewsletterNewsletterThemeModel';
  NewsletterNewsletterThemeModel?: Array<NewsletterNewsletterThemeModel>;
};

export type ArrayOfNewsletterNewsletterThemeModelInput = {
  NewsletterNewsletterThemeModel?: Array<NewsletterNewsletterThemeModelInput>;
};

export type ArrayOfNotificationVup = {
  __typename?: 'ArrayOfNotificationVUP';
  NotificationVUP?: Array<NotificationVup>;
};

export type ArrayOfNotificationVupInput = {
  NotificationVUP?: Array<NotificationVupInput>;
};

export type ArrayOfNullableOfboolean = {
  __typename?: 'ArrayOfNullableOfboolean';
  boolean?: Array<boolean>;
};

export type ArrayOfNullableOfbooleanInput = {
  boolean?: Array<boolean>;
};

export type ArrayOfNullableOfdecimal = {
  __typename?: 'ArrayOfNullableOfdecimal';
  decimal?: Array<number>;
};

export type ArrayOfNullableOfdecimalInput = {
  decimal?: Array<number>;
};

export type ArrayOfNumeroChoixModelDto = {
  __typename?: 'ArrayOfNumeroChoixModelDTO';
  NumeroChoixModelDTO?: Array<NumeroChoixModelDto>;
};

export type ArrayOfNumeroChoixModelDtoInput = {
  NumeroChoixModelDTO?: Array<NumeroChoixModelDtoInput>;
};

export type ArrayOfOdAdDto = {
  __typename?: 'ArrayOfOdAdDTO';
  OdAdDTO?: Array<OdAdDto>;
};

export type ArrayOfOdAdDtoInput = {
  OdAdDTO?: Array<OdAdDtoInput>;
};

export type ArrayOfOptionsVignettesOptionsModel = {
  __typename?: 'ArrayOfOptionsVignettesOptionsModel';
  OptionsVignettesOptionsModel?: Array<OptionsVignettesOptionsModel>;
};

export type ArrayOfOptionsVignettesOptionsModelInput = {
  OptionsVignettesOptionsModel?: Array<OptionsVignettesOptionsModelInput>;
};

export type ArrayOfOrganisationBaseModel = {
  __typename?: 'ArrayOfOrganisationBaseModel';
  OrganisationBaseModel?: Array<OrganisationBaseModel>;
};

export type ArrayOfOrganisationBaseModelInput = {
  OrganisationBaseModel?: Array<OrganisationBaseModelInput>;
};

export type ArrayOfOrganisationDto = {
  __typename?: 'ArrayOfOrganisationDTO';
  OrganisationDTO?: Array<OrganisationDto>;
};

export type ArrayOfOrganisationDtoInput = {
  OrganisationDTO?: Array<OrganisationDtoInput>;
};

export type ArrayOfPjBaseModel = {
  __typename?: 'ArrayOfPJBaseModel';
  PJBaseModel?: Array<PjBaseModel>;
};

export type ArrayOfPjBaseModelInput = {
  PJBaseModel?: Array<PjBaseModelInput>;
};

export type ArrayOfPjCompletModel = {
  __typename?: 'ArrayOfPJCompletModel';
  PJCompletModel?: Array<PjCompletModel>;
};

export type ArrayOfPjCompletModelInput = {
  PJCompletModel?: Array<PjCompletModelInput>;
};

export type ArrayOfParamCommissionModel = {
  __typename?: 'ArrayOfParamCommissionModel';
  ParamCommissionModel?: Array<ParamCommissionModel>;
};

export type ArrayOfParamCommissionModelInput = {
  ParamCommissionModel?: Array<ParamCommissionModelInput>;
};

export type ArrayOfParamModeleEchancierModel = {
  __typename?: 'ArrayOfParamModeleEchancierModel';
  ParamModeleEchancierModel?: Array<Union_1187615723202011850>;
};

export type ArrayOfParamModeleEchancierModelInput = {
  ParamModeleEchancierModel?: Array<ParamModeleEchancierModelInput>;
};

export type ArrayOfParamReqSpecifDto = {
  __typename?: 'ArrayOfParamReqSpecifDTO';
  ParamReqSpecifDTO?: Array<ParamReqSpecifDto>;
};

export type ArrayOfParamReqSpecifDtoInput = {
  ParamReqSpecifDTO?: Array<ParamReqSpecifDtoInput>;
};

export type ArrayOfParametrageFpaCodeUtiliseModel = {
  __typename?: 'ArrayOfParametrageFPACodeUtiliseModel';
  ParametrageFPACodeUtiliseModel?: Array<ParametrageFpaCodeUtiliseModel>;
};

export type ArrayOfParametrageFpaCodeUtiliseModelInput = {
  ParametrageFPACodeUtiliseModel?: Array<ParametrageFpaCodeUtiliseModelInput>;
};

export type ArrayOfParametrageTvaSimpleModel = {
  __typename?: 'ArrayOfParametrageTVASimpleModel';
  ParametrageTVASimpleModel?: Array<ParametrageTvaSimpleModel>;
};

export type ArrayOfParametrageTvaSimpleModelInput = {
  ParametrageTVASimpleModel?: Array<ParametrageTvaSimpleModelInput>;
};

export type ArrayOfParametreImpressionDto = {
  __typename?: 'ArrayOfParametreImpressionDTO';
  ParametreImpressionDTO?: Array<ParametreImpressionDto>;
};

export type ArrayOfParametreImpressionDtoInput = {
  ParametreImpressionDTO?: Array<ParametreImpressionDtoInput>;
};

export type ArrayOfParametreRegleAvanceeModelDto = {
  __typename?: 'ArrayOfParametreRegleAvanceeModelDTO';
  ParametreRegleAvanceeModelDTO?: Array<ParametreRegleAvanceeModelDto>;
};

export type ArrayOfParametreRegleAvanceeModelDtoInput = {
  ParametreRegleAvanceeModelDTO?: Array<ParametreRegleAvanceeModelDtoInput>;
};

export type ArrayOfParametreValeurDto = {
  __typename?: 'ArrayOfParametreValeurDTO';
  ParametreValeurDTO?: Array<ParametreValeurDto>;
};

export type ArrayOfParametreValeurDtoInput = {
  ParametreValeurDTO?: Array<ParametreValeurDtoInput>;
};

export type ArrayOfParametresAppliDto = {
  __typename?: 'ArrayOfParametresAppliDTO';
  ParametresAppliDTO?: Array<ParametresAppliDto>;
};

export type ArrayOfParametresAppliDtoInput = {
  ParametresAppliDTO?: Array<ParametresAppliDtoInput>;
};

export type ArrayOfParametresUserAppliModelDto = {
  __typename?: 'ArrayOfParametresUserAppliModelDTO';
  ParametresUserAppliModelDTO?: Array<ParametresUserAppliModelDto>;
};

export type ArrayOfParametresUserAppliModelDtoInput = {
  ParametresUserAppliModelDTO?: Array<ParametresUserAppliModelDtoInput>;
};

export type ArrayOfPartsOdConjointDto = {
  __typename?: 'ArrayOfPartsODConjointDTO';
  PartsODConjointDTO?: Array<PartsOdConjointDto>;
};

export type ArrayOfPartsOdConjointDtoInput = {
  PartsODConjointDTO?: Array<PartsOdConjointDtoInput>;
};

export type ArrayOfPaysDto = {
  __typename?: 'ArrayOfPaysDTO';
  PaysDTO?: Array<PaysDto>;
};

export type ArrayOfPaysDtoInput = {
  PaysDTO?: Array<PaysDtoInput>;
};

export type ArrayOfPermDto = {
  __typename?: 'ArrayOfPermDTO';
  PermDTO?: Array<PermDto>;
};

export type ArrayOfPermDtoInput = {
  PermDTO?: Array<PermDtoInput>;
};

export type ArrayOfPermHeureDto = {
  __typename?: 'ArrayOfPermHeureDTO';
  PermHeureDTO?: Array<PermHeureDto>;
};

export type ArrayOfPermHeureDtoInput = {
  PermHeureDTO?: Array<PermHeureDtoInput>;
};

export type ArrayOfPermJourDto = {
  __typename?: 'ArrayOfPermJourDTO';
  PermJourDTO?: Array<PermJourDto>;
};

export type ArrayOfPermJourDtoInput = {
  PermJourDTO?: Array<PermJourDtoInput>;
};

export type ArrayOfPermanenceParamActiviteModel = {
  __typename?: 'ArrayOfPermanenceParamActiviteModel';
  PermanenceParamActiviteModel?: Array<PermanenceParamActiviteModel>;
};

export type ArrayOfPermanenceParamActiviteModelInput = {
  PermanenceParamActiviteModel?: Array<PermanenceParamActiviteModelInput>;
};

export type ArrayOfPermanenceParametrageJourModel = {
  __typename?: 'ArrayOfPermanenceParametrageJourModel';
  PermanenceParametrageJourModel?: Array<Union_36261109274052828904>;
};

export type ArrayOfPermanenceParametrageJourModelInput = {
  PermanenceParametrageJourModel?: Array<PermanenceParametrageJourModelInput>;
};

export type ArrayOfPermanencePermanenceBaseModel = {
  __typename?: 'ArrayOfPermanencePermanenceBaseModel';
  PermanencePermanenceBaseModel?: Array<PermanencePermanenceBaseModel>;
};

export type ArrayOfPermanencePermanenceBaseModelInput = {
  PermanencePermanenceBaseModel?: Array<PermanencePermanenceBaseModelInput>;
};

export type ArrayOfPieceJointeDto = {
  __typename?: 'ArrayOfPieceJointeDTO';
  PieceJointeDTO?: Array<PieceJointeDto>;
};

export type ArrayOfPieceJointeDtoInput = {
  PieceJointeDTO?: Array<PieceJointeDtoInput>;
};

export type ArrayOfPieceJointeModelDto = {
  __typename?: 'ArrayOfPieceJointeModelDTO';
  PieceJointeModelDTO?: Array<PieceJointeModelDto>;
};

export type ArrayOfPieceJointeModelDtoInput = {
  PieceJointeModelDTO?: Array<PieceJointeModelDtoInput>;
};

export type ArrayOfPieceJustificativeBenefModel = {
  __typename?: 'ArrayOfPieceJustificativeBenefModel';
  PieceJustificativeBenefModel?: Array<PieceJustificativeBenefModel>;
};

export type ArrayOfPieceJustificativeBenefModelInput = {
  PieceJustificativeBenefModel?: Array<PieceJustificativeBenefModelInput>;
};

export type ArrayOfPieceJustificativeDto = {
  __typename?: 'ArrayOfPieceJustificativeDTO';
  PieceJustificativeDTO?: Array<PieceJustificativeDto>;
};

export type ArrayOfPieceJustificativeDtoInput = {
  PieceJustificativeDTO?: Array<PieceJustificativeDtoInput>;
};

export type ArrayOfPjDemArticleDto = {
  __typename?: 'ArrayOfPjDemArticleDTO';
  PjDemArticleDTO?: Array<PjDemArticleDto>;
};

export type ArrayOfPjDemArticleDtoInput = {
  PjDemArticleDTO?: Array<PjDemArticleDtoInput>;
};

export type ArrayOfPlanAnalytiqueModelDto = {
  __typename?: 'ArrayOfPlanAnalytiqueModelDTO';
  PlanAnalytiqueModelDTO?: Array<PlanAnalytiqueModelDto>;
};

export type ArrayOfPlanAnalytiqueModelDtoInput = {
  PlanAnalytiqueModelDTO?: Array<PlanAnalytiqueModelDtoInput>;
};

export type ArrayOfPlanSectionAnalytiqueModelDto = {
  __typename?: 'ArrayOfPlanSectionAnalytiqueModelDTO';
  PlanSectionAnalytiqueModelDTO?: Array<PlanSectionAnalytiqueModelDto>;
};

export type ArrayOfPlanSectionAnalytiqueModelDtoInput = {
  PlanSectionAnalytiqueModelDTO?: Array<PlanSectionAnalytiqueModelDtoInput>;
};

export type ArrayOfPlanWithSectionsAnalytiquesModel = {
  __typename?: 'ArrayOfPlanWithSectionsAnalytiquesModel';
  PlanWithSectionsAnalytiquesModel?: Array<PlanWithSectionsAnalytiquesModel>;
};

export type ArrayOfPlanWithSectionsAnalytiquesModelInput = {
  PlanWithSectionsAnalytiquesModel?: Array<PlanWithSectionsAnalytiquesModelInput>;
};

export type ArrayOfPointVenteDto = {
  __typename?: 'ArrayOfPointVenteDTO';
  PointVenteDTO?: Array<PointVenteDto>;
};

export type ArrayOfPointVenteDtoInput = {
  PointVenteDTO?: Array<PointVenteDtoInput>;
};

export type ArrayOfPointVenteWithDelegModel = {
  __typename?: 'ArrayOfPointVenteWithDelegModel';
  PointVenteWithDelegModel?: Array<PointVenteWithDelegModel>;
};

export type ArrayOfPointVenteWithDelegModelInput = {
  PointVenteWithDelegModel?: Array<PointVenteWithDelegModelInput>;
};

export type ArrayOfPortailAlbumDto = {
  __typename?: 'ArrayOfPortailAlbumDTO';
  PortailAlbumDTO?: Array<PortailAlbumDto>;
};

export type ArrayOfPortailAlbumDtoInput = {
  PortailAlbumDTO?: Array<PortailAlbumDtoInput>;
};

export type ArrayOfPortailArticleCommentaireDto = {
  __typename?: 'ArrayOfPortailArticleCommentaireDTO';
  PortailArticleCommentaireDTO?: Array<PortailArticleCommentaireDto>;
};

export type ArrayOfPortailArticleCommentaireDtoInput = {
  PortailArticleCommentaireDTO?: Array<PortailArticleCommentaireDtoInput>;
};

export type ArrayOfPortailArticleDto = {
  __typename?: 'ArrayOfPortailArticleDTO';
  PortailArticleDTO?: Array<PortailArticleDto>;
};

export type ArrayOfPortailArticleDtoInput = {
  PortailArticleDTO?: Array<PortailArticleDtoInput>;
};

export type ArrayOfPortailArticleLikeDto = {
  __typename?: 'ArrayOfPortailArticleLikeDTO';
  PortailArticleLikeDTO?: Array<PortailArticleLikeDto>;
};

export type ArrayOfPortailArticleLikeDtoInput = {
  PortailArticleLikeDTO?: Array<PortailArticleLikeDtoInput>;
};

export type ArrayOfPortailArticleParamDto = {
  __typename?: 'ArrayOfPortailArticleParamDTO';
  PortailArticleParamDTO?: Array<PortailArticleParamDto>;
};

export type ArrayOfPortailArticleParamDtoInput = {
  PortailArticleParamDTO?: Array<PortailArticleParamDtoInput>;
};

export type ArrayOfPortailArticleParamValDto = {
  __typename?: 'ArrayOfPortailArticleParamValDTO';
  PortailArticleParamValDTO?: Array<PortailArticleParamValDto>;
};

export type ArrayOfPortailArticleParamValDtoInput = {
  PortailArticleParamValDTO?: Array<PortailArticleParamValDtoInput>;
};

export type ArrayOfPortailArticleTypeDto = {
  __typename?: 'ArrayOfPortailArticleTypeDTO';
  PortailArticleTypeDTO?: Array<PortailArticleTypeDto>;
};

export type ArrayOfPortailArticleTypeDtoInput = {
  PortailArticleTypeDTO?: Array<PortailArticleTypeDtoInput>;
};

export type ArrayOfPortailDocumentAlbumDto = {
  __typename?: 'ArrayOfPortailDocumentAlbumDTO';
  PortailDocumentAlbumDTO?: Array<PortailDocumentAlbumDto>;
};

export type ArrayOfPortailDocumentAlbumDtoInput = {
  PortailDocumentAlbumDTO?: Array<PortailDocumentAlbumDtoInput>;
};

export type ArrayOfPortailDocumentCategorieDto = {
  __typename?: 'ArrayOfPortailDocumentCategorieDTO';
  PortailDocumentCategorieDTO?: Array<PortailDocumentCategorieDto>;
};

export type ArrayOfPortailDocumentCategorieDtoInput = {
  PortailDocumentCategorieDTO?: Array<PortailDocumentCategorieDtoInput>;
};

export type ArrayOfPortailEditorialCategorieDto = {
  __typename?: 'ArrayOfPortailEditorialCategorieDTO';
  PortailEditorialCategorieDTO?: Array<PortailEditorialCategorieDto>;
};

export type ArrayOfPortailEditorialCategorieDtoInput = {
  PortailEditorialCategorieDTO?: Array<PortailEditorialCategorieDtoInput>;
};

export type ArrayOfPortailFormulaireSpecifiqueDto = {
  __typename?: 'ArrayOfPortailFormulaireSpecifiqueDTO';
  PortailFormulaireSpecifiqueDTO?: Array<PortailFormulaireSpecifiqueDto>;
};

export type ArrayOfPortailFormulaireSpecifiqueDtoInput = {
  PortailFormulaireSpecifiqueDTO?: Array<PortailFormulaireSpecifiqueDtoInput>;
};

export type ArrayOfPortailPortletCssDto = {
  __typename?: 'ArrayOfPortailPortletCssDTO';
  PortailPortletCssDTO?: Array<PortailPortletCssDto>;
};

export type ArrayOfPortailPortletCssDtoInput = {
  PortailPortletCssDTO?: Array<PortailPortletCssDtoInput>;
};

export type ArrayOfPortailPortletDto = {
  __typename?: 'ArrayOfPortailPortletDTO';
  PortailPortletDTO?: Array<PortailPortletDto>;
};

export type ArrayOfPortailPortletDtoInput = {
  PortailPortletDTO?: Array<PortailPortletDtoInput>;
};

export type ArrayOfPortailPortletParamDto = {
  __typename?: 'ArrayOfPortailPortletParamDTO';
  PortailPortletParamDTO?: Array<PortailPortletParamDto>;
};

export type ArrayOfPortailPortletParamDtoInput = {
  PortailPortletParamDTO?: Array<PortailPortletParamDtoInput>;
};

export type ArrayOfPortailPortletParamValDto = {
  __typename?: 'ArrayOfPortailPortletParamValDTO';
  PortailPortletParamValDTO?: Array<PortailPortletParamValDto>;
};

export type ArrayOfPortailPortletParamValDtoInput = {
  PortailPortletParamValDTO?: Array<PortailPortletParamValDtoInput>;
};

export type ArrayOfPortailPortletTypeDto = {
  __typename?: 'ArrayOfPortailPortletTypeDTO';
  PortailPortletTypeDTO?: Array<PortailPortletTypeDto>;
};

export type ArrayOfPortailPortletTypeDtoInput = {
  PortailPortletTypeDTO?: Array<PortailPortletTypeDtoInput>;
};

export type ArrayOfPortailSkinCouleurPrincipaleDto = {
  __typename?: 'ArrayOfPortailSkinCouleurPrincipaleDTO';
  PortailSkinCouleurPrincipaleDTO?: Array<PortailSkinCouleurPrincipaleDto>;
};

export type ArrayOfPortailSkinCouleurPrincipaleDtoInput = {
  PortailSkinCouleurPrincipaleDTO?: Array<PortailSkinCouleurPrincipaleDtoInput>;
};

export type ArrayOfPortailSkinCouleurSecondaireDto = {
  __typename?: 'ArrayOfPortailSkinCouleurSecondaireDTO';
  PortailSkinCouleurSecondaireDTO?: Array<PortailSkinCouleurSecondaireDto>;
};

export type ArrayOfPortailSkinCouleurSecondaireDtoInput = {
  PortailSkinCouleurSecondaireDTO?: Array<PortailSkinCouleurSecondaireDtoInput>;
};

export type ArrayOfPortailSkinDto = {
  __typename?: 'ArrayOfPortailSkinDTO';
  PortailSkinDTO?: Array<PortailSkinDto>;
};

export type ArrayOfPortailSkinDtoInput = {
  PortailSkinDTO?: Array<PortailSkinDtoInput>;
};

export type ArrayOfPortailSkinOmbreDto = {
  __typename?: 'ArrayOfPortailSkinOmbreDTO';
  PortailSkinOmbreDTO?: Array<PortailSkinOmbreDto>;
};

export type ArrayOfPortailSkinOmbreDtoInput = {
  PortailSkinOmbreDTO?: Array<PortailSkinOmbreDtoInput>;
};

export type ArrayOfPortailSkinRadiusDto = {
  __typename?: 'ArrayOfPortailSkinRadiusDTO';
  PortailSkinRadiusDTO?: Array<PortailSkinRadiusDto>;
};

export type ArrayOfPortailSkinRadiusDtoInput = {
  PortailSkinRadiusDTO?: Array<PortailSkinRadiusDtoInput>;
};

export type ArrayOfPortailStatutDto = {
  __typename?: 'ArrayOfPortailStatutDTO';
  PortailStatutDTO?: Array<PortailStatutDto>;
};

export type ArrayOfPortailStatutDtoInput = {
  PortailStatutDTO?: Array<PortailStatutDtoInput>;
};

export type ArrayOfPortletPortletCssModel = {
  __typename?: 'ArrayOfPortletPortletCssModel';
  PortletPortletCssModel?: Array<PortletPortletCssModel>;
};

export type ArrayOfPortletPortletCssModelInput = {
  PortletPortletCssModel?: Array<PortletPortletCssModelInput>;
};

export type ArrayOfPortletPortletLimitCodeTypeModel = {
  __typename?: 'ArrayOfPortletPortletLimitCodeTypeModel';
  PortletPortletLimitCodeTypeModel?: Array<PortletPortletLimitCodeTypeModel>;
};

export type ArrayOfPortletPortletLimitCodeTypeModelInput = {
  PortletPortletLimitCodeTypeModel?: Array<PortletPortletLimitCodeTypeModelInput>;
};

export type ArrayOfPosteBudgetaireDto = {
  __typename?: 'ArrayOfPosteBudgetaireDTO';
  PosteBudgetaireDTO?: Array<PosteBudgetaireDto>;
};

export type ArrayOfPosteBudgetaireDtoInput = {
  PosteBudgetaireDTO?: Array<PosteBudgetaireDtoInput>;
};

export type ArrayOfPosteBudgetaireModelDto = {
  __typename?: 'ArrayOfPosteBudgetaireModelDTO';
  PosteBudgetaireModelDTO?: Array<PosteBudgetaireModelDto>;
};

export type ArrayOfPosteBudgetaireModelDtoInput = {
  PosteBudgetaireModelDTO?: Array<PosteBudgetaireModelDtoInput>;
};

export type ArrayOfPrestationModelDto = {
  __typename?: 'ArrayOfPrestationModelDTO';
  PrestationModelDTO?: Array<PrestationModelDto>;
};

export type ArrayOfPrestationModelDtoInput = {
  PrestationModelDTO?: Array<PrestationModelDtoInput>;
};

export type ArrayOfPrestationPjArticleModel = {
  __typename?: 'ArrayOfPrestationPJArticleModel';
  PrestationPJArticleModel?: Array<PrestationPjArticleModel>;
};

export type ArrayOfPrestationPjArticleModelInput = {
  PrestationPJArticleModel?: Array<PrestationPjArticleModelInput>;
};

export type ArrayOfProduitBaseAvecIdFamilleModel = {
  __typename?: 'ArrayOfProduitBaseAvecIdFamilleModel';
  ProduitBaseAvecIdFamilleModel?: Array<ProduitBaseAvecIdFamilleModel>;
};

export type ArrayOfProduitBaseAvecIdFamilleModelInput = {
  ProduitBaseAvecIdFamilleModel?: Array<ProduitBaseAvecIdFamilleModelInput>;
};

export type ArrayOfProduitBaseClosModel = {
  __typename?: 'ArrayOfProduitBaseClosModel';
  ProduitBaseClosModel?: Array<ProduitBaseClosModel>;
};

export type ArrayOfProduitBaseClosModelInput = {
  ProduitBaseClosModel?: Array<ProduitBaseClosModelInput>;
};

export type ArrayOfProduitDto = {
  __typename?: 'ArrayOfProduitDTO';
  ProduitDTO?: Array<ProduitDto>;
};

export type ArrayOfProduitDtoInput = {
  ProduitDTO?: Array<ProduitDtoInput>;
};

export type ArrayOfProduitDirectoDescriptionDto = {
  __typename?: 'ArrayOfProduitDirectoDescriptionDTO';
  ProduitDirectoDescriptionDTO?: Array<ProduitDirectoDescriptionDto>;
};

export type ArrayOfProduitDirectoDescriptionDtoInput = {
  ProduitDirectoDescriptionDTO?: Array<ProduitDirectoDescriptionDtoInput>;
};

export type ArrayOfProduitLightModel = {
  __typename?: 'ArrayOfProduitLightModel';
  ProduitLightModel?: Array<ProduitLightModel>;
};

export type ArrayOfProduitLightModelInput = {
  ProduitLightModel?: Array<ProduitLightModelInput>;
};

export type ArrayOfProduitModel = {
  __typename?: 'ArrayOfProduitModel';
  ProduitModel?: Array<ProduitModel>;
};

export type ArrayOfProduitModelInput = {
  ProduitModel?: Array<ProduitModelInput>;
};

export type ArrayOfProduitModelivraisonDto = {
  __typename?: 'ArrayOfProduitModelivraisonDTO';
  ProduitModelivraisonDTO?: Array<ProduitModelivraisonDto>;
};

export type ArrayOfProduitModelivraisonDtoInput = {
  ProduitModelivraisonDTO?: Array<ProduitModelivraisonDtoInput>;
};

export type ArrayOfProduitReservationResxPartModel = {
  __typename?: 'ArrayOfProduitReservationResxPartModel';
  ProduitReservationResxPartModel?: Array<ProduitReservationResxPartModel>;
};

export type ArrayOfProduitReservationResxPartModelInput = {
  ProduitReservationResxPartModel?: Array<ProduitReservationResxPartModelInput>;
};

export type ArrayOfProduitSectionAnalytiqueDto = {
  __typename?: 'ArrayOfProduitSectionAnalytiqueDTO';
  ProduitSectionAnalytiqueDTO?: Array<ProduitSectionAnalytiqueDto>;
};

export type ArrayOfProduitSectionAnalytiqueDtoInput = {
  ProduitSectionAnalytiqueDTO?: Array<ProduitSectionAnalytiqueDtoInput>;
};

export type ArrayOfProfilDroitDto = {
  __typename?: 'ArrayOfProfilDroitDTO';
  ProfilDroitDTO?: Array<ProfilDroitDto>;
};

export type ArrayOfProfilDroitDtoInput = {
  ProfilDroitDTO?: Array<ProfilDroitDtoInput>;
};

export type ArrayOfProfilDroitMenuTypeActiviteModelDto = {
  __typename?: 'ArrayOfProfilDroitMenuTypeActiviteModelDTO';
  ProfilDroitMenuTypeActiviteModelDTO?: Array<ProfilDroitMenuTypeActiviteModelDto>;
};

export type ArrayOfProfilDroitMenuTypeActiviteModelDtoInput = {
  ProfilDroitMenuTypeActiviteModelDTO?: Array<ProfilDroitMenuTypeActiviteModelDtoInput>;
};

export type ArrayOfProfilEspaceCse = {
  __typename?: 'ArrayOfProfilEspaceCSE';
  ProfilEspaceCSE?: Array<ProfilEspaceCse>;
};

export type ArrayOfProfilEspaceCseInput = {
  ProfilEspaceCSE?: Array<ProfilEspaceCseInput>;
};

export type ArrayOfProfilKalideaModelDto = {
  __typename?: 'ArrayOfProfilKalideaModelDTO';
  ProfilKalideaModelDTO?: Array<ProfilKalideaModelDto>;
};

export type ArrayOfProfilKalideaModelDtoInput = {
  ProfilKalideaModelDTO?: Array<ProfilKalideaModelDtoInput>;
};

export type ArrayOfProfilSubventionModelDto = {
  __typename?: 'ArrayOfProfilSubventionModelDTO';
  ProfilSubventionModelDTO?: Array<ProfilSubventionModelDto>;
};

export type ArrayOfProfilSubventionModelDtoInput = {
  ProfilSubventionModelDTO?: Array<ProfilSubventionModelDtoInput>;
};

export type ArrayOfPubliChampsBaseModel = {
  __typename?: 'ArrayOfPubliChampsBaseModel';
  PubliChampsBaseModel?: Array<PubliChampsBaseModel>;
};

export type ArrayOfPubliChampsBaseModelInput = {
  PubliChampsBaseModel?: Array<PubliChampsBaseModelInput>;
};

export type ArrayOfPubliChampsGroupeAffichageModel = {
  __typename?: 'ArrayOfPubliChampsGroupeAffichageModel';
  PubliChampsGroupeAffichageModel?: Array<Union_5208800993651906122>;
};

export type ArrayOfPubliChampsGroupeAffichageModelInput = {
  PubliChampsGroupeAffichageModel?: Array<PubliChampsGroupeAffichageModelInput>;
};

export type ArrayOfPubliChampsVueModel = {
  __typename?: 'ArrayOfPubliChampsVueModel';
  PubliChampsVueModel?: Array<PubliChampsVueModel>;
};

export type ArrayOfPubliChampsVueModelInput = {
  PubliChampsVueModel?: Array<PubliChampsVueModelInput>;
};

export type ArrayOfPubliDocumentReportModel = {
  __typename?: 'ArrayOfPubliDocumentReportModel';
  PubliDocumentReportModel?: Array<PubliDocumentReportModel>;
};

export type ArrayOfPubliDocumentReportModelInput = {
  PubliDocumentReportModel?: Array<PubliDocumentReportModelInput>;
};

export type ArrayOfPubliRequeteListerModel = {
  __typename?: 'ArrayOfPubliRequeteListerModel';
  PubliRequeteListerModel?: Array<PubliRequeteListerModel>;
};

export type ArrayOfPubliRequeteListerModelInput = {
  PubliRequeteListerModel?: Array<PubliRequeteListerModelInput>;
};

export type ArrayOfPubliTypeCourrierPossibleModel = {
  __typename?: 'ArrayOfPubliTypeCourrierPossibleModel';
  PubliTypeCourrierPossibleModel?: Array<PubliTypeCourrierPossibleModel>;
};

export type ArrayOfPubliTypeCourrierPossibleModelInput = {
  PubliTypeCourrierPossibleModel?: Array<PubliTypeCourrierPossibleModelInput>;
};

export type ArrayOfPubliVueBaseInfoModel = {
  __typename?: 'ArrayOfPubliVueBaseInfoModel';
  PubliVueBaseInfoModel?: Array<PubliVueBaseInfoModel>;
};

export type ArrayOfPubliVueBaseInfoModelInput = {
  PubliVueBaseInfoModel?: Array<PubliVueBaseInfoModelInput>;
};

export type ArrayOfPublipostageCourrierPublipostageVueModel = {
  __typename?: 'ArrayOfPublipostageCourrierPublipostageVueModel';
  PublipostageCourrierPublipostageVueModel?: Array<PublipostageCourrierPublipostageVueModel>;
};

export type ArrayOfPublipostageCourrierPublipostageVueModelInput = {
  PublipostageCourrierPublipostageVueModel?: Array<PublipostageCourrierPublipostageVueModelInput>;
};

export type ArrayOfRapprochementDto = {
  __typename?: 'ArrayOfRapprochementDTO';
  RapprochementDTO?: Array<RapprochementDto>;
};

export type ArrayOfRapprochementDtoInput = {
  RapprochementDTO?: Array<RapprochementDtoInput>;
};

export type ArrayOfRapprochementLigneDto = {
  __typename?: 'ArrayOfRapprochementLigneDTO';
  RapprochementLigneDTO?: Array<RapprochementLigneDto>;
};

export type ArrayOfRapprochementLigneDtoInput = {
  RapprochementLigneDTO?: Array<RapprochementLigneDtoInput>;
};

export type ArrayOfRecapitulatifCompteValorisationModel = {
  __typename?: 'ArrayOfRecapitulatifCompteValorisationModel';
  RecapitulatifCompteValorisationModel?: Array<RecapitulatifCompteValorisationModel>;
};

export type ArrayOfRecapitulatifCompteValorisationModelInput = {
  RecapitulatifCompteValorisationModel?: Array<RecapitulatifCompteValorisationModelInput>;
};

export type ArrayOfRecapitulatifCompteVariationModel = {
  __typename?: 'ArrayOfRecapitulatifCompteVariationModel';
  RecapitulatifCompteVariationModel?: Array<RecapitulatifCompteVariationModel>;
};

export type ArrayOfRecapitulatifCompteVariationModelInput = {
  RecapitulatifCompteVariationModel?: Array<RecapitulatifCompteVariationModelInput>;
};

export type ArrayOfRecetteDepenseEcritureRecetteDepenseModelDto = {
  __typename?: 'ArrayOfRecetteDepenseEcritureRecetteDepenseModelDTO';
  RecetteDepenseEcritureRecetteDepenseModelDTO?: Array<RecetteDepenseEcritureRecetteDepenseModelDto>;
};

export type ArrayOfRecetteDepenseEcritureRecetteDepenseModelDtoInput = {
  RecetteDepenseEcritureRecetteDepenseModelDTO?: Array<RecetteDepenseEcritureRecetteDepenseModelDtoInput>;
};

export type ArrayOfRefCalcAgeSynAdModelDto = {
  __typename?: 'ArrayOfRefCalcAgeSynAdModelDTO';
  RefCalcAgeSynAdModelDTO?: Array<RefCalcAgeSynAdModelDto>;
};

export type ArrayOfRefCalcAgeSynAdModelDtoInput = {
  RefCalcAgeSynAdModelDTO?: Array<RefCalcAgeSynAdModelDtoInput>;
};

export type ArrayOfRegionDto = {
  __typename?: 'ArrayOfRegionDTO';
  RegionDTO?: Array<RegionDto>;
};

export type ArrayOfRegionDtoInput = {
  RegionDTO?: Array<RegionDtoInput>;
};

export type ArrayOfRegleAfpaModel = {
  __typename?: 'ArrayOfRegleAFPAModel';
  RegleAFPAModel?: Array<RegleAfpaModel>;
};

export type ArrayOfRegleAfpaModelInput = {
  RegleAFPAModel?: Array<RegleAfpaModelInput>;
};

export type ArrayOfRegleAccListeValModelDto = {
  __typename?: 'ArrayOfRegleAccListeValModelDTO';
  RegleAccListeValModelDTO?: Array<RegleAccListeValModelDto>;
};

export type ArrayOfRegleAccListeValModelDtoInput = {
  RegleAccListeValModelDTO?: Array<RegleAccListeValModelDtoInput>;
};

export type ArrayOfRegleAvanceeModelDto = {
  __typename?: 'ArrayOfRegleAvanceeModelDTO';
  RegleAvanceeModelDTO?: Array<RegleAvanceeModelDto>;
};

export type ArrayOfRegleAvanceeModelDtoInput = {
  RegleAvanceeModelDTO?: Array<RegleAvanceeModelDtoInput>;
};

export type ArrayOfRegleBaseModel = {
  __typename?: 'ArrayOfRegleBaseModel';
  RegleBaseModel?: Array<RegleBaseModel>;
};

export type ArrayOfRegleBaseModelInput = {
  RegleBaseModel?: Array<RegleBaseModelInput>;
};

export type ArrayOfRegleComplementaireModelDto = {
  __typename?: 'ArrayOfRegleComplementaireModelDTO';
  RegleComplementaireModelDTO?: Array<RegleComplementaireModelDto>;
};

export type ArrayOfRegleComplementaireModelDtoInput = {
  RegleComplementaireModelDTO?: Array<RegleComplementaireModelDtoInput>;
};

export type ArrayOfRegleExpertModel = {
  __typename?: 'ArrayOfRegleExpertModel';
  RegleExpertModel?: Array<RegleExpertModel>;
};

export type ArrayOfRegleExpertModelInput = {
  RegleExpertModel?: Array<RegleExpertModelInput>;
};

export type ArrayOfRegleModeleAccesDto = {
  __typename?: 'ArrayOfRegleModeleAccesDTO';
  RegleModeleAccesDTO?: Array<RegleModeleAccesDto>;
};

export type ArrayOfRegleModeleAccesDtoInput = {
  RegleModeleAccesDTO?: Array<RegleModeleAccesDtoInput>;
};

export type ArrayOfRegleModeleAcces_ChampListValDto = {
  __typename?: 'ArrayOfRegleModeleAcces_ChampListValDTO';
  RegleModeleAcces_ChampListValDTO?: Array<RegleModeleAcces_ChampListValDto>;
};

export type ArrayOfRegleModeleAcces_ChampListValDtoInput = {
  RegleModeleAcces_ChampListValDTO?: Array<RegleModeleAcces_ChampListValDtoInput>;
};

export type ArrayOfRegleSubQuotaListeValModelDto = {
  __typename?: 'ArrayOfRegleSubQuotaListeValModelDTO';
  RegleSubQuotaListeValModelDTO?: Array<RegleSubQuotaListeValModelDto>;
};

export type ArrayOfRegleSubQuotaListeValModelDtoInput = {
  RegleSubQuotaListeValModelDTO?: Array<RegleSubQuotaListeValModelDtoInput>;
};

export type ArrayOfRegleTypeDateModel = {
  __typename?: 'ArrayOfRegleTypeDateModel';
  RegleTypeDateModel?: Array<RegleTypeDateModel>;
};

export type ArrayOfRegleTypeDateModelInput = {
  RegleTypeDateModel?: Array<RegleTypeDateModelInput>;
};

export type ArrayOfRegleUseAfpaModel = {
  __typename?: 'ArrayOfRegleUseAFPAModel';
  RegleUseAFPAModel?: Array<RegleUseAfpaModel>;
};

export type ArrayOfRegleUseAfpaModelInput = {
  RegleUseAFPAModel?: Array<RegleUseAfpaModelInput>;
};

export type ArrayOfReglementEnregistrementReglementInput = {
  ReglementEnregistrementReglement?: Array<ReglementEnregistrementReglementInput>;
};

export type ArrayOfReglementFactureModelDtoInput = {
  ReglementFactureModelDTO?: Array<ReglementFactureModelDtoInput>;
};

export type ArrayOfReglementModelDto = {
  __typename?: 'ArrayOfReglementModelDTO';
  ReglementModelDTO?: Array<ReglementModelDto>;
};

export type ArrayOfReglementModelDtoInput = {
  ReglementModelDTO?: Array<ReglementModelDtoInput>;
};

export type ArrayOfReglementMouvFacModelDto = {
  __typename?: 'ArrayOfReglementMouvFacModelDTO';
  ReglementMouvFacModelDTO?: Array<ReglementMouvFacModelDto>;
};

export type ArrayOfReglementMouvFacModelDtoInput = {
  ReglementMouvFacModelDTO?: Array<ReglementMouvFacModelDtoInput>;
};

export type ArrayOfReglementPretsEtDonsListerModel = {
  __typename?: 'ArrayOfReglementPretsEtDonsListerModel';
  ReglementPretsEtDonsListerModel?: Array<ReglementPretsEtDonsListerModel>;
};

export type ArrayOfReglementPretsEtDonsListerModelInput = {
  ReglementPretsEtDonsListerModel?: Array<ReglementPretsEtDonsListerModelInput>;
};

export type ArrayOfReglementsReglementModelInput = {
  ReglementsReglementModel?: Array<ReglementsReglementModelInput>;
};

export type ArrayOfRelationOdadModel = {
  __typename?: 'ArrayOfRelationODADModel';
  RelationODADModel?: Array<RelationOdadModel>;
};

export type ArrayOfRelationOdadModelInput = {
  RelationODADModel?: Array<RelationOdadModelInput>;
};

export type ArrayOfReleveBancaireDto = {
  __typename?: 'ArrayOfReleveBancaireDTO';
  ReleveBancaireDTO?: Array<ReleveBancaireDto>;
};

export type ArrayOfReleveBancaireDtoInput = {
  ReleveBancaireDTO?: Array<ReleveBancaireDtoInput>;
};

export type ArrayOfRemboursementPretsEtDonsListerModel = {
  __typename?: 'ArrayOfRemboursementPretsEtDonsListerModel';
  RemboursementPretsEtDonsListerModel?: Array<RemboursementPretsEtDonsListerModel>;
};

export type ArrayOfRemboursementPretsEtDonsListerModelInput = {
  RemboursementPretsEtDonsListerModel?: Array<RemboursementPretsEtDonsListerModelInput>;
};

export type ArrayOfRemiseEnBanqueModel = {
  __typename?: 'ArrayOfRemiseEnBanqueModel';
  RemiseEnBanqueModel?: Array<RemiseEnBanqueModel>;
};

export type ArrayOfRemiseEnBanqueModelInput = {
  RemiseEnBanqueModel?: Array<RemiseEnBanqueModelInput>;
};

export type ArrayOfRemiseEnCaisseLigneRemiseEnCaisseFiduModelInput = {
  RemiseEnCaisseLigneRemiseEnCaisseFiduModel?: Array<RemiseEnCaisseLigneRemiseEnCaisseFiduModelInput>;
};

export type ArrayOfRemiseEnCaisseLigneRemiseEnCaisseNonFiduModelInput = {
  RemiseEnCaisseLigneRemiseEnCaisseNonFiduModel?: Array<RemiseEnCaisseLigneRemiseEnCaisseNonFiduModelInput>;
};

export type ArrayOfRemonterBaseReferenceModelDto = {
  __typename?: 'ArrayOfRemonterBaseReferenceModelDTO';
  RemonterBaseReferenceModelDTO?: Array<RemonterBaseReferenceModelDto>;
};

export type ArrayOfRemonterBaseReferenceModelDtoInput = {
  RemonterBaseReferenceModelDTO?: Array<RemonterBaseReferenceModelDtoInput>;
};

export type ArrayOfReponseFormulaireAPlatModel = {
  __typename?: 'ArrayOfReponseFormulaireAPlatModel';
  ReponseFormulaireAPlatModel?: Array<ReponseFormulaireAPlatModel>;
};

export type ArrayOfReponseFormulaireAPlatModelInput = {
  ReponseFormulaireAPlatModel?: Array<ReponseFormulaireAPlatModelInput>;
};

export type ArrayOfReponseFormulaireBaseModel = {
  __typename?: 'ArrayOfReponseFormulaireBaseModel';
  ReponseFormulaireBaseModel?: Array<Union_3045481246475108235>;
};

export type ArrayOfReponseFormulaireBaseModelInput = {
  ReponseFormulaireBaseModel?: Array<ReponseFormulaireBaseModelInput>;
};

export type ArrayOfReponseFormulaireModel = {
  __typename?: 'ArrayOfReponseFormulaireModel';
  ReponseFormulaireModel?: Array<Union_2051424951178096057>;
};

export type ArrayOfReponseFormulaireModelInput = {
  ReponseFormulaireModel?: Array<ReponseFormulaireModelInput>;
};

export type ArrayOfReponseFormulaireParticipantModel = {
  __typename?: 'ArrayOfReponseFormulaireParticipantModel';
  ReponseFormulaireParticipantModel?: Array<Union_22110153801956302235>;
};

export type ArrayOfReponseFormulaireParticipantModelInput = {
  ReponseFormulaireParticipantModel?: Array<ReponseFormulaireParticipantModelInput>;
};

export type ArrayOfReportBaseModel = {
  __typename?: 'ArrayOfReportBaseModel';
  ReportBaseModel?: Array<ReportBaseModel>;
};

export type ArrayOfReportBaseModelInput = {
  ReportBaseModel?: Array<ReportBaseModelInput>;
};

export type ArrayOfReportBlocData_ReportTypeDto = {
  __typename?: 'ArrayOfReportBlocData_ReportTypeDTO';
  ReportBlocData_ReportTypeDTO?: Array<ReportBlocData_ReportTypeDto>;
};

export type ArrayOfReportBlocData_ReportTypeDtoInput = {
  ReportBlocData_ReportTypeDTO?: Array<ReportBlocData_ReportTypeDtoInput>;
};

export type ArrayOfReportDto = {
  __typename?: 'ArrayOfReportDTO';
  ReportDTO?: Array<ReportDto>;
};

export type ArrayOfReportDtoInput = {
  ReportDTO?: Array<ReportDtoInput>;
};

export type ArrayOfReportModeleAdrdto = {
  __typename?: 'ArrayOfReportModeleADRDTO';
  ReportModeleADRDTO?: Array<ReportModeleAdrdto>;
};

export type ArrayOfReportModeleAdrdtoInput = {
  ReportModeleADRDTO?: Array<ReportModeleAdrdtoInput>;
};

export type ArrayOfReportModeleMep_ReportTypeDto = {
  __typename?: 'ArrayOfReportModeleMEP_ReportTypeDTO';
  ReportModeleMEP_ReportTypeDTO?: Array<ReportModeleMep_ReportTypeDto>;
};

export type ArrayOfReportModeleMep_ReportTypeDtoInput = {
  ReportModeleMEP_ReportTypeDTO?: Array<ReportModeleMep_ReportTypeDtoInput>;
};

export type ArrayOfReportSubReportDto = {
  __typename?: 'ArrayOfReportSubReportDTO';
  ReportSubReportDTO?: Array<ReportSubReportDto>;
};

export type ArrayOfReportSubReportDtoInput = {
  ReportSubReportDTO?: Array<ReportSubReportDtoInput>;
};

export type ArrayOfReportTypeDto = {
  __typename?: 'ArrayOfReportTypeDTO';
  ReportTypeDTO?: Array<ReportTypeDto>;
};

export type ArrayOfReportTypeDtoInput = {
  ReportTypeDTO?: Array<ReportTypeDtoInput>;
};

export type ArrayOfReqSpecifDto = {
  __typename?: 'ArrayOfReqSpecifDTO';
  ReqSpecifDTO?: Array<ReqSpecifDto>;
};

export type ArrayOfReqSpecifDtoInput = {
  ReqSpecifDTO?: Array<ReqSpecifDtoInput>;
};

export type ArrayOfRequestModel = {
  __typename?: 'ArrayOfRequestModel';
  RequestModel?: Array<RequestModel>;
};

export type ArrayOfRequestModelInput = {
  RequestModel?: Array<RequestModelInput>;
};

export type ArrayOfRequetePubliRequeteBaseModel = {
  __typename?: 'ArrayOfRequetePubliRequeteBaseModel';
  RequetePubliRequeteBaseModel?: Array<Union_27071403723942099383>;
};

export type ArrayOfRequetePubliRequeteBaseModelInput = {
  RequetePubliRequeteBaseModel?: Array<RequetePubliRequeteBaseModelInput>;
};

export type ArrayOfRessourcesPartageesTarifFactureModel = {
  __typename?: 'ArrayOfRessourcesPartageesTarifFactureModel';
  RessourcesPartageesTarifFactureModel?: Array<Union_25557305492872672030>;
};

export type ArrayOfRessourcesPartageesTarifFactureModelInput = {
  RessourcesPartageesTarifFactureModel?: Array<RessourcesPartageesTarifFactureModelInput>;
};

export type ArrayOfRessourcesPartageesTarifModelInput = {
  RessourcesPartageesTarifModel?: Array<RessourcesPartageesTarifModelInput>;
};

export type ArrayOfRetourApiMediaModel = {
  __typename?: 'ArrayOfRetourAPIMediaModel';
  RetourAPIMediaModel?: Array<RetourApiMediaModel>;
};

export type ArrayOfRetourApiMediaModelInput = {
  RetourAPIMediaModel?: Array<RetourApiMediaModelInput>;
};

export type ArrayOfReturnModeleForVente = {
  __typename?: 'ArrayOfReturnModeleForVente';
  ReturnModeleForVente?: Array<ReturnModeleForVente>;
};

export type ArrayOfReturnModeleForVenteInput = {
  ReturnModeleForVente?: Array<ReturnModeleForVenteInput>;
};

export type ArrayOfRibDto = {
  __typename?: 'ArrayOfRibDTO';
  RibDTO?: Array<RibDto>;
};

export type ArrayOfRibDtoInput = {
  RibDTO?: Array<RibDtoInput>;
};

export type ArrayOfRibMandatBanque = {
  __typename?: 'ArrayOfRibMandatBanque';
  RibMandatBanque?: Array<RibMandatBanque>;
};

export type ArrayOfRibMandatBanqueInput = {
  RibMandatBanque?: Array<RibMandatBanqueInput>;
};

export type ArrayOfRibMandatDto = {
  __typename?: 'ArrayOfRibMandatDTO';
  RibMandatDTO?: Array<RibMandatDto>;
};

export type ArrayOfRibMandatDtoInput = {
  RibMandatDTO?: Array<RibMandatDtoInput>;
};

export type ArrayOfRibModelDto = {
  __typename?: 'ArrayOfRibModelDTO';
  RibModelDTO?: Array<RibModelDto>;
};

export type ArrayOfRibModelDtoInput = {
  RibModelDTO?: Array<RibModelDtoInput>;
};

export type ArrayOfRoomingListeParticipantsModel = {
  __typename?: 'ArrayOfRoomingListeParticipantsModel';
  RoomingListeParticipantsModel?: Array<RoomingListeParticipantsModel>;
};

export type ArrayOfRoomingListeParticipantsModelInput = {
  RoomingListeParticipantsModel?: Array<RoomingListeParticipantsModelInput>;
};

export type ArrayOfRubriquageModelDto = {
  __typename?: 'ArrayOfRubriquageModelDTO';
  RubriquageModelDTO?: Array<RubriquageModelDto>;
};

export type ArrayOfRubriquageModelDtoInput = {
  RubriquageModelDTO?: Array<RubriquageModelDtoInput>;
};

export type ArrayOfRubriquageTreeviewModelDto = {
  __typename?: 'ArrayOfRubriquageTreeviewModelDTO';
  RubriquageTreeviewModelDTO?: Array<RubriquageTreeviewModelDto>;
};

export type ArrayOfRubriquageTreeviewModelDtoInput = {
  RubriquageTreeviewModelDTO?: Array<RubriquageTreeviewModelDtoInput>;
};

export type ArrayOfSaisieEcrituresModelSaveEcritureManuelleInput = {
  SaisieEcrituresModelSaveEcritureManuelle?: Array<SaisieEcrituresModelSaveEcritureManuelleInput>;
};

export type ArrayOfSaveCompteEcritureModelDtoInput = {
  SaveCompteEcritureModelDTO?: Array<SaveCompteEcritureModelDtoInput>;
};

export type ArrayOfSaveLigneCessionStockModelInput = {
  SaveLigneCessionStockModel?: Array<SaveLigneCessionStockModelInput>;
};

export type ArrayOfSaveModeleSaisieModelDtoInput = {
  SaveModeleSaisieModelDTO?: Array<SaveModeleSaisieModelDtoInput>;
};

export type ArrayOfSectionAnalytiqueDto = {
  __typename?: 'ArrayOfSectionAnalytiqueDTO';
  SectionAnalytiqueDTO?: Array<SectionAnalytiqueDto>;
};

export type ArrayOfSectionAnalytiqueDtoInput = {
  SectionAnalytiqueDTO?: Array<SectionAnalytiqueDtoInput>;
};

export type ArrayOfSectionAnalytiqueLigneCommandeModelDto = {
  __typename?: 'ArrayOfSectionAnalytiqueLigneCommandeModelDTO';
  SectionAnalytiqueLigneCommandeModelDTO?: Array<SectionAnalytiqueLigneCommandeModelDto>;
};

export type ArrayOfSectionAnalytiqueLigneCommandeModelDtoInput = {
  SectionAnalytiqueLigneCommandeModelDTO?: Array<SectionAnalytiqueLigneCommandeModelDtoInput>;
};

export type ArrayOfSectionAnalytiqueModelDto = {
  __typename?: 'ArrayOfSectionAnalytiqueModelDTO';
  SectionAnalytiqueModelDTO?: Array<SectionAnalytiqueModelDto>;
};

export type ArrayOfSectionAnalytiqueModelDtoInput = {
  SectionAnalytiqueModelDTO?: Array<SectionAnalytiqueModelDtoInput>;
};

export type ArrayOfSelectedModeleEcheancierArticleModel = {
  __typename?: 'ArrayOfSelectedModeleEcheancierArticleModel';
  SelectedModeleEcheancierArticleModel?: Array<SelectedModeleEcheancierArticleModel>;
};

export type ArrayOfSelectedModeleEcheancierArticleModelInput = {
  SelectedModeleEcheancierArticleModel?: Array<SelectedModeleEcheancierArticleModelInput>;
};

export type ArrayOfSessionChoixBaseModel = {
  __typename?: 'ArrayOfSessionChoixBaseModel';
  SessionChoixBaseModel?: Array<SessionChoixBaseModel>;
};

export type ArrayOfSessionChoixBaseModelInput = {
  SessionChoixBaseModel?: Array<SessionChoixBaseModelInput>;
};

export type ArrayOfSessionChoixDto = {
  __typename?: 'ArrayOfSessionChoixDTO';
  SessionChoixDTO?: Array<SessionChoixDto>;
};

export type ArrayOfSessionChoixDtoInput = {
  SessionChoixDTO?: Array<SessionChoixDtoInput>;
};

export type ArrayOfSiteBaseModel = {
  __typename?: 'ArrayOfSiteBaseModel';
  SiteBaseModel?: Array<SiteBaseModel>;
};

export type ArrayOfSiteBaseModelInput = {
  SiteBaseModel?: Array<SiteBaseModelInput>;
};

export type ArrayOfSiteDto = {
  __typename?: 'ArrayOfSiteDTO';
  SiteDTO?: Array<SiteDto>;
};

export type ArrayOfSiteDtoInput = {
  SiteDTO?: Array<SiteDtoInput>;
};

export type ArrayOfSiteForExportAncvModelDto = {
  __typename?: 'ArrayOfSiteForExportANCVModelDTO';
  SiteForExportANCVModelDTO?: Array<SiteForExportAncvModelDto>;
};

export type ArrayOfSiteForExportAncvModelDtoInput = {
  SiteForExportANCVModelDTO?: Array<SiteForExportAncvModelDtoInput>;
};

export type ArrayOfSiteLivraison = {
  __typename?: 'ArrayOfSiteLivraison';
  SiteLivraison?: Array<SiteLivraison>;
};

export type ArrayOfSiteLivraisonInput = {
  SiteLivraison?: Array<SiteLivraisonInput>;
};

export type ArrayOfSiteOrganisationBaseModel = {
  __typename?: 'ArrayOfSiteOrganisationBaseModel';
  SiteOrganisationBaseModel?: Array<SiteOrganisationBaseModel>;
};

export type ArrayOfSiteOrganisationBaseModelInput = {
  SiteOrganisationBaseModel?: Array<SiteOrganisationBaseModelInput>;
};

export type ArrayOfSoldeConsommationsDto = {
  __typename?: 'ArrayOfSoldeConsommationsDTO';
  SoldeConsommationsDTO?: Array<SoldeConsommationsDto>;
};

export type ArrayOfSoldeConsommationsDtoInput = {
  SoldeConsommationsDTO?: Array<SoldeConsommationsDtoInput>;
};

export type ArrayOfSoldePmvModel = {
  __typename?: 'ArrayOfSoldePMVModel';
  SoldePMVModel?: Array<SoldePmvModel>;
};

export type ArrayOfSoldePmvModelInput = {
  SoldePMVModel?: Array<SoldePmvModelInput>;
};

export type ArrayOfSommeCompteurPointModelDto = {
  __typename?: 'ArrayOfSommeCompteurPointModelDTO';
  SommeCompteurPointModelDTO?: Array<SommeCompteurPointModelDto>;
};

export type ArrayOfSommeCompteurPointModelDtoInput = {
  SommeCompteurPointModelDTO?: Array<SommeCompteurPointModelDtoInput>;
};

export type ArrayOfSoumissionFormulaireModelInput = {
  SoumissionFormulaireModel?: Array<SoumissionFormulaireModelInput>;
};

export type ArrayOfStatutCommandeDto = {
  __typename?: 'ArrayOfStatutCommandeDTO';
  StatutCommandeDTO?: Array<StatutCommandeDto>;
};

export type ArrayOfStatutCommandeDtoInput = {
  StatutCommandeDTO?: Array<StatutCommandeDtoInput>;
};

export type ArrayOfStatutCommandeLibelleModel = {
  __typename?: 'ArrayOfStatutCommandeLibelleModel';
  StatutCommandeLibelleModel?: Array<StatutCommandeLibelleModel>;
};

export type ArrayOfStatutCommandeLibelleModelInput = {
  StatutCommandeLibelleModel?: Array<StatutCommandeLibelleModelInput>;
};

export type ArrayOfStatutCourrierDto = {
  __typename?: 'ArrayOfStatutCourrierDTO';
  StatutCourrierDTO?: Array<StatutCourrierDto>;
};

export type ArrayOfStatutCourrierDtoInput = {
  StatutCourrierDTO?: Array<StatutCourrierDtoInput>;
};

export type ArrayOfStatutFactureBaseModel = {
  __typename?: 'ArrayOfStatutFactureBaseModel';
  StatutFactureBaseModel?: Array<StatutFactureBaseModel>;
};

export type ArrayOfStatutFactureBaseModelInput = {
  StatutFactureBaseModel?: Array<StatutFactureBaseModelInput>;
};

export type ArrayOfStatutPersoActionModel = {
  __typename?: 'ArrayOfStatutPersoActionModel';
  StatutPersoActionModel?: Array<StatutPersoActionModel>;
};

export type ArrayOfStatutPersoActionModelInput = {
  StatutPersoActionModel?: Array<StatutPersoActionModelInput>;
};

export type ArrayOfStatutPersoBaseModel = {
  __typename?: 'ArrayOfStatutPersoBaseModel';
  StatutPersoBaseModel?: Array<StatutPersoBaseModel>;
};

export type ArrayOfStatutPersoBaseModelInput = {
  StatutPersoBaseModel?: Array<StatutPersoBaseModelInput>;
};

export type ArrayOfStatutPersoCouleurModel = {
  __typename?: 'ArrayOfStatutPersoCouleurModel';
  StatutPersoCouleurModel?: Array<Union_1058209019463210040>;
};

export type ArrayOfStatutPersoCouleurModelInput = {
  StatutPersoCouleurModel?: Array<StatutPersoCouleurModelInput>;
};

export type ArrayOfStatutPersoModel = {
  __typename?: 'ArrayOfStatutPersoModel';
  StatutPersoModel?: Array<StatutPersoModel>;
};

export type ArrayOfStatutPersoModelInput = {
  StatutPersoModel?: Array<StatutPersoModelInput>;
};

export type ArrayOfStatutWithOrdreModel = {
  __typename?: 'ArrayOfStatutWithOrdreModel';
  StatutWithOrdreModel?: Array<StatutWithOrdreModel>;
};

export type ArrayOfStatutWithOrdreModelInput = {
  StatutWithOrdreModel?: Array<StatutWithOrdreModelInput>;
};

export type ArrayOfStockArticleDto = {
  __typename?: 'ArrayOfStockArticleDTO';
  StockArticleDTO?: Array<StockArticleDto>;
};

export type ArrayOfStockArticleDtoInput = {
  StockArticleDTO?: Array<StockArticleDtoInput>;
};

export type ArrayOfStockArticleModelDto = {
  __typename?: 'ArrayOfStockArticleModelDTO';
  StockArticleModelDTO?: Array<StockArticleModelDto>;
};

export type ArrayOfStockArticleModelDtoInput = {
  StockArticleModelDTO?: Array<StockArticleModelDtoInput>;
};

export type ArrayOfStockDto = {
  __typename?: 'ArrayOfStockDTO';
  StockDTO?: Array<StockDto>;
};

export type ArrayOfStockDtoInput = {
  StockDTO?: Array<StockDtoInput>;
};

export type ArrayOfStockLightModel = {
  __typename?: 'ArrayOfStockLightModel';
  StockLightModel?: Array<StockLightModel>;
};

export type ArrayOfStockLightModelInput = {
  StockLightModel?: Array<StockLightModelInput>;
};

export type ArrayOfStockModeleDto = {
  __typename?: 'ArrayOfStockModeleDTO';
  StockModeleDTO?: Array<StockModeleDto>;
};

export type ArrayOfStockModeleDtoInput = {
  StockModeleDTO?: Array<StockModeleDtoInput>;
};

export type ArrayOfStockTypeReapproDto = {
  __typename?: 'ArrayOfStockTypeReapproDTO';
  StockTypeReapproDTO?: Array<StockTypeReapproDto>;
};

export type ArrayOfStockTypeReapproDtoInput = {
  StockTypeReapproDTO?: Array<StockTypeReapproDtoInput>;
};

export type ArrayOfStockTypeReapproModel = {
  __typename?: 'ArrayOfStockTypeReapproModel';
  StockTypeReapproModel?: Array<StockTypeReapproModel>;
};

export type ArrayOfStockTypeReapproModelInput = {
  StockTypeReapproModel?: Array<StockTypeReapproModelInput>;
};

export type ArrayOfStockWithDelegetPvModel = {
  __typename?: 'ArrayOfStockWithDelegetPVModel';
  StockWithDelegetPVModel?: Array<StockWithDelegetPvModel>;
};

export type ArrayOfStockWithDelegetPvModelInput = {
  StockWithDelegetPVModel?: Array<StockWithDelegetPvModelInput>;
};

export type ArrayOfSubventionAccordeeModelDtoInput = {
  SubventionAccordeeModelDTO?: Array<SubventionAccordeeModelDtoInput>;
};

export type ArrayOfSubventionValeurCritereModele = {
  __typename?: 'ArrayOfSubventionValeurCritereModele';
  SubventionValeurCritereModele?: Array<SubventionValeurCritereModele>;
};

export type ArrayOfSubventionValeurCritereModeleInput = {
  SubventionValeurCritereModele?: Array<SubventionValeurCritereModeleInput>;
};

export type ArrayOfSuiviTresorerieModelDto = {
  __typename?: 'ArrayOfSuiviTresorerieModelDTO';
  SuiviTresorerieModelDTO?: Array<SuiviTresorerieModelDto>;
};

export type ArrayOfSuiviTresorerieModelDtoInput = {
  SuiviTresorerieModelDTO?: Array<SuiviTresorerieModelDtoInput>;
};

export type ArrayOfSynchDataModel = {
  __typename?: 'ArrayOfSynchDataModel';
  SynchDataModel?: Array<SynchDataModel>;
};

export type ArrayOfSynchDataModelInput = {
  SynchDataModel?: Array<SynchDataModelInput>;
};

export type ArrayOfSynchroBenefInput = {
  SynchroBenef?: Array<SynchroBenefInput>;
};

export type ArrayOfSynchroSiteLivraisonInput = {
  SynchroSiteLivraison?: Array<SynchroSiteLivraisonInput>;
};

export type ArrayOfTvaEtatPreparatoireHistoModel = {
  __typename?: 'ArrayOfTVAEtatPreparatoireHistoModel';
  TVAEtatPreparatoireHistoModel?: Array<TvaEtatPreparatoireHistoModel>;
};

export type ArrayOfTvaEtatPreparatoireHistoModelInput = {
  TVAEtatPreparatoireHistoModel?: Array<TvaEtatPreparatoireHistoModelInput>;
};

export type ArrayOfTransfertStockPourListeModel = {
  __typename?: 'ArrayOfTransfertStockPourListeModel';
  TransfertStockPourListeModel?: Array<TransfertStockPourListeModel>;
};

export type ArrayOfTransfertStockPourListeModelInput = {
  TransfertStockPourListeModel?: Array<TransfertStockPourListeModelInput>;
};

export type ArrayOfTreeviewAfpaModel = {
  __typename?: 'ArrayOfTreeviewAFPAModel';
  TreeviewAFPAModel?: Array<TreeviewAfpaModel>;
};

export type ArrayOfTreeviewAfpaModelInput = {
  TreeviewAFPAModel?: Array<TreeviewAfpaModelInput>;
};

export type ArrayOfTrombinoscopeTrombinoscopeModel = {
  __typename?: 'ArrayOfTrombinoscopeTrombinoscopeModel';
  TrombinoscopeTrombinoscopeModel?: Array<TrombinoscopeTrombinoscopeModel>;
};

export type ArrayOfTrombinoscopeTrombinoscopeModelInput = {
  TrombinoscopeTrombinoscopeModel?: Array<TrombinoscopeTrombinoscopeModelInput>;
};

export type ArrayOfTupleOfstringstring = {
  __typename?: 'ArrayOfTupleOfstringstring';
  TupleOfstringstring?: Array<TupleOfstringstring>;
};

export type ArrayOfTupleOfstringstringInput = {
  TupleOfstringstring?: Array<TupleOfstringstringInput>;
};

export type ArrayOfTypeActiviteDto = {
  __typename?: 'ArrayOfTypeActiviteDTO';
  TypeActiviteDTO?: Array<TypeActiviteDto>;
};

export type ArrayOfTypeActiviteDtoInput = {
  TypeActiviteDTO?: Array<TypeActiviteDtoInput>;
};

export type ArrayOfTypeActiviteWithListeActiviteModel = {
  __typename?: 'ArrayOfTypeActiviteWithListeActiviteModel';
  TypeActiviteWithListeActiviteModel?: Array<TypeActiviteWithListeActiviteModel>;
};

export type ArrayOfTypeActiviteWithListeActiviteModelInput = {
  TypeActiviteWithListeActiviteModel?: Array<TypeActiviteWithListeActiviteModelInput>;
};

export type ArrayOfTypeAnalyseIaModel = {
  __typename?: 'ArrayOfTypeAnalyseIAModel';
  TypeAnalyseIAModel?: Array<TypeAnalyseIaModel>;
};

export type ArrayOfTypeAnalyseIaModelInput = {
  TypeAnalyseIAModel?: Array<TypeAnalyseIaModelInput>;
};

export type ArrayOfTypeArrondiModel = {
  __typename?: 'ArrayOfTypeArrondiModel';
  TypeArrondiModel?: Array<TypeArrondiModel>;
};

export type ArrayOfTypeArrondiModelInput = {
  TypeArrondiModel?: Array<TypeArrondiModelInput>;
};

export type ArrayOfTypeBenefDto = {
  __typename?: 'ArrayOfTypeBenefDTO';
  TypeBenefDTO?: Array<TypeBenefDto>;
};

export type ArrayOfTypeBenefDtoInput = {
  TypeBenefDTO?: Array<TypeBenefDtoInput>;
};

export type ArrayOfTypeCalculModeLivraisonDto = {
  __typename?: 'ArrayOfTypeCalculModeLivraisonDTO';
  TypeCalculModeLivraisonDTO?: Array<TypeCalculModeLivraisonDto>;
};

export type ArrayOfTypeCalculModeLivraisonDtoInput = {
  TypeCalculModeLivraisonDTO?: Array<TypeCalculModeLivraisonDtoInput>;
};

export type ArrayOfTypeChampFormulaireModel = {
  __typename?: 'ArrayOfTypeChampFormulaireModel';
  TypeChampFormulaireModel?: Array<TypeChampFormulaireModel>;
};

export type ArrayOfTypeChampFormulaireModelInput = {
  TypeChampFormulaireModel?: Array<TypeChampFormulaireModelInput>;
};

export type ArrayOfTypeConsoMouvementPointDto = {
  __typename?: 'ArrayOfTypeConsoMouvementPointDTO';
  TypeConsoMouvementPointDTO?: Array<TypeConsoMouvementPointDto>;
};

export type ArrayOfTypeConsoMouvementPointDtoInput = {
  TypeConsoMouvementPointDTO?: Array<TypeConsoMouvementPointDtoInput>;
};

export type ArrayOfTypeCritereSyncAdModelDto = {
  __typename?: 'ArrayOfTypeCritereSyncAdModelDTO';
  TypeCritereSyncAdModelDTO?: Array<TypeCritereSyncAdModelDto>;
};

export type ArrayOfTypeCritereSyncAdModelDtoInput = {
  TypeCritereSyncAdModelDTO?: Array<TypeCritereSyncAdModelDtoInput>;
};

export type ArrayOfTypeMoyenPaiementDto = {
  __typename?: 'ArrayOfTypeMoyenPaiementDTO';
  TypeMoyenPaiementDTO?: Array<TypeMoyenPaiementDto>;
};

export type ArrayOfTypeMoyenPaiementDtoInput = {
  TypeMoyenPaiementDTO?: Array<TypeMoyenPaiementDtoInput>;
};

export type ArrayOfTypePjAffichageModele = {
  __typename?: 'ArrayOfTypePJAffichageModele';
  TypePJAffichageModele?: Array<TypePjAffichageModele>;
};

export type ArrayOfTypePjAffichageModeleInput = {
  TypePJAffichageModele?: Array<TypePjAffichageModeleInput>;
};

export type ArrayOfUserBaseModel = {
  __typename?: 'ArrayOfUserBaseModel';
  UserBaseModel?: Array<UserBaseModel>;
};

export type ArrayOfUserBaseModelInput = {
  UserBaseModel?: Array<UserBaseModelInput>;
};

export type ArrayOfUserCommissionDto = {
  __typename?: 'ArrayOfUserCommissionDTO';
  UserCommissionDTO?: Array<UserCommissionDto>;
};

export type ArrayOfUserCommissionDtoInput = {
  UserCommissionDTO?: Array<UserCommissionDtoInput>;
};

export type ArrayOfUserCommissionDroit = {
  __typename?: 'ArrayOfUserCommissionDroit';
  UserCommissionDroit?: Array<UserCommissionDroit>;
};

export type ArrayOfUserCommissionDroitInput = {
  UserCommissionDroit?: Array<UserCommissionDroitInput>;
};

export type ArrayOfUserCommissionModel = {
  __typename?: 'ArrayOfUserCommissionModel';
  UserCommissionModel?: Array<UserCommissionModel>;
};

export type ArrayOfUserCommissionModelInput = {
  UserCommissionModel?: Array<UserCommissionModelInput>;
};

export type ArrayOfUserEmailModel = {
  __typename?: 'ArrayOfUserEmailModel';
  UserEmailModel?: Array<UserEmailModel>;
};

export type ArrayOfUserEmailModelInput = {
  UserEmailModel?: Array<UserEmailModelInput>;
};

export type ArrayOfUserHistoriqueModel = {
  __typename?: 'ArrayOfUserHistoriqueModel';
  UserHistoriqueModel?: Array<UserHistoriqueModel>;
};

export type ArrayOfUserHistoriqueModelInput = {
  UserHistoriqueModel?: Array<UserHistoriqueModelInput>;
};

export type ArrayOfUsersCeDelegationDto = {
  __typename?: 'ArrayOfUsersCEDelegationDTO';
  UsersCEDelegationDTO?: Array<UsersCeDelegationDto>;
};

export type ArrayOfUsersCeDelegationDtoInput = {
  UsersCEDelegationDTO?: Array<UsersCeDelegationDtoInput>;
};

export type ArrayOfUsersDto = {
  __typename?: 'ArrayOfUsersDTO';
  UsersDTO?: Array<UsersDto>;
};

export type ArrayOfUsersDtoInput = {
  UsersDTO?: Array<UsersDtoInput>;
};

export type ArrayOfUsersPointVenteDto = {
  __typename?: 'ArrayOfUsersPointVenteDTO';
  UsersPointVenteDTO?: Array<UsersPointVenteDto>;
};

export type ArrayOfUsersPointVenteDtoInput = {
  UsersPointVenteDTO?: Array<UsersPointVenteDtoInput>;
};

export type ArrayOfValeurChampFormulaireModel = {
  __typename?: 'ArrayOfValeurChampFormulaireModel';
  ValeurChampFormulaireModel?: Array<ValeurChampFormulaireModel>;
};

export type ArrayOfValeurChampFormulaireModelInput = {
  ValeurChampFormulaireModel?: Array<ValeurChampFormulaireModelInput>;
};

export type ArrayOfValeurReponseModel = {
  __typename?: 'ArrayOfValeurReponseModel';
  ValeurReponseModel?: Array<ValeurReponseModel>;
};

export type ArrayOfValeurReponseModelInput = {
  ValeurReponseModel?: Array<ValeurReponseModelInput>;
};

export type ArrayOfVerifCoherenceLivraisonModel = {
  __typename?: 'ArrayOfVerifCoherenceLivraisonModel';
  VerifCoherenceLivraisonModel?: Array<VerifCoherenceLivraisonModel>;
};

export type ArrayOfVerifCoherenceLivraisonModelInput = {
  VerifCoherenceLivraisonModel?: Array<VerifCoherenceLivraisonModelInput>;
};

export type ArrayOfVilleDto = {
  __typename?: 'ArrayOfVilleDTO';
  VilleDTO?: Array<VilleDto>;
};

export type ArrayOfVilleDtoInput = {
  VilleDTO?: Array<VilleDtoInput>;
};

export type ArrayOfVueChampVueDto = {
  __typename?: 'ArrayOfVueChampVueDTO';
  VueChampVueDTO?: Array<VueChampVueDto>;
};

export type ArrayOfVueChampVueDtoInput = {
  VueChampVueDTO?: Array<VueChampVueDtoInput>;
};

export type ArrayOfVueDto = {
  __typename?: 'ArrayOfVueDTO';
  VueDTO?: Array<VueDto>;
};

export type ArrayOfVueDtoInput = {
  VueDTO?: Array<VueDtoInput>;
};

export type ArrayOfVuePubliVueChampModel = {
  __typename?: 'ArrayOfVuePubliVueChampModel';
  VuePubliVueChampModel?: Array<VuePubliVueChampModel>;
};

export type ArrayOfVuePubliVueChampModelInput = {
  VuePubliVueChampModel?: Array<VuePubliVueChampModelInput>;
};

export type ArrayOfWidgetAccueilDto = {
  __typename?: 'ArrayOfWidgetAccueilDTO';
  WidgetAccueilDTO?: Array<WidgetAccueilDto>;
};

export type ArrayOfWidgetAccueilDtoInput = {
  WidgetAccueilDTO?: Array<WidgetAccueilDtoInput>;
};

export type ArrayOfWidgetAccueilParamDto = {
  __typename?: 'ArrayOfWidgetAccueilParamDTO';
  WidgetAccueilParamDTO?: Array<WidgetAccueilParamDto>;
};

export type ArrayOfWidgetAccueilParamDtoInput = {
  WidgetAccueilParamDTO?: Array<WidgetAccueilParamDtoInput>;
};

export type ArrayOfWidgetDto = {
  __typename?: 'ArrayOfWidgetDTO';
  WidgetDTO?: Array<WidgetDto>;
};

export type ArrayOfWidgetDtoInput = {
  WidgetDTO?: Array<WidgetDtoInput>;
};

export type ArrayOfWidgetFacturesModelDto = {
  __typename?: 'ArrayOfWidgetFacturesModelDTO';
  WidgetFacturesModelDTO?: Array<WidgetFacturesModelDto>;
};

export type ArrayOfWidgetFacturesModelDtoInput = {
  WidgetFacturesModelDTO?: Array<WidgetFacturesModelDtoInput>;
};

export type ArrayOfWidgetParamDto = {
  __typename?: 'ArrayOfWidgetParamDTO';
  WidgetParamDTO?: Array<WidgetParamDto>;
};

export type ArrayOfWidgetParamDtoInput = {
  WidgetParamDTO?: Array<WidgetParamDtoInput>;
};

export type ArrayOfWidgetParametreModelDto = {
  __typename?: 'ArrayOfWidgetParametreModelDTO';
  WidgetParametreModelDTO?: Array<WidgetParametreModelDto>;
};

export type ArrayOfWidgetParametreModelDtoInput = {
  WidgetParametreModelDTO?: Array<WidgetParametreModelDtoInput>;
};

export type ArrayOfWidgetProfilModel = {
  __typename?: 'ArrayOfWidgetProfilModel';
  WidgetProfilModel?: Array<WidgetProfilModel>;
};

export type ArrayOfWidgetProfilModelInput = {
  WidgetProfilModel?: Array<WidgetProfilModelInput>;
};

export type ArrayOfanyType = {
  __typename?: 'ArrayOfanyType';
  anyType?: Array<any>;
};

export type ArrayOfanyTypeInput = {
  anyType?: Array<any>;
};

export type ArrayOfdateTime = {
  __typename?: 'ArrayOfdateTime';
  dateTime?: Array<any>;
};

export type ArrayOfdateTimeInput = {
  dateTime?: Array<any>;
};

export type ArrayOfdecimal = {
  __typename?: 'ArrayOfdecimal';
  decimal?: Array<number>;
};

export type ArrayOfdecimalInput = {
  decimal?: Array<number>;
};

export type ArrayOfint = {
  __typename?: 'ArrayOfint';
  int?: Array<number>;
};

export type ArrayOfintInput = {
  int?: Array<number>;
};

export type ArrayOfstring = {
  __typename?: 'ArrayOfstring';
  string?: Array<string>;
};

export type ArrayOfstringInput = {
  string?: Array<string>;
};

export type ArreteCaisseArreteCaisseBaseModel = {
  __typename?: 'ArreteCaisseArreteCaisseBaseModel';
  IdArreteCaisse?: number;
};

export type ArreteCaisseArreteCaisseBaseModelInput = {
  IdArreteCaisse?: number;
};

export type ArreteCaisseArreteCaisseModel = {
  __typename?: 'ArreteCaisseArreteCaisseModel';
  DateCreation?: any;
  DateModification?: any;
  IdArreteCaisse?: number;
  IdUserCreation?: number;
  IdUserModification?: number;
  ListeMoyensPaiement?: ArrayOfArreteCaisseRecapitulatifMoyenPaiementModel;
  NomUserCreation?: string;
  NomUserModification?: string;
};

export type ArreteCaisseArreteCaisseModelInput = {
  DateCreation?: any;
  DateModification?: any;
  IdArreteCaisse?: number;
  IdUserCreation?: number;
  IdUserModification?: number;
  ListeMoyensPaiement?: ArrayOfArreteCaisseRecapitulatifMoyenPaiementModelInput;
  NomUserCreation?: string;
  NomUserModification?: string;
};

export type ArreteCaisseArreteCaissePostRafraichissementModel = {
  __typename?: 'ArreteCaisseArreteCaissePostRafraichissementModel';
  DateCreation?: any;
  DateModification?: any;
  IdArreteCaisse?: number;
  IdUserCreation?: number;
  IdUserModification?: number;
  ListeMoyensPaiement?: ArrayOfArreteCaisseRecapitulatifMoyenPaiementModel;
  ListeMoyensPaiementChanges?: ArrayOfdecimal;
  NomUserCreation?: string;
  NomUserModification?: string;
};

export type ArreteCaisseArreteCaissePostRafraichissementModelInput = {
  DateCreation?: any;
  DateModification?: any;
  IdArreteCaisse?: number;
  IdUserCreation?: number;
  IdUserModification?: number;
  ListeMoyensPaiement?: ArrayOfArreteCaisseRecapitulatifMoyenPaiementModelInput;
  ListeMoyensPaiementChanges?: ArrayOfdecimalInput;
  NomUserCreation?: string;
  NomUserModification?: string;
};

export type ArreteCaisseCriteresLigneArreteCaisseModelInput = {
  IdArreteCaisse?: number;
  IdLigneArreteCaisse?: number;
  IdMoyenPaiement?: number;
  IsOrpheline?: boolean;
  Skip?: number;
  Take?: number;
};

export type ArreteCaisseInfosPopupPaiementFiduciaireModel = {
  __typename?: 'ArreteCaisseInfosPopupPaiementFiduciaireModel';
  DateMaximum?: any;
  DateMinimum?: any;
  DernierMontantArrete?: number;
  IdArreteCaisse?: number;
  IdLigne?: number;
  IdMoyenPaiement?: number;
  IsValide?: boolean;
  LibelleLigne?: string;
  ListeMouvementsComptable?: ArrayOfMouvementComptableInfosGeneralesModel;
  MontantAttendu?: number;
  MontantConstate?: number;
};

export type ArreteCaisseInfosPopupPaiementFiduciaireModelInput = {
  DateMaximum?: any;
  DateMinimum?: any;
  DernierMontantArrete?: number;
  IdArreteCaisse?: number;
  IdLigne?: number;
  IdMoyenPaiement?: number;
  IsValide?: boolean;
  LibelleLigne?: string;
  ListeMouvementsComptable?: ArrayOfMouvementComptableInfosGeneralesModelInput;
  MontantAttendu?: number;
  MontantConstate?: number;
};

export type ArreteCaisseLigneArreteCaisseBaseModelInput = {
  IdLigne?: number;
  LibelleLigne?: string;
};

export type ArreteCaisseLigneArreteCaisseCommunModel = {
  __typename?: 'ArreteCaisseLigneArreteCaisseCommunModel';
  IdArreteCaisse?: number;
  IdLigne?: number;
  IdMoyenPaiement?: number;
  IsValide?: boolean;
  LibelleLigne?: string;
  MontantConstate?: number;
};

export type ArreteCaisseLigneArreteCaisseCommunModelInput = {
  IdArreteCaisse?: number;
  IdLigne?: number;
  IdMoyenPaiement?: number;
  IsValide?: boolean;
  LibelleLigne?: string;
  MontantConstate?: number;
};

export type ArreteCaisseLigneArreteCaisseEtatModelInput = {
  IdLigne?: number;
  IsValide?: boolean;
  LibelleLigne?: string;
  Montant?: number;
};

export type ArreteCaisseLigneArreteCaisseFiduModel = {
  __typename?: 'ArreteCaisseLigneArreteCaisseFiduModel';
  DateMaximum?: any;
  DateMinimum?: any;
  DernierMontantArrete?: number;
  IdArreteCaisse?: number;
  IdLigne?: number;
  IdMoyenPaiement?: number;
  IsValide?: boolean;
  LibelleLigne?: string;
  MontantAttendu?: number;
  MontantConstate?: number;
};

export type ArreteCaisseLigneArreteCaisseFiduModelInput = {
  DateMaximum?: any;
  DateMinimum?: any;
  DernierMontantArrete?: number;
  IdArreteCaisse?: number;
  IdLigne?: number;
  IdMoyenPaiement?: number;
  IsValide?: boolean;
  LibelleLigne?: string;
  MontantAttendu?: number;
  MontantConstate?: number;
};

export type ArreteCaisseLigneArreteCaisseNonFiduModel = {
  __typename?: 'ArreteCaisseLigneArreteCaisseNonFiduModel';
  DateMouvement?: any;
  IdArreteCaisse?: number;
  IdLigne?: number;
  IdMoyenPaiement?: number;
  IsValide?: boolean;
  LibelleLigne?: string;
  MontantAttendu?: number;
  MontantConstate?: number;
  NomBeneficiaire?: string;
  NumeroReference?: string;
};

export type ArreteCaisseLigneArreteCaisseNonFiduModelInput = {
  DateMouvement?: any;
  IdArreteCaisse?: number;
  IdLigne?: number;
  IdMoyenPaiement?: number;
  IsValide?: boolean;
  LibelleLigne?: string;
  MontantAttendu?: number;
  MontantConstate?: number;
  NomBeneficiaire?: string;
  NumeroReference?: string;
};

export type ArreteCaisseListeFiltresArreteCaisseModel = {
  __typename?: 'ArreteCaisseListeFiltresArreteCaisseModel';
  CaisseSelectionnee?: CaisseCaisseBaseModel;
  ListeCaissesDisponibles?: ArrayOfCaisseCaisseBaseModel;
  ListeMoyensPaiement?: ArrayOfMoyenPaiementMoyenPaiementSelectionableModel;
};

export type ArreteCaisseListeFiltresArreteCaisseModelInput = {
  CaisseSelectionnee?: CaisseCaisseBaseModelInput;
  ListeCaissesDisponibles?: ArrayOfCaisseCaisseBaseModelInput;
  ListeMoyensPaiement?: ArrayOfMoyenPaiementMoyenPaiementSelectionableModelInput;
};

export type ArreteCaisseListeLignesArreteCaisseNonFidu = {
  __typename?: 'ArreteCaisseListeLignesArreteCaisseNonFidu';
  Count?: number;
  ListeLignes?: ArrayOfArreteCaisseLigneArreteCaisseNonFiduModel;
  MontantAttendu?: number;
  MontantConstate?: number;
};

export type ArreteCaisseListeLignesArreteCaisseNonFiduInput = {
  Count?: number;
  ListeLignes?: ArrayOfArreteCaisseLigneArreteCaisseNonFiduModelInput;
  MontantAttendu?: number;
  MontantConstate?: number;
};

export type ArreteCaisseMoyenPaiementEtatModelInput = {
  IdMoyenPaiement?: number;
  IsValide?: boolean;
};

export type ArreteCaisseRecapitulatifMoyenPaiementModel = {
  __typename?: 'ArreteCaisseRecapitulatifMoyenPaiementModel';
  IdElement?: number;
  IdMoyenPaiement?: number;
  IsContexteRemiseCaisse?: boolean;
  IsFiduciaire?: boolean;
  IsValide?: boolean;
  LibelleMoyenPaiement?: string;
  LignesChangees?: boolean;
  MontantAttendu?: number;
  MontantConstate?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ArreteCaisseRecapitulatifMoyenPaiementModelInput = {
  IdElement?: number;
  IdMoyenPaiement?: number;
  IsContexteRemiseCaisse?: boolean;
  IsFiduciaire?: boolean;
  IsValide?: boolean;
  LibelleMoyenPaiement?: string;
  LignesChangees?: boolean;
  MontantAttendu?: number;
  MontantConstate?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ArreteCaisseSaveArreteCaisseModelInput = {
  IdArreteCaisse?: number;
  ListeLignesArreteCaisse?: ArrayOfArreteCaisseLigneArreteCaisseEtatModelInput;
  ListeMoyensPaiement?: ArrayOfArreteCaisseMoyenPaiementEtatModelInput;
};

export type ArreteEtRemiseCaisseListerModel = {
  __typename?: 'ArreteEtRemiseCaisseListerModel';
  DateArrete?: any;
  IdArreteCaisse?: number;
  IdCaisse?: number;
  IdCaisseSource?: number;
  IdRemiseEnCaisseCentrale?: number;
  IsAValider?: boolean;
  IsAnnule?: boolean;
  IsLastForCaisse?: boolean;
  IsValide?: boolean;
  LibelleCaisse?: string;
  NomUtilisateur?: string;
  PrenomUtilisateur?: string;
  TotalAttendu?: number;
  TotalConstate?: number;
};

export type ArreteEtRemiseCaisseListerModelInput = {
  DateArrete?: any;
  IdArreteCaisse?: number;
  IdCaisse?: number;
  IdCaisseSource?: number;
  IdRemiseEnCaisseCentrale?: number;
  IsAValider?: boolean;
  IsAnnule?: boolean;
  IsLastForCaisse?: boolean;
  IsValide?: boolean;
  LibelleCaisse?: string;
  NomUtilisateur?: string;
  PrenomUtilisateur?: string;
  TotalAttendu?: number;
  TotalConstate?: number;
};

export type ArticleActiviteBaseModel = {
  __typename?: 'ArticleActiviteBaseModel';
  CodeActivite?: string;
  IdActivite?: number;
  IdArticle?: number;
  IdFamille?: number;
  IdProduit?: number;
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  PrixArticle?: number;
  ReferenceArticle?: string;
};

export type ArticleActiviteBaseModelInput = {
  CodeActivite?: string;
  IdActivite?: number;
  IdArticle?: number;
  IdFamille?: number;
  IdProduit?: number;
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  PrixArticle?: number;
  ReferenceArticle?: string;
};

export type ArticleAssocieEpargneModel = {
  __typename?: 'ArticleAssocieEpargneModel';
  IdArticle?: number;
  IdArticleAssocie?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ArticleAssocieEpargneModelInput = {
  IdArticle?: number;
  IdArticleAssocie?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ArticleAttributionAuto = {
  __typename?: 'ArticleAttributionAuto';
  Id?: number;
  IdProduit?: number;
  IsOption?: boolean;
  IsQuantitesurProduit?: boolean;
  Libelle?: string;
  LibelleProduit?: string;
  NbOptions?: number;
  NbReservationsValidees?: number;
  NbTotalDispo?: number;
  NbTotalReservation?: number;
};

export type ArticleAttributionAutoInput = {
  Id?: number;
  IdProduit?: number;
  IsOption?: boolean;
  IsQuantitesurProduit?: boolean;
  Libelle?: string;
  LibelleProduit?: string;
  NbOptions?: number;
  NbReservationsValidees?: number;
  NbTotalDispo?: number;
  NbTotalReservation?: number;
};

export type ArticleChequierBorneModel = {
  __typename?: 'ArticleChequierBorneModel';
  CompositionChequier?: ArrayOfanyType;
  IdArticle?: number;
  IdArticleCheque?: number;
  IdBorne?: number;
  IdCheque?: number;
  IsDefaultComposition?: boolean;
  IsDeleted?: boolean;
  MontantMax?: number;
  MontantMin?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ArticleChequierBorneModelInput = {
  CompositionChequier?: ArrayOfanyTypeInput;
  IdArticle?: number;
  IdArticleCheque?: number;
  IdBorne?: number;
  IdCheque?: number;
  IsDefaultComposition?: boolean;
  IsDeleted?: boolean;
  MontantMax?: number;
  MontantMin?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ArticleChequierDto = {
  __typename?: 'ArticleChequierDTO';
  Article?: ArticleDto;
  Chequier?: ChequierDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Nombre?: number;
  Status?: StatusDtoEnum;
};

export type ArticleChequierDtoInput = {
  Article?: ArticleDtoInput;
  Chequier?: ChequierDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Nombre?: number;
  Status?: StatusDtoEnum;
};

export type ArticleChequierModel = {
  __typename?: 'ArticleChequierModel';
  IdArticle?: number;
  IdArticleCheque?: number;
  IdCheque?: number;
  NombreCheques?: number;
  ValeurFacialeCheque?: number;
};

export type ArticleChequierModelInput = {
  IdArticle?: number;
  IdArticleCheque?: number;
  IdCheque?: number;
  NombreCheques?: number;
  ValeurFacialeCheque?: number;
};

export type ArticleClotureModel = {
  __typename?: 'ArticleClotureModel';
  IdArticle?: number;
  IsCloture?: boolean;
  LibelleArticle?: string;
};

export type ArticleClotureModelInput = {
  IdArticle?: number;
  IsCloture?: boolean;
  LibelleArticle?: string;
};

export type ArticleCompteurPointDto = {
  __typename?: 'ArticleCompteurPointDTO';
  Article?: ArticleDto;
  CompteurPoint?: CompteurPointDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: number;
};

export type ArticleCompteurPointDtoInput = {
  Article?: ArticleDtoInput;
  CompteurPoint?: CompteurPointDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: number;
};

export type ArticleDto = {
  __typename?: 'ArticleDTO';
  AfficherDirecto?: boolean;
  AnneeRef?: AnneeReferenceDto;
  ArticlePrixVente?: ArticlePrixVenteDto;
  ArticleSeCommandeSeul?: boolean;
  AutoriseCommEnLigne?: boolean;
  Champ?: ChampDto;
  ChampValeur?: ChampValeurDto;
  Code?: string;
  CodeBarreReference?: string;
  Cpt512?: CompteDto;
  CptAchat?: CompteDto;
  CptCollectifClient?: CompteDto;
  CptCollectifFournisseur?: CompteDto;
  CptValidationStock?: CompteDto;
  CptVariationStock?: CompteDto;
  CptVente?: CompteDto;
  DateCotisationDebut?: any;
  DateCotisationFin?: any;
  DateDebutLocation?: any;
  DateDebutVente?: any;
  DateDebutVisibilite?: any;
  DateEvenement?: any;
  DateFinLocation?: any;
  DateFinVente?: any;
  DateFinVisibilite?: any;
  DateLimiteDispo?: any;
  DateSubvention?: any;
  DelaiLivraison?: number;
  Description?: string;
  Enveloppe?: EnveloppeQuotaDto;
  Exercice?: ExerciceDto;
  Fournisseur?: FournisseurDto;
  Id?: number;
  IdModeEnvoiANCV?: number;
  IdModeleTVA?: number;
  IsANCVConnect?: boolean;
  IsArticleGeneriqueDispoEnLigne?: boolean;
  IsArticleReappro?: boolean;
  IsCalculSubventionPossible?: boolean;
  IsChequierDynamique?: boolean;
  IsCloture?: boolean;
  IsDepassementAutorise?: boolean;
  IsECesu?: boolean;
  IsGenerique?: boolean;
  IsGroupe?: boolean;
  IsMDK?: boolean;
  IsNominatif?: boolean;
  IsOptionGroupe?: boolean;
  IsOptionLocation?: boolean;
  IsOptionObligatoire?: boolean;
  IsSaisieParticipants?: boolean;
  IsUniqueParCommande?: boolean;
  IsVirtuelGroupe?: boolean;
  Libelle?: string;
  LibelleUniteFormulePrestaNbUnite?: string;
  LibelleUniteTotalFormulePresta?: string;
  Lieu?: LieuDto;
  ListArticleStock?: ArrayOfStockArticleDto;
  ListeArticleChequier?: ArrayOfArticleChequierDto;
  ListeArticleChequierBorneNA?: ArrayOfArticleChequierBorneModel;
  ListeArticleChequierNA?: ArrayOfArticleChequierModel;
  ListeArticleCompteurPoint?: ArrayOfArticleCompteurPointDto;
  ListeArticleFournisseur?: ArrayOfArticleFournisseurDto;
  ListeArticleMouvement?: ArrayOfMouvementStockDto;
  ListeArticlePrixVente?: ArrayOfArticlePrixVenteDto;
  ListeArticleSectionAnalytique?: ArrayOfArticleSectionAnalytiqueDto;
  ListeChamps?: ArrayOfChampDto;
  ListeChampsValeur?: ArrayOfChampValeurDto;
  ListeCompteursPoints?: ArrayOfCompteurPointAfpaModel;
  ListeEnvImpArticle?: ArrayOfEnvImpArticleDto;
  ListeLigneCommande?: ArrayOfLigneCommandeDto;
  ListeModeLivraison?: ArrayOfArticleModeLivraisonDto;
  ListeMoteurRegleUseArticle?: ArrayOfMoteurRegleUseArticleDto;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementDto;
  ListePieceJustificative?: ArrayOfPjDemArticleDto;
  ModeAvanceCadeau?: boolean;
  ModeEnvoiANCV?: AncvModeEnvoiDto;
  ModeRemboursementFormulePresta?: string;
  ModeleFraisAnnulation?: FraisAnnulationFpaModel;
  MontantMaxFacture?: number;
  MontantSubvention?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbOptions?: number;
  NbPlaceDispo?: number;
  Picto?: FichierModel;
  PourcentageSubvention?: number;
  PrestaLibelleDateEvenement?: string;
  PrixPublic?: number;
  Produit?: ProduitDto;
  QteMinimum?: number;
  Quotite?: number;
  Remarque?: string;
  SessionChoix?: SessionChoixDto;
  Status?: StatusDtoEnum;
  TypeComportementArticle?: string;
  TypeEtat?: ChampValeurDto;
};

export type ArticleDtoInput = {
  AfficherDirecto?: boolean;
  AnneeRef?: AnneeReferenceDtoInput;
  ArticlePrixVente?: ArticlePrixVenteDtoInput;
  ArticleSeCommandeSeul?: boolean;
  AutoriseCommEnLigne?: boolean;
  Champ?: ChampDtoInput;
  ChampValeur?: ChampValeurDtoInput;
  Code?: string;
  CodeBarreReference?: string;
  Cpt512?: CompteDtoInput;
  CptAchat?: CompteDtoInput;
  CptCollectifClient?: CompteDtoInput;
  CptCollectifFournisseur?: CompteDtoInput;
  CptValidationStock?: CompteDtoInput;
  CptVariationStock?: CompteDtoInput;
  CptVente?: CompteDtoInput;
  DateCotisationDebut?: any;
  DateCotisationFin?: any;
  DateDebutLocation?: any;
  DateDebutVente?: any;
  DateDebutVisibilite?: any;
  DateEvenement?: any;
  DateFinLocation?: any;
  DateFinVente?: any;
  DateFinVisibilite?: any;
  DateLimiteDispo?: any;
  DateSubvention?: any;
  DelaiLivraison?: number;
  Description?: string;
  Enveloppe?: EnveloppeQuotaDtoInput;
  Exercice?: ExerciceDtoInput;
  Fournisseur?: FournisseurDtoInput;
  Id?: number;
  IdModeEnvoiANCV?: number;
  IdModeleTVA?: number;
  IsANCVConnect?: boolean;
  IsArticleGeneriqueDispoEnLigne?: boolean;
  IsArticleReappro?: boolean;
  IsCalculSubventionPossible?: boolean;
  IsChequierDynamique?: boolean;
  IsCloture?: boolean;
  IsDepassementAutorise?: boolean;
  IsECesu?: boolean;
  IsGenerique?: boolean;
  IsGroupe?: boolean;
  IsMDK?: boolean;
  IsNominatif?: boolean;
  IsOptionGroupe?: boolean;
  IsOptionLocation?: boolean;
  IsOptionObligatoire?: boolean;
  IsSaisieParticipants?: boolean;
  IsUniqueParCommande?: boolean;
  IsVirtuelGroupe?: boolean;
  Libelle?: string;
  LibelleUniteFormulePrestaNbUnite?: string;
  LibelleUniteTotalFormulePresta?: string;
  Lieu?: LieuDtoInput;
  ListArticleStock?: ArrayOfStockArticleDtoInput;
  ListeArticleChequier?: ArrayOfArticleChequierDtoInput;
  ListeArticleChequierBorneNA?: ArrayOfArticleChequierBorneModelInput;
  ListeArticleChequierNA?: ArrayOfArticleChequierModelInput;
  ListeArticleCompteurPoint?: ArrayOfArticleCompteurPointDtoInput;
  ListeArticleFournisseur?: ArrayOfArticleFournisseurDtoInput;
  ListeArticleMouvement?: ArrayOfMouvementStockDtoInput;
  ListeArticlePrixVente?: ArrayOfArticlePrixVenteDtoInput;
  ListeArticleSectionAnalytique?: ArrayOfArticleSectionAnalytiqueDtoInput;
  ListeChamps?: ArrayOfChampDtoInput;
  ListeChampsValeur?: ArrayOfChampValeurDtoInput;
  ListeCompteursPoints?: ArrayOfCompteurPointAfpaModelInput;
  ListeEnvImpArticle?: ArrayOfEnvImpArticleDtoInput;
  ListeLigneCommande?: ArrayOfLigneCommandeDtoInput;
  ListeModeLivraison?: ArrayOfArticleModeLivraisonDtoInput;
  ListeMoteurRegleUseArticle?: ArrayOfMoteurRegleUseArticleDtoInput;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementDtoInput;
  ListePieceJustificative?: ArrayOfPjDemArticleDtoInput;
  ModeAvanceCadeau?: boolean;
  ModeEnvoiANCV?: AncvModeEnvoiDtoInput;
  ModeRemboursementFormulePresta?: string;
  ModeleFraisAnnulation?: FraisAnnulationFpaModelInput;
  MontantMaxFacture?: number;
  MontantSubvention?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbOptions?: number;
  NbPlaceDispo?: number;
  Picto?: FichierModelInput;
  PourcentageSubvention?: number;
  PrestaLibelleDateEvenement?: string;
  PrixPublic?: number;
  Produit?: ProduitDtoInput;
  QteMinimum?: number;
  Quotite?: number;
  Remarque?: string;
  SessionChoix?: SessionChoixDtoInput;
  Status?: StatusDtoEnum;
  TypeComportementArticle?: string;
  TypeEtat?: ChampValeurDtoInput;
};

export type ArticleDateLocationModelInput = {
  DateDebutLoc?: any;
  DateFinLoc?: any;
  IdArticle?: number;
  IdProduit?: number;
  LibelleArticle?: string;
};

export type ArticleEditorialWithStatutModel = {
  __typename?: 'ArticleEditorialWithStatutModel';
  DateCreation?: any;
  Id?: number;
  StatutCode?: string;
  StatutLibelle?: string;
  Titre?: string;
};

export type ArticleEditorialWithStatutModelInput = {
  DateCreation?: any;
  Id?: number;
  StatutCode?: string;
  StatutLibelle?: string;
  Titre?: string;
};

export type ArticleEditorielLightModel = {
  __typename?: 'ArticleEditorielLightModel';
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
};

export type ArticleEditorielLightModelInput = {
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
};

export type ArticleEditorielPortletModel = {
  __typename?: 'ArticleEditorielPortletModel';
  Id?: number;
  IdCategorie?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Titre?: string;
};

export type ArticleEditorielPortletModelInput = {
  Id?: number;
  IdCategorie?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Titre?: string;
};

export type ArticleFournisseurDto = {
  __typename?: 'ArticleFournisseurDTO';
  Article?: ArticleDto;
  DateDebut?: any;
  DateFin?: any;
  Fournisseur?: FournisseurDto;
  Id?: number;
  IsActual?: boolean;
  IsCloture?: boolean;
  IsRemiseArticleCumulableRemiseFo?: boolean;
  ListArticlePrixVente?: ArrayOfArticlePrixVenteDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixAchat?: number;
  PrixAchatRemise?: number;
  PrixArticleADate?: number;
  QuantiteMinimumCommande?: number;
  ReferenceFournisseur?: string;
  Remarque?: string;
  Remise?: number;
  Status?: StatusDtoEnum;
};

export type ArticleFournisseurDtoInput = {
  Article?: ArticleDtoInput;
  DateDebut?: any;
  DateFin?: any;
  Fournisseur?: FournisseurDtoInput;
  Id?: number;
  IsActual?: boolean;
  IsCloture?: boolean;
  IsRemiseArticleCumulableRemiseFo?: boolean;
  ListArticlePrixVente?: ArrayOfArticlePrixVenteDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixAchat?: number;
  PrixAchatRemise?: number;
  PrixArticleADate?: number;
  QuantiteMinimumCommande?: number;
  ReferenceFournisseur?: string;
  Remarque?: string;
  Remise?: number;
  Status?: StatusDtoEnum;
};

export type ArticleFournisseurFpaPrixRemiseModel = {
  __typename?: 'ArticleFournisseurFpaPrixRemiseModel';
  DateAchatDebut?: any;
  DateAchatFin?: any;
  Id?: number;
  IdActivite?: number;
  IdArticle?: number;
  IdFamille?: number;
  IdFournisseur?: number;
  IdProduit?: number;
  IsRemisesCumulables?: boolean;
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  Prix?: number;
  PrixRemise?: number;
  ReferenceFournisseur?: string;
  RemiseArticle?: number;
  RemiseFournisseur?: number;
  ValeurFaciale?: number;
};

export type ArticleFournisseurFpaPrixRemiseModelInput = {
  DateAchatDebut?: any;
  DateAchatFin?: any;
  Id?: number;
  IdActivite?: number;
  IdArticle?: number;
  IdFamille?: number;
  IdFournisseur?: number;
  IdProduit?: number;
  IsRemisesCumulables?: boolean;
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  Prix?: number;
  PrixRemise?: number;
  ReferenceFournisseur?: string;
  RemiseArticle?: number;
  RemiseFournisseur?: number;
  ValeurFaciale?: number;
};

export type ArticleImputationEnErreurModel = {
  __typename?: 'ArticleImputationEnErreurModel';
  IdActivite?: number;
  IdArticle?: number;
  IdDelegation?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsBloquantComptesStock?: boolean;
  IsBloquantRepartitionAnalytique?: boolean;
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomDelegation?: string;
  NumeroCompteAchat?: string;
  NumeroCompteValorisation?: string;
  NumeroCompteVariation?: string;
  NumeroCompteVente?: string;
  Status?: StatusDtoEnum;
};

export type ArticleImputationEnErreurModelInput = {
  IdActivite?: number;
  IdArticle?: number;
  IdDelegation?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsBloquantComptesStock?: boolean;
  IsBloquantRepartitionAnalytique?: boolean;
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomDelegation?: string;
  NumeroCompteAchat?: string;
  NumeroCompteValorisation?: string;
  NumeroCompteVariation?: string;
  NumeroCompteVente?: string;
  Status?: StatusDtoEnum;
};

export type ArticleInformationsBaseModel = {
  __typename?: 'ArticleInformationsBaseModel';
  CodeArticle?: string;
  CodeBarre?: string;
  Description?: string;
  IdArticle?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Quotite?: number;
  RemarqueArticle?: string;
  Status?: StatusDtoEnum;
};

export type ArticleInformationsBaseModelInput = {
  CodeArticle?: string;
  CodeBarre?: string;
  Description?: string;
  IdArticle?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Quotite?: number;
  RemarqueArticle?: string;
  Status?: StatusDtoEnum;
};

export type ArticleLightModel = {
  __typename?: 'ArticleLightModel';
  IdArticle?: number;
  Libelle?: string;
};

export type ArticleLightModelInput = {
  IdArticle?: number;
  Libelle?: string;
};

export type ArticleLigneAvoirModelDto = {
  __typename?: 'ArticleLigneAvoirModelDTO';
  IdArticle?: number;
  IdCompteAchat?: number;
  IdCompteVente?: number;
  LibelleProduitArticle?: string;
  ListeArticleSectionAnalytique?: ArrayOfSectionAnalytiqueModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixAchatRemise?: number;
  Status?: StatusDtoEnum;
};

export type ArticleLigneAvoirModelDtoInput = {
  IdArticle?: number;
  IdCompteAchat?: number;
  IdCompteVente?: number;
  LibelleProduitArticle?: string;
  ListeArticleSectionAnalytique?: ArrayOfSectionAnalytiqueModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixAchatRemise?: number;
  Status?: StatusDtoEnum;
};

export type ArticleLocationModel = {
  __typename?: 'ArticleLocationModel';
  Category?: string;
  DateDebutLocation?: any;
  DateFinLocation?: any;
  IdArticle?: number;
  Info?: string;
  NameArticle?: string;
  NameProduit?: string;
};

export type ArticleLocationModelInput = {
  Category?: string;
  DateDebutLocation?: any;
  DateFinLocation?: any;
  IdArticle?: number;
  Info?: string;
  NameArticle?: string;
  NameProduit?: string;
};

export type ArticleMagazineModel = {
  __typename?: 'ArticleMagazineModel';
  CanLike?: boolean;
  Contenu?: string;
  Id?: string;
  ListeFormatImageAttachee?: ArrayOfKeyValueOfstringstring;
  ListeFormatImageMiseEnAvant?: ArrayOfKeyValueOfstringstring;
  Mode?: string;
  NombreLikes?: number;
  Summary?: string;
  Titre?: string;
};

export type ArticleMagazineModelInput = {
  CanLike?: boolean;
  Contenu?: string;
  Id?: string;
  ListeFormatImageAttachee?: ArrayOfKeyValueOfstringstringInput;
  ListeFormatImageMiseEnAvant?: ArrayOfKeyValueOfstringstringInput;
  Mode?: string;
  NombreLikes?: number;
  Summary?: string;
  Titre?: string;
};

export type ArticleModeLivraisonDto = {
  __typename?: 'ArticleModeLivraisonDTO';
  Article?: ArticleDto;
  IsDefaut?: boolean;
  ModeLivraison?: ModeLivraisonDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ArticleModeLivraisonDtoInput = {
  Article?: ArticleDtoInput;
  IsDefaut?: boolean;
  ModeLivraison?: ModeLivraisonDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ArticleModel = {
  __typename?: 'ArticleModel';
  ID?: number;
  IdParent?: number;
  IsCloture?: boolean;
  Libelle?: string;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ArticleModelDto = {
  __typename?: 'ArticleModelDTO';
  CodeArticle?: string;
  CodeProduit?: string;
  IdArticle?: number;
  IsArticleReappo?: boolean;
  IsGenerique?: boolean;
  IsGestionStock?: boolean;
  IsRemiseCumulable?: boolean;
  LibelleArticle?: string;
  LibelleProduit?: string;
  LibellleFamille?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Picto?: PictoDto;
  Prix?: number;
  PrixRemise?: number;
  Qte?: number;
  QuantiteDisponible?: number;
  RefFour?: string;
  RemiseGlobalFour?: number;
  RemiseUnitaireArticle?: number;
  Status?: StatusDtoEnum;
};

export type ArticleModelDtoInput = {
  CodeArticle?: string;
  CodeProduit?: string;
  IdArticle?: number;
  IsArticleReappo?: boolean;
  IsGenerique?: boolean;
  IsGestionStock?: boolean;
  IsRemiseCumulable?: boolean;
  LibelleArticle?: string;
  LibelleProduit?: string;
  LibellleFamille?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Picto?: PictoDtoInput;
  Prix?: number;
  PrixRemise?: number;
  Qte?: number;
  QuantiteDisponible?: number;
  RefFour?: string;
  RemiseGlobalFour?: number;
  RemiseUnitaireArticle?: number;
  Status?: StatusDtoEnum;
};

export type ArticleModelInput = {
  ID?: number;
  IdParent?: number;
  IsCloture?: boolean;
  Libelle?: string;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ArticleModeleEpargneModel = {
  __typename?: 'ArticleModeleEpargneModel';
  CanBeReglementComptant?: boolean;
  IdArticle?: number;
  IdModeleEcheancier?: number;
  IdMoyenPaiement?: number;
  IsCloture?: boolean;
  LibelleArticle?: string;
};

export type ArticleModeleEpargneModelInput = {
  CanBeReglementComptant?: boolean;
  IdArticle?: number;
  IdModeleEcheancier?: number;
  IdMoyenPaiement?: number;
  IsCloture?: boolean;
  LibelleArticle?: string;
};

export type ArticleMoyenPaiementModel = {
  __typename?: 'ArticleMoyenPaiementModel';
  IdArticle?: number;
  IdMoyenPaiement?: number;
  IsDefaut?: boolean;
  IsEnLigne?: boolean;
  LibelleMoyenPaiement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ArticleMoyenPaiementModelInput = {
  IdArticle?: number;
  IdMoyenPaiement?: number;
  IsDefaut?: boolean;
  IsEnLigne?: boolean;
  LibelleMoyenPaiement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ArticlePrixVenteDto = {
  __typename?: 'ArticlePrixVenteDTO';
  Article?: ArticleDto;
  DateDebut?: any;
  DateFin?: any;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixVente?: number;
  Status?: StatusDtoEnum;
};

export type ArticlePrixVenteDtoInput = {
  Article?: ArticleDtoInput;
  DateDebut?: any;
  DateFin?: any;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixVente?: number;
  Status?: StatusDtoEnum;
};

export type ArticleSectionAnalytiqueDto = {
  __typename?: 'ArticleSectionAnalytiqueDTO';
  Article?: ArticleDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueDto;
  Pourcentage?: number;
  SectionAnalytique?: SectionAnalytiqueDto;
  Status?: StatusDtoEnum;
};

export type ArticleSectionAnalytiqueDtoInput = {
  Article?: ArticleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueDtoInput;
  Pourcentage?: number;
  SectionAnalytique?: SectionAnalytiqueDtoInput;
  Status?: StatusDtoEnum;
};

export enum ArticleUpKonnectStatutEnum {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published'
}

export type ArticleVenteModeleDto = {
  __typename?: 'ArticleVenteModeleDTO';
  CapaciteMax?: number;
  CapaciteMin?: number;
  CodeArticle?: string;
  CodeBarreArticle?: string;
  CodeFonctionnementProduit?: string;
  CodeProduit?: string;
  DateDebutLocation?: any;
  DateFinLocation?: any;
  DateReapproFamille?: any;
  DateReapproProduit?: any;
  HaveFormulaireSurLigne?: boolean;
  IdArticle?: number;
  IdCourrier?: number;
  IdProduit?: number;
  IsArticleLoc?: boolean;
  IsArticleReappo?: boolean;
  IsArticleUniqueParCommande?: boolean;
  IsArticleUnitaire?: boolean;
  IsChequierDynamique?: boolean;
  IsChequierDynamiqueConnect?: boolean;
  IsContexteBilletterie?: boolean;
  IsContexteLocation?: boolean;
  IsGenerique?: boolean;
  IsGererParticipant?: boolean;
  IsNominatif?: boolean;
  IsNotGereEnStock?: boolean;
  IsObligatoireLocation?: boolean;
  IsOptionLocation?: boolean;
  IsPictoUser?: boolean;
  IsProduitSeCommandeSeule?: boolean;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  LibelleQuantiteDisponible?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Picto?: PictoDto;
  PrixVenteActuel?: number;
  Quantite?: number;
  QuantiteAttenteValidation?: number;
  QuantiteDisponible?: number;
  QuantiteDisponibleRecherche?: number;
  QuantiteMinimum?: number;
  QuantiteRecherche?: number;
  SessionChoix?: number;
  Status?: StatusDtoEnum;
  TypeComportement?: string;
  UrlPicto?: string;
};

export type ArticleVenteModeleDtoInput = {
  CapaciteMax?: number;
  CapaciteMin?: number;
  CodeArticle?: string;
  CodeBarreArticle?: string;
  CodeFonctionnementProduit?: string;
  CodeProduit?: string;
  DateDebutLocation?: any;
  DateFinLocation?: any;
  DateReapproFamille?: any;
  DateReapproProduit?: any;
  HaveFormulaireSurLigne?: boolean;
  IdArticle?: number;
  IdCourrier?: number;
  IdProduit?: number;
  IsArticleLoc?: boolean;
  IsArticleReappo?: boolean;
  IsArticleUniqueParCommande?: boolean;
  IsArticleUnitaire?: boolean;
  IsChequierDynamique?: boolean;
  IsChequierDynamiqueConnect?: boolean;
  IsContexteBilletterie?: boolean;
  IsContexteLocation?: boolean;
  IsGenerique?: boolean;
  IsGererParticipant?: boolean;
  IsNominatif?: boolean;
  IsNotGereEnStock?: boolean;
  IsObligatoireLocation?: boolean;
  IsOptionLocation?: boolean;
  IsPictoUser?: boolean;
  IsProduitSeCommandeSeule?: boolean;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  LibelleQuantiteDisponible?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Picto?: PictoDtoInput;
  PrixVenteActuel?: number;
  Quantite?: number;
  QuantiteAttenteValidation?: number;
  QuantiteDisponible?: number;
  QuantiteDisponibleRecherche?: number;
  QuantiteMinimum?: number;
  QuantiteRecherche?: number;
  SessionChoix?: number;
  Status?: StatusDtoEnum;
  TypeComportement?: string;
  UrlPicto?: string;
};

export type ArticleWithFamilleEtActiviteModel = {
  __typename?: 'ArticleWithFamilleEtActiviteModel';
  CodeArticle?: string;
  IdActivite?: number;
  IdArticle?: number;
  IdDelegationActivite?: number;
  IdFamille?: number;
  Libelle?: string;
};

export type ArticleWithFamilleEtActiviteModelInput = {
  CodeArticle?: string;
  IdActivite?: number;
  IdArticle?: number;
  IdDelegationActivite?: number;
  IdFamille?: number;
  Libelle?: string;
};

export type ArticleWithProduitModel = {
  __typename?: 'ArticleWithProduitModel';
  IdArticle?: number;
  IdProduit?: number;
  LibelleArticle?: string;
  LibelleProduit?: string;
};

export type ArticleWithProduitModelInput = {
  IdArticle?: number;
  IdProduit?: number;
  LibelleArticle?: string;
  LibelleProduit?: string;
};

export type ArticlesHistoriquePrixAchatArticleInput = {
  CommentairePrix?: string;
  DateDebutPrix?: any;
  DateFinPrix?: any;
  IdArticle?: number;
  IdArticleFournisseur?: number;
  IdFournisseur?: number;
  IsDeleted?: boolean;
  IsRemiseCumulee?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomFournisseur?: string;
  Prix?: number;
  PrixPublic?: number;
  QuantiteMinimumArticle?: number;
  ReferencePrix?: string;
  RemiseArticle?: number;
  RemiseGlobaleFournisseur?: number;
  Status?: StatusDtoEnum;
};

export type ArticlesHistoriquePrixVenteArticleInput = {
  DateDebutPrix?: any;
  DateFinPrix?: any;
  IdArticle?: number;
  IdArticlePrixVente?: number;
  IsDeleted?: boolean;
  LibelleArticle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Prix?: number;
  Status?: StatusDtoEnum;
};

export type AttributionAutoDto = {
  __typename?: 'AttributionAutoDTO';
  AnneeRef?: AnneeReferenceDto;
  AttributTri1?: AttributionTriDto;
  AttributTri2?: AttributionTriDto;
  AttributTri3?: AttributionTriDto;
  AttributTri4?: AttributionTriDto;
  CalculPointsCpt1?: CompteurPointCalculPointsDto;
  CalculPointsCpt2?: CompteurPointCalculPointsDto;
  CalculPointsCpt3?: CompteurPointCalculPointsDto;
  CalculPointsCpt4?: CompteurPointCalculPointsDto;
  CompteurPoint?: CompteurPointDto;
  CompteurPoint1?: CompteurPointDto;
  CompteurPoint2?: CompteurPointDto;
  CompteurPoint3?: CompteurPointDto;
  CritereSociauxValide?: boolean;
  DateBornMin?: any;
  DateExec?: any;
  Enveloppe?: EnveloppeQuotaDto;
  Enveloppe1?: EnveloppeQuotaDto;
  Enveloppe2?: EnveloppeQuotaDto;
  Enveloppe3?: EnveloppeQuotaDto;
  Id?: number;
  Libelle?: string;
  ListAttributionBenef?: ArrayOfAttributionBenefDto;
  ListFamille?: ArrayOfFamilleProduitDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Produit?: ProduitDto;
  Remarque?: string;
  SessionChoix?: SessionChoixDto;
  Status?: StatusDtoEnum;
};

export type AttributionAutoDtoInput = {
  AnneeRef?: AnneeReferenceDtoInput;
  AttributTri1?: AttributionTriDtoInput;
  AttributTri2?: AttributionTriDtoInput;
  AttributTri3?: AttributionTriDtoInput;
  AttributTri4?: AttributionTriDtoInput;
  CalculPointsCpt1?: CompteurPointCalculPointsDtoInput;
  CalculPointsCpt2?: CompteurPointCalculPointsDtoInput;
  CalculPointsCpt3?: CompteurPointCalculPointsDtoInput;
  CalculPointsCpt4?: CompteurPointCalculPointsDtoInput;
  CompteurPoint?: CompteurPointDtoInput;
  CompteurPoint1?: CompteurPointDtoInput;
  CompteurPoint2?: CompteurPointDtoInput;
  CompteurPoint3?: CompteurPointDtoInput;
  CritereSociauxValide?: boolean;
  DateBornMin?: any;
  DateExec?: any;
  Enveloppe?: EnveloppeQuotaDtoInput;
  Enveloppe1?: EnveloppeQuotaDtoInput;
  Enveloppe2?: EnveloppeQuotaDtoInput;
  Enveloppe3?: EnveloppeQuotaDtoInput;
  Id?: number;
  Libelle?: string;
  ListAttributionBenef?: ArrayOfAttributionBenefDtoInput;
  ListFamille?: ArrayOfFamilleProduitDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Produit?: ProduitDtoInput;
  Remarque?: string;
  SessionChoix?: SessionChoixDtoInput;
  Status?: StatusDtoEnum;
};

export type AttributionAutoModelDto = {
  __typename?: 'AttributionAutoModelDTO';
  AnneeRef?: string;
  CritAScDesc1?: string;
  CritAScDesc2?: string;
  CritAScDesc3?: string;
  CritAScDesc4?: string;
  Critere1?: string;
  Critere2?: string;
  Critere3?: string;
  Critere4?: string;
  DateAttr?: any;
  Id?: number;
  Libelle?: string;
  ListLigneAttrib?: ArrayOfLigneAttributionModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AttributionAutoModelDtoInput = {
  AnneeRef?: string;
  CritAScDesc1?: string;
  CritAScDesc2?: string;
  CritAScDesc3?: string;
  CritAScDesc4?: string;
  Critere1?: string;
  Critere2?: string;
  Critere3?: string;
  Critere4?: string;
  DateAttr?: any;
  Id?: number;
  Libelle?: string;
  ListLigneAttrib?: ArrayOfLigneAttributionModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AttributionBenefDto = {
  __typename?: 'AttributionBenefDTO';
  AttVal1?: number;
  AttVal2?: number;
  AttVal3?: number;
  AttributionAuto?: AttributionAutoDto;
  Benef?: BenefDto;
  IsAccepte?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AttributionBenefDtoInput = {
  AttVal1?: number;
  AttVal2?: number;
  AttVal3?: number;
  AttributionAuto?: AttributionAutoDtoInput;
  Benef?: BenefDtoInput;
  IsAccepte?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AttributionBenefExecModelDtoInput = {
  IdArticle?: number;
  IdBenefCible?: number;
  IdBenefOD?: number;
  IdLigneVue?: number;
  MontantAttribution?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Quantite?: number;
  Status?: StatusDtoEnum;
};

export type AttributionBenefModelDto = {
  __typename?: 'AttributionBenefModelDTO';
  CodeTypeContrat?: string;
  IdArticle?: number;
  IdBenefCible?: number;
  IdBenefOD?: number;
  IdLigneVue?: number;
  IdSiteBenef?: number;
  IdTypeContrat?: number;
  IsSelected?: boolean;
  IsSurEnveloppeSynchronisee?: boolean;
  IsSynchronise?: boolean;
  LibelleSiteBenef?: string;
  MatriculeBenefCible?: string;
  MatriculeBenefOD?: string;
  MontantAttribution?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBenefCible?: string;
  NomBenefOD?: string;
  PrenomBenefCible?: string;
  PrenomBenefOD?: string;
  Site?: KeyValueModelDto;
  Status?: StatusDtoEnum;
  TypeBenef?: string;
  TypeContrat?: KeyValueModelDto;
};

export type AttributionBenefModelDtoInput = {
  CodeTypeContrat?: string;
  IdArticle?: number;
  IdBenefCible?: number;
  IdBenefOD?: number;
  IdLigneVue?: number;
  IdSiteBenef?: number;
  IdTypeContrat?: number;
  IsSelected?: boolean;
  IsSurEnveloppeSynchronisee?: boolean;
  IsSynchronise?: boolean;
  LibelleSiteBenef?: string;
  MatriculeBenefCible?: string;
  MatriculeBenefOD?: string;
  MontantAttribution?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBenefCible?: string;
  NomBenefOD?: string;
  PrenomBenefCible?: string;
  PrenomBenefOD?: string;
  Site?: KeyValueModelDtoInput;
  Status?: StatusDtoEnum;
  TypeBenef?: string;
  TypeContrat?: KeyValueModelDtoInput;
};

export type AttributionBudgetDto = {
  __typename?: 'AttributionBudgetDTO';
  Activite?: ActiviteDto;
  AnneeRef?: AnneeReferenceDto;
  Article?: ArticleDto;
  AttribTgExec?: boolean;
  CEDelegation?: CeDelegationDto;
  Code?: string;
  DateDernierMAJ?: any;
  DateExec?: any;
  DateRef?: any;
  DateValeurDefaut?: any;
  Description?: string;
  Enveloppe?: EnveloppeQuotaDto;
  Id?: number;
  IsCloture?: boolean;
  Libelle?: string;
  MoteurRegleAccess?: MoteurRegleDto;
  MoteurRegleSubQuota?: MoteurRegleDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AttributionBudgetDtoInput = {
  Activite?: ActiviteDtoInput;
  AnneeRef?: AnneeReferenceDtoInput;
  Article?: ArticleDtoInput;
  AttribTgExec?: boolean;
  CEDelegation?: CeDelegationDtoInput;
  Code?: string;
  DateDernierMAJ?: any;
  DateExec?: any;
  DateRef?: any;
  DateValeurDefaut?: any;
  Description?: string;
  Enveloppe?: EnveloppeQuotaDtoInput;
  Id?: number;
  IsCloture?: boolean;
  Libelle?: string;
  MoteurRegleAccess?: MoteurRegleDtoInput;
  MoteurRegleSubQuota?: MoteurRegleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AttributionBudgetModelDto = {
  __typename?: 'AttributionBudgetModelDTO';
  ArticleModele?: ArticleModel;
  AttribTgExec?: boolean;
  Code?: string;
  DateDernierMAJ?: any;
  DateEvenement?: any;
  DateExec?: any;
  DateValeurDefaut?: any;
  Description?: string;
  EnveloppeModel?: ModeleEnveloppeDto;
  Id?: number;
  IdActivite?: number;
  IdAnneeRef?: number;
  IdArticle?: number;
  IdCompteChargeAbondement?: number;
  IdComptePMVAbondement?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdJournalAbondement?: number;
  IdRglAcc?: number;
  IdRglSubQta?: number;
  IsAttribBoule?: boolean;
  IsCloture?: boolean;
  IsExecutionAutoActivee?: boolean;
  IsMasquee?: boolean;
  IsNominative?: boolean;
  Libelle?: string;
  ListeClesRepartition?: ArrayOfCleRepartitionModelDto;
  MoteurRegleAcc?: MoteurRegleModelDto;
  MoteurRegleSubQta?: MoteurRegleModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AttributionBudgetModelDtoInput = {
  ArticleModele?: ArticleModelInput;
  AttribTgExec?: boolean;
  Code?: string;
  DateDernierMAJ?: any;
  DateEvenement?: any;
  DateExec?: any;
  DateValeurDefaut?: any;
  Description?: string;
  EnveloppeModel?: ModeleEnveloppeDtoInput;
  Id?: number;
  IdActivite?: number;
  IdAnneeRef?: number;
  IdArticle?: number;
  IdCompteChargeAbondement?: number;
  IdComptePMVAbondement?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdJournalAbondement?: number;
  IdRglAcc?: number;
  IdRglSubQta?: number;
  IsAttribBoule?: boolean;
  IsCloture?: boolean;
  IsExecutionAutoActivee?: boolean;
  IsMasquee?: boolean;
  IsNominative?: boolean;
  Libelle?: string;
  ListeClesRepartition?: ArrayOfCleRepartitionModelDtoInput;
  MoteurRegleAcc?: MoteurRegleModelDtoInput;
  MoteurRegleSubQta?: MoteurRegleModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AttributionCdeLigneDto = {
  __typename?: 'AttributionCDELigneDTO';
  Accepte?: boolean;
  AttributionAuto?: AttributionAutoDto;
  LigneCommande?: LigneCommandeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AttributionCdeLigneDtoInput = {
  Accepte?: boolean;
  AttributionAuto?: AttributionAutoDtoInput;
  LigneCommande?: LigneCommandeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type AttributionRanfpaModelInput = {
  DateAttribution?: any;
  Description?: string;
  IdAttribution?: number;
  IdDelegation?: number;
  Libelle?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreBeneficiaire?: number;
  Status?: StatusDtoEnum;
};

export type AttributionRanInitModelDto = {
  __typename?: 'AttributionRanInitModelDTO';
  IsSyncroClient?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NbBenefTotal?: number;
  Status?: StatusDtoEnum;
};

export type AttributionRanInitModelDtoInput = {
  IsSyncroClient?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NbBenefTotal?: number;
  Status?: StatusDtoEnum;
};

export type AttributionRanModelDto = {
  __typename?: 'AttributionRanModelDTO';
  AttribTgExec?: boolean;
  DateAttRan?: any;
  Description?: string;
  EnveloppeModel?: ModeleEnveloppeDto;
  Id?: number;
  IdCE?: number;
  IdEnveloppe?: number;
  IsCloture?: boolean;
  IsEnabledAnnulerExec?: boolean;
  Libelle?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbBenefDejaAttribuer?: number;
  Status?: StatusDtoEnum;
};

export type AttributionRanModelDtoInput = {
  AttribTgExec?: boolean;
  DateAttRan?: any;
  Description?: string;
  EnveloppeModel?: ModeleEnveloppeDtoInput;
  Id?: number;
  IdCE?: number;
  IdEnveloppe?: number;
  IsCloture?: boolean;
  IsEnabledAnnulerExec?: boolean;
  Libelle?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbBenefDejaAttribuer?: number;
  Status?: StatusDtoEnum;
};

export type AttributionSubventionForEnveloppeModel = {
  __typename?: 'AttributionSubventionForEnveloppeModel';
  AnneeReference?: string;
  DateExecution?: any;
  Id?: number;
  IsArchived?: boolean;
  IsExecutionAutomatique?: boolean;
  IsNominatif?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibilite?: string;
};

export type AttributionSubventionForEnveloppeModelInput = {
  AnneeReference?: string;
  DateExecution?: any;
  Id?: number;
  IsArchived?: boolean;
  IsExecutionAutomatique?: boolean;
  IsNominatif?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibilite?: string;
};

export type AttributionTriDto = {
  __typename?: 'AttributionTriDTO';
  Champ?: ChampDto;
  Code?: string;
  Description?: string;
  ID?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OrdreTri?: string;
  Status?: StatusDtoEnum;
};

export type AttributionTriDtoInput = {
  Champ?: ChampDtoInput;
  Code?: string;
  Description?: string;
  ID?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OrdreTri?: string;
  Status?: StatusDtoEnum;
};

export type AttributionsLigneCommandeAttributionModel = {
  __typename?: 'AttributionsLigneCommandeAttributionModel';
  DateCommande?: any;
  IdBeneficiaireCible?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdOuvrantDroit?: number;
  LibelleLigneCommande?: string;
  MatriculeBeneficiaireCible?: string;
  MontantSubvention?: number;
  MontantUnitaire?: number;
  NbSkip?: number;
  NbTakes?: number;
  NomBeneficiaireCible?: string;
  PrenomBeneficiaireCible?: string;
  Quantite?: number;
  StatutAdministratif?: string;
  StatutLivraison?: string;
};

export type AttributionsLigneCommandeAttributionModelInput = {
  DateCommande?: any;
  IdBeneficiaireCible?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdOuvrantDroit?: number;
  LibelleLigneCommande?: string;
  MatriculeBeneficiaireCible?: string;
  MontantSubvention?: number;
  MontantUnitaire?: number;
  NbSkip?: number;
  NbTakes?: number;
  NomBeneficiaireCible?: string;
  PrenomBeneficiaireCible?: string;
  Quantite?: number;
  StatutAdministratif?: string;
  StatutLivraison?: string;
};

export type AvoirAcompteModelDto = {
  __typename?: 'AvoirAcompteModelDTO';
  AvAC?: string;
  DateCrea?: any;
  DateRgl?: any;
  HaveEcritureLettre?: boolean;
  Id?: number;
  IdFacture?: number;
  Libelle?: string;
  MontantTotal?: number;
  MoyenDePaiement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Par?: string;
  Reglement?: number;
  Status?: StatusDtoEnum;
};

export type AvoirAcompteModelDtoInput = {
  AvAC?: string;
  DateCrea?: any;
  DateRgl?: any;
  HaveEcritureLettre?: boolean;
  Id?: number;
  IdFacture?: number;
  Libelle?: string;
  MontantTotal?: number;
  MoyenDePaiement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Par?: string;
  Reglement?: number;
  Status?: StatusDtoEnum;
};

export type AyantDroitModelDto = {
  __typename?: 'AyantDroitModelDTO';
  CodeTypeBenef?: string;
  DateCloture?: any;
  DateNaissance?: any;
  Id?: number;
  IsClos?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantHandicape?: boolean;
  IsEnfantRattache?: boolean;
  IsSelected?: boolean;
  IsValide?: boolean;
  MotifCloture?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Prenom?: string;
  Sexe?: string;
  Status?: StatusDtoEnum;
  TypeBenef?: string;
};

export type AyantDroitModelDtoInput = {
  CodeTypeBenef?: string;
  DateCloture?: any;
  DateNaissance?: any;
  Id?: number;
  IsClos?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantHandicape?: boolean;
  IsEnfantRattache?: boolean;
  IsSelected?: boolean;
  IsValide?: boolean;
  MotifCloture?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Prenom?: string;
  Sexe?: string;
  Status?: StatusDtoEnum;
  TypeBenef?: string;
};

export type BlbrLigneModele = {
  __typename?: 'BLBRLigneModele';
  BLBR?: BlbrModele;
  DateBon?: any;
  IdLigne?: number;
  LigneCde?: LigneCommandeDto;
  QteAutoriseeALivrerInit?: number;
  QuantiteAlivre?: number;
  Type?: string;
  TypeBon?: string;
};

export type BlbrLigneModeleInput = {
  BLBR?: BlbrModeleInput;
  DateBon?: any;
  IdLigne?: number;
  LigneCde?: LigneCommandeDtoInput;
  QteAutoriseeALivrerInit?: number;
  QuantiteAlivre?: number;
  Type?: string;
  TypeBon?: string;
};

export type BlbrListModel = {
  __typename?: 'BLBRListModel';
  Benef?: BenefDto;
  DateBL?: any;
  DetailArticleLivree?: string;
  IdBLBR?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NBArticleLivree?: number;
  NumCommande?: number;
  Par?: string;
  Pour?: string;
  RemarquePrivee?: string;
  RemarquePublic?: string;
  Site?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type BlbrListModelInput = {
  Benef?: BenefDtoInput;
  DateBL?: any;
  DetailArticleLivree?: string;
  IdBLBR?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NBArticleLivree?: number;
  NumCommande?: number;
  Par?: string;
  Pour?: string;
  RemarquePrivee?: string;
  RemarquePublic?: string;
  Site?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type BlbrModele = {
  __typename?: 'BLBRModele';
  Adresse?: AdresseDto;
  AdresseFigePV?: AdresseFigeDto;
  AdresseFigeTiers?: AdresseFigeDto;
  BenefNomPrenom?: string;
  DateBon?: any;
  IdAdresse?: number;
  IdBlBr?: number;
  ListeBLBRLigneModele?: ArrayOfBlbrLigneModele;
  ListeDevis?: ArrayOfDevisCommandeDto;
  ListeLigneCommande?: ArrayOfLigneCommandeDto;
  ModeLivraison?: ModeLivraisonDto;
  NomFournisseur?: string;
  NumCommande?: number;
  Objet?: string;
  StockEntre?: StockDto;
  StockSortie?: StockDto;
  StrQteLivre?: string;
  Type?: string;
  TypeBon?: string;
};

export type BlbrModeleInput = {
  Adresse?: AdresseDtoInput;
  AdresseFigePV?: AdresseFigeDtoInput;
  AdresseFigeTiers?: AdresseFigeDtoInput;
  BenefNomPrenom?: string;
  DateBon?: any;
  IdAdresse?: number;
  IdBlBr?: number;
  ListeBLBRLigneModele?: ArrayOfBlbrLigneModeleInput;
  ListeDevis?: ArrayOfDevisCommandeDtoInput;
  ListeLigneCommande?: ArrayOfLigneCommandeDtoInput;
  ModeLivraison?: ModeLivraisonDtoInput;
  NomFournisseur?: string;
  NumCommande?: number;
  Objet?: string;
  StockEntre?: StockDtoInput;
  StockSortie?: StockDtoInput;
  StrQteLivre?: string;
  Type?: string;
  TypeBon?: string;
};

export enum BalanceSurTiersPlanComptableEnum {
  Beneficiaire = 'Beneficiaire',
  Fournisseur = 'Fournisseur'
}

export type BanqueDto = {
  __typename?: 'BanqueDTO';
  Adresse?: AdresseDto;
  CEDelegation?: CeDelegationDto;
  CodeBanque?: string;
  CodeGuichet?: string;
  Fax?: string;
  Id?: number;
  IsCloturee?: boolean;
  IsLieeActivite?: boolean;
  ListeCompteBancaire?: ArrayOfCompteBancaireDto;
  ListeContacts?: ArrayOfContactDto;
  Mail?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Status?: StatusDtoEnum;
  Telephone?: string;
};

export type BanqueDtoInput = {
  Adresse?: AdresseDtoInput;
  CEDelegation?: CeDelegationDtoInput;
  CodeBanque?: string;
  CodeGuichet?: string;
  Fax?: string;
  Id?: number;
  IsCloturee?: boolean;
  IsLieeActivite?: boolean;
  ListeCompteBancaire?: ArrayOfCompteBancaireDtoInput;
  ListeContacts?: ArrayOfContactDtoInput;
  Mail?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Status?: StatusDtoEnum;
  Telephone?: string;
};

export type BanqueLightModel = {
  __typename?: 'BanqueLightModel';
  IdBanque?: number;
  NomBanque?: string;
};

export type BanqueLightModelInput = {
  IdBanque?: number;
  NomBanque?: string;
};

export type BanqueLigneRemiseDto = {
  __typename?: 'BanqueLigneRemiseDTO';
  BanqueRemiseEnBanque?: BanqueRemiseDto;
  Id?: number;
  IsRejete?: boolean;
  IsRemiseEnAttente?: boolean;
  Montant?: number;
  MouvementCompta?: MouvementComptableDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BanqueLigneRemiseDtoInput = {
  BanqueRemiseEnBanque?: BanqueRemiseDtoInput;
  Id?: number;
  IsRejete?: boolean;
  IsRemiseEnAttente?: boolean;
  Montant?: number;
  MouvementCompta?: MouvementComptableDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BanqueRemiseDto = {
  __typename?: 'BanqueRemiseDTO';
  CEDelegation?: CeDelegationDto;
  Caisse?: CaisseDto;
  Compte512AssocieCbancaire?: CompteDto;
  CompteBancaire?: CompteBancaireDto;
  DateCreation?: any;
  DateRemiseEnBanque?: any;
  Id?: number;
  IdMandat?: number;
  IsSupprime?: boolean;
  JournalTresorerie?: JournalDto;
  Libelle?: string;
  ListeEcriture?: ArrayOfCompteEcritureDto;
  ListeLigneRemiseEnBanque?: ArrayOfBanqueLigneRemiseDto;
  MontantRemise?: number;
  MoyenPaiement?: MoyenPaiementDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NumBordereau?: string;
  NumPieceEspece?: string;
  NumPieceJournal?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
  User?: UsersDto;
};

export type BanqueRemiseDtoInput = {
  CEDelegation?: CeDelegationDtoInput;
  Caisse?: CaisseDtoInput;
  Compte512AssocieCbancaire?: CompteDtoInput;
  CompteBancaire?: CompteBancaireDtoInput;
  DateCreation?: any;
  DateRemiseEnBanque?: any;
  Id?: number;
  IdMandat?: number;
  IsSupprime?: boolean;
  JournalTresorerie?: JournalDtoInput;
  Libelle?: string;
  ListeEcriture?: ArrayOfCompteEcritureDtoInput;
  ListeLigneRemiseEnBanque?: ArrayOfBanqueLigneRemiseDtoInput;
  MontantRemise?: number;
  MoyenPaiement?: MoyenPaiementDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NumBordereau?: string;
  NumPieceEspece?: string;
  NumPieceJournal?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
  User?: UsersDtoInput;
};

export type BaseCriteresInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BaseHomeNotificationInput = {
  Count?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type BaseInformationsHomeNotificationInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type BaseRaisePropertyChanged = {
  __typename?: 'BaseRaisePropertyChanged';
  /** DO NOT USE! */
  _fakeProperty?: string;
};

export type BaseRaisePropertyChangedInput = {
  /** DO NOT USE! */
  _fakeProperty?: string;
};

export type BaseV2Model = {
  __typename?: 'BaseV2Model';
  InitialCatalog?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBase?: string;
  Status?: StatusDtoEnum;
};

export type BaseV2ModelInput = {
  InitialCatalog?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBase?: string;
  Status?: StatusDtoEnum;
};

export type BenefAdresseDto = {
  __typename?: 'BenefAdresseDTO';
  Adresse?: AdresseDto;
  Benef?: BenefDto;
  IsCloture?: boolean;
  IsDefautDirecto?: boolean;
  IsModif?: boolean;
  IsPrincipal?: boolean;
  Libelle?: string;
  ModeActuel?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefAdresseDtoInput = {
  Adresse?: AdresseDtoInput;
  Benef?: BenefDtoInput;
  IsCloture?: boolean;
  IsDefautDirecto?: boolean;
  IsModif?: boolean;
  IsPrincipal?: boolean;
  Libelle?: string;
  ModeActuel?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefAuSeinDuCeModel = {
  __typename?: 'BenefAuSeinDuCEModel';
  Cotisation?: BenefChampHistoriqueModel;
  DateEmbauche?: any;
  ListeBlocageDroits?: ArrayOfBenefChampHistoriqueModel;
  ListeCategories?: ArrayOfBenefChampHistoriqueModel;
  ListeCommentaires?: ArrayOfBenefCommentaireModel;
  ListeContrats?: ArrayOfBenefChampHistoriqueModel;
  ListeDroitsActifs?: ArrayOfBenefChampHistoriqueModel;
  ListeMetiers?: ArrayOfBenefChampHistoriqueModel;
  ListeOrganisations?: ArrayOfBenefSiteOrgaModel;
  ListeSites?: ArrayOfBenefSiteOrgaModel;
  Matricule?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TempsTravail?: number;
};

export type BenefAuSeinDuCeModelInput = {
  Cotisation?: BenefChampHistoriqueModelInput;
  DateEmbauche?: any;
  ListeBlocageDroits?: ArrayOfBenefChampHistoriqueModelInput;
  ListeCategories?: ArrayOfBenefChampHistoriqueModelInput;
  ListeCommentaires?: ArrayOfBenefCommentaireModelInput;
  ListeContrats?: ArrayOfBenefChampHistoriqueModelInput;
  ListeDroitsActifs?: ArrayOfBenefChampHistoriqueModelInput;
  ListeMetiers?: ArrayOfBenefChampHistoriqueModelInput;
  ListeOrganisations?: ArrayOfBenefSiteOrgaModelInput;
  ListeSites?: ArrayOfBenefSiteOrgaModelInput;
  Matricule?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TempsTravail?: number;
};

export type BenefBenefBaseModel = {
  __typename?: 'BenefBenefBaseModel';
  Id?: number;
  Nom?: string;
  Prenom?: string;
};

export type BenefBenefBaseModelInput = {
  Id?: number;
  Nom?: string;
  Prenom?: string;
};

export type BenefBenefMatriculeModel = {
  __typename?: 'BenefBenefMatriculeModel';
  Id?: number;
  Matricule?: string;
  Nom?: string;
  Prenom?: string;
};

export type BenefBenefMatriculeModelInput = {
  Id?: number;
  Matricule?: string;
  Nom?: string;
  Prenom?: string;
};

export type BenefBenefModelBaseDescriptor = {
  __typename?: 'BenefBenefModelBaseDescriptor';
  Id?: number;
  Nom?: string;
  Prenom?: string;
};

export type BenefBenefModelBaseDescriptorInput = {
  Id?: number;
  Nom?: string;
  Prenom?: string;
};

export type BenefBenefPourAccesPortailModel = {
  __typename?: 'BenefBenefPourAccesPortailModel';
  Id?: number;
  Nom?: string;
  PeutAccederAuPortail?: boolean;
  Prenom?: string;
};

export type BenefBenefPourAccesPortailModelInput = {
  Id?: number;
  Nom?: string;
  PeutAccederAuPortail?: boolean;
  Prenom?: string;
};

export type BenefBenefTotalModel = {
  __typename?: 'BenefBenefTotalModel';
  Id?: number;
  Nom?: string;
  Prenom?: string;
  Total?: number;
};

export type BenefBenefTotalModelInput = {
  Id?: number;
  Nom?: string;
  Prenom?: string;
  Total?: number;
};

export type BenefBeneficiaireFicheTrombinoscopeModel = {
  __typename?: 'BenefBeneficiaireFicheTrombinoscopeModel';
  Adresse?: AdresseDto;
  EmailPro?: string;
  Id?: number;
  IdAdresse?: number;
  Nom?: string;
  Photo?: FichierModel;
  Prenom?: string;
  TelPro?: string;
};

export type BenefBeneficiaireFicheTrombinoscopeModelInput = {
  Adresse?: AdresseDtoInput;
  EmailPro?: string;
  Id?: number;
  IdAdresse?: number;
  Nom?: string;
  Photo?: FichierModelInput;
  Prenom?: string;
  TelPro?: string;
};

export type BenefCeDelegationDto = {
  __typename?: 'BenefCEDelegationDTO';
  Benef?: BenefDto;
  CeDelegation?: CeDelegationDto;
  DateDeb?: any;
  DateMiseAJourKalidea?: any;
  IdKalidea?: number;
  IsBlocageDroit?: boolean;
  IsDelegDeRattachement?: boolean;
  IsDroitActif?: boolean;
  IsMigreKalidea?: boolean;
  IsSynchronisationActive?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefCeDelegationDtoInput = {
  Benef?: BenefDtoInput;
  CeDelegation?: CeDelegationDtoInput;
  DateDeb?: any;
  DateMiseAJourKalidea?: any;
  IdKalidea?: number;
  IsBlocageDroit?: boolean;
  IsDelegDeRattachement?: boolean;
  IsDroitActif?: boolean;
  IsMigreKalidea?: boolean;
  IsSynchronisationActive?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefChampHistoriqueModel = {
  __typename?: 'BenefChampHistoriqueModel';
  CodeChamp?: string;
  DateDebut?: any;
  DateFin?: any;
  IdChamp?: number;
  IdChampListeVal?: number;
  IdChampValMbr?: number;
  IdDelegation?: number;
  IsCloture?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefChampHistoriqueModelInput = {
  CodeChamp?: string;
  DateDebut?: any;
  DateFin?: any;
  IdChamp?: number;
  IdChampListeVal?: number;
  IdChampValMbr?: number;
  IdDelegation?: number;
  IsCloture?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefChampsPersoModel = {
  __typename?: 'BenefChampsPersoModel';
  ListeChampsPersonnalises?: ArrayOfChampPersoBeneficiaireModel;
  ListeChampsPersonnalisesDynamiques?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefChampsPersoModelInput = {
  ListeChampsPersonnalises?: ArrayOfChampPersoBeneficiaireModelInput;
  ListeChampsPersonnalisesDynamiques?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefComboModel = {
  __typename?: 'BenefComboModel';
  DateNaissance?: any;
  Id?: number;
  IsBlocageDroitActif?: boolean;
  IsDroitsActifs?: boolean;
  Matricule?: string;
  Nom?: string;
  Prenom?: string;
  TypeCode?: string;
  TypeLibelle?: string;
};

export type BenefComboModelInput = {
  DateNaissance?: any;
  Id?: number;
  IsBlocageDroitActif?: boolean;
  IsDroitsActifs?: boolean;
  Matricule?: string;
  Nom?: string;
  Prenom?: string;
  TypeCode?: string;
  TypeLibelle?: string;
};

export type BenefCommentaireModel = {
  __typename?: 'BenefCommentaireModel';
  Commentaire?: string;
  DateCommentaire?: any;
  IdCommentaire?: number;
  IsPrive?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomUtilisateur?: string;
  Status?: StatusDtoEnum;
};

export type BenefCommentaireModelInput = {
  Commentaire?: string;
  DateCommentaire?: any;
  IdCommentaire?: number;
  IsPrive?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomUtilisateur?: string;
  Status?: StatusDtoEnum;
};

export type BenefCoordonneesModel = {
  __typename?: 'BenefCoordonneesModel';
  AdressePrincipale?: BeneficiaireAdresseModel;
  EmailPerso?: string;
  EmailPro?: string;
  Fax?: string;
  IdBenef?: number;
  IdMoyenCorrespondancePrivilegie?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TelephoneBureau?: string;
  TelephoneDomicile?: string;
  TelephonePortable?: string;
};

export type BenefCoordonneesModelInput = {
  AdressePrincipale?: BeneficiaireAdresseModelInput;
  EmailPerso?: string;
  EmailPro?: string;
  Fax?: string;
  IdBenef?: number;
  IdMoyenCorrespondancePrivilegie?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TelephoneBureau?: string;
  TelephoneDomicile?: string;
  TelephonePortable?: string;
};

export type BenefCriteresSociauxModel = {
  __typename?: 'BenefCriteresSociauxModel';
  CodeChamp?: string;
  CodeTypeChamp?: string;
  Description?: string;
  IdAnneeReference?: number;
  IdBenef?: number;
  IdChamp?: number;
  IdChpValMbr?: number;
  IdUtilisateur?: number;
  IdValeur?: number;
  IsCalculDynamique?: boolean;
  IsChpPerso?: boolean;
  IsClos?: boolean;
  IsCritereSocial?: boolean;
  IsDeleted?: boolean;
  IsHistorise?: boolean;
  IsObligatoire?: boolean;
  IsQFNouNBParts?: boolean;
  LibelleChamp?: string;
  ListeValeursPossible?: ArrayOfChampListeValeurChampListeValeurLightModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Valeur?: string;
  ValeurChampListe?: string;
};

export type BenefCriteresSociauxModelInput = {
  CodeChamp?: string;
  CodeTypeChamp?: string;
  Description?: string;
  IdAnneeReference?: number;
  IdBenef?: number;
  IdChamp?: number;
  IdChpValMbr?: number;
  IdUtilisateur?: number;
  IdValeur?: number;
  IsCalculDynamique?: boolean;
  IsChpPerso?: boolean;
  IsClos?: boolean;
  IsCritereSocial?: boolean;
  IsDeleted?: boolean;
  IsHistorise?: boolean;
  IsObligatoire?: boolean;
  IsQFNouNBParts?: boolean;
  LibelleChamp?: string;
  ListeValeursPossible?: ArrayOfChampListeValeurChampListeValeurLightModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Valeur?: string;
  ValeurChampListe?: string;
};

export type BenefCriteresSociauxWithPjModel = {
  __typename?: 'BenefCriteresSociauxWithPJModel';
  ListeAnneesReferences?: ArrayOfAnneeReferenceValideModel;
  ListeCriteresSociaux?: ArrayOfBenefCriteresSociauxModel;
  ListeCriteresSociauxBooleens?: ArrayOfBenefCriteresSociauxModel;
  ListeCriteresSociauxDynamiques?: ArrayOfBenefCriteresSociauxModel;
  ListePJ?: ArrayOfPieceJustificativeBenefModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefCriteresSociauxWithPjModelInput = {
  ListeAnneesReferences?: ArrayOfAnneeReferenceValideModelInput;
  ListeCriteresSociaux?: ArrayOfBenefCriteresSociauxModelInput;
  ListeCriteresSociauxBooleens?: ArrayOfBenefCriteresSociauxModelInput;
  ListeCriteresSociauxDynamiques?: ArrayOfBenefCriteresSociauxModelInput;
  ListePJ?: ArrayOfPieceJustificativeBenefModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefDto = {
  __typename?: 'BenefDTO';
  AyantsDroit?: ArrayOfOdAdDto;
  BenefBloqDroitCurrent?: ChampValeurDto;
  BenefCategorieCurrent?: ChampValeurDto;
  BenefContratCurrent?: ChampValeurDto;
  BenefCotisationCurrent?: ChampValeurDto;
  BenefCycle?: ChampValeurDto;
  BenefDroitCurrent?: ChampValeurDto;
  BenefMetierCurrent?: ChampValeurDto;
  BenefMoyenCor?: ChampValeurDto;
  BenefOrganisationCurrent?: BenefOrganisationDto;
  BenefSexe?: ChampValeurDto;
  BenefSiteCurrent?: BenefSiteDto;
  BenefSituationFamiliale?: ChampValeurDto;
  BenefTitre?: ChampValeurDto;
  CategorieCurrentNew?: ChampListeValeurDto;
  Civilite?: string;
  CodeMembre?: string;
  Commentaires?: ChampValeurDto;
  CompteEcriture?: CompteEcritureDto;
  CompteMembre?: number;
  CompteTiers?: CompteDto;
  CurrentDelegRattachement?: CeDelegationDto;
  CycleCurrent?: ChampListeValeurDto;
  DateCloture?: any;
  DateCreation?: any;
  DateEmbauche?: any;
  DateFinDrt?: any;
  DateMajDrt?: any;
  DateModification?: any;
  DateNaissance?: any;
  DroitCurrentNew?: ChampListeValeurDto;
  EmlPerso?: string;
  EmlPro?: string;
  EnfantIdcHandic?: boolean;
  Fax?: string;
  Id?: number;
  IdMoyenCor?: number;
  IdOrganisationCurrent?: number;
  IdSiteCurrent?: number;
  IdSituationFam?: number;
  IdTypeDroitCurrent?: number;
  IdcOd?: number;
  IsCloture?: boolean;
  IsSelected?: boolean;
  IsSupprime?: boolean;
  LastUserModif?: UsersDto;
  ListeAdresses?: ArrayOfBenefAdresseDto;
  ListeAnneeReferenceValidation?: ArrayOfAnneeReferenceValidationBenefDto;
  ListeAyantDroit?: ArrayOfOdAdDto;
  ListeBenefBloquageDroit?: ArrayOfChampValeurDto;
  ListeBenefCategorie?: ArrayOfChampValeurDto;
  ListeBenefCeDelegation?: ArrayOfBenefCeDelegationDto;
  ListeBenefChampsPerso?: ArrayOfChampValeurDto;
  ListeBenefContrat?: ArrayOfChampValeurDto;
  ListeBenefCotisation?: ArrayOfChampValeurDto;
  ListeBenefCriteresSociaux?: ArrayOfChampValeurDto;
  ListeBenefDroit?: ArrayOfChampValeurDto;
  ListeBenefGroupe?: ArrayOfChampValeurDto;
  ListeBenefMetier?: ArrayOfChampValeurDto;
  ListeBenefOrganisation?: ArrayOfBenefOrganisationDto;
  ListeBenefSite?: ArrayOfBenefSiteDto;
  ListeBenefSituationFamiliale?: ArrayOfChampValeurDto;
  ListeDevis?: ArrayOfDevisCommandeDto;
  ListeLigneHistoEnvoi?: ArrayOfCourrierLigneHistoEnvoiDto;
  ListeOuvrantDroit?: ArrayOfOdAdDto;
  ListePieceJustificative?: ArrayOfPieceJustificativeBenefModel;
  MetierCurrentNew?: ChampListeValeurDto;
  MoyenCorCurrent?: ChampListeValeurDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NbEnfant?: number;
  Nom?: string;
  NomJf?: string;
  OrganisationCurrent?: OrganisationDto;
  Organisations?: ArrayOfBenefOrganisationDto;
  Password?: string;
  PhotoBenef?: FichierModel;
  PorteurDroit?: OdAdDto;
  Prenom?: string;
  ProfilKalideaCurrent?: ChampValeurDto;
  Pseudo?: string;
  RemarqueCloture?: string;
  Ribs?: ArrayOfRibDto;
  Sexe?: string;
  SexeCurrent?: ChampListeValeurDto;
  SiteCurrent?: SiteDto;
  Sites?: ArrayOfBenefSiteDto;
  SituationFamilialeCurrent?: ChampListeValeurDto;
  Status?: StatusDtoEnum;
  TelDom?: string;
  TelGsm?: string;
  TelPro?: string;
  TitreCurrent?: ChampListeValeurDto;
  TpsTravail?: number;
  Uuid?: string;
  Ville?: VilleDto;
};

export type BenefDtoInput = {
  AyantsDroit?: ArrayOfOdAdDtoInput;
  BenefBloqDroitCurrent?: ChampValeurDtoInput;
  BenefCategorieCurrent?: ChampValeurDtoInput;
  BenefContratCurrent?: ChampValeurDtoInput;
  BenefCotisationCurrent?: ChampValeurDtoInput;
  BenefCycle?: ChampValeurDtoInput;
  BenefDroitCurrent?: ChampValeurDtoInput;
  BenefMetierCurrent?: ChampValeurDtoInput;
  BenefMoyenCor?: ChampValeurDtoInput;
  BenefOrganisationCurrent?: BenefOrganisationDtoInput;
  BenefSexe?: ChampValeurDtoInput;
  BenefSiteCurrent?: BenefSiteDtoInput;
  BenefSituationFamiliale?: ChampValeurDtoInput;
  BenefTitre?: ChampValeurDtoInput;
  CategorieCurrentNew?: ChampListeValeurDtoInput;
  Civilite?: string;
  CodeMembre?: string;
  Commentaires?: ChampValeurDtoInput;
  CompteEcriture?: CompteEcritureDtoInput;
  CompteMembre?: number;
  CompteTiers?: CompteDtoInput;
  CurrentDelegRattachement?: CeDelegationDtoInput;
  CycleCurrent?: ChampListeValeurDtoInput;
  DateCloture?: any;
  DateCreation?: any;
  DateEmbauche?: any;
  DateFinDrt?: any;
  DateMajDrt?: any;
  DateModification?: any;
  DateNaissance?: any;
  DroitCurrentNew?: ChampListeValeurDtoInput;
  EmlPerso?: string;
  EmlPro?: string;
  EnfantIdcHandic?: boolean;
  Fax?: string;
  Id?: number;
  IdMoyenCor?: number;
  IdOrganisationCurrent?: number;
  IdSiteCurrent?: number;
  IdSituationFam?: number;
  IdTypeDroitCurrent?: number;
  IdcOd?: number;
  IsCloture?: boolean;
  IsSelected?: boolean;
  IsSupprime?: boolean;
  LastUserModif?: UsersDtoInput;
  ListeAdresses?: ArrayOfBenefAdresseDtoInput;
  ListeAnneeReferenceValidation?: ArrayOfAnneeReferenceValidationBenefDtoInput;
  ListeAyantDroit?: ArrayOfOdAdDtoInput;
  ListeBenefBloquageDroit?: ArrayOfChampValeurDtoInput;
  ListeBenefCategorie?: ArrayOfChampValeurDtoInput;
  ListeBenefCeDelegation?: ArrayOfBenefCeDelegationDtoInput;
  ListeBenefChampsPerso?: ArrayOfChampValeurDtoInput;
  ListeBenefContrat?: ArrayOfChampValeurDtoInput;
  ListeBenefCotisation?: ArrayOfChampValeurDtoInput;
  ListeBenefCriteresSociaux?: ArrayOfChampValeurDtoInput;
  ListeBenefDroit?: ArrayOfChampValeurDtoInput;
  ListeBenefGroupe?: ArrayOfChampValeurDtoInput;
  ListeBenefMetier?: ArrayOfChampValeurDtoInput;
  ListeBenefOrganisation?: ArrayOfBenefOrganisationDtoInput;
  ListeBenefSite?: ArrayOfBenefSiteDtoInput;
  ListeBenefSituationFamiliale?: ArrayOfChampValeurDtoInput;
  ListeDevis?: ArrayOfDevisCommandeDtoInput;
  ListeLigneHistoEnvoi?: ArrayOfCourrierLigneHistoEnvoiDtoInput;
  ListeOuvrantDroit?: ArrayOfOdAdDtoInput;
  ListePieceJustificative?: ArrayOfPieceJustificativeBenefModelInput;
  MetierCurrentNew?: ChampListeValeurDtoInput;
  MoyenCorCurrent?: ChampListeValeurDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbEnfant?: number;
  Nom?: string;
  NomJf?: string;
  OrganisationCurrent?: OrganisationDtoInput;
  Organisations?: ArrayOfBenefOrganisationDtoInput;
  Password?: string;
  PhotoBenef?: FichierModelInput;
  PorteurDroit?: OdAdDtoInput;
  Prenom?: string;
  ProfilKalideaCurrent?: ChampValeurDtoInput;
  Pseudo?: string;
  RemarqueCloture?: string;
  Ribs?: ArrayOfRibDtoInput;
  Sexe?: string;
  SexeCurrent?: ChampListeValeurDtoInput;
  SiteCurrent?: SiteDtoInput;
  Sites?: ArrayOfBenefSiteDtoInput;
  SituationFamilialeCurrent?: ChampListeValeurDtoInput;
  Status?: StatusDtoEnum;
  TelDom?: string;
  TelGsm?: string;
  TelPro?: string;
  TitreCurrent?: ChampListeValeurDtoInput;
  TpsTravail?: number;
  Uuid?: string;
  Ville?: VilleDtoInput;
};

export type BenefDelegationHistoModel = {
  __typename?: 'BenefDelegationHistoModel';
  Cotisation?: BenefChampHistoriqueModel;
  IdDeleg?: number;
  IsDelegationLieeBeneficiaire?: boolean;
  IsDelegationRattachement?: boolean;
  ListeBlocageDroits?: ArrayOfBenefChampHistoriqueModel;
  ListeDroitsActifs?: ArrayOfBenefChampHistoriqueModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefDelegationHistoModelInput = {
  Cotisation?: BenefChampHistoriqueModelInput;
  IdDeleg?: number;
  IsDelegationLieeBeneficiaire?: boolean;
  IsDelegationRattachement?: boolean;
  ListeBlocageDroits?: ArrayOfBenefChampHistoriqueModelInput;
  ListeDroitsActifs?: ArrayOfBenefChampHistoriqueModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefDelegationModel = {
  __typename?: 'BenefDelegationModel';
  IdDelegationRattachement?: number;
  ListeDelegationHistorique?: ArrayOfBenefDelegationHistoModel;
  MustValidate?: boolean;
  MyGuid?: string;
  NomDelegationRattachement?: string;
  Status?: StatusDtoEnum;
};

export type BenefDelegationModelInput = {
  IdDelegationRattachement?: number;
  ListeDelegationHistorique?: ArrayOfBenefDelegationHistoModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NomDelegationRattachement?: string;
  Status?: StatusDtoEnum;
};

export type BenefEditerAyantDroitInput = {
  CodeTypeAD?: string;
  DateCloture?: any;
  DateNaissanceAD?: any;
  IdOuvrantDroit?: number;
  IdSelectCycleEnfantAD?: number;
  IdSelectSexeAD?: number;
  IdUtilisateur?: number;
  IdentifiantAD?: number;
  IsCloture?: boolean;
  IsEnfantAChargeAD?: boolean;
  IsEnfantRattacheAD?: boolean;
  IsHandicapeAD?: boolean;
  IsOuvrantDroit?: boolean;
  IsValiderAD?: boolean;
  Matricule?: string;
  MotifCloture?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomAD?: string;
  NomNaissanceAD?: string;
  PrenomAD?: string;
  Status?: StatusDtoEnum;
};

export type BenefEmpruntModelDto = {
  __typename?: 'BenefEmpruntModelDTO';
  DateDernierEmprunt?: any;
  Id?: number;
  IdDevis?: number;
  Matricule?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Photo?: FichierModel;
  Prenom?: string;
  RefTmp?: string;
  ResumeEmprunt?: ResumeBenefEmpruntModel;
  Status?: StatusDtoEnum;
};

export type BenefEmpruntModelDtoInput = {
  DateDernierEmprunt?: any;
  Id?: number;
  IdDevis?: number;
  Matricule?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Photo?: FichierModelInput;
  Prenom?: string;
  RefTmp?: string;
  ResumeEmprunt?: ResumeBenefEmpruntModelInput;
  Status?: StatusDtoEnum;
};

export type BenefFamilleModel = {
  __typename?: 'BenefFamilleModel';
  IdSituationFamiliale?: number;
  ListeAD?: ArrayOfBenefOdadModel;
  MustValidate?: boolean;
  MyGuid?: string;
  OuvrantDroit?: BenefIdentiteModel;
  Status?: StatusDtoEnum;
};

export type BenefFamilleModelInput = {
  IdSituationFamiliale?: number;
  ListeAD?: ArrayOfBenefOdadModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  OuvrantDroit?: BenefIdentiteModelInput;
  Status?: StatusDtoEnum;
};

export type BenefFicheProfilModel = {
  __typename?: 'BenefFicheProfilModel';
  ChampsPersos?: BenefChampsPersoModel;
  Coordonnees?: BenefCoordonneesModel;
  CriteresSociaux?: BenefCriteresSociauxWithPjModel;
  DatesModification?: DatesModificationBeneficiaire;
  Famille?: BenefFamilleModel;
  IBAN?: BenefIbaNsModel;
  IdBenef?: number;
  Informations?: BenefInformationsModel;
  MustValidate?: boolean;
  MyGuid?: string;
  PJDiverses?: BenefPjModel;
  SkipReloadAfterSave?: boolean;
  Status?: StatusDtoEnum;
};

export type BenefFicheProfilModelInput = {
  ChampsPersos?: BenefChampsPersoModelInput;
  Coordonnees?: BenefCoordonneesModelInput;
  CriteresSociaux?: BenefCriteresSociauxWithPjModelInput;
  DatesModification?: DatesModificationBeneficiaireInput;
  Famille?: BenefFamilleModelInput;
  IBAN?: BenefIbaNsModelInput;
  IdBenef?: number;
  Informations?: BenefInformationsModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PJDiverses?: BenefPjModelInput;
  SkipReloadAfterSave?: boolean;
  Status?: StatusDtoEnum;
};

export type BenefForVentesModeleDto = {
  __typename?: 'BenefForVentesModeleDTO';
  IdBenef?: number;
  IdDevis?: number;
  IsBlocageDroitActif?: boolean;
  IsDroitsActifs?: boolean;
  Matricule?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBenef?: string;
  PrenomBenef?: string;
  Status?: StatusDtoEnum;
  UrlPictoBenef?: string;
};

export type BenefForVentesModeleDtoInput = {
  IdBenef?: number;
  IdDevis?: number;
  IsBlocageDroitActif?: boolean;
  IsDroitsActifs?: boolean;
  Matricule?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBenef?: string;
  PrenomBenef?: string;
  Status?: StatusDtoEnum;
  UrlPictoBenef?: string;
};

export type BenefIbaNsModel = {
  __typename?: 'BenefIBANsModel';
  IdBenef?: number;
  ListeIBAN?: ArrayOfIbanBeneficiaireModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefIbaNsModelInput = {
  IdBenef?: number;
  ListeIBAN?: ArrayOfIbanBeneficiaireModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefIdentificationModel = {
  __typename?: 'BenefIdentificationModel';
  CleActivationSynapse?: string;
  DateEnrolementSynapse?: any;
  DateValiditeCleActivationSynapse?: any;
  IsMotDePasseModifie?: boolean;
  Login?: string;
  LoginSynapse?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefIdentificationModelInput = {
  CleActivationSynapse?: string;
  DateEnrolementSynapse?: any;
  DateValiditeCleActivationSynapse?: any;
  IsMotDePasseModifie?: boolean;
  Login?: string;
  LoginSynapse?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefIdentiteModel = {
  __typename?: 'BenefIdentiteModel';
  BenefSynapseAnonymized?: boolean;
  BenefSynapseLastMajDate?: any;
  CodeSexe?: string;
  DateNaissance?: any;
  Id?: number;
  IdTitre?: number;
  IsPhotoProfilDeleted?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  NomNaissance?: string;
  PhotoProfil?: FichierModel;
  Prenom?: string;
  Status?: StatusDtoEnum;
};

export type BenefIdentiteModelInput = {
  BenefSynapseAnonymized?: boolean;
  BenefSynapseLastMajDate?: any;
  CodeSexe?: string;
  DateNaissance?: any;
  Id?: number;
  IdTitre?: number;
  IsPhotoProfilDeleted?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  NomNaissance?: string;
  PhotoProfil?: FichierModelInput;
  Prenom?: string;
  Status?: StatusDtoEnum;
};

export type BenefInformationsModel = {
  __typename?: 'BenefInformationsModel';
  AuSeinDuCeBenef?: BenefAuSeinDuCeModel;
  DelegationsBenef?: BenefDelegationModel;
  IdentificationBenef?: BenefIdentificationModel;
  IdentiteBenef?: BenefIdentiteModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefInformationsModelInput = {
  AuSeinDuCeBenef?: BenefAuSeinDuCeModelInput;
  DelegationsBenef?: BenefDelegationModelInput;
  IdentificationBenef?: BenefIdentificationModelInput;
  IdentiteBenef?: BenefIdentiteModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefMailingModel = {
  __typename?: 'BenefMailingModel';
  Id?: number;
  MailPerso?: string;
  MailPro?: string;
};

export type BenefMailingModelInput = {
  Id?: number;
  MailPerso?: string;
  MailPro?: string;
};

export type BenefMandatModel = {
  __typename?: 'BenefMandatModel';
  DateOperation?: any;
  DateValidation?: any;
  IdCompteBancaire?: number;
  IdRib?: number;
  IdRibMandat?: number;
  IsDeleted?: boolean;
  IsUnique?: boolean;
  IsUtilise?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomCompteBancaire?: string;
  NumeroICS?: string;
  ReferenceMandat?: string;
  Status?: StatusDtoEnum;
};

export type BenefMandatModelInput = {
  DateOperation?: any;
  DateValidation?: any;
  IdCompteBancaire?: number;
  IdRib?: number;
  IdRibMandat?: number;
  IsDeleted?: boolean;
  IsUnique?: boolean;
  IsUtilise?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomCompteBancaire?: string;
  NumeroICS?: string;
  ReferenceMandat?: string;
  Status?: StatusDtoEnum;
};

export type BenefOdadModel = {
  __typename?: 'BenefODADModel';
  CodeTypeAD?: string;
  DateCloture?: any;
  DateNaissanceAD?: any;
  IdOuvrantDroit?: number;
  IdSelectCycleEnfantAD?: number;
  IdSelectSexeAD?: number;
  IdUtilisateur?: number;
  IdentifiantAD?: number;
  IsCloture?: boolean;
  IsEnfantAChargeAD?: boolean;
  IsEnfantRattacheAD?: boolean;
  IsHandicapeAD?: boolean;
  IsOuvrantDroit?: boolean;
  IsValiderAD?: boolean;
  ListePJ?: ArrayOfPieceJustificativeBenefModel;
  Matricule?: string;
  MotifCloture?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomAD?: string;
  NomNaissanceAD?: string;
  PrenomAD?: string;
  Status?: StatusDtoEnum;
};

export type BenefOdadModelInput = {
  CodeTypeAD?: string;
  DateCloture?: any;
  DateNaissanceAD?: any;
  IdOuvrantDroit?: number;
  IdSelectCycleEnfantAD?: number;
  IdSelectSexeAD?: number;
  IdUtilisateur?: number;
  IdentifiantAD?: number;
  IsCloture?: boolean;
  IsEnfantAChargeAD?: boolean;
  IsEnfantRattacheAD?: boolean;
  IsHandicapeAD?: boolean;
  IsOuvrantDroit?: boolean;
  IsValiderAD?: boolean;
  ListePJ?: ArrayOfPieceJustificativeBenefModelInput;
  Matricule?: string;
  MotifCloture?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomAD?: string;
  NomNaissanceAD?: string;
  PrenomAD?: string;
  Status?: StatusDtoEnum;
};

export type BenefOrganisationDto = {
  __typename?: 'BenefOrganisationDTO';
  Benef?: BenefDto;
  DateDeb?: any;
  DateFin?: any;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Organisation?: OrganisationDto;
  Status?: StatusDtoEnum;
};

export type BenefOrganisationDtoInput = {
  Benef?: BenefDtoInput;
  DateDeb?: any;
  DateFin?: any;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Organisation?: OrganisationDtoInput;
  Status?: StatusDtoEnum;
};

export type BenefPjModel = {
  __typename?: 'BenefPJModel';
  IdBenef?: number;
  ListePJBenef?: ArrayOfPieceJustificativeBenefModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefPjModelInput = {
  IdBenef?: number;
  ListePJBenef?: ArrayOfPieceJustificativeBenefModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefPresentationModel = {
  __typename?: 'BenefPresentationModel';
  Id?: number;
  Matricule?: string;
  Nom?: string;
  PhotoProfil?: any;
  PhotoProfilFileName?: string;
  Prenom?: string;
};

export type BenefPresentationModelInput = {
  Id?: number;
  Matricule?: string;
  Nom?: string;
  PhotoProfil?: any;
  PhotoProfilFileName?: string;
  Prenom?: string;
};

export type BenefSiteDto = {
  __typename?: 'BenefSiteDTO';
  Benef?: BenefDto;
  DateDeb?: any;
  DateFin?: any;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Site?: SiteDto;
  Status?: StatusDtoEnum;
};

export type BenefSiteDtoInput = {
  Benef?: BenefDtoInput;
  DateDeb?: any;
  DateFin?: any;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Site?: SiteDtoInput;
  Status?: StatusDtoEnum;
};

export type BenefSiteOrgaModel = {
  __typename?: 'BenefSiteOrgaModel';
  DateDebut?: any;
  DateFin?: any;
  IdBenefSiteOrga?: number;
  IdSiteOrga?: number;
  IsCloture?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefSiteOrgaModelInput = {
  DateDebut?: any;
  DateFin?: any;
  IdBenefSiteOrga?: number;
  IdSiteOrga?: number;
  IsCloture?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BenefSynchroModelDto = {
  __typename?: 'BenefSynchroModelDTO';
  CodeProfilKalidea?: string;
  DateCreation?: any;
  DateSynchro?: any;
  IdASP?: number;
  IdKalidea?: number;
  IsSelected?: boolean;
  IsSynchroSubNonEnvoye?: boolean;
  IsSynchronise?: boolean;
  LibelleDelegation?: string;
  Matricule?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Prenom?: string;
  Status?: StatusDtoEnum;
  TotalConsoNonSynchro?: number;
};

export type BenefSynchroModelDtoInput = {
  CodeProfilKalidea?: string;
  DateCreation?: any;
  DateSynchro?: any;
  IdASP?: number;
  IdKalidea?: number;
  IsSelected?: boolean;
  IsSynchroSubNonEnvoye?: boolean;
  IsSynchronise?: boolean;
  LibelleDelegation?: string;
  Matricule?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Prenom?: string;
  Status?: StatusDtoEnum;
  TotalConsoNonSynchro?: number;
};

export type BenefSynchroSynapse = {
  __typename?: 'BenefSynchroSynapse';
  BenefSynapseAnonymized?: boolean;
  CleActivationSynapse?: string;
  DateDerniereSynchro?: any;
  DateEnrolementSynapse?: any;
  DateValiditeCleActivationSynapse?: any;
  Email?: string;
  IdBeneficiaire?: number;
  Identifiant?: string;
  MessageSynchro?: string;
  Nom?: string;
  Prenom?: string;
  ProfilSubvention?: string;
  StatusSynchro?: string;
  UuidBeneficiaire?: string;
};

export type BenefSynchroSynapseInput = {
  BenefSynapseAnonymized?: boolean;
  CleActivationSynapse?: string;
  DateDerniereSynchro?: any;
  DateEnrolementSynapse?: any;
  DateValiditeCleActivationSynapse?: any;
  Email?: string;
  IdBeneficiaire?: number;
  Identifiant?: string;
  MessageSynchro?: string;
  Nom?: string;
  Prenom?: string;
  ProfilSubvention?: string;
  StatusSynchro?: string;
  UuidBeneficiaire?: string;
};

export type BenefSynchroSynapseListResult = {
  __typename?: 'BenefSynchroSynapseListResult';
  BenefSynchroSynapse?: ArrayOfBenefSynchroSynapse;
  TotalCount?: number;
};

export type BenefSynchroSynapseListResultInput = {
  BenefSynchroSynapse?: ArrayOfBenefSynchroSynapseInput;
  TotalCount?: number;
};

export type BeneficiaireAdresseModel = {
  __typename?: 'BeneficiaireAdresseModel';
  Adresse1?: string;
  Adresse2?: string;
  Adresse3?: string;
  Adresse4?: string;
  CodePostal?: string;
  Id?: number;
  IdVille?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomVille?: string;
  Pays?: string;
  Status?: StatusDtoEnum;
};

export type BeneficiaireAdresseModelInput = {
  Adresse1?: string;
  Adresse2?: string;
  Adresse3?: string;
  Adresse4?: string;
  CodePostal?: string;
  Id?: number;
  IdVille?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomVille?: string;
  Pays?: string;
  Status?: StatusDtoEnum;
};

export type BeneficiaireAvecMailsModel = {
  __typename?: 'BeneficiaireAvecMailsModel';
  Id?: number;
  MailPerso?: string;
  MailPro?: string;
  Matricule?: string;
  Nom?: string;
  Prenom?: string;
};

export type BeneficiaireAvecMailsModelInput = {
  Id?: number;
  MailPerso?: string;
  MailPro?: string;
  Matricule?: string;
  Nom?: string;
  Prenom?: string;
};

export type BeneficiaireInfosBenefMatriculeModelDto = {
  __typename?: 'BeneficiaireInfosBenefMatriculeModelDTO';
  Id?: number;
  Matricule?: string;
  Nom?: string;
  Prenom?: string;
};

export type BeneficiaireInfosBenefMatriculeModelDtoInput = {
  Id?: number;
  Matricule?: string;
  Nom?: string;
  Prenom?: string;
};

export type BlBrDto = {
  __typename?: 'BlBrDTO';
  AdresseFigePV?: AdresseFigeDto;
  AdresseFigeTiers?: AdresseFigeDto;
  DateBon?: any;
  Id?: number;
  IsSupprimer?: boolean;
  ListeDevisCommande?: ArrayOfDevisCommandeDto;
  ListeLignesBlBr?: ArrayOfLigneBlBrDto;
  ModeLivraison?: ModeLivraisonDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Objet?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
  Type?: string;
  TypeBon?: string;
  User?: UsersDto;
};

export type BlBrDtoInput = {
  AdresseFigePV?: AdresseFigeDtoInput;
  AdresseFigeTiers?: AdresseFigeDtoInput;
  DateBon?: any;
  Id?: number;
  IsSupprimer?: boolean;
  ListeDevisCommande?: ArrayOfDevisCommandeDtoInput;
  ListeLignesBlBr?: ArrayOfLigneBlBrDtoInput;
  ModeLivraison?: ModeLivraisonDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Objet?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
  Type?: string;
  TypeBon?: string;
  User?: UsersDtoInput;
};

export type BlocCelluleModeleDto = {
  __typename?: 'BlocCelluleModeleDTO';
  FicheProfilBlocId?: number;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  TailleWH?: number;
  Type?: string;
};

export type BlocCelluleModeleDtoInput = {
  FicheProfilBlocId?: number;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  TailleWH?: number;
  Type?: string;
};

export type BlocModelDto = {
  __typename?: 'BlocModelDTO';
  Description?: string;
  IdBloc?: number;
  IdCE?: number;
  IdFiche?: number;
  Libelle?: string;
  ListeBlocCellule?: ArrayOfBlocCelluleModeleDto;
  ListeCelluleParam?: ArrayOfFicheProfilCelluleDirectoModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type BlocModelDtoInput = {
  Description?: string;
  IdBloc?: number;
  IdCE?: number;
  IdFiche?: number;
  Libelle?: string;
  ListeBlocCellule?: ArrayOfBlocCelluleModeleDtoInput;
  ListeCelluleParam?: ArrayOfFicheProfilCelluleDirectoModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type BlocageExemplaireModel = {
  __typename?: 'BlocageExemplaireModel';
  Auteur?: string;
  CanSelect?: boolean;
  CodeExemplaire?: string;
  DateImmobilisation?: any;
  IdArticle?: number;
  IdStockActuel?: number;
  LibelleFamille?: string;
  LibelleMedia?: string;
  LibelleStockActuel?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarqueExemplaire?: string;
  Status?: StatusDtoEnum;
  TypeMedia?: string;
};

export type BlocageExemplaireModelInput = {
  Auteur?: string;
  CanSelect?: boolean;
  CodeExemplaire?: string;
  DateImmobilisation?: any;
  IdArticle?: number;
  IdStockActuel?: number;
  LibelleFamille?: string;
  LibelleMedia?: string;
  LibelleStockActuel?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarqueExemplaire?: string;
  Status?: StatusDtoEnum;
  TypeMedia?: string;
};

export type BorneDto = {
  __typename?: 'BorneDTO';
  BorneMax?: number;
  BorneMin?: number;
  BorneMontantFixe?: number;
  BornePourcentageFixe?: number;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BorneDtoInput = {
  BorneMax?: number;
  BorneMin?: number;
  BorneMontantFixe?: number;
  BornePourcentageFixe?: number;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BorneMinMaxModelInput = {
  BorneMax?: number;
  BorneMin?: number;
  IdBorne?: number;
  IdBorneStat?: number;
  IdCSNbPart?: number;
};

export type BorneStatWithBornesModel = {
  __typename?: 'BorneStatWithBornesModel';
  IdBorneStat?: number;
  IdChamp?: number;
  LibelleBorneStat?: string;
  ListeBornes?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BorneStatWithBornesModelInput = {
  IdBorneStat?: number;
  IdChamp?: number;
  LibelleBorneStat?: string;
  ListeBornes?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type BudgetDto = {
  __typename?: 'BudgetDTO';
  BudgetPere?: BudgetDto;
  CEDelegation?: CeDelegationDto;
  Code?: string;
  Commission?: CommissionDto;
  Description?: string;
  Exercice?: ExerciceDto;
  Id?: number;
  IdExercice?: number;
  IsAnalytique?: boolean;
  Libelle?: string;
  ListePosteBudgetaire?: ArrayOfPosteBudgetaireDto;
  ListeSousBudget?: ArrayOfBudgetDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueDto;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
};

export type BudgetDtoInput = {
  BudgetPere?: BudgetDtoInput;
  CEDelegation?: CeDelegationDtoInput;
  Code?: string;
  Commission?: CommissionDtoInput;
  Description?: string;
  Exercice?: ExerciceDtoInput;
  Id?: number;
  IdExercice?: number;
  IsAnalytique?: boolean;
  Libelle?: string;
  ListePosteBudgetaire?: ArrayOfPosteBudgetaireDtoInput;
  ListeSousBudget?: ArrayOfBudgetDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueDtoInput;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
};

export type BudgetInformationsListingModel = {
  __typename?: 'BudgetInformationsListingModel';
  Id?: number;
  IdExercice?: number;
  IdPlanAnalytique?: number;
  IsAnalytique?: boolean;
  Libelle?: string;
  TypeBudget?: string;
};

export type BudgetInformationsListingModelInput = {
  Id?: number;
  IdExercice?: number;
  IdPlanAnalytique?: number;
  IsAnalytique?: boolean;
  Libelle?: string;
  TypeBudget?: string;
};

export type BudgetListingModel = {
  __typename?: 'BudgetListingModel';
  Id?: number;
  IdExercice?: number;
  IdPlanAnalytique?: number;
  IsAnalytique?: boolean;
  Libelle?: string;
  ListePostesBudgetaires?: ArrayOfanyType;
  ListeSousBudgets?: ArrayOfanyType;
  TypeBudget?: string;
};

export type BudgetListingModelInput = {
  Id?: number;
  IdExercice?: number;
  IdPlanAnalytique?: number;
  IsAnalytique?: boolean;
  Libelle?: string;
  ListePostesBudgetaires?: ArrayOfanyTypeInput;
  ListeSousBudgets?: ArrayOfanyTypeInput;
  TypeBudget?: string;
};

export type BudgetModelDto = {
  __typename?: 'BudgetModelDTO';
  Code?: string;
  Description?: string;
  Exercice?: ExerciceModelDto;
  Id?: number;
  IdBudgetPere?: number;
  IdCE?: number;
  IdCommission?: number;
  IdExercice?: number;
  IdPlanAnalytique?: number;
  IsAnalytique?: boolean;
  LibCommission?: string;
  Libelle?: string;
  ListePosteBudgetaireModele?: ArrayOfPosteBudgetaireModelDto;
  ListeSousBudgetModele?: ArrayOfBudgetModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueModelDto;
  SoldeAnnuelDepense?: number;
  SoldeAnnuelRecette?: number;
  SoldeAoutD?: number;
  SoldeAoutR?: number;
  SoldeAvrilD?: number;
  SoldeAvrilR?: number;
  SoldeDecD?: number;
  SoldeDecR?: number;
  SoldeFevD?: number;
  SoldeFevR?: number;
  SoldeJanD?: number;
  SoldeJanR?: number;
  SoldeJuilD?: number;
  SoldeJuilR?: number;
  SoldeJuinD?: number;
  SoldeJuinR?: number;
  SoldeMaiD?: number;
  SoldeMaiR?: number;
  SoldeMarsD?: number;
  SoldeMarsR?: number;
  SoldeNovD?: number;
  SoldeNovR?: number;
  SoldeOctD?: number;
  SoldeOctR?: number;
  SoldeSeptD?: number;
  SoldeSeptR?: number;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
};

export type BudgetModelDtoInput = {
  Code?: string;
  Description?: string;
  Exercice?: ExerciceModelDtoInput;
  Id?: number;
  IdBudgetPere?: number;
  IdCE?: number;
  IdCommission?: number;
  IdExercice?: number;
  IdPlanAnalytique?: number;
  IsAnalytique?: boolean;
  LibCommission?: string;
  Libelle?: string;
  ListePosteBudgetaireModele?: ArrayOfPosteBudgetaireModelDtoInput;
  ListeSousBudgetModele?: ArrayOfBudgetModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueModelDtoInput;
  SoldeAnnuelDepense?: number;
  SoldeAnnuelRecette?: number;
  SoldeAoutD?: number;
  SoldeAoutR?: number;
  SoldeAvrilD?: number;
  SoldeAvrilR?: number;
  SoldeDecD?: number;
  SoldeDecR?: number;
  SoldeFevD?: number;
  SoldeFevR?: number;
  SoldeJanD?: number;
  SoldeJanR?: number;
  SoldeJuilD?: number;
  SoldeJuilR?: number;
  SoldeJuinD?: number;
  SoldeJuinR?: number;
  SoldeMaiD?: number;
  SoldeMaiR?: number;
  SoldeMarsD?: number;
  SoldeMarsR?: number;
  SoldeNovD?: number;
  SoldeNovR?: number;
  SoldeOctD?: number;
  SoldeOctR?: number;
  SoldeSeptD?: number;
  SoldeSeptR?: number;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
};

export type CeDelegIsGlobaleModel = {
  __typename?: 'CEDelegIsGlobaleModel';
  Id?: number;
  IsGlobale?: boolean;
  Nom?: string;
};

export type CeDelegIsGlobaleModelInput = {
  Id?: number;
  IsGlobale?: boolean;
  Nom?: string;
};

export type CeDelegationContactModel = {
  __typename?: 'CEDelegationContactModel';
  Adresse?: string;
  AptEtage?: string;
  BoitePostale?: string;
  CodePostal?: string;
  Courriel?: string;
  EntreeImmeuble?: string;
  Fax?: string;
  Id?: number;
  Logo?: string;
  Nom?: string;
  Siret?: string;
  Telephone?: string;
  UrlSite?: string;
  Ville?: string;
};

export type CeDelegationContactModelInput = {
  Adresse?: string;
  AptEtage?: string;
  BoitePostale?: string;
  CodePostal?: string;
  Courriel?: string;
  EntreeImmeuble?: string;
  Fax?: string;
  Id?: number;
  Logo?: string;
  Nom?: string;
  Siret?: string;
  Telephone?: string;
  UrlSite?: string;
  Ville?: string;
};

export type CeDelegationDto = {
  __typename?: 'CEDelegationDTO';
  Adresse?: AdresseDto;
  CECodl?: string;
  CEDateClo?: any;
  CEDesc?: string;
  CEEmail?: string;
  CEFax?: string;
  CEIdCclo?: boolean;
  CEIdcGlob?: boolean;
  CENom?: string;
  CESiret?: string;
  CETel?: string;
  CEUrlSite?: string;
  CompteFraisCB?: CompteDto;
  Id?: number;
  ListePointVente?: ArrayOfPointVenteDto;
  Logo?: FichierModel;
  MustValidate?: boolean;
  MyGuid?: string;
  NumTVAIntra?: string;
  Skin?: PortailSkinDto;
  Status?: StatusDtoEnum;
};

export type CeDelegationDtoInput = {
  Adresse?: AdresseDtoInput;
  CECodl?: string;
  CEDateClo?: any;
  CEDesc?: string;
  CEEmail?: string;
  CEFax?: string;
  CEIdCclo?: boolean;
  CEIdcGlob?: boolean;
  CENom?: string;
  CESiret?: string;
  CETel?: string;
  CEUrlSite?: string;
  CompteFraisCB?: CompteDtoInput;
  Id?: number;
  ListePointVente?: ArrayOfPointVenteDtoInput;
  Logo?: FichierModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NumTVAIntra?: string;
  Skin?: PortailSkinDtoInput;
  Status?: StatusDtoEnum;
};

export type CeNbPartDto = {
  __typename?: 'CENbPartDTO';
  Id?: number;
  IdcEnfantRattache?: boolean;
  IdcPartEnfantFix?: boolean;
  IdcPartODFix?: boolean;
  ListePartEnfant?: ArrayOfBorneDto;
  ListePartODConjoint?: ArrayOfPartsOdConjointDto;
  MntPartConjointFix?: number;
  MntPartEnfantFix?: number;
  MntPartEnfantHandicape?: number;
  MntPartODFix?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  PartEnfantMax?: number;
  PartFamilleMax?: number;
  Status?: StatusDtoEnum;
};

export type CeNbPartDtoInput = {
  Id?: number;
  IdcEnfantRattache?: boolean;
  IdcPartEnfantFix?: boolean;
  IdcPartODFix?: boolean;
  ListePartEnfant?: ArrayOfBorneDtoInput;
  ListePartODConjoint?: ArrayOfPartsOdConjointDtoInput;
  MntPartConjointFix?: number;
  MntPartEnfantFix?: number;
  MntPartEnfantHandicape?: number;
  MntPartODFix?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  PartEnfantMax?: number;
  PartFamilleMax?: number;
  Status?: StatusDtoEnum;
};

export type CeQfPersonnaliseDto = {
  __typename?: 'CEQfPersonnaliseDTO';
  AbatPourc?: number;
  ChampNbPartAbat?: ChampDto;
  ChampNbPartDiv?: ChampDto;
  DivCoef?: number;
  DivNbPart?: boolean;
  Id?: number;
  IdcAbatMntNbPart?: boolean;
  IdcAddAlloc?: boolean;
  IdcAddComplFam?: boolean;
  IdcDiv12?: boolean;
  IdcSousImpot?: boolean;
  MntAbattement?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeArrondi?: string;
};

export type CeQfPersonnaliseDtoInput = {
  AbatPourc?: number;
  ChampNbPartAbat?: ChampDtoInput;
  ChampNbPartDiv?: ChampDtoInput;
  DivCoef?: number;
  DivNbPart?: boolean;
  Id?: number;
  IdcAbatMntNbPart?: boolean;
  IdcAddAlloc?: boolean;
  IdcAddComplFam?: boolean;
  IdcDiv12?: boolean;
  IdcSousImpot?: boolean;
  MntAbattement?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeArrondi?: string;
};

export type CadeauAfpaModel = {
  __typename?: 'CadeauAFPAModel';
  IdActivite?: number;
  IdElement?: number;
  IsModeAvance?: boolean;
  IsPriceHidden?: boolean;
  ListeCadeaux?: ArrayOfCadeauFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreParametrage?: boolean;
  Status?: StatusDtoEnum;
  TypeElement?: TypeAfpaEnum;
};

export type CadeauAfpaModelInput = {
  IdActivite?: number;
  IdElement?: number;
  IsModeAvance?: boolean;
  IsPriceHidden?: boolean;
  ListeCadeaux?: ArrayOfCadeauFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreParametrage?: boolean;
  Status?: StatusDtoEnum;
  TypeElement?: TypeAfpaEnum;
};

export type CadeauFpaModel = {
  __typename?: 'CadeauFPAModel';
  AgeMax?: number;
  AgeMin?: number;
  AutoriseDepassementSubvention?: boolean;
  ChpListValId?: number;
  CodeActivite?: string;
  IdActivite?: number;
  IdArticle?: number;
  IdCadeau?: number;
  IdFamille?: number;
  IdProduit?: number;
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  LibelleSexe?: string;
  ModeAvance?: boolean;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixArticle?: number;
  QuantiteMax?: number;
  QuantiteMin?: number;
  ReferenceArticle?: string;
  Status?: StatusDtoEnum;
  ToDelete?: boolean;
};

export type CadeauFpaModelInput = {
  AgeMax?: number;
  AgeMin?: number;
  AutoriseDepassementSubvention?: boolean;
  ChpListValId?: number;
  CodeActivite?: string;
  IdActivite?: number;
  IdArticle?: number;
  IdCadeau?: number;
  IdFamille?: number;
  IdProduit?: number;
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  LibelleSexe?: string;
  ModeAvance?: boolean;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixArticle?: number;
  QuantiteMax?: number;
  QuantiteMin?: number;
  ReferenceArticle?: string;
  Status?: StatusDtoEnum;
  ToDelete?: boolean;
};

export type CadeauxBaseModel = {
  __typename?: 'CadeauxBaseModel';
  IdCadeau?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CadeauxBaseModelInput = {
  IdCadeau?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CadeauxEditerLignedossierPrestaEvenementsFamilliauxGestionModelDto = {
  __typename?: 'CadeauxEditerLignedossierPrestaEvenementsFamilliauxGestionModelDTO';
  CodeModeLivraison?: string;
  DateEvenement?: any;
  Formulaire?: any;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdUtilisateur?: number;
  IsAccepte?: boolean;
  IsCrediterEnveloppeKalidea?: boolean;
  ListeCadeaux?: ArrayOfanyType;
  ListeClesRepartition?: ArrayOfSectionAnalytiqueLigneCommandeModelDto;
  ListeSubventionsAccordees?: ArrayOfanyType;
  Montant?: number;
  MontantSubvention?: number;
  Quantite?: number;
};

export type CadeauxEditerLignedossierPrestaEvenementsFamilliauxGestionModelDtoInput = {
  CodeModeLivraison?: string;
  DateEvenement?: any;
  Formulaire?: any;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdUtilisateur?: number;
  IsAccepte?: boolean;
  IsCrediterEnveloppeKalidea?: boolean;
  ListeCadeaux?: ArrayOfanyTypeInput;
  ListeClesRepartition?: ArrayOfSectionAnalytiqueLigneCommandeModelDtoInput;
  ListeSubventionsAccordees?: ArrayOfanyTypeInput;
  Montant?: number;
  MontantSubvention?: number;
  Quantite?: number;
};

export type CadeauxInfosCadeauxForLigneCommandeModelDtoInput = {
  IdCadeau?: number;
  IdLignePrestation?: number;
  LibelleProduitArticle?: string;
  MontantUnitaire?: number;
  Quantite?: number;
};

export type CadeauxInfosCriteresArticleCadeauxModelInput = {
  DateReference?: any;
  IdArticle?: number;
  IdBenefCible?: number;
  IdBenefOd?: number;
  IdDossier?: number;
  IdLigneDossier?: number;
  IsModeAvance?: boolean;
  MontantSubventionAccordeBenef?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  ReferenceArticle?: string;
  Status?: StatusDtoEnum;
  TexteRechercheArticle?: string;
};

export type CadeauxInfosModificationLigneDossierEvementFamilliaux = {
  __typename?: 'CadeauxInfosModificationLigneDossierEvementFamilliaux';
  CountCadeau?: number;
  DateEvenement?: any;
  IdArticle?: number;
  IdAyantDroit?: number;
  IdDossier?: number;
  IdOuvrantDroit?: number;
  IsArticleModeAvance?: boolean;
  IsLigneAcceptee?: boolean;
  ListeCadeaux?: ArrayOfInfosArticleCadeaux;
  MontantSubventionne?: number;
  RetourMoteur?: RetourMoteurModelDto;
  SubventionAccordee?: number;
};

export type CadeauxInfosModificationLigneDossierEvementFamilliauxInput = {
  CountCadeau?: number;
  DateEvenement?: any;
  IdArticle?: number;
  IdAyantDroit?: number;
  IdDossier?: number;
  IdOuvrantDroit?: number;
  IsArticleModeAvance?: boolean;
  IsLigneAcceptee?: boolean;
  ListeCadeaux?: ArrayOfInfosArticleCadeauxInput;
  MontantSubventionne?: number;
  RetourMoteur?: RetourMoteurModelDtoInput;
  SubventionAccordee?: number;
};

export type CadeauxInfosTransformationCadeauxEnCommandeModelInput = {
  DateFacturationBeneficiaire?: any;
  DateTransformation?: any;
  IDExerciceBeneficiaire?: number;
  IDJournalBeneficiaire?: number;
  IdDossierPrestation?: number;
  IsNumeroPieceAuto?: boolean;
  NumeroDePieceJournal?: string;
};

export type CadeauxRetourTransformationCadeauxEnCommandeModel = {
  __typename?: 'CadeauxRetourTransformationCadeauxEnCommandeModel';
  IDCommandeGeneree?: number;
  IdFactureGeneree?: number;
  IsTransformationSuccess?: boolean;
  NumeroFactureGeneree?: string;
};

export type CadeauxRetourTransformationCadeauxEnCommandeModelInput = {
  IDCommandeGeneree?: number;
  IdFactureGeneree?: number;
  IsTransformationSuccess?: boolean;
  NumeroFactureGeneree?: string;
};

export type CaisseArreteDto = {
  __typename?: 'CaisseArreteDTO';
  Caisse?: CaisseDto;
  Compte?: CompteDto;
  CompteEcriture?: CompteEcritureDto;
  DateArrete?: any;
  Id?: number;
  IsDernierArrete?: boolean;
  ListeMouvementComptable?: ArrayOfMouvementComptableDto;
  MontantReel?: number;
  MontantTheorique?: number;
  MoyenPaiement?: MoyenPaiementDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
  User?: UsersDto;
};

export type CaisseArreteDtoInput = {
  Caisse?: CaisseDtoInput;
  Compte?: CompteDtoInput;
  CompteEcriture?: CompteEcritureDtoInput;
  DateArrete?: any;
  Id?: number;
  IsDernierArrete?: boolean;
  ListeMouvementComptable?: ArrayOfMouvementComptableDtoInput;
  MontantReel?: number;
  MontantTheorique?: number;
  MoyenPaiement?: MoyenPaiementDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
  User?: UsersDtoInput;
};

export type CaisseCaisseBaseModel = {
  __typename?: 'CaisseCaisseBaseModel';
  IdCaisse?: number;
  LibelleCaisse?: string;
};

export type CaisseCaisseBaseModelInput = {
  IdCaisse?: number;
  LibelleCaisse?: string;
};

export type CaisseCaisseJournauxReglementFiduModel = {
  __typename?: 'CaisseCaisseJournauxReglementFiduModel';
  IdCaisse?: number;
  IdJournal?: number;
  IdMoyenPaiement?: number;
};

export type CaisseCaisseJournauxReglementFiduModelInput = {
  IdCaisse?: number;
  IdJournal?: number;
  IdMoyenPaiement?: number;
};

export type CaisseDto = {
  __typename?: 'CaisseDTO';
  CaisseCentrale?: CaisseDto;
  Code?: string;
  CompteEcriture?: CompteEcritureDto;
  ComptePerte?: CompteDto;
  CompteProfit?: CompteDto;
  CompteVirement?: CompteDto;
  Id?: number;
  IsBloqueRemiseEnBanque?: boolean;
  IsCaisseUtilise?: boolean;
  IsCentrale?: boolean;
  IsClos?: boolean;
  IsRemiseCaisseCentrale?: boolean;
  Journal?: JournalDto;
  Libelle?: string;
  ListeCaisseSectionAnalytique?: ArrayOfCaisseSectionAnalytiqueDto;
  ListePlanSectionAnalytique?: ArrayOfPlanWithSectionsAnalytiquesModel;
  ListeUsers?: ArrayOfUsersDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PV?: PointVenteDto;
  Status?: StatusDtoEnum;
  Stock?: StockDto;
};

export type CaisseDtoInput = {
  CaisseCentrale?: CaisseDtoInput;
  Code?: string;
  CompteEcriture?: CompteEcritureDtoInput;
  ComptePerte?: CompteDtoInput;
  CompteProfit?: CompteDtoInput;
  CompteVirement?: CompteDtoInput;
  Id?: number;
  IsBloqueRemiseEnBanque?: boolean;
  IsCaisseUtilise?: boolean;
  IsCentrale?: boolean;
  IsClos?: boolean;
  IsRemiseCaisseCentrale?: boolean;
  Journal?: JournalDtoInput;
  Libelle?: string;
  ListeCaisseSectionAnalytique?: ArrayOfCaisseSectionAnalytiqueDtoInput;
  ListePlanSectionAnalytique?: ArrayOfPlanWithSectionsAnalytiquesModelInput;
  ListeUsers?: ArrayOfUsersDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PV?: PointVenteDtoInput;
  Status?: StatusDtoEnum;
  Stock?: StockDtoInput;
};

export type CaisseSectionAnalytiqueDto = {
  __typename?: 'CaisseSectionAnalytiqueDTO';
  Caisse?: CaisseDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueDto;
  Pourcentage?: number;
  SectionAnalytique?: SectionAnalytiqueDto;
  Status?: StatusDtoEnum;
};

export type CaisseSectionAnalytiqueDtoInput = {
  Caisse?: CaisseDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueDtoInput;
  Pourcentage?: number;
  SectionAnalytique?: SectionAnalytiqueDtoInput;
  Status?: StatusDtoEnum;
};

export type CaissesCriteresCaisseModelInput = {
  IsClos?: boolean;
};

export type CalculRegleAvanceeModelDto = {
  __typename?: 'CalculRegleAvanceeModelDTO';
  CalculParent?: CalculRegleAvanceeModelDto;
  CalculsEnfants?: ArrayOfCalculRegleAvanceeModelDto;
  Critere?: CritereRegleAvanceeModelDto;
  Id?: number;
  IdOperateur?: number;
  IsGroupe?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Valeur?: number;
};

export type CalculRegleAvanceeModelDtoInput = {
  CalculParent?: CalculRegleAvanceeModelDtoInput;
  CalculsEnfants?: ArrayOfCalculRegleAvanceeModelDtoInput;
  Critere?: CritereRegleAvanceeModelDtoInput;
  Id?: number;
  IdOperateur?: number;
  IsGroupe?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Valeur?: number;
};

export type CessionStockBaseModel = {
  __typename?: 'CessionStockBaseModel';
  DateCessionStock?: any;
  IdCessionStock?: number;
  IdUtilisateur?: number;
  LibelleCessionStock?: string;
};

export type CessionStockBaseModelInput = {
  DateCessionStock?: any;
  IdCessionStock?: number;
  IdUtilisateur?: number;
  LibelleCessionStock?: string;
};

export type CessionStockInfosHistoriqueModel = {
  __typename?: 'CessionStockInfosHistoriqueModel';
  DateCessionStock?: any;
  IdCessionStock?: number;
  IdUtilisateur?: number;
  IsEnAttente?: boolean;
  IsNonReceptionnee?: boolean;
  IsPartiellementReceptionnee?: boolean;
  IsReceptionnee?: boolean;
  LibelleCessionStock?: string;
  LibelleStatut?: string;
  QuantiteReceptionnee?: number;
  QuantiteSortie?: number;
};

export type CessionStockInfosHistoriqueModelInput = {
  DateCessionStock?: any;
  IdCessionStock?: number;
  IdUtilisateur?: number;
  IsEnAttente?: boolean;
  IsNonReceptionnee?: boolean;
  IsPartiellementReceptionnee?: boolean;
  IsReceptionnee?: boolean;
  LibelleCessionStock?: string;
  LibelleStatut?: string;
  QuantiteReceptionnee?: number;
  QuantiteSortie?: number;
};

export type CessionStockWithRemarqueModel = {
  __typename?: 'CessionStockWithRemarqueModel';
  DateCessionStock?: any;
  DateDerniereModification?: any;
  IdCessionStock?: number;
  IdUtilisateur?: number;
  IsTransfertStock?: boolean;
  LibelleCessionStock?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomPrenomUtilisateurDerniereModification?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type CessionStockWithRemarqueModelInput = {
  DateCessionStock?: any;
  DateDerniereModification?: any;
  IdCessionStock?: number;
  IdUtilisateur?: number;
  IsTransfertStock?: boolean;
  LibelleCessionStock?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomPrenomUtilisateurDerniereModification?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type CessionStockWithRemarqueNomPrenomModel = {
  __typename?: 'CessionStockWithRemarqueNomPrenomModel';
  DateCessionStock?: any;
  DateDerniereModification?: any;
  IdCessionStock?: number;
  IdUtilisateur?: number;
  IsTransfertStock?: boolean;
  LibelleCessionStock?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  NomPrenomUtilisateurDerniereModification?: string;
  Prenom?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type CessionStockWithRemarqueNomPrenomModelInput = {
  DateCessionStock?: any;
  DateDerniereModification?: any;
  IdCessionStock?: number;
  IdUtilisateur?: number;
  IsTransfertStock?: boolean;
  LibelleCessionStock?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  NomPrenomUtilisateurDerniereModification?: string;
  Prenom?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type ChampChampTypeModel = {
  __typename?: 'ChampChampTypeModel';
  CodeChamp?: string;
  CodeTypeChamp?: string;
  IdChamp?: number;
  LibelleChamp?: string;
};

export type ChampChampTypeModelInput = {
  CodeChamp?: string;
  CodeTypeChamp?: string;
  IdChamp?: number;
  LibelleChamp?: string;
};

export type ChampDto = {
  __typename?: 'ChampDTO';
  Activite?: ActiviteDto;
  Article?: ArticleDto;
  Benef?: BenefDto;
  CEQfPerso?: CeQfPersonnaliseDto;
  CSNbPart?: CeNbPartDto;
  ChampTypeDonnee?: ChampTypeDonneeDto;
  Code?: string;
  Description?: string;
  Famille?: FamilleProduitDto;
  Id?: number;
  IsActivite?: boolean;
  IsAfficheDirecto?: boolean;
  IsAppliquerSurArticle?: boolean;
  IsAppliquerSurFamille?: boolean;
  IsAppliquerSurProduit?: boolean;
  IsAyantDroit?: boolean;
  IsCalculDynamique?: boolean;
  IsChampPerso?: boolean;
  IsCritereSociaux?: boolean;
  IsMembre?: boolean;
  IsObligatoire?: boolean;
  IsParametre?: boolean;
  IsParametreActivite?: boolean;
  IsParametreAdmin?: boolean;
  IsParametreCEParCE?: boolean;
  IsParametreDirecto?: boolean;
  IsParametreGestion?: boolean;
  IsParametreGlobal?: boolean;
  IsParametreUserParUser?: boolean;
  IsRegleAccesibiliter?: boolean;
  IsRegleQuota?: boolean;
  IsRegleSubvention?: boolean;
  Libelle?: string;
  ListChampListeValeur?: ArrayOfChampListeValeurDto;
  ListeChampValeur?: ArrayOfChampValeurDto;
  ListeParametreValeur?: ArrayOfParametreValeurDto;
  ListeTypeActivite?: ArrayOfTypeActiviteDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Produit?: ProduitDto;
  Status?: StatusDtoEnum;
  TypeAyantDroit?: TypeBenefDto;
  UseHisto?: boolean;
  ValeurChpListValParDefautParametre?: ChampListeValeurDto;
  ValeurParDefautParametre?: string;
};

export type ChampDtoInput = {
  Activite?: ActiviteDtoInput;
  Article?: ArticleDtoInput;
  Benef?: BenefDtoInput;
  CEQfPerso?: CeQfPersonnaliseDtoInput;
  CSNbPart?: CeNbPartDtoInput;
  ChampTypeDonnee?: ChampTypeDonneeDtoInput;
  Code?: string;
  Description?: string;
  Famille?: FamilleProduitDtoInput;
  Id?: number;
  IsActivite?: boolean;
  IsAfficheDirecto?: boolean;
  IsAppliquerSurArticle?: boolean;
  IsAppliquerSurFamille?: boolean;
  IsAppliquerSurProduit?: boolean;
  IsAyantDroit?: boolean;
  IsCalculDynamique?: boolean;
  IsChampPerso?: boolean;
  IsCritereSociaux?: boolean;
  IsMembre?: boolean;
  IsObligatoire?: boolean;
  IsParametre?: boolean;
  IsParametreActivite?: boolean;
  IsParametreAdmin?: boolean;
  IsParametreCEParCE?: boolean;
  IsParametreDirecto?: boolean;
  IsParametreGestion?: boolean;
  IsParametreGlobal?: boolean;
  IsParametreUserParUser?: boolean;
  IsRegleAccesibiliter?: boolean;
  IsRegleQuota?: boolean;
  IsRegleSubvention?: boolean;
  Libelle?: string;
  ListChampListeValeur?: ArrayOfChampListeValeurDtoInput;
  ListeChampValeur?: ArrayOfChampValeurDtoInput;
  ListeParametreValeur?: ArrayOfParametreValeurDtoInput;
  ListeTypeActivite?: ArrayOfTypeActiviteDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Produit?: ProduitDtoInput;
  Status?: StatusDtoEnum;
  TypeAyantDroit?: TypeBenefDtoInput;
  UseHisto?: boolean;
  ValeurChpListValParDefautParametre?: ChampListeValeurDtoInput;
  ValeurParDefautParametre?: string;
};

export type ChampEditerChampPersoFpa = {
  __typename?: 'ChampEditerChampPersoFPA';
  CodeChamp?: string;
  CodeTypeChamp?: string;
  CodeValeur?: string;
  IdArticle?: number;
  IdChamp?: number;
  IdChpValMbr?: number;
  IdFamille?: number;
  IdProduit?: number;
  IdUtilisateur?: number;
  IdValeur?: number;
  IsAppliqueActivite?: boolean;
  IsAppliqueArticle?: boolean;
  IsAppliqueFamille?: boolean;
  IsAppliqueProduit?: boolean;
  IsChpPerso?: boolean;
  IsClos?: boolean;
  IsCritereSocial?: boolean;
  IsDeleted?: boolean;
  IsObligatoire?: boolean;
  LibelleChamp?: string;
  LibelleTypeChamp?: string;
  ListeValeursPossible?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
  ValeurChampListe?: string;
};

export type ChampEditerChampPersoFpaInput = {
  CodeChamp?: string;
  CodeTypeChamp?: string;
  CodeValeur?: string;
  IdArticle?: number;
  IdChamp?: number;
  IdChpValMbr?: number;
  IdFamille?: number;
  IdProduit?: number;
  IdUtilisateur?: number;
  IdValeur?: number;
  IsAppliqueActivite?: boolean;
  IsAppliqueArticle?: boolean;
  IsAppliqueFamille?: boolean;
  IsAppliqueProduit?: boolean;
  IsChpPerso?: boolean;
  IsClos?: boolean;
  IsCritereSocial?: boolean;
  IsDeleted?: boolean;
  IsObligatoire?: boolean;
  LibelleChamp?: string;
  LibelleTypeChamp?: string;
  ListeValeursPossible?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
  ValeurChampListe?: string;
};

export type ChampFormulaireLibelleModel = {
  __typename?: 'ChampFormulaireLibelleModel';
  IdChamp?: number;
  LibelleChamp?: string;
};

export type ChampFormulaireLibelleModelInput = {
  IdChamp?: number;
  LibelleChamp?: string;
};

export type ChampFormulaireListingModel = {
  __typename?: 'ChampFormulaireListingModel';
  CodeTypeChamp?: string;
  IdActivite?: number;
  IdChamp?: number;
  IdChampData?: number;
  IsChampUtilisateur?: boolean;
  IsCloture?: boolean;
  IsEditable?: boolean;
  LibelleChamp?: string;
  LibelleTypeChamp?: string;
};

export type ChampFormulaireListingModelInput = {
  CodeTypeChamp?: string;
  IdActivite?: number;
  IdChamp?: number;
  IdChampData?: number;
  IsChampUtilisateur?: boolean;
  IsCloture?: boolean;
  IsEditable?: boolean;
  LibelleChamp?: string;
  LibelleTypeChamp?: string;
};

export type ChampFormulaireParametrageModel = {
  __typename?: 'ChampFormulaireParametrageModel';
  CodeTypeChamp?: string;
  DateDefaut?: any;
  IdActivite?: number;
  IdChamp?: number;
  IdDelegation?: number;
  IdTypeChamp?: number;
  IsCloture?: boolean;
  IsUsedInFormulaire?: boolean;
  LibelleChamp?: string;
  ListeChampValeurFormulaire?: ArrayOfValeurChampFormulaireModel;
  ListeIdValeurDefaut?: ArrayOfint;
  ListeValeursChamp?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  RequeteSQLListeValeur?: string;
  Status?: StatusDtoEnum;
  ValeurParDefaut?: string;
};

export type ChampFormulaireParametrageModelInput = {
  CodeTypeChamp?: string;
  DateDefaut?: any;
  IdActivite?: number;
  IdChamp?: number;
  IdDelegation?: number;
  IdTypeChamp?: number;
  IsCloture?: boolean;
  IsUsedInFormulaire?: boolean;
  LibelleChamp?: string;
  ListeChampValeurFormulaire?: ArrayOfValeurChampFormulaireModelInput;
  ListeIdValeurDefaut?: ArrayOfintInput;
  ListeValeursChamp?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RequeteSQLListeValeur?: string;
  Status?: StatusDtoEnum;
  ValeurParDefaut?: string;
};

export type ChampLibelleModel = {
  __typename?: 'ChampLibelleModel';
  CodeChamp?: string;
  IdChamp?: number;
  LibelleChamp?: string;
};

export type ChampLibelleModelInput = {
  CodeChamp?: string;
  IdChamp?: number;
  LibelleChamp?: string;
};

export type ChampListeValModel = {
  __typename?: 'ChampListeValModel';
  CodeChampListVal?: string;
  Id?: number;
  Libelle?: string;
};

export type ChampListeValModelInput = {
  CodeChampListVal?: string;
  Id?: number;
  Libelle?: string;
};

export type ChampListeValeurChampListeValeurLightModel = {
  __typename?: 'ChampListeValeurChampListeValeurLightModel';
  CodeChamp?: string;
  Id?: number;
  Valeur?: string;
};

export type ChampListeValeurChampListeValeurLightModelInput = {
  CodeChamp?: string;
  Id?: number;
  Valeur?: string;
};

export type ChampListeValeurChampListeValeurModel = {
  __typename?: 'ChampListeValeurChampListeValeurModel';
  CodeChamp?: string;
  CodeChampValeur?: string;
  Id?: number;
  IdChamp?: number;
  IsCloture?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type ChampListeValeurChampListeValeurModelInput = {
  CodeChamp?: string;
  CodeChampValeur?: string;
  Id?: number;
  IdChamp?: number;
  IsCloture?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type ChampListeValeurDto = {
  __typename?: 'ChampListeValeurDTO';
  Article?: ArticleDto;
  ChaineSqlMoteur?: string;
  Champ?: ChampDto;
  Code?: string;
  Id?: number;
  IsCloture?: boolean;
  ListeChampValeur?: ArrayOfChampValeurDto;
  ListeLigneHistoEnvoi?: ArrayOfCourrierLigneHistoEnvoiDto;
  ListeRegleModeleAcces?: ArrayOfRegleModeleAccesDto;
  MustValidate?: boolean;
  MyGuid?: string;
  OrdreAffichage?: number;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type ChampListeValeurDtoInput = {
  Article?: ArticleDtoInput;
  ChaineSqlMoteur?: string;
  Champ?: ChampDtoInput;
  Code?: string;
  Id?: number;
  IsCloture?: boolean;
  ListeChampValeur?: ArrayOfChampValeurDtoInput;
  ListeLigneHistoEnvoi?: ArrayOfCourrierLigneHistoEnvoiDtoInput;
  ListeRegleModeleAcces?: ArrayOfRegleModeleAccesDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  OrdreAffichage?: number;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type ChampListeValeurEditerValeurChampListeModel = {
  __typename?: 'ChampListeValeurEditerValeurChampListeModel';
  Cloture?: boolean;
  Code?: string;
  Id?: number;
  IdChamp?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type ChampListeValeurEditerValeurChampListeModelInput = {
  Cloture?: boolean;
  Code?: string;
  Id?: number;
  IdChamp?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type ChampParGroupeAffichageModelInput = {
  CodeChamps?: string;
  DescriptionChamps?: string;
  IdChamps?: number;
  IsRequired?: boolean;
  IsSelected?: boolean;
  LibelleChamps?: string;
  TagChamp?: string;
};

export type ChampPersoBeneficiaireModel = {
  __typename?: 'ChampPersoBeneficiaireModel';
  CodeChamp?: string;
  CodeTypeChamp?: string;
  Description?: string;
  IdBenef?: number;
  IdChamp?: number;
  IdChpValMbr?: number;
  IdUtilisateur?: number;
  IdValeur?: number;
  IsChpPerso?: boolean;
  IsClos?: boolean;
  IsCritereSocial?: boolean;
  IsDeleted?: boolean;
  IsHistorise?: boolean;
  IsObligatoire?: boolean;
  LibelleChamp?: string;
  ListeValeursPossible?: ArrayOfChampListeValeurChampListeValeurLightModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Valeur?: string;
  ValeurChampListe?: string;
};

export type ChampPersoBeneficiaireModelInput = {
  CodeChamp?: string;
  CodeTypeChamp?: string;
  Description?: string;
  IdBenef?: number;
  IdChamp?: number;
  IdChpValMbr?: number;
  IdUtilisateur?: number;
  IdValeur?: number;
  IsChpPerso?: boolean;
  IsClos?: boolean;
  IsCritereSocial?: boolean;
  IsDeleted?: boolean;
  IsHistorise?: boolean;
  IsObligatoire?: boolean;
  LibelleChamp?: string;
  ListeValeursPossible?: ArrayOfChampListeValeurChampListeValeurLightModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Valeur?: string;
  ValeurChampListe?: string;
};

export type ChampTypeDataCodeModel = {
  __typename?: 'ChampTypeDataCodeModel';
  CodeTypeData?: string;
  IdTypeData?: number;
  LibelleTypeData?: string;
};

export type ChampTypeDataCodeModelInput = {
  CodeTypeData?: string;
  IdTypeData?: number;
  LibelleTypeData?: string;
};

export type ChampTypeDonneeDto = {
  __typename?: 'ChampTypeDonneeDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ChampTypeDonneeDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ChampValeurDto = {
  __typename?: 'ChampValeurDTO';
  AnneeReference?: AnneeReferenceDto;
  Article?: ArticleDto;
  Benef?: BenefDto;
  CEDelegation?: CeDelegationDto;
  Champ?: ChampDto;
  ChampListeValeur?: ChampListeValeurDto;
  Commande?: DevisCommandeDto;
  DateDeb?: any;
  DateFin?: any;
  Famille?: FamilleProduitDto;
  Id?: number;
  LastUserModif?: UsersDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Produit?: ProduitDto;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type ChampValeurDtoInput = {
  AnneeReference?: AnneeReferenceDtoInput;
  Article?: ArticleDtoInput;
  Benef?: BenefDtoInput;
  CEDelegation?: CeDelegationDtoInput;
  Champ?: ChampDtoInput;
  ChampListeValeur?: ChampListeValeurDtoInput;
  Commande?: DevisCommandeDtoInput;
  DateDeb?: any;
  DateFin?: any;
  Famille?: FamilleProduitDtoInput;
  Id?: number;
  LastUserModif?: UsersDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Produit?: ProduitDtoInput;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type ChampsCritereBooleenPubliChampsModel = {
  __typename?: 'ChampsCritereBooleenPubliChampsModel';
  ChampWHERE?: string;
  Code?: string;
  CodeChamps?: string;
  Description?: string;
  Groupe?: any;
  IdChamps?: number;
  IsDynamique?: boolean;
  IsInverse?: boolean;
  IsNullable?: boolean;
  LibelleChamps?: string;
  ListeIdPubliType?: ArrayOfint;
  ListeValeurs?: ArrayOfNullableOfboolean;
  Ordre?: number;
  SQLSelect?: string;
  Type?: string;
};

export type ChampsCritereBooleenPubliChampsModelInput = {
  ChampWHERE?: string;
  Code?: string;
  CodeChamps?: string;
  Description?: string;
  Groupe?: any;
  IdChamps?: number;
  IsDynamique?: boolean;
  IsInverse?: boolean;
  IsNullable?: boolean;
  LibelleChamps?: string;
  ListeIdPubliType?: ArrayOfintInput;
  ListeValeurs?: ArrayOfNullableOfbooleanInput;
  Ordre?: number;
  SQLSelect?: string;
  Type?: string;
};

export type ChampsCritereDatePubliChampsModel = {
  __typename?: 'ChampsCritereDatePubliChampsModel';
  ChampWHERE?: string;
  Code?: string;
  CodeChamps?: string;
  Comparateur?: string;
  DateMaximum?: any;
  DateMinimum?: any;
  Description?: string;
  Groupe?: any;
  IdChamps?: number;
  IsDynamique?: boolean;
  IsInverse?: boolean;
  IsNullable?: boolean;
  LibelleChamps?: string;
  ListeIdPubliType?: ArrayOfint;
  Ordre?: number;
  SQLSelect?: string;
  Type?: string;
};

export type ChampsCritereDatePubliChampsModelInput = {
  ChampWHERE?: string;
  Code?: string;
  CodeChamps?: string;
  Comparateur?: string;
  DateMaximum?: any;
  DateMinimum?: any;
  Description?: string;
  Groupe?: any;
  IdChamps?: number;
  IsDynamique?: boolean;
  IsInverse?: boolean;
  IsNullable?: boolean;
  LibelleChamps?: string;
  ListeIdPubliType?: ArrayOfintInput;
  Ordre?: number;
  SQLSelect?: string;
  Type?: string;
};

export type ChampsCritereLibellePubliChampsModel = {
  __typename?: 'ChampsCritereLibellePubliChampsModel';
  ChampWHERE?: string;
  Code?: string;
  CodeChamps?: string;
  Description?: string;
  Groupe?: any;
  IdChamps?: number;
  IsDynamique?: boolean;
  IsInverse?: boolean;
  IsNullable?: boolean;
  LibelleChamps?: string;
  ListeIdPubliType?: ArrayOfint;
  Ordre?: number;
  SQLSelect?: string;
  Type?: string;
  Valeur?: string;
};

export type ChampsCritereLibellePubliChampsModelInput = {
  ChampWHERE?: string;
  Code?: string;
  CodeChamps?: string;
  Description?: string;
  Groupe?: any;
  IdChamps?: number;
  IsDynamique?: boolean;
  IsInverse?: boolean;
  IsNullable?: boolean;
  LibelleChamps?: string;
  ListeIdPubliType?: ArrayOfintInput;
  Ordre?: number;
  SQLSelect?: string;
  Type?: string;
  Valeur?: string;
};

export type ChampsCritereListeValeursPubliChampsModel = {
  __typename?: 'ChampsCritereListeValeursPubliChampsModel';
  ChampWHERE?: string;
  Code?: string;
  CodeChamps?: string;
  Description?: string;
  Groupe?: any;
  IdChamps?: number;
  IsDynamique?: boolean;
  IsInverse?: boolean;
  IsNullable?: boolean;
  LibelleChamps?: string;
  ListeIdPubliType?: ArrayOfint;
  ListeValeurs?: ArrayOfNullableOfdecimal;
  ListeValeursPossibles?: ArrayOfanyType;
  Ordre?: number;
  SQLSelect?: string;
  Type?: string;
};

export type ChampsCritereListeValeursPubliChampsModelInput = {
  ChampWHERE?: string;
  Code?: string;
  CodeChamps?: string;
  Description?: string;
  Groupe?: any;
  IdChamps?: number;
  IsDynamique?: boolean;
  IsInverse?: boolean;
  IsNullable?: boolean;
  LibelleChamps?: string;
  ListeIdPubliType?: ArrayOfintInput;
  ListeValeurs?: ArrayOfNullableOfdecimalInput;
  ListeValeursPossibles?: ArrayOfanyTypeInput;
  Ordre?: number;
  SQLSelect?: string;
  Type?: string;
};

export type ChampsCritereNumeriquePubliChampsModel = {
  __typename?: 'ChampsCritereNumeriquePubliChampsModel';
  ChampWHERE?: string;
  Code?: string;
  CodeChamps?: string;
  Comparateur?: string;
  Description?: string;
  Groupe?: any;
  IdChamps?: number;
  IsDynamique?: boolean;
  IsInverse?: boolean;
  IsNullable?: boolean;
  LibelleChamps?: string;
  ListeIdPubliType?: ArrayOfint;
  Ordre?: number;
  SQLSelect?: string;
  Type?: string;
  ValeurMaximum?: number;
  ValeurMinimum?: number;
};

export type ChampsCritereNumeriquePubliChampsModelInput = {
  ChampWHERE?: string;
  Code?: string;
  CodeChamps?: string;
  Comparateur?: string;
  Description?: string;
  Groupe?: any;
  IdChamps?: number;
  IsDynamique?: boolean;
  IsInverse?: boolean;
  IsNullable?: boolean;
  LibelleChamps?: string;
  ListeIdPubliType?: ArrayOfintInput;
  Ordre?: number;
  SQLSelect?: string;
  Type?: string;
  ValeurMaximum?: number;
  ValeurMinimum?: number;
};

export type ChampsCriterePubliChampsModel = {
  __typename?: 'ChampsCriterePubliChampsModel';
  ChampWHERE?: string;
  Code?: string;
  CodeChamps?: string;
  Description?: string;
  Groupe?: any;
  IdChamps?: number;
  IsDynamique?: boolean;
  IsInverse?: boolean;
  IsNullable?: boolean;
  LibelleChamps?: string;
  ListeIdPubliType?: ArrayOfint;
  Ordre?: number;
  SQLSelect?: string;
  Type?: string;
};

export type ChampsCriterePubliChampsModelInput = {
  ChampWHERE?: string;
  Code?: string;
  CodeChamps?: string;
  Description?: string;
  Groupe?: any;
  IdChamps?: number;
  IsDynamique?: boolean;
  IsInverse?: boolean;
  IsNullable?: boolean;
  LibelleChamps?: string;
  ListeIdPubliType?: ArrayOfintInput;
  Ordre?: number;
  SQLSelect?: string;
  Type?: string;
};

export type ChampsCriteresPubliChampsDynamiquesInput = {
  IdBeneficiaire?: number;
};

export type ChampsCriteresPubliCriteresInput = {
  CodeChamps?: string;
  CodePubliPage?: string;
  IdGroupeCritere?: number;
  IdPubliPage?: number;
  IdRequete?: number;
  IdTypePubli?: number;
  IdVue?: number;
  IsChampDefaultVUP?: boolean;
  IsChampDynamique?: boolean;
  IsCritere?: boolean;
  IsCritereDefaultVUP?: boolean;
  IsVUP?: boolean;
  ListCodeChamps?: ArrayOfstringInput;
  ListeIdCriteres?: ArrayOfintInput;
  ListeIdsActivite?: ArrayOfdecimalInput;
  OrderByLibelle?: boolean;
  TypeCritere?: string;
  WithCritereDefaut?: boolean;
  WithCritereGlobale?: boolean;
};

export type ChampsCriteresPubliModeleModelInput = {
  CodeChamps?: string;
  IdPubliPage?: number;
  IdTypePubli?: number;
  IdVue?: number;
  IsVUP?: boolean;
  ListCodeChamps?: ArrayOfstringInput;
  ListeIdTypeActivite?: ArrayOfdecimalInput;
  OrderByLibelle?: boolean;
};

export type ChampsPlusValeursModel = {
  __typename?: 'ChampsPlusValeursModel';
  ListeChamps?: ArrayOfChampDto;
  ListeChampsValeurs?: ArrayOfChampValeurDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ChampsPlusValeursModelInput = {
  ListeChamps?: ArrayOfChampDtoInput;
  ListeChampsValeurs?: ArrayOfChampValeurDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ChampsSectionFormulaireFullModel = {
  __typename?: 'ChampsSectionFormulaireFullModel';
  CodeTypeChamp?: string;
  DateDefaut?: any;
  Description?: string;
  IdChamp?: number;
  IdDataFormulaire?: number;
  IdSectionParente?: number;
  IsChampObligatoire?: boolean;
  IsProproseEnLigne?: boolean;
  IsToDelete?: boolean;
  IsVisibleOD?: boolean;
  Libelle?: string;
  ListeChampValeurFormulaire?: ArrayOfValeurChampFormulaireModel;
  ListeIdValeurDefaut?: ArrayOfint;
  ListeIdValeurDefautFormulaire?: ArrayOfint;
  ListeValeursChamp?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroColonne?: number;
  NumeroLigne?: number;
  RequeteSQLListeValeur?: string;
  Status?: StatusDtoEnum;
  ValeurDefautDansFormulaire?: string;
  ValeurParDefaut?: string;
};

export type ChampsSectionFormulaireFullModelInput = {
  CodeTypeChamp?: string;
  DateDefaut?: any;
  Description?: string;
  IdChamp?: number;
  IdDataFormulaire?: number;
  IdSectionParente?: number;
  IsChampObligatoire?: boolean;
  IsProproseEnLigne?: boolean;
  IsToDelete?: boolean;
  IsVisibleOD?: boolean;
  Libelle?: string;
  ListeChampValeurFormulaire?: ArrayOfValeurChampFormulaireModelInput;
  ListeIdValeurDefaut?: ArrayOfintInput;
  ListeIdValeurDefautFormulaire?: ArrayOfintInput;
  ListeValeursChamp?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroColonne?: number;
  NumeroLigne?: number;
  RequeteSQLListeValeur?: string;
  Status?: StatusDtoEnum;
  ValeurDefautDansFormulaire?: string;
  ValeurParDefaut?: string;
};

export type ChampsValeurPossibleModelInput = {
  Id?: number;
  Libelle?: string;
};

export type ChangeStatutLigneCommandeModelDto = {
  __typename?: 'ChangeStatutLigneCommandeModelDTO';
  ArticleOptionModel?: ArticleVenteModeleDto;
  CodeStatutAdmin?: string;
  ErrMsg?: string;
  IdLigneCde?: number;
  IsInError?: boolean;
  LibelleNouveauStatut?: string;
  LibelleOptionAjoute?: string;
  ListeIdOptionModifiee?: ArrayOfdecimal;
  MessageFinTraitement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbUniteRemboursee?: number;
  NeedOpenFormulaireSurOption?: boolean;
  ObjetDevis?: string;
  QuantiteRemboursee?: number;
  RetourMoteurModel?: RetourMoteurModelDto;
  Status?: StatusDtoEnum;
  SubUnitaireAccepte?: number;
  SubUnitaireTheorique?: number;
};

export type ChangeStatutLigneCommandeModelDtoInput = {
  ArticleOptionModel?: ArticleVenteModeleDtoInput;
  CodeStatutAdmin?: string;
  ErrMsg?: string;
  IdLigneCde?: number;
  IsInError?: boolean;
  LibelleNouveauStatut?: string;
  LibelleOptionAjoute?: string;
  ListeIdOptionModifiee?: ArrayOfdecimalInput;
  MessageFinTraitement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbUniteRemboursee?: number;
  NeedOpenFormulaireSurOption?: boolean;
  ObjetDevis?: string;
  QuantiteRemboursee?: number;
  RetourMoteurModel?: RetourMoteurModelDtoInput;
  Status?: StatusDtoEnum;
  SubUnitaireAccepte?: number;
  SubUnitaireTheorique?: number;
};

export type ChangerRibSurMouvementAttenteModelInput = {
  IdRib?: number;
  ListeIdMouvementImpacte?: ArrayOfdecimalInput;
};

export type ChargerVueModeExpertBenefModelDto = {
  __typename?: 'ChargerVueModeExpertBenefModelDTO';
  ListeInfoCol?: ArrayOfInfoColDataGridModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreBenefTot?: number;
  NombreBenefTotFiltre?: number;
  Requete?: string;
  Status?: StatusDtoEnum;
};

export type ChargerVueModeExpertBenefModelDtoInput = {
  ListeInfoCol?: ArrayOfInfoColDataGridModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreBenefTot?: number;
  NombreBenefTotFiltre?: number;
  Requete?: string;
  Status?: StatusDtoEnum;
};

export type ChequierDto = {
  __typename?: 'ChequierDTO';
  Id?: number;
  IsCloture?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
  ValeurFaciale?: number;
};

export type ChequierDtoInput = {
  Id?: number;
  IsCloture?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
  ValeurFaciale?: number;
};

export type ChequierModel = {
  __typename?: 'ChequierModel';
  IdChequier?: number;
  IsClos?: number;
  LibelleChequier?: string;
  TypeChequier?: string;
  ValeurFacialCheque?: number;
};

export type ChequierModelInput = {
  IdChequier?: number;
  IsClos?: number;
  LibelleChequier?: string;
  TypeChequier?: string;
  ValeurFacialCheque?: number;
};

export type ChoixDuplicationCommandeModelDto = {
  __typename?: 'ChoixDuplicationCommandeModelDTO';
  CodeActivite?: string;
  IdCommande?: number;
  IsCalculerSubvention?: boolean;
  IsLocation?: boolean;
  IsNotCalculerSubventionMoteur?: boolean;
  IsRefuseLigneNonAccepteMoteur?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroDeChoix?: string;
  Status?: StatusDtoEnum;
};

export type ChoixDuplicationCommandeModelDtoInput = {
  CodeActivite?: string;
  IdCommande?: number;
  IsCalculerSubvention?: boolean;
  IsLocation?: boolean;
  IsNotCalculerSubventionMoteur?: boolean;
  IsRefuseLigneNonAccepteMoteur?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroDeChoix?: string;
  Status?: StatusDtoEnum;
};

export type ChoixItemDto = {
  __typename?: 'ChoixItemDTO';
  Id?: string;
  IsSelected?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ChoixItemDtoInput = {
  Id?: string;
  IsSelected?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CleRepartitionModel = {
  __typename?: 'CleRepartitionModel';
  IdPlan?: number;
  IdSection?: number;
  Pourcentage?: number;
  Valeur?: number;
};

export type CleRepartitionModelDto = {
  __typename?: 'CleRepartitionModelDTO';
  IdCompte?: number;
  IdMouvement?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytique?: number;
  IsInitialSectionAnalytique?: boolean;
  IsSelected?: boolean;
  LibelleCompte?: string;
  LibellePlanAnalytique?: string;
  LibelleSectionAnalytique?: string;
  Montant?: number;
  MontantARepartir?: number;
  MontantConsultation?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompte?: string;
  Pourcentage?: number;
  SectionAnalytique?: SectionAnalytiqueModelDto;
  Status?: StatusDtoEnum;
};

export type CleRepartitionModelDtoInput = {
  IdCompte?: number;
  IdMouvement?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytique?: number;
  IsInitialSectionAnalytique?: boolean;
  IsSelected?: boolean;
  LibelleCompte?: string;
  LibellePlanAnalytique?: string;
  LibelleSectionAnalytique?: string;
  Montant?: number;
  MontantARepartir?: number;
  MontantConsultation?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompte?: string;
  Pourcentage?: number;
  SectionAnalytique?: SectionAnalytiqueModelDtoInput;
  Status?: StatusDtoEnum;
};

export type CleRepartitionModelInput = {
  IdPlan?: number;
  IdSection?: number;
  Pourcentage?: number;
  Valeur?: number;
};

export type ClotureExerciceForInventaireModel = {
  __typename?: 'ClotureExerciceForInventaireModel';
  IdCloture?: number;
  IdExercice?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumCompteFCAP?: string;
  NumCompteFCCA?: string;
  NumCompteFPAR?: string;
  NumCompteFPCA?: string;
  NumCompteSCAP?: string;
  NumCompteSCCA?: string;
  NumCompteSPAR?: string;
  NumCompteSPCA?: string;
  Status?: StatusDtoEnum;
};

export type ClotureExerciceForInventaireModelInput = {
  IdCloture?: number;
  IdExercice?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumCompteFCAP?: string;
  NumCompteFCCA?: string;
  NumCompteFPAR?: string;
  NumCompteFPCA?: string;
  NumCompteSCAP?: string;
  NumCompteSCCA?: string;
  NumCompteSPAR?: string;
  NumCompteSPCA?: string;
  Status?: StatusDtoEnum;
};

export type ClotureReportDesTiersModel = {
  __typename?: 'ClotureReportDesTiersModel';
  Budget?: string;
  IdTiers?: number;
  LibelleCompteCollectif?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomPrenomTiers?: string;
  NumerocCompteCollectif?: string;
  SommeMouvementCredit?: number;
  SommeMouvementsDebit?: number;
  Status?: StatusDtoEnum;
};

export type ClotureReportDesTiersModelInput = {
  Budget?: string;
  IdTiers?: number;
  LibelleCompteCollectif?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomPrenomTiers?: string;
  NumerocCompteCollectif?: string;
  SommeMouvementCredit?: number;
  SommeMouvementsDebit?: number;
  Status?: StatusDtoEnum;
};

export type ClotureStatutPersoModelInput = {
  IdNouveauStatutSurDeclencheur?: number;
  IdNouveauStautSurCommande?: number;
  IdStatutPerso?: number;
  IsNouveauStatutSurCommandeIsPerso?: boolean;
  IsNouveauStatutSurDeclencheurIsPerso?: boolean;
};

export type ClotureVariationStockModel = {
  __typename?: 'ClotureVariationStockModel';
  IdArticle?: number;
  IdCloture?: number;
  IdCompteValorisation?: number;
  IdCompteVariation?: number;
  IsArticleCloture?: boolean;
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleCompteValorisation?: string;
  LibelleCompteVariation?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumerocCompteValorisation?: string;
  NumerocCompteVariation?: string;
  PrixArticle?: number;
  QuantiteEnStock?: number;
  Status?: StatusDtoEnum;
};

export type ClotureVariationStockModelInput = {
  IdArticle?: number;
  IdCloture?: number;
  IdCompteValorisation?: number;
  IdCompteVariation?: number;
  IsArticleCloture?: boolean;
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleCompteValorisation?: string;
  LibelleCompteVariation?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumerocCompteValorisation?: string;
  NumerocCompteVariation?: string;
  PrixArticle?: number;
  QuantiteEnStock?: number;
  Status?: StatusDtoEnum;
};

export type ComboBoxStatutsModel = {
  __typename?: 'ComboBoxStatutsModel';
  CodeStatut?: string;
  CodeStatutPere?: string;
  IdStatut?: number;
  IsStatutCalcule?: boolean;
  IsStatutPerso?: boolean;
  LibelleStatut?: string;
  ListeCodeStatut?: ArrayOfstring;
  ListeCodeStatutPere?: ArrayOfstring;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ComboBoxStatutsModelInput = {
  CodeStatut?: string;
  CodeStatutPere?: string;
  IdStatut?: number;
  IsStatutCalcule?: boolean;
  IsStatutPerso?: boolean;
  LibelleStatut?: string;
  ListeCodeStatut?: ArrayOfstringInput;
  ListeCodeStatutPere?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommandeBeneficiairePartAChargeListingModel = {
  __typename?: 'CommandeBeneficiairePartAChargeListingModel';
  CodeStatutAdministratif?: string;
  CommentairePrive?: string;
  CommentairePublic?: string;
  DateCommande?: any;
  IdBeneficiaire?: string;
  IdCommande?: number;
  IdDossierPrestation?: number;
  LibelleStatutAdministratif?: string;
  ListeFactures?: ArrayOfanyType;
  MatriculeBeneficiaire?: string;
  MontantTotal?: number;
  NomBeneficiaire?: string;
  ObjetCommande?: string;
  PrenomBeneficiaire?: string;
  Site?: string;
};

export type CommandeBeneficiairePartAChargeListingModelInput = {
  CodeStatutAdministratif?: string;
  CommentairePrive?: string;
  CommentairePublic?: string;
  DateCommande?: any;
  IdBeneficiaire?: string;
  IdCommande?: number;
  IdDossierPrestation?: number;
  LibelleStatutAdministratif?: string;
  ListeFactures?: ArrayOfanyTypeInput;
  MatriculeBeneficiaire?: string;
  MontantTotal?: number;
  NomBeneficiaire?: string;
  ObjetCommande?: string;
  PrenomBeneficiaire?: string;
  Site?: string;
};

export type CommandeFournisseurListingModel = {
  __typename?: 'CommandeFournisseurListingModel';
  AnyFileExported?: boolean;
  CodeStatutAdministratif?: string;
  CodeStatutReception?: string;
  CodeTypeActivite?: string;
  CommentairePrive?: string;
  CommentairePublic?: string;
  DateCommande?: any;
  DateDernierBonReception?: any;
  HaveLigneCommandeClientRattachee?: boolean;
  IdCommande?: number;
  IdDernierBonReception?: number;
  IdFournisseur?: number;
  IsDernierBonAnnule?: boolean;
  LibelleStatutAdministratif?: string;
  LibelleStatutReception?: string;
  ListeFactures?: ArrayOfanyType;
  ListeIdLigneCommande?: ArrayOfdecimal;
  MontantAcomptesTotal?: number;
  MontantFraisCommission?: number;
  MontantFraisEnvoi?: number;
  MontantRemise?: number;
  MontantTotal?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomFournisseur?: string;
  NomUtilisateurDernierBonReception?: string;
  ObjetCommande?: string;
  PrenomUtilisateurDernierBonReception?: string;
  QuantiteReceptionnee?: number;
  QuantiteTotale?: number;
  Status?: StatusDtoEnum;
  TypeDernierBonReception?: string;
};

export type CommandeFournisseurListingModelInput = {
  AnyFileExported?: boolean;
  CodeStatutAdministratif?: string;
  CodeStatutReception?: string;
  CodeTypeActivite?: string;
  CommentairePrive?: string;
  CommentairePublic?: string;
  DateCommande?: any;
  DateDernierBonReception?: any;
  HaveLigneCommandeClientRattachee?: boolean;
  IdCommande?: number;
  IdDernierBonReception?: number;
  IdFournisseur?: number;
  IsDernierBonAnnule?: boolean;
  LibelleStatutAdministratif?: string;
  LibelleStatutReception?: string;
  ListeFactures?: ArrayOfanyTypeInput;
  ListeIdLigneCommande?: ArrayOfdecimalInput;
  MontantAcomptesTotal?: number;
  MontantFraisCommission?: number;
  MontantFraisEnvoi?: number;
  MontantRemise?: number;
  MontantTotal?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomFournisseur?: string;
  NomUtilisateurDernierBonReception?: string;
  ObjetCommande?: string;
  PrenomUtilisateurDernierBonReception?: string;
  QuantiteReceptionnee?: number;
  QuantiteTotale?: number;
  Status?: StatusDtoEnum;
  TypeDernierBonReception?: string;
};

export type CommandeFournisseurPartAChargeListingModel = {
  __typename?: 'CommandeFournisseurPartAChargeListingModel';
  CodeStatutAdministratif?: string;
  CommentairePrive?: string;
  CommentairePublic?: string;
  DateCommande?: any;
  IdBeneficiaire?: number;
  IdCommande?: number;
  IdDossierPrestation?: number;
  IdFournisseur?: number;
  LibelleStatutAdministratif?: string;
  ListeFactures?: ArrayOfanyType;
  MatriculeBeneficiaire?: string;
  MontantAcomptesTotal?: number;
  MontantFraisCommission?: number;
  MontantFraisEnvoi?: number;
  MontantRemise?: number;
  MontantTotal?: number;
  NomBeneficiaire?: string;
  NomFournisseur?: string;
  ObjetCommande?: string;
  PrenomBeneficiaire?: string;
};

export type CommandeFournisseurPartAChargeListingModelInput = {
  CodeStatutAdministratif?: string;
  CommentairePrive?: string;
  CommentairePublic?: string;
  DateCommande?: any;
  IdBeneficiaire?: number;
  IdCommande?: number;
  IdDossierPrestation?: number;
  IdFournisseur?: number;
  LibelleStatutAdministratif?: string;
  ListeFactures?: ArrayOfanyTypeInput;
  MatriculeBeneficiaire?: string;
  MontantAcomptesTotal?: number;
  MontantFraisCommission?: number;
  MontantFraisEnvoi?: number;
  MontantRemise?: number;
  MontantTotal?: number;
  NomBeneficiaire?: string;
  NomFournisseur?: string;
  ObjetCommande?: string;
  PrenomBeneficiaire?: string;
};

export type CommandeInfoReglementModel = {
  __typename?: 'CommandeInfoReglementModel';
  IdCommande?: number;
  IdMandat?: number;
  IdMoyenPaiement?: number;
  IdRib?: number;
  IsAcompte?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  NomTire?: string;
  NumCheque?: string;
  Status?: StatusDtoEnum;
};

export type CommandeInfoReglementModelInput = {
  IdCommande?: number;
  IdMandat?: number;
  IdMoyenPaiement?: number;
  IdRib?: number;
  IsAcompte?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  NomTire?: string;
  NumCheque?: string;
  Status?: StatusDtoEnum;
};

export type CommandeLibreModelDto = {
  __typename?: 'CommandeLibreModelDTO';
  CodeActivite?: string;
  EnteteDevisCommandeForCommandeLibreModel?: EnteteDevisCommandeForCommandeLibreModeleDto;
  IdBenef?: number;
  IdCommande?: number;
  IdDelegation?: number;
  IdFournisseur?: number;
  IdPointVente?: number;
  ListeIdCommande?: ArrayOfdecimal;
  ListeLigneCommandeLibreModel?: ArrayOfLigneCommandeLibreModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommandeLibreModelDtoInput = {
  CodeActivite?: string;
  EnteteDevisCommandeForCommandeLibreModel?: EnteteDevisCommandeForCommandeLibreModeleDtoInput;
  IdBenef?: number;
  IdCommande?: number;
  IdDelegation?: number;
  IdFournisseur?: number;
  IdPointVente?: number;
  ListeIdCommande?: ArrayOfdecimalInput;
  ListeLigneCommandeLibreModel?: ArrayOfLigneCommandeLibreModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommandeListeModaliteReglementModel = {
  __typename?: 'CommandeListeModaliteReglementModel';
  ListeModeleEcheancier?: ArrayOfModeleEcheancierDefautModel;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementDefautModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommandeListeModaliteReglementModelInput = {
  ListeModeleEcheancier?: ArrayOfModeleEcheancierDefautModelInput;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementDefautModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommandeLivraisonModel = {
  __typename?: 'CommandeLivraisonModel';
  AdresseANCV?: string;
  Benef?: BenefDto;
  BenefId?: number;
  BenefMat?: string;
  BenefNom?: string;
  BenefPrenom?: string;
  CodeLivraison?: string;
  DateCommande?: any;
  IdActivite?: number;
  IdCommande?: number;
  IdDossier?: number;
  IdFournisseur?: number;
  IsCommandeEnLigne?: boolean;
  IsFactureRecue?: boolean;
  IsSelected?: boolean;
  ListIdLgnCmd?: ArrayOfdecimal;
  ListeCodesModesLivraison?: ArrayOfstring;
  ListeDescArticles?: ArrayOfstring;
  ListeLibellesModesLivraison?: ArrayOfstring;
  MontantTotal?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomFournisseur?: string;
  NomSiteDuBenef?: string;
  ObjetCommande?: string;
  ResteARegle?: number;
  SommeQteALivrer?: number;
  Status?: StatusDtoEnum;
  StatutLivraison?: string;
  TypeCommande?: string;
};

export type CommandeLivraisonModelInput = {
  AdresseANCV?: string;
  Benef?: BenefDtoInput;
  BenefId?: number;
  BenefMat?: string;
  BenefNom?: string;
  BenefPrenom?: string;
  CodeLivraison?: string;
  DateCommande?: any;
  IdActivite?: number;
  IdCommande?: number;
  IdDossier?: number;
  IdFournisseur?: number;
  IsCommandeEnLigne?: boolean;
  IsFactureRecue?: boolean;
  IsSelected?: boolean;
  ListIdLgnCmd?: ArrayOfdecimalInput;
  ListeCodesModesLivraison?: ArrayOfstringInput;
  ListeDescArticles?: ArrayOfstringInput;
  ListeLibellesModesLivraison?: ArrayOfstringInput;
  MontantTotal?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomFournisseur?: string;
  NomSiteDuBenef?: string;
  ObjetCommande?: string;
  ResteARegle?: number;
  SommeQteALivrer?: number;
  Status?: StatusDtoEnum;
  StatutLivraison?: string;
  TypeCommande?: string;
};

export type CommandeModaliteReglementAffichageModel = {
  __typename?: 'CommandeModaliteReglementAffichageModel';
  EcheancierLibelle?: string;
  IdCommande?: number;
  IsDisabled?: boolean;
  MoyenPaiementLibelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommandeModaliteReglementAffichageModelInput = {
  EcheancierLibelle?: string;
  IdCommande?: number;
  IsDisabled?: boolean;
  MoyenPaiementLibelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommandeModaliteReglementBaseModel = {
  __typename?: 'CommandeModaliteReglementBaseModel';
  IdCommande?: number;
  IdModeleEcheancier?: number;
  IdMoyenPaiement?: number;
  IdRib?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommandeModaliteReglementBaseModelInput = {
  IdCommande?: number;
  IdModeleEcheancier?: number;
  IdMoyenPaiement?: number;
  IdRib?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommandeModaliteReglementSaveInput = {
  IdCommande?: number;
  IdCommandeModaliteReglement?: number;
  IdModeleEcheancier?: number;
  IdMoyenPaiement?: number;
  IdRib?: number;
  IdUser?: number;
  IsEnLigne?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommandeReglementInfosStateModel = {
  __typename?: 'CommandeReglementInfosStateModel';
  AreEcheanceGenerated?: boolean;
  IsFactureCommandeSoldee?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommandeReglementInfosStateModelInput = {
  AreEcheanceGenerated?: boolean;
  IsFactureCommandeSoldee?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommentaireModerationModel = {
  __typename?: 'CommentaireModerationModel';
  Commentaire?: string;
  DateCreation?: any;
  DateValidation?: any;
  IdArticle?: number;
  IdCommentaire?: number;
  IsAnonyme?: boolean;
  IsClos?: boolean;
  IsEnLigne?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBenef?: string;
  PrenomBenef?: string;
  Status?: StatusDtoEnum;
  TitreArticle?: string;
};

export type CommentaireModerationModelInput = {
  Commentaire?: string;
  DateCreation?: any;
  DateValidation?: any;
  IdArticle?: number;
  IdCommentaire?: number;
  IsAnonyme?: boolean;
  IsClos?: boolean;
  IsEnLigne?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBenef?: string;
  PrenomBenef?: string;
  Status?: StatusDtoEnum;
  TitreArticle?: string;
};

export type CommissionCommissionModel = {
  __typename?: 'CommissionCommissionModel';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommissionCommissionModelInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommissionDto = {
  __typename?: 'CommissionDTO';
  CEDelegation?: CeDelegationDto;
  Code?: string;
  Description?: string;
  Id?: number;
  IsClos?: boolean;
  IsSelected?: boolean;
  Libelle?: string;
  ListeUsersCommission?: ArrayOfUserCommissionDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommissionDtoInput = {
  CEDelegation?: CeDelegationDtoInput;
  Code?: string;
  Description?: string;
  Id?: number;
  IsClos?: boolean;
  IsSelected?: boolean;
  Libelle?: string;
  ListeUsersCommission?: ArrayOfUserCommissionDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommissionMailModel = {
  __typename?: 'CommissionMailModel';
  AdresseMail?: string;
  IdCommission?: number;
  LibelleCommission?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommissionMailModelInput = {
  AdresseMail?: string;
  IdCommission?: number;
  LibelleCommission?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CommissionModelWithclos = {
  __typename?: 'CommissionModelWithclos';
  IdCommission?: number;
  IsClos?: boolean;
  IsSelected?: boolean;
  LibelleCommission?: string;
};

export type CommissionModelWithclosInput = {
  IdCommission?: number;
  IsClos?: boolean;
  IsSelected?: boolean;
  LibelleCommission?: string;
};

export type CommunActiviteDirectoModel = {
  __typename?: 'CommunActiviteDirectoModel';
  Id?: number;
  Libelle?: string;
};

export type CommunActiviteDirectoModelInput = {
  Id?: number;
  Libelle?: string;
};

export type CommunArticleActivitePortailModel = {
  __typename?: 'CommunArticleActivitePortailModel';
  Id?: number;
  IdActivite?: number;
  IdFamille?: number;
  IdProduit?: number;
  Libelle?: string;
};

export type CommunArticleActivitePortailModelInput = {
  Id?: number;
  IdActivite?: number;
  IdFamille?: number;
  IdProduit?: number;
  Libelle?: string;
};

export type CommunArticleEditorialPortailModel = {
  __typename?: 'CommunArticleEditorialPortailModel';
  Id?: number;
  Libelle?: string;
};

export type CommunArticleEditorialPortailModelInput = {
  Id?: number;
  Libelle?: string;
};

export type CommunCeDelegationModel = {
  __typename?: 'CommunCEDelegationModel';
  Id?: number;
  Libelle?: string;
};

export type CommunCeDelegationModelInput = {
  Id?: number;
  Libelle?: string;
};

export type CommunFamilleDirectoModel = {
  __typename?: 'CommunFamilleDirectoModel';
  Id?: number;
  IdActivite?: number;
  Libelle?: string;
};

export type CommunFamilleDirectoModelInput = {
  Id?: number;
  IdActivite?: number;
  Libelle?: string;
};

export type CommunProduitPortailModel = {
  __typename?: 'CommunProduitPortailModel';
  Id?: number;
  IdActivite?: number;
  IdFamille?: number;
  Libelle?: string;
};

export type CommunProduitPortailModelInput = {
  Id?: number;
  IdActivite?: number;
  IdFamille?: number;
  Libelle?: string;
};

export type CompositionChequeModelInput = {
  IdArticleCheque?: number;
  IdBorne?: number;
  IdCheque?: number;
  NombreCheques?: number;
};

export type ComptaArticleImputerEpargneModel = {
  __typename?: 'ComptaArticleImputerEpargneModel';
  IdCollectifActiviteArticleLie?: number;
  IdCollectifPMV?: number;
  IdJournalOD?: number;
};

export type ComptaArticleImputerEpargneModelInput = {
  IdCollectifActiviteArticleLie?: number;
  IdCollectifPMV?: number;
  IdJournalOD?: number;
};

export type ComptaCaisseModelDto = {
  __typename?: 'ComptaCaisseModelDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
};

export type ComptaCaisseModelDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
};

export type ComptaCompteBancaireModelDto = {
  __typename?: 'ComptaCompteBancaireModelDTO';
  AutoriseEncaissement?: boolean;
  AutoriseRemboursement?: boolean;
  Id?: number;
  IdCompte?: number;
  IsFonctionnement?: boolean;
  IsSocial?: boolean;
  Libelle?: string;
};

export type ComptaCompteBancaireModelDtoInput = {
  AutoriseEncaissement?: boolean;
  AutoriseRemboursement?: boolean;
  Id?: number;
  IdCompte?: number;
  IsFonctionnement?: boolean;
  IsSocial?: boolean;
  Libelle?: string;
};

export type ComptaCompteModelDto = {
  __typename?: 'ComptaCompteModelDTO';
  Id?: number;
  IsCollectifAcompteClient?: boolean;
  IsCollectifAcompteFournisseur?: boolean;
  IsCollectifCCF?: boolean;
  IsCollectifClient?: boolean;
  IsCollectifFournisseur?: boolean;
  IsCollectifPMV?: boolean;
  IsCollectifPret?: boolean;
  IsCredit?: boolean;
  IsDebit?: boolean;
  IsFonctionnement?: boolean;
  IsSocial?: boolean;
  Libelle?: string;
  Numero?: string;
};

export type ComptaCompteModelDtoInput = {
  Id?: number;
  IsCollectifAcompteClient?: boolean;
  IsCollectifAcompteFournisseur?: boolean;
  IsCollectifCCF?: boolean;
  IsCollectifClient?: boolean;
  IsCollectifFournisseur?: boolean;
  IsCollectifPMV?: boolean;
  IsCollectifPret?: boolean;
  IsCredit?: boolean;
  IsDebit?: boolean;
  IsFonctionnement?: boolean;
  IsSocial?: boolean;
  Libelle?: string;
  Numero?: string;
};

export type ComptaEcritureModelDtoInput = {
  Banque?: string;
  Caisse?: ComptaCaisseModelDtoInput;
  Commentaire?: string;
  Compte?: ComptaCompteModelDtoInput;
  CompteBancaire?: ComptaCompteBancaireModelDtoInput;
  CompteCollectif?: ComptaCompteModelDtoInput;
  DateEcheance?: any;
  DateEcriture?: any;
  Exercice?: ComptaExerciceModelDtoInput;
  IdBeneficiaire?: number;
  IdDelegation?: number;
  IdFournisseur?: number;
  IdModeleEcriture?: number;
  IdRib?: number;
  IsDateLieeToExercice?: boolean;
  Journal?: ComptaJournalModelInput;
  Lettre?: string;
  Libelle?: string;
  ListePJ?: ArrayOfComptaPjComptablesModelInput;
  Montant?: number;
  MoyenPaiement?: ComptaMoyenPaiementModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NomTiers?: string;
  NomTire?: string;
  NumeroCheque?: string;
  NumeroPiece?: string;
  NumeroReference?: string;
  Status?: StatusDtoEnum;
  TypeEcriture?: ComptaTypeEcrituresEnum;
};

export type ComptaExerciceModelDto = {
  __typename?: 'ComptaExerciceModelDTO';
  Code?: string;
  DateDebut?: any;
  DateFin?: any;
  Id?: number;
};

export type ComptaExerciceModelDtoInput = {
  Code?: string;
  DateDebut?: any;
  DateFin?: any;
  Id?: number;
};

export type ComptaJournalModel = {
  __typename?: 'ComptaJournalModel';
  CodeJournal?: string;
  CodeTypeJournal?: string;
  Id?: number;
  IsSocial?: boolean;
  Libelle?: string;
};

export type ComptaJournalModelInput = {
  CodeJournal?: string;
  CodeTypeJournal?: string;
  Id?: number;
  IsSocial?: boolean;
  Libelle?: string;
};

export type ComptaMouvementComptableModelDto = {
  __typename?: 'ComptaMouvementComptableModelDTO';
  Banque?: string;
  BicIban?: string;
  CEFonctionneEnArreteCaisse?: boolean;
  CleIban?: string;
  CleRib?: string;
  CodeBanque?: string;
  CodeCompte?: string;
  CodeGuichet?: string;
  CodeJournal?: string;
  CodeMoyenPaiementEcr?: string;
  CodePays?: string;
  Commentaire?: string;
  Compte?: ComptaCompteModelDto;
  DateCreation?: any;
  DateDerniereOperationMandat?: any;
  DateEcheance?: any;
  DateEcriture?: any;
  DateRemisEnBanque?: any;
  Iban?: string;
  Id?: number;
  IdBeneficiaire?: number;
  IdCECible?: number;
  IdCompte?: number;
  IdEcheancier?: number;
  IdEcriture?: number;
  IdExercice?: number;
  IdFacture?: number;
  IdFournisseur?: number;
  IdMandat?: number;
  IdRib?: number;
  IdUtilisateur?: number;
  IsArreteCaisse?: boolean;
  IsInModif?: boolean;
  IsNePasEncaisser?: boolean;
  IsRapproche?: boolean;
  IsRemisBanque?: boolean;
  IsRibClos?: boolean;
  IsSimulee?: boolean;
  Lettre?: string;
  LibelleCompte?: string;
  LibelleMouvement?: string;
  ListeClesRepartitions?: ArrayOfCleRepartitionModelDto;
  MPFonctionneArreteCaisse?: boolean;
  MatriculeBenefCompteTiers?: string;
  MatriculeBenefEcriture?: string;
  MonatantProratiser?: number;
  Montant?: number;
  MontantCredit?: number;
  MontantDebit?: number;
  MotifSEPA?: string;
  NomActivite?: string;
  NomBenefCompteTiers?: string;
  NomBenefEcriture?: string;
  NomCE?: string;
  NomFamille?: string;
  NomFournisseurCompteTiers?: string;
  NomFournisseurEcriture?: string;
  NomProduit?: string;
  NomTire?: string;
  NomUtilisateurEcriture?: string;
  NumeroBordereauRemisEnBanque?: string;
  NumeroCheque?: string;
  NumeroCompte?: string;
  NumeroFacture?: string;
  NumeroPiece?: string;
  NumeroReference?: string;
  NumeroReferenceMandat?: string;
  PrenomBenefCompteTiers?: string;
  PrenomBenefEcriture?: string;
  PrenomUtilisateurEcriture?: string;
  Sens?: string;
  TypeBudget?: string;
};

export type ComptaMouvementComptableModelDtoInput = {
  Banque?: string;
  BicIban?: string;
  CEFonctionneEnArreteCaisse?: boolean;
  CleIban?: string;
  CleRib?: string;
  CodeBanque?: string;
  CodeCompte?: string;
  CodeGuichet?: string;
  CodeJournal?: string;
  CodeMoyenPaiementEcr?: string;
  CodePays?: string;
  Commentaire?: string;
  Compte?: ComptaCompteModelDtoInput;
  DateCreation?: any;
  DateDerniereOperationMandat?: any;
  DateEcheance?: any;
  DateEcriture?: any;
  DateRemisEnBanque?: any;
  Iban?: string;
  Id?: number;
  IdBeneficiaire?: number;
  IdCECible?: number;
  IdCompte?: number;
  IdEcheancier?: number;
  IdEcriture?: number;
  IdExercice?: number;
  IdFacture?: number;
  IdFournisseur?: number;
  IdMandat?: number;
  IdRib?: number;
  IdUtilisateur?: number;
  IsArreteCaisse?: boolean;
  IsInModif?: boolean;
  IsNePasEncaisser?: boolean;
  IsRapproche?: boolean;
  IsRemisBanque?: boolean;
  IsRibClos?: boolean;
  IsSimulee?: boolean;
  Lettre?: string;
  LibelleCompte?: string;
  LibelleMouvement?: string;
  ListeClesRepartitions?: ArrayOfCleRepartitionModelDtoInput;
  MPFonctionneArreteCaisse?: boolean;
  MatriculeBenefCompteTiers?: string;
  MatriculeBenefEcriture?: string;
  MonatantProratiser?: number;
  Montant?: number;
  MontantCredit?: number;
  MontantDebit?: number;
  MotifSEPA?: string;
  NomActivite?: string;
  NomBenefCompteTiers?: string;
  NomBenefEcriture?: string;
  NomCE?: string;
  NomFamille?: string;
  NomFournisseurCompteTiers?: string;
  NomFournisseurEcriture?: string;
  NomProduit?: string;
  NomTire?: string;
  NomUtilisateurEcriture?: string;
  NumeroBordereauRemisEnBanque?: string;
  NumeroCheque?: string;
  NumeroCompte?: string;
  NumeroFacture?: string;
  NumeroPiece?: string;
  NumeroReference?: string;
  NumeroReferenceMandat?: string;
  PrenomBenefCompteTiers?: string;
  PrenomBenefEcriture?: string;
  PrenomUtilisateurEcriture?: string;
  Sens?: string;
  TypeBudget?: string;
};

export type ComptaMoyenPaiementModelDto = {
  __typename?: 'ComptaMoyenPaiementModelDTO';
  Code?: string;
  Id?: number;
  IsFiduciaire?: boolean;
  IsUtilisableAchat?: boolean;
  IsUtilisableVente?: boolean;
  Libelle?: string;
};

export type ComptaMoyenPaiementModelDtoInput = {
  Code?: string;
  Id?: number;
  IsFiduciaire?: boolean;
  IsUtilisableAchat?: boolean;
  IsUtilisableVente?: boolean;
  Libelle?: string;
};

export type ComptaPjComptableConsultationModel = {
  __typename?: 'ComptaPJComptableConsultationModel';
  Extension?: string;
  IdFile?: number;
  IdFileLink?: number;
  IdPieceComptable?: number;
  Libelle?: string;
  Token?: string;
  Url?: string;
};

export type ComptaPjComptableConsultationModelInput = {
  Extension?: string;
  IdFile?: number;
  IdFileLink?: number;
  IdPieceComptable?: number;
  Libelle?: string;
  Token?: string;
  Url?: string;
};

export type ComptaPjComptablesModel = {
  __typename?: 'ComptaPJComptablesModel';
  Extension?: string;
  FileName?: string;
  FluxFichier?: string;
  IdFile?: number;
  IdFileLink?: number;
  IdPieceComptable?: number;
  IsDeleted?: boolean;
  Libelle?: string;
  Token?: string;
  Url?: string;
};

export type ComptaPjComptablesModelInput = {
  Extension?: string;
  FileName?: string;
  FluxFichier?: string;
  IdFile?: number;
  IdFileLink?: number;
  IdPieceComptable?: number;
  IsDeleted?: boolean;
  Libelle?: string;
  Token?: string;
  Url?: string;
};

export type ComptaReglesModificationMouvementModelDto = {
  __typename?: 'ComptaReglesModificationMouvementModelDTO';
  IsModifiableCompteImputation?: boolean;
  IsModifiableCompteTiers?: boolean;
  IsModifiableInfosReglement?: boolean;
  IsModifiableLibComNumRef?: boolean;
  IsModifiableMontantSens?: boolean;
  IsModifiableRepartition?: boolean;
};

export type ComptaReglesModificationMouvementModelDtoInput = {
  IsModifiableCompteImputation?: boolean;
  IsModifiableCompteTiers?: boolean;
  IsModifiableInfosReglement?: boolean;
  IsModifiableLibComNumRef?: boolean;
  IsModifiableMontantSens?: boolean;
  IsModifiableRepartition?: boolean;
};

export type ComptaTotalSommeCreditDebitMouvementComptableModelDto = {
  __typename?: 'ComptaTotalSommeCreditDebitMouvementComptableModelDTO';
  SommeCreditMouvement?: number;
  SommeDebitMouvement?: number;
};

export type ComptaTotalSommeCreditDebitMouvementComptableModelDtoInput = {
  SommeCreditMouvement?: number;
  SommeDebitMouvement?: number;
};

export enum ComptaTypeEcrituresEnum {
  Aucun = 'Aucun',
  Facture = 'Facture',
  Manuelle = 'Manuelle',
  Reglement = 'Reglement'
}

export type ComptabiliteEpargnesActiviteModel = {
  __typename?: 'ComptabiliteEpargnesActiviteModel';
  IdActivite?: number;
  IdCollectifAttente?: number;
  IdCollectifPMV?: number;
  IdCompteBancaireEpargne?: number;
  IdCompteChargeAbondement?: number;
  IdJournalAbondement?: number;
  IdJournalEpargne?: number;
  IdJournalPMV?: number;
  ListePlanSectionAnalytique?: ArrayOfPlanWithSectionsAnalytiquesModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ComptabiliteEpargnesActiviteModelInput = {
  IdActivite?: number;
  IdCollectifAttente?: number;
  IdCollectifPMV?: number;
  IdCompteBancaireEpargne?: number;
  IdCompteChargeAbondement?: number;
  IdJournalAbondement?: number;
  IdJournalEpargne?: number;
  IdJournalPMV?: number;
  ListePlanSectionAnalytique?: ArrayOfPlanWithSectionsAnalytiquesModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ComptabiliteEpargnesArticleModel = {
  __typename?: 'ComptabiliteEpargnesArticleModel';
  IdArticle?: number;
  IdCollectifAttente?: number;
  IdCollectifPMV?: number;
  IdCompteBancaireEpargne?: number;
  IdCompteChargeAbondement?: number;
  IdJournalAbondement?: number;
  IdJournalEpargne?: number;
  IdJournalPMV?: number;
  ListePlanSectionAnalytique?: ArrayOfPlanWithSectionsAnalytiquesModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ComptabiliteEpargnesArticleModelInput = {
  IdArticle?: number;
  IdCollectifAttente?: number;
  IdCollectifPMV?: number;
  IdCompteBancaireEpargne?: number;
  IdCompteChargeAbondement?: number;
  IdJournalAbondement?: number;
  IdJournalEpargne?: number;
  IdJournalPMV?: number;
  ListePlanSectionAnalytique?: ArrayOfPlanWithSectionsAnalytiquesModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ComptabiliteEpargnesBaseModel = {
  __typename?: 'ComptabiliteEpargnesBaseModel';
  IdCollectifAttente?: number;
  IdCollectifPMV?: number;
  IdCompteBancaireEpargne?: number;
  IdCompteChargeAbondement?: number;
  IdJournalAbondement?: number;
  IdJournalEpargne?: number;
  IdJournalPMV?: number;
  ListePlanSectionAnalytique?: ArrayOfPlanWithSectionsAnalytiquesModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ComptabiliteEpargnesBaseModelInput = {
  IdCollectifAttente?: number;
  IdCollectifPMV?: number;
  IdCompteBancaireEpargne?: number;
  IdCompteChargeAbondement?: number;
  IdJournalAbondement?: number;
  IdJournalEpargne?: number;
  IdJournalPMV?: number;
  ListePlanSectionAnalytique?: ArrayOfPlanWithSectionsAnalytiquesModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ComptabiliteJournalCompteEtBancaireModel = {
  __typename?: 'ComptabiliteJournalCompteEtBancaireModel';
  IdCollectifAttente?: number;
  IdCompteBancaire?: number;
  IdJournalTresorerie?: number;
};

export type ComptabiliteJournalCompteEtBancaireModelInput = {
  IdCollectifAttente?: number;
  IdCompteBancaire?: number;
  IdJournalTresorerie?: number;
};

export type Compte511AgregCompte511AgregModel = {
  __typename?: 'Compte511AgregCompte511AgregModel';
  CodeMoyenPaiement?: string;
  IdCompte511Agreg?: number;
  IdMoyenPaiement?: number;
  IsModifiable?: boolean;
  LibelleCompte511Agreg?: string;
  LibelleMoyenPaiement?: string;
  NumeroCompte511Agreg?: string;
};

export type Compte511AgregCompte511AgregModelInput = {
  CodeMoyenPaiement?: string;
  IdCompte511Agreg?: number;
  IdMoyenPaiement?: number;
  IsModifiable?: boolean;
  LibelleCompte511Agreg?: string;
  LibelleMoyenPaiement?: string;
  NumeroCompte511Agreg?: string;
};

export type Compte511AgregDto = {
  __typename?: 'Compte511AgregDTO';
  Compte?: CompteDto;
  CompteBancaire?: CompteBancaireDto;
  MoyenPaiement?: MoyenPaiementDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type Compte511AgregDtoInput = {
  Compte?: CompteDtoInput;
  CompteBancaire?: CompteBancaireDtoInput;
  MoyenPaiement?: MoyenPaiementDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type Compte511Compte511BaseModelInput = {
  IdCaisse?: number;
  IdCompteAttente?: number;
  IdCompteBancaire?: number;
  IdMoyenPaiement?: number;
};

export type Compte511Compte511ParametrageModel = {
  __typename?: 'Compte511Compte511ParametrageModel';
  Compte511?: CompteBaseModel;
  IdCaisse?: number;
  IdCompteAttente?: number;
  IdCompteBancaire?: number;
  IdMoyenPaiement?: number;
  IsModifiable?: boolean;
  LibelleCaisse?: string;
  LibelleCompteBancaire?: string;
  LibelleMoyenPaiement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompteBancaire?: string;
  Status?: StatusDtoEnum;
};

export type Compte511Compte511ParametrageModelInput = {
  Compte511?: CompteBaseModelInput;
  IdCaisse?: number;
  IdCompteAttente?: number;
  IdCompteBancaire?: number;
  IdMoyenPaiement?: number;
  IsModifiable?: boolean;
  LibelleCaisse?: string;
  LibelleCompteBancaire?: string;
  LibelleMoyenPaiement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompteBancaire?: string;
  Status?: StatusDtoEnum;
};

export type Compte511CriteresCompte511ModelInput = {
  IdCaisse?: number;
  IdCompteBancaire?: number;
  IdDelegation?: number;
  IdDelegationOuDelegationGlobale?: number;
  IdMoyenPaiement?: number;
};

export type Compte511InitCompte511Model = {
  __typename?: 'Compte511InitCompte511Model';
  ListeCompte511?: ArrayOfCompte511Compte511ParametrageModel;
  ListeCompteBase?: ArrayOfCompteBaseModel;
};

export type Compte511InitCompte511ModelInput = {
  ListeCompte511?: ArrayOfCompte511Compte511ParametrageModelInput;
  ListeCompteBase?: ArrayOfCompteBaseModelInput;
};

export type Compte511MouvementModel = {
  __typename?: 'Compte511MouvementModel';
  IdMouvement?: number;
  ListCompte511?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type Compte511MouvementModelInput = {
  IdMouvement?: number;
  ListCompte511?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CompteAssociationTvaModel = {
  __typename?: 'CompteAssociationTVAModel';
  ClasseCompte?: string;
  IdCompte?: number;
  LibelleCompte?: string;
  LibelleModeleAssocie?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompte?: string;
  RacineCompte?: string;
  SousClasseCompte?: string;
  Status?: StatusDtoEnum;
};

export type CompteAssociationTvaModelInput = {
  ClasseCompte?: string;
  IdCompte?: number;
  LibelleCompte?: string;
  LibelleModeleAssocie?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompte?: string;
  RacineCompte?: string;
  SousClasseCompte?: string;
  Status?: StatusDtoEnum;
};

export type CompteBancaireCompteBancaireBaseModel = {
  __typename?: 'CompteBancaireCompteBancaireBaseModel';
  IdCompteBancaire?: number;
  LibelleCompteBancaire?: string;
  NumeroCompteBancaire?: string;
};

export type CompteBancaireCompteBancaireBaseModelInput = {
  IdCompteBancaire?: number;
  LibelleCompteBancaire?: string;
  NumeroCompteBancaire?: string;
};

export type CompteBancaireDto = {
  __typename?: 'CompteBancaireDTO';
  Banque?: BanqueDto;
  Code?: string;
  CodeCompte?: string;
  Compte?: CompteDto;
  CompteFraisCB?: CompteDto;
  Description?: string;
  FraisCB_IdcBord?: boolean;
  FraisCB_Idclal?: boolean;
  FraisCB_MntFixe?: number;
  FraisCB_MntPourc?: number;
  Id?: number;
  IsCloture?: boolean;
  IsEntree?: boolean;
  IsFonctionnement?: boolean;
  IsLieeActivite?: boolean;
  IsSocial?: boolean;
  IsSortie?: boolean;
  JournalFonctionnement?: JournalDto;
  JournalSocial?: JournalDto;
  Libelle?: string;
  ListeActiviteCompteBancaire?: ArrayOfActiviteCompteBancaireDto;
  ListeCE?: ArrayOfCeDelegationDto;
  ListeCompte511Agreg?: ArrayOfCompte511AgregDto;
  ListeJournaux?: ArrayOfJournalDto;
  ListeRibMandat?: ArrayOfRibMandatDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroEmetteur?: string;
  NumeroICS?: string;
  Rib?: RibDto;
  Status?: StatusDtoEnum;
};

export type CompteBancaireDtoInput = {
  Banque?: BanqueDtoInput;
  Code?: string;
  CodeCompte?: string;
  Compte?: CompteDtoInput;
  CompteFraisCB?: CompteDtoInput;
  Description?: string;
  FraisCB_IdcBord?: boolean;
  FraisCB_Idclal?: boolean;
  FraisCB_MntFixe?: number;
  FraisCB_MntPourc?: number;
  Id?: number;
  IsCloture?: boolean;
  IsEntree?: boolean;
  IsFonctionnement?: boolean;
  IsLieeActivite?: boolean;
  IsSocial?: boolean;
  IsSortie?: boolean;
  JournalFonctionnement?: JournalDtoInput;
  JournalSocial?: JournalDtoInput;
  Libelle?: string;
  ListeActiviteCompteBancaire?: ArrayOfActiviteCompteBancaireDtoInput;
  ListeCE?: ArrayOfCeDelegationDtoInput;
  ListeCompte511Agreg?: ArrayOfCompte511AgregDtoInput;
  ListeJournaux?: ArrayOfJournalDtoInput;
  ListeRibMandat?: ArrayOfRibMandatDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroEmetteur?: string;
  NumeroICS?: string;
  Rib?: RibDtoInput;
  Status?: StatusDtoEnum;
};

export type CompteBancaireModelDto = {
  __typename?: 'CompteBancaireModelDTO';
  Code?: string;
  IdBanque?: number;
  IdCompteBancaire?: number;
  IsClos?: boolean;
  LibelleBanque?: string;
  LibelleCompteBancaire?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CompteBancaireModelDtoInput = {
  Code?: string;
  IdBanque?: number;
  IdCompteBancaire?: number;
  IsClos?: boolean;
  LibelleBanque?: string;
  LibelleCompteBancaire?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CompteBancaireWithIcs = {
  __typename?: 'CompteBancaireWithICS';
  IdCompteBancaire?: number;
  LibelleCompteBancaire?: string;
  NumeroICS?: string;
};

export type CompteBancaireWithIcsInput = {
  IdCompteBancaire?: number;
  LibelleCompteBancaire?: string;
  NumeroICS?: string;
};

export type CompteBaseModel = {
  __typename?: 'CompteBaseModel';
  IdCompte?: number;
  LibelleCompte?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompte?: string;
  Status?: StatusDtoEnum;
};

export type CompteBaseModelInput = {
  IdCompte?: number;
  LibelleCompte?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompte?: string;
  Status?: StatusDtoEnum;
};

export type CompteClasseDto = {
  __typename?: 'CompteClasseDTO';
  ID?: number;
  Libelle?: string;
  ListeSousClasse?: ArrayOfCompteSousClasseDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Numero?: string;
  Status?: StatusDtoEnum;
};

export type CompteClasseDtoInput = {
  ID?: number;
  Libelle?: string;
  ListeSousClasse?: ArrayOfCompteSousClasseDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Numero?: string;
  Status?: StatusDtoEnum;
};

export type CompteClotureForTresorie = {
  __typename?: 'CompteClotureForTresorie';
  IdCompte?: number;
  LibelleCompte?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompte?: string;
  SommeMvtCredit?: number;
  SommeMvtDebit?: number;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
};

export type CompteClotureForTresorieInput = {
  IdCompte?: number;
  LibelleCompte?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompte?: string;
  SommeMvtCredit?: number;
  SommeMvtDebit?: number;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
};

export type CompteCollectifModel = {
  __typename?: 'CompteCollectifModel';
  IdCompte?: number;
  IsAgregateur?: boolean;
  IsCollectifAcompteFournisseur?: boolean;
  IsCollectifAcomptefClient?: boolean;
  IsCollectifCCF?: boolean;
  IsCollectifClient?: boolean;
  IsCollectifFournisseur?: boolean;
  IsCollectifMoyenPaiement?: boolean;
  IsCollectifPMV?: boolean;
  IsCollectifPret?: boolean;
  LibelleCompte?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompte?: string;
  Status?: StatusDtoEnum;
};

export type CompteCollectifModelInput = {
  IdCompte?: number;
  IsAgregateur?: boolean;
  IsCollectifAcompteFournisseur?: boolean;
  IsCollectifAcomptefClient?: boolean;
  IsCollectifCCF?: boolean;
  IsCollectifClient?: boolean;
  IsCollectifFournisseur?: boolean;
  IsCollectifMoyenPaiement?: boolean;
  IsCollectifPMV?: boolean;
  IsCollectifPret?: boolean;
  LibelleCompte?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompte?: string;
  Status?: StatusDtoEnum;
};

export type CompteCourantADebiterOuCrediterModelDto = {
  __typename?: 'CompteCourantADebiterOuCrediterModelDTO';
  DateAlimentation?: any;
  DateEcheance?: any;
  Iban?: string;
  IdBeneficiaire?: number;
  IdCompte?: number;
  IdCompteBancaire?: number;
  IdCompteReglement?: number;
  IdDelegation?: number;
  IdExercice?: number;
  IdFournisseur?: number;
  IdJournal?: number;
  IdMoyenPayement?: number;
  IdRib?: number;
  IsDateLieeToExercice?: boolean;
  IsFonctionnement?: boolean;
  IsFromEcritureManuelle?: boolean;
  IsSocial?: boolean;
  IsVirementCptOriginal?: boolean;
  Libelle?: string;
  ListePJ?: ArrayOfComptaPjComptablesModel;
  MontantCrediterOuDebiter?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumCheque?: string;
  NumPiece?: string;
  NumRef?: string;
  NumeroCompte?: string;
  Remarque?: string;
  Solde?: number;
  Status?: StatusDtoEnum;
  TypeEcriture?: string;
};

export type CompteCourantADebiterOuCrediterModelDtoInput = {
  DateAlimentation?: any;
  DateEcheance?: any;
  Iban?: string;
  IdBeneficiaire?: number;
  IdCompte?: number;
  IdCompteBancaire?: number;
  IdCompteReglement?: number;
  IdDelegation?: number;
  IdExercice?: number;
  IdFournisseur?: number;
  IdJournal?: number;
  IdMoyenPayement?: number;
  IdRib?: number;
  IsDateLieeToExercice?: boolean;
  IsFonctionnement?: boolean;
  IsFromEcritureManuelle?: boolean;
  IsSocial?: boolean;
  IsVirementCptOriginal?: boolean;
  Libelle?: string;
  ListePJ?: ArrayOfComptaPjComptablesModelInput;
  MontantCrediterOuDebiter?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumCheque?: string;
  NumPiece?: string;
  NumRef?: string;
  NumeroCompte?: string;
  Remarque?: string;
  Solde?: number;
  Status?: StatusDtoEnum;
  TypeEcriture?: string;
};

export type CompteDto = {
  __typename?: 'CompteDTO';
  AccepteLettrage?: boolean;
  Beneficiaire?: BenefDto;
  CEDelegation?: CeDelegationDto;
  Code?: string;
  Commentaire?: string;
  CompteBancaire?: CompteBancaireDto;
  CptSection?: CompteSectionDto;
  DateCloture?: any;
  FonctionneCredit?: boolean;
  FonctionneDebit?: boolean;
  Fournisseur?: FournisseurDto;
  IDFournisseur?: number;
  Id?: number;
  IdCptSection?: number;
  IdModeleTVA?: number;
  IsAgregateur?: boolean;
  IsBloque?: boolean;
  IsCentralisateur?: boolean;
  IsClos?: boolean;
  IsCollectifAcompteClient?: boolean;
  IsCollectifAcompteFour?: boolean;
  IsCollectifClient?: boolean;
  IsCollectifCompteCourantFournisseur?: boolean;
  IsCollectifFournisseur?: boolean;
  IsCollectifMoyenPaiement?: boolean;
  IsCollectifPVMClient?: boolean;
  IsCollectifPret?: boolean;
  IsFonctionnement?: boolean;
  IsSocial?: boolean;
  Libelle?: string;
  ListeActivites?: ArrayOfActiviteDto;
  ListeArticles?: ArrayOfArticleDto;
  ListeDelegations?: ArrayOfCeDelegationDto;
  ListeFamilles?: ArrayOfFamilleProduitDto;
  ListeMouvementsComptables?: ArrayOfMouvementComptableDto;
  ListeMouvementsComptablesTiers?: ArrayOfMouvementComptableDto;
  ListePosteBudgetaire?: ArrayOfPosteBudgetaireDto;
  ListeProduits?: ArrayOfProduitDto;
  MouvementCollectifComptable?: MouvementComptableDto;
  MouvementComptable?: MouvementComptableDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Numero?: string;
  PrefixeExport?: string;
  Status?: StatusDtoEnum;
  Utilisateur?: UsersDto;
};

export type CompteDtoInput = {
  AccepteLettrage?: boolean;
  Beneficiaire?: BenefDtoInput;
  CEDelegation?: CeDelegationDtoInput;
  Code?: string;
  Commentaire?: string;
  CompteBancaire?: CompteBancaireDtoInput;
  CptSection?: CompteSectionDtoInput;
  DateCloture?: any;
  FonctionneCredit?: boolean;
  FonctionneDebit?: boolean;
  Fournisseur?: FournisseurDtoInput;
  IDFournisseur?: number;
  Id?: number;
  IdCptSection?: number;
  IdModeleTVA?: number;
  IsAgregateur?: boolean;
  IsBloque?: boolean;
  IsCentralisateur?: boolean;
  IsClos?: boolean;
  IsCollectifAcompteClient?: boolean;
  IsCollectifAcompteFour?: boolean;
  IsCollectifClient?: boolean;
  IsCollectifCompteCourantFournisseur?: boolean;
  IsCollectifFournisseur?: boolean;
  IsCollectifMoyenPaiement?: boolean;
  IsCollectifPVMClient?: boolean;
  IsCollectifPret?: boolean;
  IsFonctionnement?: boolean;
  IsSocial?: boolean;
  Libelle?: string;
  ListeActivites?: ArrayOfActiviteDtoInput;
  ListeArticles?: ArrayOfArticleDtoInput;
  ListeDelegations?: ArrayOfCeDelegationDtoInput;
  ListeFamilles?: ArrayOfFamilleProduitDtoInput;
  ListeMouvementsComptables?: ArrayOfMouvementComptableDtoInput;
  ListeMouvementsComptablesTiers?: ArrayOfMouvementComptableDtoInput;
  ListePosteBudgetaire?: ArrayOfPosteBudgetaireDtoInput;
  ListeProduits?: ArrayOfProduitDtoInput;
  MouvementCollectifComptable?: MouvementComptableDtoInput;
  MouvementComptable?: MouvementComptableDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Numero?: string;
  PrefixeExport?: string;
  Status?: StatusDtoEnum;
  Utilisateur?: UsersDtoInput;
};

export type CompteEcritureDto = {
  __typename?: 'CompteEcritureDTO';
  BanqueRemiseEnBanque?: BanqueRemiseDto;
  Beneficiaire?: BenefDto;
  CEDelegationCible?: CeDelegationDto;
  CEDelegationCreePar?: CeDelegationDto;
  CEDelegationSource?: CeDelegationDto;
  Caisse?: CaisseDto;
  Compte511Mouvement?: Compte511MouvementModel;
  DateEcriture?: any;
  DateExport?: any;
  DateOkForExport?: any;
  Echeancier?: EcheancierDto;
  Exercice?: ExerciceDto;
  Facture?: FactureDto;
  Fournisseur?: FournisseurDto;
  Id?: number;
  IdTransaction?: number;
  IsBordereau?: boolean;
  IsExport?: boolean;
  IsIdOkForExport?: boolean;
  IsManuel?: boolean;
  IsRapproche?: boolean;
  IsSimulation?: boolean;
  IsSupprime?: boolean;
  Journal?: JournalDto;
  Lettre?: string;
  Libelle?: string;
  ListeCompteEcritureFacture?: ArrayOfCompteEcritureFactureDto;
  ListeMouvementComptable?: ArrayOfMouvementComptableDto;
  ListeMouvementStock?: ArrayOfMouvementStockDto;
  Montant?: number;
  MoyenDePaiement?: MoyenPaiementDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroPiece?: string;
  ReferenceBordereau?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
  TypeEcriture?: TypeEcritureDto;
  UserForExport?: UsersDto;
  UserLastUpdate?: UsersDto;
};

export type CompteEcritureDtoInput = {
  BanqueRemiseEnBanque?: BanqueRemiseDtoInput;
  Beneficiaire?: BenefDtoInput;
  CEDelegationCible?: CeDelegationDtoInput;
  CEDelegationCreePar?: CeDelegationDtoInput;
  CEDelegationSource?: CeDelegationDtoInput;
  Caisse?: CaisseDtoInput;
  Compte511Mouvement?: Compte511MouvementModelInput;
  DateEcriture?: any;
  DateExport?: any;
  DateOkForExport?: any;
  Echeancier?: EcheancierDtoInput;
  Exercice?: ExerciceDtoInput;
  Facture?: FactureDtoInput;
  Fournisseur?: FournisseurDtoInput;
  Id?: number;
  IdTransaction?: number;
  IsBordereau?: boolean;
  IsExport?: boolean;
  IsIdOkForExport?: boolean;
  IsManuel?: boolean;
  IsRapproche?: boolean;
  IsSimulation?: boolean;
  IsSupprime?: boolean;
  Journal?: JournalDtoInput;
  Lettre?: string;
  Libelle?: string;
  ListeCompteEcritureFacture?: ArrayOfCompteEcritureFactureDtoInput;
  ListeMouvementComptable?: ArrayOfMouvementComptableDtoInput;
  ListeMouvementStock?: ArrayOfMouvementStockDtoInput;
  Montant?: number;
  MoyenDePaiement?: MoyenPaiementDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroPiece?: string;
  ReferenceBordereau?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
  TypeEcriture?: TypeEcritureDtoInput;
  UserForExport?: UsersDtoInput;
  UserLastUpdate?: UsersDtoInput;
};

export type CompteEcritureFactureDto = {
  __typename?: 'CompteEcritureFactureDTO';
  CompteEcriture?: CompteEcritureDto;
  Facture?: FactureDto;
  ListeCompteEcriture?: ArrayOfCompteEcritureDto;
  ListeFacture?: ArrayOfFactureDto;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CompteEcritureFactureDtoInput = {
  CompteEcriture?: CompteEcritureDtoInput;
  Facture?: FactureDtoInput;
  ListeCompteEcriture?: ArrayOfCompteEcritureDtoInput;
  ListeFacture?: ArrayOfFactureDtoInput;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CompteForListeCompteModel = {
  __typename?: 'CompteForListeCompteModel';
  Code?: string;
  CompteClasse?: string;
  CompteRacine?: string;
  CompteSousClasse?: string;
  DateCloture?: any;
  IdCompte?: number;
  IsBloque?: boolean;
  IsCloture?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Numero?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
  TooltipTypeBudget?: string;
  TooltipTypeFonctionnement?: string;
  TypeBudget?: string;
  TypeCollectif?: string;
  TypeFonctionnement?: string;
};

export type CompteForListeCompteModelInput = {
  Code?: string;
  CompteClasse?: string;
  CompteRacine?: string;
  CompteSousClasse?: string;
  DateCloture?: any;
  IdCompte?: number;
  IsBloque?: boolean;
  IsCloture?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Numero?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
  TooltipTypeBudget?: string;
  TooltipTypeFonctionnement?: string;
  TypeBudget?: string;
  TypeCollectif?: string;
  TypeFonctionnement?: string;
};

export type CompteJournalPrmAutoDto = {
  __typename?: 'CompteJournalPRMAutoDTO';
  CEDelegation?: CeDelegationDto;
  CompteBancaire?: CompteBancaireDto;
  Id?: number;
  IsDefaut?: boolean;
  Journal?: JournalDto;
  MoyenDePaiement?: MoyenPaiementDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CompteJournalPrmAutoDtoInput = {
  CEDelegation?: CeDelegationDtoInput;
  CompteBancaire?: CompteBancaireDtoInput;
  Id?: number;
  IsDefaut?: boolean;
  Journal?: JournalDtoInput;
  MoyenDePaiement?: MoyenPaiementDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CompteJournalPrmAutoFiduDto = {
  __typename?: 'CompteJournalPRMAutoFiduDTO';
  Id?: number;
  IsDefaut?: boolean;
  Journal?: JournalDto;
  MoyenDePaiement?: MoyenPaiementDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CompteJournalPrmAutoFiduDtoInput = {
  Id?: number;
  IsDefaut?: boolean;
  Journal?: JournalDtoInput;
  MoyenDePaiement?: MoyenPaiementDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CompteLightClosModel = {
  __typename?: 'CompteLightClosModel';
  Id?: number;
  IsClos?: boolean;
  Libelle?: string;
  Numero?: string;
};

export type CompteLightClosModelInput = {
  Id?: number;
  IsClos?: boolean;
  Libelle?: string;
  Numero?: string;
};

export type CompteLightModel = {
  __typename?: 'CompteLightModel';
  Id?: number;
  Libelle?: string;
  Numero?: string;
};

export type CompteLightModelInput = {
  Id?: number;
  Libelle?: string;
  Numero?: string;
};

export type CompteLightVisibleEnLigneModel = {
  __typename?: 'CompteLightVisibleEnLigneModel';
  Id?: number;
  IsVisibleEnLigne?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Numero?: string;
  Status?: StatusDtoEnum;
};

export type CompteLightVisibleEnLigneModelInput = {
  Id?: number;
  IsVisibleEnLigne?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Numero?: string;
  Status?: StatusDtoEnum;
};

export type CompteModelDto = {
  __typename?: 'CompteModelDTO';
  ClasseCpt?: string;
  ClasseRacine?: string;
  Code?: string;
  IdCompte?: number;
  IsClos?: boolean;
  IsSelected?: boolean;
  LibelleBudget?: string;
  LibelleCompte?: string;
  LibellePosteBudgetaire?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Numero?: string;
  SousClasseCpt?: string;
  Status?: StatusDtoEnum;
};

export type CompteModelDtoInput = {
  ClasseCpt?: string;
  ClasseRacine?: string;
  Code?: string;
  IdCompte?: number;
  IsClos?: boolean;
  IsSelected?: boolean;
  LibelleBudget?: string;
  LibelleCompte?: string;
  LibellePosteBudgetaire?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Numero?: string;
  SousClasseCpt?: string;
  Status?: StatusDtoEnum;
};

export type CompteReglementFiduciaireDto = {
  __typename?: 'CompteReglementFiduciaireDTO';
  Caisse?: CaisseDto;
  Compte?: CompteDto;
  CompteVirementInterne?: CompteDto;
  Id?: number;
  MoyenPaiement?: MoyenPaiementDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CompteReglementFiduciaireDtoInput = {
  Caisse?: CaisseDtoInput;
  Compte?: CompteDtoInput;
  CompteVirementInterne?: CompteDtoInput;
  Id?: number;
  MoyenPaiement?: MoyenPaiementDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CompteReglementFiduciaireModelDto = {
  __typename?: 'CompteReglementFiduciaireModelDTO';
  Id?: number;
  IdCaisse?: number;
  IdCompteAttente?: number;
  IdCompteVirementInterne?: number;
  IdMoyenPaiement?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CompteReglementFiduciaireModelDtoInput = {
  Id?: number;
  IdCaisse?: number;
  IdCompteAttente?: number;
  IdCompteVirementInterne?: number;
  IdMoyenPaiement?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CompteSectionDto = {
  __typename?: 'CompteSectionDTO';
  Id?: number;
  Libelle?: string;
  ListeCompte?: ArrayOfCompteDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Num?: string;
  SousClasse?: CompteSousClasseDto;
  Status?: StatusDtoEnum;
};

export type CompteSectionDtoInput = {
  Id?: number;
  Libelle?: string;
  ListeCompte?: ArrayOfCompteDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Num?: string;
  SousClasse?: CompteSousClasseDtoInput;
  Status?: StatusDtoEnum;
};

export type CompteSimplifieModelDto = {
  __typename?: 'CompteSimplifieModelDTO';
  IdCompte?: number;
  LibelleCompte?: string;
  ListeSectionsRattachees?: ArrayOfstring;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompte?: string;
  Status?: StatusDtoEnum;
};

export type CompteSimplifieModelDtoInput = {
  IdCompte?: number;
  LibelleCompte?: string;
  ListeSectionsRattachees?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompte?: string;
  Status?: StatusDtoEnum;
};

export type CompteSousClasseDto = {
  __typename?: 'CompteSousClasseDTO';
  CompteClasse?: CompteClasseDto;
  ID?: number;
  IdClasse?: number;
  Libelle?: string;
  ListeSections?: ArrayOfCompteSectionDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Numero?: string;
  Status?: StatusDtoEnum;
};

export type CompteSousClasseDtoInput = {
  CompteClasse?: CompteClasseDtoInput;
  ID?: number;
  IdClasse?: number;
  Libelle?: string;
  ListeSections?: ArrayOfCompteSectionDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Numero?: string;
  Status?: StatusDtoEnum;
};

export type ComptesBancairesCompteBancaireLightModel = {
  __typename?: 'ComptesBancairesCompteBancaireLightModel';
  Id?: number;
  IdCompte?: number;
  Libelle?: string;
};

export type ComptesBancairesCompteBancaireLightModelInput = {
  Id?: number;
  IdCompte?: number;
  Libelle?: string;
};

export type ComptesBancairesCriteresCompteBancaireModelInput = {
  IdActivite?: number;
  IdCaisse?: number;
  IdCompte?: number;
  IdCompteBancaire?: number;
  IdDelegation?: number;
  IdDelegationOuGlobale?: number;
  IsClos?: boolean;
  IsCompteParDefautSurActivite?: boolean;
};

export type ComptesPlanCompteModel = {
  __typename?: 'ComptesPlanCompteModel';
  Classe?: string;
  CodeCompte?: string;
  DateCloture?: any;
  IdCompte?: number;
  IsAgregateur?: boolean;
  IsBloque?: boolean;
  IsClos?: boolean;
  IsCollectifAcompteFournisseur?: boolean;
  IsCollectifAcomptefClient?: boolean;
  IsCollectifCCF?: boolean;
  IsCollectifClient?: boolean;
  IsCollectifFournisseur?: boolean;
  IsCollectifMoyenPaiement?: boolean;
  IsCollectifPMV?: boolean;
  IsCollectifPret?: boolean;
  IsCredit?: boolean;
  IsDebit?: boolean;
  IsFonctionnement?: boolean;
  IsSocial?: boolean;
  LibelleCompte?: string;
  ModeleTVAAssocie?: string;
  ModeleTVACollecte?: string;
  ModeleTVADeductible?: string;
  NumeroCompte?: string;
  Racine?: string;
  Remarque?: string;
  SousClasse?: string;
};

export type ComptesPlanCompteModelInput = {
  Classe?: string;
  CodeCompte?: string;
  DateCloture?: any;
  IdCompte?: number;
  IsAgregateur?: boolean;
  IsBloque?: boolean;
  IsClos?: boolean;
  IsCollectifAcompteFournisseur?: boolean;
  IsCollectifAcomptefClient?: boolean;
  IsCollectifCCF?: boolean;
  IsCollectifClient?: boolean;
  IsCollectifFournisseur?: boolean;
  IsCollectifMoyenPaiement?: boolean;
  IsCollectifPMV?: boolean;
  IsCollectifPret?: boolean;
  IsCredit?: boolean;
  IsDebit?: boolean;
  IsFonctionnement?: boolean;
  IsSocial?: boolean;
  LibelleCompte?: string;
  ModeleTVAAssocie?: string;
  ModeleTVACollecte?: string;
  ModeleTVADeductible?: string;
  NumeroCompte?: string;
  Racine?: string;
  Remarque?: string;
  SousClasse?: string;
};

export type CompteurImputNbPointModelInput = {
  CompteurPts?: CompteurPointDtoInput;
  NbPoint?: number;
};

export type CompteurPointAfpaModel = {
  __typename?: 'CompteurPointAFPAModel';
  Code?: string;
  IdAFPA?: number;
  IdCompteur?: number;
  IsDeleted?: boolean;
  IsFromFirstEuro?: boolean;
  Libelle?: string;
  MontantSub?: number;
  Valeur?: number;
};

export type CompteurPointAfpaModelInput = {
  Code?: string;
  IdAFPA?: number;
  IdCompteur?: number;
  IsDeleted?: boolean;
  IsFromFirstEuro?: boolean;
  Libelle?: string;
  MontantSub?: number;
  Valeur?: number;
};

export type CompteurPointBaseModel = {
  __typename?: 'CompteurPointBaseModel';
  Code?: string;
  IdCompteur?: number;
  Libelle?: string;
};

export type CompteurPointBaseModelInput = {
  Code?: string;
  IdCompteur?: number;
  Libelle?: string;
};

export type CompteurPointCalculPointsDto = {
  __typename?: 'CompteurPointCalculPointsDTO';
  DateDebutCalculPoint?: any;
  DateFinCalculPoint?: any;
  IsCalculPointByVieBenef?: boolean;
  IsCalculPointsByAnneeCalendaire?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreAnnees?: number;
  Status?: StatusDtoEnum;
};

export type CompteurPointCalculPointsDtoInput = {
  DateDebutCalculPoint?: any;
  DateFinCalculPoint?: any;
  IsCalculPointByVieBenef?: boolean;
  IsCalculPointsByAnneeCalendaire?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreAnnees?: number;
  Status?: StatusDtoEnum;
};

export type CompteurPointDto = {
  __typename?: 'CompteurPointDTO';
  Code?: string;
  Id?: number;
  IdcCalulAnneeCalendaire?: boolean;
  IdcCalulAnneeGlissante?: boolean;
  IdcCalulBenef?: boolean;
  IsClos?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbAnnee?: number;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type CompteurPointDtoInput = {
  Code?: string;
  Id?: number;
  IdcCalulAnneeCalendaire?: boolean;
  IdcCalulAnneeGlissante?: boolean;
  IdcCalulBenef?: boolean;
  IsClos?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbAnnee?: number;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type ConfirmationTransfertComptaModel = {
  __typename?: 'ConfirmationTransfertComptaModel';
  ActiviteJournauxModel?: ActiviteJournauxModel;
  ListeExerciceDTO?: ArrayOfExerciceDto;
  ListeJournalBenefDTO?: ArrayOfJournalDto;
  ListeJournalFourDTO?: ArrayOfJournalDto;
  TypeJournal?: string;
};

export type ConfirmationTransfertComptaModelInput = {
  ActiviteJournauxModel?: ActiviteJournauxModelInput;
  ListeExerciceDTO?: ArrayOfExerciceDtoInput;
  ListeJournalBenefDTO?: ArrayOfJournalDtoInput;
  ListeJournalFourDTO?: ArrayOfJournalDtoInput;
  TypeJournal?: string;
};

export type ConnexionModelDto = {
  __typename?: 'ConnexionModelDTO';
  CodesModules?: ArrayOfstring;
  Contexte?: ContextInfos;
  CurrentCaisse?: CaisseDto;
  CurrentDelegation?: CeDelegationDto;
  CurrentPointVente?: PointVenteDto;
  CurrentStock?: StockDto;
  CurrentUser?: UsersDto;
  ExerciceNotFoundForThisYear?: boolean;
  HasAnneesReference?: boolean;
  IsLogsPerfActif?: boolean;
  ListeCodesFonctionnalitesAccessible?: ArrayOfstring;
  ListeCodesWidgetsAccessible?: ArrayOfstring;
  ListeExerciceInfos?: ArrayOfExerciceInfos;
  ListeParametresAppli?: ArrayOfParametresUserAppliModelDto;
  ListeUserCommissionDroit?: ArrayOfUserCommissionDroit;
  NoteMinGestionWarning?: number;
  ParametresCE?: ParametresCeInfos;
  PathsCE?: PathsCeInfos;
  StaticFileServerClientLogin?: string;
  StaticFileServerRootUrl?: string;
  UrlPortail?: string;
  UrlServeurDeCharge?: string;
  UrlWebservice?: string;
  VersionVUP?: string;
};

export type ConnexionModelDtoInput = {
  CodesModules?: ArrayOfstringInput;
  Contexte?: ContextInfosInput;
  CurrentCaisse?: CaisseDtoInput;
  CurrentDelegation?: CeDelegationDtoInput;
  CurrentPointVente?: PointVenteDtoInput;
  CurrentStock?: StockDtoInput;
  CurrentUser?: UsersDtoInput;
  ExerciceNotFoundForThisYear?: boolean;
  HasAnneesReference?: boolean;
  IsLogsPerfActif?: boolean;
  ListeCodesFonctionnalitesAccessible?: ArrayOfstringInput;
  ListeCodesWidgetsAccessible?: ArrayOfstringInput;
  ListeExerciceInfos?: ArrayOfExerciceInfosInput;
  ListeParametresAppli?: ArrayOfParametresUserAppliModelDtoInput;
  ListeUserCommissionDroit?: ArrayOfUserCommissionDroitInput;
  NoteMinGestionWarning?: number;
  ParametresCE?: ParametresCeInfosInput;
  PathsCE?: PathsCeInfosInput;
  StaticFileServerClientLogin?: string;
  StaticFileServerRootUrl?: string;
  UrlPortail?: string;
  UrlServeurDeCharge?: string;
  UrlWebservice?: string;
  VersionVUP?: string;
};

export type ConnexionUtilisateurModelDto = {
  __typename?: 'ConnexionUtilisateurModelDTO';
  ListeCEDelegation?: ArrayOfCeDelegationDto;
  ListeCaisse?: ArrayOfCaisseDto;
  ListePointVente?: ArrayOfPointVenteDto;
  ListeStock?: ArrayOfStockDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ConnexionUtilisateurModelDtoInput = {
  ListeCEDelegation?: ArrayOfCeDelegationDtoInput;
  ListeCaisse?: ArrayOfCaisseDtoInput;
  ListePointVente?: ArrayOfPointVenteDtoInput;
  ListeStock?: ArrayOfStockDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ConsoBenefSynchroModelDto = {
  __typename?: 'ConsoBenefSynchroModelDTO';
  CodeKalEnv?: string;
  DateCreation?: any;
  DateMajKal?: any;
  DateValeur?: any;
  IsFromKalidea?: boolean;
  LibelleConso?: string;
  LibelleEnveloppe?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ConsoBenefSynchroModelDtoInput = {
  CodeKalEnv?: string;
  DateCreation?: any;
  DateMajKal?: any;
  DateValeur?: any;
  IsFromKalidea?: boolean;
  LibelleConso?: string;
  LibelleEnveloppe?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ConsoMouvementCptPointDto = {
  __typename?: 'ConsoMouvementCptPointDTO';
  CompteurPoint?: CompteurPointDto;
  ConsoMouvement?: ConsoMouvementDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NbPoint?: number;
  Status?: StatusDtoEnum;
};

export type ConsoMouvementCptPointDtoInput = {
  CompteurPoint?: CompteurPointDtoInput;
  ConsoMouvement?: ConsoMouvementDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbPoint?: number;
  Status?: StatusDtoEnum;
};

export type ConsoMouvementDto = {
  __typename?: 'ConsoMouvementDTO';
  ArtQte?: number;
  AttribBDG?: AttributionBudgetDto;
  AyantDroit?: BenefDto;
  Beneficiaire?: BenefDto;
  CEDelegation?: CeDelegationDto;
  DateCreation?: any;
  DateValeur?: any;
  Id?: number;
  IdcCCE?: number;
  IdcValidite?: number;
  IsComplementaire?: boolean;
  Libelle?: string;
  LigneCommande?: LigneCommandeDto;
  ListeConsoMouvementCptPoint?: ArrayOfConsoMouvementCptPointDto;
  ListeConsoMouvementEnveloppeQuota?: ArrayOfConsoMouvementEnveloppeQuotaDto;
  ListeEveloppe?: ArrayOfEnveloppeQuotaDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NbUnit?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Sens?: string;
  Status?: StatusDtoEnum;
  SubMvt?: number;
  TypeConso?: TypeConsoMouvementPointDto;
  ValFac?: number;
};

export type ConsoMouvementDtoInput = {
  ArtQte?: number;
  AttribBDG?: AttributionBudgetDtoInput;
  AyantDroit?: BenefDtoInput;
  Beneficiaire?: BenefDtoInput;
  CEDelegation?: CeDelegationDtoInput;
  DateCreation?: any;
  DateValeur?: any;
  Id?: number;
  IdcCCE?: number;
  IdcValidite?: number;
  IsComplementaire?: boolean;
  Libelle?: string;
  LigneCommande?: LigneCommandeDtoInput;
  ListeConsoMouvementCptPoint?: ArrayOfConsoMouvementCptPointDtoInput;
  ListeConsoMouvementEnveloppeQuota?: ArrayOfConsoMouvementEnveloppeQuotaDtoInput;
  ListeEveloppe?: ArrayOfEnveloppeQuotaDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbUnit?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Sens?: string;
  Status?: StatusDtoEnum;
  SubMvt?: number;
  TypeConso?: TypeConsoMouvementPointDtoInput;
  ValFac?: number;
};

export type ConsoMouvementEnveloppeQuotaDto = {
  __typename?: 'ConsoMouvementEnveloppeQuotaDTO';
  ConsoMouvement?: ConsoMouvementDto;
  EnveloppeQuota?: EnveloppeQuotaDto;
  IdOperationSynchronisation?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ConsoMouvementEnveloppeQuotaDtoInput = {
  ConsoMouvement?: ConsoMouvementDtoInput;
  EnveloppeQuota?: EnveloppeQuotaDtoInput;
  IdOperationSynchronisation?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type Constantes_StatutsMediathquesLigneReservationModel = {
  __typename?: 'Constantes_StatutsMediathquesLigneReservationModel';
  AuteurCompositeurMedia?: string;
  CodeStatutAdministratif?: string;
  CodeTypeActivite?: string;
  CodeTypeMedia?: string;
  CoteMedia?: string;
  CouleurStatutPerso?: string;
  DateCommande?: any;
  DateDebutReservation?: any;
  DateEmprunt?: any;
  DateFinReservation?: any;
  DateLivraison?: any;
  DateRetourPrevue?: any;
  DateRetourReelle?: any;
  IdBenef?: number;
  IdCommande?: number;
  IdFamille?: number;
  IdLigneCommande?: number;
  IdProduit?: number;
  IdStockLocalisation?: number;
  IsALivrer?: boolean;
  IsBloque?: boolean;
  IsEmpruntee?: boolean;
  IsEnFileAttente?: boolean;
  IsEnLigne?: boolean;
  IsEnRetard?: boolean;
  IsLivEnFileAttente?: boolean;
  IsPerdu?: boolean;
  IsReserve?: boolean;
  IsRetournee?: boolean;
  IsRetourneePartiellement?: boolean;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  LibelleStatutPerso?: string;
  LibelleStockLivraison?: string;
  LibelleStockRetour?: string;
  LibelleTypeMedia?: string;
  ListeIdExemplaireDispoMedia?: ArrayOfdecimal;
  MatriculeBenef?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBenef?: string;
  NombreFileAttente?: number;
  NombreJourEmprunt?: number;
  PlaceFileAttente?: number;
  PrenomBenef?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type Constantes_StatutsMediathquesLigneReservationModelInput = {
  AuteurCompositeurMedia?: string;
  CodeStatutAdministratif?: string;
  CodeTypeActivite?: string;
  CodeTypeMedia?: string;
  CoteMedia?: string;
  CouleurStatutPerso?: string;
  DateCommande?: any;
  DateDebutReservation?: any;
  DateEmprunt?: any;
  DateFinReservation?: any;
  DateLivraison?: any;
  DateRetourPrevue?: any;
  DateRetourReelle?: any;
  IdBenef?: number;
  IdCommande?: number;
  IdFamille?: number;
  IdLigneCommande?: number;
  IdProduit?: number;
  IdStockLocalisation?: number;
  IsALivrer?: boolean;
  IsBloque?: boolean;
  IsEmpruntee?: boolean;
  IsEnFileAttente?: boolean;
  IsEnLigne?: boolean;
  IsEnRetard?: boolean;
  IsLivEnFileAttente?: boolean;
  IsPerdu?: boolean;
  IsReserve?: boolean;
  IsRetournee?: boolean;
  IsRetourneePartiellement?: boolean;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  LibelleStatutPerso?: string;
  LibelleStockLivraison?: string;
  LibelleStockRetour?: string;
  LibelleTypeMedia?: string;
  ListeIdExemplaireDispoMedia?: ArrayOfdecimalInput;
  MatriculeBenef?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBenef?: string;
  NombreFileAttente?: number;
  NombreJourEmprunt?: number;
  PlaceFileAttente?: number;
  PrenomBenef?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type ConsultationArticleLocationModel = {
  __typename?: 'ConsultationArticleLocationModel';
  Category?: string;
  DateJour?: any;
  InfoBulle?: string;
  ListIdArticle?: ArrayOfdecimal;
};

export type ConsultationArticleLocationModelInput = {
  Category?: string;
  DateJour?: any;
  InfoBulle?: string;
  ListIdArticle?: ArrayOfdecimalInput;
};

export type ConsultationClotureVariationStockModel = {
  __typename?: 'ConsultationClotureVariationStockModel';
  DataPagerModel?: RadgridviewPagineModelDtoOfClotureVariationStockModelWfN5Koph;
  ListeRecalitulatifValorisation?: ArrayOfRecapitulatifCompteValorisationModel;
  ListeRecalitulatifVariation?: ArrayOfRecapitulatifCompteVariationModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ConsultationClotureVariationStockModelInput = {
  DataPagerModel?: RadgridviewPagineModelDtoOfClotureVariationStockModelWfN5KophInput;
  ListeRecalitulatifValorisation?: ArrayOfRecapitulatifCompteValorisationModelInput;
  ListeRecalitulatifVariation?: ArrayOfRecapitulatifCompteVariationModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ConsultationEcritureBaseModel = {
  __typename?: 'ConsultationEcritureBaseModel';
  DateEcriture?: any;
  IdCECible?: number;
  IdDelegationOrigine?: number;
  IdEcriture?: number;
  IsSupprimee?: boolean;
  JournalCode?: string;
  Libelle?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroPiece?: string;
  Status?: StatusDtoEnum;
};

export type ConsultationEcritureBaseModelInput = {
  DateEcriture?: any;
  IdCECible?: number;
  IdDelegationOrigine?: number;
  IdEcriture?: number;
  IsSupprimee?: boolean;
  JournalCode?: string;
  Libelle?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroPiece?: string;
  Status?: StatusDtoEnum;
};

export type ConsultationMouvementConsommationModel = {
  __typename?: 'ConsultationMouvementConsommationModel';
  DateValeur?: any;
  IdCommande?: number;
  IdMouvementConso?: number;
  LibelleContratBeneficiaire?: string;
  LibelleMouvement?: string;
  MatriculeBenef?: string;
  MontantSubvention?: number;
  NomBenef?: string;
  NomCE?: string;
  NomPrenomAyantDroit?: string;
  NomSiteBeneficiaire?: string;
  NombreUnite?: number;
  PrenomBenef?: string;
  Quantite?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Sens?: string;
  ValeurFacial?: number;
};

export type ConsultationMouvementConsommationModelInput = {
  DateValeur?: any;
  IdCommande?: number;
  IdMouvementConso?: number;
  LibelleContratBeneficiaire?: string;
  LibelleMouvement?: string;
  MatriculeBenef?: string;
  MontantSubvention?: number;
  NomBenef?: string;
  NomCE?: string;
  NomPrenomAyantDroit?: string;
  NomSiteBeneficiaire?: string;
  NombreUnite?: number;
  PrenomBenef?: string;
  Quantite?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Sens?: string;
  ValeurFacial?: number;
};

export type ContactDto = {
  __typename?: 'ContactDTO';
  Banque?: BanqueDto;
  EmailPerso?: string;
  EmailPro?: string;
  Fax?: string;
  Fonction?: string;
  Fournisseur?: FournisseurDto;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Prenom?: string;
  Status?: StatusDtoEnum;
  TelephoneDomicile?: string;
  TelephoneGSM?: string;
  TelephonePro?: string;
};

export type ContactDtoInput = {
  Banque?: BanqueDtoInput;
  EmailPerso?: string;
  EmailPro?: string;
  Fax?: string;
  Fonction?: string;
  Fournisseur?: FournisseurDtoInput;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Prenom?: string;
  Status?: StatusDtoEnum;
  TelephoneDomicile?: string;
  TelephoneGSM?: string;
  TelephonePro?: string;
};

export type ContactParamModel = {
  __typename?: 'ContactParamModel';
  EmailLibre?: string;
  IdCE?: number;
  IdCommission?: number;
  IdContactParam?: number;
  IdUser?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ContactParamModelInput = {
  EmailLibre?: string;
  IdCE?: number;
  IdCommission?: number;
  IdContactParam?: number;
  IdUser?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ContenuRegleAvanceeModelDto = {
  __typename?: 'ContenuRegleAvanceeModelDTO';
  ListeReglesPourApplication?: ArrayOfKeyValueModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Regle?: RegleAvanceeModelDto;
  Status?: StatusDtoEnum;
};

export type ContenuRegleAvanceeModelDtoInput = {
  ListeReglesPourApplication?: ArrayOfKeyValueModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Regle?: RegleAvanceeModelDtoInput;
  Status?: StatusDtoEnum;
};

export type ContextInfos = {
  __typename?: 'ContextInfos';
  CurrentCE?: number;
  CurrentCaisse?: number;
  CurrentPV?: number;
  CurrentStock?: number;
  CurrentUserId?: number;
  DateDernierAppel?: any;
  DontUpdateDateAppel?: boolean;
  IdBenefDirectoV2?: number;
  IsSuperAdministrateur?: boolean;
  LoguerAppelWS?: boolean;
  NumSession?: string;
  NumeroAppelWS?: string;
};

export type ContextInfosInput = {
  CurrentCE?: number;
  CurrentCaisse?: number;
  CurrentPV?: number;
  CurrentStock?: number;
  CurrentUserId?: number;
  DateDernierAppel?: any;
  DontUpdateDateAppel?: boolean;
  IdBenefDirectoV2?: number;
  IsSuperAdministrateur?: boolean;
  LoguerAppelWS?: boolean;
  NumSession?: string;
  NumeroAppelWS?: string;
};

export enum ContextModeMouvementsComptablesEnum {
  Aucun = 'Aucun',
  ClotureCap = 'ClotureCAP',
  ClotureCca = 'ClotureCCA',
  CloturePar = 'CloturePAR',
  CloturePca = 'CloturePCA',
  Consultation = 'Consultation',
  ConsultationCaisseArrete = 'ConsultationCaisseArrete',
  ConsultationFournisseur = 'ConsultationFournisseur',
  EcritureManuelle = 'EcritureManuelle',
  FicheSignaletique = 'FicheSignaletique',
  PanneauDroitSaisieEcriture = 'PanneauDroitSaisieEcriture',
  PopupEcritureFournisseur = 'PopupEcritureFournisseur',
  ReceptionCheque = 'ReceptionCheque',
  RemiseEnBanque = 'RemiseEnBanque'
}

export enum ContexteClientFournisseurEnum {
  ClientAcompte = 'ClientAcompte',
  ClientCollectif = 'ClientCollectif',
  FournisseurAcompte = 'FournisseurAcompte',
  FournisseurCollectif = 'FournisseurCollectif',
  None = 'None'
}

export type CorrectionImputationArticleModel = {
  __typename?: 'CorrectionImputationArticleModel';
  IdArticle?: number;
  IsRepartitionAnalytiqueCreee?: boolean;
  LibelleArticle?: string;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompteValorisationApres?: string;
  NumeroCompteValorisationAvant?: string;
  NumeroCompteVariationApres?: string;
  NumeroCompteVariationAvant?: string;
  Status?: StatusDtoEnum;
};

export type CorrectionImputationArticleModelInput = {
  IdArticle?: number;
  IsRepartitionAnalytiqueCreee?: boolean;
  LibelleArticle?: string;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompteValorisationApres?: string;
  NumeroCompteValorisationAvant?: string;
  NumeroCompteVariationApres?: string;
  NumeroCompteVariationAvant?: string;
  Status?: StatusDtoEnum;
};

export type CorrectionMontantMouvementModel = {
  __typename?: 'CorrectionMontantMouvementModel';
  DateEcriture?: any;
  IdEcriture?: number;
  IdMouvement?: number;
  IsEcartFacturation?: boolean;
  LibelleMouvement?: string;
  MontantApres?: number;
  MontantAvant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroPiece?: string;
  SensMouvement?: string;
  Status?: StatusDtoEnum;
};

export type CorrectionMontantMouvementModelInput = {
  DateEcriture?: any;
  IdEcriture?: number;
  IdMouvement?: number;
  IsEcartFacturation?: boolean;
  LibelleMouvement?: string;
  MontantApres?: number;
  MontantAvant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroPiece?: string;
  SensMouvement?: string;
  Status?: StatusDtoEnum;
};

export type CorrectionRepartitionAnalytiqueModel = {
  __typename?: 'CorrectionRepartitionAnalytiqueModel';
  DateEcriture?: any;
  IdEcriture?: number;
  IdMouvement?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytique?: number;
  LibelleMouvement?: string;
  MontantApres?: number;
  MontantAvant?: number;
  MontantMouvement?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompte?: string;
  NumeroPiece?: string;
  SensMouvement?: string;
  Status?: StatusDtoEnum;
};

export type CorrectionRepartitionAnalytiqueModelInput = {
  DateEcriture?: any;
  IdEcriture?: number;
  IdMouvement?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytique?: number;
  LibelleMouvement?: string;
  MontantApres?: number;
  MontantAvant?: number;
  MontantMouvement?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompte?: string;
  NumeroPiece?: string;
  SensMouvement?: string;
  Status?: StatusDtoEnum;
};

export type CotisationArticleParamCotisationModel = {
  __typename?: 'CotisationArticleParamCotisationModel';
  DateDebutCotisation?: any;
  DateFinCotisation?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixVente?: number;
  Status?: StatusDtoEnum;
};

export type CotisationArticleParamCotisationModelInput = {
  DateDebutCotisation?: any;
  DateFinCotisation?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixVente?: number;
  Status?: StatusDtoEnum;
};

export type CotisationInformationsProduitModel = {
  __typename?: 'CotisationInformationsProduitModel';
  CodeProduit?: string;
  DescriptionProduit?: string;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  IsProduitCommandeSeul?: boolean;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarqueProduit?: string;
  Status?: StatusDtoEnum;
};

export type CotisationInformationsProduitModelInput = {
  CodeProduit?: string;
  DescriptionProduit?: string;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  IsProduitCommandeSeul?: boolean;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarqueProduit?: string;
  Status?: StatusDtoEnum;
};

export type CourrierBaseWithCodeTypeModel = {
  __typename?: 'CourrierBaseWithCodeTypeModel';
  CodeTypeReport?: string;
  IdCourrier?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
};

export type CourrierBaseWithCodeTypeModelInput = {
  CodeTypeReport?: string;
  IdCourrier?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
};

export type CourrierCourrierEnvoiLigneModel = {
  __typename?: 'CourrierCourrierEnvoiLigneModel';
  Benef?: string;
  Mail?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CourrierCourrierEnvoiLigneModelInput = {
  Benef?: string;
  Mail?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CourrierCourrierEnvoiModel = {
  __typename?: 'CourrierCourrierEnvoiModel';
  Corps?: string;
  Createur?: string;
  DateCreation?: any;
  Id?: number;
  IsSpecificModele?: boolean;
  LibelleModele?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbBenef?: number;
  Objet?: string;
  Status?: StatusDtoEnum;
  WithModele?: boolean;
};

export type CourrierCourrierEnvoiModelInput = {
  Corps?: string;
  Createur?: string;
  DateCreation?: any;
  Id?: number;
  IsSpecificModele?: boolean;
  LibelleModele?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbBenef?: number;
  Objet?: string;
  Status?: StatusDtoEnum;
  WithModele?: boolean;
};

export type CourrierCriteresCourrierBaseModelInput = {
  CodeTypeReport?: string;
  IdActivite?: number;
  IdCourrier?: number;
  IsClos?: boolean;
  ListeCodeTypeReport?: ArrayOfstringInput;
};

export type CourrierDto = {
  __typename?: 'CourrierDTO';
  Activite?: ActiviteDto;
  BasDePage?: string;
  Corps?: string;
  DateDerEnvoi?: any;
  Id?: number;
  Intro?: string;
  IsAdresseCEVisible?: boolean;
  IsCloture?: boolean;
  IsLogoVisible?: boolean;
  IsSignatureCEVisible?: boolean;
  Libelle?: string;
  ListeHistoEnvoi?: ArrayOfCourrierHistoEnvoiDto;
  ListeHistoriqueImpression?: ArrayOfHistoriqueImpressionCourrierDto;
  ModeleAdresse?: ReportModeleAdrdto;
  MustValidate?: boolean;
  MyGuid?: string;
  Objet?: string;
  PiedDePage?: string;
  Report?: ReportDto;
  SignatureCE?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
  TypeDestinataire?: string;
};

export type CourrierDtoInput = {
  Activite?: ActiviteDtoInput;
  BasDePage?: string;
  Corps?: string;
  DateDerEnvoi?: any;
  Id?: number;
  Intro?: string;
  IsAdresseCEVisible?: boolean;
  IsCloture?: boolean;
  IsLogoVisible?: boolean;
  IsSignatureCEVisible?: boolean;
  Libelle?: string;
  ListeHistoEnvoi?: ArrayOfCourrierHistoEnvoiDtoInput;
  ListeHistoriqueImpression?: ArrayOfHistoriqueImpressionCourrierDtoInput;
  ModeleAdresse?: ReportModeleAdrdtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Objet?: string;
  PiedDePage?: string;
  Report?: ReportDtoInput;
  SignatureCE?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
  TypeDestinataire?: string;
};

export type CourrierEnvoiLightModel = {
  __typename?: 'CourrierEnvoiLightModel';
  DateCreation?: any;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Objet?: string;
  Status?: StatusDtoEnum;
};

export type CourrierEnvoiLightModelInput = {
  DateCreation?: any;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Objet?: string;
  Status?: StatusDtoEnum;
};

export type CourrierHistoEnvoiDto = {
  __typename?: 'CourrierHistoEnvoiDTO';
  Courrier?: CourrierDto;
  DateEnvoi?: any;
  Id?: number;
  ListeLigneHistoEnvoi?: ArrayOfCourrierLigneHistoEnvoiDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NbCourriers?: number;
  NbMails?: number;
  NombreEnvoisCourriers?: number;
  NombreEnvoisEmails?: number;
  Produit?: ProduitDto;
  Status?: StatusDtoEnum;
  User?: UsersDto;
};

export type CourrierHistoEnvoiDtoInput = {
  Courrier?: CourrierDtoInput;
  DateEnvoi?: any;
  Id?: number;
  ListeLigneHistoEnvoi?: ArrayOfCourrierLigneHistoEnvoiDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbCourriers?: number;
  NbMails?: number;
  NombreEnvoisCourriers?: number;
  NombreEnvoisEmails?: number;
  Produit?: ProduitDtoInput;
  Status?: StatusDtoEnum;
  User?: UsersDtoInput;
};

export type CourrierInfosSaveNewsletterCourrierInput = {
  CriteresRechercheBenef?: CriteresBenefBaseModelInput;
  IdDelegation?: number;
  IdUser?: number;
  IsSimulationEnvoi?: boolean;
  ListeThemes?: ArrayOfdecimalInput;
  Mail?: MailModelDtoInput;
  ModeleNewsletter?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CourrierLigneHistoEnvoiDto = {
  __typename?: 'CourrierLigneHistoEnvoiDTO';
  AdresseFigee?: AdresseFigeDto;
  Beneficiaire?: BenefDto;
  ChampListeValeur?: ChampListeValeurDto;
  CourrierHistoEnvoi?: CourrierHistoEnvoiDto;
  EmailFrom?: string;
  EmailTo?: string;
  Id?: number;
  ListPieceJointe?: ArrayOfPieceJointeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StatutEnvoi?: StatutCourrierDto;
  StatutStr?: string;
};

export type CourrierLigneHistoEnvoiDtoInput = {
  AdresseFigee?: AdresseFigeDtoInput;
  Beneficiaire?: BenefDtoInput;
  ChampListeValeur?: ChampListeValeurDtoInput;
  CourrierHistoEnvoi?: CourrierHistoEnvoiDtoInput;
  EmailFrom?: string;
  EmailTo?: string;
  Id?: number;
  ListPieceJointe?: ArrayOfPieceJointeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StatutEnvoi?: StatutCourrierDtoInput;
  StatutStr?: string;
};

export type CreationCommandeEpargneModelInput = {
  FormulaireCommande?: ArrayOfSoumissionFormulaireModelInput;
  FormulaireLigneCommande?: ArrayOfSoumissionFormulaireModelInput;
  IdActivite?: number;
  IdArticle?: number;
  IdBenef?: number;
  IdCaisse?: number;
  IdCe?: number;
  IdDossierEpargne?: number;
  IdPV?: number;
  IdStock?: number;
  QuantiteArticle?: number;
};

export type CreationCompteModelInput = {
  Code?: string;
  Libelle?: string;
  Numero?: string;
};

export type CreerImportModelDtoInput = {
  IdModeleImport?: number;
  IdUser?: number;
  LibelleFichier?: string;
};

export type CritereAchatFourFinalModelDtoInput = {
  IsDeleteCommande?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  WithGenererFacture?: boolean;
};

export type CritereAchatFourInitModelDtoInput = {
  IdActivite?: number;
  IdCommandeUpdated?: number;
  IdFourAAfficherEnPlus?: number;
  IdFournisseur?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  OnlyReapproAttente?: boolean;
  Status?: StatusDtoEnum;
  WithCloture?: boolean;
  WithCommande?: boolean;
  WithFournisseur?: boolean;
  WithListeArticle?: boolean;
  WithStockCE?: boolean;
};

export type CritereActiviteGraphModelDtoInput = {
  DateDeb?: any;
  DateFin?: any;
  IdActivite?: number;
  IdFamille?: number;
  IdProduit?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Niveau?: NiveauxAfpaEnum;
  StatistiqueActivite?: StatistiqueActiviteEnum;
  Status?: StatusDtoEnum;
};

export type CritereBenefGraphModelDtoInput = {
  CritereBenef?: CriteresBenefDtoInput;
  IdBareme?: number;
  IdCritereChamp?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CritereCadeauModelInput = {
  Age?: number;
  IdArticle?: number;
  IdCadeau?: number;
  IdChpVal?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsClos?: boolean;
  IsRecherCheSurChpValSexe?: boolean;
  MontantTotalMinimum?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  ReferenceArticle?: string;
  Status?: StatusDtoEnum;
  TexteRechercheArticle?: string;
};

export type CritereContacterBenefDtoInput = {
  AdressePerso?: boolean;
  AdressePrivilegier?: boolean;
  AdressePro?: boolean;
  IdCmdFour?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CritereEmpruntDtoInput = {
  IdActivite?: number;
  IdBenef?: number;
  IdDevis?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Reference?: string;
  Status?: StatusDtoEnum;
};

export type CritereImportFamilleInput = {
  CodeActi?: string;
  IdActivite?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CritereParametrageCompteBancaireDtoInput = {
  CriterePlanAnalytique?: CriteresPlanAnalytiqueDtoInput;
  CriteresBanque?: CriteresBanqueDtoInput;
  CriteresSuiviTresorerie?: CriteresSuiviTresorerieDtoInput;
};

export type CritereRechTreeViewFpadtoInput = {
  IdActivite?: number;
  InArticle?: boolean;
  InFamille?: boolean;
  InProduit?: boolean;
  IsCloture?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NotLoadArticle?: boolean;
  Status?: StatusDtoEnum;
  Text?: string;
};

export type CritereRechercheArticleModelDtoInput = {
  ActeurAuteurArtiste?: string;
  AreDisplayedDirecto?: boolean;
  CibleMediaExemplaire?: string;
  CodeActivite?: string;
  CodeChamp?: string;
  CodeFamille?: string;
  CollectionMediaExemplaire?: string;
  ComparaisonDateAchat?: string;
  ComparaisonDateEdition?: string;
  ComparaisonDateNouveauteMedia?: string;
  ComparaisonDateSortie?: string;
  ComptarateurDate?: string;
  CoteMediaExemplaire?: string;
  DateDebutAchat?: any;
  DateDebutBlocage?: any;
  DateDebutEdition?: any;
  DateDebutNouveauteMedia?: any;
  DateDebutSortie?: any;
  DateFinAchat?: any;
  DateFinBlocage?: any;
  DateFinEdition?: any;
  DateFinNouveauteMedia?: any;
  DateFinSortie?: any;
  EditeurMediaExemplaire?: string;
  FromCommandeEnLigne?: boolean;
  GenreMediaExemplaire?: string;
  HasPrixActuels?: boolean;
  HasPrixDateAndIsGenericOrIsChequierDynamique?: any;
  IdActivite?: number;
  IdArticle?: number;
  IdBeneficiaire?: number;
  IdCompteChargeOuProduit?: number;
  IdDelegPourFiltreActivite?: number;
  IdDelegationActivite?: number;
  IdFamille?: number;
  IdFournisseur?: number;
  IdLocalisation?: number;
  IdModeleTVA?: number;
  IdProduit?: number;
  IdStock?: number;
  IdStockLivraison?: number;
  IdStockRattachement?: number;
  IsAFPAVisibleEnLigne?: boolean;
  IsActiviteClos?: boolean;
  IsArticleAvecPrixAchat?: boolean;
  IsBloque?: boolean;
  IsCacher?: boolean;
  IsChequierDynamique?: boolean;
  IsChequierDynamiqueConnect?: boolean;
  IsClos?: boolean;
  IsFamilleClos?: boolean;
  IsGenerique?: boolean;
  IsGeneriqueOrHasPrixActuels?: boolean;
  IsGeneriqueOrHasPrixActuelsOrIsChequierDynamique?: boolean;
  IsGereEnStock?: boolean;
  IsOptionLocation?: boolean;
  IsPerdu?: boolean;
  IsProduitClos?: boolean;
  IsProduitReappro?: boolean;
  IsVirtuel?: boolean;
  IsVisibleEnLigne?: boolean;
  LibelleArticle?: string;
  LibelleContains?: string;
  LibelleDescriptionContains?: string;
  ListeCodeActivite?: ArrayOfstringInput;
  ListeCodeTypeActivite?: ArrayOfstringInput;
  ListeIdArticle?: ArrayOfdecimalInput;
  ListeIdFamilles?: ArrayOfdecimalInput;
  ListeIdProduits?: ArrayOfdecimalInput;
  ListeStatut?: ArrayOfstringInput;
  MDKTypeMedia?: string;
  MdkIsALivrer?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  NumerotationMediaExemplaire?: string;
  OrderByLibelleASC?: boolean;
  OrderByLibelleProduitASC?: boolean;
  OrderByLibelleProduitDESC?: boolean;
  OrderByPrixASC?: boolean;
  OrderByPrixDESC?: boolean;
  ReferenceMediaExemplaire?: string;
  SeulementArticleDispo?: boolean;
  SousCollectionMediaExemplaire?: string;
  Status?: StatusDtoEnum;
  TakeChequierDynamiques?: boolean;
  ThemeSujetMediaExemplaire?: string;
  TitleStartWith?: boolean;
  TitreMediaExemplaire?: string;
};

export type CritereRechercheMediaInput = {
  CodeBar?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
  TypeMediaRecherche?: string;
};

export type CritereRechercheNumeroPieceDtoInput = {
  DateEcriture?: any;
  IdActivite?: number;
  IdCECible?: number;
  IdCEConnecte?: number;
  IdJournal?: number;
  IdUtilisateur?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumPieceAVerifier?: string;
  Status?: StatusDtoEnum;
};

export type CritereRechercheRoomingListInput = {
  DateDebutMax?: any;
  DateDebutMin?: any;
  IdActivite?: number;
  IdFamille?: number;
  IdProduit?: number;
  IdRoomingList?: number;
  LibelleRoomingList?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OperateurComparaison?: string;
  Status?: StatusDtoEnum;
};

export type CritereRegleAvanceeModelDto = {
  __typename?: 'CritereRegleAvanceeModelDTO';
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Parametres?: ArrayOfMoleculeRegleAvanceeModelDto;
  Status?: StatusDtoEnum;
};

export type CritereRegleAvanceeModelDtoInput = {
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Parametres?: ArrayOfMoleculeRegleAvanceeModelDtoInput;
  Status?: StatusDtoEnum;
};

export type CritereSyncAdModelDto = {
  __typename?: 'CritereSyncAdModelDTO';
  Actif?: boolean;
  CritereSync?: TypeCritereSyncAdModelDto;
  DateCreation?: any;
  DateEffet?: any;
  DateFin?: any;
  DateModif?: any;
  GroupeClause?: number;
  IdSyncCritere?: number;
  JourRef?: number;
  MoisRef?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Obligatoire?: boolean;
  Operateur?: string;
  Priorite?: number;
  RefCalcAge?: RefCalcAgeSynAdModelDto;
  Status?: StatusDtoEnum;
  TypeBenef?: TypeBenefDto;
  Unite?: string;
  UserCreation?: number;
  UserModif?: UsersDto;
  Valeur1?: string;
  Valeur2?: string;
};

export type CritereSyncAdModelDtoInput = {
  Actif?: boolean;
  CritereSync?: TypeCritereSyncAdModelDtoInput;
  DateCreation?: any;
  DateEffet?: any;
  DateFin?: any;
  DateModif?: any;
  GroupeClause?: number;
  IdSyncCritere?: number;
  JourRef?: number;
  MoisRef?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Obligatoire?: boolean;
  Operateur?: string;
  Priorite?: number;
  RefCalcAge?: RefCalcAgeSynAdModelDtoInput;
  Status?: StatusDtoEnum;
  TypeBenef?: TypeBenefDtoInput;
  Unite?: string;
  UserCreation?: number;
  UserModif?: UsersDtoInput;
  Valeur1?: string;
  Valeur2?: string;
};

export type CriteresAncvModeEnvoiDtoInput = {
  Id?: number;
  IdArticle?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresActiviteCompteBancaireTypeDtoInput = {
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresActiviteDtoInput = {
  Code?: string;
  CodeTypeActivite?: string;
  CodeVersionLogiciel?: string;
  FiltrerElementsClotures?: boolean;
  FiltrerParCommissionViaIdUtilisateur?: number;
  Id?: number;
  IdArticle?: number;
  IdCE?: number;
  IdCEOuCEGlobalProprietaire?: number;
  IdCEProprietaire?: number;
  IdTypActivite?: number;
  IdUser?: number;
  IsCloture?: boolean;
  IsTVA?: boolean;
  IsVisibleDirecto?: boolean;
  ListeCodeModuleTypeActivite?: ArrayOfstringInput;
  ListeTypeActivite?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  PvId?: number;
  RedescendreParametrageCompteurPoint?: boolean;
  RedescendreParametrageRegles?: boolean;
  ReglesSent?: boolean;
  Status?: StatusDtoEnum;
  TakeActiviteForRedescenteRegle?: boolean;
  TakeCEDelegationProprietaire?: boolean;
  TakeCommission?: boolean;
  TakeCompteCollectifClient?: boolean;
  TakeCompteCollectifFour?: boolean;
  TakeCompteFraisPortHA?: boolean;
  TakeCompteFraisPortVente?: boolean;
  TakeCompteTropPercu?: boolean;
  TakeCptAcompteCollectif?: boolean;
  TakeCptCollectif?: boolean;
  TakeDelegationEnveloppe?: boolean;
  TakeEnvImpActivite?: boolean;
  TakeFamProd?: boolean;
  TakeFamille?: boolean;
  TakeForPaiMoy?: boolean;
  TakeForParamFPA?: boolean;
  TakeForSaveActivite?: boolean;
  TakeJournal3?: boolean;
  TakeJournalAchat?: boolean;
  TakeJournalVente?: boolean;
  TakeListeActiviteCompteBancaire?: boolean;
  TakeListeCEDelegation?: boolean;
  TakeListePointVente?: boolean;
  TakeTypeActivite?: boolean;
  WithEnveloppe?: boolean;
};

export type CriteresActiviteLightModelInput = {
  IdCommission?: number;
  IdDelegaitonOrCEGlobalePortail?: number;
  IdDelegation?: number;
  IdModeleFraisAnnualtion?: number;
  IsClos?: boolean;
  ListeCodeActivite?: ArrayOfstringInput;
  ListeCodeTypeActivite?: ArrayOfstringInput;
  ListeIdsActivite?: ArrayOfdecimalInput;
};

export type CriteresActualitesMobileInput = {
  DateCreationDebut?: any;
  DateCreationFin?: any;
  DateEnvoiDebut?: any;
  DateEnvoiFin?: any;
  IdActualite?: number;
  IdDelegation?: number;
  IdDelegationOuGlobale?: number;
  IdFile?: number;
  IsCloture?: boolean;
  IsEnvoye?: boolean;
  IsValide?: boolean;
  NotListeIdActu?: ArrayOfdecimalInput;
  OperateurDateCreation?: string;
  OperateurDateEnvoi?: string;
  OrderByDateCreationDESC?: boolean;
  OrderByDateEnvoiDESC?: boolean;
  OrderByStatutDESC?: boolean;
  OrderByTitreActualiteDESC?: boolean;
  Recherche?: string;
  Skip?: number;
  Take?: number;
};

export type CriteresAdresseDtoInput = {
  Id?: number;
  IdBenef?: number;
  IdPointVente?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeInfosAdresse?: boolean;
  TakeVille?: boolean;
};

export type CriteresAffectationTiersModelInput = {
  IdCompteTiers?: number;
  ListeIdMouvements?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresAgendaDtoInput = {
  DateAgenda?: any;
  Id?: number;
  IdCE?: number;
  IdUser?: number;
  MonthByDay?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeCE?: boolean;
  TakeUser?: boolean;
};

export type CriteresAnneeReferenceDtoInput = {
  CodeAnnee?: string;
  CurrentAnneeRef?: boolean;
  FromDate?: any;
  Id?: number;
  IsClos?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeAnneeReferenceValidation?: boolean;
  TakeAnneeReferenceValidationEtBenef?: boolean;
};

export type CriteresAnnonceCategorieDtoInput = {
  CodeTypeAnnonce?: string;
  Id?: number;
  IdUser?: number;
  IsClos?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeAnnonceCategChamp?: boolean;
  TakeAnnonceCategorieUserGest?: boolean;
  TakeAnnoncePrix?: boolean;
  TakeChampsPersos?: boolean;
  TakeDelegation?: boolean;
  TakeGestionnaires?: boolean;
};

export type CriteresAnnonceDtoInput = {
  BenefId?: number;
  CategorieId?: number;
  CeDelegationId?: number;
  CheckDatePubValable?: boolean;
  CheckDimanche?: boolean;
  CheckJeudi?: boolean;
  CheckLundi?: boolean;
  CheckMardi?: boolean;
  CheckMercredi?: boolean;
  CheckSamedi?: boolean;
  CheckVendredi?: boolean;
  ContrePartieProposee?: string;
  DateCloture?: any;
  DateCreation?: any;
  DateDebutPublication?: any;
  DateFinPublication?: any;
  DepartementArrId?: number;
  DepartementId?: number;
  HeureAllerA?: number;
  HeureAllerDe?: number;
  HeureRetourA?: number;
  HeureRetourDe?: number;
  Id?: number;
  IsAnnonceValidee?: boolean;
  IsClos?: boolean;
  IsDepassee?: boolean;
  IsOffre?: boolean;
  IsStatutEnAttente?: boolean;
  IsStatutEnCours?: boolean;
  IsStatutTermine?: boolean;
  IsTypeCovoiturage?: boolean;
  IsTypePetiteAnnonce?: boolean;
  MontantPropose?: number;
  MotifCloture?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OffreDemande?: string;
  OperationDate?: string;
  OrdreDateCreationAscendant?: boolean;
  OrdreDateDebutPubAscendant?: boolean;
  PrixAPayerPourBenef?: number;
  RegionArrId?: number;
  RegionId?: number;
  SkipNbLignes?: number;
  Status?: StatusDtoEnum;
  TakeAnnonceTypeJour?: boolean;
  TakeBeneficiaire?: boolean;
  TakeCategorie?: boolean;
  TakeDetailsAnnonce?: boolean;
  TakeDetailsTrajet?: boolean;
  TakeNbLignes?: number;
  Titre?: string;
  VilleArrId?: number;
  VilleId?: number;
};

export type CriteresArreteEtRemiseCaisseModelInput = {
  DateDebutArrete?: any;
  DateFinArrete?: any;
  IdArrete?: number;
  IdCaisse?: number;
  IdPVOfCaisse?: number;
  IdUserOfCaisse?: number;
  IdUtilisateurDerniereModif?: number;
  IsEnErreurDeCaisse?: boolean;
  IsSupprime?: boolean;
  IsValide?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Skip?: number;
  Status?: StatusDtoEnum;
  Take?: number;
  WithEnCours?: boolean;
  WithSupprime?: boolean;
  WithValide?: boolean;
};

export type CriteresArticleChequierDtoInput = {
  ArticleId?: number;
  ChequierId?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeArticle?: boolean;
  TakeChequier?: boolean;
};

export type CriteresArticleDtoInput = {
  ArticleRecherche?: string;
  CodeMvt?: string;
  CodeOuCodebarre?: string;
  CodeRechArtAchatFour?: string;
  ComparaisonPV?: string;
  ComparaissonQteStockDispo?: string;
  ComparateurDateLocation?: string;
  DateArticleAchatFour?: any;
  DateLocationStrictementInferieure?: any;
  DateLocationStrictementSuperieure?: any;
  DateVente?: any;
  HavePVActuelOrIsGenerique?: boolean;
  HavePVActuelOrIsGeneriqueOrChqDyna?: boolean;
  Id?: number;
  IdActivite?: number;
  IdEnveloppeImpute?: number;
  IdFamille?: number;
  IdFourReappro?: number;
  IdFournisseur?: number;
  IdLigneCde?: number;
  IdProduit?: number;
  IdRegle?: number;
  IdStock?: number;
  IsArticleChequierDynamique?: boolean;
  IsArticleVituel?: boolean;
  IsCloture?: boolean;
  IsDisponibleEnStock?: boolean;
  IsFiltreIdFour?: boolean;
  IsGenerique?: boolean;
  IsGereEnStock?: boolean;
  IsGererInSelectedStock?: boolean;
  IsNotNullablePrix?: boolean;
  IsOptionLocation?: boolean;
  IsOrderByDateLoc?: boolean;
  IsPrixAchatEnCours?: boolean;
  IsSurProduitRemboursement?: boolean;
  IsVisibleDirecto?: boolean;
  LibelleContains?: string;
  ListeIdArticle?: string;
  ListeTypeActivite?: string;
  LocDateInferieur?: any;
  LocDateSuperieur?: any;
  LocationInDate?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  OrderByNiveauFPA?: number;
  PossedePrixDeVenteActuel?: boolean;
  PrixAchatMax?: number;
  PrixAchatMin?: number;
  PrixValeurFacialeMax?: number;
  PrixValeurFacialeMin?: number;
  PrixVenteEnd?: number;
  PrixVenteMax?: number;
  PrixVenteMin?: number;
  PrixVenteStart?: number;
  QteStockDisponibleEnd?: number;
  QteStockDisponibleStart?: number;
  ReferenceCodeBarre?: string;
  Status?: StatusDtoEnum;
  TakeArticleChequier?: boolean;
  TakeArticleSectionAnalytique?: boolean;
  TakeArticleSessionChoix?: boolean;
  TakeArticleStockLocation?: boolean;
  TakeForGetArticle?: boolean;
  TakeForGetArticlePlus?: boolean;
  TakeForGetChamps?: boolean;
  TakeForGetListeArticle?: boolean;
  TakeForModuleVente?: boolean;
  TakeForParamFPAChampsPerso?: boolean;
  TakeForParamFPACompteursPts?: boolean;
  TakeForParamFPAImputationComptable?: boolean;
  TakeForParamFPAInfosGene?: boolean;
  TakeForParamFPAModesLivraison?: boolean;
  TakeForParamFPAPrixAchatVente?: boolean;
  TakeForParamFPAPrixVente?: boolean;
  TakeForParamFPARegles?: boolean;
  TakeModeEnvoiANCV?: boolean;
  TakeMoyenPaiement?: boolean;
  TakePhoto?: boolean;
  TakeProdEtFamilleTakeStockTyperReappro?: boolean;
  WithActType?: boolean;
  WithActivite?: boolean;
  WithArtFour?: boolean;
  WithCompteVente?: boolean;
  WithFamille?: boolean;
  WithFourFavori?: boolean;
  WithModeLivraison?: boolean;
  WithPJ?: boolean;
  WithPrixVente?: boolean;
  WithProduit?: boolean;
  WithRemboursement?: boolean;
  WithSessionChoix?: boolean;
  WithStock?: boolean;
  WithStockArticle?: boolean;
};

export type CriteresArticleEditorielModelInput = {
  CodeTypeArticle?: string;
  DateCreationDebut?: any;
  DateCreationFin?: any;
  DateDerniereModifDebut?: any;
  DateDerniereModifFin?: any;
  HaveCommentaires?: boolean;
  Id?: number;
  IdCategorie?: number;
  IdCe?: number;
  IdDelegOuDelegGlobale?: number;
  IdMenuEnfant?: number;
  IdMenuParent?: number;
  IdPortlet?: number;
  IdProduit?: number;
  IsActualite?: boolean;
  IsDateValide?: boolean;
  IsDirecto?: boolean;
  IsDisplayedAccueilPublic?: boolean;
  IsEditorial?: boolean;
  IsInBlog?: boolean;
  IsRefuse?: boolean;
  IsValide?: boolean;
  ListeCodeArtTypExcluded?: ArrayOfstringInput;
  ListeCodeStatuts?: ArrayOfstringInput;
  ListeCodeTypeArticle?: ArrayOfstringInput;
  ListeIdArticle?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  OrderByDateCRE?: boolean;
  OrderByDateMAJ?: boolean;
  OrderById?: boolean;
  OrderByOrdre?: boolean;
  OrderByTitre?: boolean;
  Skip?: number;
  Status?: StatusDtoEnum;
  Take?: number;
  TitreCorpsTagContains?: string;
};

export type CriteresArticleFournisseurModelInput = {
  ComparateurDateAchat?: string;
  DateAchatDebut?: any;
  DateAchatFin?: any;
  Id?: number;
  IdActivite?: number;
  IdArticle?: number;
  IdFamille?: number;
  IdFournisseur?: number;
  IdProduit?: number;
  IsArticleCloture?: boolean;
  IsCloture?: boolean;
  IsPrixAchatEnCours?: boolean;
  LibelleArticle?: string;
  ListeCodeActivitePrefiltrage?: ArrayOfstringInput;
  Prix?: number;
  PrixAchatMax?: number;
  PrixAchatMin?: number;
  PrixValeurFacialeMax?: number;
  PrixValeurFacialeMin?: number;
  PrixVenteMax?: number;
  PrixVenteMin?: number;
};

export type CriteresArticleImputationEnErreurModelInput = {
  DateDebut?: any;
  DateFin?: any;
  IdActivite?: number;
  IdDelegation?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsComptesStockManquants?: boolean;
  IsRepartitionAnalytiqueManquante?: boolean;
  LibelleArticle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  Status?: StatusDtoEnum;
};

export type CriteresArticleLightModelInput = {
  ActeurAuteurArtiste?: string;
  AreDisplayedDirecto?: boolean;
  CibleMediaExemplaire?: string;
  CollectionMediaExemplaire?: string;
  ComparaisonDateAchat?: string;
  ComparaisonDateEdition?: string;
  ComparaisonDateNouveauteMedia?: string;
  ComparaisonDateSortie?: string;
  ComptarateurDate?: string;
  CoteMediaExemplaire?: string;
  DateDebutAchat?: any;
  DateDebutBlocage?: any;
  DateDebutEdition?: any;
  DateDebutNouveauteMedia?: any;
  DateDebutSortie?: any;
  DateFinAchat?: any;
  DateFinBlocage?: any;
  DateFinEdition?: any;
  DateFinNouveauteMedia?: any;
  DateFinSortie?: any;
  EditeurMediaExemplaire?: string;
  FromCommandeEnLigne?: boolean;
  GenreMediaExemplaire?: string;
  IdActivite?: number;
  IdArticle?: number;
  IdBeneficiaire?: number;
  IdCompteChargeOuProduit?: number;
  IdDelegPourFiltreActivite?: number;
  IdDelegationActivite?: number;
  IdFamille?: number;
  IdFournisseur?: number;
  IdLocalisation?: number;
  IdModeleTVA?: number;
  IdProduit?: number;
  IdStock?: number;
  IdStockLivraison?: number;
  IdStockRattachement?: number;
  IsAFPAVisibleEnLigne?: boolean;
  IsBloque?: boolean;
  IsChequierDynamique?: boolean;
  IsClos?: boolean;
  IsGenerique?: boolean;
  IsGeneriqueOrHasPrixActuels?: boolean;
  IsGereEnStock?: boolean;
  IsOptionLocation?: boolean;
  IsPerdu?: boolean;
  IsVirtuel?: boolean;
  IsVisibleEnLigne?: boolean;
  LibelleArticle?: string;
  LibelleDescriptionContains?: string;
  ListeCodeTypeActivite?: ArrayOfstringInput;
  ListeIdArticle?: ArrayOfdecimalInput;
  ListeIdFamilles?: ArrayOfdecimalInput;
  ListeIdProduits?: ArrayOfdecimalInput;
  ListeStatut?: ArrayOfstringInput;
  MDKTypeMedia?: string;
  MdkIsALivrer?: boolean;
  NbSkip?: number;
  NbTakes?: number;
  NumerotationMediaExemplaire?: string;
  OrderByLibelleASC?: boolean;
  OrderByLibelleProduitASC?: boolean;
  OrderByLibelleProduitDESC?: boolean;
  OrderByPrixASC?: boolean;
  OrderByPrixDESC?: boolean;
  ReferenceMediaExemplaire?: string;
  SousCollectionMediaExemplaire?: string;
  TakeChequierDynamiques?: boolean;
  ThemeSujetMediaExemplaire?: string;
  TitleStartWith?: boolean;
  TitreMediaExemplaire?: string;
};

export type CriteresArticleModelInput = {
  DateFinCreationCommande?: any;
  DateLimiteComparateur?: string;
  DateLimiteEnd?: any;
  DateLimiteStart?: any;
  DateLocation?: any;
  IdActivite?: number;
  IdArticle?: number;
  IdCompteChargeOuProduit?: number;
  IdFamille?: number;
  IdModeleFraisAnnulation?: number;
  IdModeleTVA?: number;
  IdProduit?: number;
  IdSessionChoix?: number;
  IsAllotement?: boolean;
  IsClos?: boolean;
  IsCommandeFinish?: boolean;
  IsConflitDemandesOptions?: boolean;
  IsOptionLocation?: boolean;
  IsSansDemande?: boolean;
  IsVirtuel?: boolean;
  LibelleArticle?: string;
  ListeStatutAdministratifCommande?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  OrderByAFPADatesc?: boolean;
  OrderByDifferenceDemandesOptions?: boolean;
  Skip?: number;
  Status?: StatusDtoEnum;
  Take?: number;
};

export type CriteresArticlesFournisseurModelInput = {
  DateCommandeClient?: any;
  DateCommandeFournisseur?: any;
  HasCommandeFournisseur?: boolean;
  IdActivite?: number;
  IdCommandeFournisseur?: number;
  IdDelegation?: number;
  IdFournisseur?: number;
  IdPointVente?: number;
  IdStock?: number;
  IdUtilisateur?: number;
  IsArticleAvecPrixAchat?: boolean;
  IsClos?: boolean;
  IsCommandeFinish?: boolean;
  IsCommandeGenerique?: boolean;
  IsCommandeReappro?: boolean;
  IsEnCourSaisie?: boolean;
  ListeIdArticles?: ArrayOfdecimalInput;
  ListeIdOrganisations?: ArrayOfdecimalInput;
  ListeIdSites?: ArrayOfdecimalInput;
  ListeIdStatutsPerso?: ArrayOfdecimalInput;
  ListeIdStatutsReglement?: ArrayOfdecimalInput;
  ListeStatutsAdm?: ArrayOfstringInput;
  MontantFraisPort?: number;
};

export type CriteresAttributionAutoDtoInput = {
  CritereLigneCommande?: CriteresLigneCommandeDtoInput;
  Id?: number;
  IdAct?: number;
  OrderByDate?: boolean;
  TakeForNewAttribution?: boolean;
  TakeListAttributionBenef?: boolean;
};

export type CriteresAttributionBudgetDtoInput = {
  Context?: string;
  Id?: number;
  IdActivite?: number;
  IdCE?: number;
  IsAbondement?: boolean;
  IsClos?: boolean;
  IsOrderByLibelle?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeActivite?: boolean;
  TakeArticle?: boolean;
  TakeAttBDGForAddOrUpdate?: boolean;
  TakeAttBDGForDeleted?: boolean;
};

export type CriteresAttributionRanDtoInput = {
  Id?: number;
  IdCE?: number;
  IdEnveloppe?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeAttRanForAddOrUpdate?: boolean;
  TakeAttRanForDeleted?: boolean;
};

export type CriteresBanqueDto = {
  __typename?: 'CriteresBanqueDTO';
  Id?: number;
  IdCe?: number;
  IsCloture?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeAdresse?: boolean;
  TakeCEDelegation?: boolean;
  TakeCeCompteBancaire?: boolean;
  TakeCompteBancaireForParam?: boolean;
  TakeContact?: boolean;
  TakeForSaveBanqueAndForParam?: boolean;
};

export type CriteresBanqueDtoInput = {
  Id?: number;
  IdCe?: number;
  IsCloture?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeAdresse?: boolean;
  TakeCEDelegation?: boolean;
  TakeCeCompteBancaire?: boolean;
  TakeCompteBancaireForParam?: boolean;
  TakeContact?: boolean;
  TakeForSaveBanqueAndForParam?: boolean;
};

export type CriteresBanqueModelInput = {
  IdBanque?: number;
  IsClos?: boolean;
  NomBanqueVide?: boolean;
};

export type CriteresBanqueRemiseDtoInput = {
  CaisseId?: number;
  CompteBancaireId?: number;
  DateDeb?: any;
  DateFin?: any;
  Id?: number;
  IdDelegation?: number;
  IsSupprime?: boolean;
  MoyenPaiementId?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  Status?: StatusDtoEnum;
  TakeAdresseBanque?: boolean;
  TakeForGenerationPrelevementSEPA?: boolean;
  TakeForGenerationVirementSEPA?: boolean;
  TakeForSaveRemise?: boolean;
  TakeLigneRemiseEnBanque?: boolean;
  TakeMouvementAndBenef?: boolean;
  TakeMoyenPaiement?: boolean;
  TakeRib?: boolean;
  TakeRibTiers?: boolean;
  TakeTiersSurEcriture?: boolean;
  UserId?: number;
};

export type CriteresBenefBaseModelInput = {
  BenefAvecDroitActifToutCE?: boolean;
  BenefSansBlocageDroitToutCE?: boolean;
  DateCreationMax?: any;
  DateCreationMin?: any;
  DateEmbaucheDebut?: any;
  DateEmbaucheFin?: any;
  DateNaissance?: any;
  Email?: string;
  IdBeneficiaire?: number;
  IdCEPourTestDroitsActifs?: number;
  IdCEPourTestNonBlocageDroit?: number;
  IdCe?: number;
  IsCloture?: boolean;
  IsOuvrantDroit?: boolean;
  ListIdBenef?: ArrayOfdecimalInput;
  Matricule?: string;
  Nom?: string;
  Prenom?: string;
  UserId?: number;
};

export type CriteresBenefContactModelInput = {
  BenefAvecDroitActifToutCE?: boolean;
  BenefSansBlocageDroitToutCE?: boolean;
  DateCreationMax?: any;
  DateCreationMin?: any;
  DateEmbaucheDebut?: any;
  DateEmbaucheFin?: any;
  DateNaissance?: any;
  Email?: string;
  HaveEmailPerso?: boolean;
  HaveEmailPriviligie?: boolean;
  HaveEmailProfOrPerso?: boolean;
  HaveEmailProfessionel?: boolean;
  IdBeneficiaire?: number;
  IdCEPourTestDroitsActifs?: number;
  IdCEPourTestNonBlocageDroit?: number;
  IdCe?: number;
  IdHistoriqueEnvoi?: number;
  IsCloture?: boolean;
  IsOuvrantDroit?: boolean;
  ListIdBenef?: ArrayOfdecimalInput;
  Matricule?: string;
  Nom?: string;
  Prenom?: string;
  UserId?: number;
};

export type CriteresBenefDtoInput = {
  BenefAvecBlocageDroitSurDeleg?: number;
  BenefAvecBlocageInsesl?: boolean;
  BenefAvecDroitActif?: boolean;
  BenefAvecDroitActifSurDeleg?: number;
  BenefAvecDroitActifToutCE?: boolean;
  BenefSansBlocageDroit?: boolean;
  BenefSansBlocageDroitSurDeleg?: number;
  BenefSansBlocageDroitToutCE?: boolean;
  BenefSansDroitActifSurDeleg?: number;
  BenefSansPoint?: boolean;
  BenefSexe?: string;
  BenefSurDelegationCourante?: boolean;
  Clotures?: EtatClotureEnum;
  CodePostalStartsWith?: string;
  ComparaisonDateEmbauche?: string;
  ComparaisonDateNaiss?: string;
  ContainsAdr1234?: string;
  ContainsMailProPerso?: string;
  ContainsMatricule?: string;
  ContainsNom?: string;
  ContainsNomPrenomOuMatricule?: string;
  ContainsPrenom?: string;
  ContainsTelProPersoGsmFax?: string;
  ContainsVille?: string;
  DateDerniereModif?: any;
  DateEmbaucheDebut?: any;
  DateEmbaucheFin?: any;
  DateInscriptionDebut?: any;
  DateInscriptionFin?: any;
  DateNaissDebut?: any;
  DateNaissFin?: any;
  FaitPartieDeLorgaID?: number;
  FaitPartieDuSiteID?: number;
  HasAdresseWithCP?: string;
  Id?: number;
  IdAnneeRef?: number;
  IdBenefAAfficherEnPlus?: number;
  IdBenefDifferentDe?: number;
  IdCEForBenefCE?: number;
  IdCurrentDelegation?: number;
  IdDelegation?: number;
  IdGroupe?: number;
  IdOrganisation?: number;
  IdOuvrantDroit?: number;
  IdSite?: number;
  IsForExport?: boolean;
  IsOuvrantDroit?: boolean;
  LigneDepart?: number;
  ListeIdBenef?: string;
  ListeIdBenefs?: ArrayOfdecimalInput;
  ListeIdNewsletterTheme?: ArrayOfdecimalInput;
  MatriculeEquals?: string;
  MatriculeOdContains?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbLignes?: number;
  NbSkip?: number;
  NbTake?: number;
  Nom?: string;
  NomOdContains?: string;
  NomPrenomMatriculeStartsWith?: string;
  NomStartsWith?: string;
  ODetAdByIdOD?: number;
  OnDelegationGlobale?: boolean;
  OperateurDateInscription?: string;
  OrdreDeTri?: ArrayOfstringInput;
  OuvrantDroitHasDroits?: boolean;
  Password?: string;
  PeriodeES?: PeriodeEntreeSortieEnum;
  PrendreAnciensBenefs?: boolean;
  Prenom?: string;
  PrenomOdContains?: string;
  Pseudo?: string;
  RechercheSimple?: boolean;
  Status?: StatusDtoEnum;
  TakeAdresses?: boolean;
  TakeAyantDroit?: boolean;
  TakeCEDelegationChampValeur?: boolean;
  TakeCeDelegation?: boolean;
  TakeChamp?: boolean;
  TakeChampListeValeur?: boolean;
  TakeChampValeur?: boolean;
  TakeChampValeurComplet?: boolean;
  TakeCompteTiers?: boolean;
  TakeCompteTiersEtBenef?: boolean;
  TakeContrat?: boolean;
  TakeCriteresSociauxFicheSignaletique?: boolean;
  TakeDelegOnly?: boolean;
  TakeForBenefNew?: boolean;
  TakeForBenefPartiel?: boolean;
  TakeForExBeneficiaireGenerique?: boolean;
  TakeForSaveDossierBenef?: boolean;
  TakeMigrationV1V2?: boolean;
  TakeOrganisation?: boolean;
  TakeOrganisationAdresse?: boolean;
  TakeOrganisationPereAdresse?: boolean;
  TakeOuvrantDroit?: boolean;
  TakePhoto?: boolean;
  TakeProcCriteresSociaux?: boolean;
  TakeRibEtMandat?: boolean;
  TakeRibs?: boolean;
  TakeSaveChampValeur?: boolean;
  TakeSexe?: boolean;
  TakeSite?: boolean;
  TakeSiteAdresse?: boolean;
  TakeSitePereAdresse?: boolean;
  VoirBenefEnErreur?: boolean;
  VoirBenefNonSynchro?: boolean;
  VoirBenefSansProfil?: boolean;
  VoirBenefSubNonSynchro?: boolean;
  WithConjoint?: boolean;
  WithContratID?: number;
  WithExterne?: boolean;
  WithMetierID?: number;
  WithOrganisationFille?: boolean;
  WithSiteFils?: boolean;
};

export type CriteresBenefMoyenContacteMailInput = {
  IsEmailPerso?: boolean;
  IsEmailPriviligie?: boolean;
  IsEmailPriviligiePerso?: boolean;
  IsEmailPriviligiePro?: boolean;
  IsEmailPro?: boolean;
  IsEmailProfOrPerso?: boolean;
};

export type CriteresBenefNewsletterModelInput = {
  BenefAvecDroitActifToutCE?: boolean;
  BenefSansBlocageDroitToutCE?: boolean;
  DateCreationMax?: any;
  DateCreationMin?: any;
  DateEmbaucheDebut?: any;
  DateEmbaucheFin?: any;
  DateNaissance?: any;
  Email?: string;
  HaveEmailPerso?: boolean;
  HaveEmailPriviligie?: boolean;
  HaveEmailProfOrPerso?: boolean;
  HaveEmailProfessionel?: boolean;
  IdBeneficiaire?: number;
  IdCEPourTestDroitsActifs?: number;
  IdCEPourTestNonBlocageDroit?: number;
  IdCe?: number;
  IdHistoriqueEnvoi?: number;
  IsCloture?: boolean;
  IsOuvrantDroit?: boolean;
  ListIdBenef?: ArrayOfdecimalInput;
  ListeIdContrat?: ArrayOfdecimalInput;
  ListeIdOrganisation?: ArrayOfdecimalInput;
  ListeIdSite?: ArrayOfdecimalInput;
  ListeIdThemes?: ArrayOfdecimalInput;
  Matricule?: string;
  Nom?: string;
  Prenom?: string;
  UserId?: number;
};

export type CriteresBenefSynchroSynapseModelInput = {
  BenefAvecDroitActifToutCE?: boolean;
  BenefSansBlocageDroitToutCE?: boolean;
  DateCreationMax?: any;
  DateCreationMin?: any;
  DateEmbaucheDebut?: any;
  DateEmbaucheFin?: any;
  DateNaissance?: any;
  Email?: string;
  IdBeneficiaire?: number;
  IdCEPourTestDroitsActifs?: number;
  IdCEPourTestNonBlocageDroit?: number;
  IdCe?: number;
  IsCloture?: boolean;
  IsOuvrantDroit?: boolean;
  ListIdBenef?: ArrayOfdecimalInput;
  ListeIdContrat?: string;
  ListeIdOrganisation?: string;
  ListeIdSite?: string;
  Matricule?: string;
  Nom?: string;
  Prenom?: string;
  UserId?: number;
  VoirBenefNonSynchro?: boolean;
};

export type CriteresBlbrDtoInput = {
  Comparateur?: string;
  DateInferieur?: any;
  DateSuperieur?: any;
  Id?: number;
  IdActivite?: number;
  IdActiviteDossierPrestaLie?: number;
  IdBenef?: number;
  IdCDE?: number;
  IdDelegation?: number;
  IdDossierPresta?: number;
  IdFournisseur?: number;
  IdSite?: number;
  IsBLAnnule?: boolean;
  IsBonLivraison?: boolean;
  IsBonRetour?: boolean;
  IsContexteClient?: boolean;
  IsContexteFournisseur?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTake?: number;
  OnlyBlBrNonSupprime?: boolean;
  RechercheString?: string;
  Status?: StatusDtoEnum;
  TakeAdresseFigeePV?: boolean;
  TakeAdresseFigeeTiers?: boolean;
  TakeDevisCommande?: boolean;
  TakeDevisCommandeTiers?: boolean;
  TakeExGetBlBr?: boolean;
  TakeForExSaveListeModel?: boolean;
  TakeLigneBLBLRandBLBRandModeLivraison?: boolean;
  TakeLigneBLBR?: boolean;
  TakeLigneDevisCommande?: boolean;
  TakeModeLivraison?: boolean;
  TakeMouvementBlBr?: boolean;
  TakeStatutLivraisonLigneCommande?: boolean;
  TakeUser?: boolean;
};

export type CriteresBorneStatModelInput = {
  IdBorneStat?: number;
  IdChamp?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresBudgetDtoInput = {
  Id?: number;
  IdBudgetPere?: number;
  IdDeleg?: number;
  IdExercice?: number;
  IsAnalytique?: boolean;
  IsAnnuel?: boolean;
  IsQueBudgetPere?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NumMoisForImpression?: number;
  Status?: StatusDtoEnum;
  TakeBugetPere?: boolean;
  TakeCE?: boolean;
  TakeCommission?: boolean;
  TakeExercice?: boolean;
  TakePlanAnalytique?: boolean;
  TakePosteBudgetaire?: boolean;
  TakePosteBudgetaireForAnnulation?: boolean;
  TakeSousBudget?: boolean;
  TypeFonctionnementBDG?: string;
};

export type CriteresCeDelegationDto = {
  __typename?: 'CriteresCEDelegationDTO';
  Id?: number;
  IdUser?: number;
  IsCloture?: boolean;
  IsGlobale?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeAdresseVille?: boolean;
  TakeCaisse?: boolean;
  TakeCompteFCB?: boolean;
  TakeInitParameters?: boolean;
  TakePointVente?: boolean;
  TakeSkin?: boolean;
  TakeStock?: boolean;
};

export type CriteresCeDelegationDtoInput = {
  Id?: number;
  IdUser?: number;
  IsCloture?: boolean;
  IsGlobale?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeAdresseVille?: boolean;
  TakeCaisse?: boolean;
  TakeCompteFCB?: boolean;
  TakeInitParameters?: boolean;
  TakePointVente?: boolean;
  TakeSkin?: boolean;
  TakeStock?: boolean;
};

export type CriteresCaisseDtoInput = {
  Id?: number;
  IdUser?: number;
  IsBloqueRemiseEnBanque?: boolean;
  IsCaisseCentrale?: boolean;
  IsClos?: boolean;
  ListeCompteReglementFiduciaire?: ArrayOfCompteReglementFiduciaireModelDtoInput;
  ListeJournauxCaisseMoyenPaiementFidu?: ArrayOfCaisseCaisseJournauxReglementFiduModelInput;
  ListePVId?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NotId?: number;
  PvId?: number;
  Status?: StatusDtoEnum;
  TakeCaisseCentrale?: boolean;
  TakeComptePerte?: boolean;
  TakeCompteProfit?: boolean;
  TakeCompteVirement?: boolean;
  TakeJournal?: boolean;
  TakePointVente?: boolean;
  TakeSectionAnalytique?: boolean;
  TakeStock?: boolean;
  TakeUser?: boolean;
};

export type CriteresCessionStockBaseModelInput = {
  DateDebutCession?: any;
  DateFinCession?: any;
  IdActiviteEntree?: number;
  IdActiviteSortie?: number;
  IdArticleEntree?: number;
  IdArticleSortie?: number;
  IdCession?: number;
  IdDelegationEntree?: number;
  IdDelegationSortie?: number;
  IdFamilleEntree?: number;
  IdFamilleSortie?: number;
  IdPointVenteEntree?: number;
  IdPointVenteSortie?: number;
  IdStockEntree?: number;
  IdStockSortie?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  OrderByDateDesc?: boolean;
  Status?: StatusDtoEnum;
};

export type CriteresCessionStockModelInput = {
  ComparateurDates?: string;
  DateDebutCession?: any;
  DateFinCession?: any;
  IdActiviteEntree?: number;
  IdActiviteSortie?: number;
  IdArticleEntree?: number;
  IdArticleSortie?: number;
  IdCession?: number;
  IdDelegationEntree?: number;
  IdDelegationSortie?: number;
  IdFamilleEntree?: number;
  IdFamilleSortie?: number;
  IdPointVenteEntree?: number;
  IdPointVenteSortie?: number;
  IdStockEntree?: number;
  IdStockSortie?: number;
  IsAnnulee?: boolean;
  IsEnAttente?: boolean;
  IsNonReceptionnee?: boolean;
  IsPartiellementReceptionnee?: boolean;
  IsReceptionnee?: boolean;
  IsSupprimee?: boolean;
  LibelleContient?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  OrderByDateDesc?: boolean;
  Status?: StatusDtoEnum;
};

export type CriteresChampDtoInput = {
  ChargerChampsSousNiveaux?: boolean;
  Code?: string;
  FiltrerParamGlobaux?: boolean;
  Id?: number;
  IdActivite?: number;
  IdActiviteParamVal?: number;
  IdArticle?: number;
  IdFamille?: number;
  IdProduit?: number;
  IdTypeActivite?: number;
  IsChampCritere?: boolean;
  IsChampCritereAD?: boolean;
  IsChampCritereQuota?: boolean;
  IsChampCritereSub?: boolean;
  IsChampSpecifiqueGestion?: boolean;
  IsChampsBoolean?: boolean;
  IsChampsCalcules?: boolean;
  IsChampsCalculesDynamiques?: boolean;
  IsChampsMembre?: boolean;
  IsChampsNonCalcules?: boolean;
  IsChampsPersoActivite?: boolean;
  IsChampsPersoBeneficiaire?: boolean;
  IsChampsPersoForActivite?: boolean;
  IsCritSoc?: boolean;
  IsCritSocPerso?: boolean;
  IsNbPartsOrQf?: boolean;
  IsParam?: boolean;
  IsParamActivite?: boolean;
  IsTypeNumeriqueOrListeVal?: boolean;
  Libelle?: string;
  ListeCode?: ArrayOfstringInput;
  ListeCodeModuleAccessible?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeActivite?: boolean;
  TakeChampListeValeur?: boolean;
  TakeChampListeValeurDef?: boolean;
  TakeChampTypeDonnee?: boolean;
  TakeForCritSocCalculeOrNonCalcule?: boolean;
  TakeForFPA?: boolean;
  TakeForPersoActivite?: boolean;
  TakeForPersoBenef?: boolean;
  TakeForSaveChamp?: boolean;
  TakeForSaveListeChampPerso?: boolean;
  TakeInitParameters?: boolean;
  TakeParamVal?: boolean;
  TakeParamValPlus?: boolean;
  TypeRech?: string;
  UserPeutVoirChampAdmin?: boolean;
  WithNbPart?: boolean;
  WithQF?: boolean;
};

export type CriteresChampListeValeurDtoInput = {
  Code?: string;
  CodeCHP?: string;
  Id?: number;
  IdBenef?: number;
  IdChamp?: number;
  IsCloture?: boolean;
  IsNotTakeChpBenef?: boolean;
  Libelle?: string;
  ListeCodeCHP?: string;
  ListeId?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeBenefOfChampValeur?: boolean;
  TakeChamp?: boolean;
  TakeChampOfChampValeur?: boolean;
  TakeChampValeur?: boolean;
  TakeForWithBenef?: boolean;
  WithFirstOrDefault?: boolean;
};

export type CriteresChampTypeDonneeDtoInput = {
  Code?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresChampValeurDtoInput = {
  BenefId?: number;
  Code?: string;
  CodeCHP?: string;
  Id?: number;
  IdAnneeReference?: number;
  IdArticle?: number;
  IdChamp?: number;
  IdChampListVal?: boolean;
  IdFamille?: number;
  IdProduit?: number;
  IsOrderingByDateDeb?: boolean;
  ListeBenefId?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  SkipNbLignes?: number;
  Status?: StatusDtoEnum;
  TakeAnneeReference?: boolean;
  TakeArticle?: boolean;
  TakeBenef?: boolean;
  TakeChamp?: boolean;
  TakeChampListeVal?: boolean;
  TakeCommande?: boolean;
  TakeFamille?: boolean;
  TakeInitParameters?: boolean;
  TakeNbLignes?: number;
  TakeProduit?: boolean;
};

export type CriteresChampsModelInput = {
  CodeChamp?: string;
  CodeTypeChamp?: string;
  IdArticle?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsActivite?: boolean;
  IsAppliqueArticle?: boolean;
  IsAppliqueFamille?: boolean;
  IsAppliqueProduit?: boolean;
  IsChampDynamique?: boolean;
  IsClos?: boolean;
  IsCritereAccessibilite?: boolean;
  IsCriteresSociaux?: boolean;
  IsMembre?: boolean;
  IsMembreAD?: boolean;
  IsPerso?: boolean;
  IsSubventions?: boolean;
  ListeCodeChamp?: ArrayOfstringInput;
  ListeIdChamp?: ArrayOfdecimalInput;
  ListeIdTypeActiviteParametres?: ArrayOfdecimalInput;
};

export type CriteresChequierDtoInput = {
  Id?: number;
  IsCloture?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresClotureVariationStockInput = {
  AvecLignesQteZero?: boolean;
  IdActivite?: number;
  IdCloture?: number;
  IdCompteValorisation?: number;
  IdCompteVariation?: number;
  LibelleRecherche?: string;
  NbSkip?: number;
  NbTakes?: number;
};

export type CriteresCommandeBeneficiaireModelInput = {
  CommandeWithFactureSupprimee?: boolean;
  DateDebut?: any;
  DateDebutFacture?: any;
  DateFin?: any;
  DateFinFacture?: any;
  HasDossierPrestration?: boolean;
  IdActivite?: number;
  IdBeneficiaire?: number;
  IsCommandeFinalisee?: boolean;
  ListeCodeStatutAdministratif?: ArrayOfstringInput;
  ListeCodeStatutReglement?: ArrayOfstringInput;
  ListeIdStatutComplementaire?: ArrayOfdecimalInput;
  ListeTypesFacture?: ArrayOfstringInput;
  OperateurDate?: string;
  OperateurDateFacture?: string;
  Recherche?: string;
  Skip?: number;
  Take?: number;
};

export type CriteresCommandeFournisseurModelInput = {
  CommandeWithFactureSupprimee?: boolean;
  DateDebut?: any;
  DateDebutFacture?: any;
  DateFin?: any;
  DateFinFacture?: any;
  HasDossierPrestationLie?: boolean;
  IdActivite?: number;
  IdBeneficiairePrestation?: number;
  IdFournisseur?: number;
  IsCommandeFinalisee?: boolean;
  IsCommandeSaisieLibre?: boolean;
  ListeCodeStatutAdministratif?: ArrayOfstringInput;
  ListeCodeStatutReception?: ArrayOfstringInput;
  ListeCodeStatutReglement?: ArrayOfstringInput;
  ListeIdStatutComplementaire?: ArrayOfdecimalInput;
  ListeTypesFacture?: ArrayOfstringInput;
  NumeroFacture?: string;
  OperateurDate?: string;
  OperateurDateFacture?: string;
  Recherche?: string;
  Skip?: number;
  Take?: number;
};

export type CriteresCommentairesModelInput = {
  ComparateurDate?: string;
  DateDebut?: any;
  DateFin?: any;
  Id?: number;
  IdArticle?: number;
  IdBenef?: number;
  IdDocument?: number;
  IsAnonyme?: boolean;
  IsArticleDisplayedAccueilPublic?: boolean;
  IsCloture?: boolean;
  IsEnAttente?: boolean;
  IsValide?: boolean;
  OrderByDateDesc?: boolean;
  OrderById?: boolean;
  OrderByStatusDESC?: boolean;
  Skip?: number;
  Take?: number;
};

export type CriteresCommissionDtoInput = {
  Id?: number;
  IdDelegation?: number;
  IdDelegationOuDelegationGlobale?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeDelegation?: boolean;
  TakeUser?: boolean;
  WithClotured?: boolean;
};

export type CriteresCommissionModelInput = {
  FromEditOptions?: boolean;
  IdCommission?: number;
  IdDelegation?: number;
  IdEditArticle?: number;
  IdMenu?: number;
  IsClos?: boolean;
  NbSkip?: number;
  NbTake?: number;
};

export type CriteresCompteBancaireDtoInput = {
  AutoriseEncaissement?: boolean;
  AutoriseRemboursement?: boolean;
  Id?: number;
  IdBanque?: number;
  IdDelegOuDelegGlobale?: number;
  IdDelegationCouranteForCompteBancaire?: number;
  IsClos?: boolean;
  ListIdCompteBancaire?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeCEDelegation?: boolean;
  TakeCompte511Agreg?: boolean;
  TakeCompte512?: boolean;
  TakeForGetAllCompteBancaire?: boolean;
  TakeRib?: boolean;
  TakeRibMandat?: boolean;
};

export type CriteresCompteDtoInput = {
  AffichagePlanComptable?: AffichagePlanComptableEnum;
  BalanceSurTiers?: BalanceSurTiersPlanComptableEnum;
  CommencePar?: string;
  ContientDansCodeNumLib?: string;
  DateDeb?: any;
  DateFin?: any;
  HaveMvtOnJournalFonc?: boolean;
  HaveMvtOnJournalSocial?: boolean;
  HaveMvtTiersOnJournalFonc?: boolean;
  HaveMvtTiersOnJournalSocial?: boolean;
  Id?: number;
  IdBudgetOrSSBudget?: number;
  IdCE?: number;
  IdSection?: number;
  IdTiers?: number;
  IdTiersForCptCourantOrPMV?: number;
  IsAggregateur?: boolean;
  IsAgregee?: boolean;
  IsBeneficiaire?: boolean;
  IsBlocked?: boolean;
  IsCentralise?: boolean;
  IsClotured?: boolean;
  IsCollectif?: boolean;
  IsCollectifAcompteClient?: boolean;
  IsCollectifAcompteFour?: boolean;
  IsCollectifClient?: boolean;
  IsCollectifCompteCourantFournisseur?: boolean;
  IsCollectifEtAcompteClient?: boolean;
  IsCollectifEtAcompteFour?: boolean;
  IsCollectifFournisseur?: boolean;
  IsCollectifMoyenPaiement?: boolean;
  IsCollectifPMV?: boolean;
  IsCollectifPret?: boolean;
  IsCompteAccepteLettrage?: boolean;
  IsCompteCourantFourOrClient?: boolean;
  IsFonctionnement?: boolean;
  IsFournisseur?: boolean;
  IsSocial?: boolean;
  IsSoldeExerciceEnCours?: boolean;
  IsTiers?: boolean;
  ListeCaisse?: string;
  ListeIdCompte?: string;
  ListeJournaux?: string;
  ListeStringStartWith?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompte?: string;
  PlageCompteNumDeb?: string;
  PlageCompteNumFin?: string;
  Status?: StatusDtoEnum;
  StringInclude?: string;
  StringStartWith?: string;
  TakeBeneficiaire?: boolean;
  TakeCEDelegation?: boolean;
  TakeCompteTiers?: boolean;
  TakeEcriture?: boolean;
  TakeFournisseur?: boolean;
  TakeJournal?: boolean;
  TakeMouvementEtCompte?: boolean;
  TakePosteBudgetaire?: boolean;
  TakeSection?: boolean;
  TakeSectionSSClasseClasse?: boolean;
  VisionPlanComptable?: VisionPlanComptableEnum;
};

export type CriteresCompteEcritureDtoInput = {
  ComparaisonEcr?: string;
  ContientMvtMontantMax?: number;
  ContientMvtMontantMin?: number;
  ContientMvtMontantOperateur?: string;
  DateDebut?: any;
  DateFin?: any;
  Exercice?: ExerciceDtoInput;
  Facture?: FactureDtoInput;
  Id?: number;
  IdBenef?: number;
  IdCECreePar?: number;
  IdCESource?: number;
  IdCommande?: number;
  IdCompte?: number;
  IdDelegationCourante?: number;
  IdEcheancier?: number;
  IdExerciceOD?: number;
  IdFournisseur?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytique?: number;
  IsEcritureLettree?: boolean;
  IsHistoriqueExport?: boolean;
  IsManuel?: boolean;
  IsPreparationExport?: boolean;
  IsSimulation?: boolean;
  Journal?: JournalDtoInput;
  Libelle?: string;
  ListeIdFacture?: ArrayOfdecimalInput;
  ListeIdJournaux?: ArrayOfdecimalInput;
  MontantBorneMax?: number;
  MontantBorneMin?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumPiece?: string;
  Reference?: string;
  SelectedOperateur?: string;
  Status?: StatusDtoEnum;
  TakeBenef?: boolean;
  TakeCEDelegation?: boolean;
  TakeCEOrigine?: boolean;
  TakeCESource?: boolean;
  TakeCaisse?: boolean;
  TakeCompteMouvement?: boolean;
  TakeCompteTiersMouvement?: boolean;
  TakeEcritureMouvement?: boolean;
  TakeExercice?: boolean;
  TakeFacture?: boolean;
  TakeFactureCompteEcritureFacture?: boolean;
  TakeForAcompte?: boolean;
  TakeForExGetListeCompteEcriture?: boolean;
  TakeForExSaveCompteEcriture?: boolean;
  TakeForExSaveListeCompteEcriture?: boolean;
  TakeForSaveMouvementStock?: boolean;
  TakeFournisseur?: boolean;
  TakeIsRapproche?: boolean;
  TakeJournal?: boolean;
  TakeJournalEtTypeJournal?: boolean;
  TakeMoyenPaiement?: boolean;
  TakeRemisEnBanque?: boolean;
  TakeRibMouvement?: boolean;
  TakeTiersEtCompteTiersMouvement?: boolean;
  TakeTypeEcriture?: boolean;
  TakeTypeMoyenPaiement?: boolean;
  TakeUserForExport?: boolean;
  TakeUserLastUpdate?: boolean;
  TypeEcriture?: string;
  WithAllMouvementSupprime?: boolean;
  WithBLBRCommandeFacture?: boolean;
  WithCommandeFacture?: boolean;
  WithMouvementRemiseEnBanque?: boolean;
  WithSaveContext?: boolean;
  WithSupprime?: boolean;
  WithUpdateFacture?: boolean;
};

export type CriteresCompteEcritureModelInput = {
  ComparaisonEcr?: string;
  ContientMvtMontantMax?: number;
  ContientMvtMontantMin?: number;
  ContientMvtMontantOperateur?: string;
  DateDebut?: any;
  DateFin?: any;
  DatesExercice?: KeyValuePairOfNullableOfdateTimeNullableOfdateTime_ShTdFhl_PInput;
  HasMouvementSur511?: boolean;
  IdAttribution?: number;
  IdBenef?: number;
  IdCECible?: number;
  IdCECreePar?: number;
  IdCESource?: number;
  IdCESourceCible?: number;
  IdCloture?: number;
  IdCommande?: number;
  IdCommandeEcriture?: number;
  IdCompte?: number;
  IdCompteEcriture?: number;
  IdDelegationOrigine?: number;
  IdDossierEpargnePMV?: number;
  IdEcheancier?: number;
  IdExerciceOD?: number;
  IdFacture?: number;
  IdFactureReglement?: number;
  IdFournisseur?: number;
  IdSectionAnalytique?: number;
  IsClos?: boolean;
  IsEcheance?: boolean;
  IsEcritureLettree?: boolean;
  IsExport?: boolean;
  IsMouvementClos?: boolean;
  IsNotContrepassationDecaissement?: boolean;
  IsOkForExport?: boolean;
  IsRemiseEnBanque?: boolean;
  IsSimulation?: boolean;
  ListeIdCompte?: ArrayOfdecimalInput;
  ListeIdJournaux?: ArrayOfdecimalInput;
  ListeIdModeleTVA?: ArrayOfintInput;
  ListeTypeEcriture?: ArrayOfstringInput;
  ListeTypeEcritureAExclure?: ArrayOfstringInput;
  MontantBorneMax?: number;
  MontantBorneMin?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  NumCheque?: string;
  NumPiece?: string;
  OrderByDate?: boolean;
  OrderByExportDate?: boolean;
  OrderByExported?: boolean;
  OrderByJournal?: boolean;
  OrderByLettre?: boolean;
  OrderByLibelle?: boolean;
  OrderByMontant?: boolean;
  OrderByNumeroPiece?: boolean;
  OrderByReference?: boolean;
  OrderByRemarque?: boolean;
  OrderByUserOkForExport?: boolean;
  SearchInRefLibelleNumPiece?: string;
  SelectedOperateur?: string;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
};

export type CriteresCompteLightModelInput = {
  IdModeleTVA?: number;
  IsClos?: boolean;
  IsCollectifClient?: boolean;
  IsCollectifPMV?: boolean;
  IsCompteLettrable?: boolean;
  IsCompteTiers?: boolean;
  ListeIdsComptes?: ArrayOfdecimalInput;
  ListeNumeroStartWith?: ArrayOfstringInput;
  NumeroCommencePar?: string;
};

export type CriteresCompteModelInput = {
  IdBeneficiaire?: number;
  IdFournisseur?: number;
  IdModeleTVA?: number;
  IsAggregateur?: boolean;
  IsBloque?: boolean;
  IsClos?: boolean;
  IsCollectifClient?: boolean;
  IsCollectifPMV?: boolean;
  IsCompteLettrable?: boolean;
  IsCompteTiers?: boolean;
  IsTiersBeneficiaireNull?: boolean;
  IsTiersFournisseurNull?: boolean;
  ListeIdsComptes?: ArrayOfdecimalInput;
  ListeNumeroStartWith?: ArrayOfstringInput;
  NumeroCommencePar?: string;
  StringRecherche?: string;
};

export type CriteresCompteSectionAnalytiqueDtoInput = {
  CompteId?: number;
  IdArticle?: number;
  IdLigneCommande?: number;
  IdModeleSaisie?: number;
  ListeIdCompte?: string;
  ListeIdModeleFraisAnnulation?: ArrayOfdecimalInput;
  ListeIdPlan?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytiqueId?: number;
  RacineDebut?: string;
  RacineFin?: string;
  SectionAnalytiqueId?: number;
  Status?: StatusDtoEnum;
  TakeCompte?: boolean;
  TakePlanAnalytique?: boolean;
  TakeSectionAnalytique?: boolean;
  VisionCle?: TypeCleRepartitionEnum;
};

export type CriteresCompteurPointDtoInput = {
  Id?: number;
  IdDelegation?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  WithCloture?: boolean;
};

export type CriteresConsoMouvementDtoInput = {
  CodeTypeMouvement?: string;
  DateDebut?: any;
  DateFin?: any;
  FiltreLibelle?: string;
  Id?: number;
  IdAttribution?: number;
  IdBenef?: number;
  IdCompteur?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdLigneCommande?: number;
  IdSite?: number;
  IdTypeContrat?: number;
  IsActivite?: boolean;
  IsCommande?: boolean;
  IsConsoCompensee?: boolean;
  IsEnveloppeForAttribution?: boolean;
  IsFamille?: boolean;
  IsIndependant?: boolean;
  IsMouvementCompense?: boolean;
  IsMvtCPTPoint?: boolean;
  IsNotConsoMvtAnnulee?: boolean;
  IsQuantite?: boolean;
  IsQuantiteQuotite?: boolean;
  IsSubvention?: boolean;
  IsSubventionAccordee?: boolean;
  IsTransverse?: boolean;
  IsValeurFacial?: boolean;
  IsValide?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreElemParPage?: number;
  PageEnCours?: number;
  Status?: StatusDtoEnum;
  TakeAyantsDroit?: boolean;
  TakeBenef?: boolean;
  TakeCEDelegation?: boolean;
  TakeConsoMouvementCompteurPoint?: boolean;
  TakeDevisCde?: boolean;
  TakeForAttribution?: boolean;
  TakeForSaveConsoEnveloppeQuota?: boolean;
  TakeForSaveConsoMouvement?: boolean;
  TakeTypeConsoMouvementPoint?: boolean;
  WithQuantiteA0?: boolean;
  WithSubventionA0?: boolean;
  WithValeurFacialeA0?: boolean;
};

export type CriteresConsommationQuotaDtoInput = {
  Activite?: ActiviteDtoInput;
  ActiviteModel?: ActiviteModelInput;
  Benef?: BenefDtoInput;
  BenefID?: number;
  Enveloppe?: EnveloppeQuotaDtoInput;
  Exercice?: ExerciceDtoInput;
  Famille?: FamilleProduitModelInput;
  IdConso?: number;
  IdEnv?: number;
  IdEnveloppeForAttribution?: number;
  IsActiviteChecked?: boolean;
  IsFamilleChecked?: boolean;
  IsTransverseChecked?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  WithEnveloppeForAttBdg?: boolean;
};

export type CriteresContactParamModelInput = {
  IdCE?: number;
  IdCommission?: number;
  IdContactParam?: number;
  IdUser?: number;
};

export type CriteresCorrectionImputationArticleModelInput = {
  IdCompteValorisation?: number;
  IdCompteVariation?: number;
  IsSimulation?: boolean;
  ListeIdArticle?: ArrayOfdecimalInput;
  ListePlansAnalytiques?: ArrayOfPlanWithSectionsAnalytiquesModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresCorrectionMontantMouvementModelInput = {
  IsSimulation?: boolean;
  ListeIdEcriture?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresCorrectionRepartitionAnalytiqueModelInput = {
  IsSimulation?: boolean;
  ListeIdEcriture?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresCourrierDtoInput = {
  CodeReport?: string;
  CodeTypeActivite?: string;
  CodeTypeReport?: string;
  Id?: number;
  IdActivite?: number;
  IdImpression?: number;
  IsClotured?: boolean;
  ListeCodeTypeReport?: string;
  ListeIdBenef?: string;
  ListeIdCourrier?: string;
  ListeIdLigneCourrier?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeActivite?: boolean;
  TakeCourrierHistoEnvoi?: boolean;
  TakeForExGetCourrierGenerique?: boolean;
  TakeForReporting?: boolean;
  TakeHistoriqueImpression?: boolean;
  TakeModeleAdresse?: boolean;
  TakeReport?: boolean;
  TakeReportBlocData?: boolean;
  TakeReportCoteClient?: boolean;
  TakeReportEtTypeReport?: boolean;
  TakeReportModeleAdresse?: boolean;
  TypeDestinataire?: string;
};

export type CriteresCourrierHistoEnvoiDtoInput = {
  DateEnvoi?: any;
  DateInferieurAux?: any;
  DateSupperieurAux?: any;
  Id?: number;
  IdCourrier?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RechercheString?: string;
  Status?: StatusDtoEnum;
  TakeAdresseFigeeLigneHisto?: boolean;
  TakeBenef?: boolean;
  TakeChampListeValeur?: boolean;
  TakeCourrier?: boolean;
  TakeLigneCourrier?: boolean;
  TakePieceJointe?: boolean;
  TakeProduit?: boolean;
  TakeStatut?: boolean;
  TakeUser?: boolean;
  TakeUserAdresse?: boolean;
};

export type CriteresCreateNewArticleDtoInput = {
  /** DO NOT USE! */
  _fakeProperty?: string;
};

export type CriteresCreateNewFamilleDtoInput = {
  /** DO NOT USE! */
  _fakeProperty?: string;
};

export type CriteresCreateNewProduitDtoInput = {
  /** DO NOT USE! */
  _fakeProperty?: string;
};

export type CriteresDelegationModelDtoInput = {
  IdDelegation?: number;
  IdUtilisateur?: number;
  IsClos?: boolean;
  IsDelegationGlobale?: boolean;
  IsVisibleDelegLocale?: boolean;
  OrderBYDelegGlobThenNom?: boolean;
};

export type CriteresDepartementDtoInput = {
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumDep?: string;
  RegionId?: number;
  Status?: StatusDtoEnum;
  TakePays?: boolean;
  TakeRegion?: boolean;
};

export type CriteresDevisCommandeDtoInput = {
  AdresseANCV?: string;
  CodeTypeDossierPrestation?: string;
  CommandeType?: string;
  DateActiviteInferieur?: any;
  DateActiviteSuperieur?: any;
  DateDebutLoc?: any;
  DateFinLoc?: any;
  DateInferieur?: any;
  DateReferenceInferieur?: any;
  DateReferenceSuperieur?: any;
  DateSuperieur?: any;
  EstPaye?: boolean;
  Id?: number;
  IdActivite?: number;
  IdArticle?: number;
  IdAttribution?: number;
  IdBenef?: number;
  IdDelegation?: number;
  IdDossierPrestaHasValue?: boolean;
  IdFacture?: number;
  IdFamille?: number;
  IdFamilleArtInDevis?: number;
  IdFournisseur?: number;
  IdModeLivraison?: number;
  IdModeleSaisiLibreCde?: number;
  IdOrganisation?: number;
  IdProduit?: number;
  IdProduitArtInDevis?: number;
  IdSessionChoix?: number;
  IdSite?: number;
  IsCommandeEventFamiliaux?: boolean;
  IsCommandeFinie?: boolean;
  IsCommandePartACharge?: boolean;
  IsCommandeRembPresta?: boolean;
  IsCommandeRmbMensuelPresta?: boolean;
  IsDevisTypeClient?: boolean;
  IsEnCours?: boolean;
  IsEnLigne?: boolean;
  IsFiltrerCdeClientEnvFour?: boolean;
  IsLibre?: boolean;
  IsModuleEpargneActif?: boolean;
  IsNotCdeCloture?: boolean;
  IsUpdateMouvementStockLgeCde?: boolean;
  ListId?: ArrayOfdecimalInput;
  ListIdArticle?: ArrayOfdecimalInput;
  ListeIdStatutPerso?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreElemParPage?: number;
  NumeroSessionChoix?: number;
  OrderingByDateAsc?: boolean;
  OrderingByIdAsc?: boolean;
  PageEnCours?: number;
  RechercheCdeLibreString?: string;
  RechercheStatutADM?: boolean;
  RechercheStatutEPA?: boolean;
  RechercheStatutLIV?: boolean;
  RechercheStatutPERSO?: boolean;
  RechercheString?: string;
  SigneComparaison?: string;
  SigneComparaisonActivite?: string;
  SigneComparaisonLoc?: string;
  SigneComparaisonReference?: string;
  Status?: StatusDtoEnum;
  StatutAnnulee?: boolean;
  StatutEnAttente?: boolean;
  StatutEnSaisi?: boolean;
  StatutEnvoye?: boolean;
  StatutEpaARegler?: boolean;
  StatutEpaATraiter?: boolean;
  StatutEpaAnnule?: boolean;
  StatutEpaAttente?: boolean;
  StatutEpaEnCours?: boolean;
  StatutEpaTermine?: boolean;
  StatutFacturable?: boolean;
  StatutFacturePartiellement?: boolean;
  StatutFacturee?: boolean;
  StatutLivree?: boolean;
  StatutLivreePartiellement?: boolean;
  StatutNonLivrable?: boolean;
  StatutNonLivree?: boolean;
  StatutRefusee?: boolean;
  StatutRetournee?: boolean;
  StatutSansObjet?: boolean;
  TakeAFPA?: boolean;
  TakeActivite?: boolean;
  TakeActiviteAndType?: boolean;
  TakeAdresse?: boolean;
  TakeArticle?: boolean;
  TakeArticleEtProduit?: boolean;
  TakeBenefEtFournisseur?: boolean;
  TakeBenefEtFournisseurWithAdresse?: boolean;
  TakeBlBR?: boolean;
  TakeCEDelegation?: boolean;
  TakeCEDelegationActivite?: boolean;
  TakeCompteVenteArticle?: boolean;
  TakeDevisForAnnulation?: boolean;
  TakeDevisForGenerationBonRetour?: boolean;
  TakeDevisForSaveSuppression?: boolean;
  TakeDevisForSuppression?: boolean;
  TakeDevisModeleGenerique?: boolean;
  TakeDevisStatutAdministratif?: boolean;
  TakeDevisStatutLivraison?: boolean;
  TakeDevisStatutPersoAdministratif?: boolean;
  TakeExercice?: boolean;
  TakeFacHistoStatutStatutFac?: boolean;
  TakeFacture?: boolean;
  TakeForAvoirDossierPrestation?: boolean;
  TakeForDevisCommandeForVente?: boolean;
  TakeForDossierPrestation?: boolean;
  TakeForOptimisationSaveDevisCde?: boolean;
  TakeForSaveAttributionAuto?: boolean;
  TakeForSaveDevisByModel?: boolean;
  TakeForSaveDevisCommandeForVente?: boolean;
  TakeForSaveListeCommande?: boolean;
  TakeFormulaireLigneCommande?: boolean;
  TakeHistoCommandeBenef?: boolean;
  TakeHistoCommandeBenefWithActivite?: boolean;
  TakeHistoStatut?: boolean;
  TakeHistoStatutEtStatutPerso?: boolean;
  TakeHistoStatutLigne?: boolean;
  TakeInfosForVerificationFacturation?: boolean;
  TakeLigneCdeForVente?: boolean;
  TakeLigneCommandeForReport?: boolean;
  TakeLigneDevis?: boolean;
  TakeLigneDevisConsoMouvement?: boolean;
  TakeLigneDevisEtStatutLigne?: boolean;
  TakeLigneDevisWithStatut?: boolean;
  TakeLigneDevisWithStatutAndLigneCdeFour?: boolean;
  TakeLigneEtBenef?: boolean;
  TakeLigneHistoStatut?: boolean;
  TakeLigneMouvementStock?: boolean;
  TakeListeHistoStatutLigneSeule?: boolean;
  TakeModeLivLigne?: boolean;
  TakeNatureMouvementStk?: boolean;
  TakeOrigineCommande?: boolean;
  TakePV?: boolean;
  TakePartAChargeFacturationFournisseur?: boolean;
  TakeParticipant?: boolean;
  TakePoint?: boolean;
  TakeProduit?: boolean;
  TakeProduitContratLocation?: boolean;
  TakeSessionChoix?: boolean;
  TakeStatutLivLigne?: boolean;
  TakeStock?: boolean;
  TypeRetourModel?: TypeRemonterModelEnum;
  TypeVue?: string;
  WithAnnulee?: boolean;
  WithBenef?: boolean;
  WithEnCours?: boolean;
  WithEnCoursOnly?: boolean;
  WithEnLigne?: boolean;
  WithGenerationFacture?: boolean;
  WithImpayee?: boolean;
  WithPJAbsentes?: boolean;
  WithPJEnAttenteValidation?: boolean;
  WithRefusee?: boolean;
  WithStatutAdministratif?: boolean;
  WithSurGestion?: boolean;
  WithTraitee?: boolean;
};

export type CriteresDevisCommandeModelInput = {
  CEId?: number;
  CdeClientTypeDossierPrestation?: string;
  CodeCommandeOrigine?: string;
  DateDebutCommande?: any;
  DateDebutLocation?: any;
  DateFinCommande?: any;
  DateFinLocation?: any;
  HasArticleAssocie?: boolean;
  HasAvoirARembourser?: boolean;
  HasCommandeAssocieEpargne?: boolean;
  HasDossierLie?: boolean;
  HasEcritureReglementEpargne?: boolean;
  HasLigneWithArticleDepassementQte?: boolean;
  HasPJAbsentes?: boolean;
  HasPJEnAttente?: boolean;
  HasStatutCommande?: boolean;
  HaveRemboursementPret?: boolean;
  IdActivite?: number;
  IdActiviteDossierPrestaLie?: number;
  IdArticle?: number;
  IdAttribution?: number;
  IdBenefSurCommandeClient?: number;
  IdBeneficiaire?: number;
  IdChpListeValAssurance?: number;
  IdCommande?: number;
  IdFacture?: number;
  IdFamille?: number;
  IdFamilleArticleLigneCommande?: number;
  IdFournisseur?: number;
  IdModeLivraison?: number;
  IdModeleEcheancier?: number;
  IdModeleSaisiLibreCde?: number;
  IdOrganisation?: number;
  IdProduit?: number;
  IdProduitArticleLigne?: number;
  IdSite?: number;
  IdTypeActivite?: number;
  IsBenefDroitActif?: boolean;
  IsCommandeEnCoursVUP?: boolean;
  IsCommandeEnLigne?: boolean;
  IsCommandeEnSaisieLibre?: boolean;
  IsCommandeEventFamiliaux?: boolean;
  IsCommandeFinalisee?: boolean;
  IsCommandePayee?: boolean;
  IsDateRetourDepasseeMdkRsx?: boolean;
  IsDevisTypeClient?: boolean;
  IsDossierClotureAvantTermeEpargne?: boolean;
  IsDossierPretsEtDonsCompletementRegle?: boolean;
  IsDossierPretsEtDonsNonRegle?: boolean;
  IsDossierPretsEtDonsNonSolde?: boolean;
  IsDossierPretsEtDonsPartiellementRegle?: boolean;
  IsDossierPretsEtDonsPartiellementSolde?: boolean;
  IsDossierPretsEtDonsSolde?: boolean;
  IsDossierWithCommandeReglee?: boolean;
  IsEnCourSaisie?: boolean;
  IsFiltrerCdeClientEnvFour?: boolean;
  IsLivree?: boolean;
  IsModuleEpargneActif?: boolean;
  IsRechercheWithStatutAdmCumule?: boolean;
  IsStatutAnnuleCommande?: boolean;
  IsStatutEnCours?: boolean;
  IsStatutImpayee?: boolean;
  IsStatutRefusee?: boolean;
  IsStatutSaisieEnCours?: boolean;
  IsStatutTraitee?: boolean;
  IsSuivi?: boolean;
  IsTypeDon?: boolean;
  IsTypePret?: boolean;
  LibelleContains?: string;
  ListeCodeStatutEpargne?: ArrayOfstringInput;
  ListeCodeStatutEpargneHistoCmd?: ArrayOfstringInput;
  ListeCodeStatutLivraison?: ArrayOfstringInput;
  ListeCodeTypeActivite?: ArrayOfstringInput;
  ListeIdBeneficiaire?: ArrayOfdecimalInput;
  ListeIdCommande?: ArrayOfdecimalInput;
  ListeIdLignesCommande?: ArrayOfdecimalInput;
  ListeIdProduit?: ArrayOfdecimalInput;
  ListeIdSite?: ArrayOfdecimalInput;
  ListeIdStatutAdmInverse?: ArrayOfdecimalInput;
  ListeIdStatutPerso?: ArrayOfdecimalInput;
  ListeIdStatutPersoInverse?: ArrayOfintInput;
  ListeIdsArticle?: ArrayOfdecimalInput;
  ListeStatutRemboursementUpGestion?: ArrayOfstringInput;
  MatriculeBenef?: string;
  MontantBorneMax?: number;
  MontantBorneMin?: number;
  MontantOperateur?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTake?: number;
  NomPrenomBenefStartWith?: string;
  NotListeCodeStatutAdministratif?: ArrayOfstringInput;
  NotListeIdCommande?: ArrayOfdecimalInput;
  OperateurDate?: string;
  OperateurDateLocation?: string;
  OrderByDateASC?: boolean;
  OrderByDateDESC?: boolean;
  OrderByLibelleASC?: boolean;
  OrderByLibelleDESC?: boolean;
  OrderByStatutAttenteThenDateDESC?: boolean;
  OrderByVenteEssentiel?: boolean;
  RechercheLibreHistorique?: string;
  RechercheStatutEPA?: boolean;
  ResteALivrerSuperieurZero?: boolean;
  SessionChoixId?: number;
  SiteAdresseANCV?: string;
  SkipCount?: boolean;
  Status?: StatusDtoEnum;
  Statut?: ArrayOfstringInput;
  StatutAnnulee?: boolean;
  StatutEnAttente?: boolean;
  StatutEnSaisi?: boolean;
  StatutEnvoye?: boolean;
  StatutEpaARegler?: boolean;
  StatutEpaATraiter?: boolean;
  StatutEpaAnnule?: boolean;
  StatutEpaAttente?: boolean;
  StatutEpaEnCours?: boolean;
  StatutEpaTermine?: boolean;
  StatutFacturable?: boolean;
  StatutFacturePartiellement?: boolean;
  StatutFacturee?: boolean;
  StatutLivree?: boolean;
  StatutLivreePartiellement?: boolean;
  StatutNonLivrable?: boolean;
  StatutNonLivree?: boolean;
  StatutRefusee?: boolean;
  StatutRetournee?: boolean;
  StatutSansObjet?: boolean;
  TypeDossierPrestation?: string;
  WithAttributionsMasquees?: boolean;
  WithPJAbsentes?: boolean;
  WithPJEnAttente?: boolean;
  WithTypeDon?: boolean;
  WithTypePret?: boolean;
};

export type CriteresDisponibilitesRessourcesModelInput = {
  DateDebutPlage?: any;
  DateFinPlage?: any;
  IdActivite?: number;
  IdExemplaire?: number;
  IdFamille?: number;
  IdRessource?: number;
  IsVueJour?: boolean;
  IsVueMois?: boolean;
  IsVueSemaine?: boolean;
};

export type CriteresEcheancierDtoInput = {
  DateDebutEcheance?: any;
  DateFinEcheance?: any;
  Id?: number;
  IdBenef?: number;
  IdCESourceCible?: number;
  IdCompteBancaire?: number;
  IdMoyenPaiement?: number;
  IdRib?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreElemParPage?: number;
  PageEnCours?: number;
  RechercheString?: string;
  Status?: StatusDtoEnum;
  TakeBenef?: boolean;
  TakeCompteBancaire?: boolean;
  TakeRib?: boolean;
};

export type CriteresEcheancierModelInput = {
  IdArticle?: number;
  IdFamille?: number;
  IdModeleEcheancier?: number;
  IdProduit?: number;
  IsClos?: boolean;
  IsNotWithDateDeclenchement?: boolean;
  ListeIdActivite?: ArrayOfdecimalInput;
  ListeIdModeleEcheancier?: ArrayOfdecimalInput;
};

export type CriteresEcheancierModeleActiviteModelInput = {
  IdActivite?: number;
  IdModeleEcheancier?: number;
  IdMoyenPaiement?: number;
  IsAfficheEnLigne?: boolean;
  IsModeleEcheancierClos?: boolean;
  ListeIdActivite?: ArrayOfdecimalInput;
  MontantReglement?: number;
};

export type CriteresEcritureDesequilibreeModelInput = {
  AvecExercicesClotures?: boolean;
  DateDebut?: any;
  DateFin?: any;
  IdDelegation?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  Status?: StatusDtoEnum;
};

export type CriteresEngagementBudgetDtoInput = {
  Id?: number;
  IdBudget?: number;
  IdPosteBDG?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresEnteteBaremeDtoInput = {
  Id?: number;
  IdChamp?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeBorne?: boolean;
  TakeChamp?: boolean;
};

export type CriteresEnveloppeBaseModelInput = {
  CodeEnveloppe?: string;
  IdCe?: number;
  IdEnveloppe?: number;
  IsAfficheeEnLigne?: boolean;
  IsClos?: boolean;
  IsEnvAttribution?: boolean;
  IsEnveloppeComplementaire?: boolean;
  IsEnveloppeSynchronisee?: boolean;
  IsTransverseAttribOuChoisie?: boolean;
  LibelleEnveloppe?: string;
  NbSkip?: number;
  NbTake?: number;
  OrderByLibelle?: boolean;
};

export type CriteresEnveloppeQuotaDtoInput = {
  Id?: number;
  IdActivite?: number;
  IdActiviteFamille?: number;
  IdActiviteForAllEnveloppe?: number;
  IdActiviteForFPA?: number;
  IdActivitePourFamille?: number;
  IdActivitePourFamilleImpute?: number;
  IdArticleForAllEnveloppe?: number;
  IdArticleForDupliquerFPA?: number;
  IdCE?: number;
  IdCECurrentOuCEGlobal?: number;
  IdCECurrentOuCEGlobalForActivite?: number;
  IdDelegOuDelegGlobale?: number;
  IdFamille?: number;
  IdFamilleForAllEnveloppe?: number;
  IdFamilleForFPA?: number;
  IdFamillePourProduit?: number;
  IdFamillePourProduitImpute?: number;
  IdProduitForAllEnveloppe?: number;
  IdProduitForDupliquerFPA?: number;
  IdProduitForFPA?: number;
  IdProduitPourArtcile?: number;
  IdProduitPourArtcileImpute?: number;
  IsActivite?: boolean;
  IsActiviteCountA0?: boolean;
  IsArticleCountA0?: boolean;
  IsCloture?: boolean;
  IsEnvComplementaire?: boolean;
  IsEnveloppeAttrib?: boolean;
  IsEnveloppeAttribOrTranverse?: boolean;
  IsEnveloppeForAttributionAFPA?: boolean;
  IsEnveloppeForAttributionParam?: boolean;
  IsEnveloppeForSubventionHistorique?: boolean;
  IsFamille?: boolean;
  IsFamilleCountA0?: boolean;
  IsProduitCountA0?: boolean;
  IsSyncroCodKalidea?: boolean;
  IsTransverse?: boolean;
  ListeIdEnveloppe?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  OnlyEnveloppeDelegationGlobale?: boolean;
  Status?: StatusDtoEnum;
  TakeCE?: boolean;
  TakeChampListVal?: boolean;
  TakeEnvImpActivite?: boolean;
  TakeEnvImpArticle?: boolean;
  TakeEnvImpFamille?: boolean;
  TakeEnvImpProduit?: boolean;
  TakeFamilleEtActivite?: boolean;
  TakeMoteurRegle?: boolean;
  WithArticle?: boolean;
  WithFamille?: boolean;
  WithProduit?: boolean;
};

export type CriteresExerciceDtoInput = {
  CurrentIdExerciceToExclude?: number;
  DateDebut?: any;
  DateEntre?: any;
  DateFin?: any;
  Id?: number;
  IsClos?: boolean;
  IsExerciceTravail?: boolean;
  ListeIdExercice?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  WithSuppr?: boolean;
};

export type CriteresFacturationCommandeMasseModelInput = {
  CodeStatutAdministratif?: string;
  CommandeType?: string;
  DateCommandeMax?: any;
  DateDebutCreation?: any;
  DateDebutToCheck?: any;
  DateFinCreation?: any;
  DateFinToCheck?: any;
  DateMaximumMediatheque?: any;
  DateMinimumMediatheque?: any;
  DatePrestationFacture?: any;
  DateReservationAu?: any;
  DateReservationDebutDispo?: any;
  DateReservationDu?: any;
  DateReservationFinDispo?: any;
  DatesLivraison?: any;
  DatesReservationDebut?: any;
  DatesReservationEmpruntDebut?: any;
  DatesReservationFin?: any;
  DatesRetour?: any;
  HasIdLigneCommandeFournisseur?: boolean;
  HaveArticleEnReappro?: boolean;
  HaveMontantSupZero?: boolean;
  IdActivite?: number;
  IdArticle?: number;
  IdAttribution?: number;
  IdBenef?: number;
  IdBenefLigne?: number;
  IdCommande?: number;
  IdDelegation?: number;
  IdDelegationOuDelegGLobale?: number;
  IdDevisCde?: number;
  IdFactureCommande?: number;
  IdFamille?: number;
  IdLigneCommande?: number;
  IdModeLivraison?: number;
  IdOrga?: number;
  IdProduit?: number;
  IdSite?: number;
  IsAnnule?: boolean;
  IsCommandeEnLigne?: boolean;
  IsEnAttente?: boolean;
  IsEnCourSaisie?: boolean;
  IsFacturable?: boolean;
  IsNominatif?: boolean;
  IsOptionGroupe?: boolean;
  IsRefusee?: boolean;
  IsStatutAdmRefuse?: boolean;
  ListeCodesTypeActiviteCommande?: ArrayOfstringInput;
  ListeIdArticles?: ArrayOfdecimalInput;
  ListeIdBenefLigne?: ArrayOfdecimalInput;
  ListeIdCommande?: ArrayOfdecimalInput;
  ListeIdLigneComFour?: ArrayOfdecimalInput;
  ListeIdLigneCommande?: ArrayOfdecimalInput;
  ListeIdOrganisations?: ArrayOfdecimalInput;
  ListeIdSites?: ArrayOfdecimalInput;
  ListeIdStatutPerso?: ArrayOfdecimalInput;
  ListeIdStatutsReglement?: ArrayOfdecimalInput;
  ListeStatutAdministratifLigne?: ArrayOfstringInput;
  ListeStatutAdministratifLigneInverse?: ArrayOfstringInput;
  ListeStatutLivraisonLigne?: ArrayOfstringInput;
  ListeStatutLivraisonLigneInverse?: ArrayOfstringInput;
  MdkIdStockLivraison?: number;
  MdkIsALivrer?: boolean;
  MdkIsLivraisonEmprunte?: boolean;
  MdkIsLivraisonEnFileAttente?: boolean;
  MdkIsLivraisonEnRetard?: boolean;
  MdkIsLivraisonRetourne?: boolean;
  MdkIsLivraisonRetournePartiellement?: boolean;
  MdkIsReserve?: boolean;
  MdkIsStatutAdmAccepte?: boolean;
  MdkIsStatutAdmFileAttente?: boolean;
  MdkLivreAu?: any;
  MdkLivreDu?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  NbHeureDurationDevisSuperieurA?: number;
  NbSkip?: number;
  NbTake?: number;
  NotIdLigneCommande?: number;
  NotIdRegroupement?: number;
  OrderByDateRetourPrevueDesc?: boolean;
  OrderByIdCommandeDesc?: boolean;
  RPIsLivraisonALivrer?: boolean;
  RPIsLivraisonEmprunte?: boolean;
  RPIsLivraisonEnRetard?: boolean;
  RPIsLivraisonNonLivrable?: boolean;
  RPIsLivraisonReserve?: boolean;
  RPIsLivraisonRetourne?: boolean;
  RPIsLivraisonRetournePartiellement?: boolean;
  RPIsLivraisonSansObjet?: boolean;
  RPIsStatutAccepte?: boolean;
  RPIsStatutAnnule?: boolean;
  RPIsStatutEnAttente?: boolean;
  RPIsStatutFactureNonSolde?: boolean;
  RPIsStatutFacturePartiellement?: boolean;
  RPIsStatutFactureSolde?: boolean;
  RPIsStatutRefuse?: boolean;
  Status?: StatusDtoEnum;
  TexteRechercheReservationMDK?: string;
};

export type CriteresFactureDtoInput = {
  BenefId?: number;
  CodeVersionLogiciel?: string;
  DateInferieurAux?: any;
  DateSuperieurAux?: any;
  Id?: number;
  IdActivite?: number;
  IdCDE?: number;
  IdCE?: number;
  IdCdeSurFacture?: number;
  IdDelegOuDelegGlobale?: number;
  IdDelegation?: number;
  IdFournisseur?: number;
  IdUser?: number;
  InitialNumFacture?: string;
  IsComptaSeparee?: boolean;
  IsDernierFactClient?: boolean;
  IsFactureAcompte?: boolean;
  IsFactureClient?: boolean;
  IsFactureCommandeCadeau?: boolean;
  IsFactureCommandePartACharge?: boolean;
  IsFactureCommandeRemboursement?: boolean;
  IsFactureCommandeRemboursementMensuel?: boolean;
  IsFactureFournisseur?: boolean;
  IsFactureHide?: boolean;
  IsFactureSoldeDifferentDeZero?: boolean;
  IsFactureTousTypeRemboursement?: boolean;
  IsLibre?: boolean;
  IsNotNullMontantTotal?: boolean;
  IsSoldee?: boolean;
  ListeIdFacture?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreLignes?: number;
  NumeroFacture?: string;
  NumeroPage?: number;
  RechercheStatut?: boolean;
  RechercheString?: string;
  SelectedComparaison?: string;
  Status?: StatusDtoEnum;
  TakeActivite?: boolean;
  TakeActiviteAndJounal?: boolean;
  TakeAdresseFigeePV?: boolean;
  TakeAdresseFigeeTiers?: boolean;
  TakeArticleLigneFacture?: boolean;
  TakeAvoirDossierPrestation?: boolean;
  TakeAvoirEtLigneAvoir?: boolean;
  TakeBenef?: boolean;
  TakeBenefCompteTiers?: boolean;
  TakeCommande?: boolean;
  TakeCommandeAcompte?: boolean;
  TakeCommandeAcompteEtListeFacturesLiees?: boolean;
  TakeCommandeLibre?: boolean;
  TakeCompteAchatVente?: boolean;
  TakeCompteCollectif?: boolean;
  TakeCompteCollectifClientActivite?: boolean;
  TakeCompteEcriture?: boolean;
  TakeCompteEcritureFacture?: boolean;
  TakeCompteFraisPortAchat?: boolean;
  TakeCompteFraisPortVente?: boolean;
  TakeDelegationCible?: boolean;
  TakeDelegationCreerPar?: boolean;
  TakeDelegationSource?: boolean;
  TakeFactureAvoirForEcritureComptable?: boolean;
  TakeFactureForCreerAvoir?: boolean;
  TakeFactureForSuppression?: boolean;
  TakeFacturesImputees?: boolean;
  TakeFacturesImputeesComplet?: boolean;
  TakeFournisseur?: boolean;
  TakeInfosForVerificationFacturation?: boolean;
  TakeLigneCommandeSurLigneFacture?: boolean;
  TakeLigneFacture?: boolean;
  TakeLigneFactureWithFacture?: boolean;
  TakeListAvoirAcompte?: boolean;
  TakeListeAvoirAcompteImpute?: boolean;
  TakeListeCommandeAvecAcomptes?: boolean;
  TakeListeCompteEcritureEtFacture?: boolean;
  TakeMouvementComptable?: boolean;
  TakePacHistoFactBenef?: boolean;
  TakeProduit?: boolean;
  TakeRibsBenef?: boolean;
  TakeStatut?: boolean;
  TypeFacture?: string;
  WithAccompte?: boolean;
  WithAvoir?: boolean;
  WithFacture?: boolean;
  WithFacturesSupprimees?: boolean;
  WithStatutNonSoldee?: boolean;
  WithStatutPartiellementSoldee?: boolean;
  WithStatutSoldee?: boolean;
};

export type CriteresFactureModelInput = {
  CodeActivite?: string;
  CodeVersionLogiciel?: string;
  DateInferieurAux?: any;
  DateSuperieurAux?: any;
  HasMontantNull?: boolean;
  Id?: number;
  IdActivite?: number;
  IdBenef?: number;
  IdCE?: number;
  IdCde?: number;
  IdCdeAcompte?: number;
  IdCdePourTarif?: number;
  IdDelegOuDelegGlobale?: number;
  IdDossierPresta?: number;
  IdDossierPrestaForAllFacture?: number;
  IdFournisseur?: number;
  IdLigneCommande?: number;
  IdUser?: number;
  IsAcompte?: boolean;
  IsAnnulationJustificatifRemboursement?: boolean;
  IsAvoir?: boolean;
  IsComptaSeparee?: boolean;
  IsFacture?: boolean;
  IsFactureAcompte?: boolean;
  IsFactureClient?: boolean;
  IsFactureCommandeCadeau?: boolean;
  IsFactureCommandePartACharge?: boolean;
  IsFactureCommandeRemboursement?: boolean;
  IsFactureCommandeRemboursementMensuel?: boolean;
  IsFactureFournisseur?: boolean;
  IsFactureHide?: boolean;
  IsFactureTousTypeRemboursement?: boolean;
  IsLibre?: boolean;
  IsSoldee?: boolean;
  IsSupprimer?: boolean;
  IsSupprimerWithStatutsReglement?: boolean;
  Libelle?: string;
  ListIdCommission?: ArrayOfdecimalInput;
  ListeIdCde?: ArrayOfdecimalInput;
  ListeIdCdeSurFacture?: ArrayOfdecimalInput;
  ListeIdFacture?: ArrayOfdecimalInput;
  ListeStatuts?: ArrayOfstringInput;
  ListeStatutsInverse?: ArrayOfstringInput;
  ListeTypeActivite?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NotListeIdFacture?: ArrayOfdecimalInput;
  NumeroFacture?: string;
  OrderById?: boolean;
  OrderByNumeroFactureDesc?: boolean;
  RechercheString?: string;
  SelectedComparaison?: string;
  Skip?: number;
  StartWith?: string;
  Status?: StatusDtoEnum;
  Take?: number;
  TypeFacture?: string;
};

export type CriteresFamilleLightModelInput = {
  AreDisplayedDirecto?: boolean;
  HasPrixActuels?: boolean;
  Id?: number;
  IdActivite?: number;
  IdCompteChargeOuProduit?: number;
  IdDelegation?: number;
  IdModeleFraisAnnulation?: number;
  IdModeleTVA?: number;
  IdProduit?: number;
  IsClos?: boolean;
  IsLieARegroupement?: boolean;
  LibelleFamille?: string;
  ListeCodeTypeActivite?: ArrayOfstringInput;
  ListeIdFamille?: ArrayOfdecimalInput;
  NbSkip?: number;
  NbTake?: number;
};

export type CriteresFamilleProduitDtoInput = {
  AreDisplayedDirecto?: boolean;
  Code?: string;
  Id?: number;
  IdActivite?: number;
  IdCourrierLoc?: number;
  IdDelegationOuDelegationGlobale?: number;
  IdSession?: number;
  IsClos?: boolean;
  LibelleContains?: string;
  ListeTypeActivite?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OnlyWithArticleBilleterie?: boolean;
  RedescendreParametrageRegles?: boolean;
  Status?: StatusDtoEnum;
  TakeActivite?: boolean;
  TakeArticleForFPA?: boolean;
  TakeCourrier?: boolean;
  TakeCourrierContratLocation?: boolean;
  TakeEnveloppePresta?: boolean;
  TakeForGetChamps?: boolean;
  TakeForInitFPA?: boolean;
  TakeForParamFPAChampsPerso?: boolean;
  TakeForParamFPAImputationComptable?: boolean;
  TakeForParamFPAInfosGene?: boolean;
  TakeForParamFPAModesLivraison?: boolean;
  TakeForParamFPARegles?: boolean;
  TakeForParamFamille?: boolean;
  TakeForRedescente?: boolean;
  TakeForSaveFamilleProduit?: boolean;
  TakeFournisseursConventionnes?: boolean;
  TakeInfoForRegle?: boolean;
  TakeModeLivraisonForFPA?: boolean;
  TakePhoto?: boolean;
  TakeProduit?: boolean;
  TakeProduitArticle?: boolean;
  TakeProduitForFPA?: boolean;
  TakeRetourMedia?: boolean;
  TakeSessionChoix?: boolean;
  TakeStockTypeReappro?: boolean;
  TakeTypeActivite?: boolean;
  TakesForCreationProduit?: boolean;
  WithCloture?: boolean;
  WithEnveloppe?: boolean;
};

export type CriteresFicheProfilDataDirectoDtoInput = {
  Id?: number;
  IsCSV?: boolean;
  IsForMultiDeleg?: boolean;
  IsForVue?: boolean;
  IsOD?: boolean;
  IsReadOnly?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Property?: boolean;
  Status?: StatusDtoEnum;
  TakeChamp?: boolean;
  TakeChampTypeDonnee?: boolean;
};

export type CriteresFicheSignaletiqueDtoInput = {
  ChoixDonnees?: FicheSignaletiqueEnumDtoEnum;
  ChoixDonnees2?: FicheSignaletiqueEnumDtoEnum;
  CodeVersionLogiciel?: string;
  Exercice?: ExerciceDtoInput;
  ExerciceMvtComptable?: ExerciceDtoInput;
  ExerciceQuota?: ExerciceDtoInput;
  ExerciceSub?: ExerciceDtoInput;
  IdActivite?: number;
  IdAnneeReference?: number;
  IdBenef?: number;
  IdCompteurPoint?: number;
  IdExercice?: number;
  IdExerciceMvtComptable?: number;
  IdExerciceQuota?: number;
  IdExerciceSubvention?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  WithStatutAdministratif?: boolean;
};

export type CriteresFormulairesFpaModelInput = {
  IdElement?: number;
  TypeElement?: TypeAfpaEnum;
};

export type CriteresFournisseurDtoInput = {
  Id?: number;
  IdProduitForFourConventionne?: number;
  IsClos?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeAdresse?: boolean;
  TakeCompteCommission?: boolean;
  TakeCompteEcriture?: boolean;
  TakeCompteTiers?: boolean;
  TakeContact?: boolean;
  TakeFamillesConventionnees?: boolean;
  TakeForGetFournisseurForParam?: boolean;
  TakeJournalCommission?: boolean;
  TakeMouvementsComptableFromCompteEcriture?: boolean;
  TakeMouvementsComptableFromCompteTiers?: boolean;
  TakeProduitsConventionnes?: boolean;
  TakeRibs?: boolean;
  TakeSectionAnalytique?: boolean;
  TakeSpecificForFournisseur?: boolean;
};

export type CriteresGetListeBenefForComboInput = {
  IdBenef?: number;
  IdBenefAAfficherEnPlus?: number;
  IsBigListe?: boolean;
  Matricule?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  ODetAdByIdOD?: number;
  OnDelegationGlobale?: boolean;
  PremiereLettre?: string;
  Status?: StatusDtoEnum;
  WithBenefDroitBloque?: boolean;
  WithBenefHorsDroit?: boolean;
  WithCloture?: boolean;
};

export type CriteresHistoStatutCommandeDtoInput = {
  Id?: number;
  IdCDE?: number;
  IdCDELIG?: number;
  ListeIdCDE?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OrerbyIdDesc?: boolean;
  Status?: StatusDtoEnum;
  TakeCommande?: boolean;
  TakeLigneCommande?: boolean;
  TakeStatutCde?: boolean;
  TakeStatutPersoCde?: boolean;
  TakeUser?: boolean;
};

export type CriteresHistoriqueModifBenefInput = {
  ChampsModifies?: ArrayOfstringInput;
  ComparateurDate?: string;
  DateDebutOuFixe?: any;
  DateFin?: any;
  IdBenef?: number;
  IdUser?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  OrderByBenef?: boolean;
  OrderByChamp?: boolean;
  OrderByDateModif?: boolean;
  OrderByNewValue?: boolean;
  OrderByOldValue?: boolean;
  OrderByOrigineModif?: boolean;
  OrderByUser?: boolean;
  Origine?: string;
  Status?: StatusDtoEnum;
};

export type CriteresImportArticleModelInput = {
  CmpCode?: string;
  CodeStatus?: string;
  DateIntegrationEnd?: any;
  DateIntegrationStart?: any;
  DatePlannedEnd?: any;
  DatePlannedStart?: any;
  JobCode?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: string;
};

export type CriteresImportHistoDtoInput = {
  CodeImportHistoStatut?: string;
  ComparaisonDateImport?: string;
  ComparaisonDateIntegration?: string;
  ComparaisonDateIntegrationEffective?: string;
  DateImportDeb?: any;
  DateImportFin?: any;
  DateIntegrationDeb?: any;
  DateIntegrationEffectiveDeb?: any;
  DateIntegrationEffectiveFin?: any;
  DateIntegrationFin?: any;
  Id?: number;
  IdImportHistoModele?: number;
  IdImportHistoModeleType?: number;
  IdImportHistoStatut?: number;
  IdImportHistoUser?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  SkipNbLignes?: number;
  Status?: StatusDtoEnum;
  TakeColonne?: boolean;
  TakeColonneDFPData?: boolean;
  TakeColonneDFPDataTypeDonnee?: boolean;
  TakeFicheProfilDataDirecto?: boolean;
  TakeImporModeleReqPrePost?: boolean;
  TakeImportHistoLogGenLogDetHistoLigHistoCol?: boolean;
  TakeImportHistoModeleStatut?: boolean;
  TakeImportHistoStatut?: boolean;
  TakeImportModele?: boolean;
  TakeImportModeleCol?: boolean;
  TakeImportModeleColColMapping?: boolean;
  TakeImportModeleColColMappingChampListeValeur?: boolean;
  TakeImportModeleColColMappingChampListeValeurChamp?: boolean;
  TakeImportModeleDFPData?: boolean;
  TakeImportModeleDFPDataChamp?: boolean;
  TakeImportModeleDFPDataTypeDonnee?: boolean;
  TakeImportModeleType?: boolean;
  TakeLigne?: boolean;
  TakeListeImportLogGeneral?: boolean;
  TakeListeImportModeleCol?: boolean;
  TakeLogDetail?: boolean;
  TakeLogGen?: boolean;
  TakeNbLignes?: number;
  TakeUser?: boolean;
};

export type CriteresImportHistoLigneDtoInput = {
  Id?: number;
  IdImportHisto?: number;
  IsLigneAjout?: boolean;
  IsLigneDoublon?: boolean;
  IsLigneErreur?: boolean;
  IsLigneLienOdAd?: boolean;
  IsLigneModif?: boolean;
  IsLigneRattachementDeleg?: boolean;
  IsLigneSup?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTake?: number;
  RechercheLigneImportHisto?: string;
  SkipPremiereLigne?: boolean;
  Status?: StatusDtoEnum;
  TakeColonneDFPData?: boolean;
  TakeImportHistoCol?: boolean;
  TakeImportHistoColProfilDataDirecto?: boolean;
  WithEntete?: boolean;
};

export type CriteresImportHistoStatutDtoInput = {
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresImportModeleDtoInput = {
  Id?: number;
  IdImportModeleType?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeFicheProfilDataDirectoImportModeleType?: boolean;
  TakeImportModeleCol?: boolean;
  TakeImportModeleColMapping?: boolean;
  TakeImportReqPrepost?: boolean;
  TakeImportTraitDonnee?: boolean;
  TakeModeleType?: boolean;
  TakeUser?: boolean;
};

export type CriteresImportModeleTypeDtoInput = {
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeFicheProfilDataDirectoImportModeleType?: boolean;
};

export type CriteresImportReqPrepostDtoInput = {
  Id?: number;
  MasquerRequetesNonUtilisateur?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeTypeImport?: boolean;
};

export type CriteresImportTraitDonneesDtoInput = {
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeFicheProfilDataDirecto?: boolean;
};

export type CriteresImpressionBilanVenteInput = {
  CEId?: number;
  CdeClientTypeDossierPrestation?: string;
  ChoixGroupe?: number;
  CodeActivite?: string;
  CodeCommandeOrigine?: string;
  CodeReport?: string;
  ComparateurDateLivraison?: string;
  ComparateurDateVente?: string;
  DateDebutLivraison?: any;
  DateDebutLocation?: any;
  DateDebutVente?: any;
  DateFinLivraison?: any;
  DateFinLocation?: any;
  DateFinVente?: any;
  HasArticleAssocie?: boolean;
  HasAvoirARembourser?: boolean;
  HasCommandeAssocieEpargne?: boolean;
  HasDossierLie?: boolean;
  HasEcritureReglementEpargne?: boolean;
  HasFormulaire?: boolean;
  HasLigneWithArticleDepassementQte?: boolean;
  HasPJAbsentes?: boolean;
  HasPJEnAttente?: boolean;
  HasReponsesFormulaireVisible?: boolean;
  HasStatutCommande?: boolean;
  HaveRemboursementPret?: boolean;
  IdActivite?: number;
  IdActiviteDossierPrestaLie?: number;
  IdArticle?: number;
  IdAttribution?: number;
  IdBenef?: number;
  IdBenefSurCommandeClient?: number;
  IdChpListeValAssurance?: number;
  IdCommande?: number;
  IdFacture?: number;
  IdFamille?: number;
  IdFamilleArticleLigneCommande?: number;
  IdFournisseur?: number;
  IdModeLivraison?: number;
  IdModeleEcheancier?: number;
  IdModeleSaisiLibreCde?: number;
  IdOrganisation?: number;
  IdProduit?: number;
  IdProduitArticleLigne?: number;
  IdSite?: number;
  IdTypeActivite?: number;
  IsArticleCloture?: boolean;
  IsBenefDroitActif?: boolean;
  IsCommandeEnCoursVUP?: boolean;
  IsCommandeEnLigne?: boolean;
  IsCommandeEnSaisieLibre?: boolean;
  IsCommandeEventFamiliaux?: boolean;
  IsCommandeFinalisee?: boolean;
  IsCommandeLivre?: boolean;
  IsCommandeNonLivrable?: boolean;
  IsCommandeNonLivre?: boolean;
  IsCommandePartLivre?: boolean;
  IsCommandePayee?: boolean;
  IsCumuleFournisseur?: boolean;
  IsDateRetourDepasseeMdkRsx?: boolean;
  IsDevisTypeClient?: boolean;
  IsDossierClotureAvantTermeEpargne?: boolean;
  IsDossierPretsEtDonsCompletementRegle?: boolean;
  IsDossierPretsEtDonsNonRegle?: boolean;
  IsDossierPretsEtDonsNonSolde?: boolean;
  IsDossierPretsEtDonsPartiellementRegle?: boolean;
  IsDossierPretsEtDonsPartiellementSolde?: boolean;
  IsDossierPretsEtDonsSolde?: boolean;
  IsDossierWithCommandeReglee?: boolean;
  IsEnCourSaisie?: boolean;
  IsFiltrerCdeClientEnvFour?: boolean;
  IsLivree?: boolean;
  IsModuleEpargneActif?: boolean;
  IsRechercheWithStatutAdmCumule?: boolean;
  IsStatutAnnuleCommande?: boolean;
  IsStatutEnCours?: boolean;
  IsStatutImpayee?: boolean;
  IsStatutRefusee?: boolean;
  IsStatutSaisieEnCours?: boolean;
  IsStatutTraitee?: boolean;
  IsSuivi?: boolean;
  IsTypeDon?: boolean;
  IsTypePret?: boolean;
  LibelleContains?: string;
  ListeCodeActivite?: ArrayOfstringInput;
  ListeCodeStatutAdministratif?: ArrayOfstringInput;
  ListeCodeStatutEpargne?: ArrayOfstringInput;
  ListeCodeStatutEpargneHistoCmd?: ArrayOfstringInput;
  ListeCodeStatutLivraison?: ArrayOfstringInput;
  ListeCodeTypeActivite?: ArrayOfstringInput;
  ListeIdBeneficiaire?: ArrayOfdecimalInput;
  ListeIdChampsFormulaires?: ArrayOfdecimalInput;
  ListeIdCommande?: ArrayOfdecimalInput;
  ListeIdLignesCommande?: ArrayOfdecimalInput;
  ListeIdProduit?: ArrayOfdecimalInput;
  ListeIdSite?: ArrayOfdecimalInput;
  ListeIdStatutAdmInverse?: ArrayOfdecimalInput;
  ListeIdStatutPerso?: ArrayOfdecimalInput;
  ListeIdStatutPersoInverse?: ArrayOfintInput;
  ListeIdsArticle?: ArrayOfdecimalInput;
  ListeStatutRemboursementUpGestion?: ArrayOfstringInput;
  MatriculeBenef?: string;
  MontantBorneMax?: number;
  MontantBorneMin?: number;
  MontantOperateur?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTake?: number;
  NomPrenomBenefStartWith?: string;
  NotListeCodeStatutAdministratif?: ArrayOfstringInput;
  NotListeIdCommande?: ArrayOfdecimalInput;
  OperateurDateLocation?: string;
  OrderByDateASC?: boolean;
  OrderByDateDESC?: boolean;
  OrderByLibelleASC?: boolean;
  OrderByLibelleDESC?: boolean;
  OrderByStatutAttenteThenDateDESC?: boolean;
  OrderByVenteEssentiel?: boolean;
  RechercheLibreHistorique?: string;
  RechercheStatutEPA?: boolean;
  ResteALivrerSuperieurZero?: boolean;
  SessionChoixId?: number;
  SiteAdresseANCV?: string;
  SkipCount?: boolean;
  Status?: StatusDtoEnum;
  StatutAnnulee?: boolean;
  StatutEnAttente?: boolean;
  StatutEnSaisi?: boolean;
  StatutEnvoye?: boolean;
  StatutEpaARegler?: boolean;
  StatutEpaATraiter?: boolean;
  StatutEpaAnnule?: boolean;
  StatutEpaAttente?: boolean;
  StatutEpaEnCours?: boolean;
  StatutEpaTermine?: boolean;
  StatutFacturable?: boolean;
  StatutFacturePartiellement?: boolean;
  StatutFacturee?: boolean;
  StatutRefusee?: boolean;
  StatutRetournee?: boolean;
  StatutSansObjet?: boolean;
  TypeDossierPrestation?: string;
  TypeExport?: string;
  WithAttributionsMasquees?: boolean;
  WithPJAbsentes?: boolean;
  WithPJEnAttente?: boolean;
  WithTypeDon?: boolean;
  WithTypePret?: boolean;
};

export type CriteresImpressionBudgetsInput = {
  CodeReport?: string;
  IdBudget?: number;
  IdCourrier?: number;
  IsAnnuel?: boolean;
  IsComptaSeparee?: boolean;
  IsCumule?: boolean;
  IsDebitCredit?: boolean;
  MoisExercice?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumMois?: number;
  NumSession?: string;
  Status?: StatusDtoEnum;
  TypeExport?: string;
};

export type CriteresInventaireDtoInput = {
  ActiviteId?: number;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StockId?: number;
  TakeActivite?: boolean;
  TakeLigneInventaire?: boolean;
  TakeLigneInventaireArticleEtProduit?: boolean;
  TakeStock?: boolean;
  TakeUser?: boolean;
};

export type CriteresJournalBaseModelInput = {
  CodeTypeBudget?: string;
  CodeTypeJournal?: string;
  Id?: number;
  IsClos?: boolean;
  IsSocial?: boolean;
  ListeCodeTypeJournal?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  OrderById?: boolean;
  SkipTake?: KeyValuePairOfintintInput;
  Status?: StatusDtoEnum;
};

export type CriteresJournalDtoInput = {
  Id?: number;
  IdCompteBancaire?: number;
  IdDelegationCourante?: number;
  IdMoyenPaiement?: number;
  IdMoyenPaiementForPRMAutoFidu?: number;
  IsANouveau?: boolean;
  IsAchat?: boolean;
  IsEspece?: boolean;
  IsFonctionnement?: boolean;
  IsOD?: boolean;
  IsRemboursement?: boolean;
  IsSocial?: boolean;
  IsSupprime?: boolean;
  IsTreso?: boolean;
  IsVente?: boolean;
  ListeIdJournaux?: string;
  ListeTypeJournal?: ArrayOfstringInput;
  ListeTypeJournalExclu?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeCompteBancaire?: boolean;
  TakeEcriture?: boolean;
  TakeForExGetListeGenerique?: boolean;
  TakeTypeJournal?: boolean;
  TakeUserLastUpdate?: boolean;
  TypeJournal?: string;
  TypeJournalCommencePar?: string;
  WithTypeJournalANouveau?: boolean;
  WithTypeJournalAchat?: boolean;
  WithTypeJournalEspAutre?: boolean;
  WithTypeJournalOD?: boolean;
  WithTypeJournalTresorerie?: boolean;
  WithTypeJournalVente?: boolean;
};

export type CriteresJournalTypeDtoInput = {
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  WithANouveau?: boolean;
  WithAchat?: boolean;
  WithEspAutre?: boolean;
  WithOD?: boolean;
  WithTresorerie?: boolean;
  WithVente?: boolean;
};

export type CriteresLettrageAutomatiqueModelInput = {
  IdCompteImputation?: number;
  IdDelegation?: number;
  IdExercice?: number;
};

export type CriteresLienDirectoDtoInput = {
  CodeDirecto?: string;
  Id?: number;
  IdCEFromActiviteMustBeDelegGlobale?: boolean;
  IdDelegationOuDelegationGlobale?: number;
  IdcPortail?: boolean;
  IsCloture?: boolean;
  ListeCodeDirecto?: ArrayOfstringInput;
  ListeCodeModule?: ArrayOfstringInput;
  ListeNeedCodeModuleOrNull?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeActivite?: boolean;
};

export type CriteresLieuDtoInput = {
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeAdresse?: boolean;
};

export type CriteresLigneCessionStockModelInput = {
  DateDebutCession?: any;
  DateFinCession?: any;
  IdActiviteEntree?: number;
  IdActiviteSortie?: number;
  IdArticleEntree?: number;
  IdArticleSortie?: number;
  IdCession?: number;
  IdDelegationEntree?: number;
  IdDelegationSortie?: number;
  IdFamilleEntree?: number;
  IdFamilleSortie?: number;
  IdPointVenteEntree?: number;
  IdPointVenteSortie?: number;
  IdStockEntree?: number;
  IdStockSortie?: number;
  IsEnAttente?: boolean;
  IsReceptionnee?: boolean;
  IsTotalementReceptionnee?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  OrderByDateDesc?: boolean;
  Status?: StatusDtoEnum;
};

export type CriteresLigneCommandeDtoInput = {
  Accepte?: boolean;
  ArticleIsFonctionnementVente?: boolean;
  CodeStatutLivraison?: string;
  ForAttributionAutoModel?: boolean;
  Id?: number;
  IdAttribution?: number;
  IdCommande?: number;
  IdModeLivraison?: number;
  IdModeleSaisie?: number;
  IdOrganisation?: number;
  IdSite?: number;
  IsCommandeFinie?: boolean;
  IsEnCourDeSaisie?: boolean;
  IsLigneDossierPrestation?: boolean;
  ListIDArticle?: ArrayOfdecimalInput;
  ListId?: ArrayOfdecimalInput;
  ListIdLgeCdeFour?: ArrayOfdecimalInput;
  ListeIdCommande?: ArrayOfdecimalInput;
  ListeStatutLigneAccepte?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RechercheString?: string;
  Refuser?: boolean;
  Status?: StatusDtoEnum;
  StatutAdminDevisNotIn?: ArrayOfstringInput;
  TakeArticle?: boolean;
  TakeArticleCompteAchat?: boolean;
  TakeArticleCompteVente?: boolean;
  TakeAttribution?: boolean;
  TakeBenef?: boolean;
  TakeCommande?: boolean;
  TakeDevisBenef?: boolean;
  TakeDevisBenefAdresse?: boolean;
  TakeDevisStock?: boolean;
  TakeForInfoLoc?: boolean;
  TakeForMouvement?: boolean;
  TakeGenerationBL?: boolean;
  TakeHistoStatut?: boolean;
  TakeLigneCdeFour?: boolean;
  TakeModeLivraison?: boolean;
  TakeMouvementStockLight?: boolean;
  TakeMvtSTk?: boolean;
  TakeProduit?: boolean;
  TakeStatutAdministratif?: boolean;
  TakeStatutLivraison?: boolean;
  WithStatutEnAttenteOnly?: boolean;
  WithStatutFacturableOnly?: boolean;
  WithStatutFactureOnly?: boolean;
};

export type CriteresLigneCommandeModelInput = {
  CodeOrigine?: string;
  CodeStatutAdministratif?: string;
  CommandeType?: string;
  DateCommandeMax?: any;
  DateDebutToCheck?: any;
  DateFinToCheck?: any;
  DateMaximumMediatheque?: any;
  DateMaximumRessourcePartagees?: any;
  DateMinimumMediatheque?: any;
  DateMinimumRessourcePartagees?: any;
  DatePrestationFacture?: any;
  DateReservationAu?: any;
  DateReservationDebut?: any;
  DateReservationDebutDispo?: any;
  DateReservationDu?: any;
  DateReservationFin?: any;
  DateReservationFinDispo?: any;
  DatesLivraison?: any;
  DatesReservationDebut?: any;
  DatesReservationEmpruntDebut?: any;
  DatesReservationFin?: any;
  DatesRetour?: any;
  HasAttributionLiee?: boolean;
  HasIdLigneCommandeFournisseur?: boolean;
  HaveArticleEnReappro?: boolean;
  IdActivite?: number;
  IdArticle?: number;
  IdAttribution?: number;
  IdBenef?: number;
  IdBenefLigne?: number;
  IdCdeReappro?: number;
  IdCommande?: number;
  IdDelegation?: number;
  IdDelegationOuDelegGLobale?: number;
  IdDevisCde?: number;
  IdFactureCommande?: number;
  IdFamille?: number;
  IdLigneCommande?: number;
  IdModeLivraison?: number;
  IdOrga?: number;
  IdProduit?: number;
  IdSite?: number;
  IsAncvConnect?: boolean;
  IsAnnule?: boolean;
  IsCommandeEnLigne?: boolean;
  IsCommandeFinish?: boolean;
  IsCommandePayee?: boolean;
  IsCommandeSuivie?: boolean;
  IsECesu?: boolean;
  IsEnAttente?: boolean;
  IsEnCourSaisie?: boolean;
  IsFacturable?: boolean;
  IsNominatif?: boolean;
  IsOptionGroupe?: boolean;
  IsRefusee?: boolean;
  IsStatutAdmRefuse?: boolean;
  ListCodeStatutAdministratif?: ArrayOfstringInput;
  ListeCodesTypeActiviteCommande?: ArrayOfstringInput;
  ListeIdAttribution?: ArrayOfdecimalInput;
  ListeIdBenefLigne?: ArrayOfdecimalInput;
  ListeIdCommande?: ArrayOfdecimalInput;
  ListeIdLigneComFour?: ArrayOfdecimalInput;
  ListeIdLigneCommande?: ArrayOfdecimalInput;
  ListeIdLigneRemiseEnBanque?: ArrayOfdecimalInput;
  ListeIdOrganisations?: ArrayOfdecimalInput;
  ListeIdSites?: ArrayOfdecimalInput;
  ListeIdStatutPerso?: ArrayOfdecimalInput;
  ListeIdStatutsReglement?: ArrayOfdecimalInput;
  ListeStatutAdministratifCommandeInverse?: ArrayOfstringInput;
  ListeStatutAdministratifLigne?: ArrayOfstringInput;
  ListeStatutAdministratifLigneInverse?: ArrayOfstringInput;
  ListeStatutLivraisonLigne?: ArrayOfstringInput;
  ListeStatutLivraisonLigneInverse?: ArrayOfstringInput;
  ListeStatutRemboursementUpGestion?: ArrayOfstringInput;
  MdkIdStockLivraison?: number;
  MdkIsALivrer?: boolean;
  MdkIsLivraisonEmprunte?: boolean;
  MdkIsLivraisonEnFileAttente?: boolean;
  MdkIsLivraisonEnRetard?: boolean;
  MdkIsLivraisonRetourne?: boolean;
  MdkIsLivraisonRetournePartiellement?: boolean;
  MdkIsReserve?: boolean;
  MdkIsStatutAdmAccepte?: boolean;
  MdkIsStatutAdmFileAttente?: boolean;
  MdkLivreAu?: any;
  MdkLivreDu?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  NbHeureDurationDevisSuperieurA?: number;
  NbSkip?: number;
  NbTake?: number;
  NomPrenomBenefStartWith?: string;
  NotIdLigneCommande?: number;
  NotIdRegroupement?: number;
  OrderByDateCreaMvtConsoThenByNomPrenom?: boolean;
  OrderByDateRetourPrevueDesc?: boolean;
  OrderByIdCommandeDesc?: boolean;
  OrderByIsSuiviThenStatutAttenteThenDateDESC?: boolean;
  Status?: StatusDtoEnum;
  TexteRechercheReservationMDK?: string;
  TypeDossierPrestation?: string;
  listeIdArticles?: ArrayOfdecimalInput;
};

export type CriteresLigneCommandeRpModelInput = {
  CodeStatutAdministratif?: string;
  CommandeType?: string;
  DateCommandeMax?: any;
  DateDebutToCheck?: any;
  DateFinToCheck?: any;
  DateMaximumMediatheque?: any;
  DateMinimumMediatheque?: any;
  DatePrestationFacture?: any;
  DateReservationAu?: any;
  DateReservationDebutDispo?: any;
  DateReservationDu?: any;
  DateReservationFinDispo?: any;
  DatesLivraison?: any;
  DatesReservationDebut?: any;
  DatesReservationEmpruntDebut?: any;
  DatesReservationFin?: any;
  DatesRetour?: any;
  HasIdLigneCommandeFournisseur?: boolean;
  HaveArticleEnReappro?: boolean;
  IdActivite?: number;
  IdArticle?: number;
  IdAttribution?: number;
  IdBenef?: number;
  IdBenefLigne?: number;
  IdCommande?: number;
  IdDelegation?: number;
  IdDelegationOuDelegGLobale?: number;
  IdDevisCde?: number;
  IdFactureCommande?: number;
  IdFamille?: number;
  IdLigneCommande?: number;
  IdModeLivraison?: number;
  IdOrga?: number;
  IdProduit?: number;
  IdSite?: number;
  IsAnnule?: boolean;
  IsCommandeEnLigne?: boolean;
  IsEnAttente?: boolean;
  IsEnCourSaisie?: boolean;
  IsFacturable?: boolean;
  IsNominatif?: boolean;
  IsOptionGroupe?: boolean;
  IsRefusee?: boolean;
  IsStatutAdmRefuse?: boolean;
  ListeCodesTypeActiviteCommande?: ArrayOfstringInput;
  ListeIdArticles?: ArrayOfdecimalInput;
  ListeIdBenefLigne?: ArrayOfdecimalInput;
  ListeIdCommande?: ArrayOfdecimalInput;
  ListeIdLigneComFour?: ArrayOfdecimalInput;
  ListeIdLigneCommande?: ArrayOfdecimalInput;
  ListeIdOrganisations?: ArrayOfdecimalInput;
  ListeIdSites?: ArrayOfdecimalInput;
  ListeIdStatutPerso?: ArrayOfdecimalInput;
  ListeIdStatutsReglement?: ArrayOfdecimalInput;
  ListeStatutAdministratifLigne?: ArrayOfstringInput;
  ListeStatutAdministratifLigneInverse?: ArrayOfstringInput;
  ListeStatutLivraisonLigne?: ArrayOfstringInput;
  ListeStatutLivraisonLigneInverse?: ArrayOfstringInput;
  MdkIdStockLivraison?: number;
  MdkIsALivrer?: boolean;
  MdkIsLivraisonEmprunte?: boolean;
  MdkIsLivraisonEnFileAttente?: boolean;
  MdkIsLivraisonEnRetard?: boolean;
  MdkIsLivraisonRetourne?: boolean;
  MdkIsLivraisonRetournePartiellement?: boolean;
  MdkIsReserve?: boolean;
  MdkIsStatutAdmAccepte?: boolean;
  MdkIsStatutAdmFileAttente?: boolean;
  MdkLivreAu?: any;
  MdkLivreDu?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  NbHeureDurationDevisSuperieurA?: number;
  NbSkip?: number;
  NbTake?: number;
  NotIdLigneCommande?: number;
  NotIdRegroupement?: number;
  OrderByDateRetourPrevueDesc?: boolean;
  OrderByIdCommandeDesc?: boolean;
  RPIsLivraisonALivrer?: boolean;
  RPIsLivraisonEmprunte?: boolean;
  RPIsLivraisonEnRetard?: boolean;
  RPIsLivraisonNonLivrable?: boolean;
  RPIsLivraisonReserve?: boolean;
  RPIsLivraisonRetourne?: boolean;
  RPIsLivraisonRetournePartiellement?: boolean;
  RPIsLivraisonSansObjet?: boolean;
  RPIsStatutAccepte?: boolean;
  RPIsStatutAnnule?: boolean;
  RPIsStatutEnAttente?: boolean;
  RPIsStatutFactureNonSolde?: boolean;
  RPIsStatutFacturePartiellement?: boolean;
  RPIsStatutFactureSolde?: boolean;
  RPIsStatutRefuse?: boolean;
  Status?: StatusDtoEnum;
  TexteRechercheReservationMDK?: string;
};

export type CriteresLigneInventaireDtoInput = {
  ActiviteId?: number;
  Id?: number;
  InventaireId?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StockId?: number;
  TakeArticleFournisseur?: boolean;
  TakeInventaire?: boolean;
  TakeLigneFPA?: boolean;
};

export type CriteresLigneRemiseEnCaisseModelInput = {
  IdLigneRemiseEnCaisse?: number;
  IdMoyenPaiement?: number;
  IdRemiseEnCaisse?: number;
  Skip?: number;
  Take?: number;
};

export type CriteresLignesEnvoiModelDtoInput = {
  IdBenef?: number;
  IdFormatEnvoi?: number;
  IdHistoEnvoi?: number;
  IdStatut?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresListingBudgetModelInput = {
  HasParent?: boolean;
  IdExercice?: number;
  IsAnalytique?: boolean;
  TypeBudget?: string;
};

export type CriteresMenuDtoInput = {
  CodeVersionLogiciel?: string;
  Id?: number;
  IdCe?: number;
  IdDelegPourFiltreActivite?: number;
  IdMenuParent?: number;
  IdMenuParentFavori?: number;
  IdUser?: number;
  IdUserPourProfil?: number;
  IsSuperAdmin?: boolean;
  IsUsersMenus?: boolean;
  ListeCodeModuleAccessible?: ArrayOfstringInput;
  ListeIdTypeActivite?: ArrayOfdecimalInput;
  MenuCode?: string;
  MenuOrderingByOrdreAsc?: boolean;
  MenuOrderingByOrdreDesc?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  PrendreEnCompteProfilUser?: boolean;
  Status?: StatusDtoEnum;
  TakeMenuForAccueil?: boolean;
  TakeMenuForParam?: boolean;
  UserFavoriteMenu?: number;
  WithActivite?: boolean;
  WithActiviteNonClos?: boolean;
  WithCeDelegation?: boolean;
  WithDev?: boolean;
  WithFavoris?: boolean;
  WithGenere?: boolean;
  WithGeneriqueActivite?: boolean;
  WithMenuPage?: boolean;
  WithMenuPageEtMenuPageParam?: boolean;
  WithModimportRH?: boolean;
  WithNoDebug?: boolean;
  WithOutilDev?: boolean;
  WithParentMenu?: boolean;
  WithParentMenuFavori?: boolean;
  WithPerso?: boolean;
  WithTypeActivite?: boolean;
  WithUser?: boolean;
  WithUserAndFavoris?: boolean;
};

export type CriteresMessageAppliDtoInput = {
  CodeCibleLogiciel?: string;
  DateDebutMessage?: any;
  DateFinMessage?: any;
  EntreDateDebut?: any;
  EntreDateFin?: any;
  Id?: number;
  IdDelegOrDelegNull?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresModeLivraisonDtoInput = {
  Code?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeLigneFraisPort?: boolean;
  TakeTypeCalculFraisPort?: boolean;
};

export type CriteresModelEmailDtoInput = {
  Code?: string;
  Id?: number;
  IdCe?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeCEDelegation?: boolean;
};

export type CriteresModelJournauxExerciceDtoInput = {
  CritereAct?: CriteresActiviteDtoInput;
  CritereEx?: CriteresExerciceDtoInput;
  CritereJourn?: CriteresJournalDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  WithActivite?: boolean;
  WithExercice?: boolean;
  WithJournaux?: boolean;
};

export type CriteresModeleAdresseModelInput = {
  Code?: string;
  Id?: number;
  IsClos?: boolean;
  IsDefaut?: boolean;
  OrderById?: boolean;
  SkipTake?: KeyValuePairOfintintInput;
};

export type CriteresModeleSaisieLibreDtoInput = {
  Id?: number;
  IdActivite?: number;
  IsClos?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeActivite?: boolean;
  TakeCeDelegation?: boolean;
  TakeCompteAchat?: boolean;
  TakeCompteVente?: boolean;
  TakeSectionParPlan?: boolean;
};

export type CriteresMoteurRegleDtoInput = {
  Id?: number;
  IdActivite?: number;
  IdActiviteForFPA?: number;
  IdActivitePourFamille?: number;
  IdActivitePourFamilleUse?: number;
  IdArticleForAllRegle?: number;
  IdCECurrentOuCEGlobal?: number;
  IdFamilleForAllRegle?: number;
  IdFamilleForFPA?: number;
  IdFamillePourProduit?: number;
  IdFamillePourProduitUse?: number;
  IdHeriatgeType?: number;
  IdProduitForAllRegle?: number;
  IdProduitForFPA?: number;
  IdProduitPourArtcile?: number;
  IdProduitPourArtcileUse?: number;
  IdRegleGroup?: number;
  IdRegleParentHerite?: number;
  IsCloture?: boolean;
  IsComplementaire?: boolean;
  IsHerite?: boolean;
  IsNotRegleGroupe?: boolean;
  IsQuotaEnveloppe?: boolean;
  IsRegleBudget?: boolean;
  IsRegleGroupe?: boolean;
  IsTakeRegleGroupeFille?: boolean;
  IsTransverse?: boolean;
  ListeIdRegle?: ArrayOfdecimalInput;
  ListeIdRegleHerite?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeCEDelegation?: boolean;
  TakeEnveloppe?: boolean;
  TakeModeleAcc?: boolean;
  TakeModeleSubQta?: boolean;
  TakeMoteurCritereParamForSaveEnvAttbgd?: boolean;
  TakeMoteurForGenerationRegle?: boolean;
  TakeMoteurForUpdated?: boolean;
  TakeRegleAfaireHeriteForParamAFPA?: boolean;
  TakeRegleCalculForDeleted?: boolean;
  TakeRegleEnfant?: boolean;
  TakeRegleForDeleted?: boolean;
  TakeRegleHeriteForParamAFPA?: boolean;
  TakeRegleLocaleForParamAFPA?: boolean;
  TakeRegleParentGroupe?: boolean;
  TakeRegleParentHerite?: boolean;
  TakeReglePereHeriteForClonage?: boolean;
  TakeRegleUseActivite?: boolean;
  TakeRegleUseArticle?: boolean;
  TakeRegleUseFamille?: boolean;
  TakeRegleUseProduit?: boolean;
  TakeReglesAvancees?: boolean;
  TypeRegle?: string;
  TypeValeurLimite?: string;
  WithActivite?: boolean;
  WithArticle?: boolean;
  WithEnveloppe?: boolean;
  WithFamille?: boolean;
  WithHeritage?: boolean;
  WithProduit?: boolean;
};

export type CriteresMouvementAnalytiqueDtoInput = {
  DateDebut?: any;
  DateFin?: any;
  IdCeSouceCible?: number;
  IdExercice?: number;
  InitTriConsultationMvtsAnalytiques?: boolean;
  MouvementComptableId?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  OrderByCredit?: boolean;
  OrderByDate?: boolean;
  OrderByDebit?: boolean;
  OrderByJournal?: boolean;
  OrderByLibelle?: boolean;
  OrderByLibelleCPT?: boolean;
  OrderByNumeroPiece?: boolean;
  OrderByReference?: boolean;
  PlanAnalytiqueId?: number;
  SectionAnalytiqueId?: number;
  SelectedComparaison?: string;
  Status?: StatusDtoEnum;
  WithChildren?: boolean;
  WithEcritureSimule?: boolean;
};

export type CriteresMouvementAnalytiqueEnErreurModelInput = {
  AvecEcrituresSimulees?: boolean;
  AvecExercicesClotures?: boolean;
  DateDebut?: any;
  DateFin?: any;
  IdCompte?: number;
  IdDelegation?: number;
  IdExercice?: number;
  IdJournal?: number;
  IncludeRepartitionManquante?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  Status?: StatusDtoEnum;
};

export type CriteresMouvementCollectifSansTiersModelInput = {
  AvecExercicesClotures?: boolean;
  DateDebut?: any;
  DateFin?: any;
  IdDelegation?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  Status?: StatusDtoEnum;
};

export type CriteresMouvementComptableDtoInput = {
  Caisse?: CaisseDtoInput;
  CodeMoyenPaiement?: string;
  CodeTypeJournal?: string;
  CodeTypeJournalNotEgal?: string;
  ComparaisonEcr?: string;
  CompteBancaire?: CompteBancaireDtoInput;
  CompteCollectifId?: number;
  CompteId?: number;
  CompteStartWith?: string;
  ContextMouvementComptable?: ContextModeMouvementsComptablesEnum;
  DateCreationEcriture?: any;
  DateDebut?: any;
  DateFin?: any;
  DateFinAvecHeure?: any;
  DateRemise?: any;
  Id?: number;
  IdActivite?: number;
  IdBenef?: number;
  IdBenefEcriture?: number;
  IdCECible?: number;
  IdCECibleSource?: number;
  IdCECreePar?: number;
  IdCESource?: number;
  IdCaisse?: number;
  IdDeleg?: number;
  IdDelegationCourante?: number;
  IdEcriture?: number;
  IdExercice?: number;
  IdFacture?: number;
  IdFamille?: number;
  IdFournisseur?: number;
  IdFournisseurEcriture?: number;
  IdJournal?: number;
  IdJournalForTypeBudget?: number;
  IdMoyenPaiement?: number;
  IdProduit?: number;
  IdUtilisateur?: number;
  InfOuEgalDatereleve?: any;
  IsArrete?: boolean;
  IsBloqueRIBIncomplet?: boolean;
  IsChequeNepasEncaisser?: boolean;
  IsComptaSeparee?: boolean;
  IsCompteAccepteLettrage?: boolean;
  IsContrepasse?: boolean;
  IsCredit?: boolean;
  IsDebit?: boolean;
  IsEcheance?: boolean;
  IsEcritureBeneficiaire?: boolean;
  IsEcritureManuelle?: boolean;
  IsEcritureSimulee?: boolean;
  IsEcritureTiers?: boolean;
  IsEcrituresLettrees?: boolean;
  IsFonctionnement?: boolean;
  IsForRemiseEnBanque?: boolean;
  IsMouvementAvecBic?: boolean;
  IsOnJournalFonctionnement?: boolean;
  IsOnJournalSocial?: boolean;
  IsPCAOrCCA?: boolean;
  IsPaiementRecu?: boolean;
  IsRapproche?: boolean;
  IsRemisEnBanque?: boolean;
  IsRemiseEnCaisseCentrale?: boolean;
  IsSocial?: boolean;
  IsSupprime?: boolean;
  IsSurExerciceEnCours?: boolean;
  Journal?: JournalDtoInput;
  LettreComptable?: string;
  ListIdUtilisateurs?: ArrayOfdecimalInput;
  ListeCompteStartWith?: string;
  ListeIdActivite?: ArrayOfdecimalInput;
  ListeIdEcriture?: ArrayOfdecimalInput;
  ListeIdMouvement?: string;
  ListeLettreComptable?: ArrayOfstringInput;
  Mois?: number;
  MontantBorneMax?: number;
  MontantBorneMin?: number;
  MotCle?: string;
  MotCleRecetteDepense?: string;
  MotCleRechercheCheque?: string;
  MoyenPaiment?: MoyenPaiementDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  NumCheque?: string;
  NumCompteStart?: string;
  OrderByActivite?: boolean;
  OrderByCompte?: boolean;
  OrderByCompteCollectif?: boolean;
  OrderByCompteTiers?: boolean;
  OrderByCredit?: boolean;
  OrderByDate?: boolean;
  OrderByDebit?: boolean;
  OrderByDelegCible?: boolean;
  OrderByJournal?: boolean;
  OrderByLettreMvt?: boolean;
  OrderByLibelleCompte?: boolean;
  OrderByLibelleMvt?: boolean;
  OrderByNumCheque?: boolean;
  OrderByNumPiece?: boolean;
  OrderByReference?: boolean;
  OrderByRemisBanque?: boolean;
  OrderByTiers?: boolean;
  OrderByTiersBenef?: boolean;
  OrderByTiersFournisseur?: boolean;
  OrderByUtilisateur?: boolean;
  RacineDeb?: string;
  RacineFin?: string;
  RecherchePourLettrage?: string;
  SelectedOperateur?: string;
  ShowOnlyRapprochee?: boolean;
  SkipCount?: boolean;
  Status?: StatusDtoEnum;
  SurCompteTiers?: boolean;
  TakeCompte?: boolean;
  TakeCompteTiers?: boolean;
  TakeEcheancier?: boolean;
  TakeEcriture?: boolean;
  TakeForExGetListeGenerique?: boolean;
  TakeJournal?: boolean;
  TakeMouvementCompteEcriture?: boolean;
  TakeRib?: boolean;
  TakeRibsTiers?: boolean;
  TakeTiersFromCompteEcriture?: boolean;
  TakeTypeMoyenPaiement?: boolean;
  TextRech?: string;
  WithCompte?: boolean;
  WithEcritureSupprimee?: boolean;
  WithMoyenPaiement?: boolean;
  WithRapproche?: boolean;
  WithRejetee?: boolean;
};

export type CriteresMouvementComptableModelInput = {
  AffichageNature?: string;
  BalanceSurTiers?: string;
  BeforeRapprochementReleveBancaireId?: number;
  CeId?: number;
  CodeExercice?: string;
  ComparaisonEcriture?: string;
  CompteNonSolde?: string;
  CptRacineDeb?: string;
  CptRacineFin?: string;
  DateDebExerciceSurEcriture?: any;
  DateFinExerciceSurEcriture?: any;
  DateMaximum?: any;
  DateMaximumAvecHeures?: any;
  DateMinimum?: any;
  DateMinimumAvecHeures?: any;
  IdArreteCaisse?: number;
  IdArreteCaisseFidu?: number;
  IdBanque?: number;
  IdBeneficiaire?: number;
  IdBeneficiaireMouvement?: number;
  IdCESource?: number;
  IdCeCibleEcriture?: number;
  IdCeCreerPar?: number;
  IdCloture?: number;
  IdCommandeEcriture?: number;
  IdCompte?: number;
  IdCompteBancaire?: number;
  IdEcriture?: number;
  IdExercice?: number;
  IdExerciceCeClos?: number;
  IdFournisseur?: number;
  IdJournal?: number;
  IdMoyenPaiement?: number;
  IdPlanAnalytique?: string;
  IdTiers?: string;
  IsCompteAccepteLettrage?: boolean;
  IsCptBloque?: boolean;
  IsCptClos?: boolean;
  IsEcritureRemisEnBanqueEpargne?: boolean;
  IsEcritureRemiseEnBanque?: boolean;
  IsEcritureRemiseEnBanqueApresRejetOuAttente?: boolean;
  IsEcritureRemiseEnBanqueNonRejete?: boolean;
  IsExerciceClos?: boolean;
  IsExportAvance?: boolean;
  IsFonctionnement?: boolean;
  IsLettre?: boolean;
  IsLinkedToModeleTVA?: boolean;
  IsMouvementsBeneficiaires?: boolean;
  IsMouvementsFournisseurs?: boolean;
  IsNonSolde?: boolean;
  IsOnCompte6ou7?: boolean;
  IsOnComptePMV?: boolean;
  IsOnCompteTVACollectOrDeduc?: boolean;
  IsPCACCA?: boolean;
  IsRemisEnBanque?: boolean;
  IsSocial?: boolean;
  IsSupprime?: boolean;
  IsSurCompteTiers?: boolean;
  IsSurEcritureSimulee?: boolean;
  LettrageChoisi?: string;
  ListIdJournaux?: string;
  ListeCodeTypeJournal?: ArrayOfstringInput;
  ListeIdCECible?: string;
  ListeIdCaisses?: string;
  ListeIdsComptes?: ArrayOfdecimalInput;
  ListeIdsEcritures?: ArrayOfdecimalInput;
  ListeIdsMouvements?: ArrayOfdecimalInput;
  ListeLettres?: ArrayOfstringInput;
  ListeNomCaisse?: string;
  ListeNomJournaux?: string;
  ListeTypesEcritures?: ArrayOfstringInput;
  MotCleRecherche?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  NomCodeFournisseur?: string;
  NomPrenomMatriculeBeneficiaire?: string;
  NotListeCodeTypeJournal?: ArrayOfstringInput;
  NotListeTypesEcritures?: ArrayOfstringInput;
  NumeroCompte?: string;
  OrderByDateEcrtitureDesc?: boolean;
  PlanAnalytique?: string;
  Rupture?: string;
  SensMouvement?: string;
  SkipCount?: boolean;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
  TypeExport?: string;
  Vision?: string;
};

export type CriteresMouvementConsoCompteurPointsModelInput = {
  DateDebut?: any;
  DateDebutCalculPointsNonArchives?: any;
  DateFin?: any;
  IdBeneficiaire?: number;
  IdCompteurPoints?: number;
  IsMouvementCompensateur?: boolean;
  IsOrderByDateValDesc?: boolean;
  IsValide?: boolean;
  Libelle?: string;
  ListeIdBenef?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkips?: number;
  NbTakes?: number;
  Status?: StatusDtoEnum;
};

export type CriteresMouvementConsoModelInput = {
  DateCreationDebut?: any;
  DateCreationFin?: any;
  DateDebut?: any;
  DateFin?: any;
  IdAttribution?: number;
  IdBeneficiaire?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdEnveloppeAttribTransCompl?: number;
  IdSite?: number;
  IdTypeContrat?: number;
  IsActivite?: boolean;
  IsAttributionSubvention?: boolean;
  IsCommande?: boolean;
  IsConsoCompensee?: boolean;
  IsConsoValide?: boolean;
  IsEnveloppeForAttribution?: boolean;
  IsFamille?: boolean;
  IsLieAttribution?: boolean;
  IsMouvementBilletterie?: boolean;
  IsMouvementSynapse?: boolean;
  IsMvtConsoRattacheEnveloppeAfficheEnLigne?: boolean;
  IsNotConsoMvtAnnulee?: boolean;
  IsQuantite?: boolean;
  IsQuantiteQuotite?: boolean;
  IsSubvention?: boolean;
  IsTransverse?: boolean;
  IsTransverseAttribOuChoisieOuActivite?: boolean;
  IsValeurFacial?: boolean;
  Libelle?: string;
  ListeIdBeneficiaire?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkips?: number;
  NbTakes?: number;
  NomPrenomBenef?: string;
  NotListeIdBenef?: ArrayOfdecimalInput;
  Status?: StatusDtoEnum;
  WithAttributionsMasquees?: boolean;
  WithQuantiteA0?: boolean;
  WithSubventionA0?: boolean;
  WithValeurFacialeA0?: boolean;
};

export type CriteresMouvementSansTiersDetailModelInput = {
  AvecExercicesClotures?: boolean;
  IdCompte?: number;
  IdDelegation?: number;
  IdExercice?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
};

export type CriteresMouvementStockDtoInput = {
  Comparateur?: string;
  DateDeb?: any;
  DateFin?: any;
  DateReappro?: any;
  DateReapproOrNothing?: any;
  Id?: number;
  IdActivite?: number;
  IdActiviteSurStockDelegation?: number;
  IdArticle?: number;
  IdDeleg?: number;
  IdLigneCde?: number;
  IdProduit?: number;
  IdStkMvtReap?: number;
  IdStock?: number;
  InventaireId?: number;
  IsStkMvtDateReappro?: boolean;
  ListeArticle?: string;
  ListeIdMvtStk?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbElemParPage?: number;
  PageEnCours?: number;
  Status?: StatusDtoEnum;
  StockSurIdActivite?: number;
  TakeArticle?: boolean;
  TakeArticleFournisseur?: boolean;
  TakeFPA?: boolean;
  TakeLigneCommande?: boolean;
  TakeMouvementReapro?: boolean;
  TakeMouvementType?: boolean;
  TakeStock?: boolean;
  TakeUser?: boolean;
  TypeMouvement?: TypeMouvementRechEnum;
  WithActFamProd?: boolean;
  WithActivite?: boolean;
  WithCession?: boolean;
  WithCommandes?: boolean;
  WithFamille?: boolean;
  WithGenerique?: boolean;
  WithInventaire?: boolean;
  WithProduit?: boolean;
  WithQteStock?: boolean;
  WithUser?: boolean;
};

export type CriteresMouvementStockInventaireInput = {
  CodeTypeMvt?: string;
  ComparateurDate?: string;
  DateMaximun?: any;
  DateMinimun?: any;
  HasCommandeFournisseur?: boolean;
  IdActivite?: number;
  IdArticle?: number;
  IdDelegation?: number;
  IdLigneBonLivraisonRetour?: number;
  IdMvtStock?: number;
  IdStock?: number;
  IsArticleNonClos?: boolean;
  IsPasseReappro?: boolean;
  IsTypeMvtPhysique?: boolean;
  ListeCodeTypeMouvement?: ArrayOfstringInput;
  ListeIdArticle?: ArrayOfdecimalInput;
  ListeIdLigneCommande?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  SensMouvement?: string;
  Status?: StatusDtoEnum;
  WithArticleGenerique?: boolean;
};

export type CriteresMoyenPaiementActiviteDtoInput = {
  ActiviteId?: number;
  IsMoyenPaiementClos?: boolean;
  IsUserAchat?: boolean;
  IsUserDirecto?: boolean;
  IsUserVente?: boolean;
  MoyenPaiementId?: number;
  TakeActivite?: boolean;
  TakeMoyenPaiement?: boolean;
};

export type CriteresMoyenPaiementDtoInput = {
  CodeMoyenPayement?: string;
  Id?: number;
  IdActivite?: number;
  IdKitBancaire?: number;
  IdcIsUserDirecto?: number;
  IsAchat?: boolean;
  IsAchatInActivite?: boolean;
  IsClos?: boolean;
  IsFiduciaire?: boolean;
  IsFromParametrageActivite?: boolean;
  IsNotMoyenPForCptCourantEtPMV?: boolean;
  IsUsedInActivite?: boolean;
  IsVente?: boolean;
  IsVenteInActivite?: boolean;
  ListIdMoyenPaiement?: ArrayOfdecimalInput;
  ListeCodeMoyenPayement?: string;
  ListeIdActivite?: ArrayOfdecimalInput;
  ListeNotCodeMoyenPayement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeArticle?: boolean;
  TakeArticleWithStock?: boolean;
  TakeCommission?: boolean;
  TakeKitBancaire?: boolean;
  TakeMoyenPaiement?: boolean;
  TakeTypeMoyenPaiement?: boolean;
  WithPMV?: boolean;
  WithSEPA?: boolean;
};

export type CriteresMoyenPaiementModelInput = {
  IdActivite?: number;
  IdArticleForActivite?: number;
  IdProduit?: number;
  IsClos?: boolean;
  IsEnLignePourProduit?: boolean;
  IsEntree?: boolean;
  IsMoyenPaiementVente?: boolean;
  IsSortie?: boolean;
  ListeCodes?: ArrayOfstringInput;
  ListeCodesExcluded?: ArrayOfstringInput;
  ListeIdMoyenPaiement?: ArrayOfdecimalInput;
  ListeIdsActivite?: ArrayOfdecimalInput;
  SansKitBancaire?: boolean;
};

export type CriteresNatureMouvementStockDtoInput = {
  Code?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresOdadModelInput = {
  IdBeneficiaire?: number;
  IdDelegationODActifSansBlocage?: number;
  IsCloture?: boolean;
  IsODActifSansBlocage?: boolean;
  IsValide?: boolean;
  ListeCodeTypeBenef?: ArrayOfstringInput;
};

export type CriteresOrganisationDtoInput = {
  Id?: number;
  IdCE?: number;
  IsCloture?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeBenefOrganisation?: boolean;
  TakeForExBenefOrga?: boolean;
  TakeForExSaveListeOrga?: boolean;
  WithChildren?: boolean;
};

export type CriteresPjModeleInput = {
  AnalysableIa?: boolean;
  CodePieceJustificativeContains?: string;
  ComparaisonDateAnalyseIa?: string;
  ComparaisonDateEnvoie?: string;
  ComparaisonDateReception?: string;
  DateDebutAnalyseIa?: any;
  DateDebutEnvoie?: any;
  DateDebutReception?: any;
  DateFinAnalyseIa?: any;
  DateFinEnvoie?: any;
  DateFinReception?: any;
  HasFileLink?: boolean;
  Id?: number;
  IdActivite?: number;
  IdArticle?: number;
  IdAyantDroit?: number;
  IdBenef?: number;
  IdDelegationConnecte?: number;
  IdDevisCde?: number;
  IdLigneCommandeOrNull?: number;
  IdPieceJustificative?: number;
  IdPieceJustificativeBeneficiaire?: number;
  IdRib?: number;
  IsADPjClos?: boolean;
  IsBenefDelegationDroitActif?: boolean;
  IsClos?: boolean;
  IsNotAnnuleDevis?: boolean;
  IsNotAnnuleeLigneCommande?: boolean;
  IsNotRefuseDevis?: boolean;
  IsNotRefuseLigneCommande?: boolean;
  IsPJDossierRenseignee?: boolean;
  IsReceptionnee?: boolean;
  IsTakePJBenefUniquement?: boolean;
  IsTakePJDossierUniquement?: boolean;
  ListIdBenef?: ArrayOfdecimalInput;
  ListeCodeTypePj?: ArrayOfstringInput;
  ListeIdAd?: ArrayOfdecimalInput;
  ListeIdBenef?: ArrayOfdecimalInput;
  ListeIdRib?: ArrayOfdecimalInput;
  ListeStatut?: ArrayOfstringInput;
  ListeStatutDossierInverse?: ArrayOfstringInput;
  ListeStatutIa?: ArrayOfstringInput;
  ListeTypeAnalyseIaId?: ArrayOfdecimalInput;
  NbSkip?: number;
  NbTakes?: number;
  NotListCdeStatusCodes?: ArrayOfstringInput;
  NotListeCodeTypePj?: ArrayOfstringInput;
  SkipCount?: boolean;
  TexteRecherche?: string;
  TypeAnalyseIaId?: number;
  ValidatedBy?: string;
};

export type CriteresParamReqSpecifDtoInput = {
  Id?: number;
  IdChampTypeData?: number;
  IdReqSpecif?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  OrderByLibelle?: boolean;
  Status?: StatusDtoEnum;
  TakeChampType?: boolean;
  TakeReqSpecif?: boolean;
};

export type CriteresParametrageActiviteModelDtoInput = {
  CritereActivite?: CriteresActiviteDtoInput;
  CritereCompteBancaire?: CriteresCompteBancaireDtoInput;
  CritereHA?: CriteresJournalTypeDtoInput;
  CriterePlanAnalytique?: CriteresPlanAnalytiqueDtoInput;
  CritereTypeActivite?: CriteresTypeActiviteDtoInput;
  CritereVente?: CriteresJournalTypeDtoInput;
  IsCheckCommande?: boolean;
  IsCheckFamille?: boolean;
  IsInitDelegationGlobale?: boolean;
  IsInitParamActivite?: boolean;
  IsTakeCompteBancaire?: boolean;
};

export type CriteresPieceJustificativeDtoInput = {
  CodePJ?: string;
  Id?: number;
  IdFormule?: number;
  IsActivitePJ?: boolean;
  IsBenefPJ?: boolean;
  IsCloture?: boolean;
  NotTypePJ?: ArrayOfstringInput;
};

export type CriteresPlanAnalytiqueDtoInput = {
  Id?: number;
  IdBudget?: number;
  IdDelegation?: number;
  IsClos?: boolean;
  ListeIdPlan?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakePosteBDG?: boolean;
};

export type CriteresPointVenteDtoInput = {
  DelegationId?: number;
  Id?: number;
  IdUser?: number;
  IsCloture?: boolean;
  ListeDelegationId?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeAdresse?: boolean;
  TakeCEDelegation?: boolean;
  TakeCaisse?: boolean;
  TakeStock?: boolean;
};

export type CriteresPortailAlbumDtoInput = {
  Id?: number;
  IdCe?: number;
  IdStatut?: number;
  IsDateDepassee?: boolean;
  IsNonLie?: boolean;
  MotCles?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTake?: number;
  Status?: StatusDtoEnum;
  TakeCeDelegation?: boolean;
  TakeDocuments?: boolean;
  TakeListeArticles?: boolean;
  TakeStatut?: boolean;
};

export type CriteresPortailArticleDtoInput = {
  CEid?: number;
  CodeArticleType?: string;
  Id?: number;
  IdDelegOuDelegGlobale?: number;
  IsAffichagePublic?: boolean;
  IsArtVisible?: boolean;
  IsValide?: boolean;
  ListeCodeArtTypeExcluded?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeBibliotheque?: boolean;
  TakeCategorie?: boolean;
  TakeCeDelegation?: boolean;
  TakeLastUserMaj?: boolean;
  TakeListeAlbums?: boolean;
  TakeListeAlbumsArticle?: boolean;
  TakeListeCommentaires?: boolean;
  TakeListeDocuments?: boolean;
  TakeListeLikes?: boolean;
  TakeListeParamValeur?: boolean;
  TakeMenuParent?: boolean;
  TakePortailArticleType?: boolean;
  TakeStatut?: boolean;
  TakeUserCreation?: boolean;
};

export type CriteresPortailDocumentCategorieDtoInput = {
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresPortailFormulaireSpecifiqueDtoInput = {
  Id?: number;
  IsMenu?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresPortailPortletDtoInput = {
  CEid?: number;
  Id?: number;
  IsPortletPublic?: boolean;
  IsValide?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeCEDeleg?: boolean;
  TakePortailListeEnveloppeQTA?: boolean;
  TakePortailPortletCss?: boolean;
  TakePortailPortletParamVal?: boolean;
  TakePortailPortletParamValAndParam?: boolean;
  TakePortailPortletType?: boolean;
  TakeSavePortailPortletParamValAndParam?: boolean;
  TakeStatut?: boolean;
};

export type CriteresPortailStatutDtoInput = {
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  WithoutStatutRedaction?: boolean;
};

export type CriteresPosteBudgetaireDtoInput = {
  Id?: number;
  IdBudget?: number;
  IdBudgetPere?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeBudget?: boolean;
  TakeCompte?: boolean;
  TakeSectionAnalytique?: boolean;
};

export type CriteresProduitDtoInput = {
  CodeType?: string;
  DateDebutGrp?: any;
  DateDebutLoc?: any;
  DateFinGrp?: any;
  DateFinLoc?: any;
  DateMaj?: any;
  Id?: number;
  IdActivite?: number;
  IdFamille?: number;
  IdLieu?: number;
  IsPrestation?: boolean;
  IsRemboursementPresta?: boolean;
  IsVisible?: boolean;
  LibelleContains?: string;
  ListeIdFamille?: ArrayOfintInput;
  ListeTypeActivite?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OnlyDateVenteValide?: boolean;
  RedescendreParametrageRegles?: boolean;
  Status?: StatusDtoEnum;
  TakeAnneeRef?: boolean;
  TakeArticle?: boolean;
  TakeChampsPerso?: boolean;
  TakeCourrierAcceptation?: boolean;
  TakeCourrierContratLocation?: boolean;
  TakeCourrierRefus?: boolean;
  TakeDocument?: boolean;
  TakeEnveloppePresta?: boolean;
  TakeFamille?: boolean;
  TakeFamilleActivite?: boolean;
  TakeForCreationArticle?: boolean;
  TakeForGetChamps?: boolean;
  TakeForParamFPAChampsPerso?: boolean;
  TakeForParamFPAImputationComptable?: boolean;
  TakeForParamFPAInfosGene?: boolean;
  TakeForParamFPAModesLivraison?: boolean;
  TakeForParamFPARegles?: boolean;
  TakeForRedescente?: boolean;
  TakeFourniseur?: boolean;
  TakeFournisseursConventionnes?: boolean;
  TakeGeoloc?: boolean;
  TakeInfoForRegle?: boolean;
  TakePhoto?: boolean;
  TakeProduitDirectoDescription?: boolean;
  TakeProduitForSaveRegleHerite?: boolean;
  TakeRetourMedia?: boolean;
  TakeSessionChoix?: boolean;
  TakeStockTypeReappro?: boolean;
  WithCloture?: boolean;
};

export type CriteresProduitLightModelInput = {
  AreDisplayedDirecto?: boolean;
  CodeProduit?: string;
  DateDebutGroupe?: any;
  DateFinGroupe?: any;
  DateVentesProduit?: any;
  EqualsLibelleProduit?: string;
  HasArticleDispoOnDateRange?: boolean;
  HasArticleNominatifLie?: boolean;
  IdActivite?: number;
  IdCompteChargeOuProduit?: number;
  IdDelegPourFiltreActivite?: number;
  IdFamille?: number;
  IdModeleFraisAnnulation?: number;
  IdModeleTVA?: number;
  IdProduit?: number;
  IsActiviteClos?: boolean;
  IsClos?: boolean;
  IsFamilleClos?: boolean;
  IsLieARegroupement?: boolean;
  IsMAJAPI?: boolean;
  LibelleArticleContains?: string;
  LibelleArticleDescriptionContains?: string;
  LibelleContains?: string;
  LibelleFamilleArticleContains?: string;
  LibelleFamilleContains?: string;
  LibelleProduit?: string;
  ListeCodeTypeActivite?: ArrayOfstringInput;
  ListeIdFamille?: ArrayOfdecimalInput;
  ListeIdProduit?: ArrayOfdecimalInput;
  ListeRechercheSurSitePortail?: ArrayOfstringInput;
  LocationDateDebutArticle?: any;
  LocationDateFinArticle?: any;
  MDKAuteur?: string;
  MDKCollection?: string;
  MDKDateSortieDebut?: any;
  MDKDateSortieFin?: any;
  MDKEditeur?: string;
  MDKGenre?: string;
  MDKIdStockLocalisation?: number;
  MDKRechercheGenerique?: string;
  MDKReference?: string;
  MDKTheme?: string;
  MDKTypeMedia?: string;
  MDKVoirDisponible?: boolean;
  MDKVoirNouveaute?: boolean;
  NbSkip?: number;
  NbTakes?: number;
  OrderByFamilleProduitLibelle?: boolean;
  OrderByGroupeDateDebut?: boolean;
  OrderByGroupeType?: boolean;
  OrderByLibelle?: boolean;
  OrderByLibelleActivite?: boolean;
  OrderByLibelleProduitASC?: boolean;
  OrderByLibelleProduitDESC?: boolean;
  OrderByNouveauteProduitASC?: boolean;
  OrderByNouveauteProduitDESC?: boolean;
  ProduitDateMajSupEgal?: any;
};

export type CriteresProduitsInput = {
  AreDisplayedDirecto?: boolean;
  DateDebutGroupe?: any;
  DateFinGroupe?: any;
  EqualsLibelleProduit?: string;
  HasArticleDispoOnDateRange?: boolean;
  HasArticleNominatifLie?: boolean;
  IdActivite?: number;
  IdCompteChargeOuProduit?: number;
  IdDelegPourFiltreActivite?: number;
  IdFamille?: number;
  IdModeleFraisAnnulation?: number;
  IdModeleTVA?: number;
  IdProduit?: number;
  IsClos?: boolean;
  IsLieARegroupement?: boolean;
  IsMAJAPI?: boolean;
  LibelleArticleDescriptionContains?: string;
  LibelleProduit?: string;
  ListeCodeTypeActivite?: ArrayOfstringInput;
  ListeIdFamille?: ArrayOfdecimalInput;
  ListeIdProduit?: ArrayOfdecimalInput;
  ListeRechercheSurSitePortail?: ArrayOfstringInput;
  LocationDateDebutArticle?: any;
  LocationDateFinArticle?: any;
  MDKAuteur?: string;
  MDKCollection?: string;
  MDKDateSortieDebut?: any;
  MDKDateSortieFin?: any;
  MDKEditeur?: string;
  MDKGenre?: string;
  MDKIdStockLocalisation?: number;
  MDKRechercheGenerique?: string;
  MDKReference?: string;
  MDKTheme?: string;
  MDKTypeMedia?: string;
  MDKVoirDisponible?: boolean;
  MDKVoirNouveaute?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  OrderByFamilleProduitLibelle?: boolean;
  OrderByGroupeDateDebut?: boolean;
  OrderByGroupeType?: boolean;
  OrderByLibelleProduitASC?: boolean;
  OrderByLibelleProduitDESC?: boolean;
  OrderByNouveauteProduitASC?: boolean;
  OrderByNouveauteProduitDESC?: boolean;
  ProduitDateMajSupEgal?: any;
  Status?: StatusDtoEnum;
};

export type CriteresProfilDroitDtoInput = {
  Id?: number;
  IdDelegation?: number;
  IsAdministrateur?: boolean;
  IsSupprime?: boolean;
  IsUseDirecto?: boolean;
  ListProfilDroitMenuTypeActiviteModel?: ArrayOfProfilDroitMenuTypeActiviteModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeCEDelegation?: boolean;
  TakeListeProfilDataForParamCellule?: boolean;
  TakeMenu?: boolean;
  TakeProfilsForParamUsers?: boolean;
  TakeUserDelegation?: boolean;
};

export type CriteresProfilDroitMenuTypeActiviteDtoInput = {
  Id?: number;
  IdMenu?: number;
  IdProfilDroit?: number;
  IdTypeActivite?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeMenu?: boolean;
  TakeProfilDroit?: boolean;
  TakeTypeActivite?: boolean;
};

export type CriteresPubliDocumentInput = {
  IdTypePubli?: number;
  ListeIdReport?: ArrayOfdecimalInput;
  ListeIdTypeActivite?: ArrayOfdecimalInput;
};

export type CriteresPubliRequeteModelInput = {
  Comparateur?: string;
  DateMaxDerniereUtilisateur?: any;
  DateMinDerniereUtilisateur?: any;
  Id?: number;
  IdActivite?: number;
  IdContexte?: number;
  IsCloture?: boolean;
  IsDeclencheurStatutPerso?: boolean;
  IsDeclencheurStatutPersoMaster?: boolean;
  IsFiltreStatutPerso?: boolean;
  IsFiltreStatutPersoMaster?: boolean;
  IsLinkedToMasterVUP?: boolean;
  IsMasterVUP?: boolean;
  IsPublipage?: boolean;
  IsPublipageUser?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  Status?: StatusDtoEnum;
  WithContexteBenef?: boolean;
  WithContexteCommande?: boolean;
  WithContexteFacture?: boolean;
};

export type CriteresPubliVueInput = {
  IdTypePublipostage?: number;
  IsClos?: boolean;
  IsPublipage?: boolean;
  IsPublipageUser?: boolean;
  NbSkip?: number;
  NbTakes?: number;
  OrderbyDefautLibelle?: boolean;
};

export type CriteresRapprochementDtoInput = {
  Id?: number;
  IdReleve?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresReceptionCessionStockModelInput = {
  DateDebutCession?: any;
  DateFinCession?: any;
  IdActiviteEntree?: number;
  IdActiviteSortie?: number;
  IdArticleEntree?: number;
  IdArticleSortie?: number;
  IdCession?: number;
  IdDelegationEntree?: number;
  IdDelegationSortie?: number;
  IdFamilleEntree?: number;
  IdFamilleSortie?: number;
  IdPointVenteEntree?: number;
  IdPointVenteSortie?: number;
  IdStockEntree?: number;
  IdStockSortie?: number;
  IsTotalementReceptionnee?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  OrderByDateDesc?: boolean;
  Status?: StatusDtoEnum;
};

export type CriteresRechercheConformiteTvaModelInput = {
  ComparateurDate?: string;
  ComparateurMontant?: string;
  DateMaximum?: any;
  DateMinimum?: any;
  IdCESourceCible?: number;
  IdExercice?: number;
  ListeIdCompte?: ArrayOfdecimalInput;
  ListeIdJournaux?: ArrayOfdecimalInput;
  ListeIdModelesTVA?: ArrayOfintInput;
  MontantMaximum?: number;
  MontantMinimum?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresRechercheStatutsModelInput = {
  CodeStatut?: string;
  CodeStatutPere?: string;
  DisplayStatutsFils?: boolean;
  DisplayStatutsPeres?: boolean;
  IdActivite?: number;
  IdStatutPere?: number;
  IdStatutPerso?: number;
  IsClos?: boolean;
  IsContexteFournisseur?: boolean;
  IsModifManuelPossible?: boolean;
  ListeCodeStatuts?: ArrayOfstringInput;
};

export type CriteresRecoActionDtoInput = {
  Action?: string;
  IdArticle?: number;
  IdUser?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresRecommandationArticleMagazineModelInput = {
  ApplicationCode?: string;
  IsRandom?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Take?: number;
};

export type CriteresRegionDtoInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakePays?: boolean;
};

export type CriteresReglesModelInput = {
  CodeTypeRegle?: string;
  IdActivite?: number;
  IdArticle?: number;
  IdCurrentDelegationOrGlobal?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsClos?: boolean;
  IsEnveloppeComplementaire?: boolean;
  IsLieeModeleRegleAccessibilite?: boolean;
  IsLieeModeleRegleSubQuota?: boolean;
  IsQuotaEnveloppe?: boolean;
  IsRegleAttribution?: boolean;
  IsRegleExpert?: boolean;
  IsRegleHeritee?: boolean;
  IsRegleTransverse?: boolean;
  IsRegleTransverseOuHeritee?: boolean;
  TypeValeur?: string;
};

export type CriteresReleveBancaireDtoInput = {
  Id?: number;
  IdCompteBancaire?: number;
  IsOnlyOneResult?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Precedent?: any;
  Status?: StatusDtoEnum;
  WithCompteBancaire?: boolean;
  WithLigneRapproMvtEcrMoyenPaiEtCompte?: boolean;
  WithRapprochement?: boolean;
  WithUser?: boolean;
};

export type CriteresReportDtoInput = {
  CodM?: string;
  Id?: number;
  IdActivite?: number;
  ListeTypeReport?: string;
  ModeleAdresse?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RptType?: string;
  Status?: StatusDtoEnum;
  TakeBlocData?: boolean;
  TakeForGetListeGenerique?: boolean;
  TakeForReporting?: boolean;
  TakeModeleAdresse?: boolean;
  TakeModeleMEP?: boolean;
  TakeReportType?: boolean;
};

export type CriteresReportGrandLivreAnalytiqueInput = {
  ChoixRechercheLettrage?: string;
  DateDebut?: any;
  DateFin?: any;
  IdCECibleOuSource?: number;
  IdCECreePar?: number;
  IdCEEntete?: number;
  IdCESource?: number;
  IdCourrier?: number;
  IdExercice?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytique?: number;
  IsFonctionnement?: boolean;
  IsGdLivreAvance?: boolean;
  IsSocial?: boolean;
  IsVoirEcritureSimule?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NumSession?: string;
  Status?: StatusDtoEnum;
  TypeExport?: string;
};

export type CriteresReportModeleAdrdtoInput = {
  Id?: number;
  IsDefaut?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeReports?: boolean;
  TypeModeleAdresse?: string;
  WithAdresseModeleCloture?: boolean;
};

export type CriteresReportTypeDtoInput = {
  Id?: number;
  ListeTypeReport?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresReqSpecifDtoInput = {
  Id?: number;
  IsVisible?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeListParam?: boolean;
};

export type CriteresRibDtoInput = {
  CleRib?: string;
  CodeBanque?: string;
  CodeCompte?: string;
  CodeGuichet?: string;
  Iban?: string;
  Id?: number;
  IdBenef?: number;
  IdFour?: number;
  IsClos?: boolean;
  IsCompteBanquaireClos?: boolean;
  IsDefaut?: boolean;
  ListIdRib?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeBenef?: boolean;
  TakeFournisseur?: boolean;
  TakeRibMandat?: boolean;
};

export type CriteresRibsModelInput = {
  IdBeneficiaire?: number;
  IdFournisseur?: number;
  IsCloture?: boolean;
  IsValideCE?: boolean;
};

export type CriteresSaveArticleDtoInput = {
  ANCVParametrageSent?: boolean;
  ArticleLocation?: boolean;
  ArticleMediateque?: boolean;
  CadeauxSent?: boolean;
  ChampsPersosSent?: boolean;
  CompteursPointsSent?: boolean;
  GenerationAuto?: boolean;
  ImputationComptableSent?: boolean;
  InfosGeneralesSent?: boolean;
  IsNewArticle?: boolean;
  ModesLivraisonSent?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  PJSent?: boolean;
  PrixHAchatVenteSent?: boolean;
  PrixVenteSent?: boolean;
  ReglesSent?: boolean;
  SectionsAnalytiquesSent?: boolean;
  Status?: StatusDtoEnum;
  TakeAnneeRef?: boolean;
  TakeChampPerso?: boolean;
  TakeEnvImpArticle?: boolean;
  TakeForNewArticle?: boolean;
  TakeForNewArticleForEnveloppe?: boolean;
  TakeForParamFPA?: boolean;
  TakeModeLivraison?: boolean;
  TakeModeleRegle?: boolean;
  TakeSessionChoix?: boolean;
};

export type CriteresSaveFamilleDtoInput = {
  AppliquerSurProduitFournisseurConv?: boolean;
  AppliquerSurProduitModeFonctionnement?: boolean;
  CadeauxSent?: boolean;
  ChampsPersosSent?: boolean;
  CompteursPointsSent?: boolean;
  ImputationComptableSent?: boolean;
  InfosGeneralesSent?: boolean;
  ModesLivraisonSent?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreCadeaux?: boolean;
  RedescendreImage?: boolean;
  RedescendreImputation?: boolean;
  RedescendreModalitesReglement?: boolean;
  RedescendreModesLivraison?: boolean;
  RedescendreParamDirecto?: boolean;
  RedescendreParametrageCompteurPoint?: boolean;
  RedescendreRegles?: boolean;
  ReglesSent?: boolean;
  SectionsAnalytiquesSent?: boolean;
  Status?: StatusDtoEnum;
  TakeCourrier?: boolean;
  TakeCourrierContratLocation?: boolean;
  TakeEnveloppePresta?: boolean;
  TakeForNewFamilleForEnveloppe?: boolean;
  TakeForParamFPA?: boolean;
  TakeFourniseurConventionne?: boolean;
  TakeModeleRegle?: boolean;
  TakeRetourMedia?: boolean;
  TakeSessionChoix?: boolean;
  TakeStockTypeReappro?: boolean;
};

export type CriteresSaveProduitDtoInput = {
  CadeauxSent?: boolean;
  ChampsPersosSent?: boolean;
  CompteursPointsSent?: boolean;
  ImputationComptableSent?: boolean;
  InfosGeneralesSent?: boolean;
  ModesLivraisonSent?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreCadeaux?: boolean;
  RedescendreDateSubvention?: boolean;
  RedescendreImage?: boolean;
  RedescendreImputation?: boolean;
  RedescendreModesLivraison?: boolean;
  RedescendreParametrageCompteurPoint?: boolean;
  RedescendreRegles?: boolean;
  RedesendreParamDirecto?: boolean;
  ReglesSent?: boolean;
  SectionsAnalytiquesSent?: boolean;
  Status?: StatusDtoEnum;
  TakeAnneeRef?: boolean;
  TakeArticle?: boolean;
  TakeChamPerso?: boolean;
  TakeCourrier?: boolean;
  TakeCourrierContratLocation?: boolean;
  TakeEnveloppePresta?: boolean;
  TakeForNewProduit?: boolean;
  TakeForNewProduitForEnveloppe?: boolean;
  TakeForParamFPA?: boolean;
  TakeFourniseur?: boolean;
  TakeFourniseurConventionne?: boolean;
  TakeModeLivraison?: boolean;
  TakeModeleRegle?: boolean;
  TakeProduitDirectoDescription?: boolean;
  TakeProduitDocument?: boolean;
  TakeRetourMedia?: boolean;
  TakeSessionChoix?: boolean;
  TakeStockTypeReappro?: boolean;
};

export type CriteresSectionAnalytiqueDtoInput = {
  Id?: number;
  IdArticle?: number;
  IdBudget?: number;
  IdDelegation?: number;
  IdLigneDevis?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytiquePere?: number;
  IsClos?: boolean;
  IsPremierNiveau?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Niveau?: number;
  Status?: StatusDtoEnum;
  TakePere?: boolean;
  TakePlan?: boolean;
  TakePosteBDG?: boolean;
};

export type CriteresSectionAnalytiqueModelInput = {
  Code?: string;
  Description?: string;
  IdCompte?: number;
  IsAfficheCompte?: boolean;
  Libelle?: string;
};

export type CriteresSessionChoixDtoInput = {
  Id?: number;
  IdActivite?: number;
  IsClos?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeActivite?: boolean;
};

export type CriteresSiteDtoInput = {
  Id?: number;
  IdBenef?: number;
  IdCE?: number;
  IdSitePere?: number;
  IsCloture?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeBenefSite?: boolean;
  TakeForExGetSiteGenerique?: boolean;
  TakeForExSaveSiteGenerique?: boolean;
  TakeModeEnvoiANCV?: boolean;
  TakeSitePere?: boolean;
  WithChildren?: boolean;
};

export type CriteresSoldeConsommationsDtoInput = {
  DateReference?: any;
  IdActivite?: number;
  IdBenef?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdSite?: number;
  IdTypeContrat?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  SkipNbLignes?: number;
  Status?: StatusDtoEnum;
  TakeNbLignes?: number;
  WithBenefHorsDroits?: boolean;
};

export type CriteresSoldePmvModelInput = {
  ComparateurDate?: string;
  ComparateurSolde?: string;
  DateDebut?: any;
  DateFin?: any;
  DateMax?: any;
  IdBenef?: number;
  IdPMV?: number;
  IsEcritureBenef?: boolean;
  IsMouvementSupprime?: boolean;
  IsOnComptePMV?: boolean;
  ListeIdPMV?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTake?: number;
  NotListeCodeTypeJournal?: ArrayOfstringInput;
  SoldeRecherche?: number;
  Status?: StatusDtoEnum;
};

export type CriteresStatutCommandeDtoInput = {
  Code?: string;
  Id?: number;
  ListeCode?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeCommande?: string;
};

export type CriteresStatutCourrierDtoInput = {
  Code?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresStatutFactureModelInput = {
  CodeStatut?: string;
  IdStatut?: number;
  IsTypeClient?: boolean;
};

export type CriteresStatutPersoModelInput = {
  CodeStatut?: string;
  CodeStatutPere?: string;
  IdActivite?: number;
  IdStatutPere?: number;
  IdStatutPerso?: number;
  IsClos?: boolean;
  IsModifManuelPossible?: boolean;
};

export type CriteresStockArticleDtoInput = {
  ArtGereEnStock?: boolean;
  ArtGroupe?: boolean;
  ArticleId?: number;
  DelegationId?: number;
  IdActivite?: number;
  ListeArticle?: string;
  ListeIdStock?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StockId?: number;
  StockSurIdActivite?: number;
  WithActFamProd?: boolean;
  WithArticleLigneCommandeStatutCommande?: boolean;
  WithCloture?: boolean;
  WithGenerique?: boolean;
  WithValorisation?: boolean;
};

export type CriteresStockDtoInput = {
  CEId?: number;
  IDCDeleg?: number;
  Id?: number;
  IdActivite?: number;
  IdActiviteDelegation?: number;
  IdDeleg?: number;
  IdDelegationPourStockPhysiqueDirecto?: number;
  IdUser?: number;
  IsStockDelegGlobale?: boolean;
  ListePVId?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  PvId?: number;
  Status?: StatusDtoEnum;
  TakeForGetStock?: boolean;
  TakeForGetStockForParam?: boolean;
  WithCloture?: boolean;
  WithPV?: boolean;
  WithStockDeleg?: boolean;
};

export type CriteresStockLightModelInput = {
  IdActiviteDelegation?: number;
  IdDelegStockPhysique?: number;
  IsClos?: boolean;
  IsStockPhysique?: boolean;
  WithStockPVDelegGlobal?: boolean;
};

export type CriteresStockTypeReapproDtoInput = {
  Code?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresSuiviTresorerieDtoInput = {
  DateDebut?: any;
  DateFin?: any;
  IdBanque?: number;
  IdCompteBancaire?: number;
  IsMensuel?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresSurDateModelInput = {
  Comparateur?: string;
  DateInferieure?: any;
  DateSuperieure?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresTvaModelInput = {
  IdModele?: number;
  IsClos?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresTypeActiviteDtoInput = {
  CodeDirecto?: string;
  Id?: number;
  IdActivite?: number;
  ListeCodeModuleAccessible?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresTypeBenefDtoInput = {
  Code?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresTypeCalculModeLivraisonDtoInput = {
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresTypeConsoMouvementPointDtoInput = {
  Code?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresTypeMoyenPaiementDtoInput = {
  Code?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type CriteresUserCommissionDtoInput = {
  CommissionId?: number;
  TakeCommission?: boolean;
  TakeUser?: boolean;
  UsersId?: number;
};

export type CriteresUsersDtoInput = {
  Id?: number;
  IdDelegation?: number;
  IsAdministrateur?: boolean;
  IsDirecto?: boolean;
  Login?: string;
  Mdp?: string;
  MdpCrypteOuClair?: string;
  PvId?: number;
  TakeAdresse?: boolean;
  TakeArticle?: boolean;
  TakeBenef?: boolean;
  TakeCEDelegation?: boolean;
  TakeCEDelegationEtUsers?: boolean;
  TakeCaisse?: boolean;
  TakeForParametrageUtilisateurs?: boolean;
  TakeListUserCommissions?: boolean;
  TakeParametresAppli?: boolean;
  TakePointVente?: boolean;
  TakePointVenteEtUsers?: boolean;
  TakeProfilDroit?: boolean;
  TakeStock?: boolean;
  WithCloture?: boolean;
};

export type CriteresUsersModelInput = {
  HaveEmail?: boolean;
  Id?: number;
  IdDelegation?: number;
  IdPointVenteRattache?: number;
  IsAdmin?: boolean;
  IsClos?: boolean;
  IsProfilApprobateur?: boolean;
  IsUserDirecto?: boolean;
  IsUserKalidea?: boolean;
  ListeIdComission?: ArrayOfdecimalInput;
  ListeIdUtilisateur?: ArrayOfdecimalInput;
  NbParPage?: number;
  NomPrenomStartWith?: string;
  NumeroPage?: number;
  OrderById?: boolean;
};

export type CriteresValidationRmbMensuelInput = {
  DateLigneDossier?: any;
  IdBeneficiaire?: number;
  IdDossier?: number;
  IdLigneCommande?: number;
  IdPrestation?: number;
  IsLigneAcceptee?: boolean;
};

export type CriteresVilleDtoInput = {
  CP?: string;
  DepartementId?: number;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  NomStarWith?: string;
  Recherche?: string;
  StartWithCP?: string;
  Status?: StatusDtoEnum;
  TakeDepartement?: boolean;
  TakePays?: boolean;
  TakeRegion?: boolean;
};

export type CriteresVueDtoInput = {
  Id?: number;
  IdDelegation?: number;
  IdUser?: number;
  IsGlobal?: boolean;
  IsGlobalAndPrivee?: boolean;
  IsPrivee?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeChampVue?: boolean;
  TakeDelegation?: boolean;
  TakeUser?: boolean;
  TakeVueChampVue?: boolean;
};

export type CriteresWidgetAccueilDtoInput = {
  Id?: number;
  IdCE?: number;
  IdUser?: number;
  ListeCodesWidgets?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeCE?: boolean;
  TakeForWidgetControlleurLoad?: boolean;
  TakeForWidgetControlleurSave?: boolean;
  TakeUser?: boolean;
  TakeWidget?: boolean;
  TakeWidgetAccueilParam?: boolean;
};

export type CriteresWidgetAccueilParamDtoInput = {
  CodeParam?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeWidgetAccueil?: boolean;
  TakeWidgetParam?: boolean;
  WidgetAccueilId?: number;
  WidgetParamId?: number;
};

export type CriteresWidgetDtoInput = {
  CodeWidget?: string;
  Id?: number;
  ListeCodesWidgetsAccessible?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TakeParametres?: boolean;
};

export type DateReservationModelInput = {
  DateDebutReservation?: any;
  DateFinReservation?: any;
  IdLigneCommande?: number;
};

export type DatesModificationBeneficiaire = {
  __typename?: 'DatesModificationBeneficiaire';
  DateCreation?: any;
  DateModification?: any;
  IdUserDerniereModification?: number;
};

export type DatesModificationBeneficiaireInput = {
  DateCreation?: any;
  DateModification?: any;
  IdUserDerniereModification?: number;
};

export type DelegationBaseModel = {
  __typename?: 'DelegationBaseModel';
  Id?: number;
  Nom?: string;
};

export type DelegationBaseModelInput = {
  Id?: number;
  Nom?: string;
};

export type DepartementDto = {
  __typename?: 'DepartementDTO';
  Code?: string;
  Id?: number;
  IsCloture?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Region?: RegionDto;
  Status?: StatusDtoEnum;
};

export type DepartementDtoInput = {
  Code?: string;
  Id?: number;
  IsCloture?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Region?: RegionDtoInput;
  Status?: StatusDtoEnum;
};

export type DestinataireMailModelDtoInput = {
  Adresse?: string;
  AdressePro?: string;
  IdBenef?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type DetailEcrituresAnnulationDossierPretsEtDonsModelDto = {
  __typename?: 'DetailEcrituresAnnulationDossierPretsEtDonsModelDTO';
  CodeTypeEcriture?: string;
  HasEcheancierId?: boolean;
  IdEcriture?: number;
  MontantEcriture?: number;
};

export type DetailEcrituresAnnulationDossierPretsEtDonsModelDtoInput = {
  CodeTypeEcriture?: string;
  HasEcheancierId?: boolean;
  IdEcriture?: number;
  MontantEcriture?: number;
};

export type DevisCommandeDto = {
  __typename?: 'DevisCommandeDTO';
  ARegler?: number;
  Activite?: ActiviteDto;
  Adresse?: AdresseDto;
  Benef?: BenefDto;
  CEDelegation?: CeDelegationDto;
  Caisse?: CaisseDto;
  ClassementAttribution?: number;
  CommandeLibre?: DevisCommandeDto;
  DateDevis?: any;
  DateRefSub?: any;
  DossierPrestation?: DevisCommandeDto;
  Exercice?: ExerciceDto;
  Fournisseur?: FournisseurDto;
  FraisCB?: number;
  Id?: number;
  IdDossier?: number;
  IsCommandeEnLigne?: boolean;
  IsCommandeEventFamiliaux?: boolean;
  IsCommandeFinie?: boolean;
  IsCommandeLibre?: boolean;
  IsCustomLibelle?: number;
  IsSaisieEnCours?: boolean;
  ListParticipant?: ArrayOfBenefDto;
  ListeBlBr?: ArrayOfBlBrDto;
  ListeChampValeur?: ArrayOfChampValeurDto;
  ListeCommandes?: ArrayOfDevisCommandeDto;
  ListeCommandesLibres?: ArrayOfDevisCommandeDto;
  ListeFacture?: ArrayOfFactureDto;
  ListeHistoStatut?: ArrayOfHistoStatutCommandeDto;
  ListeLigCde?: ArrayOfLigneCommandeDto;
  ModeLivraison?: string;
  MontantDossierAvecSubvention?: number;
  MontantFraisCommission?: number;
  MontantFraisPort?: number;
  MontantPresentePrestationTotal?: number;
  MontantRemboursePrestation?: number;
  MontantRemise?: number;
  MontantSubventionTotal?: number;
  MontantTotalDevisAvecSubvention?: number;
  MontantTotalDevisHorsSubvention?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NecessiteAcceptationBenef?: boolean;
  NecessiteAcceptationCE?: boolean;
  NumeroChoixLocation?: number;
  Objet?: string;
  OrigineCommande?: OrigineCommandeDto;
  PV?: PointVenteDto;
  Permanence?: PermDto;
  Produit?: ProduitDto;
  RemarquePrive?: string;
  RemarquePublic?: string;
  SessionChoix?: SessionChoixDto;
  Status?: StatusDtoEnum;
  StatutAdministratifCurrent?: StatutCommandeDto;
  StatutLivraisonCurrent?: StatutCommandeDto;
  StatutPersoAdministratifCurrent?: StatutPersoCommandeDto;
  Stock?: StockDto;
  Type?: string;
};

export type DevisCommandeDtoInput = {
  ARegler?: number;
  Activite?: ActiviteDtoInput;
  Adresse?: AdresseDtoInput;
  Benef?: BenefDtoInput;
  CEDelegation?: CeDelegationDtoInput;
  Caisse?: CaisseDtoInput;
  ClassementAttribution?: number;
  CommandeLibre?: DevisCommandeDtoInput;
  DateDevis?: any;
  DateRefSub?: any;
  DossierPrestation?: DevisCommandeDtoInput;
  Exercice?: ExerciceDtoInput;
  Fournisseur?: FournisseurDtoInput;
  FraisCB?: number;
  Id?: number;
  IdDossier?: number;
  IsCommandeEnLigne?: boolean;
  IsCommandeEventFamiliaux?: boolean;
  IsCommandeFinie?: boolean;
  IsCommandeLibre?: boolean;
  IsCustomLibelle?: number;
  IsSaisieEnCours?: boolean;
  ListParticipant?: ArrayOfBenefDtoInput;
  ListeBlBr?: ArrayOfBlBrDtoInput;
  ListeChampValeur?: ArrayOfChampValeurDtoInput;
  ListeCommandes?: ArrayOfDevisCommandeDtoInput;
  ListeCommandesLibres?: ArrayOfDevisCommandeDtoInput;
  ListeFacture?: ArrayOfFactureDtoInput;
  ListeHistoStatut?: ArrayOfHistoStatutCommandeDtoInput;
  ListeLigCde?: ArrayOfLigneCommandeDtoInput;
  ModeLivraison?: string;
  MontantDossierAvecSubvention?: number;
  MontantFraisCommission?: number;
  MontantFraisPort?: number;
  MontantPresentePrestationTotal?: number;
  MontantRemboursePrestation?: number;
  MontantRemise?: number;
  MontantSubventionTotal?: number;
  MontantTotalDevisAvecSubvention?: number;
  MontantTotalDevisHorsSubvention?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NecessiteAcceptationBenef?: boolean;
  NecessiteAcceptationCE?: boolean;
  NumeroChoixLocation?: number;
  Objet?: string;
  OrigineCommande?: OrigineCommandeDtoInput;
  PV?: PointVenteDtoInput;
  Permanence?: PermDtoInput;
  Produit?: ProduitDtoInput;
  RemarquePrive?: string;
  RemarquePublic?: string;
  SessionChoix?: SessionChoixDtoInput;
  Status?: StatusDtoEnum;
  StatutAdministratifCurrent?: StatutCommandeDtoInput;
  StatutLivraisonCurrent?: StatutCommandeDtoInput;
  StatutPersoAdministratifCurrent?: StatutPersoCommandeDtoInput;
  Stock?: StockDtoInput;
  Type?: string;
};

export type DevisCommandeInfosCommandeNonLivreePartiellementLivreeModel = {
  __typename?: 'DevisCommandeInfosCommandeNonLivreePartiellementLivreeModel';
  Libelle?: string;
  ListeArticle?: ArrayOfstring;
  NumeroCommande?: number;
};

export type DevisCommandeInfosCommandeNonLivreePartiellementLivreeModelInput = {
  Libelle?: string;
  ListeArticle?: ArrayOfstringInput;
  NumeroCommande?: number;
};

export type DevisCommandeInfosReglMasModel = {
  __typename?: 'DevisCommandeInfosReglMasModel';
  CodeMoyenPaiement?: string;
  HasModalitePaiement?: boolean;
  IdCommande?: number;
  MontantRestantARegler?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RibAssocie?: number;
  Status?: StatusDtoEnum;
  StatutCommande?: string;
};

export type DevisCommandeInfosReglMasModelInput = {
  CodeMoyenPaiement?: string;
  HasModalitePaiement?: boolean;
  IdCommande?: number;
  MontantRestantARegler?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RibAssocie?: number;
  Status?: StatusDtoEnum;
  StatutCommande?: string;
};

export type DevisCommandeListingModel = {
  __typename?: 'DevisCommandeListingModel';
  AnyFileExported?: boolean;
  CodeStatutAdministratif?: string;
  CodeStatutLivraison?: string;
  CodeTypeActivite?: string;
  CouleurStatut?: string;
  DateCommande?: any;
  DateMaxLocation?: any;
  DateMinLocation?: any;
  HaveLigneCommandeClientRattachee?: boolean;
  IdActivite?: number;
  IdBeneficiaire?: number;
  IdCommande?: number;
  IdDossierLie?: number;
  IdFournisseur?: number;
  IsCommandeLibre?: boolean;
  IsEnvoyeFournisseur?: boolean;
  LibelleCommande?: string;
  LibelleSessionChoix?: string;
  LibelleStatut?: string;
  LibelleStatutAdministratif?: string;
  LibelleStatutLivraison?: string;
  MatriculeBeneficiaire?: string;
  MontantAcompte?: number;
  MontantFraisCommission?: number;
  MontantFraisPort?: number;
  MontantRemise?: number;
  MontantSubventionTotale?: number;
  MontantTotalCommande?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NecessiteAcceptationBenef?: boolean;
  NecessiteAcceptationCE?: boolean;
  NomFournisseur?: string;
  NomPrenomBenef?: string;
  NombreCompteurPoint?: number;
  NombreParticipant?: number;
  NombrePoints?: number;
  NumeroAttribution?: number;
  NumeroChoix?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  RestantAPayer?: number;
  Site?: string;
  Status?: StatusDtoEnum;
};

export type DevisCommandeListingModelInput = {
  AnyFileExported?: boolean;
  CodeStatutAdministratif?: string;
  CodeStatutLivraison?: string;
  CodeTypeActivite?: string;
  CouleurStatut?: string;
  DateCommande?: any;
  DateMaxLocation?: any;
  DateMinLocation?: any;
  HaveLigneCommandeClientRattachee?: boolean;
  IdActivite?: number;
  IdBeneficiaire?: number;
  IdCommande?: number;
  IdDossierLie?: number;
  IdFournisseur?: number;
  IsCommandeLibre?: boolean;
  IsEnvoyeFournisseur?: boolean;
  LibelleCommande?: string;
  LibelleSessionChoix?: string;
  LibelleStatut?: string;
  LibelleStatutAdministratif?: string;
  LibelleStatutLivraison?: string;
  MatriculeBeneficiaire?: string;
  MontantAcompte?: number;
  MontantFraisCommission?: number;
  MontantFraisPort?: number;
  MontantRemise?: number;
  MontantSubventionTotale?: number;
  MontantTotalCommande?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NecessiteAcceptationBenef?: boolean;
  NecessiteAcceptationCE?: boolean;
  NomFournisseur?: string;
  NomPrenomBenef?: string;
  NombreCompteurPoint?: number;
  NombreParticipant?: number;
  NombrePoints?: number;
  NumeroAttribution?: number;
  NumeroChoix?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  RestantAPayer?: number;
  Site?: string;
  Status?: StatusDtoEnum;
};

export type DevisCommandeModelDto = {
  __typename?: 'DevisCommandeModelDTO';
  CodeSatutAdm?: string;
  CodeSatutLiv?: string;
  CodeTypeActivite?: string;
  DateCommande?: any;
  IdCommande?: number;
  IdDossier?: number;
  IdTiers?: number;
  IsCanExportCde?: boolean;
  IsDevisLibreFacture?: boolean;
  IsEnvoyerFour?: boolean;
  IsSaisieEnCours?: boolean;
  LibelleBeneficiaire?: string;
  LibelleFournisseur?: string;
  LibelleStatutAdm?: string;
  LibelleStatutLiv?: string;
  MontantAcompte?: number;
  MontantFraisCom?: number;
  MontantFraisPort?: number;
  MontantRemise?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Objet?: string;
  Reference?: string;
  RemarquePrive?: string;
  RemarquePublic?: string;
  Status?: StatusDtoEnum;
  TotalCde?: number;
  Type?: string;
};

export type DevisCommandeModelDtoInput = {
  CodeSatutAdm?: string;
  CodeSatutLiv?: string;
  CodeTypeActivite?: string;
  DateCommande?: any;
  IdCommande?: number;
  IdDossier?: number;
  IdTiers?: number;
  IsCanExportCde?: boolean;
  IsDevisLibreFacture?: boolean;
  IsEnvoyerFour?: boolean;
  IsSaisieEnCours?: boolean;
  LibelleBeneficiaire?: string;
  LibelleFournisseur?: string;
  LibelleStatutAdm?: string;
  LibelleStatutLiv?: string;
  MontantAcompte?: number;
  MontantFraisCom?: number;
  MontantFraisPort?: number;
  MontantRemise?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Objet?: string;
  Reference?: string;
  RemarquePrive?: string;
  RemarquePublic?: string;
  Status?: StatusDtoEnum;
  TotalCde?: number;
  Type?: string;
};

export type DispoCategorieRessourcesPartageesModel = {
  __typename?: 'DispoCategorieRessourcesPartageesModel';
  IdArticle?: number;
  IdProduit?: number;
  Libelle?: string;
  LibelleProduit?: string;
};

export type DispoCategorieRessourcesPartageesModelInput = {
  IdArticle?: number;
  IdProduit?: number;
  Libelle?: string;
  LibelleProduit?: string;
};

export type DispoProduitGroupeModelDto = {
  __typename?: 'DispoProduitGroupeModelDTO';
  Accepte?: number;
  Ann?: number;
  Dispo?: string;
  EnAtt?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Ref?: number;
  Status?: StatusDtoEnum;
  Total?: string;
};

export type DispoProduitGroupeModelDtoInput = {
  Accepte?: number;
  Ann?: number;
  Dispo?: string;
  EnAtt?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Ref?: number;
  Status?: StatusDtoEnum;
  Total?: string;
};

export type DisponibiliteProduitInscriptionModel = {
  __typename?: 'DisponibiliteProduitInscriptionModel';
  NbAccepte?: number;
  NbAnnule?: number;
  NbDisponible?: number;
  NbEnAttente?: number;
  NbRefuse?: number;
  NbTotal?: number;
};

export type DisponibiliteProduitInscriptionModelInput = {
  NbAccepte?: number;
  NbAnnule?: number;
  NbDisponible?: number;
  NbEnAttente?: number;
  NbRefuse?: number;
  NbTotal?: number;
};

export type DisponibilitesRessourcesPartageesModel = {
  __typename?: 'DisponibilitesRessourcesPartageesModel';
  CodeExemplaire?: string;
  Commentaire?: string;
  DateEmprunt?: any;
  DateRetour?: any;
  IdBenef?: number;
  IdCde?: number;
  IdExemplaire?: number;
  IdLigneCde?: number;
  IdRessource?: number;
  IsAttente?: boolean;
  IsEmprunte?: boolean;
  IsReserve?: boolean;
  IsRetard?: boolean;
  IsRetournee?: boolean;
  IsRetourneePartiellement?: boolean;
  IsVueJour?: boolean;
  IsVueMois?: boolean;
  IsVueSemaine?: boolean;
  Matricule?: string;
  MontantTotal?: number;
  NomBenef?: string;
  NomRessource?: string;
  PrenomBenef?: string;
};

export type DisponibilitesRessourcesPartageesModelInput = {
  CodeExemplaire?: string;
  Commentaire?: string;
  DateEmprunt?: any;
  DateRetour?: any;
  IdBenef?: number;
  IdCde?: number;
  IdExemplaire?: number;
  IdLigneCde?: number;
  IdRessource?: number;
  IsAttente?: boolean;
  IsEmprunte?: boolean;
  IsReserve?: boolean;
  IsRetard?: boolean;
  IsRetournee?: boolean;
  IsRetourneePartiellement?: boolean;
  IsVueJour?: boolean;
  IsVueMois?: boolean;
  IsVueSemaine?: boolean;
  Matricule?: string;
  MontantTotal?: number;
  NomBenef?: string;
  NomRessource?: string;
  PrenomBenef?: string;
};

export type DocumentBaseModelInput = {
  FontIcon?: string;
  Id?: number;
  IsSupprime?: boolean;
  Libelle?: string;
  Lien?: string;
  LienType?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RepertoireUserDocument?: string;
  Status?: StatusDtoEnum;
  Taille?: number;
  Type?: string;
};

export type DossierBenefModelDto = {
  __typename?: 'DossierBenefModelDTO';
  ChampBlocageDroit?: ChampDto;
  ChampCategorie?: ChampDto;
  ChampContrat?: ChampDto;
  ChampCotisation?: ChampDto;
  ChampCycle?: ChampDto;
  ChampDroit?: ChampDto;
  ChampMetier?: ChampDto;
  ChampMoyenCorrespondance?: ChampDto;
  ChampSexe?: ChampDto;
  ChampSituationFamiliale?: ChampDto;
  ChampTitre?: ChampDto;
  ListeBlocageDroits?: ArrayOfChampListeValeurDto;
  ListeCategories?: ArrayOfChampListeValeurDto;
  ListeChampsPersosBenef?: ArrayOfChampDto;
  ListeContrats?: ArrayOfChampListeValeurDto;
  ListeCriteresSociauxBoolean?: ArrayOfChampDto;
  ListeCriteresSociauxCalcules?: ArrayOfChampDto;
  ListeCriteresSociauxNonCalcules?: ArrayOfChampDto;
  ListeCycles?: ArrayOfChampListeValeurDto;
  ListeDroits?: ArrayOfChampListeValeurDto;
  ListeMetiers?: ArrayOfChampListeValeurDto;
  ListeMoyensCorrespondance?: ArrayOfChampListeValeurDto;
  ListeOrganisations?: ArrayOfOrganisationDto;
  ListeSexes?: ArrayOfChampListeValeurDto;
  ListeSites?: ArrayOfSiteDto;
  ListeSituationsFamiliale?: ArrayOfChampListeValeurDto;
  ListeTitres?: ArrayOfChampListeValeurDto;
  ListeTypesBenef?: ArrayOfTypeBenefDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type DossierBenefModelDtoInput = {
  ChampBlocageDroit?: ChampDtoInput;
  ChampCategorie?: ChampDtoInput;
  ChampContrat?: ChampDtoInput;
  ChampCotisation?: ChampDtoInput;
  ChampCycle?: ChampDtoInput;
  ChampDroit?: ChampDtoInput;
  ChampMetier?: ChampDtoInput;
  ChampMoyenCorrespondance?: ChampDtoInput;
  ChampSexe?: ChampDtoInput;
  ChampSituationFamiliale?: ChampDtoInput;
  ChampTitre?: ChampDtoInput;
  ListeBlocageDroits?: ArrayOfChampListeValeurDtoInput;
  ListeCategories?: ArrayOfChampListeValeurDtoInput;
  ListeChampsPersosBenef?: ArrayOfChampDtoInput;
  ListeContrats?: ArrayOfChampListeValeurDtoInput;
  ListeCriteresSociauxBoolean?: ArrayOfChampDtoInput;
  ListeCriteresSociauxCalcules?: ArrayOfChampDtoInput;
  ListeCriteresSociauxNonCalcules?: ArrayOfChampDtoInput;
  ListeCycles?: ArrayOfChampListeValeurDtoInput;
  ListeDroits?: ArrayOfChampListeValeurDtoInput;
  ListeMetiers?: ArrayOfChampListeValeurDtoInput;
  ListeMoyensCorrespondance?: ArrayOfChampListeValeurDtoInput;
  ListeOrganisations?: ArrayOfOrganisationDtoInput;
  ListeSexes?: ArrayOfChampListeValeurDtoInput;
  ListeSites?: ArrayOfSiteDtoInput;
  ListeSituationsFamiliale?: ArrayOfChampListeValeurDtoInput;
  ListeTitres?: ArrayOfChampListeValeurDtoInput;
  ListeTypesBenef?: ArrayOfTypeBenefDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type DossierEpargneFull = {
  __typename?: 'DossierEpargneFull';
  Dossier?: DossierEpargneModel;
  EnteteDossier?: EnteteEpargneModel;
  IdCompte?: number;
  ListeMouvements?: ArrayOfMouvementsMouvementEpargne;
  MontantDossier?: MontantDossierEpargneModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StatutDossier?: StatutDossierEpargneModel;
  UserEtDateCreationModification?: UserEtDateCreationModificationCommandeModel;
};

export type DossierEpargneFullInput = {
  Dossier?: DossierEpargneModelInput;
  EnteteDossier?: EnteteEpargneModelInput;
  IdCompte?: number;
  ListeMouvements?: ArrayOfMouvementsMouvementEpargneInput;
  MontantDossier?: MontantDossierEpargneModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StatutDossier?: StatutDossierEpargneModelInput;
  UserEtDateCreationModification?: UserEtDateCreationModificationCommandeModelInput;
};

export type DossierEpargneListerModel = {
  __typename?: 'DossierEpargneListerModel';
  AReglerSurCommandeGeneree?: number;
  CodeStatutAdministratif?: string;
  CommentairePrive?: string;
  CommentairePublic?: string;
  CouleurStatut?: string;
  DateDossier?: any;
  DateProchaineEcheance?: any;
  HasArticleAssocie?: boolean;
  HasEcheancesRemisEnBanque?: boolean;
  IdCommandeGeneree?: number;
  IdDossier?: number;
  IdModeleEcheancier?: number;
  IdModeleEpargne?: number;
  IdStatutPerso?: number;
  IsAllEcheancesRemisEnBanque?: boolean;
  IsDossierTermineAvantTerme?: boolean;
  LibelleCommandeGeneree?: string;
  LibelleModeleEcheancier?: string;
  LibelleModeleEpargne?: string;
  LibelleStatut?: string;
  MatriculeBenef?: string;
  MontantDossier?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomPrenomBenef?: string;
  NombreEcheance?: number;
  NombreEcheancePasse?: number;
  Status?: StatusDtoEnum;
  TotalDejaAbonde?: number;
  TotalDejaEpargne?: number;
};

export type DossierEpargneListerModelInput = {
  AReglerSurCommandeGeneree?: number;
  CodeStatutAdministratif?: string;
  CommentairePrive?: string;
  CommentairePublic?: string;
  CouleurStatut?: string;
  DateDossier?: any;
  DateProchaineEcheance?: any;
  HasArticleAssocie?: boolean;
  HasEcheancesRemisEnBanque?: boolean;
  IdCommandeGeneree?: number;
  IdDossier?: number;
  IdModeleEcheancier?: number;
  IdModeleEpargne?: number;
  IdStatutPerso?: number;
  IsAllEcheancesRemisEnBanque?: boolean;
  IsDossierTermineAvantTerme?: boolean;
  LibelleCommandeGeneree?: string;
  LibelleModeleEcheancier?: string;
  LibelleModeleEpargne?: string;
  LibelleStatut?: string;
  MatriculeBenef?: string;
  MontantDossier?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomPrenomBenef?: string;
  NombreEcheance?: number;
  NombreEcheancePasse?: number;
  Status?: StatusDtoEnum;
  TotalDejaAbonde?: number;
  TotalDejaEpargne?: number;
};

export type DossierEpargneModel = {
  __typename?: 'DossierEpargneModel';
  CommentairePrive?: string;
  CommentairePublic?: string;
  HaveEcheancierGenere?: boolean;
  IdActiviteCommandeGeneree?: number;
  IdArticle?: number;
  IdArticleAssocie?: number;
  IdCommandeGeneree?: number;
  IdDossier?: number;
  IdFactureGeneree?: number;
  IdFormulaireCdeArticleAssocie?: number;
  IdFormulaireLigneCdeArticleAssocie?: number;
  IdLigneDossier?: number;
  IsAbondementAChaqueEcheance?: boolean;
  IsClotureAvantTerme?: boolean;
  IsEpargneAChaqueEcheance?: boolean;
  IsMontantFixe?: boolean;
  IsReglementComptant?: boolean;
  IsReglementFactureGeneree?: boolean;
  IsTermine?: boolean;
  LibelleArticleAssocie?: string;
  LibelleProduit?: string;
  MontantAbondement?: number;
  MontantEpargne?: number;
  MontantMaximunArticle?: number;
  MontantMinimunOrFixeArticle?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbArticle?: number;
  Status?: StatusDtoEnum;
  ValeurFacialeArticleAssocie?: number;
};

export type DossierEpargneModelInput = {
  CommentairePrive?: string;
  CommentairePublic?: string;
  HaveEcheancierGenere?: boolean;
  IdActiviteCommandeGeneree?: number;
  IdArticle?: number;
  IdArticleAssocie?: number;
  IdCommandeGeneree?: number;
  IdDossier?: number;
  IdFactureGeneree?: number;
  IdFormulaireCdeArticleAssocie?: number;
  IdFormulaireLigneCdeArticleAssocie?: number;
  IdLigneDossier?: number;
  IsAbondementAChaqueEcheance?: boolean;
  IsClotureAvantTerme?: boolean;
  IsEpargneAChaqueEcheance?: boolean;
  IsMontantFixe?: boolean;
  IsReglementComptant?: boolean;
  IsReglementFactureGeneree?: boolean;
  IsTermine?: boolean;
  LibelleArticleAssocie?: string;
  LibelleProduit?: string;
  MontantAbondement?: number;
  MontantEpargne?: number;
  MontantMaximunArticle?: number;
  MontantMinimunOrFixeArticle?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbArticle?: number;
  Status?: StatusDtoEnum;
  ValeurFacialeArticleAssocie?: number;
};

export type DossierPrestationAnnulerTransformationCommandeModelInput = {
  DateAnnulation?: any;
  IdDossier?: number;
};

export type DossierPrestationBasePieceJustificativeModelDtoInput = {
  Id?: number;
  IdBeneficiaire?: number;
  IdLien?: number;
  IdPieceJustificative?: number;
  IsTypeBenef?: boolean;
  IsTypeDossierPresta?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type DossierPrestationChangerStatutLigneCommandePrestaModelInput = {
  CodeModeLivraison?: string;
  CodeStatut?: string;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  Quantite?: number;
};

export type DossierPrestationChangerStatutLigneCommandePrestaRetourPopupModelInput = {
  CodeModeLivraison?: string;
  CodeStatut?: string;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdUtilisateur?: number;
  ListeSubventionsAccordees?: ArrayOfanyTypeInput;
  MontantUnitaireSubventionne?: number;
  Quantite?: number;
};

export type DossierPrestationCreationDossierPrestationModelDtoInput = {
  DateDossier?: any;
  IdActivite?: number;
  IdCaisse?: number;
  IdDelegation?: number;
  IdFournisseur?: number;
  IdOuvrantDroit?: number;
  IdPointDeVente?: number;
  IdPrestation?: number;
  TypeDossier?: string;
};

export type DossierPrestationCriteresPjModelInput = {
  AnalysableIa?: boolean;
  CodePieceJustificativeContains?: string;
  ComparaisonDateAnalyseIa?: string;
  ComparaisonDateEnvoie?: string;
  ComparaisonDateReception?: string;
  DateDebutAnalyseIa?: any;
  DateDebutEnvoie?: any;
  DateDebutReception?: any;
  DateFinAnalyseIa?: any;
  DateFinEnvoie?: any;
  DateFinReception?: any;
  HasFileLink?: boolean;
  Id?: number;
  IdActivite?: number;
  IdArticle?: number;
  IdAyantDroit?: number;
  IdBenef?: number;
  IdDelegationConnecte?: number;
  IdDevisCde?: number;
  IdLigneCommandeOrNull?: number;
  IdPieceJustificative?: number;
  IdPieceJustificativeBeneficiaire?: number;
  IdRib?: number;
  IsADPjClos?: boolean;
  IsBenefDelegationDroitActif?: boolean;
  IsClos?: boolean;
  IsNotAnnuleDevis?: boolean;
  IsNotAnnuleeLigneCommande?: boolean;
  IsNotRefuseDevis?: boolean;
  IsNotRefuseLigneCommande?: boolean;
  IsPJDossierRenseignee?: boolean;
  IsReceptionnee?: boolean;
  IsTakePJBenefUniquement?: boolean;
  IsTakePJDossierUniquement?: boolean;
  ListIdBenef?: ArrayOfdecimalInput;
  ListeCodeTypePj?: ArrayOfstringInput;
  ListeIdAd?: ArrayOfdecimalInput;
  ListeIdBenef?: ArrayOfdecimalInput;
  ListeIdRib?: ArrayOfdecimalInput;
  ListeStatut?: ArrayOfstringInput;
  ListeStatutDossierInverse?: ArrayOfstringInput;
  ListeStatutIa?: ArrayOfstringInput;
  ListeTypeAnalyseIaId?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  NotListCdeStatusCodes?: ArrayOfstringInput;
  NotListeCodeTypePj?: ArrayOfstringInput;
  SkipCount?: boolean;
  Status?: StatusDtoEnum;
  TexteRecherche?: string;
  TypeAnalyseIaId?: number;
  ValidatedBy?: string;
};

export type DossierPrestationDossierPrestationModelDto = {
  __typename?: 'DossierPrestationDossierPrestationModelDTO';
  CodeStatutDossier?: string;
  EnteteDossierPresta?: DossierPrestationEnteteDossierPrestationModelDto;
  Id?: number;
  IsValidationChrono?: boolean;
  ListeLignes?: ArrayOfDossierPrestationLigneDossierPrestationModelDto;
  ListePiecesJustificatives?: ArrayOfDossierPrestationPieceJustificativeModelDto;
  MontantsDossierPresta?: DossierPrestationMontantsDossierPrestationModelDto;
  TypeDocumentPresenteDefaut?: string;
};

export type DossierPrestationDossierPrestationModelDtoInput = {
  CodeStatutDossier?: string;
  EnteteDossierPresta?: DossierPrestationEnteteDossierPrestationModelDtoInput;
  Id?: number;
  IsValidationChrono?: boolean;
  ListeLignes?: ArrayOfDossierPrestationLigneDossierPrestationModelDtoInput;
  ListePiecesJustificatives?: ArrayOfDossierPrestationPieceJustificativeModelDtoInput;
  MontantsDossierPresta?: DossierPrestationMontantsDossierPrestationModelDtoInput;
  TypeDocumentPresenteDefaut?: string;
};

export type DossierPrestationEditerLigneCommandeBaseModelDto = {
  __typename?: 'DossierPrestationEditerLigneCommandeBaseModelDTO';
  CodeModeLivraison?: string;
  Formulaire?: any;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  ListeSubventionsAccordees?: ArrayOfanyType;
  Montant?: number;
  Quantite?: number;
};

export type DossierPrestationEditerLigneCommandeBaseModelDtoInput = {
  CodeModeLivraison?: string;
  Formulaire?: any;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  ListeSubventionsAccordees?: ArrayOfanyTypeInput;
  Montant?: number;
  Quantite?: number;
};

export type DossierPrestationEditerLigneDossierPrestationModelDto = {
  __typename?: 'DossierPrestationEditerLigneDossierPrestationModelDTO';
  AnneeReferenceRmbMensuel?: number;
  CodeModeLivraison?: string;
  DateDebutActivite?: any;
  DateDocument?: any;
  DateFinActivite?: any;
  Formulaire?: any;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdUtilisateur?: number;
  IsAccepte?: boolean;
  LibelleLignecommande?: string;
  ListeClesRepartition?: ArrayOfSectionAnalytiqueLigneCommandeModelDto;
  ListeIdParticipants?: ArrayOfdecimal;
  ListeSubventionsAccordees?: ArrayOfanyType;
  MoisReferenceRmbMensuel?: number;
  Montant?: number;
  MontantFacturePresente?: number;
  MontantFacturePrisEnCompte?: number;
  MontantRembourse?: number;
  Quantite?: number;
  QuantitePresente?: number;
  QuantitePrisEnCompte?: number;
  ReferenceFacture?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  TypeDocumentPresente?: string;
};

export type DossierPrestationEditerLigneDossierPrestationModelDtoInput = {
  AnneeReferenceRmbMensuel?: number;
  CodeModeLivraison?: string;
  DateDebutActivite?: any;
  DateDocument?: any;
  DateFinActivite?: any;
  Formulaire?: any;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdUtilisateur?: number;
  IsAccepte?: boolean;
  LibelleLignecommande?: string;
  ListeClesRepartition?: ArrayOfSectionAnalytiqueLigneCommandeModelDtoInput;
  ListeIdParticipants?: ArrayOfdecimalInput;
  ListeSubventionsAccordees?: ArrayOfanyTypeInput;
  MoisReferenceRmbMensuel?: number;
  Montant?: number;
  MontantFacturePresente?: number;
  MontantFacturePrisEnCompte?: number;
  MontantRembourse?: number;
  Quantite?: number;
  QuantitePresente?: number;
  QuantitePrisEnCompte?: number;
  ReferenceFacture?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  TypeDocumentPresente?: string;
};

export type DossierPrestationEnteteDossierPrestationModelDto = {
  __typename?: 'DossierPrestationEnteteDossierPrestationModelDTO';
  CommentairePrive?: string;
  CommentairePublic?: string;
  CouleurStatutPerso?: string;
  CreerPar?: string;
  DateCreation?: any;
  DateDerniereModif?: any;
  DateDossier?: any;
  DateRemboursement?: any;
  DerniereModifPar?: string;
  Fournisseur?: string;
  HaveFormulaire?: boolean;
  IdDossier?: number;
  IdFournisseur?: number;
  IdOuvrantDroit?: number;
  IdPrestation?: number;
  IdStatutAdm?: number;
  IdStatutPerso?: number;
  IsTransfertAnnule?: boolean;
  LibelleStatutPerso?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OuvrantDroit?: string;
  Prestation?: string;
  RefDossier?: string;
  Status?: StatusDtoEnum;
  StatutDossier?: string;
  TypeDocumentPresente?: string;
  TypeDossier?: string;
};

export type DossierPrestationEnteteDossierPrestationModelDtoInput = {
  CommentairePrive?: string;
  CommentairePublic?: string;
  CouleurStatutPerso?: string;
  CreerPar?: string;
  DateCreation?: any;
  DateDerniereModif?: any;
  DateDossier?: any;
  DateRemboursement?: any;
  DerniereModifPar?: string;
  Fournisseur?: string;
  HaveFormulaire?: boolean;
  IdDossier?: number;
  IdFournisseur?: number;
  IdOuvrantDroit?: number;
  IdPrestation?: number;
  IdStatutAdm?: number;
  IdStatutPerso?: number;
  IsTransfertAnnule?: boolean;
  LibelleStatutPerso?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OuvrantDroit?: string;
  Prestation?: string;
  RefDossier?: string;
  Status?: StatusDtoEnum;
  StatutDossier?: string;
  TypeDocumentPresente?: string;
  TypeDossier?: string;
};

export type DossierPrestationInfosPjBaseModelDto = {
  __typename?: 'DossierPrestationInfosPJBaseModelDTO';
  IdPieceJustificative?: number;
  LibellePJ?: string;
};

export type DossierPrestationInfosPjBaseModelDtoInput = {
  IdPieceJustificative?: number;
  LibellePJ?: string;
};

export type DossierPrestationInitInfosRecherchePjModelDto = {
  __typename?: 'DossierPrestationInitInfosRecherchePJModelDTO';
  ListeActiviteModel?: ArrayOfActiviteBaseModel;
  ListeTypePJ?: ArrayOfDossierPrestationInfosPjBaseModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type DossierPrestationInitInfosRecherchePjModelDtoInput = {
  ListeActiviteModel?: ArrayOfActiviteBaseModelInput;
  ListeTypePJ?: ArrayOfDossierPrestationInfosPjBaseModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type DossierPrestationLigneDossierPrestationModelDto = {
  __typename?: 'DossierPrestationLigneDossierPrestationModelDTO';
  Cadeaux?: string;
  DateDebutActivite?: any;
  DateDocument?: any;
  DateFinActivite?: any;
  HaveFormulaire?: boolean;
  Id?: number;
  IdBenef?: number;
  IdFormule?: number;
  IsCreditEnveloppeKalidea?: boolean;
  IsFormuleSaisieParticipants?: boolean;
  LibelleFormule?: string;
  ListeIdParticipants?: ArrayOfdecimal;
  MontantFacturePresente?: number;
  MontantFacturePrisEnCompte?: number;
  MontantRembourse?: number;
  MontantRestantACharge?: number;
  MontantSubventionne?: number;
  NomPrenomBenefCible?: string;
  NomPrenomListeParticipants?: ArrayOfstring;
  QuantitePresente?: number;
  QuantitePrisEnCompte?: number;
  QuantiteRembourse?: number;
  QuantiteSubventionne?: number;
  ReferenceFacture?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Statut?: string;
  TypeDocumentPresente?: string;
};

export type DossierPrestationLigneDossierPrestationModelDtoInput = {
  Cadeaux?: string;
  DateDebutActivite?: any;
  DateDocument?: any;
  DateFinActivite?: any;
  HaveFormulaire?: boolean;
  Id?: number;
  IdBenef?: number;
  IdFormule?: number;
  IsCreditEnveloppeKalidea?: boolean;
  IsFormuleSaisieParticipants?: boolean;
  LibelleFormule?: string;
  ListeIdParticipants?: ArrayOfdecimalInput;
  MontantFacturePresente?: number;
  MontantFacturePrisEnCompte?: number;
  MontantRembourse?: number;
  MontantRestantACharge?: number;
  MontantSubventionne?: number;
  NomPrenomBenefCible?: string;
  NomPrenomListeParticipants?: ArrayOfstringInput;
  QuantitePresente?: number;
  QuantitePrisEnCompte?: number;
  QuantiteRembourse?: number;
  QuantiteSubventionne?: number;
  ReferenceFacture?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Statut?: string;
  TypeDocumentPresente?: string;
};

export type DossierPrestationMessagesAnnulationTransfertEnCommandeModel = {
  __typename?: 'DossierPrestationMessagesAnnulationTransfertEnCommandeModel';
  FactureBenefHaveReglement?: boolean;
  FactureFournisseurHaveReglement?: boolean;
  IdCommandeBenef?: number;
  IdCommandeFournisseur?: number;
  IdDossier?: number;
  IsDossierPAC?: boolean;
  MessageSuppressionEcritureImpossible?: string;
  NumeroFactureBenef?: string;
  NumeroFactureFournisseur?: string;
};

export type DossierPrestationMessagesAnnulationTransfertEnCommandeModelInput = {
  FactureBenefHaveReglement?: boolean;
  FactureFournisseurHaveReglement?: boolean;
  IdCommandeBenef?: number;
  IdCommandeFournisseur?: number;
  IdDossier?: number;
  IsDossierPAC?: boolean;
  MessageSuppressionEcritureImpossible?: string;
  NumeroFactureBenef?: string;
  NumeroFactureFournisseur?: string;
};

export type DossierPrestationModelDto = {
  __typename?: 'DossierPrestationModelDTO';
  CodeStatut?: string;
  DateRefSub?: any;
  DateSaisie?: any;
  IdActivite?: number;
  IdBenef?: number;
  IdDossierPrestation?: number;
  IdFournisseur?: number;
  IdPrestation?: number;
  IdStatut?: number;
  IsSaisieEnCours?: boolean;
  MontantTotalPresente?: number;
  MontantTotalPrisEnCompte?: number;
  MontantTotalRembAcc?: number;
  MontantTotalRembTheo?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
  TextBenefNom?: string;
  TextBenefPrenom?: string;
  TextFournisseur?: string;
  TextPrestation?: string;
  TextStatut?: string;
};

export type DossierPrestationModelDtoInput = {
  CodeStatut?: string;
  DateRefSub?: any;
  DateSaisie?: any;
  IdActivite?: number;
  IdBenef?: number;
  IdDossierPrestation?: number;
  IdFournisseur?: number;
  IdPrestation?: number;
  IdStatut?: number;
  IsSaisieEnCours?: boolean;
  MontantTotalPresente?: number;
  MontantTotalPrisEnCompte?: number;
  MontantTotalRembAcc?: number;
  MontantTotalRembTheo?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
  TextBenefNom?: string;
  TextBenefPrenom?: string;
  TextFournisseur?: string;
  TextPrestation?: string;
  TextStatut?: string;
};

export type DossierPrestationMontantsDossierPrestationModelDto = {
  __typename?: 'DossierPrestationMontantsDossierPrestationModelDTO';
  MontantBenefCharge?: number;
  MontantBenefEnCaisse?: number;
  MontantBenefRemisEnBanque?: number;
  MontantBenefResteAEncaisse?: number;
  MontantBeneficiaire?: number;
  MontantBeneficiaireDejaVerse?: number;
  MontantBeneficiaireRemisEnBanque?: number;
  MontantBeneficiaireVerse?: number;
  MontantCadeauxBeneficiaire?: number;
  MontantCrediteKalidea?: number;
  MontantDossierPresente?: number;
  MontantFournisseur?: number;
  MontantFournisseurDejaVerse?: number;
  MontantFournisseurRemisEnBanque?: number;
  MontantFournisseurVerse?: number;
  MontantPrisEnCompte?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type DossierPrestationMontantsDossierPrestationModelDtoInput = {
  MontantBenefCharge?: number;
  MontantBenefEnCaisse?: number;
  MontantBenefRemisEnBanque?: number;
  MontantBenefResteAEncaisse?: number;
  MontantBeneficiaire?: number;
  MontantBeneficiaireDejaVerse?: number;
  MontantBeneficiaireRemisEnBanque?: number;
  MontantBeneficiaireVerse?: number;
  MontantCadeauxBeneficiaire?: number;
  MontantCrediteKalidea?: number;
  MontantDossierPresente?: number;
  MontantFournisseur?: number;
  MontantFournisseurDejaVerse?: number;
  MontantFournisseurRemisEnBanque?: number;
  MontantFournisseurVerse?: number;
  MontantPrisEnCompte?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type DossierPrestationPieceJustificativeForRechercheModelDto = {
  __typename?: 'DossierPrestationPieceJustificativeForRechercheModelDTO';
  AnalysableIA?: boolean;
  DateEnvoie?: any;
  DateReception?: any;
  IaDateAnalysis?: any;
  IaIsValid?: boolean;
  IaMotif?: string;
  IaStatus?: string;
  Id?: number;
  IdActivite?: number;
  IdBenefAd?: number;
  IdBeneficiaire?: number;
  IdDossier?: number;
  IdLien?: number;
  IdLigneDossier?: number;
  IdPieceJustificative?: number;
  IsObligatoire?: boolean;
  IsPJAvecFichier?: boolean;
  IsTypeBenef?: boolean;
  IsTypeDossierPresta?: boolean;
  LibelleActivite?: string;
  ListeIdDossier?: ArrayOfdecimal;
  ListeLibelleActivite?: ArrayOfstring;
  Matricule?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBeneficiaire?: string;
  NomFichier?: string;
  NomValideur?: string;
  PrenomBenefAD?: string;
  PrenomBeneficiaire?: string;
  PrenomValideur?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
  TypePJLib?: string;
};

export type DossierPrestationPieceJustificativeForRechercheModelDtoInput = {
  AnalysableIA?: boolean;
  DateEnvoie?: any;
  DateReception?: any;
  IaDateAnalysis?: any;
  IaIsValid?: boolean;
  IaMotif?: string;
  IaStatus?: string;
  Id?: number;
  IdActivite?: number;
  IdBenefAd?: number;
  IdBeneficiaire?: number;
  IdDossier?: number;
  IdLien?: number;
  IdLigneDossier?: number;
  IdPieceJustificative?: number;
  IsObligatoire?: boolean;
  IsPJAvecFichier?: boolean;
  IsTypeBenef?: boolean;
  IsTypeDossierPresta?: boolean;
  LibelleActivite?: string;
  ListeIdDossier?: ArrayOfdecimalInput;
  ListeLibelleActivite?: ArrayOfstringInput;
  Matricule?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBeneficiaire?: string;
  NomFichier?: string;
  NomValideur?: string;
  PrenomBenefAD?: string;
  PrenomBeneficiaire?: string;
  PrenomValideur?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
  TypePJLib?: string;
};

export type DossierPrestationPieceJustificativeForWidgetModelDto = {
  __typename?: 'DossierPrestationPieceJustificativeForWidgetModelDTO';
  DateEnvoie?: any;
  Id?: number;
  IdBeneficiaire?: number;
  IdPieceJustificative?: number;
  IsPJAvecFichier?: boolean;
  IsTypeBenef?: boolean;
  IsTypeDossierPresta?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBeneficiaire?: string;
  NomPieceJustificative?: string;
  PrenomBeneficiaire?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type DossierPrestationPieceJustificativeForWidgetModelDtoInput = {
  DateEnvoie?: any;
  Id?: number;
  IdBeneficiaire?: number;
  IdPieceJustificative?: number;
  IsPJAvecFichier?: boolean;
  IsTypeBenef?: boolean;
  IsTypeDossierPresta?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBeneficiaire?: string;
  NomPieceJustificative?: string;
  PrenomBeneficiaire?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type DossierPrestationPieceJustificativeModelDto = {
  __typename?: 'DossierPrestationPieceJustificativeModelDTO';
  AnalysableIA?: boolean;
  DateEnvoie?: any;
  DateReception?: any;
  IaDateAnalysis?: any;
  IaIsValid?: boolean;
  IaMotif?: string;
  IaStatus?: string;
  Id?: number;
  IdBenefAd?: number;
  IdLien?: number;
  IdLigneDossier?: number;
  IdPieceJustificative?: number;
  IsObligatoire?: boolean;
  IsPJAvecFichier?: boolean;
  IsTypeBenef?: boolean;
  IsTypeDossierPresta?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomFichier?: string;
  NomValideur?: string;
  PrenomBenefAD?: string;
  PrenomValideur?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
  TypePJLib?: string;
};

export type DossierPrestationPieceJustificativeModelDtoInput = {
  AnalysableIA?: boolean;
  DateEnvoie?: any;
  DateReception?: any;
  IaDateAnalysis?: any;
  IaIsValid?: boolean;
  IaMotif?: string;
  IaStatus?: string;
  Id?: number;
  IdBenefAd?: number;
  IdLien?: number;
  IdLigneDossier?: number;
  IdPieceJustificative?: number;
  IsObligatoire?: boolean;
  IsPJAvecFichier?: boolean;
  IsTypeBenef?: boolean;
  IsTypeDossierPresta?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomFichier?: string;
  NomValideur?: string;
  PrenomBenefAD?: string;
  PrenomValideur?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
  TypePJLib?: string;
};

export type DossierPrestationRemarquesPieceJustificativeModelDtoInput = {
  Id?: number;
  IdAyantDroit?: number;
  IdBeneficiaire?: number;
  IdPieceJustificative?: number;
  IsTypeBenef?: boolean;
  IsTypeDossierPresta?: boolean;
  RemarquePrivee?: string;
  RemarquePublique?: string;
};

export type DossierPrestationRetourEnregistrementLigneDossierPrestationModelDto = {
  __typename?: 'DossierPrestationRetourEnregistrementLigneDossierPrestationModelDTO';
  LigneDossierPrestation?: DossierPrestationLigneDossierPrestationModelDto;
  RetourMoteur?: any;
  TypeErreurAjoutLigne?: AjouterLigneCdeRetourStockEnum;
};

export type DossierPrestationRetourEnregistrementLigneDossierPrestationModelDtoInput = {
  LigneDossierPrestation?: DossierPrestationLigneDossierPrestationModelDtoInput;
  RetourMoteur?: any;
  TypeErreurAjoutLigne?: AjouterLigneCdeRetourStockEnum;
};

export type DossierPrestationValiderPieceJustificativeModelDtoInput = {
  Id?: number;
  IdBeneficiaire?: number;
  IdPieceJustificative?: number;
  IdUtilisateur?: number;
  IsTypeBenef?: boolean;
  IsTypeDossierPresta?: boolean;
};

export type DossierPretsEtDonsBaseModelInput = {
  Commentaire?: string;
  Formulaire?: SoumissionFormulaireModelInput;
  IdArticle?: number;
  IdDossier?: number;
  IdLigneDossier?: number;
  IsMontantFixe?: boolean;
  LibelleArticle?: string;
  MontantDossier?: number;
  MontantMaximunArticle?: number;
  MontantMinimunOrFixeArticle?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type DossierPretsEtDonsDonModel = {
  __typename?: 'DossierPretsEtDonsDonModel';
  Commentaire?: string;
  Formulaire?: SoumissionFormulaireModel;
  IdArticle?: number;
  IdDossier?: number;
  IdLigneDossier?: number;
  IsMontantFixe?: boolean;
  LibelleArticle?: string;
  MontantDossier?: number;
  MontantMaximunArticle?: number;
  MontantMinimunOrFixeArticle?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type DossierPretsEtDonsDonModelInput = {
  Commentaire?: string;
  Formulaire?: SoumissionFormulaireModelInput;
  IdArticle?: number;
  IdDossier?: number;
  IdLigneDossier?: number;
  IsMontantFixe?: boolean;
  LibelleArticle?: string;
  MontantDossier?: number;
  MontantMaximunArticle?: number;
  MontantMinimunOrFixeArticle?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type DossierPretsEtDonsFull = {
  __typename?: 'DossierPretsEtDonsFull';
  Dossier?: Union_13510198731919550967;
  EnteteDossier?: EnteteDossierPretsEtDonsModel;
  HaveEcheancierGenere?: boolean;
  HaveLigneDossier?: boolean;
  HaveRemboursementAnticipeOrTransformationDonGenerer?: boolean;
  IsRegleBeneficiaire?: boolean;
  ListePiecesJustificatives?: ArrayOfDossierPrestationPieceJustificativeModelDto;
  ListeReglement?: ArrayOfReglementPretsEtDonsListerModel;
  ListeRemboursement?: ArrayOfRemboursementPretsEtDonsListerModel;
  MontantDossier?: MontantDossierPretsEtDonsModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StatutDossier?: StatutDossierPretsEtDonsModel;
  UserEtDateCreationModification?: UserEtDateCreationModificationCommandeModel;
};

export type DossierPretsEtDonsFullInput = {
  Dossier?: DossierPretsEtDonsBaseModelInput;
  EnteteDossier?: EnteteDossierPretsEtDonsModelInput;
  HaveEcheancierGenere?: boolean;
  HaveLigneDossier?: boolean;
  HaveRemboursementAnticipeOrTransformationDonGenerer?: boolean;
  IsRegleBeneficiaire?: boolean;
  ListePiecesJustificatives?: ArrayOfDossierPrestationPieceJustificativeModelDtoInput;
  ListeReglement?: ArrayOfReglementPretsEtDonsListerModelInput;
  ListeRemboursement?: ArrayOfRemboursementPretsEtDonsListerModelInput;
  MontantDossier?: MontantDossierPretsEtDonsModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StatutDossier?: StatutDossierPretsEtDonsModelInput;
  UserEtDateCreationModification?: UserEtDateCreationModificationCommandeModelInput;
};

export type DossierPretsEtDonsPretModel = {
  __typename?: 'DossierPretsEtDonsPretModel';
  Commentaire?: string;
  DateDerniereEcheance?: any;
  DatePremiereEcheance?: any;
  DureeDossier?: number;
  DureeMaximun?: number;
  DureeMinimunOrFixe?: number;
  Formulaire?: SoumissionFormulaireModel;
  IdArticle?: number;
  IdAssuranceChpListVal?: number;
  IdDossier?: number;
  IdLigneDossier?: number;
  IsDureeFixe?: boolean;
  IsMontantFixe?: boolean;
  IsPourcentage?: boolean;
  IsSurPremiereEcheance?: boolean;
  LibelleArticle?: string;
  MontantDossier?: number;
  MontantFraisDossier?: number;
  MontantInitial?: number;
  MontantMaximunArticle?: number;
  MontantMinimunOrFixeArticle?: number;
  MontantPourcentageFraisDossier?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  PourcentageFraisDossier?: number;
  Status?: StatusDtoEnum;
};

export type DossierPretsEtDonsPretModelInput = {
  Commentaire?: string;
  DateDerniereEcheance?: any;
  DatePremiereEcheance?: any;
  DureeDossier?: number;
  DureeMaximun?: number;
  DureeMinimunOrFixe?: number;
  Formulaire?: SoumissionFormulaireModelInput;
  IdArticle?: number;
  IdAssuranceChpListVal?: number;
  IdDossier?: number;
  IdLigneDossier?: number;
  IsDureeFixe?: boolean;
  IsMontantFixe?: boolean;
  IsPourcentage?: boolean;
  IsSurPremiereEcheance?: boolean;
  LibelleArticle?: string;
  MontantDossier?: number;
  MontantFraisDossier?: number;
  MontantInitial?: number;
  MontantMaximunArticle?: number;
  MontantMinimunOrFixeArticle?: number;
  MontantPourcentageFraisDossier?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  PourcentageFraisDossier?: number;
  Status?: StatusDtoEnum;
};

export type DroitPortailModel = {
  __typename?: 'DroitPortailModel';
  CodeDroitPortail?: string;
  IdDroitPortail?: number;
  LibelleDroitPortail?: string;
};

export type DroitPortailModelInput = {
  CodeDroitPortail?: string;
  IdDroitPortail?: number;
  LibelleDroitPortail?: string;
};

export type DuplicationFpaModelInput = {
  DupliquerArticleModel?: DupliquerArticleModelInput;
  DupliquerProduitModel?: DupliquerProduitModelInput;
  IdParentARattacher?: number;
};

export type DupliquerArticleModelInput = {
  DupliquerCadeauxParametresArticle?: boolean;
  DupliquerChampsPersonnels?: boolean;
  DupliquerChequiers?: boolean;
  DupliquerCompteursPoint?: boolean;
  DupliquerLocalisation?: boolean;
  DupliquerModesLivraison?: boolean;
  DupliquerPiecesJustificatives?: boolean;
  DupliquerPrixAchatCourant?: boolean;
  DupliquerPrixVenteCourant?: boolean;
  DupliquerRegles?: boolean;
  DupliquerStockReel?: boolean;
  IdArticle?: number;
  IdDeleg?: number;
  IdUtilisateur?: number;
  ModificationLibelleArticle?: boolean;
  ProvientDunElementDupplique?: boolean;
};

export type DupliquerProduitModelInput = {
  DupliquerArticleDuProduit?: boolean;
  DupliquerCadeauxParametresProduit?: boolean;
  DupliquerChampsPersonnelsProduit?: boolean;
  DupliquerCompteursPointProduit?: boolean;
  DupliquerDocumentsProduit?: boolean;
  DupliquerImputationsComptablesProduit?: boolean;
  DupliquerLocalisationProduit?: boolean;
  DupliquerModalitesReglement?: boolean;
  DupliquerModelesLocationProduit?: boolean;
  DupliquerModesLivraisonProduit?: boolean;
  DupliquerPiecesJustificativesProduit?: boolean;
  DupliquerReglesProduit?: boolean;
  IdDeleg?: number;
  IdProduit?: number;
  IdUtilisateur?: number;
};

export type EcheanceModelDto = {
  __typename?: 'EcheanceModelDTO';
  CodeTypeMoyenPaiement?: string;
  DateEcheance?: any;
  DateEcheanceMouvement?: any;
  DateRemisEnBnq?: any;
  Id?: number;
  IdCaisse?: number;
  IdCompteCollectif?: number;
  IdExercice?: number;
  IdJournal?: number;
  IsEnabled?: boolean;
  IsRemisEnBanque?: boolean;
  IsSelected?: boolean;
  LibelleEcheance?: string;
  MontantEcheance?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  NomTire?: string;
  NumeroCheque?: string;
  Status?: StatusDtoEnum;
};

export type EcheanceModelDtoInput = {
  CodeTypeMoyenPaiement?: string;
  DateEcheance?: any;
  DateEcheanceMouvement?: any;
  DateRemisEnBnq?: any;
  Id?: number;
  IdCaisse?: number;
  IdCompteCollectif?: number;
  IdExercice?: number;
  IdJournal?: number;
  IsEnabled?: boolean;
  IsRemisEnBanque?: boolean;
  IsSelected?: boolean;
  LibelleEcheance?: string;
  MontantEcheance?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  NomTire?: string;
  NumeroCheque?: string;
  Status?: StatusDtoEnum;
};

export type EcheancierDto = {
  __typename?: 'EcheancierDTO';
  Beneficiaire?: BenefDto;
  CompteBancaire?: CompteBancaireDto;
  DateCreation?: any;
  Id?: number;
  JourMois?: number;
  Libelle?: string;
  MontantTotal?: number;
  MoyenPaiement?: MoyenPaiementDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PeriodiciteMois?: number;
  Rib?: RibDto;
  Status?: StatusDtoEnum;
};

export type EcheancierDtoInput = {
  Beneficiaire?: BenefDtoInput;
  CompteBancaire?: CompteBancaireDtoInput;
  DateCreation?: any;
  Id?: number;
  JourMois?: number;
  Libelle?: string;
  MontantTotal?: number;
  MoyenPaiement?: MoyenPaiementDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PeriodiciteMois?: number;
  Rib?: RibDtoInput;
  Status?: StatusDtoEnum;
};

export type EcheancierModelDto = {
  __typename?: 'EcheancierModelDTO';
  CodeMoyenPaiement?: string;
  DateDebutEcheance?: any;
  DateDernierEcheance?: any;
  DatePremierEcheance?: any;
  DateProchaineEcheance?: any;
  Frequence?: number;
  Id?: number;
  IdBenef?: number;
  IdCompteBancaire?: number;
  IdDossierPretsEtDons?: number;
  IdMandat?: number;
  IdMoyenPaiement?: number;
  IdRib?: number;
  IsAutoriseModif?: boolean;
  JourEcheance?: number;
  LibelleBeneficiaire?: string;
  LibelleCptBnq?: string;
  LibelleEcheancier?: string;
  LibelleMoyenPaiement?: string;
  ListeEcheances?: ArrayOfEcheanceModelDto;
  MontantARegler?: number;
  MontantEcheance?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbEchRemisBnqSurNbEchTotal?: string;
  NbEcheance?: number;
  NbEcheanceCreation?: number;
  NbEcheanceRestante?: number;
  NomBanque?: string;
  NomTire?: string;
  NumeroCheque?: string;
  RestantAPayer?: number;
  Status?: StatusDtoEnum;
};

export type EcheancierModelDtoInput = {
  CodeMoyenPaiement?: string;
  DateDebutEcheance?: any;
  DateDernierEcheance?: any;
  DatePremierEcheance?: any;
  DateProchaineEcheance?: any;
  Frequence?: number;
  Id?: number;
  IdBenef?: number;
  IdCompteBancaire?: number;
  IdDossierPretsEtDons?: number;
  IdMandat?: number;
  IdMoyenPaiement?: number;
  IdRib?: number;
  IsAutoriseModif?: boolean;
  JourEcheance?: number;
  LibelleBeneficiaire?: string;
  LibelleCptBnq?: string;
  LibelleEcheancier?: string;
  LibelleMoyenPaiement?: string;
  ListeEcheances?: ArrayOfEcheanceModelDtoInput;
  MontantARegler?: number;
  MontantEcheance?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbEchRemisBnqSurNbEchTotal?: string;
  NbEcheance?: number;
  NbEcheanceCreation?: number;
  NbEcheanceRestante?: number;
  NomBanque?: string;
  NomTire?: string;
  NumeroCheque?: string;
  RestantAPayer?: number;
  Status?: StatusDtoEnum;
};

export type EcheancierModeleActiviteModel = {
  __typename?: 'EcheancierModeleActiviteModel';
  IdModeleEcheancier?: number;
  IsAfficheEnLigne?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EcheancierModeleActiviteModelInput = {
  IdModeleEcheancier?: number;
  IsAfficheEnLigne?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EcritureAnalytiqueEnErreurModel = {
  __typename?: 'EcritureAnalytiqueEnErreurModel';
  CodeJournal?: string;
  DateEcriture?: any;
  EcartTotal?: number;
  IdDelegation?: number;
  IdEcriture?: number;
  IsExerciceClos?: boolean;
  LibelleEcriture?: string;
  Mouvements?: ArrayOfMouvementAnalytiqueEnErreurModel;
  MustValidate?: boolean;
  MyGuid?: string;
  NomDelegation?: string;
  NumeroPiece?: string;
  Status?: StatusDtoEnum;
};

export type EcritureAnalytiqueEnErreurModelInput = {
  CodeJournal?: string;
  DateEcriture?: any;
  EcartTotal?: number;
  IdDelegation?: number;
  IdEcriture?: number;
  IsExerciceClos?: boolean;
  LibelleEcriture?: string;
  Mouvements?: ArrayOfMouvementAnalytiqueEnErreurModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NomDelegation?: string;
  NumeroPiece?: string;
  Status?: StatusDtoEnum;
};

export type EcritureBalanceOuvertureModel = {
  __typename?: 'EcritureBalanceOuvertureModel';
  CodeJournal?: string;
  DateEcriture?: any;
  IdEcriture?: number;
  LibelleEcriture?: string;
  Montant?: number;
  NumeroPiece?: string;
};

export type EcritureBalanceOuvertureModelInput = {
  CodeJournal?: string;
  DateEcriture?: any;
  IdEcriture?: number;
  LibelleEcriture?: string;
  Montant?: number;
  NumeroPiece?: string;
};

export type EcritureComptaModelDtoInput = {
  IdJournal?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroPiece?: string;
  Status?: StatusDtoEnum;
};

export type EcritureConsultationModel = {
  __typename?: 'EcritureConsultationModel';
  Compte511?: Compte511MouvementModel;
  InformationsEcriture?: InformationsEcritureConsultationModel;
  ListeMouvementsEcriture?: ArrayOfMouvementsMouvementConsultationModel;
  ListePJEcriture?: ArrayOfComptaPjComptablesModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EcritureConsultationModelInput = {
  Compte511?: Compte511MouvementModelInput;
  InformationsEcriture?: InformationsEcritureConsultationModelInput;
  ListeMouvementsEcriture?: ArrayOfMouvementsMouvementConsultationModelInput;
  ListePJEcriture?: ArrayOfComptaPjComptablesModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EcritureDebitCreditPmvModelInput = {
  DateEcriture?: any;
  DateRemiseEnBanque?: any;
  IdBenef?: number;
  IdCompteBancaire?: number;
  IdEcriture?: number;
  IdIban?: number;
  IdJournal?: number;
  IdMandat?: number;
  IdMoyenPaiement?: number;
  IdPMV?: number;
  IsDebit?: boolean;
  LibelleEcriture?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  NomTire?: string;
  NumCheque?: string;
  NumPiece?: string;
  Status?: StatusDtoEnum;
};

export type EcritureDesequilibreeModel = {
  __typename?: 'EcritureDesequilibreeModel';
  CodeJournal?: string;
  DateEcriture?: any;
  IdDelegation?: number;
  IdEcriture?: number;
  IsExerciceClos?: boolean;
  LibelleEcriture?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomDelegation?: string;
  NumeroPiece?: string;
  Status?: StatusDtoEnum;
  TotalCredit?: number;
  TotalDebit?: number;
};

export type EcritureDesequilibreeModelInput = {
  CodeJournal?: string;
  DateEcriture?: any;
  IdDelegation?: number;
  IdEcriture?: number;
  IsExerciceClos?: boolean;
  LibelleEcriture?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomDelegation?: string;
  NumeroPiece?: string;
  Status?: StatusDtoEnum;
  TotalCredit?: number;
  TotalDebit?: number;
};

export type EcritureEnregistrementEcritureBaseInput = {
  DateEcriture?: any;
  IdCECible?: number;
  IdCECreePar?: number;
  IdCESource?: number;
  IdCaisse?: number;
  IdEcriture?: number;
  IdJournal?: number;
  IdUtilisateur?: number;
  Libelle?: string;
  TypeEcriture?: TypeEcritureInput;
};

export type EcritureExportModel = {
  __typename?: 'EcritureExportModel';
  AExporter?: boolean;
  DateEcriture?: any;
  DateExport?: any;
  IdCECible?: number;
  IdDelegationOrigine?: number;
  IdEcriture?: number;
  IsExport?: boolean;
  IsSupprimee?: boolean;
  JournalCode?: string;
  Lettres?: ArrayOfstring;
  Libelle?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroPiece?: string;
  Reference?: string;
  RemarquePrivee?: string;
  RemarquePublic?: string;
  Status?: StatusDtoEnum;
  UserForExport?: string;
};

export type EcritureExportModelInput = {
  AExporter?: boolean;
  DateEcriture?: any;
  DateExport?: any;
  IdCECible?: number;
  IdDelegationOrigine?: number;
  IdEcriture?: number;
  IsExport?: boolean;
  IsSupprimee?: boolean;
  JournalCode?: string;
  Lettres?: ArrayOfstringInput;
  Libelle?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroPiece?: string;
  Reference?: string;
  RemarquePrivee?: string;
  RemarquePublic?: string;
  Status?: StatusDtoEnum;
  UserForExport?: string;
};

export type EcritureGenerationEcritureContrepassationModelInput = {
  DateEcriture?: any;
  IdBenef?: number;
  IdCECible?: number;
  IdCECreePar?: number;
  IdCESource?: number;
  IdCaisse?: number;
  IdEcriture?: number;
  IdEcritureContrepassee?: number;
  IdExercice?: number;
  IdJournal?: number;
  IdUtilisateur?: number;
  Libelle?: string;
  NumeroPiece?: string;
  Reference?: string;
  TypeEcriture?: TypeEcritureInput;
};

export type EcritureGenerationEcritureReglementModelInput = {
  DateEcriture?: any;
  IdBeneficiaire?: number;
  IdCECible?: number;
  IdCECreePar?: number;
  IdCESource?: number;
  IdCaisse?: number;
  IdCommande?: number;
  IdEcriture?: number;
  IdJournal?: number;
  IdMoyenPaiement?: number;
  IdUtilisateur?: number;
  IsManuel?: boolean;
  Libelle?: string;
  NumeroPiece?: string;
  TypeEcriture?: TypeEcritureInput;
};

export type EcritureListingModel = {
  __typename?: 'EcritureListingModel';
  DateEcriture?: any;
  IdCECible?: number;
  IdDelegationOrigine?: number;
  IdEcriture?: number;
  IsRapproche?: boolean;
  IsSimulation?: boolean;
  IsSupprimee?: boolean;
  JournalCode?: string;
  Lettres?: ArrayOfstring;
  Libelle?: string;
  ListeNumeroCheque?: ArrayOfstring;
  ListePJModel?: ArrayOfComptaPjComptableConsultationModel;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomCECreePar?: string;
  NomCESource?: string;
  NumeroPiece?: string;
  Reference?: string;
  RemarquePublic?: string;
  Status?: StatusDtoEnum;
};

export type EcritureListingModelInput = {
  DateEcriture?: any;
  IdCECible?: number;
  IdDelegationOrigine?: number;
  IdEcriture?: number;
  IsRapproche?: boolean;
  IsSimulation?: boolean;
  IsSupprimee?: boolean;
  JournalCode?: string;
  Lettres?: ArrayOfstringInput;
  Libelle?: string;
  ListeNumeroCheque?: ArrayOfstringInput;
  ListePJModel?: ArrayOfComptaPjComptableConsultationModelInput;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomCECreePar?: string;
  NomCESource?: string;
  NumeroPiece?: string;
  Reference?: string;
  RemarquePublic?: string;
  Status?: StatusDtoEnum;
};

export type EcritureTransactionBancairePoco = {
  __typename?: 'EcritureTransactionBancairePOCO';
  IdEcriture?: number;
  LibelleEcriture?: string;
  NumeroPiece?: string;
  NumeroTransaction?: string;
};

export type EcritureTransactionBancairePocoInput = {
  IdEcriture?: number;
  LibelleEcriture?: string;
  NumeroPiece?: string;
  NumeroTransaction?: string;
};

export type EcritureVerificationConformiteTva = {
  __typename?: 'EcritureVerificationConformiteTVA';
  CodeJournal?: string;
  DateEcriture?: any;
  IdEcriture?: number;
  LibelleEcriture?: string;
  LibelleModele?: string;
  MontantEcriture?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroPiece?: string;
  Probleme?: string;
  Status?: StatusDtoEnum;
};

export type EcritureVerificationConformiteTvaInput = {
  CodeJournal?: string;
  DateEcriture?: any;
  IdEcriture?: number;
  LibelleEcriture?: string;
  LibelleModele?: string;
  MontantEcriture?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroPiece?: string;
  Probleme?: string;
  Status?: StatusDtoEnum;
};

export type EditAlbumLightModel = {
  __typename?: 'EditAlbumLightModel';
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EditAlbumLightModelInput = {
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EditChequierAncv = {
  __typename?: 'EditChequierANCV';
  CompositionChequierDynamique?: ArrayOfanyType;
  CompositionChequierGenerique?: ArrayOfanyType;
  IdArticle?: number;
  IdModeEnvoiANCV?: number;
  IsModifiableCompositionChequier?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EditChequierAncvInput = {
  CompositionChequierDynamique?: ArrayOfanyTypeInput;
  CompositionChequierGenerique?: ArrayOfanyTypeInput;
  IdArticle?: number;
  IdModeEnvoiANCV?: number;
  IsModifiableCompositionChequier?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EditEcheancierModeleActiviteModel = {
  __typename?: 'EditEcheancierModeleActiviteModel';
  IdActivite?: number;
  IdMoyenPaiement?: number;
  IsReglementComptant?: boolean;
  ListeModeleEcheancierActivite?: ArrayOfEcheancierModeleActiviteModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EditEcheancierModeleActiviteModelInput = {
  IdActivite?: number;
  IdMoyenPaiement?: number;
  IsReglementComptant?: boolean;
  ListeModeleEcheancierActivite?: ArrayOfEcheancierModeleActiviteModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EditHistoriqueSalarieModelInput = {
  HistoCommandeVisible?: boolean;
  ListeIdEnveloppeAffichee?: ArrayOfdecimalInput;
  ListeIdPMVAffiches?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PointsMaximumVisible?: boolean;
  PointsMinimumVisible?: boolean;
  PointsMoyenneVisible?: boolean;
  PointsVisible?: boolean;
  SoldeEnveloppesVisible?: boolean;
  Status?: StatusDtoEnum;
  SubventionsVisible?: boolean;
};

export type EditerArticleMonEspaceCse = {
  __typename?: 'EditerArticleMonEspaceCSE';
  Contenu?: string;
  ContenuNotification?: string;
  DateDebut?: any;
  DateFin?: any;
  Description?: string;
  Id?: number;
  IdAuteur?: string;
  IdContent?: string;
  Illustration?: TupleOfstringstring;
  IllustrationFile?: FichierModel;
  IsPublie?: boolean;
  IsUne?: boolean;
  ListeDocument?: ArrayOfTupleOfstringstring;
  ListeDocumentLieFile?: ArrayOfFichierModel;
  ListeDocumentsToDelete?: ArrayOfstring;
  ListeTokensDocuments?: ArrayOfstring;
  MustValidate?: boolean;
  MyGuid?: string;
  SendNotification?: boolean;
  Status?: StatusDtoEnum;
  Statut?: string;
  Tags?: ArrayOfstring;
  Titre?: string;
  TitreNotification?: string;
  TokenIllustration?: string;
};

export type EditerArticleMonEspaceCseInput = {
  Contenu?: string;
  ContenuNotification?: string;
  DateDebut?: any;
  DateFin?: any;
  Description?: string;
  Id?: number;
  IdAuteur?: string;
  IdContent?: string;
  Illustration?: TupleOfstringstringInput;
  IllustrationFile?: FichierModelInput;
  IsPublie?: boolean;
  IsUne?: boolean;
  ListeDocument?: ArrayOfTupleOfstringstringInput;
  ListeDocumentLieFile?: ArrayOfFichierModelInput;
  ListeDocumentsToDelete?: ArrayOfstringInput;
  ListeTokensDocuments?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  SendNotification?: boolean;
  Status?: StatusDtoEnum;
  Statut?: string;
  Tags?: ArrayOfstringInput;
  Titre?: string;
  TitreNotification?: string;
  TokenIllustration?: string;
};

export type EditerArticleUpKonnectModel = {
  __typename?: 'EditerArticleUpKonnectModel';
  ArticleStatut?: ArticleUpKonnectStatutEnum;
  Corps?: string;
  CorpsNotification?: string;
  DateDebutPublication?: any;
  DateFinPublication?: any;
  Id?: string;
  IdAuteur?: string;
  IdOrganisation?: string;
  Illustration?: FichierModel;
  IsArticleEpingle?: boolean;
  ListeDocument?: ArrayOfFichierModel;
  ListeTags?: ArrayOfstring;
  MustValidate?: boolean;
  MyGuid?: string;
  PublishedAs?: TypeAuteurArticleUpKonnectEnum;
  SendNotification?: boolean;
  Status?: StatusDtoEnum;
  Titre?: string;
  TitreNotification?: string;
};

export type EditerArticleUpKonnectModelInput = {
  ArticleStatut?: ArticleUpKonnectStatutEnum;
  Corps?: string;
  CorpsNotification?: string;
  DateDebutPublication?: any;
  DateFinPublication?: any;
  Id?: string;
  IdAuteur?: string;
  IdOrganisation?: string;
  Illustration?: FichierModelInput;
  IsArticleEpingle?: boolean;
  ListeDocument?: ArrayOfFichierModelInput;
  ListeTags?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PublishedAs?: TypeAuteurArticleUpKonnectEnum;
  SendNotification?: boolean;
  Status?: StatusDtoEnum;
  Titre?: string;
  TitreNotification?: string;
};

export type EditerAttributionAutoModelInput = {
  AcceptationConflit?: string;
  CodeStatutAccepte?: string;
  CodeStatutRefuse?: string;
  DateDebutCalculPoint1?: any;
  DateDebutCalculPoint2?: any;
  DateDebutCalculPoint3?: any;
  DateDebutCalculPoint4?: any;
  DateFinCalculPoint1?: any;
  DateFinCalculPoint2?: any;
  DateFinCalculPoint3?: any;
  DateFinCalculPoint4?: any;
  DateReservationMax?: any;
  IdActivite?: number;
  IdAnneeRef?: number;
  IdAttribution?: number;
  IdCptPoint1?: number;
  IdCptPoint2?: number;
  IdCptPoint3?: number;
  IdCptPoint4?: number;
  IdCritereTri1?: number;
  IdCritereTri2?: number;
  IdCritereTri3?: number;
  IdCritereTri4?: number;
  IdEnvelope1?: number;
  IdEnvelope2?: number;
  IdEnvelope3?: number;
  IdEnvelope4?: number;
  IdProduit?: number;
  IdSessionChoix?: number;
  IdStatutCompAccepte?: number;
  IdStatutCompRefuse?: number;
  IsCritereSociauxValide?: boolean;
  Libelle?: string;
  Remarque?: string;
};

export type EditerBlocDescriptionModel = {
  __typename?: 'EditerBlocDescriptionModel';
  Description?: string;
  Id?: number;
  IdProduit?: number;
  IsDeleted?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Titre?: string;
};

export type EditerBlocDescriptionModelInput = {
  Description?: string;
  Id?: number;
  IdProduit?: number;
  IsDeleted?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Titre?: string;
};

export type EditerExecutionAttributionAutoModel = {
  __typename?: 'EditerExecutionAttributionAutoModel';
  ContactParam?: ContactParamModel;
  FrequenceExecution?: string;
  IdAttrib?: number;
  IdContactParam?: number;
  IsExecutionAuto?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedSendAlwaysReport?: boolean;
  Status?: StatusDtoEnum;
};

export type EditerExecutionAttributionAutoModelInput = {
  ContactParam?: ContactParamModelInput;
  FrequenceExecution?: string;
  IdAttrib?: number;
  IdContactParam?: number;
  IsExecutionAuto?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedSendAlwaysReport?: boolean;
  Status?: StatusDtoEnum;
};

export type EditerGroupeRoomingListModelInput = {
  IdGroupe?: number;
  IdRegroupement?: number;
  LibelleGroupe?: string;
  ListeIdLigneCommande?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EditerIbanTiers = {
  __typename?: 'EditerIbanTiers';
  AdresseCodePaysIBAN?: string;
  AdresseCodePostalIBAN?: string;
  AdresseLigne1IBAN?: string;
  AdresseLigne2IBAN?: string;
  AdresseVilleIBAN?: string;
  BBAN?: string;
  BBAN_Encrypt?: string;
  BIC?: string;
  BIC_Encrypt?: string;
  CleIban?: string;
  CodePaysIban?: string;
  DateCloture?: any;
  IdBeneficiaire?: number;
  IdFournisseur?: number;
  IdRib?: number;
  IdUtilisateur?: number;
  IsCloture?: boolean;
  IsParDefaut?: boolean;
  NomBanque?: string;
  TitulaireCompteIBAN?: string;
};

export type EditerIbanTiersInput = {
  AdresseCodePaysIBAN?: string;
  AdresseCodePostalIBAN?: string;
  AdresseLigne1IBAN?: string;
  AdresseLigne2IBAN?: string;
  AdresseVilleIBAN?: string;
  BBAN?: string;
  BBAN_Encrypt?: string;
  BIC?: string;
  BIC_Encrypt?: string;
  CleIban?: string;
  CodePaysIban?: string;
  DateCloture?: any;
  IdBeneficiaire?: number;
  IdFournisseur?: number;
  IdRib?: number;
  IdUtilisateur?: number;
  IsCloture?: boolean;
  IsParDefaut?: boolean;
  NomBanque?: string;
  TitulaireCompteIBAN?: string;
};

export type EditerLigneCommandeBilletterieArticleGeneriqueGestionModelInput = {
  CodeModeLivraison?: string;
  DateReappro?: any;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdStock?: number;
  IdUtilisateur?: number;
  LibelleArticle?: string;
  LibelleLignecommande?: string;
  PrixVente?: number;
  Quantite?: number;
  QuantiteALivrer?: number;
  ReferenceArticle?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
};

export type EditerLigneCommandeBilletterieGestionModelInput = {
  CodeModeLivraison?: string;
  DateReappro?: any;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdStock?: number;
  IdUtilisateur?: number;
  LibelleLignecommande?: string;
  Quantite?: number;
  QuantiteALivrer?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
};

export type EditerLigneCommandeChangementStatutBilletterieInput = {
  CodeModeLivraison?: string;
  CodeStatut?: string;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdUtilisateur?: number;
  Quantite?: number;
};

export type EditerLigneCommandeChangementStatutBilletterieRetourPopupInput = {
  CodeModeLivraison?: string;
  CodeStatut?: string;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdUtilisateur?: number;
  ListeSubventionsAccordeesObs?: ArrayOfSubventionAccordeeModelDtoInput;
  Quantite?: number;
};

export type EditerLigneCommandeChangementStatutGestionModelInput = {
  CodeModeLivraison?: string;
  CodeStatut?: string;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdUtilisateur?: number;
  Quantite?: number;
};

export type EditerLigneCommandeChangementStatutLocationGestionModelInput = {
  CodeModeLivraison?: string;
  CodeStatut?: string;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdUtilisateur?: number;
  Quantite?: number;
};

export type EditerLigneCommandeChangementStatutLocationGestionRetourPopupInput = {
  CodeModeLivraison?: string;
  CodeStatut?: string;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdUtilisateur?: number;
  ListeSubventionsAccordeesObs?: ArrayOfSubventionAccordeeModelDtoInput;
  Quantite?: number;
};

export type EditerLigneCommandeChangementStatutPretsEtDonsModelInput = {
  CodeModeLivraison?: string;
  CodeStatut?: string;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdUtilisateur?: number;
  MontantDossier?: number;
  Quantite?: number;
};

export type EditerLigneCommandeGestionInput = {
  CodeModeLivraison?: string;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdUtilisateur?: number;
  LibelleLignecommande?: string;
  Quantite?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
};

export type EditerLigneCommandeLocationGestionModelInput = {
  CodeModeLivraison?: string;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdUtilisateur?: number;
  LibelleLignecommande?: string;
  Quantite?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
};

export type EditerLigneCommandeRetourPopupGestionArticleGeneriqueModelInput = {
  CodeModeLivraison?: string;
  DateReappro?: any;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdStock?: number;
  IdUtilisateur?: number;
  LibelleArticle?: string;
  LibelleLignecommande?: string;
  ListeSubventionsAccordeesObs?: ArrayOfSubventionAccordeeModelDtoInput;
  PrixDeVente?: number;
  Quantite?: number;
  QuantiteALivrer?: number;
  ReferenceArticle?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
};

export type EditerLigneCommandeRetourPopupGestionModelInput = {
  CodeModeLivraison?: string;
  DateReappro?: any;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdStock?: number;
  IdUtilisateur?: number;
  LibelleLignecommande?: string;
  ListeSubventionsAccordeesObs?: ArrayOfSubventionAccordeeModelDtoInput;
  Quantite?: number;
  QuantiteALivrer?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
};

export type EditerLigneCommandeRetourPopupLocationGestionModelInput = {
  CodeModeLivraison?: string;
  DateReappro?: any;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdStock?: number;
  IdUtilisateur?: number;
  LibelleLignecommande?: string;
  ListeSubventionsAccordeesObs?: ArrayOfSubventionAccordeeModelDtoInput;
  Quantite?: number;
  QuantiteALivrer?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
};

export type EditerMouvementAnalytiqueModel = {
  __typename?: 'EditerMouvementAnalytiqueModel';
  IdMouvementComptable?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytique?: number;
  Montant?: number;
};

export type EditerMouvementAnalytiqueModelInput = {
  IdMouvementComptable?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytique?: number;
  Montant?: number;
};

export type EditerMouvementAnalytiqueWithSectionAnalytiqueModel = {
  __typename?: 'EditerMouvementAnalytiqueWithSectionAnalytiqueModel';
  IdMouvementComptable?: number;
  IdPereSectionAnalytique?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytique?: number;
  LibelleSectionAnalytique?: string;
  Montant?: number;
};

export type EditerMouvementAnalytiqueWithSectionAnalytiqueModelInput = {
  IdMouvementComptable?: number;
  IdPereSectionAnalytique?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytique?: number;
  LibelleSectionAnalytique?: string;
  Montant?: number;
};

export type EditerProduitClotureModel = {
  __typename?: 'EditerProduitClotureModel';
  CodeProduit?: string;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  IsGereEnStock?: boolean;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeFonctionnement?: string;
};

export type EditerProduitClotureModelInput = {
  CodeProduit?: string;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  IsGereEnStock?: boolean;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeFonctionnement?: string;
};

export type EditerRoomingListModel = {
  __typename?: 'EditerRoomingListModel';
  IdProduit?: number;
  IdRoomingList?: number;
  LibelleRoomingList?: string;
  ListeIdChampFormulaire?: ArrayOfint;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EditerRoomingListModelInput = {
  IdProduit?: number;
  IdRoomingList?: number;
  LibelleRoomingList?: string;
  ListeIdChampFormulaire?: ArrayOfintInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EditerSectionAnalytiqueSurMouvementInput = {
  IdMouvementComptable?: number;
  IdSectionAnalytique?: number;
};

export type EditerStatutPersoModelInput = {
  ClotureStatutModel?: ClotureStatutPersoModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StatutPersoModel?: StatutPersoParamModelInput;
};

export type EditionChampListeValeurModel = {
  __typename?: 'EditionChampListeValeurModel';
  ChampHistorise?: string;
  CodeChamp?: string;
  IdChamp?: number;
  LibelleChamp?: string;
  ListeChampsValeur?: ArrayOfChampListeValeurEditerValeurChampListeModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EditionChampListeValeurModelInput = {
  ChampHistorise?: string;
  CodeChamp?: string;
  IdChamp?: number;
  LibelleChamp?: string;
  ListeChampsValeur?: ArrayOfChampListeValeurEditerValeurChampListeModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ElementAssocieDocModel = {
  __typename?: 'ElementAssocieDocModel';
  Libelle?: string;
  NomDocument?: string;
  Type?: string;
};

export type ElementAssocieDocModelInput = {
  Libelle?: string;
  NomDocument?: string;
  Type?: string;
};

export type EmpruntModelDto = {
  __typename?: 'EmpruntModelDTO';
  ListBenef?: ArrayOfBenefEmpruntModelDto;
  ListInfoEmprunt?: ArrayOfInfoEmpruntModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EmpruntModelDtoInput = {
  ListBenef?: ArrayOfBenefEmpruntModelDtoInput;
  ListInfoEmprunt?: ArrayOfInfoEmpruntModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnLigneEpargneModel = {
  __typename?: 'EnLigneEpargneModel';
  IsAfficherSurSiteCE?: boolean;
  IsAutoriserResaSurSiteCE?: boolean;
  RedescendreSurEnfants?: boolean;
  VisibleAu?: any;
  VisibleDu?: any;
};

export type EnLigneEpargneModelInput = {
  IsAfficherSurSiteCE?: boolean;
  IsAutoriserResaSurSiteCE?: boolean;
  RedescendreSurEnfants?: boolean;
  VisibleAu?: any;
  VisibleDu?: any;
};

export type EngagementBudgetModelDto = {
  __typename?: 'EngagementBudgetModelDTO';
  DatePrevisionnel?: any;
  Description?: string;
  Id?: number;
  IdPosteBDG?: number;
  Libelle?: string;
  LibellePosteBDG?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EngagementBudgetModelDtoInput = {
  DatePrevisionnel?: any;
  Description?: string;
  Id?: number;
  IdPosteBDG?: number;
  Libelle?: string;
  LibellePosteBDG?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnregistrementProduitExceptionnelModelInput = {
  DateEcriture?: any;
  IdBeneficiaire?: number;
  IdCECible?: number;
  IdCECreePar?: number;
  IdCESource?: number;
  IdCaisse?: number;
  IdEcriture?: number;
  IdJournal?: number;
  IdUtilisateur?: number;
  Libelle?: string;
  Montant?: number;
  TypeEcriture?: TypeEcritureInput;
};

export type EnteteBaremeDto = {
  __typename?: 'EnteteBaremeDTO';
  Champ?: ChampDto;
  Id?: number;
  Libelle?: string;
  ListeBaremes?: ArrayOfBorneDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnteteBaremeDtoInput = {
  Champ?: ChampDtoInput;
  Id?: number;
  Libelle?: string;
  ListeBaremes?: ArrayOfBorneDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnteteDevisCommandeForCommandeLibreModeleDto = {
  __typename?: 'EnteteDevisCommandeForCommandeLibreModeleDTO';
  DateDevisCommande?: any;
  IdActivite?: number;
  IdBenef?: number;
  IdDevisCommande?: number;
  IdExercice?: number;
  IdFournisseur?: number;
  MontantFraisCommission?: number;
  MontantFraisPort?: number;
  MontantRemise?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  ObjetDevisCommande?: string;
  RemarquePriveeDevisCommande?: string;
  RemarquePubliqueDevisCommande?: string;
  Status?: StatusDtoEnum;
};

export type EnteteDevisCommandeForCommandeLibreModeleDtoInput = {
  DateDevisCommande?: any;
  IdActivite?: number;
  IdBenef?: number;
  IdDevisCommande?: number;
  IdExercice?: number;
  IdFournisseur?: number;
  MontantFraisCommission?: number;
  MontantFraisPort?: number;
  MontantRemise?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  ObjetDevisCommande?: string;
  RemarquePriveeDevisCommande?: string;
  RemarquePubliqueDevisCommande?: string;
  Status?: StatusDtoEnum;
};

export type EnteteDevisCommandeForVentesModeleDto = {
  __typename?: 'EnteteDevisCommandeForVentesModeleDTO';
  DateDevisCommande?: any;
  HaveFormulaireParametre?: boolean;
  IdActivite?: number;
  IdBenef?: number;
  IdDevisCommande?: number;
  IdExercice?: number;
  IdFournisseur?: number;
  IsSaisieEnCours?: boolean;
  MontantFraisCB?: number;
  MontantFraisCom?: number;
  MontantFraisPort?: number;
  MontantRemise?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumChoixLocation?: number;
  ObjetDevisCommande?: string;
  RemarquePriveeDevisCommande?: string;
  RemarquePubliqueDevisCommande?: string;
  Status?: StatusDtoEnum;
};

export type EnteteDevisCommandeForVentesModeleDtoInput = {
  DateDevisCommande?: any;
  HaveFormulaireParametre?: boolean;
  IdActivite?: number;
  IdBenef?: number;
  IdDevisCommande?: number;
  IdExercice?: number;
  IdFournisseur?: number;
  IsSaisieEnCours?: boolean;
  MontantFraisCB?: number;
  MontantFraisCom?: number;
  MontantFraisPort?: number;
  MontantRemise?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumChoixLocation?: number;
  ObjetDevisCommande?: string;
  RemarquePriveeDevisCommande?: string;
  RemarquePubliqueDevisCommande?: string;
  Status?: StatusDtoEnum;
};

export type EnteteDevisCommandeModel = {
  __typename?: 'EnteteDevisCommandeModel';
  Beneficiaire?: string;
  BeneficiairesConcernes?: string;
  Choix?: string;
  CodeActiviteDossierAssocie?: string;
  CodeStatutADM?: string;
  CodeStatutLIVCommandeDossierPresta?: string;
  CouleurStatutPerso?: string;
  DateActiviteLigne?: string;
  DateDebutLocation?: any;
  DateDevis?: any;
  DateFacture?: any;
  DateFinLocation?: any;
  EncaisseBenef?: number;
  EstPaye?: boolean;
  IDDevis?: number;
  IdActiviteDossierAssocie?: number;
  IdBenef?: number;
  IdDossier?: number;
  IdStatutPerso?: number;
  IsSaisieEnCours?: boolean;
  IsSelected?: boolean;
  IsTransfertAnnule?: boolean;
  LibelleClassique?: string;
  LibelleLocation?: string;
  LibelleSessionChoix?: string;
  LibelleStatutPerso?: string;
  ListeBeneficiaires?: string;
  ListeLibellePJNonRecues?: ArrayOfstring;
  ListeLibellePJRecues?: ArrayOfstring;
  ListeMoisReferenceBeneficiaires?: string;
  ListePoints?: ArrayOfKeyValueOfstringdecimal;
  MatriculeBeneficiaire?: string;
  ModeFonctionnement?: string;
  Montant?: number;
  MontantCadeaux?: number;
  MontantFou?: number;
  MontantPresente?: number;
  MontantPrisEnCompte?: number;
  MontantSub?: number;
  NbAccepte?: number;
  NbAnnule?: number;
  NbEnAttente?: number;
  NbPJDemandees?: number;
  NbPJNonValides?: number;
  NbPJRecues?: number;
  NbParticipants?: number;
  NbRefuse?: number;
  PACBenef?: number;
  PJ?: string;
  Paye?: number;
  QteALiv?: string;
  QteALivToolTip?: string;
  RegleFour?: number;
  RestantBenef?: number;
  RestantDU?: number;
  RestantFou?: number;
  RmqPrivee?: string;
  RmqPublic?: string;
  SaisiPar?: string;
  StatutADM?: string;
  StatutLIV?: string;
  SubventionAccordeeCadeaux?: number;
  TypeDossier?: string;
};

export type EnteteDevisCommandeModelInput = {
  Beneficiaire?: string;
  BeneficiairesConcernes?: string;
  Choix?: string;
  CodeActiviteDossierAssocie?: string;
  CodeStatutADM?: string;
  CodeStatutLIVCommandeDossierPresta?: string;
  CouleurStatutPerso?: string;
  DateActiviteLigne?: string;
  DateDebutLocation?: any;
  DateDevis?: any;
  DateFacture?: any;
  DateFinLocation?: any;
  EncaisseBenef?: number;
  EstPaye?: boolean;
  IDDevis?: number;
  IdActiviteDossierAssocie?: number;
  IdBenef?: number;
  IdDossier?: number;
  IdStatutPerso?: number;
  IsSaisieEnCours?: boolean;
  IsSelected?: boolean;
  IsTransfertAnnule?: boolean;
  LibelleClassique?: string;
  LibelleLocation?: string;
  LibelleSessionChoix?: string;
  LibelleStatutPerso?: string;
  ListeBeneficiaires?: string;
  ListeLibellePJNonRecues?: ArrayOfstringInput;
  ListeLibellePJRecues?: ArrayOfstringInput;
  ListeMoisReferenceBeneficiaires?: string;
  ListePoints?: ArrayOfKeyValueOfstringdecimalInput;
  MatriculeBeneficiaire?: string;
  ModeFonctionnement?: string;
  Montant?: number;
  MontantCadeaux?: number;
  MontantFou?: number;
  MontantPresente?: number;
  MontantPrisEnCompte?: number;
  MontantSub?: number;
  NbAccepte?: number;
  NbAnnule?: number;
  NbEnAttente?: number;
  NbPJDemandees?: number;
  NbPJNonValides?: number;
  NbPJRecues?: number;
  NbParticipants?: number;
  NbRefuse?: number;
  PACBenef?: number;
  PJ?: string;
  Paye?: number;
  QteALiv?: string;
  QteALivToolTip?: string;
  RegleFour?: number;
  RestantBenef?: number;
  RestantDU?: number;
  RestantFou?: number;
  RmqPrivee?: string;
  RmqPublic?: string;
  SaisiPar?: string;
  StatutADM?: string;
  StatutLIV?: string;
  SubventionAccordeeCadeaux?: number;
  TypeDossier?: string;
};

export type EnteteDevisModelEtNombreDevis = {
  __typename?: 'EnteteDevisModelEtNombreDevis';
  ListeEnteteDevisCommande?: ArrayOfEnteteDevisCommandeModel;
  NombreDevis?: number;
};

export type EnteteDevisModelEtNombreDevisInput = {
  ListeEnteteDevisCommande?: ArrayOfEnteteDevisCommandeModelInput;
  NombreDevis?: number;
};

export type EnteteDossierPretsEtDonsModel = {
  __typename?: 'EnteteDossierPretsEtDonsModel';
  DateDossier?: any;
  HaveFormulaireParametre?: boolean;
  IdBenef?: number;
  IdCommande?: number;
  IdFormule?: number;
  IdProduit?: number;
  LibelleCommande?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnteteDossierPretsEtDonsModelInput = {
  DateDossier?: any;
  HaveFormulaireParametre?: boolean;
  IdBenef?: number;
  IdCommande?: number;
  IdFormule?: number;
  IdProduit?: number;
  LibelleCommande?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnteteEpargneModel = {
  __typename?: 'EnteteEpargneModel';
  DateDossier?: any;
  IdBenef?: number;
  IdCommande?: number;
  IdEpargne?: number;
  IdModeleEcheancier?: number;
  IdMoyenPaiement?: number;
  InfosReglement?: CommandeInfoReglementModel;
  IsReglementComptant?: boolean;
  LibelleCommande?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnteteEpargneModelInput = {
  DateDossier?: any;
  IdBenef?: number;
  IdCommande?: number;
  IdEpargne?: number;
  IdModeleEcheancier?: number;
  IdMoyenPaiement?: number;
  InfosReglement?: CommandeInfoReglementModelInput;
  IsReglementComptant?: boolean;
  LibelleCommande?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnvImpActiviteDto = {
  __typename?: 'EnvImpActiviteDTO';
  Activite?: ActiviteDto;
  Enveloppe?: EnveloppeQuotaDto;
  IsHerite?: boolean;
  IsTransverse?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnvImpActiviteDtoInput = {
  Activite?: ActiviteDtoInput;
  Enveloppe?: EnveloppeQuotaDtoInput;
  IsHerite?: boolean;
  IsTransverse?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnvImpArticleDto = {
  __typename?: 'EnvImpArticleDTO';
  Article?: ArticleDto;
  Enveloppe?: EnveloppeQuotaDto;
  IsHerite?: boolean;
  IsTransverse?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnvImpArticleDtoInput = {
  Article?: ArticleDtoInput;
  Enveloppe?: EnveloppeQuotaDtoInput;
  IsHerite?: boolean;
  IsTransverse?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnvImpFamilleDto = {
  __typename?: 'EnvImpFamilleDTO';
  Enveloppe?: EnveloppeQuotaDto;
  Famille?: FamilleProduitDto;
  IsHerite?: boolean;
  IsTransverse?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnvImpFamilleDtoInput = {
  Enveloppe?: EnveloppeQuotaDtoInput;
  Famille?: FamilleProduitDtoInput;
  IsHerite?: boolean;
  IsTransverse?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnvImpProduitDto = {
  __typename?: 'EnvImpProduitDTO';
  Enveloppe?: EnveloppeQuotaDto;
  IsHerite?: boolean;
  IsTransverse?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Produit?: ProduitDto;
  Status?: StatusDtoEnum;
};

export type EnvImpProduitDtoInput = {
  Enveloppe?: EnveloppeQuotaDtoInput;
  IsHerite?: boolean;
  IsTransverse?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Produit?: ProduitDtoInput;
  Status?: StatusDtoEnum;
};

export type EnveloppeAfpaModel = {
  __typename?: 'EnveloppeAFPAModel';
  IdActivite?: number;
  IdActiviteParente?: number;
  IdArticle?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdFamilleParente?: number;
  IdProduit?: number;
  IdProduitParent?: number;
  IsAfficheeEnLigne?: boolean;
  LibelleEnveloppe?: string;
  ListeEnveloppe?: ArrayOfEnveloppeAfpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnveloppeAfpaModelInput = {
  IdActivite?: number;
  IdActiviteParente?: number;
  IdArticle?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdFamilleParente?: number;
  IdProduit?: number;
  IdProduitParent?: number;
  IsAfficheeEnLigne?: boolean;
  LibelleEnveloppe?: string;
  ListeEnveloppe?: ArrayOfEnveloppeAfpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnveloppeBaseModel = {
  __typename?: 'EnveloppeBaseModel';
  IdEnveloppe?: number;
  LibelleEnveloppe?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnveloppeBaseModelInput = {
  IdEnveloppe?: number;
  LibelleEnveloppe?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnveloppeBaseSelectedModel = {
  __typename?: 'EnveloppeBaseSelectedModel';
  IdEnveloppe?: number;
  IsSelected?: boolean;
  LibelleEnveloppe?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnveloppeBaseSelectedModelInput = {
  IdEnveloppe?: number;
  IsSelected?: boolean;
  LibelleEnveloppe?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type EnveloppeQuotaDto = {
  __typename?: 'EnveloppeQuotaDTO';
  Activite?: ActiviteDto;
  Article?: ArticleDto;
  CEDelegation?: CeDelegationDto;
  ChampListeVal?: ChampListeValeurDto;
  Code?: string;
  CodeEnveloppeKalidea?: string;
  DateDebutAttBDG?: any;
  DateDebutValidite?: any;
  DateFinAttBDG?: any;
  DateFinValidite?: any;
  Famille?: FamilleProduitDto;
  FamillePresta?: FamilleProduitDto;
  Id?: number;
  IsCloture?: boolean;
  IsComplementaire?: boolean;
  IsEnvAttribution?: boolean;
  IsSubChoisie?: boolean;
  IsTransverse?: boolean;
  Libelle?: string;
  ListeConsoMouvement?: ArrayOfConsoMouvementDto;
  ListeConsoMouvementEnveloppeQuota?: ArrayOfConsoMouvementEnveloppeQuotaDto;
  ListeEnvImpActivite?: ArrayOfEnvImpActiviteDto;
  ListeEnvImpArticle?: ArrayOfEnvImpArticleDto;
  ListeEnvImpFamille?: ArrayOfEnvImpFamilleDto;
  ListeEnvImpProduit?: ArrayOfEnvImpProduitDto;
  ListeMoteurRegle?: ArrayOfMoteurRegleDto;
  ListePortailPortlet?: ArrayOfPortailPortletDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Produit?: ProduitDto;
  ProduitPresta?: ProduitDto;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type EnveloppeQuotaDtoInput = {
  Activite?: ActiviteDtoInput;
  Article?: ArticleDtoInput;
  CEDelegation?: CeDelegationDtoInput;
  ChampListeVal?: ChampListeValeurDtoInput;
  Code?: string;
  CodeEnveloppeKalidea?: string;
  DateDebutAttBDG?: any;
  DateDebutValidite?: any;
  DateFinAttBDG?: any;
  DateFinValidite?: any;
  Famille?: FamilleProduitDtoInput;
  FamillePresta?: FamilleProduitDtoInput;
  Id?: number;
  IsCloture?: boolean;
  IsComplementaire?: boolean;
  IsEnvAttribution?: boolean;
  IsSubChoisie?: boolean;
  IsTransverse?: boolean;
  Libelle?: string;
  ListeConsoMouvement?: ArrayOfConsoMouvementDtoInput;
  ListeConsoMouvementEnveloppeQuota?: ArrayOfConsoMouvementEnveloppeQuotaDtoInput;
  ListeEnvImpActivite?: ArrayOfEnvImpActiviteDtoInput;
  ListeEnvImpArticle?: ArrayOfEnvImpArticleDtoInput;
  ListeEnvImpFamille?: ArrayOfEnvImpFamilleDtoInput;
  ListeEnvImpProduit?: ArrayOfEnvImpProduitDtoInput;
  ListeMoteurRegle?: ArrayOfMoteurRegleDtoInput;
  ListePortailPortlet?: ArrayOfPortailPortletDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Produit?: ProduitDtoInput;
  ProduitPresta?: ProduitDtoInput;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type EpargnesModeleRegleQuotaEpargneInput = {
  IdChpListValPeriodeNombreDossiersAcceptes?: number;
  IdModeleRegle?: number;
  IsForcageAutorise?: boolean;
  IsVenteSansSubvention?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreDemandesSimultaneesMaximum?: number;
  NombreDossiersAcceptesSimultaneesMaximum?: number;
  OrdreModeleRegle?: number;
  Status?: StatusDtoEnum;
  TypeModeleRegle?: string;
  TypeValeurModeleRegle?: string;
};

export type ErreurValidationInput = {
  Message?: string;
  PropertyName?: string;
};

export type EtapesSuppressionTarif = {
  __typename?: 'EtapesSuppressionTarif';
  CreationAvoir?: boolean;
  IdTarif?: number;
  SuppressionFacture?: boolean;
  SuppressionTarif?: boolean;
};

export type EtapesSuppressionTarifInput = {
  CreationAvoir?: boolean;
  IdTarif?: number;
  SuppressionFacture?: boolean;
  SuppressionTarif?: boolean;
};

export enum EtatClotureEnum {
  Clotures = 'Clotures',
  NonClotures = 'NonClotures',
  Tous = 'Tous'
}

export type EvolutionImportModel = {
  __typename?: 'EvolutionImportModel';
  NombreLigneDansFichier?: number;
  NombreMediaEnregistre?: number;
};

export type EvolutionImportModelInput = {
  NombreLigneDansFichier?: number;
  NombreMediaEnregistre?: number;
};

export type ExecutionActionsGroupeesModelInput = {
  DateReglement?: any;
  DateTransfertComptabiliteBeneficiaire?: any;
  DateTransfertComptabiliteFournisseur?: any;
  IdActivite?: number;
  IdCompteBancaire?: number;
  IdMoyenPaiement?: number;
  ListeEntetesDossierPrestation?: ArrayOfEnteteDevisCommandeModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  ProcederRemboursement?: boolean;
  ProcederTransfertComptabilite?: boolean;
  SelectedIDExerciceBeneficiaire?: number;
  SelectedIDExerciceFournisseur?: number;
  SelectedIDJournalBeneficiaire?: number;
  SelectedIDJournalFournisseur?: number;
  SelectedIDJournalRemboursement?: number;
  Status?: StatusDtoEnum;
  TypeDossiers?: string;
};

export type ExemplaireMediaTransfertStockModel = {
  __typename?: 'ExemplaireMediaTransfertStockModel';
  Auteur?: string;
  CodeExemplaire?: string;
  IdArticle?: number;
  IsPerdu?: boolean;
  LibelleFamille?: string;
  LibelleMedia?: string;
  TypeMedia?: string;
};

export type ExemplaireMediaTransfertStockModelInput = {
  Auteur?: string;
  CodeExemplaire?: string;
  IdArticle?: number;
  IsPerdu?: boolean;
  LibelleFamille?: string;
  LibelleMedia?: string;
  TypeMedia?: string;
};

export type ExemplaireMediathequeRechercheMediaModelDto = {
  __typename?: 'ExemplaireMediathequeRechercheMediaModelDTO';
  Auteur?: string;
  BenefEmprunte?: string;
  BenefEnFileDattente?: string;
  BenefReserve?: string;
  BenefRetard?: string;
  Code?: string;
  Cote?: string;
  EtatExemplaire?: string;
  IdBenefEmprunte?: number;
  IdEnveloppe?: number;
  IdEtatExemplaire?: number;
  IdExemplaire?: number;
  IdProduit?: number;
  IdStockActuel?: number;
  IdStockRattachement?: number;
  IsBloque?: boolean;
  IsEmprunte?: boolean;
  IsEnFileDattente?: boolean;
  IsEnStock?: boolean;
  IsEnTransfert?: boolean;
  IsGereEnFileAttente?: boolean;
  IsPerdu?: boolean;
  IsReserve?: boolean;
  IsRetard?: boolean;
  IsSelected?: boolean;
  Localisation?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QteFileEnAttente?: number;
  Remarque?: string;
  Status?: StatusDtoEnum;
  StockRattachement?: string;
  TitreMedia?: string;
  ToDelete?: boolean;
  TypeMedia?: string;
};

export type ExemplaireMediathequeRechercheMediaModelDtoInput = {
  Auteur?: string;
  BenefEmprunte?: string;
  BenefEnFileDattente?: string;
  BenefReserve?: string;
  BenefRetard?: string;
  Code?: string;
  Cote?: string;
  EtatExemplaire?: string;
  IdBenefEmprunte?: number;
  IdEnveloppe?: number;
  IdEtatExemplaire?: number;
  IdExemplaire?: number;
  IdProduit?: number;
  IdStockActuel?: number;
  IdStockRattachement?: number;
  IsBloque?: boolean;
  IsEmprunte?: boolean;
  IsEnFileDattente?: boolean;
  IsEnStock?: boolean;
  IsEnTransfert?: boolean;
  IsGereEnFileAttente?: boolean;
  IsPerdu?: boolean;
  IsReserve?: boolean;
  IsRetard?: boolean;
  IsSelected?: boolean;
  Localisation?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QteFileEnAttente?: number;
  Remarque?: string;
  Status?: StatusDtoEnum;
  StockRattachement?: string;
  TitreMedia?: string;
  ToDelete?: boolean;
  TypeMedia?: string;
};

export type ExerciceClotureModel = {
  __typename?: 'ExerciceClotureModel';
  CanAddCloture?: boolean;
  CanSupprModif?: boolean;
  Code?: string;
  DateCloture?: any;
  DateLastModif?: any;
  IdDelegationCloture?: number;
  IdDerniereCloture?: number;
  IdExercice?: number;
  IsCloture?: boolean;
  IsValide?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  UserLastModif?: string;
};

export type ExerciceClotureModelInput = {
  CanAddCloture?: boolean;
  CanSupprModif?: boolean;
  Code?: string;
  DateCloture?: any;
  DateLastModif?: any;
  IdDelegationCloture?: number;
  IdDerniereCloture?: number;
  IdExercice?: number;
  IsCloture?: boolean;
  IsValide?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  UserLastModif?: string;
};

export type ExerciceDto = {
  __typename?: 'ExerciceDTO';
  Code?: string;
  CompteEcriture?: CompteEcritureDto;
  DateCloture?: any;
  DateDeb?: any;
  DateFin?: any;
  Id?: number;
  IsClos?: boolean;
  IsTravail?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: UsersDto;
};

export type ExerciceDtoInput = {
  Code?: string;
  CompteEcriture?: CompteEcritureDtoInput;
  DateCloture?: any;
  DateDeb?: any;
  DateFin?: any;
  Id?: number;
  IsClos?: boolean;
  IsTravail?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: UsersDtoInput;
};

export type ExerciceForVenteModeleDto = {
  __typename?: 'ExerciceForVenteModeleDTO';
  CodeExercice?: string;
  IdExercice?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ExerciceForVenteModeleDtoInput = {
  CodeExercice?: string;
  IdExercice?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ExerciceInfos = {
  __typename?: 'ExerciceInfos';
  CodeExercice?: string;
  DateCloture?: any;
  DateDebutExercice?: any;
  DateFinExercice?: any;
  IdDelegation?: number;
  IdExercice?: number;
  IsCloture?: boolean;
  IsEnCoursDeCloture?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ExerciceInfosInput = {
  CodeExercice?: string;
  DateCloture?: any;
  DateDebutExercice?: any;
  DateFinExercice?: any;
  IdDelegation?: number;
  IdExercice?: number;
  IsCloture?: boolean;
  IsEnCoursDeCloture?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ExerciceModelDto = {
  __typename?: 'ExerciceModelDTO';
  CodeExercice?: string;
  DateDebut?: any;
  DateFin?: any;
  IdExercice?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Periode?: string;
  Status?: StatusDtoEnum;
};

export type ExerciceModelDtoInput = {
  CodeExercice?: string;
  DateDebut?: any;
  DateFin?: any;
  IdExercice?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Periode?: string;
  Status?: StatusDtoEnum;
};

export type ExportAncvCesuModelDtoInput = {
  AdresseGenerique?: string;
  IsEnvoiChequeAuBenef?: boolean;
  IsEnvoiChequeAuCE?: boolean;
  IsGenerationParSite?: boolean;
  IsGenerationUnique?: boolean;
  IsModeEnvoiParamArticle?: boolean;
  LibelleModeEnvoiSelectionne?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeExport?: FormatExportEnum;
};

export type ExportCommandeFournisseurModel = {
  __typename?: 'ExportCommandeFournisseurModel';
  NombreLigneANCVConnect?: number;
  NombreLigneCommande?: number;
};

export type ExportCommandeFournisseurModelInput = {
  NombreLigneANCVConnect?: number;
  NombreLigneCommande?: number;
};

export type FpaArticleComptaModel = {
  __typename?: 'FPAArticleComptaModel';
  IdCompteImputation?: number;
  IdProduit?: number;
  LibelleProduit?: string;
  ListeCleRepartition?: ArrayOfCleRepartitionModel;
};

export type FpaArticleComptaModelInput = {
  IdCompteImputation?: number;
  IdProduit?: number;
  LibelleProduit?: string;
  ListeCleRepartition?: ArrayOfCleRepartitionModelInput;
};

export type FpaPrestaArticleBaseModel = {
  __typename?: 'FPAPrestaArticleBaseModel';
  Id?: number;
  Libelle?: string;
};

export type FpaPrestaArticleBaseModelInput = {
  Id?: number;
  Libelle?: string;
};

export type FpaPrestaArticleCadeauModel = {
  __typename?: 'FPAPrestaArticleCadeauModel';
  DateEvenement?: any;
  HaveFormulaireALaLigne?: boolean;
  Id?: number;
  IsArticleModeAvance?: boolean;
  Libelle?: string;
  LibelleDateEvenement?: string;
  LibelleEnveloppeKalidea?: string;
};

export type FpaPrestaArticleCadeauModelInput = {
  DateEvenement?: any;
  HaveFormulaireALaLigne?: boolean;
  Id?: number;
  IsArticleModeAvance?: boolean;
  Libelle?: string;
  LibelleDateEvenement?: string;
  LibelleEnveloppeKalidea?: string;
};

export type FpaPrestaArticleIsGereStockComptaModel = {
  __typename?: 'FPAPrestaArticleIsGereStockComptaModel';
  Id?: number;
  IdCompteImputation?: number;
  IdProduit?: number;
  IsGereEnStock?: boolean;
  Libelle?: string;
  LibelleProduit?: string;
};

export type FpaPrestaArticleIsGereStockComptaModelInput = {
  Id?: number;
  IdCompteImputation?: number;
  IdProduit?: number;
  IsGereEnStock?: boolean;
  Libelle?: string;
  LibelleProduit?: string;
};

export type FpaSectionAnalytiqueModelDto = {
  __typename?: 'FPASectionAnalytiqueModelDTO';
  IdFPA?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytique?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FpaSectionAnalytiqueModelDtoInput = {
  IdFPA?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytique?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FpaVenteEnLigneBaseModel = {
  __typename?: 'FPAVenteEnLigneBaseModel';
  AutoriserCommandesEnLigne?: boolean;
  DateDebutVisibilite?: any;
  DateFinVisibilite?: any;
  IdElement?: number;
  IsAfficheEnLigne?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreVenteEnLigne?: boolean;
  Status?: StatusDtoEnum;
};

export type FpaVenteEnLigneBaseModelInput = {
  AutoriserCommandesEnLigne?: boolean;
  DateDebutVisibilite?: any;
  DateFinVisibilite?: any;
  IdElement?: number;
  IsAfficheEnLigne?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreVenteEnLigne?: boolean;
  Status?: StatusDtoEnum;
};

export type FpaVenteEnLigneWithAcompteModel = {
  __typename?: 'FPAVenteEnLigneWithAcompteModel';
  AutoriserCommandesEnLigne?: boolean;
  DateDebutVisibilite?: any;
  DateFinVisibilite?: any;
  HasCompteAcompte?: boolean;
  IdElement?: number;
  IsAcompteObligatoireEnLigne?: boolean;
  IsAfficheEnLigne?: boolean;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreVenteEnLigne?: boolean;
  Status?: StatusDtoEnum;
};

export type FpaVenteEnLigneWithAcompteModelInput = {
  AutoriserCommandesEnLigne?: boolean;
  DateDebutVisibilite?: any;
  DateFinVisibilite?: any;
  HasCompteAcompte?: boolean;
  IdElement?: number;
  IsAcompteObligatoireEnLigne?: boolean;
  IsAfficheEnLigne?: boolean;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreVenteEnLigne?: boolean;
  Status?: StatusDtoEnum;
};

export type FactureAPayerModelDto = {
  __typename?: 'FactureAPayerModelDTO';
  Activite?: string;
  ActiviteId?: number;
  IsFactureHidden?: boolean;
  MntAPayer?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FactureAPayerModelDtoInput = {
  Activite?: string;
  ActiviteId?: number;
  IsFactureHidden?: boolean;
  MntAPayer?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FactureAvoirModelDtoInput = {
  CodeActivite?: string;
  CodeTypeEcriture?: string;
  CodeTypeStatut?: string;
  DateFact?: any;
  EcritureModel?: EcritureComptaModelDtoInput;
  IdActivite?: number;
  IdAdresseFigePV?: number;
  IdAdresseFigeTiers?: number;
  IdBenef?: number;
  IdCdeAccompte?: number;
  IdCompteFraisComFour?: number;
  IdDelegation?: number;
  IdExercice?: number;
  IdFacture?: number;
  IdFactureConcerneAvoir?: number;
  IdFournisseur?: number;
  IdJournal?: number;
  IdPointVente?: number;
  IdProduit?: number;
  IsAcompte?: boolean;
  IsAvoir?: boolean;
  IsFactureLibre?: boolean;
  IsGenereeCompta?: boolean;
  IsImputeAvoirSurFact?: boolean;
  IsLibre?: boolean;
  ListeIdCommande?: ArrayOfdecimalInput;
  ListeLigneAvoirModel?: ArrayOfLigneAvoirModelDtoInput;
  MontFraisComFour?: number;
  MontantAImputerSurAvoirPartiel?: number;
  MontantFactureTotal?: number;
  MontantFraisCB?: number;
  MontantFraisPort?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumFacture?: string;
  NumeroPiece?: string;
  NumeroPieceAuto?: boolean;
  Objet?: string;
  PourcentageSurAvoirPartiel?: number;
  Reference?: string;
  RemarquePrive?: string;
  RemarquePublique?: string;
  RemiseGlobale?: number;
  Status?: StatusDtoEnum;
  TypeFac?: string;
  TypeStatut?: TypeStatutCommandeDtoEnum;
};

export type FactureDto = {
  __typename?: 'FactureDTO';
  Activite?: ActiviteDto;
  AdresseFigePV?: AdresseFigeDto;
  AdresseFigeTiers?: AdresseFigeDto;
  Benef?: BenefDto;
  CEDelegationCible?: CeDelegationDto;
  CEDelegationCreePar?: CeDelegationDto;
  CEDelegationSource?: CeDelegationDto;
  CommandeAccompte?: DevisCommandeDto;
  CompteEcriture?: CompteEcritureDto;
  DateFacture?: any;
  FactureConcerneParAvoir?: FactureDto;
  Fournisseur?: FournisseurDto;
  FraisCommissionFour?: number;
  Id?: number;
  IsAccompte?: boolean;
  IsAvoir?: boolean;
  IsLibre?: boolean;
  IsSupprimer?: boolean;
  ListeAcompteAvoirImpute?: ArrayOfFactureImputationAcompteAvoirDto;
  ListeAvoir?: ArrayOfFactureDto;
  ListeCommande?: ArrayOfDevisCommandeDto;
  ListeCompteEcritureFacture?: ArrayOfCompteEcritureFactureDto;
  ListeFactureImpute?: ArrayOfFactureImputationAcompteAvoirDto;
  ListeHistoStatutFacture?: ArrayOfHistoStatutFactureDto;
  ListeLigneFacture?: ArrayOfLigneFactureDto;
  MontantFactureTotal?: number;
  MontantFraisCB?: number;
  MontantFraisPort?: number;
  MontantSubventionAccordeeTotal?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumFacture?: string;
  Objet?: string;
  PointVente?: PointVenteDto;
  Produit?: ProduitDto;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  RemiseGlobale?: number;
  Solde?: number;
  Status?: StatusDtoEnum;
  StatutFacture?: StatutFactureDto;
  TypeFacture?: string;
};

export type FactureDtoInput = {
  Activite?: ActiviteDtoInput;
  AdresseFigePV?: AdresseFigeDtoInput;
  AdresseFigeTiers?: AdresseFigeDtoInput;
  Benef?: BenefDtoInput;
  CEDelegationCible?: CeDelegationDtoInput;
  CEDelegationCreePar?: CeDelegationDtoInput;
  CEDelegationSource?: CeDelegationDtoInput;
  CommandeAccompte?: DevisCommandeDtoInput;
  CompteEcriture?: CompteEcritureDtoInput;
  DateFacture?: any;
  FactureConcerneParAvoir?: FactureDtoInput;
  Fournisseur?: FournisseurDtoInput;
  FraisCommissionFour?: number;
  Id?: number;
  IsAccompte?: boolean;
  IsAvoir?: boolean;
  IsLibre?: boolean;
  IsSupprimer?: boolean;
  ListeAcompteAvoirImpute?: ArrayOfFactureImputationAcompteAvoirDtoInput;
  ListeAvoir?: ArrayOfFactureDtoInput;
  ListeCommande?: ArrayOfDevisCommandeDtoInput;
  ListeCompteEcritureFacture?: ArrayOfCompteEcritureFactureDtoInput;
  ListeFactureImpute?: ArrayOfFactureImputationAcompteAvoirDtoInput;
  ListeHistoStatutFacture?: ArrayOfHistoStatutFactureDtoInput;
  ListeLigneFacture?: ArrayOfLigneFactureDtoInput;
  MontantFactureTotal?: number;
  MontantFraisCB?: number;
  MontantFraisPort?: number;
  MontantSubventionAccordeeTotal?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumFacture?: string;
  Objet?: string;
  PointVente?: PointVenteDtoInput;
  Produit?: ProduitDtoInput;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  RemiseGlobale?: number;
  Solde?: number;
  Status?: StatusDtoEnum;
  StatutFacture?: StatutFactureDtoInput;
  TypeFacture?: string;
};

export type FactureEcheancierModelDto = {
  __typename?: 'FactureEcheancierModelDTO';
  DateFacture?: any;
  Id?: number;
  IdActivite?: number;
  LibelleFacture?: string;
  MontantFacture?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  ReferenceFacture?: string;
  Status?: StatusDtoEnum;
};

export type FactureEcheancierModelDtoInput = {
  DateFacture?: any;
  Id?: number;
  IdActivite?: number;
  LibelleFacture?: string;
  MontantFacture?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  ReferenceFacture?: string;
  Status?: StatusDtoEnum;
};

export type FactureHistoriqueModel = {
  __typename?: 'FactureHistoriqueModel';
  Activite?: string;
  BenefMat?: string;
  BenefNom?: string;
  BenefPrenom?: string;
  CodeTypeActivite?: string;
  ConcerneCommandeId?: number;
  DateFacture?: any;
  FournisseurNom?: string;
  HasEcriture?: boolean;
  HaveAcompteSuCommande?: boolean;
  IdActivite?: number;
  IdBenef?: number;
  IdCompteCollectifClient?: number;
  IdCompteCollectifFournisseur?: number;
  IdEcriture?: number;
  IdFacture?: number;
  IdFournisseur?: number;
  IdJournalAchat?: number;
  IdJournalVente?: number;
  IsAcompte?: boolean;
  IsAvoir?: boolean;
  IsFacture?: boolean;
  IsFactureAnnulationAvoir?: boolean;
  IsFactureTVA?: boolean;
  IsLibre?: boolean;
  IsSupprime?: boolean;
  LibelleFacture?: string;
  LibelleStatut?: string;
  ListeAvoirsLies?: ArrayOfstring;
  ListeIdDossierPresta?: ArrayOfdecimal;
  MontantFacture?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumFacture?: string;
  NumeroFactureAnnulationAvoirAssociee?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Solde?: number;
  Status?: StatusDtoEnum;
  StatutFacture?: string;
  TypeFacture?: string;
};

export type FactureHistoriqueModelInput = {
  Activite?: string;
  BenefMat?: string;
  BenefNom?: string;
  BenefPrenom?: string;
  CodeTypeActivite?: string;
  ConcerneCommandeId?: number;
  DateFacture?: any;
  FournisseurNom?: string;
  HasEcriture?: boolean;
  HaveAcompteSuCommande?: boolean;
  IdActivite?: number;
  IdBenef?: number;
  IdCompteCollectifClient?: number;
  IdCompteCollectifFournisseur?: number;
  IdEcriture?: number;
  IdFacture?: number;
  IdFournisseur?: number;
  IdJournalAchat?: number;
  IdJournalVente?: number;
  IsAcompte?: boolean;
  IsAvoir?: boolean;
  IsFacture?: boolean;
  IsFactureAnnulationAvoir?: boolean;
  IsFactureTVA?: boolean;
  IsLibre?: boolean;
  IsSupprime?: boolean;
  LibelleFacture?: string;
  LibelleStatut?: string;
  ListeAvoirsLies?: ArrayOfstringInput;
  ListeIdDossierPresta?: ArrayOfdecimalInput;
  MontantFacture?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumFacture?: string;
  NumeroFactureAnnulationAvoirAssociee?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Solde?: number;
  Status?: StatusDtoEnum;
  StatutFacture?: string;
  TypeFacture?: string;
};

export type FactureImputationAcompteAvoirDto = {
  __typename?: 'FactureImputationAcompteAvoirDTO';
  Avoir?: FactureDto;
  DateImputation?: any;
  Facture?: FactureDto;
  MontantImputation?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: UsersDto;
};

export type FactureImputationAcompteAvoirDtoInput = {
  Avoir?: FactureDtoInput;
  DateImputation?: any;
  Facture?: FactureDtoInput;
  MontantImputation?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: UsersDtoInput;
};

export type FactureInfosFacturationCommandeClientGestionModelInput = {
  DateFacturation?: any;
  IdActivite?: number;
  IdExercice?: number;
  IdJournal?: number;
  IdUtilisateur?: number;
  InfosCheque?: any;
  InfosMoyenPaiement?: any;
  ListeIdCommande?: ArrayOfdecimalInput;
  NePasLivrerCommande?: boolean;
  NumPiece?: string;
};

export type FactureInfosFactureAcompteFourPrestaModel = {
  __typename?: 'FactureInfosFactureAcompteFourPrestaModel';
  IdAcompte?: number;
  IdEcheancier?: number;
  MontantAcompte?: number;
};

export type FactureInfosFactureAcompteFourPrestaModelInput = {
  IdAcompte?: number;
  IdEcheancier?: number;
  MontantAcompte?: number;
};

export type FactureInfosFactureForReglementWorkFlow = {
  __typename?: 'FactureInfosFactureForReglementWorkFlow';
  DateFacture?: any;
  IdActivite?: number;
  IdFacture?: number;
  IdTiers?: number;
  Solde?: number;
  TypeFacture?: string;
};

export type FactureInfosFactureForReglementWorkFlowInput = {
  DateFacture?: any;
  IdActivite?: number;
  IdFacture?: number;
  IdTiers?: number;
  Solde?: number;
  TypeFacture?: string;
};

export type FactureInfosFactureModel = {
  __typename?: 'FactureInfosFactureModel';
  BenefNomPrenom?: string;
  DateFacture?: any;
  FourNom?: string;
  HaveEcritureLettre?: boolean;
  IdActivite?: number;
  IdBenef?: number;
  IdFacture?: number;
  IdFour?: number;
  LibelleActivite?: string;
  LibelleFacture?: string;
  ListeNumeroAvoir?: ArrayOfstring;
  MontantFacture?: number;
  NumFacture?: string;
  RemarquePrive?: string;
  RemarquePublic?: string;
  RestantDu?: number;
  Statut?: string;
  TypeActivite?: string;
  TypeFacture?: string;
};

export type FactureInfosFactureModelInput = {
  BenefNomPrenom?: string;
  DateFacture?: any;
  FourNom?: string;
  HaveEcritureLettre?: boolean;
  IdActivite?: number;
  IdBenef?: number;
  IdFacture?: number;
  IdFour?: number;
  LibelleActivite?: string;
  LibelleFacture?: string;
  ListeNumeroAvoir?: ArrayOfstringInput;
  MontantFacture?: number;
  NumFacture?: string;
  RemarquePrive?: string;
  RemarquePublic?: string;
  RestantDu?: number;
  Statut?: string;
  TypeActivite?: string;
  TypeFacture?: string;
};

export type FactureStatutFactureOuCdeModel = {
  __typename?: 'FactureStatutFactureOuCdeModel';
  DateStatut?: any;
  Libelle?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
};

export type FactureStatutFactureOuCdeModelInput = {
  DateStatut?: any;
  Libelle?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
};

export type FacturerTarifsGestionModelInput = {
  IdExercice?: number;
  IdJournal?: number;
  IdModeleAdresse?: number;
  IdUtilisateur?: number;
  ListeIdTarifs?: ArrayOfdecimalInput;
  NumeroPiece?: string;
};

export type FamilleBaseModel = {
  __typename?: 'FamilleBaseModel';
  IdFamille?: number;
  Libelle?: string;
};

export type FamilleBaseModelInput = {
  IdFamille?: number;
  Libelle?: string;
};

export type FamilleImportModelDto = {
  __typename?: 'FamilleImportModelDTO';
  CPTHA?: CompteDto;
  CPTSTKVAL?: CompteDto;
  CPTSTKVAR?: CompteDto;
  CPTVT?: CompteDto;
  Code?: string;
  IDCPTVT?: string;
  Id?: number;
  IdCPTHA?: number;
  IdCPTSTKVAL?: number;
  IdCPTSTKVAR?: number;
  IsCharger?: boolean;
  IsSelected?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FamilleImportModelDtoInput = {
  CPTHA?: CompteDtoInput;
  CPTSTKVAL?: CompteDtoInput;
  CPTSTKVAR?: CompteDtoInput;
  CPTVT?: CompteDtoInput;
  Code?: string;
  IDCPTVT?: string;
  Id?: number;
  IdCPTHA?: number;
  IdCPTSTKVAL?: number;
  IdCPTSTKVAR?: number;
  IsCharger?: boolean;
  IsSelected?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FamilleInformationsBaseModel = {
  __typename?: 'FamilleInformationsBaseModel';
  CodeFamille?: string;
  Description?: string;
  IdActivite?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IsCloture?: boolean;
  LibelleFamille?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type FamilleInformationsBaseModelInput = {
  CodeFamille?: string;
  Description?: string;
  IdActivite?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IsCloture?: boolean;
  LibelleFamille?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type FamilleLightModel = {
  __typename?: 'FamilleLightModel';
  IdFamille?: number;
  Libelle?: string;
};

export type FamilleLightModelInput = {
  IdFamille?: number;
  Libelle?: string;
};

export type FamilleModel = {
  __typename?: 'FamilleModel';
  Description?: string;
  ID?: number;
  IdParent?: number;
  IsClos?: boolean;
  IsSelected?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomFamille?: string;
  Status?: StatusDtoEnum;
};

export type FamilleModelInput = {
  Description?: string;
  ID?: number;
  IdParent?: number;
  IsClos?: boolean;
  IsSelected?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomFamille?: string;
  Status?: StatusDtoEnum;
};

export type FamilleProduitDto = {
  __typename?: 'FamilleProduitDTO';
  Activite?: ActiviteDto;
  AfficherDirecto?: boolean;
  AutoriseCommEnLigne?: boolean;
  AutoriseQteDispoNegaVal?: boolean;
  AutoriseQteDispoNegativeAtt?: boolean;
  AutoriseQteNega?: boolean;
  Code?: string;
  CourrierAcceptation?: CourrierDto;
  CourrierContractLoc?: CourrierDto;
  CourrierRefus?: CourrierDto;
  Cpt512?: CompteDto;
  CptAchat?: CompteDto;
  CptCollectifClient?: CompteDto;
  CptCollectifFournisseur?: CompteDto;
  CptValidationStock?: CompteDto;
  CptVariationStock?: CompteDto;
  CptVente?: CompteDto;
  DateDebutRmbMensuel?: any;
  DateDebutVente?: any;
  DateDebutVisibilite?: any;
  DateFinRmbMensuel?: any;
  DateFinVente?: any;
  DateFinVisibilite?: any;
  DatePourReappro?: any;
  Description?: string;
  Enveloppe?: EnveloppeQuotaDto;
  EnveloppePresta?: EnveloppeQuotaDto;
  Fournisseur?: FournisseurDto;
  IDCNumChoix?: boolean;
  Id?: number;
  IdModeleTVA?: number;
  IsCloture?: boolean;
  IsCrediterEnveloppe?: boolean;
  IsGroupe?: boolean;
  IsNotGereEnStock?: boolean;
  IsRemboursementCadeau?: boolean;
  IsRemboursementMensuel?: boolean;
  IsRemboursementPartACharge?: boolean;
  IsRemboursementPrestation?: boolean;
  IsSaisieChronologiqueRmbMensuel?: boolean;
  Libelle?: string;
  ListeChamps?: ArrayOfChampDto;
  ListeChampsValeur?: ArrayOfChampValeurDto;
  ListeCompteursPoints?: ArrayOfCompteurPointAfpaModel;
  ListeEnvImpFamille?: ArrayOfEnvImpFamilleDto;
  ListeFamilleProduitSectionAnalytique?: ArrayOfFamilleProduitSectionAnalytiqueDto;
  ListeFamilleProduitsModeLivraison?: ArrayOfFamilleProduitModeLivraisonDto;
  ListeFournisseursConventionnes?: ArrayOfFournisseurDto;
  ListeModeleEcheancier?: ArrayOfModeleEcheancierGeneriqueModel;
  ListeMoteurRegleHeritageFamille?: ArrayOfMoteurRegleHeritageFamilleDto;
  ListeMoteurRegleUseFamille?: ArrayOfMoteurRegleUseFamilleDto;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementAfpaModel;
  ListeProduits?: ArrayOfProduitDto;
  ModeAvanceCadeau?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Picto?: FichierModel;
  RedesendreRetourMDKSurProduit?: boolean;
  Remarque?: string;
  RetourMediaNouv?: MediaRetourDto;
  RetourMediaPasNouv?: MediaRetourDto;
  SessionChoix?: SessionChoixDto;
  Status?: StatusDtoEnum;
  StockTypeReappro?: StockTypeReapproDto;
  TypeComportementFamille?: string;
  TypeDocumentPresente?: string;
  TypeFonctionnement?: string;
};

export type FamilleProduitDtoInput = {
  Activite?: ActiviteDtoInput;
  AfficherDirecto?: boolean;
  AutoriseCommEnLigne?: boolean;
  AutoriseQteDispoNegaVal?: boolean;
  AutoriseQteDispoNegativeAtt?: boolean;
  AutoriseQteNega?: boolean;
  Code?: string;
  CourrierAcceptation?: CourrierDtoInput;
  CourrierContractLoc?: CourrierDtoInput;
  CourrierRefus?: CourrierDtoInput;
  Cpt512?: CompteDtoInput;
  CptAchat?: CompteDtoInput;
  CptCollectifClient?: CompteDtoInput;
  CptCollectifFournisseur?: CompteDtoInput;
  CptValidationStock?: CompteDtoInput;
  CptVariationStock?: CompteDtoInput;
  CptVente?: CompteDtoInput;
  DateDebutRmbMensuel?: any;
  DateDebutVente?: any;
  DateDebutVisibilite?: any;
  DateFinRmbMensuel?: any;
  DateFinVente?: any;
  DateFinVisibilite?: any;
  DatePourReappro?: any;
  Description?: string;
  Enveloppe?: EnveloppeQuotaDtoInput;
  EnveloppePresta?: EnveloppeQuotaDtoInput;
  Fournisseur?: FournisseurDtoInput;
  IDCNumChoix?: boolean;
  Id?: number;
  IdModeleTVA?: number;
  IsCloture?: boolean;
  IsCrediterEnveloppe?: boolean;
  IsGroupe?: boolean;
  IsNotGereEnStock?: boolean;
  IsRemboursementCadeau?: boolean;
  IsRemboursementMensuel?: boolean;
  IsRemboursementPartACharge?: boolean;
  IsRemboursementPrestation?: boolean;
  IsSaisieChronologiqueRmbMensuel?: boolean;
  Libelle?: string;
  ListeChamps?: ArrayOfChampDtoInput;
  ListeChampsValeur?: ArrayOfChampValeurDtoInput;
  ListeCompteursPoints?: ArrayOfCompteurPointAfpaModelInput;
  ListeEnvImpFamille?: ArrayOfEnvImpFamilleDtoInput;
  ListeFamilleProduitSectionAnalytique?: ArrayOfFamilleProduitSectionAnalytiqueDtoInput;
  ListeFamilleProduitsModeLivraison?: ArrayOfFamilleProduitModeLivraisonDtoInput;
  ListeFournisseursConventionnes?: ArrayOfFournisseurDtoInput;
  ListeModeleEcheancier?: ArrayOfModeleEcheancierGeneriqueModelInput;
  ListeMoteurRegleHeritageFamille?: ArrayOfMoteurRegleHeritageFamilleDtoInput;
  ListeMoteurRegleUseFamille?: ArrayOfMoteurRegleUseFamilleDtoInput;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementAfpaModelInput;
  ListeProduits?: ArrayOfProduitDtoInput;
  ModeAvanceCadeau?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Picto?: FichierModelInput;
  RedesendreRetourMDKSurProduit?: boolean;
  Remarque?: string;
  RetourMediaNouv?: MediaRetourDtoInput;
  RetourMediaPasNouv?: MediaRetourDtoInput;
  SessionChoix?: SessionChoixDtoInput;
  Status?: StatusDtoEnum;
  StockTypeReappro?: StockTypeReapproDtoInput;
  TypeComportementFamille?: string;
  TypeDocumentPresente?: string;
  TypeFonctionnement?: string;
};

export type FamilleProduitModeLivraisonDto = {
  __typename?: 'FamilleProduitModeLivraisonDTO';
  FamilleProduit?: FamilleProduitDto;
  IsDefaut?: boolean;
  ModeLivraison?: ModeLivraisonDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FamilleProduitModeLivraisonDtoInput = {
  FamilleProduit?: FamilleProduitDtoInput;
  IsDefaut?: boolean;
  ModeLivraison?: ModeLivraisonDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FamilleProduitModel = {
  __typename?: 'FamilleProduitModel';
  ID?: number;
  IdParent?: number;
  IsCloture?: boolean;
  Libelle?: string;
  ListProduit?: ArrayOfProduitModel;
  MustValidate?: boolean;
  MyGuid?: string;
  NbProduit?: number;
  Status?: StatusDtoEnum;
};

export type FamilleProduitModelInput = {
  ID?: number;
  IdParent?: number;
  IsCloture?: boolean;
  Libelle?: string;
  ListProduit?: ArrayOfProduitModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbProduit?: number;
  Status?: StatusDtoEnum;
};

export type FamilleProduitSectionAnalytiqueDto = {
  __typename?: 'FamilleProduitSectionAnalytiqueDTO';
  FamilleProduit?: FamilleProduitDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueDto;
  Pourcentage?: number;
  SectionAnalytique?: SectionAnalytiqueDto;
  Status?: StatusDtoEnum;
};

export type FamilleProduitSectionAnalytiqueDtoInput = {
  FamilleProduit?: FamilleProduitDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueDtoInput;
  Pourcentage?: number;
  SectionAnalytique?: SectionAnalytiqueDtoInput;
  Status?: StatusDtoEnum;
};

export type FamilleProduitSimpleModelDto = {
  __typename?: 'FamilleProduitSimpleModelDTO';
  IdFamille?: number;
  LibelleFamille?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FamilleProduitSimpleModelDtoInput = {
  IdFamille?: number;
  LibelleFamille?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FamilleWithActiviteModel = {
  __typename?: 'FamilleWithActiviteModel';
  IdActivite?: number;
  IdFamille?: number;
  Libelle?: string;
};

export type FamilleWithActiviteModelInput = {
  IdActivite?: number;
  IdFamille?: number;
  Libelle?: string;
};

export type FicheMediaMediathequeModel = {
  __typename?: 'FicheMediaMediathequeModel';
  Auteur?: string;
  BaseURLLocal?: string;
  CDU?: string;
  Cible?: string;
  CodeFamille?: string;
  Collection?: string;
  Cote?: string;
  CritiqueMedia?: string;
  DEWAY?: string;
  DateAchat?: any;
  DateAchatString?: string;
  DateDebutNouveaute?: any;
  DateEdition?: string;
  DateFinNouveaute?: any;
  DateSortie?: string;
  Duree?: string;
  Editeur?: string;
  Format?: string;
  Genre?: string;
  ISBN10?: string;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdProduit?: number;
  Image?: string;
  ImageOrigine?: string;
  ImagePerso?: string;
  IsCloture?: boolean;
  IsFamilleCloture?: boolean;
  IsMAJApi?: boolean;
  LibelleFamille?: string;
  Libre?: string;
  LieuAchat?: string;
  LivretDispoMedia?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nationalite?: string;
  NbPageOrDisk?: string;
  Note?: string;
  Numerotation?: string;
  Picto?: FichierModel;
  PrixAchat?: number;
  PrixAchatString?: string;
  Realisateur?: string;
  Reference?: string;
  SousCollec?: string;
  SousTitre?: string;
  Status?: StatusDtoEnum;
  Synopsis?: string;
  Theme?: string;
  Titre?: string;
  Type?: string;
  TypeMedia?: string;
  WithRemplacementDonneesFromAPI?: boolean;
};

export type FicheMediaMediathequeModelInput = {
  Auteur?: string;
  BaseURLLocal?: string;
  CDU?: string;
  Cible?: string;
  CodeFamille?: string;
  Collection?: string;
  Cote?: string;
  CritiqueMedia?: string;
  DEWAY?: string;
  DateAchat?: any;
  DateAchatString?: string;
  DateDebutNouveaute?: any;
  DateEdition?: string;
  DateFinNouveaute?: any;
  DateSortie?: string;
  Duree?: string;
  Editeur?: string;
  Format?: string;
  Genre?: string;
  ISBN10?: string;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdProduit?: number;
  Image?: string;
  ImageOrigine?: string;
  ImagePerso?: string;
  IsCloture?: boolean;
  IsFamilleCloture?: boolean;
  IsMAJApi?: boolean;
  LibelleFamille?: string;
  Libre?: string;
  LieuAchat?: string;
  LivretDispoMedia?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nationalite?: string;
  NbPageOrDisk?: string;
  Note?: string;
  Numerotation?: string;
  Picto?: FichierModelInput;
  PrixAchat?: number;
  PrixAchatString?: string;
  Realisateur?: string;
  Reference?: string;
  SousCollec?: string;
  SousTitre?: string;
  Status?: StatusDtoEnum;
  Synopsis?: string;
  Theme?: string;
  Titre?: string;
  Type?: string;
  TypeMedia?: string;
  WithRemplacementDonneesFromAPI?: boolean;
};

export type FicheProfilCelluleDirectoModelDto = {
  __typename?: 'FicheProfilCelluleDirectoModelDTO';
  FicheProfilBlocId?: number;
  FicheProfilDataId?: number;
  Id?: number;
  IsEditable?: boolean;
  IsMail?: boolean;
  IsObligatoire?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroColonne?: number;
  NumeroLigne?: number;
  Status?: StatusDtoEnum;
  TailleSaisie?: number;
};

export type FicheProfilCelluleDirectoModelDtoInput = {
  FicheProfilBlocId?: number;
  FicheProfilDataId?: number;
  Id?: number;
  IsEditable?: boolean;
  IsMail?: boolean;
  IsObligatoire?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroColonne?: number;
  NumeroLigne?: number;
  Status?: StatusDtoEnum;
  TailleSaisie?: number;
};

export type FicheProfilDataDirectoDto = {
  __typename?: 'FicheProfilDataDirectoDTO';
  Champ?: ChampDto;
  ChampTypeDonnee?: ChampTypeDonneeDto;
  Code?: string;
  Description?: string;
  Id?: number;
  IdChamp?: number;
  IdVue?: number;
  IdcImpCSV?: boolean;
  IdcMapAutorise?: boolean;
  IdcMapOblig?: boolean;
  IdcReadOnly?: boolean;
  IdcUpdateMassif?: number;
  JointureVue?: string;
  LargeurColonne?: number;
  Libelle?: string;
  ListeTypesDataModeleImport?: ArrayOfFicheProfilDataDirectoImportModeleTypeDto;
  LongueurMaximum?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumericMaximum?: number;
  NumericMinimum?: number;
  OrdreColonne?: number;
  SelectVue?: string;
  Status?: StatusDtoEnum;
  UpdateValeurBenef?: string;
  ValeurBenef?: string;
  ValeurVue?: string;
  ValeursPossibles?: string;
};

export type FicheProfilDataDirectoDtoInput = {
  Champ?: ChampDtoInput;
  ChampTypeDonnee?: ChampTypeDonneeDtoInput;
  Code?: string;
  Description?: string;
  Id?: number;
  IdChamp?: number;
  IdVue?: number;
  IdcImpCSV?: boolean;
  IdcMapAutorise?: boolean;
  IdcMapOblig?: boolean;
  IdcReadOnly?: boolean;
  IdcUpdateMassif?: number;
  JointureVue?: string;
  LargeurColonne?: number;
  Libelle?: string;
  ListeTypesDataModeleImport?: ArrayOfFicheProfilDataDirectoImportModeleTypeDtoInput;
  LongueurMaximum?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumericMaximum?: number;
  NumericMinimum?: number;
  OrdreColonne?: number;
  SelectVue?: string;
  Status?: StatusDtoEnum;
  UpdateValeurBenef?: string;
  ValeurBenef?: string;
  ValeurVue?: string;
  ValeursPossibles?: string;
};

export type FicheProfilDataDirectoImportModeleTypeDto = {
  __typename?: 'FicheProfilDataDirectoImportModeleTypeDTO';
  FicheProfilDataDirecto?: FicheProfilDataDirectoDto;
  ImportModeleType?: ImportModeleTypeDto;
  IsOD?: boolean;
  IsObligatoire?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheProfilDataDirectoImportModeleTypeDtoInput = {
  FicheProfilDataDirecto?: FicheProfilDataDirectoDtoInput;
  ImportModeleType?: ImportModeleTypeDtoInput;
  IsOD?: boolean;
  IsObligatoire?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheProfilDataDirectoModelDto = {
  __typename?: 'FicheProfilDataDirectoModelDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Taille?: number;
};

export type FicheProfilDataDirectoModelDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Taille?: number;
};

export type FicheProfilInfosAffichageOnglet = {
  __typename?: 'FicheProfilInfosAffichageOnglet';
  DescriptionOnglet?: string;
  IdOnglet?: number;
  IsVisibleOnglet?: boolean;
  LibelleOnglet?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheProfilInfosAffichageOngletInput = {
  DescriptionOnglet?: string;
  IdOnglet?: number;
  IsVisibleOnglet?: boolean;
  LibelleOnglet?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueActivitesModelDto = {
  __typename?: 'FicheSignaletiqueActivitesModelDTO';
  CodeTypeActivite?: string;
  HasDroitHistoriqueVente?: boolean;
  ListeCommandes?: ArrayOfDevisCommandeDto;
  ListeEnteteDevisModel?: ArrayOfEnteteDevisCommandeModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeRetourModel?: TypeRemonterModelEnum;
};

export type FicheSignaletiqueActivitesModelDtoInput = {
  CodeTypeActivite?: string;
  HasDroitHistoriqueVente?: boolean;
  ListeCommandes?: ArrayOfDevisCommandeDtoInput;
  ListeEnteteDevisModel?: ArrayOfEnteteDevisCommandeModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeRetourModel?: TypeRemonterModelEnum;
};

export type FicheSignaletiqueChampsPersoModelDto = {
  __typename?: 'FicheSignaletiqueChampsPersoModelDTO';
  ListeBenefChpVal?: ArrayOfChampValeurDto;
  ListeChamps?: ArrayOfChampDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueChampsPersoModelDtoInput = {
  ListeBenefChpVal?: ArrayOfChampValeurDtoInput;
  ListeChamps?: ArrayOfChampDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueContactModelDto = {
  __typename?: 'FicheSignaletiqueContactModelDTO';
  AdressePrincipale?: string;
  EmlPerso?: string;
  EmlPro?: string;
  Fax?: string;
  MoyenCorrespondance?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TelDom?: string;
  TelGsm?: string;
  TelPro?: string;
};

export type FicheSignaletiqueContactModelDtoInput = {
  AdressePrincipale?: string;
  EmlPerso?: string;
  EmlPro?: string;
  Fax?: string;
  MoyenCorrespondance?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TelDom?: string;
  TelGsm?: string;
  TelPro?: string;
};

export type FicheSignaletiqueCriteresSociauxModelDto = {
  __typename?: 'FicheSignaletiqueCriteresSociauxModelDTO';
  ListeChampsCalcule?: ArrayOfChampDto;
  ListeChampsNonCalcule?: ArrayOfChampDto;
  ListeCriteresSociauxCalcules?: ArrayOfChampValeurDto;
  ListeCriteresSociauxNonCalcules?: ArrayOfChampValeurDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueCriteresSociauxModelDtoInput = {
  ListeChampsCalcule?: ArrayOfChampDtoInput;
  ListeChampsNonCalcule?: ArrayOfChampDtoInput;
  ListeCriteresSociauxCalcules?: ArrayOfChampValeurDtoInput;
  ListeCriteresSociauxNonCalcules?: ArrayOfChampValeurDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export enum FicheSignaletiqueEnumDtoEnum {
  Activite = 'ACTIVITE',
  Champsperso = 'CHAMPSPERSO',
  Contact = 'CONTACT',
  Criteresociaux = 'CRITERESOCIAUX',
  Factureavoir = 'FACTUREAVOIR',
  Famille = 'FAMILLE',
  HistoEnvoi = 'HISTO_ENVOI',
  Impaye = 'IMPAYE',
  Infoce = 'INFOCE',
  Infocomptable = 'INFOCOMPTABLE',
  Infogenerale = 'INFOGENERALE',
  Mouvementcomptable = 'MOUVEMENTCOMPTABLE',
  Pmv = 'PMV',
  Point = 'POINT',
  Quota = 'QUOTA',
  Subvention = 'SUBVENTION'
}

export type FicheSignaletiqueFamilleModelDto = {
  __typename?: 'FicheSignaletiqueFamilleModelDTO';
  ListeAyantDroit?: ArrayOfAyantDroitModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  SituationFamiliale?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueFamilleModelDtoInput = {
  ListeAyantDroit?: ArrayOfAyantDroitModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  SituationFamiliale?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueImpayesModelDto = {
  __typename?: 'FicheSignaletiqueImpayesModelDTO';
  ListeFactureAPayer?: ArrayOfFactureAPayerModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueImpayesModelDtoInput = {
  ListeFactureAPayer?: ArrayOfFactureAPayerModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueInfoCeModelDto = {
  __typename?: 'FicheSignaletiqueInfoCEModelDTO';
  Categorie?: string;
  CommentaireBenef?: string;
  Contrat?: string;
  Metier?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Organisation?: string;
  Site?: string;
  Status?: StatusDtoEnum;
  TpsTravail?: number;
};

export type FicheSignaletiqueInfoCeModelDtoInput = {
  Categorie?: string;
  CommentaireBenef?: string;
  Contrat?: string;
  Metier?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Organisation?: string;
  Site?: string;
  Status?: StatusDtoEnum;
  TpsTravail?: number;
};

export type FicheSignaletiqueInfoComptableModelDto = {
  __typename?: 'FicheSignaletiqueInfoComptableModelDTO';
  CompteTiers?: string;
  ListeIBAN?: ArrayOfIbanWithBanqueModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueInfoComptableModelDtoInput = {
  CompteTiers?: string;
  ListeIBAN?: ArrayOfIbanWithBanqueModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueInfoGeneralesModelDto = {
  __typename?: 'FicheSignaletiqueInfoGeneralesModelDTO';
  BlocageDroitBoolean?: boolean;
  CleActivationSynapse?: string;
  DateCreation?: any;
  DateDebutCotisation?: any;
  DateEmbauche?: any;
  DateEnrolementSynapse?: any;
  DateFinCotisation?: any;
  DateNaiss?: any;
  DateValiditeCleActivationSynapse?: any;
  DroitActifBoolean?: boolean;
  IsHideInitialMDP?: boolean;
  LoginSynapse?: string;
  Matricule?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomJf?: string;
  PhotoBenef?: FichierModel;
  Pseudo?: string;
  Sexe?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueInfoGeneralesModelDtoInput = {
  BlocageDroitBoolean?: boolean;
  CleActivationSynapse?: string;
  DateCreation?: any;
  DateDebutCotisation?: any;
  DateEmbauche?: any;
  DateEnrolementSynapse?: any;
  DateFinCotisation?: any;
  DateNaiss?: any;
  DateValiditeCleActivationSynapse?: any;
  DroitActifBoolean?: boolean;
  IsHideInitialMDP?: boolean;
  LoginSynapse?: string;
  Matricule?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomJf?: string;
  PhotoBenef?: FichierModelInput;
  Pseudo?: string;
  Sexe?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueModelDto = {
  __typename?: 'FicheSignaletiqueModelDTO';
  FicheSignaletiqueActivitesModel?: FicheSignaletiqueActivitesModelDto;
  FicheSignaletiqueChampsPersoModel?: FicheSignaletiqueChampsPersoModelDto;
  FicheSignaletiqueContactModel?: FicheSignaletiqueContactModelDto;
  FicheSignaletiqueCriteresSociauxModel?: FicheSignaletiqueCriteresSociauxModelDto;
  FicheSignaletiqueFamilleModel?: FicheSignaletiqueFamilleModelDto;
  FicheSignaletiqueHistoriqueEnvoiModel?: ArrayOfHistoriqueCourrierHistoriquePublipostageModel;
  FicheSignaletiqueImpayesModel?: FicheSignaletiqueImpayesModelDto;
  FicheSignaletiqueInfoComptableModel?: FicheSignaletiqueInfoComptableModelDto;
  FicheSignaletiqueInfosCEModel?: FicheSignaletiqueInfoCeModelDto;
  FicheSignaletiqueInfosGeneralesModel?: FicheSignaletiqueInfoGeneralesModelDto;
  FicheSignaletiqueMouvementsComptablesModel?: FicheSignaletiqueMouvementsComptablesModelDto;
  FicheSignaletiquePointsModel?: FicheSignaletiquePointsModelDto;
  FicheSignaletiqueQuotasModel?: FicheSignaletiqueQuotasModelDto;
  FicheSignaletiqueSubventionsModel?: FicheSignaletiqueSubventionsModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueModelDtoInput = {
  FicheSignaletiqueActivitesModel?: FicheSignaletiqueActivitesModelDtoInput;
  FicheSignaletiqueChampsPersoModel?: FicheSignaletiqueChampsPersoModelDtoInput;
  FicheSignaletiqueContactModel?: FicheSignaletiqueContactModelDtoInput;
  FicheSignaletiqueCriteresSociauxModel?: FicheSignaletiqueCriteresSociauxModelDtoInput;
  FicheSignaletiqueFamilleModel?: FicheSignaletiqueFamilleModelDtoInput;
  FicheSignaletiqueHistoriqueEnvoiModel?: ArrayOfHistoriqueCourrierHistoriquePublipostageModelInput;
  FicheSignaletiqueImpayesModel?: FicheSignaletiqueImpayesModelDtoInput;
  FicheSignaletiqueInfoComptableModel?: FicheSignaletiqueInfoComptableModelDtoInput;
  FicheSignaletiqueInfosCEModel?: FicheSignaletiqueInfoCeModelDtoInput;
  FicheSignaletiqueInfosGeneralesModel?: FicheSignaletiqueInfoGeneralesModelDtoInput;
  FicheSignaletiqueMouvementsComptablesModel?: FicheSignaletiqueMouvementsComptablesModelDtoInput;
  FicheSignaletiquePointsModel?: FicheSignaletiquePointsModelDtoInput;
  FicheSignaletiqueQuotasModel?: FicheSignaletiqueQuotasModelDtoInput;
  FicheSignaletiqueSubventionsModel?: FicheSignaletiqueSubventionsModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueMouvementsComptablesModelDto = {
  __typename?: 'FicheSignaletiqueMouvementsComptablesModelDTO';
  HaveMouvementsFiltres?: boolean;
  ListeMouvementComptable?: ArrayOfComptaMouvementComptableModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueMouvementsComptablesModelDtoInput = {
  HaveMouvementsFiltres?: boolean;
  ListeMouvementComptable?: ArrayOfComptaMouvementComptableModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiquePointsModelDto = {
  __typename?: 'FicheSignaletiquePointsModelDTO';
  ListeSommeCptBenef?: ArrayOfSommeCompteurPointModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiquePointsModelDtoInput = {
  ListeSommeCptBenef?: ArrayOfSommeCompteurPointModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueQuotasModelDto = {
  __typename?: 'FicheSignaletiqueQuotasModelDTO';
  ListeEnveloppes?: ArrayOfModeleConsoEnvQuotaDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueQuotasModelDtoInput = {
  ListeEnveloppes?: ArrayOfModeleConsoEnvQuotaDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueSubventionsModelDto = {
  __typename?: 'FicheSignaletiqueSubventionsModelDTO';
  ListeEnveloppes?: ArrayOfModeleConsoEnvQuotaDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FicheSignaletiqueSubventionsModelDtoInput = {
  ListeEnveloppes?: ArrayOfModeleConsoEnvQuotaDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FichierCommandeModel = {
  __typename?: 'FichierCommandeModel';
  DateModif?: any;
  FileName?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomUserModif?: string;
  PrenomUserModif?: string;
  Status?: StatusDtoEnum;
  Token?: string;
};

export type FichierCommandeModelInput = {
  DateModif?: any;
  FileName?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomUserModif?: string;
  PrenomUserModif?: string;
  Status?: StatusDtoEnum;
  Token?: string;
};

export type FichierCompletModel = {
  __typename?: 'FichierCompletModel';
  AlbumId?: number;
  AlbumName?: string;
  CategCode?: string;
  CategorieLibelle?: string;
  DateCreation?: any;
  DateDebut?: any;
  DateFin?: any;
  EditCategCode?: string;
  EditCategLibelle?: string;
  Extension?: string;
  FileBytes?: string;
  Filename?: string;
  IdFile?: number;
  IdLienFichier?: number;
  IsCommentable?: boolean;
  IsFichierClient?: boolean;
  IsLikeable?: boolean;
  LibelleLien?: string;
  OrigineCode?: string;
  RemarqueLien?: string;
  StatutCode?: string;
  StatutLibelle?: string;
  Tags?: ArrayOfstring;
  Taille?: number;
  Token?: string;
  TypeFichierIcone?: string;
  TypeFichierLibelle?: string;
  Url?: string;
};

export type FichierCompletModelInput = {
  AlbumId?: number;
  AlbumName?: string;
  CategCode?: string;
  CategorieLibelle?: string;
  DateCreation?: any;
  DateDebut?: any;
  DateFin?: any;
  EditCategCode?: string;
  EditCategLibelle?: string;
  Extension?: string;
  FileBytes?: string;
  Filename?: string;
  IdFile?: number;
  IdLienFichier?: number;
  IsCommentable?: boolean;
  IsFichierClient?: boolean;
  IsLikeable?: boolean;
  LibelleLien?: string;
  OrigineCode?: string;
  RemarqueLien?: string;
  StatutCode?: string;
  StatutLibelle?: string;
  Tags?: ArrayOfstringInput;
  Taille?: number;
  Token?: string;
  TypeFichierIcone?: string;
  TypeFichierLibelle?: string;
  Url?: string;
};

export type FichierModel = {
  __typename?: 'FichierModel';
  CategCode?: string;
  Extension?: string;
  FileBytes?: string;
  Filename?: string;
  IdFile?: number;
  IdFileAliznet?: string;
  IsFichierClient?: boolean;
  LibelleLien?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarqueLien?: string;
  Status?: StatusDtoEnum;
  Taille?: number;
  Token?: string;
  TypeFichierLibelle?: string;
  Url?: string;
  UuidFileSynapse?: string;
};

export type FichierModelInput = {
  CategCode?: string;
  Extension?: string;
  FileBytes?: string;
  Filename?: string;
  IdFile?: number;
  IdFileAliznet?: string;
  IsFichierClient?: boolean;
  LibelleLien?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarqueLien?: string;
  Status?: StatusDtoEnum;
  Taille?: number;
  Token?: string;
  TypeFichierLibelle?: string;
  Url?: string;
  UuidFileSynapse?: string;
};

export type FichierTypeModel = {
  __typename?: 'FichierTypeModel';
  Code?: string;
  Extension?: string;
  Id?: number;
  Libelle?: string;
  MimeType?: string;
};

export type FichierTypeModelInput = {
  Code?: string;
  Extension?: string;
  Id?: number;
  Libelle?: string;
  MimeType?: string;
};

export type FilDArianeFpaModel = {
  __typename?: 'FilDArianeFPAModel';
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FilDArianeFpaModelInput = {
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FiltrageBenefModeExpertModelDtoInput = {
  Adresse?: string;
  AgeMaxAyantDroit?: number;
  AgeMinAyantDroit?: number;
  CodePostal?: string;
  DateCreationEnd?: any;
  DateCreationOperator?: string;
  DateCreationSQL?: string;
  DateCreationStart?: any;
  DateEmbaucheEnd?: any;
  DateEmbaucheOperator?: string;
  DateEmbaucheSQL?: string;
  DateEmbaucheStart?: any;
  DateNaissanceEnd?: any;
  DateNaissanceOperator?: string;
  DateNaissanceSQL?: string;
  DateNaissanceStart?: any;
  Email?: string;
  FiltreCommutatif?: boolean;
  FiltreOrganisation?: string;
  FiltreSite?: string;
  HaveEnfantACharge?: boolean;
  HaveEnfantHandicape?: boolean;
  HaveEnfantRattache?: boolean;
  IdCycleScolaire?: number;
  IsConjointValide?: boolean;
  IsCriteresSociauxValides?: boolean;
  IsEnfantValide?: boolean;
  IsExterneValide?: boolean;
  ListeFiltres?: ArrayOfKeyValueModelDtoInput;
  Matricule?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomAD?: string;
  NomBenef?: string;
  PrendreOrgaAssocie?: boolean;
  PrendreSiteAssocie?: boolean;
  PrenomAD?: string;
  PrenomBenef?: string;
  Status?: StatusDtoEnum;
  Telephone?: string;
  TexteRecherche?: string;
  Ville?: string;
  VoirBenefEnErreur?: boolean;
  VoirBenefNonSynchro?: boolean;
  VoirBenefSansProfilKalidea?: boolean;
  VoirBenefSubNonSynchro?: boolean;
  VoirDroitActif?: boolean;
  VoirHorsDroit?: boolean;
  VoirTousDroits?: boolean;
};

export type FiltresRemiseEnCaisseCentraleModel = {
  __typename?: 'FiltresRemiseEnCaisseCentraleModel';
  CaisseSelectionnee?: CaisseCaisseBaseModel;
  ListeCaissesDisponibles?: ArrayOfCaisseCaisseBaseModel;
  ListeMoyensPaiement?: ArrayOfMoyenPaiementMoyenPaiementSelectionableModel;
};

export type FiltresRemiseEnCaisseCentraleModelInput = {
  CaisseSelectionnee?: CaisseCaisseBaseModelInput;
  ListeCaissesDisponibles?: ArrayOfCaisseCaisseBaseModelInput;
  ListeMoyensPaiement?: ArrayOfMoyenPaiementMoyenPaiementSelectionableModelInput;
};

export type FonctionnalitesProfilModel = {
  __typename?: 'FonctionnalitesProfilModel';
  CodeFonctionnalite?: string;
  DescriptionFonctionnalite?: string;
  IdFonctionnalite?: number;
  IsChecked?: boolean;
  LibelleFonctionnalite?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FonctionnalitesProfilModelInput = {
  CodeFonctionnalite?: string;
  DescriptionFonctionnalite?: string;
  IdFonctionnalite?: number;
  IsChecked?: boolean;
  LibelleFonctionnalite?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export enum FormatExportEnum {
  Ancv = 'ANCV',
  Cesu = 'CESU'
}

export type FormulaireCommandeClotureModel = {
  __typename?: 'FormulaireCommandeClotureModel';
  IdActivite?: number;
  IdDelegation?: number;
  IdFormulaire?: number;
  IsCloture?: boolean;
  IsEditable?: boolean;
  IsSupprimable?: boolean;
  LibelleFormulaire?: string;
};

export type FormulaireCommandeClotureModelInput = {
  IdActivite?: number;
  IdDelegation?: number;
  IdFormulaire?: number;
  IsCloture?: boolean;
  IsEditable?: boolean;
  IsSupprimable?: boolean;
  LibelleFormulaire?: string;
};

export type FormulaireCommandeFullModelInput = {
  IdActivite?: number;
  IdDelegation?: number;
  IdFormulaire?: number;
  IsCloture?: boolean;
  LibelleFormulaire?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FormulaireDto = {
  __typename?: 'FormulaireDTO';
  Activite?: ActiviteDto;
  CEDelegation?: CeDelegationDto;
  Id?: number;
  IsClos?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FormulaireDtoInput = {
  Activite?: ActiviteDtoInput;
  CEDelegation?: CeDelegationDtoInput;
  Id?: number;
  IsClos?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FormulaireFpaModel = {
  __typename?: 'FormulaireFPAModel';
  IdElement?: number;
  IdFormulaireCommande?: number;
  IdFormulaireLigne?: number;
  IsArticleUnitaire?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreSurEnfants?: boolean;
  Status?: StatusDtoEnum;
  TypeElement?: TypeAfpaEnum;
};

export type FormulaireFpaModelInput = {
  IdElement?: number;
  IdFormulaireCommande?: number;
  IdFormulaireLigne?: number;
  IsArticleUnitaire?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreSurEnfants?: boolean;
  Status?: StatusDtoEnum;
  TypeElement?: TypeAfpaEnum;
};

export type FormulaireFullModel = {
  __typename?: 'FormulaireFullModel';
  InfosFormulaire?: any;
  ListeSection?: ArrayOfanyType;
  ListeSectionObservable?: ArrayOfFormulaireSectionGestionModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FormulaireFullModelInput = {
  InfosFormulaire?: any;
  ListeSection?: ArrayOfanyTypeInput;
  ListeSectionObservable?: ArrayOfFormulaireSectionGestionModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type FormulaireSectionGestionModel = {
  __typename?: 'FormulaireSectionGestionModel';
  DescriptionSection?: string;
  IdSection?: number;
  IsToDelete?: boolean;
  LibelleSection?: string;
  ListeChampFormulaire?: ArrayOfanyType;
  ListeChampFormulaireObservable?: ArrayOfChampsSectionFormulaireFullModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type FormulaireSectionGestionModelInput = {
  DescriptionSection?: string;
  IdSection?: number;
  IsToDelete?: boolean;
  LibelleSection?: string;
  ListeChampFormulaire?: ArrayOfanyTypeInput;
  ListeChampFormulaireObservable?: ArrayOfChampsSectionFormulaireFullModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type FormulePrestationModelDto = {
  __typename?: 'FormulePrestationModelDTO';
  IdFormule?: number;
  IdPrestation?: number;
  IsCloturee?: boolean;
  LibelleNombreUnite?: string;
  LibelleNombreUniteTotal?: string;
  ModeRemboursement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Quotite?: number;
  Status?: StatusDtoEnum;
  TextFormule?: string;
  TextPrestation?: string;
};

export type FormulePrestationModelDtoInput = {
  IdFormule?: number;
  IdPrestation?: number;
  IsCloturee?: boolean;
  LibelleNombreUnite?: string;
  LibelleNombreUniteTotal?: string;
  ModeRemboursement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Quotite?: number;
  Status?: StatusDtoEnum;
  TextFormule?: string;
  TextPrestation?: string;
};

export type FournisseurBaseModel = {
  __typename?: 'FournisseurBaseModel';
  IdFournisseur?: number;
  NomFournisseur?: string;
};

export type FournisseurBaseModelInput = {
  IdFournisseur?: number;
  NomFournisseur?: string;
};

export type FournisseurDto = {
  __typename?: 'FournisseurDTO';
  Adresse?: AdresseDto;
  CodeClient?: string;
  CodeM?: string;
  CompteCommission?: CompteDto;
  CompteTiers?: CompteDto;
  ConcerneAideSociale?: boolean;
  ConcerneFonctionnement?: boolean;
  Contacts?: ArrayOfContactDto;
  Description?: string;
  Email?: string;
  EstCloture?: boolean;
  Fax?: string;
  Id?: number;
  JournalCommission?: JournalDto;
  ListeArticles?: ArrayOfArticleDto;
  ListeCompteEcriture?: ArrayOfCompteEcritureDto;
  ListeFamilles?: ArrayOfFamilleProduitDto;
  ListeFamillesConventionnees?: ArrayOfFamilleProduitDto;
  ListePlanSectionAnalytique?: ArrayOfPlanWithSectionsAnalytiquesModel;
  ListeProduits?: ArrayOfProduitDto;
  ListeProduitsConventionnes?: ArrayOfProduitDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  NumContrat?: string;
  NumeroSiret?: string;
  PourCommis?: number;
  Remarque?: string;
  RemiseFournisseur?: number;
  Ribs?: ArrayOfRibDto;
  SiteWeb?: string;
  Status?: StatusDtoEnum;
  TelephonePrimaire?: string;
  TelephoneSecondaire?: string;
  UseCompteCourant?: boolean;
};

export type FournisseurDtoInput = {
  Adresse?: AdresseDtoInput;
  CodeClient?: string;
  CodeM?: string;
  CompteCommission?: CompteDtoInput;
  CompteTiers?: CompteDtoInput;
  ConcerneAideSociale?: boolean;
  ConcerneFonctionnement?: boolean;
  Contacts?: ArrayOfContactDtoInput;
  Description?: string;
  Email?: string;
  EstCloture?: boolean;
  Fax?: string;
  Id?: number;
  JournalCommission?: JournalDtoInput;
  ListeArticles?: ArrayOfArticleDtoInput;
  ListeCompteEcriture?: ArrayOfCompteEcritureDtoInput;
  ListeFamilles?: ArrayOfFamilleProduitDtoInput;
  ListeFamillesConventionnees?: ArrayOfFamilleProduitDtoInput;
  ListePlanSectionAnalytique?: ArrayOfPlanWithSectionsAnalytiquesModelInput;
  ListeProduits?: ArrayOfProduitDtoInput;
  ListeProduitsConventionnes?: ArrayOfProduitDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  NumContrat?: string;
  NumeroSiret?: string;
  PourCommis?: number;
  Remarque?: string;
  RemiseFournisseur?: number;
  Ribs?: ArrayOfRibDtoInput;
  SiteWeb?: string;
  Status?: StatusDtoEnum;
  TelephonePrimaire?: string;
  TelephoneSecondaire?: string;
  UseCompteCourant?: boolean;
};

export type FournisseurModelDto = {
  __typename?: 'FournisseurModelDTO';
  CodeFour?: string;
  IdCompteFraisComFour?: number;
  IdFournisseur?: number;
  IsUtilisableFonctionnement?: boolean;
  IsUtilisableSocial?: boolean;
  MontFraisComFour?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomFour?: string;
  Status?: StatusDtoEnum;
};

export type FournisseurModelDtoInput = {
  CodeFour?: string;
  IdCompteFraisComFour?: number;
  IdFournisseur?: number;
  IsUtilisableFonctionnement?: boolean;
  IsUtilisableSocial?: boolean;
  MontFraisComFour?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomFour?: string;
  Status?: StatusDtoEnum;
};

export type FournisseurRemiseGlobaleModel = {
  __typename?: 'FournisseurRemiseGlobaleModel';
  IdFournisseur?: number;
  IsClos?: boolean;
  NomFournisseur?: string;
  RemiseGlobale?: number;
};

export type FournisseurRemiseGlobaleModelInput = {
  IdFournisseur?: number;
  IsClos?: boolean;
  NomFournisseur?: string;
  RemiseGlobale?: number;
};

export type FraisAnnulationBaseModel = {
  __typename?: 'FraisAnnulationBaseModel';
  IdFraisAnnulation?: number;
  LibelleFraisAnnulation?: string;
};

export type FraisAnnulationBaseModelInput = {
  IdFraisAnnulation?: number;
  LibelleFraisAnnulation?: string;
};

export type FraisAnnulationFpaModel = {
  __typename?: 'FraisAnnulationFPAModel';
  IdElement?: number;
  IdModeleFraisAnnulation?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreSurEnfants?: boolean;
  Status?: StatusDtoEnum;
  TypeElement?: TypeAfpaEnum;
};

export type FraisAnnulationFpaModelInput = {
  IdElement?: number;
  IdModeleFraisAnnulation?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreSurEnfants?: boolean;
  Status?: StatusDtoEnum;
  TypeElement?: TypeAfpaEnum;
};

export type FraisAnnulationModel = {
  __typename?: 'FraisAnnulationModel';
  CodeTypeFraisDefaut?: string;
  IdActivite?: number;
  IdCompteFraisImputation?: number;
  IdModeleFraisAnnulation?: number;
  LibelleModeleFrais?: string;
  ListeLigneFraisAnnulationModel?: ArrayOfLigneFraisAnnulationModel;
  ListePlanSectionAnalytique?: ArrayOfPlanWithSectionsAnalytiquesModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ValeurDefaut?: number;
};

export type FraisAnnulationModelInput = {
  CodeTypeFraisDefaut?: string;
  IdActivite?: number;
  IdCompteFraisImputation?: number;
  IdModeleFraisAnnulation?: number;
  LibelleModeleFrais?: string;
  ListeLigneFraisAnnulationModel?: ArrayOfLigneFraisAnnulationModelInput;
  ListePlanSectionAnalytique?: ArrayOfPlanWithSectionsAnalytiquesModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ValeurDefaut?: number;
};

export type FraisAnnulationSupprimableModel = {
  __typename?: 'FraisAnnulationSupprimableModel';
  IdFraisAnnulation?: number;
  IsSupprimable?: boolean;
  LibelleFraisAnnulation?: string;
};

export type FraisAnnulationSupprimableModelInput = {
  IdFraisAnnulation?: number;
  IsSupprimable?: boolean;
  LibelleFraisAnnulation?: string;
};

export type GedCriteresFiltrageGedModelInput = {
  CodeCateg?: string;
  CodeEditCateg?: string;
  CodeTypeFichiers?: string;
  CodeUsage?: string;
  FileLibelleContain?: string;
  IdCategorie?: number;
  IdCe?: number;
  IdTypeFichiers?: number;
  IsCommentables?: boolean;
  IsDateDepassee?: boolean;
  IsEnAttente?: boolean;
  IsFichierClient?: boolean;
  IsLikable?: boolean;
  IsNonLie?: boolean;
  LibelleTypeFichiers?: string;
  ListeCodeTypeFiles?: ArrayOfstringInput;
  ListeTokens?: ArrayOfstringInput;
  MotCles?: string;
  NotListeCodeCategFiles?: ArrayOfstringInput;
  OrderByCategorie?: boolean;
  OrderByID?: boolean;
  OrderByLibelle?: boolean;
  OrderByTaille?: boolean;
  OrderByType?: boolean;
  RechercheTags?: string;
  Skip?: number;
  StatutId?: number;
  Take?: number;
};

export type GedInitialisationModuleGestionGedAlbumModel = {
  __typename?: 'GEDInitialisationModuleGestionGEDAlbumModel';
  ListeAlbums?: GedListeAlbumsGedModel;
  ListeCategories?: ArrayOfPortailDocumentCategorieDto;
  ListeStatut?: ArrayOfPortailStatutDto;
  ListeTypes?: ArrayOfFichierTypeModel;
};

export type GedInitialisationModuleGestionGedAlbumModelInput = {
  ListeAlbums?: GedListeAlbumsGedModelInput;
  ListeCategories?: ArrayOfPortailDocumentCategorieDtoInput;
  ListeStatut?: ArrayOfPortailStatutDtoInput;
  ListeTypes?: ArrayOfFichierTypeModelInput;
};

export type GedInitialisationModuleGestionGedDocumentModel = {
  __typename?: 'GEDInitialisationModuleGestionGEDDocumentModel';
  ListeCategories?: ArrayOfPortailDocumentCategorieDto;
  ListeDocuments?: GedListeDocumentsGedModel;
  ListeStatut?: ArrayOfPortailStatutDto;
  ListeTypes?: ArrayOfstring;
};

export type GedInitialisationModuleGestionGedDocumentModelInput = {
  ListeCategories?: ArrayOfPortailDocumentCategorieDtoInput;
  ListeDocuments?: GedListeDocumentsGedModelInput;
  ListeStatut?: ArrayOfPortailStatutDtoInput;
  ListeTypes?: ArrayOfstringInput;
};

export type GedListeAlbumsGedModel = {
  __typename?: 'GEDListeAlbumsGEDModel';
  ListeAlbums?: ArrayOfPortailAlbumDto;
  NbElementTot?: number;
};

export type GedListeAlbumsGedModelInput = {
  ListeAlbums?: ArrayOfPortailAlbumDtoInput;
  NbElementTot?: number;
};

export type GedListeDocumentsGedModel = {
  __typename?: 'GEDListeDocumentsGEDModel';
  ListeDocuments?: ArrayOfFichierCompletModel;
  NbElementTot?: number;
};

export type GedListeDocumentsGedModelInput = {
  ListeDocuments?: ArrayOfFichierCompletModelInput;
  NbElementTot?: number;
};

export type GenerationArticleLocationModelInput = {
  DateVenteAu?: any;
  DateVenteDu?: any;
  ListErreur?: ArrayOfErreurValidationInput;
  ListeCompteurs?: ArrayOfCompteurImputNbPointModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbJour?: number;
  PlageAu?: any;
  PlageDu?: any;
  PrixAchat?: number;
  PrixPublic?: number;
  PrixVente?: number;
  Quantite?: string;
  Quotite?: string;
  SelectedCompteurs?: CompteurPointDtoInput;
  Status?: StatusDtoEnum;
};

export type GenerationBlbrModelDtoInput = {
  DateBon?: any;
  IdActivite?: number;
  IdFournisseur?: number;
  IdModeLivraison?: number;
  IdOrganisation?: number;
  IdSite?: number;
  IdStock?: number;
  IsLivraisonGroupeClientForLgeCdeFour?: boolean;
  ListeIdCommande?: ArrayOfdecimalInput;
  ListeIdLigne?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeActivite?: string;
  TypeCommande?: string;
};

export type GenerationEcritureDecaissementModelInput = {
  DateEcriture?: any;
  IdCECible?: number;
  IdCECreePar?: number;
  IdCESource?: number;
  IdCaisse?: number;
  IdCompteDecaissement?: number;
  IdEcriture?: number;
  IdEtat?: number;
  IdJournal?: number;
  IdUtilisateur?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumPiece?: number;
  Status?: StatusDtoEnum;
  TypeEcriture?: TypeEcritureInput;
};

export type GenereationEcheancierModeleInput = {
  IdCompteBancaire?: number;
  IdCompteCollectif?: number;
  IdJournal?: number;
  ListeIdCommandes?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type GenererPermanenceModelInput = {
  DateDebutPlage?: any;
  DateFinPlage?: any;
  IdPermanence?: number;
  ListeJoursFeries?: ArrayOfJourModelInput;
  ListeJoursOuverture?: ArrayOfJourModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Occurence?: number;
  Status?: StatusDtoEnum;
};

export type GestionIndentifiantModelDtoInput = {
  GarderLoginAct?: boolean;
  GarderMDPActuel?: boolean;
  LOGDEF?: ChampListeValeurDtoInput;
  MDPDEF?: ChampListeValeurDtoInput;
  MotPasseFixe?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RegenererLogin?: boolean;
  RegenererMDPInit?: boolean;
  ReprendreMDPInit?: boolean;
  Status?: StatusDtoEnum;
};

export type GestionnaireDto = {
  __typename?: 'GestionnaireDTO';
  AdresseMailPerso?: string;
  AdresseMailPro?: string;
  IdUser?: number;
  MailPerso?: boolean;
  MailPro?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomGestionnaire?: string;
  PrenomGestionnaire?: string;
  Status?: StatusDtoEnum;
};

export type GestionnaireDtoInput = {
  AdresseMailPerso?: string;
  AdresseMailPro?: string;
  IdUser?: number;
  MailPerso?: boolean;
  MailPro?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomGestionnaire?: string;
  PrenomGestionnaire?: string;
  Status?: StatusDtoEnum;
};

export type GraphiqueModelDto = {
  __typename?: 'GraphiqueModelDTO';
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Pourcentage?: number;
  Status?: StatusDtoEnum;
  Valeur?: number;
};

export type GraphiqueModelDtoInput = {
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Pourcentage?: number;
  Status?: StatusDtoEnum;
  Valeur?: number;
};

export type GroupePubliGroupeOrdreModel = {
  __typename?: 'GroupePubliGroupeOrdreModel';
  IdGroupe?: number;
  LibelleGroupe?: string;
  Ordre?: number;
};

export type GroupePubliGroupeOrdreModelInput = {
  IdGroupe?: number;
  LibelleGroupe?: string;
  Ordre?: number;
};

export type GroupeRoomingListModel = {
  __typename?: 'GroupeRoomingListModel';
  IdGroupe?: number;
  LibelleGroupe?: string;
  ListeIdCommande?: ArrayOfdecimal;
  ListeIdODCommande?: ArrayOfNullableOfdecimal;
  ListeParticipants?: ArrayOfanyType;
};

export type GroupeRoomingListModelInput = {
  IdGroupe?: number;
  LibelleGroupe?: string;
  ListeIdCommande?: ArrayOfdecimalInput;
  ListeIdODCommande?: ArrayOfNullableOfdecimalInput;
  ListeParticipants?: ArrayOfanyTypeInput;
};

export type GroupeVenteEnLigneFamProduitModel = {
  __typename?: 'GroupeVenteEnLigneFamProduitModel';
  AfficherNbInscrits?: boolean;
  AfficherNbPlacesDispo?: boolean;
  AfficherNbPlacesTotales?: boolean;
  AutoriserCommandesEnLigne?: boolean;
  DateDebutVisibilite?: any;
  DateFinVisibilite?: any;
  HasCompteAcompte?: boolean;
  IdElement?: number;
  IsAcompteObligatoireEnLigne?: boolean;
  IsAfficheEnLigne?: boolean;
  IsFacturationManuelle?: boolean;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreVenteEnLigne?: boolean;
  Status?: StatusDtoEnum;
};

export type GroupeVenteEnLigneFamProduitModelInput = {
  AfficherNbInscrits?: boolean;
  AfficherNbPlacesDispo?: boolean;
  AfficherNbPlacesTotales?: boolean;
  AutoriserCommandesEnLigne?: boolean;
  DateDebutVisibilite?: any;
  DateFinVisibilite?: any;
  HasCompteAcompte?: boolean;
  IdElement?: number;
  IsAcompteObligatoireEnLigne?: boolean;
  IsAfficheEnLigne?: boolean;
  IsFacturationManuelle?: boolean;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreVenteEnLigne?: boolean;
  Status?: StatusDtoEnum;
};

export type GroupesInformationsArticleModel = {
  __typename?: 'GroupesInformationsArticleModel';
  CodeArticle?: string;
  CodeBarre?: string;
  DatePriseEnCompteSub?: any;
  Description?: string;
  IdArticle?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdProduit?: number;
  IsArticleNominatif?: boolean;
  IsArticleOption?: boolean;
  IsCloture?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbPlacesDispos?: number;
  Quotite?: number;
  RemarqueArticle?: string;
  Status?: StatusDtoEnum;
};

export type GroupesInformationsArticleModelInput = {
  CodeArticle?: string;
  CodeBarre?: string;
  DatePriseEnCompteSub?: any;
  Description?: string;
  IdArticle?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdProduit?: number;
  IsArticleNominatif?: boolean;
  IsArticleOption?: boolean;
  IsCloture?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbPlacesDispos?: number;
  Quotite?: number;
  RemarqueArticle?: string;
  Status?: StatusDtoEnum;
};

export type GroupesInformationsFamilleModel = {
  __typename?: 'GroupesInformationsFamilleModel';
  CodeFamille?: string;
  Description?: string;
  IdActivite?: number;
  IdCourrierAcceptation?: number;
  IdCourrierRefus?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdSessionChoix?: number;
  IsCloture?: boolean;
  IsFacturationManuelle?: boolean;
  LibelleFamille?: string;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedAcceptationCE?: boolean;
  RedescendreAcceptation?: boolean;
  RedescendreParametrageAcompte?: boolean;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type GroupesInformationsFamilleModelInput = {
  CodeFamille?: string;
  Description?: string;
  IdActivite?: number;
  IdCourrierAcceptation?: number;
  IdCourrierRefus?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdSessionChoix?: number;
  IsCloture?: boolean;
  IsFacturationManuelle?: boolean;
  LibelleFamille?: string;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedAcceptationCE?: boolean;
  RedescendreAcceptation?: boolean;
  RedescendreParametrageAcompte?: boolean;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type GroupesInformationsProduitModel = {
  __typename?: 'GroupesInformationsProduitModel';
  CodeProduit?: string;
  DateDebutEvenement?: any;
  DateDebutVente?: any;
  DateFinEvenement?: any;
  DateFinVente?: any;
  DatePriseEnCompteSub?: any;
  DescriptionProduit?: string;
  IdAnneeReference?: number;
  IdCourrierAcceptation?: number;
  IdCourrierRefus?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdProduit?: number;
  IdSessionChoix?: number;
  IsCloture?: boolean;
  IsFacturationCentralisee?: boolean;
  IsFacturationManuelle?: boolean;
  LibelleProduit?: string;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbPlacesDispo?: number;
  NeedAcceptationCE?: boolean;
  RemarqueProduit?: string;
  Status?: StatusDtoEnum;
};

export type GroupesInformationsProduitModelInput = {
  CodeProduit?: string;
  DateDebutEvenement?: any;
  DateDebutVente?: any;
  DateFinEvenement?: any;
  DateFinVente?: any;
  DatePriseEnCompteSub?: any;
  DescriptionProduit?: string;
  IdAnneeReference?: number;
  IdCourrierAcceptation?: number;
  IdCourrierRefus?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdProduit?: number;
  IdSessionChoix?: number;
  IsCloture?: boolean;
  IsFacturationCentralisee?: boolean;
  IsFacturationManuelle?: boolean;
  LibelleProduit?: string;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbPlacesDispo?: number;
  NeedAcceptationCE?: boolean;
  RemarqueProduit?: string;
  Status?: StatusDtoEnum;
};

export type HaveStatutComplementaireModel = {
  __typename?: 'HaveStatutComplementaireModel';
  HaveStatutCompAttente?: boolean;
  HaveStatutCompFacturable?: boolean;
  HaveStatutCompFacture?: boolean;
  HaveStatutCompFacturePartiellement?: boolean;
  HaveStatutCompRefuse?: boolean;
  HaveStautCompAnnule?: boolean;
};

export type HaveStatutComplementaireModelInput = {
  HaveStatutCompAttente?: boolean;
  HaveStatutCompFacturable?: boolean;
  HaveStatutCompFacture?: boolean;
  HaveStatutCompFacturePartiellement?: boolean;
  HaveStatutCompRefuse?: boolean;
  HaveStautCompAnnule?: boolean;
};

export type HelperFileDownload = {
  __typename?: 'HelperFileDownload';
  FullPath?: string;
  NomFichier?: string;
  NomFichierGuid?: string;
};

export type HelperFileDownloadInput = {
  FullPath?: string;
  NomFichier?: string;
  NomFichierGuid?: string;
};

export type HeureModel = {
  __typename?: 'HeureModel';
  HeureDebut?: any;
  HeureFin?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type HeureModelInput = {
  HeureDebut?: any;
  HeureFin?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type HistoStatutCommandeDto = {
  __typename?: 'HistoStatutCommandeDTO';
  Commande?: DevisCommandeDto;
  DateHisto?: any;
  Id?: number;
  LigneCommande?: LigneCommandeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarquePriveCE?: string;
  RemarquePublic?: string;
  Status?: StatusDtoEnum;
  StatutCde?: StatutCommandeDto;
  StatutPersoCde?: StatutPersoCommandeDto;
  User?: UsersDto;
};

export type HistoStatutCommandeDtoInput = {
  Commande?: DevisCommandeDtoInput;
  DateHisto?: any;
  Id?: number;
  LigneCommande?: LigneCommandeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarquePriveCE?: string;
  RemarquePublic?: string;
  Status?: StatusDtoEnum;
  StatutCde?: StatutCommandeDtoInput;
  StatutPersoCde?: StatutPersoCommandeDtoInput;
  User?: UsersDtoInput;
};

export type HistoStatutFactureDto = {
  __typename?: 'HistoStatutFactureDTO';
  DateHistorique?: any;
  Facture?: FactureDto;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
  StatutFacture?: StatutFactureDto;
};

export type HistoStatutFactureDtoInput = {
  DateHistorique?: any;
  Facture?: FactureDtoInput;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
  StatutFacture?: StatutFactureDtoInput;
};

export type HistoriqueCourrierCriteresHistoriqueEnvoiModelInput = {
  Comparateur?: string;
  DateDebutEnvoi?: any;
  DateFinEnvoi?: any;
  Id?: number;
  IdBenefConcerne?: number;
  IdCe?: number;
  IdContextePublipostage?: number;
  IdTheme?: number;
  IsClos?: boolean;
  IsCourrier?: boolean;
  IsMail?: boolean;
  IsNewsletter?: boolean;
  IsPublipostage?: boolean;
  ListeIdBenefConcerne?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbSkip?: number;
  NbTakes?: number;
  NomPrenomBenefStartWith?: string;
  OrderByDate?: boolean;
  Status?: StatusDtoEnum;
  TextRecherchePublipostage?: string;
};

export type HistoriqueCourrierHistoriquePublipostageModel = {
  __typename?: 'HistoriqueCourrierHistoriquePublipostageModel';
  Contexte?: string;
  DateEnvoi?: any;
  IdHistoriqueCourrier?: number;
  LibelleDelegation?: string;
  ListeThemes?: ArrayOfstring;
  NombreEnvoye?: number;
  Objet?: string;
  TotalEnvoi?: number;
  Type?: string;
};

export type HistoriqueCourrierHistoriquePublipostageModelInput = {
  Contexte?: string;
  DateEnvoi?: any;
  IdHistoriqueCourrier?: number;
  LibelleDelegation?: string;
  ListeThemes?: ArrayOfstringInput;
  NombreEnvoye?: number;
  Objet?: string;
  TotalEnvoi?: number;
  Type?: string;
};

export type HistoriqueImpressionCourrierDto = {
  __typename?: 'HistoriqueImpressionCourrierDTO';
  BasDePage?: string;
  CEDelegation?: CeDelegationDto;
  Corps?: string;
  Courrier?: CourrierDto;
  DateCreation?: any;
  Id?: number;
  Intro?: string;
  IsAdresseCEVisible?: boolean;
  IsLogoVisible?: boolean;
  IsSignatureCEVisible?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Objet?: string;
  PiedDePage?: string;
  SignatureCE?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
  Users?: UsersDto;
};

export type HistoriqueImpressionCourrierDtoInput = {
  BasDePage?: string;
  CEDelegation?: CeDelegationDtoInput;
  Corps?: string;
  Courrier?: CourrierDtoInput;
  DateCreation?: any;
  Id?: number;
  Intro?: string;
  IsAdresseCEVisible?: boolean;
  IsLogoVisible?: boolean;
  IsSignatureCEVisible?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Objet?: string;
  PiedDePage?: string;
  SignatureCE?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
  Users?: UsersDtoInput;
};

export type HistoriqueModifBenefsHistoriqueModifBenefForAffichageModel = {
  __typename?: 'HistoriqueModifBenefsHistoriqueModifBenefForAffichageModel';
  BenefNom?: string;
  DateModif?: any;
  IdBenef?: number;
  IdChamp?: number;
  IdUser?: number;
  LibelleChamp?: string;
  NewValue?: string;
  OldValue?: string;
  OrigineModif?: string;
  UserNom?: string;
};

export type HistoriqueModifBenefsHistoriqueModifBenefForAffichageModelInput = {
  BenefNom?: string;
  DateModif?: any;
  IdBenef?: number;
  IdChamp?: number;
  IdUser?: number;
  LibelleChamp?: string;
  NewValue?: string;
  OldValue?: string;
  OrigineModif?: string;
  UserNom?: string;
};

export type HistoriqueSalarieModel = {
  __typename?: 'HistoriqueSalarieModel';
  HistoCommandeVisible?: boolean;
  ListeComptesPMV?: ArrayOfCompteLightVisibleEnLigneModel;
  ListeEnveloppe?: ArrayOfEnveloppeAfpaModel;
  ListeEnveloppeAttribTransOuChoisie?: ArrayOfEnveloppeBaseSelectedModel;
  MustValidate?: boolean;
  MyGuid?: string;
  PointsMaximumVisible?: boolean;
  PointsMinimumVisible?: boolean;
  PointsMoyenneVisible?: boolean;
  PointsVisible?: boolean;
  SoldeEnveloppesVisible?: boolean;
  Status?: StatusDtoEnum;
  SubventionsVisible?: boolean;
};

export type HistoriqueSalarieModelInput = {
  HistoCommandeVisible?: boolean;
  ListeComptesPMV?: ArrayOfCompteLightVisibleEnLigneModelInput;
  ListeEnveloppe?: ArrayOfEnveloppeAfpaModelInput;
  ListeEnveloppeAttribTransOuChoisie?: ArrayOfEnveloppeBaseSelectedModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PointsMaximumVisible?: boolean;
  PointsMinimumVisible?: boolean;
  PointsMoyenneVisible?: boolean;
  PointsVisible?: boolean;
  SoldeEnveloppesVisible?: boolean;
  Status?: StatusDtoEnum;
  SubventionsVisible?: boolean;
};

export type HomeNotification = {
  __typename?: 'HomeNotification';
  Count?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type HomeNotificationInput = {
  Count?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type IbanMandatLightModel = {
  __typename?: 'IBANMandatLightModel';
  BBAN?: string;
  BBANEncrypted?: string;
  Cle?: string;
  CodePays?: string;
  IdIban?: number;
  IsDefaut?: boolean;
  ListeMandats?: ArrayOfRibMandatBanque;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type IbanMandatLightModelInput = {
  BBAN?: string;
  BBANEncrypted?: string;
  Cle?: string;
  CodePays?: string;
  IdIban?: number;
  IsDefaut?: boolean;
  ListeMandats?: ArrayOfRibMandatBanqueInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type IbanBeneficiaireModel = {
  __typename?: 'IbanBeneficiaireModel';
  AdresseCodePaysIBAN?: string;
  AdresseCodePostalIBAN?: string;
  AdresseLigne1IBAN?: string;
  AdresseLigne2IBAN?: string;
  AdresseVilleIBAN?: string;
  BBAN?: string;
  BBAN_Encrypt?: string;
  BIC?: string;
  BIC_Encrypt?: string;
  Cle?: string;
  CodePays?: string;
  DateCloture?: any;
  IdBeneficiaire?: number;
  IdIban?: number;
  IdUtilisateur?: number;
  IsClosed?: boolean;
  IsDefault?: boolean;
  IsModificationBloquee?: boolean;
  ListeMandats?: ArrayOfBenefMandatModel;
  ListePiecesJustificatives?: ArrayOfPieceJustificativeBenefModel;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  Status?: StatusDtoEnum;
  TitulaireCompteIBAN?: string;
};

export type IbanBeneficiaireModelInput = {
  AdresseCodePaysIBAN?: string;
  AdresseCodePostalIBAN?: string;
  AdresseLigne1IBAN?: string;
  AdresseLigne2IBAN?: string;
  AdresseVilleIBAN?: string;
  BBAN?: string;
  BBAN_Encrypt?: string;
  BIC?: string;
  BIC_Encrypt?: string;
  Cle?: string;
  CodePays?: string;
  DateCloture?: any;
  IdBeneficiaire?: number;
  IdIban?: number;
  IdUtilisateur?: number;
  IsClosed?: boolean;
  IsDefault?: boolean;
  IsModificationBloquee?: boolean;
  ListeMandats?: ArrayOfBenefMandatModelInput;
  ListePiecesJustificatives?: ArrayOfPieceJustificativeBenefModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  Status?: StatusDtoEnum;
  TitulaireCompteIBAN?: string;
};

export type IbanFournisseurModel = {
  __typename?: 'IbanFournisseurModel';
  AdresseCodePaysIBAN?: string;
  AdresseCodePostalIBAN?: string;
  AdresseLigne1IBAN?: string;
  AdresseLigne2IBAN?: string;
  AdresseVilleIBAN?: string;
  BBAN?: string;
  BBAN_Encrypt?: string;
  BIC?: string;
  BIC_Encrypt?: string;
  Cle?: string;
  CodePays?: string;
  DateCloture?: any;
  IdFournisseur?: number;
  IdIban?: number;
  IdUtilisateur?: number;
  IsClosed?: boolean;
  IsDefault?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  Status?: StatusDtoEnum;
  TitulaireCompteIBAN?: string;
};

export type IbanFournisseurModelInput = {
  AdresseCodePaysIBAN?: string;
  AdresseCodePostalIBAN?: string;
  AdresseLigne1IBAN?: string;
  AdresseLigne2IBAN?: string;
  AdresseVilleIBAN?: string;
  BBAN?: string;
  BBAN_Encrypt?: string;
  BIC?: string;
  BIC_Encrypt?: string;
  Cle?: string;
  CodePays?: string;
  DateCloture?: any;
  IdFournisseur?: number;
  IdIban?: number;
  IdUtilisateur?: number;
  IsClosed?: boolean;
  IsDefault?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  Status?: StatusDtoEnum;
  TitulaireCompteIBAN?: string;
};

export type IbanParametrageBaseModel = {
  __typename?: 'IbanParametrageBaseModel';
  AdresseCodePaysIBAN?: string;
  AdresseCodePostalIBAN?: string;
  AdresseLigne1IBAN?: string;
  AdresseLigne2IBAN?: string;
  AdresseVilleIBAN?: string;
  BBAN?: string;
  BBAN_Encrypt?: string;
  BIC?: string;
  BIC_Encrypt?: string;
  Cle?: string;
  CodePays?: string;
  DateCloture?: any;
  IdIban?: number;
  IdUtilisateur?: number;
  IsClosed?: boolean;
  IsDefault?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  Status?: StatusDtoEnum;
  TitulaireCompteIBAN?: string;
};

export type IbanParametrageBaseModelInput = {
  AdresseCodePaysIBAN?: string;
  AdresseCodePostalIBAN?: string;
  AdresseLigne1IBAN?: string;
  AdresseLigne2IBAN?: string;
  AdresseVilleIBAN?: string;
  BBAN?: string;
  BBAN_Encrypt?: string;
  BIC?: string;
  BIC_Encrypt?: string;
  Cle?: string;
  CodePays?: string;
  DateCloture?: any;
  IdIban?: number;
  IdUtilisateur?: number;
  IsClosed?: boolean;
  IsDefault?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  Status?: StatusDtoEnum;
  TitulaireCompteIBAN?: string;
};

export type IbanWithBanqueModel = {
  __typename?: 'IbanWithBanqueModel';
  BBAN?: string;
  BBAN_Encrypt?: string;
  CLE?: string;
  CODPAY?: string;
  NomBanque?: string;
};

export type IbanWithBanqueModelInput = {
  BBAN?: string;
  BBAN_Encrypt?: string;
  CLE?: string;
  CODPAY?: string;
  NomBanque?: string;
};

export type IdentifiantBenefModelInput = {
  ChampValCodeLoginParDefaut?: string;
  KeepCurrentLogin?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ImpayesAvoirsAcomptesModel = {
  __typename?: 'ImpayesAvoirsAcomptesModel';
  Id?: number;
  IsAccompte?: boolean;
  IsAvoir?: boolean;
  IsFacture?: boolean;
  IsSupprime?: boolean;
  Solde?: number;
};

export type ImpayesAvoirsAcomptesModelInput = {
  Id?: number;
  IsAccompte?: boolean;
  IsAvoir?: boolean;
  IsFacture?: boolean;
  IsSupprime?: boolean;
  Solde?: number;
};

export type ImportCatalogueModelInput = {
  ByteArray?: string;
  IdActivite?: number;
};

export type ImportColMappingDto = {
  __typename?: 'ImportColMappingDTO';
  ChampListeValeur?: ChampListeValeurDto;
  Id?: number;
  ImportModeleCol?: ImportModeleColDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ValeurBDD?: string;
  ValeurFichier?: string;
};

export type ImportColMappingDtoInput = {
  ChampListeValeur?: ChampListeValeurDtoInput;
  Id?: number;
  ImportModeleCol?: ImportModeleColDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ValeurBDD?: string;
  ValeurFichier?: string;
};

export type ImportColonneAMapperValeurModel = {
  __typename?: 'ImportColonneAMapperValeurModel';
  IdColonneModeleImport?: number;
  IdDirFPData?: number;
  IsMappingObligatoire?: boolean;
  Libelle?: string;
  ListeValeursFromCSV?: ArrayOfanyType;
  ListeValeursPossiblesFromBDD?: ArrayOfanyType;
};

export type ImportColonneAMapperValeurModelInput = {
  IdColonneModeleImport?: number;
  IdDirFPData?: number;
  IsMappingObligatoire?: boolean;
  Libelle?: string;
  ListeValeursFromCSV?: ArrayOfanyTypeInput;
  ListeValeursPossiblesFromBDD?: ArrayOfanyTypeInput;
};

export type ImportErreurDto = {
  __typename?: 'ImportErreurDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ImportErreurDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ImportHistoColonneArchiveDto = {
  __typename?: 'ImportHistoColonneArchiveDTO';
  FicheProfilDataDirecto?: FicheProfilDataDirectoDto;
  Id?: number;
  ImportHistoLigne?: ImportHistoLigneArchiveDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type ImportHistoColonneArchiveDtoInput = {
  FicheProfilDataDirecto?: FicheProfilDataDirectoDtoInput;
  Id?: number;
  ImportHistoLigne?: ImportHistoLigneArchiveDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type ImportHistoColonneDto = {
  __typename?: 'ImportHistoColonneDTO';
  FicheProfilDataDirecto?: FicheProfilDataDirectoDto;
  Id?: number;
  ImportHistoLigne?: ImportHistoLigneDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type ImportHistoColonneDtoInput = {
  FicheProfilDataDirecto?: FicheProfilDataDirectoDtoInput;
  Id?: number;
  ImportHistoLigne?: ImportHistoLigneDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type ImportHistoDto = {
  __typename?: 'ImportHistoDTO';
  DateCreation?: any;
  DateFinImport?: any;
  DateIntegrationEffective?: any;
  DateIntegrationPrevue?: any;
  Id?: number;
  ImportHistoStatut?: ImportHistoStatutDto;
  ImportModele?: ImportModeleDto;
  Libelle?: string;
  ListeImportHistoLigne?: ArrayOfImportHistoLigneDto;
  ListeImportHistoLigneArchive?: ArrayOfImportHistoLigneArchiveDto;
  ListeImportLogDetails?: ArrayOfImportLogDetailsDto;
  ListeImportLogGeneral?: ArrayOfImportLogGeneralDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PathFichierLog?: string;
  PathFichierSource?: string;
  Status?: StatusDtoEnum;
  User?: UsersDto;
};

export type ImportHistoDtoInput = {
  DateCreation?: any;
  DateFinImport?: any;
  DateIntegrationEffective?: any;
  DateIntegrationPrevue?: any;
  Id?: number;
  ImportHistoStatut?: ImportHistoStatutDtoInput;
  ImportModele?: ImportModeleDtoInput;
  Libelle?: string;
  ListeImportHistoLigne?: ArrayOfImportHistoLigneDtoInput;
  ListeImportHistoLigneArchive?: ArrayOfImportHistoLigneArchiveDtoInput;
  ListeImportLogDetails?: ArrayOfImportLogDetailsDtoInput;
  ListeImportLogGeneral?: ArrayOfImportLogGeneralDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PathFichierLog?: string;
  PathFichierSource?: string;
  Status?: StatusDtoEnum;
  User?: UsersDtoInput;
};

export type ImportHistoDetailsModelDto = {
  __typename?: 'ImportHistoDetailsModelDTO';
  DatFinImport?: any;
  DateImport?: any;
  DateIntegrationEffective?: any;
  DateIntegrationPrevue?: any;
  Fichier?: string;
  HaveErreurBloquante?: boolean;
  IdImport?: number;
  Libelle?: string;
  Modele?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreErreurs?: number;
  Status?: StatusDtoEnum;
  StatusCode?: string;
  Statut?: string;
  Type?: string;
  UserNom?: string;
  UserPrenom?: string;
};

export type ImportHistoDetailsModelDtoInput = {
  DatFinImport?: any;
  DateImport?: any;
  DateIntegrationEffective?: any;
  DateIntegrationPrevue?: any;
  Fichier?: string;
  HaveErreurBloquante?: boolean;
  IdImport?: number;
  Libelle?: string;
  Modele?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreErreurs?: number;
  Status?: StatusDtoEnum;
  StatusCode?: string;
  Statut?: string;
  Type?: string;
  UserNom?: string;
  UserPrenom?: string;
};

export type ImportHistoImportHistoColonneModelInput = {
  CodeDirFPData?: string;
  CodeTypeData?: string;
  IdCol?: number;
  IdDirFPData?: number;
  Libelle?: string;
  Valeur?: string;
};

export type ImportHistoImportHistoLigneModelInput = {
  Action?: string;
  IdLigne?: number;
  ListeHistoCol?: ArrayOfanyTypeInput;
};

export type ImportHistoImportRapportPreviewLignesModel = {
  __typename?: 'ImportHistoImportRapportPreviewLignesModel';
  InfosImport?: any;
  Lignes?: ArrayOfanyType;
  NombreLignesAjoutees?: number;
  NombreLignesDoublon?: number;
  NombreLignesEnErreur?: number;
  NombreLignesLienODAD?: number;
  NombreLignesModifiees?: number;
  NombreLignesRattachementDeleg?: number;
  NombreLignesSupprimees?: number;
  TotalNombreLignes?: number;
};

export type ImportHistoImportRapportPreviewLignesModelInput = {
  InfosImport?: any;
  Lignes?: ArrayOfanyTypeInput;
  NombreLignesAjoutees?: number;
  NombreLignesDoublon?: number;
  NombreLignesEnErreur?: number;
  NombreLignesLienODAD?: number;
  NombreLignesModifiees?: number;
  NombreLignesRattachementDeleg?: number;
  NombreLignesSupprimees?: number;
  TotalNombreLignes?: number;
};

export type ImportHistoLigneArchiveDto = {
  __typename?: 'ImportHistoLigneArchiveDTO';
  Action?: string;
  BenefId?: number;
  CEId?: number;
  ElementParentId?: number;
  Id?: number;
  ImportHisto?: ImportHistoDto;
  IsTraite?: boolean;
  ListeImportHistoColonne?: ArrayOfImportHistoColonneArchiveDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroLigne?: number;
  Status?: StatusDtoEnum;
};

export type ImportHistoLigneArchiveDtoInput = {
  Action?: string;
  BenefId?: number;
  CEId?: number;
  ElementParentId?: number;
  Id?: number;
  ImportHisto?: ImportHistoDtoInput;
  IsTraite?: boolean;
  ListeImportHistoColonne?: ArrayOfImportHistoColonneArchiveDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroLigne?: number;
  Status?: StatusDtoEnum;
};

export type ImportHistoLigneDto = {
  __typename?: 'ImportHistoLigneDTO';
  Action?: string;
  BenefId?: number;
  CEId?: number;
  ElementParentId?: number;
  Id?: number;
  ImportHisto?: ImportHistoDto;
  IsTraite?: boolean;
  ListeImportHistoColonne?: ArrayOfImportHistoColonneDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroLigne?: number;
  Status?: StatusDtoEnum;
};

export type ImportHistoLigneDtoInput = {
  Action?: string;
  BenefId?: number;
  CEId?: number;
  ElementParentId?: number;
  Id?: number;
  ImportHisto?: ImportHistoDtoInput;
  IsTraite?: boolean;
  ListeImportHistoColonne?: ArrayOfImportHistoColonneDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroLigne?: number;
  Status?: StatusDtoEnum;
};

export type ImportHistoModelInput = {
  CodeStatutImport?: string;
  CodeTypeImport?: string;
  DateCreationImport?: any;
  DateFinImport?: any;
  DateIntergrationEffectue?: any;
  DateIntergrationPrevue?: any;
  Id?: number;
  IsArchive?: boolean;
  LibelleFichier?: string;
  LibelleImportHisto?: string;
  LibelleModelImport?: string;
  LibelleTypeImport?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  UserNomPrenom?: string;
};

export type ImportHistoStatutDto = {
  __typename?: 'ImportHistoStatutDTO';
  Code?: string;
  Description?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ImportHistoStatutDtoInput = {
  Code?: string;
  Description?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ImportLogDetailsDto = {
  __typename?: 'ImportLogDetailsDTO';
  DonneesFichier?: string;
  Exception?: string;
  Id?: number;
  IdElement?: number;
  IdElementParent?: number;
  ImportErreur?: ImportErreurDto;
  ImportHisto?: ImportHistoDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroLigne?: number;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type ImportLogDetailsDtoInput = {
  DonneesFichier?: string;
  Exception?: string;
  Id?: number;
  IdElement?: number;
  IdElementParent?: number;
  ImportErreur?: ImportErreurDtoInput;
  ImportHisto?: ImportHistoDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroLigne?: number;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type ImportLogGeneralDto = {
  __typename?: 'ImportLogGeneralDTO';
  Id?: number;
  ImportHisto?: ImportHistoDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NbAjoutsEffectues?: number;
  NbDoublonsDetectes?: number;
  NbLignesErreur?: number;
  NbMAJEffectuees?: number;
  NbSuppressionEffectuees?: number;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type ImportLogGeneralDtoInput = {
  Id?: number;
  ImportHisto?: ImportHistoDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbAjoutsEffectues?: number;
  NbDoublonsDetectes?: number;
  NbLignesErreur?: number;
  NbMAJEffectuees?: number;
  NbSuppressionEffectuees?: number;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type ImportLogsDetaillesModelDto = {
  __typename?: 'ImportLogsDetaillesModelDTO';
  BenefId?: number;
  BenefParentId?: number;
  DateLog?: any;
  DonneeCSV?: string;
  Id?: number;
  MessageErreur?: string;
  NumeroLigne?: number;
  TypeErreur?: string;
};

export type ImportLogsDetaillesModelDtoInput = {
  BenefId?: number;
  BenefParentId?: number;
  DateLog?: any;
  DonneeCSV?: string;
  Id?: number;
  MessageErreur?: string;
  NumeroLigne?: number;
  TypeErreur?: string;
};

export type ImportMappingValeurFromCsvModelInput = {
  IdColonneModeleImport?: number;
  IdDirFPData?: number;
  IdFromBDDSavedInMappingValeur?: string;
  IdMapping?: number;
  IsValeurACreer?: boolean;
  ValeurBddAssociee?: any;
  ValeurCSV?: string;
};

export type ImportMappingValeurPossibleFromBddModelInput = {
  IdValeur?: number;
  Libelle?: string;
};

export type ImportModeleColDto = {
  __typename?: 'ImportModeleColDTO';
  FicheProfilDataDirecto?: FicheProfilDataDirectoDto;
  Id?: number;
  IdcIdBenef?: boolean;
  IdcIdParent?: boolean;
  IdcSuppValeurNull?: boolean;
  ImportModele?: ImportModeleDto;
  ImportTraitDonnees?: ImportTraitDonneesDto;
  ListeImportColMapping?: ArrayOfImportColMappingDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type ImportModeleColDtoInput = {
  FicheProfilDataDirecto?: FicheProfilDataDirectoDtoInput;
  Id?: number;
  IdcIdBenef?: boolean;
  IdcIdParent?: boolean;
  IdcSuppValeurNull?: boolean;
  ImportModele?: ImportModeleDtoInput;
  ImportTraitDonnees?: ImportTraitDonneesDtoInput;
  ListeImportColMapping?: ArrayOfImportColMappingDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type ImportModeleDto = {
  __typename?: 'ImportModeleDTO';
  DateDerniereModification?: any;
  Description?: string;
  DoitTraiterDoublonsEnModif?: boolean;
  Id?: number;
  ImportModeleType?: ImportModeleTypeDto;
  Libelle?: string;
  ListeImportModeleCol?: ArrayOfImportModeleColDto;
  ListeImportReqPrepost?: ArrayOfImportReqPrepostDto;
  ModeEntreeSortie?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: UsersDto;
};

export type ImportModeleDtoInput = {
  DateDerniereModification?: any;
  Description?: string;
  DoitTraiterDoublonsEnModif?: boolean;
  Id?: number;
  ImportModeleType?: ImportModeleTypeDtoInput;
  Libelle?: string;
  ListeImportModeleCol?: ArrayOfImportModeleColDtoInput;
  ListeImportReqPrepost?: ArrayOfImportReqPrepostDtoInput;
  ModeEntreeSortie?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: UsersDtoInput;
};

export type ImportModeleTypeDto = {
  __typename?: 'ImportModeleTypeDTO';
  Code?: string;
  Description?: string;
  Id?: number;
  Libelle?: string;
  ListeFicheProfilDataDirectoImportModeleType?: ArrayOfFicheProfilDataDirectoImportModeleTypeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedParent?: boolean;
  SQLSelElement?: string;
  SQLSelElementCE?: string;
  SQLSelElementParent?: string;
  SQLWhereElement?: string;
  SQLWhereElementCE?: string;
  SQLWhereElementParent?: string;
  Status?: StatusDtoEnum;
};

export type ImportModeleTypeDtoInput = {
  Code?: string;
  Description?: string;
  Id?: number;
  Libelle?: string;
  ListeFicheProfilDataDirectoImportModeleType?: ArrayOfFicheProfilDataDirectoImportModeleTypeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedParent?: boolean;
  SQLSelElement?: string;
  SQLSelElementCE?: string;
  SQLSelElementParent?: string;
  SQLWhereElement?: string;
  SQLWhereElementCE?: string;
  SQLWhereElementParent?: string;
  Status?: StatusDtoEnum;
};

export type ImportReqPrepostDto = {
  __typename?: 'ImportReqPrepostDTO';
  Description?: string;
  Id?: number;
  Libelle?: string;
  ListeImportModeleType?: ArrayOfImportModeleTypeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  RequeteSQL?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type ImportReqPrepostDtoInput = {
  Description?: string;
  Id?: number;
  Libelle?: string;
  ListeImportModeleType?: ArrayOfImportModeleTypeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RequeteSQL?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type ImportRestaurationModelInput = {
  ByteArray?: string;
  IdActivite?: number;
  IdCompteAchat?: number;
  IdCompteValorisationStock?: number;
  IdCompteVariationStock?: number;
  IdCompteVente?: number;
  IdDelegation?: number;
  IdFournisseur?: number;
  IdSectionAnalytique?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  PathFichierUpload?: string;
  Status?: StatusDtoEnum;
};

export type ImportTraitDonneesDto = {
  __typename?: 'ImportTraitDonneesDTO';
  Code?: string;
  Description?: string;
  Id?: number;
  Libelle?: string;
  ListeFicheProfilDataDirecto?: ArrayOfFicheProfilDataDirectoDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TraitSQL?: string;
};

export type ImportTraitDonneesDtoInput = {
  Code?: string;
  Description?: string;
  Id?: number;
  Libelle?: string;
  ListeFicheProfilDataDirecto?: ArrayOfFicheProfilDataDirectoDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TraitSQL?: string;
};

export type ImputationComptableEditerImputationFpaCharge = {
  __typename?: 'ImputationComptableEditerImputationFPACharge';
  IdCompteCharge?: number;
  IdElement?: number;
  IsRedescente?: boolean;
  ListePlansAnalytiques?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ImputationComptableEditerImputationFpaChargeInput = {
  IdCompteCharge?: number;
  IdElement?: number;
  IsRedescente?: boolean;
  ListePlansAnalytiques?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ImputationComptableEditerImputationFpaInput = {
  IdElement?: number;
  IsRedescente?: boolean;
  ListePlansAnalytiques?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ImputationComptableEditerImputationFpaProduit = {
  __typename?: 'ImputationComptableEditerImputationFPAProduit';
  IdCompteProduit?: number;
  IdElement?: number;
  IsRedescente?: boolean;
  ListePlansAnalytiques?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ImputationComptableEditerImputationFpaProduitCharge = {
  __typename?: 'ImputationComptableEditerImputationFPAProduitCharge';
  IdCompteCharge?: number;
  IdCompteProduit?: number;
  IdElement?: number;
  IsKdo?: boolean;
  IsPac?: boolean;
  IsRedescente?: boolean;
  ListePlansAnalytiques?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ImputationComptableEditerImputationFpaProduitChargeInput = {
  IdCompteCharge?: number;
  IdCompteProduit?: number;
  IdElement?: number;
  IsKdo?: boolean;
  IsPac?: boolean;
  IsRedescente?: boolean;
  ListePlansAnalytiques?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ImputationComptableEditerImputationFpaProduitInput = {
  IdCompteProduit?: number;
  IdElement?: number;
  IsRedescente?: boolean;
  ListePlansAnalytiques?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ImputationComptableEditerImputationFpaTousComptes = {
  __typename?: 'ImputationComptableEditerImputationFPATousComptes';
  IdCompteCharge?: number;
  IdCompteProduit?: number;
  IdCompteValorisation?: number;
  IdCompteVariation?: number;
  IdElement?: number;
  IdModeleTVA?: number;
  IsKdo?: boolean;
  IsPac?: boolean;
  IsRedescente?: boolean;
  ListePlansAnalytiques?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ImputationComptableEditerImputationFpaTousComptesInput = {
  IdCompteCharge?: number;
  IdCompteProduit?: number;
  IdCompteValorisation?: number;
  IdCompteVariation?: number;
  IdElement?: number;
  IdModeleTVA?: number;
  IsKdo?: boolean;
  IsPac?: boolean;
  IsRedescente?: boolean;
  ListePlansAnalytiques?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ImputationComptableEditerImputationFpaVariationValorisation = {
  __typename?: 'ImputationComptableEditerImputationFPAVariationValorisation';
  IdCompteCharge?: number;
  IdCompteProduit?: number;
  IdCompteValorisation?: number;
  IdCompteVariation?: number;
  IdElement?: number;
  IsKdo?: boolean;
  IsPac?: boolean;
  IsRedescente?: boolean;
  ListePlansAnalytiques?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ImputationComptableEditerImputationFpaVariationValorisationInput = {
  IdCompteCharge?: number;
  IdCompteProduit?: number;
  IdCompteValorisation?: number;
  IdCompteVariation?: number;
  IdElement?: number;
  IsKdo?: boolean;
  IsPac?: boolean;
  IsRedescente?: boolean;
  ListePlansAnalytiques?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InfoAcceptationLigneRmbMensuel = {
  __typename?: 'InfoAcceptationLigneRmbMensuel';
  DateDebutPrestation?: any;
  DateDerniereLigneAcceptee?: any;
};

export type InfoAcceptationLigneRmbMensuelInput = {
  DateDebutPrestation?: any;
  DateDerniereLigneAcceptee?: any;
};

export type InfoColDataGridModelDto = {
  __typename?: 'InfoColDataGridModelDTO';
  CodeColonne?: string;
  IdFicheProfil?: number;
  IsReadOnly?: boolean;
  LargeurColonne?: number;
  ListeValeurs?: ArrayOfKeyValueModelDto;
  MaxLength?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomColonne?: string;
  OrdreColonne?: number;
  Status?: StatusDtoEnum;
  TypeValeur?: TypesValeursEnum;
  ValeurMax?: number;
  ValeurMin?: number;
};

export type InfoColDataGridModelDtoInput = {
  CodeColonne?: string;
  IdFicheProfil?: number;
  IsReadOnly?: boolean;
  LargeurColonne?: number;
  ListeValeurs?: ArrayOfKeyValueModelDtoInput;
  MaxLength?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomColonne?: string;
  OrdreColonne?: number;
  Status?: StatusDtoEnum;
  TypeValeur?: TypesValeursEnum;
  ValeurMax?: number;
  ValeurMin?: number;
};

export type InfoDossierPrestationRmbMensuel = {
  __typename?: 'InfoDossierPrestationRmbMensuel';
  DateDebutRmbMensuel?: any;
  DateDossierRmbMensuel?: any;
  DateFinRmbMensuel?: any;
  IdPrestation?: number;
  IsValidationChrono?: boolean;
  ListeAnneesReference?: ArrayOfint;
  ListeMoisReference?: ArrayOfKeyValueOfintstring;
};

export type InfoDossierPrestationRmbMensuelInput = {
  DateDebutRmbMensuel?: any;
  DateDossierRmbMensuel?: any;
  DateFinRmbMensuel?: any;
  IdPrestation?: number;
  IsValidationChrono?: boolean;
  ListeAnneesReference?: ArrayOfintInput;
  ListeMoisReference?: ArrayOfKeyValueOfintstringInput;
};

export type InfoEcritureDisplayModel = {
  __typename?: 'InfoEcritureDisplayModel';
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TotalEcriture?: number;
  TotalMontant?: number;
};

export type InfoEcritureDisplayModelInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TotalEcriture?: number;
  TotalMontant?: number;
};

export type InfoEmpruntModelDto = {
  __typename?: 'InfoEmpruntModelDTO';
  DateEmprunt?: any;
  DateRetourPrevu?: any;
  Etat?: string;
  IdArticle?: number;
  IdCdeLig?: number;
  ImageMedia?: string;
  IsEmprunt?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  RefTmp?: string;
  Reference?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
};

export type InfoEmpruntModelDtoInput = {
  DateEmprunt?: any;
  DateRetourPrevu?: any;
  Etat?: string;
  IdArticle?: number;
  IdCdeLig?: number;
  ImageMedia?: string;
  IsEmprunt?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  RefTmp?: string;
  Reference?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
};

export type InfoRetourHistoriqueMediathequeModel = {
  __typename?: 'InfoRetourHistoriqueMediathequeModel';
  IsEmprunt?: boolean;
  IsLivre?: boolean;
  IsNonLivree?: boolean;
  IsRefuse?: boolean;
  IsRetour?: boolean;
  NbFileAttente?: number;
  NextBenefFileAttente?: BeneficiaireInfosBenefMatriculeModelDto;
};

export type InfoRetourHistoriqueMediathequeModelInput = {
  IsEmprunt?: boolean;
  IsLivre?: boolean;
  IsNonLivree?: boolean;
  IsRefuse?: boolean;
  IsRetour?: boolean;
  NbFileAttente?: number;
  NextBenefFileAttente?: BeneficiaireInfosBenefMatriculeModelDtoInput;
};

export type InfoStatutModel = {
  __typename?: 'InfoStatutModel';
  CodeStatut?: string;
  CodeStatutPere?: string;
  IdStatut?: number;
  IsModificationManuelPossible?: boolean;
  IsSelected?: boolean;
  IsStatutPerso?: boolean;
  LibelleStatut?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InfoStatutModelInput = {
  CodeStatut?: string;
  CodeStatutPere?: string;
  IdStatut?: number;
  IsModificationManuelPossible?: boolean;
  IsSelected?: boolean;
  IsStatutPerso?: boolean;
  LibelleStatut?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InfoValidationLigneDossierRmbMensuel = {
  __typename?: 'InfoValidationLigneDossierRmbMensuel';
  DateDerniereLigneDossier?: any;
  DateReference?: any;
  IdDerniereLigneAcceptee?: number;
  IdLigneDossier?: number;
  IsDateAnterieureDernierRemboursement?: boolean;
  IsDateRefAlreadyExist?: boolean;
  IsValidationChrono?: boolean;
  IsValidationNeeded?: boolean;
  ListeDatesLignesAcceptees?: ArrayOfKeyValueOfdecimalNullableOfdateTimeU6ho3Bhd;
  ListeDatesLignesAttente?: ArrayOfKeyValueOfdecimalNullableOfdateTimeU6ho3Bhd;
};

export type InfoValidationLigneDossierRmbMensuelInput = {
  DateDerniereLigneDossier?: any;
  DateReference?: any;
  IdDerniereLigneAcceptee?: number;
  IdLigneDossier?: number;
  IsDateAnterieureDernierRemboursement?: boolean;
  IsDateRefAlreadyExist?: boolean;
  IsValidationChrono?: boolean;
  IsValidationNeeded?: boolean;
  ListeDatesLignesAcceptees?: ArrayOfKeyValueOfdecimalNullableOfdateTimeU6ho3BhdInput;
  ListeDatesLignesAttente?: ArrayOfKeyValueOfdecimalNullableOfdateTimeU6ho3BhdInput;
};

export type InformationLocationDto = {
  __typename?: 'InformationLocationDTO';
  ListArticle?: ArrayOfArticleDto;
  ListLigneCommande?: ArrayOfLigneCommandeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InformationLocationDtoInput = {
  ListArticle?: ArrayOfArticleDtoInput;
  ListLigneCommande?: ArrayOfLigneCommandeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InformationsActiviteHomeNotification = {
  __typename?: 'InformationsActiviteHomeNotification';
  CodeTypeActivite?: string;
  IdActivite?: number;
  LibelleActivite?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type InformationsActiviteHomeNotificationInput = {
  CodeTypeActivite?: string;
  IdActivite?: number;
  LibelleActivite?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type InformationsEcritureConsultationModel = {
  __typename?: 'InformationsEcritureConsultationModel';
  CodeTypeBudget?: string;
  DateDernierArrete?: any;
  DateEcriture?: any;
  IdBenef?: number;
  IdCECible?: number;
  IdCECreePar?: number;
  IdCESource?: number;
  IdCaisse?: number;
  IdEcriture?: number;
  IdExercice?: number;
  IdJournal?: number;
  IdMoyenPaiement?: number;
  IdUtilisateur?: number;
  IsEcritureExportee?: boolean;
  IsEcritureFiduciaire?: boolean;
  IsEcritureSimulation?: boolean;
  IsEcritureSupprimable?: boolean;
  IsEcritureSupprimee?: boolean;
  IsExerciceCloture?: boolean;
  LibelleEcriture?: string;
  ListeMouvementsEcriture?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  NomCECreation?: string;
  NomCESource?: string;
  NumeroPiece?: string;
  Reference?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
  TypeEcriture?: string;
  TypeJournal?: string;
};

export type InformationsEcritureConsultationModelInput = {
  CodeTypeBudget?: string;
  DateDernierArrete?: any;
  DateEcriture?: any;
  IdBenef?: number;
  IdCECible?: number;
  IdCECreePar?: number;
  IdCESource?: number;
  IdCaisse?: number;
  IdEcriture?: number;
  IdExercice?: number;
  IdJournal?: number;
  IdMoyenPaiement?: number;
  IdUtilisateur?: number;
  IsEcritureExportee?: boolean;
  IsEcritureFiduciaire?: boolean;
  IsEcritureSimulation?: boolean;
  IsEcritureSupprimable?: boolean;
  IsEcritureSupprimee?: boolean;
  IsExerciceCloture?: boolean;
  LibelleEcriture?: string;
  ListeMouvementsEcriture?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NomCECreation?: string;
  NomCESource?: string;
  NumeroPiece?: string;
  Reference?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
  TypeEcriture?: string;
  TypeJournal?: string;
};

export type InformationsEpargneModel = {
  __typename?: 'InformationsEpargneModel';
  CanBeReglementComptant?: boolean;
  Description?: string;
  IdArticle?: number;
  IdProduit?: number;
  Image?: string;
  IsAbondementApresChaqueEcheance?: boolean;
  IsCloture?: boolean;
  IsEpargneDispoApresChaqueEcheance?: boolean;
  IsModeleDuplicated?: boolean;
  IsModeleUsed?: boolean;
  IsMontantFixe?: boolean;
  IsPictoUser?: boolean;
  LibelleArticle?: string;
  ListeArticleMoyenPaiementEcheancier?: ArrayOfArticleMoyenPaiementModel;
  ListeModeleEcheancierArticle?: ArrayOfSelectedModeleEcheancierArticleModel;
  MontantFixe?: number;
  MontantMaximum?: number;
  MontantMinimum?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Picto?: FichierModel;
  Status?: StatusDtoEnum;
};

export type InformationsEpargneModelInput = {
  CanBeReglementComptant?: boolean;
  Description?: string;
  IdArticle?: number;
  IdProduit?: number;
  Image?: string;
  IsAbondementApresChaqueEcheance?: boolean;
  IsCloture?: boolean;
  IsEpargneDispoApresChaqueEcheance?: boolean;
  IsModeleDuplicated?: boolean;
  IsModeleUsed?: boolean;
  IsMontantFixe?: boolean;
  IsPictoUser?: boolean;
  LibelleArticle?: string;
  ListeArticleMoyenPaiementEcheancier?: ArrayOfArticleMoyenPaiementModelInput;
  ListeModeleEcheancierArticle?: ArrayOfSelectedModeleEcheancierArticleModelInput;
  MontantFixe?: number;
  MontantMaximum?: number;
  MontantMinimum?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Picto?: FichierModelInput;
  Status?: StatusDtoEnum;
};

export type InformationsHomeNotification = {
  __typename?: 'InformationsHomeNotification';
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type InformationsHomeNotificationInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type InformationsNouveauRapprochementModel = {
  __typename?: 'InformationsNouveauRapprochementModel';
  DateRelevePrecedent?: any;
  HasReleveEnCours?: boolean;
};

export type InformationsNouveauRapprochementModelInput = {
  DateRelevePrecedent?: any;
  HasReleveEnCours?: boolean;
};

export type InfosAchatCommandeFournisseurSelectionneModelDto = {
  __typename?: 'InfosAchatCommandeFournisseurSelectionneModelDTO';
  ListeArticleModele?: ArrayOfArticleModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteArticleEnReappro?: number;
  QuantiteArticleGenerique?: number;
  Status?: StatusDtoEnum;
};

export type InfosAchatCommandeFournisseurSelectionneModelDtoInput = {
  ListeArticleModele?: ArrayOfArticleModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteArticleEnReappro?: number;
  QuantiteArticleGenerique?: number;
  Status?: StatusDtoEnum;
};

export type InfosArticleCadeaux = {
  __typename?: 'InfosArticleCadeaux';
  CodeArticle?: string;
  Id?: number;
  IdCadeau?: number;
  IsAutoriserDepassementSubvention?: boolean;
  IsSelectedCadeau?: boolean;
  LibelleActivite?: string;
  LibelleProduitArticle?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Quantite?: number;
  QuantiteMax?: number;
  QuantiteMinimum?: number;
  Status?: StatusDtoEnum;
};

export type InfosArticleCadeauxInput = {
  CodeArticle?: string;
  Id?: number;
  IdCadeau?: number;
  IsAutoriserDepassementSubvention?: boolean;
  IsSelectedCadeau?: boolean;
  LibelleActivite?: string;
  LibelleProduitArticle?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Quantite?: number;
  QuantiteMax?: number;
  QuantiteMinimum?: number;
  Status?: StatusDtoEnum;
};

export type InfosAstucesNouveautesModelDto = {
  __typename?: 'InfosAstucesNouveautesModelDTO';
  DateInfo?: any;
  HTMLContent?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: MessageTypeEnum;
};

export type InfosAstucesNouveautesModelDtoInput = {
  DateInfo?: any;
  HTMLContent?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: MessageTypeEnum;
};

export type InfosAvoirModel = {
  __typename?: 'InfosAvoirModel';
  DateFacture?: any;
  IdBenef?: number;
  IdFacture?: number;
  IdFactureLiee?: number;
  LibelleFacture?: string;
  MontRestantFacture?: number;
  MontantAvoir?: number;
};

export type InfosAvoirModelInput = {
  DateFacture?: any;
  IdBenef?: number;
  IdFacture?: number;
  IdFactureLiee?: number;
  LibelleFacture?: string;
  MontRestantFacture?: number;
  MontantAvoir?: number;
};

export type InfosBenefRpModel = {
  __typename?: 'InfosBenefRPModel';
  BenefId?: number;
  IdLigneCommande?: number;
  Matricule?: string;
  Nom?: string;
  Prenom?: string;
  ProduitId?: number;
  ProduitLibelle?: string;
  RessourceId?: number;
  RessourceLibelle?: string;
};

export type InfosBenefRpModelInput = {
  BenefId?: number;
  IdLigneCommande?: number;
  Matricule?: string;
  Nom?: string;
  Prenom?: string;
  ProduitId?: number;
  ProduitLibelle?: string;
  RessourceId?: number;
  RessourceLibelle?: string;
};

export type InfosBeneficiairesModelDto = {
  __typename?: 'InfosBeneficiairesModelDTO';
  DateEmbauche?: any;
  DateNaissance?: any;
  IdBenef?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  PhotoUrl?: FichierModel;
  Prenom?: string;
  Status?: StatusDtoEnum;
};

export type InfosBeneficiairesModelDtoInput = {
  DateEmbauche?: any;
  DateNaissance?: any;
  IdBenef?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  PhotoUrl?: FichierModelInput;
  Prenom?: string;
  Status?: StatusDtoEnum;
};

export type InfosChequeReglementModelDtoInput = {
  IdRib?: number;
  IdRibMandat?: number;
  NomBanque?: string;
  NumeroCheque?: string;
  TitreCheque?: string;
};

export type InfosControleModificationEcritureModel = {
  __typename?: 'InfosControleModificationEcritureModel';
  CodeTypeJournal?: string;
  DateDernierArrete?: any;
  IdJournalInit?: number;
  IsDateSurExerciceCloture?: boolean;
  IsEcritureFacAvoirAcompte?: boolean;
  IsEcritureFiduciaire?: boolean;
  IsExporter?: boolean;
  IsSuppressionPossible?: boolean;
  LibelleJournal?: string;
  TypeBudget?: string;
  isManuel?: boolean;
};

export type InfosControleModificationEcritureModelInput = {
  CodeTypeJournal?: string;
  DateDernierArrete?: any;
  IdJournalInit?: number;
  IsDateSurExerciceCloture?: boolean;
  IsEcritureFacAvoirAcompte?: boolean;
  IsEcritureFiduciaire?: boolean;
  IsExporter?: boolean;
  IsSuppressionPossible?: boolean;
  LibelleJournal?: string;
  TypeBudget?: string;
  isManuel?: boolean;
};

export type InfosCreationAvoirPourFactureModelInput = {
  IdCaisse?: number;
  IdExercice?: number;
  IdFacture?: number;
  IdJournal?: number;
  NumeroPiece?: string;
};

export type InfosDemarrageModelDto = {
  __typename?: 'InfosDemarrageModelDTO';
  ModeEnv?: string;
  UrlReporting?: string;
  Version?: string;
};

export type InfosDemarrageModelDtoInput = {
  ModeEnv?: string;
  UrlReporting?: string;
  Version?: string;
};

export type InfosDevisCapaciteLocationModel = {
  __typename?: 'InfosDevisCapaciteLocationModel';
  CapaciteMax?: number;
  CapaciteMin?: number;
  IdCommande?: number;
  NombreParticipants?: number;
};

export type InfosDevisCapaciteLocationModelInput = {
  CapaciteMax?: number;
  CapaciteMin?: number;
  IdCommande?: number;
  NombreParticipants?: number;
};

export type InfosDevisCdeInscriptionGroupeModel = {
  __typename?: 'InfosDevisCdeInscriptionGroupeModel';
  ARegler?: number;
  BenefId?: number;
  BenefMatricule?: string;
  BenefNom?: string;
  BenefPrenom?: string;
  CodeStatutAdministratif?: string;
  DateCde?: any;
  IdCommande?: number;
  IdProduit?: number;
  IsCdeEnLigne?: boolean;
  IsCommandeFinie?: boolean;
  LibelleCommande?: string;
  LibelleProduit?: string;
  LibelleSessionChoix?: string;
  LibelleStatutAdministratif?: string;
  ListeIdFactures?: ArrayOfdecimal;
  MontantDossierAvecSubvention?: number;
  MontantTotalDevisAvecSub?: number;
  NbAcc?: number;
  NbAtt?: number;
  NbFactures?: number;
  NbTot?: number;
  NumeroAttribution?: number;
  NumeroChoixLocation?: number;
  PointTooltip?: ArrayOfstring;
  Points?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
};

export type InfosDevisCdeInscriptionGroupeModelInput = {
  ARegler?: number;
  BenefId?: number;
  BenefMatricule?: string;
  BenefNom?: string;
  BenefPrenom?: string;
  CodeStatutAdministratif?: string;
  DateCde?: any;
  IdCommande?: number;
  IdProduit?: number;
  IsCdeEnLigne?: boolean;
  IsCommandeFinie?: boolean;
  LibelleCommande?: string;
  LibelleProduit?: string;
  LibelleSessionChoix?: string;
  LibelleStatutAdministratif?: string;
  ListeIdFactures?: ArrayOfdecimalInput;
  MontantDossierAvecSubvention?: number;
  MontantTotalDevisAvecSub?: number;
  NbAcc?: number;
  NbAtt?: number;
  NbFactures?: number;
  NbTot?: number;
  NumeroAttribution?: number;
  NumeroChoixLocation?: number;
  PointTooltip?: ArrayOfstringInput;
  Points?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
};

export type InfosDossiersPretsEtDonsHistoriqueModelDto = {
  __typename?: 'InfosDossiersPretsEtDonsHistoriqueModelDTO';
  Assurance?: string;
  CodeStatutDossier?: string;
  CodeTypeDossier?: string;
  CouleurStatutPerso?: string;
  DateDossier?: any;
  DateProchaineEcheance?: any;
  Duree?: number;
  HasEcritureDon?: boolean;
  HaveEcheancierGenere?: boolean;
  HaveFormulaireSurLigne?: boolean;
  IdBenef?: number;
  IdCde?: number;
  IdLigneDossier?: number;
  IdStatutPerso?: number;
  IsRegle?: boolean;
  IsSolde?: boolean;
  LibelleFormule?: string;
  LibelleProduit?: string;
  LibelleStatutPerso?: string;
  MatriculeBenef?: string;
  Montant?: number;
  MontantDejaRegle?: number;
  MontantDejaRembourse?: number;
  MontantFraisDossier?: number;
  MontantRemisEnBanque?: number;
  MontantRestantDu?: number;
  NbPJEnvoyees?: number;
  NbPJTotal?: number;
  NomBenef?: string;
  NombreEcheancesEchues?: number;
  NombreEcheancesTotales?: number;
  PrenomBenef?: string;
};

export type InfosDossiersPretsEtDonsHistoriqueModelDtoInput = {
  Assurance?: string;
  CodeStatutDossier?: string;
  CodeTypeDossier?: string;
  CouleurStatutPerso?: string;
  DateDossier?: any;
  DateProchaineEcheance?: any;
  Duree?: number;
  HasEcritureDon?: boolean;
  HaveEcheancierGenere?: boolean;
  HaveFormulaireSurLigne?: boolean;
  IdBenef?: number;
  IdCde?: number;
  IdLigneDossier?: number;
  IdStatutPerso?: number;
  IsRegle?: boolean;
  IsSolde?: boolean;
  LibelleFormule?: string;
  LibelleProduit?: string;
  LibelleStatutPerso?: string;
  MatriculeBenef?: string;
  Montant?: number;
  MontantDejaRegle?: number;
  MontantDejaRembourse?: number;
  MontantFraisDossier?: number;
  MontantRemisEnBanque?: number;
  MontantRestantDu?: number;
  NbPJEnvoyees?: number;
  NbPJTotal?: number;
  NomBenef?: string;
  NombreEcheancesEchues?: number;
  NombreEcheancesTotales?: number;
  PrenomBenef?: string;
};

export type InfosEcritureAffichageBaseModel = {
  __typename?: 'InfosEcritureAffichageBaseModel';
  CodeJournal?: string;
  DateEcriture?: any;
  IdEcriture?: number;
  LibelleEcriture?: string;
  ListeLettres?: ArrayOfstring;
  MontantEcriture?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumReference?: string;
  NumeroPiece?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type InfosEcritureAffichageBaseModelInput = {
  CodeJournal?: string;
  DateEcriture?: any;
  IdEcriture?: number;
  LibelleEcriture?: string;
  ListeLettres?: ArrayOfstringInput;
  MontantEcriture?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumReference?: string;
  NumeroPiece?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type InfosFacturationMasseRpModel = {
  __typename?: 'InfosFacturationMasseRPModel';
  NombreBeneficiaireConcerne?: number;
  NombreCommandeConcernee?: number;
};

export type InfosFacturationMasseRpModelInput = {
  NombreBeneficiaireConcerne?: number;
  NombreCommandeConcernee?: number;
};

export type InfosFactureCommandeBeneficiairePartAChargeListingModelInput = {
  CommentairePrive?: string;
  CommentairePublic?: string;
  DateFacture?: any;
  IdFacture?: number;
  IsAcompte?: boolean;
  IsAvoir?: boolean;
  LibelleFacture?: string;
  LibelleStatutReglement?: string;
  MontantFacture?: number;
  NumeroFacture?: string;
  Solde?: number;
};

export type InfosFactureCommandeFournisseurListingModelInput = {
  IdFacture?: number;
  LibelleStatutReglement?: string;
  NumeroFacture?: string;
};

export type InfosFactureCommandeFournisseurPartAChargeListingModelInput = {
  CodeStatutReglement?: string;
  CommentairePrive?: string;
  CommentairePublic?: string;
  DateFacture?: any;
  IdFacture?: number;
  IsAcompte?: boolean;
  IsAvoir?: boolean;
  LibelleFacture?: string;
  LibelleStatutReglement?: string;
  MontantFacture?: number;
  NumeroFacture?: string;
  Solde?: number;
};

export type InfosFactureForImpressionModel = {
  __typename?: 'InfosFactureForImpressionModel';
  CodeTypeActivite?: string;
  HasTVA?: boolean;
  IdActivite?: number;
  IdCe?: number;
  IsFactureBenef?: boolean;
  IsFactureDossierPAC?: boolean;
};

export type InfosFactureForImpressionModelInput = {
  CodeTypeActivite?: string;
  HasTVA?: boolean;
  IdActivite?: number;
  IdCe?: number;
  IsFactureBenef?: boolean;
  IsFactureDossierPAC?: boolean;
};

export type InfosMouvementLettrageAutoModel = {
  __typename?: 'InfosMouvementLettrageAutoModel';
  CodeJournal?: string;
  CompteCollectif?: string;
  DateEcriture?: any;
  IdMouvement?: number;
  LibelleEcriture?: string;
  Montant?: number;
  NomDelegCibleEcriture?: string;
  NumPiece?: string;
  Sens?: string;
  Tiers?: string;
};

export type InfosMouvementLettrageAutoModelInput = {
  CodeJournal?: string;
  CompteCollectif?: string;
  DateEcriture?: any;
  IdMouvement?: number;
  LibelleEcriture?: string;
  Montant?: number;
  NomDelegCibleEcriture?: string;
  NumPiece?: string;
  Sens?: string;
  Tiers?: string;
};

export type InfosMoyenPaiementBaseModelInput = {
  IdMoyenPaiement?: number;
};

export type InfosPjTypeModel = {
  __typename?: 'InfosPJTypeModel';
  CodePJ?: string;
  CodeTypePJ?: string;
  DescriptionPJ?: string;
  IdPieceJustificative?: number;
  LibellePJ?: string;
};

export type InfosPjTypeModelInput = {
  CodePJ?: string;
  CodeTypePJ?: string;
  DescriptionPJ?: string;
  IdPieceJustificative?: number;
  LibellePJ?: string;
};

export type InfosRetourLivraison = {
  __typename?: 'InfosRetourLivraison';
  ErreurLivraison?: string;
  IdActivite?: number;
  IsToutesCommandesStatutEnvoye?: boolean;
  ListeCommandeNonLivrePartiellementLivreModel?: ArrayOfDevisCommandeInfosCommandeNonLivreePartiellementLivreeModel;
  ListeIdBonLivraison?: ArrayOfdecimal;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InfosRetourLivraisonInput = {
  ErreurLivraison?: string;
  IdActivite?: number;
  IsToutesCommandesStatutEnvoye?: boolean;
  ListeCommandeNonLivrePartiellementLivreModel?: ArrayOfDevisCommandeInfosCommandeNonLivreePartiellementLivreeModelInput;
  ListeIdBonLivraison?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InfosRetourLivraisonOuReceptionTotaleGroupeeCommande = {
  __typename?: 'InfosRetourLivraisonOuReceptionTotaleGroupeeCommande';
  IdActivite?: number;
  IsToutesCommandesStatutEnvoye?: boolean;
  ListeCommandeNonLivrePartiellementLivreModel?: ArrayOfDevisCommandeInfosCommandeNonLivreePartiellementLivreeModel;
  ListeIdBonLivraison?: ArrayOfdecimal;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InfosRetourLivraisonOuReceptionTotaleGroupeeCommandeInput = {
  IdActivite?: number;
  IsToutesCommandesStatutEnvoye?: boolean;
  ListeCommandeNonLivrePartiellementLivreModel?: ArrayOfDevisCommandeInfosCommandeNonLivreePartiellementLivreeModelInput;
  ListeIdBonLivraison?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InfosSuppressionTarifCreationAvoirModelInput = {
  IdCaisse?: number;
  IdExercice?: number;
  IdJournal?: number;
  IdTarif?: number;
  NumeroPiece?: string;
};

export type InitArticleAssocieEpargneModel = {
  __typename?: 'InitArticleAssocieEpargneModel';
  ListeActivites?: ArrayOfActiviteBaseModel;
  ListeArticles?: ArrayOfArticleWithProduitModel;
  ListeFamilles?: ArrayOfFamilleWithActiviteModel;
  ListeProduit?: ArrayOfProduitBaseAvecIdFamilleModel;
};

export type InitArticleAssocieEpargneModelInput = {
  ListeActivites?: ArrayOfActiviteBaseModelInput;
  ListeArticles?: ArrayOfArticleWithProduitModelInput;
  ListeFamilles?: ArrayOfFamilleWithActiviteModelInput;
  ListeProduit?: ArrayOfProduitBaseAvecIdFamilleModelInput;
};

export type InitAttributionAutoModel = {
  __typename?: 'InitAttributionAutoModel';
  Activite?: ActiviteDto;
  ListAnneeRef?: ArrayOfAnneeReferenceDto;
  ListCompteurPoint?: ArrayOfCompteurPointDto;
  ListEnveloppe?: ArrayOfEnveloppeQuotaDto;
  ListProduit?: ArrayOfProduitDto;
  ListSessionChoix?: ArrayOfSessionChoixDto;
  ListTri?: ArrayOfAttributionTriDto;
};

export type InitAttributionAutoModelInput = {
  Activite?: ActiviteDtoInput;
  ListAnneeRef?: ArrayOfAnneeReferenceDtoInput;
  ListCompteurPoint?: ArrayOfCompteurPointDtoInput;
  ListEnveloppe?: ArrayOfEnveloppeQuotaDtoInput;
  ListProduit?: ArrayOfProduitDtoInput;
  ListSessionChoix?: ArrayOfSessionChoixDtoInput;
  ListTri?: ArrayOfAttributionTriDtoInput;
};

export type InitBalanceOuvertureModel = {
  __typename?: 'InitBalanceOuvertureModel';
  CodeExerciceCloture?: string;
  CodeExerciceSuivant?: string;
};

export type InitBalanceOuvertureModelInput = {
  CodeExerciceCloture?: string;
  CodeExerciceSuivant?: string;
};

export type InitComptabiliteEpargneModel = {
  __typename?: 'InitComptabiliteEpargneModel';
  ListeCompte?: ArrayOfCompteCollectifModel;
  ListeCompteBancaireBase?: ArrayOfCompteBancaireCompteBancaireBaseModel;
  ListeJournaux?: ArrayOfJournalBaseModel;
};

export type InitComptabiliteEpargneModelInput = {
  ListeCompte?: ArrayOfCompteCollectifModelInput;
  ListeCompteBancaireBase?: ArrayOfCompteBancaireCompteBancaireBaseModelInput;
  ListeJournaux?: ArrayOfJournalBaseModelInput;
};

export type InitDonneesFiltrageCessionModelInput = {
  IdActivite?: number;
  IdDelegation?: number;
  RecupererDelegations?: boolean;
  RecupererPointVentes?: boolean;
  RecupererStocks?: boolean;
};

export type InitEnteteDossierEpargneResult = {
  __typename?: 'InitEnteteDossierEpargneResult';
  ListeModeleEcheancier?: ArrayOfModelesModeleEcheancierArticlesModel;
  ListeModeleEpargne?: ArrayOfArticleModeleEpargneModel;
  ListeMoyenPaiement?: ArrayOfMoyensPaiementMoyenPaiementLightModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InitEnteteDossierEpargneResultInput = {
  ListeModeleEcheancier?: ArrayOfModelesModeleEcheancierArticlesModelInput;
  ListeModeleEpargne?: ArrayOfArticleModeleEpargneModelInput;
  ListeMoyenPaiement?: ArrayOfMoyensPaiementMoyenPaiementLightModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InitEnteteDossierPretsEtDonsModel = {
  __typename?: 'InitEnteteDossierPretsEtDonsModel';
  ListeArticle?: ArrayOfArticleWithProduitModel;
  ListeProduit?: ArrayOfProduitLightModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InitEnteteDossierPretsEtDonsModelInput = {
  ListeArticle?: ArrayOfArticleWithProduitModelInput;
  ListeProduit?: ArrayOfProduitLightModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InitFpaModelDto = {
  __typename?: 'InitFPAModelDTO';
  Activite?: ActiviteDto;
  ListeActiviteBaseCodeModel?: ArrayOfActiviteBaseCodeModel;
  ListeAnneeReference?: ArrayOfAnneeReferenceDto;
  ListeCourrier?: ArrayOfCourrierDto;
  ListeFournisseur?: ArrayOfFournisseurDto;
  ListePlanSectionAnalytique?: ArrayOfPlanSectionAnalytiqueModelDto;
  ListeSessionChoix?: ArrayOfSessionChoixDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InitFpaModelDtoInput = {
  Activite?: ActiviteDtoInput;
  ListeActiviteBaseCodeModel?: ArrayOfActiviteBaseCodeModelInput;
  ListeAnneeReference?: ArrayOfAnneeReferenceDtoInput;
  ListeCourrier?: ArrayOfCourrierDtoInput;
  ListeFournisseur?: ArrayOfFournisseurDtoInput;
  ListePlanSectionAnalytique?: ArrayOfPlanSectionAnalytiqueModelDtoInput;
  ListeSessionChoix?: ArrayOfSessionChoixDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InitHistoriqueDossierEpargneResult = {
  __typename?: 'InitHistoriqueDossierEpargneResult';
  ListeCategorie?: ArrayOfProduitLightModel;
  ListeModeleEcheancier?: ArrayOfModeleEcheancierBaseModel;
  ListeModeleEpargne?: ArrayOfArticleModeleEpargneModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InitHistoriqueDossierEpargneResultInput = {
  ListeCategorie?: ArrayOfProduitLightModelInput;
  ListeModeleEcheancier?: ArrayOfModeleEcheancierBaseModelInput;
  ListeModeleEpargne?: ArrayOfArticleModeleEpargneModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InitListingArreteCaisseModel = {
  __typename?: 'InitListingArreteCaisseModel';
  ListeCaisse?: ArrayOfCaisseCaisseBaseModel;
  ListeUtilisateur?: ArrayOfUserBaseModel;
};

export type InitListingArreteCaisseModelInput = {
  ListeCaisse?: ArrayOfCaisseCaisseBaseModelInput;
  ListeUtilisateur?: ArrayOfUserBaseModelInput;
};

export type InitModelForPopupMouvement = {
  __typename?: 'InitModelForPopupMouvement';
  ListeBenef?: ArrayOfBenefDto;
  ListeFournisseur?: ArrayOfFournisseurDto;
  Mouvement?: MouvementComptableDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InitModelForPopupMouvementInput = {
  ListeBenef?: ArrayOfBenefDtoInput;
  ListeFournisseur?: ArrayOfFournisseurDtoInput;
  Mouvement?: MouvementComptableDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InitModeleForCommandeLibreDtoInput = {
  Contexte?: string;
  IdActivite?: number;
  IdBenef?: number;
  IdCaisse?: number;
  IdCommande?: number;
  IdCompteAchat?: number;
  IdDeleg?: number;
  IdExercice?: number;
  IdFournisseur?: number;
  IdOrigineCommande?: number;
  IdPV?: number;
  ListeIdCdeLibre?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarquePrive?: string;
  Status?: StatusDtoEnum;
};

export type InitModeleForVente = {
  __typename?: 'InitModeleForVente';
  IdActivite?: number;
  IdAdresse?: number;
  IdBenef?: number;
  IdCaisse?: number;
  IdCommande?: number;
  IdDeleg?: number;
  IdExercice?: number;
  IdOrigineCommande?: number;
  IdPV?: number;
  IdProduit?: number;
  IdStock?: number;
  ListIdArticle?: ArrayOfdecimal;
  MustValidate?: boolean;
  MyGuid?: string;
  NbChoixArticle?: number;
  NePasCreerCommande?: boolean;
  Objet?: string;
  RemarquePrive?: string;
  Status?: StatusDtoEnum;
};

export type InitModeleForVenteInput = {
  IdActivite?: number;
  IdAdresse?: number;
  IdBenef?: number;
  IdCaisse?: number;
  IdCommande?: number;
  IdDeleg?: number;
  IdExercice?: number;
  IdOrigineCommande?: number;
  IdPV?: number;
  IdProduit?: number;
  IdStock?: number;
  ListIdArticle?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbChoixArticle?: number;
  NePasCreerCommande?: boolean;
  Objet?: string;
  RemarquePrive?: string;
  Status?: StatusDtoEnum;
};

export type InitMouvementsAnalytiquesForCloturerSectionModel = {
  __typename?: 'InitMouvementsAnalytiquesForCloturerSectionModel';
  ListeMouvementsAnalytiques?: ArrayOfEditerMouvementAnalytiqueWithSectionAnalytiqueModel;
  PlanAnalytique?: PlanWithSectionsAnalytiquesModel;
};

export type InitMouvementsAnalytiquesForCloturerSectionModelInput = {
  ListeMouvementsAnalytiques?: ArrayOfEditerMouvementAnalytiqueWithSectionAnalytiqueModelInput;
  PlanAnalytique?: PlanWithSectionsAnalytiquesModelInput;
};

export type InitRechercheHistoriqueReservationModel = {
  __typename?: 'InitRechercheHistoriqueReservationModel';
  ListeFamilles?: ArrayOfFamilleBaseModel;
  ListeMedias?: ArrayOfProduitBaseAvecIdFamilleModel;
};

export type InitRechercheHistoriqueReservationModelInput = {
  ListeFamilles?: ArrayOfFamilleBaseModelInput;
  ListeMedias?: ArrayOfProduitBaseAvecIdFamilleModelInput;
};

export type InitReglementEpargneAgModel = {
  __typename?: 'InitReglementEpargneAGModel';
  ListeCompteCollectif?: ArrayOfCompteLightModel;
  ListeComptePMV?: ArrayOfCompteLightModel;
  ListeJournauxOD?: ArrayOfJournalLightModel;
};

export type InitReglementEpargneAgModelInput = {
  ListeCompteCollectif?: ArrayOfCompteLightModelInput;
  ListeComptePMV?: ArrayOfCompteLightModelInput;
  ListeJournauxOD?: ArrayOfJournalLightModelInput;
};

export type InitReglementModelDto = {
  __typename?: 'InitReglementModelDTO';
  ListeBeneficiaire?: ArrayOfBenefDto;
  ListeFournisseur?: ArrayOfFournisseurDto;
  ListeJournaux?: ArrayOfJournalDto;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InitReglementModelDtoInput = {
  ListeBeneficiaire?: ArrayOfBenefDtoInput;
  ListeFournisseur?: ArrayOfFournisseurDtoInput;
  ListeJournaux?: ArrayOfJournalDtoInput;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InitSelectedEnteteDossierEpargneModelInput = {
  IdActivite?: number;
  IdDossier?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InitTropPercuModel = {
  __typename?: 'InitTropPercuModel';
  IdCollectifTropPercu?: number;
  IdCompteBancaireActivite?: number;
  IdCompteTropPercu?: number;
  IdSectionAnalytique?: number;
  ListeBanques?: ArrayOfstring;
  ListeCaisses?: ArrayOfComptaCaisseModelDto;
  ListeComptes?: ArrayOfCompteLightModel;
  ListeComptesBancaires?: ArrayOfComptesBancairesCompteBancaireLightModel;
  ListeComptesCollectifClient?: ArrayOfCompteLightModel;
  ListeComptesCollectifPMV?: ArrayOfCompteLightModel;
  ListeJournaux?: ArrayOfJournalLightModel;
  ListeMoyensPaiement?: ArrayOfMoyensPaiementMoyenPaiementLightModel;
};

export type InitTropPercuModelInput = {
  IdCollectifTropPercu?: number;
  IdCompteBancaireActivite?: number;
  IdCompteTropPercu?: number;
  IdSectionAnalytique?: number;
  ListeBanques?: ArrayOfstringInput;
  ListeCaisses?: ArrayOfComptaCaisseModelDtoInput;
  ListeComptes?: ArrayOfCompteLightModelInput;
  ListeComptesBancaires?: ArrayOfComptesBancairesCompteBancaireLightModelInput;
  ListeComptesCollectifClient?: ArrayOfCompteLightModelInput;
  ListeComptesCollectifPMV?: ArrayOfCompteLightModelInput;
  ListeJournaux?: ArrayOfJournalLightModelInput;
  ListeMoyensPaiement?: ArrayOfMoyensPaiementMoyenPaiementLightModelInput;
};

export type InitiModelImpressionDto = {
  __typename?: 'InitiModelImpressionDTO';
  ListeCourrier?: ArrayOfCourrierDto;
  ListeParametresImpression?: ArrayOfParametreImpressionDto;
};

export type InitiModelImpressionDtoInput = {
  ListeCourrier?: ArrayOfCourrierDtoInput;
  ListeParametresImpression?: ArrayOfParametreImpressionDtoInput;
};

export type InitialisationImportRestaurationModel = {
  __typename?: 'InitialisationImportRestaurationModel';
  ListeCompte?: ArrayOfCompteBaseModel;
};

export type InitialisationImportRestaurationModelInput = {
  ListeCompte?: ArrayOfCompteBaseModelInput;
};

export type InitialisationImpressionEtiquetteLaCroixModel = {
  __typename?: 'InitialisationImpressionEtiquetteLaCroixModel';
  ListeFamille?: ArrayOfFamilleBaseModel;
  ListeReport?: ArrayOfReportBaseModel;
};

export type InitialisationImpressionEtiquetteLaCroixModelInput = {
  ListeFamille?: ArrayOfFamilleBaseModelInput;
  ListeReport?: ArrayOfReportBaseModelInput;
};

export type InitialisationParametrageClotureModel = {
  __typename?: 'InitialisationParametrageClotureModel';
  ListeCompte?: ArrayOfCompteBaseModel;
  ListeJournaux?: ArrayOfJournalBaseModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InitialisationParametrageClotureModelInput = {
  ListeCompte?: ArrayOfCompteBaseModelInput;
  ListeJournaux?: ArrayOfJournalBaseModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type InitialisationReportDesTiersModel = {
  __typename?: 'InitialisationReportDesTiersModel';
  ListeCompteCollectif?: ArrayOfCompteCollectifModel;
};

export type InitialisationReportDesTiersModelInput = {
  ListeCompteCollectif?: ArrayOfCompteCollectifModelInput;
};

export type InitialisationVariationStockClotureModel = {
  __typename?: 'InitialisationVariationStockClotureModel';
  ListeActivite?: ArrayOfActiviteBaseModel;
  ListeCompteValorisation?: ArrayOfCompteBaseModel;
  ListeCompteVariation?: ArrayOfCompteBaseModel;
};

export type InitialisationVariationStockClotureModelInput = {
  ListeActivite?: ArrayOfActiviteBaseModelInput;
  ListeCompteValorisation?: ArrayOfCompteBaseModelInput;
  ListeCompteVariation?: ArrayOfCompteBaseModelInput;
};

export type InitialisationWorkflowAfpaModel = {
  __typename?: 'InitialisationWorkflowAFPAModel';
  ActiviteHasFormulaire?: boolean;
  ActiviteHasModeleFraisAnnulation?: boolean;
  CodeTypeActivite?: string;
  IsActiviteTVA?: boolean;
  IsActiviteVisibleEnLigne?: boolean;
  IsExisteModeleEcheancier?: boolean;
};

export type InitialisationWorkflowAfpaModelInput = {
  ActiviteHasFormulaire?: boolean;
  ActiviteHasModeleFraisAnnulation?: boolean;
  CodeTypeActivite?: string;
  IsActiviteTVA?: boolean;
  IsActiviteVisibleEnLigne?: boolean;
  IsExisteModeleEcheancier?: boolean;
};

export type InitialiserModeExpertBenefModelDto = {
  __typename?: 'InitialiserModeExpertBenefModelDTO';
  LettresDisponibles?: string;
  ListeVues?: ArrayOfVueDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreBenefTot?: number;
  Status?: StatusDtoEnum;
  VueParDefaut?: VueDto;
};

export type InitialiserModeExpertBenefModelDtoInput = {
  LettresDisponibles?: string;
  ListeVues?: ArrayOfVueDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreBenefTot?: number;
  Status?: StatusDtoEnum;
  VueParDefaut?: VueDtoInput;
};

export type InventaireDto = {
  __typename?: 'InventaireDTO';
  Activite?: ActiviteDto;
  DateCloture?: any;
  DateInventaire?: any;
  DateOuverture?: any;
  Id?: number;
  IdTStockCurrent?: number;
  ListeLigneInventaire?: ArrayOfLigneInventaireDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
  Stock?: StockDto;
  Titre?: string;
  User?: UsersDto;
};

export type InventaireDtoInput = {
  Activite?: ActiviteDtoInput;
  DateCloture?: any;
  DateInventaire?: any;
  DateOuverture?: any;
  Id?: number;
  IdTStockCurrent?: number;
  ListeLigneInventaire?: ArrayOfLigneInventaireDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
  Stock?: StockDtoInput;
  Titre?: string;
  User?: UsersDtoInput;
};

export type InventaireStockModelInput = {
  DateInvetaire?: any;
  Id?: number;
  IdActivite?: number;
  IdStock?: number;
  IdUser?: number;
  Libelle?: string;
  ListeLigneInventaire?: ArrayOfLigneInventaireStockModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type IsSupprimableEcritureModelInput = {
  IdEcriture?: number;
  IdFacture?: number;
  IsSuppressionRemiseEnCaisse?: boolean;
  ListeIdEcriture?: ArrayOfdecimalInput;
};

export type IsSupprimableStockModel = {
  __typename?: 'IsSupprimableStockModel';
  MessageSuppressionImpossible?: string;
  MessageWarningSuppression?: string;
};

export type IsSupprimableStockModelInput = {
  MessageSuppressionImpossible?: string;
  MessageWarningSuppression?: string;
};

export type JourModel = {
  __typename?: 'JourModel';
  IsSelected?: boolean;
  LibelleJour?: string;
  ListeHeureObs?: ArrayOfHeureModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type JourModelInput = {
  IsSelected?: boolean;
  LibelleJour?: string;
  ListeHeureObs?: ArrayOfHeureModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type JourWithDateModel = {
  __typename?: 'JourWithDateModel';
  DateJour?: any;
  IsSelected?: boolean;
  LibelleJour?: string;
  ListeHeureObs?: ArrayOfHeureModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type JourWithDateModelInput = {
  DateJour?: any;
  IsSelected?: boolean;
  LibelleJour?: string;
  ListeHeureObs?: ArrayOfHeureModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type JournalBaseModel = {
  __typename?: 'JournalBaseModel';
  CodeJournal?: string;
  CodeTypeJournal?: string;
  IdJournal?: number;
  LibelleJournal?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
};

export type JournalBaseModelInput = {
  CodeJournal?: string;
  CodeTypeJournal?: string;
  IdJournal?: number;
  LibelleJournal?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
};

export type JournalDto = {
  __typename?: 'JournalDTO';
  CEDelegation?: CeDelegationDto;
  Code?: string;
  CodeITool?: string;
  CompteBancaire?: CompteBancaireDto;
  HasEcriture?: boolean;
  Id?: number;
  IdCompteBancaire?: number;
  IdJournalType?: number;
  IsSupprime?: boolean;
  Libelle?: string;
  ListeCompteEcriture?: ArrayOfCompteEcritureDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NotHasEcriture?: boolean;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
  TypeJournal?: JournalTypeDto;
  UserLastUpdate?: UsersDto;
};

export type JournalDtoInput = {
  CEDelegation?: CeDelegationDtoInput;
  Code?: string;
  CodeITool?: string;
  CompteBancaire?: CompteBancaireDtoInput;
  HasEcriture?: boolean;
  Id?: number;
  IdCompteBancaire?: number;
  IdJournalType?: number;
  IsSupprime?: boolean;
  Libelle?: string;
  ListeCompteEcriture?: ArrayOfCompteEcritureDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NotHasEcriture?: boolean;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
  TypeJournal?: JournalTypeDtoInput;
  UserLastUpdate?: UsersDtoInput;
};

export type JournalEcritureModel = {
  __typename?: 'JournalEcritureModel';
  CodeJournal?: string;
  IdJournal?: number;
  IsOnEcriture?: boolean;
  LibelleJournal?: string;
};

export type JournalEcritureModelInput = {
  CodeJournal?: string;
  IdJournal?: number;
  IsOnEcriture?: boolean;
  LibelleJournal?: string;
};

export type JournalLightModel = {
  __typename?: 'JournalLightModel';
  Id?: number;
  Libelle?: string;
  TypeBudget?: string;
  TypeJournal?: string;
};

export type JournalLightModelInput = {
  Id?: number;
  Libelle?: string;
  TypeBudget?: string;
  TypeJournal?: string;
};

export type JournalModelDto = {
  __typename?: 'JournalModelDTO';
  Code?: string;
  CodeTypeJournal?: string;
  IdJournal?: number;
  LibelleJournal?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type JournalModelDtoInput = {
  Code?: string;
  CodeTypeJournal?: string;
  IdJournal?: number;
  LibelleJournal?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type JournalTypeDto = {
  __typename?: 'JournalTypeDTO';
  Code?: string;
  Description?: string;
  Id?: number;
  Libelle?: string;
  ListeJournal?: ArrayOfJournalDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type JournalTypeDtoInput = {
  Code?: string;
  Description?: string;
  Id?: number;
  Libelle?: string;
  ListeJournal?: ArrayOfJournalDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type KeyValueModelDto = {
  __typename?: 'KeyValueModelDTO';
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type KeyValueModelDtoInput = {
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type KeyValueModelInput = {
  Key?: number;
  Value?: number;
};

export type KeyValueOfdecimalNullableOfdateTimeU6ho3Bhd = {
  __typename?: 'KeyValueOfdecimalNullableOfdateTimeU6ho3Bhd';
  Key?: number;
  Value?: any;
};

export type KeyValueOfdecimalNullableOfdateTimeU6ho3BhdInput = {
  Key?: number;
  Value?: any;
};

export type KeyValueOfdecimalNullableOfdecimalU6ho3BhdInput = {
  Key?: number;
  Value?: number;
};

export type KeyValueOfdecimalint = {
  __typename?: 'KeyValueOfdecimalint';
  Key?: number;
  Value?: number;
};

export type KeyValueOfdecimalintInput = {
  Key?: number;
  Value?: number;
};

export type KeyValueOfdecimalstring = {
  __typename?: 'KeyValueOfdecimalstring';
  Key?: number;
  Value?: string;
};

export type KeyValueOfdecimalstringInput = {
  Key?: number;
  Value?: string;
};

export type KeyValueOfintstring = {
  __typename?: 'KeyValueOfintstring';
  Key?: number;
  Value?: string;
};

export type KeyValueOfintstringInput = {
  Key?: number;
  Value?: string;
};

export type KeyValueOfstringFactureDtoOsihyJcl = {
  __typename?: 'KeyValueOfstringFactureDTOOsihyJcl';
  Key?: string;
  Value?: FactureDto;
};

export type KeyValueOfstringFactureDtoOsihyJclInput = {
  Key?: string;
  Value?: FactureDtoInput;
};

export type KeyValueOfstringanyTypeInput = {
  Key?: string;
  Value?: any;
};

export type KeyValueOfstringdecimal = {
  __typename?: 'KeyValueOfstringdecimal';
  Key?: string;
  Value?: number;
};

export type KeyValueOfstringdecimalInput = {
  Key?: string;
  Value?: number;
};

export type KeyValueOfstringstring = {
  __typename?: 'KeyValueOfstringstring';
  Key?: string;
  Value?: string;
};

export type KeyValueOfstringstringInput = {
  Key?: string;
  Value?: string;
};

export type KeyValuePairOfNullableOfdateTimeNullableOfdateTime_ShTdFhl_PInput = {
  key?: any;
  value?: any;
};

export type KeyValuePairOfintintInput = {
  key?: number;
  value?: number;
};

export type KeyValueStrings = {
  __typename?: 'KeyValueStrings';
  Key?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Value?: string;
};

export type KeyValueStringsInput = {
  Key?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Value?: string;
};

export type KitBancaireDto = {
  __typename?: 'KitBancaireDTO';
  CodeXL?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Version?: string;
};

export type KitBancaireDtoInput = {
  CodeXL?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Version?: string;
};

export type LettrageEtNombreElementModel = {
  __typename?: 'LettrageEtNombreElementModel';
  ListeLettrageModel?: ArrayOfLettrageModel;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreElementTotal?: number;
  Status?: StatusDtoEnum;
};

export type LettrageEtNombreElementModelInput = {
  ListeLettrageModel?: ArrayOfLettrageModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreElementTotal?: number;
  Status?: StatusDtoEnum;
};

export type LettrageModel = {
  __typename?: 'LettrageModel';
  CodeJournal?: string;
  CompteCollectif?: string;
  Credit?: number;
  DateEcriture?: any;
  Debit?: number;
  IdBenef?: number;
  IdDelegCibleEcriture?: number;
  IdEcriture?: number;
  IdExercice?: number;
  IdFacture?: number;
  IdFournisseur?: number;
  IdMouvement?: number;
  IdRemiseEnBanque?: number;
  IsSelected?: boolean;
  Lettre?: string;
  LibelleEcriture?: string;
  LibelleMouvement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomDelegCibleEcriture?: string;
  NomFournisseur?: string;
  NomPrenomBenef?: string;
  NumeroBorderau?: string;
  NumeroPiece?: string;
  NumeroReference?: string;
  OnBudgetSocial?: boolean;
  Status?: StatusDtoEnum;
  Utilisateur?: string;
};

export type LettrageModelInput = {
  CodeJournal?: string;
  CompteCollectif?: string;
  Credit?: number;
  DateEcriture?: any;
  Debit?: number;
  IdBenef?: number;
  IdDelegCibleEcriture?: number;
  IdEcriture?: number;
  IdExercice?: number;
  IdFacture?: number;
  IdFournisseur?: number;
  IdMouvement?: number;
  IdRemiseEnBanque?: number;
  IsSelected?: boolean;
  Lettre?: string;
  LibelleEcriture?: string;
  LibelleMouvement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomDelegCibleEcriture?: string;
  NomFournisseur?: string;
  NomPrenomBenef?: string;
  NumeroBorderau?: string;
  NumeroPiece?: string;
  NumeroReference?: string;
  OnBudgetSocial?: boolean;
  Status?: StatusDtoEnum;
  Utilisateur?: string;
};

export type LibTypePjBaseModel = {
  __typename?: 'LibTypePJBaseModel';
  IdPJ?: number;
  LibellePJ?: string;
  LibelleTypePJ?: string;
};

export type LibTypePjBaseModelInput = {
  IdPJ?: number;
  LibellePJ?: string;
  LibelleTypePJ?: string;
};

export type LibelleAfpaModel = {
  __typename?: 'LibelleAFPAModel';
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleModeleLocation?: string;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type LibelleAfpaModelInput = {
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleModeleLocation?: string;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type LibelleActionModelInput = {
  IdAction?: number;
  LibelleAction?: string;
  LibelleStatutTransition?: string;
  VersStatutPrecedent?: boolean;
  VersStatutSuivant?: boolean;
};

export type LibellesAfpaModel = {
  __typename?: 'LibellesAFPAModel';
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleModeleLocation?: string;
  LibelleProduit?: string;
};

export type LibellesAfpaModelInput = {
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleModeleLocation?: string;
  LibelleProduit?: string;
};

export enum LibrairieImagesDtoEnum {
  Articles = 'Articles',
  Benefs = 'Benefs',
  Menus = 'Menus',
  None = 'None'
}

export type LienDirectoDto = {
  __typename?: 'LienDirectoDTO';
  Activite?: ActiviteDto;
  CodeDirecto?: string;
  CodeM?: string;
  CodeModule?: string;
  CodeModulePourAffichage?: string;
  Id?: number;
  IdcPortail?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type LienDirectoDtoInput = {
  Activite?: ActiviteDtoInput;
  CodeDirecto?: string;
  CodeM?: string;
  CodeModule?: string;
  CodeModulePourAffichage?: string;
  Id?: number;
  IdcPortail?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type LienDirectoModelDto = {
  __typename?: 'LienDirectoModelDTO';
  DateDebutAffichage?: any;
  DateFinAffichage?: any;
  IdActivite?: number;
  IdFamille?: number;
  IdLien?: number;
  IdLienAffichage?: number;
  IsAffiche?: boolean;
  Libelle?: string;
  Lien?: string;
  ListeFamille?: ArrayOfFamilleProduitSimpleModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  SelectedFamille?: FamilleProduitSimpleModelDto;
  Status?: StatusDtoEnum;
  VisibilityBoutonSupp?: boolean;
};

export type LienDirectoModelDtoInput = {
  DateDebutAffichage?: any;
  DateFinAffichage?: any;
  IdActivite?: number;
  IdFamille?: number;
  IdLien?: number;
  IdLienAffichage?: number;
  IsAffiche?: boolean;
  Libelle?: string;
  Lien?: string;
  ListeFamille?: ArrayOfFamilleProduitSimpleModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  SelectedFamille?: FamilleProduitSimpleModelDtoInput;
  Status?: StatusDtoEnum;
  VisibilityBoutonSupp?: boolean;
};

export type LieuDto = {
  __typename?: 'LieuDTO';
  Adresse?: AdresseDto;
  Code?: string;
  Email?: string;
  Fax?: string;
  Id?: number;
  IsCloture?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
  Telephone?: string;
};

export type LieuDtoInput = {
  Adresse?: AdresseDtoInput;
  Code?: string;
  Email?: string;
  Fax?: string;
  Id?: number;
  IsCloture?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
  Telephone?: string;
};

export type LieuModelDto = {
  __typename?: 'LieuModelDTO';
  IDPays?: number;
  IDRegion?: number;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type LieuModelDtoInput = {
  IDPays?: number;
  IDRegion?: number;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type LigneAttributionModelDto = {
  __typename?: 'LigneAttributionModelDTO';
  AnneeRefValide?: boolean;
  BenefCible?: string;
  BenefMatricule?: string;
  BenefNom?: string;
  BenefPrenom?: string;
  Beneficiaire?: BenefDto;
  Choix?: number;
  CodeMoyenCorespondancePrivilegier?: string;
  DateAu?: any;
  DateDu?: any;
  IdBenef?: number;
  IdCourrierAcc?: number;
  IdCourrierRef?: number;
  IdLigneCmd?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroAttribution?: number;
  Resultat?: boolean;
  Status?: StatusDtoEnum;
  Valeur1?: number;
  Valeur1IsDate?: boolean;
  Valeur2?: number;
  Valeur2IsDate?: boolean;
  Valeur3?: number;
  Valeur3IsDate?: boolean;
  Valeur4?: number;
  Valeur4IsDate?: boolean;
};

export type LigneAttributionModelDtoInput = {
  AnneeRefValide?: boolean;
  BenefCible?: string;
  BenefMatricule?: string;
  BenefNom?: string;
  BenefPrenom?: string;
  Beneficiaire?: BenefDtoInput;
  Choix?: number;
  CodeMoyenCorespondancePrivilegier?: string;
  DateAu?: any;
  DateDu?: any;
  IdBenef?: number;
  IdCourrierAcc?: number;
  IdCourrierRef?: number;
  IdLigneCmd?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroAttribution?: number;
  Resultat?: boolean;
  Status?: StatusDtoEnum;
  Valeur1?: number;
  Valeur1IsDate?: boolean;
  Valeur2?: number;
  Valeur2IsDate?: boolean;
  Valeur3?: number;
  Valeur3IsDate?: boolean;
  Valeur4?: number;
  Valeur4IsDate?: boolean;
};

export type LigneAvoirModelDto = {
  __typename?: 'LigneAvoirModelDTO';
  AdresseBenef?: AdresseDto;
  AdresseFournisseur?: AdresseDto;
  CompteModelAchatVente?: CompteModelDto;
  CompteModelCollectif?: CompteModelDto;
  DateCommande?: any;
  IdArticle?: number;
  IdAvoir?: number;
  IdBenef?: number;
  IdCompte?: number;
  IdCptCollectif?: number;
  IdFournisseur?: number;
  IdLigneAvoir?: number;
  IdModeleSaisi?: number;
  IdModeleTVA?: number;
  IdMouvement?: number;
  LibelleLigneAvoir?: string;
  LibelleProduitArticle?: string;
  LigneFactAvoirDTO?: LigneFactureDto;
  ListeLigneRepartitionCptSectionAnaModele?: ArrayOfLigneRepartitionCompteAnaSecModelDto;
  ListeSectionAnalytique?: ArrayOfSectionAnalytiqueModelDto;
  Montant?: number;
  MontantHorsTaxe?: number;
  MontantRemise?: number;
  MontantSubventionUnitaire?: number;
  MontantTVA?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Quantite?: number;
  Reference?: string;
  RmqPrivee?: string;
  RmqPublique?: string;
  Status?: StatusDtoEnum;
  TauxTVA?: number;
};

export type LigneAvoirModelDtoInput = {
  AdresseBenef?: AdresseDtoInput;
  AdresseFournisseur?: AdresseDtoInput;
  CompteModelAchatVente?: CompteModelDtoInput;
  CompteModelCollectif?: CompteModelDtoInput;
  DateCommande?: any;
  IdArticle?: number;
  IdAvoir?: number;
  IdBenef?: number;
  IdCompte?: number;
  IdCptCollectif?: number;
  IdFournisseur?: number;
  IdLigneAvoir?: number;
  IdModeleSaisi?: number;
  IdModeleTVA?: number;
  IdMouvement?: number;
  LibelleLigneAvoir?: string;
  LibelleProduitArticle?: string;
  LigneFactAvoirDTO?: LigneFactureDtoInput;
  ListeLigneRepartitionCptSectionAnaModele?: ArrayOfLigneRepartitionCompteAnaSecModelDtoInput;
  ListeSectionAnalytique?: ArrayOfSectionAnalytiqueModelDtoInput;
  Montant?: number;
  MontantHorsTaxe?: number;
  MontantRemise?: number;
  MontantSubventionUnitaire?: number;
  MontantTVA?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Quantite?: number;
  Reference?: string;
  RmqPrivee?: string;
  RmqPublique?: string;
  Status?: StatusDtoEnum;
  TauxTVA?: number;
};

export type LigneBlBrDto = {
  __typename?: 'LigneBlBrDTO';
  BlBr?: BlBrDto;
  Id?: number;
  LigneCommande?: LigneCommandeDto;
  ListeMouvementStock?: ArrayOfMouvementStockDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Qte?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type LigneBlBrDtoInput = {
  BlBr?: BlBrDtoInput;
  Id?: number;
  LigneCommande?: LigneCommandeDtoInput;
  ListeMouvementStock?: ArrayOfMouvementStockDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Qte?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type LigneCdeFourArticleReapproModelDto = {
  __typename?: 'LigneCdeFourArticleReapproModelDTO';
  BenefNomPrenom?: string;
  CodeLivraison?: string;
  DateCommande?: any;
  IdCommande?: number;
  IdFournisseur?: number;
  IdLgnCmd?: number;
  IsSelected?: boolean;
  LibelleArticleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomFournisseur?: string;
  ObjetCommande?: string;
  QteCommandee?: number;
  QteLivrer?: number;
  QteReceptionnee?: number;
  Status?: StatusDtoEnum;
};

export type LigneCdeFourArticleReapproModelDtoInput = {
  BenefNomPrenom?: string;
  CodeLivraison?: string;
  DateCommande?: any;
  IdCommande?: number;
  IdFournisseur?: number;
  IdLgnCmd?: number;
  IsSelected?: boolean;
  LibelleArticleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomFournisseur?: string;
  ObjetCommande?: string;
  QteCommandee?: number;
  QteLivrer?: number;
  QteReceptionnee?: number;
  Status?: StatusDtoEnum;
};

export type LigneCessionStockDetailModel = {
  __typename?: 'LigneCessionStockDetailModel';
  IdArticleEntree?: number;
  IdArticleSortie?: number;
  IdCessionStock?: number;
  IdLigneCessionStock?: number;
  IdStockEntree?: number;
  IdStockSortie?: number;
  IdUtilisateurReception?: number;
  IsSupprimee?: boolean;
  LibelleActiviteEntree?: string;
  LibelleActiviteSortie?: string;
  LibelleArticleEntree?: string;
  LibelleArticleSortie?: string;
  LibelleDelegationEntree?: string;
  LibelleDelegationSortie?: string;
  LibellePointVenteEntree?: string;
  LibellePointVenteSortie?: string;
  LibelleStockEntree?: string;
  LibelleStockSortie?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteEntree?: number;
  QuantiteSortie?: number;
  Status?: StatusDtoEnum;
};

export type LigneCessionStockDetailModelInput = {
  IdArticleEntree?: number;
  IdArticleSortie?: number;
  IdCessionStock?: number;
  IdLigneCessionStock?: number;
  IdStockEntree?: number;
  IdStockSortie?: number;
  IdUtilisateurReception?: number;
  IsSupprimee?: boolean;
  LibelleActiviteEntree?: string;
  LibelleActiviteSortie?: string;
  LibelleArticleEntree?: string;
  LibelleArticleSortie?: string;
  LibelleDelegationEntree?: string;
  LibelleDelegationSortie?: string;
  LibellePointVenteEntree?: string;
  LibellePointVenteSortie?: string;
  LibelleStockEntree?: string;
  LibelleStockSortie?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteEntree?: number;
  QuantiteSortie?: number;
  Status?: StatusDtoEnum;
};

export type LigneCessionStockModel = {
  __typename?: 'LigneCessionStockModel';
  IdArticleEntree?: number;
  IdArticleSortie?: number;
  IdCessionStock?: number;
  IdLigneCessionStock?: number;
  IdStockEntree?: number;
  IdStockSortie?: number;
  IdUtilisateurReception?: number;
  IsSupprimee?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteEntree?: number;
  QuantiteSortie?: number;
  Status?: StatusDtoEnum;
};

export type LigneCessionStockModelInput = {
  IdArticleEntree?: number;
  IdArticleSortie?: number;
  IdCessionStock?: number;
  IdLigneCessionStock?: number;
  IdStockEntree?: number;
  IdStockSortie?: number;
  IdUtilisateurReception?: number;
  IsSupprimee?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteEntree?: number;
  QuantiteSortie?: number;
  Status?: StatusDtoEnum;
};

export type LigneCessionStockTransfertStockModel = {
  __typename?: 'LigneCessionStockTransfertStockModel';
  Auteur?: string;
  CodeExemplaire?: string;
  IdArticleEntree?: number;
  IdArticleSortie?: number;
  IdCessionStock?: number;
  IdLigneCessionStock?: number;
  IdStockEntree?: number;
  IdStockSortie?: number;
  IdUtilisateurReception?: number;
  IsSelected?: boolean;
  IsSupprimee?: boolean;
  LibelleFamille?: string;
  LibelleMedia?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteEntree?: number;
  QuantiteSortie?: number;
  Remarque?: string;
  Status?: StatusDtoEnum;
  TypeMedia?: string;
};

export type LigneCessionStockTransfertStockModelInput = {
  Auteur?: string;
  CodeExemplaire?: string;
  IdArticleEntree?: number;
  IdArticleSortie?: number;
  IdCessionStock?: number;
  IdLigneCessionStock?: number;
  IdStockEntree?: number;
  IdStockSortie?: number;
  IdUtilisateurReception?: number;
  IsSelected?: boolean;
  IsSupprimee?: boolean;
  LibelleFamille?: string;
  LibelleMedia?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteEntree?: number;
  QuantiteSortie?: number;
  Remarque?: string;
  Status?: StatusDtoEnum;
  TypeMedia?: string;
};

export type LigneCommandeDto = {
  __typename?: 'LigneCommandeDTO';
  Adresse?: AdresseDto;
  Article?: ArticleDto;
  Benef?: BenefDto;
  DateDebutLocation?: any;
  DateEcheanceReappro?: any;
  DateFacture?: any;
  DateFinLocation?: any;
  DevisCommande?: DevisCommandeDto;
  HeureDebutLocation?: string;
  HeureFinLocation?: string;
  IDBenef?: number;
  Id?: number;
  IdModeLivraison?: number;
  LibelleLigneCommande?: string;
  LigneCommandeFournisseur?: LigneCommandeDto;
  ListeAttributionCDELig?: ArrayOfAttributionCdeLigneDto;
  ListeConsoMouvement?: ArrayOfConsoMouvementDto;
  ListeFormulaire?: ArrayOfFormulaireDto;
  ListeHistoriqueStatut?: ArrayOfHistoStatutCommandeDto;
  ListeLigneBLBR?: ArrayOfLigneBlBrDto;
  ListeLigneFacture?: ArrayOfLigneFactureDto;
  ListeMouvementStock?: ArrayOfMouvementStockDto;
  ModeLivraison?: ModeLivraisonDto;
  ModeleSaisieLibre?: ModeleSaisieLibreDto;
  MontantParQuantiteRembourseAcceptePresta?: number;
  MontantParQuantiteRembourseTheoriquePresta?: number;
  MontantSubAccepteUnitaire?: number;
  MontantSubTheoUnitaire?: number;
  MontantTotalHorsSubvention?: number;
  MontantTotalPresentePresta?: number;
  MontantTotalPrisEnComptePresta?: number;
  MontantTotalSubventionDeduite?: number;
  MontantUnitaire?: number;
  MontantUnitaireFinalFournisseur?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbUnites?: number;
  NbUnitesPresenteesPresta?: number;
  NbUnitesPrisesEnComptePresta?: number;
  Quantite?: number;
  QuantiteALivre?: number;
  QuantitePresenteePresta?: number;
  QuantitePriseEnComptePresta?: number;
  QuantiteRestanteALivrer?: number;
  Quotite?: number;
  Reference?: string;
  ReferenceFacture?: string;
  RemarquePriveCE?: string;
  RemarquePublic?: string;
  RemiseMontantUnitaire?: number;
  Status?: StatusDtoEnum;
  StatutAdministratifCurrent?: StatutCommandeDto;
  StatutLivraisonCurrent?: StatutCommandeDto;
};

export type LigneCommandeDtoInput = {
  Adresse?: AdresseDtoInput;
  Article?: ArticleDtoInput;
  Benef?: BenefDtoInput;
  DateDebutLocation?: any;
  DateEcheanceReappro?: any;
  DateFacture?: any;
  DateFinLocation?: any;
  DevisCommande?: DevisCommandeDtoInput;
  HeureDebutLocation?: string;
  HeureFinLocation?: string;
  IDBenef?: number;
  Id?: number;
  IdModeLivraison?: number;
  LibelleLigneCommande?: string;
  LigneCommandeFournisseur?: LigneCommandeDtoInput;
  ListeAttributionCDELig?: ArrayOfAttributionCdeLigneDtoInput;
  ListeConsoMouvement?: ArrayOfConsoMouvementDtoInput;
  ListeFormulaire?: ArrayOfFormulaireDtoInput;
  ListeHistoriqueStatut?: ArrayOfHistoStatutCommandeDtoInput;
  ListeLigneBLBR?: ArrayOfLigneBlBrDtoInput;
  ListeLigneFacture?: ArrayOfLigneFactureDtoInput;
  ListeMouvementStock?: ArrayOfMouvementStockDtoInput;
  ModeLivraison?: ModeLivraisonDtoInput;
  ModeleSaisieLibre?: ModeleSaisieLibreDtoInput;
  MontantParQuantiteRembourseAcceptePresta?: number;
  MontantParQuantiteRembourseTheoriquePresta?: number;
  MontantSubAccepteUnitaire?: number;
  MontantSubTheoUnitaire?: number;
  MontantTotalHorsSubvention?: number;
  MontantTotalPresentePresta?: number;
  MontantTotalPrisEnComptePresta?: number;
  MontantTotalSubventionDeduite?: number;
  MontantUnitaire?: number;
  MontantUnitaireFinalFournisseur?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbUnites?: number;
  NbUnitesPresenteesPresta?: number;
  NbUnitesPrisesEnComptePresta?: number;
  Quantite?: number;
  QuantiteALivre?: number;
  QuantitePresenteePresta?: number;
  QuantitePriseEnComptePresta?: number;
  QuantiteRestanteALivrer?: number;
  Quotite?: number;
  Reference?: string;
  ReferenceFacture?: string;
  RemarquePriveCE?: string;
  RemarquePublic?: string;
  RemiseMontantUnitaire?: number;
  Status?: StatusDtoEnum;
  StatutAdministratifCurrent?: StatutCommandeDtoInput;
  StatutLivraisonCurrent?: StatutCommandeDtoInput;
};

export type LigneCommandeFormulaireModel = {
  __typename?: 'LigneCommandeFormulaireModel';
  CodeModeLivraison?: string;
  DateFacture?: any;
  IdLigneCommande?: number;
  LibelleLigneCommande?: string;
  MontantLigne?: number;
  MontantPresente?: number;
  MontantPrisEnCompte?: number;
  MontantRembourse?: number;
  NomPrenomBeneficiaire?: string;
  PrixVenteUnitaire?: number;
  Quantite?: number;
  QuantiteALivrer?: number;
  ReferenceFacture?: string;
  SubventionTotale?: number;
  SubventionUnitaire?: number;
};

export type LigneCommandeFormulaireModelInput = {
  CodeModeLivraison?: string;
  DateFacture?: any;
  IdLigneCommande?: number;
  LibelleLigneCommande?: string;
  MontantLigne?: number;
  MontantPresente?: number;
  MontantPrisEnCompte?: number;
  MontantRembourse?: number;
  NomPrenomBeneficiaire?: string;
  PrixVenteUnitaire?: number;
  Quantite?: number;
  QuantiteALivrer?: number;
  ReferenceFacture?: string;
  SubventionTotale?: number;
  SubventionUnitaire?: number;
};

export type LigneCommandeHistoriqueReservationRpModel = {
  __typename?: 'LigneCommandeHistoriqueReservationRPModel';
  AuteurCompositeurMedia?: string;
  CodeStatutAdministratif?: string;
  CodeTypeActivite?: string;
  CodeTypeMedia?: string;
  CoteMedia?: string;
  CouleurStatutPerso?: string;
  DateCommande?: any;
  DateDebutReservation?: any;
  DateEmprunt?: any;
  DateFinReservation?: any;
  DateLivraison?: any;
  DateRetourPrevue?: any;
  DateRetourReelle?: any;
  IdBenef?: number;
  IdCommande?: number;
  IdFamille?: number;
  IdLigneCommande?: number;
  IdProduit?: number;
  IdStockLocalisation?: number;
  IsALivrer?: boolean;
  IsBloque?: boolean;
  IsEmpruntee?: boolean;
  IsEnFileAttente?: boolean;
  IsEnLigne?: boolean;
  IsEnRetard?: boolean;
  IsFactureSolde?: boolean;
  IsLivEnFileAttente?: boolean;
  IsLivraisonSansObjet?: boolean;
  IsNonLivrable?: boolean;
  IsPerdu?: boolean;
  IsReserve?: boolean;
  IsRetournee?: boolean;
  IsRetourneePartiellement?: boolean;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  LibelleStatutPerso?: string;
  LibelleStockLivraison?: string;
  LibelleStockRetour?: string;
  LibelleTypeMedia?: string;
  ListeIdExemplaireDispoMedia?: ArrayOfdecimal;
  MatriculeBenef?: string;
  MontantRestantARegler?: number;
  MontantTotal?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBenef?: string;
  NombreFileAttente?: number;
  NombreJourEmprunt?: number;
  PlaceFileAttente?: number;
  PrenomBenef?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type LigneCommandeHistoriqueReservationRpModelInput = {
  AuteurCompositeurMedia?: string;
  CodeStatutAdministratif?: string;
  CodeTypeActivite?: string;
  CodeTypeMedia?: string;
  CoteMedia?: string;
  CouleurStatutPerso?: string;
  DateCommande?: any;
  DateDebutReservation?: any;
  DateEmprunt?: any;
  DateFinReservation?: any;
  DateLivraison?: any;
  DateRetourPrevue?: any;
  DateRetourReelle?: any;
  IdBenef?: number;
  IdCommande?: number;
  IdFamille?: number;
  IdLigneCommande?: number;
  IdProduit?: number;
  IdStockLocalisation?: number;
  IsALivrer?: boolean;
  IsBloque?: boolean;
  IsEmpruntee?: boolean;
  IsEnFileAttente?: boolean;
  IsEnLigne?: boolean;
  IsEnRetard?: boolean;
  IsFactureSolde?: boolean;
  IsLivEnFileAttente?: boolean;
  IsLivraisonSansObjet?: boolean;
  IsNonLivrable?: boolean;
  IsPerdu?: boolean;
  IsReserve?: boolean;
  IsRetournee?: boolean;
  IsRetourneePartiellement?: boolean;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  LibelleStatutPerso?: string;
  LibelleStockLivraison?: string;
  LibelleStockRetour?: string;
  LibelleTypeMedia?: string;
  ListeIdExemplaireDispoMedia?: ArrayOfdecimalInput;
  MatriculeBenef?: string;
  MontantRestantARegler?: number;
  MontantTotal?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBenef?: string;
  NombreFileAttente?: number;
  NombreJourEmprunt?: number;
  PlaceFileAttente?: number;
  PrenomBenef?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type LigneCommandeLibreModelDto = {
  __typename?: 'LigneCommandeLibreModelDTO';
  BenefNomPrenom?: string;
  CodeStatusCommande?: string;
  CompteModel?: CompteModelDto;
  DateDebutLocation?: any;
  DateFinLocation?: any;
  IdBenef?: number;
  IdCommande?: number;
  IdCompte?: number;
  IdFournisseur?: number;
  IdLigneCdeClientEnvoyeFour?: number;
  IdLigneCommande?: number;
  IdModeleSaisie?: number;
  LibelleLigneCommande?: string;
  LibelleModeleSaisie?: string;
  ListeLigneCommandeCompteAnaSecModel?: ArrayOfLigneRepartitionCompteAnaSecModelDto;
  MontantUnitaire?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Quantite?: number;
  ReferenceLigneCommande?: string;
  RmqPrivee?: string;
  RmqPublique?: string;
  Status?: StatusDtoEnum;
};

export type LigneCommandeLibreModelDtoInput = {
  BenefNomPrenom?: string;
  CodeStatusCommande?: string;
  CompteModel?: CompteModelDtoInput;
  DateDebutLocation?: any;
  DateFinLocation?: any;
  IdBenef?: number;
  IdCommande?: number;
  IdCompte?: number;
  IdFournisseur?: number;
  IdLigneCdeClientEnvoyeFour?: number;
  IdLigneCommande?: number;
  IdModeleSaisie?: number;
  LibelleLigneCommande?: string;
  LibelleModeleSaisie?: string;
  ListeLigneCommandeCompteAnaSecModel?: ArrayOfLigneRepartitionCompteAnaSecModelDtoInput;
  MontantUnitaire?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Quantite?: number;
  ReferenceLigneCommande?: string;
  RmqPrivee?: string;
  RmqPublique?: string;
  Status?: StatusDtoEnum;
};

export type LigneCommandeValidationAncvConnectModel = {
  __typename?: 'LigneCommandeValidationANCVConnectModel';
  EmailPerso?: string;
  EmailPro?: string;
  IdBenef?: number;
  IdLigneCommande?: number;
  IdSiteBeneficiaire?: number;
  LibelleLigneCommande?: string;
  Matricule?: string;
  MontantLigne?: number;
  Nom?: string;
  Prenom?: string;
  TelDomicile?: string;
  TelPortable?: string;
  TelPro?: string;
};

export type LigneCommandeValidationAncvConnectModelInput = {
  EmailPerso?: string;
  EmailPro?: string;
  IdBenef?: number;
  IdLigneCommande?: number;
  IdSiteBeneficiaire?: number;
  LibelleLigneCommande?: string;
  Matricule?: string;
  MontantLigne?: number;
  Nom?: string;
  Prenom?: string;
  TelDomicile?: string;
  TelPortable?: string;
  TelPro?: string;
};

export type LigneDevisModeleDto = {
  __typename?: 'LigneDevisModeleDTO';
  APayer?: number;
  Adresse?: string;
  ArticleTypeComportement?: string;
  BenefNomPrenom?: string;
  CapaciteMax?: number;
  CapaciteMin?: number;
  CodeHistoStatut?: string;
  CodeModeLivraison?: string;
  CodeStatutFacture?: string;
  CodeStatutLigne?: string;
  DateDebutCotisation?: any;
  DateDebutLocation?: any;
  DateFinCotisation?: any;
  DateFinLocation?: any;
  DateReapproLigne?: any;
  EnteteDevisModel?: EnteteDevisCommandeForVentesModeleDto;
  HaveFormulaireParametre?: boolean;
  IdAdresseCommande?: number;
  IdArticle?: number;
  IdBenefLigne?: number;
  IdCommandeFournisseur?: number;
  IdCompteImputation?: number;
  IdCourrier?: number;
  IdLigneDevisCommande?: number;
  IdModeleFraisAnnulation?: number;
  IdProduit?: number;
  IdSessionChoix?: number;
  IsArticleChequierDynamique?: boolean;
  IsArticleGrpNominatif?: boolean;
  IsArticleReapproOuNotCanLivre?: boolean;
  IsArticleUniqueParCommande?: boolean;
  IsArticleUnitaire?: boolean;
  IsGererParticipant?: boolean;
  IsLigneLivree?: boolean;
  IsLocationDisponible?: boolean;
  IsOptionLocation?: boolean;
  IsOptionObligatoireLocation?: boolean;
  IsSelected?: boolean;
  LibelleArticle?: string;
  LibelleLigne?: string;
  LibelleModeLivraison?: string;
  LibelleModeleFraisAnnulation?: string;
  LibelleOptionAjoute?: string;
  LibelleProduit?: string;
  ListeIdOptionModifiee?: ArrayOfdecimal;
  ListeIdSectionAnalytiqueImputation?: ArrayOfdecimal;
  MontantAcompteDefaut?: number;
  MontantFraisAnnulation?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedOpenFormulaireSurOption?: boolean;
  NumeroChoixCommande?: NumeroChoixModelDto;
  PVU?: number;
  PVUSubDeduite?: number;
  PrixVenteActuel?: number;
  ProduitSeCommandeSeule?: boolean;
  Quantite?: number;
  QuantiteALivree?: number;
  QuantiteLivree?: number;
  ReferenceCommande?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  RetourMoteurModel?: RetourMoteurModelDto;
  SessionChoixModel?: SessionChoixDevisBenefModelDto;
  Status?: StatusDtoEnum;
  SubTotale?: number;
  SubTotaleTheorique?: number;
  SubUnitTheorique?: number;
  SubUnitaire?: number;
  isFacturationCentraliseeSurProduit?: boolean;
};

export type LigneDevisModeleDtoInput = {
  APayer?: number;
  Adresse?: string;
  ArticleTypeComportement?: string;
  BenefNomPrenom?: string;
  CapaciteMax?: number;
  CapaciteMin?: number;
  CodeHistoStatut?: string;
  CodeModeLivraison?: string;
  CodeStatutFacture?: string;
  CodeStatutLigne?: string;
  DateDebutCotisation?: any;
  DateDebutLocation?: any;
  DateFinCotisation?: any;
  DateFinLocation?: any;
  DateReapproLigne?: any;
  EnteteDevisModel?: EnteteDevisCommandeForVentesModeleDtoInput;
  HaveFormulaireParametre?: boolean;
  IdAdresseCommande?: number;
  IdArticle?: number;
  IdBenefLigne?: number;
  IdCommandeFournisseur?: number;
  IdCompteImputation?: number;
  IdCourrier?: number;
  IdLigneDevisCommande?: number;
  IdModeleFraisAnnulation?: number;
  IdProduit?: number;
  IdSessionChoix?: number;
  IsArticleChequierDynamique?: boolean;
  IsArticleGrpNominatif?: boolean;
  IsArticleReapproOuNotCanLivre?: boolean;
  IsArticleUniqueParCommande?: boolean;
  IsArticleUnitaire?: boolean;
  IsGererParticipant?: boolean;
  IsLigneLivree?: boolean;
  IsLocationDisponible?: boolean;
  IsOptionLocation?: boolean;
  IsOptionObligatoireLocation?: boolean;
  IsSelected?: boolean;
  LibelleArticle?: string;
  LibelleLigne?: string;
  LibelleModeLivraison?: string;
  LibelleModeleFraisAnnulation?: string;
  LibelleOptionAjoute?: string;
  LibelleProduit?: string;
  ListeIdOptionModifiee?: ArrayOfdecimalInput;
  ListeIdSectionAnalytiqueImputation?: ArrayOfdecimalInput;
  MontantAcompteDefaut?: number;
  MontantFraisAnnulation?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedOpenFormulaireSurOption?: boolean;
  NumeroChoixCommande?: NumeroChoixModelDtoInput;
  PVU?: number;
  PVUSubDeduite?: number;
  PrixVenteActuel?: number;
  ProduitSeCommandeSeule?: boolean;
  Quantite?: number;
  QuantiteALivree?: number;
  QuantiteLivree?: number;
  ReferenceCommande?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  RetourMoteurModel?: RetourMoteurModelDtoInput;
  SessionChoixModel?: SessionChoixDevisBenefModelDtoInput;
  Status?: StatusDtoEnum;
  SubTotale?: number;
  SubTotaleTheorique?: number;
  SubUnitTheorique?: number;
  SubUnitaire?: number;
  isFacturationCentraliseeSurProduit?: boolean;
};

export type LigneDossierPrestationModelDto = {
  __typename?: 'LigneDossierPrestationModelDTO';
  Cadeaux?: string;
  CodeStatut?: string;
  DateDebut?: any;
  DateFacture?: any;
  DateFin?: any;
  FAC_MontantParQuantiteRembourseeAccordee?: number;
  FAC_MontantParQuantiteRembourseeTheorique?: number;
  FAC_MontantTotalFacturePresente?: number;
  FAC_MontantTotalFacturePrisEnCompte?: number;
  FAC_NbUnitePresente?: number;
  FAC_NbUnitePriseEnCompte?: number;
  FAC_NbUniteRemboursee?: number;
  FAC_QuantitePresentee?: number;
  FAC_QuantitePriseEnCompte?: number;
  FAC_QuantiteRemboursee?: number;
  HaveFormulaireParametre?: boolean;
  IdBenef?: number;
  IdDossierPrestation?: number;
  IdFormule?: number;
  IdLigneDossierPrestation?: number;
  IdStatut?: number;
  IsAccepte?: boolean;
  IsCreditEnveloppeKalidea?: boolean;
  LibelleUnite?: string;
  LibelleUniteTotal?: string;
  ListePieceJustificative?: ArrayOfPieceJustificativeBenefModel;
  MatriculeBenef?: string;
  ModeRemboursement?: string;
  MontantAEncaisser?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NBUNITE_MontantParQuantitePresente?: number;
  NBUNITE_MontantParQuantitePrisEnCompte?: number;
  NBUNITE_MontantParQuantiteRembourseeAccordee?: number;
  NBUNITE_MontantParQuantiteRembourseeTheorique?: number;
  NBUNITE_MontantTotalFacturePresente?: number;
  NBUNITE_MontantTotalFacturePrisEnCompte?: number;
  NBUNITE_NbUnitePresentee?: number;
  NBUNITE_NbUnitePriseEnCompte?: number;
  NBUNITE_NbUniteRemboursee?: number;
  NBUNITE_QuantitePresentee?: number;
  NBUNITE_QuantitePriseEnCompte?: number;
  NBUNITE_QuantiteRemboursee?: number;
  NBUNITE_Quotite?: number;
  RefFacture?: string;
  RetourMoteurModel?: RetourMoteurModelDto;
  Status?: StatusDtoEnum;
  TextBenefNom?: string;
  TextBenefPrenom?: string;
  TextFormule?: string;
  TextStatut?: string;
};

export type LigneDossierPrestationModelDtoInput = {
  Cadeaux?: string;
  CodeStatut?: string;
  DateDebut?: any;
  DateFacture?: any;
  DateFin?: any;
  FAC_MontantParQuantiteRembourseeAccordee?: number;
  FAC_MontantParQuantiteRembourseeTheorique?: number;
  FAC_MontantTotalFacturePresente?: number;
  FAC_MontantTotalFacturePrisEnCompte?: number;
  FAC_NbUnitePresente?: number;
  FAC_NbUnitePriseEnCompte?: number;
  FAC_NbUniteRemboursee?: number;
  FAC_QuantitePresentee?: number;
  FAC_QuantitePriseEnCompte?: number;
  FAC_QuantiteRemboursee?: number;
  HaveFormulaireParametre?: boolean;
  IdBenef?: number;
  IdDossierPrestation?: number;
  IdFormule?: number;
  IdLigneDossierPrestation?: number;
  IdStatut?: number;
  IsAccepte?: boolean;
  IsCreditEnveloppeKalidea?: boolean;
  LibelleUnite?: string;
  LibelleUniteTotal?: string;
  ListePieceJustificative?: ArrayOfPieceJustificativeBenefModelInput;
  MatriculeBenef?: string;
  ModeRemboursement?: string;
  MontantAEncaisser?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NBUNITE_MontantParQuantitePresente?: number;
  NBUNITE_MontantParQuantitePrisEnCompte?: number;
  NBUNITE_MontantParQuantiteRembourseeAccordee?: number;
  NBUNITE_MontantParQuantiteRembourseeTheorique?: number;
  NBUNITE_MontantTotalFacturePresente?: number;
  NBUNITE_MontantTotalFacturePrisEnCompte?: number;
  NBUNITE_NbUnitePresentee?: number;
  NBUNITE_NbUnitePriseEnCompte?: number;
  NBUNITE_NbUniteRemboursee?: number;
  NBUNITE_QuantitePresentee?: number;
  NBUNITE_QuantitePriseEnCompte?: number;
  NBUNITE_QuantiteRemboursee?: number;
  NBUNITE_Quotite?: number;
  RefFacture?: string;
  RetourMoteurModel?: RetourMoteurModelDtoInput;
  Status?: StatusDtoEnum;
  TextBenefNom?: string;
  TextBenefPrenom?: string;
  TextFormule?: string;
  TextStatut?: string;
};

export type LigneFactureDto = {
  __typename?: 'LigneFactureDTO';
  Article?: ArticleDto;
  CompteCollectif?: CompteDto;
  CompteVente?: CompteDto;
  DateDebutLocation?: any;
  DateFinLocation?: any;
  Facture?: FactureDto;
  Id?: number;
  IdModeleTVA?: number;
  Libelle?: string;
  LigneCommande?: LigneCommandeDto;
  ListeLigneFactureSectionAnalytique?: ArrayOfLigneFactureSectionAnalytiqueDto;
  MontantHorsTaxe?: number;
  MontantSubAccepteUnitaire?: number;
  MontantTVA?: number;
  MontantTotalHorsSubvention?: number;
  MontantTotalSubventionDeduite?: number;
  MontantUnitaire?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Quantite?: number;
  Reference?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  RemiseMontantUnitaire?: number;
  Status?: StatusDtoEnum;
  TauxTVA?: number;
};

export type LigneFactureDtoInput = {
  Article?: ArticleDtoInput;
  CompteCollectif?: CompteDtoInput;
  CompteVente?: CompteDtoInput;
  DateDebutLocation?: any;
  DateFinLocation?: any;
  Facture?: FactureDtoInput;
  Id?: number;
  IdModeleTVA?: number;
  Libelle?: string;
  LigneCommande?: LigneCommandeDtoInput;
  ListeLigneFactureSectionAnalytique?: ArrayOfLigneFactureSectionAnalytiqueDtoInput;
  MontantHorsTaxe?: number;
  MontantSubAccepteUnitaire?: number;
  MontantTVA?: number;
  MontantTotalHorsSubvention?: number;
  MontantTotalSubventionDeduite?: number;
  MontantUnitaire?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Quantite?: number;
  Reference?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  RemiseMontantUnitaire?: number;
  Status?: StatusDtoEnum;
  TauxTVA?: number;
};

export type LigneFactureSectionAnalytiqueDto = {
  __typename?: 'LigneFactureSectionAnalytiqueDTO';
  LigneFacture?: LigneFactureDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueDto;
  Pourcentage?: number;
  SectionAnalytique?: SectionAnalytiqueDto;
  Status?: StatusDtoEnum;
};

export type LigneFactureSectionAnalytiqueDtoInput = {
  LigneFacture?: LigneFactureDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueDtoInput;
  Pourcentage?: number;
  SectionAnalytique?: SectionAnalytiqueDtoInput;
  Status?: StatusDtoEnum;
};

export type LigneFraisAnnulationModel = {
  __typename?: 'LigneFraisAnnulationModel';
  BorneMax?: number;
  BorneMin?: number;
  CodeTypeFrais?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: number;
};

export type LigneFraisAnnulationModelInput = {
  BorneMax?: number;
  BorneMin?: number;
  CodeTypeFrais?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: number;
};

export type LigneFraisPortDto = {
  __typename?: 'LigneFraisPortDTO';
  ID?: number;
  ModeLivraisonFraisPort?: ModeLivraisonFraisPortDto;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ValeurMax?: number;
  ValeurMin?: number;
};

export type LigneFraisPortDtoInput = {
  ID?: number;
  ModeLivraisonFraisPort?: ModeLivraisonFraisPortDtoInput;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ValeurMax?: number;
  ValeurMin?: number;
};

export type LigneInventaireDto = {
  __typename?: 'LigneInventaireDTO';
  Article?: ArticleDto;
  Id?: number;
  Inventaire?: InventaireDto;
  MouvementStock?: MouvementStockDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixAchat?: number;
  QteReelle?: number;
  QteTheorique?: number;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type LigneInventaireDtoInput = {
  Article?: ArticleDtoInput;
  Id?: number;
  Inventaire?: InventaireDtoInput;
  MouvementStock?: MouvementStockDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixAchat?: number;
  QteReelle?: number;
  QteTheorique?: number;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type LigneInventaireStockModel = {
  __typename?: 'LigneInventaireStockModel';
  Commentaire?: string;
  IdArticle?: number;
  IdInventaire?: number;
  IdLigneInventaire?: number;
  IdMvtStock?: number;
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QteReel?: number;
  QteTheorique?: number;
  RemarqueMvt?: string;
  Status?: StatusDtoEnum;
};

export type LigneInventaireStockModelInput = {
  Commentaire?: string;
  IdArticle?: number;
  IdInventaire?: number;
  IdLigneInventaire?: number;
  IdMvtStock?: number;
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QteReel?: number;
  QteTheorique?: number;
  RemarqueMvt?: string;
  Status?: StatusDtoEnum;
};

export type LigneReceptionCessionStockModel = {
  __typename?: 'LigneReceptionCessionStockModel';
  IdArticleEntree?: number;
  IdArticleSortie?: number;
  IdCessionStock?: number;
  IdLigneCessionStock?: number;
  IdStockEntree?: number;
  IdStockSortie?: number;
  IdUtilisateurReception?: number;
  IsSupprimee?: boolean;
  LibelleActiviteEntree?: string;
  LibelleActiviteSortie?: string;
  LibelleArticleEntree?: string;
  LibelleArticleSortie?: string;
  LibelleDelegationEntree?: string;
  LibelleDelegationSortie?: string;
  LibellePointVenteEntree?: string;
  LibellePointVenteSortie?: string;
  LibelleStockEntree?: string;
  LibelleStockSortie?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteEntree?: number;
  QuantiteSortie?: number;
  Status?: StatusDtoEnum;
};

export type LigneReceptionCessionStockModelInput = {
  IdArticleEntree?: number;
  IdArticleSortie?: number;
  IdCessionStock?: number;
  IdLigneCessionStock?: number;
  IdStockEntree?: number;
  IdStockSortie?: number;
  IdUtilisateurReception?: number;
  IsSupprimee?: boolean;
  LibelleActiviteEntree?: string;
  LibelleActiviteSortie?: string;
  LibelleArticleEntree?: string;
  LibelleArticleSortie?: string;
  LibelleDelegationEntree?: string;
  LibelleDelegationSortie?: string;
  LibellePointVenteEntree?: string;
  LibellePointVenteSortie?: string;
  LibelleStockEntree?: string;
  LibelleStockSortie?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteEntree?: number;
  QuantiteSortie?: number;
  Status?: StatusDtoEnum;
};

export type LigneRemiseEnBanqueModel = {
  __typename?: 'LigneRemiseEnBanqueModel';
  BBAN?: string;
  BBANEncrypt?: string;
  BIC?: string;
  BICEncrypt?: string;
  Banque?: string;
  CleIban?: string;
  CodePays?: string;
  DateMouvement?: any;
  IdLigneRemise?: number;
  IdMouvement?: number;
  IsEnableSelect?: boolean;
  IsRapprochee?: boolean;
  IsRejetee?: boolean;
  IsRemiseEnAttente?: boolean;
  IsSelected?: boolean;
  LibelleMouvement?: string;
  MatriculeBenef?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomTire?: string;
  NumeroCheque?: string;
  Status?: StatusDtoEnum;
  User?: string;
};

export type LigneRemiseEnBanqueModelInput = {
  BBAN?: string;
  BBANEncrypt?: string;
  BIC?: string;
  BICEncrypt?: string;
  Banque?: string;
  CleIban?: string;
  CodePays?: string;
  DateMouvement?: any;
  IdLigneRemise?: number;
  IdMouvement?: number;
  IsEnableSelect?: boolean;
  IsRapprochee?: boolean;
  IsRejetee?: boolean;
  IsRemiseEnAttente?: boolean;
  IsSelected?: boolean;
  LibelleMouvement?: string;
  MatriculeBenef?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomTire?: string;
  NumeroCheque?: string;
  Status?: StatusDtoEnum;
  User?: string;
};

export type LigneRemiseEnCaisseForValidationFiduModel = {
  __typename?: 'LigneRemiseEnCaisseForValidationFiduModel';
  IdLigneRemiseEnCaisse?: number;
  IdMoyenPaiement?: number;
  MontantAttendu?: number;
  MontantRemiseEnCaisse?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type LigneRemiseEnCaisseForValidationFiduModelInput = {
  IdLigneRemiseEnCaisse?: number;
  IdMoyenPaiement?: number;
  MontantAttendu?: number;
  MontantRemiseEnCaisse?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type LigneRemiseEnCaisseForValidationNonFiduModel = {
  __typename?: 'LigneRemiseEnCaisseForValidationNonFiduModel';
  DateReglement?: any;
  IdLigneRemiseEnCaisse?: number;
  IdMoyenPaiement?: number;
  IsValide?: boolean;
  LibelleCommande?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomPrenomBeneficiaire?: string;
  NumeroCommande?: string;
  Status?: StatusDtoEnum;
};

export type LigneRemiseEnCaisseForValidationNonFiduModelInput = {
  DateReglement?: any;
  IdLigneRemiseEnCaisse?: number;
  IdMoyenPaiement?: number;
  IsValide?: boolean;
  LibelleCommande?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomPrenomBeneficiaire?: string;
  NumeroCommande?: string;
  Status?: StatusDtoEnum;
};

export type LigneRepartitionCompteAnaSecModelDto = {
  __typename?: 'LigneRepartitionCompteAnaSecModelDTO';
  IdLigneCommande?: number;
  IdLigneFacture?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytique?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Pourcentage?: number;
  Status?: StatusDtoEnum;
};

export type LigneRepartitionCompteAnaSecModelDtoInput = {
  IdLigneCommande?: number;
  IdLigneFacture?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytique?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Pourcentage?: number;
  Status?: StatusDtoEnum;
};

export type LigneResultatImportArticle = {
  __typename?: 'LigneResultatImportArticle';
  DateCreated?: any;
  DateExecuted?: any;
  DatePlanned?: any;
  FichierName?: string;
  IsBtDetailShow?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Parameters?: any;
  ResultCron?: string;
  Status?: StatusDtoEnum;
  Statut?: string;
  User?: string;
};

export type LigneResultatImportArticleInput = {
  DateCreated?: any;
  DateExecuted?: any;
  DatePlanned?: any;
  FichierName?: string;
  IsBtDetailShow?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Parameters?: any;
  ResultCron?: string;
  Status?: StatusDtoEnum;
  Statut?: string;
  User?: string;
};

export type LignesEnvoiModelDto = {
  __typename?: 'LignesEnvoiModelDTO';
  AdresseFigee?: AdresseFigeDto;
  Beneficiaire?: string;
  CodeFormat?: string;
  Coordonnees?: string;
  Format?: string;
  IdBeneficaire?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  PJenvoye?: ArrayOfPieceJointeModelDto;
  Status?: StatusDtoEnum;
  StatutEnvoi?: string;
};

export type LignesEnvoiModelDtoInput = {
  AdresseFigee?: AdresseFigeDtoInput;
  Beneficiaire?: string;
  CodeFormat?: string;
  Coordonnees?: string;
  Format?: string;
  IdBeneficaire?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  PJenvoye?: ArrayOfPieceJointeModelDtoInput;
  Status?: StatusDtoEnum;
  StatutEnvoi?: string;
};

export type ListElementLightModel = {
  __typename?: 'ListElementLightModel';
  ListActuMobile?: ArrayOfListeActualiteMobileModel;
  ListAlbums?: ArrayOfEditAlbumLightModel;
  ListArticleEdit?: ArrayOfArticleEditorialWithStatutModel;
  ListCourriers?: ArrayOfCourrierEnvoiLightModel;
  ListeModeleMail?: ArrayOfModelEmailModelEmailClotureModel;
};

export type ListElementLightModelInput = {
  ListActuMobile?: ArrayOfListeActualiteMobileModelInput;
  ListAlbums?: ArrayOfEditAlbumLightModelInput;
  ListArticleEdit?: ArrayOfArticleEditorialWithStatutModelInput;
  ListCourriers?: ArrayOfCourrierEnvoiLightModelInput;
  ListeModeleMail?: ArrayOfModelEmailModelEmailClotureModelInput;
};

export type ListLocalisationModel = {
  __typename?: 'ListLocalisationModel';
  ListLieuModel?: ArrayOfLieuModelDto;
  ListPays?: ArrayOfPaysDto;
  ListRegion?: ArrayOfRegionDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ListLocalisationModelInput = {
  ListLieuModel?: ArrayOfLieuModelDtoInput;
  ListPays?: ArrayOfPaysDtoInput;
  ListRegion?: ArrayOfRegionDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ListReglListAvoirAcompteModel = {
  __typename?: 'ListReglListAvoirAcompteModel';
  ListAvoirAcompte?: ArrayOfAvoirAcompteModelDto;
  ListRglModel?: ArrayOfReglementMouvFacModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ListReglListAvoirAcompteModelInput = {
  ListAvoirAcompte?: ArrayOfAvoirAcompteModelDtoInput;
  ListRglModel?: ArrayOfReglementMouvFacModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ListeActualiteMobileModel = {
  __typename?: 'ListeActualiteMobileModel';
  DateCreation?: any;
  DateEnvoi?: any;
  IdActu?: number;
  IdDelegation?: number;
  IsDelegationGlobale?: boolean;
  IsValide?: boolean;
  Titre?: string;
};

export type ListeActualiteMobileModelInput = {
  DateCreation?: any;
  DateEnvoi?: any;
  IdActu?: number;
  IdDelegation?: number;
  IsDelegationGlobale?: boolean;
  IsValide?: boolean;
  Titre?: string;
};

export type ListeChampVueModel = {
  __typename?: 'ListeChampVueModel';
  ListChampDispo?: ArrayOfPubliChampsBaseModel;
  ListChampUtilise?: ArrayOfPubliChampsVueModel;
};

export type ListeChampVueModelInput = {
  ListChampDispo?: ArrayOfPubliChampsBaseModelInput;
  ListChampUtilise?: ArrayOfPubliChampsVueModelInput;
};

export type ListeCodeFonctionnalitesWidgetsAccessibleModel = {
  __typename?: 'ListeCodeFonctionnalitesWidgetsAccessibleModel';
  ListeCodesFonctionnalitesDisponibles?: ArrayOfstring;
  ListeCodesWidgetsdisponibles?: ArrayOfstring;
};

export type ListeCodeFonctionnalitesWidgetsAccessibleModelInput = {
  ListeCodesFonctionnalitesDisponibles?: ArrayOfstringInput;
  ListeCodesWidgetsdisponibles?: ArrayOfstringInput;
};

export type ListeCompteursPointsFpa = {
  __typename?: 'ListeCompteursPointsFPA';
  IsRedescente?: boolean;
  ListeCompteursPoints?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ListeCompteursPointsFpaInput = {
  IsRedescente?: boolean;
  ListeCompteursPoints?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ListeFacturesEtListeReglementsModelDtoInput = {
  Benef?: BenefDtoInput;
  Caisse?: CaisseDtoInput;
  Fournisseur?: FournisseurDtoInput;
  ListeFacture?: ArrayOfReglementFactureModelDtoInput;
  ListeReglementModel?: ArrayOfReglementModelDtoInput;
  ListeReglements?: ArrayOfReglementsReglementModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeEcriture?: string;
  User?: UsersDtoInput;
};

export type ListeHomeNotification = {
  __typename?: 'ListeHomeNotification';
  Count?: number;
  Informations?: Union_2668492363200023698;
  ListeNotifications?: ArrayOfBaseHomeNotification;
};

export type ListeHomeNotificationInput = {
  Count?: number;
  Informations?: BaseInformationsHomeNotificationInput;
  ListeNotifications?: ArrayOfBaseHomeNotificationInput;
};

export type ListeJournauxAndExerciceModelDto = {
  __typename?: 'ListeJournauxAndExerciceModelDTO';
  CompteAchatClientModel?: CompteModelDto;
  CompteAchatFourModel?: CompteModelDto;
  CompteCollectifClientModel?: CompteModelDto;
  CompteCollectifFourModel?: CompteModelDto;
  JournalAchatActModel?: JournalModelDto;
  JournalVenteActModel?: JournalModelDto;
  ListeCompteAchatModel?: ArrayOfCompteModelDto;
  ListeExercicesModel?: ArrayOfExerciceModelDto;
  ListeJournauxModel?: ArrayOfJournalModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ListeJournauxAndExerciceModelDtoInput = {
  CompteAchatClientModel?: CompteModelDtoInput;
  CompteAchatFourModel?: CompteModelDtoInput;
  CompteCollectifClientModel?: CompteModelDtoInput;
  CompteCollectifFourModel?: CompteModelDtoInput;
  JournalAchatActModel?: JournalModelDtoInput;
  JournalVenteActModel?: JournalModelDtoInput;
  ListeCompteAchatModel?: ArrayOfCompteModelDtoInput;
  ListeExercicesModel?: ArrayOfExerciceModelDtoInput;
  ListeJournauxModel?: ArrayOfJournalModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ListePermanenceActiviteModel = {
  __typename?: 'ListePermanenceActiviteModel';
  ListeIdPermanence?: ArrayOfdecimal;
  MustValidate?: boolean;
  MyGuid?: string;
  NombrePermaAfficheeEnLigne?: number;
  Status?: StatusDtoEnum;
};

export type ListePermanenceActiviteModelInput = {
  ListeIdPermanence?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NombrePermaAfficheeEnLigne?: number;
  Status?: StatusDtoEnum;
};

export type ListerCourrierModel = {
  __typename?: 'ListerCourrierModel';
  IdCourrier?: number;
  IsCloture?: boolean;
  Titre?: string;
};

export type ListerCourrierModelInput = {
  IdCourrier?: number;
  IsCloture?: boolean;
  Titre?: string;
};

export type ListerRessourceModel = {
  __typename?: 'ListerRessourceModel';
  CodeFamille?: string;
  IdFamille?: number;
  IdProduit?: number;
  IsClos?: boolean;
  Libelle?: string;
};

export type ListerRessourceModelInput = {
  CodeFamille?: string;
  IdFamille?: number;
  IdProduit?: number;
  IsClos?: boolean;
  Libelle?: string;
};

export type ListerRoomingListModel = {
  __typename?: 'ListerRoomingListModel';
  DateDebutProduit?: any;
  IdFamille?: number;
  IdProduit?: number;
  IdRoomingList?: number;
  LibelleProduit?: string;
  LibelleRoomingList?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbGroupes?: number;
  Status?: StatusDtoEnum;
};

export type ListerRoomingListModelInput = {
  DateDebutProduit?: any;
  IdFamille?: number;
  IdProduit?: number;
  IdRoomingList?: number;
  LibelleProduit?: string;
  LibelleRoomingList?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbGroupes?: number;
  Status?: StatusDtoEnum;
};

export type ListesDonneesReglesAvanceesModelDto = {
  __typename?: 'ListesDonneesReglesAvanceesModelDTO';
  ListeCriteres?: ArrayOfMoteurCritereDto;
  ListeOperateurs?: ArrayOfMoteurOperateurDto;
  ListeParametres?: ArrayOfParametreRegleAvanceeModelDto;
  ListeReglesPourApplication?: ArrayOfKeyValueModelDto;
  ListeTypesDates?: ArrayOfMoteurRegleTypeDateRefDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ListesDonneesReglesAvanceesModelDtoInput = {
  ListeCriteres?: ArrayOfMoteurCritereDtoInput;
  ListeOperateurs?: ArrayOfMoteurOperateurDtoInput;
  ListeParametres?: ArrayOfParametreRegleAvanceeModelDtoInput;
  ListeReglesPourApplication?: ArrayOfKeyValueModelDtoInput;
  ListeTypesDates?: ArrayOfMoteurRegleTypeDateRefDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ListesPiecesJustificativesModel = {
  __typename?: 'ListesPiecesJustificativesModel';
  ListePJDispo?: ArrayOfPieceJustificativeBenefModel;
  ListePJRequises?: ArrayOfPieceJustificativeBenefModel;
};

export type ListesPiecesJustificativesModelInput = {
  ListePJDispo?: ArrayOfPieceJustificativeBenefModelInput;
  ListePJRequises?: ArrayOfPieceJustificativeBenefModelInput;
};

export type ListesReglesAfpaModel = {
  __typename?: 'ListesReglesAFPAModel';
  LibelleAFPA?: LibelleAfpaModel;
  ListeReglesAccessibilite?: ArrayOfRegleAfpaModel;
  ListeReglesEnveloppe?: ArrayOfRegleAfpaModel;
  ListeReglesQuota?: ArrayOfRegleAfpaModel;
  ListeReglesSubvention?: ArrayOfRegleAfpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ListesReglesAfpaModelInput = {
  LibelleAFPA?: LibelleAfpaModelInput;
  ListeReglesAccessibilite?: ArrayOfRegleAfpaModelInput;
  ListeReglesEnveloppe?: ArrayOfRegleAfpaModelInput;
  ListeReglesQuota?: ArrayOfRegleAfpaModelInput;
  ListeReglesSubvention?: ArrayOfRegleAfpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type LivraisonCommandeDossierPrestaModelInput = {
  IdDossierPrestation?: number;
  IdUtilisateur?: number;
};

export type LivraisonsCommandesInfosLivraisonBaseModel = {
  __typename?: 'LivraisonsCommandesInfosLivraisonBaseModel';
  DateLivraison?: any;
  IdBeneficiaire?: number;
  IdCommande?: number;
  IdFournisseur?: number;
  IdLigneCommande?: number;
  LibelleLigneCommande?: string;
  MatriculeBeneficiaire?: string;
  NomBeneficiaire?: string;
  NomFournisseur?: string;
  PrenomBeneficiaire?: string;
  QuantiteDemandee?: number;
  QuantiteRestantALivrer?: number;
  QuantiteTotale?: number;
};

export type LivraisonsCommandesInfosLivraisonBaseModelInput = {
  DateLivraison?: any;
  IdBeneficiaire?: number;
  IdCommande?: number;
  IdFournisseur?: number;
  IdLigneCommande?: number;
  LibelleLigneCommande?: string;
  MatriculeBeneficiaire?: string;
  NomBeneficiaire?: string;
  NomFournisseur?: string;
  PrenomBeneficiaire?: string;
  QuantiteDemandee?: number;
  QuantiteRestantALivrer?: number;
  QuantiteTotale?: number;
};

export type LivraisonsInfosCommandeBlApresLivRapide = {
  __typename?: 'LivraisonsInfosCommandeBLApresLivRapide';
  IdBL?: number;
  ListeArticle?: ArrayOfKeyValueOfdecimalint;
};

export type LivraisonsInfosCommandeBlApresLivRapideInput = {
  IdBL?: number;
  ListeArticle?: ArrayOfKeyValueOfdecimalintInput;
};

export type LivraisonsInfosCommandePourLivraisonRapideModel = {
  __typename?: 'LivraisonsInfosCommandePourLivraisonRapideModel';
  IdBeneficiaire?: number;
  IdCommande?: number;
  Libelle?: string;
  ListeIdCommande?: ArrayOfdecimal;
  ListeLigneCommande?: ArrayOfanyType;
  MatriculeBeneficiaire?: string;
  NomBeneficiaire?: string;
  NumeroFacture?: string;
  PhotoBeneficiaire?: any;
  PhotoBeneficiaireFileName?: string;
  PrenomBeneficiaire?: string;
  StatutCommande?: string;
  StatutCommandeLibelle?: string;
  StatutCommandeLivraison?: string;
};

export type LivraisonsInfosCommandePourLivraisonRapideModelInput = {
  IdBeneficiaire?: number;
  IdCommande?: number;
  Libelle?: string;
  ListeIdCommande?: ArrayOfdecimalInput;
  ListeLigneCommande?: ArrayOfanyTypeInput;
  MatriculeBeneficiaire?: string;
  NomBeneficiaire?: string;
  NumeroFacture?: string;
  PhotoBeneficiaire?: any;
  PhotoBeneficiaireFileName?: string;
  PrenomBeneficiaire?: string;
  StatutCommande?: string;
  StatutCommandeLibelle?: string;
  StatutCommandeLivraison?: string;
};

export type LivraisonsInfosLigneCdeForLivraisonReceptionModele = {
  __typename?: 'LivraisonsInfosLigneCdeForLivraisonReceptionModele';
  DateLivraison?: any;
  IdLigneCommande?: number;
  QuantiteDemandee?: number;
};

export type LivraisonsInfosLigneCdeForLivraisonReceptionModeleInput = {
  DateLivraison?: any;
  IdLigneCommande?: number;
  QuantiteDemandee?: number;
};

export type LivraisonsInfosLigneCdePourLivraisonRapideInput = {
  IdArticle?: number;
  IdLigneCommande?: number;
  LibelleArticle?: string;
  LibelleProduit?: string;
  QuantiteDemande?: number;
  QuantiteDisponible?: number;
  QuantiteLivree?: number;
  RestantALivrer?: number;
};

export type LocationInformationsArticleModel = {
  __typename?: 'LocationInformationsArticleModel';
  CodeArticle?: string;
  CodeBarre?: string;
  DateDebutLocation?: any;
  DateFinLocation?: any;
  DateLimiteDispo?: any;
  DatePriseEnCompteSub?: any;
  DepassementDateAutorise?: boolean;
  Description?: string;
  IdAnneeReference?: number;
  IdArticle?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdProduit?: number;
  IdSessionChoix?: number;
  IsArticleCommandeSeul?: boolean;
  IsArticleOption?: boolean;
  IsCloture?: boolean;
  IsObligatoire?: boolean;
  IsProduitAllotement?: boolean;
  IsUsedOnLigneCommande?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbArticleDispo?: number;
  Quotite?: number;
  RemarqueArticle?: string;
  Status?: StatusDtoEnum;
};

export type LocationInformationsArticleModelInput = {
  CodeArticle?: string;
  CodeBarre?: string;
  DateDebutLocation?: any;
  DateFinLocation?: any;
  DateLimiteDispo?: any;
  DatePriseEnCompteSub?: any;
  DepassementDateAutorise?: boolean;
  Description?: string;
  IdAnneeReference?: number;
  IdArticle?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdProduit?: number;
  IdSessionChoix?: number;
  IsArticleCommandeSeul?: boolean;
  IsArticleOption?: boolean;
  IsCloture?: boolean;
  IsObligatoire?: boolean;
  IsProduitAllotement?: boolean;
  IsUsedOnLigneCommande?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbArticleDispo?: number;
  Quotite?: number;
  RemarqueArticle?: string;
  Status?: StatusDtoEnum;
};

export type LocationInformationsFamilleModel = {
  __typename?: 'LocationInformationsFamilleModel';
  CodeFamille?: string;
  Description?: string;
  IdActivite?: number;
  IdContratLocation?: number;
  IdCourrierAcceptation?: number;
  IdCourrierRefus?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IsCloture?: boolean;
  IsFacturationManuelle?: boolean;
  LibelleFamille?: string;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedAcceptationCE?: boolean;
  NotProposerLocNonDispo?: boolean;
  RedescendreAcceptation?: boolean;
  RedescendreParametrageAcompte?: boolean;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type LocationInformationsFamilleModelInput = {
  CodeFamille?: string;
  Description?: string;
  IdActivite?: number;
  IdContratLocation?: number;
  IdCourrierAcceptation?: number;
  IdCourrierRefus?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IsCloture?: boolean;
  IsFacturationManuelle?: boolean;
  LibelleFamille?: string;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedAcceptationCE?: boolean;
  NotProposerLocNonDispo?: boolean;
  RedescendreAcceptation?: boolean;
  RedescendreParametrageAcompte?: boolean;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type LocationInformationsProduitModel = {
  __typename?: 'LocationInformationsProduitModel';
  AutoriserReservationsSupp?: boolean;
  CapaciteMaxi?: number;
  CapaciteMini?: number;
  CodeProduit?: string;
  DateDebutLocation?: any;
  DateFinLocation?: any;
  DatePriseEnCompteSub?: any;
  DescriptionProduit?: string;
  IdAnneeReference?: number;
  IdContratLocation?: number;
  IdCourrierAcceptation?: number;
  IdCourrierRefus?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdFournisseurFavoris?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  IsFacturationManuelle?: boolean;
  IsGestionAllotement?: boolean;
  IsGestionParticipant?: boolean;
  IsProduitCommandeSeul?: boolean;
  LibelleProduit?: string;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedAcceptationCE?: boolean;
  NotProposerLocNonDispo?: boolean;
  ProduitHasArticle?: boolean;
  RemarqueProduit?: string;
  Status?: StatusDtoEnum;
};

export type LocationInformationsProduitModelInput = {
  AutoriserReservationsSupp?: boolean;
  CapaciteMaxi?: number;
  CapaciteMini?: number;
  CodeProduit?: string;
  DateDebutLocation?: any;
  DateFinLocation?: any;
  DatePriseEnCompteSub?: any;
  DescriptionProduit?: string;
  IdAnneeReference?: number;
  IdContratLocation?: number;
  IdCourrierAcceptation?: number;
  IdCourrierRefus?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdFournisseurFavoris?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  IsFacturationManuelle?: boolean;
  IsGestionAllotement?: boolean;
  IsGestionParticipant?: boolean;
  IsProduitCommandeSeul?: boolean;
  LibelleProduit?: string;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedAcceptationCE?: boolean;
  NotProposerLocNonDispo?: boolean;
  ProduitHasArticle?: boolean;
  RemarqueProduit?: string;
  Status?: StatusDtoEnum;
};

export type LocationTauxOccupationModel = {
  __typename?: 'LocationTauxOccupationModel';
  DateLimite?: any;
  Id?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsOption?: boolean;
  IsQuantitesurProduit?: boolean;
  Libelle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  NbOptions?: number;
  NbReservationsValidees?: number;
  NbTotalDispo?: number;
  NbTotalReservation?: number;
  PrixVente?: number;
};

export type LocationTauxOccupationModelInput = {
  DateLimite?: any;
  Id?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsOption?: boolean;
  IsQuantitesurProduit?: boolean;
  Libelle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  NbOptions?: number;
  NbReservationsValidees?: number;
  NbTotalDispo?: number;
  NbTotalReservation?: number;
  PrixVente?: number;
};

export type LocationVenteEnLigneProduitModel = {
  __typename?: 'LocationVenteEnLigneProduitModel';
  AutoriserCommandesEnLigne?: boolean;
  DateDebutVisibilite?: any;
  DateFinVisibilite?: any;
  HasCompteAcompte?: boolean;
  IdElement?: number;
  IsAcompteObligatoireEnLigne?: boolean;
  IsAfficheEnLigne?: boolean;
  LibelleDetail?: string;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreVenteEnLigne?: boolean;
  Status?: StatusDtoEnum;
};

export type LocationVenteEnLigneProduitModelInput = {
  AutoriserCommandesEnLigne?: boolean;
  DateDebutVisibilite?: any;
  DateFinVisibilite?: any;
  HasCompteAcompte?: boolean;
  IdElement?: number;
  IsAcompteObligatoireEnLigne?: boolean;
  IsAfficheEnLigne?: boolean;
  LibelleDetail?: string;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreVenteEnLigne?: boolean;
  Status?: StatusDtoEnum;
};

export type LogAfpaHistoriqueModel = {
  __typename?: 'LogAFPAHistoriqueModel';
  DateLog?: any;
  IdLog?: number;
  NomUtilisateur?: string;
  PrenomUtilisateur?: string;
  Type?: string;
};

export type LogAfpaHistoriqueModelInput = {
  DateLog?: any;
  IdLog?: number;
  NomUtilisateur?: string;
  PrenomUtilisateur?: string;
  Type?: string;
};

export type LogPerfModelInput = {
  BaseClient?: string;
  Loading?: any;
  Name?: string;
  Type?: string;
};

export type MailModelDtoInput = {
  AdrPrivilegierPerso?: boolean;
  AdrPrivilegierPro?: boolean;
  AdresseLesDeux?: boolean;
  AdressePerso?: boolean;
  AdressePrivilegier?: boolean;
  AdressePro?: boolean;
  Body?: string;
  CopieCE?: boolean;
  From?: string;
  FromDisplayName?: string;
  IdBenef?: number;
  IdFam?: number;
  Identifiant?: GestionIndentifiantModelDtoInput;
  IsHTML?: boolean;
  ListDestinataire?: ArrayOfDestinataireMailModelDtoInput;
  ListFichier?: ArrayOfFichierModelInput;
  ListIdDevis?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  ReplyTo?: string;
  SendMail?: boolean;
  Status?: StatusDtoEnum;
  Subject?: string;
};

export type MandatUseModel = {
  __typename?: 'MandatUseModel';
  IdMandat?: number;
  IsUsed?: boolean;
};

export type MandatUseModelInput = {
  IdMandat?: number;
  IsUsed?: boolean;
};

export type MediaImportModelInput = {
  Auteurs?: string;
  Cible?: string;
  Collection?: string;
  DateSortie?: string;
  EAN?: string;
  Editeur?: string;
  Genre?: string;
  Image?: string;
  Numero?: string;
  Prix?: string;
  Resume?: string;
  Titre?: string;
  TypeMedia?: string;
};

export type MediaRetourDto = {
  __typename?: 'MediaRetourDTO';
  HeureRetour?: any;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbJour?: number;
  NumJourSem?: number;
  Status?: StatusDtoEnum;
};

export type MediaRetourDtoInput = {
  HeureRetour?: any;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbJour?: number;
  NumJourSem?: number;
  Status?: StatusDtoEnum;
};

export type MediathequeBenefMediathequeModelDto = {
  __typename?: 'MediathequeBenefMediathequeModelDTO';
  DateDernierEmprunt?: any;
  Id?: number;
  IsBenefAvecBlocageDroit?: boolean;
  IsBenefAvecDroitActif?: boolean;
  Matricule?: string;
  NbAutres?: number;
  NbCDs?: number;
  NbDVDs?: number;
  NbLivres?: number;
  NbLogiciels?: number;
  Nom?: string;
  Photo?: any;
  Prenom?: string;
};

export type MediathequeBenefMediathequeModelDtoInput = {
  DateDernierEmprunt?: any;
  Id?: number;
  IsBenefAvecBlocageDroit?: boolean;
  IsBenefAvecDroitActif?: boolean;
  Matricule?: string;
  NbAutres?: number;
  NbCDs?: number;
  NbDVDs?: number;
  NbLivres?: number;
  NbLogiciels?: number;
  Nom?: string;
  Photo?: any;
  Prenom?: string;
};

export type MediathequeCritereExemplaireUpdateDateEmpruntReservationModelInput = {
  DateDebutEmpruntReservation?: any;
  DateFinEmpruntReservation?: any;
  IdLigneCommande?: number;
  IsModeReservation?: boolean;
};

export type MediathequeEditerLigneCommandeMediathequeBaseModelDtoInput = {
  CodeModeLivraison?: string;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdPermanence?: number;
  IdUtilisateur?: number;
  LibelleLignecommande?: string;
  LigneLibelle?: string;
  LigneReference?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Quantite?: number;
  QuantiteInitiale?: number;
  Quotite?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type MediathequeEditerLigneCommandeMediathequeEmpruntModelDtoInput = {
  CodeModeLivraison?: string;
  DateEmprunt?: any;
  DateRetourPrevue?: any;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdPermanence?: number;
  IdUtilisateur?: number;
  LibelleLignecommande?: string;
  LigneLibelle?: string;
  LigneReference?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbJourPermanences?: number;
  Quantite?: number;
  QuantiteInitiale?: number;
  Quotite?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type MediathequeEditerLigneCommandeMediathequeFileAttenteModelDtoInput = {
  CodeModeLivraison?: string;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdPermanence?: number;
  IdUtilisateur?: number;
  LibelleLignecommande?: string;
  LigneLibelle?: string;
  LigneReference?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Quantite?: number;
  QuantiteInitiale?: number;
  Quotite?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type MediathequeEditerLigneCommandeMediathequeReservationDateADateModelDtoInput = {
  CodeModeLivraison?: string;
  DateDebutReservation?: any;
  DateFinReservation?: any;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdPermanence?: number;
  IdUtilisateur?: number;
  LibelleLignecommande?: string;
  LigneLibelle?: string;
  LigneReference?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Quantite?: number;
  QuantiteInitiale?: number;
  Quotite?: number;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type MediathequeEmpruntReservationFamilleModel = {
  __typename?: 'MediathequeEmpruntReservationFamilleModel';
  HeureDebutEmpruntDefaut?: any;
  HeureFinEmpruntDefaut?: any;
  IsDateADate?: boolean;
  IsFilDAttente?: boolean;
  IsJoursOuvres?: boolean;
  IsPermanences?: boolean;
  JourSuivant?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbHeuresOuvres?: number;
  NbJoursOuvres?: number;
  NbMinutesOuvres?: number;
  NbPermanences?: number;
  RedescendreSurEnfants?: boolean;
  Status?: StatusDtoEnum;
  TarifLibelleDefaut?: string;
  VueReservationJour?: boolean;
  VueReservationMois?: boolean;
  VueReservationSemaine?: boolean;
};

export type MediathequeEmpruntReservationFamilleModelInput = {
  HeureDebutEmpruntDefaut?: any;
  HeureFinEmpruntDefaut?: any;
  IsDateADate?: boolean;
  IsFilDAttente?: boolean;
  IsJoursOuvres?: boolean;
  IsPermanences?: boolean;
  JourSuivant?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbHeuresOuvres?: number;
  NbJoursOuvres?: number;
  NbMinutesOuvres?: number;
  NbPermanences?: number;
  RedescendreSurEnfants?: boolean;
  Status?: StatusDtoEnum;
  TarifLibelleDefaut?: string;
  VueReservationJour?: boolean;
  VueReservationMois?: boolean;
  VueReservationSemaine?: boolean;
};

export type MediathequeExemplaireCatalogueMediaModel = {
  __typename?: 'MediathequeExemplaireCatalogueMediaModel';
  BenefEmprunte?: string;
  BenefEnFileDattente?: string;
  BenefReserve?: string;
  BenefRetard?: string;
  Code?: string;
  EtatExemplaire?: string;
  IdEnveloppe?: number;
  IdEtatExemplaire?: number;
  IdExemplaire?: number;
  IdProduit?: number;
  IdStockActuel?: number;
  IdStockRattachement?: number;
  IsBloque?: boolean;
  IsEmprunte?: boolean;
  IsEnFileDattente?: boolean;
  IsEnStock?: boolean;
  IsEnTransfert?: boolean;
  IsGereEnFileAttente?: boolean;
  IsPerdu?: boolean;
  IsReserve?: boolean;
  IsRetard?: boolean;
  Localisation?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QteFileEnAttente?: number;
  Remarque?: string;
  Status?: StatusDtoEnum;
  StockRattachement?: string;
  ToDelete?: boolean;
};

export type MediathequeExemplaireCatalogueMediaModelInput = {
  BenefEmprunte?: string;
  BenefEnFileDattente?: string;
  BenefReserve?: string;
  BenefRetard?: string;
  Code?: string;
  EtatExemplaire?: string;
  IdEnveloppe?: number;
  IdEtatExemplaire?: number;
  IdExemplaire?: number;
  IdProduit?: number;
  IdStockActuel?: number;
  IdStockRattachement?: number;
  IsBloque?: boolean;
  IsEmprunte?: boolean;
  IsEnFileDattente?: boolean;
  IsEnStock?: boolean;
  IsEnTransfert?: boolean;
  IsGereEnFileAttente?: boolean;
  IsPerdu?: boolean;
  IsReserve?: boolean;
  IsRetard?: boolean;
  Localisation?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QteFileEnAttente?: number;
  Remarque?: string;
  Status?: StatusDtoEnum;
  StockRattachement?: string;
  ToDelete?: boolean;
};

export type MediathequeExemplaireMediaEmpruntReservationMediathequeModelDto = {
  __typename?: 'MediathequeExemplaireMediaEmpruntReservationMediathequeModelDTO';
  Auteur?: string;
  Cible?: string;
  Collection?: string;
  Cote?: string;
  DateDebutEmpruntReservation?: any;
  DateFinEmpruntReservationPrevu?: any;
  DateRetour?: any;
  Description?: string;
  Editeur?: string;
  EtatExemplaire?: string;
  Genre?: string;
  IdBenef?: number;
  IdDevis?: number;
  IdExemplaire?: number;
  IdLigneDevis?: number;
  IdMedia?: number;
  IsBenefAvecBlocageDroit?: boolean;
  IsBenefAvecDroitActif?: boolean;
  IsDisponibleEnStock?: boolean;
  IsExemplaireReserverBenef?: boolean;
  IsModeMediaReservationADate?: boolean;
  IsNouveau?: boolean;
  LibelleExemplaire?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbFileAttente?: number;
  NbJourEmprunt?: number;
  NbPermanence?: number;
  NbReservations?: number;
  Numerotation?: string;
  PhotoClient?: string;
  PhotoFileName?: string;
  Picto?: FichierModel;
  Reference?: string;
  RemarqueExemplaire?: string;
  RemarquePrive?: string;
  RemarquePublic?: string;
  Status?: StatusDtoEnum;
  StatutLivraison?: string;
  TitreMedia?: string;
  TypeMedia?: string;
};

export type MediathequeExemplaireMediaEmpruntReservationMediathequeModelDtoInput = {
  Auteur?: string;
  Cible?: string;
  Collection?: string;
  Cote?: string;
  DateDebutEmpruntReservation?: any;
  DateFinEmpruntReservationPrevu?: any;
  DateRetour?: any;
  Description?: string;
  Editeur?: string;
  EtatExemplaire?: string;
  Genre?: string;
  IdBenef?: number;
  IdDevis?: number;
  IdExemplaire?: number;
  IdLigneDevis?: number;
  IdMedia?: number;
  IsBenefAvecBlocageDroit?: boolean;
  IsBenefAvecDroitActif?: boolean;
  IsDisponibleEnStock?: boolean;
  IsExemplaireReserverBenef?: boolean;
  IsModeMediaReservationADate?: boolean;
  IsNouveau?: boolean;
  LibelleExemplaire?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbFileAttente?: number;
  NbJourEmprunt?: number;
  NbPermanence?: number;
  NbReservations?: number;
  Numerotation?: string;
  PhotoClient?: string;
  PhotoFileName?: string;
  Picto?: FichierModelInput;
  Reference?: string;
  RemarqueExemplaire?: string;
  RemarquePrive?: string;
  RemarquePublic?: string;
  Status?: StatusDtoEnum;
  StatutLivraison?: string;
  TitreMedia?: string;
  TypeMedia?: string;
};

export type MediathequeFamilleLightModel = {
  __typename?: 'MediathequeFamilleLightModel';
  Code?: string;
  Id?: number;
  IsClos?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type MediathequeFamilleLightModelInput = {
  Code?: string;
  Id?: number;
  IsClos?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type MediathequeInformationsFamilleModel = {
  __typename?: 'MediathequeInformationsFamilleModel';
  Code?: string;
  Description?: string;
  IdActivite?: number;
  IdFamille?: number;
  Illustration?: FichierModel;
  IsClos?: boolean;
  IsConsidererNouveauxProduits?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbJoursConsidererNouveauxProduits?: number;
  RedescendreImage?: boolean;
  Status?: StatusDtoEnum;
  TokenIllustration?: string;
  TypeParDefautDesProduits?: string;
};

export type MediathequeInformationsFamilleModelInput = {
  Code?: string;
  Description?: string;
  IdActivite?: number;
  IdFamille?: number;
  Illustration?: FichierModelInput;
  IsClos?: boolean;
  IsConsidererNouveauxProduits?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbJoursConsidererNouveauxProduits?: number;
  RedescendreImage?: boolean;
  Status?: StatusDtoEnum;
  TokenIllustration?: string;
  TypeParDefautDesProduits?: string;
};

export type MediathequeInfosMediathequeBenefMediaModelDto = {
  __typename?: 'MediathequeInfosMediathequeBenefMediaModelDTO';
  IdBenef?: number;
  IdExemplaire?: number;
  IdStockLocalisation?: number;
  IsBenefAvecBlocageDroit?: boolean;
  IsBenefAvecDroitActif?: boolean;
  IsBloque?: boolean;
  IsGereEnFileAttente?: boolean;
  IsPerdu?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MediathequeInfosMediathequeBenefMediaModelDtoInput = {
  IdBenef?: number;
  IdExemplaire?: number;
  IdStockLocalisation?: number;
  IsBenefAvecBlocageDroit?: boolean;
  IsBenefAvecDroitActif?: boolean;
  IsBloque?: boolean;
  IsGereEnFileAttente?: boolean;
  IsPerdu?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MediathequeLigneCommandeBaseModel = {
  __typename?: 'MediathequeLigneCommandeBaseModel';
  IdLigneCommande?: number;
  LibelleLigneCommande?: string;
};

export type MediathequeLigneCommandeBaseModelInput = {
  IdLigneCommande?: number;
  LibelleLigneCommande?: string;
};

export type MediathequeLigneCommandeInfosResaMdkModel = {
  __typename?: 'MediathequeLigneCommandeInfosResaMDKModel';
  DateDebutResa?: any;
  DateFinResa?: any;
  IdBenef?: number;
  IdLigneCommande?: number;
  LibelleLigneCommande?: string;
  NomPrenomBenef?: string;
};

export type MediathequeLigneCommandeInfosResaMdkModelInput = {
  DateDebutResa?: any;
  DateFinResa?: any;
  IdBenef?: number;
  IdLigneCommande?: number;
  LibelleLigneCommande?: string;
  NomPrenomBenef?: string;
};

export type MediathequeListeCatalogueMediaModel = {
  __typename?: 'MediathequeListeCatalogueMediaModel';
  Auteur?: string;
  CodeFamille?: string;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdMedia?: number;
  IsClos?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeMedia?: string;
};

export type MediathequeListeCatalogueMediaModelInput = {
  Auteur?: string;
  CodeFamille?: string;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdMedia?: number;
  IsClos?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeMedia?: string;
};

export type MediathequeModelInitRechercheAvanceExemplaireMediaDto = {
  __typename?: 'MediathequeModelInitRechercheAvanceExemplaireMediaDTO';
  ListeCollection?: ArrayOfstring;
  ListeFamilleModel?: ArrayOfFamilleBaseModel;
  ListeGenre?: ArrayOfstring;
  ListeSousCollection?: ArrayOfstring;
  ListeStock?: ArrayOfStockModeleDto;
  ListeStockLivraison?: ArrayOfStockModeleDto;
  ListeThemeSujet?: ArrayOfstring;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MediathequeModelInitRechercheAvanceExemplaireMediaDtoInput = {
  ListeCollection?: ArrayOfstringInput;
  ListeFamilleModel?: ArrayOfFamilleBaseModelInput;
  ListeGenre?: ArrayOfstringInput;
  ListeSousCollection?: ArrayOfstringInput;
  ListeStock?: ArrayOfStockModeleDtoInput;
  ListeStockLivraison?: ArrayOfStockModeleDtoInput;
  ListeThemeSujet?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MediathequeReservationEnLigneFamilleModel = {
  __typename?: 'MediathequeReservationEnLigneFamilleModel';
  IsAfficherSurSiteCE?: boolean;
  IsAutoriserResaSurSiteCE?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreSurEnfants?: boolean;
  Status?: StatusDtoEnum;
  VisibleAu?: any;
  VisibleDu?: any;
};

export type MediathequeReservationEnLigneFamilleModelInput = {
  IsAfficherSurSiteCE?: boolean;
  IsAutoriserResaSurSiteCE?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreSurEnfants?: boolean;
  Status?: StatusDtoEnum;
  VisibleAu?: any;
  VisibleDu?: any;
};

export type MediathequeRetourEditerLigneCommandeMediathequeModelDto = {
  __typename?: 'MediathequeRetourEditerLigneCommandeMediathequeModelDTO';
  ErreurEditerLigne?: string;
  IdDevis?: number;
  IdLigneCommande?: number;
  MessageAlerte?: string;
};

export type MediathequeRetourEditerLigneCommandeMediathequeModelDtoInput = {
  ErreurEditerLigne?: string;
  IdDevis?: number;
  IdLigneCommande?: number;
  MessageAlerte?: string;
};

export type MenuDto = {
  __typename?: 'MenuDTO';
  Activite?: ActiviteDto;
  CeDelegation?: CeDelegationDto;
  Code?: string;
  CodeModule?: string;
  Id?: number;
  IsExpanded?: boolean;
  IsFullScreen?: boolean;
  IsGeneriqueActivite?: boolean;
  IsMenuDev?: boolean;
  IsPerso?: boolean;
  IsRacineFavori?: boolean;
  Libelle?: string;
  ListeMenus?: ArrayOfMenuDto;
  ListeTypeActivites?: ArrayOfTypeActiviteDto;
  MenuGenerique?: MenuDto;
  MenuPage?: MenuPageDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NodeLevel?: number;
  Ordre?: number;
  ParentMenu?: MenuDto;
  ParentMenuFavori?: MenuDto;
  Picto?: FichierModel;
  PictoOver?: FichierModel;
  Status?: StatusDtoEnum;
  User?: UsersDto;
  UserCanModify?: boolean;
};

export type MenuDtoInput = {
  Activite?: ActiviteDtoInput;
  CeDelegation?: CeDelegationDtoInput;
  Code?: string;
  CodeModule?: string;
  Id?: number;
  IsExpanded?: boolean;
  IsFullScreen?: boolean;
  IsGeneriqueActivite?: boolean;
  IsMenuDev?: boolean;
  IsPerso?: boolean;
  IsRacineFavori?: boolean;
  Libelle?: string;
  ListeMenus?: ArrayOfMenuDtoInput;
  ListeTypeActivites?: ArrayOfTypeActiviteDtoInput;
  MenuGenerique?: MenuDtoInput;
  MenuPage?: MenuPageDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NodeLevel?: number;
  Ordre?: number;
  ParentMenu?: MenuDtoInput;
  ParentMenuFavori?: MenuDtoInput;
  Picto?: FichierModelInput;
  PictoOver?: FichierModelInput;
  Status?: StatusDtoEnum;
  User?: UsersDtoInput;
  UserCanModify?: boolean;
};

export type MenuPageDto = {
  __typename?: 'MenuPageDTO';
  Activite?: ActiviteDto;
  Classe?: string;
  Code?: string;
  Id?: number;
  IsGeneriqueActivite?: boolean;
  Libelle?: string;
  ListeMenuParent?: ArrayOfMenuDto;
  ListeParametres?: ArrayOfMenuPageParamDto;
  ListeTypeActivites?: ArrayOfTypeActiviteDto;
  MenuPageGenerique?: MenuPageDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Picto?: string;
  Status?: StatusDtoEnum;
};

export type MenuPageDtoInput = {
  Activite?: ActiviteDtoInput;
  Classe?: string;
  Code?: string;
  Id?: number;
  IsGeneriqueActivite?: boolean;
  Libelle?: string;
  ListeMenuParent?: ArrayOfMenuDtoInput;
  ListeParametres?: ArrayOfMenuPageParamDtoInput;
  ListeTypeActivites?: ArrayOfTypeActiviteDtoInput;
  MenuPageGenerique?: MenuPageDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Picto?: string;
  Status?: StatusDtoEnum;
};

export type MenuPageParamDto = {
  __typename?: 'MenuPageParamDTO';
  Id?: number;
  Libelle?: string;
  MenuPage?: MenuPageDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type MenuPageParamDtoInput = {
  Id?: number;
  Libelle?: string;
  MenuPage?: MenuPageDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type MenusArticleTreeViewModuleGestionMenusModel = {
  __typename?: 'MenusArticleTreeViewModuleGestionMenusModel';
  CodeTypeArticle?: string;
  Id?: number;
  IdDelegation?: number;
  IdParent?: number;
  IsAffichagePublic?: boolean;
  IsContainer?: boolean;
  IsDelegationGlobale?: boolean;
  IsExpanded?: boolean;
  IsMenuASCBoule?: boolean;
  IsModificationPossibleSurLocal?: boolean;
  Libelle?: string;
  ListeArticlesEnfants?: ArrayOfMenusArticleTreeViewModuleGestionMenusModel;
  ListeCommissions?: ArrayOfdecimal;
  MustValidate?: boolean;
  MyGuid?: string;
  OrdreMenu?: number;
  Parent?: MenusArticleTreeViewModuleGestionMenusModel;
  Status?: StatusDtoEnum;
  StatutCod?: string;
  StatutLib?: string;
};

export type MenusArticleTreeViewModuleGestionMenusModelInput = {
  CodeTypeArticle?: string;
  Id?: number;
  IdDelegation?: number;
  IdParent?: number;
  IsAffichagePublic?: boolean;
  IsContainer?: boolean;
  IsDelegationGlobale?: boolean;
  IsExpanded?: boolean;
  IsMenuASCBoule?: boolean;
  IsModificationPossibleSurLocal?: boolean;
  Libelle?: string;
  ListeArticlesEnfants?: ArrayOfMenusArticleTreeViewModuleGestionMenusModelInput;
  ListeCommissions?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  OrdreMenu?: number;
  Parent?: MenusArticleTreeViewModuleGestionMenusModelInput;
  Status?: StatusDtoEnum;
  StatutCod?: string;
  StatutLib?: string;
};

export type MenusInitialisationModuleGestionMenusModel = {
  __typename?: 'MenusInitialisationModuleGestionMenusModel';
  ListePortailArticle?: ArrayOfMenusArticleTreeViewModuleGestionMenusModel;
  ListePortailArticleParametres?: ArrayOfPortailArticleParamDto;
  ListePortailArticleTypes?: ArrayOfPortailArticleTypeDto;
  ListePortailStatut?: ArrayOfPortailStatutDto;
  OptionsGenerales?: PortailOptionsDto;
};

export type MenusInitialisationModuleGestionMenusModelInput = {
  ListePortailArticle?: ArrayOfMenusArticleTreeViewModuleGestionMenusModelInput;
  ListePortailArticleParametres?: ArrayOfPortailArticleParamDtoInput;
  ListePortailArticleTypes?: ArrayOfPortailArticleTypeDtoInput;
  ListePortailStatut?: ArrayOfPortailStatutDtoInput;
  OptionsGenerales?: PortailOptionsDtoInput;
};

export type MenusParametresDeplacementArbreArborescenceModelInput = {
  Id?: number;
  IdParent?: number;
  Parente?: string;
};

export type MessageAppliDto = {
  __typename?: 'MessageAppliDTO';
  Code?: string;
  DateDebutAffichage?: any;
  DateFinAffichage?: any;
  Id?: number;
  Message?: string;
  MessageHTML?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OrdreImportance?: number;
  Status?: StatusDtoEnum;
};

export type MessageAppliDtoInput = {
  Code?: string;
  DateDebutAffichage?: any;
  DateFinAffichage?: any;
  Id?: number;
  Message?: string;
  MessageHTML?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OrdreImportance?: number;
  Status?: StatusDtoEnum;
};

export enum MessageTypeEnum {
  Astuce = 'Astuce',
  Info = 'Info',
  Nouveaute = 'Nouveaute'
}

export type ModalitesReglementFpaModel = {
  __typename?: 'ModalitesReglementFPAModel';
  IsProduitNecessiteAcceptationCE?: boolean;
  ListeModeleEcheancier?: ArrayOfModeleEcheancierGeneriqueModel;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementAfpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreSurEnfants?: boolean;
  Status?: StatusDtoEnum;
};

export type ModalitesReglementFpaModelInput = {
  IsProduitNecessiteAcceptationCE?: boolean;
  ListeModeleEcheancier?: ArrayOfModeleEcheancierGeneriqueModelInput;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementAfpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreSurEnfants?: boolean;
  Status?: StatusDtoEnum;
};

export type ModeEnvoiAncvModel = {
  __typename?: 'ModeEnvoiANCVModel';
  CodeModeEnvoi?: string;
  IdModeEnvoi?: number;
  LibelleModeEnvoi?: string;
};

export type ModeEnvoiAncvModelInput = {
  CodeModeEnvoi?: string;
  IdModeEnvoi?: number;
  LibelleModeEnvoi?: string;
};

export type ModeLivraisonDto = {
  __typename?: 'ModeLivraisonDTO';
  Code?: string;
  Id?: number;
  IsClos?: boolean;
  IsPerso?: boolean;
  Libelle?: string;
  ListeArticle?: ArrayOfArticleModeLivraisonDto;
  ListeBLBR?: ArrayOfBlBrDto;
  ListeFamillesProduits?: ArrayOfFamilleProduitModeLivraisonDto;
  ListeLignesCommande?: ArrayOfLigneCommandeDto;
  ListeModeLivraisonFraisPort?: ArrayOfModeLivraisonFraisPortDto;
  ListeProduits?: ArrayOfProduitModelivraisonDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NecessiteAdresseMail?: boolean;
  NecessiteSelectionAdresse?: boolean;
  Status?: StatusDtoEnum;
};

export type ModeLivraisonDtoInput = {
  Code?: string;
  Id?: number;
  IsClos?: boolean;
  IsPerso?: boolean;
  Libelle?: string;
  ListeArticle?: ArrayOfArticleModeLivraisonDtoInput;
  ListeBLBR?: ArrayOfBlBrDtoInput;
  ListeFamillesProduits?: ArrayOfFamilleProduitModeLivraisonDtoInput;
  ListeLignesCommande?: ArrayOfLigneCommandeDtoInput;
  ListeModeLivraisonFraisPort?: ArrayOfModeLivraisonFraisPortDtoInput;
  ListeProduits?: ArrayOfProduitModelivraisonDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NecessiteAdresseMail?: boolean;
  NecessiteSelectionAdresse?: boolean;
  Status?: StatusDtoEnum;
};

export type ModeLivraisonFpaModel = {
  __typename?: 'ModeLivraisonFPAModel';
  IdElement?: number;
  IdModeLivraison?: number;
  IsDefaut?: boolean;
  IsPossible?: boolean;
  LibelleModeLivraison?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeLivraisonFpaModelInput = {
  IdElement?: number;
  IdModeLivraison?: number;
  IsDefaut?: boolean;
  IsPossible?: boolean;
  LibelleModeLivraison?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeLivraisonFraisPortDto = {
  __typename?: 'ModeLivraisonFraisPortDTO';
  Id?: number;
  ListeLignesFraisPort?: ArrayOfLigneFraisPortDto;
  ModeLivraison?: ModeLivraisonDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeCalculModeLivraison?: TypeCalculModeLivraisonDto;
};

export type ModeLivraisonFraisPortDtoInput = {
  Id?: number;
  ListeLignesFraisPort?: ArrayOfLigneFraisPortDtoInput;
  ModeLivraison?: ModeLivraisonDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeCalculModeLivraison?: TypeCalculModeLivraisonDtoInput;
};

export type ModeLivraisonModeleDto = {
  __typename?: 'ModeLivraisonModeleDTO';
  CodeModeLivraison?: string;
  IdModeLivraison?: number;
  IsClos?: boolean;
  LibelleModeLivraison?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeLivraisonModeleDtoInput = {
  CodeModeLivraison?: string;
  IdModeLivraison?: number;
  IsClos?: boolean;
  LibelleModeLivraison?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModelEmailCriteresModelEmailModelInput = {
  CodeTypePublipostage?: string;
  IdFile?: number;
  IdModelEmail?: number;
  IdTypePubli?: number;
  IsClos?: boolean;
  IsModelPublipostage?: boolean;
};

export type ModelEmailDto = {
  __typename?: 'ModelEmailDTO';
  CEDelegation?: CeDelegationDto;
  Code?: string;
  Corp?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Obj?: string;
  Status?: StatusDtoEnum;
};

export type ModelEmailDtoInput = {
  CEDelegation?: CeDelegationDtoInput;
  Code?: string;
  Corp?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Obj?: string;
  Status?: StatusDtoEnum;
};

export type ModelEmailModelEmailClotureModel = {
  __typename?: 'ModelEmailModelEmailClotureModel';
  IdModelEmail?: number;
  IsCloture?: boolean;
  IsSupprimable?: boolean;
  LibelleModelEmail?: string;
};

export type ModelEmailModelEmailClotureModelInput = {
  IdModelEmail?: number;
  IsCloture?: boolean;
  IsSupprimable?: boolean;
  LibelleModelEmail?: string;
};

export type ModelEmailModelEmailVuePubliModel = {
  __typename?: 'ModelEmailModelEmailVuePubliModel';
  CodeModele?: string;
  CorpsModelEmail?: string;
  IdModelEmail?: number;
  IdTypePubli?: number;
  IdVuePubli?: number;
  LibelleModelEmail?: string;
  ListIdTypeActivite?: ArrayOfdecimal;
  ListeIdReportJoint?: ArrayOfdecimal;
  ListePJ?: ArrayOfFichierModel;
  ObjectModelEmail?: string;
};

export type ModelEmailModelEmailVuePubliModelInput = {
  CodeModele?: string;
  CorpsModelEmail?: string;
  IdModelEmail?: number;
  IdTypePubli?: number;
  IdVuePubli?: number;
  LibelleModelEmail?: string;
  ListIdTypeActivite?: ArrayOfdecimalInput;
  ListeIdReportJoint?: ArrayOfdecimalInput;
  ListePJ?: ArrayOfFichierModelInput;
  ObjectModelEmail?: string;
};

export type ModelEmailModelEmailVuePubliModelLight = {
  __typename?: 'ModelEmailModelEmailVuePubliModelLight';
  IdModelEmail?: number;
  LibelleModelEmail?: string;
};

export type ModelEmailModelEmailVuePubliModelLightInput = {
  IdModelEmail?: number;
  LibelleModelEmail?: string;
};

export type ModelEmailPjEtPubliTypModel = {
  __typename?: 'ModelEmailPjEtPubliTypModel';
  CorpsModelEmail?: string;
  DestinataireModelEmail?: string;
  EmetteurModelEmail?: string;
  IdModelEmail?: number;
  IdModeleNewsLetter?: number;
  IdTypePublipostage?: number;
  IsIdentifiants?: boolean;
  IsNewsLetter?: boolean;
  IsPubliPostage?: boolean;
  LibelleModelEmail?: string;
  ListeIdReportJoint?: ArrayOfdecimal;
  ListeIdTheme?: ArrayOfdecimal;
  ListePJ?: ArrayOfFichierModel;
  ListePubliDocument?: ArrayOfPubliDocumentReportModel;
  MustValidate?: boolean;
  MyGuid?: string;
  ObjectModelEmail?: string;
  Status?: StatusDtoEnum;
};

export type ModelEmailPjEtPubliTypModelInput = {
  CorpsModelEmail?: string;
  DestinataireModelEmail?: string;
  EmetteurModelEmail?: string;
  IdModelEmail?: number;
  IdModeleNewsLetter?: number;
  IdTypePublipostage?: number;
  IsIdentifiants?: boolean;
  IsNewsLetter?: boolean;
  IsPubliPostage?: boolean;
  LibelleModelEmail?: string;
  ListeIdReportJoint?: ArrayOfdecimalInput;
  ListeIdTheme?: ArrayOfdecimalInput;
  ListePJ?: ArrayOfFichierModelInput;
  ListePubliDocument?: ArrayOfPubliDocumentReportModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  ObjectModelEmail?: string;
  Status?: StatusDtoEnum;
};

export type ModelInitInventaireStock = {
  __typename?: 'ModelInitInventaireStock';
  Activite?: ActiviteBaseModel;
  ListeStock?: ArrayOfStockModeleDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModelInitInventaireStockInput = {
  Activite?: ActiviteBaseModelInput;
  ListeStock?: ArrayOfStockModeleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModelRetourSaveInventaire = {
  __typename?: 'ModelRetourSaveInventaire';
  IdInventaire?: number;
  ListeIdMvtStockInventorie?: ArrayOfdecimal;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModelRetourSaveInventaireInput = {
  IdInventaire?: number;
  ListeIdMvtStockInventorie?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleAdresseBaseModel = {
  __typename?: 'ModeleAdresseBaseModel';
  CodeModeleAdresse?: string;
  IdModeleAdresse?: number;
  LibelleModeleAdresse?: string;
};

export type ModeleAdresseBaseModelInput = {
  CodeModeleAdresse?: string;
  IdModeleAdresse?: number;
  LibelleModeleAdresse?: string;
};

export type ModeleAdresseModelDto = {
  __typename?: 'ModeleAdresseModelDTO';
  Code?: string;
  IdModeleAdresse?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleAdresseModelDtoInput = {
  Code?: string;
  IdModeleAdresse?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleAffichageEnveloppeDto = {
  __typename?: 'ModeleAffichageEnveloppeDTO';
  ListeEnveloppeModeleHerite?: ArrayOfModeleEnveloppeDto;
  ListeEnveloppeModeleImpute?: ArrayOfModeleEnveloppeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleAffichageEnveloppeDtoInput = {
  ListeEnveloppeModeleHerite?: ArrayOfModeleEnveloppeDtoInput;
  ListeEnveloppeModeleImpute?: ArrayOfModeleEnveloppeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleAffichageRegleDto = {
  __typename?: 'ModeleAffichageRegleDTO';
  ListeModeleRegleAfaireHerite?: ArrayOfMoteurRegleModelDto;
  ListeModeleRegleHerite?: ArrayOfMoteurRegleModelDto;
  ListeModeleRegleLocale?: ArrayOfMoteurRegleModelDto;
  ListeModeleRegleUse?: ArrayOfMoteurRegleModelDto;
  ListeReglesComplementaires?: ArrayOfRegleComplementaireModelDto;
  ModeleAffichageEnveloppe?: ModeleAffichageEnveloppeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleAffichageRegleDtoInput = {
  ListeModeleRegleAfaireHerite?: ArrayOfMoteurRegleModelDtoInput;
  ListeModeleRegleHerite?: ArrayOfMoteurRegleModelDtoInput;
  ListeModeleRegleLocale?: ArrayOfMoteurRegleModelDtoInput;
  ListeModeleRegleUse?: ArrayOfMoteurRegleModelDtoInput;
  ListeReglesComplementaires?: ArrayOfRegleComplementaireModelDtoInput;
  ModeleAffichageEnveloppe?: ModeleAffichageEnveloppeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleChargementAttBdgBenfDto = {
  __typename?: 'ModeleChargementAttBdgBenfDTO';
  DateAttribution?: any;
  IdAttribution?: number;
  IsSurEnveloppeSynchronisee?: boolean;
  Libelle?: string;
  LibelleArticle?: string;
  ListeAttributionBenefModele?: ArrayOfAttributionBenefModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarquePrive?: string;
  RemarquePublic?: string;
  Status?: StatusDtoEnum;
};

export type ModeleChargementAttBdgBenfDtoInput = {
  DateAttribution?: any;
  IdAttribution?: number;
  IsSurEnveloppeSynchronisee?: boolean;
  Libelle?: string;
  LibelleArticle?: string;
  ListeAttributionBenefModele?: ArrayOfAttributionBenefModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarquePrive?: string;
  RemarquePublic?: string;
  Status?: StatusDtoEnum;
};

export type ModeleConsoEnvQuotaDto = {
  __typename?: 'ModeleConsoEnvQuotaDTO';
  BenefID?: number;
  BenefString?: string;
  EnveloppeID?: number;
  EnveloppeString?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteQuota?: number;
  Status?: StatusDtoEnum;
  SubVentionMontant?: number;
  TypeEnveloppe?: string;
  ValeurFacialeQuota?: number;
};

export type ModeleConsoEnvQuotaDtoInput = {
  BenefID?: number;
  BenefString?: string;
  EnveloppeID?: number;
  EnveloppeString?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteQuota?: number;
  Status?: StatusDtoEnum;
  SubVentionMontant?: number;
  TypeEnveloppe?: string;
  ValeurFacialeQuota?: number;
};

export type ModeleDeploiementReglesBaseInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  RedescenteRegleAccessibilite?: boolean;
  RedescenteRegleQuota?: boolean;
  Status?: StatusDtoEnum;
};

export type ModeleEchancierListingModelInput = {
  IdModeleEcheancier?: number;
  IsClos?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleEcheancierBaseModel = {
  __typename?: 'ModeleEcheancierBaseModel';
  IdModeleEcheancier?: number;
  Libelle?: string;
};

export type ModeleEcheancierBaseModelInput = {
  IdModeleEcheancier?: number;
  Libelle?: string;
};

export type ModeleEcheancierDefautModel = {
  __typename?: 'ModeleEcheancierDefautModel';
  IdModeleEcheancier?: number;
  IsClos?: boolean;
  IsParDefaut?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleEcheancierDefautModelInput = {
  IdModeleEcheancier?: number;
  IsClos?: boolean;
  IsParDefaut?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleEcheancierFpaModel = {
  __typename?: 'ModeleEcheancierFPAModel';
  IdElement?: number;
  IdModeleEcheancier?: number;
  IsDefaut?: boolean;
  IsSelected?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleEcheancierFpaModelInput = {
  IdElement?: number;
  IdModeleEcheancier?: number;
  IsDefaut?: boolean;
  IsSelected?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleEcheancierGeneriqueModel = {
  __typename?: 'ModeleEcheancierGeneriqueModel';
  DelaiPremiereEcheance?: number;
  IdElement?: number;
  IdModeleEcheancier?: number;
  IsClos?: boolean;
  IsDeclenchementAvant?: boolean;
  IsDefaut?: boolean;
  IsSelected?: boolean;
  JourDansMois?: number;
  Libelle?: string;
  MoisPremiereEcheance?: number;
  MontantMinimal?: number;
  MontantPremiereEcheance?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreEcheance?: number;
  NombreJoursDeclenchement?: number;
  Periodicite?: number;
  PourcentagePremiereEcheance?: number;
  Status?: StatusDtoEnum;
};

export type ModeleEcheancierGeneriqueModelInput = {
  DelaiPremiereEcheance?: number;
  IdElement?: number;
  IdModeleEcheancier?: number;
  IsClos?: boolean;
  IsDeclenchementAvant?: boolean;
  IsDefaut?: boolean;
  IsSelected?: boolean;
  JourDansMois?: number;
  Libelle?: string;
  MoisPremiereEcheance?: number;
  MontantMinimal?: number;
  MontantPremiereEcheance?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreEcheance?: number;
  NombreJoursDeclenchement?: number;
  Periodicite?: number;
  PourcentagePremiereEcheance?: number;
  Status?: StatusDtoEnum;
};

export type ModeleEcheancierMntMinModel = {
  __typename?: 'ModeleEcheancierMntMinModel';
  IdModeleEcheancier?: number;
  Libelle?: string;
  MontantMinimum?: number;
};

export type ModeleEcheancierMntMinModelInput = {
  IdModeleEcheancier?: number;
  Libelle?: string;
  MontantMinimum?: number;
};

export type ModeleEnveloppeDto = {
  __typename?: 'ModeleEnveloppeDTO';
  Code?: string;
  DateDebut?: any;
  DateDebutValidite?: any;
  DateFin?: any;
  DateFinValidite?: any;
  Id?: number;
  IdCE?: number;
  IdModeleRglLim?: number;
  IdMoteurRegle?: number;
  IdValPeriode?: number;
  IsAfficheEnLigne?: boolean;
  IsCloture?: boolean;
  IsComplementaire?: boolean;
  IsEnvAttribution?: boolean;
  IsHerite?: boolean;
  IsNominatif?: boolean;
  IsPeriodeCycle?: boolean;
  IsPeriodeUnique?: boolean;
  IsSansPeriode?: boolean;
  IsSubChoisie?: boolean;
  IsSynchroKalidea?: boolean;
  IsSynchroSynapse?: boolean;
  IsTransverse?: boolean;
  Libelle?: string;
  LibelleEnvelopeKalidea?: string;
  ListeIdEnvImpAct?: ArrayOfdecimal;
  ListeIdEnvImpArt?: ArrayOfdecimal;
  ListeIdEnvImpFam?: ArrayOfdecimal;
  ListeIdEnvImpPrd?: ArrayOfdecimal;
  MoteurRegleModele?: MoteurRegleModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type ModeleEnveloppeDtoInput = {
  Code?: string;
  DateDebut?: any;
  DateDebutValidite?: any;
  DateFin?: any;
  DateFinValidite?: any;
  Id?: number;
  IdCE?: number;
  IdModeleRglLim?: number;
  IdMoteurRegle?: number;
  IdValPeriode?: number;
  IsAfficheEnLigne?: boolean;
  IsCloture?: boolean;
  IsComplementaire?: boolean;
  IsEnvAttribution?: boolean;
  IsHerite?: boolean;
  IsNominatif?: boolean;
  IsPeriodeCycle?: boolean;
  IsPeriodeUnique?: boolean;
  IsSansPeriode?: boolean;
  IsSubChoisie?: boolean;
  IsSynchroKalidea?: boolean;
  IsSynchroSynapse?: boolean;
  IsTransverse?: boolean;
  Libelle?: string;
  LibelleEnvelopeKalidea?: string;
  ListeIdEnvImpAct?: ArrayOfdecimalInput;
  ListeIdEnvImpArt?: ArrayOfdecimalInput;
  ListeIdEnvImpFam?: ArrayOfdecimalInput;
  ListeIdEnvImpPrd?: ArrayOfdecimalInput;
  MoteurRegleModele?: MoteurRegleModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type ModeleEpargneModel = {
  __typename?: 'ModeleEpargneModel';
  ArticleAssocie?: ArticleAssocieEpargneModel;
  Comptabilite?: Union_266707523219680728;
  EnLigne?: EnLigneEpargneModel;
  Information?: InformationsEpargneModel;
  Regles?: ModeleSaveReglesAfpadto;
};

export type ModeleEpargneModelInput = {
  ArticleAssocie?: ArticleAssocieEpargneModelInput;
  Comptabilite?: ComptabiliteEpargnesArticleModelInput;
  EnLigne?: EnLigneEpargneModelInput;
  Information?: InformationsEpargneModelInput;
  Regles?: ModeleSaveReglesAfpadtoInput;
};

export type ModeleExecAttributionBudgetDtoInput = {
  ContextAttBDG?: string;
  DateValidationAttBDG?: any;
  IdActivite?: number;
  IdArticle?: number;
  IdAttribution?: number;
  Libelle?: string;
  ListeAttBdgBenefAttribue?: ArrayOfAttributionBenefExecModelDtoInput;
  ListeIdLgeVueBenefNotAttribue?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarquePrive?: string;
  RemarquePublic?: string;
  Status?: StatusDtoEnum;
};

export type ModeleForFacturationDto = {
  __typename?: 'ModeleForFacturationDTO';
  Banque?: string;
  CodeTypeActivite?: string;
  DateFacture?: any;
  GenererNumeroPiece?: boolean;
  IdActivite?: number;
  IdBenef?: number;
  IdCaisse?: number;
  IdExercice?: number;
  IdJournal?: number;
  IdMoyenPaiement?: number;
  IdPV?: number;
  IdStock?: number;
  IdTransactionForReglementEnLigne?: number;
  IsContexteLocation?: boolean;
  IsReglementEnLigne?: boolean;
  LibelleFacture?: string;
  ListeIdCommande?: ArrayOfdecimal;
  MustValidate?: boolean;
  MyGuid?: string;
  NomTire?: string;
  NumCheque?: string;
  NumPiece?: string;
  NumPieceAuto?: boolean;
  Rib?: RibDto;
  Status?: StatusDtoEnum;
  TypeEcriture?: string;
  TypeFacture?: string;
};

export type ModeleForFacturationDtoInput = {
  Banque?: string;
  CodeTypeActivite?: string;
  DateFacture?: any;
  GenererNumeroPiece?: boolean;
  IdActivite?: number;
  IdBenef?: number;
  IdCaisse?: number;
  IdExercice?: number;
  IdJournal?: number;
  IdMoyenPaiement?: number;
  IdPV?: number;
  IdStock?: number;
  IdTransactionForReglementEnLigne?: number;
  IsContexteLocation?: boolean;
  IsReglementEnLigne?: boolean;
  LibelleFacture?: string;
  ListeIdCommande?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NomTire?: string;
  NumCheque?: string;
  NumPiece?: string;
  NumPieceAuto?: boolean;
  Rib?: RibDtoInput;
  Status?: StatusDtoEnum;
  TypeEcriture?: string;
  TypeFacture?: string;
};

export type ModeleForFacturationListCmdDtoInput = {
  DateFacturation?: any;
  IdActivite?: number;
  IdCaisse?: number;
  IdExercice?: number;
  IdJournal?: number;
  IdPV?: number;
  IdStock?: number;
  ListeIdCommande?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleHistoRaprpochementDto = {
  __typename?: 'ModeleHistoRaprpochementDTO';
  CodeStatut?: string;
  DateArchive?: any;
  DateCreation?: any;
  IdRapprochement?: number;
  IsArchive?: boolean;
  IsValide?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  SoldeInitial512?: number;
  Status?: StatusDtoEnum;
  Statut?: string;
  User?: string;
};

export type ModeleHistoRaprpochementDtoInput = {
  CodeStatut?: string;
  DateArchive?: any;
  DateCreation?: any;
  IdRapprochement?: number;
  IsArchive?: boolean;
  IsValide?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  SoldeInitial512?: number;
  Status?: StatusDtoEnum;
  Statut?: string;
  User?: string;
};

export type ModeleInitFiltrageCessionModel = {
  __typename?: 'ModeleInitFiltrageCessionModel';
  ListeActivites?: ArrayOfActiviteBaseModel;
  ListeArticles?: ArrayOfArticleWithFamilleEtActiviteModel;
  ListeDelegations?: ArrayOfDelegationBaseModel;
  ListeFamilles?: ArrayOfFamilleWithActiviteModel;
  ListePointVentes?: ArrayOfPointVenteWithDelegModel;
  ListeStocks?: ArrayOfStockWithDelegetPvModel;
};

export type ModeleInitFiltrageCessionModelInput = {
  ListeActivites?: ArrayOfActiviteBaseModelInput;
  ListeArticles?: ArrayOfArticleWithFamilleEtActiviteModelInput;
  ListeDelegations?: ArrayOfDelegationBaseModelInput;
  ListeFamilles?: ArrayOfFamilleWithActiviteModelInput;
  ListePointVentes?: ArrayOfPointVenteWithDelegModelInput;
  ListeStocks?: ArrayOfStockWithDelegetPvModelInput;
};

export type ModeleInitParamFicheProfile = {
  __typename?: 'ModeleInitParamFicheProfile';
  IdFicheProfil?: number;
  ListeBloc?: ArrayOfBlocModelDto;
  ListeProfileData?: ArrayOfFicheProfilDataDirectoModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleInitParamFicheProfileInput = {
  IdFicheProfil?: number;
  ListeBloc?: ArrayOfBlocModelDtoInput;
  ListeProfileData?: ArrayOfFicheProfilDataDirectoModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleLocationBaseModel = {
  __typename?: 'ModeleLocationBaseModel';
  Id?: number;
  IdProduit?: number;
  IsUsedForGeneration?: boolean;
  IsUsedOnLigneCommande?: boolean;
  Libelle?: string;
  ModeleHaveCommandeEnAttente?: boolean;
};

export type ModeleLocationBaseModelInput = {
  Id?: number;
  IdProduit?: number;
  IsUsedForGeneration?: boolean;
  IsUsedOnLigneCommande?: boolean;
  Libelle?: string;
  ModeleHaveCommandeEnAttente?: boolean;
};

export type ModeleLocationModel = {
  __typename?: 'ModeleLocationModel';
  ListeCompteurPointModel?: ArrayOfCompteurPointAfpaModel;
  ListePlageDeDateModel?: ArrayOfModeleLocationPlageDateModel;
  ListeRegleSubventionModel?: ArrayOfModeleLocationReglesSubModel;
  ModeleAffichageRegle?: ModeleAffichageRegleDto;
  ParametrageModel?: ModeleLocationParametrageModel;
};

export type ModeleLocationModelInput = {
  ListeCompteurPointModel?: ArrayOfCompteurPointAfpaModelInput;
  ListePlageDeDateModel?: ArrayOfModeleLocationPlageDateModelInput;
  ListeRegleSubventionModel?: ArrayOfModeleLocationReglesSubModelInput;
  ModeleAffichageRegle?: ModeleAffichageRegleDtoInput;
  ParametrageModel?: ModeleLocationParametrageModelInput;
};

export type ModeleLocationParametrageModel = {
  __typename?: 'ModeleLocationParametrageModel';
  DateDebutReservation?: any;
  DateFinReservation?: any;
  DateSubvention?: any;
  DebutVisibiliteEnLigne?: any;
  DepassementAutorise?: boolean;
  FinVisibiliteEnLigne?: any;
  HeureDebut?: any;
  HeureFin?: any;
  Id?: number;
  IdFraisAnnulation?: number;
  IdProduit?: number;
  IdSessionChoix?: number;
  IdUtilisateur?: number;
  IsGererAllotement?: boolean;
  IsUsedForGeneration?: boolean;
  IsUsedOnLigneCommande?: boolean;
  JourDebut?: string;
  JourFin?: string;
  Libelle?: string;
  ModeleHaveCommandeEnAttente?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NecessiteAutorisationCE?: boolean;
  Periodicite?: string;
  Quotite?: number;
  Status?: StatusDtoEnum;
  _dateLimiteDispo?: any;
  _nbMoisDispo?: number;
};

export type ModeleLocationParametrageModelInput = {
  DateDebutReservation?: any;
  DateFinReservation?: any;
  DateSubvention?: any;
  DebutVisibiliteEnLigne?: any;
  DepassementAutorise?: boolean;
  FinVisibiliteEnLigne?: any;
  HeureDebut?: any;
  HeureFin?: any;
  Id?: number;
  IdFraisAnnulation?: number;
  IdProduit?: number;
  IdSessionChoix?: number;
  IdUtilisateur?: number;
  IsGererAllotement?: boolean;
  IsUsedForGeneration?: boolean;
  IsUsedOnLigneCommande?: boolean;
  JourDebut?: string;
  JourFin?: string;
  Libelle?: string;
  ModeleHaveCommandeEnAttente?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NecessiteAutorisationCE?: boolean;
  Periodicite?: string;
  Quotite?: number;
  Status?: StatusDtoEnum;
  _dateLimiteDispo?: any;
  _nbMoisDispo?: number;
};

export type ModeleLocationPlageDateModel = {
  __typename?: 'ModeleLocationPlageDateModel';
  DateDebut?: any;
  DateFin?: any;
  IdModeleLocation?: number;
  IdPlageDate?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbOptions?: number;
  PrixPublic?: number;
  PrixVente?: number;
  Status?: StatusDtoEnum;
};

export type ModeleLocationPlageDateModelInput = {
  DateDebut?: any;
  DateFin?: any;
  IdModeleLocation?: number;
  IdPlageDate?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbOptions?: number;
  PrixPublic?: number;
  PrixVente?: number;
  Status?: StatusDtoEnum;
};

export type ModeleLocationReglesSubModel = {
  __typename?: 'ModeleLocationReglesSubModel';
  IdModeleLocation?: number;
  IdRegle?: number;
  IsRegleAvancee?: boolean;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
};

export type ModeleLocationReglesSubModelInput = {
  IdModeleLocation?: number;
  IdRegle?: number;
  IsRegleAvancee?: boolean;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
};

export type ModeleRegleAfpaAccessibiliteConjoint = {
  __typename?: 'ModeleRegleAFPAAccessibiliteConjoint';
  AllowForcage?: boolean;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibiliteConjoint?: boolean;
  IsAccessibiliteEnfant?: boolean;
  IsAccessibiliteExterne?: boolean;
  IsAccessibiliteOuvrantDroit?: boolean;
  IsConjointHandicape?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeCriteresOD?: ArrayOfanyType;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaAccessibiliteConjointInput = {
  AllowForcage?: boolean;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibiliteConjoint?: boolean;
  IsAccessibiliteEnfant?: boolean;
  IsAccessibiliteExterne?: boolean;
  IsAccessibiliteOuvrantDroit?: boolean;
  IsConjointHandicape?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeCriteresOD?: ArrayOfanyTypeInput;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaAccessibiliteEnfant = {
  __typename?: 'ModeleRegleAFPAAccessibiliteEnfant';
  AgeEnfantMaximum?: number;
  AgeEnfantMinimum?: number;
  AllowForcage?: boolean;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampEnfant?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAgeEnfant?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibiliteConjoint?: boolean;
  IsAccessibiliteEnfant?: boolean;
  IsAccessibiliteExterne?: boolean;
  IsAccessibiliteOuvrantDroit?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantDirect?: boolean;
  IsEnfantHandicape?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  JourDateReferenceEnfant?: number;
  LibelleRegle?: string;
  ListeCriteresAD?: ArrayOfanyType;
  ListeCriteresOD?: ArrayOfanyType;
  MoisDateReference?: number;
  MoisDateReferenceEnfant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaAccessibiliteEnfantInput = {
  AgeEnfantMaximum?: number;
  AgeEnfantMinimum?: number;
  AllowForcage?: boolean;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampEnfant?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAgeEnfant?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibiliteConjoint?: boolean;
  IsAccessibiliteEnfant?: boolean;
  IsAccessibiliteExterne?: boolean;
  IsAccessibiliteOuvrantDroit?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantDirect?: boolean;
  IsEnfantHandicape?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  JourDateReferenceEnfant?: number;
  LibelleRegle?: string;
  ListeCriteresAD?: ArrayOfanyTypeInput;
  ListeCriteresOD?: ArrayOfanyTypeInput;
  MoisDateReference?: number;
  MoisDateReferenceEnfant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaAccessibiliteOdad = {
  __typename?: 'ModeleRegleAFPAAccessibiliteODAD';
  AllowForcage?: boolean;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibiliteConjoint?: boolean;
  IsAccessibiliteEnfant?: boolean;
  IsAccessibiliteExterne?: boolean;
  IsAccessibiliteOuvrantDroit?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeCriteresOD?: ArrayOfanyType;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaAccessibiliteOdadInput = {
  AllowForcage?: boolean;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibiliteConjoint?: boolean;
  IsAccessibiliteEnfant?: boolean;
  IsAccessibiliteExterne?: boolean;
  IsAccessibiliteOuvrantDroit?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeCriteresOD?: ArrayOfanyTypeInput;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaAccessibiliteOuvrantDroit = {
  __typename?: 'ModeleRegleAFPAAccessibiliteOuvrantDroit';
  AllowForcage?: boolean;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeCriteresOD?: ArrayOfanyType;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaAccessibiliteOuvrantDroitInput = {
  AllowForcage?: boolean;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeCriteresOD?: ArrayOfanyTypeInput;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaAccessibiliteTousBeneficiaires = {
  __typename?: 'ModeleRegleAFPAAccessibiliteTousBeneficiaires';
  AgeEnfantMaximum?: number;
  AgeEnfantMinimum?: number;
  AllowForcage?: boolean;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampEnfant?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAgeEnfant?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibiliteConjoint?: boolean;
  IsAccessibiliteEnfant?: boolean;
  IsAccessibiliteExterne?: boolean;
  IsAccessibiliteOuvrantDroit?: boolean;
  IsConjointHandicape?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantDirect?: boolean;
  IsEnfantHandicape?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  JourDateReferenceEnfant?: number;
  LibelleRegle?: string;
  ListeCriteresAD?: ArrayOfanyType;
  ListeCriteresOD?: ArrayOfanyType;
  MoisDateReference?: number;
  MoisDateReferenceEnfant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaAccessibiliteTousBeneficiairesInput = {
  AgeEnfantMaximum?: number;
  AgeEnfantMinimum?: number;
  AllowForcage?: boolean;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampEnfant?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAgeEnfant?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibiliteConjoint?: boolean;
  IsAccessibiliteEnfant?: boolean;
  IsAccessibiliteExterne?: boolean;
  IsAccessibiliteOuvrantDroit?: boolean;
  IsConjointHandicape?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantDirect?: boolean;
  IsEnfantHandicape?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  JourDateReferenceEnfant?: number;
  LibelleRegle?: string;
  ListeCriteresAD?: ArrayOfanyTypeInput;
  ListeCriteresOD?: ArrayOfanyTypeInput;
  MoisDateReference?: number;
  MoisDateReferenceEnfant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaBaseInput = {
  IdModeleRegle?: number;
  IdRegle?: number;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleRegleAfpaEnveloppe = {
  __typename?: 'ModeleRegleAFPAEnveloppe';
  AgeEnfantMaximum?: number;
  AgeEnfantMinimum?: number;
  AllowForcage?: boolean;
  AllowSansSubvention?: boolean;
  IdCritereChamp?: number;
  IdModeleRegle?: number;
  IdPeriode?: number;
  IdRegle?: number;
  IdTypeDateReference?: number;
  IsEachOuvrantDroit?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantDirect?: boolean;
  IsEnfantHandicape?: boolean;
  IsMoisEntierUniquement?: boolean;
  IsNominatif?: boolean;
  IsPondereMoisPresence?: boolean;
  IsPondereTempsTravail?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeValeurs?: ArrayOfanyType;
  ListeValeursDefault?: ArrayOfanyType;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteAllOuvrantDroit?: number;
  QuantiteConjoint?: number;
  QuantiteEnfants?: number;
  QuantiteExternes?: number;
  QuantiteOuvrantDroit?: number;
  Status?: StatusDtoEnum;
  ValeurMaximum?: number;
  ValeurMinimum?: number;
};

export type ModeleRegleAfpaEnveloppeAttribution = {
  __typename?: 'ModeleRegleAFPAEnveloppeAttribution';
  CodeEnveloppe?: string;
  DateDebutValiditeEnveloppe?: any;
  DateFinValiditeEnveloppe?: any;
  IdEnveloppe?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IsClotureEnveloppe?: boolean;
  IsComplementaireEnveloppe?: boolean;
  IsNominatif?: boolean;
  IsRegleTransverse?: boolean;
  IsSynchroniseeEnveloppe?: boolean;
  LibelleEnveloppe?: string;
  LibelleRegle?: string;
  ListeAttributionRAN?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarquePubliqueEnveloppe?: string;
  Status?: StatusDtoEnum;
};

export type ModeleRegleAfpaEnveloppeAttributionInput = {
  CodeEnveloppe?: string;
  DateDebutValiditeEnveloppe?: any;
  DateFinValiditeEnveloppe?: any;
  IdEnveloppe?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IsClotureEnveloppe?: boolean;
  IsComplementaireEnveloppe?: boolean;
  IsNominatif?: boolean;
  IsRegleTransverse?: boolean;
  IsSynchroniseeEnveloppe?: boolean;
  LibelleEnveloppe?: string;
  LibelleRegle?: string;
  ListeAttributionRAN?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarquePubliqueEnveloppe?: string;
  Status?: StatusDtoEnum;
};

export type ModeleRegleAfpaEnveloppeBase = {
  __typename?: 'ModeleRegleAFPAEnveloppeBase';
  AgeEnfantMaximum?: number;
  AgeEnfantMinimum?: number;
  AllowForcage?: boolean;
  IdCritereChamp?: number;
  IdModeleRegle?: number;
  IdPeriode?: number;
  IdRegle?: number;
  IdTypeDateReference?: number;
  IsEachOuvrantDroit?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantDirect?: boolean;
  IsEnfantHandicape?: boolean;
  IsMoisEntierUniquement?: boolean;
  IsNominatif?: boolean;
  IsPondereMoisPresence?: boolean;
  IsPondereTempsTravail?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeValeurs?: ArrayOfanyType;
  ListeValeursDefault?: ArrayOfanyType;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteAllOuvrantDroit?: number;
  QuantiteConjoint?: number;
  QuantiteEnfants?: number;
  QuantiteExternes?: number;
  QuantiteOuvrantDroit?: number;
  Status?: StatusDtoEnum;
  ValeurMaximum?: number;
  ValeurMinimum?: number;
};

export type ModeleRegleAfpaEnveloppeBaseInput = {
  AgeEnfantMaximum?: number;
  AgeEnfantMinimum?: number;
  AllowForcage?: boolean;
  IdCritereChamp?: number;
  IdModeleRegle?: number;
  IdPeriode?: number;
  IdRegle?: number;
  IdTypeDateReference?: number;
  IsEachOuvrantDroit?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantDirect?: boolean;
  IsEnfantHandicape?: boolean;
  IsMoisEntierUniquement?: boolean;
  IsNominatif?: boolean;
  IsPondereMoisPresence?: boolean;
  IsPondereTempsTravail?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeValeurs?: ArrayOfanyTypeInput;
  ListeValeursDefault?: ArrayOfanyTypeInput;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteAllOuvrantDroit?: number;
  QuantiteConjoint?: number;
  QuantiteEnfants?: number;
  QuantiteExternes?: number;
  QuantiteOuvrantDroit?: number;
  Status?: StatusDtoEnum;
  ValeurMaximum?: number;
  ValeurMinimum?: number;
};

export type ModeleRegleAfpaEnveloppeInput = {
  AgeEnfantMaximum?: number;
  AgeEnfantMinimum?: number;
  AllowForcage?: boolean;
  AllowSansSubvention?: boolean;
  IdCritereChamp?: number;
  IdModeleRegle?: number;
  IdPeriode?: number;
  IdRegle?: number;
  IdTypeDateReference?: number;
  IsEachOuvrantDroit?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantDirect?: boolean;
  IsEnfantHandicape?: boolean;
  IsMoisEntierUniquement?: boolean;
  IsNominatif?: boolean;
  IsPondereMoisPresence?: boolean;
  IsPondereTempsTravail?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeValeurs?: ArrayOfanyTypeInput;
  ListeValeursDefault?: ArrayOfanyTypeInput;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteAllOuvrantDroit?: number;
  QuantiteConjoint?: number;
  QuantiteEnfants?: number;
  QuantiteExternes?: number;
  QuantiteOuvrantDroit?: number;
  Status?: StatusDtoEnum;
  ValeurMaximum?: number;
  ValeurMinimum?: number;
};

export type ModeleRegleAfpaEnveloppePrestation = {
  __typename?: 'ModeleRegleAFPAEnveloppePrestation';
  AgeEnfantMaximum?: number;
  AgeEnfantMinimum?: number;
  AllowForcage?: boolean;
  IdCritereChamp?: number;
  IdModeleRegle?: number;
  IdPeriode?: number;
  IdRegle?: number;
  IdTypeDateReference?: number;
  IsEachOuvrantDroit?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantDirect?: boolean;
  IsEnfantHandicape?: boolean;
  IsMoisEntierUniquement?: boolean;
  IsNominatif?: boolean;
  IsPondereMoisPresence?: boolean;
  IsPondereTempsTravail?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeValeurs?: ArrayOfanyType;
  ListeValeursDefault?: ArrayOfanyType;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteAllOuvrantDroit?: number;
  QuantiteConjoint?: number;
  QuantiteEnfants?: number;
  QuantiteExternes?: number;
  QuantiteOuvrantDroit?: number;
  Status?: StatusDtoEnum;
  ValeurMaximum?: number;
  ValeurMinimum?: number;
};

export type ModeleRegleAfpaEnveloppePrestationInput = {
  AgeEnfantMaximum?: number;
  AgeEnfantMinimum?: number;
  AllowForcage?: boolean;
  IdCritereChamp?: number;
  IdModeleRegle?: number;
  IdPeriode?: number;
  IdRegle?: number;
  IdTypeDateReference?: number;
  IsEachOuvrantDroit?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantDirect?: boolean;
  IsEnfantHandicape?: boolean;
  IsMoisEntierUniquement?: boolean;
  IsNominatif?: boolean;
  IsPondereMoisPresence?: boolean;
  IsPondereTempsTravail?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeValeurs?: ArrayOfanyTypeInput;
  ListeValeursDefault?: ArrayOfanyTypeInput;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteAllOuvrantDroit?: number;
  QuantiteConjoint?: number;
  QuantiteEnfants?: number;
  QuantiteExternes?: number;
  QuantiteOuvrantDroit?: number;
  Status?: StatusDtoEnum;
  ValeurMaximum?: number;
  ValeurMinimum?: number;
};

export type ModeleRegleAfpaPrestationAccessibiliteConjoint = {
  __typename?: 'ModeleRegleAFPAPrestationAccessibiliteConjoint';
  AllowForcage?: boolean;
  AncienneteFactureMaximum?: number;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibiliteConjoint?: boolean;
  IsAccessibiliteEnfant?: boolean;
  IsAccessibiliteExterne?: boolean;
  IsAccessibiliteOuvrantDroit?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeCriteresOD?: ArrayOfanyType;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaPrestationAccessibiliteConjointInput = {
  AllowForcage?: boolean;
  AncienneteFactureMaximum?: number;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibiliteConjoint?: boolean;
  IsAccessibiliteEnfant?: boolean;
  IsAccessibiliteExterne?: boolean;
  IsAccessibiliteOuvrantDroit?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeCriteresOD?: ArrayOfanyTypeInput;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaPrestationAccessibiliteEnfant = {
  __typename?: 'ModeleRegleAFPAPrestationAccessibiliteEnfant';
  AllowForcage?: boolean;
  AncienneteFactureMaximum?: number;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibiliteConjoint?: boolean;
  IsAccessibiliteEnfant?: boolean;
  IsAccessibiliteExterne?: boolean;
  IsAccessibiliteOuvrantDroit?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeCriteresOD?: ArrayOfanyType;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaPrestationAccessibiliteEnfantInput = {
  AllowForcage?: boolean;
  AncienneteFactureMaximum?: number;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibiliteConjoint?: boolean;
  IsAccessibiliteEnfant?: boolean;
  IsAccessibiliteExterne?: boolean;
  IsAccessibiliteOuvrantDroit?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeCriteresOD?: ArrayOfanyTypeInput;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaPrestationAccessibiliteOdad = {
  __typename?: 'ModeleRegleAFPAPrestationAccessibiliteODAD';
  AllowForcage?: boolean;
  AncienneteFactureMaximum?: number;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibiliteConjoint?: boolean;
  IsAccessibiliteEnfant?: boolean;
  IsAccessibiliteExterne?: boolean;
  IsAccessibiliteOuvrantDroit?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeCriteresOD?: ArrayOfanyType;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaPrestationAccessibiliteOdadInput = {
  AllowForcage?: boolean;
  AncienneteFactureMaximum?: number;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibiliteConjoint?: boolean;
  IsAccessibiliteEnfant?: boolean;
  IsAccessibiliteExterne?: boolean;
  IsAccessibiliteOuvrantDroit?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeCriteresOD?: ArrayOfanyTypeInput;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaPrestationAccessibiliteOuvrantDroit = {
  __typename?: 'ModeleRegleAFPAPrestationAccessibiliteOuvrantDroit';
  AllowForcage?: boolean;
  AncienneteFactureMaximum?: number;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeCriteresOD?: ArrayOfanyType;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaPrestationAccessibiliteOuvrantDroitInput = {
  AllowForcage?: boolean;
  AncienneteFactureMaximum?: number;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  LibelleRegle?: string;
  ListeCriteresOD?: ArrayOfanyTypeInput;
  MoisDateReference?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaPrestationAccessibiliteTousBeneficiaires = {
  __typename?: 'ModeleRegleAFPAPrestationAccessibiliteTousBeneficiaires';
  AgeEnfantMaximum?: number;
  AgeEnfantMinimum?: number;
  AllowForcage?: boolean;
  AncienneteFactureMaximum?: number;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampEnfant?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAgeEnfant?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibiliteConjoint?: boolean;
  IsAccessibiliteEnfant?: boolean;
  IsAccessibiliteExterne?: boolean;
  IsAccessibiliteOuvrantDroit?: boolean;
  IsConjointHandicape?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantDirect?: boolean;
  IsEnfantHandicape?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  JourDateReferenceEnfant?: number;
  LibelleRegle?: string;
  ListeCriteresAD?: ArrayOfanyType;
  ListeCriteresOD?: ArrayOfanyType;
  MoisDateReference?: number;
  MoisDateReferenceEnfant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaPrestationAccessibiliteTousBeneficiairesInput = {
  AgeEnfantMaximum?: number;
  AgeEnfantMinimum?: number;
  AllowForcage?: boolean;
  AncienneteFactureMaximum?: number;
  AncienneteMaximumOD?: number;
  AncienneteMinimumOD?: number;
  IdChampEnfant?: number;
  IdChampOD?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IdTypeDateCalculAgeEnfant?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibiliteConjoint?: boolean;
  IsAccessibiliteEnfant?: boolean;
  IsAccessibiliteExterne?: boolean;
  IsAccessibiliteOuvrantDroit?: boolean;
  IsConjointHandicape?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantDirect?: boolean;
  IsEnfantHandicape?: boolean;
  IsRegleTransverse?: boolean;
  JourDateReference?: number;
  JourDateReferenceEnfant?: number;
  LibelleRegle?: string;
  ListeCriteresAD?: ArrayOfanyTypeInput;
  ListeCriteresOD?: ArrayOfanyTypeInput;
  MoisDateReference?: number;
  MoisDateReferenceEnfant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAccessibiliteOD?: string;
};

export type ModeleRegleAfpaQuota = {
  __typename?: 'ModeleRegleAFPAQuota';
  AgeMaximumEnfants?: number;
  AgeMinimumEnfants?: number;
  AllowForcage?: boolean;
  AllowSansSubvention?: boolean;
  IdModeleRegle?: number;
  IdPeriode?: number;
  IdRegle?: number;
  IsEnfantsACharge?: boolean;
  IsEnfantsDirects?: boolean;
  IsEnfantsHandicapes?: boolean;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
  ListeValeurs?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreMaxArticle?: number;
  Status?: StatusDtoEnum;
  TypeValeur?: string;
};

export type ModeleRegleAfpaQuotaBase = {
  __typename?: 'ModeleRegleAFPAQuotaBase';
  AgeMaximumEnfants?: number;
  AgeMinimumEnfants?: number;
  AllowForcage?: boolean;
  IdModeleRegle?: number;
  IdPeriode?: number;
  IdRegle?: number;
  IsEnfantsACharge?: boolean;
  IsEnfantsDirects?: boolean;
  IsEnfantsHandicapes?: boolean;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
  ListeValeurs?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreMaxArticle?: number;
  Status?: StatusDtoEnum;
};

export type ModeleRegleAfpaQuotaBaseInput = {
  AgeMaximumEnfants?: number;
  AgeMinimumEnfants?: number;
  AllowForcage?: boolean;
  IdModeleRegle?: number;
  IdPeriode?: number;
  IdRegle?: number;
  IsEnfantsACharge?: boolean;
  IsEnfantsDirects?: boolean;
  IsEnfantsHandicapes?: boolean;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
  ListeValeurs?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreMaxArticle?: number;
  Status?: StatusDtoEnum;
};

export type ModeleRegleAfpaQuotaInput = {
  AgeMaximumEnfants?: number;
  AgeMinimumEnfants?: number;
  AllowForcage?: boolean;
  AllowSansSubvention?: boolean;
  IdModeleRegle?: number;
  IdPeriode?: number;
  IdRegle?: number;
  IsEnfantsACharge?: boolean;
  IsEnfantsDirects?: boolean;
  IsEnfantsHandicapes?: boolean;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
  ListeValeurs?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreMaxArticle?: number;
  Status?: StatusDtoEnum;
  TypeValeur?: string;
};

export type ModeleRegleAfpaQuotaPrestation = {
  __typename?: 'ModeleRegleAFPAQuotaPrestation';
  AgeMaximumEnfants?: number;
  AgeMinimumEnfants?: number;
  AllowForcage?: boolean;
  IdModeleRegle?: number;
  IdPeriode?: number;
  IdPeriodeDossier?: number;
  IdRegle?: number;
  IsEnfantsACharge?: boolean;
  IsEnfantsDirects?: boolean;
  IsEnfantsHandicapes?: boolean;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
  ListeValeurs?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreDossierMaximum?: number;
  NombreMaxArticle?: number;
  NombreUniteDossier?: number;
  Status?: StatusDtoEnum;
};

export type ModeleRegleAfpaQuotaPrestationInput = {
  AgeMaximumEnfants?: number;
  AgeMinimumEnfants?: number;
  AllowForcage?: boolean;
  IdModeleRegle?: number;
  IdPeriode?: number;
  IdPeriodeDossier?: number;
  IdRegle?: number;
  IsEnfantsACharge?: boolean;
  IsEnfantsDirects?: boolean;
  IsEnfantsHandicapes?: boolean;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
  ListeValeurs?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreDossierMaximum?: number;
  NombreMaxArticle?: number;
  NombreUniteDossier?: number;
  Status?: StatusDtoEnum;
};

export type ModeleRegleAfpaSubvention = {
  __typename?: 'ModeleRegleAFPASubvention';
  IdChamp?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
  ListeValeurs?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Subvention?: number;
  SubventionDefault?: number;
  TypeValeur?: string;
};

export type ModeleRegleAfpaSubventionBase = {
  __typename?: 'ModeleRegleAFPASubventionBase';
  IdModeleRegle?: number;
  IdRegle?: number;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Subvention?: number;
  TypeValeur?: string;
};

export type ModeleRegleAfpaSubventionBaseInput = {
  IdModeleRegle?: number;
  IdRegle?: number;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Subvention?: number;
  TypeValeur?: string;
};

export type ModeleRegleAfpaSubventionComplementaire = {
  __typename?: 'ModeleRegleAFPASubventionComplementaire';
  IdEnveloppeComplementaire?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Subvention?: number;
  TypeValeur?: string;
};

export type ModeleRegleAfpaSubventionComplementaireInput = {
  IdEnveloppeComplementaire?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Subvention?: number;
  TypeValeur?: string;
};

export type ModeleRegleAfpaSubventionInput = {
  IdChamp?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
  ListeValeurs?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Subvention?: number;
  SubventionDefault?: number;
  TypeValeur?: string;
};

export type ModeleRegleAfpaSubventionRestantACharge = {
  __typename?: 'ModeleRegleAFPASubventionRestantACharge';
  IdChamp?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
  ListeValeurs?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Subvention?: number;
  SubventionDefault?: number;
  TypeValeur?: string;
};

export type ModeleRegleAfpaSubventionRestantAChargeInput = {
  IdChamp?: number;
  IdModeleRegle?: number;
  IdRegle?: number;
  IsRegleTransverse?: boolean;
  LibelleRegle?: string;
  ListeValeurs?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Subvention?: number;
  SubventionDefault?: number;
  TypeValeur?: string;
};

export type ModeleRegleAccChpListValModeGuide = {
  __typename?: 'ModeleRegleAccChpListValModeGuide';
  IdChpListVal?: number;
  IdRegleAccessibilite?: number;
  IsCheckedValeur?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ValeurAncienneteMax?: number;
  ValeurAncienneteMin?: number;
};

export type ModeleRegleAccChpListValModeGuideInput = {
  IdChpListVal?: number;
  IdRegleAccessibilite?: number;
  IsCheckedValeur?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ValeurAncienneteMax?: number;
  ValeurAncienneteMin?: number;
};

export type ModeleRegleAccModelDto = {
  __typename?: 'ModeleRegleAccModelDTO';
  AgeEnfantMax?: number;
  AgeEnfantMin?: number;
  AncienneteFactureMax?: number;
  DateRefJour?: number;
  DateRefJourAgeEnf?: number;
  DateRefMois?: number;
  DateRefMoisAgeEnf?: number;
  Id?: number;
  IdChamp?: number;
  IdChampAD?: number;
  IdTypeDateRefAge?: number;
  IdtypeRefAnc?: number;
  IsConjointHandicape?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantDirect?: boolean;
  IsEnfantHandicape?: boolean;
  IsForcageAutorise?: boolean;
  IsNominative?: boolean;
  ListeIdChampAD?: ArrayOfdecimal;
  ListeIdTypeBenef?: ArrayOfdecimal;
  ListeModeleRegleAccListeModele?: ArrayOfRegleAccListeValModelDto;
  ModeAccess?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RgModAccesAnMax?: number;
  RgModAccesAnMin?: number;
  Status?: StatusDtoEnum;
};

export type ModeleRegleAccModelDtoInput = {
  AgeEnfantMax?: number;
  AgeEnfantMin?: number;
  AncienneteFactureMax?: number;
  DateRefJour?: number;
  DateRefJourAgeEnf?: number;
  DateRefMois?: number;
  DateRefMoisAgeEnf?: number;
  Id?: number;
  IdChamp?: number;
  IdChampAD?: number;
  IdTypeDateRefAge?: number;
  IdtypeRefAnc?: number;
  IsConjointHandicape?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantDirect?: boolean;
  IsEnfantHandicape?: boolean;
  IsForcageAutorise?: boolean;
  IsNominative?: boolean;
  ListeIdChampAD?: ArrayOfdecimalInput;
  ListeIdTypeBenef?: ArrayOfdecimalInput;
  ListeModeleRegleAccListeModele?: ArrayOfRegleAccListeValModelDtoInput;
  ModeAccess?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RgModAccesAnMax?: number;
  RgModAccesAnMin?: number;
  Status?: StatusDtoEnum;
};

export type ModeleRegleAccessibiliteBaseInput = {
  IdChampOuvrantDroit?: number;
  IdModeleRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibleSelonCritere?: boolean;
  IsAccessibleTousOuvrantsDroit?: boolean;
  IsForcageAutorise?: boolean;
  JourDateFixe?: number;
  ListeValeursCritere?: ArrayOfanyTypeInput;
  ModeCalculAccessibilite?: string;
  MoisDateFixe?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbMoisAncienneteMax?: number;
  NbMoisAncienneteMin?: number;
  Status?: StatusDtoEnum;
};

export type ModeleRegleAccessibiliteChpListValInput = {
  IdChpListVal?: number;
  IdRegleAccessibilite?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ValeurAncienneteMax?: number;
  ValeurAncienneteMin?: number;
};

export type ModeleRegleAccessibiliteEpargnesInput = {
  IdChampOuvrantDroit?: number;
  IdModeleRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibleSelonCritere?: boolean;
  IsAccessibleTousOuvrantsDroit?: boolean;
  IsForcageAutorise?: boolean;
  JourDateFixe?: number;
  ListeValeursCritere?: ArrayOfanyTypeInput;
  ModeCalculAccessibilite?: string;
  MoisDateFixe?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbMoisAncienneteMax?: number;
  NbMoisAncienneteMin?: number;
  NombreMoisAvantFinContrat?: number;
  Status?: StatusDtoEnum;
};

export type ModeleRegleAccessibiliteMediathequeInput = {
  IdChampOuvrantDroit?: number;
  IdModeleRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibleSelonCritere?: boolean;
  IsAccessibleTousOuvrantsDroit?: boolean;
  IsForcageAutorise?: boolean;
  JourDateFixe?: number;
  ListeValeursCritere?: ArrayOfanyTypeInput;
  ModeCalculAccessibilite?: string;
  MoisDateFixe?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbMoisAncienneteMax?: number;
  NbMoisAncienneteMin?: number;
  NombreJoursAvantFinContrat?: number;
  NombreJoursDeRetardSurEmpruntEnCours?: number;
  Status?: StatusDtoEnum;
};

export type ModeleRegleAccessibilitePretsEtDonsInput = {
  IdChampOuvrantDroit?: number;
  IdModeleRegle?: number;
  IdTypeDateCalculAnciennete?: number;
  IsAccessibleSelonCritere?: boolean;
  IsAccessibleTousOuvrantsDroit?: boolean;
  IsForcageAutorise?: boolean;
  JourDateFixe?: number;
  ListeValeursCritere?: ArrayOfanyTypeInput;
  ModeCalculAccessibilite?: string;
  MoisDateFixe?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NbMoisAncienneteMax?: number;
  NbMoisAncienneteMin?: number;
  NombreMoisAvantFinContrat?: number;
  Status?: StatusDtoEnum;
};

export type ModeleRegleQuotaMediathequeInput = {
  IdModeleRegle?: number;
  IsForcageAutorise?: boolean;
  IsVenteSansSubvention?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreAutresMediasNouveaute?: number;
  NombreAutresMediasTotal?: number;
  NombreCDNouveaute?: number;
  NombreCDTotal?: number;
  NombreDVDNouveaute?: number;
  NombreDVDTotal?: number;
  NombreLivresNouveaute?: number;
  NombreLivresTotal?: number;
  NombreLogicielsNouveaute?: number;
  NombreLogicielsTotal?: number;
  NombreMediasNouveaute?: number;
  NombreMediasTotal?: number;
  OrdreModeleRegle?: number;
  Status?: StatusDtoEnum;
  TypeModeleRegle?: string;
  TypeValeurModeleRegle?: string;
};

export type ModeleRegleQuotaPretsEtDonsInput = {
  IdChpListValMontantPeriodeMaximunPretsOuDonsAccodes?: number;
  IdChpListValNombrePeriodeMaximunPretsOuDonsAccodes?: number;
  IdModeleRegle?: number;
  IsForcageAutorise?: boolean;
  IsVenteSansSubvention?: boolean;
  MontantMaximunPretsOuDonsAccodes?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreMaximunDemandesAttente?: number;
  NombreMaximunPretsOuDonsAccodes?: number;
  NombreMaximunPretsSimultanes?: number;
  OrdreModeleRegle?: number;
  Status?: StatusDtoEnum;
  TypeModeleRegle?: string;
  TypeValeurModeleRegle?: string;
};

export type ModeleRegleQuotaRessourcesPartageesInput = {
  IdModeleRegle?: number;
  IsForcageAutorise?: boolean;
  IsVenteSansSubvention?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreEmpruntNouveaute?: number;
  NombreEmpruntTotal?: number;
  NombreResaAttenteNouveaute?: number;
  NombreResaAttenteTotal?: number;
  NombreResaValideNouveaute?: number;
  NombreResaValideTotal?: number;
  OrdreModeleRegle?: number;
  Status?: StatusDtoEnum;
  TypeModeleRegle?: string;
  TypeValeurModeleRegle?: string;
};

export type ModeleRegleSubQuotaBaseInput = {
  IdModeleRegle?: number;
  IsForcageAutorise?: boolean;
  IsVenteSansSubvention?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  OrdreModeleRegle?: number;
  Status?: StatusDtoEnum;
  TypeModeleRegle?: string;
  TypeValeurModeleRegle?: string;
};

export type ModeleRegleSubQuotaDto = {
  __typename?: 'ModeleRegleSubQuotaDTO';
  ActiviteQuota?: ActiviteDto;
  ActiviteSub?: ActiviteDto;
  ArticleQuota?: ArticleDto;
  ArticleSub?: ArticleDto;
  Champ?: ChampDto;
  DateRefPondJour?: number;
  DateRefPondMois?: number;
  FamilleProduitQuota?: FamilleProduitDto;
  FamilleProduitSub?: FamilleProduitDto;
  Id?: number;
  IsForcageAutorise?: boolean;
  IsNominatif?: boolean;
  IsPondererMoisEntier?: boolean;
  IsPondererMoisPresence?: boolean;
  IsPondererTempsTravail?: boolean;
  IsSansSubventionAudelaLimite?: boolean;
  ListeModeleRegleSubQuotaValCritere?: ArrayOfModeleRegleSubQuotaValCritereDto;
  MoteurRegle?: MoteurRegleDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NbCommandeMax?: number;
  NbUniteParCommandeMax?: number;
  PeriodeNbDossier?: ChampListeValeurDto;
  ProduitQuota?: ProduitDto;
  ProduitSub?: ProduitDto;
  RgModSQTypeVal?: string;
  RglModeleIdAgeEnfMax?: number;
  RglModeleIdAgeEnfMin?: number;
  RglModeleIdEnfAch?: boolean;
  RglModeleIdEnfDir?: boolean;
  RglModeleIdEnfHan?: boolean;
  RglModeleSQMontant?: number;
  RglModeleSQTypeRegle?: string;
  Status?: StatusDtoEnum;
  TypeDateRefPond?: MoteurRegleTypeDateRefDto;
  ValeurSubParDefaut?: number;
};

export type ModeleRegleSubQuotaDtoInput = {
  ActiviteQuota?: ActiviteDtoInput;
  ActiviteSub?: ActiviteDtoInput;
  ArticleQuota?: ArticleDtoInput;
  ArticleSub?: ArticleDtoInput;
  Champ?: ChampDtoInput;
  DateRefPondJour?: number;
  DateRefPondMois?: number;
  FamilleProduitQuota?: FamilleProduitDtoInput;
  FamilleProduitSub?: FamilleProduitDtoInput;
  Id?: number;
  IsForcageAutorise?: boolean;
  IsNominatif?: boolean;
  IsPondererMoisEntier?: boolean;
  IsPondererMoisPresence?: boolean;
  IsPondererTempsTravail?: boolean;
  IsSansSubventionAudelaLimite?: boolean;
  ListeModeleRegleSubQuotaValCritere?: ArrayOfModeleRegleSubQuotaValCritereDtoInput;
  MoteurRegle?: MoteurRegleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbCommandeMax?: number;
  NbUniteParCommandeMax?: number;
  PeriodeNbDossier?: ChampListeValeurDtoInput;
  ProduitQuota?: ProduitDtoInput;
  ProduitSub?: ProduitDtoInput;
  RgModSQTypeVal?: string;
  RglModeleIdAgeEnfMax?: number;
  RglModeleIdAgeEnfMin?: number;
  RglModeleIdEnfAch?: boolean;
  RglModeleIdEnfDir?: boolean;
  RglModeleIdEnfHan?: boolean;
  RglModeleSQMontant?: number;
  RglModeleSQTypeRegle?: string;
  Status?: StatusDtoEnum;
  TypeDateRefPond?: MoteurRegleTypeDateRefDtoInput;
  ValeurSubParDefaut?: number;
};

export type ModeleRegleSubQuotaModeleDto = {
  __typename?: 'ModeleRegleSubQuotaModeleDTO';
  DateRefPondJour?: number;
  DateRefPondMois?: number;
  Id?: number;
  IdChamp?: number;
  IdPeriodeNbDossier?: number;
  IdTypeDateRefPond?: number;
  IsForcageAutorise?: boolean;
  IsNominatif?: boolean;
  IsPondererMoisEntier?: boolean;
  IsPondererMoisPresence?: boolean;
  IsPondererTempsTravail?: boolean;
  IsPourChaqueOD?: boolean;
  IsSansSubventionAudelaLimite?: boolean;
  ListeModeleRegleSubQuotaValModele?: ArrayOfRegleSubQuotaListeValModelDto;
  ModeSimple?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NbCommandeMax?: number;
  NbUniteParCommandeMax?: number;
  RgModSQTypeVal?: string;
  RglModeleIdAgeEnfMax?: number;
  RglModeleIdAgeEnfMin?: number;
  RglModeleIdEnfAch?: boolean;
  RglModeleIdEnfDir?: boolean;
  RglModeleIdEnfHan?: boolean;
  RglModeleSQMontant?: number;
  RglModeleSQTypeRegle?: string;
  Status?: StatusDtoEnum;
  ValeurSubParDefaut?: number;
};

export type ModeleRegleSubQuotaModeleDtoInput = {
  DateRefPondJour?: number;
  DateRefPondMois?: number;
  Id?: number;
  IdChamp?: number;
  IdPeriodeNbDossier?: number;
  IdTypeDateRefPond?: number;
  IsForcageAutorise?: boolean;
  IsNominatif?: boolean;
  IsPondererMoisEntier?: boolean;
  IsPondererMoisPresence?: boolean;
  IsPondererTempsTravail?: boolean;
  IsPourChaqueOD?: boolean;
  IsSansSubventionAudelaLimite?: boolean;
  ListeModeleRegleSubQuotaValModele?: ArrayOfRegleSubQuotaListeValModelDtoInput;
  ModeSimple?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NbCommandeMax?: number;
  NbUniteParCommandeMax?: number;
  RgModSQTypeVal?: string;
  RglModeleIdAgeEnfMax?: number;
  RglModeleIdAgeEnfMin?: number;
  RglModeleIdEnfAch?: boolean;
  RglModeleIdEnfDir?: boolean;
  RglModeleIdEnfHan?: boolean;
  RglModeleSQMontant?: number;
  RglModeleSQTypeRegle?: string;
  Status?: StatusDtoEnum;
  ValeurSubParDefaut?: number;
};

export type ModeleRegleSubQuotaValCritereDto = {
  __typename?: 'ModeleRegleSubQuotaValCritereDTO';
  Borne?: BorneDto;
  ChampListeVal?: ChampListeValeurDto;
  Id?: number;
  ModeleRegleSubQuota?: ModeleRegleSubQuotaDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeBenef?: TypeBenefDto;
  TypeVal?: string;
  ValMax?: number;
  ValMin?: number;
  ValMontant?: number;
};

export type ModeleRegleSubQuotaValCritereDtoInput = {
  Borne?: BorneDtoInput;
  ChampListeVal?: ChampListeValeurDtoInput;
  Id?: number;
  ModeleRegleSubQuota?: ModeleRegleSubQuotaDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeBenef?: TypeBenefDtoInput;
  TypeVal?: string;
  ValMax?: number;
  ValMin?: number;
  ValMontant?: number;
};

export type ModeleRetourExportAncvCesuDto = {
  __typename?: 'ModeleRetourExportAncvCesuDTO';
  FileBytes?: string;
  FluxCSV?: string;
  NomFichierAffiche?: string;
  NomFichierCsv?: string;
  TokenFile?: string;
};

export type ModeleRetourExportAncvCesuDtoInput = {
  FileBytes?: string;
  FluxCSV?: string;
  NomFichierAffiche?: string;
  NomFichierCsv?: string;
  TokenFile?: string;
};

export type ModeleSaisieEcritureEcritureModeleSaisieEcritureModelDto = {
  __typename?: 'ModeleSaisieEcritureEcritureModeleSaisieEcritureModelDTO';
  Id?: number;
  IdBenef?: number;
  IdFournisseur?: number;
  IdJournal?: number;
  IdModeleSaisieEcriture?: number;
  IdMoyenPaiement?: number;
  Libelle?: string;
  LibelleDate?: string;
  LibelleReference?: string;
  ListeClesRepartitions?: ArrayOfCleRepartitionModelDto;
  ListeMouvementModeleSaisieEcriture?: ArrayOfModeleSaisieEcritureMouvementModeleSaisieEcritureModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleSaisieEcritureEcritureModeleSaisieEcritureModelDtoInput = {
  Id?: number;
  IdBenef?: number;
  IdFournisseur?: number;
  IdJournal?: number;
  IdModeleSaisieEcriture?: number;
  IdMoyenPaiement?: number;
  Libelle?: string;
  LibelleDate?: string;
  LibelleReference?: string;
  ListeClesRepartitions?: ArrayOfCleRepartitionModelDtoInput;
  ListeMouvementModeleSaisieEcriture?: ArrayOfModeleSaisieEcritureMouvementModeleSaisieEcritureModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleSaisieEcritureInitModelForUcModeleSaisieEcritureDto = {
  __typename?: 'ModeleSaisieEcritureInitModelForUCModeleSaisieEcritureDTO';
  ListeJournaux?: ArrayOfComptaJournalModel;
  ListeMoyenPaiement?: ArrayOfComptaMoyenPaiementModelDto;
};

export type ModeleSaisieEcritureInitModelForUcModeleSaisieEcritureDtoInput = {
  ListeJournaux?: ArrayOfComptaJournalModelInput;
  ListeMoyenPaiement?: ArrayOfComptaMoyenPaiementModelDtoInput;
};

export type ModeleSaisieEcritureModeleSaisieEcritureModelDto = {
  __typename?: 'ModeleSaisieEcritureModeleSaisieEcritureModelDTO';
  Code?: string;
  Id?: number;
  IdCe?: number;
  IsCloture?: boolean;
  IsDelegGlobale?: boolean;
  Libelle?: string;
  ListeEcritureModeleSaisieEcriture?: ArrayOfModeleSaisieEcritureEcritureModeleSaisieEcritureModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleSaisieEcritureModeleSaisieEcritureModelDtoInput = {
  Code?: string;
  Id?: number;
  IdCe?: number;
  IsCloture?: boolean;
  IsDelegGlobale?: boolean;
  Libelle?: string;
  ListeEcritureModeleSaisieEcriture?: ArrayOfModeleSaisieEcritureEcritureModeleSaisieEcritureModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleSaisieEcritureMouvementModeleSaisieEcritureModelDto = {
  __typename?: 'ModeleSaisieEcritureMouvementModeleSaisieEcritureModelDTO';
  Compte?: ComptaCompteModelDto;
  Id?: number;
  IdCompte?: number;
  IdEcritureModeleSaisieEcriture?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Sens?: string;
  Status?: StatusDtoEnum;
};

export type ModeleSaisieEcritureMouvementModeleSaisieEcritureModelDtoInput = {
  Compte?: ComptaCompteModelDtoInput;
  Id?: number;
  IdCompte?: number;
  IdEcritureModeleSaisieEcriture?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Sens?: string;
  Status?: StatusDtoEnum;
};

export type ModeleSaisieLibreCompteAnaSecDto = {
  __typename?: 'ModeleSaisieLibreCompteAnaSecDTO';
  ModeleSaisieLibre?: ModeleSaisieLibreDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueDto;
  Pourcentage?: number;
  SectionAnalytique?: SectionAnalytiqueDto;
  Status?: StatusDtoEnum;
};

export type ModeleSaisieLibreCompteAnaSecDtoInput = {
  ModeleSaisieLibre?: ModeleSaisieLibreDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueDtoInput;
  Pourcentage?: number;
  SectionAnalytique?: SectionAnalytiqueDtoInput;
  Status?: StatusDtoEnum;
};

export type ModeleSaisieLibreDto = {
  __typename?: 'ModeleSaisieLibreDTO';
  Activite?: ActiviteDto;
  CEDelegation?: CeDelegationDto;
  Code?: string;
  CompteAchat?: CompteDto;
  CompteVente?: CompteDto;
  Description?: string;
  Id?: number;
  IsCloture?: boolean;
  Libelle?: string;
  ListeSectionAnalytiqueParPlan?: ArrayOfModeleSaisieLibreCompteAnaSecDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Picto?: string;
  PrixAchat?: number;
  PrixVente?: number;
  Quotite?: number;
  Reference?: string;
  Status?: StatusDtoEnum;
};

export type ModeleSaisieLibreDtoInput = {
  Activite?: ActiviteDtoInput;
  CEDelegation?: CeDelegationDtoInput;
  Code?: string;
  CompteAchat?: CompteDtoInput;
  CompteVente?: CompteDtoInput;
  Description?: string;
  Id?: number;
  IsCloture?: boolean;
  Libelle?: string;
  ListeSectionAnalytiqueParPlan?: ArrayOfModeleSaisieLibreCompteAnaSecDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Picto?: string;
  PrixAchat?: number;
  PrixVente?: number;
  Quotite?: number;
  Reference?: string;
  Status?: StatusDtoEnum;
};

export type ModeleSaisieSectionAnaParPlanModelDtoInput = {
  ListeClesRepartition?: ArrayOfCleRepartitionModelDtoInput;
  ModeleSaisieLibre?: ModeleSaisieLibreDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleSauvegardeAfpadtoInput = {
  ListeModeleEcheancierLinked?: ArrayOfModeleEcheancierFpaModelInput;
  ListeMoyenPaiementLinked?: ArrayOfMoyenPaiementFpaModelInput;
  ModeleAffichageRegle?: ModeleAffichageRegleDtoInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  ModeleFraisAnnulationFPA?: FraisAnnulationFpaModelInput;
  ModeleSaveActivite?: SaveActiviteModelDtoInput;
  ModeleSaveArticle?: SaveArticleModelDtoInput;
  ModeleSaveFamille?: SaveFamilleModelDtoInput;
  ModeleSaveProduit?: SaveProduitModelDtoInput;
  ModeleSaveReglesAFPA?: ModeleSaveReglesAfpadtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleSaveReglesAfpadto = {
  __typename?: 'ModeleSaveReglesAFPADTO';
  IdDelegation?: number;
  IdElement?: number;
  IdParent?: number;
  ListeRegles?: ArrayOfanyType;
  ModeleDeploiementRegles?: any;
  ModeleRegleAccChplistval?: ArrayOfanyType;
  ModeleRegleAccessibilite?: any;
  ModeleRegleQuota?: any;
  ModeleRegleSubQuota?: any;
  ModeleRegleSubvention?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeElement?: TypeAfpaEnum;
};

export type ModeleSaveReglesAfpadtoInput = {
  IdDelegation?: number;
  IdElement?: number;
  IdParent?: number;
  ListeRegles?: ArrayOfanyTypeInput;
  ModeleDeploiementRegles?: any;
  ModeleRegleAccChplistval?: ArrayOfanyTypeInput;
  ModeleRegleAccessibilite?: any;
  ModeleRegleQuota?: any;
  ModeleRegleSubQuota?: any;
  ModeleRegleSubvention?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeElement?: TypeAfpaEnum;
};

export type ModeleSupAnnRemBonRetourCommandeDtoInput = {
  DateAnnulationCommande?: any;
  FraisAnnulation?: number;
  IdActivite?: number;
  IdCptImputationFrais?: number;
  IdExercice?: number;
  IdJournal?: number;
  IdProduitGroupe?: number;
  IsAnnulationRemboursementAvecConnaissanceKitBancaire?: boolean;
  IsAnnulerCdeFour?: boolean;
  IsAnnulerRembourserCdeClient?: boolean;
  IsAnnulerRembourserCdeLocGrp?: boolean;
  IsCommandeFournisseurHaveAcompteRapproche?: boolean;
  IsCommandeSurFactureAvoirise?: boolean;
  IsRetourCdeClient?: boolean;
  IsSuppressionCdeClient?: boolean;
  IsSuppressionCdeFour?: boolean;
  IsTVAActivee?: boolean;
  ListIdLigne?: ArrayOfdecimalInput;
  ListeCleRepartitionFraisAnnulation?: ArrayOfCleRepartitionModelDtoInput;
  ListeIdCommande?: ArrayOfdecimalInput;
  MontantAvoiriser?: number;
  NumeroPiece?: string;
  RemarquePrive?: string;
  RemarquePublic?: string;
};

export type ModeleSuppressionAcompteDto = {
  __typename?: 'ModeleSuppressionAcompteDTO';
  CanDeleteAcompte?: boolean;
  DateEcriture?: any;
  IdEcriture?: number;
  IdFacture?: number;
  NumeroFacture?: string;
  NumeroPiece?: string;
};

export type ModeleSuppressionAcompteDtoInput = {
  CanDeleteAcompte?: boolean;
  DateEcriture?: any;
  IdEcriture?: number;
  IdFacture?: number;
  NumeroFacture?: string;
  NumeroPiece?: string;
};

export type ModeleTvafpaModel = {
  __typename?: 'ModeleTVAFPAModel';
  IdModeleTVA?: number;
  LibCptTVACollectee?: string;
  LibCptTVADeductible?: string;
  LibelleModele?: string;
  ListeIdCptAssocies?: ArrayOfdecimal;
  MustValidate?: boolean;
  MyGuid?: string;
  NumCptTVACollectee?: string;
  NumCptTVADeductible?: string;
  Status?: StatusDtoEnum;
  Taux?: number;
};

export type ModeleTvafpaModelInput = {
  IdModeleTVA?: number;
  LibCptTVACollectee?: string;
  LibCptTVADeductible?: string;
  LibelleModele?: string;
  ListeIdCptAssocies?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NumCptTVACollectee?: string;
  NumCptTVADeductible?: string;
  Status?: StatusDtoEnum;
  Taux?: number;
};

export type ModeleTvaLightModel = {
  __typename?: 'ModeleTVALightModel';
  IdModeleTVA?: number;
  LibelleModeleTVA?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleTvaLightModelInput = {
  IdModeleTVA?: number;
  LibelleModeleTVA?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModeleVerificationSupAnnRemBonRetourCde = {
  __typename?: 'ModeleVerificationSupAnnRemBonRetourCde';
  CodeStatutFacture?: string;
  DateAnnulation?: any;
  DateCommande?: any;
  DateMinimumAnnulation?: any;
  FraisAnnulation?: number;
  IdCommandeDossierPresta?: number;
  IdCptImputationFrais?: number;
  IdDossierPretsEtDons?: number;
  IsAnnulerCdeFour?: boolean;
  IsAnnulerRembourserCdeClient?: boolean;
  IsAnnulerRembourserCdeLocGrp?: boolean;
  IsCommandeActiviteTVA?: boolean;
  IsCommandeSaisieLibre?: boolean;
  IsCommandeSurFactureAvoirise?: boolean;
  IsDernierefact?: boolean;
  IsExisteBLBRL?: boolean;
  IsExisteMvtCompensationArtReappro?: string;
  IsPret?: boolean;
  IsRetourCdeClient?: boolean;
  IsSubVentionAccorde?: boolean;
  IsSuppressionAvoirClient?: boolean;
  IsSuppressionCdeClient?: boolean;
  IsSuppressionCdeFour?: boolean;
  LibelleActivite?: string;
  LibelleProduit?: string;
  ListeAcomptesLies?: ArrayOfModeleSuppressionAcompteDto;
  ListeCleRepartitionFraisAnnulation?: ArrayOfCleRepartitionModelDto;
  ListeDetailEcrituresPretsEtDons?: ArrayOfDetailEcrituresAnnulationDossierPretsEtDonsModelDto;
  ListeIdCommande?: ArrayOfdecimal;
  ListeIdLigneReapproEnvoyeCdeFour?: string;
  ListeLigneCommande?: ArrayOfLigneDevisModeleDto;
  ListeNumFatcure?: ArrayOfstring;
  ListeTransactionInfo?: ArrayOfEcritureTransactionBancairePoco;
  Matricule?: string;
  MessageErreur?: string;
  MontantAcomptesLies?: number;
  MontantAvoiriser?: number;
  MontantCde?: number;
  MontantFactPaye?: number;
  MontantLgeCdeTotal?: number;
  MontantRestantARegler?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomPrenomBenef?: string;
  NumCommande?: string;
  SoldeFacture?: number;
  Status?: StatusDtoEnum;
};

export type ModeleVerificationSupAnnRemBonRetourCdeInput = {
  CodeStatutFacture?: string;
  DateAnnulation?: any;
  DateCommande?: any;
  DateMinimumAnnulation?: any;
  FraisAnnulation?: number;
  IdCommandeDossierPresta?: number;
  IdCptImputationFrais?: number;
  IdDossierPretsEtDons?: number;
  IsAnnulerCdeFour?: boolean;
  IsAnnulerRembourserCdeClient?: boolean;
  IsAnnulerRembourserCdeLocGrp?: boolean;
  IsCommandeActiviteTVA?: boolean;
  IsCommandeSaisieLibre?: boolean;
  IsCommandeSurFactureAvoirise?: boolean;
  IsDernierefact?: boolean;
  IsExisteBLBRL?: boolean;
  IsExisteMvtCompensationArtReappro?: string;
  IsPret?: boolean;
  IsRetourCdeClient?: boolean;
  IsSubVentionAccorde?: boolean;
  IsSuppressionAvoirClient?: boolean;
  IsSuppressionCdeClient?: boolean;
  IsSuppressionCdeFour?: boolean;
  LibelleActivite?: string;
  LibelleProduit?: string;
  ListeAcomptesLies?: ArrayOfModeleSuppressionAcompteDtoInput;
  ListeCleRepartitionFraisAnnulation?: ArrayOfCleRepartitionModelDtoInput;
  ListeDetailEcrituresPretsEtDons?: ArrayOfDetailEcrituresAnnulationDossierPretsEtDonsModelDtoInput;
  ListeIdCommande?: ArrayOfdecimalInput;
  ListeIdLigneReapproEnvoyeCdeFour?: string;
  ListeLigneCommande?: ArrayOfLigneDevisModeleDtoInput;
  ListeNumFatcure?: ArrayOfstringInput;
  ListeTransactionInfo?: ArrayOfEcritureTransactionBancairePocoInput;
  Matricule?: string;
  MessageErreur?: string;
  MontantAcomptesLies?: number;
  MontantAvoiriser?: number;
  MontantCde?: number;
  MontantFactPaye?: number;
  MontantLgeCdeTotal?: number;
  MontantRestantARegler?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomPrenomBenef?: string;
  NumCommande?: string;
  SoldeFacture?: number;
  Status?: StatusDtoEnum;
};

export type ModelesCourrierPublipostageModel = {
  __typename?: 'ModelesCourrierPublipostageModel';
  Corps?: string;
  IdModeleAdresse?: number;
  Introduction?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Objet?: string;
  SignatureCE?: string;
  Status?: StatusDtoEnum;
  VoirCoordonneeCE?: boolean;
  VoirLogoCE?: boolean;
  VoirLogoSignature?: boolean;
};

export type ModelesCourrierPublipostageModelInput = {
  Corps?: string;
  IdModeleAdresse?: number;
  Introduction?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Objet?: string;
  SignatureCE?: string;
  Status?: StatusDtoEnum;
  VoirCoordonneeCE?: boolean;
  VoirLogoCE?: boolean;
  VoirLogoSignature?: boolean;
};

export type ModelesInitParamModelesPublipostageModel = {
  __typename?: 'ModelesInitParamModelesPublipostageModel';
  ListePubliType?: ArrayOfPubliTypeCourrierPossibleModel;
  ListeTypeActivite?: ArrayOfTypeActiviteWithListeActiviteModel;
};

export type ModelesInitParamModelesPublipostageModelInput = {
  ListePubliType?: ArrayOfPubliTypeCourrierPossibleModelInput;
  ListeTypeActivite?: ArrayOfTypeActiviteWithListeActiviteModelInput;
};

export type ModelesModelEmailPieceJointeModel = {
  __typename?: 'ModelesModelEmailPieceJointeModel';
  CorpsModelEmail?: string;
  DestinataireModelEmail?: string;
  EmetteurModelEmail?: string;
  IdModelEmail?: number;
  IdModeleNewsLetter?: number;
  IsIdentifiants?: boolean;
  IsNewsLetter?: boolean;
  IsPubliPostage?: boolean;
  LibelleModelEmail?: string;
  ListeIdReportJoint?: ArrayOfdecimal;
  ListeIdTheme?: ArrayOfdecimal;
  ListePJ?: ArrayOfFichierModel;
  MustValidate?: boolean;
  MyGuid?: string;
  ObjectModelEmail?: string;
  Status?: StatusDtoEnum;
};

export type ModelesModelEmailPieceJointeModelInput = {
  CorpsModelEmail?: string;
  DestinataireModelEmail?: string;
  EmetteurModelEmail?: string;
  IdModelEmail?: number;
  IdModeleNewsLetter?: number;
  IsIdentifiants?: boolean;
  IsNewsLetter?: boolean;
  IsPubliPostage?: boolean;
  LibelleModelEmail?: string;
  ListeIdReportJoint?: ArrayOfdecimalInput;
  ListeIdTheme?: ArrayOfdecimalInput;
  ListePJ?: ArrayOfFichierModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  ObjectModelEmail?: string;
  Status?: StatusDtoEnum;
};

export type ModelesModelEmailPublipostageModel = {
  __typename?: 'ModelesModelEmailPublipostageModel';
  CodeElement?: string;
  IdElement?: number;
  IdTypePublipostage?: number;
  IsCloture?: boolean;
  IsSupprimable?: boolean;
  LibelleElement?: string;
  ListeIdTypeActivite?: ArrayOfdecimal;
  ModeleMail?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModelesModelEmailPublipostageModelInput = {
  CodeElement?: string;
  IdElement?: number;
  IdTypePublipostage?: number;
  IsCloture?: boolean;
  IsSupprimable?: boolean;
  LibelleElement?: string;
  ListeIdTypeActivite?: ArrayOfdecimalInput;
  ModeleMail?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModelesModeleCourrierPublipostageModel = {
  __typename?: 'ModelesModeleCourrierPublipostageModel';
  CodeElement?: string;
  IdElement?: number;
  IdTypePublipostage?: number;
  IsCloture?: boolean;
  LibelleElement?: string;
  ListeIdTypeActivite?: ArrayOfdecimal;
  ModeleCourrier?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModelesModeleCourrierPublipostageModelInput = {
  CodeElement?: string;
  IdElement?: number;
  IdTypePublipostage?: number;
  IsCloture?: boolean;
  LibelleElement?: string;
  ListeIdTypeActivite?: ArrayOfdecimalInput;
  ModeleCourrier?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModelesModeleEcheancierArticlesModel = {
  __typename?: 'ModelesModeleEcheancierArticlesModel';
  IdModeleEcheancier?: number;
  IsClos?: boolean;
  Libelle?: string;
  ListeArticlesRattaches?: ArrayOfdecimal;
};

export type ModelesModeleEcheancierArticlesModelInput = {
  IdModeleEcheancier?: number;
  IsClos?: boolean;
  Libelle?: string;
  ListeArticlesRattaches?: ArrayOfdecimalInput;
};

export type ModificationRibMandatModel = {
  __typename?: 'ModificationRibMandatModel';
  ListeMouvementImpactes?: ArrayOfMouvementComptableModificationRibMandatModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModificationRibMandatModelInput = {
  ListeMouvementImpactes?: ArrayOfMouvementComptableModificationRibMandatModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModuleInfoDto = {
  __typename?: 'ModuleInfoDTO';
  Code?: string;
  Id?: number;
  IsModuleV2?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type ModuleInfoDtoInput = {
  Code?: string;
  Id?: number;
  IsModuleV2?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type ModulesMonoModelDto = {
  __typename?: 'ModulesMonoModelDTO';
  IsCommissions?: boolean;
  IsMonoCaisse?: boolean;
  IsMonoDeleg?: boolean;
  IsMonoPV?: boolean;
  IsMonoStock?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ModulesMonoModelDtoInput = {
  IsCommissions?: boolean;
  IsMonoCaisse?: boolean;
  IsMonoDeleg?: boolean;
  IsMonoPV?: boolean;
  IsMonoStock?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoleculeRegleAvanceeModelDto = {
  __typename?: 'MoleculeRegleAvanceeModelDTO';
  CalculValeur?: CalculRegleAvanceeModelDto;
  Critere?: CritereRegleAvanceeModelDto;
  IdChamp?: number;
  IdOperateur?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeValeur?: TypesValeursEnum;
  Valeur?: string;
};

export type MoleculeRegleAvanceeModelDtoInput = {
  CalculValeur?: CalculRegleAvanceeModelDtoInput;
  Critere?: CritereRegleAvanceeModelDtoInput;
  IdChamp?: number;
  IdOperateur?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeValeur?: TypesValeursEnum;
  Valeur?: string;
};

export type MontantDossierEpargneModel = {
  __typename?: 'MontantDossierEpargneModel';
  DateDernierPrelevement?: any;
  MontantAbondement?: number;
  MontantDisponible?: number;
  MontantDossierAbondement?: number;
  MontantDossierEpargne?: number;
  MontantEpargne?: number;
  MontantRegleBeneficiaire?: number;
  TotalDejaAbonde?: number;
  TotalDejaEpargne?: number;
};

export type MontantDossierEpargneModelInput = {
  DateDernierPrelevement?: any;
  MontantAbondement?: number;
  MontantDisponible?: number;
  MontantDossierAbondement?: number;
  MontantDossierEpargne?: number;
  MontantEpargne?: number;
  MontantRegleBeneficiaire?: number;
  TotalDejaAbonde?: number;
  TotalDejaEpargne?: number;
};

export type MontantDossierPretsEtDonsModel = {
  __typename?: 'MontantDossierPretsEtDonsModel';
  DatePremiereEcheance?: any;
  DureePret?: number;
  FraisDossier?: number;
  IsDossierPretsEtDonsSolde?: boolean;
  IsFraisDossierMensuel?: boolean;
  IsSoldeParReglementAnticipeOuDon?: boolean;
  MontantDejaRembourse?: number;
  MontantDonAuBenef?: number;
  MontantPret?: number;
  MontantRemisEnBanque?: number;
  MontantSur512?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StatutDossier?: string;
};

export type MontantDossierPretsEtDonsModelInput = {
  DatePremiereEcheance?: any;
  DureePret?: number;
  FraisDossier?: number;
  IsDossierPretsEtDonsSolde?: boolean;
  IsFraisDossierMensuel?: boolean;
  IsSoldeParReglementAnticipeOuDon?: boolean;
  MontantDejaRembourse?: number;
  MontantDonAuBenef?: number;
  MontantPret?: number;
  MontantRemisEnBanque?: number;
  MontantSur512?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StatutDossier?: string;
};

export type MoteurAppelDtoInput = {
  DateActivite?: any;
  DateOperation?: any;
  DateValeur?: any;
  IdAnneeReference?: number;
  IdArticle?: number;
  IdBeneficiaireCible?: number;
  IdBeneficiaireOuvrantDroit?: number;
  IdCommande?: number;
  IdEvenementURSSAF?: number;
  IdExercice?: number;
  IdFournisseur?: number;
  IdLigneCommande?: number;
  IdRegleMoteur?: number;
  ListeIdParticipant?: ArrayOfdecimalInput;
  ListeSubventionAccorde?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreArticle?: number;
  NombreArticleReserve?: number;
  NombreArticleReserveAttente?: number;
  PrixArticle?: number;
  QuotiteArticle?: number;
  Status?: StatusDtoEnum;
  ValeurFacialeArticle?: number;
};

export type MoteurCalculDto = {
  __typename?: 'MoteurCalculDTO';
  CalculParent?: MoteurCalculDto;
  Critere?: MoteurCritereDto;
  Id?: number;
  IsGroupe?: boolean;
  Libelle?: string;
  ListeCalculsEnfants?: ArrayOfMoteurCalculDto;
  ListeMotParamCrit?: ArrayOfMoteurParamCritereDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Operateur?: MoteurOperateurDto;
  Ordre?: number;
  Status?: StatusDtoEnum;
  ValeurNumerique?: number;
};

export type MoteurCalculDtoInput = {
  CalculParent?: MoteurCalculDtoInput;
  Critere?: MoteurCritereDtoInput;
  Id?: number;
  IsGroupe?: boolean;
  Libelle?: string;
  ListeCalculsEnfants?: ArrayOfMoteurCalculDtoInput;
  ListeMotParamCrit?: ArrayOfMoteurParamCritereDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Operateur?: MoteurOperateurDtoInput;
  Ordre?: number;
  Status?: StatusDtoEnum;
  ValeurNumerique?: number;
};

export type MoteurCritereDto = {
  __typename?: 'MoteurCritereDTO';
  Champ?: ChampDto;
  Code?: string;
  Id?: number;
  IsCritere?: boolean;
  IsRegleAccessibilite?: boolean;
  IsRegleEnveloppe?: boolean;
  IsRegleQuotaNombre?: boolean;
  IsRegleQuotaValeurFaciale?: boolean;
  IsRegleSubvention?: boolean;
  Libelle?: string;
  LibelleVariableMoteur?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OrdreSQL?: string;
  OrdreSqlParam?: string;
  RegleCalcul?: MoteurCalculDto;
  Status?: StatusDtoEnum;
  TypeCritere?: string;
  TypeDonnee?: ChampTypeDonneeDto;
};

export type MoteurCritereDtoInput = {
  Champ?: ChampDtoInput;
  Code?: string;
  Id?: number;
  IsCritere?: boolean;
  IsRegleAccessibilite?: boolean;
  IsRegleEnveloppe?: boolean;
  IsRegleQuotaNombre?: boolean;
  IsRegleQuotaValeurFaciale?: boolean;
  IsRegleSubvention?: boolean;
  Libelle?: string;
  LibelleVariableMoteur?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OrdreSQL?: string;
  OrdreSqlParam?: string;
  RegleCalcul?: MoteurCalculDtoInput;
  Status?: StatusDtoEnum;
  TypeCritere?: string;
  TypeDonnee?: ChampTypeDonneeDtoInput;
};

export type MoteurOperateurDto = {
  __typename?: 'MoteurOperateurDTO';
  Id?: number;
  Libelle?: string;
  ListeCriteres?: ArrayOfMoteurParamCritereDto;
  ListeRegles?: ArrayOfMoteurRegleDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeOperateur?: string;
  Valeur?: string;
};

export type MoteurOperateurDtoInput = {
  Id?: number;
  Libelle?: string;
  ListeCriteres?: ArrayOfMoteurParamCritereDtoInput;
  ListeRegles?: ArrayOfMoteurRegleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeOperateur?: string;
  Valeur?: string;
};

export type MoteurParamCritereDto = {
  __typename?: 'MoteurParamCritereDTO';
  Calcul?: MoteurCalculDto;
  ChampListeValeur?: ChampListeValeurDto;
  Critere?: MoteurCritereDto;
  Id?: number;
  MoteurOperateur?: MoteurOperateurDto;
  MoteurRegle?: MoteurRegleDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type MoteurParamCritereDtoInput = {
  Calcul?: MoteurCalculDtoInput;
  ChampListeValeur?: ChampListeValeurDtoInput;
  Critere?: MoteurCritereDtoInput;
  Id?: number;
  MoteurOperateur?: MoteurOperateurDtoInput;
  MoteurRegle?: MoteurRegleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type MoteurRegleDto = {
  __typename?: 'MoteurRegleDTO';
  CEDelegation?: CeDelegationDto;
  DateReference?: any;
  Enveloppe?: EnveloppeQuotaDto;
  Id?: number;
  IsBudget?: boolean;
  IsCloture?: boolean;
  IsComplementaire?: boolean;
  IsForcageAutorise?: boolean;
  IsGroupe?: boolean;
  IsPondererMoisEntier?: boolean;
  IsPondererMoisPresence?: boolean;
  IsPondererTempsTravail?: boolean;
  IsRegleAFaireHerite?: boolean;
  IsSansSubventionAudelaLimite?: boolean;
  IsSubChoisie?: boolean;
  IsTransverse?: boolean;
  JourDateFixe?: number;
  Libelle?: string;
  ListeMotParamCritere?: ArrayOfMoteurParamCritereDto;
  ListeMoteurRegleHeriatgeActivite?: ArrayOfMoteurRegleHeritageActiviteDto;
  ListeMoteurRegleHeritageFamille?: ArrayOfMoteurRegleHeritageFamilleDto;
  ListeMoteurRegleHeritageProduit?: ArrayOfMoteurRegleHeritageProduitDto;
  ListeMoteurRegleUseActivite?: ArrayOfMoteurRegleUseActiviteDto;
  ListeMoteurRegleUseArticle?: ArrayOfMoteurRegleUseArticleDto;
  ListeMoteurRegleUseFamille?: ArrayOfMoteurRegleUseFamilleDto;
  ListeMoteurRegleUseProduit?: ArrayOfMoteurRegleUseProduitDto;
  ListeReglesEnfants?: ArrayOfMoteurRegleDto;
  ModeleRegleSubQuota?: ModeleRegleSubQuotaDto;
  MoisDateFixe?: number;
  MoteurCritere?: MoteurCritereDto;
  MoteurOperateur?: MoteurOperateurDto;
  MoteurRegleType?: MoteurRegleTypeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NeSAppliquePasA?: MoteurRegleDto;
  OperateurDeGroupeOLD?: string;
  RegleCalculCritereValeur?: MoteurCalculDto;
  RegleCalculSubvention?: MoteurCalculDto;
  RegleCalculSubventionDefaut?: MoteurCalculDto;
  RegleModeleAcces?: RegleModeleAccesDto;
  RegleParent?: MoteurRegleDto;
  RegleParentHerite?: MoteurRegleDto;
  SAppliqueA?: MoteurRegleDto;
  Status?: StatusDtoEnum;
  TypeDateRef?: MoteurRegleTypeDateRefDto;
  TypeValeurLimite?: string;
  ValeurCritere?: string;
  ValeurListe?: ChampListeValeurDto;
  ValeurSubvention?: number;
};

export type MoteurRegleDtoInput = {
  CEDelegation?: CeDelegationDtoInput;
  DateReference?: any;
  Enveloppe?: EnveloppeQuotaDtoInput;
  Id?: number;
  IsBudget?: boolean;
  IsCloture?: boolean;
  IsComplementaire?: boolean;
  IsForcageAutorise?: boolean;
  IsGroupe?: boolean;
  IsPondererMoisEntier?: boolean;
  IsPondererMoisPresence?: boolean;
  IsPondererTempsTravail?: boolean;
  IsRegleAFaireHerite?: boolean;
  IsSansSubventionAudelaLimite?: boolean;
  IsSubChoisie?: boolean;
  IsTransverse?: boolean;
  JourDateFixe?: number;
  Libelle?: string;
  ListeMotParamCritere?: ArrayOfMoteurParamCritereDtoInput;
  ListeMoteurRegleHeriatgeActivite?: ArrayOfMoteurRegleHeritageActiviteDtoInput;
  ListeMoteurRegleHeritageFamille?: ArrayOfMoteurRegleHeritageFamilleDtoInput;
  ListeMoteurRegleHeritageProduit?: ArrayOfMoteurRegleHeritageProduitDtoInput;
  ListeMoteurRegleUseActivite?: ArrayOfMoteurRegleUseActiviteDtoInput;
  ListeMoteurRegleUseArticle?: ArrayOfMoteurRegleUseArticleDtoInput;
  ListeMoteurRegleUseFamille?: ArrayOfMoteurRegleUseFamilleDtoInput;
  ListeMoteurRegleUseProduit?: ArrayOfMoteurRegleUseProduitDtoInput;
  ListeReglesEnfants?: ArrayOfMoteurRegleDtoInput;
  ModeleRegleSubQuota?: ModeleRegleSubQuotaDtoInput;
  MoisDateFixe?: number;
  MoteurCritere?: MoteurCritereDtoInput;
  MoteurOperateur?: MoteurOperateurDtoInput;
  MoteurRegleType?: MoteurRegleTypeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NeSAppliquePasA?: MoteurRegleDtoInput;
  OperateurDeGroupeOLD?: string;
  RegleCalculCritereValeur?: MoteurCalculDtoInput;
  RegleCalculSubvention?: MoteurCalculDtoInput;
  RegleCalculSubventionDefaut?: MoteurCalculDtoInput;
  RegleModeleAcces?: RegleModeleAccesDtoInput;
  RegleParent?: MoteurRegleDtoInput;
  RegleParentHerite?: MoteurRegleDtoInput;
  SAppliqueA?: MoteurRegleDtoInput;
  Status?: StatusDtoEnum;
  TypeDateRef?: MoteurRegleTypeDateRefDtoInput;
  TypeValeurLimite?: string;
  ValeurCritere?: string;
  ValeurListe?: ChampListeValeurDtoInput;
  ValeurSubvention?: number;
};

export type MoteurRegleHeritageActiviteDto = {
  __typename?: 'MoteurRegleHeritageActiviteDTO';
  Activite?: ActiviteDto;
  MoteurRegle?: MoteurRegleDto;
  MoteurRegleHeritageType?: MoteurRegleHeritageTypeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoteurRegleHeritageActiviteDtoInput = {
  Activite?: ActiviteDtoInput;
  MoteurRegle?: MoteurRegleDtoInput;
  MoteurRegleHeritageType?: MoteurRegleHeritageTypeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoteurRegleHeritageFamilleDto = {
  __typename?: 'MoteurRegleHeritageFamilleDTO';
  Famille?: FamilleProduitDto;
  MoteurRegle?: MoteurRegleDto;
  MoteurRegleHeritageType?: MoteurRegleHeritageTypeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoteurRegleHeritageFamilleDtoInput = {
  Famille?: FamilleProduitDtoInput;
  MoteurRegle?: MoteurRegleDtoInput;
  MoteurRegleHeritageType?: MoteurRegleHeritageTypeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoteurRegleHeritageProduitDto = {
  __typename?: 'MoteurRegleHeritageProduitDTO';
  MoteurRegle?: MoteurRegleDto;
  MoteurRegleHeritageType?: MoteurRegleHeritageTypeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Produit?: ProduitDto;
  Status?: StatusDtoEnum;
};

export type MoteurRegleHeritageProduitDtoInput = {
  MoteurRegle?: MoteurRegleDtoInput;
  MoteurRegleHeritageType?: MoteurRegleHeritageTypeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Produit?: ProduitDtoInput;
  Status?: StatusDtoEnum;
};

export type MoteurRegleHeritageTypeDto = {
  __typename?: 'MoteurRegleHeritageTypeDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoteurRegleHeritageTypeDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoteurRegleModelDto = {
  __typename?: 'MoteurRegleModelDTO';
  CodeHeritage?: string;
  EnveloppeModele?: ModeleEnveloppeDto;
  Id?: number;
  IdCE?: number;
  IdEnveloppe?: number;
  IdModeleRegleAcc?: number;
  IdModeleRegleSubQta?: number;
  IdRegleHerite?: number;
  IdTypeArrondi?: number;
  IsCloture?: boolean;
  IsComplementaire?: boolean;
  IsForcageAutorise?: boolean;
  IsModifiableRegle?: boolean;
  IsRegleAfaireHerite?: boolean;
  IsRegleAvancee?: boolean;
  IsRegleNiveauUn?: boolean;
  IsRegleUse?: boolean;
  IsRglBudget?: boolean;
  IsSansSubventionAudelaLimite?: boolean;
  IsSubChoisie?: boolean;
  IsTransverse?: boolean;
  LibelleRegle?: string;
  ListeIdRglUseAct?: ArrayOfdecimal;
  ListeIdRglUseArt?: ArrayOfdecimal;
  ListeIdRglUseFam?: ArrayOfdecimal;
  ListeIdRglUsePrd?: ArrayOfdecimal;
  ListeIdRgleHerAct?: ArrayOfdecimal;
  ListeIdRgleHerFam?: ArrayOfdecimal;
  ListeIdRgleHerPrd?: ArrayOfdecimal;
  ModeleRegleAcc?: ModeleRegleAccModelDto;
  ModeleRegleSubQta?: ModeleRegleSubQuotaModeleDto;
  MustValidate?: boolean;
  MyGuid?: string;
  RegleAvancee?: RegleAvanceeModelDto;
  Status?: StatusDtoEnum;
  TypeRegle?: string;
  TypeValeurLimite?: string;
};

export type MoteurRegleModelDtoInput = {
  CodeHeritage?: string;
  EnveloppeModele?: ModeleEnveloppeDtoInput;
  Id?: number;
  IdCE?: number;
  IdEnveloppe?: number;
  IdModeleRegleAcc?: number;
  IdModeleRegleSubQta?: number;
  IdRegleHerite?: number;
  IdTypeArrondi?: number;
  IsCloture?: boolean;
  IsComplementaire?: boolean;
  IsForcageAutorise?: boolean;
  IsModifiableRegle?: boolean;
  IsRegleAfaireHerite?: boolean;
  IsRegleAvancee?: boolean;
  IsRegleNiveauUn?: boolean;
  IsRegleUse?: boolean;
  IsRglBudget?: boolean;
  IsSansSubventionAudelaLimite?: boolean;
  IsSubChoisie?: boolean;
  IsTransverse?: boolean;
  LibelleRegle?: string;
  ListeIdRglUseAct?: ArrayOfdecimalInput;
  ListeIdRglUseArt?: ArrayOfdecimalInput;
  ListeIdRglUseFam?: ArrayOfdecimalInput;
  ListeIdRglUsePrd?: ArrayOfdecimalInput;
  ListeIdRgleHerAct?: ArrayOfdecimalInput;
  ListeIdRgleHerFam?: ArrayOfdecimalInput;
  ListeIdRgleHerPrd?: ArrayOfdecimalInput;
  ModeleRegleAcc?: ModeleRegleAccModelDtoInput;
  ModeleRegleSubQta?: ModeleRegleSubQuotaModeleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RegleAvancee?: RegleAvanceeModelDtoInput;
  Status?: StatusDtoEnum;
  TypeRegle?: string;
  TypeValeurLimite?: string;
};

export type MoteurRegleTypeDto = {
  __typename?: 'MoteurRegleTypeDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoteurRegleTypeDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoteurRegleTypeDateRefDto = {
  __typename?: 'MoteurRegleTypeDateRefDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoteurRegleTypeDateRefDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoteurRegleUseActiviteDto = {
  __typename?: 'MoteurRegleUseActiviteDTO';
  Activite?: ActiviteDto;
  MoteurRegle?: MoteurRegleDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoteurRegleUseActiviteDtoInput = {
  Activite?: ActiviteDtoInput;
  MoteurRegle?: MoteurRegleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoteurRegleUseArticleDto = {
  __typename?: 'MoteurRegleUseArticleDTO';
  Article?: ArticleDto;
  MoteurRegle?: MoteurRegleDto;
  MustValidate?: boolean;
  MyGuid?: string;
  RGLUART_IDCHER?: boolean;
  Status?: StatusDtoEnum;
};

export type MoteurRegleUseArticleDtoInput = {
  Article?: ArticleDtoInput;
  MoteurRegle?: MoteurRegleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RGLUART_IDCHER?: boolean;
  Status?: StatusDtoEnum;
};

export type MoteurRegleUseFamilleDto = {
  __typename?: 'MoteurRegleUseFamilleDTO';
  Famille?: FamilleProduitDto;
  MoteurRegle?: MoteurRegleDto;
  MustValidate?: boolean;
  MyGuid?: string;
  RGLUPRDFAM_IDCHER?: boolean;
  Status?: StatusDtoEnum;
};

export type MoteurRegleUseFamilleDtoInput = {
  Famille?: FamilleProduitDtoInput;
  MoteurRegle?: MoteurRegleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RGLUPRDFAM_IDCHER?: boolean;
  Status?: StatusDtoEnum;
};

export type MoteurRegleUseProduitDto = {
  __typename?: 'MoteurRegleUseProduitDTO';
  MoteurRegle?: MoteurRegleDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Produit?: ProduitDto;
  RGLUPRD_IDCHER?: boolean;
  Status?: StatusDtoEnum;
};

export type MoteurRegleUseProduitDtoInput = {
  MoteurRegle?: MoteurRegleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Produit?: ProduitDtoInput;
  RGLUPRD_IDCHER?: boolean;
  Status?: StatusDtoEnum;
};

export type MoteurTraitementRetourMoteurModelDto = {
  __typename?: 'MoteurTraitementRetourMoteurModelDTO';
  AnneeReferenceRmbMensuel?: number;
  CodeModeLivraison?: string;
  DateDebutActivite?: any;
  DateDocument?: any;
  DateFinActivite?: any;
  Formulaire?: any;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdUtilisateur?: number;
  IsAccepte?: boolean;
  LibelleLignecommande?: string;
  ListeClesRepartition?: ArrayOfSectionAnalytiqueLigneCommandeModelDto;
  ListeIdParticipants?: ArrayOfdecimal;
  ListeSubventionsAccordees?: ArrayOfanyType;
  MoisReferenceRmbMensuel?: number;
  Montant?: number;
  MontantFacturePresente?: number;
  MontantFacturePrisEnCompte?: number;
  MontantRembourse?: number;
  Quantite?: number;
  QuantitePresente?: number;
  QuantitePrisEnCompte?: number;
  ReferenceFacture?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  TypeDocumentPresente?: string;
};

export type MoteurTraitementRetourMoteurModelDtoInput = {
  AnneeReferenceRmbMensuel?: number;
  CodeModeLivraison?: string;
  DateDebutActivite?: any;
  DateDocument?: any;
  DateFinActivite?: any;
  Formulaire?: any;
  IdArticle?: number;
  IdBenef?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdUtilisateur?: number;
  IsAccepte?: boolean;
  LibelleLignecommande?: string;
  ListeClesRepartition?: ArrayOfSectionAnalytiqueLigneCommandeModelDtoInput;
  ListeIdParticipants?: ArrayOfdecimalInput;
  ListeSubventionsAccordees?: ArrayOfanyTypeInput;
  MoisReferenceRmbMensuel?: number;
  Montant?: number;
  MontantFacturePresente?: number;
  MontantFacturePrisEnCompte?: number;
  MontantRembourse?: number;
  Quantite?: number;
  QuantitePresente?: number;
  QuantitePrisEnCompte?: number;
  ReferenceFacture?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  TypeDocumentPresente?: string;
};

export type MouvementAnalytiqueDto = {
  __typename?: 'MouvementAnalytiqueDTO';
  Montant?: number;
  MouvementComptable?: MouvementComptableDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueDto;
  SectionAnalytique?: SectionAnalytiqueDto;
  Status?: StatusDtoEnum;
};

export type MouvementAnalytiqueDtoInput = {
  Montant?: number;
  MouvementComptable?: MouvementComptableDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueDtoInput;
  SectionAnalytique?: SectionAnalytiqueDtoInput;
  Status?: StatusDtoEnum;
};

export type MouvementAnalytiqueEnErreurModel = {
  __typename?: 'MouvementAnalytiqueEnErreurModel';
  CodeJournalEcriture?: string;
  DateEcriture?: any;
  IdDelegation?: number;
  IdEcriture?: number;
  IdMouvement?: number;
  IsEnDefaut?: boolean;
  IsExerciceClos?: boolean;
  IsRepartitionManquante?: boolean;
  LibelleCompte?: string;
  LibelleEcriture?: string;
  LibelleMouvement?: string;
  MontantMouvement?: number;
  MontantRepartition?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomDelegation?: string;
  NombreLignesVentilees?: number;
  NombrePlansVentiles?: number;
  NumeroCompte?: string;
  NumeroPiece?: string;
  SensMouvement?: string;
  Status?: StatusDtoEnum;
};

export type MouvementAnalytiqueEnErreurModelInput = {
  CodeJournalEcriture?: string;
  DateEcriture?: any;
  IdDelegation?: number;
  IdEcriture?: number;
  IdMouvement?: number;
  IsEnDefaut?: boolean;
  IsExerciceClos?: boolean;
  IsRepartitionManquante?: boolean;
  LibelleCompte?: string;
  LibelleEcriture?: string;
  LibelleMouvement?: string;
  MontantMouvement?: number;
  MontantRepartition?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomDelegation?: string;
  NombreLignesVentilees?: number;
  NombrePlansVentiles?: number;
  NumeroCompte?: string;
  NumeroPiece?: string;
  SensMouvement?: string;
  Status?: StatusDtoEnum;
};

export type MouvementAnalytiqueModelDto = {
  __typename?: 'MouvementAnalytiqueModelDTO';
  DateEcriture?: any;
  IsSimulee?: boolean;
  Journal?: string;
  LibelleEcriture?: string;
  LibelleSectionAnalytique?: string;
  MontantCredit?: number;
  MontantDebit?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumPiece?: string;
  NumRef?: string;
  Status?: StatusDtoEnum;
};

export type MouvementAnalytiqueModelDtoInput = {
  DateEcriture?: any;
  IsSimulee?: boolean;
  Journal?: string;
  LibelleEcriture?: string;
  LibelleSectionAnalytique?: string;
  MontantCredit?: number;
  MontantDebit?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumPiece?: string;
  NumRef?: string;
  Status?: StatusDtoEnum;
};

export type MouvementCollectifSansTiersModel = {
  __typename?: 'MouvementCollectifSansTiersModel';
  IdCompte?: number;
  IdDelegation?: number;
  IsExerciceClos?: boolean;
  LibelleCompte?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbMouvements?: number;
  NbMouvementsClotures?: number;
  NomDelegation?: string;
  NumeroCompte?: string;
  SoldeNet?: number;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
};

export type MouvementCollectifSansTiersModelInput = {
  IdCompte?: number;
  IdDelegation?: number;
  IsExerciceClos?: boolean;
  LibelleCompte?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbMouvements?: number;
  NbMouvementsClotures?: number;
  NomDelegation?: string;
  NumeroCompte?: string;
  SoldeNet?: number;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
};

export type MouvementComptableCleRepartitionModelDtoInput = {
  ListeClesRepartition?: ArrayOfCleRepartitionModelDtoInput;
  Mouvement?: MouvementComptableDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MouvementComptableDto = {
  __typename?: 'MouvementComptableDTO';
  Compte?: CompteDto;
  CompteEcriture?: CompteEcritureDto;
  CompteTiers?: CompteDto;
  DateEcheance?: any;
  Id?: number;
  IdTiers?: number;
  IsAccompte?: boolean;
  IsArrete?: boolean;
  IsCaution?: boolean;
  IsContrePasse?: boolean;
  IsCredit?: boolean;
  IsDebit?: boolean;
  IsNePasEncaisser?: boolean;
  IsPaiementRecu?: boolean;
  IsRapproche?: boolean;
  IsRemisBanque?: boolean;
  IsRendu?: boolean;
  IsSupprime?: boolean;
  Lettre?: string;
  Libelle?: string;
  ListeCaisseArrete?: ArrayOfCaisseArreteDto;
  ListeCleRepartition?: ArrayOfCleRepartitionModelDto;
  ListeLigneRemiseBanque?: ArrayOfBanqueLigneRemiseDto;
  ListeMouvementAnalytique?: ArrayOfMouvementAnalytiqueDto;
  Montant?: number;
  MotifSEPA?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanqueCheque?: string;
  NomTire?: string;
  NumeroCheque?: string;
  NumeroReference?: string;
  Remarque?: string;
  Rib?: RibDto;
  RibMandat?: RibMandatDto;
  Status?: StatusDtoEnum;
};

export type MouvementComptableDtoInput = {
  Compte?: CompteDtoInput;
  CompteEcriture?: CompteEcritureDtoInput;
  CompteTiers?: CompteDtoInput;
  DateEcheance?: any;
  Id?: number;
  IdTiers?: number;
  IsAccompte?: boolean;
  IsArrete?: boolean;
  IsCaution?: boolean;
  IsContrePasse?: boolean;
  IsCredit?: boolean;
  IsDebit?: boolean;
  IsNePasEncaisser?: boolean;
  IsPaiementRecu?: boolean;
  IsRapproche?: boolean;
  IsRemisBanque?: boolean;
  IsRendu?: boolean;
  IsSupprime?: boolean;
  Lettre?: string;
  Libelle?: string;
  ListeCaisseArrete?: ArrayOfCaisseArreteDtoInput;
  ListeCleRepartition?: ArrayOfCleRepartitionModelDtoInput;
  ListeLigneRemiseBanque?: ArrayOfBanqueLigneRemiseDtoInput;
  ListeMouvementAnalytique?: ArrayOfMouvementAnalytiqueDtoInput;
  Montant?: number;
  MotifSEPA?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanqueCheque?: string;
  NomTire?: string;
  NumeroCheque?: string;
  NumeroReference?: string;
  Remarque?: string;
  Rib?: RibDtoInput;
  RibMandat?: RibMandatDtoInput;
  Status?: StatusDtoEnum;
};

export type MouvementComptableInfosGeneralesModel = {
  __typename?: 'MouvementComptableInfosGeneralesModel';
  DateMouvement?: any;
  IdMouvement?: number;
  LibelleMouvement?: string;
  Montant?: number;
  NomBeneficiaire?: string;
  NumeroReference?: string;
  SensMouvement?: string;
};

export type MouvementComptableInfosGeneralesModelInput = {
  DateMouvement?: any;
  IdMouvement?: number;
  LibelleMouvement?: string;
  Montant?: number;
  NomBeneficiaire?: string;
  NumeroReference?: string;
  SensMouvement?: string;
};

export type MouvementComptableModificationRibMandatModel = {
  __typename?: 'MouvementComptableModificationRibMandatModel';
  DateEcriture?: any;
  IdMouvement?: number;
  LibelleMouvement?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroPiece?: string;
  Reference?: string;
  SensMouvement?: string;
  Status?: StatusDtoEnum;
};

export type MouvementComptableModificationRibMandatModelInput = {
  DateEcriture?: any;
  IdMouvement?: number;
  LibelleMouvement?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroPiece?: string;
  Reference?: string;
  SensMouvement?: string;
  Status?: StatusDtoEnum;
};

export type MouvementComptableRemiseBanqueModele = {
  __typename?: 'MouvementComptableRemiseBanqueModele';
  DateRemise?: any;
  IdLigneRemiseBanque?: number;
  IdMouvement?: number;
  IdRemiseBanque?: number;
  IdUtilisateur?: number;
  LibelleMouvement?: string;
  NomUtilisateur?: string;
  NumeroBordereau?: string;
  PrenomUtilisateur?: string;
};

export type MouvementComptableRemiseBanqueModeleInput = {
  DateRemise?: any;
  IdLigneRemiseBanque?: number;
  IdMouvement?: number;
  IdRemiseBanque?: number;
  IdUtilisateur?: number;
  LibelleMouvement?: string;
  NomUtilisateur?: string;
  NumeroBordereau?: string;
  PrenomUtilisateur?: string;
};

export type MouvementConsoPointHistoriqueModel = {
  __typename?: 'MouvementConsoPointHistoriqueModel';
  CodeCompteur?: string;
  DateMvt?: any;
  IdBenef?: number;
  IdCompteur?: number;
  IdMouvementConso?: number;
  Libelle?: string;
  LibelleCompteur?: string;
  MatriculeBenef?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbPts?: number;
  NomBenef?: string;
  PrenomBenef?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Sens?: string;
  Status?: StatusDtoEnum;
};

export type MouvementConsoPointHistoriqueModelInput = {
  CodeCompteur?: string;
  DateMvt?: any;
  IdBenef?: number;
  IdCompteur?: number;
  IdMouvementConso?: number;
  Libelle?: string;
  LibelleCompteur?: string;
  MatriculeBenef?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbPts?: number;
  NomBenef?: string;
  PrenomBenef?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Sens?: string;
  Status?: StatusDtoEnum;
};

export type MouvementReglementModel = {
  __typename?: 'MouvementReglementModel';
  Caisse?: string;
  DateMouvement?: any;
  IdCompte?: number;
  IdCompteTiers?: number;
  IdEcriture?: number;
  IdMouvement?: number;
  IsPaiementCheque?: boolean;
  Journal?: string;
  LibelleMouvement?: string;
  ListeDateRemiseBanque?: ArrayOfdateTime;
  ListeNumeroRemiseBanque?: ArrayOfstring;
  Montant?: number;
  MoyenPaiement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  NomPrenomUser?: string;
  NomTire?: string;
  NumeroCheque?: string;
  Piece?: string;
  Remarque?: string;
  SensMouvement?: string;
  Status?: StatusDtoEnum;
  TitreCheque?: string;
};

export type MouvementReglementModelInput = {
  Caisse?: string;
  DateMouvement?: any;
  IdCompte?: number;
  IdCompteTiers?: number;
  IdEcriture?: number;
  IdMouvement?: number;
  IsPaiementCheque?: boolean;
  Journal?: string;
  LibelleMouvement?: string;
  ListeDateRemiseBanque?: ArrayOfdateTimeInput;
  ListeNumeroRemiseBanque?: ArrayOfstringInput;
  Montant?: number;
  MoyenPaiement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  NomPrenomUser?: string;
  NomTire?: string;
  NumeroCheque?: string;
  Piece?: string;
  Remarque?: string;
  SensMouvement?: string;
  Status?: StatusDtoEnum;
  TitreCheque?: string;
};

export type MouvementSansTiersDetailModel = {
  __typename?: 'MouvementSansTiersDetailModel';
  CodeJournal?: string;
  DateEcriture?: any;
  IdCompteTiersProbable?: number;
  IdEcriture?: number;
  IdMouvement?: number;
  IsExerciceClos?: boolean;
  LibelleCompte?: string;
  LibelleMouvement?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBeneficiaireProbable?: string;
  NumeroCompte?: string;
  NumeroPiece?: string;
  OrigineSuggestion?: string;
  Sens?: string;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
};

export type MouvementSansTiersDetailModelInput = {
  CodeJournal?: string;
  DateEcriture?: any;
  IdCompteTiersProbable?: number;
  IdEcriture?: number;
  IdMouvement?: number;
  IsExerciceClos?: boolean;
  LibelleCompte?: string;
  LibelleMouvement?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBeneficiaireProbable?: string;
  NumeroCompte?: string;
  NumeroPiece?: string;
  OrigineSuggestion?: string;
  Sens?: string;
  Status?: StatusDtoEnum;
  TypeBudget?: string;
};

export type MouvementStockDto = {
  __typename?: 'MouvementStockDTO';
  Article?: ArticleDto;
  CompteEcriture?: CompteEcritureDto;
  DateMouvement?: any;
  DatePourReappro?: any;
  HistoStatut?: HistoStatutCommandeDto;
  Id?: number;
  IsInventorie?: boolean;
  LigneBLBR?: LigneBlBrDto;
  LigneCommande?: LigneCommandeDto;
  LigneInventaire?: LigneInventaireDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Nature?: NatureMouvementStockDto;
  Quantite?: number;
  Remarque?: string;
  Status?: StatusDtoEnum;
  StkMvtReappro?: MouvementStockDto;
  Stock?: StockDto;
  TypeES?: string;
  User?: UsersDto;
};

export type MouvementStockDtoInput = {
  Article?: ArticleDtoInput;
  CompteEcriture?: CompteEcritureDtoInput;
  DateMouvement?: any;
  DatePourReappro?: any;
  HistoStatut?: HistoStatutCommandeDtoInput;
  Id?: number;
  IsInventorie?: boolean;
  LigneBLBR?: LigneBlBrDtoInput;
  LigneCommande?: LigneCommandeDtoInput;
  LigneInventaire?: LigneInventaireDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Nature?: NatureMouvementStockDtoInput;
  Quantite?: number;
  Remarque?: string;
  Status?: StatusDtoEnum;
  StkMvtReappro?: MouvementStockDtoInput;
  Stock?: StockDtoInput;
  TypeES?: string;
  User?: UsersDtoInput;
};

export type MouvementStockModelDto = {
  __typename?: 'MouvementStockModelDTO';
  CodeLibelleStock?: string;
  DateMouvement?: any;
  IdActivite?: number;
  IdArticle?: number;
  IdBenef?: number;
  IdCession?: number;
  IdCommande?: number;
  IdFamille?: number;
  IdFour?: number;
  IdInventaire?: number;
  IdMouvementStock?: number;
  IdProduit?: number;
  IdStock?: number;
  IsArticleCloture?: boolean;
  IsProduitCloture?: boolean;
  LibelleActivite?: string;
  LibelleCessionStock?: string;
  LibelleCommande?: string;
  LibelleFamille?: string;
  LibelleInventaire?: string;
  LibelleNaureMouvementStock?: string;
  LibelleProdArticle?: string;
  LibelleProduit?: string;
  LibelleTypeES?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBenefOrFour?: string;
  NomUser?: string;
  PrenomUser?: string;
  PrixAchat?: number;
  Quantite?: number;
  Remarque?: string;
  Status?: StatusDtoEnum;
  TypeES?: string;
};

export type MouvementStockModelDtoInput = {
  CodeLibelleStock?: string;
  DateMouvement?: any;
  IdActivite?: number;
  IdArticle?: number;
  IdBenef?: number;
  IdCession?: number;
  IdCommande?: number;
  IdFamille?: number;
  IdFour?: number;
  IdInventaire?: number;
  IdMouvementStock?: number;
  IdProduit?: number;
  IdStock?: number;
  IsArticleCloture?: boolean;
  IsProduitCloture?: boolean;
  LibelleActivite?: string;
  LibelleCessionStock?: string;
  LibelleCommande?: string;
  LibelleFamille?: string;
  LibelleInventaire?: string;
  LibelleNaureMouvementStock?: string;
  LibelleProdArticle?: string;
  LibelleProduit?: string;
  LibelleTypeES?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBenefOrFour?: string;
  NomUser?: string;
  PrenomUser?: string;
  PrixAchat?: number;
  Quantite?: number;
  Remarque?: string;
  Status?: StatusDtoEnum;
  TypeES?: string;
};

export type MouvementsGenerationMouvementAnalytiqueModelInput = {
  IdCompte?: number;
  IdEcriture?: number;
  IdMouvement?: number;
  Libelle?: string;
  ListeRepartitionAnalytique?: ArrayOfanyTypeInput;
  Montant?: number;
  Sens?: string;
};

export type MouvementsGenerationMouvementBaseInput = {
  IdCompte?: number;
  IdEcriture?: number;
  IdMouvement?: number;
  Libelle?: string;
  Montant?: number;
  Sens?: string;
};

export type MouvementsGenerationMouvementChequeModelInput = {
  IdCompte?: number;
  IdCompteTiers?: number;
  IdEcriture?: number;
  IdMouvement?: number;
  Libelle?: string;
  Montant?: number;
  NomBanque?: string;
  NomTire?: string;
  NumeroCheque?: string;
  Sens?: string;
};

export type MouvementsGenerationMouvementTiersModelInput = {
  IdCompte?: number;
  IdCompteTiers?: number;
  IdEcriture?: number;
  IdMouvement?: number;
  Libelle?: string;
  Montant?: number;
  Sens?: string;
};

export type MouvementsInformationsMouvementModel = {
  __typename?: 'MouvementsInformationsMouvementModel';
  DateEcheance?: any;
  DateRemisEnBanque?: any;
  DoesEcritureHaveAnyMouvementsRapproche?: boolean;
  Fournisseur?: string;
  IdBeneficiaire?: number;
  IdCompte?: number;
  IdCompteTiers?: number;
  IdEcriture?: number;
  IdFournisseur?: number;
  IdMouvement?: number;
  IdRib?: number;
  IsCaution?: boolean;
  IsEcritureExportee?: boolean;
  IsEcritureSupprimable?: boolean;
  IsExerciceCloture?: boolean;
  IsMontantSensMouvementModifiable?: boolean;
  IsMouvementSupprime?: boolean;
  IsNePasEncaisser?: boolean;
  IsRapproche?: boolean;
  IsRemisEnBanque?: boolean;
  IsRendu?: boolean;
  Lettre?: string;
  LibelleMouvement?: string;
  MatriculeBeneficiaire?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  NomBeneficiaire?: string;
  NomTire?: string;
  NumeroBordereauRemisEnBanque?: string;
  NumeroCheque?: string;
  NumeroCompte?: string;
  PrenomBeneficiaire?: string;
  Reference?: string;
  Remarque?: string;
  SensMouvement?: string;
  Status?: StatusDtoEnum;
  TypeEcriture?: string;
};

export type MouvementsInformationsMouvementModelInput = {
  DateEcheance?: any;
  DateRemisEnBanque?: any;
  DoesEcritureHaveAnyMouvementsRapproche?: boolean;
  Fournisseur?: string;
  IdBeneficiaire?: number;
  IdCompte?: number;
  IdCompteTiers?: number;
  IdEcriture?: number;
  IdFournisseur?: number;
  IdMouvement?: number;
  IdRib?: number;
  IsCaution?: boolean;
  IsEcritureExportee?: boolean;
  IsEcritureSupprimable?: boolean;
  IsExerciceCloture?: boolean;
  IsMontantSensMouvementModifiable?: boolean;
  IsMouvementSupprime?: boolean;
  IsNePasEncaisser?: boolean;
  IsRapproche?: boolean;
  IsRemisEnBanque?: boolean;
  IsRendu?: boolean;
  Lettre?: string;
  LibelleMouvement?: string;
  MatriculeBeneficiaire?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  NomBeneficiaire?: string;
  NomTire?: string;
  NumeroBordereauRemisEnBanque?: string;
  NumeroCheque?: string;
  NumeroCompte?: string;
  PrenomBeneficiaire?: string;
  Reference?: string;
  Remarque?: string;
  SensMouvement?: string;
  Status?: StatusDtoEnum;
  TypeEcriture?: string;
};

export type MouvementsMouvementConsultationModel = {
  __typename?: 'MouvementsMouvementConsultationModel';
  InformationsMouvement?: MouvementsInformationsMouvementModel;
  ListeRepartitionAnalytiqueMouvement?: ArrayOfEditerMouvementAnalytiqueModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MouvementsMouvementConsultationModelInput = {
  InformationsMouvement?: MouvementsInformationsMouvementModelInput;
  ListeRepartitionAnalytiqueMouvement?: ArrayOfEditerMouvementAnalytiqueModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MouvementsMouvementEpargne = {
  __typename?: 'MouvementsMouvementEpargne';
  DateEcriture?: any;
  IdEcriture?: number;
  IdEpargne?: number;
  IdMouvement?: number;
  IdMoyenPaiement?: number;
  Libelle?: string;
  LibelleMoyenPaiement?: string;
  Montant?: number;
  MontantEcheance?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Remarque?: string;
  RemisBanque?: boolean;
  SensMouvement?: string;
  Status?: StatusDtoEnum;
  TypeEcriture?: string;
};

export type MouvementsMouvementEpargneInput = {
  DateEcriture?: any;
  IdEcriture?: number;
  IdEpargne?: number;
  IdMouvement?: number;
  IdMoyenPaiement?: number;
  Libelle?: string;
  LibelleMoyenPaiement?: string;
  Montant?: number;
  MontantEcheance?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Remarque?: string;
  RemisBanque?: boolean;
  SensMouvement?: string;
  Status?: StatusDtoEnum;
  TypeEcriture?: string;
};

export type MoyenEnvoiModelDtoInput = {
  Courrier?: boolean;
  DefCourrier?: boolean;
  DefEmailPerso?: boolean;
  DefEmailPro?: boolean;
  EmailPerso?: boolean;
  EmailPro?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Privilegier?: boolean;
  ReportModeleADR?: ReportModeleAdrdtoInput;
  SelectedCourrier?: CourrierDtoInput;
  Status?: StatusDtoEnum;
};

export type MoyenPaiementAfpaModel = {
  __typename?: 'MoyenPaiementAFPAModel';
  Code?: string;
  IdElement?: number;
  IdMoyenPaiement?: number;
  IsDefaut?: boolean;
  IsEnLigne?: boolean;
  LibelleMoyenPaiement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyenPaiementAfpaModelInput = {
  Code?: string;
  IdElement?: number;
  IdMoyenPaiement?: number;
  IsDefaut?: boolean;
  IsEnLigne?: boolean;
  LibelleMoyenPaiement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyenPaiementActiviteDto = {
  __typename?: 'MoyenPaiementActiviteDTO';
  Activite?: ActiviteDto;
  CanUseModeleEcheancier?: boolean;
  HaveModeleEcheancierParametre?: boolean;
  IsUseAchat?: boolean;
  IsUseDirecto?: boolean;
  IsUseVente?: boolean;
  MoyenPaiement?: MoyenPaiementDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyenPaiementActiviteDtoInput = {
  Activite?: ActiviteDtoInput;
  CanUseModeleEcheancier?: boolean;
  HaveModeleEcheancierParametre?: boolean;
  IsUseAchat?: boolean;
  IsUseDirecto?: boolean;
  IsUseVente?: boolean;
  MoyenPaiement?: MoyenPaiementDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyenPaiementActiviteModelDtoInput = {
  IdMoyenPaiement?: number;
  IsUtilisableAchat?: boolean;
  IsUtilisableDirecto?: boolean;
  IsUtilisableVente?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyenPaiementDto = {
  __typename?: 'MoyenPaiementDTO';
  Article?: ArticleDto;
  Code?: string;
  Compte?: CompteDto;
  Id?: number;
  IsBloqueArreteCaisse?: boolean;
  IsBloqueRemiseEnCaisse?: boolean;
  IsCloture?: boolean;
  IsCreerManuellement?: boolean;
  IsFiduciaire?: boolean;
  IsModifiable?: boolean;
  IsModifiableCloture?: boolean;
  IsModifiableFiduciaire?: boolean;
  IsModifiableNecessiteCaisse?: boolean;
  IsModifiableUseCommission?: boolean;
  IsModifiableUtilisableAchat?: boolean;
  IsModifiableUtilisableDirecto?: boolean;
  IsModifiableUtilisableVente?: boolean;
  IsUseCommission?: boolean;
  IsUtilisableAchat?: boolean;
  IsUtilisableDirecto?: boolean;
  IsUtilisableVente?: boolean;
  KitBancaire?: KitBancaireDto;
  Libelle?: string;
  ListMoyenPaiementActivite?: ArrayOfMoyenPaiementActiviteDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NecessiteCaissePourAchats?: boolean;
  OrdreAffichageDirecto?: number;
  OrdreAffichageGestion?: number;
  PourcentageCommissionnement?: number;
  Status?: StatusDtoEnum;
  TypeMoyenPaiement?: TypeMoyenPaiementDto;
};

export type MoyenPaiementDtoInput = {
  Article?: ArticleDtoInput;
  Code?: string;
  Compte?: CompteDtoInput;
  Id?: number;
  IsBloqueArreteCaisse?: boolean;
  IsBloqueRemiseEnCaisse?: boolean;
  IsCloture?: boolean;
  IsCreerManuellement?: boolean;
  IsFiduciaire?: boolean;
  IsModifiable?: boolean;
  IsModifiableCloture?: boolean;
  IsModifiableFiduciaire?: boolean;
  IsModifiableNecessiteCaisse?: boolean;
  IsModifiableUseCommission?: boolean;
  IsModifiableUtilisableAchat?: boolean;
  IsModifiableUtilisableDirecto?: boolean;
  IsModifiableUtilisableVente?: boolean;
  IsUseCommission?: boolean;
  IsUtilisableAchat?: boolean;
  IsUtilisableDirecto?: boolean;
  IsUtilisableVente?: boolean;
  KitBancaire?: KitBancaireDtoInput;
  Libelle?: string;
  ListMoyenPaiementActivite?: ArrayOfMoyenPaiementActiviteDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NecessiteCaissePourAchats?: boolean;
  OrdreAffichageDirecto?: number;
  OrdreAffichageGestion?: number;
  PourcentageCommissionnement?: number;
  Status?: StatusDtoEnum;
  TypeMoyenPaiement?: TypeMoyenPaiementDtoInput;
};

export type MoyenPaiementDefautModel = {
  __typename?: 'MoyenPaiementDefautModel';
  Code?: string;
  Id?: number;
  IsParDefaut?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyenPaiementDefautModelInput = {
  Code?: string;
  Id?: number;
  IsParDefaut?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyenPaiementFpaModel = {
  __typename?: 'MoyenPaiementFPAModel';
  IdElement?: number;
  IdMoyenPaiement?: number;
  IsDefaut?: boolean;
  IsEnligne?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyenPaiementFpaModelInput = {
  IdElement?: number;
  IdMoyenPaiement?: number;
  IsDefaut?: boolean;
  IsEnligne?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyenPaiementForVenteModeleDto = {
  __typename?: 'MoyenPaiementForVenteModeleDTO';
  CodeMoyenPaiement?: string;
  IdMoyenPaiement?: number;
  LibelleMoyenPaiement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyenPaiementForVenteModeleDtoInput = {
  CodeMoyenPaiement?: string;
  IdMoyenPaiement?: number;
  LibelleMoyenPaiement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyenPaiementMoyenPaiementBaseModel = {
  __typename?: 'MoyenPaiementMoyenPaiementBaseModel';
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyenPaiementMoyenPaiementBaseModelInput = {
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyenPaiementMoyenPaiementSelectionableModel = {
  __typename?: 'MoyenPaiementMoyenPaiementSelectionableModel';
  Id?: number;
  IsChecked?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyenPaiementMoyenPaiementSelectionableModelInput = {
  Id?: number;
  IsChecked?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyenPayementModelDto = {
  __typename?: 'MoyenPayementModelDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyenPayementModelDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type MoyensPaiementMoyenPaiementBaseModele = {
  __typename?: 'MoyensPaiementMoyenPaiementBaseModele';
  Id?: number;
  Libelle?: string;
};

export type MoyensPaiementMoyenPaiementBaseModeleInput = {
  Id?: number;
  Libelle?: string;
};

export type MoyensPaiementMoyenPaiementLightModel = {
  __typename?: 'MoyensPaiementMoyenPaiementLightModel';
  CodeType?: string;
  Id?: number;
  IsFiduciaire?: boolean;
  Libelle?: string;
};

export type MoyensPaiementMoyenPaiementLightModelInput = {
  CodeType?: string;
  Id?: number;
  IsFiduciaire?: boolean;
  Libelle?: string;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** from ModuleAttributionBudget1 */
  AbondementIsUsed?: boolean;
  /** from DossierPrestation3 */
  AccepterListePiecesJustificatives?: ArrayOfDossierPrestationPieceJustificativeModelDto;
  /** from Article1 */
  ActionGroupes?: ArrayOfArticleDto;
  /** from Activite_NA4 */
  ActiviteHasFormulaire?: boolean;
  /** from Activite_NA6 */
  ActiviteHasStatutPerso?: boolean;
  /** from Activite_NA2 */
  ActiviteHavePermanence?: boolean;
  /** from Activite_NA6 */
  ActiviteHaveStatutPersoByStatut?: HaveStatutComplementaireModel;
  /** from Activite2 */
  ActivitePossedeLiensPortail?: boolean;
  /** from ModulesVentes2 */
  AddLigneCommandePrestation?: LigneDossierPrestationModelDto;
  /** from ModuleBudget */
  AddOrDeleteCptOrSectionAnaInPosteBDG?: string;
  /** from Compta8 */
  AddPlanAnalytique?: number;
  /** from Administration1 */
  AddPortailArticle?: ArrayOfMenusArticleTreeViewModuleGestionMenusModel;
  /** from Compta8 */
  AddSectionAnalytique?: number;
  /** from Compta24 */
  AffecterTiersAuxMouvements?: ResultatAffectationTiersModel;
  /** from Ventes_NA5 */
  AjoutHistoriqueStatutPersoSurCommandeClient?: string;
  /** from Ventes_NA6 */
  AjoutHistoriqueStatutSurCommandeClient?: string;
  /** from Activite_NA11 */
  AjouterListeParticipants?: string;
  /** from Benef4 */
  AjouterNewsletterTheme?: ArrayOfNewsletterNewsletterThemeModel;
  /** from Activite_NA5 */
  AllArticleAvecValoEtVariation?: boolean;
  /** from Mediatheque1 */
  AnnulationImmediatEmpruntExemplaire?: string;
  /** from Mediatheque1 */
  AnnulationImmediatReservationExemplaire?: string;
  /** from Mediatheque1 */
  AnnulationImmediatRetourExemplaire?: string;
  /** from ModulesVentes1 */
  AnnulerBonLivraison?: string;
  /** from Ventes_NA */
  AnnulerCommande?: string;
  /** from DossierPrestation2 */
  AnnulerDossierPrestation?: string;
  /** from ModuleAttributionBudget */
  AnnulerExecutionAttributionBDG?: string;
  /** from Article2 */
  AnnulerListLigneComandeByFlash?: string;
  /** from RessourcesPartagees1 */
  AnnulerLivraison?: string;
  /** from ModuleBudget */
  AnnulerModificationBudget?: BudgetModelDto;
  /** from Benef4 */
  AnnulerReinitialisationPassword?: string;
  /** from ModulesVentes1 */
  AnnulerRembourserCommande?: RetourAnnulationRemboursementModelDto;
  /** from RessourcesPartagees1 */
  AnnulerRetour?: string;
  /** from Mediatheque1 */
  AnnulerToutesActionsEmpruntReservationRetour?: string;
  /** from DossierPrestation5 */
  AnnulerTransfertCompta?: RetourAnnulationTransfertComptaModel;
  /** from DossierPrestation3 */
  AnnulerTransformationEnCommande?: string;
  /** from DossierPrestation4 */
  AnnulerValidationListePiecesJustificatives?: string;
  /** from Compta14 */
  AppliquerLettrageComptable?: string;
  /** from DossierPrestation5 */
  AreAllComptesProduitOK?: boolean;
  /** from Ventes_NA8 */
  AreModalitesReglementAvailableForAddedProduit?: boolean;
  /** from Article5 */
  ArticleLocationWithChevauchementDates?: ArrayOfstring;
  /** from Application5 */
  ArticleMagazineRecommandation?: boolean;
  /** from Ventes_NA2 */
  ArticleUsedOnLigneCommande?: boolean;
  /** from ModulesVentes */
  AttributionHaveDevisFacture?: boolean;
  /** from Mediatheque4 */
  BloquerListeExemplaire?: ArrayOfBlocageExemplaireModel;
  /** from Activite_NA8 */
  CEHasCompteurPoint?: boolean;
  /** from Benef_NA1 */
  CalculCriteresSociauxChampsDynamiques?: number;
  /** from Mediatheque1 */
  CalculDateFinEmpruntReservationWithNbPermanence?: any;
  /** from Compta_NA9 */
  CalculateSoldeNonRapprocheByIdReleveBancaire?: SoldeNonRapprocheModel;
  /** from Mediatheque4 */
  CalculerDateFinEmpruntReservationWithIdExemplaire?: any;
  /** from Mediatheque4 */
  CalculerDateFinEmpruntReservationWithIdMedia?: any;
  /** from ModulesVentes */
  CancelAttributionAuto?: string;
  /** from ModulesVentes3 */
  ChangementStatutLigneCommandePrestation?: ChangeStatutLigneCommandeModelDto;
  /** from ModulesVentes3 */
  ChangementStatutLigneCommandePrestationViaPopup?: ChangeStatutLigneCommandeModelDto;
  /** from Mediatheque4 */
  ChangerExemplaireSurLigneEtLivrer?: MediathequeRetourEditerLigneCommandeMediathequeModelDto;
  /** from Compta_NA2 */
  ChangerRibBenefSurMouvementEnAttente?: string;
  /** from Mediatheque3 */
  ChangerStatutAdministratifLigneCommandeMediatheque?: string;
  /** from RessourcesPartagees */
  ChangerStatutAdministratifLigneCommandeRP?: string;
  /** from Ventes_NA4 */
  ChangerStatutLigneCommandeGestion?: ChangeStatutLigneCommandeModelDto;
  /** from Ventes_NA2 */
  ChangerStatutLigneDossierEpargne?: RetourEditerLigneDossierEpargneModel;
  /** from ModulesMoteurRegle1 */
  ChargerRegleAvancee?: ContenuRegleAvanceeModelDto;
  /** from DossierPrestation5 */
  CheckBeforeAnnulationTransfertComptaPAC?: RetourCheckBeforeAnnulTransfertComptaModel;
  /** from DossierPrestation5 */
  CheckBeforeAnnulationTransfertComptaRemboursement?: RetourCheckBeforeAnnulTransfertComptaModel;
  /** from Article6 */
  CheckBeforeDuplicationFPA?: boolean;
  /** from Activite3 */
  CheckCodeActiviteEdited?: boolean;
  /** from Champ2 */
  CheckCodeExisteChampPersonalise?: boolean;
  /** from Compta6 */
  CheckCompte512RattacheACompteBancaire?: boolean;
  /** from Courrier1 */
  CheckCourrierLocationProduitFamille?: boolean;
  /** from Ventes_NA8 */
  CheckDateLivraisonReception?: string;
  /** from Article4 */
  CheckElementFPAToDelete?: string;
  /** from Ventes_NA7 */
  CheckIfCommandeHasProduitWithModalitesReglement?: boolean;
  /** from Ventes_NA7 */
  CheckIfProduitHaveMoyenPaiementLie?: boolean;
  /** from Ventes_NA7 */
  CheckIfProduitModeleEcheancierLie?: boolean;
  /** from Benef1 */
  CheckMatriculeExist?: BenefDto;
  /** from Compta3 */
  CheckNumeroPieceForEcriture?: boolean;
  /** from Compta3 */
  CheckNumeroPieceForJournal?: boolean;
  /** from Benef1 */
  CheckPseudoBenefExist?: boolean;
  /** from Stock1 */
  CheckStockArticleQuantite?: ArrayOfVerifCoherenceLivraisonModel;
  /** from Compta14 */
  CheckUniciteMandat?: boolean;
  /** from Benef1 */
  CheckUniciteNomPrenom?: BenefBenefTotalModel;
  /** from Application3 */
  ClotureCommission?: ArrayOfParamCommissionModel;
  /** from Activite_NA9 */
  ClotureDeClotureCompteurPoints?: string;
  /** from Mediatheque1 */
  CloturerCatalogue?: string;
  /** from Administration5 */
  CloturerCommentaire?: string;
  /** from Communication1 */
  CloturerCourrier?: string;
  /** from Courrier */
  CloturerCourrierEnvoi?: ArrayOfCourrierCourrierEnvoiModel;
  /** from ApplicationMobile */
  CloturerDecloturerActualite?: string;
  /** from Mediatheque */
  CloturerFamille?: string;
  /** from Communication2 */
  CloturerMail?: string;
  /** from Compta_NA1 */
  CloturerModeleEcheancier?: string;
  /** from Benef4 */
  CloturerNewsletterTheme?: ArrayOfNewsletterNewsletterThemeModel;
  /** from Compta10 */
  CloturerPlanAnalytique?: string;
  /** from Activite_NA5 */
  CloturerProduit?: string;
  /** from Communication */
  CloturerPubliVue?: string;
  /** from Communication3 */
  CloturerRequete?: string;
  /** from Compta10 */
  CloturerSectionAnalytique?: string;
  /** from Ventes_NA5 */
  CloturerStatutPerso?: string;
  /** from Ventes_NA1 */
  CommandeHasFormulaireParametre?: boolean;
  /** from Ventes_NA1 */
  CommandeOuLigneHasFormulaireParametre?: boolean;
  /** from Ventes5 */
  CompareSessionChoix?: boolean;
  /** from Connexion */
  ConnexionGestionByLogin?: ConnexionModelDto;
  /** from Connexion */
  ConnexionVupByLogin?: ConnexionModelDto;
  /** from Contacter */
  ContacterBenefForCommandeFourniseur?: string;
  /** from Contacter */
  ContacterByMailLibre?: string;
  /** from Compta19 */
  CorrigerImputationArticle?: RadgridviewPagineModelDtoOfCorrectionImputationArticleModelWfN5Koph;
  /** from Compta23 */
  CorrigerMontantMouvement?: RadgridviewPagineModelDtoOfCorrectionMontantMouvementModelWfN5Koph;
  /** from Compta18 */
  CorrigerRepartitionAnalytique?: RadgridviewPagineModelDtoOfCorrectionRepartitionAnalytiqueModelWfN5Koph;
  /** from Activite1 */
  CreateEcritureAndMouvementsAndSaveReglement?: ArrayOfCompteEcritureDto;
  /** from Article1 */
  CreateNewArticle?: ArticleDto;
  /** from Compta1 */
  CreateNewCompte511?: ArrayOfCompteDto;
  /** from Compta_NA6 */
  CreateNewDeclaration?: string;
  /** from ModulesVentes3 */
  CreateNewDevisCommande?: DevisCommandeDto;
  /** from Article */
  CreateNewFamille?: FamilleProduitDto;
  /** from Article */
  CreateNewProduit?: ProduitDto;
  /** from Courrier */
  CreationCourrierHistoEnvoiAcceptationRefusWhithModelAttribution?: ArrayOfCourrierHistoEnvoiDto;
  /** from Compta21 */
  CreerArreteCaisse?: Union_39409527161397698042;
  /** from Activite_NA */
  CreerArticle?: Union_7392513492403361798;
  /** from Compta_NA */
  CreerAvoirPourRemboursementBenefDons?: number;
  /** from Compta_NA */
  CreerAvoirPourRemboursementBenefPrets?: number;
  /** from Ventes7 */
  CreerAvoirSurFacture?: string;
  /** from Benef_NA1 */
  CreerChampDroits?: BenefChampHistoriqueModel;
  /** from Compta15 */
  CreerClotureComptable?: ParametrageClotureExerciceModel;
  /** from Ventes_NA3 */
  CreerCommandeEpargne?: RetourCreationCommandeDossierEpargneModel;
  /** from Compta_NA3 */
  CreerComptes?: string;
  /** from Application2 */
  CreerDemandeDeTelechargement?: string;
  /** from Application2 */
  CreerDemandeDeTelechargementStr?: string;
  /** from Ventes_NA2 */
  CreerDossierEpargne?: DossierEpargneFull;
  /** from DossierPrestation1 */
  CreerDossierPrestation?: number;
  /** from Ventes_NA */
  CreerDossierPretsEtDons?: DossierPretsEtDonsFull;
  /** from Compta_NA5 */
  CreerEcritureContrepassation?: string;
  /** from Compta_NA */
  CreerFacturePourRemboursementPretsEtDons?: number;
  /** from Activite_NA */
  CreerFamille?: Union_50922305263755211;
  /** from Activite_NA */
  CreerProduit?: Union_30188432553199321036;
  /** from Compta22 */
  CreerRemiseEnCaisseCentrale?: RemiseCaisseCentraleModel;
  /** from Commun2 */
  CryptagePassword?: string;
  /** from Compta_NA8 */
  DebiterCrediterPMV?: number;
  /** from Mediatheque4 */
  DebloquerListeExemplaire?: string;
  /** from Compta17 */
  DeclotureExercice?: string;
  /** from Commun2 */
  DecodeHtml?: string;
  /** from Connexion */
  Deconnecter?: string;
  /** from Administration8 */
  DeleteAlbumDeArticle?: boolean;
  /** from Administration5 */
  DeleteCategorie?: string;
  /** from Ventes_NA8 */
  DeleteCommandeModalitesReglement?: string;
  /** from DossierPrestation */
  DeleteDossierPrestation?: string;
  /** from Files */
  DeleteFile?: boolean;
  /** from Files1 */
  DeleteFileDeAlbum?: boolean;
  /** from Files1 */
  DeleteFileDeArticle?: boolean;
  /** from Activite_NA2 */
  DeleteHoraires?: string;
  /** from ModulesVentes */
  DeleteLigneCommandeForVente?: string;
  /** from Compta_NA5 */
  DeleteModeleTVA?: string;
  /** from Activite_NA2 */
  DeletePermanence?: ArrayOfstring;
  /** from Administration1 */
  DeletePortailArticle?: ArrayOfMenusArticleTreeViewModuleGestionMenusModel;
  /** from Administration4 */
  DeleteTrombinoscope?: TrombinoscopeInitialiationTrombinoscopeModel;
  /** from Compta_NA8 */
  DeleteWrongLettrageOnExercice?: string;
  /** from Compta14 */
  DelettrerEcritures?: string;
  /** from Compta14 */
  DelettrerMouvements?: string;
  /** from Adresse */
  DepartementHasVille?: boolean;
  /** from Administration2 */
  DeplacementMenuArborescence?: string;
  /** from Administration6 */
  DetacherDocAssoArticleEditorial?: string;
  /** from Files */
  DetacherDocument?: string;
  /** from RessourcesPartagees */
  DeterminerActionsSuppressionTarif?: EtapesSuppressionTarif;
  /** from Administration8 */
  DiffusionMonEspaceCSE?: string;
  /** from Champ2 */
  DoesCodeChampListeValeurExists?: boolean;
  /** from Article4 */
  DuplicationAFPA?: string;
  /** from ModuleAttributionBudget */
  DupliquerAttributionBudget?: AttributionBudgetModelDto;
  /** from Compta_NA8 */
  DupliquerBudget?: number;
  /** from ModulesMoteurRegle1 */
  DupliquerRegle?: number;
  /** from Champ2 */
  EditValeurChampListe?: string;
  /** from Champ2 */
  EditValeurParamHistorisationOfChamp?: KeyValueStrings;
  /** from Ventes_NA6 */
  EditerActionsTrigger?: string;
  /** from ApplicationMobile */
  EditerActualite?: number;
  /** from Activite_NA1 */
  EditerArticle?: number;
  /** from Administration5 */
  EditerCategorie?: number;
  /** from Stock2 */
  EditerCessionStock?: string;
  /** from Activite_NA3 */
  EditerChampFormulaire?: number;
  /** from Ventes_NA1 */
  EditerCommentairesBLBR?: string;
  /** from Ventes_NA2 */
  EditerDossierEpargne?: RetourEditerLigneDossierEpargneModel;
  /** from Ventes_NA2 */
  EditerEnteteDossierEpargne?: string;
  /** from Benef_NA2 */
  EditerExecutionAttributionAuto?: EditerExecutionAttributionAutoModel;
  /** from Compta_NA3 */
  EditerExercice?: number;
  /** from Activite_NA1 */
  EditerFamille?: number;
  /** from Activite_NA3 */
  EditerFormulaire?: number;
  /** from Activite_NA7 */
  EditerGroupeRoomingList?: GroupeRoomingListModel;
  /** from Administration5 */
  EditerHistoriqueSalarie?: string;
  /** from Ventes_NA */
  EditerInfosEnteteDossierPretsEtDons?: Union_13510198731919550967;
  /** from Compta19 */
  EditerLibelleMouvement?: string;
  /** from Compta_NA */
  EditerLibelleRemiseEnBanque?: string;
  /** from Activite_NA7 */
  EditerLibelleRoomingList?: string;
  /** from Ventes_NA4 */
  EditerLigneCommandeGestionPlus?: LigneDevisModeleDto;
  /** from Mediatheque1 */
  EditerLigneCommandeMediatheque?: MediathequeRetourEditerLigneCommandeMediathequeModelDto;
  /** from Ventes_NA */
  EditerLigneDossierPretsEtDons?: RetourEditerLigneDossierPretsEtDonsModel;
  /** from Communication1 */
  EditerModeleCourrierPublipostage?: number;
  /** from Compta_NA1 */
  EditerModeleEcheancier?: string;
  /** from Compta_NA2 */
  EditerModeleEcheancierActivite?: string;
  /** from Communication2 */
  EditerModeleEmailPublipostage?: number;
  /** from Compta19 */
  EditerMotifSEPAMouvement?: string;
  /** from Commun2 */
  EditerPieceJustificative?: number;
  /** from Activite_NA1 */
  EditerProduit?: number;
  /** from Activite_NA5 */
  EditerProduitCloture?: number;
  /** from Activite_NA7 */
  EditerRommingList?: RetourEditerRoomingListModel;
  /** from Ventes_NA5 */
  EditerStatutPerso?: number;
  /** from Benef6 */
  EditionEnregistrementODAD?: number;
  /** from Ventes_NA7 */
  EffectuerLivraisonRapidePartielle?: LivraisonsInfosCommandeBlApresLivRapide;
  /** from Ventes_NA7 */
  EffectuerLivraisonRapideTotale?: LivraisonsInfosCommandeBlApresLivRapide;
  /** from Compta22 */
  EffectuerRemiseEnCaisse?: string;
  /** from Compta_NA2 */
  EnregistrerAbondementManuel?: MouvementsMouvementEpargne;
  /** from Compta21 */
  EnregistrerArreteCaisse?: string;
  /** from Compta_NA3 */
  EnregistrerEcheances?: ArrayOfMouvementsMouvementEpargne;
  /** from DossierPrestation2 */
  EnregistrerLigneDossierPrestation?: DossierPrestationRetourEnregistrementLigneDossierPrestationModelDto;
  /** from Champ */
  EnregistrerNouvelleVueParDefaut?: string;
  /** from ModulesAdministration1 */
  EnregistrerParametrageOrganisationSynchro?: string;
  /** from Activite_NA2 */
  EnregistrerPermanencesSurActivite?: string;
  /** from ModulesMoteurRegle1 */
  EnregistrerRegleGuidee?: MoteurRegleModelDto;
  /** from Compta_NA2 */
  EnregistrerReglementManuel?: MouvementsMouvementEpargne;
  /** from ModulesMoteurRegle1 */
  EnregistrerReglesAvancees?: number;
  /** from Stock1 */
  EnregistrerRemarqueMouvementStock?: string;
  /** from DossierPrestation3 */
  EnregistrerRemarquesPieceJustificative?: string;
  /** from Compta22 */
  EnregistrerRemiseEnCaisse?: string;
  /** from Activite_NA4 */
  EnregistrerReponsesFormulaires?: string;
  /** from Activite2 */
  EnregistrerReservationResxPartagee?: RetourMoteurModelDto;
  /** from Compta11 */
  EnregistrerSourceXML?: string;
  /** from Activite2 */
  EnregistrerTarif?: string;
  /** from Contacter */
  EnvoieMailAcceptationRefus?: string;
  /** from Communication2 */
  EnvoieMailPublipostage?: RetourBenefMailPublipostage;
  /** from Communication4 */
  EnvoieMailUtilisateurPublipostage?: string;
  /** from Annonce */
  EnvoyerEmailApresModificationAnnonces?: string;
  /** from Administration7 */
  EnvoyerMailApprobateurPourValidation?: string;
  /** from Application2 */
  EnvoyerMailDepressionNotationGestion?: string;
  /** from Commun3 */
  EnvoyerPiecesJustificativesVersDoki?: string;
  /** from DossierPrestation */
  ExecuteActionsGroupees?: RetourExecutionActionsGroupees;
  /** from ModuleAttributionBudget */
  ExecuterOrUpdateAttDBGBenef?: string;
  /** from Application4 */
  ExistsContactParam?: boolean;
  /** from ModulesVentes5 */
  ExportAndSaveLigneCommande?: ArrayOfModeleRetourExportAncvCesuDto;
  /** from Benef */
  ExportAnneeRefToAnneeCible?: string;
  /** from Compta23 */
  ExportFichierPNM100?: string;
  /** from Contacter */
  ExportGrandLivreAnalytique?: string;
  /** from Contacter */
  ExportGrandLivreComptableEnExcel?: string;
  /** from Contacter */
  ExportGrandLivreComptableEnPDF?: string;
  /** from Compta23 */
  ExportPrelevementSEPA?: string;
  /** from Compta23 */
  ExportVirementSEPA?: string;
  /** from ModulesVentes2 */
  ExporterLigneCommande?: ArrayOfModeleRetourExportAncvCesuDto;
  /** from ReqSpecif */
  ExporterProcStocker?: ResultReqSpec;
  /** from ReqSpecif */
  ExporterProcStockerCSV?: string;
  /** from Compta23 */
  ExporterReleverBancaire?: string;
  /** from DossierPrestation4 */
  ExtensionPieceJustificativeValide?: string;
  /** from RessourcesPartagees */
  FacturationMasseCommandeClient?: string;
  /** from RessourcesPartagees1 */
  FacturerCommandeClientParTarif?: RetourFacturationModel;
  /** from RessourcesPartagees1 */
  FacturerListeCommandeClient?: RetourFacturationModel;
  /** from Activite_NA11 */
  FamilleHasProduitWithFacturationAuto?: boolean;
  /** from Ventes_NA4 */
  FinProcessVentes?: RetourFacturationModel;
  /** from Files1 */
  ForceDeleteFile?: string;
  /** from Fournisseurs */
  FournisseurPossedeArticlesGenerique?: number;
  /** from Administration6 */
  GenerateModelListeArticlePortlet?: RadgridviewPagineModelDtoOfArticleEditorielPortletModelWfN5Koph;
  /** from Communication3 */
  GenerateReportWithIdImpression?: string;
  /** from Ventes3 */
  GenerationBlBRReceptionPartielle?: ArrayOfBlbrModele;
  /** from Ventes3 */
  GenerationBlBRReceptionTotale?: InfosRetourLivraisonOuReceptionTotaleGroupeeCommande;
  /** from Article2 */
  GenereSessionEmprunt?: number;
  /** from Ventes_NA4 */
  GenererActionsGroupeesCommandes?: ArrayOfdecimal;
  /** from Ventes_NA3 */
  GenererActionsGroupeesEpargnes?: RetourActionsGroupeesModel;
  /** from Ventes_NA */
  GenererActionsGroupeesPretsEtDons?: RetourActionsGroupeesPretsEtDonsModel;
  /** from Ventes2 */
  GenererAndSaveAccompteWithReglement?: number;
  /** from Article3 */
  GenererArticlesLocation?: boolean;
  /** from ModulesVentes1 */
  GenererBonRetourCommande?: string;
  /** from Ventes_NA9 */
  GenererCommandeFournisseurSQL?: boolean;
  /** from Ventes_NA7 */
  GenererEcheancierReglementsMasse?: string;
  /** from Compta_NA6 */
  GenererEcritureDecaissement?: string;
  /** from Compta17 */
  GenererEcrituresBalanceOuverture?: RadgridviewPagineModelDtoOfEcritureBalanceOuvertureModelWfN5Koph;
  /** from Compta15 */
  GenererFichierPrelevementSEPA?: string;
  /** from Compta15 */
  GenererFichierVirementSEPA?: string;
  /** from Commun1 */
  GenererPermanence?: string;
  /** from Activite_NA1 */
  GenererPermanenceNA?: string;
  /** from Compta13 */
  GenererReferenceRum?: string;
  /** from Compta_NA */
  GenererTableauEcheancierPretsEtDons?: ArrayOfRemboursementPretsEtDonsListerModel;
  /** from Stock3 */
  GererActionReceptionTransfertStock?: string;
  /** from Article2 */
  GestionEmpruntRetour?: InfoEmpruntModelDto;
  /** from Article4 */
  GestionMouvementStockArticleLocPlageDatesCroisees?: string;
  /** from Activite_NA7 */
  GetAFPAModeleFraisAnnulation?: ArrayOfLibellesAfpaModel;
  /** from Ventes4 */
  GetAchatFourInitModel?: AchatFournisseurInitModelDto;
  /** from Ventes_NA5 */
  GetActionModel?: ActionStatutModel;
  /** from RessourcesPartagees1 */
  GetActionsAnnulationReservation?: ActionsAnnulationReservation;
  /** from Activite_NA */
  GetActiviteJournaux?: ActiviteJournauxModel;
  /** from ApplicationMobile */
  GetActualiteEdition?: ActualiteMobileEditionModelDto;
  /** from Administration3 */
  GetAdresseFluxRSSKalidea?: string;
  /** from Activite1 */
  GetAllCodeActivite?: ArrayOfActiviteBaseCodeModel;
  /** from Communication */
  GetAllListePubliType?: ArrayOfPubliTypeCourrierPossibleModel;
  /** from Application */
  GetAllMonoModules?: ModulesMonoModelDto;
  /** from Adresse1 */
  GetAllPays?: ArrayOfPaysDto;
  /** from Files */
  GetAllTypesLibelles?: ArrayOfstring;
  /** from Adresse */
  GetAllVilleCP?: ArrayOfVilleDto;
  /** from Annonce */
  GetAnnonceDetail?: AnnonceDetailsModelDto;
  /** from ModulesActivite */
  GetAppelComplementaireForReglement?: AppelComplementaireReglementModelDto;
  /** from Compta_NA9 */
  GetArborescenceBudget?: ArrayOfBudgetListingModel;
  /** from Compta22 */
  GetArreteCaisse?: Union_33595702961915738127;
  /** from Activite_NA */
  GetArticle?: Union_7392513492403361798;
  /** from Article4 */
  GetArticleEtGestionStock?: Union_37395321602086970009;
  /** from Article1 */
  GetArticleLocationModel?: ArrayOfConsultationArticleLocationModel;
  /** from Administration8 */
  GetArticleUpKonnect?: EditerArticleUpKonnectModel;
  /** from ModuleAttributionBudget */
  GetAttibutionBDGModelWithId?: AttributionBudgetModelDto;
  /** from ModulesVentes1 */
  GetAttributionAutoModel?: AttributionAutoModelDto;
  /** from Ventes_NA6 */
  GetAvoirsAcomptesFromFournisseur?: ArrayOfImpayesAvoirsAcomptesModel;
  /** from Benef5 */
  GetBenefBaseModelById?: BenefBenefBaseModel;
  /** from Benef5 */
  GetBenefFromIdCommande?: BenefBenefBaseModel;
  /** from Benef5 */
  GetBenefFromIdLigneCommande?: BenefBenefBaseModel;
  /** from Benef_NA */
  GetBenefMails?: BenefMailingModel;
  /** from Benef_NA */
  GetBenefMatriculeModelById?: BenefBenefMatriculeModel;
  /** from Mediatheque */
  GetBenefMediatheque?: MediathequeBenefMediathequeModelDto;
  /** from ModulesVentes4 */
  GetBenefModelForVentesClients?: BenefForVentesModeleDto;
  /** from Communication1 */
  GetBenefNonContactable?: ArrayOfBeneficiaireAvecMailsModel;
  /** from Benef_NA1 */
  GetBenefODADModel?: BenefOdadModel;
  /** from Benef6 */
  GetBenefPourAccesPortail?: Union_29816689623692486759;
  /** from Benef5 */
  GetBeneficiaireFicheTrombinoscope?: BenefBeneficiaireFicheTrombinoscopeModel;
  /** from ModulesAdministration */
  GetBlocModele?: BlocModelDto;
  /** from ModuleBudget */
  GetBudgetModele?: BudgetModelDto;
  /** from Benef3 */
  GetCalculAnneeReference?: number;
  /** from ModulesVentes5 */
  GetCalculPoint?: CompteurPointCalculPointsDto;
  /** from Mediatheque */
  GetCatalogueFull?: ParamMediathequeCatalogueModel;
  /** from ModulesAdministration1 */
  GetCeSynchroForParametrageOrganisation?: SynchroOrganisationModelDto;
  /** from Stock3 */
  GetCessionStockRemarque?: CessionStockWithRemarqueModel;
  /** from Stock2 */
  GetCessionStockRemarqueNomPrenom?: CessionStockWithRemarqueNomPrenomModel;
  /** from Activite_NA3 */
  GetChampFormulaire?: ChampFormulaireParametrageModel;
  /** from Champ2 */
  GetChampListeValByCode?: ArrayOfChampListeValeurChampListeValeurLightModel;
  /** from Champ3 */
  GetChampListeValFromCodeChamp?: ArrayOfChampListeValModel;
  /** from Champ */
  GetChampListeValGenerique?: ArrayOfChampListeValeurDto;
  /** from Compta16 */
  GetClotureComptable?: ClotureExerciceForInventaireModel;
  /** from Benef_NA */
  GetCodeAnneeRefCourante?: string;
  /** from Champ1 */
  GetCodeMoyenCorrespondanceBenef?: string;
  /** from Activite_NA1 */
  GetCodeMoyenPaiement2?: string;
  /** from DossierPrestation1 */
  GetCodeStatutDossierPrestation?: string;
  /** from Activite */
  GetCodeTypeActiviteWithIdAct?: string;
  /** from Ventes8 */
  GetCodeTypeVue?: string;
  /** from Ventes_NA8 */
  GetCommandeInfoReglement?: CommandeReglementInfosStateModel;
  /** from Ventes_NA7 */
  GetCommandeModaliteReglementAffichage?: CommandeModaliteReglementAffichageModel;
  /** from Ventes_NA8 */
  GetCommandeModalitesReglement?: CommandeModaliteReglementBaseModel;
  /** from Ventes_NA3 */
  GetCommandesAvecQuantite?: ArrayOfLivraisonsCommandesInfosLivraisonBaseModel;
  /** from Ventes_NA4 */
  GetComptaArticleImputerEpargne?: ComptaArticleImputerEpargneModel;
  /** from Activite_NA5 */
  GetComptaPourEcheances?: ComptabiliteJournalCompteEtBancaireModel;
  /** from Compta20 */
  GetCompteImputationEtAnalytiqueModel?: FpaArticleComptaModel;
  /** from Activite_NA6 */
  GetCompteTropPercu?: number;
  /** from ModulesCompta */
  GetComptesForListeCompteModelGenerique?: ArrayOfCompteForListeCompteModel;
  /** from Compta_NA4 */
  GetConfirmationTransfertComptaModel?: ConfirmationTransfertComptaModel;
  /** from Compta8 */
  GetConsommationEnveloppeQuota?: ArrayOfModeleConsoEnvQuotaDto;
  /** from Administration5 */
  GetCouleurPortlet?: PortletCssColorModel;
  /** from Article5 */
  GetCountArticle?: number;
  /** from Benef5 */
  GetCountBenef?: number;
  /** from Benef */
  GetCountListeBeneficiaireGenerique?: number;
  /** from Compta */
  GetCountListeMoyenPaiementActiviteGenerique?: number;
  /** from Mediatheque3 */
  GetCountMediaMAJAPI?: number;
  /** from Compta20 */
  GetCountMouvementsComptables?: number;
  /** from Communication3 */
  GetCourrierEnvoyePublipostage?: ModelesCourrierPublipostageModel;
  /** from ModulesCompta */
  GetCptCollectifClientActiviteWithListIdFactRgl?: number;
  /** from Benef2 */
  GetDateDebutCalculCompteurPoint?: any;
  /** from Compta_NA6 */
  GetDateDebutExerciceEnCours?: any;
  /** from Commun1 */
  GetDatesPerm?: ArrayOfdateTime;
  /** from Compta7 */
  GetDefaultJournalPRMFidu?: JournalDto;
  /** from Application4 */
  GetDernierArticleMagazine?: ArticleMagazineModel;
  /** from SynchroSynapse_NA */
  GetDerniereSynchroHistoAD?: SynchroSynapseHistoModelDto;
  /** from Article4 */
  GetDescriptionArticle?: string;
  /** from Compta_NA6 */
  GetDetailDeclaration?: TvaEtatPreparatoireDetailModel;
  /** from Stock1 */
  GetDispoProduitGroupeModel?: DispoProduitGroupeModelDto;
  /** from Ventes_NA9 */
  GetDisponibiliteInscriptionGroupes?: DisponibiliteProduitInscriptionModel;
  /** from Ventes6 */
  GetDisponibilitesRessourcesPartagees?: ArrayOfDisponibilitesRessourcesPartageesModel;
  /** from Administration6 */
  GetDocumentsArticleEditorial?: ArrayOfFichierModel;
  /** from ModulesBenef */
  GetDossierBenefModel?: DossierBenefModelDto;
  /** from Ventes_NA2 */
  GetDossierEpargneFull?: DossierEpargneFull;
  /** from Ventes_NA2 */
  GetDossierEpargneModel?: DossierEpargneModel;
  /** from DossierPrestation1 */
  GetDossierPrestation?: DossierPrestationDossierPrestationModelDto;
  /** from Ventes_NA */
  GetDossierPretsEtDons?: DossierPretsEtDonsFull;
  /** from Compta_NA4 */
  GetEcritureConsultationModel?: EcritureConsultationModel;
  /** from Compta_NA6 */
  GetEcrituresNonConformeTVA?: ArrayOfEcritureVerificationConformiteTva;
  /** from Communication2 */
  GetEmailEnvoyePublipostage?: Union_872526003726237120;
  /** from DossierPrestation4 */
  GetEnteteDossierPrestation?: DossierPrestationEnteteDossierPrestationModelDto;
  /** from Benef_NA2 */
  GetExecutionAutoAttributionModel?: EditerExecutionAttributionAutoModel;
  /** from Mediatheque */
  GetExemplaireMediaMediatheque?: MediathequeExemplaireMediaEmpruntReservationMediathequeModelDto;
  /** from Compta15 */
  GetExerciceACloturer?: ExerciceClotureModel;
  /** from Contacter */
  GetExportBalanceAnalytique?: string;
  /** from Contacter */
  GetExportBalanceComptable?: string;
  /** from Contacter */
  GetExportBalanceTiers?: string;
  /** from Contacter */
  GetExportBilanVentes?: string;
  /** from Contacter */
  GetExportBudgets?: string;
  /** from Contacter */
  GetExportGrandLivreDesTiers?: string;
  /** from Files */
  GetExtentionByFileType?: string;
  /** from Compta_NA6 */
  GetFPAListeModelesTVA?: ArrayOfModeleTvafpaModel;
  /** from Activite_NA */
  GetFamille?: Union_50922305263755211;
  /** from Mediatheque */
  GetFamilleMediathequeFull?: ParamMediathequeFamilleModel;
  /** from ModulesAdministration1 */
  GetFicheProfilInfosAffichageOnglets?: ArrayOfFicheProfilInfosAffichageOnglet;
  /** from Benef_NA */
  GetFicheProfilModel?: BenefFicheProfilModel;
  /** from ModulesBenef */
  GetFicheSignaletiqueModel?: FicheSignaletiqueModelDto;
  /** from Administration4 */
  GetFicheTrombinoscope?: TrombinoscopeInitialiationTrombinoscopeFicheModel;
  /** from Activite_NA9 */
  GetFilDAriane?: FilDArianeFpaModel;
  /** from Compta21 */
  GetFiltresArreteCaisse?: ArreteCaisseListeFiltresArreteCaisseModel;
  /** from Compta22 */
  GetFiltresRemiseEnCaisseCentrale?: FiltresRemiseEnCaisseCentraleModel;
  /** from Activite_NA3 */
  GetFormulaire?: FormulaireFullModel;
  /** from Activite_NA4 */
  GetFormulaireArticle?: Union_2051424951178096057;
  /** from Activite_NA4 */
  GetFormulaireLigneCommande?: Union_2051424951178096057;
  /** from Activite_NA4 */
  GetFormulaireReponses?: Union_2051424951178096057;
  /** from Ventes7 */
  GetFraisAnnulation?: ArrayOfLigneDevisModeleDto;
  /** from Benef5 */
  GetGabaritNewsletterHTMl?: string;
  /** from Mediatheque5 */
  GetGenresMedia?: ArrayOfstring;
  /** from Commun1 */
  GetHeuresPerm?: ArrayOfPermHeureDto;
  /** from Stock2 */
  GetHistoriqueCessionStock?: ArrayOfCessionStockInfosHistoriqueModel;
  /** from Imports1 */
  GetHistoriqueDesImports?: RadgridviewPagineModelDtoOfImportHistoDetailsModelDtoWfN5Koph;
  /** from Activite_NA11 */
  GetHistoriqueExecutionImportArticle?: RetourHistoriqueExecutionImportArticle;
  /** from Application3 */
  GetHistoriqueUser?: ArrayOfUserHistoriqueModel;
  /** from Compta_NA7 */
  GetIBANModel?: Union_11709815821493216246;
  /** from Mediatheque5 */
  GetISBNDoublons?: ArrayOfstring;
  /** from Ventes_NA3 */
  GetIdActiviteCommande?: number;
  /** from Ventes_NA1 */
  GetIdActiviteFacture?: number;
  /** from Ventes_NA4 */
  GetIdBenefCommande?: number;
  /** from Ventes_NA4 */
  GetIdBenefFacture?: number;
  /** from Ventes_NA1 */
  GetIdCeCommande?: number;
  /** from Ventes_NA1 */
  GetIdCeFacture?: number;
  /** from Ventes_NA7 */
  GetIdCommandeFournisseur?: number;
  /** from Activite1 */
  GetIdCompteAFPA?: number;
  /** from Compta_NA4 */
  GetIdCompteReglementFiduciaire?: number;
  /** from Compta_NA2 */
  GetIdCompteTiersBenefDepuisCommande?: number;
  /** from Compta_NA */
  GetIdCompteVenteArticle?: number;
  /** from Compta20 */
  GetIdCptBancaireParDefautSurActivite?: number;
  /** from ModulesActivite */
  GetIdCptBancaireWithListIdFact?: number;
  /** from Commun2 */
  GetIdDelegationGlobale?: number;
  /** from Activite_NA10 */
  GetIdEnveloppeRegle?: number;
  /** from Compta14 */
  GetIdExerciceOfEcriture?: number;
  /** from Compta14 */
  GetIdExerciceOfFacture?: number;
  /** from Activite_NA5 */
  GetIdFamilleEpargne?: number;
  /** from Activite1 */
  GetIdJournalDefaut?: number;
  /** from Activite1 */
  GetIdJournalVenteActiviteDefaut?: number;
  /** from ModulesActivite */
  GetIdJournalWithIdCptBancAndIdMPayement?: number;
  /** from Article5 */
  GetIdModeEnvoiANCV?: number;
  /** from Activite_NA6 */
  GetIdModeleFraisAnnulation?: number;
  /** from Communication4 */
  GetIdTypePublipostage?: number;
  /** from Application */
  GetImageLibrairie?: ArrayOfFichierModel;
  /** from Application */
  GetImagesBibliotheque?: ArrayOfFichierCompletModel;
  /** from Ventes_NA6 */
  GetImpayesAvoirsAcomptes?: ArrayOfImpayesAvoirsAcomptesModel;
  /** from ModulesActivite */
  GetInfoArticleCommandeLocation?: InformationLocationDto;
  /** from Compta18 */
  GetInfoCountAndSum?: InfoEcritureDisplayModel;
  /** from Mediatheque5 */
  GetInfoRetourHistoriqueMediatheque?: InfoRetourHistoriqueMediathequeModel;
  /** from ApplicationMobile */
  GetInformations?: AppMobileInfosModel;
  /** from RessourcesPartagees1 */
  GetInformationsFacturationMasse?: InfosFacturationMasseRpModel;
  /** from Compta_NA9 */
  GetInformationsNouveauRapprochement?: InformationsNouveauRapprochementModel;
  /** from Ventes4 */
  GetInformationsSiteForExportANCV?: VerifSiteForExportAncvModel;
  /** from Ventes6 */
  GetInfosAvoir?: InfosAvoirModel;
  /** from Ventes */
  GetInfosBenefRP?: InfosBenefRpModel;
  /** from ModulesAdministration1 */
  GetInfosBenefSynchronisationSynapse?: ArrayOfSynchDataModel;
  /** from Widgets1 */
  GetInfosBeneficiairesData?: WidgetInfosBeneficiairesDto;
  /** from DossierPrestation4 */
  GetInfosChgtStatutLigneRmbMensuel?: InfoAcceptationLigneRmbMensuel;
  /** from Ventes_NA6 */
  GetInfosCommandePourLivraisonRapide?: LivraisonsInfosCommandePourLivraisonRapideModel;
  /** from Compta18 */
  GetInfosControleModificationEcriture?: InfosControleModificationEcritureModel;
  /** from Commun2 */
  GetInfosCurrentCEDeleg?: CeDelegationContactModel;
  /** from Application */
  GetInfosDemarrageConnexion?: InfosDemarrageModelDto;
  /** from DossierPrestation4 */
  GetInfosDossierPrestaRemboursementMensuel?: InfoDossierPrestationRmbMensuel;
  /** from Ventes5 */
  GetInfosFactureForReglementWorkFlow?: ArrayOfFactureInfosFactureForReglementWorkFlow;
  /** from Ventes_NA9 */
  GetInfosImpressionFacture?: InfosFactureForImpressionModel;
  /** from DossierPrestation4 */
  GetInfosInitRecherchePJ?: DossierPrestationInitInfosRecherchePjModelDto;
  /** from DossierPrestation3 */
  GetInfosLigneDossierDossierForModification?: CadeauxInfosModificationLigneDossierEvementFamilliaux;
  /** from Mediatheque */
  GetInfosRechercheBenefMediaMediatheque?: MediathequeInfosMediathequeBenefMediaModelDto;
  /** from DossierPrestation4 */
  GetInfosSuppressionDossierRmbMensuel?: boolean;
  /** from DossierPrestation4 */
  GetInfosValidationLigneDossierRmbMensuel?: InfoValidationLigneDossierRmbMensuel;
  /** from Widgets */
  GetInfosWidgetInfosBeneficiaires?: WidgetInfosBeneficiairesModelDto;
  /** from ModulesVentes4 */
  GetInitAttributionAutoModel?: InitAttributionAutoModel;
  /** from ModulesActivite */
  GetInitDataForReglement?: InitReglementModelDto;
  /** from Compta10 */
  GetInitForPopupMouvement?: InitModelForPopupMouvement;
  /** from Compta12 */
  GetInitForPopupMouvementComptableModel?: PopupMouvementComptableInitialisationModelDto;
  /** from Compta19 */
  GetInitModelParametrageComptes511?: Compte511InitCompte511Model;
  /** from ModulesAdministration */
  GetInitParamFicheProfilModel?: ModeleInitParamFicheProfile;
  /** from Ventes_NA3 */
  GetInitPopupReglementEpargneAG?: InitReglementEpargneAgModel;
  /** from Administration1 */
  GetInitialisationAdministrationsMenus?: MenusInitialisationModuleGestionMenusModel;
  /** from Administration1 */
  GetInitialisationAdministrationsPortlets?: PortletsInitialisationModuleGestionPortletsModel;
  /** from Stock1 */
  GetInitialisationDonnesFiltrageCessionStock?: ModeleInitFiltrageCessionModel;
  /** from Article6 */
  GetInitialisationExportFournisseur?: ExportCommandeFournisseurModel;
  /** from Compta12 */
  GetInitialisationForUCModeleSaisieEcriture?: ModeleSaisieEcritureInitModelForUcModeleSaisieEcritureDto;
  /** from Benef3 */
  GetInitialisationModeExpertModel?: InitialiserModeExpertBenefModelDto;
  /** from Administration6 */
  GetInitialisationParametresPortletsActualites?: PortletsInitialisationParametresPortletActualites;
  /** from Administration4 */
  GetInitialisationParametresPortletsAuthentif?: PortletsInitialisationModulePortletsParametresAuthentifModel;
  /** from Administration2 */
  GetInitialisationParametresPortletsDocument?: PortletsInitialisationModulePortletsParametresDocumentModel;
  /** from Administration6 */
  GetInitialisationParametresPortletsListeArticle?: PortletsInitialisationParametresPortletListeArticle;
  /** from Administration4 */
  GetInitialisationParametresPortletsPFB?: PortletsInitialisationModulePortletsParametresPfbModel;
  /** from Administration5 */
  GetInitialisationParametresPortletsSoldeEnvAttrib?: PortletsInitialisationParametresPortletSoldeEnvAttrib;
  /** from Administration4 */
  GetInitialisationParametresPortletsTrombinoscope?: PortletsInitialisationModulePortletsParametresTrombinoscopeModel;
  /** from Administration1 */
  GetInitialisationParametresSkins?: OptionsInitialisationModuleGestionSkinsModel;
  /** from Compta5 */
  GetLastBanqueForTiers?: string;
  /** from Application1 */
  GetLastUserNote?: UserNoteVersionModel;
  /** from Compta14 */
  GetLettreSuivanteEcriture?: string;
  /** from Compta_NA3 */
  GetLibelleAFPAFromSectionAnalytique?: ArrayOfLibellesAfpaModel;
  /** from Activite_NA9 */
  GetLibelleAFPAModeleTVA?: ArrayOfLibellesAfpaModel;
  /** from Compta_NA1 */
  GetLibelleActiviteModeleEcheancier?: string;
  /** from Compta_NA7 */
  GetLibelleModeleTVAAssocie?: string;
  /** from Activite_NA10 */
  GetLibelleProduit?: string;
  /** from Directo */
  GetLienEspaceEnLigneActivite?: string;
  /** from Directo */
  GetLienFicheProfil?: string;
  /** from Compta21 */
  GetLigneArreteCaissePourMoyenPaiementFidu?: Union_16290039003644539366;
  /** from ModulesVentes1 */
  GetLigneDevisModel?: LigneDevisModeleDto;
  /** from DossierPrestation2 */
  GetLigneDossierPrestationForUpdate?: Union_41875787341757271086;
  /** from Compta23 */
  GetLigneRemiseEnCaisseFiduciaire?: LigneRemiseEnCaisseForValidationFiduModel;
  /** from Compta21 */
  GetLignesArreteCaissePourMoyenPaiementNonFidu?: ArreteCaisseListeLignesArreteCaisseNonFidu;
  /** from ModulesBenef */
  GetListADDevis?: ArrayOfAyantDroitModelDto;
  /** from ModulesActivite */
  GetListActiviteModel?: ArrayOfActiviteModel;
  /** from Application1 */
  GetListAlerte?: ArrayOfAlertesDto;
  /** from ModulesVentes1 */
  GetListAttributionAutoModel?: ArrayOfAttributionAutoModelDto;
  /** from Ventes3 */
  GetListBLBRListModel?: RadgridviewPagineModelDtoOfBlbrListModelWfN5Koph;
  /** from Caisse */
  GetListCaisseGenerique?: ArrayOfCaisseDto;
  /** from Ventes1 */
  GetListCommandeInfoLivrer?: RadgridviewPagineModelDtoOfCommandeLivraisonModelWfN5Koph;
  /** from Compta7 */
  GetListCompteJournalPRMAutoFidu?: ArrayOfCompteJournalPrmAutoFiduDto;
  /** from Administration */
  GetListCompteursPointsGenerique?: ArrayOfCompteurPointDto;
  /** from Ventes1 */
  GetListEnteteDevisCommandeModel?: ArrayOfEnteteDevisCommandeModel;
  /** from Article */
  GetListFamilleModel?: ArrayOfFamilleModel;
  /** from Fournisseurs */
  GetListFournisseursGenerique?: ArrayOfFournisseurDto;
  /** from Ventes1 */
  GetListIdCommandeInfoLivrer?: ArrayOfdecimal;
  /** from Ventes6 */
  GetListIdLigneCommande?: ArrayOfdecimal;
  /** from Article */
  GetListImportFamille?: ArrayOfFamilleImportModelDto;
  /** from Imports */
  GetListImportTraitDonnees?: ArrayOfImportTraitDonneesDto;
  /** from Compta_NA5 */
  GetListJournauxFromIdEcriture?: ArrayOfJournalEcritureModel;
  /** from Ventes */
  GetListLigneCommandeGenerique?: ArrayOfLigneCommandeDto;
  /** from ModuleLocalisation */
  GetListLocalisationModelDTO?: ListLocalisationModel;
  /** from ReqSpecif */
  GetListParamReqSpecifGenerique?: ArrayOfParamReqSpecifDto;
  /** from Commun */
  GetListPerm?: ArrayOfPermDto;
  /** from ModulesAdministration1 */
  GetListProfilsSubvention?: ArrayOfProfilSubventionModelDto;
  /** from Commun1 */
  GetListRIBGenerique?: ArrayOfRibDto;
  /** from Reporting */
  GetListReportModAdrGenerique?: ArrayOfReportModeleAdrdto;
  /** from ReqSpecif */
  GetListReqSpecifGenerique?: ArrayOfReqSpecifDto;
  /** from ModulesVentes3 */
  GetListRglAndListAvoirModel?: ListReglListAvoirAcompteModel;
  /** from ModulesVentes2 */
  GetListSessionChoix?: ArrayOfSessionChoixDto;
  /** from Activite_NA */
  GetListeAFPA?: ArrayOfTreeviewAfpaModel;
  /** from Article2 */
  GetListeANCVModeEnvoiGenerique?: ArrayOfAncvModeEnvoiDto;
  /** from Compta_NA4 */
  GetListeAPFALiesModeleEcheancier?: ArrayOfLibellesAfpaModel;
  /** from Ventes4 */
  GetListeAchatArticleModel?: ArrayOfArticleModelDto;
  /** from Ventes4 */
  GetListeAchatLigneCdeModel?: ArrayOfAchatLigneCdeModelDto;
  /** from Ventes5 */
  GetListeAcompteCommandeModelDTO?: ArrayOfReglementModelDto;
  /** from Ventes2 */
  GetListeAcompteModelWithIdCde?: ArrayOfAcompteModelDto;
  /** from Activite_NA11 */
  GetListeActiviteBaseAndCode?: ArrayOfActiviteAndCodeModel;
  /** from Activite3 */
  GetListeActiviteCompteBanaireType?: ArrayOfActiviteCompteBancaireTypeDto;
  /** from Directo */
  GetListeActiviteFamilleLienDirecto?: ArrayOfActiviteFamillesLienDirectoModelDto;
  /** from Activite */
  GetListeActiviteGenerique?: ArrayOfActiviteDto;
  /** from DossierPrestation5 */
  GetListeActivitesCadeauxPrestation?: ArrayOfActiviteLightModel;
  /** from ListesLight */
  GetListeActivitesLight?: ArrayOfActiviteLightModel;
  /** from ApplicationMobile */
  GetListeActualites?: RadgridviewPagineModelDtoOfActualiteMobileListeModelDtoWfN5Koph;
  /** from Adresse */
  GetListeAdresseGenerique?: ArrayOfAdresseDto;
  /** from ListesLight2 */
  GetListeAdressesANCVLight?: ArrayOfstring;
  /** from Widgets */
  GetListeAgendaGenerique?: ArrayOfAgendaDto;
  /** from Files */
  GetListeAlbumsLinked?: ArrayOfEditAlbumLightModel;
  /** from Benef3 */
  GetListeAnneeReference?: ArrayOfAnneeReferenceDto;
  /** from Benef_NA1 */
  GetListeAnneesReferenceBeneficiaire?: ArrayOfAnneeReferenceValideModel;
  /** from ListesLight1 */
  GetListeAnneesReferenceLight?: ArrayOfAnneeReferenceBaseModel;
  /** from Annonce */
  GetListeAnnoncesFiltree?: ArrayOfAnnonceDto;
  /** from Compta11 */
  GetListeArborescenceRubriquage?: RubriquageTreeviewModelDto;
  /** from Compta21 */
  GetListeArreteCaisse?: RadgridviewPagineModelDtoOfArreteEtRemiseCaisseListerModelWfN5Koph;
  /** from Article3 */
  GetListeArticleCadeauModel?: ArrayOfFpaPrestaArticleCadeauModel;
  /** from Article5 */
  GetListeArticleChequier?: ArrayOfArticleChequierModel;
  /** from Article5 */
  GetListeArticleChequierBorne?: ArrayOfArticleChequierBorneModel;
  /** from Article2 */
  GetListeArticleChequierGenerique?: ArrayOfArticleChequierDto;
  /** from Activite_NA5 */
  GetListeArticleCloture?: ArrayOfArticleClotureModel;
  /** from Administration7 */
  GetListeArticleEditFromDoc?: ArrayOfArticleEditorialWithStatutModel;
  /** from ModulesVentes */
  GetListeArticleForVente?: ArrayOfArticleVenteModeleDto;
  /** from Activite1 */
  GetListeArticleFournisseur?: ArrayOfArticleFournisseurFpaPrixRemiseModel;
  /** from Article1 */
  GetListeArticleGenerique?: ArrayOfArticleDto;
  /** from Article3 */
  GetListeArticleGeneriqueByFournisseur?: ArrayOfAchatLigneCdeModelDto;
  /** from Activite */
  GetListeArticleLigneAvoirModel?: ArrayOfArticleLigneAvoirModelDto;
  /** from Article1 */
  GetListeArticleLocationModel?: ArrayOfArticleLocationModel;
  /** from Article1 */
  GetListeArticleModel?: ArrayOfArticleModel;
  /** from Mediatheque4 */
  GetListeArticleTransfertStock?: ArrayOfExemplaireMediaTransfertStockModel;
  /** from ListesLight */
  GetListeArticlesEditorielLight?: ArrayOfArticleEditorielLightModel;
  /** from Compta19 */
  GetListeArticlesImputationEnErreur?: RadgridviewPagineModelDtoOfArticleImputationEnErreurModelWfN5Koph;
  /** from ListesLight */
  GetListeArticlesLight?: ArrayOfArticleLightModel;
  /** from Fournisseurs */
  GetListeArticlesNonGeneriquesSansPrixAchat?: ArrayOfstring;
  /** from ModuleAttributionBudget */
  GetListeAttributionBudget?: ArrayOfAttributionBudgetModelDto;
  /** from ModuleAttributionRan */
  GetListeAttributionRanModele?: ArrayOfAttributionRanModelDto;
  /** from ModuleAttributionBudget1 */
  GetListeAttributionSubventionByIdEnveloppe?: ArrayOfAttributionSubventionForEnveloppeModel;
  /** from Administration3 */
  GetListeBackgroundPortail?: ArrayOfOptionsVignettesOptionsModel;
  /** from Administration3 */
  GetListeBandeauxPortail?: ArrayOfOptionsVignettesOptionsModel;
  /** from Administration4 */
  GetListeBandeauxPortlet?: ArrayOfPortletPortletCssModel;
  /** from Compta6 */
  GetListeBanqueGenerique?: ArrayOfBanqueDto;
  /** from Compta4 */
  GetListeBanquesFromMouvementComptable?: ArrayOfstring;
  /** from Activite_NA10 */
  GetListeBaremesRegles?: ArrayOfBorneStatWithBornesModel;
  /** from Benef */
  GetListeBenefComboModel?: ArrayOfBenefComboModel;
  /** from Benef */
  GetListeBenefModelsForCombo?: ArrayOfBenefComboModel;
  /** from Compta_NA1 */
  GetListeBenefMouvementEnAttente?: ModificationRibMandatModel;
  /** from ModulesAdministration */
  GetListeBeneficiaireForSynchronisation?: ArrayOfBenefSynchroModelDto;
  /** from ModulesAdministration */
  GetListeBeneficiaireForSynchronisationSynapse?: BenefSynchroSynapseListResult;
  /** from Benef */
  GetListeBeneficiaireGenerique?: ArrayOfBenefDto;
  /** from Benef */
  GetListeBeneficiaireGeneriqueWithCount?: RadgridviewPagineModelDtoOfBenefDtoWfN5Koph;
  /** from Benef */
  GetListeBeneficiaireNonValide?: string;
  /** from Communication3 */
  GetListeBeneficiairesContactesPublipostage?: ArrayOfBenefBenefMatriculeModel;
  /** from Benef5 */
  GetListeBeneficiairesNonContactable?: ArrayOfBenefDto;
  /** from Widgets */
  GetListeBenefsForWidgetInfosBenef?: ArrayOfInfosBeneficiairesModelDto;
  /** from Administration8 */
  GetListeBorderRadiusTheme?: ArrayOfPortailSkinRadiusDto;
  /** from ModuleBudget */
  GetListeBudgetModele?: ArrayOfBudgetModelDto;
  /** from Administration */
  GetListeCEDelegationGenerique?: ArrayOfCeDelegationDto;
  /** from ListesLight1 */
  GetListeCaissesLight?: ArrayOfComptaCaisseModelDto;
  /** from Mediatheque */
  GetListeCatalogues?: RadgridviewPagineModelDtoOfMediathequeListeCatalogueMediaModelWfN5Koph;
  /** from Mediatheque3 */
  GetListeCataloguesRechercheAvancee?: RadgridviewPagineModelDtoOfMediathequeListeCatalogueMediaModelWfN5Koph;
  /** from Administration5 */
  GetListeCategories?: ArrayOfPortailEditorialCategorieDto;
  /** from Annonce */
  GetListeCategoriesAnnonceGenerique?: ArrayOfAnnonceCategorieDto;
  /** from Stock2 */
  GetListeCessionStockBaseModel?: ArrayOfCessionStockBaseModel;
  /** from Champ */
  GetListeChampGenerique?: ArrayOfChampDto;
  /** from Champ2 */
  GetListeChampTypeData?: ArrayOfChampTypeDataCodeModel;
  /** from Champ1 */
  GetListeChampTypeDonneeGenerique?: ArrayOfChampTypeDonneeDto;
  /** from Champ1 */
  GetListeChampValeurByCodeChamp?: ArrayOfChampListeValeurChampListeValeurModel;
  /** from Champ2 */
  GetListeChampValeurByIdChamp?: ArrayOfChampListeValeurChampListeValeurLightModel;
  /** from Champ */
  GetListeChampValeurGenerique?: ArrayOfChampValeurDto;
  /** from Communication */
  GetListeChampVue?: ListeChampVueModel;
  /** from Communication */
  GetListeChampsByGroupeAffichage?: ArrayOfPubliChampsGroupeAffichageModel;
  /** from Activite_NA11 */
  GetListeChampsFormulaireActivite?: ArrayOfChampFormulaireLibelleModel;
  /** from Activite_NA2 */
  GetListeChampsFormulaires?: ArrayOfChampFormulaireListingModel;
  /** from Activite_NA2 */
  GetListeChampsFormulairesByIdProduit?: ArrayOfChampFormulaireLibelleModel;
  /** from Activite_NA8 */
  GetListeChampsFormulairesByIdRoomingList?: ArrayOfChampFormulaireLibelleModel;
  /** from Activite_NA8 */
  GetListeChampsFormulairesLigneCdeByIdProduit?: ArrayOfChampFormulaireLibelleModel;
  /** from Champ */
  GetListeChampsGenerique?: ArrayOfChampDto;
  /** from Imports1 */
  GetListeChampsHistorisesImport?: ArrayOfstring;
  /** from Activite_NA3 */
  GetListeChampsParametrageFormulaire?: ArrayOfChampFormulaireParametrageModel;
  /** from Champ1 */
  GetListeChampsPersoForNewFPA?: ChampsPlusValeursModel;
  /** from Champ1 */
  GetListeChampsPersoPlusValeurs?: ChampsPlusValeursModel;
  /** from Benef_NA1 */
  GetListeChampsPersonnalisesBeneficiaire?: ArrayOfChampPersoBeneficiaireModel;
  /** from Champ2 */
  GetListeChampsType?: ArrayOfChampChampTypeModel;
  /** from Compta13 */
  GetListeChequeModel?: RadgridviewPagineModelDtoOfComptaMouvementComptableModelDtOnJ9m3fvh;
  /** from Article3 */
  GetListeChequierGenerique?: ArrayOfChequierDto;
  /** from Article5 */
  GetListeChequiers?: ArrayOfChequierModel;
  /** from Champ2 */
  GetListeChoixPrefixeExportEcriture?: ArrayOfChampLibelleModel;
  /** from Compta10 */
  GetListeClesRepartitionModel?: ArrayOfCleRepartitionModelDto;
  /** from Application3 */
  GetListeCodeFonctionnaliteWidgetAccessible?: ListeCodeFonctionnalitesWidgetsAccessibleModel;
  /** from Ventes_NA9 */
  GetListeCommandeFournisseur?: RadgridviewPagineModelDtoOfCommandeFournisseurListingModelWfN5Koph;
  /** from DossierPrestation6 */
  GetListeCommandeFournisseurPartAChargeListingModel?: RadgridviewPagineModelDtoOfCommandeFournisseurPartAChargeListingModelWfN5Koph;
  /** from Ventes_NA4 */
  GetListeCommandeHistorique?: RadgridviewPagineModelDtoOfDevisCommandeListingModelWfN5Koph;
  /** from DossierPrestation6 */
  GetListeCommandesBeneficiairesPartACharge?: RadgridviewPagineModelDtoOfCommandeBeneficiairePartAChargeListingModelWfN5Koph;
  /** from Administration5 */
  GetListeCommentaires?: RadgridviewPagineModelDtoOfCommentaireModerationModelWfN5Koph;
  /** from Activite1 */
  GetListeCommission?: ArrayOfCommissionCommissionModel;
  /** from Activite */
  GetListeCommissionGenerique?: ArrayOfCommissionDto;
  /** from Communication4 */
  GetListeCommissionMail?: ArrayOfCommissionMailModel;
  /** from Application3 */
  GetListeCommissions?: ArrayOfParamCommissionModel;
  /** from Administration7 */
  GetListeCommissionsPortail?: ArrayOfCommissionModelWithclos;
  /** from Compta19 */
  GetListeCompte511AgregByCompteBancaire?: ArrayOfCompte511AgregCompte511AgregModel;
  /** from Compta_NA6 */
  GetListeCompteAssociationTVA?: ArrayOfCompteAssociationTvaModel;
  /** from Compta6 */
  GetListeCompteBancaireGenerique?: ArrayOfCompteBancaireDto;
  /** from Compta6 */
  GetListeCompteBancaireModel?: ArrayOfCompteBancaireModelDto;
  /** from Compta13 */
  GetListeCompteBancaireModelCompta?: ArrayOfComptaCompteBancaireModelDto;
  /** from Compta20 */
  GetListeCompteBaseModel?: ArrayOfCompteBaseModel;
  /** from Fournisseurs */
  GetListeCompteCourantFour?: ArrayOfCompteCourantADebiterOuCrediterModelDto;
  /** from Compta3 */
  GetListeCompteEcritureGenerique?: ArrayOfCompteEcritureDto;
  /** from Compta17 */
  GetListeCompteForClotureOngletTresorie?: RadgridviewPagineModelDtoOfCompteClotureForTresorieWfN5Koph;
  /** from Compta1 */
  GetListeCompteGenerique?: ArrayOfCompteDto;
  /** from Compta_NA9 */
  GetListeCompteLightVisibleEnLigne?: ArrayOfCompteLightVisibleEnLigneModel;
  /** from Compta */
  GetListeCompteModelGenerique?: ArrayOfCompteModelDto;
  /** from Compta12 */
  GetListeCompteModelSaisieEcriture?: ArrayOfComptaCompteModelDto;
  /** from Compta7 */
  GetListeCompteReglementFiduciaireModel?: ArrayOfCompteReglementFiduciaireModelDto;
  /** from Compta1 */
  GetListeCompteSimplifieModelGenerique?: ArrayOfCompteSimplifieModelDto;
  /** from Compta23 */
  GetListeCompteWithInfosCollectifModel?: ArrayOfCompteCollectifModel;
  /** from Compta_NA4 */
  GetListeComptes511?: Compte511MouvementModel;
  /** from ListesLight1 */
  GetListeComptesBancairesLight?: ArrayOfComptesBancairesCompteBancaireLightModel;
  /** from Compta_NA7 */
  GetListeComptesBancairesWithICS?: ArrayOfCompteBancaireWithIcs;
  /** from ListesLight */
  GetListeComptesLight?: ArrayOfCompteLightModel;
  /** from ListesLight1 */
  GetListeComptesLightClos?: ArrayOfCompteLightClosModel;
  /** from Compta_NA4 */
  GetListeComptesMouvement?: ArrayOfComptaCompteModelDto;
  /** from Activite_NA8 */
  GetListeCompteurPointAFPA?: ArrayOfCompteurPointAfpaModel;
  /** from Activite_NA9 */
  GetListeCompteurPointModelBase?: ArrayOfCompteurPointBaseModel;
  /** from ModulesAdministration1 */
  GetListeConsoBenefSynchro?: ArrayOfConsoBenefSynchroModelDto;
  /** from Benef6 */
  GetListeConsoMvtPointHistorique?: ArrayOfMouvementConsoPointHistoriqueModel;
  /** from Administration8 */
  GetListeCouleurPrincipale?: ArrayOfPortailSkinCouleurPrincipaleDto;
  /** from Administration8 */
  GetListeCouleurSecondaire?: ArrayOfPortailSkinCouleurSecondaireDto;
  /** from Courrier */
  GetListeCourrierEnvoiLigneNewsletter?: ArrayOfCourrierCourrierEnvoiLigneModel;
  /** from Courrier */
  GetListeCourrierEnvoiNewsletterHistorique?: ArrayOfCourrierCourrierEnvoiModel;
  /** from Communication1 */
  GetListeCourrierForListing?: ArrayOfListerCourrierModel;
  /** from Courrier */
  GetListeCourrierGenerique?: ArrayOfCourrierDto;
  /** from Courrier */
  GetListeCourrierHistoEnvoiGenerique?: ArrayOfCourrierHistoEnvoiDto;
  /** from Courrier1 */
  GetListeCourrierWithCodeTypeReport?: ArrayOfCourrierBaseWithCodeTypeModel;
  /** from Files1 */
  GetListeCourriersLinked?: ArrayOfCourrierEnvoiLightModel;
  /** from Communication2 */
  GetListeCourriersPublipostageAvecVue?: ArrayOfPublipostageCourrierPublipostageVueModel;
  /** from Communication */
  GetListeCriteres?: ArrayOfChampsCriterePubliChampsModel;
  /** from Ventes_NA6 */
  GetListeDeclencheurOfStatut?: ArrayOfStatutPersoActionModel;
  /** from Commun2 */
  GetListeDelegationBaseModel?: ArrayOfDelegationBaseModel;
  /** from Commun2 */
  GetListeDelegationIsGlobaleModel?: ArrayOfCeDelegIsGlobaleModel;
  /** from Adresse */
  GetListeDepartementsGenerique?: ArrayOfDepartementDto;
  /** from Ventes4 */
  GetListeDevisCdeModel?: RadgridviewPagineModelDtoOfDevisCommandeModelDtoWfN5Koph;
  /** from Ventes1 */
  GetListeDevisCdeModelEtNombreLignes?: EnteteDevisModelEtNombreDevis;
  /** from Ventes */
  GetListeDevisCommandeDataPager?: RadgridviewPagineModelDtoOfDevisCommandeDtoWfN5Koph;
  /** from Ventes */
  GetListeDevisCommandeGenerique?: ArrayOfDevisCommandeDto;
  /** from Ventes_NA7 */
  GetListeDevisCommandeInfosReglementsMasse?: ReglementsMasseModel;
  /** from ModulesVentes4 */
  GetListeDevisForInscriptionGroupes?: RadgridviewPagineModelDtoOfInfosDevisCdeInscriptionGroupeModelWfN5Koph;
  /** from Files */
  GetListeDocumentsGED?: ArrayOfFichierCompletModel;
  /** from Files */
  GetListeDocumentsGEDModel?: GedListeDocumentsGedModel;
  /** from Activite */
  GetListeDonneesActiviteGraphModel?: ArrayOfGraphiqueModelDto;
  /** from Commun */
  GetListeDonneesGraphModel?: ArrayOfGraphiqueModelDto;
  /** from Ventes_NA3 */
  GetListeDossierEpargneLister?: RadgridviewPagineModelDtoOfDossierEpargneListerModelWfN5Koph;
  /** from Application3 */
  GetListeDroitsPortail?: ArrayOfDroitPortailModel;
  /** from Compta12 */
  GetListeEcheancierModel?: RadgridviewPagineModelDtoOfEcheancierModelDtoWfN5Koph;
  /** from Compta17 */
  GetListeEcritureBalanceOuvertureModel?: RadgridviewPagineModelDtoOfEcritureBalanceOuvertureModelWfN5Koph;
  /** from Compta18 */
  GetListeEcritureForConsultation?: RadgridviewPagineModelDtoOfEcritureListingModelWfN5Koph;
  /** from Compta18 */
  GetListeEcritureMouvementModelExport?: RadgridviewPagineModelDtoOfEcritureExportModelWfN5Koph;
  /** from Compta13 */
  GetListeEcritureRecetteDepense?: RadgridviewPagineModelDtoOfRecetteDepenseEcritureRecetteDepenseModelDto5szyLq5Y;
  /** from Compta_NA8 */
  GetListeEcrituresAffichageBaseModel?: ArrayOfInfosEcritureAffichageBaseModel;
  /** from Compta18 */
  GetListeEcrituresAnalytiqueEnErreur?: RadgridviewPagineModelDtoOfEcritureAnalytiqueEnErreurModelWfN5Koph;
  /** from Compta19 */
  GetListeEcrituresDesequilibrees?: RadgridviewPagineModelDtoOfEcritureDesequilibreeModelWfN5Koph;
  /** from Compta_NA8 */
  GetListeEcrituresWrongLettrage?: ArrayOfInfosEcritureAffichageBaseModel;
  /** from Files1 */
  GetListeElementLinked?: ListElementLightModel;
  /** from Files1 */
  GetListeElementsAssociesAlbum?: ArrayOfElementAssocieDocModel;
  /** from Files1 */
  GetListeElementsAssociesDocuments?: ArrayOfElementAssocieDocModel;
  /** from ModuleBudget */
  GetListeEngagementBudget?: ArrayOfEngagementBudgetModelDto;
  /** from Commun */
  GetListeEntetesBaremeGenerique?: ArrayOfEnteteBaremeDto;
  /** from Activite */
  GetListeEnveloppeGenerique?: ArrayOfEnveloppeQuotaDto;
  /** from ModulesEnveloppe */
  GetListeEnveloppeModeleGenerique?: ArrayOfModeleEnveloppeDto;
  /** from ListesLight2 */
  GetListeEnveloppesBase?: ArrayOfEnveloppeBaseModel;
  /** from Compta_NA6 */
  GetListeEtatPreparatoireForHisto?: ArrayOfTvaEtatPreparatoireHistoModel;
  /** from Mediatheque2 */
  GetListeExemplairesForRechercheMedia?: RadgridviewPagineModelDtoOfExemplaireMediathequeRechercheMediaModelDtOs7iMPt1y;
  /** from Compta16 */
  GetListeExerciceBaseModel?: ArrayOfExerciceModelDto;
  /** from Compta15 */
  GetListeExerciceForCloture?: ArrayOfExerciceClotureModel;
  /** from Compta17 */
  GetListeExerciceInfos?: ArrayOfExerciceInfos;
  /** from Compta */
  GetListeExerciceModel?: ArrayOfExerciceModelDto;
  /** from Activite_NA6 */
  GetListeFPAActivite?: AfpaFiltreModel;
  /** from Activite_NA11 */
  GetListeFPACodeUtilise?: ArrayOfParametrageFpaCodeUtiliseModel;
  /** from Activite_NA9 */
  GetListeFPAFiltre?: AfpaFiltreModel;
  /** from Ventes */
  GetListeFactures?: ArrayOfFactureInfosFactureModel;
  /** from Widgets1 */
  GetListeFacturesData?: WidgetListeFacturesDto;
  /** from Ventes1 */
  GetListeFacturesGenerique?: ArrayOfFactureDto;
  /** from Widgets1 */
  GetListeFacturesModelForWidget?: ArrayOfWidgetFacturesModelDto;
  /** from Ventes6 */
  GetListeFacturesPourHistorique?: RadgridviewPagineModelDtoOfFactureHistoriqueModelWfN5Koph;
  /** from Administration3 */
  GetListeFamilleDirectoModel?: ArrayOfCommunFamilleDirectoModel;
  /** from Article */
  GetListeFamilleProduitGenerique?: ArrayOfFamilleProduitDto;
  /** from Article */
  GetListeFamilleproduitModel?: ArrayOfFamilleProduitModel;
  /** from ListesLight */
  GetListeFamillesLight?: ArrayOfFamilleLightModel;
  /** from Mediatheque */
  GetListeFamillesMediathequeLight?: ArrayOfMediathequeFamilleLightModel;
  /** from Directo */
  GetListeFicheProfilDataGenerique?: ArrayOfFicheProfilDataDirectoDto;
  /** from Application2 */
  GetListeFonctionnalitesProfil?: ArrayOfFonctionnalitesProfilModel;
  /** from Activite_NA3 */
  GetListeFormulaire?: ArrayOfFormulaireCommandeClotureModel;
  /** from Activite_NA3 */
  GetListeFormulaireCommande?: ArrayOfReponseFormulaireModel;
  /** from Activite_NA4 */
  GetListeFormulairesParticipant?: ArrayOfReponseFormulaireParticipantModel;
  /** from Administration5 */
  GetListeFormulairesSpecifiques?: ArrayOfPortailFormulaireSpecifiqueDto;
  /** from ListesLight2 */
  GetListeFournisseurNonClosLight?: ArrayOfFournisseurBaseModel;
  /** from Fournisseurs */
  GetListeFournisseurRemiseGlobale?: ArrayOfFournisseurRemiseGlobaleModel;
  /** from Activite_NA6 */
  GetListeFraisAnnulation?: ArrayOfFraisAnnulationBaseModel;
  /** from Activite_NA6 */
  GetListeFraisAnnulationSupprimable?: ArrayOfFraisAnnulationSupprimableModel;
  /** from User */
  GetListeGestionnaire?: ArrayOfGestionnaireDto;
  /** from User */
  GetListeGestionnaireParametre?: ArrayOfGestionnaireDto;
  /** from Activite_NA7 */
  GetListeGroupesRoomingList?: ArrayOfGroupeRoomingListModel;
  /** from Imports */
  GetListeHistoImportGenerique?: ArrayOfImportHistoDto;
  /** from Communication4 */
  GetListeHistoriqueEnvoi?: RadgridviewPagineModelDtoOfHistoriqueCourrierHistoriquePublipostageModel_SnbEoFHh;
  /** from Communication2 */
  GetListeHistoriqueEnvoiPublipostage?: RadgridviewPagineModelDtoOfHistoriqueCourrierHistoriquePublipostageModel_SnbEoFHh;
  /** from Ventes7 */
  GetListeHistoriqueStatut?: ArrayOfHistoStatutCommandeDto;
  /** from Application5 */
  GetListeHomeNotifications?: ArrayOfListeHomeNotification;
  /** from Widgets */
  GetListeIANModel?: ArrayOfInfosAstucesNouveautesModelDto;
  /** from ListesLight2 */
  GetListeIBANMandatsLight?: ArrayOfIbanMandatLightModel;
  /** from Compta_NA8 */
  GetListeIban?: ArrayOfIbanParametrageBaseModel;
  /** from Compta_NA4 */
  GetListeIbansTiers?: ArrayOfEditerIbanTiers;
  /** from Ventes_NA1 */
  GetListeIdArticleCommande?: ArrayOfdecimal;
  /** from Benef_NA2 */
  GetListeIdBenef?: ArrayOfdecimal;
  /** from Ventes_NA9 */
  GetListeIdCommandes?: ArrayOfdecimal;
  /** from Administration7 */
  GetListeIdCommissionFromOptionsGenerales?: ArrayOfdecimal;
  /** from Compta_NA5 */
  GetListeIdCompteAttente?: ArrayOfdecimal;
  /** from Ventes_NA1 */
  GetListeIdLigneCommande?: ArrayOfdecimal;
  /** from User */
  GetListeIdStocksAutorises?: ArrayOfdecimal;
  /** from Ventes_NA6 */
  GetListeIdsAcomptes?: ArrayOfdecimal;
  /** from Ventes_NA1 */
  GetListeIdsCommande?: ArrayOfdecimal;
  /** from Files */
  GetListeImagesCommonGED?: ArrayOfFichierCompletModel;
  /** from Imports */
  GetListeImportHistoStatutGenerique?: ArrayOfImportHistoStatutDto;
  /** from Imports */
  GetListeImportModeleGenerique?: ArrayOfImportModeleDto;
  /** from Imports */
  GetListeImportModeleTypeGenerique?: ArrayOfImportModeleTypeDto;
  /** from Imports */
  GetListeImportReqPrepost?: ArrayOfImportReqPrepostDto;
  /** from DossierPrestation3 */
  GetListeInfosAcompteFourDossierPresta?: ArrayOfFactureInfosFactureAcompteFourPrestaModel;
  /** from Assolution */
  GetListeInfosAssociationConnectionV2?: ArrayOfRemonterBaseReferenceModelDto;
  /** from Ventes */
  GetListeInfosFactureModelDataPager?: RadgridviewPagineModelDtoOfFactureInfosFactureModel8lIa1pkA;
  /** from Compta21 */
  GetListeInfosGeneralesMouvementComptable?: RadgridviewPagineModelDtoOfMouvementComptableInfosGeneralesModelWfN5Koph;
  /** from Ventes_NA */
  GetListeInfosHistoriquePretsEtDons?: RadgridviewPagineModelDtoOfInfosDossiersPretsEtDonsHistoriqueModelDtoWfN5Koph;
  /** from Ventes8 */
  GetListeInfosLignesCommandeFournisseur?: ArrayOfAchatLigneCdeModelDto;
  /** from Stock */
  GetListeInventaireGenerique?: ArrayOfInventaireDto;
  /** from Compta20 */
  GetListeJournaux?: ArrayOfJournalBaseModel;
  /** from Ventes4 */
  GetListeJournauxAndExerciceModel?: ListeJournauxAndExerciceModelDto;
  /** from Compta23 */
  GetListeJournauxCaisseMoyenPaiementFidu?: ArrayOfCaisseCaisseJournauxReglementFiduModel;
  /** from Compta1 */
  GetListeJournauxGenerique?: ArrayOfJournalDto;
  /** from ListesLight */
  GetListeJournauxLight?: ArrayOfJournalLightModel;
  /** from Compta13 */
  GetListeLettrageModel?: LettrageEtNombreElementModel;
  /** from Compta14 */
  GetListeLettreEcrituresFromFacture?: ArrayOfstring;
  /** from Benef_NA */
  GetListeLibellesChampsModifiablesHistoriqueBenef?: ArrayOfstring;
  /** from Directo */
  GetListeLienDirectoGenerique?: ArrayOfLienDirectoDto;
  /** from Directo */
  GetListeLiensDirecto?: ArrayOfLienDirectoModelDto;
  /** from Lieu */
  GetListeLieuxGenerique?: ArrayOfLieuDto;
  /** from Ventes3 */
  GetListeLigneAvoirModel?: ArrayOfLigneAvoirModelDto;
  /** from Ventes4 */
  GetListeLigneCdeFourArticleReappro?: ArrayOfLigneCdeFourArticleReapproModelDto;
  /** from Stock2 */
  GetListeLigneCessionStock?: RadgridviewPagineModelDtoOfLigneReceptionCessionStockModelWfN5Koph;
  /** from Stock2 */
  GetListeLigneCessionStockDetail?: RadgridviewPagineModelDtoOfLigneCessionStockDetailModelWfN5Koph;
  /** from ModulesVentes3 */
  GetListeLigneCommandeLibre?: ArrayOfLigneCommandeLibreModelDto;
  /** from Ventes3 */
  GetListeLigneFactureAvoirModel?: ArrayOfLigneAvoirModelDto;
  /** from Activite2 */
  GetListeLigneHistoriqueReservationRP?: RadgridviewPagineModelDtoOfLigneCommandeHistoriqueReservationRpModelWfN5Koph;
  /** from Mediatheque2 */
  GetListeLigneHistoriqueReservations?: RadgridviewPagineModelDtoOfConstantes_StatutsMediathquesLigneReservationModelWfN5Koph;
  /** from Stock1 */
  GetListeLigneInventaire?: RadgridviewPagineModelDtoOfLigneInventaireStockModelWfN5Koph;
  /** from Stock */
  GetListeLigneInventaireGenerique?: ArrayOfLigneInventaireDto;
  /** from Ventes7 */
  GetListeLigneOfCommande?: ArrayOfLigneDevisModeleDto;
  /** from Compta5 */
  GetListeLigneRemiseEnBanqueModel?: ArrayOfLigneRemiseEnBanqueModel;
  /** from Compta23 */
  GetListeLigneRemiseEnCaisseNonFiduciaire?: ArrayOfLigneRemiseEnCaisseForValidationNonFiduModel;
  /** from Stock3 */
  GetListeLigneTransfertStock?: ArrayOfLigneCessionStockTransfertStockModel;
  /** from Stock3 */
  GetListeLignesCessionStockPourModification?: ArrayOfLigneCessionStockDetailModel;
  /** from Ventes_NA4 */
  GetListeLignesCommandesAttribution?: RadgridviewPagineModelDtoOfAttributionsLigneCommandeAttributionModel9TKbPa9D;
  /** from Courrier */
  GetListeLignesEnvoiModel?: ArrayOfLignesEnvoiModelDto;
  /** from Imports1 */
  GetListeLignesPreview?: ImportHistoImportRapportPreviewLignesModel;
  /** from Article4 */
  GetListeLocationsPourAttributionAuto?: RadgridviewPagineModelDtoOfArticleAttributionAutoWfN5Koph;
  /** from Article4 */
  GetListeLocationsTauxOccupation?: RadgridviewPagineModelDtoOfLocationTauxOccupationModelWfN5Koph;
  /** from Activite_NA10 */
  GetListeLogsAFPA?: ArrayOfLogAfpaHistoriqueModel;
  /** from Compta_NA1 */
  GetListeMandatUsed?: ArrayOfMandatUseModel;
  /** from Imports1 */
  GetListeMappingValeurColonnes?: ArrayOfImportColonneAMapperValeurModel;
  /** from Application */
  GetListeMenuGenerique?: ArrayOfMenuDto;
  /** from Application */
  GetListeMessageAppliGenerique?: ArrayOfMessageAppliDto;
  /** from Ventes_NA7 */
  GetListeModalitesReglementCommandeAvailable?: CommandeListeModaliteReglementModel;
  /** from ModulesVentes */
  GetListeModeLivraisonModelForVentesClients?: ArrayOfModeLivraisonModeleDto;
  /** from Article3 */
  GetListeModelArticleActiviteBase?: ArrayOfArticleActiviteBaseModel;
  /** from Mediatheque4 */
  GetListeModelBlocageExemplaire?: ArrayOfBlocageExemplaireModel;
  /** from Compta17 */
  GetListeModelClotureReportDesTiers?: RadgridviewPagineModelDtoOfClotureReportDesTiersModelWfN5Koph;
  /** from Communication1 */
  GetListeModelEmailPubli?: ArrayOfModelEmailModelEmailVuePubliModel;
  /** from Communication1 */
  GetListeModelEmailPubliLight?: ArrayOfModelEmailModelEmailVuePubliModelLight;
  /** from Article4 */
  GetListeModelProduitAvecIdFamille?: ArrayOfProduitBaseAvecIdFamilleModel;
  /** from Article5 */
  GetListeModelProduitClos?: ArrayOfProduitBaseClosModel;
  /** from Reporting */
  GetListeModeleAdresse?: ArrayOfModeleAdresseModelDto;
  /** from Compta17 */
  GetListeModeleClotureVariationStock?: ConsultationClotureVariationStockModel;
  /** from Compta_NA1 */
  GetListeModeleEcheancieActivite?: ArrayOfModeleEchancierListingModel;
  /** from Compta_NA1 */
  GetListeModeleEcheancier?: ArrayOfModeleEchancierListingModel;
  /** from Activite_NA8 */
  GetListeModeleEcheancierFPA?: ArrayOfModeleEcheancierGeneriqueModel;
  /** from Compta_NA1 */
  GetListeModeleEcheancierInfos?: ArrayOfParamModeleEchancierModel;
  /** from ModulesEnveloppe */
  GetListeModeleEnveloppeForAFPA?: ModeleAffichageEnveloppeDto;
  /** from Article3 */
  GetListeModeleLocation?: ArrayOfModeleLocationBaseModel;
  /** from Communication2 */
  GetListeModeleMail?: ArrayOfModelEmailModelEmailClotureModel;
  /** from ModulesMoteurRegle */
  GetListeModeleMoteurRegleForParamAFPAGenerique?: ModeleAffichageRegleDto;
  /** from ModulesMoteurRegle */
  GetListeModeleMoteurRegleGenerique?: ArrayOfMoteurRegleModelDto;
  /** from ModulesMoteurRegle */
  GetListeModeleRegleLocaleForDuplication?: ArrayOfMoteurRegleModelDto;
  /** from Compta12 */
  GetListeModeleSaisieEcriture?: ArrayOfModeleSaisieEcritureModeleSaisieEcritureModelDto;
  /** from Commun1 */
  GetListeModeleSaisieLibreGenerique?: ArrayOfModeleSaisieLibreDto;
  /** from Application1 */
  GetListeModelesAdresse?: ArrayOfModeleAdresseBaseModel;
  /** from Communication3 */
  GetListeModelesRequete?: ArrayOfRequetePubliRequeteBaseModel;
  /** from Compta_NA5 */
  GetListeModelesTVA?: ArrayOfParametrageTvaSimpleModel;
  /** from ListesLight1 */
  GetListeModelesTVALight?: ArrayOfModeleTvaLightModel;
  /** from Article1 */
  GetListeModesLivraison?: ArrayOfModeLivraisonDto;
  /** from Benef_NA */
  GetListeModificationsByCriteresPagine?: RadgridviewPagineModelDtoOfHistoriqueModifBenefsHistoriqueModifBenefForAffichageModelDjsizrkj;
  /** from Article5 */
  GetListeModseEnvoiANCV?: ArrayOfModeEnvoiAncvModel;
  /** from Application */
  GetListeModulesInfo?: ArrayOfModuleInfoDto;
  /** from Moteur */
  GetListeMoteurRegleTypeDateRef?: ArrayOfMoteurRegleTypeDateRefDto;
  /** from Compta16 */
  GetListeMouvementComptableForCloture?: RadgridviewPagineModelDtoOfComptaMouvementComptableModelDtOnJ9m3fvh;
  /** from Compta4 */
  GetListeMouvementComptableGenerique?: ArrayOfMouvementComptableDto;
  /** from Compta4 */
  GetListeMouvementComptableModel?: RadgridviewPagineModelDtoOfComptaMouvementComptableModelDtOnJ9m3fvh;
  /** from Benef5 */
  GetListeMouvementConsoModel?: RadgridviewPagineModelDtoOfConsultationMouvementConsommationModelWfN5Koph;
  /** from Compta_NA7 */
  GetListeMouvementInfosLettrageAuto?: ArrayOfInfosMouvementLettrageAutoModel;
  /** from Compta4 */
  GetListeMouvementModelEtNombreLignes?: UcListeMouvementsComptablesListeMouvementModelEtNbLignesDto;
  /** from Stock */
  GetListeMouvementStockModel?: RadgridviewPagineModelDtoOfMouvementStockModelDtoWfN5Koph;
  /** from Compta9 */
  GetListeMouvementsAnalytiquesModel?: RadgridviewPagineModelDtoOfMouvementAnalytiqueModelDtoWfN5Koph;
  /** from Compta24 */
  GetListeMouvementsCollectifSansTiers?: RadgridviewPagineModelDtoOfMouvementCollectifSansTiersModelWfN5Koph;
  /** from DossierPrestation3 */
  GetListeMouvementsReglementsModel?: ArrayOfMouvementReglementModel;
  /** from Compta_NA2 */
  GetListeMouvementsRemisEnBanque?: ArrayOfMouvementComptableRemiseBanqueModele;
  /** from Compta24 */
  GetListeMouvementsSansTiersDuCompte?: RadgridviewPagineModelDtoOfMouvementSansTiersDetailModelWfN5Koph;
  /** from Stock */
  GetListeMouvementsStockGenerique?: ArrayOfMouvementStockDto;
  /** from Compta20 */
  GetListeMoyenPaiementCommunForListeFactures?: ArrayOfMoyenPaiementDto;
  /** from Activite_NA8 */
  GetListeMoyenPaiementForEcheancierAFPA?: ArrayOfMoyenPaiementAfpaModel;
  /** from Compta */
  GetListeMoyenPaiementGenerique?: ArrayOfMoyenPaiementDto;
  /** from Compta12 */
  GetListeMoyenPaiementModelGenerique?: ArrayOfMoyenPayementModelDto;
  /** from Benef2 */
  GetListeMoyenneCompteurPoint?: ArrayOfConsoMouvementCptPointDto;
  /** from ListesLight1 */
  GetListeMoyensPaiementLight?: ArrayOfMoyensPaiementMoyenPaiementLightModel;
  /** from Stock */
  GetListeNatureMouvementsStockGenerique?: ArrayOfNatureMouvementStockDto;
  /** from Benef4 */
  GetListeNewsletterModele?: ArrayOfNewsletterNewsletterModeleModel;
  /** from Benef4 */
  GetListeNewsletterTheme?: ArrayOfNewsletterNewsletterThemeModel;
  /** from Benef5 */
  GetListeNewsletterThemeFromCourrier?: ArrayOfNewsletterNewsletterThemeModel;
  /** from Connexion */
  GetListeNomCEV2?: ArrayOfBaseV2Model;
  /** from Administration8 */
  GetListeOmbreTheme?: ArrayOfPortailSkinOmbreDto;
  /** from Application1 */
  GetListeOrganisationBaseModel?: ArrayOfOrganisationBaseModel;
  /** from Benef1 */
  GetListeOrganisationGenerique?: ArrayOfOrganisationDto;
  /** from Benef6 */
  GetListeOrganisationGeneriqueAPlat?: ArrayOfOrganisationDto;
  /** from Application4 */
  GetListeOrganisationsBaseModelSiteOrganisation?: ArrayOfSiteOrganisationBaseModel;
  /** from Benef_NA */
  GetListePJADODComplete?: ArrayOfPieceJustificativeBenefModel;
  /** from Benef_NA */
  GetListePJByListeCodeType?: ArrayOfInfosPjTypeModel;
  /** from Benef_NA1 */
  GetListePJDiversForBenef?: ArrayOfPieceJustificativeBenefModel;
  /** from ListesLight */
  GetListePJLight?: ArrayOfPjBaseModel;
  /** from ListesLight1 */
  GetListePJLightFiltre?: ArrayOfLibTypePjBaseModel;
  /** from DossierPrestation5 */
  GetListeParticipantsLigneDossier?: ArrayOfRelationOdadModel;
  /** from Activite_NA1 */
  GetListePermanences?: ArrayOfPermanencePermanenceBaseModel;
  /** from Activite_NA2 */
  GetListePermanencesParamActivite?: ArrayOfPermanenceParamActiviteModel;
  /** from Commun2 */
  GetListePieceJustificative?: ArrayOfPjCompletModel;
  /** from Benef3 */
  GetListePieceJustificativeBenefModel?: ArrayOfPieceJustificativeBenefModel;
  /** from DossierPrestation1 */
  GetListePieceJustificativeDossierPrestationModel?: ArrayOfPieceJustificativeBenefModel;
  /** from Commun */
  GetListePieceJustificativeGenerique?: ArrayOfPieceJustificativeDto;
  /** from DossierPrestation1 */
  GetListePieceJustificativeModelGenerique?: ArrayOfPieceJustificativeBenefModel;
  /** from DossierPrestation4 */
  GetListePieceJustificativesForRecherche?: RadgridviewPagineModelDtoOfDossierPrestationPieceJustificativeForRechercheModelDtOgD04_PDwX;
  /** from DossierPrestation4 */
  GetListePieceJustificativesForWidget?: RadgridviewPagineModelDtoOfDossierPrestationPieceJustificativeForWidgetModelDtOgD04_PDwX;
  /** from DossierPrestation2 */
  GetListePiecesJustificatives?: ArrayOfDossierPrestationPieceJustificativeModelDto;
  /** from Compta8 */
  GetListePlanAnalytiqueGenerique?: ArrayOfPlanAnalytiqueModelDto;
  /** from Compta_NA7 */
  GetListePlanCompte?: ArrayOfComptesPlanCompteModel;
  /** from Compta9 */
  GetListePlanSectionAnalytique?: ArrayOfPlanSectionAnalytiqueModelDto;
  /** from Compta20 */
  GetListePlanWithSectionsAnalytiques?: ArrayOfPlanWithSectionsAnalytiquesModel;
  /** from Administration */
  GetListePointVente?: ArrayOfPointVenteDto;
  /** from Commun1 */
  GetListePointVenteGenerique?: ArrayOfPointVenteDto;
  /** from Administration1 */
  GetListePortailArticleGenerique?: ArrayOfPortailArticleDto;
  /** from Administration3 */
  GetListePortailDocumentCategorieGenerique?: ArrayOfPortailDocumentCategorieDto;
  /** from Administration3 */
  GetListePortailStatutGenerique?: ArrayOfPortailStatutDto;
  /** from ModuleBudget */
  GetListePosteBudgetaireModele?: ArrayOfPosteBudgetaireModelDto;
  /** from Activite_NA7 */
  GetListeProduitAvecIdFamille?: ArrayOfProduitBaseAvecIdFamilleModel;
  /** from Activite_NA5 */
  GetListeProduitEpargne?: ArrayOfEditerProduitClotureModel;
  /** from Article */
  GetListeProduitGenerique?: ArrayOfProduitDto;
  /** from Article */
  GetListeProduitModel?: ArrayOfProduitModel;
  /** from Article6 */
  GetListeProduitsBaseClos?: ArrayOfProduitBaseClosModel;
  /** from ListesLight */
  GetListeProduitsLight?: ArrayOfProduitLightModel;
  /** from Administration1 */
  GetListeProfilDroitMenuTypeActiviteModelGenerique?: ArrayOfProfilDroitMenuTypeActiviteModelDto;
  /** from ModulesAdministration */
  GetListeProfilKalidea?: ArrayOfProfilKalideaModelDto;
  /** from Administration8 */
  GetListeProfilsMonEspaceCSE?: ArrayOfProfilEspaceCse;
  /** from Communication2 */
  GetListePubliDocumentReport?: ArrayOfPubliDocumentReportModel;
  /** from Communication */
  GetListePubliVue?: RadgridviewPagineModelDtoOfPubliVueBaseInfoModelWfN5Koph;
  /** from Communication4 */
  GetListePublichpDynamiques?: ArrayOfChampsCriterePubliChampsModel;
  /** from Compta8 */
  GetListeRapprochementModeleGenerique?: ArrayOfModeleHistoRaprpochementDto;
  /** from Adresse */
  GetListeRegionsGenerique?: ArrayOfRegionDto;
  /** from Ventes7 */
  GetListeReglementsFacture?: ArrayOfdecimal;
  /** from Activite_NA9 */
  GetListeReglesBase?: ArrayOfRegleBaseModel;
  /** from Moteur */
  GetListeReglesParent?: ArrayOfRegleExpertModel;
  /** from Activite_NA9 */
  GetListeReglesUseAFPA?: ArrayOfRegleUseAfpaModel;
  /** from Compta7 */
  GetListeReleveBancaire?: ArrayOfReleveBancaireDto;
  /** from Compta5 */
  GetListeRemiseEnBanqueGenerique?: ArrayOfBanqueRemiseDto;
  /** from Compta5 */
  GetListeRemiseEnBanqueModelGenerique?: RadgridviewPagineModelDtoOfRemiseEnBanqueModelWfN5Koph;
  /** from Compta22 */
  GetListeRemiseEnCaisse?: RadgridviewPagineModelDtoOfArreteEtRemiseCaisseListerModelWfN5Koph;
  /** from Compta20 */
  GetListeRepartitionLigneFactureAnalytiqueModel?: ArrayOfCleRepartitionModelDto;
  /** from Compta5 */
  GetListeRepartitionMouvementAnalytiqueModel?: ArrayOfCleRepartitionModelDto;
  /** from Reporting */
  GetListeReportGenerique?: ArrayOfReportDto;
  /** from Communication3 */
  GetListeRequetesForListing?: RadgridviewPagineModelDtoOfPubliRequeteListerModelWfN5Koph;
  /** from RessourcesPartagees */
  GetListeRessources?: RadgridviewPagineModelDtoOfListerRessourceModelWfN5Koph;
  /** from Ventes6 */
  GetListeRessourcesForDispos?: ArrayOfDispoCategorieRessourcesPartageesModel;
  /** from Activite2 */
  GetListeRessourcesPartagees?: ArrayOfProduitReservationResxPartModel;
  /** from Ventes7 */
  GetListeRibNonClosBenef?: ArrayOfRibModelDto;
  /** from Activite_NA7 */
  GetListeRoomingList?: ArrayOfListerRoomingListModel;
  /** from Activite_NA7 */
  GetListeRoomingListeParticipants?: ArrayOfRoomingListeParticipantsModel;
  /** from Compta11 */
  GetListeRubriquage?: ArrayOfRubriquageModelDto;
  /** from Compta8 */
  GetListeSectionAnalytiqueGenerique?: ArrayOfSectionAnalytiqueModelDto;
  /** from Ventes5 */
  GetListeSessionChoixBaseModel?: ArrayOfSessionChoixBaseModel;
  /** from Application1 */
  GetListeSiteBaseModel?: ArrayOfSiteBaseModel;
  /** from Benef1 */
  GetListeSiteGenerique?: ArrayOfSiteDto;
  /** from Benef6 */
  GetListeSiteGeneriqueAPlat?: ArrayOfSiteDto;
  /** from Benef_NA2 */
  GetListeSiteLivraison?: ArrayOfSiteLivraison;
  /** from Application3 */
  GetListeSitesBaseModelSiteOrganisation?: ArrayOfSiteOrganisationBaseModel;
  /** from Benef2 */
  GetListeSoldeConsommations?: SoldeConsommationModelDto;
  /** from Compta_NA8 */
  GetListeSoldePMV?: RadgridviewPagineModelDtoOfSoldePmvModelWfN5Koph;
  /** from Ventes_NA6 */
  GetListeStatutAdmAvecPere?: ArrayOfInfoStatutModel;
  /** from Ventes_NA6 */
  GetListeStatutAdmForFiltre?: ArrayOfComboBoxStatutsModel;
  /** from Ventes_NA5 */
  GetListeStatutAdministratif?: ArrayOfStatutCommandeLibelleModel;
  /** from Ventes1 */
  GetListeStatutCommande?: ArrayOfStatutCommandeDto;
  /** from Ventes_NA4 */
  GetListeStatutCommandeNA?: ArrayOfStatutWithOrdreModel;
  /** from Courrier */
  GetListeStatutCourrierGenerique?: ArrayOfStatutCourrierDto;
  /** from ListesLight1 */
  GetListeStatutPersoBase?: ArrayOfStatutPersoBaseModel;
  /** from Ventes_NA5 */
  GetListeStatutPersoCouleur?: ArrayOfStatutPersoCouleurModel;
  /** from Ventes1 */
  GetListeStatutsFacture?: ArrayOfFactureStatutFactureOuCdeModel;
  /** from ListesLight1 */
  GetListeStatutsFactureLight?: ArrayOfStatutFactureBaseModel;
  /** from Stock1 */
  GetListeStockArticleGenerique?: ArrayOfStockArticleDto;
  /** from Stock1 */
  GetListeStockArticleModel?: ArrayOfStockArticleModelDto;
  /** from Stock */
  GetListeStockGenerique?: ArrayOfStockDto;
  /** from ListesLight */
  GetListeStockLight?: ArrayOfStockLightModel;
  /** from Mediatheque5 */
  GetListeStockLivraisonMediatheque?: ArrayOfStockModeleDto;
  /** from Stock3 */
  GetListeStockTypeReappro?: ArrayOfStockTypeReapproModel;
  /** from Stock */
  GetListeStockTypeReapproGenerique?: ArrayOfStockTypeReapproDto;
  /** from Commun2 */
  GetListeTagsBibliothequeImage?: ArrayOfstring;
  /** from Mediatheque4 */
  GetListeTransfertsPourHistorique?: RadgridviewPagineModelDtoOfTransfertStockPourListeModelWfN5Koph;
  /** from Administration4 */
  GetListeTrombinoscope?: TrombinoscopeInitialiationTrombinoscopeModel;
  /** from Administration4 */
  GetListeTrombinoscopeCommission?: ArrayOfTrombinoscopeTrombinoscopeModel;
  /** from Activite */
  GetListeTypeActiviteGenerique?: ArrayOfTypeActiviteDto;
  /** from Commun3 */
  GetListeTypeAnalyseIA?: ArrayOfTypeAnalyseIaModel;
  /** from ModulesMoteurRegle1 */
  GetListeTypeArrondi?: ArrayOfTypeArrondiModel;
  /** from Benef1 */
  GetListeTypeBenefGenerique?: ArrayOfTypeBenefDto;
  /** from Activite1 */
  GetListeTypeCalculModeLivraisonGenerique?: ArrayOfTypeCalculModeLivraisonDto;
  /** from Activite_NA3 */
  GetListeTypeChampFormulaire?: ArrayOfTypeChampFormulaireModel;
  /** from Benef2 */
  GetListeTypeConsoMouvement?: ArrayOfTypeConsoMouvementPointDto;
  /** from Compta */
  GetListeTypeMoyenPaiementGenerique?: ArrayOfTypeMoyenPaiementDto;
  /** from Commun3 */
  GetListeTypePJ?: ArrayOfTypePjAffichageModele;
  /** from Reporting */
  GetListeTypeReportGenerique?: ArrayOfReportTypeDto;
  /** from ListesLight2 */
  GetListeTypesDatesRegle?: ArrayOfRegleTypeDateModel;
  /** from Files */
  GetListeTypesDoc?: ArrayOfstring;
  /** from Files */
  GetListeTypesModels?: ArrayOfFichierTypeModel;
  /** from User */
  GetListeUserBase?: ArrayOfUserBaseModel;
  /** from Activite */
  GetListeUserCommissionGenerique?: ArrayOfUserCommissionDto;
  /** from User */
  GetListeUserGenerique?: ArrayOfUsersDto;
  /** from Application3 */
  GetListeUsersCommission?: ArrayOfUserCommissionModel;
  /** from ListesLight */
  GetListeUsersLight?: ArrayOfUserBaseModel;
  /** from User1 */
  GetListeUsersMail?: ArrayOfUserEmailModel;
  /** from Champ1 */
  GetListeValeurs?: ArrayOfSubventionValeurCritereModele;
  /** from Moteur */
  GetListeValeursChampRegleAccessibiliteMediatheque?: ArrayOfModeleRegleAccChpListValModeGuide;
  /** from Adresse */
  GetListeVillesGenerique?: ArrayOfVilleDto;
  /** from Commun */
  GetListeVueGenerique?: ArrayOfVueDto;
  /** from Communication */
  GetListeVuesAvecChamps?: ArrayOfVuePubliVueChampModel;
  /** from Widgets */
  GetListeWidgetAccueilParametreModel?: ArrayOfWidgetParametreModelDto;
  /** from Widgets */
  GetListeWidgetsAccueilGenerique?: ArrayOfWidgetAccueilDto;
  /** from Widgets */
  GetListeWidgetsGenerique?: ArrayOfWidgetDto;
  /** from Application2 */
  GetListeWidgetsProfil?: ArrayOfWidgetProfilModel;
  /** from ListesLight1 */
  GetListesBanqueLight?: ArrayOfBanqueLightModel;
  /** from Article3 */
  GetListesCadeauxFPAModel?: RadgridviewPagineModelDtoOfCadeauFpaModelWfN5Koph;
  /** from Administration1 */
  GetListesConnexionUtilisateur?: ConnexionUtilisateurModelDto;
  /** from ModulesMoteurRegle */
  GetListesDonneesReglesAvancees?: ListesDonneesReglesAvanceesModelDto;
  /** from DossierPrestation5 */
  GetListesPiecesJustificatives?: ListesPiecesJustificativesModel;
  /** from Imports1 */
  GetLogsDetailles?: RadgridviewPagineModelDtoOfImportLogsDetaillesModelDtoWfN5Koph;
  /** from Mediatheque1 */
  GetMediathequeEmpruntReservationFamilleModel?: MediathequeEmpruntReservationFamilleModel;
  /** from Mediatheque1 */
  GetMediathequeFicheMediaLightFamilleModel?: Union_7257672451169240978;
  /** from Mediatheque2 */
  GetMediathequeResaEnLigneFamilleModel?: MediathequeReservationEnLigneFamilleModel;
  /** from Ventes_NA9 */
  GetMiniDateDebutLocOrGroupe?: any;
  /** from Ventes_NA9 */
  GetMiniDateDebutLocOrGroupeByIdCde?: any;
  /** from Benef5 */
  GetModelBaseDescriptor?: BenefBenefModelBaseDescriptor;
  /** from Contacter */
  GetModelEmailGenerique?: ModelEmailDto;
  /** from Communication1 */
  GetModelEmailPubli?: ModelEmailModelEmailVuePubliModel;
  /** from Compta11 */
  GetModelInitEcritureComptable?: SaisieEcrituresInitSaisieEcrituresModelDto;
  /** from Stock1 */
  GetModelInitialisationForInventaireStock?: ModelInitInventaireStock;
  /** from Compta16 */
  GetModelInitialisationForODInventaire?: InitialisationParametrageClotureModel;
  /** from Mediatheque2 */
  GetModelInitialisationForRechercheMediaAvance?: MediathequeModelInitRechercheAvanceExemplaireMediaDto;
  /** from Compta15 */
  GetModelInitialisationOngletParametrage?: InitialisationParametrageClotureModel;
  /** from Ventes_NA1 */
  GetModelMontantDossierPretsEtDons?: MontantDossierPretsEtDonsModel;
  /** from ModulesMoteurRegle */
  GetModelMoteurRegle?: MoteurRegleModelDto;
  /** from Compta15 */
  GetModelParametrageCloture?: ParametrageClotureExerciceModel;
  /** from Article3 */
  GetModelParametrageModeleLocation?: ModeleLocationModel;
  /** from Compta22 */
  GetModelRemiseEnCaisseCentrale?: RemiseCaisseCentraleModel;
  /** from ModulesVentes1 */
  GetModelVerifiCationCondSupAnnBonRetourCommande?: ModeleVerificationSupAnnRemBonRetourCde;
  /** from ModulesVentes4 */
  GetModelVerificationSuppressionDossierPrestaCadeau?: ModeleVerificationSupAnnRemBonRetourCde;
  /** from Activite_NA */
  GetModeleActiviteParamAFPA?: ActiviteParamAfpaModel;
  /** from Activite_NA */
  GetModeleActiviteParamAFPAFromIdCommande?: ActiviteParamAfpaModel;
  /** from ModuleAttributionBudget */
  GetModeleChargementExecAttribution?: ModeleChargementAttBdgBenfDto;
  /** from ModulesVentes2 */
  GetModeleChoixDuplicationCommande?: ChoixDuplicationCommandeModelDto;
  /** from Communication1 */
  GetModeleCourrierPublipostage?: ModelesModeleCourrierPublipostageModel;
  /** from RessourcesPartagees */
  GetModeleCreationRessource?: ParamRessourceModel;
  /** from Communication3 */
  GetModeleEMailPublipostage?: ModelesModelEmailPieceJointeModel;
  /** from Compta_NA1 */
  GetModeleEcheancierInfos?: Union_1187615723202011850;
  /** from Compta_NA2 */
  GetModeleEditEcheancierActivite?: EditEcheancierModeleActiviteModel;
  /** from Champ2 */
  GetModeleEditionChampListeValeur?: EditionChampListeValeurModel;
  /** from ModulesEnveloppe */
  GetModeleEnveloppe?: ModeleEnveloppeDto;
  /** from Activite_NA5 */
  GetModeleEpargne?: ModeleEpargneModel;
  /** from Activite_NA6 */
  GetModeleFraisAnnulation?: FraisAnnulationModel;
  /** from ModuleAttributionRan */
  GetModeleInitAttributionRan?: AttributionRanInitModelDto;
  /** from Activite3 */
  GetModeleInitFPA?: InitFpaModelDto;
  /** from Mediatheque2 */
  GetModeleInitRechercheHistoriqueReservation?: InitRechercheHistoriqueReservationModel;
  /** from Activite_NA9 */
  GetModeleInitialisationWorkflow?: InitialisationWorkflowAfpaModel;
  /** from Communication2 */
  GetModeleMailPublipostage?: ModelesModelEmailPublipostageModel;
  /** from Activite_NA10 */
  GetModeleRegleAccessibilite?: Union_37323748901697156950;
  /** from Activite_NA10 */
  GetModeleRegleEnveloppe?: Union_37323748901697156950;
  /** from Activite_NA10 */
  GetModeleRegleEnveloppeAttribution?: Union_37323748901697156950;
  /** from Activite_NA10 */
  GetModeleRegleQuota?: Union_37323748901697156950;
  /** from Activite_NA9 */
  GetModeleRegleSubvention?: Union_37323748901697156950;
  /** from Communication3 */
  GetModeleRequete?: Union_33818115703809269357;
  /** from Moteur */
  GetModeleSaveReglesAFPADTO?: ModeleSaveReglesAfpadto;
  /** from Compta_NA5 */
  GetModeleTVA?: ParametrageTvaModel;
  /** from Ventes_NA2 */
  GetModificationParticipantsModel?: InfosDevisCapaciteLocationModel;
  /** from ModulesVentes2 */
  GetMontantFactImpayeeBenef?: number;
  /** from Activite2 */
  GetMontantListeCommandes?: number;
  /** from Ventes_NA3 */
  GetMontantsDossierEpargne?: MontantDossierEpargneModel;
  /** from DossierPrestation1 */
  GetMontantsDossierPrestation?: DossierPrestationMontantsDossierPrestationModelDto;
  /** from Compta_NA2 */
  GetMouvementsPrelevementAbondement?: ArrayOfMouvementsMouvementEpargne;
  /** from Benef2 */
  GetMoyenneCompteurPoint?: number;
  /** from ModulesVentes1 */
  GetNbLivraisonsEnAttente?: number;
  /** from Ventes7 */
  GetNbParticipants?: number;
  /** from ModulesVentes1 */
  GetNewLigneCommandeModelForVentes?: LigneDevisModeleDto;
  /** from DossierPrestation */
  GetNewParamEditionDossierPrestationModel?: ParamEditionDossierPrestationModelDto;
  /** from ApplicationMobile */
  GetNombreActusANotifier?: number;
  /** from Annonce */
  GetNombreAnnoncesGenerique?: number;
  /** from Fournisseurs */
  GetNombreArticlesAttenteCommandeFournisseur?: QuantiteArticlesFournisseur;
  /** from Compta_NA7 */
  GetNombreComptesAssociesModeleTVA?: number;
  /** from ApplicationMobile */
  GetNombreDevicesInscrits?: AppMobileNombreInscritsModelDto;
  /** from Ventes1 */
  GetNombreFacturesGenerique?: number;
  /** from Mediatheque2 */
  GetNombreMediaEnregistre?: EvolutionImportModel;
  /** from Mediatheque3 */
  GetNombreReservationBenefFileAttente?: number;
  /** from Ventes3 */
  GetNumeroFacture?: string;
  /** from Compta18 */
  GetOldDateEcriture?: any;
  /** from Benef1 */
  GetOrganisation?: OrganisationDto;
  /** from Application4 */
  GetParamAssoCEByCode?: string;
  /** from Compta11 */
  GetParamEcheancierModel?: ParamEcheancierModelDto;
  /** from DossierPrestation */
  GetParamEditionDossierPrestationModel?: ParamEditionDossierPrestationModelDto;
  /** from Activite2 */
  GetParamFamilleModel?: ParamRessourcePartageeFpaModel;
  /** from Application1 */
  GetParamSync?: ParamSyncModelDto;
  /** from ModulesActivite */
  GetParametrageActivite?: ParametrageActiviteModelDto;
  /** from Activite_NA4 */
  GetParametrageComptableActiviteEpargnes?: Union_20780602624083161499;
  /** from Activite_NA4 */
  GetParametrageComptableArticleEpargnes?: Union_20780602624083161499;
  /** from Compta6 */
  GetParametrageCompteBancaire?: ParametrageCompteBancaireModelDto;
  /** from Activite_NA4 */
  GetParametrageFormulaireFPA?: FormulaireFpaModel;
  /** from Activite_NA2 */
  GetParametragePermanencesActivite?: ListePermanenceActiviteModel;
  /** from DossierPrestation5 */
  GetParametreAjustementMontantPrisCompte?: string;
  /** from Administration3 */
  GetParametresPortletSondage?: PortletsInitialisationParametresPortletSondageModel;
  /** from Activite_NA1 */
  GetPermanence?: Union_13441779963965314999;
  /** from Compta_NA4 */
  GetPlanAnalytiqueWithSousSection?: PlanWithSectionsAnalytiquesModel;
  /** from Ventes_NA5 */
  GetPostClotureStatutModel?: PostClotureStatutModel;
  /** from ModuleBudget */
  GetPosteBudgetaireModele?: PosteBudgetaireModelDto;
  /** from Benef_NA1 */
  GetPrenomNomBenef?: string;
  /** from Benef_NA */
  GetPresentationBenef?: BenefPresentationModel;
  /** from Compta_NA8 */
  GetProchainNumeroPiece?: number;
  /** from Activite_NA */
  GetProduit?: Union_30188432553199321036;
  /** from Article1 */
  GetProduitWithArticleInfos?: ProduitWithArticleInfosModelDto;
  /** from Imports1 */
  GetProgressionImportEnCours?: ProgressionImportEnCoursModelDto;
  /** from Application4 */
  GetProgressionStep?: ProgressionModel;
  /** from Stock2 */
  GetQuantiteEnStockReel?: number;
  /** from Mediatheque3 */
  GetRecapitulatifImportCatalogueFinished?: RetourImportCatalogueModel;
  /** from Benef2 */
  GetRechercheSoldeConsommations?: RechercheSoldeConsommationsDto;
  /** from Application4 */
  GetRecommendationArticleMagazine?: ArrayOfArticleMagazineModel;
  /** from SynchroSynapse_NA */
  GetRefCalcAge?: ArrayOfRefCalcAgeSynAdModelDto;
  /** from Compta13 */
  GetReglesModificationMouvements?: ComptaReglesModificationMouvementModelDto;
  /** from Communication */
  GetRequeteSQlPublipostage?: string;
  /** from RessourcesPartagees */
  GetRessourceFull?: ParamRessourceModel;
  /** from Communication */
  GetResultatsPublipostage?: ArrayOfArrayOfstring;
  /** from Activite_NA7 */
  GetRoomingList?: RetourEditerRoomingListModel;
  /** from Compta9 */
  GetSectionAnalytiqueByPlanAndActiviteFPHA?: ArrayOfSectionAnalytiqueModelDto;
  /** from Compta9 */
  GetSectionAnalytiqueByPlanAndActiviteFPVEN?: ArrayOfSectionAnalytiqueModelDto;
  /** from Compta9 */
  GetSectionAnalytiqueByPlanAndActiviteTP?: ArrayOfSectionAnalytiqueModelDto;
  /** from Compta9 */
  GetSectionAnalytiqueByPlanAndArticle?: ArrayOfSectionAnalytiqueModelDto;
  /** from Compta9 */
  GetSectionAnalytiqueByPlanAndCompteBancaire?: ArrayOfSectionAnalytiqueModelDto;
  /** from Compta9 */
  GetSectionAnalytiqueByPlanAndDelegation?: ArrayOfSectionAnalytiqueModelDto;
  /** from Compta9 */
  GetSectionAnalytiqueByPlanAndFamilleProduit?: ArrayOfSectionAnalytiqueModelDto;
  /** from Compta9 */
  GetSectionAnalytiqueByPlanAndProduit?: ArrayOfSectionAnalytiqueModelDto;
  /** from ApplicationMobile */
  GetSimpleListeActualites?: ArrayOfListeActualiteMobileModel;
  /** from Article6 */
  GetSimulationChequierForBenef?: SimulationChequierDynamiqueModel;
  /** from Benef2 */
  GetSite?: SiteDto;
  /** from Compta_NA8 */
  GetSoldePMV?: SoldePmvModel;
  /** from ModuleAttributionBudget */
  GetSoldePMVBenef?: number;
  /** from Compta_NA8 */
  GetSoldePMVBenefCompta?: number;
  /** from Benef2 */
  GetSommeCptPt?: ArrayOfSommeCompteurPointModelDto;
  /** from Activite2 */
  GetSommeTarifsSurLigneCommande?: number;
  /** from ModulesVentes3 */
  GetSourcesCombosPopupAjoutModifLigneAvoir?: PopupAjoutModifligneAvoirModelDto;
  /** from ModulesCompta */
  GetSourcesCombosUCRechercheRemiseEnBanque?: UcRechercheRemiseEnBanqueDto;
  /** from Widgets1 */
  GetStatsBeneficiairesData?: WidgetStatsBeneficiairesDto;
  /** from Ventes7 */
  GetStatutFacture?: StatutFactureDto;
  /** from DossierPrestation1 */
  GetStatutLivraisonCommandeDossierPrestation?: string;
  /** from Ventes_NA5 */
  GetStatutPersoModel?: ParamStatutPersoModel;
  /** from Ventes */
  GetStatutsCommande?: StatutsCommandeModel;
  /** from Stock3 */
  GetStockWithCessionEnAttente?: number;
  /** from Ventes_NA2 */
  GetSubventionArticle?: number;
  /** from DossierPrestation3 */
  GetSubventionArticleCadeaux?: RetourMoteurModelDto;
  /** from Compta11 */
  GetSuiviTresorerieModel?: ArrayOfSuiviTresorerieModelDto;
  /** from SynchroSynapse_NA */
  GetSyncCritereAdList?: ArrayOfCritereSyncAdModelDto;
  /** from RessourcesPartagees1 */
  GetTarifLibelleDefautParArticle?: string;
  /** from RessourcesPartagees */
  GetTarifsFactures?: ArrayOfRessourcesPartageesTarifFactureModel;
  /** from Ventes */
  GetTempsReservation?: TempsReservationModel;
  /** from Administration6 */
  GetThemeCourant?: string;
  /** from Compta20 */
  GetTotalSommeCreditDebitMouvementsComptablesModel?: ComptaTotalSommeCreditDebitMouvementComptableModelDto;
  /** from Compta16 */
  GetTypeCalculVariationStockForCloture?: string;
  /** from Benef2 */
  GetTypeConsoMouvement?: TypeConsoMouvementPointDto;
  /** from SynchroSynapse_NA */
  GetTypeCritereSyncAdList?: ArrayOfTypeCritereSyncAdModelDto;
  /** from DossierPrestation5 */
  GetTypeDossierPresta?: string;
  /** from Compta6 */
  GetTypeEcritureByCode?: TypeEcritureDto;
  /** from Activite */
  GetUriForVisualisationActivite?: string;
  /** from ModulesAdministration */
  GetUriForVisualisationProfilBenef?: string;
  /** from Application3 */
  GetUrlSarm?: string;
  /** from Benef_NA2 */
  GetUrlZipDoneesBenefRGPD?: string;
  /** from Application5 */
  GetUserNotificationsVUP?: ArrayOfNotificationVup;
  /** from Champ3 */
  GetValeurParamHistorisationFromCodeChamp?: string;
  /** from Communication1 */
  GetValeursPossiblesListeValeurs?: ArrayOfChampsCritereListeValeursPubliChampsModel;
  /** from Application2 */
  GetValueParametreAssolution?: string;
  /** from Application1 */
  GetValueParametrePoidsMaxImage?: number;
  /** from Application1 */
  GetValueParametrePoidsMaxImageActuMobile?: number;
  /** from Application2 */
  GetValueParametrePublipostageLimiteAvertissement?: number;
  /** from Application2 */
  GetValueParametrePublipostageLimiteBlocage?: number;
  /** from Ventes4 */
  GetVerifGeneUniqueForExportANCV?: VerifGeneUniqueExpAncvModelDto;
  /** from Benef4 */
  GetVueExportModeExpert?: string;
  /** from Benef4 */
  GetVueExportModeExpertV2?: string;
  /** from Benef3 */
  GetVueModeExpertModel?: ChargerVueModeExpertBenefModelDto;
  /** from Benef3 */
  GetVueModeExpertModelV2?: ChargerVueModeExpertBenefModelDto;
  /** from Champ1 */
  GetlisteChampValeur?: ArrayOfChampListeValeurChampListeValeurModel;
  /** from Champ1 */
  GetlisteChampValeurNotChpPerso?: ArrayOfChampListeValeurChampListeValeurModel;
  /** from ModulesAdministration1 */
  Getparamuserlisteuser?: ParamUsersListeUsersModelDto;
  /** from Activite_NA9 */
  HasActiviteFraisAnnulation?: boolean;
  /** from Ventes_NA8 */
  HasCommandeModaliteReglement?: boolean;
  /** from Application4 */
  HasMultipleSitesActive?: boolean;
  /** from Reporting */
  HaveReportsLettreCheque?: boolean;
  /** from Ventes_NA9 */
  HistoriqueFiles?: ArrayOfFichierCommandeModel;
  /** from Compta6 */
  ISCompte512RattacheACompteBancaire?: boolean;
  /** from Imports */
  ImportExecuter?: string;
  /** from Article */
  ImportFamille?: string;
  /** from Mediatheque2 */
  ImporterCatalogue?: string;
  /** from Mediatheque5 */
  ImporterMedias?: string;
  /** from Activite3 */
  ImporterRestaurationLaCroix?: RetourImportRestaurationModel;
  /** from Ventes6 */
  ImputerAvoirAFacture?: number;
  /** from Compta_NA3 */
  ImputerEpargneSurCommande?: StatutDossierEpargneModel;
  /** from Compta12 */
  ImputerListeAcompteCommandeSurFacture?: number;
  /** from DossierPrestation */
  InitActionsGroupeesDossierPrestation?: ActionsGroupeesDossierPrestationModelDto;
  /** from Ventes_NA2 */
  InitEnteteDossierEpargne?: InitEnteteDossierEpargneResult;
  /** from Ventes_NA */
  InitEnteteDossierPretsEtDons?: InitEnteteDossierPretsEtDonsModel;
  /** from Ventes_NA3 */
  InitHistoriqueDossierEpargne?: InitHistoriqueDossierEpargneResult;
  /** from Ventes5 */
  InitInfosFournisseurSelectionne?: InfosAchatCommandeFournisseurSelectionneModelDto;
  /** from Compta_NA3 */
  InitMouvementsAnalytiquesForCloturerSection?: InitMouvementsAnalytiquesForCloturerSectionModel;
  /** from Compta17 */
  InitOngletReportDesTiers?: InitialisationReportDesTiersModel;
  /** from Compta16 */
  InitOngletVariationStock?: InitialisationVariationStockClotureModel;
  /** from Compta17 */
  InitialisationBalanceOuverture?: InitBalanceOuvertureModel;
  /** from ModulesVentes4 */
  InitialisationByIdCommandeForVentesClients?: VentesClientsModeleDto;
  /** from ModulesVentes4 */
  InitialisationByListIdArticleAndIdBenef?: VentesClientsModeleDto;
  /** from Compta_NA2 */
  InitialisationComptabiliteEpargnes?: InitComptabiliteEpargneModel;
  /** from ModulesVentes */
  InitialisationForCommandeLibre?: CommandeLibreModelDto;
  /** from ModulesVentes4 */
  InitialisationForInscriptionGRP?: VentesClientsModeleDto;
  /** from ModulesVentes4 */
  InitialisationForVentesClients?: VentesClientsModeleDto;
  /** from Reporting */
  InitialisationModeleImpression?: InitiModelImpressionDto;
  /** from Administration5 */
  InitialiserHistoriqueSalarie?: HistoriqueSalarieModel;
  /** from Activite3 */
  InitialiserImportRestaurationLaCroix?: InitialisationImportRestaurationModel;
  /** from Activite3 */
  InitialiserImpressionEtiquetteLaCroix?: InitialisationImpressionEtiquetteLaCroixModel;
  /** from Compta21 */
  InitialiserListingArreteCaisse?: InitListingArreteCaisseModel;
  /** from Activite_NA5 */
  InitialiserOngletArticleAssocie?: InitArticleAssocieEpargneModel;
  /** from Communication1 */
  InitialiserParametrageModelePublipostage?: ModelesInitParamModelesPublipostageModel;
  /** from Compta_NA3 */
  InitialiserPopupTropPercu?: InitTropPercuModel;
  /** from Ventes_NA5 */
  InverserOrdreStatutsPersos?: string;
  /** from Compta19 */
  Is511CompteBancaireHaveMouvements?: boolean;
  /** from Activite_NA11 */
  IsActiviteHasCompteAcompte?: boolean;
  /** from Activite_NA6 */
  IsAllowedCreationStatutPerso?: boolean;
  /** from Benef6 */
  IsAnneeReferenceValideCEForBenef?: boolean;
  /** from DossierPrestation5 */
  IsArticleLieToSynchEnveloppe?: boolean;
  /** from Benef_NA */
  IsBenefHasIban?: boolean;
  /** from Ventes5 */
  IsBenefHaveCommandeSurProduit?: boolean;
  /** from Application */
  IsCEHaveModule?: boolean;
  /** from Compta6 */
  IsCloturableCompteBancaire?: boolean;
  /** from Compta_NA7 */
  IsConformeTVA?: boolean;
  /** from Compta13 */
  IsDateEcheanceValide?: string;
  /** from Activite_NA8 */
  IsDateSubventionCoherente?: boolean;
  /** from Activite1 */
  IsDelegProprietaireActiviteGlobale?: boolean;
  /** from Compta_NA5 */
  IsExerciceClotureByIdEcriture?: boolean;
  /** from Compta_NA4 */
  IsExerciceExists?: boolean;
  /** from Compta8 */
  IsExistNumeroReleve?: string;
  /** from Ventes_NA9 */
  IsExistSiteWithAdressANCV?: boolean;
  /** from Compta_NA1 */
  IsExisteModeleEcheancier?: boolean;
  /** from ModulesMoteurRegle */
  IsExisteRegleBudget?: boolean;
  /** from ModulesMoteurRegle */
  IsExisteRegleLocale?: boolean;
  /** from ModulesMoteurRegle */
  IsExisteRegleTransverse?: boolean;
  /** from Activite2 */
  IsFacturationCentraliseeSurActivite?: boolean;
  /** from ModulesVentes4 */
  IsFacturationCentraliseeSurCommande?: boolean;
  /** from Administration8 */
  IsFilesAlbumUsed?: boolean;
  /** from Activite_NA4 */
  IsFormulairePresentSurCommande?: boolean;
  /** from Fournisseurs */
  IsFournisseurFavorisSurArticle?: boolean;
  /** from Ventes7 */
  IsLettreChequeImprimablePourFacture?: boolean;
  /** from Compta_NA4 */
  IsModeleEcheancierLinkedToFPA?: boolean;
  /** from Connexion */
  IsMotDePasseDifferent?: boolean;
  /** from Compta5 */
  IsNumeroBordereauAlreadyExists?: boolean;
  /** from Compta18 */
  IsParametrageComptableCorrect?: boolean;
  /** from Article5 */
  IsPeriodeLocationCoherente?: boolean;
  /** from Connexion */
  IsPremiereConnexionVUP?: boolean;
  /** from Activite_NA10 */
  IsProduitReapprovisionnement?: boolean;
  /** from Ventes6 */
  IsReglementAutoriseSurFacture?: boolean;
  /** from Connexion */
  IsSuperAdministrateur?: boolean;
  /** from Compta10 */
  IsSupprimableCloturablePlanAnalytique?: VerificationSuppresionPlanEtSectionModelDto;
  /** from Compta10 */
  IsSupprimableCloturableSectionAnalytique?: VerificationSuppresionPlanEtSectionModelDto;
  /** from Compta11 */
  IsSupprimableEcriture?: string;
  /** from Ventes5 */
  IsSupprimableEcritureWithErrorMessage?: DossierPrestationMessagesAnnulationTransfertEnCommandeModel;
  /** from Ventes2 */
  IsSupprimableFacture?: boolean;
  /** from Stock3 */
  IsSupprimableStock?: IsSupprimableStockModel;
  /** from Compta_NA5 */
  IsTVASurActiveeFromEcriture?: boolean;
  /** from Article5 */
  IsTypeChequeModifiable?: boolean;
  /** from Compta13 */
  IsUsedLettreSurExercice?: boolean;
  /** from User */
  IsUserAdminInDelegation?: boolean;
  /** from Nagios */
  IsWCFWork?: boolean;
  /** from Assolution */
  LancerProcedureSupressionConnexionEtRestaurationBase?: string;
  /** from ModulesAdministration */
  LancerSynchro?: string;
  /** from ModulesAdministration */
  LancerSynchroSynapse?: string;
  /** from SynchroSynapse_NA */
  LancerSynchroSynapseBenefsWithAd?: boolean;
  /** from Compta_NA7 */
  LettrageAuto?: string;
  /** from Application4 */
  LikeArticleMagazine?: string;
  /** from Ventes5 */
  LivraisonCadeauDossierPrestation?: InfosRetourLivraisonOuReceptionTotaleGroupeeCommande;
  /** from Mediatheque2 */
  LivraisonExemplaire?: string;
  /** from Ventes_NA3 */
  LivrerLignesCommandes?: Union_13581429883425318489;
  /** from Application2 */
  LoggerMenu?: string;
  /** from Application4 */
  LoggerPerformances?: string;
  /** from Contacter */
  LoginMotDePasseByEmail?: string;
  /** from Compta13 */
  MarquerListeChequeCommeRecu?: string;
  /** from Compta18 */
  MarquerPretAExporter?: ArrayOfEcritureExportModel;
  /** from Compta18 */
  MarquerTouteslesEcrituresPretAExporter?: string;
  /** from Mediatheque3 */
  ModificationDateEmpruntExemplaire?: boolean;
  /** from Compta20 */
  ModificationMandatDateOperation?: string;
  /** from DossierPrestation1 */
  ModifierEnteteDossierPresta?: boolean;
  /** from Activite_NA8 */
  ModifierLibelleGroupe?: string;
  /** from Benef4 */
  ModifierNewsletterTheme?: ArrayOfNewsletterNewsletterThemeModel;
  /** from ApplicationMobile1 */
  ModifierParamAppMobile?: string;
  /** from DossierPrestation1 */
  ModifierStatutLigneDossierPrestation?: DossierPrestationRetourEnregistrementLigneDossierPrestationModelDto;
  /** from DossierPrestation2 */
  ModifierStatutLigneDossierPrestationRetourPopup?: DossierPrestationRetourEnregistrementLigneDossierPrestationModelDto;
  /** from Ventes_NA */
  ModifierStatutLigneDossierPretsEtDons?: RetourEditerLigneDossierPretsEtDonsModel;
  /** from DossierPrestation2 */
  ModifierStatutListeLigneDossierPrestation?: boolean;
  /** from Ventes7 */
  NeedFiltrerArticleLocationNonDispo?: boolean;
  /** from ApplicationMobile */
  NotifierActualite?: string;
  /** from ApplicationMobile */
  NotifierNouvellesActus?: string;
  /** from Compta_NA3 */
  ParserCSVComptes?: ArrayOfArrayOfstring;
  /** from Adresse1 */
  PaysHasVilleRegion?: boolean;
  /** from Activite_NA11 */
  PlanifieExecutionImportArticle?: KeyValueModelDto;
  /** from ModulesVentes */
  PreparationResumeCommandeAvantReglement?: PopupValiderCommandeModele;
  /** from Communication2 */
  PreparerReportPublipostage?: number;
  /** from Compta22 */
  RafraichirArreteCaisse?: Union_554281857723606794;
  /** from Compta22 */
  RafraichissementRemiseEnCaisseCentrale?: RemiseCaisseCentraleModel;
  /** from Benef3 */
  RecalculCriteresSociaux?: string;
  /** from Compta16 */
  RecalculerValorisationStock?: string;
  /** from Stock2 */
  ReceptionnerListeLigneCessionStock?: string;
  /** from Article2 */
  RechercheMedia?: ArrayOfRetourApiMediaModel;
  /** from Compta4 */
  RechercheSommeMouvementComptableFidu?: number;
  /** from Article */
  RechercheTreeView?: ArrayOfFamilleProduitModel;
  /** from DossierPrestation3 */
  RechercherCadeauxAvecSubventionArticle?: RadgridviewPagineModelDtoOfInfosArticleCadeaux5_PhkmGrb;
  /** from ReqSpecif */
  RechercherChoixParamReqSpecif?: ArrayOfChoixItemDto;
  /** from User */
  RefreshContext?: UsersDto;
  /** from Benef_NA1 */
  RefreshPJBenef?: BenefFicheProfilModel;
  /** from Application1 */
  RefreshParametresAppli?: ArrayOfParametresUserAppliModelDto;
  /** from Benef_NA2 */
  RegenLoginAndPassWord?: string;
  /** from Adresse1 */
  RegionHasDepartement?: boolean;
  /** from Compta_NA */
  ReglerCommande?: Union_570005100139003652;
  /** from Benef_NA2 */
  ReinitMDPOuInvSynapse?: string;
  /** from Commun3 */
  ReinitialiserAnalyseIaPiecesJustificatives?: string;
  /** from Benef4 */
  ReinitialiserMotPasse?: string;
  /** from Compta_NA */
  RemboursementAnticipePretsEtDons?: string;
  /** from Assolution */
  RemonterBaseDeProdSurBaseTest?: string;
  /** from Commun2 */
  RemovePieceJustificative?: string;
  /** from Benef_NA2 */
  RenvoyerInvitationSynapse?: string;
  /** from Mediatheque3 */
  ReservationModificationDateExemplaire?: boolean;
  /** from Assolution */
  ResetCacheClient?: string;
  /** from Ventes5 */
  ResetSessionChoixSurCommande?: string;
  /** from Mediatheque1 */
  RetourExemplaire?: BeneficiaireInfosBenefMatriculeModelDto;
  /** from Compta14 */
  RibMandatHaveMouvement?: boolean;
  /** from Article2 */
  SaisieEmprunt?: EmpruntModelDto;
  /** from Mediatheque4 */
  SauvegardeExemplaire?: string;
  /** from Communication4 */
  SauvegarderFooterNewsletter?: string;
  /** from Communication */
  SauvegarderPubliVue?: string;
  /** from Administration2 */
  SaveAdministrationMenus?: ArrayOfMenusArticleTreeViewModuleGestionMenusModel;
  /** from Administration1 */
  SaveAdministrationSkin?: PortailOptionsDto;
  /** from Administration2 */
  SaveAlbumGED?: GedListeAlbumsGedModel;
  /** from Administration */
  SaveAlerteEmail?: string;
  /** from Champ */
  SaveApplicationParameter?: ParametreValeurDto;
  /** from Administration9 */
  SaveArticleUpKonnect?: string;
  /** from Ventes6 */
  SaveAttributionAutomatique?: boolean;
  /** from ModuleAttributionBudget */
  SaveAttributionBudget?: number;
  /** from ModuleAttributionRan */
  SaveAttributionRanModele?: number;
  /** from Commun */
  SaveBareme?: EnteteBaremeDto;
  /** from Activite_NA10 */
  SaveBaremeRegle?: BorneStatWithBornesModel;
  /** from Benef */
  SaveBenefNewWithPieceJustificative?: BenefDto;
  /** from Benef */
  SaveBeneficiaireNew?: BenefDto;
  /** from ModuleBudget */
  SaveBudget?: number;
  /** from Administration */
  SaveCEDelegationModel?: SaveCeDelegationModelDto;
  /** from Mediatheque */
  SaveCatalogueMediatheque?: number;
  /** from Stock2 */
  SaveCessionStock?: number;
  /** from Ventes_NA8 */
  SaveCommandeModalitesReglement?: number;
  /** from DossierPrestation */
  SaveCommentaire?: string;
  /** from Compta_NA3 */
  SaveCommentaireEcriture?: string;
  /** from DossierPrestation */
  SaveCommentaireFacture?: string;
  /** from DossierPrestation */
  SaveCommentaireLigneDossier?: string;
  /** from Application3 */
  SaveCommissionAndUsersCommission?: ArrayOfParamCommissionModel;
  /** from Compta6 */
  SaveCompteBancaireModel?: SaveCompteBancaireModelDto;
  /** from Courrier1 */
  SaveCourrierNewsletter?: string;
  /** from SynchroSynapse_NA */
  SaveCritereSyncAdList?: boolean;
  /** from Ventes4 */
  SaveDevisCdeFour?: RetouSaveCommandeFournisseurModelDto;
  /** from Ventes */
  SaveDevisCommande?: DevisCommandeDto;
  /** from Ventes */
  SaveDevisCommandeGenerique?: DevisCommandeDto;
  /** from Administration2 */
  SaveDocumentGED?: GedListeDocumentsGedModel;
  /** from DossierPrestation */
  SaveDossierPrestation?: ParamEditionDossierPrestationModelDto;
  /** from Compta11 */
  SaveEcritureManuelleModel?: string;
  /** from Compta12 */
  SaveEcritureParModel?: ArrayOfdecimal;
  /** from Compta12 */
  SaveEcritureTiersModel?: string;
  /** from Compta_NA5 */
  SaveEcritureWithMouvements?: string;
  /** from ModuleBudget */
  SaveEngagementBudgetModel?: number;
  /** from Article1 */
  SaveEtGenereArticleLocation?: boolean;
  /** from Ventes3 */
  SaveFactureAvoir?: FactureDto;
  /** from Ventes2 */
  SaveFactureWithAcompteAvoir?: string;
  /** from Ventes3 */
  SaveFactureWithEcriture?: FactureDto;
  /** from Activite2 */
  SaveFamille?: number;
  /** from Mediatheque */
  SaveFamilleMediatheque?: number;
  /** from Benef_NA1 */
  SaveFicheProfilBeneficiaire?: BenefFicheProfilModel;
  /** from Administration4 */
  SaveFicheTrombinoscope?: TrombinoscopeInitialiationTrombinoscopeModel;
  /** from Administration2 */
  SaveFichierGED?: FichierCompletModel;
  /** from Fournisseurs */
  SaveFournisseur?: FournisseurDto;
  /** from Activite_NA7 */
  SaveFraisAnnulationModel?: number;
  /** from Activite_NA2 */
  SaveHorairesModifies?: string;
  /** from Compta_NA7 */
  SaveIbanTiers?: Union_11709815821493216246;
  /** from Administration */
  SaveInfosConnexionUser?: ArrayOfParametresUserAppliModelDto;
  /** from Stock */
  SaveInventaire?: InventaireDto;
  /** from Stock1 */
  SaveInventaireStock?: ModelRetourSaveInventaire;
  /** from Benef4 */
  SaveLargeurColonneModeExpert?: boolean;
  /** from SynchroSynapse_NA */
  SaveLastHistoSynchro?: boolean;
  /** from ModulesVentes3 */
  SaveLigneCommandeLibreModel?: LigneCommandeLibreModelDto;
  /** from Compta7 */
  SaveListCompteJournalPRMAutoFidu?: ArrayOfCompteJournalPrmAutoFiduDto;
  /** from Commun1 */
  SaveListRIBGenerique?: ArrayOfRibDto;
  /** from Ventes2 */
  SaveListeAcompteModel?: ArrayOfdecimal;
  /** from Ventes2 */
  SaveListeAcomptes?: ArrayOfdecimal;
  /** from Widgets */
  SaveListeAgendaGenerique?: ArrayOfAgendaDto;
  /** from Benef3 */
  SaveListeAnneeReferenceGenerique?: ArrayOfAnneeReferenceDto;
  /** from Annonce */
  SaveListeAnnoncesGenerique?: ArrayOfAnnonceDto;
  /** from Champ1 */
  SaveListeApplicationParameters?: ArrayOfParametresUserAppliModelDto;
  /** from Ventes3 */
  SaveListeBLBRModele?: ArrayOfBlBrDto;
  /** from Compta6 */
  SaveListeBanqueGenerique?: ArrayOfBanqueDto;
  /** from ModulesAdministration */
  SaveListeBenefProfilKalidea?: string;
  /** from Annonce */
  SaveListeCategoriesAnnonceGenerique?: ArrayOfAnnonceCategorieDto;
  /** from Administration3 */
  SaveListeCategoriesGED?: ArrayOfPortailDocumentCategorieDto;
  /** from Champ */
  SaveListeChampListeValeursGenerique?: ArrayOfChampListeValeurDto;
  /** from Champ */
  SaveListeChampsGenerique?: ArrayOfChampDto;
  /** from Compta10 */
  SaveListeCleRepartitionModel?: string;
  /** from Activite */
  SaveListeCommissionsGenerique?: ArrayOfCommissionDto;
  /** from Compta19 */
  SaveListeCompte511?: string;
  /** from Compta3 */
  SaveListeCompteEcritureGenerique?: string;
  /** from Compta3 */
  SaveListeCompteEcritureWithMouvementsAnalytique?: string;
  /** from Compta2 */
  SaveListeCompteEtCleRepartition?: ArrayOfCompteDto;
  /** from Compta1 */
  SaveListeCompteGenerique?: ArrayOfCompteDto;
  /** from Benef2 */
  SaveListeConsoMouvementGenerique?: ArrayOfConsoMouvementDto;
  /** from Courrier */
  SaveListeCourrierGenerique?: ArrayOfCourrierDto;
  /** from Courrier */
  SaveListeCourrierHistoEnvoiGenerique?: ArrayOfCourrierHistoEnvoiDto;
  /** from Adresse */
  SaveListeDepartements?: ArrayOfDepartementDto;
  /** from Compta */
  SaveListeExerciceGenerique?: string;
  /** from Ventes2 */
  SaveListeFactureGenerique?: ArrayOfFactureDto;
  /** from ModulesAdministration1 */
  SaveListeFicheProfilInfosAffichageOnglets?: string;
  /** from Benef3 */
  SaveListeFicheProfilModeExpert?: number;
  /** from Ventes1 */
  SaveListeHistoStatut?: ArrayOfHistoStatutCommandeDto;
  /** from Imports */
  SaveListeImportModeleGenerique?: ArrayOfImportModeleDto;
  /** from Compta1 */
  SaveListeJournalGenerique?: string;
  /** from Directo */
  SaveListeLienDirectoModel?: ArrayOfLienDirectoModelDto;
  /** from Lieu */
  SaveListeLieux?: ArrayOfLieuDto;
  /** from Compta5 */
  SaveListeLigneRemiseEnBanqueModel?: ArrayOfLigneRemiseEnBanqueModel;
  /** from Imports1 */
  SaveListeMappingValeurColonnes?: string;
  /** from Application */
  SaveListeMenus?: ArrayOfMenuDto;
  /** from Reporting */
  SaveListeModeleAdresse?: ArrayOfReportModeleAdrdto;
  /** from Commun1 */
  SaveListeModeleSaisieSectionAnaParPlan?: ArrayOfModeleSaisieLibreDto;
  /** from Article2 */
  SaveListeModesLivraisonGenerique?: ArrayOfModeLivraisonDto;
  /** from Fournisseurs */
  SaveListeMontantCrediterOuDebiterCompte?: string;
  /** from Compta4 */
  SaveListeMouvementComptableGenerique?: ArrayOfMouvementComptableDto;
  /** from Stock */
  SaveListeMouvementStockGenerique?: ArrayOfMouvementStockDto;
  /** from Compta */
  SaveListeMoyenPaiementsGenerique?: ArrayOfMoyenPaiementDto;
  /** from Benef1 */
  SaveListeOrganisationGenerique?: ArrayOfOrganisationDto;
  /** from DossierPrestation1 */
  SaveListePJDossierPrestation?: string;
  /** from Adresse1 */
  SaveListePays?: ArrayOfPaysDto;
  /** from Benef6 */
  SaveListePieceJustificativeBenef?: string;
  /** from Commun */
  SaveListePieceJustificativeGenerique?: ArrayOfPieceJustificativeDto;
  /** from Administration */
  SaveListePointVenteGenerique?: ArrayOfPointVenteDto;
  /** from Administration1 */
  SaveListePortailPortletGenerique?: ArrayOfPortailPortletDto;
  /** from Administration */
  SaveListeProfilsDroitGenerique?: ArrayOfProfilDroitDto;
  /** from Adresse */
  SaveListeRegions?: ArrayOfRegionDto;
  /** from Benef1 */
  SaveListeSiteGenerique?: ArrayOfSiteDto;
  /** from Stock */
  SaveListeStockGenerique?: ArrayOfStockDto;
  /** from User */
  SaveListeUsersGenerique?: ArrayOfUsersDto;
  /** from Adresse */
  SaveListeVille?: ArrayOfVilleDto;
  /** from Commun */
  SaveListeVueGenerique?: ArrayOfVueDto;
  /** from Widgets */
  SaveListeWidgetParamByModel?: SaveWidgetParamModelDto;
  /** from Widgets */
  SaveListeWidgetsAccueilGenerique?: ArrayOfWidgetAccueilDto;
  /** from Contacter */
  SaveModelEmailGenerique?: string;
  /** from Article1 */
  SaveModeleAFPA?: RetourAfpaModelDto;
  /** from ModulesEnveloppe */
  SaveModeleEnveloppe?: ModeleEnveloppeDto;
  /** from Activite_NA5 */
  SaveModeleEpargne?: number;
  /** from Reporting */
  SaveModeleImpression?: number;
  /** from Article3 */
  SaveModeleLocation?: ModeleLocationModel;
  /** from Article2 */
  SaveModeleRegleSubQuota?: string;
  /** from Communication3 */
  SaveModeleRequete?: string;
  /** from Compta12 */
  SaveModeleSaisieEcriture?: ModeleSaisieEcritureModeleSaisieEcritureModelDto;
  /** from Compta_NA5 */
  SaveModeleTVA?: number;
  /** from Application5 */
  SaveNotificationsVUP?: ArrayOfNotificationVup;
  /** from ModulesAdministration */
  SaveParamFicheProfil?: number;
  /** from Compta16 */
  SaveParametrageClotureComptable?: string;
  /** from Administration4 */
  SaveParametresPortletSondage?: number;
  /** from ModulesVentes4 */
  SaveParticipantDevis?: DevisCommandeDto;
  /** from Commun */
  SavePerm?: string;
  /** from Activite_NA2 */
  SavePermanence?: number;
  /** from Commun */
  SavePicto?: string;
  /** from Administration3 */
  SavePortailAlbum?: PortailAlbumDto;
  /** from ModuleBudget */
  SavePosteBudgetaire?: number;
  /** from Compta8 */
  SaveRapprochement?: RapprochementDto;
  /** from Article2 */
  SaveRegleModeleAcces?: string;
  /** from Compta8 */
  SaveReleveBancaire?: ReleveBancaireDto;
  /** from RessourcesPartagees */
  SaveRessource?: number;
  /** from ModulesVentes2 */
  SaveSessionChoix?: SaveSessionChoixModel;
  /** from Application1 */
  SaveUserNote?: string;
  /** from Application */
  SendError?: string;
  /** from Courrier1 */
  SendMailFromEmlModele?: string;
  /** from Courrier1 */
  SendMailWithCourrier?: string;
  /** from Ventes_NA8 */
  SolderOuReglerPartiellementReglementsMasse?: string;
  /** from ModuleAttributionBudget */
  SolderPMV?: string;
  /** from Champ */
  SuppressionBlocageInsesl?: string;
  /** from Ventes1 */
  SuppressionPhysiqueOuAnnulationListeDevis?: string;
  /** from Ventes_NA5 */
  SuppressionTriggerStatutPerso?: string;
  /** from Ventes2 */
  SupprimerAcompte?: boolean;
  /** from Administration7 */
  SupprimerAlbumAssosArticleEditorial?: string;
  /** from Administration7 */
  SupprimerAlbumEtFichiers?: string;
  /** from Benef3 */
  SupprimerAnneeReference?: boolean;
  /** from Compta21 */
  SupprimerArreteCaisse?: string;
  /** from Activite_NA1 */
  SupprimerArticle?: string;
  /** from Administration9 */
  SupprimerArticleUpKonnect?: string;
  /** from ModuleAttributionBudget */
  SupprimerAttributionBudget?: string;
  /** from ModuleAttributionRan */
  SupprimerAttributionRan?: string;
  /** from Ventes_NA8 */
  SupprimerAvoir?: number;
  /** from Stock2 */
  SupprimerCessionStock?: string;
  /** from Champ */
  SupprimerChamp?: string;
  /** from Activite_NA3 */
  SupprimerChampFormulaire?: string;
  /** from Compta10 */
  SupprimerCleRepartitionByModel?: string;
  /** from Compta15 */
  SupprimerClotureComptable?: string;
  /** from ModulesVentes1 */
  SupprimerCommande?: string;
  /** from Courrier1 */
  SupprimerContratLocationProduitFamille?: string;
  /** from Compta_NA6 */
  SupprimerDeclarationTVA?: string;
  /** from Administration6 */
  SupprimerDocAssoArticleEditorial?: string;
  /** from Administration8 */
  SupprimerDocument?: string;
  /** from Compta_NA2 */
  SupprimerEcheancesRestantes?: string;
  /** from Compta13 */
  SupprimerEcheancier?: string;
  /** from Compta_NA */
  SupprimerEcriture?: string;
  /** from Compta_NA6 */
  SupprimerEcritureDecaissement?: string;
  /** from Compta_NA7 */
  SupprimerEcritureDecaissementSeule?: string;
  /** from Compta11 */
  SupprimerEcritureModel?: string;
  /** from Compta */
  SupprimerExercice?: string;
  /** from Ventes6 */
  SupprimerFacture?: string;
  /** from DossierPrestation */
  SupprimerFactureAvoir?: string;
  /** from Ventes2 */
  SupprimerFactureFournisseur?: string;
  /** from Ventes2 */
  SupprimerFactureParIdDossierPresta?: boolean;
  /** from Compta11 */
  SupprimerFactureReservation?: string;
  /** from Activite_NA1 */
  SupprimerFamille?: string;
  /** from Activite_NA3 */
  SupprimerFormulaire?: string;
  /** from Activite_NA8 */
  SupprimerGroupe?: string;
  /** from Administration6 */
  SupprimerImagePortail?: string;
  /** from Imports1 */
  SupprimerImport?: string;
  /** from Ventes4 */
  SupprimerImputationFactureSurAvoirAcompte?: string;
  /** from Activite_NA6 */
  SupprimerModeleFraisAnnulation?: string;
  /** from Article3 */
  SupprimerModeleLocation?: string;
  /** from Compta14 */
  SupprimerOrClosRibMandat?: string;
  /** from Activite_NA11 */
  SupprimerParticipant?: string;
  /** from DossierPrestation3 */
  SupprimerPieceJustificative?: string;
  /** from Compta10 */
  SupprimerPlanAnalytique?: string;
  /** from Activite_NA1 */
  SupprimerProduit?: string;
  /** from ModulesMoteurRegle1 */
  SupprimerRegleMoteur?: RapportRegleModelDto;
  /** from Compta22 */
  SupprimerRemiseCaisse?: string;
  /** from Compta5 */
  SupprimerRemiseEnBanqueModel?: string;
  /** from RessourcesPartagees1 */
  SupprimerReservationRP?: string;
  /** from Activite_NA8 */
  SupprimerRoomingList?: string;
  /** from Compta10 */
  SupprimerSectionAnalytique?: string;
  /** from RessourcesPartagees */
  SupprimerTarif?: boolean;
  /** from RessourcesPartagees */
  SupprimerTarifEtGenererAvoir?: number;
  /** from Mediatheque4 */
  SupprimerTransfert?: string;
  /** from DossierPrestation2 */
  TelechargerPieceJustificative?: HelperFileDownload;
  /** from DossierPrestation2 */
  TeleverserPieceJustificative?: DossierPrestationPieceJustificativeModelDto;
  /** from Ventes_NA3 */
  TerminerDossierEpargne?: StatutDossierEpargneModel;
  /** from DossierPrestation2 */
  TransfertModePAC?: ArrayOfKeyValueOfstringFactureDtoOsihyJcl;
  /** from DossierPrestation2 */
  TransfertModeRemboursement?: RetourEcritureComptableFactureAvoirModelDto;
  /** from ModulesMoteurRegle */
  TransformeAndSaveListeModeleMoteurRegle?: ArrayOfMoteurRegleModelDto;
  /** from ModulesVentes */
  TransformeCommandeFactureByModel?: ReturnModeleForVente;
  /** from ModulesVentes */
  TransformeListCommandeListFactureByModel?: ArrayOfReturnModeleForVente;
  /** from Compta_NA */
  TransformerEnDonPretsEtDons?: string;
  /** from DossierPrestation3 */
  TransformerPrestationCadeauxEnCommande?: CadeauxRetourTransformationCadeauxEnCommandeModel;
  /** from Moteur */
  TransformerRegleGuideeEnExpert?: string;
  /** from Application4 */
  UnlikeArticleMagazine?: string;
  /** from Ventes_NA6 */
  UpdateChoixSessionChoixVentesClient?: SessionChoixDevisBenefModelDto;
  /** from Communication3 */
  UpdateDateDerniereUtilisationRequete?: string;
  /** from Mediatheque2 */
  UpdateDateReservationEmpruntSurLigneCommnade?: string;
  /** from Ventes_NA */
  UpdateDatesEcheancesDossierPretsEtDons?: string;
  /** from ModulesVentes2 */
  UpdateDevisBenef?: BenefForVentesModeleDto;
  /** from Ventes5 */
  UpdateDevisSaisieEnCours?: string;
  /** from Activite1 */
  UpdateEcheancier?: number;
  /** from Compta16 */
  UpdateEcritureForDeleteMntProratiser?: string;
  /** from Compta16 */
  UpdateEcritureForSaveMntProratiser?: string;
  /** from Courrier1 */
  UpdateEmlModele?: string;
  /** from ModulesVentes */
  UpdateEnteteDevisByModel?: string;
  /** from ModulesVentes3 */
  UpdateEnteteDevisCommandeLibreByModel?: string;
  /** from Application2 */
  UpdateFonctionnalitesProfil?: RetourSaveProfilDroit;
  /** from ModulesVentes2 */
  UpdateInfosSimpleLigneCommandeByModel?: string;
  /** from Compta */
  UpdateIsUseSurMoyenPaiementActivite?: string;
  /** from ModulesVentes3 */
  UpdateLigneCommandePrestation?: LigneDossierPrestationModelDto;
  /** from Administration7 */
  UpdateListeCommissionEditOption?: string;
  /** from Administration7 */
  UpdateListeCommissionListeEditArticle?: string;
  /** from Application3 */
  UpdateListeDroitsUserCommission?: ArrayOfUserCommissionDroit;
  /** from Mediatheque3 */
  UpdateListeMedia?: string;
  /** from Compta4 */
  UpdateMandatSurMouvementComptable?: string;
  /** from ModulesVentes2 */
  UpdateModeLivraisonLigneCommandeByModel?: string;
  /** from ModulesMoteurRegle */
  UpdateModeleRgele?: string;
  /** from Compta17 */
  UpdateMontantValorisation?: string;
  /** from Connexion */
  UpdateMotDePassePremiereConnexion?: string;
  /** from Ventes_NA9 */
  UpdateParticipantsCommande?: string;
  /** from Compta8 */
  UpdatePlanAnalytique?: number;
  /** from ModulesAdministration1 */
  UpdateProfilSubventionBenefs?: boolean;
  /** from ModuleAttributionBudget1 */
  UpdateQteAttribuee?: string;
  /** from Compta4 */
  UpdateRibSurMouvementComptable?: string;
  /** from Compta_NA9 */
  UpdateSectionAnalytique?: string;
  /** from Compta_NA3 */
  UpdateSectionAnalytiqueSurMouvements?: string;
  /** from Imports */
  UploadImportFile?: ImportHistoDto;
  /** from Commun1 */
  UploaderImageFromRichTextBox?: FichierModel;
  /** from User */
  UserHaveAccessFonctionnalite?: boolean;
  /** from User */
  UtiliseurPeutAccederAuMenu?: boolean;
  /** from Benef */
  ValidateAnnRefWithCritSoc?: number;
  /** from Compta21 */
  ValiderArreteCaisse?: string;
  /** from Administration6 */
  ValiderCommentaire?: string;
  /** from Mediatheque2 */
  ValiderDonneesISBNMediatheque?: ArrayOfstring;
  /** from Imports1 */
  ValiderImportPourExecution?: string;
  /** from Compta23 */
  ValiderRemiseEnCaisse?: string;
  /** from Assolution */
  VerifCodeValidationRemonteeBase?: boolean;
  /** from Compta15 */
  VerifGenerationFichierPrelSEPA?: string;
  /** from Ventes3 */
  VerifMontantRestantAvoirSurFacture?: VerifMontatRestantAvoirDto;
  /** from Lieu */
  VerifProduitLierLieu?: boolean;
  /** from Compta15 */
  VerificationAvantClotureComptable?: VerificationRepartitionModel;
  /** from Compta19 */
  VerificationAvantExportEcriture?: string;
  /** from ModulesVentes3 */
  VerificationCompteSurLigneCdeClientLibre?: boolean;
  /** from Ventes_NA8 */
  VerificationsMandatAssocieRibPrelevelementSEPA?: number;
  /** from Ventes6 */
  VerifierAttributionEnAllotement?: boolean;
  /** from ModulesActivite */
  VerifierAvoirAcompteSurFactureEtDevisCde?: boolean;
  /** from Stock1 */
  VerifierChangementTypeStockProduitPossible?: boolean;
  /** from ModulesEnveloppe */
  VerifierConditionSupEnveloppe?: string;
  /** from ModuleAttributionRan */
  VerifierConditionSuppressionAttRan?: string;
  /** from Champ1 */
  VerifierConditionSuppressionChampPerso?: string;
  /** from Mediatheque3 */
  VerifierDisponibiliteMedia?: Union_5965143003362621529;
  /** from Administration7 */
  VerifierDossierAssosArticleEditSupprimable?: boolean;
  /** from Mediatheque3 */
  VerifierEmpruntExemplaireFPA?: boolean;
  /** from ModulesVentes2 */
  VerifierLigneCdeClientDejaReapproWithIdCdeFour?: boolean;
  /** from Article4 */
  VerifierMoyenPaiementValid?: string;
  /** from Article4 */
  VerifierPlageReservation?: boolean;
  /** from Benef1 */
  VerifierRelationBenefODAD?: string;
  /** from Imports */
  VerifierSiImportEnCours?: boolean;
  /** from Fournisseurs */
  VerifierUniciteCodeFournisseur?: boolean;
  /** from Benef_NA1 */
  VerifierUniciteInformationsBeneficiaire?: RetourVerificationUniciteBeneficiaireModel;
  /** from Administration6 */
  VerifierVilleExiste?: string;
  /** from Adresse */
  VilleHasAdresse?: boolean;
  /** from Compta1 */
  getCompteIn511?: CompteDto;
  /** from Compta7 */
  getCompteReglementFiduciaire?: CompteReglementFiduciaireDto;
  /** from Compta3 */
  getDernierCompteEcritureNumero?: string;
  /** from Compta5 */
  getDernierNumeroBordereau?: string;
  /** from Administration3 */
  getInitialisationAdmninistrationAlbums?: GedInitialisationModuleGestionGedAlbumModel;
  /** from Administration2 */
  getInitialisationAdmninistrationDocuments?: GedInitialisationModuleGestionGedDocumentModel;
  /** from Administration7 */
  getInitialisationParametresPortletVenteArticle?: PortletsInitialisationParametresPortletVenteArticle;
  /** from Administration2 */
  getInitialisationParametresPortletsArticleEditorial?: PortletsInitialisationModulePortletsParametresArticleEditorialModel;
  /** from Administration2 */
  getInitialisationParametresPortletsDirecto?: PortletsInitialisationModulePortletsParametresDirectoModel;
  /** from Compta3 */
  getListClasseCompte?: ArrayOfCompteClasseDto;
  /** from Compta */
  getListExerciceGenerique?: ArrayOfExerciceDto;
  /** from Compta1 */
  getListImportCompte?: ArrayOfCompteDto;
  /** from Compta2 */
  getListSectionCompte?: ArrayOfCompteSectionDto;
  /** from Compta3 */
  getListSousClasseCompte?: ArrayOfCompteSousClasseDto;
  /** from Compta1 */
  getListTypJournal?: ArrayOfJournalTypeDto;
  /** from Administration2 */
  getListeAlbumsGEDModel?: GedListeAlbumsGedModel;
  /** from Compta7 */
  getListeCompteJournalPRM?: ArrayOfCompteJournalPrmAutoDto;
  /** from Compta2 */
  getListeCompteReglement?: ArrayOfCompteReglementFiduciaireDto;
  /** from Administration */
  getListeProfilsDroits?: ArrayOfProfilDroitDto;
  /** from Compta2 */
  hasAgregInLevelHigher?: boolean;
  /** from Compta2 */
  importListeCompte?: string;
  /** from Compta2 */
  isCompteExists?: boolean;
  /** from Commun1 */
  razPermanence?: string;
  /** from Compta5 */
  saveBanqueRemise?: number;
  /** from Compta3 */
  saveClasseCompte?: CompteClasseDto;
  /** from Compta2 */
  saveCompte?: string;
  /** from Compta7 */
  saveCompteJournalPRMAutoFidu?: CompteJournalPrmAutoFiduDto;
  /** from Compta7 */
  saveComptesReglement?: string;
  /** from Compta1 */
  saveJournal?: ArrayOfstring;
  /** from Caisse */
  saveListeCaisseGenerique?: ArrayOfCaisseDto;
  /** from Compta3 */
  saveListeClasseCompte?: string;
  /** from Compta2 */
  saveListeCompte?: string;
  /** from Compta7 */
  saveListeCompteJournalPRMAuto?: ArrayOfCompteJournalPrmAutoDto;
  /** from Administration */
  saveListeCompteursPoints?: ArrayOfCompteurPointDto;
  /** from Compta2 */
  saveListeSectionCompte?: string;
  /** from Compta4 */
  saveListeSousClasseCompte?: string;
  /** from Compta2 */
  saveSectionCompte?: CompteSectionDto;
  /** from Compta4 */
  saveSousClasseCompte?: CompteSousClasseDto;
};


export type MutationAbondementIsUsedArgs = {
  IdAbondement?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationAccepterListePiecesJustificativesArgs = {
  contexte?: ContextInfosInput;
  idDossierPresta?: number;
  listeLignesPJ?: ArrayOfDossierPrestationValiderPieceJustificativeModelDtoInput;
  rawXML?: string;
};


export type MutationActionGroupesArgs = {
  ActGrpModel?: ActionGroupesModelInput;
  contexte?: ContextInfosInput;
  critereArticle?: CriteresArticleDtoInput;
  rawXML?: string;
};


export type MutationActiviteHasFormulaireArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationActiviteHasStatutPersoArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationActiviteHavePermanenceArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationActiviteHaveStatutPersoByStatutArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationActivitePossedeLiensPortailArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationAddLigneCommandePrestationArgs = {
  contexte?: ContextInfosInput;
  modelePresta?: AjoutLigneCommandePrestationModelDtoInput;
  rawXML?: string;
  skipAppelMoteur?: boolean;
};


export type MutationAddOrDeleteCptOrSectionAnaInPosteBdgArgs = {
  contexte?: ContextInfosInput;
  modeleSaveCptOrSectionAna?: AjoutOuSupCptSectionAnaPosteBudgetaireModelDtoInput;
  rawXML?: string;
};


export type MutationAddPlanAnalytiqueArgs = {
  contexte?: ContextInfosInput;
  model?: PlanAnalytiqueModelDtoInput;
  rawXML?: string;
};


export type MutationAddPortailArticleArgs = {
  ListeIdCommissions?: ArrayOfdecimalInput;
  ListeIdExpanded?: ArrayOfintInput;
  article?: PortailArticleDtoInput;
  contexte?: ContextInfosInput;
  parent?: MenusArticleTreeViewModuleGestionMenusModelInput;
  rawXML?: string;
};


export type MutationAddSectionAnalytiqueArgs = {
  contexte?: ContextInfosInput;
  model?: SectionAnalytiqueModelDtoInput;
  rawXML?: string;
};


export type MutationAffecterTiersAuxMouvementsArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresAffectationTiersModelInput;
  rawXML?: string;
};


export type MutationAjoutHistoriqueStatutPersoSurCommandeClientArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  idStatutPerso?: number;
  rawXML?: string;
};


export type MutationAjoutHistoriqueStatutSurCommandeClientArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  idStatut?: number;
  rawXML?: string;
};


export type MutationAjouterListeParticipantsArgs = {
  contexte?: ContextInfosInput;
  idGroupe?: number;
  listeIdLigneCommande?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationAjouterNewsletterThemeArgs = {
  contexte?: ContextInfosInput;
  newsletter?: AjouterModifierNewsletterThemeModelInput;
  rawXML?: string;
};


export type MutationAllArticleAvecValoEtVariationArgs = {
  contexte?: ContextInfosInput;
  idProduit?: number;
  rawXML?: string;
};


export type MutationAnnulationImmediatEmpruntExemplaireArgs = {
  contexte?: ContextInfosInput;
  idLigneCommande?: number;
  rawXML?: string;
};


export type MutationAnnulationImmediatReservationExemplaireArgs = {
  contexte?: ContextInfosInput;
  idLigneCommande?: number;
  rawXML?: string;
};


export type MutationAnnulationImmediatRetourExemplaireArgs = {
  contexte?: ContextInfosInput;
  idLigneCommande?: number;
  rawXML?: string;
};


export type MutationAnnulerBonLivraisonArgs = {
  DateAnnulation?: any;
  contexte?: ContextInfosInput;
  idBL?: number;
  rawXML?: string;
};


export type MutationAnnulerCommandeArgs = {
  contexte?: ContextInfosInput;
  modeleAnnulation?: AnnulerCommandeBaseModelInput;
  rawXML?: string;
};


export type MutationAnnulerDossierPrestationArgs = {
  contexte?: ContextInfosInput;
  idDossierPresta?: number;
  rawXML?: string;
};


export type MutationAnnulerExecutionAttributionBdgArgs = {
  ContextAttBDG?: string;
  contexte?: ContextInfosInput;
  idAttbdg?: number;
  rawXML?: string;
};


export type MutationAnnulerListLigneComandeByFlashArgs = {
  ListEmprunt?: ArrayOfInfoEmpruntModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationAnnulerLivraisonArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationAnnulerModificationBudgetArgs = {
  budgetInit?: BudgetModelDtoInput;
  budgetUpdate?: BudgetModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationAnnulerReinitialisationPasswordArgs = {
  Password?: string;
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationAnnulerRembourserCommandeArgs = {
  contexte?: ContextInfosInput;
  modeleAnnulerRembourserCde?: ModeleSupAnnRemBonRetourCommandeDtoInput;
  rawXML?: string;
};


export type MutationAnnulerRetourArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationAnnulerToutesActionsEmpruntReservationRetourArgs = {
  contexte?: ContextInfosInput;
  listeIdLigneCommande?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationAnnulerTransfertComptaArgs = {
  contexte?: ContextInfosInput;
  dateAnnulation?: any;
  idDossier?: number;
  rawXML?: string;
  typeDossier?: string;
};


export type MutationAnnulerTransformationEnCommandeArgs = {
  ModeleAnnulation?: DossierPrestationAnnulerTransformationCommandeModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationAnnulerValidationListePiecesJustificativesArgs = {
  contexte?: ContextInfosInput;
  listeLignesPJ?: ArrayOfDossierPrestationValiderPieceJustificativeModelDtoInput;
  rawXML?: string;
};


export type MutationAppliquerLettrageComptableArgs = {
  Lettre?: string;
  contexte?: ContextInfosInput;
  listeIdMouvement?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationAreAllComptesProduitOkArgs = {
  contexte?: ContextInfosInput;
  idDossier?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationAreModalitesReglementAvailableForAddedProduitArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  idProduitToAdd?: number;
  rawXML?: string;
};


export type MutationArticleLocationWithChevauchementDatesArgs = {
  IdProduit?: number;
  contexte?: ContextInfosInput;
  dateDebutLocation?: any;
  dateFinLocation?: any;
  idArticleExclude?: number;
  rawXML?: string;
};


export type MutationArticleMagazineRecommandationArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresRecoActionDtoInput;
  rawXML?: string;
};


export type MutationArticleUsedOnLigneCommandeArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  rawXML?: string;
};


export type MutationAttributionHaveDevisFactureArgs = {
  IdAttribution?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationBloquerListeExemplaireArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleLightModelInput;
  rawXML?: string;
  remarque?: string;
};


export type MutationCeHasCompteurPointArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCalculCriteresSociauxChampsDynamiquesArgs = {
  beneficiaire?: BenefFicheProfilModelInput;
  contexte?: ContextInfosInput;
  critereSocial?: BenefCriteresSociauxModelInput;
  rawXML?: string;
};


export type MutationCalculDateFinEmpruntReservationWithNbPermanenceArgs = {
  contexte?: ContextInfosInput;
  dateDebut?: any;
  idActivite?: number;
  nombrePermanence?: number;
  rawXML?: string;
};


export type MutationCalculateSoldeNonRapprocheByIdReleveBancaireArgs = {
  contexte?: ContextInfosInput;
  idReleveBancaire?: number;
  rawXML?: string;
};


export type MutationCalculerDateFinEmpruntReservationWithIdExemplaireArgs = {
  contexte?: ContextInfosInput;
  dateDebut?: any;
  idExemplaire?: number;
  rawXML?: string;
};


export type MutationCalculerDateFinEmpruntReservationWithIdMediaArgs = {
  contexte?: ContextInfosInput;
  dateDebut?: any;
  idProduit?: number;
  rawXML?: string;
};


export type MutationCancelAttributionAutoArgs = {
  IdAttribution?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationChangementStatutLigneCommandePrestationArgs = {
  NewStatut?: string;
  contexte?: ContextInfosInput;
  idLigneCommande?: number;
  rawXML?: string;
};


export type MutationChangementStatutLigneCommandePrestationViaPopupArgs = {
  NewStatut?: string;
  contexte?: ContextInfosInput;
  idLigneCommande?: number;
  listeSubComplementaire?: ArrayOfSubventionAccordeeModelDtoInput;
  montantRembourse?: number;
  quantiteRemboursee?: number;
  rawXML?: string;
};


export type MutationChangerExemplaireSurLigneEtLivrerArgs = {
  ModeleLivraison?: DateReservationModelInput;
  contexte?: ContextInfosInput;
  idNouvelExemplaire?: number;
  rawXML?: string;
};


export type MutationChangerRibBenefSurMouvementEnAttenteArgs = {
  contexte?: ContextInfosInput;
  model?: ChangerRibSurMouvementAttenteModelInput;
  rawXML?: string;
};


export type MutationChangerStatutAdministratifLigneCommandeMediathequeArgs = {
  codeStatut?: string;
  contexte?: ContextInfosInput;
  listIdLigneCommande?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationChangerStatutAdministratifLigneCommandeRpArgs = {
  codeStatut?: string;
  contexte?: ContextInfosInput;
  idLigneCommande?: number;
  rawXML?: string;
};


export type MutationChangerStatutLigneCommandeGestionArgs = {
  contexte?: ContextInfosInput;
  ligneCommande?: EditerLigneCommandeChangementStatutGestionModelInput;
  rawXML?: string;
};


export type MutationChangerStatutLigneDossierEpargneArgs = {
  codeStatut?: string;
  contexte?: ContextInfosInput;
  idDossier?: number;
  rawXML?: string;
};


export type MutationChargerRegleAvanceeArgs = {
  contexte?: ContextInfosInput;
  idRegle?: number;
  rawXML?: string;
};


export type MutationCheckBeforeAnnulationTransfertComptaPacArgs = {
  contexte?: ContextInfosInput;
  idDossier?: number;
  rawXML?: string;
};


export type MutationCheckBeforeAnnulationTransfertComptaRemboursementArgs = {
  contexte?: ContextInfosInput;
  idDossier?: number;
  rawXML?: string;
};


export type MutationCheckBeforeDuplicationFpaArgs = {
  contexte?: ContextInfosInput;
  idElementDuplique?: number;
  rawXML?: string;
  typeElement?: TypeAfpaEnum;
};


export type MutationCheckCodeActiviteEditedArgs = {
  code?: string;
  contexte?: ContextInfosInput;
  idActiviteEdited?: number;
  rawXML?: string;
};


export type MutationCheckCodeExisteChampPersonaliseArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresChampTypeDonneeDtoInput;
  rawXML?: string;
};


export type MutationCheckCompte512RattacheACompteBancaireArgs = {
  IdCompte512?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCheckCourrierLocationProduitFamilleArgs = {
  IdCourrier?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCheckDateLivraisonReceptionArgs = {
  contexte?: ContextInfosInput;
  dateLivRec?: any;
  listeIdCommande?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationCheckElementFpaToDeleteArgs = {
  article?: ArticleDtoInput;
  contexte?: ContextInfosInput;
  famile?: FamilleProduitDtoInput;
  produit?: ProduitDtoInput;
  rawXML?: string;
};


export type MutationCheckIfCommandeHasProduitWithModalitesReglementArgs = {
  contexte?: ContextInfosInput;
  idCde?: number;
  rawXML?: string;
};


export type MutationCheckIfProduitHaveMoyenPaiementLieArgs = {
  ListeIdProduit?: ArrayOfdecimalInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCheckIfProduitModeleEcheancierLieArgs = {
  ListeIdProduit?: ArrayOfdecimalInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCheckMatriculeExistArgs = {
  CodeMembre?: string;
  IdBenef?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCheckNumeroPieceForEcritureArgs = {
  contexte?: ContextInfosInput;
  dateEcriture?: any;
  idEcriture?: number;
  idJournal?: number;
  numeroPiece?: string;
  rawXML?: string;
};


export type MutationCheckNumeroPieceForJournalArgs = {
  DateEcriture?: any;
  IdJournal?: number;
  NumeroPiece?: string;
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationCheckPseudoBenefExistArgs = {
  IdBenef?: number;
  Pseudo?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCheckStockArticleQuantiteArgs = {
  ListIdCommande?: ArrayOfdecimalInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCheckUniciteMandatArgs = {
  IdRib?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
  reference?: string;
};


export type MutationCheckUniciteNomPrenomArgs = {
  IdBenef?: number;
  contexte?: ContextInfosInput;
  nom?: string;
  prenom?: string;
  rawXML?: string;
};


export type MutationClotureCommissionArgs = {
  contexte?: ContextInfosInput;
  idCommission?: number;
  rawXML?: string;
};


export type MutationClotureDeClotureCompteurPointsArgs = {
  contexte?: ContextInfosInput;
  idCompteur?: number;
  isDeleteLienArticle?: boolean;
  rawXML?: string;
};


export type MutationCloturerCatalogueArgs = {
  contexte?: ContextInfosInput;
  idProduit?: number;
  rawXML?: string;
};


export type MutationCloturerCommentaireArgs = {
  contexte?: ContextInfosInput;
  listeId?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationCloturerCourrierArgs = {
  contexte?: ContextInfosInput;
  idCourrier?: number;
  rawXML?: string;
};


export type MutationCloturerCourrierEnvoiArgs = {
  contexte?: ContextInfosInput;
  idCourrier?: number;
  idDelegation?: number;
  rawXML?: string;
};


export type MutationCloturerDecloturerActualiteArgs = {
  contexte?: ContextInfosInput;
  idActu?: number;
  rawXML?: string;
};


export type MutationCloturerFamilleArgs = {
  contexte?: ContextInfosInput;
  idFamille?: number;
  rawXML?: string;
};


export type MutationCloturerMailArgs = {
  contexte?: ContextInfosInput;
  idMail?: number;
  rawXML?: string;
};


export type MutationCloturerModeleEcheancierArgs = {
  contexte?: ContextInfosInput;
  idModeleEcheancier?: number;
  isClos?: boolean;
  rawXML?: string;
};


export type MutationCloturerNewsletterThemeArgs = {
  contexte?: ContextInfosInput;
  idDelegation?: number;
  idNewsletter?: number;
  rawXML?: string;
};


export type MutationCloturerPlanAnalytiqueArgs = {
  IdPlan?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCloturerProduitArgs = {
  contexte?: ContextInfosInput;
  idProduit?: number;
  rawXML?: string;
};


export type MutationCloturerPubliVueArgs = {
  contexte?: ContextInfosInput;
  idVue?: number;
  rawXML?: string;
};


export type MutationCloturerRequeteArgs = {
  contexte?: ContextInfosInput;
  idRequete?: number;
  rawXML?: string;
};


export type MutationCloturerSectionAnalytiqueArgs = {
  IdSection?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCloturerStatutPersoArgs = {
  clotureModel?: ClotureStatutPersoModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCommandeHasFormulaireParametreArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationCommandeOuLigneHasFormulaireParametreArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationCompareSessionChoixArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresDevisCommandeModelInput;
  rawXML?: string;
};


export type MutationConnexionGestionByLoginArgs = {
  ListNumSession?: ArrayOfstringInput;
  isOOB?: boolean;
  nomCe?: string;
  rawXML?: string;
  userLogin?: string;
  userPassword?: string;
  version?: string;
};


export type MutationConnexionVupByLoginArgs = {
  ListNumSession?: ArrayOfstringInput;
  nomCe?: string;
  rawXML?: string;
  userLogin?: string;
  userPassword?: string;
};


export type MutationContacterBenefForCommandeFourniseurArgs = {
  contexte?: ContextInfosInput;
  critere?: CritereContacterBenefDtoInput;
  rawXML?: string;
};


export type MutationContacterByMailLibreArgs = {
  Email?: MailModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCorrigerImputationArticleArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCorrectionImputationArticleModelInput;
  rawXML?: string;
};


export type MutationCorrigerMontantMouvementArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCorrectionMontantMouvementModelInput;
  rawXML?: string;
};


export type MutationCorrigerRepartitionAnalytiqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCorrectionRepartitionAnalytiqueModelInput;
  rawXML?: string;
};


export type MutationCreateEcritureAndMouvementsAndSaveReglementArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  reglementFacture?: ListeFacturesEtListeReglementsModelDtoInput;
};


export type MutationCreateNewArticleArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCreateNewArticleDtoInput;
  idProduitParent?: number;
  rawXML?: string;
};


export type MutationCreateNewCompte511Args = {
  Compte512?: CompteDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCreateNewDeclarationArgs = {
  contexte?: ContextInfosInput;
  moisDeclaration?: any;
  rawXML?: string;
};


export type MutationCreateNewDevisCommandeArgs = {
  IsActiviteLocation?: boolean;
  contexte?: ContextInfosInput;
  initModel?: InitModeleForVenteInput;
  rawXML?: string;
};


export type MutationCreateNewFamilleArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCreateNewFamilleDtoInput;
  idActiviteParente?: number;
  rawXML?: string;
};


export type MutationCreateNewProduitArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCreateNewProduitDtoInput;
  idFamilleParente?: number;
  rawXML?: string;
};


export type MutationCreationCourrierHistoEnvoiAcceptationRefusWhithModelAttributionArgs = {
  Acceptation?: boolean;
  MoyenEnvoi?: MoyenEnvoiModelDtoInput;
  attrib?: AttributionAutoModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCreerArreteCaisseArgs = {
  contexte?: ContextInfosInput;
  idCaisse?: number;
  idsMoyensPaiement?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationCreerArticleArgs = {
  contexte?: ContextInfosInput;
  idProduit?: number;
  rawXML?: string;
};


export type MutationCreerAvoirPourRemboursementBenefDonsArgs = {
  contexte?: ContextInfosInput;
  idDossier?: number;
  rawXML?: string;
};


export type MutationCreerAvoirPourRemboursementBenefPretsArgs = {
  contexte?: ContextInfosInput;
  idCompte?: number;
  idDossier?: number;
  idJournal?: number;
  rawXML?: string;
};


export type MutationCreerAvoirSurFactureArgs = {
  contexte?: ContextInfosInput;
  idFacture?: number;
  rawXML?: string;
};


export type MutationCreerChampDroitsArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCreerClotureComptableArgs = {
  ClotureExercice?: ExerciceClotureModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCreerCommandeEpargneArgs = {
  contexte?: ContextInfosInput;
  modeleCreationCommande?: CreationCommandeEpargneModelInput;
  rawXML?: string;
};


export type MutationCreerComptesArgs = {
  comptes?: ArrayOfCreationCompteModelInput;
  contexte?: ContextInfosInput;
  options?: OptionsCreationCompteModelInput;
  rawXML?: string;
};


export type MutationCreerDemandeDeTelechargementArgs = {
  CodeDownload?: string;
  contexte?: ContextInfosInput;
  idElement?: number;
  rawXML?: string;
};


export type MutationCreerDemandeDeTelechargementStrArgs = {
  CodeDownload?: string;
  chaine?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationCreerDossierEpargneArgs = {
  contexte?: ContextInfosInput;
  modeleCreationDossier?: PreparerNouveauDevisCommandeEpargneModelInput;
  rawXML?: string;
};


export type MutationCreerDossierPrestationArgs = {
  contexte?: ContextInfosInput;
  dossierPrestation?: DossierPrestationCreationDossierPrestationModelDtoInput;
  rawXML?: string;
};


export type MutationCreerDossierPretsEtDonsArgs = {
  contexte?: ContextInfosInput;
  modeleCreationDossier?: PreparerNouveauDevisCommandePretsEtDonsModelInput;
  rawXML?: string;
};


export type MutationCreerEcritureContrepassationArgs = {
  contexte?: ContextInfosInput;
  ecritureAContrepasser?: EcritureGenerationEcritureContrepassationModelInput;
  rawXML?: string;
};


export type MutationCreerFacturePourRemboursementPretsEtDonsArgs = {
  contexte?: ContextInfosInput;
  idDossier?: number;
  rawXML?: string;
};


export type MutationCreerFamilleArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationCreerProduitArgs = {
  contexte?: ContextInfosInput;
  idFamille?: number;
  rawXML?: string;
};


export type MutationCreerRemiseEnCaisseCentraleArgs = {
  contexte?: ContextInfosInput;
  idCaisse?: number;
  listeIdMoyensPaiement?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationCryptagePasswordArgs = {
  contexte?: ContextInfosInput;
  passwordToCrypt?: string;
  rawXML?: string;
};


export type MutationDebiterCrediterPmvArgs = {
  contexte?: ContextInfosInput;
  ecr?: EcritureDebitCreditPmvModelInput;
  rawXML?: string;
};


export type MutationDebloquerListeExemplaireArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleLightModelInput;
  rawXML?: string;
  remarque?: string;
};


export type MutationDeclotureExerciceArgs = {
  IdExercice?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationDecodeHtmlArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  texteEntree?: string;
};


export type MutationDeconnecterArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationDeleteAlbumDeArticleArgs = {
  contexte?: ContextInfosInput;
  idAlbum?: number;
  idArticle?: number;
  rawXML?: string;
};


export type MutationDeleteCategorieArgs = {
  categorieSupprimer?: PortailEditorialCategorieDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationDeleteCommandeModalitesReglementArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationDeleteDossierPrestationArgs = {
  contexte?: ContextInfosInput;
  idDossierPrestation?: number;
  rawXML?: string;
};


export type MutationDeleteFileArgs = {
  contexte?: ContextInfosInput;
  id?: number;
  rawXML?: string;
};


export type MutationDeleteFileDeAlbumArgs = {
  contexte?: ContextInfosInput;
  id?: number;
  idAlbum?: number;
  rawXML?: string;
};


export type MutationDeleteFileDeArticleArgs = {
  contexte?: ContextInfosInput;
  id?: number;
  idArticle?: number;
  rawXML?: string;
};


export type MutationDeleteHorairesArgs = {
  contexte?: ContextInfosInput;
  idPermanence?: number;
  rawXML?: string;
};


export type MutationDeleteLigneCommandeForVenteArgs = {
  IdLigne?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationDeleteModeleTvaArgs = {
  contexte?: ContextInfosInput;
  idModele?: number;
  rawXML?: string;
};


export type MutationDeletePermanenceArgs = {
  contexte?: ContextInfosInput;
  idPermanence?: number;
  rawXML?: string;
};


export type MutationDeletePortailArticleArgs = {
  contexte?: ContextInfosInput;
  idMenuPortail?: number;
  rawXML?: string;
};


export type MutationDeleteTrombinoscopeArgs = {
  contexte?: ContextInfosInput;
  id?: number;
  rawXML?: string;
};


export type MutationDeleteWrongLettrageOnExerciceArgs = {
  contexte?: ContextInfosInput;
  idExercice?: number;
  rawXML?: string;
};


export type MutationDelettrerEcrituresArgs = {
  ListeIdEcritures?: ArrayOfdecimalInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationDelettrerMouvementsArgs = {
  contexte?: ContextInfosInput;
  listeIdsMouvement?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationDepartementHasVilleArgs = {
  contexte?: ContextInfosInput;
  idDepartement?: number;
  rawXML?: string;
};


export type MutationDeplacementMenuArborescenceArgs = {
  contexte?: ContextInfosInput;
  modele?: MenusParametresDeplacementArbreArborescenceModelInput;
  rawXML?: string;
};


export type MutationDetacherDocAssoArticleEditorialArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  listeIdFichier?: ArrayOfintInput;
  rawXML?: string;
};


export type MutationDetacherDocumentArgs = {
  contexte?: ContextInfosInput;
  idLien?: number;
  rawXML?: string;
};


export type MutationDeterminerActionsSuppressionTarifArgs = {
  contexte?: ContextInfosInput;
  idTarif?: number;
  rawXML?: string;
};


export type MutationDiffusionMonEspaceCseArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  rawXML?: string;
};


export type MutationDoesCodeChampListeValeurExistsArgs = {
  codeChampValeur?: string;
  contexte?: ContextInfosInput;
  idChampListeValeur?: number;
  rawXML?: string;
};


export type MutationDuplicationAfpaArgs = {
  contexte?: ContextInfosInput;
  modeleDuplication?: DuplicationFpaModelInput;
  rawXML?: string;
};


export type MutationDupliquerAttributionBudgetArgs = {
  contexte?: ContextInfosInput;
  idAtb?: number;
  rawXML?: string;
};


export type MutationDupliquerBudgetArgs = {
  contexte?: ContextInfosInput;
  idBudget?: number;
  rawXML?: string;
};


export type MutationDupliquerRegleArgs = {
  contexte?: ContextInfosInput;
  idRegle?: number;
  rawXML?: string;
};


export type MutationEditValeurChampListeArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  valeurChampListe?: ChampListeValeurEditerValeurChampListeModelInput;
};


export type MutationEditValeurParamHistorisationOfChampArgs = {
  contexte?: ContextInfosInput;
  idChamp?: number;
  rawXML?: string;
  valeur?: string;
};


export type MutationEditerActionsTriggerArgs = {
  contexte?: ContextInfosInput;
  modeleAction?: ActionStatutModelInput;
  rawXML?: string;
};


export type MutationEditerActualiteArgs = {
  actu?: ActualiteMobileEditionModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationEditerArticleArgs = {
  contexte?: ContextInfosInput;
  modeleArticle?: ParametrageArticleBaseModelInput;
  rawXML?: string;
};


export type MutationEditerCategorieArgs = {
  categorieSavegarder?: PortailEditorialCategorieDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationEditerCessionStockArgs = {
  contexte?: ContextInfosInput;
  model?: CessionStockWithRemarqueNomPrenomModelInput;
  rawXML?: string;
};


export type MutationEditerChampFormulaireArgs = {
  champFormulaire?: ChampFormulaireParametrageModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationEditerCommentairesBlbrArgs = {
  contexte?: ContextInfosInput;
  idBlbr?: number;
  rawXML?: string;
  remarquePrivee?: string;
  remarquePublique?: string;
};


export type MutationEditerDossierEpargneArgs = {
  contexte?: ContextInfosInput;
  dossierEpargne?: DossierEpargneModelInput;
  rawXML?: string;
};


export type MutationEditerEnteteDossierEpargneArgs = {
  contexte?: ContextInfosInput;
  enteteDossier?: EnteteEpargneModelInput;
  rawXML?: string;
};


export type MutationEditerExecutionAttributionAutoArgs = {
  contexte?: ContextInfosInput;
  execModel?: EditerExecutionAttributionAutoModelInput;
  rawXML?: string;
};


export type MutationEditerExerciceArgs = {
  contexte?: ContextInfosInput;
  model?: ExerciceInfosInput;
  rawXML?: string;
};


export type MutationEditerFamilleArgs = {
  contexte?: ContextInfosInput;
  modeleFamille?: ParametrageFamilleBaseModelInput;
  rawXML?: string;
};


export type MutationEditerFormulaireArgs = {
  contexte?: ContextInfosInput;
  modeleFormulaire?: FormulaireFullModelInput;
  rawXML?: string;
};


export type MutationEditerGroupeRoomingListArgs = {
  contexte?: ContextInfosInput;
  modele?: EditerGroupeRoomingListModelInput;
  rawXML?: string;
};


export type MutationEditerHistoriqueSalarieArgs = {
  contexte?: ContextInfosInput;
  modelEditHisto?: EditHistoriqueSalarieModelInput;
  rawXML?: string;
};


export type MutationEditerInfosEnteteDossierPretsEtDonsArgs = {
  contexte?: ContextInfosInput;
  modeleEntete?: EnteteDossierPretsEtDonsModelInput;
  rawXML?: string;
};


export type MutationEditerLibelleMouvementArgs = {
  Libelle?: string;
  ListeIdMouvement?: ArrayOfdecimalInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationEditerLibelleRemiseEnBanqueArgs = {
  contexte?: ContextInfosInput;
  idRemise?: number;
  libelleRemise?: string;
  rawXML?: string;
};


export type MutationEditerLibelleRoomingListArgs = {
  contexte?: ContextInfosInput;
  idRegroupement?: number;
  libelle?: string;
  rawXML?: string;
};


export type MutationEditerLigneCommandeGestionPlusArgs = {
  contexte?: ContextInfosInput;
  formulaire?: SoumissionFormulaireModelInput;
  isDepassementStockValideByUser?: boolean;
  ligneCommande?: EditerLigneCommandeGestionInput;
  rawXML?: string;
};


export type MutationEditerLigneCommandeMediathequeArgs = {
  contexte?: ContextInfosInput;
  modele?: MediathequeEditerLigneCommandeMediathequeBaseModelDtoInput;
  rawXML?: string;
};


export type MutationEditerLigneDossierPretsEtDonsArgs = {
  contexte?: ContextInfosInput;
  dossierPretsEtDons?: DossierPretsEtDonsBaseModelInput;
  rawXML?: string;
};


export type MutationEditerModeleCourrierPublipostageArgs = {
  contexte?: ContextInfosInput;
  modeleCourrier?: ModelesModeleCourrierPublipostageModelInput;
  rawXML?: string;
};


export type MutationEditerModeleEcheancierArgs = {
  contexte?: ContextInfosInput;
  modeleEcheancier?: ParamModeleEchancierModelInput;
  rawXML?: string;
};


export type MutationEditerModeleEcheancierActiviteArgs = {
  contexte?: ContextInfosInput;
  modele?: EditEcheancierModeleActiviteModelInput;
  rawXML?: string;
};


export type MutationEditerModeleEmailPublipostageArgs = {
  contexte?: ContextInfosInput;
  modeleEmail?: ModelesModelEmailPublipostageModelInput;
  rawXML?: string;
};


export type MutationEditerMotifSepaMouvementArgs = {
  IdMouvement?: number;
  MotifSEPA?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationEditerPieceJustificativeArgs = {
  contexte?: ContextInfosInput;
  pj?: PjCompletModelInput;
  rawXML?: string;
};


export type MutationEditerProduitArgs = {
  contexte?: ContextInfosInput;
  modeleProduit?: ParametrageProduitBaseModelInput;
  rawXML?: string;
};


export type MutationEditerProduitClotureArgs = {
  contexte?: ContextInfosInput;
  model?: EditerProduitClotureModelInput;
  rawXML?: string;
};


export type MutationEditerRommingListArgs = {
  contexte?: ContextInfosInput;
  modele?: EditerRoomingListModelInput;
  rawXML?: string;
};


export type MutationEditerStatutPersoArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  statutPerso?: EditerStatutPersoModelInput;
};


export type MutationEditionEnregistrementOdadArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  modelOdAD?: BenefEditerAyantDroitInput;
  rawXML?: string;
};


export type MutationEffectuerLivraisonRapidePartielleArgs = {
  contexte?: ContextInfosInput;
  listeLignesCommandes?: ArrayOfLivraisonsInfosLigneCdeForLivraisonReceptionModeleInput;
  rawXML?: string;
};


export type MutationEffectuerLivraisonRapideTotaleArgs = {
  ModeleGenerationBLBR?: GenerationBlbrModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationEffectuerRemiseEnCaisseArgs = {
  contexte?: ContextInfosInput;
  modeleSave?: RemiseEnCaisseSaveRemiseEnCaisseModelInput;
  rawXML?: string;
};


export type MutationEnregistrerAbondementManuelArgs = {
  abondement?: AbondementEnregistrementAbondementInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationEnregistrerArreteCaisseArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  saveModele?: ArreteCaisseSaveArreteCaisseModelInput;
};


export type MutationEnregistrerEcheancesArgs = {
  contexte?: ContextInfosInput;
  echeances?: ArrayOfReglementEnregistrementReglementInput;
  montantAbondement?: number;
  rawXML?: string;
};


export type MutationEnregistrerLigneDossierPrestationArgs = {
  contexte?: ContextInfosInput;
  ligneDossierPresta?: DossierPrestationEditerLigneCommandeBaseModelDtoInput;
  rawXML?: string;
};


export type MutationEnregistrerNouvelleVueParDefautArgs = {
  contexte?: ContextInfosInput;
  idNouvelleVue?: number;
  rawXML?: string;
};


export type MutationEnregistrerParametrageOrganisationSynchroArgs = {
  contexte?: ContextInfosInput;
  organisation?: SynchroOrganisationModelDtoInput;
  rawXML?: string;
};


export type MutationEnregistrerPermanencesSurActiviteArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  listeIdPermanence?: ArrayOfdecimalInput;
  nombreAfficheEnLigne?: number;
  rawXML?: string;
};


export type MutationEnregistrerRegleGuideeArgs = {
  contexte?: ContextInfosInput;
  modeleDeRegle?: MoteurRegleModelDtoInput;
  rawXML?: string;
};


export type MutationEnregistrerReglementManuelArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  reglement?: ReglementEnregistrementReglementInput;
};


export type MutationEnregistrerReglesAvanceesArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  regleMere?: RegleAvanceeModelDtoInput;
};


export type MutationEnregistrerRemarqueMouvementStockArgs = {
  contexte?: ContextInfosInput;
  idMouvementStock?: number;
  rawXML?: string;
  remarque?: string;
};


export type MutationEnregistrerRemarquesPieceJustificativeArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  remarques?: DossierPrestationRemarquesPieceJustificativeModelDtoInput;
};


export type MutationEnregistrerRemiseEnCaisseArgs = {
  contexte?: ContextInfosInput;
  modeleSave?: RemiseEnCaisseSaveRemiseEnCaisseModelInput;
  rawXML?: string;
};


export type MutationEnregistrerReponsesFormulairesArgs = {
  contexte?: ContextInfosInput;
  modeleSaveReponses?: SaveReponsesFormulaireModelInput;
  rawXML?: string;
};


export type MutationEnregistrerReservationResxPartageeArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  reservation?: RessourcesPartageesReservationModelInput;
};


export type MutationEnregistrerSourceXmlArgs = {
  FluxXml?: string;
  NomFichier?: string;
  Type?: TypeFichierEnum;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationEnregistrerTarifArgs = {
  contexte?: ContextInfosInput;
  idLigneDeCommande?: number;
  rawXML?: string;
  tarif?: RessourcesPartageesTarifModelInput;
};


export type MutationEnvoieMailAcceptationRefusArgs = {
  AttribModel?: AttributionAutoModelDtoInput;
  contexte?: ContextInfosInput;
  listHisto?: ArrayOfCourrierHistoEnvoiDtoInput;
  rawXML?: string;
};


export type MutationEnvoieMailPublipostageArgs = {
  contexte?: ContextInfosInput;
  criteresRechercheBenef?: CriteresBenefMoyenContacteMailInput;
  idTypePubli?: number;
  isGenerationCourrierEnabled?: boolean;
  isNewsLetter?: boolean;
  listeId?: ArrayOfdecimalInput;
  listePieceJointe?: ArrayOfDocumentBaseModelInput;
  modeleEmail?: ModelesModelEmailPieceJointeModelInput;
  rawXML?: string;
};


export type MutationEnvoieMailUtilisateurPublipostageArgs = {
  contexte?: ContextInfosInput;
  id?: number;
  listePieceJointe?: ArrayOfDocumentBaseModelInput;
  modeleEmail?: ModelesModelEmailPieceJointeModelInput;
  rawXML?: string;
};


export type MutationEnvoyerEmailApresModificationAnnoncesArgs = {
  contexte?: ContextInfosInput;
  listeAnnoncesModifiees?: ArrayOfAnnonceDtoInput;
  rawXML?: string;
};


export type MutationEnvoyerMailApprobateurPourValidationArgs = {
  contexte?: ContextInfosInput;
  idMenu?: number;
  rawXML?: string;
};


export type MutationEnvoyerMailDepressionNotationGestionArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationEnvoyerPiecesJustificativesVersDokiArgs = {
  contexte?: ContextInfosInput;
  listeIdPjBenef?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationExecuteActionsGroupeesArgs = {
  contexte?: ContextInfosInput;
  model?: ExecutionActionsGroupeesModelInput;
  rawXML?: string;
};


export type MutationExecuterOrUpdateAttDbgBenefArgs = {
  contexte?: ContextInfosInput;
  modeleExecAtr?: ModeleExecAttributionBudgetDtoInput;
  rawXML?: string;
};


export type MutationExistsContactParamArgs = {
  contexte?: ContextInfosInput;
  crit?: CriteresContactParamModelInput;
  rawXML?: string;
};


export type MutationExportAndSaveLigneCommandeArgs = {
  ModelExport?: ExportAncvCesuModelDtoInput;
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationExportAnneeRefToAnneeCibleArgs = {
  contexte?: ContextInfosInput;
  modelReportAnneeRef?: AnneeReferenceReportAnneeReferenceModelInput;
  rawXML?: string;
};


export type MutationExportFichierPnm100Args = {
  asExported?: boolean;
  codePrefixe?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationExportGrandLivreAnalytiqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresReportGrandLivreAnalytiqueInput;
  rawXML?: string;
};


export type MutationExportGrandLivreComptableEnExcelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementComptableModelInput;
  rawXML?: string;
};


export type MutationExportGrandLivreComptableEnPdfArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementComptableModelInput;
  rawXML?: string;
};


export type MutationExportPrelevementSepaArgs = {
  contexte?: ContextInfosInput;
  idRemiseEnBanque?: number;
  isReeditionFichier?: boolean;
  numeroBordereau?: string;
  rawXML?: string;
};


export type MutationExportVirementSepaArgs = {
  contexte?: ContextInfosInput;
  idRemiseEnBanque?: number;
  numeroBordereau?: string;
  rawXML?: string;
};


export type MutationExporterLigneCommandeArgs = {
  ModelExport?: ExportAncvCesuModelDtoInput;
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationExporterProcStockerArgs = {
  Req?: ReqSpecifDtoInput;
  contexte?: ContextInfosInput;
  nbElementParPage?: number;
  numPage?: number;
  rawXML?: string;
};


export type MutationExporterProcStockerCsvArgs = {
  Req?: ReqSpecifDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationExporterReleverBancaireArgs = {
  contexte?: ContextInfosInput;
  idRapprochement?: number;
  rawXML?: string;
};


export type MutationExtensionPieceJustificativeValideArgs = {
  contexte?: ContextInfosInput;
  extensionPJ?: string;
  rawXML?: string;
};


export type MutationFacturationMasseCommandeClientArgs = {
  contexte?: ContextInfosInput;
  criteresFacturationMasse?: CriteresFacturationCommandeMasseModelInput;
  infosFacturation?: FactureInfosFacturationCommandeClientGestionModelInput;
  rawXML?: string;
};


export type MutationFacturerCommandeClientParTarifArgs = {
  contexte?: ContextInfosInput;
  infos?: FacturerTarifsGestionModelInput;
  rawXML?: string;
};


export type MutationFacturerListeCommandeClientArgs = {
  contexte?: ContextInfosInput;
  infos?: FactureInfosFacturationCommandeClientGestionModelInput;
  rawXML?: string;
};


export type MutationFamilleHasProduitWithFacturationAutoArgs = {
  contexte?: ContextInfosInput;
  idFamille?: number;
  rawXML?: string;
};


export type MutationFinProcessVentesArgs = {
  contexte?: ContextInfosInput;
  model?: FactureInfosFacturationCommandeClientGestionModelInput;
  rawXML?: string;
};


export type MutationForceDeleteFileArgs = {
  contexte?: ContextInfosInput;
  idFile?: number;
  rawXML?: string;
};


export type MutationFournisseurPossedeArticlesGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresArticleDtoInput;
  rawXML?: string;
};


export type MutationGenerateModelListeArticlePortletArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleEditorielModelInput;
  rawXML?: string;
};


export type MutationGenerateReportWithIdImpressionArgs = {
  contexte?: ContextInfosInput;
  idImpression?: number;
  rawXML?: string;
};


export type MutationGenerationBlBrReceptionPartielleArgs = {
  contexte?: ContextInfosInput;
  modeleGeneration?: GenerationBlbrModelDtoInput;
  rawXML?: string;
};


export type MutationGenerationBlBrReceptionTotaleArgs = {
  contexte?: ContextInfosInput;
  modeleGeneration?: GenerationBlbrModelDtoInput;
  rawXML?: string;
};


export type MutationGenereSessionEmpruntArgs = {
  Critere?: CritereEmpruntDtoInput;
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGenererActionsGroupeesCommandesArgs = {
  contexte?: ContextInfosInput;
  modeleActions?: ActionsGroupeesCommandesModelInput;
  rawXML?: string;
};


export type MutationGenererActionsGroupeesEpargnesArgs = {
  contexte?: ContextInfosInput;
  modeleActions?: ActionsGroupeesModelInput;
  rawXML?: string;
};


export type MutationGenererActionsGroupeesPretsEtDonsArgs = {
  contexte?: ContextInfosInput;
  modeleActionsGroupees?: ActionsGroupeesPretsEtDonsModelInput;
  rawXML?: string;
};


export type MutationGenererAndSaveAccompteWithReglementArgs = {
  contexte?: ContextInfosInput;
  factureAccompteModele?: FactureAvoirModelDtoInput;
  rawXML?: string;
  reglementModele?: ReglementModelDtoInput;
};


export type MutationGenererArticlesLocationArgs = {
  ListeIdModeleLoc?: ArrayOfdecimalInput;
  WithClotureArticle?: boolean;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGenererBonRetourCommandeArgs = {
  contexte?: ContextInfosInput;
  modeleSuppressionCde?: ModeleSupAnnRemBonRetourCommandeDtoInput;
  rawXML?: string;
};


export type MutationGenererCommandeFournisseurSqlArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticlesFournisseurModelInput;
  rawXML?: string;
};


export type MutationGenererEcheancierReglementsMasseArgs = {
  contexte?: ContextInfosInput;
  modele?: GenereationEcheancierModeleInput;
  rawXML?: string;
};


export type MutationGenererEcritureDecaissementArgs = {
  contexte?: ContextInfosInput;
  modeleGeneration?: GenerationEcritureDecaissementModelInput;
  rawXML?: string;
};


export type MutationGenererEcrituresBalanceOuvertureArgs = {
  IdCloture?: number;
  IsForSimulation?: boolean;
  NbSkip?: number;
  NbTake?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGenererFichierPrelevementSepaArgs = {
  IdRemiseEnBanque?: number;
  IsReeditionFichier?: boolean;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGenererFichierVirementSepaArgs = {
  IdRemiseEnBanque?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGenererPermanenceArgs = {
  contexte?: ContextInfosInput;
  datePlageDeb?: string;
  datePlageFin?: string;
  idPerm?: number;
  listeHoraire?: ArrayOfArrayOfPermHeureDtoInput;
  rawXML?: string;
};


export type MutationGenererPermanenceNaArgs = {
  contexte?: ContextInfosInput;
  modeleGeneration?: GenererPermanenceModelInput;
  rawXML?: string;
};


export type MutationGenererReferenceRumArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGenererTableauEcheancierPretsEtDonsArgs = {
  codeMoyenPaiement?: string;
  contexte?: ContextInfosInput;
  idDossier?: number;
  rawXML?: string;
};


export type MutationGererActionReceptionTransfertStockArgs = {
  contexte?: ContextInfosInput;
  listeAction?: ArrayOfActionReceptionPartielleMdkModelInput;
  rawXML?: string;
};


export type MutationGestionEmpruntRetourArgs = {
  Critere?: CritereEmpruntDtoInput;
  contexte?: ContextInfosInput;
  infoEmprunt?: InfoEmpruntModelDtoInput;
  rawXML?: string;
};


export type MutationGestionMouvementStockArticleLocPlageDatesCroiseesArgs = {
  article?: ArticleDateLocationModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetAfpaModeleFraisAnnulationArgs = {
  contexte?: ContextInfosInput;
  idModeleFraisAnnulation?: number;
  rawXML?: string;
};


export type MutationGetAchatFourInitModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CritereAchatFourInitModelDtoInput;
  rawXML?: string;
};


export type MutationGetActionModelArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  idStatut?: number;
  idTrigger?: number;
  isStatutPerso?: boolean;
  rawXML?: string;
};


export type MutationGetActionsAnnulationReservationArgs = {
  IdCommande?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetActiviteJournauxArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetActualiteEditionArgs = {
  contexte?: ContextInfosInput;
  idActu?: number;
  rawXML?: string;
};


export type MutationGetAdresseFluxRssKalideaArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetAllCodeActiviteArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetAllListePubliTypeArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetAllMonoModulesArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetAllPaysArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetAllTypesLibellesArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetAllVilleCpArgs = {
  contexte?: ContextInfosInput;
  cp?: string;
  rawXML?: string;
};


export type MutationGetAnnonceDetailArgs = {
  contexte?: ContextInfosInput;
  idAnnonce?: number;
  rawXML?: string;
};


export type MutationGetAppelComplementaireForReglementArgs = {
  CriteresCompteBancaire?: CriteresCompteBancaireDtoInput;
  contexte?: ContextInfosInput;
  criteresCompte?: CriteresCompteDtoInput;
  isReglementFidu?: boolean;
  rawXML?: string;
};


export type MutationGetArborescenceBudgetArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresListingBudgetModelInput;
  rawXML?: string;
};


export type MutationGetArreteCaisseArgs = {
  contexte?: ContextInfosInput;
  idArreteCaisse?: number;
  rawXML?: string;
};


export type MutationGetArticleArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  rawXML?: string;
};


export type MutationGetArticleEtGestionStockArgs = {
  contexte?: ContextInfosInput;
  idLigneCommande?: number;
  rawXML?: string;
};


export type MutationGetArticleLocationModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleDtoInput;
  rawXML?: string;
};


export type MutationGetArticleUpKonnectArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  rawXML?: string;
};


export type MutationGetAttibutionBdgModelWithIdArgs = {
  contexte?: ContextInfosInput;
  idAtb?: number;
  rawXML?: string;
};


export type MutationGetAttributionAutoModelArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresAttributionAutoDtoInput;
  rawXML?: string;
};


export type MutationGetAvoirsAcomptesFromFournisseurArgs = {
  contexte?: ContextInfosInput;
  idFournisseur?: number;
  rawXML?: string;
};


export type MutationGetBenefBaseModelByIdArgs = {
  contexte?: ContextInfosInput;
  idBeneficiaire?: number;
  rawXML?: string;
};


export type MutationGetBenefFromIdCommandeArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetBenefFromIdLigneCommandeArgs = {
  contexte?: ContextInfosInput;
  idLigneCommande?: number;
  rawXML?: string;
};


export type MutationGetBenefMailsArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGetBenefMatriculeModelByIdArgs = {
  contexte?: ContextInfosInput;
  idBeneficiaire?: number;
  rawXML?: string;
};


export type MutationGetBenefMediathequeArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGetBenefModelForVentesClientsArgs = {
  IdBenef?: number;
  IdCommande?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetBenefNonContactableArgs = {
  contexte?: ContextInfosInput;
  crit?: CriteresBenefContactModelInput;
  idTypePublipostage?: number;
  listeId?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetBenefOdadModelArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGetBenefPourAccesPortailArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBenefBaseModelInput;
  rawXML?: string;
};


export type MutationGetBeneficiaireFicheTrombinoscopeArgs = {
  contexte?: ContextInfosInput;
  id?: number;
  rawXML?: string;
};


export type MutationGetBlocModeleArgs = {
  contexte?: ContextInfosInput;
  idBLK?: number;
  rawXML?: string;
};


export type MutationGetBudgetModeleArgs = {
  contexte?: ContextInfosInput;
  idBudget?: number;
  rawXML?: string;
};


export type MutationGetCalculAnneeReferenceArgs = {
  anneeRef?: AnneeReferenceDtoInput;
  benef?: BenefDtoInput;
  champ?: ChampDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetCalculPointArgs = {
  code?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetCatalogueFullArgs = {
  contexte?: ContextInfosInput;
  idProduit?: number;
  rawXML?: string;
};


export type MutationGetCeSynchroForParametrageOrganisationArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetCessionStockRemarqueArgs = {
  contexte?: ContextInfosInput;
  idCessionStock?: number;
  rawXML?: string;
};


export type MutationGetCessionStockRemarqueNomPrenomArgs = {
  contexte?: ContextInfosInput;
  idCessionStock?: number;
  rawXML?: string;
};


export type MutationGetChampFormulaireArgs = {
  contexte?: ContextInfosInput;
  idChampFormulaire?: number;
  rawXML?: string;
};


export type MutationGetChampListeValByCodeArgs = {
  contexte?: ContextInfosInput;
  listeCode?: ArrayOfstringInput;
  rawXML?: string;
};


export type MutationGetChampListeValFromCodeChampArgs = {
  codeChamp?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetChampListeValGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresChampListeValeurDtoInput;
  rawXML?: string;
};


export type MutationGetClotureComptableArgs = {
  contexte?: ContextInfosInput;
  idCloture?: number;
  rawXML?: string;
};


export type MutationGetCodeAnneeRefCouranteArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetCodeMoyenCorrespondanceBenefArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGetCodeMoyenPaiement2Args = {
  contexte?: ContextInfosInput;
  idProduit?: number;
  rawXML?: string;
};


export type MutationGetCodeStatutDossierPrestationArgs = {
  contexte?: ContextInfosInput;
  idDossierPresta?: number;
  rawXML?: string;
};


export type MutationGetCodeTypeActiviteWithIdActArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetCodeTypeVueArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetCommandeInfoReglementArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetCommandeModaliteReglementAffichageArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetCommandeModalitesReglementArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetCommandesAvecQuantiteArgs = {
  contexte?: ContextInfosInput;
  listeIdsLignesCommandes?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetComptaArticleImputerEpargneArgs = {
  contexte?: ContextInfosInput;
  idDossier?: number;
  rawXML?: string;
};


export type MutationGetComptaPourEcheancesArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  rawXML?: string;
};


export type MutationGetCompteImputationEtAnalytiqueModelArgs = {
  afpa?: TypeAfpaEnum;
  contexte?: ContextInfosInput;
  idElement?: number;
  rawXML?: string;
};


export type MutationGetCompteTropPercuArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresActiviteLightModelInput;
  rawXML?: string;
};


export type MutationGetComptesForListeCompteModelGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCompteDtoInput;
  rawXML?: string;
};


export type MutationGetConfirmationTransfertComptaModelArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  montantPAC?: number;
  rawXML?: string;
  typeDocumentPresente?: string;
  typeDossier?: string;
};


export type MutationGetConsommationEnveloppeQuotaArgs = {
  contexte?: ContextInfosInput;
  crit?: CriteresConsommationQuotaDtoInput;
  rawXML?: string;
};


export type MutationGetCouleurPortletArgs = {
  contexte?: ContextInfosInput;
  idPortletCss?: number;
  rawXML?: string;
  urlPortail?: string;
};


export type MutationGetCountArticleArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleLightModelInput;
  rawXML?: string;
};


export type MutationGetCountBenefArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBenefBaseModelInput;
  rawXML?: string;
};


export type MutationGetCountListeBeneficiaireGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresBenefDtoInput;
  rawXML?: string;
};


export type MutationGetCountListeMoyenPaiementActiviteGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresMoyenPaiementActiviteDtoInput;
  rawXML?: string;
};


export type MutationGetCountMediaMajapiArgs = {
  contexte?: ContextInfosInput;
  listeIdMedia?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetCountMouvementsComptablesArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementComptableModelInput;
  rawXML?: string;
};


export type MutationGetCourrierEnvoyePublipostageArgs = {
  contexte?: ContextInfosInput;
  idHistoriqueCourrier?: number;
  rawXML?: string;
};


export type MutationGetCptCollectifClientActiviteWithListIdFactRglArgs = {
  ListIDFact?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetDateDebutCalculCompteurPointArgs = {
  contexte?: ContextInfosInput;
  dateFin?: any;
  idCptPt?: number;
  rawXML?: string;
};


export type MutationGetDateDebutExerciceEnCoursArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetDatesPermArgs = {
  contexte?: ContextInfosInput;
  numPerm?: number;
  rawXML?: string;
};


export type MutationGetDefaultJournalPrmFiduArgs = {
  PaiMoyId?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetDernierArticleMagazineArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetDerniereSynchroHistoAdArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  typeSynchro?: string;
};


export type MutationGetDescriptionArticleArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  rawXML?: string;
};


export type MutationGetDetailDeclarationArgs = {
  contexte?: ContextInfosInput;
  idEtat?: number;
  rawXML?: string;
};


export type MutationGetDispoProduitGroupeModelArgs = {
  contexte?: ContextInfosInput;
  idProd?: number;
  rawXML?: string;
};


export type MutationGetDisponibiliteInscriptionGroupesArgs = {
  contexte?: ContextInfosInput;
  listeIdProduit?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetDisponibilitesRessourcesPartageesArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDisponibilitesRessourcesModelInput;
  rawXML?: string;
};


export type MutationGetDocumentsArticleEditorialArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  rawXML?: string;
};


export type MutationGetDossierBenefModelArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetDossierEpargneFullArgs = {
  IdDossier?: number;
  IdEpargne?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetDossierEpargneModelArgs = {
  IdDossier?: number;
  IdEparnge?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetDossierPrestationArgs = {
  contexte?: ContextInfosInput;
  idDossierPresta?: number;
  rawXML?: string;
};


export type MutationGetDossierPretsEtDonsArgs = {
  contexte?: ContextInfosInput;
  idDossier?: number;
  rawXML?: string;
};


export type MutationGetEcritureConsultationModelArgs = {
  contexte?: ContextInfosInput;
  idEcriture?: number;
  rawXML?: string;
};


export type MutationGetEcrituresNonConformeTvaArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresRechercheConformiteTvaModelInput;
  rawXML?: string;
};


export type MutationGetEmailEnvoyePublipostageArgs = {
  contexte?: ContextInfosInput;
  idHistoriqueCourrier?: number;
  rawXML?: string;
};


export type MutationGetEnteteDossierPrestationArgs = {
  contexte?: ContextInfosInput;
  idDossierPresta?: number;
  rawXML?: string;
};


export type MutationGetExecutionAutoAttributionModelArgs = {
  contexte?: ContextInfosInput;
  idAttrib?: number;
  rawXML?: string;
};


export type MutationGetExemplaireMediaMediathequeArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  idExemplaire?: number;
  isModeEmprunt?: boolean;
  rawXML?: string;
};


export type MutationGetExerciceACloturerArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetExportBalanceAnalytiqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementComptableModelInput;
  rawXML?: string;
};


export type MutationGetExportBalanceComptableArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementComptableModelInput;
  rawXML?: string;
};


export type MutationGetExportBalanceTiersArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementComptableModelInput;
  rawXML?: string;
};


export type MutationGetExportBilanVentesArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresImpressionBilanVenteInput;
  rawXML?: string;
};


export type MutationGetExportBudgetsArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresImpressionBudgetsInput;
  rawXML?: string;
};


export type MutationGetExportGrandLivreDesTiersArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementComptableModelInput;
  rawXML?: string;
};


export type MutationGetExtentionByFileTypeArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  typeLib?: string;
};


export type MutationGetFpaListeModelesTvaArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetFamilleArgs = {
  contexte?: ContextInfosInput;
  idFamille?: number;
  rawXML?: string;
};


export type MutationGetFamilleMediathequeFullArgs = {
  contexte?: ContextInfosInput;
  idFamille?: number;
  rawXML?: string;
};


export type MutationGetFicheProfilInfosAffichageOngletsArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetFicheProfilModelArgs = {
  contexte?: ContextInfosInput;
  idBeneficiaire?: number;
  rawXML?: string;
};


export type MutationGetFicheSignaletiqueModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresFicheSignaletiqueDtoInput;
  rawXML?: string;
};


export type MutationGetFicheTrombinoscopeArgs = {
  contexte?: ContextInfosInput;
  id?: number;
  rawXML?: string;
};


export type MutationGetFilDArianeArgs = {
  contexte?: ContextInfosInput;
  idElement?: number;
  rawXML?: string;
  typeElement?: TypeAfpaEnum;
};


export type MutationGetFiltresArreteCaisseArgs = {
  IdArreteCaisse?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetFiltresRemiseEnCaisseCentraleArgs = {
  contexte?: ContextInfosInput;
  idRemiseEnCaisseCentrale?: number;
  rawXML?: string;
};


export type MutationGetFormulaireArgs = {
  contexte?: ContextInfosInput;
  idFormulaire?: number;
  rawXML?: string;
};


export type MutationGetFormulaireArticleArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  isFormulaireALaLigne?: boolean;
  rawXML?: string;
};


export type MutationGetFormulaireLigneCommandeArgs = {
  contexte?: ContextInfosInput;
  idLigneCommande?: number;
  isFormulaireALaLigne?: boolean;
  rawXML?: string;
};


export type MutationGetFormulaireReponsesArgs = {
  contexte?: ContextInfosInput;
  idFormulaire?: number;
  rawXML?: string;
};


export type MutationGetFraisAnnulationArgs = {
  contexte?: ContextInfosInput;
  dateAnnulationCommande?: any;
  dateCommande?: any;
  listesLigneCommande?: ArrayOfLigneDevisModeleDtoInput;
  montantAcompte?: number;
  montantCommande?: number;
  rawXML?: string;
};


export type MutationGetGabaritNewsletterHtMlArgs = {
  contexte?: ContextInfosInput;
  idNewsLetterSelected?: number;
  rawXML?: string;
};


export type MutationGetGenresMediaArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetHeuresPermArgs = {
  contexte?: ContextInfosInput;
  datePerm?: any;
  idPerm?: number;
  rawXML?: string;
};


export type MutationGetHistoriqueCessionStockArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCessionStockModelInput;
  rawXML?: string;
};


export type MutationGetHistoriqueDesImportsArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresImportHistoDtoInput;
  rawXML?: string;
};


export type MutationGetHistoriqueExecutionImportArticleArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresImportArticleModelInput;
  rawXML?: string;
};


export type MutationGetHistoriqueUserArgs = {
  contexte?: ContextInfosInput;
  idCe?: number;
  idUser?: number;
  rawXML?: string;
};


export type MutationGetIbanModelArgs = {
  contexte?: ContextInfosInput;
  idBeneficiaire?: number;
  idFournisseur?: number;
  idRibIban?: number;
  rawXML?: string;
};


export type MutationGetIsbnDoublonsArgs = {
  contexte?: ContextInfosInput;
  listeISBN?: ArrayOfstringInput;
  rawXML?: string;
};


export type MutationGetIdActiviteCommandeArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetIdActiviteFactureArgs = {
  contexte?: ContextInfosInput;
  idFacture?: number;
  rawXML?: string;
};


export type MutationGetIdBenefCommandeArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetIdBenefFactureArgs = {
  contexte?: ContextInfosInput;
  idFacture?: number;
  rawXML?: string;
};


export type MutationGetIdCeCommandeArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetIdCeFactureArgs = {
  contexte?: ContextInfosInput;
  idFacture?: number;
  rawXML?: string;
};


export type MutationGetIdCommandeFournisseurArgs = {
  contexte?: ContextInfosInput;
  idLigneDevisCommande?: number;
  rawXML?: string;
};


export type MutationGetIdCompteAfpaArgs = {
  contexte?: ContextInfosInput;
  contexteCF?: ContexteClientFournisseurEnum;
  idActivite?: number;
  rawXML?: string;
  typeAFPA?: TypeAfpaEnum;
};


export type MutationGetIdCompteReglementFiduciaireArgs = {
  contexte?: ContextInfosInput;
  idCaisse?: number;
  idMoyenPaiement?: number;
  rawXML?: string;
};


export type MutationGetIdCompteTiersBenefDepuisCommandeArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetIdCompteVenteArticleArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleModelInput;
  rawXML?: string;
};


export type MutationGetIdCptBancaireParDefautSurActiviteArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetIdCptBancaireWithListIdFactArgs = {
  contexte?: ContextInfosInput;
  listeIdFact?: string;
  rawXML?: string;
};


export type MutationGetIdDelegationGlobaleArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetIdEnveloppeRegleArgs = {
  contexte?: ContextInfosInput;
  idRegle?: number;
  rawXML?: string;
};


export type MutationGetIdExerciceOfEcritureArgs = {
  IdEcriture?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetIdExerciceOfFactureArgs = {
  IdFacture?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetIdFamilleEpargneArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetIdJournalDefautArgs = {
  IdActivite?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetIdJournalVenteActiviteDefautArgs = {
  IdActivite?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetIdJournalWithIdCptBancAndIdMPayementArgs = {
  contexte?: ContextInfosInput;
  idCptBnq?: number;
  idMoyenPayement?: number;
  rawXML?: string;
};


export type MutationGetIdModeEnvoiAncvArgs = {
  IdArticle?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetIdModeleFraisAnnulationArgs = {
  IdElement?: number;
  TypeElement?: TypeAfpaEnum;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetIdTypePublipostageArgs = {
  codeType?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetImageLibrairieArgs = {
  contexte?: ContextInfosInput;
  librairie?: LibrairieImagesDtoEnum;
  rawXML?: string;
};


export type MutationGetImagesBibliothequeArgs = {
  Recherche?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetImpayesAvoirsAcomptesArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGetInfoArticleCommandeLocationArgs = {
  contexte?: ContextInfosInput;
  critereArt?: CriteresArticleDtoInput;
  critereComm?: CriteresLigneCommandeDtoInput;
  rawXML?: string;
};


export type MutationGetInfoCountAndSumArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCompteEcritureModelInput;
  rawXML?: string;
};


export type MutationGetInfoRetourHistoriqueMediathequeArgs = {
  contexte?: ContextInfosInput;
  idLigneReservation?: number;
  idMedia?: number;
  rawXML?: string;
};


export type MutationGetInformationsArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInformationsFacturationMasseArgs = {
  contexte?: ContextInfosInput;
  criteresFacturationMasse?: CriteresFacturationCommandeMasseModelInput;
  rawXML?: string;
};


export type MutationGetInformationsNouveauRapprochementArgs = {
  contexte?: ContextInfosInput;
  idCompteBancaire?: number;
  rawXML?: string;
};


export type MutationGetInformationsSiteForExportAncvArgs = {
  IdCommande?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInfosAvoirArgs = {
  contexte?: ContextInfosInput;
  idAvoir?: number;
  rawXML?: string;
};


export type MutationGetInfosBenefRpArgs = {
  IdCommande?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInfosBenefSynchronisationSynapseArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGetInfosBeneficiairesDataArgs = {
  IdWidget?: number;
  IdWidgetAccueil?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInfosChgtStatutLigneRmbMensuelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresLigneCommandeModelInput;
  rawXML?: string;
};


export type MutationGetInfosCommandePourLivraisonRapideArgs = {
  contexte?: ContextInfosInput;
  idCdeNumFac?: string;
  rawXML?: string;
};


export type MutationGetInfosControleModificationEcritureArgs = {
  contexte?: ContextInfosInput;
  idEcriture?: number;
  rawXML?: string;
};


export type MutationGetInfosCurrentCeDelegArgs = {
  IdDelegation?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInfosDemarrageConnexionArgs = {
  rawXML?: string;
};


export type MutationGetInfosDossierPrestaRemboursementMensuelArgs = {
  contexte?: ContextInfosInput;
  idDossierPresta?: number;
  idLigneDossierPresta?: number;
  rawXML?: string;
};


export type MutationGetInfosFactureForReglementWorkFlowArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresFactureModelInput;
  rawXML?: string;
};


export type MutationGetInfosImpressionFactureArgs = {
  contexte?: ContextInfosInput;
  idFacture?: number;
  rawXML?: string;
};


export type MutationGetInfosInitRecherchePjArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInfosLigneDossierDossierForModificationArgs = {
  CriteresCalculSub?: CadeauxInfosCriteresArticleCadeauxModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInfosRechercheBenefMediaMediathequeArgs = {
  code?: string;
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetInfosSuppressionDossierRmbMensuelArgs = {
  contexte?: ContextInfosInput;
  idDossier?: number;
  rawXML?: string;
};


export type MutationGetInfosValidationLigneDossierRmbMensuelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresValidationRmbMensuelInput;
  rawXML?: string;
};


export type MutationGetInfosWidgetInfosBeneficiairesArgs = {
  contexte?: ContextInfosInput;
  criteresBenef?: CriteresBenefDtoInput;
  criteresChampValeur?: CriteresChampValeurDtoInput;
  rawXML?: string;
};


export type MutationGetInitAttributionAutoModelArgs = {
  CriteresFamille?: CriteresFamilleProduitDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitDataForReglementArgs = {
  CriterePaiMoy?: CriteresMoyenPaiementDtoInput;
  CriteresBenef?: CriteresBenefDtoInput;
  contexte?: ContextInfosInput;
  criteresFour?: CriteresFournisseurDtoInput;
  rawXML?: string;
};


export type MutationGetInitForPopupMouvementArgs = {
  IdMouvement?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitForPopupMouvementComptableModelArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitModelParametrageComptes511Args = {
  contexte?: ContextInfosInput;
  criteres?: Compte511CriteresCompte511ModelInput;
  rawXML?: string;
};


export type MutationGetInitParamFicheProfilModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresProfilDroitDtoInput;
  rawXML?: string;
};


export type MutationGetInitPopupReglementEpargneAgArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitialisationAdministrationsMenusArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitialisationAdministrationsPortletsArgs = {
  contexte?: ContextInfosInput;
  isPublicHomePage?: boolean;
  listeCodeModule?: ArrayOfstringInput;
  rawXML?: string;
};


export type MutationGetInitialisationDonnesFiltrageCessionStockArgs = {
  contexte?: ContextInfosInput;
  modeleInit?: InitDonneesFiltrageCessionModelInput;
  rawXML?: string;
};


export type MutationGetInitialisationExportFournisseurArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetInitialisationForUcModeleSaisieEcritureArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitialisationModeExpertModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBenefDtoInput;
  rawXML?: string;
};


export type MutationGetInitialisationParametresPortletsActualitesArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitialisationParametresPortletsAuthentifArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitialisationParametresPortletsDocumentArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitialisationParametresPortletsListeArticleArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitialisationParametresPortletsPfbArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitialisationParametresPortletsSoldeEnvAttribArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitialisationParametresPortletsTrombinoscopeArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitialisationParametresSkinsArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetLastBanqueForTiersArgs = {
  contexte?: ContextInfosInput;
  idBeneficiaire?: number;
  idFournisseur?: number;
  rawXML?: string;
};


export type MutationGetLastUserNoteArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetLettreSuivanteEcritureArgs = {
  DateEcriture?: any;
  SurBudgetSocial?: boolean;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetLibelleAfpaFromSectionAnalytiqueArgs = {
  contexte?: ContextInfosInput;
  idSectionAnalytique?: number;
  rawXML?: string;
};


export type MutationGetLibelleAfpaModeleTvaArgs = {
  contexte?: ContextInfosInput;
  idCompte?: number;
  idModeleTVA?: number;
  rawXML?: string;
};


export type MutationGetLibelleActiviteModeleEcheancierArgs = {
  contexte?: ContextInfosInput;
  idModeleEcheancier?: number;
  rawXML?: string;
};


export type MutationGetLibelleModeleTvaAssocieArgs = {
  contexte?: ContextInfosInput;
  idCompte?: number;
  rawXML?: string;
};


export type MutationGetLibelleProduitArgs = {
  contexte?: ContextInfosInput;
  idProduit?: number;
  rawXML?: string;
};


export type MutationGetLienEspaceEnLigneActiviteArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGetLienFicheProfilArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGetLigneArreteCaissePourMoyenPaiementFiduArgs = {
  contexte?: ContextInfosInput;
  criteres?: ArreteCaisseCriteresLigneArreteCaisseModelInput;
  rawXML?: string;
};


export type MutationGetLigneDevisModelArgs = {
  IdLigne?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetLigneDossierPrestationForUpdateArgs = {
  contexte?: ContextInfosInput;
  idLigneDossierPrestation?: number;
  rawXML?: string;
};


export type MutationGetLigneRemiseEnCaisseFiduciaireArgs = {
  Criteres?: CriteresLigneRemiseEnCaisseModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetLignesArreteCaissePourMoyenPaiementNonFiduArgs = {
  contexte?: ContextInfosInput;
  criteres?: ArreteCaisseCriteresLigneArreteCaisseModelInput;
  rawXML?: string;
};


export type MutationGetListAdDevisArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  idDevisCDE?: number;
  idLigneCommande?: number;
  rawXML?: string;
};


export type MutationGetListActiviteModelArgs = {
  Critere?: CriteresActiviteDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListAlerteArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListAttributionAutoModelArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresAttributionAutoDtoInput;
  rawXML?: string;
};


export type MutationGetListBlbrListModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBlbrDtoInput;
  rawXML?: string;
};


export type MutationGetListCaisseGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCaisseDtoInput;
  rawXML?: string;
};


export type MutationGetListCommandeInfoLivrerArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDevisCommandeModelInput;
  rawXML?: string;
};


export type MutationGetListCompteJournalPrmAutoFiduArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListCompteursPointsGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresCompteurPointDtoInput;
  rawXML?: string;
};


export type MutationGetListEnteteDevisCommandeModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDevisCommandeDtoInput;
  rawXML?: string;
};


export type MutationGetListFamilleModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresFamilleProduitDtoInput;
  rawXML?: string;
};


export type MutationGetListFournisseursGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresFournisseurDtoInput;
  rawXML?: string;
};


export type MutationGetListIdCommandeInfoLivrerArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDevisCommandeModelInput;
  rawXML?: string;
};


export type MutationGetListIdLigneCommandeArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetListImportFamilleArgs = {
  Critere?: CritereImportFamilleInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListImportTraitDonneesArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresImportTraitDonneesDtoInput;
  rawXML?: string;
};


export type MutationGetListJournauxFromIdEcritureArgs = {
  contexte?: ContextInfosInput;
  idEcriture?: number;
  rawXML?: string;
};


export type MutationGetListLigneCommandeGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresLigneCommandeDtoInput;
  rawXML?: string;
};


export type MutationGetListLocalisationModelDtoArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListParamReqSpecifGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresParamReqSpecifDtoInput;
  rawXML?: string;
};


export type MutationGetListPermArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListProfilsSubventionArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListRibGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresRibDtoInput;
  rawXML?: string;
};


export type MutationGetListReportModAdrGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresReportModeleAdrdtoInput;
  rawXML?: string;
};


export type MutationGetListReqSpecifGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresReqSpecifDtoInput;
  rawXML?: string;
};


export type MutationGetListRglAndListAvoirModelArgs = {
  contexte?: ContextInfosInput;
  idFacture?: number;
  rawXML?: string;
};


export type MutationGetListSessionChoixArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresSessionChoixDtoInput;
  rawXML?: string;
};


export type MutationGetListeAfpaArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
  showCloture?: boolean;
};


export type MutationGetListeAncvModeEnvoiGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresAncvModeEnvoiDtoInput;
  rawXML?: string;
};


export type MutationGetListeApfaLiesModeleEcheancierArgs = {
  contexte?: ContextInfosInput;
  idModeleEcheancier?: number;
  rawXML?: string;
};


export type MutationGetListeAchatArticleModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleDtoInput;
  rawXML?: string;
};


export type MutationGetListeAchatLigneCdeModelArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresArticleDtoInput;
  rawXML?: string;
};


export type MutationGetListeAcompteCommandeModelDtoArgs = {
  IdCommande?: number;
  contexte?: ContextInfosInput;
  isVente?: boolean;
  rawXML?: string;
};


export type MutationGetListeAcompteModelWithIdCdeArgs = {
  contexte?: ContextInfosInput;
  idCde?: number;
  rawXML?: string;
};


export type MutationGetListeActiviteBaseAndCodeArgs = {
  contexte?: ContextInfosInput;
  params?: CriteresActiviteLightModelInput;
  rawXML?: string;
};


export type MutationGetListeActiviteCompteBanaireTypeArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresActiviteCompteBancaireTypeDtoInput;
  rawXML?: string;
};


export type MutationGetListeActiviteFamilleLienDirectoArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeActiviteGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresActiviteDtoInput;
  rawXML?: string;
};


export type MutationGetListeActivitesCadeauxPrestationArgs = {
  contexte?: ContextInfosInput;
  idActivitePrestation?: number;
  rawXML?: string;
};


export type MutationGetListeActivitesLightArgs = {
  Criteres?: CriteresActiviteLightModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeActualitesArgs = {
  contexte?: ContextInfosInput;
  getClotures?: boolean;
  nbPerPage?: number;
  numeroPage?: number;
  rawXML?: string;
};


export type MutationGetListeAdresseGeneriqueArgs = {
  Criteres?: CriteresAdresseDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeAdressesAncvLightArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeAgendaGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresAgendaDtoInput;
  rawXML?: string;
};


export type MutationGetListeAlbumsLinkedArgs = {
  contexte?: ContextInfosInput;
  id?: number;
  rawXML?: string;
};


export type MutationGetListeAnneeReferenceArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresAnneeReferenceDtoInput;
  rawXML?: string;
};


export type MutationGetListeAnneesReferenceBeneficiaireArgs = {
  contexte?: ContextInfosInput;
  idBeneficiaire?: number;
  rawXML?: string;
};


export type MutationGetListeAnneesReferenceLightArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeAnnoncesFiltreeArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresAnnonceDtoInput;
  rawXML?: string;
};


export type MutationGetListeArborescenceRubriquageArgs = {
  contexte?: ContextInfosInput;
  idRbqCpt?: number;
  rawXML?: string;
};


export type MutationGetListeArreteCaisseArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArreteEtRemiseCaisseModelInput;
  rawXML?: string;
};


export type MutationGetListeArticleCadeauModelArgs = {
  contexte?: ContextInfosInput;
  idProduit?: number;
  rawXML?: string;
};


export type MutationGetListeArticleChequierArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  rawXML?: string;
};


export type MutationGetListeArticleChequierBorneArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  rawXML?: string;
};


export type MutationGetListeArticleChequierGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresArticleChequierDtoInput;
  rawXML?: string;
};


export type MutationGetListeArticleClotureArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleLightModelInput;
  rawXML?: string;
};


export type MutationGetListeArticleEditFromDocArgs = {
  contexte?: ContextInfosInput;
  idfile?: number;
  rawXML?: string;
};


export type MutationGetListeArticleForVenteArgs = {
  contexte?: ContextInfosInput;
  criteresArticle?: CriteresArticleDtoInput;
  rawXML?: string;
};


export type MutationGetListeArticleFournisseurArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleFournisseurModelInput;
  rawXML?: string;
};


export type MutationGetListeArticleGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleDtoInput;
  rawXML?: string;
};


export type MutationGetListeArticleGeneriqueByFournisseurArgs = {
  contexte?: ContextInfosInput;
  parametresAchatArticles?: AchatArticleGeneriqueModelDtoInput;
  rawXML?: string;
};


export type MutationGetListeArticleLigneAvoirModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleDtoInput;
  listeIdPlanAnalytique?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetListeArticleLocationModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleDtoInput;
  rawXML?: string;
};


export type MutationGetListeArticleModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleDtoInput;
  rawXML?: string;
};


export type MutationGetListeArticleTransfertStockArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleLightModelInput;
  rawXML?: string;
};


export type MutationGetListeArticlesEditorielLightArgs = {
  Criteres?: CriteresArticleEditorielModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeArticlesImputationEnErreurArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleImputationEnErreurModelInput;
  rawXML?: string;
};


export type MutationGetListeArticlesLightArgs = {
  Criteres?: CriteresArticleLightModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeArticlesNonGeneriquesSansPrixAchatArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticlesFournisseurModelInput;
  rawXML?: string;
};


export type MutationGetListeAttributionBudgetArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresAttributionBudgetDtoInput;
  rawXML?: string;
};


export type MutationGetListeAttributionRanModeleArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresAttributionRanDtoInput;
  rawXML?: string;
};


export type MutationGetListeAttributionSubventionByIdEnveloppeArgs = {
  contexte?: ContextInfosInput;
  idEnveloppe?: number;
  rawXML?: string;
};


export type MutationGetListeBackgroundPortailArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeBandeauxPortailArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeBandeauxPortletArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  urlPortail?: string;
};


export type MutationGetListeBanqueGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBanqueDtoInput;
  rawXML?: string;
};


export type MutationGetListeBanquesFromMouvementComptableArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeBaremesReglesArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBorneStatModelInput;
  rawXML?: string;
};


export type MutationGetListeBenefComboModelArgs = {
  contexte?: ContextInfosInput;
  idOD?: number;
  rawXML?: string;
};


export type MutationGetListeBenefModelsForComboArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresGetListeBenefForComboInput;
  rawXML?: string;
};


export type MutationGetListeBenefMouvementEnAttenteArgs = {
  IdBenef?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeBeneficiaireForSynchronisationArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBenefDtoInput;
  rawXML?: string;
};


export type MutationGetListeBeneficiaireForSynchronisationSynapseArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBenefSynchroSynapseModelInput;
  rawXML?: string;
  skip?: number;
  take?: number;
};


export type MutationGetListeBeneficiaireGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresBenefDtoInput;
  rawXML?: string;
};


export type MutationGetListeBeneficiaireGeneriqueWithCountArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresBenefDtoInput;
  rawXML?: string;
};


export type MutationGetListeBeneficiaireNonValideArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresBenefDtoInput;
  rawXML?: string;
};


export type MutationGetListeBeneficiairesContactesPublipostageArgs = {
  contexte?: ContextInfosInput;
  idHistoriqueCourrier?: number;
  rawXML?: string;
};


export type MutationGetListeBeneficiairesNonContactableArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBenefBaseModelInput;
  rawXML?: string;
};


export type MutationGetListeBenefsForWidgetInfosBenefArgs = {
  contexte?: ContextInfosInput;
  criteresChampValeur?: CriteresChampValeurDtoInput;
  rawXML?: string;
};


export type MutationGetListeBorderRadiusThemeArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeBudgetModeleArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresBudgetDtoInput;
  rawXML?: string;
};


export type MutationGetListeCeDelegationGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresCeDelegationDtoInput;
  rawXML?: string;
};


export type MutationGetListeCaissesLightArgs = {
  contexte?: ContextInfosInput;
  criteres?: CaissesCriteresCaisseModelInput;
  rawXML?: string;
};


export type MutationGetListeCataloguesArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresProduitsInput;
  rawXML?: string;
};


export type MutationGetListeCataloguesRechercheAvanceeArgs = {
  contexte?: ContextInfosInput;
  criteres?: CritereRechercheArticleModelDtoInput;
  rawXML?: string;
};


export type MutationGetListeCategoriesArgs = {
  contexte?: ContextInfosInput;
  idCategorie?: number;
  rawXML?: string;
};


export type MutationGetListeCategoriesAnnonceGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresAnnonceCategorieDtoInput;
  rawXML?: string;
};


export type MutationGetListeCessionStockBaseModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCessionStockBaseModelInput;
  rawXML?: string;
};


export type MutationGetListeChampGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresChampDtoInput;
  rawXML?: string;
};


export type MutationGetListeChampTypeDataArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeChampTypeDonneeGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresChampTypeDonneeDtoInput;
  rawXML?: string;
};


export type MutationGetListeChampValeurByCodeChampArgs = {
  codeCritere?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeChampValeurByIdChampArgs = {
  contexte?: ContextInfosInput;
  idChamp?: number;
  rawXML?: string;
};


export type MutationGetListeChampValeurGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresChampValeurDtoInput;
  rawXML?: string;
};


export type MutationGetListeChampVueArgs = {
  contexte?: ContextInfosInput;
  idType?: number;
  idVue?: number;
  rawXML?: string;
};


export type MutationGetListeChampsByGroupeAffichageArgs = {
  contexte?: ContextInfosInput;
  criteres?: ChampsCriteresPubliModeleModelInput;
  rawXML?: string;
};


export type MutationGetListeChampsFormulaireActiviteArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetListeChampsFormulairesArgs = {
  IdActivite?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeChampsFormulairesByIdProduitArgs = {
  IdProduit?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeChampsFormulairesByIdRoomingListArgs = {
  contexte?: ContextInfosInput;
  idRoomingList?: number;
  rawXML?: string;
};


export type MutationGetListeChampsFormulairesLigneCdeByIdProduitArgs = {
  IdProduit?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeChampsGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresChampDtoInput;
  rawXML?: string;
};


export type MutationGetListeChampsHistorisesImportArgs = {
  contexte?: ContextInfosInput;
  idImport?: number;
  rawXML?: string;
};


export type MutationGetListeChampsParametrageFormulaireArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetListeChampsPersoForNewFpaArgs = {
  IdActivite?: number;
  IdFamille?: number;
  IdPRoduit?: number;
  contexte?: ContextInfosInput;
  niveau?: NiveauxAfpaEnum;
  rawXML?: string;
};


export type MutationGetListeChampsPersoPlusValeursArgs = {
  contexte?: ContextInfosInput;
  identifiant?: number;
  niveau?: NiveauxAfpaEnum;
  rawXML?: string;
};


export type MutationGetListeChampsPersonnalisesBeneficiaireArgs = {
  contexte?: ContextInfosInput;
  idBeneficiaire?: number;
  rawXML?: string;
};


export type MutationGetListeChampsTypeArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresChampsModelInput;
  rawXML?: string;
};


export type MutationGetListeChequeModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementComptableDtoInput;
  rawXML?: string;
};


export type MutationGetListeChequierGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresChequierDtoInput;
  rawXML?: string;
};


export type MutationGetListeChequiersArgs = {
  contexte?: ContextInfosInput;
  listeType?: ArrayOfstringInput;
  rawXML?: string;
};


export type MutationGetListeChoixPrefixeExportEcritureArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeClesRepartitionModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCompteSectionAnalytiqueDtoInput;
  rawXML?: string;
};


export type MutationGetListeCodeFonctionnaliteWidgetAccessibleArgs = {
  contexte?: ContextInfosInput;
  idCe?: number;
  idUser?: number;
  rawXML?: string;
};


export type MutationGetListeCommandeFournisseurArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCommandeFournisseurModelInput;
  rawXML?: string;
};


export type MutationGetListeCommandeFournisseurPartAChargeListingModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCommandeFournisseurModelInput;
  rawXML?: string;
};


export type MutationGetListeCommandeHistoriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDevisCommandeModelInput;
  rawXML?: string;
};


export type MutationGetListeCommandesBeneficiairesPartAChargeArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCommandeBeneficiaireModelInput;
  rawXML?: string;
};


export type MutationGetListeCommentairesArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCommentairesModelInput;
  rawXML?: string;
};


export type MutationGetListeCommissionArgs = {
  IdDelegation?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeCommissionGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCommissionDtoInput;
  rawXML?: string;
};


export type MutationGetListeCommissionMailArgs = {
  contexte?: ContextInfosInput;
  listeIdCom?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetListeCommissionsArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCommissionModelInput;
  rawXML?: string;
};


export type MutationGetListeCommissionsPortailArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCommissionModelInput;
  rawXML?: string;
};


export type MutationGetListeCompte511AgregByCompteBancaireArgs = {
  IdCompteBancaire?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeCompteAssociationTvaArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeCompteBancaireGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresCompteBancaireDtoInput;
  rawXML?: string;
};


export type MutationGetListeCompteBancaireModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCompteBancaireDtoInput;
  rawXML?: string;
};


export type MutationGetListeCompteBancaireModelComptaArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeCompteBaseModelArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeCompteCourantFourArgs = {
  contexte?: ContextInfosInput;
  critereCompte?: CriteresCompteDtoInput;
  rawXML?: string;
};


export type MutationGetListeCompteEcritureGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresCompteEcritureDtoInput;
  rawXML?: string;
};


export type MutationGetListeCompteForClotureOngletTresorieArgs = {
  IdExercice?: number;
  NbSkip?: number;
  NbTakes?: number;
  contexte?: ContextInfosInput;
  isCompteNonSolde?: boolean;
  rawXML?: string;
  typeBudget?: string;
};


export type MutationGetListeCompteGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresCompteDtoInput;
  rawXML?: string;
};


export type MutationGetListeCompteLightVisibleEnLigneArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCompteLightModelInput;
  rawXML?: string;
};


export type MutationGetListeCompteModelGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresCompteDtoInput;
  rawXML?: string;
};


export type MutationGetListeCompteModelSaisieEcritureArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeCompteReglementFiduciaireModelArgs = {
  contexte?: ContextInfosInput;
  idCaisse?: number;
  rawXML?: string;
};


export type MutationGetListeCompteSimplifieModelGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresCompteDtoInput;
  rawXML?: string;
};


export type MutationGetListeCompteWithInfosCollectifModelArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeComptes511Args = {
  contexte?: ContextInfosInput;
  idEcriture?: number;
  idMouvement?: number;
  rawXML?: string;
};


export type MutationGetListeComptesBancairesLightArgs = {
  contexte?: ContextInfosInput;
  criteres?: ComptesBancairesCriteresCompteBancaireModelInput;
  rawXML?: string;
};


export type MutationGetListeComptesBancairesWithIcsArgs = {
  contexte?: ContextInfosInput;
  criteres?: ComptesBancairesCriteresCompteBancaireModelInput;
  rawXML?: string;
};


export type MutationGetListeComptesLightArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCompteLightModelInput;
  rawXML?: string;
};


export type MutationGetListeComptesLightClosArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCompteLightModelInput;
  rawXML?: string;
};


export type MutationGetListeComptesMouvementArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCompteModelInput;
  rawXML?: string;
};


export type MutationGetListeCompteurPointAfpaArgs = {
  TypeElement?: TypeAfpaEnum;
  contexte?: ContextInfosInput;
  idAFPA?: number;
  rawXML?: string;
};


export type MutationGetListeCompteurPointModelBaseArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeConsoBenefSynchroArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresConsoMouvementDtoInput;
  rawXML?: string;
};


export type MutationGetListeConsoMvtPointHistoriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementConsoCompteurPointsModelInput;
  rawXML?: string;
};


export type MutationGetListeCouleurPrincipaleArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeCouleurSecondaireArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeCourrierEnvoiLigneNewsletterArgs = {
  contexte?: ContextInfosInput;
  idCourrier?: number;
  rawXML?: string;
};


export type MutationGetListeCourrierEnvoiNewsletterHistoriqueArgs = {
  contexte?: ContextInfosInput;
  idDelegation?: number;
  rawXML?: string;
};


export type MutationGetListeCourrierForListingArgs = {
  codeTypReport?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeCourrierGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCourrierDtoInput;
  rawXML?: string;
};


export type MutationGetListeCourrierHistoEnvoiGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCourrierHistoEnvoiDtoInput;
  rawXML?: string;
};


export type MutationGetListeCourrierWithCodeTypeReportArgs = {
  contexte?: ContextInfosInput;
  crit?: CourrierCriteresCourrierBaseModelInput;
  rawXML?: string;
};


export type MutationGetListeCourriersLinkedArgs = {
  contexte?: ContextInfosInput;
  id?: number;
  rawXML?: string;
};


export type MutationGetListeCourriersPublipostageAvecVueArgs = {
  contexte?: ContextInfosInput;
  criteres?: PublipostageCriteresCourrierPublipostageModelInput;
  rawXML?: string;
};


export type MutationGetListeCriteresArgs = {
  contexte?: ContextInfosInput;
  criteres?: ChampsCriteresPubliCriteresInput;
  rawXML?: string;
};


export type MutationGetListeDeclencheurOfStatutArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  idStatut?: number;
  isStatutPerso?: boolean;
  rawXML?: string;
};


export type MutationGetListeDelegationBaseModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDelegationModelDtoInput;
  rawXML?: string;
};


export type MutationGetListeDelegationIsGlobaleModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDelegationModelDtoInput;
  rawXML?: string;
};


export type MutationGetListeDepartementsGeneriqueArgs = {
  Criteres?: CriteresDepartementDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeDevisCdeModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDevisCommandeDtoInput;
  rawXML?: string;
};


export type MutationGetListeDevisCdeModelEtNombreLignesArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDevisCommandeDtoInput;
  rawXML?: string;
};


export type MutationGetListeDevisCommandeDataPagerArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDevisCommandeDtoInput;
  rawXML?: string;
};


export type MutationGetListeDevisCommandeGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDevisCommandeDtoInput;
  rawXML?: string;
};


export type MutationGetListeDevisCommandeInfosReglementsMasseArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  listeIdCommandes?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetListeDevisForInscriptionGroupesArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDevisCommandeModelInput;
  rawXML?: string;
};


export type MutationGetListeDocumentsGedArgs = {
  contexte?: ContextInfosInput;
  criteres?: GedCriteresFiltrageGedModelInput;
  rawXML?: string;
};


export type MutationGetListeDocumentsGedModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: GedCriteresFiltrageGedModelInput;
  rawXML?: string;
};


export type MutationGetListeDonneesActiviteGraphModelArgs = {
  contexte?: ContextInfosInput;
  critere?: CritereActiviteGraphModelDtoInput;
  rawXML?: string;
};


export type MutationGetListeDonneesGraphModelArgs = {
  contexte?: ContextInfosInput;
  critere?: CritereBenefGraphModelDtoInput;
  rawXML?: string;
};


export type MutationGetListeDossierEpargneListerArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDevisCommandeModelInput;
  rawXML?: string;
};


export type MutationGetListeDroitsPortailArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeEcheancierModelArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresEcheancierDtoInput;
  rawXML?: string;
};


export type MutationGetListeEcritureBalanceOuvertureModelArgs = {
  Criteres?: CriteresCompteEcritureModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeEcritureForConsultationArgs = {
  NeedPJ?: boolean;
  contexte?: ContextInfosInput;
  criteres?: CriteresCompteEcritureModelInput;
  rawXML?: string;
};


export type MutationGetListeEcritureMouvementModelExportArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCompteEcritureModelInput;
  rawXML?: string;
};


export type MutationGetListeEcritureRecetteDepenseArgs = {
  NeedPJ?: boolean;
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementComptableDtoInput;
  rawXML?: string;
};


export type MutationGetListeEcrituresAffichageBaseModelArgs = {
  contexte?: ContextInfosInput;
  listeIdEcritures?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetListeEcrituresAnalytiqueEnErreurArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementAnalytiqueEnErreurModelInput;
  rawXML?: string;
};


export type MutationGetListeEcrituresDesequilibreesArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresEcritureDesequilibreeModelInput;
  rawXML?: string;
};


export type MutationGetListeEcrituresWrongLettrageArgs = {
  contexte?: ContextInfosInput;
  idExercice?: number;
  rawXML?: string;
};


export type MutationGetListeElementLinkedArgs = {
  contexte?: ContextInfosInput;
  idFile?: number;
  rawXML?: string;
};


export type MutationGetListeElementsAssociesAlbumArgs = {
  contexte?: ContextInfosInput;
  idAlbum?: number;
  rawXML?: string;
};


export type MutationGetListeElementsAssociesDocumentsArgs = {
  contexte?: ContextInfosInput;
  idAlbum?: number;
  idArticle?: number;
  idDocument?: number;
  rawXML?: string;
};


export type MutationGetListeEngagementBudgetArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresEngagementBudgetDtoInput;
  rawXML?: string;
};


export type MutationGetListeEntetesBaremeGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresEnteteBaremeDtoInput;
  rawXML?: string;
};


export type MutationGetListeEnveloppeGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresEnveloppeQuotaDtoInput;
  rawXML?: string;
};


export type MutationGetListeEnveloppeModeleGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresEnveloppeQuotaDtoInput;
  rawXML?: string;
};


export type MutationGetListeEnveloppesBaseArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresEnveloppeBaseModelInput;
  rawXML?: string;
};


export type MutationGetListeEtatPreparatoireForHistoArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeExemplairesForRechercheMediaArgs = {
  contexte?: ContextInfosInput;
  critereRechercheExemplaire?: CritereRechercheArticleModelDtoInput;
  rawXML?: string;
};


export type MutationGetListeExerciceBaseModelArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeExerciceForClotureArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeExerciceInfosArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeExerciceModelArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresExerciceDtoInput;
  rawXML?: string;
};


export type MutationGetListeFpaActiviteArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetListeFpaCodeUtiliseArgs = {
  code?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
  typeFpa?: TypeAfpaEnum;
};


export type MutationGetListeFpaFiltreArgs = {
  contexte?: ContextInfosInput;
  idElement?: number;
  rawXML?: string;
  typeElement?: TypeAfpaEnum;
};


export type MutationGetListeFacturesArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresFactureModelInput;
  rawXML?: string;
};


export type MutationGetListeFacturesDataArgs = {
  IdWidget?: number;
  IdWidgetAccueil?: number;
  NbrLignes?: number;
  Page?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeFacturesGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresFactureDtoInput;
  rawXML?: string;
};


export type MutationGetListeFacturesModelForWidgetArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresFactureDtoInput;
  rawXML?: string;
};


export type MutationGetListeFacturesPourHistoriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresFactureModelInput;
  rawXML?: string;
};


export type MutationGetListeFamilleDirectoModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresFamilleProduitDtoInput;
  rawXML?: string;
};


export type MutationGetListeFamilleProduitGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresFamilleProduitDtoInput;
  rawXML?: string;
};


export type MutationGetListeFamilleproduitModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresFamilleProduitDtoInput;
  rawXML?: string;
};


export type MutationGetListeFamillesLightArgs = {
  Criteres?: CriteresFamilleLightModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeFamillesMediathequeLightArgs = {
  VoirClotures?: boolean;
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetListeFicheProfilDataGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresFicheProfilDataDirectoDtoInput;
  rawXML?: string;
};


export type MutationGetListeFonctionnalitesProfilArgs = {
  contexte?: ContextInfosInput;
  idProfil?: number;
  rawXML?: string;
};


export type MutationGetListeFormulaireArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetListeFormulaireCommandeArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetListeFormulairesParticipantArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGetListeFormulairesSpecifiquesArgs = {
  CriteresPortailFormulaireSpecifique?: CriteresPortailFormulaireSpecifiqueDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeFournisseurNonClosLightArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeFournisseurRemiseGlobaleArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeFraisAnnulationArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetListeFraisAnnulationSupprimableArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetListeGestionnaireArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeGestionnaireParametreArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeGroupesRoomingListArgs = {
  contexte?: ContextInfosInput;
  idRegroupement?: number;
  rawXML?: string;
};


export type MutationGetListeHistoImportGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresImportHistoDtoInput;
  rawXML?: string;
};


export type MutationGetListeHistoriqueEnvoiArgs = {
  contexte?: ContextInfosInput;
  criteres?: HistoriqueCourrierCriteresHistoriqueEnvoiModelInput;
  rawXML?: string;
};


export type MutationGetListeHistoriqueEnvoiPublipostageArgs = {
  contexte?: ContextInfosInput;
  criteres?: HistoriqueCourrierCriteresHistoriqueEnvoiModelInput;
  rawXML?: string;
};


export type MutationGetListeHistoriqueStatutArgs = {
  contexte?: ContextInfosInput;
  crit?: CriteresHistoStatutCommandeDtoInput;
  rawXML?: string;
};


export type MutationGetListeHomeNotificationsArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeIanModelArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeIbanMandatsLightArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGetListeIbanArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  idFournisseur?: number;
  rawXML?: string;
};


export type MutationGetListeIbansTiersArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresRibsModelInput;
  rawXML?: string;
};


export type MutationGetListeIdArticleCommandeArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetListeIdBenefArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBenefBaseModelInput;
  rawXML?: string;
};


export type MutationGetListeIdCommandesArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDevisCommandeModelInput;
  rawXML?: string;
};


export type MutationGetListeIdCommissionFromOptionsGeneralesArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeIdCompteAttenteArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeIdLigneCommandeArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresLigneCommandeModelInput;
  rawXML?: string;
};


export type MutationGetListeIdStocksAutorisesArgs = {
  contexte?: ContextInfosInput;
  idUser?: number;
  rawXML?: string;
};


export type MutationGetListeIdsAcomptesArgs = {
  contexte?: ContextInfosInput;
  idFacture?: number;
  rawXML?: string;
};


export type MutationGetListeIdsCommandeArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresImpressionBilanVenteInput;
  rawXML?: string;
};


export type MutationGetListeImagesCommonGedArgs = {
  contexte?: ContextInfosInput;
  criteres?: GedCriteresFiltrageGedModelInput;
  rawXML?: string;
};


export type MutationGetListeImportHistoStatutGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresImportHistoStatutDtoInput;
  rawXML?: string;
};


export type MutationGetListeImportModeleGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresImportModeleDtoInput;
  rawXML?: string;
};


export type MutationGetListeImportModeleTypeGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresImportModeleTypeDtoInput;
  rawXML?: string;
};


export type MutationGetListeImportReqPrepostArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresImportReqPrepostDtoInput;
  rawXML?: string;
};


export type MutationGetListeInfosAcompteFourDossierPrestaArgs = {
  contexte?: ContextInfosInput;
  idDossierPresta?: number;
  rawXML?: string;
};


export type MutationGetListeInfosAssociationConnectionV2Args = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeInfosFactureModelDataPagerArgs = {
  contexte?: ContextInfosInput;
  critereFact?: CriteresFactureDtoInput;
  rawXML?: string;
};


export type MutationGetListeInfosGeneralesMouvementComptableArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementComptableModelInput;
  rawXML?: string;
};


export type MutationGetListeInfosHistoriquePretsEtDonsArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDevisCommandeModelInput;
  rawXML?: string;
};


export type MutationGetListeInfosLignesCommandeFournisseurArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresArticlesFournisseurModelInput;
  rawXML?: string;
};


export type MutationGetListeInventaireGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresInventaireDtoInput;
  rawXML?: string;
};


export type MutationGetListeJournauxArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresJournalBaseModelInput;
  rawXML?: string;
};


export type MutationGetListeJournauxAndExerciceModelArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresModelJournauxExerciceDtoInput;
  rawXML?: string;
};


export type MutationGetListeJournauxCaisseMoyenPaiementFiduArgs = {
  contexte?: ContextInfosInput;
  idCaisse?: number;
  rawXML?: string;
};


export type MutationGetListeJournauxGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresJournalDtoInput;
  rawXML?: string;
};


export type MutationGetListeJournauxLightArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresJournalBaseModelInput;
  rawXML?: string;
};


export type MutationGetListeLettrageModelArgs = {
  Criteres?: CriteresMouvementComptableDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeLettreEcrituresFromFactureArgs = {
  IdFacture?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeLibellesChampsModifiablesHistoriqueBenefArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeLienDirectoGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresLienDirectoDtoInput;
  rawXML?: string;
};


export type MutationGetListeLiensDirectoArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeLieuxGeneriqueArgs = {
  Criteres?: CriteresLieuDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeLigneAvoirModelArgs = {
  contexte?: ContextInfosInput;
  idAvoir?: number;
  rawXML?: string;
};


export type MutationGetListeLigneCdeFourArticleReapproArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresDevisCommandeDtoInput;
  rawXML?: string;
};


export type MutationGetListeLigneCessionStockArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresLigneCessionStockModelInput;
  rawXML?: string;
};


export type MutationGetListeLigneCessionStockDetailArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresLigneCessionStockModelInput;
  rawXML?: string;
};


export type MutationGetListeLigneCommandeLibreArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresLigneCommandeDtoInput;
  rawXML?: string;
};


export type MutationGetListeLigneFactureAvoirModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresLigneCommandeDtoInput;
  rawXML?: string;
};


export type MutationGetListeLigneHistoriqueReservationRpArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresLigneCommandeRpModelInput;
  rawXML?: string;
};


export type MutationGetListeLigneHistoriqueReservationsArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresLigneCommandeModelInput;
  rawXML?: string;
};


export type MutationGetListeLigneInventaireArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresMouvementStockInventaireInput;
  rawXML?: string;
};


export type MutationGetListeLigneInventaireGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresLigneInventaireDtoInput;
  rawXML?: string;
};


export type MutationGetListeLigneOfCommandeArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetListeLigneRemiseEnBanqueModelArgs = {
  contexte?: ContextInfosInput;
  idRemise?: number;
  rawXML?: string;
};


export type MutationGetListeLigneRemiseEnCaisseNonFiduciaireArgs = {
  Criteres?: CriteresLigneRemiseEnCaisseModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeLigneTransfertStockArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresLigneCessionStockModelInput;
  rawXML?: string;
};


export type MutationGetListeLignesCessionStockPourModificationArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresLigneCessionStockModelInput;
  rawXML?: string;
};


export type MutationGetListeLignesCommandesAttributionArgs = {
  contexte?: ContextInfosInput;
  criteresLigneCommande?: CriteresLigneCommandeModelInput;
  rawXML?: string;
};


export type MutationGetListeLignesEnvoiModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresLignesEnvoiModelDtoInput;
  rawXML?: string;
};


export type MutationGetListeLignesPreviewArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresImportHistoLigneDtoInput;
  rawXML?: string;
};


export type MutationGetListeLocationsPourAttributionAutoArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleModelInput;
  rawXML?: string;
};


export type MutationGetListeLocationsTauxOccupationArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleModelInput;
  rawXML?: string;
};


export type MutationGetListeLogsAfpaArgs = {
  contexte?: ContextInfosInput;
  idElement?: number;
  rawXML?: string;
  typeElement?: TypeAfpaEnum;
};


export type MutationGetListeMandatUsedArgs = {
  contexte?: ContextInfosInput;
  idRib?: number;
  rawXML?: string;
};


export type MutationGetListeMappingValeurColonnesArgs = {
  contexte?: ContextInfosInput;
  idImport?: number;
  rawXML?: string;
};


export type MutationGetListeMenuGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMenuDtoInput;
  rawXML?: string;
};


export type MutationGetListeMessageAppliGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMessageAppliDtoInput;
  rawXML?: string;
};


export type MutationGetListeModalitesReglementCommandeAvailableArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetListeModeLivraisonModelForVentesClientsArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeModelArticleActiviteBaseArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  listCodeActiviteType?: ArrayOfstringInput;
  rawXML?: string;
};


export type MutationGetListeModelBlocageExemplaireArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticleLightModelInput;
  rawXML?: string;
};


export type MutationGetListeModelClotureReportDesTiersArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementComptableModelInput;
  rawXML?: string;
};


export type MutationGetListeModelEmailPubliArgs = {
  contexte?: ContextInfosInput;
  crit?: ModelEmailCriteresModelEmailModelInput;
  rawXML?: string;
};


export type MutationGetListeModelEmailPubliLightArgs = {
  contexte?: ContextInfosInput;
  crit?: ModelEmailCriteresModelEmailModelInput;
  rawXML?: string;
};


export type MutationGetListeModelProduitAvecIdFamilleArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetListeModelProduitClosArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetListeModeleAdresseArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresReportModeleAdrdtoInput;
  rawXML?: string;
};


export type MutationGetListeModeleClotureVariationStockArgs = {
  Criteres?: CriteresClotureVariationStockInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeModeleEcheancieActiviteArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresEcheancierModeleActiviteModelInput;
  rawXML?: string;
};


export type MutationGetListeModeleEcheancierArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresEcheancierModelInput;
  rawXML?: string;
};


export type MutationGetListeModeleEcheancierFpaArgs = {
  IdElement?: number;
  TypeElement?: TypeAfpaEnum;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeModeleEcheancierInfosArgs = {
  contexte?: ContextInfosInput;
  isContexteEpargne?: boolean;
  rawXML?: string;
};


export type MutationGetListeModeleEnveloppeForAfpaArgs = {
  contexte?: ContextInfosInput;
  paramRechercheEnveloppe?: ParametreRechercheEnveloppeDtoInput;
  rawXML?: string;
};


export type MutationGetListeModeleLocationArgs = {
  IdProduit?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeModeleMailArgs = {
  contexte?: ContextInfosInput;
  criteres?: ModelEmailCriteresModelEmailModelInput;
  rawXML?: string;
};


export type MutationGetListeModeleMoteurRegleForParamAfpaGeneriqueArgs = {
  contexte?: ContextInfosInput;
  paramRechercheRegle?: ParametreRechercheRegleModelDtoInput;
  rawXML?: string;
};


export type MutationGetListeModeleMoteurRegleGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresMoteurRegleDtoInput;
  rawXML?: string;
};


export type MutationGetListeModeleRegleLocaleForDuplicationArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresMoteurRegleDtoInput;
  rawXML?: string;
};


export type MutationGetListeModeleSaisieEcritureArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeModeleSaisieLibreGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresModeleSaisieLibreDtoInput;
  rawXML?: string;
};


export type MutationGetListeModelesAdresseArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresModeleAdresseModelInput;
  rawXML?: string;
};


export type MutationGetListeModelesRequeteArgs = {
  contexte?: ContextInfosInput;
  idContexte?: number;
  rawXML?: string;
};


export type MutationGetListeModelesTvaArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeModelesTvaLightArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresTvaModelInput;
  rawXML?: string;
};


export type MutationGetListeModesLivraisonArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresModeLivraisonDtoInput;
  rawXML?: string;
};


export type MutationGetListeModificationsByCriteresPagineArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresHistoriqueModifBenefInput;
  rawXML?: string;
};


export type MutationGetListeModseEnvoiAncvArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeModulesInfoArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeMoteurRegleTypeDateRefArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeMouvementComptableForClotureArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresMouvementComptableModelInput;
  rawXML?: string;
};


export type MutationGetListeMouvementComptableGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementComptableDtoInput;
  rawXML?: string;
};


export type MutationGetListeMouvementComptableModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementComptableDtoInput;
  rawXML?: string;
};


export type MutationGetListeMouvementConsoModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementConsoModelInput;
  rawXML?: string;
};


export type MutationGetListeMouvementInfosLettrageAutoArgs = {
  contexte?: ContextInfosInput;
  crit?: CriteresLettrageAutomatiqueModelInput;
  rawXML?: string;
};


export type MutationGetListeMouvementModelEtNombreLignesArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementComptableDtoInput;
  rawXML?: string;
};


export type MutationGetListeMouvementStockModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementStockDtoInput;
  rawXML?: string;
};


export type MutationGetListeMouvementsAnalytiquesModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementAnalytiqueDtoInput;
  rawXML?: string;
};


export type MutationGetListeMouvementsCollectifSansTiersArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementCollectifSansTiersModelInput;
  rawXML?: string;
};


export type MutationGetListeMouvementsReglementsModelArgs = {
  codeFourOrBenef?: string;
  contexte?: ContextInfosInput;
  idDossierPresta?: number;
  rawXML?: string;
};


export type MutationGetListeMouvementsRemisEnBanqueArgs = {
  contexte?: ContextInfosInput;
  listeIdsMouvements?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetListeMouvementsSansTiersDuCompteArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementSansTiersDetailModelInput;
  rawXML?: string;
};


export type MutationGetListeMouvementsStockGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementStockDtoInput;
  rawXML?: string;
};


export type MutationGetListeMoyenPaiementCommunForListeFacturesArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresMoyenPaiementDtoInput;
  listeIdFactures?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetListeMoyenPaiementForEcheancierAfpaArgs = {
  IdElement?: number;
  TypeElement?: TypeAfpaEnum;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeMoyenPaiementGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresMoyenPaiementDtoInput;
  rawXML?: string;
};


export type MutationGetListeMoyenPaiementModelGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresMoyenPaiementDtoInput;
  rawXML?: string;
};


export type MutationGetListeMoyenneCompteurPointArgs = {
  contexte?: ContextInfosInput;
  listeCptPt?: ArrayOfCompteurPointDtoInput;
  rawXML?: string;
};


export type MutationGetListeMoyensPaiementLightArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMoyenPaiementModelInput;
  rawXML?: string;
};


export type MutationGetListeNatureMouvementsStockGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresNatureMouvementStockDtoInput;
  rawXML?: string;
};


export type MutationGetListeNewsletterModeleArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeNewsletterThemeArgs = {
  contexte?: ContextInfosInput;
  idDelegation?: number;
  rawXML?: string;
};


export type MutationGetListeNewsletterThemeFromCourrierArgs = {
  contexte?: ContextInfosInput;
  idCourrier?: number;
  rawXML?: string;
};


export type MutationGetListeNomCev2Args = {
  rawXML?: string;
  userLogin?: string;
  userPassword?: string;
};


export type MutationGetListeOmbreThemeArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeOrganisationBaseModelArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeOrganisationGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresOrganisationDtoInput;
  rawXML?: string;
};


export type MutationGetListeOrganisationGeneriqueAPlatArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresOrganisationDtoInput;
  rawXML?: string;
};


export type MutationGetListeOrganisationsBaseModelSiteOrganisationArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListePjadodCompleteArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresOdadModelInput;
  rawXML?: string;
};


export type MutationGetListePjByListeCodeTypeArgs = {
  contexte?: ContextInfosInput;
  listeCodeTypePJ?: ArrayOfstringInput;
  rawXML?: string;
};


export type MutationGetListePjDiversForBenefArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGetListePjLightArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListePjLightFiltreArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresPjModeleInput;
  rawXML?: string;
};


export type MutationGetListeParticipantsLigneDossierArgs = {
  IdLigneDossier?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListePermanencesArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListePermanencesParamActiviteArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetListePieceJustificativeArgs = {
  contexte?: ContextInfosInput;
  criteres?: DossierPrestationCriteresPjModelInput;
  rawXML?: string;
};


export type MutationGetListePieceJustificativeBenefModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresPjModeleInput;
  rawXML?: string;
};


export type MutationGetListePieceJustificativeDossierPrestationModelArgs = {
  contexte?: ContextInfosInput;
  idDossierPrestation?: number;
  rawXML?: string;
};


export type MutationGetListePieceJustificativeGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresPieceJustificativeDtoInput;
  rawXML?: string;
};


export type MutationGetListePieceJustificativeModelGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresPieceJustificativeDtoInput;
  rawXML?: string;
};


export type MutationGetListePieceJustificativesForRechercheArgs = {
  contexte?: ContextInfosInput;
  criteres?: DossierPrestationCriteresPjModelInput;
  rawXML?: string;
};


export type MutationGetListePieceJustificativesForWidgetArgs = {
  contexte?: ContextInfosInput;
  criteres?: DossierPrestationCriteresPjModelInput;
  rawXML?: string;
};


export type MutationGetListePiecesJustificativesArgs = {
  contexte?: ContextInfosInput;
  idDossierPresta?: number;
  rawXML?: string;
};


export type MutationGetListePlanAnalytiqueGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresPlanAnalytiqueDtoInput;
  rawXML?: string;
};


export type MutationGetListePlanCompteArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCompteModelInput;
  rawXML?: string;
};


export type MutationGetListePlanSectionAnalytiqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresPlanAnalytiqueDtoInput;
  rawXML?: string;
};


export type MutationGetListePlanWithSectionsAnalytiquesArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListePointVenteArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresPointVenteDtoInput;
  rawXML?: string;
};


export type MutationGetListePointVenteGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresPointVenteDtoInput;
  rawXML?: string;
};


export type MutationGetListePortailArticleGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresPortailArticleDtoInput;
  rawXML?: string;
};


export type MutationGetListePortailDocumentCategorieGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresPortailDocumentCategorieDtoInput;
  rawXML?: string;
};


export type MutationGetListePortailStatutGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresPortailStatutDtoInput;
  rawXML?: string;
};


export type MutationGetListePosteBudgetaireModeleArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresPosteBudgetaireDtoInput;
  rawXML?: string;
};


export type MutationGetListeProduitAvecIdFamilleArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresProduitLightModelInput;
  rawXML?: string;
};


export type MutationGetListeProduitEpargneArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetListeProduitGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresProduitDtoInput;
  rawXML?: string;
};


export type MutationGetListeProduitModelArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresProduitDtoInput;
  rawXML?: string;
};


export type MutationGetListeProduitsBaseClosArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresProduitLightModelInput;
  rawXML?: string;
};


export type MutationGetListeProduitsLightArgs = {
  Criteres?: CriteresProduitLightModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeProfilDroitMenuTypeActiviteModelGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresProfilDroitMenuTypeActiviteDtoInput;
  rawXML?: string;
};


export type MutationGetListeProfilKalideaArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeProfilsMonEspaceCseArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListePubliDocumentReportArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresPubliDocumentInput;
  rawXML?: string;
};


export type MutationGetListePubliVueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresPubliVueInput;
  rawXML?: string;
};


export type MutationGetListePublichpDynamiquesArgs = {
  contexte?: ContextInfosInput;
  criteres?: ChampsCriteresPubliChampsDynamiquesInput;
  rawXML?: string;
};


export type MutationGetListeRapprochementModeleGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresRapprochementDtoInput;
  rawXML?: string;
};


export type MutationGetListeRegionsGeneriqueArgs = {
  Criteres?: CriteresRegionDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeReglementsFactureArgs = {
  contexte?: ContextInfosInput;
  idFacture?: number;
  rawXML?: string;
};


export type MutationGetListeReglesBaseArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresReglesModelInput;
  rawXML?: string;
};


export type MutationGetListeReglesParentArgs = {
  contexte?: ContextInfosInput;
  idElement?: number;
  rawXML?: string;
  typeElement?: TypeAfpaEnum;
};


export type MutationGetListeReglesUseAfpaArgs = {
  contexte?: ContextInfosInput;
  idElement?: number;
  rawXML?: string;
  typeElement?: TypeAfpaEnum;
  typeRegle?: string;
};


export type MutationGetListeReleveBancaireArgs = {
  NeedPJ?: boolean;
  contexte?: ContextInfosInput;
  critere?: CriteresReleveBancaireDtoInput;
  rawXML?: string;
};


export type MutationGetListeRemiseEnBanqueGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBanqueRemiseDtoInput;
  rawXML?: string;
};


export type MutationGetListeRemiseEnBanqueModelGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBanqueRemiseDtoInput;
  rawXML?: string;
};


export type MutationGetListeRemiseEnCaisseArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArreteEtRemiseCaisseModelInput;
  rawXML?: string;
};


export type MutationGetListeRepartitionLigneFactureAnalytiqueModelArgs = {
  contexte?: ContextInfosInput;
  idLigneFacture?: number;
  rawXML?: string;
};


export type MutationGetListeRepartitionMouvementAnalytiqueModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementAnalytiqueDtoInput;
  rawXML?: string;
};


export type MutationGetListeReportGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresReportDtoInput;
  rawXML?: string;
};


export type MutationGetListeRequetesForListingArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresPubliRequeteModelInput;
  rawXML?: string;
};


export type MutationGetListeRessourcesArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresProduitsInput;
  rawXML?: string;
};


export type MutationGetListeRessourcesForDisposArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDisponibilitesRessourcesModelInput;
  rawXML?: string;
};


export type MutationGetListeRessourcesPartageesArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresProduitsInput;
  rawXML?: string;
};


export type MutationGetListeRibNonClosBenefArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetListeRoomingListArgs = {
  contexte?: ContextInfosInput;
  criteres?: CritereRechercheRoomingListInput;
  rawXML?: string;
};


export type MutationGetListeRoomingListeParticipantsArgs = {
  contexte?: ContextInfosInput;
  idProduit?: number;
  idRegroupement?: number;
  listeIdChampFormulaire?: ArrayOfintInput;
  rawXML?: string;
};


export type MutationGetListeRubriquageArgs = {
  codeEtat?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeSectionAnalytiqueGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresSectionAnalytiqueDtoInput;
  rawXML?: string;
};


export type MutationGetListeSessionChoixBaseModelArgs = {
  IdActivite?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeSiteBaseModelArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeSiteGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresSiteDtoInput;
  rawXML?: string;
};


export type MutationGetListeSiteGeneriqueAPlatArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresSiteDtoInput;
  rawXML?: string;
};


export type MutationGetListeSiteLivraisonArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeSitesBaseModelSiteOrganisationArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeSoldeConsommationsArgs = {
  codeContexte?: string;
  contexte?: ContextInfosInput;
  criteres?: CriteresSoldeConsommationsDtoInput;
  rawXML?: string;
};


export type MutationGetListeSoldePmvArgs = {
  contexte?: ContextInfosInput;
  crit?: CriteresSoldePmvModelInput;
  rawXML?: string;
};


export type MutationGetListeStatutAdmAvecPereArgs = {
  codeStatut?: string;
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetListeStatutAdmForFiltreArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresRechercheStatutsModelInput;
  rawXML?: string;
};


export type MutationGetListeStatutAdministratifArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeStatutCommandeArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresStatutCommandeDtoInput;
  rawXML?: string;
};


export type MutationGetListeStatutCommandeNaArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetListeStatutCourrierGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresStatutCourrierDtoInput;
  rawXML?: string;
};


export type MutationGetListeStatutPersoBaseArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresStatutPersoModelInput;
  rawXML?: string;
};


export type MutationGetListeStatutPersoCouleurArgs = {
  contexte?: ContextInfosInput;
  crit?: CriteresStatutPersoModelInput;
  rawXML?: string;
};


export type MutationGetListeStatutsFactureArgs = {
  contexte?: ContextInfosInput;
  idFacture?: number;
  rawXML?: string;
};


export type MutationGetListeStatutsFactureLightArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresStatutFactureModelInput;
  rawXML?: string;
};


export type MutationGetListeStockArticleGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresStockArticleDtoInput;
  rawXML?: string;
};


export type MutationGetListeStockArticleModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresStockArticleDtoInput;
  dateMax?: any;
  rawXML?: string;
};


export type MutationGetListeStockGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresStockDtoInput;
  rawXML?: string;
};


export type MutationGetListeStockLightArgs = {
  Criteres?: CriteresStockLightModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeStockLivraisonMediathequeArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetListeStockTypeReapproArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeStockTypeReapproGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresStockTypeReapproDtoInput;
  rawXML?: string;
};


export type MutationGetListeTagsBibliothequeImageArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeTransfertsPourHistoriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCessionStockModelInput;
  rawXML?: string;
};


export type MutationGetListeTrombinoscopeArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  skip?: number;
  take?: number;
};


export type MutationGetListeTrombinoscopeCommissionArgs = {
  contexte?: ContextInfosInput;
  idCommission?: number;
  idTrombinoscope?: number;
  rawXML?: string;
};


export type MutationGetListeTypeActiviteGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresTypeActiviteDtoInput;
  rawXML?: string;
};


export type MutationGetListeTypeAnalyseIaArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeTypeArrondiArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeTypeBenefGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresTypeBenefDtoInput;
  rawXML?: string;
};


export type MutationGetListeTypeCalculModeLivraisonGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresTypeCalculModeLivraisonDtoInput;
  rawXML?: string;
};


export type MutationGetListeTypeChampFormulaireArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeTypeConsoMouvementArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresTypeConsoMouvementPointDtoInput;
  rawXML?: string;
};


export type MutationGetListeTypeMoyenPaiementGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresTypeMoyenPaiementDtoInput;
  rawXML?: string;
};


export type MutationGetListeTypePjArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeTypeReportGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresReportTypeDtoInput;
  rawXML?: string;
};


export type MutationGetListeTypesDatesRegleArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeTypesDocArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeTypesModelsArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeUserBaseArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresUsersModelInput;
  rawXML?: string;
};


export type MutationGetListeUserCommissionGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresUserCommissionDtoInput;
  rawXML?: string;
};


export type MutationGetListeUserGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresUsersDtoInput;
  rawXML?: string;
};


export type MutationGetListeUsersCommissionArgs = {
  contexte?: ContextInfosInput;
  idCommission?: number;
  rawXML?: string;
};


export type MutationGetListeUsersLightArgs = {
  Criteres?: CriteresUsersModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeUsersMailArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeValeursArgs = {
  codeChamp?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeValeursChampRegleAccessibiliteMediathequeArgs = {
  contexte?: ContextInfosInput;
  idChamp?: number;
  idModeleRegle?: number;
  rawXML?: string;
};


export type MutationGetListeVillesGeneriqueArgs = {
  Criteres?: CriteresVilleDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeVueGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresVueDtoInput;
  rawXML?: string;
};


export type MutationGetListeVuesAvecChampsArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresPubliVueInput;
  rawXML?: string;
};


export type MutationGetListeWidgetAccueilParametreModelArgs = {
  IdWidget?: number;
  IdWidgetAccueil?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeWidgetsAccueilGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteresWidget?: CriteresWidgetAccueilDtoInput;
  rawXML?: string;
};


export type MutationGetListeWidgetsGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteresWidget?: CriteresWidgetDtoInput;
  rawXML?: string;
};


export type MutationGetListeWidgetsProfilArgs = {
  contexte?: ContextInfosInput;
  idProfil?: number;
  rawXML?: string;
};


export type MutationGetListesBanqueLightArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBanqueModelInput;
  rawXML?: string;
};


export type MutationGetListesCadeauxFpaModelArgs = {
  contexte?: ContextInfosInput;
  critere?: CritereCadeauModelInput;
  rawXML?: string;
};


export type MutationGetListesConnexionUtilisateurArgs = {
  UserId?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListesDonneesReglesAvanceesArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  typeDeRegle?: TypesRegleEnum;
};


export type MutationGetListesPiecesJustificativesArgs = {
  contexte?: ContextInfosInput;
  idFormulePrestation?: number;
  rawXML?: string;
};


export type MutationGetLogsDetaillesArgs = {
  ListeCodes?: ArrayOfstringInput;
  contexte?: ContextInfosInput;
  idImport?: number;
  nbElements?: number;
  rawXML?: string;
  skip?: number;
};


export type MutationGetMediathequeEmpruntReservationFamilleModelArgs = {
  contexte?: ContextInfosInput;
  idFamille?: number;
  rawXML?: string;
};


export type MutationGetMediathequeFicheMediaLightFamilleModelArgs = {
  contexte?: ContextInfosInput;
  idFamille?: number;
  rawXML?: string;
};


export type MutationGetMediathequeResaEnLigneFamilleModelArgs = {
  contexte?: ContextInfosInput;
  idFamille?: number;
  rawXML?: string;
};


export type MutationGetMiniDateDebutLocOrGroupeArgs = {
  ListeIdFacture?: ArrayOfdecimalInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetMiniDateDebutLocOrGroupeByIdCdeArgs = {
  IdCde?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetModelBaseDescriptorArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGetModelEmailGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresModelEmailDtoInput;
  rawXML?: string;
};


export type MutationGetModelEmailPubliArgs = {
  contexte?: ContextInfosInput;
  idMail?: number;
  rawXML?: string;
};


export type MutationGetModelInitEcritureComptableArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetModelInitialisationForInventaireStockArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetModelInitialisationForOdInventaireArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetModelInitialisationForRechercheMediaAvanceArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetModelInitialisationOngletParametrageArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetModelMontantDossierPretsEtDonsArgs = {
  contexte?: ContextInfosInput;
  idDossier?: number;
  rawXML?: string;
};


export type MutationGetModelMoteurRegleArgs = {
  contexte?: ContextInfosInput;
  idRegle?: number;
  rawXML?: string;
};


export type MutationGetModelParametrageClotureArgs = {
  IdCloture?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetModelParametrageModeleLocationArgs = {
  IdModele?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetModelRemiseEnCaisseCentraleArgs = {
  contexte?: ContextInfosInput;
  idRemiseEnCaisseCentrale?: number;
  rawXML?: string;
};


export type MutationGetModelVerifiCationCondSupAnnBonRetourCommandeArgs = {
  contexte?: ContextInfosInput;
  modeleSupAnnRemBonRetourCde?: ModeleSupAnnRemBonRetourCommandeDtoInput;
  rawXML?: string;
};


export type MutationGetModelVerificationSuppressionDossierPrestaCadeauArgs = {
  IdDossierPresta?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetModeleActiviteParamAfpaArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetModeleActiviteParamAfpaFromIdCommandeArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetModeleChargementExecAttributionArgs = {
  ContextAttBDG?: string;
  contexte?: ContextInfosInput;
  idAtb?: number;
  rawXML?: string;
};


export type MutationGetModeleChoixDuplicationCommandeArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetModeleCourrierPublipostageArgs = {
  contexte?: ContextInfosInput;
  idCourrier?: number;
  rawXML?: string;
};


export type MutationGetModeleCreationRessourceArgs = {
  IdFamille?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetModeleEMailPublipostageArgs = {
  contexte?: ContextInfosInput;
  idTypePubli?: number;
  listeId?: number;
  modeleEmail?: ModelesModelEmailPieceJointeModelInput;
  rawXML?: string;
};


export type MutationGetModeleEcheancierInfosArgs = {
  contexte?: ContextInfosInput;
  idModeleEcheancier?: number;
  rawXML?: string;
};


export type MutationGetModeleEditEcheancierActiviteArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  idMoyenPaiement?: number;
  rawXML?: string;
};


export type MutationGetModeleEditionChampListeValeurArgs = {
  codeChamp?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetModeleEnveloppeArgs = {
  contexte?: ContextInfosInput;
  idEnv?: number;
  rawXML?: string;
};


export type MutationGetModeleEpargneArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  idArticle?: number;
  rawXML?: string;
};


export type MutationGetModeleFraisAnnulationArgs = {
  contexte?: ContextInfosInput;
  idModele?: number;
  rawXML?: string;
};


export type MutationGetModeleInitAttributionRanArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetModeleInitFpaArgs = {
  IdActivite?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetModeleInitRechercheHistoriqueReservationArgs = {
  IdActivite?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetModeleInitialisationWorkflowArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetModeleMailPublipostageArgs = {
  contexte?: ContextInfosInput;
  idMail?: number;
  rawXML?: string;
};


export type MutationGetModeleRegleAccessibiliteArgs = {
  codeTypeActivite?: string;
  contexte?: ContextInfosInput;
  idRegle?: number;
  rawXML?: string;
};


export type MutationGetModeleRegleEnveloppeArgs = {
  codeTypeActivite?: string;
  contexte?: ContextInfosInput;
  idRegle?: number;
  rawXML?: string;
};


export type MutationGetModeleRegleEnveloppeAttributionArgs = {
  contexte?: ContextInfosInput;
  idRegle?: number;
  rawXML?: string;
};


export type MutationGetModeleRegleQuotaArgs = {
  codeTypeActivite?: string;
  contexte?: ContextInfosInput;
  idRegle?: number;
  rawXML?: string;
};


export type MutationGetModeleRegleSubventionArgs = {
  contexte?: ContextInfosInput;
  idRegle?: number;
  rawXML?: string;
};


export type MutationGetModeleRequeteArgs = {
  contexte?: ContextInfosInput;
  idRequete?: number;
  rawXML?: string;
};


export type MutationGetModeleSaveReglesAfpadtoArgs = {
  contexte?: ContextInfosInput;
  idConteneur?: number;
  rawXML?: string;
  typeActivite?: string;
  typeConteneur?: TypeAfpaEnum;
};


export type MutationGetModeleTvaArgs = {
  contexte?: ContextInfosInput;
  idModele?: number;
  rawXML?: string;
};


export type MutationGetModificationParticipantsModelArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetMontantFactImpayeeBenefArgs = {
  IdBenef?: number;
  contexte?: ContextInfosInput;
  idDeleg?: number;
  rawXML?: string;
};


export type MutationGetMontantListeCommandesArgs = {
  contexte?: ContextInfosInput;
  listeIdsCommandes?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetMontantsDossierEpargneArgs = {
  contexte?: ContextInfosInput;
  idDossier?: number;
  rawXML?: string;
};


export type MutationGetMontantsDossierPrestationArgs = {
  contexte?: ContextInfosInput;
  idDossierPresta?: number;
  rawXML?: string;
};


export type MutationGetMouvementsPrelevementAbondementArgs = {
  contexte?: ContextInfosInput;
  idDossier?: number;
  rawXML?: string;
};


export type MutationGetMoyenneCompteurPointArgs = {
  contexte?: ContextInfosInput;
  dateFin?: any;
  idCptPt?: number;
  rawXML?: string;
};


export type MutationGetNbLivraisonsEnAttenteArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  idBeneficiaire?: number;
  rawXML?: string;
};


export type MutationGetNbParticipantsArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationGetNewLigneCommandeModelForVentesArgs = {
  VerifEtAjoutLigneDevisModel?: VerifEtAjoutLigneDevisModelDtoInput;
  contexte?: ContextInfosInput;
  dateReappro?: any;
  rawXML?: string;
};


export type MutationGetNewParamEditionDossierPrestationModelArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetNombreActusANotifierArgs = {
  contexte?: ContextInfosInput;
  idActu?: number;
  rawXML?: string;
};


export type MutationGetNombreAnnoncesGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresAnnonceDtoInput;
  rawXML?: string;
};


export type MutationGetNombreArticlesAttenteCommandeFournisseurArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresArticlesFournisseurModelInput;
  rawXML?: string;
};


export type MutationGetNombreComptesAssociesModeleTvaArgs = {
  contexte?: ContextInfosInput;
  idCompte?: number;
  rawXML?: string;
};


export type MutationGetNombreDevicesInscritsArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetNombreFacturesGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresFactureDtoInput;
  rawXML?: string;
};


export type MutationGetNombreMediaEnregistreArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetNombreReservationBenefFileAttenteArgs = {
  contexte?: ContextInfosInput;
  idLigneReservation?: number;
  idMedia?: number;
  rawXML?: string;
};


export type MutationGetNumeroFactureArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetOldDateEcritureArgs = {
  contexte?: ContextInfosInput;
  idExport?: boolean;
  rawXML?: string;
};


export type MutationGetOrganisationArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresOrganisationDtoInput;
  idOrganisation?: number;
  rawXML?: string;
};


export type MutationGetParamAssoCeByCodeArgs = {
  codeParam?: string;
  contexte?: ContextInfosInput;
  nomCe?: string;
  rawXML?: string;
};


export type MutationGetParamEcheancierModelArgs = {
  contexte?: ContextInfosInput;
  idEcheancier?: number;
  rawXML?: string;
};


export type MutationGetParamEditionDossierPrestationModelArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  idDossier?: number;
  rawXML?: string;
};


export type MutationGetParamFamilleModelArgs = {
  contexte?: ContextInfosInput;
  idFamille?: number;
  rawXML?: string;
};


export type MutationGetParamSyncArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetParametrageActiviteArgs = {
  ModelCritere?: CriteresParametrageActiviteModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetParametrageComptableActiviteEpargnesArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetParametrageComptableArticleEpargnesArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  rawXML?: string;
};


export type MutationGetParametrageCompteBancaireArgs = {
  contexte?: ContextInfosInput;
  criteres?: CritereParametrageCompteBancaireDtoInput;
  rawXML?: string;
};


export type MutationGetParametrageFormulaireFpaArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresFormulairesFpaModelInput;
  rawXML?: string;
};


export type MutationGetParametragePermanencesActiviteArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetParametreAjustementMontantPrisCompteArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetParametresPortletSondageArgs = {
  contexte?: ContextInfosInput;
  idSondage?: number;
  rawXML?: string;
};


export type MutationGetPermanenceArgs = {
  contexte?: ContextInfosInput;
  idPermanence?: number;
  rawXML?: string;
};


export type MutationGetPlanAnalytiqueWithSousSectionArgs = {
  contexte?: ContextInfosInput;
  idPlanAnalytique?: number;
  rawXML?: string;
};


export type MutationGetPostClotureStatutModelArgs = {
  contexte?: ContextInfosInput;
  idStatutPerso?: number;
  rawXML?: string;
};


export type MutationGetPosteBudgetaireModeleArgs = {
  contexte?: ContextInfosInput;
  idPodteBDG?: number;
  rawXML?: string;
};


export type MutationGetPrenomNomBenefArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGetPresentationBenefArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGetProchainNumeroPieceArgs = {
  contexte?: ContextInfosInput;
  critere?: CritereRechercheNumeroPieceDtoInput;
  rawXML?: string;
};


export type MutationGetProduitArgs = {
  contexte?: ContextInfosInput;
  idProduit?: number;
  rawXML?: string;
};


export type MutationGetProduitWithArticleInfosArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresProduitDtoInput;
  rawXML?: string;
};


export type MutationGetProgressionImportEnCoursArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetProgressionStepArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  token?: string;
};


export type MutationGetQuantiteEnStockReelArgs = {
  IdArticle?: number;
  IdStock?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetRecapitulatifImportCatalogueFinishedArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetRechercheSoldeConsommationsArgs = {
  contexte?: ContextInfosInput;
  criteresActivite?: CriteresActiviteDtoInput;
  criteresEnveloppe?: CriteresEnveloppeQuotaDtoInput;
  criteresFamilleProduit?: CriteresFamilleProduitDtoInput;
  rawXML?: string;
};


export type MutationGetRecommendationArticleMagazineArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresRecommandationArticleMagazineModelInput;
  rawXML?: string;
};


export type MutationGetRefCalcAgeArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetReglesModificationMouvementsArgs = {
  IsFromPopupEcriture?: boolean;
  contexte?: ContextInfosInput;
  idMouvement?: number;
  rawXML?: string;
};


export type MutationGetRequeteSQlPublipostageArgs = {
  contexte?: ContextInfosInput;
  idVue?: number;
  listeCriteres?: ArrayOfChampsCriterePubliChampsModelInput;
  rawXML?: string;
};


export type MutationGetRessourceFullArgs = {
  IdProduit?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetResultatsPublipostageArgs = {
  contexte?: ContextInfosInput;
  idVue?: number;
  listeCriteres?: ArrayOfChampsCriterePubliChampsModelInput;
  rawXML?: string;
};


export type MutationGetRoomingListArgs = {
  contexte?: ContextInfosInput;
  idRegroupement?: number;
  rawXML?: string;
};


export type MutationGetSectionAnalytiqueByPlanAndActiviteFphaArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  listIdPlanAnalytique?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetSectionAnalytiqueByPlanAndActiviteFpvenArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  listIdPlanAnalytique?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetSectionAnalytiqueByPlanAndActiviteTpArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  listIdPlanAnalytique?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetSectionAnalytiqueByPlanAndArticleArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  listIdPlanAnalytique?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetSectionAnalytiqueByPlanAndCompteBancaireArgs = {
  contexte?: ContextInfosInput;
  idCompteBancaire?: number;
  listIdPlanAnalytique?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetSectionAnalytiqueByPlanAndDelegationArgs = {
  contexte?: ContextInfosInput;
  idDelegation?: number;
  listIdPlanAnalytique?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetSectionAnalytiqueByPlanAndFamilleProduitArgs = {
  contexte?: ContextInfosInput;
  idFamilleProduit?: number;
  listIdPlanAnalytique?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetSectionAnalytiqueByPlanAndProduitArgs = {
  contexte?: ContextInfosInput;
  idProduit?: number;
  listIdPlanAnalytique?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationGetSimpleListeActualitesArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresActualitesMobileInput;
  rawXML?: string;
};


export type MutationGetSimulationChequierForBenefArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGetSiteArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresSiteDtoInput;
  idSite?: number;
  rawXML?: string;
};


export type MutationGetSoldePmvArgs = {
  contexte?: ContextInfosInput;
  crit?: CriteresSoldePmvModelInput;
  rawXML?: string;
};


export type MutationGetSoldePmvBenefArgs = {
  DateValeur?: any;
  IdAbondement?: number;
  IdBenef?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetSoldePmvBenefComptaArgs = {
  contexte?: ContextInfosInput;
  crit?: CriteresSoldePmvModelInput;
  rawXML?: string;
};


export type MutationGetSommeCptPtArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresFicheSignaletiqueDtoInput;
  rawXML?: string;
};


export type MutationGetSommeTarifsSurLigneCommandeArgs = {
  contexte?: ContextInfosInput;
  idLigneDeCommande?: number;
  rawXML?: string;
};


export type MutationGetSourcesCombosPopupAjoutModifLigneAvoirArgs = {
  IsClient?: boolean;
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationGetSourcesCombosUcRechercheRemiseEnBanqueArgs = {
  PointVenteId?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetStatsBeneficiairesDataArgs = {
  IdWidget?: number;
  IdWidgetAccueil?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetStatutFactureArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresFactureModelInput;
  rawXML?: string;
};


export type MutationGetStatutLivraisonCommandeDossierPrestationArgs = {
  contexte?: ContextInfosInput;
  idDossierPresta?: number;
  rawXML?: string;
};


export type MutationGetStatutPersoModelArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  idStatut?: number;
  isStatutPerso?: boolean;
  rawXML?: string;
};


export type MutationGetStatutsCommandeArgs = {
  IdCommande?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetStockWithCessionEnAttenteArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  idStock?: number;
  rawXML?: string;
};


export type MutationGetSubventionArticleArgs = {
  contexte?: ContextInfosInput;
  dossier?: DossierEpargneModelInput;
  rawXML?: string;
};


export type MutationGetSubventionArticleCadeauxArgs = {
  contexte?: ContextInfosInput;
  criteres?: CadeauxInfosCriteresArticleCadeauxModelInput;
  rawXML?: string;
};


export type MutationGetSuiviTresorerieModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresSuiviTresorerieDtoInput;
  rawXML?: string;
};


export type MutationGetSyncCritereAdListArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetTarifLibelleDefautParArticleArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  rawXML?: string;
};


export type MutationGetTarifsFacturesArgs = {
  contexte?: ContextInfosInput;
  idLigneCommande?: number;
  rawXML?: string;
};


export type MutationGetTempsReservationArgs = {
  IdCommande?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetThemeCourantArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetTotalSommeCreditDebitMouvementsComptablesModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementComptableDtoInput;
  rawXML?: string;
};


export type MutationGetTypeCalculVariationStockForClotureArgs = {
  IdCloture?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetTypeConsoMouvementArgs = {
  codeType?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetTypeCritereSyncAdListArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetTypeDossierPrestaArgs = {
  contexte?: ContextInfosInput;
  idDossier?: number;
  rawXML?: string;
};


export type MutationGetTypeEcritureByCodeArgs = {
  code?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetUriForVisualisationActiviteArgs = {
  contexte?: ContextInfosInput;
  idAct?: number;
  idBenef?: number;
  idce?: number;
  rawXML?: string;
};


export type MutationGetUriForVisualisationProfilBenefArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  idce?: number;
  rawXML?: string;
};


export type MutationGetUrlSarmArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetUrlZipDoneesBenefRgpdArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationGetUserNotificationsVupArgs = {
  contexte?: ContextInfosInput;
  idUser?: number;
  rawXML?: string;
};


export type MutationGetValeurParamHistorisationFromCodeChampArgs = {
  codeChamp?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetValeursPossiblesListeValeursArgs = {
  IdTypePublipostage?: number;
  contexte?: ContextInfosInput;
  inclureClos?: boolean;
  listeCriteres?: ArrayOfChampsCritereListeValeursPubliChampsModelInput;
  rawXML?: string;
};


export type MutationGetValueParametreAssolutionArgs = {
  constanteParametre?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetValueParametrePoidsMaxImageArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetValueParametrePoidsMaxImageActuMobileArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetValueParametrePublipostageLimiteAvertissementArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetValueParametrePublipostageLimiteBlocageArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetVerifGeneUniqueForExportAncvArgs = {
  IdCommande?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetVueExportModeExpertArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBenefDtoInput;
  filtre?: FiltrageBenefModeExpertModelDtoInput;
  idVue?: number;
  rawXML?: string;
};


export type MutationGetVueExportModeExpertV2Args = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBenefDtoInput;
  filtre?: FiltrageBenefModeExpertModelDtoInput;
  idVue?: number;
  rawXML?: string;
};


export type MutationGetVueModeExpertModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBenefDtoInput;
  filtre?: FiltrageBenefModeExpertModelDtoInput;
  idVue?: number;
  rawXML?: string;
};


export type MutationGetVueModeExpertModelV2Args = {
  contexte?: ContextInfosInput;
  criteres?: CriteresBenefDtoInput;
  filtre?: FiltrageBenefModeExpertModelDtoInput;
  idVue?: number;
  rawXML?: string;
};


export type MutationGetlisteChampValeurArgs = {
  codeCritere?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetlisteChampValeurNotChpPersoArgs = {
  codeCritere?: ArrayOfstringInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetparamuserlisteuserArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationHasActiviteFraisAnnulationArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationHasCommandeModaliteReglementArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationHasMultipleSitesActiveArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationHaveReportsLettreChequeArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  typeDestinataire?: string;
};


export type MutationHistoriqueFilesArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationIsCompte512RattacheACompteBancaireArgs = {
  IdCompte512?: number;
  IdCompteBancaire?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationImportExecuterArgs = {
  IdImportHisto?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationImportFamilleArgs = {
  IdAct?: number;
  ListFamille?: ArrayOfFamilleImportModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationImporterCatalogueArgs = {
  contexte?: ContextInfosInput;
  modeleImportCatalogue?: ImportCatalogueModelInput;
  rawXML?: string;
};


export type MutationImporterMediasArgs = {
  contexte?: ContextInfosInput;
  listeMedias?: ArrayOfMediaImportModelInput;
  options?: OptionsImportMediaInput;
  rawXML?: string;
};


export type MutationImporterRestaurationLaCroixArgs = {
  contexte?: ContextInfosInput;
  modeleImport?: ImportRestaurationModelInput;
  rawXML?: string;
};


export type MutationImputerAvoirAFactureArgs = {
  contexte?: ContextInfosInput;
  idAvoir?: number;
  idFacture?: number;
  rawXML?: string;
};


export type MutationImputerEpargneSurCommandeArgs = {
  contexte?: ContextInfosInput;
  idCollectifPMV?: number;
  idCompteCollectif?: number;
  idDossier?: number;
  idJournalOD?: number;
  rawXML?: string;
};


export type MutationImputerListeAcompteCommandeSurFactureArgs = {
  contexte?: ContextInfosInput;
  idFact?: number;
  rawXML?: string;
};


export type MutationInitActionsGroupeesDossierPrestationArgs = {
  contexte?: ContextInfosInput;
  model?: ActionsGroupeesDossierPrestationModelDtoInput;
  rawXML?: string;
};


export type MutationInitEnteteDossierEpargneArgs = {
  InitSelectedEnteteDossierEpargne?: InitSelectedEnteteDossierEpargneModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationInitEnteteDossierPretsEtDonsArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationInitHistoriqueDossierEpargneArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationInitInfosFournisseurSelectionneArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresArticleDtoInput;
  rawXML?: string;
};


export type MutationInitMouvementsAnalytiquesForCloturerSectionArgs = {
  contexte?: ContextInfosInput;
  idSectionAnalytique?: number;
  rawXML?: string;
};


export type MutationInitOngletReportDesTiersArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationInitOngletVariationStockArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationInitialisationBalanceOuvertureArgs = {
  IdCloture?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationInitialisationByIdCommandeForVentesClientsArgs = {
  contexte?: ContextInfosInput;
  initModel?: InitModeleForVenteInput;
  rawXML?: string;
};


export type MutationInitialisationByListIdArticleAndIdBenefArgs = {
  contexte?: ContextInfosInput;
  initModel?: InitModeleForVenteInput;
  rawXML?: string;
};


export type MutationInitialisationComptabiliteEpargnesArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationInitialisationForCommandeLibreArgs = {
  contexte?: ContextInfosInput;
  initModel?: InitModeleForCommandeLibreDtoInput;
  rawXML?: string;
};


export type MutationInitialisationForInscriptionGrpArgs = {
  contexte?: ContextInfosInput;
  initModel?: InitModeleForVenteInput;
  rawXML?: string;
};


export type MutationInitialisationForVentesClientsArgs = {
  contexte?: ContextInfosInput;
  initModel?: InitModeleForVenteInput;
  rawXML?: string;
};


export type MutationInitialisationModeleImpressionArgs = {
  CodeReport?: string;
  Criteres?: CriteresCourrierDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationInitialiserHistoriqueSalarieArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationInitialiserImportRestaurationLaCroixArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationInitialiserImpressionEtiquetteLaCroixArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationInitialiserListingArreteCaisseArgs = {
  IsContexteRemiseEnCaisse?: boolean;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationInitialiserOngletArticleAssocieArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationInitialiserParametrageModelePublipostageArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationInitialiserPopupTropPercuArgs = {
  contexte?: ContextInfosInput;
  listeIdsActivite?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationInverserOrdreStatutsPersosArgs = {
  contexte?: ContextInfosInput;
  idDeuxiemeStatut?: number;
  idPremierStatut?: number;
  rawXML?: string;
};


export type MutationIs511CompteBancaireHaveMouvementsArgs = {
  IdCompteBancaire?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsActiviteHasCompteAcompteArgs = {
  contexte?: ContextInfosInput;
  idElementParent?: number;
  rawXML?: string;
  typeElement?: TypeAfpaEnum;
};


export type MutationIsAllowedCreationStatutPersoArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationIsAnneeReferenceValideCeForBenefArgs = {
  contexte?: ContextInfosInput;
  idAnneeRef?: number;
  idBenef?: number;
  rawXML?: string;
};


export type MutationIsArticleLieToSynchEnveloppeArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  rawXML?: string;
};


export type MutationIsBenefHasIbanArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationIsBenefHaveCommandeSurProduitArgs = {
  IdBenef?: number;
  IdCommande?: number;
  IdProduit?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsCeHaveModuleArgs = {
  CodeModule?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsCloturableCompteBancaireArgs = {
  IdCompteBancaire?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsConformeTvaArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresRechercheConformiteTvaModelInput;
  rawXML?: string;
};


export type MutationIsDateEcheanceValideArgs = {
  IdEcheancier?: number;
  contexte?: ContextInfosInput;
  dateEcheance?: any;
  rawXML?: string;
};


export type MutationIsDateSubventionCoherenteArgs = {
  DateSubvention?: any;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsDelegProprietaireActiviteGlobaleArgs = {
  IdActivite?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsExerciceClotureByIdEcritureArgs = {
  contexte?: ContextInfosInput;
  idEcriture?: number;
  rawXML?: string;
};


export type MutationIsExerciceExistsArgs = {
  contexte?: ContextInfosInput;
  dateExercice?: any;
  rawXML?: string;
};


export type MutationIsExistNumeroReleveArgs = {
  NumeroReleve?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsExistSiteWithAdressAncvArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsExisteModeleEcheancierArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsExisteRegleBudgetArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsExisteRegleLocaleArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresMoteurRegleDtoInput;
  rawXML?: string;
};


export type MutationIsExisteRegleTransverseArgs = {
  codeTypeRgl?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
  typeValeurLim?: string;
};


export type MutationIsFacturationCentraliseeSurActiviteArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationIsFacturationCentraliseeSurCommandeArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationIsFilesAlbumUsedArgs = {
  contexte?: ContextInfosInput;
  idAlbum?: number;
  rawXML?: string;
};


export type MutationIsFormulairePresentSurCommandeArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationIsFournisseurFavorisSurArticleArgs = {
  contexte?: ContextInfosInput;
  idFournisseur?: number;
  rawXML?: string;
};


export type MutationIsLettreChequeImprimablePourFactureArgs = {
  contexte?: ContextInfosInput;
  idFacture?: number;
  rawXML?: string;
};


export type MutationIsModeleEcheancierLinkedToFpaArgs = {
  contexte?: ContextInfosInput;
  idModeleEcheancier?: number;
  rawXML?: string;
};


export type MutationIsMotDePasseDifferentArgs = {
  contexte?: ContextInfosInput;
  password?: string;
  rawXML?: string;
};


export type MutationIsNumeroBordereauAlreadyExistsArgs = {
  NumeroBordereau?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsParametrageComptableCorrectArgs = {
  IdCloture?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsPeriodeLocationCoherenteArgs = {
  contexte?: ContextInfosInput;
  listeIdProduit?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationIsPremiereConnexionVupArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsProduitReapprovisionnementArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  rawXML?: string;
};


export type MutationIsReglementAutoriseSurFactureArgs = {
  contexte?: ContextInfosInput;
  idFacture?: number;
  rawXML?: string;
};


export type MutationIsSuperAdministrateurArgs = {
  rawXML?: string;
  userLogin?: string;
  userPassword?: string;
};


export type MutationIsSupprimableCloturablePlanAnalytiqueArgs = {
  IdPlan?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsSupprimableCloturableSectionAnalytiqueArgs = {
  IdSection?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsSupprimableEcritureArgs = {
  IdEcriture?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsSupprimableEcritureWithErrorMessageArgs = {
  IdDossier?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsSupprimableFactureArgs = {
  IdFac?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationIsSupprimableStockArgs = {
  contexte?: ContextInfosInput;
  idStock?: number;
  rawXML?: string;
};


export type MutationIsTvaSurActiveeFromEcritureArgs = {
  contexte?: ContextInfosInput;
  idEcriture?: number;
  rawXML?: string;
};


export type MutationIsTypeChequeModifiableArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  rawXML?: string;
};


export type MutationIsUsedLettreSurExerciceArgs = {
  contexte?: ContextInfosInput;
  idDelegCibleConnecte?: number;
  idExercice?: number;
  lettre?: string;
  onBudgetSocial?: boolean;
  rawXML?: string;
};


export type MutationIsUserAdminInDelegationArgs = {
  contexte?: ContextInfosInput;
  idCe?: number;
  idUser?: number;
  rawXML?: string;
};


export type MutationIsWcfWorkArgs = {
  rawXML?: string;
};


export type MutationLancerProcedureSupressionConnexionEtRestaurationBaseArgs = {
  InitialCatalogBaseRef?: string;
  NomBase?: string;
  PathBaseRef?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationLancerSynchroArgs = {
  ListeIdBenef?: string;
  Type?: TypeSynchroEnum;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationLancerSynchroSynapseArgs = {
  contexte?: ContextInfosInput;
  listeBenef?: ArrayOfSynchroBenefInput;
  listeSitesLivraison?: ArrayOfSynchroSiteLivraisonInput;
  rawXML?: string;
};


export type MutationLancerSynchroSynapseBenefsWithAdArgs = {
  contexte?: ContextInfosInput;
  organisationUuid?: string;
  rawXML?: string;
};


export type MutationLettrageAutoArgs = {
  contexte?: ContextInfosInput;
  crit?: CriteresLettrageAutomatiqueModelInput;
  rawXML?: string;
};


export type MutationLikeArticleMagazineArgs = {
  contexte?: ContextInfosInput;
  idArticle?: string;
  rawXML?: string;
};


export type MutationLivraisonCadeauDossierPrestationArgs = {
  contexte?: ContextInfosInput;
  infos?: LivraisonCommandeDossierPrestaModelInput;
  rawXML?: string;
};


export type MutationLivraisonExemplaireArgs = {
  ModeleLivraison?: DateReservationModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationLivrerLignesCommandesArgs = {
  DateLivraison?: any;
  contexte?: ContextInfosInput;
  listeLignesCommandes?: ArrayOfLivraisonsInfosLigneCdeForLivraisonReceptionModeleInput;
  rawXML?: string;
};


export type MutationLoggerMenuArgs = {
  contexte?: ContextInfosInput;
  idMenu?: number;
  rawXML?: string;
};


export type MutationLoggerPerformancesArgs = {
  contexte?: ContextInfosInput;
  logPerfModel?: LogPerfModelInput;
  rawXML?: string;
};


export type MutationLoginMotDePasseByEmailArgs = {
  Email?: MailModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationMarquerListeChequeCommeRecuArgs = {
  ListeIdMouvements?: ArrayOfdecimalInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationMarquerPretAExporterArgs = {
  contexte?: ContextInfosInput;
  listeIdEcriture?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationMarquerTouteslesEcrituresPretAExporterArgs = {
  asExporter?: boolean;
  contexte?: ContextInfosInput;
  criteres?: CriteresCompteEcritureModelInput;
  rawXML?: string;
};


export type MutationModificationDateEmpruntExemplaireArgs = {
  contexte?: ContextInfosInput;
  dateEmprunt?: any;
  dateEmpruntRetour?: any;
  idLigne?: number;
  needConfirmation?: boolean;
  rawXML?: string;
};


export type MutationModificationMandatDateOperationArgs = {
  contexte?: ContextInfosInput;
  idRemiseEnBanque?: number;
  rawXML?: string;
};


export type MutationModifierEnteteDossierPrestaArgs = {
  contexte?: ContextInfosInput;
  enteteDossierPrestation?: DossierPrestationEnteteDossierPrestationModelDtoInput;
  rawXML?: string;
};


export type MutationModifierLibelleGroupeArgs = {
  contexte?: ContextInfosInput;
  idGroupe?: number;
  libelleGroupe?: string;
  rawXML?: string;
};


export type MutationModifierNewsletterThemeArgs = {
  contexte?: ContextInfosInput;
  newsletter?: AjouterModifierNewsletterThemeModelInput;
  rawXML?: string;
};


export type MutationModifierParamAppMobileArgs = {
  contexte?: ContextInfosInput;
  idIdentification?: number;
  isCodeBar?: boolean;
  rawXML?: string;
};


export type MutationModifierStatutLigneDossierPrestationArgs = {
  contexte?: ContextInfosInput;
  modele?: DossierPrestationChangerStatutLigneCommandePrestaModelInput;
  rawXML?: string;
};


export type MutationModifierStatutLigneDossierPrestationRetourPopupArgs = {
  contexte?: ContextInfosInput;
  modele?: DossierPrestationChangerStatutLigneCommandePrestaRetourPopupModelInput;
  rawXML?: string;
};


export type MutationModifierStatutLigneDossierPretsEtDonsArgs = {
  contexte?: ContextInfosInput;
  model?: EditerLigneCommandeChangementStatutPretsEtDonsModelInput;
  rawXML?: string;
};


export type MutationModifierStatutListeLigneDossierPrestationArgs = {
  ListeIdLigne?: ArrayOfdecimalInput;
  contexte?: ContextInfosInput;
  nouveauStatut?: string;
  rawXML?: string;
};


export type MutationNeedFiltrerArticleLocationNonDispoArgs = {
  contexte?: ContextInfosInput;
  idActivite?: number;
  rawXML?: string;
};


export type MutationNotifierActualiteArgs = {
  contexte?: ContextInfosInput;
  idActu?: number;
  rawXML?: string;
};


export type MutationNotifierNouvellesActusArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationParserCsvComptesArgs = {
  contexte?: ContextInfosInput;
  csv?: string;
  rawXML?: string;
};


export type MutationPaysHasVilleRegionArgs = {
  contexte?: ContextInfosInput;
  idPays?: number;
  rawXML?: string;
};


export type MutationPlanifieExecutionImportArticleArgs = {
  contexte?: ContextInfosInput;
  params?: ParametresExecutionImportArticleInput;
  rawXML?: string;
};


export type MutationPreparationResumeCommandeAvantReglementArgs = {
  ListIdCommande?: ArrayOfdecimalInput;
  MultiBenef?: boolean;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationPreparerReportPublipostageArgs = {
  contexte?: ContextInfosInput;
  listeIds?: ArrayOfdecimalInput;
  modeleCourrier?: ModelesModeleCourrierPublipostageModelInput;
  rawXML?: string;
};


export type MutationRafraichirArreteCaisseArgs = {
  contexte?: ContextInfosInput;
  idArreteCaisse?: number;
  rawXML?: string;
};


export type MutationRafraichissementRemiseEnCaisseCentraleArgs = {
  IdRemiseEnCaisse?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationRecalculCriteresSociauxArgs = {
  champ?: ChampDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationRecalculerValorisationStockArgs = {
  IdCloture?: number;
  TypeCalcul?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationReceptionnerListeLigneCessionStockArgs = {
  contexte?: ContextInfosInput;
  listeLigneCession?: ArrayOfSaveLigneCessionStockModelInput;
  rawXML?: string;
};


export type MutationRechercheMediaArgs = {
  Critere?: CritereRechercheMediaInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationRechercheSommeMouvementComptableFiduArgs = {
  contexte?: ContextInfosInput;
  critereRechercheMvt?: CriteresMouvementComptableDtoInput;
  rawXML?: string;
};


export type MutationRechercheTreeViewArgs = {
  contexte?: ContextInfosInput;
  critere?: CritereRechTreeViewFpadtoInput;
  rawXML?: string;
};


export type MutationRechercherCadeauxAvecSubventionArticleArgs = {
  contexte?: ContextInfosInput;
  criteres?: CadeauxInfosCriteresArticleCadeauxModelInput;
  rawXML?: string;
};


export type MutationRechercherChoixParamReqSpecifArgs = {
  contexte?: ContextInfosInput;
  idParam?: number;
  motCle?: string;
  rawXML?: string;
  top?: number;
};


export type MutationRefreshContextArgs = {
  IdUser?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationRefreshPjBenefArgs = {
  contexte?: ContextInfosInput;
  ficheBenef?: BenefFicheProfilModelInput;
  rawXML?: string;
};


export type MutationRefreshParametresAppliArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationRegenLoginAndPassWordArgs = {
  contexte?: ContextInfosInput;
  identifiant?: IdentifiantBenefModelInput;
  listIdBenef?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationRegionHasDepartementArgs = {
  contexte?: ContextInfosInput;
  idRegion?: number;
  rawXML?: string;
};


export type MutationReglerCommandeArgs = {
  contexte?: ContextInfosInput;
  modeleReglement?: ReglementCommandeBaseModelInput;
  rawXML?: string;
};


export type MutationReinitMdpOuInvSynapseArgs = {
  contexte?: ContextInfosInput;
  idBeneficiaire?: number;
  rawXML?: string;
};


export type MutationReinitialiserAnalyseIaPiecesJustificativesArgs = {
  contexte?: ContextInfosInput;
  listeIdPjBenef?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationReinitialiserMotPasseArgs = {
  NewPassword?: string;
  contexte?: ContextInfosInput;
  idBenef?: number;
  rawXML?: string;
};


export type MutationRemboursementAnticipePretsEtDonsArgs = {
  contexte?: ContextInfosInput;
  infosRemboursementAnticipe?: RemboursementAnticipePretsEtDonsModelInput;
  rawXML?: string;
};


export type MutationRemonterBaseDeProdSurBaseTestArgs = {
  CurrentContext?: ContextInfosInput;
  rawXML?: string;
};


export type MutationRemovePieceJustificativeArgs = {
  contexte?: ContextInfosInput;
  idPj?: number;
  rawXML?: string;
};


export type MutationRenvoyerInvitationSynapseArgs = {
  contexte?: ContextInfosInput;
  listeIdBenef?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationReservationModificationDateExemplaireArgs = {
  ModeleLivraison?: DateReservationModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationResetCacheClientArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationResetSessionChoixSurCommandeArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresDevisCommandeModelInput;
  rawXML?: string;
};


export type MutationRetourExemplaireArgs = {
  contexte?: ContextInfosInput;
  idLigneCommande?: number;
  rawXML?: string;
};


export type MutationRibMandatHaveMouvementArgs = {
  IdRibMandat?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaisieEmpruntArgs = {
  Critere?: CritereEmpruntDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSauvegardeExemplaireArgs = {
  contexte?: ContextInfosInput;
  exemplaire?: MediathequeExemplaireCatalogueMediaModelInput;
  rawXML?: string;
};


export type MutationSauvegarderFooterNewsletterArgs = {
  contexte?: ContextInfosInput;
  footer?: string;
  rawXML?: string;
};


export type MutationSauvegarderPubliVueArgs = {
  contexte?: ContextInfosInput;
  listeChampUtiliseVue?: ArrayOfPubliChampsVueModelInput;
  publiVue?: PubliVueBaseInfoModelInput;
  rawXML?: string;
};


export type MutationSaveAdministrationMenusArgs = {
  ListeIdCommissions?: ArrayOfdecimalInput;
  ListeIdExpanded?: ArrayOfintInput;
  RedescendreDelegSurEnfants?: boolean;
  applyToChildMenu?: boolean;
  contexte?: ContextInfosInput;
  menu?: PortailArticleDtoInput;
  rawXML?: string;
};


export type MutationSaveAdministrationSkinArgs = {
  contexte?: ContextInfosInput;
  currentSkinId?: number;
  options?: PortailOptionsDtoInput;
  rawXML?: string;
};


export type MutationSaveAlbumGedArgs = {
  SupprimerFichierLies?: boolean;
  album?: PortailAlbumDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveAlerteEmailArgs = {
  ListeGestionnaire?: ArrayOfGestionnaireDtoInput;
  ListeOnglet?: ArrayOfAlertesDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveApplicationParameterArgs = {
  CodeChamp?: string;
  ValeurChamp?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveArticleUpKonnectArgs = {
  contexte?: ContextInfosInput;
  idArticlePortail?: number;
  model?: EditerArticleUpKonnectModelInput;
  rawXML?: string;
};


export type MutationSaveAttributionAutomatiqueArgs = {
  attribution?: EditerAttributionAutoModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveAttributionBudgetArgs = {
  AttribBdgModele?: AttributionBudgetModelDtoInput;
  contexte?: ContextInfosInput;
  critere?: CriteresAttributionBudgetDtoInput;
  rawXML?: string;
};


export type MutationSaveAttributionRanModeleArgs = {
  attRanModele?: AttributionRanModelDtoInput;
  contexte?: ContextInfosInput;
  critere?: CriteresAttributionRanDtoInput;
  rawXML?: string;
};


export type MutationSaveBaremeArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresEnteteBaremeDtoInput;
  entBareme?: EnteteBaremeDtoInput;
  rawXML?: string;
};


export type MutationSaveBaremeRegleArgs = {
  bornes?: BorneStatWithBornesModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveBenefNewWithPieceJustificativeArgs = {
  SaveBenefModel?: SaveBenefModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveBeneficiaireNewArgs = {
  benef?: BenefDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveBudgetArgs = {
  budgetModele?: BudgetModelDtoInput;
  contexte?: ContextInfosInput;
  critere?: CriteresBudgetDtoInput;
  rawXML?: string;
};


export type MutationSaveCeDelegationModelArgs = {
  contexte?: ContextInfosInput;
  model?: SaveCeDelegationModelDtoInput;
  rawXML?: string;
};


export type MutationSaveCatalogueMediathequeArgs = {
  catalogue?: ParamMediathequeCatalogueModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveCessionStockArgs = {
  contexte?: ContextInfosInput;
  modeleCessionStock?: SaveCessionStockModelInput;
  rawXML?: string;
};


export type MutationSaveCommandeModalitesReglementArgs = {
  contexte?: ContextInfosInput;
  modeleCommandeModalite?: CommandeModaliteReglementSaveInput;
  rawXML?: string;
};


export type MutationSaveCommentaireArgs = {
  RmqPrivee?: string;
  RmqPublic?: string;
  contexte?: ContextInfosInput;
  idDossierPrestation?: number;
  rawXML?: string;
};


export type MutationSaveCommentaireEcritureArgs = {
  contexte?: ContextInfosInput;
  idEcriture?: number;
  rawXML?: string;
  remarque?: string;
};


export type MutationSaveCommentaireFactureArgs = {
  RmqPrivee?: string;
  RmqPublic?: string;
  contexte?: ContextInfosInput;
  idFacture?: number;
  rawXML?: string;
};


export type MutationSaveCommentaireLigneDossierArgs = {
  contexte?: ContextInfosInput;
  idLigneDossierPrestation?: number;
  rawXML?: string;
  remarquePrivee?: string;
  remarquePublique?: string;
};


export type MutationSaveCommissionAndUsersCommissionArgs = {
  commission?: ParamCommissionModelInput;
  contexte?: ContextInfosInput;
  listeUsersCommission?: ArrayOfUserCommissionModelInput;
  rawXML?: string;
};


export type MutationSaveCompteBancaireModelArgs = {
  contexte?: ContextInfosInput;
  model?: SaveCompteBancaireModelDtoInput;
  rawXML?: string;
};


export type MutationSaveCourrierNewsletterArgs = {
  contexte?: ContextInfosInput;
  infos?: CourrierInfosSaveNewsletterCourrierInput;
  rawXML?: string;
};


export type MutationSaveCritereSyncAdListArgs = {
  contexte?: ContextInfosInput;
  listCritereSyncAdModelDTO?: ArrayOfCritereSyncAdModelDtoInput;
  rawXML?: string;
};


export type MutationSaveDevisCdeFourArgs = {
  CdeFourFinalModel?: AchatFournisseurFinalModelDtoInput;
  contexte?: ContextInfosInput;
  critere?: CritereAchatFourFinalModelDtoInput;
  rawXML?: string;
};


export type MutationSaveDevisCommandeArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDevisCommandeDtoInput;
  deviscommande?: DevisCommandeDtoInput;
  rawXML?: string;
};


export type MutationSaveDevisCommandeGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresDevisCommandeDtoInput;
  deviscommande?: DevisCommandeDtoInput;
  rawXML?: string;
};


export type MutationSaveDocumentGedArgs = {
  contexte?: ContextInfosInput;
  doc?: FichierCompletModelInput;
  rawXML?: string;
};


export type MutationSaveDossierPrestationArgs = {
  contexte?: ContextInfosInput;
  modele?: ParamEditionDossierPrestationModelDtoInput;
  rawXML?: string;
};


export type MutationSaveEcritureManuelleModelArgs = {
  contexte?: ContextInfosInput;
  modeleSaveEcritureManuelle?: SaisieEcrituresModelSaveEcritureManuelleInput;
  rawXML?: string;
};


export type MutationSaveEcritureParModelArgs = {
  ListeModeleSaveEcritureManuelle?: ArrayOfSaisieEcrituresModelSaveEcritureManuelleInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveEcritureTiersModelArgs = {
  contexte?: ContextInfosInput;
  modeleSaveEcritureTiers?: SaisieEcrituresModelSaveEcritureTiersInput;
  rawXML?: string;
};


export type MutationSaveEcritureWithMouvementsArgs = {
  contexte?: ContextInfosInput;
  ecriture?: EcritureConsultationModelInput;
  rawXML?: string;
};


export type MutationSaveEngagementBudgetModelArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresEngagementBudgetDtoInput;
  engagementBudgetModel?: EngagementBudgetModelDtoInput;
  rawXML?: string;
};


export type MutationSaveEtGenereArticleLocationArgs = {
  ModelGenArt?: SaveEtGenerationArtLocModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveFactureAvoirArgs = {
  contexte?: ContextInfosInput;
  factureModel?: FactureAvoirModelDtoInput;
  rawXML?: string;
};


export type MutationSaveFactureWithAcompteAvoirArgs = {
  contexte?: ContextInfosInput;
  facture?: FactureDtoInput;
  rawXML?: string;
};


export type MutationSaveFactureWithEcritureArgs = {
  Facture?: FactureDtoInput;
  IsInContexteAvoirTotalSurFacture?: boolean;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveFamilleArgs = {
  contexte?: ContextInfosInput;
  famille?: ParamRessourcePartageeFpaModelInput;
  rawXML?: string;
};


export type MutationSaveFamilleMediathequeArgs = {
  contexte?: ContextInfosInput;
  famille?: ParamMediathequeFamilleModelInput;
  rawXML?: string;
};


export type MutationSaveFicheProfilBeneficiaireArgs = {
  beneficiaire?: BenefFicheProfilModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveFicheTrombinoscopeArgs = {
  contexte?: ContextInfosInput;
  infos?: TrombinoscopeTrombinoscopeFicheModelInput;
  rawXML?: string;
};


export type MutationSaveFichierGedArgs = {
  contexte?: ContextInfosInput;
  doc?: FichierCompletModelInput;
  rawXML?: string;
};


export type MutationSaveFournisseurArgs = {
  contexte?: ContextInfosInput;
  fournisseur?: FournisseurDtoInput;
  rawXML?: string;
};


export type MutationSaveFraisAnnulationModelArgs = {
  contexte?: ContextInfosInput;
  modele?: FraisAnnulationModelInput;
  rawXML?: string;
};


export type MutationSaveHorairesModifiesArgs = {
  contexte?: ContextInfosInput;
  listeHoraires?: ArrayOfPermanenceParametrageJourModelInput;
  rawXML?: string;
};


export type MutationSaveIbanTiersArgs = {
  contexte?: ContextInfosInput;
  iban?: IbanParametrageBaseModelInput;
  rawXML?: string;
};


export type MutationSaveInfosConnexionUserArgs = {
  caisseId?: number;
  contexte?: ContextInfosInput;
  delegId?: number;
  pvId?: number;
  rawXML?: string;
  stockId?: number;
  userId?: number;
};


export type MutationSaveInventaireArgs = {
  contexte?: ContextInfosInput;
  inventaire?: InventaireDtoInput;
  rawXML?: string;
};


export type MutationSaveInventaireStockArgs = {
  contexte?: ContextInfosInput;
  inventaireModel?: InventaireStockModelInput;
  rawXML?: string;
};


export type MutationSaveLargeurColonneModeExpertArgs = {
  contexte?: ContextInfosInput;
  idVue?: number;
  infoCol?: InfoColDataGridModelDtoInput;
  rawXML?: string;
};


export type MutationSaveLastHistoSynchroArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  typeSynchro?: string;
  userId?: number;
};


export type MutationSaveLigneCommandeLibreModelArgs = {
  LigneCommandeLibreModel?: LigneCommandeLibreModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveListCompteJournalPrmAutoFiduArgs = {
  contexte?: ContextInfosInput;
  l?: ArrayOfCompteJournalPrmAutoFiduDtoInput;
  rawXML?: string;
};


export type MutationSaveListRibGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresRibDtoInput;
  listRib?: ArrayOfRibDtoInput;
  rawXML?: string;
};


export type MutationSaveListeAcompteModelArgs = {
  DateDevis?: any;
  IdActivite?: number;
  IdDevis?: number;
  IdFour?: number;
  ListeAcompteModel?: ArrayOfReglementModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveListeAcomptesArgs = {
  ListeAcompteModel?: ArrayOfReglementModelDtoInput;
  contexte?: ContextInfosInput;
  factureAccompteModele?: FactureAvoirModelDtoInput;
  rawXML?: string;
};


export type MutationSaveListeAgendaGeneriqueArgs = {
  ListeAgenda?: ArrayOfAgendaDtoInput;
  contexte?: ContextInfosInput;
  criteres?: CriteresAgendaDtoInput;
  rawXML?: string;
};


export type MutationSaveListeAnneeReferenceGeneriqueArgs = {
  ListeAnneeReference?: ArrayOfAnneeReferenceDtoInput;
  contexte?: ContextInfosInput;
  criteres?: CriteresAnneeReferenceDtoInput;
  rawXML?: string;
};


export type MutationSaveListeAnnoncesGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresAnnonceDtoInput;
  liste?: ArrayOfAnnonceDtoInput;
  rawXML?: string;
};


export type MutationSaveListeApplicationParametersArgs = {
  ListeParametreValeur?: ArrayOfParametresUserAppliModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveListeBlbrModeleArgs = {
  contexte?: ContextInfosInput;
  listebLBRModele?: ArrayOfBlbrModeleInput;
  rawXML?: string;
};


export type MutationSaveListeBanqueGeneriqueArgs = {
  ListeBanques?: ArrayOfBanqueDtoInput;
  contexte?: ContextInfosInput;
  criteres?: CriteresBanqueDtoInput;
  rawXML?: string;
};


export type MutationSaveListeBenefProfilKalideaArgs = {
  CodeProfilKalidea?: string;
  ListeIdBenef?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveListeCategoriesAnnonceGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresAnnonceCategorieDtoInput;
  liste?: ArrayOfAnnonceCategorieDtoInput;
  rawXML?: string;
};


export type MutationSaveListeCategoriesGedArgs = {
  ListeDocumentCategorie?: ArrayOfPortailDocumentCategorieDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveListeChampListeValeursGeneriqueArgs = {
  ListeChampValeur?: ArrayOfChampListeValeurDtoInput;
  contexte?: ContextInfosInput;
  critere?: CriteresChampListeValeurDtoInput;
  rawXML?: string;
};


export type MutationSaveListeChampsGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresChampDtoInput;
  listeChamps?: ArrayOfChampDtoInput;
  rawXML?: string;
};


export type MutationSaveListeCleRepartitionModelArgs = {
  ListeCleRepartition?: ArrayOfCleRepartitionModelDtoInput;
  ListeIdCompte?: ArrayOfdecimalInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveListeCommissionsGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresCommissionDtoInput;
  listeCommission?: ArrayOfCommissionDtoInput;
  rawXML?: string;
};


export type MutationSaveListeCompte511Args = {
  ListeCompte511?: ArrayOfCompte511Compte511BaseModelInput;
  contexte?: ContextInfosInput;
  criteres?: Compte511CriteresCompte511ModelInput;
  rawXML?: string;
};


export type MutationSaveListeCompteEcritureGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresCompteEcritureDtoInput;
  listeCompteEcriture?: ArrayOfCompteEcritureDtoInput;
  rawXML?: string;
};


export type MutationSaveListeCompteEcritureWithMouvementsAnalytiqueArgs = {
  ListeCompteEcritureModel?: ArrayOfSaveCompteEcritureModelDtoInput;
  contexte?: ContextInfosInput;
  criteres?: CriteresCompteEcritureDtoInput;
  rawXML?: string;
};


export type MutationSaveListeCompteEtCleRepartitionArgs = {
  ListeCleRepartition?: ArrayOfCleRepartitionModelDtoInput;
  ListeComptes?: ArrayOfCompteDtoInput;
  contexte?: ContextInfosInput;
  critere?: CriteresCompteDtoInput;
  rawXML?: string;
};


export type MutationSaveListeCompteGeneriqueArgs = {
  ListeComptes?: ArrayOfCompteDtoInput;
  contexte?: ContextInfosInput;
  critere?: CriteresCompteDtoInput;
  rawXML?: string;
};


export type MutationSaveListeConsoMouvementGeneriqueArgs = {
  ListeConsoMouvement?: ArrayOfConsoMouvementDtoInput;
  contexte?: ContextInfosInput;
  critere?: CriteresConsoMouvementDtoInput;
  rawXML?: string;
};


export type MutationSaveListeCourrierGeneriqueArgs = {
  ListeCourrier?: ArrayOfCourrierDtoInput;
  contexte?: ContextInfosInput;
  criteres?: CriteresCourrierDtoInput;
  rawXML?: string;
};


export type MutationSaveListeCourrierHistoEnvoiGeneriqueArgs = {
  ListeCourrierHisto?: ArrayOfCourrierHistoEnvoiDtoInput;
  contexte?: ContextInfosInput;
  critere?: CriteresCourrierHistoEnvoiDtoInput;
  rawXML?: string;
};


export type MutationSaveListeDepartementsArgs = {
  Criteres?: CriteresDepartementDtoInput;
  contexte?: ContextInfosInput;
  departement?: ArrayOfDepartementDtoInput;
  rawXML?: string;
};


export type MutationSaveListeExerciceGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresExerciceDtoInput;
  listeExercices?: ArrayOfExerciceDtoInput;
  rawXML?: string;
};


export type MutationSaveListeFactureGeneriqueArgs = {
  Listefacture?: ArrayOfFactureDtoInput;
  contexte?: ContextInfosInput;
  criteres?: CriteresFactureDtoInput;
  rawXML?: string;
};


export type MutationSaveListeFicheProfilInfosAffichageOngletsArgs = {
  ListeInfosAffichageOnglets?: ArrayOfFicheProfilInfosAffichageOngletInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveListeFicheProfilModeExpertArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  idVue?: number;
  listeKeyValue?: ArrayOfKeyValueModelDtoInput;
  rawXML?: string;
};


export type MutationSaveListeHistoStatutArgs = {
  ListeHistoStatut?: ArrayOfHistoStatutCommandeDtoInput;
  contexte?: ContextInfosInput;
  critere?: CriteresHistoStatutCommandeDtoInput;
  rawXML?: string;
};


export type MutationSaveListeImportModeleGeneriqueArgs = {
  ListeImportModele?: ArrayOfImportModeleDtoInput;
  contexte?: ContextInfosInput;
  critere?: CriteresImportModeleDtoInput;
  rawXML?: string;
};


export type MutationSaveListeJournalGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresJournalDtoInput;
  liste?: ArrayOfJournalDtoInput;
  rawXML?: string;
};


export type MutationSaveListeLienDirectoModelArgs = {
  ListeLienDirecto?: ArrayOfLienDirectoModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveListeLieuxArgs = {
  contexte?: ContextInfosInput;
  listeLieux?: ArrayOfLieuDtoInput;
  rawXML?: string;
};


export type MutationSaveListeLigneRemiseEnBanqueModelArgs = {
  IsRejetSimple?: boolean;
  contexte?: ContextInfosInput;
  dateRejet?: any;
  liste?: ArrayOfLigneRemiseEnBanqueModelInput;
  rawXML?: string;
};


export type MutationSaveListeMappingValeurColonnesArgs = {
  contexte?: ContextInfosInput;
  idImportHisto?: number;
  listemappings?: ArrayOfImportColonneAMapperValeurModelInput;
  rawXML?: string;
};


export type MutationSaveListeMenusArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMenuDtoInput;
  listeMenus?: ArrayOfMenuDtoInput;
  rawXML?: string;
};


export type MutationSaveListeModeleAdresseArgs = {
  contexte?: ContextInfosInput;
  listeModeleAdresse?: ArrayOfReportModeleAdrdtoInput;
  rawXML?: string;
};


export type MutationSaveListeModeleSaisieSectionAnaParPlanArgs = {
  ListeModeleSaisieSecAnaParPlanModel?: ArrayOfSaveModeleSaisieModelDtoInput;
  contexte?: ContextInfosInput;
  criteres?: CriteresModeleSaisieLibreDtoInput;
  rawXML?: string;
};


export type MutationSaveListeModesLivraisonGeneriqueArgs = {
  ListeModesLivraison?: ArrayOfModeLivraisonDtoInput;
  contexte?: ContextInfosInput;
  criteres?: CriteresModeLivraisonDtoInput;
  rawXML?: string;
};


export type MutationSaveListeMontantCrediterOuDebiterCompteArgs = {
  contexte?: ContextInfosInput;
  listeModeleSoldeCptCrediterOrDebiter?: ArrayOfCompteCourantADebiterOuCrediterModelDtoInput;
  rawXML?: string;
};


export type MutationSaveListeMouvementComptableGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementComptableDtoInput;
  listeMouvement?: ArrayOfMouvementComptableDtoInput;
  rawXML?: string;
};


export type MutationSaveListeMouvementStockGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresMouvementStockDtoInput;
  listeMouvement?: ArrayOfMouvementStockDtoInput;
  rawXML?: string;
};


export type MutationSaveListeMoyenPaiementsGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresMoyenPaiementDtoInput;
  listeMoyenPaiement?: ArrayOfMoyenPaiementDtoInput;
  rawXML?: string;
};


export type MutationSaveListeOrganisationGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresOrganisationDtoInput;
  listeOrgas?: ArrayOfOrganisationDtoInput;
  rawXML?: string;
};


export type MutationSaveListePjDossierPrestationArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  idDossierPrestation?: number;
  listePieceJustificative?: ArrayOfPieceJustificativeBenefModelInput;
  rawXML?: string;
};


export type MutationSaveListePaysArgs = {
  contexte?: ContextInfosInput;
  pays?: ArrayOfPaysDtoInput;
  rawXML?: string;
};


export type MutationSaveListePieceJustificativeBenefArgs = {
  contexte?: ContextInfosInput;
  idBenef?: number;
  listePieceJustificative?: ArrayOfPieceJustificativeBenefModelInput;
  rawXML?: string;
};


export type MutationSaveListePieceJustificativeGeneriqueArgs = {
  ListePJ?: ArrayOfPieceJustificativeDtoInput;
  contexte?: ContextInfosInput;
  critere?: CriteresPieceJustificativeDtoInput;
  rawXML?: string;
};


export type MutationSaveListePointVenteGeneriqueArgs = {
  ListePointVente?: ArrayOfPointVenteDtoInput;
  contexte?: ContextInfosInput;
  critere?: CriteresPointVenteDtoInput;
  rawXML?: string;
};


export type MutationSaveListePortailPortletGeneriqueArgs = {
  ListePortailPortlet?: ArrayOfPortailPortletDtoInput;
  contexte?: ContextInfosInput;
  criteres?: CriteresPortailPortletDtoInput;
  rawXML?: string;
};


export type MutationSaveListeProfilsDroitGeneriqueArgs = {
  ListeProfilsDroit?: ArrayOfProfilDroitDtoInput;
  contexte?: ContextInfosInput;
  critere?: CriteresProfilDroitDtoInput;
  rawXML?: string;
};


export type MutationSaveListeRegionsArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  region?: ArrayOfRegionDtoInput;
};


export type MutationSaveListeSiteGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresSiteDtoInput;
  listeSites?: ArrayOfSiteDtoInput;
  rawXML?: string;
};


export type MutationSaveListeStockGeneriqueArgs = {
  ListeStock?: ArrayOfStockDtoInput;
  contexte?: ContextInfosInput;
  criteres?: CriteresStockDtoInput;
  rawXML?: string;
};


export type MutationSaveListeUsersGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresUsersDtoInput;
  liste?: ArrayOfUsersDtoInput;
  rawXML?: string;
};


export type MutationSaveListeVilleArgs = {
  Criteres?: CriteresVilleDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
  ville?: ArrayOfVilleDtoInput;
};


export type MutationSaveListeVueGeneriqueArgs = {
  ListeVue?: ArrayOfVueDtoInput;
  contexte?: ContextInfosInput;
  critere?: CriteresVueDtoInput;
  rawXML?: string;
};


export type MutationSaveListeWidgetParamByModelArgs = {
  WidgetParamModel?: SaveWidgetParamModelDtoInput;
  contexte?: ContextInfosInput;
  criteresWidget?: CriteresWidgetAccueilParamDtoInput;
  rawXML?: string;
};


export type MutationSaveListeWidgetsAccueilGeneriqueArgs = {
  contexte?: ContextInfosInput;
  criteresWidget?: CriteresWidgetAccueilDtoInput;
  listeWidgetAccueils?: ArrayOfWidgetAccueilDtoInput;
  rawXML?: string;
};


export type MutationSaveModelEmailGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresModelEmailDtoInput;
  modelEmail?: ModelEmailDtoInput;
  rawXML?: string;
};


export type MutationSaveModeleAfpaArgs = {
  contexte?: ContextInfosInput;
  modele?: ModeleSauvegardeAfpadtoInput;
  rawXML?: string;
};


export type MutationSaveModeleEnveloppeArgs = {
  IsGenerationRegleForEnv?: boolean;
  contexte?: ContextInfosInput;
  critere?: CriteresEnveloppeQuotaDtoInput;
  modeleEnv?: ModeleEnveloppeDtoInput;
  rawXML?: string;
};


export type MutationSaveModeleEpargneArgs = {
  contexte?: ContextInfosInput;
  model?: ModeleEpargneModelInput;
  rawXML?: string;
};


export type MutationSaveModeleImpressionArgs = {
  SaveModel?: SaveModelImpressionDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveModeleLocationArgs = {
  ModeleLocation?: ModeleLocationModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveModeleRegleSubQuotaArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  regle?: ModeleRegleSubQuotaDtoInput;
};


export type MutationSaveModeleRequeteArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  requete?: RequetePubliRequeteAvecCriteresModelInput;
};


export type MutationSaveModeleSaisieEcritureArgs = {
  ModeleSaisieEcriture?: ModeleSaisieEcritureModeleSaisieEcritureModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveModeleTvaArgs = {
  contexte?: ContextInfosInput;
  modele?: ParametrageTvaModelInput;
  rawXML?: string;
};


export type MutationSaveNotificationsVupArgs = {
  contexte?: ContextInfosInput;
  idUser?: number;
  listeNotificationVUP?: ArrayOfNotificationVupInput;
  rawXML?: string;
};


export type MutationSaveParamFicheProfilArgs = {
  contexte?: ContextInfosInput;
  modeleSaveParamFiche?: SaveParamFicheProfileModelInput;
  rawXML?: string;
};


export type MutationSaveParametrageClotureComptableArgs = {
  ModelParametrage?: ParametrageClotureExerciceModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveParametresPortletSondageArgs = {
  contexte?: ContextInfosInput;
  infos?: PortletsInfosParametresPortletSondageInput;
  rawXML?: string;
};


export type MutationSaveParticipantDevisArgs = {
  Devis?: DevisCommandeDtoInput;
  ListIdAd?: ArrayOfdecimalInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSavePermArgs = {
  contexte?: ContextInfosInput;
  permanence?: PermDtoInput;
  rawXML?: string;
};


export type MutationSavePermanenceArgs = {
  contexte?: ContextInfosInput;
  permanence?: PermanencePermanenceModelInput;
  rawXML?: string;
};


export type MutationSavePictoArgs = {
  IdElement?: number;
  Picto?: PictoDtoInput;
  Type?: TypePictoEnum;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSavePortailAlbumArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresPortailAlbumDtoInput;
  desc?: PortailAlbumDtoInput;
  rawXML?: string;
};


export type MutationSavePosteBudgetaireArgs = {
  PosteBDGModele?: PosteBudgetaireModelDtoInput;
  contexte?: ContextInfosInput;
  critere?: CriteresPosteBudgetaireDtoInput;
  rawXML?: string;
};


export type MutationSaveRapprochementArgs = {
  contexte?: ContextInfosInput;
  r?: RapprochementDtoInput;
  rawXML?: string;
};


export type MutationSaveRegleModeleAccesArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  regle?: RegleModeleAccesDtoInput;
};


export type MutationSaveReleveBancaireArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  releve?: ReleveBancaireDtoInput;
};


export type MutationSaveRessourceArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  ressourceModel?: ParamRessourceModelInput;
};


export type MutationSaveSessionChoixArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresSessionChoixDtoInput;
  rawXML?: string;
  sessionChoix?: SessionChoixDtoInput;
};


export type MutationSaveUserNoteArgs = {
  contexte?: ContextInfosInput;
  modeleNotation?: UserNoteVersionModelInput;
  rawXML?: string;
};


export type MutationSendErrorArgs = {
  contexte?: ContextInfosInput;
  exception?: UnhandledExceptionModelInput;
  rawXML?: string;
};


export type MutationSendMailFromEmlModeleArgs = {
  benef?: ArrayOfBenefDtoInput;
  contexte?: ContextInfosInput;
  mail?: MailModelDtoInput;
  rawXML?: string;
};


export type MutationSendMailWithCourrierArgs = {
  CodeReport?: string;
  contexte?: ContextInfosInput;
  dictionaryParameters?: ArrayOfKeyValueOfstringanyTypeInput;
  mail?: MailModelDtoInput;
  rawXML?: string;
};


export type MutationSolderOuReglerPartiellementReglementsMasseArgs = {
  contexte?: ContextInfosInput;
  modele?: SolderReglerPartiellementModeleInput;
  rawXML?: string;
};


export type MutationSolderPmvArgs = {
  DateValeur?: any;
  IdAbondement?: number;
  IdBenef?: number;
  IdUser?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSuppressionBlocageInseslArgs = {
  contexte?: ContextInfosInput;
  listeIdBenef?: ArrayOfdecimalInput;
  rawXML?: string;
  refusInscriptionEsl?: boolean;
};


export type MutationSuppressionPhysiqueOuAnnulationListeDevisArgs = {
  ListIdDevisCommande?: ArrayOfdecimalInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSuppressionTriggerStatutPersoArgs = {
  contexte?: ContextInfosInput;
  idAction?: number;
  rawXML?: string;
};


export type MutationSupprimerAcompteArgs = {
  IdFac?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerAlbumAssosArticleEditorialArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  listeIdAlbum?: ArrayOfintInput;
  rawXML?: string;
};


export type MutationSupprimerAlbumEtFichiersArgs = {
  contexte?: ContextInfosInput;
  idAlbum?: number;
  rawXML?: string;
  withUsedFiles?: boolean;
};


export type MutationSupprimerAnneeReferenceArgs = {
  contexte?: ContextInfosInput;
  idAnneeReference?: number;
  rawXML?: string;
};


export type MutationSupprimerArreteCaisseArgs = {
  IdArreteCaisse?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerArticleArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  rawXML?: string;
};


export type MutationSupprimerArticleUpKonnectArgs = {
  contexte?: ContextInfosInput;
  idArticlePortail?: number;
  rawXML?: string;
};


export type MutationSupprimerAttributionBudgetArgs = {
  contexte?: ContextInfosInput;
  idAtb?: number;
  rawXML?: string;
};


export type MutationSupprimerAttributionRanArgs = {
  contexte?: ContextInfosInput;
  idAttRan?: number;
  rawXML?: string;
};


export type MutationSupprimerAvoirArgs = {
  contexte?: ContextInfosInput;
  dateAnnulation?: any;
  idAvoir?: number;
  rawXML?: string;
};


export type MutationSupprimerCessionStockArgs = {
  contexte?: ContextInfosInput;
  idCession?: number;
  rawXML?: string;
};


export type MutationSupprimerChampArgs = {
  IdChamp?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerChampFormulaireArgs = {
  contexte?: ContextInfosInput;
  idChampFormulaire?: number;
  rawXML?: string;
};


export type MutationSupprimerCleRepartitionByModelArgs = {
  CleRepartition?: CleRepartitionModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerClotureComptableArgs = {
  IdExercice?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerCommandeArgs = {
  contexte?: ContextInfosInput;
  modeleSuppressionCde?: ModeleSupAnnRemBonRetourCommandeDtoInput;
  rawXML?: string;
};


export type MutationSupprimerContratLocationProduitFamilleArgs = {
  IdCourrier?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerDeclarationTvaArgs = {
  contexte?: ContextInfosInput;
  etat?: TvaEtatPreparatoireHistoModelInput;
  rawXML?: string;
};


export type MutationSupprimerDocAssoArticleEditorialArgs = {
  contexte?: ContextInfosInput;
  idArticle?: number;
  listeIdFichier?: ArrayOfintInput;
  rawXML?: string;
};


export type MutationSupprimerDocumentArgs = {
  contexte?: ContextInfosInput;
  fichierId?: number;
  rawXML?: string;
};


export type MutationSupprimerEcheancesRestantesArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationSupprimerEcheancierArgs = {
  contexte?: ContextInfosInput;
  idEccheancier?: number;
  rawXML?: string;
};


export type MutationSupprimerEcritureArgs = {
  contexte?: ContextInfosInput;
  modeleSuppression?: IsSupprimableEcritureModelInput;
  rawXML?: string;
};


export type MutationSupprimerEcritureDecaissementArgs = {
  contexte?: ContextInfosInput;
  idEcriture?: number;
  rawXML?: string;
};


export type MutationSupprimerEcritureDecaissementSeuleArgs = {
  contexte?: ContextInfosInput;
  idEcriture?: number;
  rawXML?: string;
};


export type MutationSupprimerEcritureModelArgs = {
  IdEcriture?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerExerciceArgs = {
  IdExercice?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerFactureArgs = {
  contexte?: ContextInfosInput;
  idFacture?: number;
  rawXML?: string;
};


export type MutationSupprimerFactureAvoirArgs = {
  contexte?: ContextInfosInput;
  listeIdAvoirFacture?: ArrayOfdecimalInput;
  listeIdDossierPrestation?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationSupprimerFactureFournisseurArgs = {
  IdFac?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerFactureParIdDossierPrestaArgs = {
  IdDossierPresta?: number;
  IsAnnulationTransfertCompta?: boolean;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerFactureReservationArgs = {
  IdFacture?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerFamilleArgs = {
  contexte?: ContextInfosInput;
  idFamille?: number;
  rawXML?: string;
};


export type MutationSupprimerFormulaireArgs = {
  contexte?: ContextInfosInput;
  idFormulaire?: number;
  rawXML?: string;
};


export type MutationSupprimerGroupeArgs = {
  contexte?: ContextInfosInput;
  idGroupe?: number;
  rawXML?: string;
};


export type MutationSupprimerImagePortailArgs = {
  Tag?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerImportArgs = {
  contexte?: ContextInfosInput;
  idImport?: number;
  rawXML?: string;
};


export type MutationSupprimerImputationFactureSurAvoirAcompteArgs = {
  contexte?: ContextInfosInput;
  idAvoirAcompte?: number;
  idFacture?: number;
  rawXML?: string;
};


export type MutationSupprimerModeleFraisAnnulationArgs = {
  contexte?: ContextInfosInput;
  idModele?: number;
  rawXML?: string;
};


export type MutationSupprimerModeleLocationArgs = {
  IdModele?: number;
  WithClotureArticle?: boolean;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerOrClosRibMandatArgs = {
  contexte?: ContextInfosInput;
  idribManadat?: number;
  rawXML?: string;
};


export type MutationSupprimerParticipantArgs = {
  contexte?: ContextInfosInput;
  idGroupe?: number;
  idLigneCommande?: number;
  rawXML?: string;
};


export type MutationSupprimerPieceJustificativeArgs = {
  contexte?: ContextInfosInput;
  pieceJustificative?: DossierPrestationBasePieceJustificativeModelDtoInput;
  rawXML?: string;
};


export type MutationSupprimerPlanAnalytiqueArgs = {
  IdPlan?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerProduitArgs = {
  contexte?: ContextInfosInput;
  idProduit?: number;
  rawXML?: string;
};


export type MutationSupprimerRegleMoteurArgs = {
  contexte?: ContextInfosInput;
  forcerSuppression?: boolean;
  idRegleRacine?: number;
  rawXML?: string;
  supprimerRegleMere?: boolean;
};


export type MutationSupprimerRemiseCaisseArgs = {
  IdRemiseCaisse?: number;
  IsInvalidationRemise?: boolean;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerRemiseEnBanqueModelArgs = {
  RemiseEnBanque?: RemiseEnBanqueModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerReservationRpArgs = {
  contexte?: ContextInfosInput;
  infos?: AnnulationReservationModelInput;
  rawXML?: string;
};


export type MutationSupprimerRoomingListArgs = {
  contexte?: ContextInfosInput;
  idRegroupement?: number;
  rawXML?: string;
};


export type MutationSupprimerSectionAnalytiqueArgs = {
  IdSection?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSupprimerTarifArgs = {
  contexte?: ContextInfosInput;
  idTarif?: number;
  rawXML?: string;
};


export type MutationSupprimerTarifEtGenererAvoirArgs = {
  contexte?: ContextInfosInput;
  infosSuppression?: InfosSuppressionTarifCreationAvoirModelInput;
  rawXML?: string;
};


export type MutationSupprimerTransfertArgs = {
  contexte?: ContextInfosInput;
  idTransfert?: number;
  rawXML?: string;
};


export type MutationTelechargerPieceJustificativeArgs = {
  contexte?: ContextInfosInput;
  pieceJustificative?: DossierPrestationBasePieceJustificativeModelDtoInput;
  rawXML?: string;
};


export type MutationTeleverserPieceJustificativeArgs = {
  contexte?: ContextInfosInput;
  fichier?: string;
  nomFichier?: string;
  pieceJustificative?: DossierPrestationValiderPieceJustificativeModelDtoInput;
  rawXML?: string;
};


export type MutationTerminerDossierEpargneArgs = {
  contexte?: ContextInfosInput;
  idDossier?: number;
  rawXML?: string;
};


export type MutationTransfertModePacArgs = {
  TransfertEnComptabilite?: TransfertEnComptabiliteModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationTransfertModeRemboursementArgs = {
  TransfertEnComptabilite?: TransfertEnComptabiliteModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationTransformeAndSaveListeModeleMoteurRegleArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresMoteurRegleDtoInput;
  listeRegleModele?: ArrayOfMoteurRegleModelDtoInput;
  rawXML?: string;
};


export type MutationTransformeCommandeFactureByModelArgs = {
  ModeleFacturation?: ModeleForFacturationDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationTransformeListCommandeListFactureByModelArgs = {
  ModeleFacturation?: ModeleForFacturationListCmdDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationTransformerEnDonPretsEtDonsArgs = {
  contexte?: ContextInfosInput;
  modeleTransformation?: TransformerEnDonModelInput;
  rawXML?: string;
};


export type MutationTransformerPrestationCadeauxEnCommandeArgs = {
  TransfertEnComptabilite?: CadeauxInfosTransformationCadeauxEnCommandeModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationTransformerRegleGuideeEnExpertArgs = {
  contexte?: ContextInfosInput;
  idRegle?: number;
  rawXML?: string;
};


export type MutationUnlikeArticleMagazineArgs = {
  contexte?: ContextInfosInput;
  idArticle?: string;
  rawXML?: string;
};


export type MutationUpdateChoixSessionChoixVentesClientArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  numeroChoix?: number;
  rawXML?: string;
};


export type MutationUpdateDateDerniereUtilisationRequeteArgs = {
  contexte?: ContextInfosInput;
  idRequete?: number;
  rawXML?: string;
};


export type MutationUpdateDateReservationEmpruntSurLigneCommnadeArgs = {
  contexte?: ContextInfosInput;
  critereUpdateDate?: MediathequeCritereExemplaireUpdateDateEmpruntReservationModelInput;
  rawXML?: string;
};


export type MutationUpdateDatesEcheancesDossierPretsEtDonsArgs = {
  contexte?: ContextInfosInput;
  idDossier?: number;
  rawXML?: string;
};


export type MutationUpdateDevisBenefArgs = {
  IdBenef?: number;
  contexte?: ContextInfosInput;
  idDevis?: number;
  rawXML?: string;
};


export type MutationUpdateDevisSaisieEnCoursArgs = {
  IdCommande?: number;
  IsSaisieEnCours?: boolean;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationUpdateEcheancierArgs = {
  contexte?: ContextInfosInput;
  echeancier?: EcheancierModelDtoInput;
  rawXML?: string;
};


export type MutationUpdateEcritureForDeleteMntProratiserArgs = {
  contexte?: ContextInfosInput;
  listeIdEcriture?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationUpdateEcritureForSaveMntProratiserArgs = {
  MontantProratiser?: number;
  contexte?: ContextInfosInput;
  idEcriture?: number;
  rawXML?: string;
};


export type MutationUpdateEmlModeleArgs = {
  contexte?: ContextInfosInput;
  mail?: MailModelDtoInput;
  mailCode?: string;
  rawXML?: string;
};


export type MutationUpdateEnteteDevisByModelArgs = {
  contexte?: ContextInfosInput;
  enteteDeivsModel?: EnteteDevisCommandeForVentesModeleDtoInput;
  rawXML?: string;
};


export type MutationUpdateEnteteDevisCommandeLibreByModelArgs = {
  contexte?: ContextInfosInput;
  enteteDevisModel?: EnteteDevisCommandeForCommandeLibreModeleDtoInput;
  rawXML?: string;
};


export type MutationUpdateFonctionnalitesProfilArgs = {
  contexte?: ContextInfosInput;
  modelUpdateFonctionnalites?: UpdateProfilFonctionnalitesModelInput;
  rawXML?: string;
};


export type MutationUpdateInfosSimpleLigneCommandeByModelArgs = {
  LigneCommmandeModel?: LigneDevisModeleDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationUpdateIsUseSurMoyenPaiementActiviteArgs = {
  MoyenPaiementActiviteModel?: MoyenPaiementActiviteModelDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationUpdateLigneCommandePrestationArgs = {
  contexte?: ContextInfosInput;
  modeleLigne?: UpdateLigneCommandePrestationModelDtoInput;
  rawXML?: string;
  skipAppelMoteur?: boolean;
};


export type MutationUpdateListeCommissionEditOptionArgs = {
  contexte?: ContextInfosInput;
  idEditOption?: number;
  listeIdCommissions?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationUpdateListeCommissionListeEditArticleArgs = {
  contexte?: ContextInfosInput;
  listeEditArticle?: ArrayOfdecimalInput;
  listeIdCommissions?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationUpdateListeDroitsUserCommissionArgs = {
  contexte?: ContextInfosInput;
  idUser?: number;
  rawXML?: string;
};


export type MutationUpdateListeMediaArgs = {
  contexte?: ContextInfosInput;
  listeIdMedia?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationUpdateMandatSurMouvementComptableArgs = {
  IdMandat?: number;
  contexte?: ContextInfosInput;
  listeIdMouvement?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationUpdateModeLivraisonLigneCommandeByModelArgs = {
  IdLigneCommmandeModel?: number;
  IdModeLivraison?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationUpdateModeleRgeleArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  regleModele?: MoteurRegleModelDtoInput;
};


export type MutationUpdateMontantValorisationArgs = {
  IdArticle?: number;
  IdCloture?: number;
  MontantValorisation?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationUpdateMotDePassePremiereConnexionArgs = {
  confirmPassword?: string;
  contexte?: ContextInfosInput;
  password?: string;
  rawXML?: string;
};


export type MutationUpdateParticipantsCommandeArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  listeBenef?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationUpdatePlanAnalytiqueArgs = {
  contexte?: ContextInfosInput;
  model?: PlanAnalytiqueModelDtoInput;
  rawXML?: string;
};


export type MutationUpdateProfilSubventionBenefsArgs = {
  contexte?: ContextInfosInput;
  idProfilSubvention?: number;
  listIdsBenef?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationUpdateQteAttribueeArgs = {
  contexte?: ContextInfosInput;
  idLigneVue?: number;
  newQte?: number;
  rawXML?: string;
};


export type MutationUpdateRibSurMouvementComptableArgs = {
  IdMouvement?: number;
  IdRib?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationUpdateSectionAnalytiqueArgs = {
  contexte?: ContextInfosInput;
  model?: CriteresSectionAnalytiqueModelInput;
  rawXML?: string;
};


export type MutationUpdateSectionAnalytiqueSurMouvementsArgs = {
  contexte?: ContextInfosInput;
  listeIdsMouvementSectionAnalytique?: ArrayOfEditerSectionAnalytiqueSurMouvementInput;
  rawXML?: string;
};


export type MutationUploadImportFileArgs = {
  ByteTab?: string;
  contexte?: ContextInfosInput;
  modeleCreationImport?: CreerImportModelDtoInput;
  rawXML?: string;
};


export type MutationUploaderImageFromRichTextBoxArgs = {
  contexte?: ContextInfosInput;
  fichier?: string;
  nomFichier?: string;
  rawXML?: string;
};


export type MutationUserHaveAccessFonctionnaliteArgs = {
  codeMenuGenerique?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationUtiliseurPeutAccederAuMenuArgs = {
  CodeVersionLogiciel?: string;
  NomGestionMenuPge?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationValidateAnnRefWithCritSocArgs = {
  IdAnneeRef?: number;
  IdDelegation?: number;
  contexte?: ContextInfosInput;
  listeIdCriteresSociaux?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationValiderArreteCaisseArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  saveModele?: ArreteCaisseSaveArreteCaisseModelInput;
};


export type MutationValiderCommentaireArgs = {
  contexte?: ContextInfosInput;
  isValide?: boolean;
  listeId?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationValiderDonneesIsbnMediathequeArgs = {
  contexte?: ContextInfosInput;
  id?: number;
  idActivite?: number;
  isbn?: string;
  rawXML?: string;
  type?: TypeAfpaEnum;
};


export type MutationValiderImportPourExecutionArgs = {
  contexte?: ContextInfosInput;
  dateExecution?: any;
  idImport?: number;
  rawXML?: string;
};


export type MutationValiderRemiseEnCaisseArgs = {
  contexte?: ContextInfosInput;
  modeleSave?: RemiseEnCaisseSaveRemiseEnCaisseModelInput;
  rawXML?: string;
};


export type MutationVerifCodeValidationRemonteeBaseArgs = {
  CodeValidation?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationVerifGenerationFichierPrelSepaArgs = {
  contexte?: ContextInfosInput;
  idCompteBancaire?: number;
  idRemiseEnBanque?: number;
  rawXML?: string;
};


export type MutationVerifMontantRestantAvoirSurFactureArgs = {
  IdFacture?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationVerifProduitLierLieuArgs = {
  contexte?: ContextInfosInput;
  idLieu?: number;
  idProduit?: number;
  rawXML?: string;
};


export type MutationVerificationAvantClotureComptableArgs = {
  IdExercice?: number;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationVerificationAvantExportEcritureArgs = {
  codePrefixe?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationVerificationCompteSurLigneCdeClientLibreArgs = {
  contexte?: ContextInfosInput;
  listeIdCdeClientLibre?: string;
  rawXML?: string;
};


export type MutationVerificationsMandatAssocieRibPrelevelementSepaArgs = {
  contexte?: ContextInfosInput;
  idCompteBancaire?: number;
  listRib?: ArrayOfdecimalInput;
  rawXML?: string;
};


export type MutationVerifierAttributionEnAllotementArgs = {
  contexte?: ContextInfosInput;
  idProduit?: number;
  idSessionChoix?: number;
  rawXML?: string;
};


export type MutationVerifierAvoirAcompteSurFactureEtDevisCdeArgs = {
  contexte?: ContextInfosInput;
  idFact?: number;
  listeIdCde?: string;
  rawXML?: string;
};


export type MutationVerifierChangementTypeStockProduitPossibleArgs = {
  contexte?: ContextInfosInput;
  idProduit?: number;
  rawXML?: string;
};


export type MutationVerifierConditionSupEnveloppeArgs = {
  contexte?: ContextInfosInput;
  idEnv?: number;
  rawXML?: string;
};


export type MutationVerifierConditionSuppressionAttRanArgs = {
  contexte?: ContextInfosInput;
  idAttRan?: number;
  rawXML?: string;
};


export type MutationVerifierConditionSuppressionChampPersoArgs = {
  contexte?: ContextInfosInput;
  idChampPerso?: number;
  rawXML?: string;
};


export type MutationVerifierDisponibiliteMediaArgs = {
  contexte?: ContextInfosInput;
  criteres?: CriteresLigneCommandeModelInput;
  rawXML?: string;
};


export type MutationVerifierDossierAssosArticleEditSupprimableArgs = {
  contexte?: ContextInfosInput;
  idAlbum?: number;
  idArticle?: number;
  rawXML?: string;
};


export type MutationVerifierEmpruntExemplaireFpaArgs = {
  contexte?: ContextInfosInput;
  idFPA?: number;
  rawXML?: string;
  typeFPA?: TypeAfpaEnum;
};


export type MutationVerifierLigneCdeClientDejaReapproWithIdCdeFourArgs = {
  contexte?: ContextInfosInput;
  idCommande?: number;
  rawXML?: string;
};


export type MutationVerifierMoyenPaiementValidArgs = {
  article?: ArticleDtoInput;
  contexte?: ContextInfosInput;
  montantReg?: number;
  rawXML?: string;
};


export type MutationVerifierPlageReservationArgs = {
  contexte?: ContextInfosInput;
  dateDebut?: any;
  dateFin?: any;
  idArticle?: number;
  rawXML?: string;
};


export type MutationVerifierRelationBenefOdadArgs = {
  AyantDroit?: BenefOdadModelInput;
  IsAjout?: boolean;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationVerifierSiImportEnCoursArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationVerifierUniciteCodeFournisseurArgs = {
  codeFour?: string;
  contexte?: ContextInfosInput;
  idFour?: number;
  rawXML?: string;
};


export type MutationVerifierUniciteInformationsBeneficiaireArgs = {
  beneficiaire?: VerificationUniciteBeneficiaireModelInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationVerifierVilleExisteArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  ville?: string;
};


export type MutationVilleHasAdresseArgs = {
  contexte?: ContextInfosInput;
  idVille?: number;
  rawXML?: string;
};


export type MutationGetCompteIn511Args = {
  contexte?: ContextInfosInput;
  idCaisse?: number;
  idCompteBancaire?: number;
  idMoyenP?: number;
  rawXML?: string;
};


export type MutationGetCompteReglementFiduciaireArgs = {
  contexte?: ContextInfosInput;
  idCaisse?: number;
  idMoyenPaiment?: number;
  rawXML?: string;
};


export type MutationGetDernierCompteEcritureNumeroArgs = {
  contexte?: ContextInfosInput;
  critere?: CritereRechercheNumeroPieceDtoInput;
  rawXML?: string;
};


export type MutationGetDernierNumeroBordereauArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitialisationAdmninistrationAlbumsArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitialisationAdmninistrationDocumentsArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitialisationParametresPortletVenteArticleArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitialisationParametresPortletsArticleEditorialArgs = {
  IsPrehomePublique?: boolean;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetInitialisationParametresPortletsDirectoArgs = {
  CodePortlet?: string;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListClasseCompteArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListExerciceGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresExerciceDtoInput;
  rawXML?: string;
};


export type MutationGetListImportCompteArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListSectionCompteArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  withSousClasse?: boolean;
};


export type MutationGetListSousClasseCompteArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  withClasse?: boolean;
};


export type MutationGetListTypJournalArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeAlbumsGedModelArgs = {
  contexte?: ContextInfosInput;
  criteres?: GedCriteresFiltrageGedModelInput;
  rawXML?: string;
};


export type MutationGetListeCompteJournalPrmArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeCompteReglementArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationGetListeProfilsDroitsArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresProfilDroitDtoInput;
  rawXML?: string;
};


export type MutationHasAgregInLevelHigherArgs = {
  compte?: CompteDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationImportListeCompteArgs = {
  contexte?: ContextInfosInput;
  liste?: ArrayOfCompteDtoInput;
  rawXML?: string;
};


export type MutationIsCompteExistsArgs = {
  compte?: CompteDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationRazPermanenceArgs = {
  contexte?: ContextInfosInput;
  idPerm?: number;
  rawXML?: string;
};


export type MutationSaveBanqueRemiseArgs = {
  contexte?: ContextInfosInput;
  rawXML?: string;
  remiseEnBanqueModel?: SaveRemiseEnBanqueBaseModelInput;
};


export type MutationSaveClasseCompteArgs = {
  classe?: CompteClasseDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveCompteArgs = {
  IDCForceSave?: boolean;
  compte?: CompteDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveCompteJournalPrmAutoFiduArgs = {
  contexte?: ContextInfosInput;
  cptJrnFidu?: CompteJournalPrmAutoFiduDtoInput;
  rawXML?: string;
};


export type MutationSaveComptesReglementArgs = {
  contexte?: ContextInfosInput;
  cptReglement?: CompteReglementFiduciaireDtoInput;
  rawXML?: string;
};


export type MutationSaveJournalArgs = {
  contexte?: ContextInfosInput;
  journal?: JournalDtoInput;
  rawXML?: string;
};


export type MutationSaveListeCaisseGeneriqueArgs = {
  contexte?: ContextInfosInput;
  critere?: CriteresCaisseDtoInput;
  liste?: ArrayOfCaisseDtoInput;
  rawXML?: string;
};


export type MutationSaveListeClasseCompteArgs = {
  contexte?: ContextInfosInput;
  liste?: ArrayOfCompteClasseDtoInput;
  rawXML?: string;
};


export type MutationSaveListeCompteArgs = {
  contexte?: ContextInfosInput;
  liste?: ArrayOfCompteDtoInput;
  rawXML?: string;
};


export type MutationSaveListeCompteJournalPrmAutoArgs = {
  contexte?: ContextInfosInput;
  l?: ArrayOfCompteJournalPrmAutoDtoInput;
  rawXML?: string;
};


export type MutationSaveListeCompteursPointsArgs = {
  ListeCompteursPoints?: ArrayOfCompteurPointDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveListeSectionCompteArgs = {
  contexte?: ContextInfosInput;
  liste?: ArrayOfCompteSectionDtoInput;
  rawXML?: string;
};


export type MutationSaveListeSousClasseCompteArgs = {
  contexte?: ContextInfosInput;
  liste?: ArrayOfCompteSousClasseDtoInput;
  rawXML?: string;
};


export type MutationSaveSectionCompteArgs = {
  compteSection?: CompteSectionDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};


export type MutationSaveSousClasseCompteArgs = {
  compteSousClasse?: CompteSousClasseDtoInput;
  contexte?: ContextInfosInput;
  rawXML?: string;
};

export type NatureMouvementStockDto = {
  __typename?: 'NatureMouvementStockDTO';
  Code?: string;
  Id?: number;
  IsMouvementSurStockReel?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type NatureMouvementStockDtoInput = {
  Code?: string;
  Id?: number;
  IsMouvementSurStockReel?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type NewsletterNewsletterModeleModel = {
  __typename?: 'NewsletterNewsletterModeleModel';
  DefaultFooter?: string;
  Id?: number;
  IsSpecifique?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  UncEnteteModele?: string;
  UrlEnteteModele?: string;
};

export type NewsletterNewsletterModeleModelInput = {
  DefaultFooter?: string;
  Id?: number;
  IsSpecifique?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  UncEnteteModele?: string;
  UrlEnteteModele?: string;
};

export type NewsletterNewsletterThemeModel = {
  __typename?: 'NewsletterNewsletterThemeModel';
  Description?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type NewsletterNewsletterThemeModelInput = {
  Description?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export enum NiveauxAfpaEnum {
  Activite = 'Activite',
  Article = 'Article',
  Aucun = 'Aucun',
  Famille = 'Famille',
  Produit = 'Produit'
}

export type NotificationVup = {
  __typename?: 'NotificationVUP';
  Code?: string;
  CodeCategorie?: string;
  Id?: number;
  IdCategorie?: number;
  IsChecked?: boolean;
  Libelle?: string;
  LibelleCategorie?: string;
  Ordre?: number;
  OrdreCategorie?: number;
};

export type NotificationVupInput = {
  Code?: string;
  CodeCategorie?: string;
  Id?: number;
  IdCategorie?: number;
  IsChecked?: boolean;
  Libelle?: string;
  LibelleCategorie?: string;
  Ordre?: number;
  OrdreCategorie?: number;
};

export type NumeroChoixModelDto = {
  __typename?: 'NumeroChoixModelDTO';
  IdCommandeConcernee?: number;
  IdCommandeEnCours?: number;
  LibelleCMD?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Numero?: number;
  Status?: StatusDtoEnum;
};

export type NumeroChoixModelDtoInput = {
  IdCommandeConcernee?: number;
  IdCommandeEnCours?: number;
  LibelleCMD?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Numero?: number;
  Status?: StatusDtoEnum;
};

export type ObservableCollectionDtoOfLigneRemiseEnCaisseForValidationFiduModelWfN5Koph = {
  __typename?: 'ObservableCollectionDTOOfLigneRemiseEnCaisseForValidationFiduModelWfN5Koph';
  LigneRemiseEnCaisseForValidationFiduModel?: Array<LigneRemiseEnCaisseForValidationFiduModel>;
};

export type ObservableCollectionDtoOfLigneRemiseEnCaisseForValidationFiduModelWfN5KophInput = {
  LigneRemiseEnCaisseForValidationFiduModel?: Array<LigneRemiseEnCaisseForValidationFiduModelInput>;
};

export type ObservableCollectionDtoOfLigneRemiseEnCaisseForValidationNonFiduModelWfN5Koph = {
  __typename?: 'ObservableCollectionDTOOfLigneRemiseEnCaisseForValidationNonFiduModelWfN5Koph';
  LigneRemiseEnCaisseForValidationNonFiduModel?: Array<LigneRemiseEnCaisseForValidationNonFiduModel>;
};

export type ObservableCollectionDtoOfLigneRemiseEnCaisseForValidationNonFiduModelWfN5KophInput = {
  LigneRemiseEnCaisseForValidationNonFiduModel?: Array<LigneRemiseEnCaisseForValidationNonFiduModelInput>;
};

export type OdAdDto = {
  __typename?: 'OdAdDTO';
  BenefAyantDroit?: BenefDto;
  BenefOuvrantDroit?: BenefDto;
  DateCloture?: any;
  IsCloture?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantRattache?: boolean;
  IsPorteurDroit?: boolean;
  IsValide?: boolean;
  LastUserModif?: UsersDto;
  ListeRelation?: string;
  MotifCloture?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  PorteurDroit?: OdAdDto;
  Status?: StatusDtoEnum;
  TypeBeneficiare?: TypeBenefDto;
};

export type OdAdDtoInput = {
  BenefAyantDroit?: BenefDtoInput;
  BenefOuvrantDroit?: BenefDtoInput;
  DateCloture?: any;
  IsCloture?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantRattache?: boolean;
  IsPorteurDroit?: boolean;
  IsValide?: boolean;
  LastUserModif?: UsersDtoInput;
  ListeRelation?: string;
  MotifCloture?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  PorteurDroit?: OdAdDtoInput;
  Status?: StatusDtoEnum;
  TypeBeneficiare?: TypeBenefDtoInput;
};

export type OptionsCreationCompteModelInput = {
  TailleCode?: number;
  TailleNumero?: number;
};

export type OptionsImportMediaInput = {
  CreerExemplaireMediaExistant?: boolean;
  CreerExemplaireNouveauMedia?: boolean;
  IdFamilleCible?: number;
  IdStockExemplaire?: number;
  RemplacerCouverture?: boolean;
  RemplacerInformations?: boolean;
};

export type OptionsInitialisationModuleGestionSkinsModel = {
  __typename?: 'OptionsInitialisationModuleGestionSkinsModel';
  CurrentOptions?: PortailOptionsDto;
  CurrentSkin?: PortailSkinDto;
  ListeSkins?: ArrayOfPortailSkinDto;
};

export type OptionsInitialisationModuleGestionSkinsModelInput = {
  CurrentOptions?: PortailOptionsDtoInput;
  CurrentSkin?: PortailSkinDtoInput;
  ListeSkins?: ArrayOfPortailSkinDtoInput;
};

export type OptionsVignettesOptionsModel = {
  __typename?: 'OptionsVignettesOptionsModel';
  CategCode?: string;
  Categorie?: string;
  Extension?: string;
  FileBytes?: string;
  IdFile?: number;
  IsFichierClient?: boolean;
  Libelle?: string;
  LibelleLien?: string;
  RacineUrl?: string;
  RemarqueLien?: string;
  Taille?: number;
  Token?: string;
  TypeFichierLibelle?: string;
  Url?: string;
};

export type OptionsVignettesOptionsModelInput = {
  CategCode?: string;
  Categorie?: string;
  Extension?: string;
  FileBytes?: string;
  IdFile?: number;
  IsFichierClient?: boolean;
  Libelle?: string;
  LibelleLien?: string;
  RacineUrl?: string;
  RemarqueLien?: string;
  Taille?: number;
  Token?: string;
  TypeFichierLibelle?: string;
  Url?: string;
};

export type OrganisationBaseModel = {
  __typename?: 'OrganisationBaseModel';
  IdOrganisation?: number;
  NomOrganisation?: string;
};

export type OrganisationBaseModelInput = {
  IdOrganisation?: number;
  NomOrganisation?: string;
};

export type OrganisationDto = {
  __typename?: 'OrganisationDTO';
  Adresse?: AdresseDto;
  CEDelegation?: CeDelegationDto;
  Code?: string;
  CodeANA?: string;
  CodeClient?: string;
  Email?: string;
  Fax?: string;
  Id?: number;
  IsCloture?: boolean;
  ListeOrganisationFils?: ArrayOfOrganisationDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  OrgaParente?: OrganisationDto;
  Status?: StatusDtoEnum;
  Telephone?: string;
};

export type OrganisationDtoInput = {
  Adresse?: AdresseDtoInput;
  CEDelegation?: CeDelegationDtoInput;
  Code?: string;
  CodeANA?: string;
  CodeClient?: string;
  Email?: string;
  Fax?: string;
  Id?: number;
  IsCloture?: boolean;
  ListeOrganisationFils?: ArrayOfOrganisationDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  OrgaParente?: OrganisationDtoInput;
  Status?: StatusDtoEnum;
  Telephone?: string;
};

export type OrigineCommandeDto = {
  __typename?: 'OrigineCommandeDTO';
  Code?: string;
  Id?: number;
  IsOriginePossibleClient?: boolean;
  IsOriginePossibleFournisseur?: string;
  Libelle?: string;
  ListeDevisCommande?: ArrayOfDevisCommandeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type OrigineCommandeDtoInput = {
  Code?: string;
  Id?: number;
  IsOriginePossibleClient?: boolean;
  IsOriginePossibleFournisseur?: string;
  Libelle?: string;
  ListeDevisCommande?: ArrayOfDevisCommandeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PjBaseModel = {
  __typename?: 'PJBaseModel';
  IdPJ?: number;
  LibellePJ?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PjBaseModelInput = {
  IdPJ?: number;
  LibellePJ?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PjCompletModel = {
  __typename?: 'PJCompletModel';
  AnalysableIA?: boolean;
  AnneeReferenceDoki?: number;
  AnneeReferenceId?: number;
  CodePJ?: string;
  Description?: string;
  DokiDateDebutValidite?: any;
  DokiDateFinValidite?: any;
  IdPJ?: number;
  IdTypePJ?: number;
  IsCloture?: boolean;
  IsObligatoireGlobal?: boolean;
  IsPJBenef?: boolean;
  IsUtilise?: boolean;
  LibellePJ?: string;
  LibelleTypePJ?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAnalyseIaId?: number;
};

export type PjCompletModelInput = {
  AnalysableIA?: boolean;
  AnneeReferenceDoki?: number;
  AnneeReferenceId?: number;
  CodePJ?: string;
  Description?: string;
  DokiDateDebutValidite?: any;
  DokiDateFinValidite?: any;
  IdPJ?: number;
  IdTypePJ?: number;
  IsCloture?: boolean;
  IsObligatoireGlobal?: boolean;
  IsPJBenef?: boolean;
  IsUtilise?: boolean;
  LibellePJ?: string;
  LibelleTypePJ?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeAnalyseIaId?: number;
};

export type ParamCommissionModel = {
  __typename?: 'ParamCommissionModel';
  CodeCommission?: string;
  DescriptionCommission?: string;
  EMail?: string;
  IdCommission?: number;
  IdDelegation?: number;
  IsClos?: boolean;
  LibelleCommission?: string;
  ListeIdUsersCommission?: ArrayOfdecimal;
};

export type ParamCommissionModelInput = {
  CodeCommission?: string;
  DescriptionCommission?: string;
  EMail?: string;
  IdCommission?: number;
  IdDelegation?: number;
  IsClos?: boolean;
  LibelleCommission?: string;
  ListeIdUsersCommission?: ArrayOfdecimalInput;
};

export type ParamCotisationArticleModel = {
  __typename?: 'ParamCotisationArticleModel';
  ArticleInformationsModel?: ArticleInformationsBaseModel;
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  CotisationParam?: CotisationArticleParamCotisationModel;
  IdElement?: number;
  Illustration?: FichierModel;
  ImputationComptable?: Union_15979101523990191512;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamCotisationArticleModelInput = {
  ArticleInformationsModel?: ArticleInformationsBaseModelInput;
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  CotisationParam?: CotisationArticleParamCotisationModelInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ImputationComptable?: ImputationComptableEditerImputationFpaInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamCotisationFamilleModel = {
  __typename?: 'ParamCotisationFamilleModel';
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  FamilleInformationsModel?: FamilleInformationsBaseModel;
  IdElement?: number;
  Illustration?: FichierModel;
  ImputationComptable?: Union_15979101523990191512;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamCotisationFamilleModelInput = {
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  FamilleInformationsModel?: FamilleInformationsBaseModelInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ImputationComptable?: ImputationComptableEditerImputationFpaInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamCotisationProduitModel = {
  __typename?: 'ParamCotisationProduitModel';
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  IdElement?: number;
  Illustration?: FichierModel;
  ImputationComptable?: Union_15979101523990191512;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  ProduitInformationsModel?: CotisationInformationsProduitModel;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamCotisationProduitModelInput = {
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ImputationComptable?: ImputationComptableEditerImputationFpaInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  ProduitInformationsModel?: CotisationInformationsProduitModelInput;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamEcheancierModelDto = {
  __typename?: 'ParamEcheancierModelDTO';
  Echeancier?: EcheancierModelDto;
  ListeCompteBancaire?: ArrayOfCompteBancaireModelDto;
  ListeFactures?: ArrayOfFactureEcheancierModelDto;
  ListeRib?: ArrayOfRibModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ParamEcheancierModelDtoInput = {
  Echeancier?: EcheancierModelDtoInput;
  ListeCompteBancaire?: ArrayOfCompteBancaireModelDtoInput;
  ListeFactures?: ArrayOfFactureEcheancierModelDtoInput;
  ListeRib?: ArrayOfRibModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ParamEditionDossierPrestationModelDto = {
  __typename?: 'ParamEditionDossierPrestationModelDTO';
  DossierPrestation?: DossierPrestationModelDto;
  IdDerniereLigneDossierPrestationManipulee?: number;
  ListeBenef?: ArrayOfBenefComboModel;
  ListeFormule?: ArrayOfFormulePrestationModelDto;
  ListeLignesDossierPrestation?: ArrayOfLigneDossierPrestationModelDto;
  ListePrestation?: ArrayOfPrestationModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ParamEditionDossierPrestationModelDtoInput = {
  DossierPrestation?: DossierPrestationModelDtoInput;
  IdDerniereLigneDossierPrestationManipulee?: number;
  ListeBenef?: ArrayOfBenefComboModelInput;
  ListeFormule?: ArrayOfFormulePrestationModelDtoInput;
  ListeLignesDossierPrestation?: ArrayOfLigneDossierPrestationModelDtoInput;
  ListePrestation?: ArrayOfPrestationModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ParamGroupesArticleModel = {
  __typename?: 'ParamGroupesArticleModel';
  ArticleInformationsModel?: GroupesInformationsArticleModel;
  ArticleVenteEnLigneModel?: Union_238092739497534820;
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  FraisAnnulation?: FraisAnnulationFpaModel;
  IdElement?: number;
  Illustration?: FichierModel;
  ImputationComptable?: Union_15979101523990191512;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ListeModeleEcheancier?: ArrayOfModeleEcheancierFpaModel;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementFpaModel;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixArticle?: PrixArticleModel;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamGroupesArticleModelInput = {
  ArticleInformationsModel?: GroupesInformationsArticleModelInput;
  ArticleVenteEnLigneModel?: FpaVenteEnLigneBaseModelInput;
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  FraisAnnulation?: FraisAnnulationFpaModelInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ImputationComptable?: ImputationComptableEditerImputationFpaInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ListeModeleEcheancier?: ArrayOfModeleEcheancierFpaModelInput;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementFpaModelInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixArticle?: PrixArticleModelInput;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamGroupesFamilleModel = {
  __typename?: 'ParamGroupesFamilleModel';
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  FamilleInformationsModel?: GroupesInformationsFamilleModel;
  FamilleVenteEnLigneModel?: GroupeVenteEnLigneFamProduitModel;
  FraisAnnulation?: FraisAnnulationFpaModel;
  IdElement?: number;
  Illustration?: FichierModel;
  ImputationComptable?: Union_15979101523990191512;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ModalitesReglement?: ModalitesReglementFpaModel;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamGroupesFamilleModelInput = {
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  FamilleInformationsModel?: GroupesInformationsFamilleModelInput;
  FamilleVenteEnLigneModel?: GroupeVenteEnLigneFamProduitModelInput;
  FraisAnnulation?: FraisAnnulationFpaModelInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ImputationComptable?: ImputationComptableEditerImputationFpaInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ModalitesReglement?: ModalitesReglementFpaModelInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamGroupesProduitModel = {
  __typename?: 'ParamGroupesProduitModel';
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  FraisAnnulation?: FraisAnnulationFpaModel;
  IdElement?: number;
  Illustration?: FichierModel;
  ImputationComptable?: Union_15979101523990191512;
  ListeBlocDescription?: ArrayOfEditerBlocDescriptionModel;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ListeDocuments?: ArrayOfFichierModel;
  ModalitesReglement?: ModalitesReglementFpaModel;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  ProduitInformationsModel?: GroupesInformationsProduitModel;
  ProduitVenteEnLigneModel?: GroupeVenteEnLigneFamProduitModel;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamGroupesProduitModelInput = {
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  FraisAnnulation?: FraisAnnulationFpaModelInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ImputationComptable?: ImputationComptableEditerImputationFpaInput;
  ListeBlocDescription?: ArrayOfEditerBlocDescriptionModelInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ListeDocuments?: ArrayOfFichierModelInput;
  ModalitesReglement?: ModalitesReglementFpaModelInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  ProduitInformationsModel?: GroupesInformationsProduitModelInput;
  ProduitVenteEnLigneModel?: GroupeVenteEnLigneFamProduitModelInput;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamLocationArticleModel = {
  __typename?: 'ParamLocationArticleModel';
  ArticleInformationsModel?: LocationInformationsArticleModel;
  ArticleVenteEnLigneModel?: Union_238092739497534820;
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  FraisAnnulation?: FraisAnnulationFpaModel;
  IdElement?: number;
  Illustration?: FichierModel;
  ImputationComptable?: Union_15979101523990191512;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixArticle?: PrixArticleModel;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamLocationArticleModelInput = {
  ArticleInformationsModel?: LocationInformationsArticleModelInput;
  ArticleVenteEnLigneModel?: FpaVenteEnLigneBaseModelInput;
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  FraisAnnulation?: FraisAnnulationFpaModelInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ImputationComptable?: ImputationComptableEditerImputationFpaInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixArticle?: PrixArticleModelInput;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamLocationFamilleModel = {
  __typename?: 'ParamLocationFamilleModel';
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  FamilleInformationsModel?: LocationInformationsFamilleModel;
  FamilleVenteEnLigneModel?: FpaVenteEnLigneWithAcompteModel;
  FraisAnnulation?: FraisAnnulationFpaModel;
  IdElement?: number;
  Illustration?: FichierModel;
  ImputationComptable?: Union_15979101523990191512;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ModalitesReglement?: ModalitesReglementFpaModel;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamLocationFamilleModelInput = {
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  FamilleInformationsModel?: LocationInformationsFamilleModelInput;
  FamilleVenteEnLigneModel?: FpaVenteEnLigneWithAcompteModelInput;
  FraisAnnulation?: FraisAnnulationFpaModelInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ImputationComptable?: ImputationComptableEditerImputationFpaInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ModalitesReglement?: ModalitesReglementFpaModelInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamLocationProduitModel = {
  __typename?: 'ParamLocationProduitModel';
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  FraisAnnulation?: FraisAnnulationFpaModel;
  IdElement?: number;
  Illustration?: FichierModel;
  ImputationComptable?: Union_15979101523990191512;
  ListeBlocDescription?: ArrayOfEditerBlocDescriptionModel;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ListeDocuments?: ArrayOfFichierModel;
  ModalitesReglement?: ModalitesReglementFpaModel;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  ProduitInformationsModel?: LocationInformationsProduitModel;
  ProduitVenteEnLigneModel?: LocationVenteEnLigneProduitModel;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamLocationProduitModelInput = {
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  FraisAnnulation?: FraisAnnulationFpaModelInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ImputationComptable?: ImputationComptableEditerImputationFpaInput;
  ListeBlocDescription?: ArrayOfEditerBlocDescriptionModelInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ListeDocuments?: ArrayOfFichierModelInput;
  ModalitesReglement?: ModalitesReglementFpaModelInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  ProduitInformationsModel?: LocationInformationsProduitModelInput;
  ProduitVenteEnLigneModel?: LocationVenteEnLigneProduitModelInput;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamMediathequeCatalogueModel = {
  __typename?: 'ParamMediathequeCatalogueModel';
  CatalogueEmpruntReservationModel?: MediathequeEmpruntReservationFamilleModel;
  CatalogueFicheMediaModel?: Union_7257672451169240978;
  CatalogueInfosReservationEnLigne?: MediathequeReservationEnLigneFamilleModel;
  CatalogueListeExemplairesMediaModel?: ArrayOfMediathequeExemplaireCatalogueMediaModel;
  ModeleSaveReglesAFPA?: ModeleSaveReglesAfpadto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ParamMediathequeCatalogueModelInput = {
  CatalogueEmpruntReservationModel?: MediathequeEmpruntReservationFamilleModelInput;
  CatalogueFicheMediaModel?: FicheMediaMediathequeModelInput;
  CatalogueInfosReservationEnLigne?: MediathequeReservationEnLigneFamilleModelInput;
  CatalogueListeExemplairesMediaModel?: ArrayOfMediathequeExemplaireCatalogueMediaModelInput;
  ModeleSaveReglesAFPA?: ModeleSaveReglesAfpadtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ParamMediathequeFamilleModel = {
  __typename?: 'ParamMediathequeFamilleModel';
  FamilleEmpruntReservationModel?: MediathequeEmpruntReservationFamilleModel;
  FamilleInformationsModel?: MediathequeInformationsFamilleModel;
  InfosReservationEnLigne?: MediathequeReservationEnLigneFamilleModel;
  ModeleSaveReglesAFPA?: ModeleSaveReglesAfpadto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ParamMediathequeFamilleModelInput = {
  FamilleEmpruntReservationModel?: MediathequeEmpruntReservationFamilleModelInput;
  FamilleInformationsModel?: MediathequeInformationsFamilleModelInput;
  InfosReservationEnLigne?: MediathequeReservationEnLigneFamilleModelInput;
  ModeleSaveReglesAFPA?: ModeleSaveReglesAfpadtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ParamModeleEchancierModel = {
  __typename?: 'ParamModeleEchancierModel';
  DelaiPremiereEcheance?: number;
  IdModeleEcheancier?: number;
  IsClos?: boolean;
  IsDeclenchementAvant?: boolean;
  JourDansMois?: number;
  Libelle?: string;
  MoisPremiereEcheance?: number;
  MontantMinimal?: number;
  MontantPremiereEcheance?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreEcheance?: number;
  NombreJoursDeclenchement?: number;
  Periodicite?: number;
  PourcentagePremiereEcheance?: number;
  Status?: StatusDtoEnum;
};

export type ParamModeleEchancierModelInput = {
  DelaiPremiereEcheance?: number;
  IdModeleEcheancier?: number;
  IsClos?: boolean;
  IsDeclenchementAvant?: boolean;
  JourDansMois?: number;
  Libelle?: string;
  MoisPremiereEcheance?: number;
  MontantMinimal?: number;
  MontantPremiereEcheance?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreEcheance?: number;
  NombreJoursDeclenchement?: number;
  Periodicite?: number;
  PourcentagePremiereEcheance?: number;
  Status?: StatusDtoEnum;
};

export type ParamPrestationArticleModel = {
  __typename?: 'ParamPrestationArticleModel';
  ArticleInformationsModel?: PrestationInformationsArticleModel;
  ArticleRemboursementModel?: PrestationRemboursementArticleModel;
  ArticleVenteEnLigneModel?: Union_238092739497534820;
  Cadeau?: CadeauAfpaModel;
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  IdElement?: number;
  Illustration?: FichierModel;
  ImputationComptable?: Union_15979101523990191512;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ListePieceJustificativeModel?: ArrayOfPrestationPjArticleModel;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  ProduitHasPrestationCadeau?: boolean;
  ProduitHasPrestationRmbOrPAC?: boolean;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamPrestationArticleModelInput = {
  ArticleInformationsModel?: PrestationInformationsArticleModelInput;
  ArticleRemboursementModel?: PrestationRemboursementArticleModelInput;
  ArticleVenteEnLigneModel?: FpaVenteEnLigneBaseModelInput;
  Cadeau?: CadeauAfpaModelInput;
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ImputationComptable?: ImputationComptableEditerImputationFpaInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ListePieceJustificativeModel?: ArrayOfPrestationPjArticleModelInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  ProduitHasPrestationCadeau?: boolean;
  ProduitHasPrestationRmbOrPAC?: boolean;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamPrestationFamilleModel = {
  __typename?: 'ParamPrestationFamilleModel';
  Cadeau?: CadeauAfpaModel;
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  FamilleInformationsModel?: FamilleInformationsBaseModel;
  FamilleVenteEnLigneModel?: Union_21781205322457394155;
  IdElement?: number;
  Illustration?: FichierModel;
  ImputationComptable?: Union_15979101523990191512;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  ParametragePrestation?: ParametragePrestationModel;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamPrestationFamilleModelInput = {
  Cadeau?: CadeauAfpaModelInput;
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  FamilleInformationsModel?: FamilleInformationsBaseModelInput;
  FamilleVenteEnLigneModel?: PrestationFamilleVenteEnLigneModelInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ImputationComptable?: ImputationComptableEditerImputationFpaInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  ParametragePrestation?: ParametragePrestationModelInput;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamPrestationProduitModel = {
  __typename?: 'ParamPrestationProduitModel';
  Cadeau?: CadeauAfpaModel;
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  IdElement?: number;
  Illustration?: FichierModel;
  ImputationComptable?: Union_15979101523990191512;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  ParametragePrestation?: ParametragePrestationModel;
  ProduitInformationsModel?: ProduitInformationBaseModel;
  ProduitVenteEnLigneModel?: PrestationProduitVenteEnLigneModel;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamPrestationProduitModelInput = {
  Cadeau?: CadeauAfpaModelInput;
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ImputationComptable?: ImputationComptableEditerImputationFpaInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  ParametragePrestation?: ParametragePrestationModelInput;
  ProduitInformationsModel?: ProduitInformationBaseModelInput;
  ProduitVenteEnLigneModel?: PrestationProduitVenteEnLigneModelInput;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamPretsEtDonsArticleModel = {
  __typename?: 'ParamPretsEtDonsArticleModel';
  ArticleDescriptionModel?: RessourceDescriptionModel;
  ArticleImputationComptableModel?: PretsEtDonsImputationComptableModel;
  ArticleInformationsModel?: PretsEtDonsInformationsArticleModel;
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  IdElement?: number;
  Illustration?: FichierModel;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ListePieceJustificativeModel?: ArrayOfLibTypePjBaseModel;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  ModeleSaveReglesAFPA?: ModeleSaveReglesAfpadto;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamPretsEtDonsArticleModelInput = {
  ArticleDescriptionModel?: RessourceDescriptionModelInput;
  ArticleImputationComptableModel?: PretsEtDonsImputationComptableModelInput;
  ArticleInformationsModel?: PretsEtDonsInformationsArticleModelInput;
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ListePieceJustificativeModel?: ArrayOfLibTypePjBaseModelInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  ModeleSaveReglesAFPA?: ModeleSaveReglesAfpadtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamPretsEtDonsFamilleModel = {
  __typename?: 'ParamPretsEtDonsFamilleModel';
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  FamilleImputationComptableModel?: PretsEtDonsImputationComptableModel;
  FamilleInformationsModel?: FamilleInformationsBaseModel;
  IdElement?: number;
  Illustration?: FichierModel;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  ModeleSaveReglesAFPA?: ModeleSaveReglesAfpadto;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamPretsEtDonsFamilleModelInput = {
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  FamilleImputationComptableModel?: PretsEtDonsImputationComptableModelInput;
  FamilleInformationsModel?: FamilleInformationsBaseModelInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  ModeleSaveReglesAFPA?: ModeleSaveReglesAfpadtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamPretsEtDonsProduitModel = {
  __typename?: 'ParamPretsEtDonsProduitModel';
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  IdElement?: number;
  Illustration?: FichierModel;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  ModeleSaveReglesAFPA?: ModeleSaveReglesAfpadto;
  MustValidate?: boolean;
  MyGuid?: string;
  ProduitDescriptionModel?: RessourceDescriptionModel;
  ProduitImputationComptableModel?: PretsEtDonsImputationComptableModel;
  ProduitInformationsModel?: PretsEtDonsInformationsProduitModel;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamPretsEtDonsProduitModelInput = {
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  ModeleSaveReglesAFPA?: ModeleSaveReglesAfpadtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  ProduitDescriptionModel?: RessourceDescriptionModelInput;
  ProduitImputationComptableModel?: PretsEtDonsImputationComptableModelInput;
  ProduitInformationsModel?: PretsEtDonsInformationsProduitModelInput;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamReqSpecifDto = {
  __typename?: 'ParamReqSpecifDTO';
  ChoixItem?: ChoixItemDto;
  Code?: string;
  CodeSQL?: string;
  Description?: string;
  EstNull?: boolean;
  Id?: number;
  IdBenefComboBenef?: number;
  IsBigList?: boolean;
  IsComboBoxBenef?: boolean;
  IsMultiSelec?: boolean;
  Libelle?: string;
  ListChoixItem?: ArrayOfChoixItemDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  ReqSpecif?: ReqSpecifDto;
  SqlListVal?: string;
  Status?: StatusDtoEnum;
  TypeData?: ChampTypeDonneeDto;
  Valeur?: string;
  ValeurBoolean?: boolean;
};

export type ParamReqSpecifDtoInput = {
  ChoixItem?: ChoixItemDtoInput;
  Code?: string;
  CodeSQL?: string;
  Description?: string;
  EstNull?: boolean;
  Id?: number;
  IdBenefComboBenef?: number;
  IsBigList?: boolean;
  IsComboBoxBenef?: boolean;
  IsMultiSelec?: boolean;
  Libelle?: string;
  ListChoixItem?: ArrayOfChoixItemDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  ReqSpecif?: ReqSpecifDtoInput;
  SqlListVal?: string;
  Status?: StatusDtoEnum;
  TypeData?: ChampTypeDonneeDtoInput;
  Valeur?: string;
  ValeurBoolean?: boolean;
};

export type ParamRessourceModel = {
  __typename?: 'ParamRessourceModel';
  CatalogueInfosReservationEnLigne?: MediathequeReservationEnLigneFamilleModel;
  ComptabiliteRessourceModel?: RessourceComptabiliteModel;
  DescriptionRessource?: RessourceDescriptionModel;
  EmpruntReservationRessourceModel?: MediathequeEmpruntReservationFamilleModel;
  InformationsRessourceModel?: RessourceInformationsModel;
  ListeExemplaireRessourceModel?: ArrayOfMediathequeExemplaireCatalogueMediaModel;
  ModeleSaveReglesAFPA?: ModeleSaveReglesAfpadto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ParamRessourceModelInput = {
  CatalogueInfosReservationEnLigne?: MediathequeReservationEnLigneFamilleModelInput;
  ComptabiliteRessourceModel?: RessourceComptabiliteModelInput;
  DescriptionRessource?: RessourceDescriptionModelInput;
  EmpruntReservationRessourceModel?: MediathequeEmpruntReservationFamilleModelInput;
  InformationsRessourceModel?: RessourceInformationsModelInput;
  ListeExemplaireRessourceModel?: ArrayOfMediathequeExemplaireCatalogueMediaModelInput;
  ModeleSaveReglesAFPA?: ModeleSaveReglesAfpadtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ParamRessourcePartageeFpaModel = {
  __typename?: 'ParamRessourcePartageeFpaModel';
  ComptabiliteRessource?: RessourceComptabiliteModel;
  FamilleEmpruntReservationModel?: MediathequeEmpruntReservationFamilleModel;
  FamilleInformationsModel?: MediathequeInformationsFamilleModel;
  InfosReservationEnLigne?: MediathequeReservationEnLigneFamilleModel;
  ModeleSaveReglesAFPA?: ModeleSaveReglesAfpadto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ParamRessourcePartageeFpaModelInput = {
  ComptabiliteRessource?: RessourceComptabiliteModelInput;
  FamilleEmpruntReservationModel?: MediathequeEmpruntReservationFamilleModelInput;
  FamilleInformationsModel?: MediathequeInformationsFamilleModelInput;
  InfosReservationEnLigne?: MediathequeReservationEnLigneFamilleModelInput;
  ModeleSaveReglesAFPA?: ModeleSaveReglesAfpadtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ParamStatutPersoModel = {
  __typename?: 'ParamStatutPersoModel';
  ListeDeclencheur?: ArrayOfStatutPersoActionModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StatutPersoModel?: StatutPersoParamModel;
};

export type ParamStatutPersoModelInput = {
  ListeDeclencheur?: ArrayOfStatutPersoActionModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StatutPersoModel?: StatutPersoParamModelInput;
};

export type ParamSyncModelDto = {
  __typename?: 'ParamSyncModelDTO';
  CodeASP?: string;
  CodeBusinessCanalCE?: string;
  CodePropagation?: string;
  IsEnvironnementDev?: boolean;
  IsMultiDeleg?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  SynchroBenef?: boolean;
  SynchroBenefPartielle?: boolean;
  SynchroSubventions?: boolean;
};

export type ParamSyncModelDtoInput = {
  CodeASP?: string;
  CodeBusinessCanalCE?: string;
  CodePropagation?: string;
  IsEnvironnementDev?: boolean;
  IsMultiDeleg?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  SynchroBenef?: boolean;
  SynchroBenefPartielle?: boolean;
  SynchroSubventions?: boolean;
};

export type ParamUsersListeUsersModelDto = {
  __typename?: 'ParamUsersListeUsersModelDTO';
  ListeCE?: ArrayOfCeDelegationDto;
  ListeCaisse?: ArrayOfCaisseDto;
  ListeCommissions?: ArrayOfCommissionDto;
  ListePV?: ArrayOfPointVenteDto;
  ListeProfils?: ArrayOfProfilDroitDto;
  ListeStock?: ArrayOfStockDto;
  ListeUsers?: ArrayOfUsersDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ParamUsersListeUsersModelDtoInput = {
  ListeCE?: ArrayOfCeDelegationDtoInput;
  ListeCaisse?: ArrayOfCaisseDtoInput;
  ListeCommissions?: ArrayOfCommissionDtoInput;
  ListePV?: ArrayOfPointVenteDtoInput;
  ListeProfils?: ArrayOfProfilDroitDtoInput;
  ListeStock?: ArrayOfStockDtoInput;
  ListeUsers?: ArrayOfUsersDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ParamVentesChequesArticleModel = {
  __typename?: 'ParamVentesChequesArticleModel';
  ArticleInformationsModel?: VentesChequesInformationsArticleModel;
  ArticleVenteEnLigneModel?: VentesChequesVenteEnLigneArticleModel;
  ChequierANCV?: EditChequierAncv;
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  IdElement?: number;
  Illustration?: FichierModel;
  ImputationComptable?: Union_15979101523990191512;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixArticle?: PrixArticleModel;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamVentesChequesArticleModelInput = {
  ArticleInformationsModel?: VentesChequesInformationsArticleModelInput;
  ArticleVenteEnLigneModel?: VentesChequesVenteEnLigneArticleModelInput;
  ChequierANCV?: EditChequierAncvInput;
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ImputationComptable?: ImputationComptableEditerImputationFpaInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixArticle?: PrixArticleModelInput;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamVentesChequesFamilleModel = {
  __typename?: 'ParamVentesChequesFamilleModel';
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  FamilleInformationsModel?: VentesChequesInformationsFamilleModel;
  FamilleVenteEnLigneModel?: VentesChequesVenteEnLigneFamilleProduitModel;
  IdElement?: number;
  Illustration?: FichierModel;
  ImputationComptable?: Union_15979101523990191512;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamVentesChequesFamilleModelInput = {
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  FamilleInformationsModel?: VentesChequesInformationsFamilleModelInput;
  FamilleVenteEnLigneModel?: VentesChequesVenteEnLigneFamilleProduitModelInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ImputationComptable?: ImputationComptableEditerImputationFpaInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParamVentesChequesProduitModel = {
  __typename?: 'ParamVentesChequesProduitModel';
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpa;
  GestionStock?: ParametrageStockFpaModel;
  IdElement?: number;
  Illustration?: FichierModel;
  ImputationComptable?: Union_15979101523990191512;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpa;
  ModeleFormulaireFPA?: FormulaireFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  ProduitInformationsModel?: VentesChequesInformationsProduitModel;
  ProduitVenteEnLigneModel?: VentesChequesVenteEnLigneFamilleProduitModel;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModel;
  Status?: StatusDtoEnum;
};

export type ParamVentesChequesProduitModelInput = {
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  GestionStock?: ParametrageStockFpaModelInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ImputationComptable?: ImputationComptableEditerImputationFpaInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  ProduitInformationsModel?: VentesChequesInformationsProduitModelInput;
  ProduitVenteEnLigneModel?: VentesChequesVenteEnLigneFamilleProduitModelInput;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParametrageAfpaBaseModelInput = {
  CodeTypeActivite?: string;
  IdElement?: number;
  Illustration?: FichierModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Status?: StatusDtoEnum;
};

export type ParametrageActiviteModelDto = {
  __typename?: 'ParametrageActiviteModelDTO';
  IsCommissionsActive?: boolean;
  IsExisteCommandeInCurrentActivite?: boolean;
  IsExisteFamilleInCurrentActivite?: boolean;
  IsTVA?: boolean;
  ListActivites?: ArrayOfActiviteDto;
  ListCollectifAcompteClient?: ArrayOfCompteDto;
  ListCollectifAcompteFour?: ArrayOfCompteDto;
  ListCollectifClient?: ArrayOfCompteDto;
  ListCollectifFourniseur?: ArrayOfCompteDto;
  ListPlanSectionAnalytique?: ArrayOfPlanSectionAnalytiqueModelDto;
  ListeActiviteCompteBancaireModel?: ArrayOfActiviteCompteBancaireModelDto;
  ListeCommissions?: ArrayOfCommissionDto;
  ListeCompteBancaires?: ArrayOfCompteBancaireDto;
  ListeCptFraisCommun?: ArrayOfCompteDto;
  ListeJournaux?: ArrayOfJournalDto;
  ListeTypesActivite?: ArrayOfTypeActiviteDto;
  ListeValeursChampsRegleAccessibilite?: ArrayOfModeleRegleAccChpListValModeGuide;
  ModeleRegleAccessibilite?: any;
  ModeleRegleSubQuota?: any;
};

export type ParametrageActiviteModelDtoInput = {
  IsCommissionsActive?: boolean;
  IsExisteCommandeInCurrentActivite?: boolean;
  IsExisteFamilleInCurrentActivite?: boolean;
  IsTVA?: boolean;
  ListActivites?: ArrayOfActiviteDtoInput;
  ListCollectifAcompteClient?: ArrayOfCompteDtoInput;
  ListCollectifAcompteFour?: ArrayOfCompteDtoInput;
  ListCollectifClient?: ArrayOfCompteDtoInput;
  ListCollectifFourniseur?: ArrayOfCompteDtoInput;
  ListPlanSectionAnalytique?: ArrayOfPlanSectionAnalytiqueModelDtoInput;
  ListeActiviteCompteBancaireModel?: ArrayOfActiviteCompteBancaireModelDtoInput;
  ListeCommissions?: ArrayOfCommissionDtoInput;
  ListeCompteBancaires?: ArrayOfCompteBancaireDtoInput;
  ListeCptFraisCommun?: ArrayOfCompteDtoInput;
  ListeJournaux?: ArrayOfJournalDtoInput;
  ListeTypesActivite?: ArrayOfTypeActiviteDtoInput;
  ListeValeursChampsRegleAccessibilite?: ArrayOfModeleRegleAccChpListValModeGuideInput;
  ModeleRegleAccessibilite?: any;
  ModeleRegleSubQuota?: any;
};

export type ParametrageArticleBaseModelInput = {
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParametrageClotureExerciceModel = {
  __typename?: 'ParametrageClotureExerciceModel';
  CAPIdCompteFonctionnement?: number;
  CAPIdCompteSocial?: number;
  CAPIdJournalFonctionnement?: number;
  CAPIdJournalSocial?: number;
  CCAIdCompteFonctionnement?: number;
  CCAIdCompteSocial?: number;
  CCAIdJournalFonctionnement?: number;
  CCAIdJournalSocial?: number;
  CodeExercice?: string;
  IdCloture?: number;
  IdCompteResultatNegatifFonctionnement?: number;
  IdCompteResultatNegatifSocial?: number;
  IdCompteResultatPositifFonctionnement?: number;
  IdCompteResultatPositifSocial?: number;
  IdExercice?: number;
  IdUtilisateur?: number;
  IsCalculValoParPAMP?: boolean;
  IsValorisationStock?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  PARIdCompteFonctionnement?: number;
  PARIdCompteSocial?: number;
  PARIdJournalFonctionnement?: number;
  PARIdJournalSocial?: number;
  PCAIdCompteFonctionnement?: number;
  PCAIdCompteSocial?: number;
  PCAIdJournalFonctionnement?: number;
  PCAIdJournalSocial?: number;
  RANIdJournalFonctionnement?: number;
  RANIdJournalSocial?: number;
  STKIdJournalFonctionnement?: number;
  STKIdJournalSocial?: number;
  Status?: StatusDtoEnum;
  TypeGenerationMouvementTiers?: string;
};

export type ParametrageClotureExerciceModelInput = {
  CAPIdCompteFonctionnement?: number;
  CAPIdCompteSocial?: number;
  CAPIdJournalFonctionnement?: number;
  CAPIdJournalSocial?: number;
  CCAIdCompteFonctionnement?: number;
  CCAIdCompteSocial?: number;
  CCAIdJournalFonctionnement?: number;
  CCAIdJournalSocial?: number;
  CodeExercice?: string;
  IdCloture?: number;
  IdCompteResultatNegatifFonctionnement?: number;
  IdCompteResultatNegatifSocial?: number;
  IdCompteResultatPositifFonctionnement?: number;
  IdCompteResultatPositifSocial?: number;
  IdExercice?: number;
  IdUtilisateur?: number;
  IsCalculValoParPAMP?: boolean;
  IsValorisationStock?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  PARIdCompteFonctionnement?: number;
  PARIdCompteSocial?: number;
  PARIdJournalFonctionnement?: number;
  PARIdJournalSocial?: number;
  PCAIdCompteFonctionnement?: number;
  PCAIdCompteSocial?: number;
  PCAIdJournalFonctionnement?: number;
  PCAIdJournalSocial?: number;
  RANIdJournalFonctionnement?: number;
  RANIdJournalSocial?: number;
  STKIdJournalFonctionnement?: number;
  STKIdJournalSocial?: number;
  Status?: StatusDtoEnum;
  TypeGenerationMouvementTiers?: string;
};

export type ParametrageCompteBancaireModelDto = {
  __typename?: 'ParametrageCompteBancaireModelDTO';
  ListBanque?: ArrayOfBanqueDto;
  ListPlanSectionAnalytique?: ArrayOfPlanSectionAnalytiqueModelDto;
  ListSuiviTresorerie?: ArrayOfSuiviTresorerieModelDto;
};

export type ParametrageCompteBancaireModelDtoInput = {
  ListBanque?: ArrayOfBanqueDtoInput;
  ListPlanSectionAnalytique?: ArrayOfPlanSectionAnalytiqueModelDtoInput;
  ListSuiviTresorerie?: ArrayOfSuiviTresorerieModelDtoInput;
};

export type ParametrageFpaCodeUtiliseModel = {
  __typename?: 'ParametrageFPACodeUtiliseModel';
  CodeFPA?: string;
  Id?: number;
  LibelleActivite?: string;
  LibelleFPA?: string;
};

export type ParametrageFpaCodeUtiliseModelInput = {
  CodeFPA?: string;
  Id?: number;
  LibelleActivite?: string;
  LibelleFPA?: string;
};

export type ParametrageFamilleBaseModelInput = {
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParametragePrestationModel = {
  __typename?: 'ParametragePrestationModel';
  AnneeDebutRemboursement?: number;
  AnneeFinRemboursement?: number;
  IdElement?: number;
  IdEnveloppeKalidea?: number;
  IsCadeau?: boolean;
  IsCreditSurEnveloppeKalidea?: boolean;
  IsPartACharge?: boolean;
  IsRemboursement?: boolean;
  IsRemboursementMensuel?: boolean;
  IsSaisieChronologique?: boolean;
  IsSaisieObligatoireFournisseur?: boolean;
  ListeIdFournisseursConventionnes?: ArrayOfdecimal;
  MoisDebutRemboursement?: number;
  MoisFinRemboursement?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreFournisseursConventionnes?: boolean;
  RedescendreParametrage?: boolean;
  Status?: StatusDtoEnum;
  TypeDocumentPresente?: string;
};

export type ParametragePrestationModelInput = {
  AnneeDebutRemboursement?: number;
  AnneeFinRemboursement?: number;
  IdElement?: number;
  IdEnveloppeKalidea?: number;
  IsCadeau?: boolean;
  IsCreditSurEnveloppeKalidea?: boolean;
  IsPartACharge?: boolean;
  IsRemboursement?: boolean;
  IsRemboursementMensuel?: boolean;
  IsSaisieChronologique?: boolean;
  IsSaisieObligatoireFournisseur?: boolean;
  ListeIdFournisseursConventionnes?: ArrayOfdecimalInput;
  MoisDebutRemboursement?: number;
  MoisFinRemboursement?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreFournisseursConventionnes?: boolean;
  RedescendreParametrage?: boolean;
  Status?: StatusDtoEnum;
  TypeDocumentPresente?: string;
};

export type ParametrageProduitBaseModelInput = {
  CodeTypeActivite?: string;
  CompteursDePoints?: ListeCompteursPointsFpaInput;
  IdElement?: number;
  Illustration?: FichierModelInput;
  ListeChampsPersonnalises?: ArrayOfChampEditerChampPersoFpaInput;
  ModeleFormulaireFPA?: FormulaireFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreImage?: boolean;
  Regles?: ListesReglesAfpaModelInput;
  Status?: StatusDtoEnum;
};

export type ParametrageStockFpaModel = {
  __typename?: 'ParametrageStockFPAModel';
  DateReappro?: any;
  IdProduit?: number;
  IdTypeReappro?: number;
  IsGestionEnStock?: boolean;
  IsModificationGestionStockPossible?: boolean;
  IsProduitWithMvtStockSurArticle?: boolean;
  IsSurStockDisponible?: boolean;
  IsSurStockDisponibleAttente?: boolean;
  IsSurStockReel?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeFonctionnement?: string;
};

export type ParametrageStockFpaModelInput = {
  DateReappro?: any;
  IdProduit?: number;
  IdTypeReappro?: number;
  IsGestionEnStock?: boolean;
  IsModificationGestionStockPossible?: boolean;
  IsProduitWithMvtStockSurArticle?: boolean;
  IsSurStockDisponible?: boolean;
  IsSurStockDisponibleAttente?: boolean;
  IsSurStockReel?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeFonctionnement?: string;
};

export type ParametrageTvaModel = {
  __typename?: 'ParametrageTVAModel';
  CodeModele?: string;
  IdCptTVACollectee?: number;
  IdCptTVADeductible?: number;
  IdModele?: number;
  LibelleModele?: string;
  ListeCptAssocies?: ArrayOfCompteLightModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TauxModele?: number;
};

export type ParametrageTvaModelInput = {
  CodeModele?: string;
  IdCptTVACollectee?: number;
  IdCptTVADeductible?: number;
  IdModele?: number;
  LibelleModele?: string;
  ListeCptAssocies?: ArrayOfCompteLightModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TauxModele?: number;
};

export type ParametrageTvaSimpleModel = {
  __typename?: 'ParametrageTVASimpleModel';
  CodeModele?: string;
  IdCptTVACollectee?: number;
  IdCptTVADeductible?: number;
  IdModele?: number;
  LibelleModele?: string;
  TauxModele?: number;
};

export type ParametrageTvaSimpleModelInput = {
  CodeModele?: string;
  IdCptTVACollectee?: number;
  IdCptTVADeductible?: number;
  IdModele?: number;
  LibelleModele?: string;
  TauxModele?: number;
};

export type ParametreImpressionDto = {
  __typename?: 'ParametreImpressionDTO';
  CodeParametre?: string;
  IdParametre?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ValeurParametre?: string;
};

export type ParametreImpressionDtoInput = {
  CodeParametre?: string;
  IdParametre?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ValeurParametre?: string;
};

export type ParametreRechercheEnveloppeDtoInput = {
  CritereHeriteEnveloppe?: CriteresEnveloppeQuotaDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  WithEnvHerite?: boolean;
  WithEnvImp?: boolean;
};

export type ParametreRechercheRegleModelDtoInput = {
  CritereHeriteRegle?: CriteresMoteurRegleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  WithRegleAfaireHerite?: boolean;
  WithRegleHerite?: boolean;
  WithRegleLocale?: boolean;
  WithRegleUse?: boolean;
};

export type ParametreRegleAvanceeModelDto = {
  __typename?: 'ParametreRegleAvanceeModelDTO';
  Id?: number;
  IdCritere?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OccurenceMax?: number;
  OccurenceMin?: number;
  Status?: StatusDtoEnum;
};

export type ParametreRegleAvanceeModelDtoInput = {
  Id?: number;
  IdCritere?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OccurenceMax?: number;
  OccurenceMin?: number;
  Status?: StatusDtoEnum;
};

export type ParametreValeurDto = {
  __typename?: 'ParametreValeurDTO';
  Activite?: ActiviteDto;
  CeDelegation?: CeDelegationDto;
  ChampListeValeur?: ChampListeValeurDto;
  ChampParametre?: ChampDto;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: UsersDto;
  Valeur?: string;
};

export type ParametreValeurDtoInput = {
  Activite?: ActiviteDtoInput;
  CeDelegation?: CeDelegationDtoInput;
  ChampListeValeur?: ChampListeValeurDtoInput;
  ChampParametre?: ChampDtoInput;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: UsersDtoInput;
  Valeur?: string;
};

export type ParametresAppliDto = {
  __typename?: 'ParametresAppliDTO';
  Champ?: ChampDto;
  ChampListVal?: ChampListeValeurDto;
  Delegation?: CeDelegationDto;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: UsersDto;
  Valeur?: string;
};

export type ParametresAppliDtoInput = {
  Champ?: ChampDtoInput;
  ChampListVal?: ChampListeValeurDtoInput;
  Delegation?: CeDelegationDtoInput;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: UsersDtoInput;
  Valeur?: string;
};

export type ParametresCeInfos = {
  __typename?: 'ParametresCEInfos';
  ActiverLogsPerf?: string;
  CodeValidationClotureComptable?: string;
  ElasticSearchServerUrl?: string;
  EmailNoReplySender?: string;
  FileServerLogin?: string;
  FileServerPwd?: string;
  IdPartenairePrimoloisir?: string;
  KeyArte?: string;
  KeyPrimoloisir?: string;
  KibanaServerLogin?: string;
  KibanaServerPwd?: string;
  ListeEmailRapportRemonte?: string;
  MailChargeClientele?: string;
  MailChefProjet?: string;
  MailjetSender?: string;
  NomCEFranceBillet?: string;
  NombreBeneficiairesMax?: number;
  NombreLicencesUtilisateurGenerique?: number;
  NombreLicencesUtilisateurNomme?: number;
  PiwikLogin?: string;
  PiwikPassword?: string;
  PiwikSiteId?: string;
  PiwikUrlSite?: string;
  PoidsFichierMax?: number;
  PoidsImageMaxActuMobile?: number;
  PublipostageLimiteAvertissement?: number;
  PublipostageLimiteBlocage?: number;
  PublipostageLimiteBlocageCourrier?: number;
  URLFranceBillet?: string;
  URLPrimoloisir?: string;
  UrlArte?: string;
  UrlFaviconPortailCE?: string;
  UseMailingApi?: boolean;
  UtiliserEmailNoReplyCommeExpediteur?: string;
};

export type ParametresCeInfosInput = {
  ActiverLogsPerf?: string;
  CodeValidationClotureComptable?: string;
  ElasticSearchServerUrl?: string;
  EmailNoReplySender?: string;
  FileServerLogin?: string;
  FileServerPwd?: string;
  IdPartenairePrimoloisir?: string;
  KeyArte?: string;
  KeyPrimoloisir?: string;
  KibanaServerLogin?: string;
  KibanaServerPwd?: string;
  ListeEmailRapportRemonte?: string;
  MailChargeClientele?: string;
  MailChefProjet?: string;
  MailjetSender?: string;
  NomCEFranceBillet?: string;
  NombreBeneficiairesMax?: number;
  NombreLicencesUtilisateurGenerique?: number;
  NombreLicencesUtilisateurNomme?: number;
  PiwikLogin?: string;
  PiwikPassword?: string;
  PiwikSiteId?: string;
  PiwikUrlSite?: string;
  PoidsFichierMax?: number;
  PoidsImageMaxActuMobile?: number;
  PublipostageLimiteAvertissement?: number;
  PublipostageLimiteBlocage?: number;
  PublipostageLimiteBlocageCourrier?: number;
  URLFranceBillet?: string;
  URLPrimoloisir?: string;
  UrlArte?: string;
  UrlFaviconPortailCE?: string;
  UseMailingApi?: boolean;
  UtiliserEmailNoReplyCommeExpediteur?: string;
};

export type ParametresExecutionImportArticleInput = {
  Activites?: ArrayOfKeyValueOfdecimalNullableOfdecimalU6ho3BhdInput;
  DateTimeExec?: any;
  EmailRapport?: string;
  File?: FichierModelInput;
  UserId?: number;
  UserName?: string;
};

export type ParametresUserAppliModelDto = {
  __typename?: 'ParametresUserAppliModelDTO';
  CodeActivite?: string;
  CodeChamp?: string;
  CodeValeur?: string;
  IdActivite?: number;
  IdChamp?: number;
  IdValeur?: number;
  IsParametreCE?: boolean;
  IsParametreUser?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ParametresUserAppliModelDtoInput = {
  CodeActivite?: string;
  CodeChamp?: string;
  CodeValeur?: string;
  IdActivite?: number;
  IdChamp?: number;
  IdValeur?: number;
  IsParametreCE?: boolean;
  IsParametreUser?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ParticipantGroupeRoomingListInput = {
  CodeStatutLigne?: string;
  IdLigneCommande?: number;
  IdParticipant?: number;
  NomParticipant?: string;
  PrenomParticipant?: string;
};

export type PartsOdConjointDto = {
  __typename?: 'PartsODConjointDTO';
  CENbPart?: CeNbPartDto;
  ChampListeValeur?: ChampListeValeurDto;
  CsNbPart_Conjoint_PartAvecEnf?: number;
  CsNbPart_Conjoint_PartSansEnf?: number;
  CsNbPart_OD_PartAvecEnf?: number;
  CsNbPart_OD_PartSansEnf?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PartsOdConjointDtoInput = {
  CENbPart?: CeNbPartDtoInput;
  ChampListeValeur?: ChampListeValeurDtoInput;
  CsNbPart_Conjoint_PartAvecEnf?: number;
  CsNbPart_Conjoint_PartSansEnf?: number;
  CsNbPart_OD_PartAvecEnf?: number;
  CsNbPart_OD_PartSansEnf?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PathsCeInfos = {
  __typename?: 'PathsCEInfos';
  CodeTheme?: string;
  DailymotionUrl?: string;
  DirectoV2Url?: string;
  DirectoV21Url?: string;
  GestionUrlBase?: string;
  NomCE?: string;
  PortailProtocol?: string;
  Repertoires_Clients?: string;
  Repertoires_Uploads?: string;
  RessourceUrl?: string;
  SharedRootFolderPath?: string;
  YoutubeUrl?: string;
};

export type PathsCeInfosInput = {
  CodeTheme?: string;
  DailymotionUrl?: string;
  DirectoV2Url?: string;
  DirectoV21Url?: string;
  GestionUrlBase?: string;
  NomCE?: string;
  PortailProtocol?: string;
  Repertoires_Clients?: string;
  Repertoires_Uploads?: string;
  RessourceUrl?: string;
  SharedRootFolderPath?: string;
  YoutubeUrl?: string;
};

export type PaysDto = {
  __typename?: 'PaysDTO';
  Code?: string;
  Id?: number;
  IsCloture?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PaysDtoInput = {
  Code?: string;
  Id?: number;
  IsCloture?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export enum PeriodeEntreeSortieEnum {
  AnneeCourante = 'AnneeCourante',
  MoisCourant = 'MoisCourant',
  SemaineCourante = 'SemaineCourante'
}

export type PermDto = {
  __typename?: 'PermDTO';
  Desc?: string;
  Id?: number;
  IdcVisDirecto?: boolean;
  IsCloturer?: boolean;
  Libelle?: string;
  ListeActivites?: ArrayOfActiviteDto;
  ListeJourPerm?: ArrayOfPermJourDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Nbjr_Directo_Deb?: number;
  Nbjr_Directo_Fin?: number;
  Pointvente?: PointVenteDto;
  Site?: SiteDto;
  Status?: StatusDtoEnum;
};

export type PermDtoInput = {
  Desc?: string;
  Id?: number;
  IdcVisDirecto?: boolean;
  IsCloturer?: boolean;
  Libelle?: string;
  ListeActivites?: ArrayOfActiviteDtoInput;
  ListeJourPerm?: ArrayOfPermJourDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Nbjr_Directo_Deb?: number;
  Nbjr_Directo_Fin?: number;
  Pointvente?: PointVenteDtoInput;
  Site?: SiteDtoInput;
  Status?: StatusDtoEnum;
};

export type PermHeureDto = {
  __typename?: 'PermHeureDTO';
  HeureDeb?: any;
  HeureFin?: any;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  PermJour?: PermJourDto;
  Status?: StatusDtoEnum;
};

export type PermHeureDtoInput = {
  HeureDeb?: any;
  HeureFin?: any;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  PermJour?: PermJourDtoInput;
  Status?: StatusDtoEnum;
};

export type PermJourDto = {
  __typename?: 'PermJourDTO';
  MustValidate?: boolean;
  MyGuid?: string;
  Perm?: PermDto;
  PermHeure?: ArrayOfPermHeureDto;
  PermJourDate?: any;
  PermJourID?: number;
  Status?: StatusDtoEnum;
};

export type PermJourDtoInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  Perm?: PermDtoInput;
  PermHeure?: ArrayOfPermHeureDtoInput;
  PermJourDate?: any;
  PermJourID?: number;
  Status?: StatusDtoEnum;
};

export type PermanenceParamActiviteModel = {
  __typename?: 'PermanenceParamActiviteModel';
  IdPermanence?: number;
  LibellePermanence?: string;
  LibelleStock?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PermanenceParamActiviteModelInput = {
  IdPermanence?: number;
  LibellePermanence?: string;
  LibelleStock?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PermanenceParametrageJourModel = {
  __typename?: 'PermanenceParametrageJourModel';
  IdJour?: number;
  IdPermanence?: number;
  Jour?: any;
  ListeHeures?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PermanenceParametrageJourModelInput = {
  IdJour?: number;
  IdPermanence?: number;
  Jour?: any;
  ListeHeures?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PermanencePermanenceBaseModel = {
  __typename?: 'PermanencePermanenceBaseModel';
  IdPermanence?: number;
  Libelle?: string;
};

export type PermanencePermanenceBaseModelInput = {
  IdPermanence?: number;
  Libelle?: string;
};

export type PermanencePermanenceListeHeuresModel = {
  __typename?: 'PermanencePermanenceListeHeuresModel';
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PermanencePermanenceListeHeuresModelInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PermanencePermanenceModel = {
  __typename?: 'PermanencePermanenceModel';
  Description?: string;
  IdPermanence?: number;
  Libelle?: string;
  ListeJours?: ArrayOfPermanenceParametrageJourModel;
  MessagePortail?: string;
  StockId?: number;
};

export type PermanencePermanenceModelInput = {
  Description?: string;
  IdPermanence?: number;
  Libelle?: string;
  ListeJours?: ArrayOfPermanenceParametrageJourModelInput;
  MessagePortail?: string;
  StockId?: number;
};

export type PictoDto = {
  __typename?: 'PictoDTO';
  MustSavePicto?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  PictoBytesArray?: string;
  PictoFileName?: string;
  PictoFromUser?: boolean;
  PictoFullUrl?: string;
  Status?: StatusDtoEnum;
};

export type PictoDtoInput = {
  MustSavePicto?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  PictoBytesArray?: string;
  PictoFileName?: string;
  PictoFromUser?: boolean;
  PictoFullUrl?: string;
  Status?: StatusDtoEnum;
};

export type PieceJointeDto = {
  __typename?: 'PieceJointeDTO';
  CourrierLigneHistoEnvoi?: CourrierLigneHistoEnvoiDto;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Path?: string;
  Status?: StatusDtoEnum;
};

export type PieceJointeDtoInput = {
  CourrierLigneHistoEnvoi?: CourrierLigneHistoEnvoiDtoInput;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Path?: string;
  Status?: StatusDtoEnum;
};

export type PieceJointeModelDto = {
  __typename?: 'PieceJointeModelDTO';
  Libelle?: string;
  Lien?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PieceJointeModelDtoInput = {
  Libelle?: string;
  Lien?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PieceJustificativeBenefModel = {
  __typename?: 'PieceJustificativeBenefModel';
  CodePJ?: string;
  CodeTypePJ?: string;
  DateEnvoi?: any;
  DateReception?: any;
  DescriptionPJ?: string;
  Fichier?: FichierModel;
  IdAyantDroit?: number;
  IdBenef?: number;
  IdFormule?: number;
  IdPJBenef?: number;
  IdPJDossier?: number;
  IdPieceJustificative?: number;
  IdRib?: number;
  IsDeleted?: boolean;
  IsEnvoyee?: boolean;
  IsObligActivite?: boolean;
  IsPJBenef?: boolean;
  IsRecue?: boolean;
  IsUpdated?: boolean;
  IsValide?: boolean;
  LibTypePJ?: string;
  LibellePJ?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomFichier?: string;
  OrdreTypePJ?: number;
  PrenomBenefAD?: string;
  RemarquePriveePJ?: string;
  RemarquePublique?: string;
  RemarquePubliquePJ?: string;
  RibLibelle?: string;
  RibLibelleLight?: string;
  Status?: StatusDtoEnum;
  StatutPJEnum?: TypeStatutPieceJustificativeEnum;
};

export type PieceJustificativeBenefModelInput = {
  CodePJ?: string;
  CodeTypePJ?: string;
  DateEnvoi?: any;
  DateReception?: any;
  DescriptionPJ?: string;
  Fichier?: FichierModelInput;
  IdAyantDroit?: number;
  IdBenef?: number;
  IdFormule?: number;
  IdPJBenef?: number;
  IdPJDossier?: number;
  IdPieceJustificative?: number;
  IdRib?: number;
  IsDeleted?: boolean;
  IsEnvoyee?: boolean;
  IsObligActivite?: boolean;
  IsPJBenef?: boolean;
  IsRecue?: boolean;
  IsUpdated?: boolean;
  IsValide?: boolean;
  LibTypePJ?: string;
  LibellePJ?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomFichier?: string;
  OrdreTypePJ?: number;
  PrenomBenefAD?: string;
  RemarquePriveePJ?: string;
  RemarquePublique?: string;
  RemarquePubliquePJ?: string;
  RibLibelle?: string;
  RibLibelleLight?: string;
  Status?: StatusDtoEnum;
  StatutPJEnum?: TypeStatutPieceJustificativeEnum;
};

export type PieceJustificativeDto = {
  __typename?: 'PieceJustificativeDTO';
  Code?: string;
  Description?: string;
  Id?: number;
  IsCloture?: boolean;
  IsPJActivite?: boolean;
  IsPJBenef?: boolean;
  Libelle?: string;
  ListePjDemArticle?: ArrayOfPjDemArticleDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PieceJustificativeDtoInput = {
  Code?: string;
  Description?: string;
  Id?: number;
  IsCloture?: boolean;
  IsPJActivite?: boolean;
  IsPJBenef?: boolean;
  Libelle?: string;
  ListePjDemArticle?: ArrayOfPjDemArticleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PjDemArticleDto = {
  __typename?: 'PjDemArticleDTO';
  Article?: ArticleDto;
  IsObligatoire?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  PieceJustificative?: PieceJustificativeDto;
  Status?: StatusDtoEnum;
};

export type PjDemArticleDtoInput = {
  Article?: ArticleDtoInput;
  IsObligatoire?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  PieceJustificative?: PieceJustificativeDtoInput;
  Status?: StatusDtoEnum;
};

export type PlanAnalytiqueDto = {
  __typename?: 'PlanAnalytiqueDTO';
  CEDelegation?: CeDelegationDto;
  Code?: string;
  Description?: string;
  Id?: number;
  IsClos?: boolean;
  Libelle?: string;
  ListeLigneFactureSectionAnalytique?: ArrayOfLigneFactureSectionAnalytiqueDto;
  ListeMouvementAnalytique?: ArrayOfMouvementAnalytiqueDto;
  ListeSectionAnalytique?: ArrayOfSectionAnalytiqueDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PlanAnalytiqueDtoInput = {
  CEDelegation?: CeDelegationDtoInput;
  Code?: string;
  Description?: string;
  Id?: number;
  IsClos?: boolean;
  Libelle?: string;
  ListeLigneFactureSectionAnalytique?: ArrayOfLigneFactureSectionAnalytiqueDtoInput;
  ListeMouvementAnalytique?: ArrayOfMouvementAnalytiqueDtoInput;
  ListeSectionAnalytique?: ArrayOfSectionAnalytiqueDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PlanAnalytiqueModelDto = {
  __typename?: 'PlanAnalytiqueModelDTO';
  Code?: string;
  Description?: string;
  Id?: number;
  Libelle?: string;
  ListeClesRepartition?: ArrayOfCleRepartitionModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PlanAnalytiqueModelDtoInput = {
  Code?: string;
  Description?: string;
  Id?: number;
  Libelle?: string;
  ListeClesRepartition?: ArrayOfCleRepartitionModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PlanSectionAnalytiqueCleModelInput = {
  Code?: string;
  Description?: string;
  IdPlan?: number;
  LibellePlan?: string;
  ListeClesRepartitions?: ArrayOfanyTypeInput;
  ListeSections?: ArrayOfanyTypeInput;
};

export type PlanSectionAnalytiqueModelDto = {
  __typename?: 'PlanSectionAnalytiqueModelDTO';
  IdPlanAnalytique?: number;
  LibellePlanAnalytique?: string;
  ListeSectionsAnalytiques?: ArrayOfSectionAnalytiqueModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PlanSectionAnalytiqueModelDtoInput = {
  IdPlanAnalytique?: number;
  LibellePlanAnalytique?: string;
  ListeSectionsAnalytiques?: ArrayOfSectionAnalytiqueModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PlanWithSectionsAnalytiquesModel = {
  __typename?: 'PlanWithSectionsAnalytiquesModel';
  IdPlan?: number;
  IdSectionAnalytique?: number;
  LibellePlan?: string;
  ListeSection?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PlanWithSectionsAnalytiquesModelInput = {
  IdPlan?: number;
  IdSectionAnalytique?: number;
  LibellePlan?: string;
  ListeSection?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PointVenteDto = {
  __typename?: 'PointVenteDTO';
  Adresse?: AdresseDto;
  CEDelegation?: CeDelegationDto;
  ID?: number;
  ListeActivite?: ArrayOfActiviteDto;
  ListeCaisse?: ArrayOfCaisseDto;
  ListeStocks?: ArrayOfStockDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PVCodl?: string;
  PVDateClo?: any;
  PVDesc?: string;
  PVEmail?: string;
  PVFax?: string;
  PVIDCclo?: boolean;
  PVLib?: string;
  PVTel?: string;
  PVUseAdrGlo?: boolean;
  Status?: StatusDtoEnum;
};

export type PointVenteDtoInput = {
  Adresse?: AdresseDtoInput;
  CEDelegation?: CeDelegationDtoInput;
  ID?: number;
  ListeActivite?: ArrayOfActiviteDtoInput;
  ListeCaisse?: ArrayOfCaisseDtoInput;
  ListeStocks?: ArrayOfStockDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PVCodl?: string;
  PVDateClo?: any;
  PVDesc?: string;
  PVEmail?: string;
  PVFax?: string;
  PVIDCclo?: boolean;
  PVLib?: string;
  PVTel?: string;
  PVUseAdrGlo?: boolean;
  Status?: StatusDtoEnum;
};

export type PointVenteWithDelegModel = {
  __typename?: 'PointVenteWithDelegModel';
  IdDelegation?: number;
  IdPointVente?: number;
  LibellePointVente?: string;
};

export type PointVenteWithDelegModelInput = {
  IdDelegation?: number;
  IdPointVente?: number;
  LibellePointVente?: string;
};

export type PopupAjoutModifligneAvoirModelDto = {
  __typename?: 'PopupAjoutModifligneAvoirModelDTO';
  CompteCollectifActivite?: CompteDto;
  ListeCompte?: ArrayOfCompteModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PopupAjoutModifligneAvoirModelDtoInput = {
  CompteCollectifActivite?: CompteDtoInput;
  ListeCompte?: ArrayOfCompteModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PopupMouvementComptableInitialisationModelDto = {
  __typename?: 'PopupMouvementComptableInitialisationModelDTO';
  HavePlanAnalytiqueParametre?: boolean;
  ListeBanque?: ArrayOfstring;
  ListeCompte?: ArrayOfComptaCompteModelDto;
};

export type PopupMouvementComptableInitialisationModelDtoInput = {
  HavePlanAnalytiqueParametre?: boolean;
  ListeBanque?: ArrayOfstringInput;
  ListeCompte?: ArrayOfComptaCompteModelDtoInput;
};

export type PopupValiderCommandeModele = {
  __typename?: 'PopupValiderCommandeModele';
  ListBanque?: ArrayOfstring;
  ListExercice?: ArrayOfExerciceDto;
  ListLigneDevisCommandeModel?: ArrayOfLigneDevisModeleDto;
  ListeActivite?: ArrayOfActiviteDto;
  ListeJournaux?: ArrayOfJournalDto;
  ModeleFacturation?: ModeleForFacturationDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PopupValiderCommandeModeleInput = {
  ListBanque?: ArrayOfstringInput;
  ListExercice?: ArrayOfExerciceDtoInput;
  ListLigneDevisCommandeModel?: ArrayOfLigneDevisModeleDtoInput;
  ListeActivite?: ArrayOfActiviteDtoInput;
  ListeJournaux?: ArrayOfJournalDtoInput;
  ModeleFacturation?: ModeleForFacturationDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailAlbumDto = {
  __typename?: 'PortailAlbumDTO';
  CeDelegation?: CeDelegationDto;
  DateDebut?: any;
  DateFin?: any;
  Description?: string;
  Id?: number;
  Libelle?: string;
  ListeArticles?: ArrayOfPortailArticleDto;
  ListeDocumentAlbum?: ArrayOfPortailDocumentAlbumDto;
  ListeDocumentsToSave?: ArrayOfFichierCompletModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Statut?: PortailStatutDto;
};

export type PortailAlbumDtoInput = {
  CeDelegation?: CeDelegationDtoInput;
  DateDebut?: any;
  DateFin?: any;
  Description?: string;
  Id?: number;
  Libelle?: string;
  ListeArticles?: ArrayOfPortailArticleDtoInput;
  ListeDocumentAlbum?: ArrayOfPortailDocumentAlbumDtoInput;
  ListeDocumentsToSave?: ArrayOfFichierCompletModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Statut?: PortailStatutDtoInput;
};

export type PortailArticleCommentaireDto = {
  __typename?: 'PortailArticleCommentaireDTO';
  Article?: PortailArticleDto;
  Benef?: BenefDto;
  DateCreation?: any;
  DateValidation?: any;
  Description?: string;
  Id?: number;
  IsValide?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: UsersDto;
};

export type PortailArticleCommentaireDtoInput = {
  Article?: PortailArticleDtoInput;
  Benef?: BenefDtoInput;
  DateCreation?: any;
  DateValidation?: any;
  Description?: string;
  Id?: number;
  IsValide?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: UsersDtoInput;
};

export type PortailArticleDto = {
  __typename?: 'PortailArticleDTO';
  AddedImagesIds?: ArrayOfint;
  CanComment?: boolean;
  CanLike?: boolean;
  Categorie?: PortailEditorialCategorieDto;
  CeDelegation?: CeDelegationDto;
  ChapeauPersonnalise?: boolean;
  Corps?: string;
  CorpsActu?: string;
  DateCreation?: any;
  DateDebutPublication?: any;
  DateFinPublication?: any;
  DateMAJ?: any;
  DiffusionArticleModel?: EditerArticleMonEspaceCse;
  Id?: number;
  Illustration?: FichierModel;
  IsActualite?: boolean;
  IsAnonyme?: boolean;
  IsAnonymeParDefaut?: boolean;
  IsMasquerInfosPublication?: boolean;
  IsModificationPossibleParLocal?: boolean;
  IsPublic?: boolean;
  LastUserMaj?: UsersDto;
  ListeAlbums?: ArrayOfPortailAlbumDto;
  ListeCommentaires?: ArrayOfPortailArticleCommentaireDto;
  ListeCommissions?: ArrayOfdecimal;
  ListeDocuments?: ArrayOfFichierModel;
  ListeLikes?: ArrayOfPortailArticleLikeDto;
  ListeParamValeur?: ArrayOfPortailArticleParamValDto;
  MailNotifAutoCommentaire?: boolean;
  MenuPortailParent?: PortailArticleDto;
  ModereComentaire?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OrdreMenu?: number;
  Status?: StatusDtoEnum;
  Statut?: PortailStatutDto;
  Titre?: string;
  TypeArticle?: PortailArticleTypeDto;
  TypeOrdre?: string;
  UserCreation?: UsersDto;
};

export type PortailArticleDtoInput = {
  AddedImagesIds?: ArrayOfintInput;
  CanComment?: boolean;
  CanLike?: boolean;
  Categorie?: PortailEditorialCategorieDtoInput;
  CeDelegation?: CeDelegationDtoInput;
  ChapeauPersonnalise?: boolean;
  Corps?: string;
  CorpsActu?: string;
  DateCreation?: any;
  DateDebutPublication?: any;
  DateFinPublication?: any;
  DateMAJ?: any;
  DiffusionArticleModel?: EditerArticleMonEspaceCseInput;
  Id?: number;
  Illustration?: FichierModelInput;
  IsActualite?: boolean;
  IsAnonyme?: boolean;
  IsAnonymeParDefaut?: boolean;
  IsMasquerInfosPublication?: boolean;
  IsModificationPossibleParLocal?: boolean;
  IsPublic?: boolean;
  LastUserMaj?: UsersDtoInput;
  ListeAlbums?: ArrayOfPortailAlbumDtoInput;
  ListeCommentaires?: ArrayOfPortailArticleCommentaireDtoInput;
  ListeCommissions?: ArrayOfdecimalInput;
  ListeDocuments?: ArrayOfFichierModelInput;
  ListeLikes?: ArrayOfPortailArticleLikeDtoInput;
  ListeParamValeur?: ArrayOfPortailArticleParamValDtoInput;
  MailNotifAutoCommentaire?: boolean;
  MenuPortailParent?: PortailArticleDtoInput;
  ModereComentaire?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OrdreMenu?: number;
  Status?: StatusDtoEnum;
  Statut?: PortailStatutDtoInput;
  Titre?: string;
  TypeArticle?: PortailArticleTypeDtoInput;
  TypeOrdre?: string;
  UserCreation?: UsersDtoInput;
};

export type PortailArticleLikeDto = {
  __typename?: 'PortailArticleLikeDTO';
  Article?: PortailArticleDto;
  Benef?: BenefDto;
  DateCreation?: any;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailArticleLikeDtoInput = {
  Article?: PortailArticleDtoInput;
  Benef?: BenefDtoInput;
  DateCreation?: any;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailArticleParamDto = {
  __typename?: 'PortailArticleParamDTO';
  Code?: string;
  Id?: number;
  ListeTypesArticles?: ArrayOfPortailArticleTypeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ValeurParDefaut?: string;
};

export type PortailArticleParamDtoInput = {
  Code?: string;
  Id?: number;
  ListeTypesArticles?: ArrayOfPortailArticleTypeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ValeurParDefaut?: string;
};

export type PortailArticleParamValDto = {
  __typename?: 'PortailArticleParamValDTO';
  Article?: PortailArticleDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Parametre?: PortailArticleParamDto;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type PortailArticleParamValDtoInput = {
  Article?: PortailArticleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Parametre?: PortailArticleParamDtoInput;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type PortailArticleTypeDto = {
  __typename?: 'PortailArticleTypeDTO';
  Code?: string;
  Description?: string;
  Id?: number;
  Libelle?: string;
  ListeArticles?: ArrayOfPortailArticleDto;
  ListeParametres?: ArrayOfPortailArticleParamDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailArticleTypeDtoInput = {
  Code?: string;
  Description?: string;
  Id?: number;
  Libelle?: string;
  ListeArticles?: ArrayOfPortailArticleDtoInput;
  ListeParametres?: ArrayOfPortailArticleParamDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailDocumentAlbumDto = {
  __typename?: 'PortailDocumentAlbumDTO';
  Document?: FichierCompletModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  PortailAlbum?: PortailAlbumDto;
  Status?: StatusDtoEnum;
};

export type PortailDocumentAlbumDtoInput = {
  Document?: FichierCompletModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  PortailAlbum?: PortailAlbumDtoInput;
  Status?: StatusDtoEnum;
};

export type PortailDocumentCategorieDto = {
  __typename?: 'PortailDocumentCategorieDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailDocumentCategorieDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailEditorialCategorieDto = {
  __typename?: 'PortailEditorialCategorieDTO';
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailEditorialCategorieDtoInput = {
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailFormulaireSpecifiqueDto = {
  __typename?: 'PortailFormulaireSpecifiqueDTO';
  Code?: string;
  Id?: number;
  IsMenu?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailFormulaireSpecifiqueDtoInput = {
  Code?: string;
  Id?: number;
  IsMenu?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailOptionsDto = {
  __typename?: 'PortailOptionsDTO';
  AfficherAuthentifPrehome?: boolean;
  AfficherNouveauxArticles?: boolean;
  AfficherPreHome?: boolean;
  AnonymeParDefaut?: boolean;
  AnonymisationPossible?: boolean;
  Bandeau?: FichierModel;
  CommentairesAutorises?: boolean;
  EnvoieMailApprobation?: boolean;
  Fond?: FichierModel;
  Id?: number;
  LikesAutorises?: boolean;
  Logo?: FichierModel;
  MailNotifAuto?: boolean;
  MentionsLegalesAuto?: boolean;
  MotDePassePreHome?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreJoursAffichageNouveauxArticles?: number;
  PiwikId?: number;
  PiwikLogin?: string;
  PiwikPassword?: string;
  PiwikUrl?: string;
  PolitiqueConfidentialite?: FichierModel;
  Skin?: PortailSkinDto;
  Status?: StatusDtoEnum;
  TypeModeration?: string;
};

export type PortailOptionsDtoInput = {
  AfficherAuthentifPrehome?: boolean;
  AfficherNouveauxArticles?: boolean;
  AfficherPreHome?: boolean;
  AnonymeParDefaut?: boolean;
  AnonymisationPossible?: boolean;
  Bandeau?: FichierModelInput;
  CommentairesAutorises?: boolean;
  EnvoieMailApprobation?: boolean;
  Fond?: FichierModelInput;
  Id?: number;
  LikesAutorises?: boolean;
  Logo?: FichierModelInput;
  MailNotifAuto?: boolean;
  MentionsLegalesAuto?: boolean;
  MotDePassePreHome?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreJoursAffichageNouveauxArticles?: number;
  PiwikId?: number;
  PiwikLogin?: string;
  PiwikPassword?: string;
  PiwikUrl?: string;
  PolitiqueConfidentialite?: FichierModelInput;
  Skin?: PortailSkinDtoInput;
  Status?: StatusDtoEnum;
  TypeModeration?: string;
};

export type PortailPortletCssDto = {
  __typename?: 'PortailPortletCssDTO';
  Code?: string;
  Id?: number;
  LibelleClass?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type PortailPortletCssDtoInput = {
  Code?: string;
  Id?: number;
  LibelleClass?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type PortailPortletDto = {
  __typename?: 'PortailPortletDTO';
  CeDeleg?: CeDelegationDto;
  CoordX?: number;
  CoordY?: number;
  DateMaj?: any;
  Height?: number;
  Id?: number;
  Illustration?: FichierModel;
  IsPrehome?: boolean;
  ListeArticleEditorialPortletOrdre?: ArrayOfArticleEditorielPortletModel;
  ListeEnveloppeQuota?: ArrayOfEnveloppeQuotaDto;
  ListeParamval?: ArrayOfPortailPortletParamValDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PortletCss?: PortailPortletCssDto;
  Status?: StatusDtoEnum;
  Statut?: PortailStatutDto;
  Titre?: string;
  TypePortlet?: PortailPortletTypeDto;
  Width?: number;
};

export type PortailPortletDtoInput = {
  CeDeleg?: CeDelegationDtoInput;
  CoordX?: number;
  CoordY?: number;
  DateMaj?: any;
  Height?: number;
  Id?: number;
  Illustration?: FichierModelInput;
  IsPrehome?: boolean;
  ListeArticleEditorialPortletOrdre?: ArrayOfArticleEditorielPortletModelInput;
  ListeEnveloppeQuota?: ArrayOfEnveloppeQuotaDtoInput;
  ListeParamval?: ArrayOfPortailPortletParamValDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PortletCss?: PortailPortletCssDtoInput;
  Status?: StatusDtoEnum;
  Statut?: PortailStatutDtoInput;
  Titre?: string;
  TypePortlet?: PortailPortletTypeDtoInput;
  Width?: number;
};

export type PortailPortletParamDto = {
  __typename?: 'PortailPortletParamDTO';
  Code?: string;
  Id?: number;
  ListeParamVal?: ArrayOfPortailPortletParamValDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypePortlet?: PortailPortletTypeDto;
  ValeurParDefaut?: string;
};

export type PortailPortletParamDtoInput = {
  Code?: string;
  Id?: number;
  ListeParamVal?: ArrayOfPortailPortletParamValDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypePortlet?: PortailPortletTypeDtoInput;
  ValeurParDefaut?: string;
};

export type PortailPortletParamValDto = {
  __typename?: 'PortailPortletParamValDTO';
  MustValidate?: boolean;
  MyGuid?: string;
  Portlet?: PortailPortletDto;
  PortletParam?: PortailPortletParamDto;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type PortailPortletParamValDtoInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  Portlet?: PortailPortletDtoInput;
  PortletParam?: PortailPortletParamDtoInput;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type PortailPortletTypeDto = {
  __typename?: 'PortailPortletTypeDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  ListeParametres?: ArrayOfPortailPortletParamDto;
  ListePortlets?: ArrayOfPortailPortletDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailPortletTypeDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  ListeParametres?: ArrayOfPortailPortletParamDtoInput;
  ListePortlets?: ArrayOfPortailPortletDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailSkinCouleurPrincipaleDto = {
  __typename?: 'PortailSkinCouleurPrincipaleDTO';
  Code?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailSkinCouleurPrincipaleDtoInput = {
  Code?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailSkinCouleurSecondaireDto = {
  __typename?: 'PortailSkinCouleurSecondaireDTO';
  Code?: string;
  Id?: number;
  IdCouleurPrincipale?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailSkinCouleurSecondaireDtoInput = {
  Code?: string;
  Id?: number;
  IdCouleurPrincipale?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailSkinDto = {
  __typename?: 'PortailSkinDTO';
  Apercu?: FichierModel;
  Background_HauteurMax?: number;
  Background_LargeurMax?: number;
  Bandeau_HauteurMax?: number;
  Bandeau_LargeurMax?: number;
  CanConfigureBackground?: boolean;
  CanConfigureBandeau?: boolean;
  CanConfigureBordureTheme?: boolean;
  CanConfigureCouleurTheme?: boolean;
  CanConfigureOmbresTheme?: boolean;
  Css?: string;
  Id?: number;
  IdCouleurPrincipale?: number;
  IdCouleurSecondaire?: number;
  IdOmbre?: number;
  IdRadius?: number;
  Libelle?: string;
  ListeCE?: ArrayOfCeDelegationDto;
  Logo_HauteurMax?: number;
  Logo_LargeurMax?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ThemeDirectory?: string;
};

export type PortailSkinDtoInput = {
  Apercu?: FichierModelInput;
  Background_HauteurMax?: number;
  Background_LargeurMax?: number;
  Bandeau_HauteurMax?: number;
  Bandeau_LargeurMax?: number;
  CanConfigureBackground?: boolean;
  CanConfigureBandeau?: boolean;
  CanConfigureBordureTheme?: boolean;
  CanConfigureCouleurTheme?: boolean;
  CanConfigureOmbresTheme?: boolean;
  Css?: string;
  Id?: number;
  IdCouleurPrincipale?: number;
  IdCouleurSecondaire?: number;
  IdOmbre?: number;
  IdRadius?: number;
  Libelle?: string;
  ListeCE?: ArrayOfCeDelegationDtoInput;
  Logo_HauteurMax?: number;
  Logo_LargeurMax?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ThemeDirectory?: string;
};

export type PortailSkinOmbreDto = {
  __typename?: 'PortailSkinOmbreDTO';
  BlurRadius?: number;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OffsetX?: number;
  OffsetY?: number;
  SpreadRadius?: number;
  Status?: StatusDtoEnum;
  Unite?: string;
};

export type PortailSkinOmbreDtoInput = {
  BlurRadius?: number;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  OffsetX?: number;
  OffsetY?: number;
  SpreadRadius?: number;
  Status?: StatusDtoEnum;
  Unite?: string;
};

export type PortailSkinRadiusDto = {
  __typename?: 'PortailSkinRadiusDTO';
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Unite?: string;
  Valeur?: number;
};

export type PortailSkinRadiusDtoInput = {
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Unite?: string;
  Valeur?: number;
};

export type PortailStatutDto = {
  __typename?: 'PortailStatutDTO';
  Code?: string;
  Id?: number;
  IsActif?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortailStatutDtoInput = {
  Code?: string;
  Id?: number;
  IsActif?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortletCssColorModel = {
  __typename?: 'PortletCssColorModel';
  ColorBandeau?: string;
  ColorTextBandeau?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortletCssColorModelInput = {
  ColorBandeau?: string;
  ColorTextBandeau?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortletPortletCssModel = {
  __typename?: 'PortletPortletCssModel';
  Code?: string;
  ColorBandeau?: string;
  ColorTextBandeau?: string;
  Id?: number;
  LibelleClass?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortletPortletCssModelInput = {
  Code?: string;
  ColorBandeau?: string;
  ColorTextBandeau?: string;
  Id?: number;
  LibelleClass?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PortletPortletLimitCodeTypeModel = {
  __typename?: 'PortletPortletLimitCodeTypeModel';
  ListeCodeTypePortlet?: ArrayOfstring;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreColonne?: number;
  NombreLigne?: number;
  Status?: StatusDtoEnum;
};

export type PortletPortletLimitCodeTypeModelInput = {
  ListeCodeTypePortlet?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreColonne?: number;
  NombreLigne?: number;
  Status?: StatusDtoEnum;
};

export type PortletsInfosParametresPortletSondageInput = {
  DateDebut?: any;
  DateFin?: any;
  IdCe?: number;
  IdSondage?: number;
  IdUser?: number;
  IsMultiple?: boolean;
  IsUnique?: boolean;
  LibellePortlet?: string;
  LibelleQuestion?: string;
  ListeChampValeur?: ArrayOfChampListeValeurDtoInput;
};

export type PortletsInitialisationModuleGestionPortletsModel = {
  __typename?: 'PortletsInitialisationModuleGestionPortletsModel';
  ListePortletCss?: ArrayOfPortailPortletCssDto;
  ListePortletLimit?: ArrayOfPortletPortletLimitCodeTypeModel;
  ListePortletsAssignes?: ArrayOfPortailPortletDto;
  ListePortletsDispos?: ArrayOfPortailPortletTypeDto;
  ListePortletsParam?: ArrayOfPortailPortletParamDto;
  ListeStatut?: ArrayOfPortailStatutDto;
  ThemeCourant?: string;
};

export type PortletsInitialisationModuleGestionPortletsModelInput = {
  ListePortletCss?: ArrayOfPortailPortletCssDtoInput;
  ListePortletLimit?: ArrayOfPortletPortletLimitCodeTypeModelInput;
  ListePortletsAssignes?: ArrayOfPortailPortletDtoInput;
  ListePortletsDispos?: ArrayOfPortailPortletTypeDtoInput;
  ListePortletsParam?: ArrayOfPortailPortletParamDtoInput;
  ListeStatut?: ArrayOfPortailStatutDtoInput;
  ThemeCourant?: string;
};

export type PortletsInitialisationModulePortletsParametresArticleEditorialModel = {
  __typename?: 'PortletsInitialisationModulePortletsParametresArticleEditorialModel';
  ListeArticles?: ArrayOfCommunArticleEditorialPortailModel;
  ListeStatut?: ArrayOfPortailStatutDto;
};

export type PortletsInitialisationModulePortletsParametresArticleEditorialModelInput = {
  ListeArticles?: ArrayOfCommunArticleEditorialPortailModelInput;
  ListeStatut?: ArrayOfPortailStatutDtoInput;
};

export type PortletsInitialisationModulePortletsParametresAuthentifModel = {
  __typename?: 'PortletsInitialisationModulePortletsParametresAuthentifModel';
  ListeStatut?: ArrayOfPortailStatutDto;
};

export type PortletsInitialisationModulePortletsParametresAuthentifModelInput = {
  ListeStatut?: ArrayOfPortailStatutDtoInput;
};

export type PortletsInitialisationModulePortletsParametresDirectoModel = {
  __typename?: 'PortletsInitialisationModulePortletsParametresDirectoModel';
  ListeActivite?: ArrayOfCommunActiviteDirectoModel;
  ListeFamille?: ArrayOfCommunFamilleDirectoModel;
  ListeStatut?: ArrayOfPortailStatutDto;
};

export type PortletsInitialisationModulePortletsParametresDirectoModelInput = {
  ListeActivite?: ArrayOfCommunActiviteDirectoModelInput;
  ListeFamille?: ArrayOfCommunFamilleDirectoModelInput;
  ListeStatut?: ArrayOfPortailStatutDtoInput;
};

export type PortletsInitialisationModulePortletsParametresDocumentModel = {
  __typename?: 'PortletsInitialisationModulePortletsParametresDocumentModel';
  ListeCategories?: ArrayOfPortailDocumentCategorieDto;
  ListeStatut?: ArrayOfPortailStatutDto;
};

export type PortletsInitialisationModulePortletsParametresDocumentModelInput = {
  ListeCategories?: ArrayOfPortailDocumentCategorieDtoInput;
  ListeStatut?: ArrayOfPortailStatutDtoInput;
};

export type PortletsInitialisationModulePortletsParametresPfbModel = {
  __typename?: 'PortletsInitialisationModulePortletsParametresPFBModel';
  ListeStatut?: ArrayOfPortailStatutDto;
};

export type PortletsInitialisationModulePortletsParametresPfbModelInput = {
  ListeStatut?: ArrayOfPortailStatutDtoInput;
};

export type PortletsInitialisationModulePortletsParametresTrombinoscopeModel = {
  __typename?: 'PortletsInitialisationModulePortletsParametresTrombinoscopeModel';
  ListeCommission?: ArrayOfCommissionCommissionModel;
  ListeStatut?: ArrayOfPortailStatutDto;
  WithCommission?: boolean;
};

export type PortletsInitialisationModulePortletsParametresTrombinoscopeModelInput = {
  ListeCommission?: ArrayOfCommissionCommissionModelInput;
  ListeStatut?: ArrayOfPortailStatutDtoInput;
  WithCommission?: boolean;
};

export type PortletsInitialisationParametresPortletActualites = {
  __typename?: 'PortletsInitialisationParametresPortletActualites';
  ListeCategorie?: ArrayOfPortailEditorialCategorieDto;
  ListeStatut?: ArrayOfPortailStatutDto;
};

export type PortletsInitialisationParametresPortletActualitesInput = {
  ListeCategorie?: ArrayOfPortailEditorialCategorieDtoInput;
  ListeStatut?: ArrayOfPortailStatutDtoInput;
};

export type PortletsInitialisationParametresPortletListeArticle = {
  __typename?: 'PortletsInitialisationParametresPortletListeArticle';
  ListeCategorie?: ArrayOfPortailEditorialCategorieDto;
  ListeStatut?: ArrayOfPortailStatutDto;
};

export type PortletsInitialisationParametresPortletListeArticleInput = {
  ListeCategorie?: ArrayOfPortailEditorialCategorieDtoInput;
  ListeStatut?: ArrayOfPortailStatutDtoInput;
};

export type PortletsInitialisationParametresPortletSoldeEnvAttrib = {
  __typename?: 'PortletsInitialisationParametresPortletSoldeEnvAttrib';
  ListeEnveloppeAttrib?: ArrayOfEnveloppeQuotaDto;
  ListeStatut?: ArrayOfPortailStatutDto;
};

export type PortletsInitialisationParametresPortletSoldeEnvAttribInput = {
  ListeEnveloppeAttrib?: ArrayOfEnveloppeQuotaDtoInput;
  ListeStatut?: ArrayOfPortailStatutDtoInput;
};

export type PortletsInitialisationParametresPortletSondageModel = {
  __typename?: 'PortletsInitialisationParametresPortletSondageModel';
  ListeReponses?: ArrayOfChampListeValeurDto;
  Question?: SondageSondageQuestionPortletModel;
};

export type PortletsInitialisationParametresPortletSondageModelInput = {
  ListeReponses?: ArrayOfChampListeValeurDtoInput;
  Question?: SondageSondageQuestionPortletModelInput;
};

export type PortletsInitialisationParametresPortletVenteArticle = {
  __typename?: 'PortletsInitialisationParametresPortletVenteArticle';
  ListeActivites?: ArrayOfCommunActiviteDirectoModel;
  ListeArticles?: ArrayOfCommunArticleActivitePortailModel;
  ListeFamilles?: ArrayOfCommunFamilleDirectoModel;
  ListeProduits?: ArrayOfCommunProduitPortailModel;
  ListeStatuts?: ArrayOfPortailStatutDto;
};

export type PortletsInitialisationParametresPortletVenteArticleInput = {
  ListeActivites?: ArrayOfCommunActiviteDirectoModelInput;
  ListeArticles?: ArrayOfCommunArticleActivitePortailModelInput;
  ListeFamilles?: ArrayOfCommunFamilleDirectoModelInput;
  ListeProduits?: ArrayOfCommunProduitPortailModelInput;
  ListeStatuts?: ArrayOfPortailStatutDtoInput;
};

export type PostClotureStatutModel = {
  __typename?: 'PostClotureStatutModel';
  NombreActionLieeAStatut?: number;
  NombreCommandeLieeAStatut?: number;
};

export type PostClotureStatutModelInput = {
  NombreActionLieeAStatut?: number;
  NombreCommandeLieeAStatut?: number;
};

export type PosteBudgetaireDto = {
  __typename?: 'PosteBudgetaireDTO';
  Budget?: BudgetDto;
  Code?: string;
  Id?: number;
  IsTypeRecette?: boolean;
  Libelle?: string;
  ListeCompte?: ArrayOfCompteDto;
  ListeSectionAnalytique?: ArrayOfSectionAnalytiqueDto;
  MustValidate?: boolean;
  MyGuid?: string;
  SoldeAout?: number;
  SoldeAvril?: number;
  SoldeDec?: number;
  SoldeFev?: number;
  SoldeJan?: number;
  SoldeJuil?: number;
  SoldeJuin?: number;
  SoldeMai?: number;
  SoldeMars?: number;
  SoldeNov?: number;
  SoldeOct?: number;
  SoldeSept?: number;
  SoldeTGAnnuel?: number;
  Status?: StatusDtoEnum;
  TypeSuivi?: string;
};

export type PosteBudgetaireDtoInput = {
  Budget?: BudgetDtoInput;
  Code?: string;
  Id?: number;
  IsTypeRecette?: boolean;
  Libelle?: string;
  ListeCompte?: ArrayOfCompteDtoInput;
  ListeSectionAnalytique?: ArrayOfSectionAnalytiqueDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  SoldeAout?: number;
  SoldeAvril?: number;
  SoldeDec?: number;
  SoldeFev?: number;
  SoldeJan?: number;
  SoldeJuil?: number;
  SoldeJuin?: number;
  SoldeMai?: number;
  SoldeMars?: number;
  SoldeNov?: number;
  SoldeOct?: number;
  SoldeSept?: number;
  SoldeTGAnnuel?: number;
  Status?: StatusDtoEnum;
  TypeSuivi?: string;
};

export type PosteBudgetaireListingModelInput = {
  Id?: number;
  Libelle?: string;
};

export type PosteBudgetaireModelDto = {
  __typename?: 'PosteBudgetaireModelDTO';
  Code?: string;
  Id?: number;
  IdBudget?: number;
  IsMensuel?: boolean;
  IsTypeRecette?: boolean;
  Libelle?: string;
  LibelleBudget?: string;
  LibelleCptOrSecAna?: string;
  ListeCompteModele?: ArrayOfCompteModelDto;
  ListeIdCompteInitUse?: ArrayOfdecimal;
  ListeIdSectionAnaInitUse?: ArrayOfdecimal;
  ListeSectionAnalytiqueModele?: ArrayOfSectionAnalytiqueModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  SoldeAout?: number;
  SoldeAvril?: number;
  SoldeDec?: number;
  SoldeFev?: number;
  SoldeJan?: number;
  SoldeJuil?: number;
  SoldeJuin?: number;
  SoldeMai?: number;
  SoldeMars?: number;
  SoldeNov?: number;
  SoldeOct?: number;
  SoldeSept?: number;
  SoldeTGAnnuel?: number;
  Status?: StatusDtoEnum;
  TypeSuivi?: string;
};

export type PosteBudgetaireModelDtoInput = {
  Code?: string;
  Id?: number;
  IdBudget?: number;
  IsMensuel?: boolean;
  IsTypeRecette?: boolean;
  Libelle?: string;
  LibelleBudget?: string;
  LibelleCptOrSecAna?: string;
  ListeCompteModele?: ArrayOfCompteModelDtoInput;
  ListeIdCompteInitUse?: ArrayOfdecimalInput;
  ListeIdSectionAnaInitUse?: ArrayOfdecimalInput;
  ListeSectionAnalytiqueModele?: ArrayOfSectionAnalytiqueModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  SoldeAout?: number;
  SoldeAvril?: number;
  SoldeDec?: number;
  SoldeFev?: number;
  SoldeJan?: number;
  SoldeJuil?: number;
  SoldeJuin?: number;
  SoldeMai?: number;
  SoldeMars?: number;
  SoldeNov?: number;
  SoldeOct?: number;
  SoldeSept?: number;
  SoldeTGAnnuel?: number;
  Status?: StatusDtoEnum;
  TypeSuivi?: string;
};

export type PreparerNouveauDevisCommandeEpargneModelInput = {
  DateDossier?: any;
  IdActivite?: number;
  IdBenef?: number;
  IdCaisse?: number;
  IdCe?: number;
  IdEpargne?: number;
  IdModeleEcheancier?: number;
  IdMoyenPaiement?: number;
  IdPV?: number;
  IdStock?: number;
  InfosReglement?: CommandeInfoReglementModelInput;
  IsReglementComptant?: boolean;
};

export type PreparerNouveauDevisCommandePretsEtDonsModelInput = {
  DateDossier?: any;
  IdActivite?: number;
  IdBenef?: number;
  IdCaisse?: number;
  IdCe?: number;
  IdFormule?: number;
  IdPV?: number;
  IdProduit?: number;
  IdStock?: number;
  LibelleCommande?: string;
};

export type PrestationFamilleVenteEnLigneModel = {
  __typename?: 'PrestationFamilleVenteEnLigneModel';
  AutoriserCommandesEnLigne?: boolean;
  DateDebutVisibilite?: any;
  DateFinVisibilite?: any;
  IdElement?: number;
  IsAfficheEnLigne?: boolean;
  IsDossierSimplifieEnLigne?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreVenteEnLigne?: boolean;
  Status?: StatusDtoEnum;
};

export type PrestationFamilleVenteEnLigneModelInput = {
  AutoriserCommandesEnLigne?: boolean;
  DateDebutVisibilite?: any;
  DateFinVisibilite?: any;
  IdElement?: number;
  IsAfficheEnLigne?: boolean;
  IsDossierSimplifieEnLigne?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreVenteEnLigne?: boolean;
  Status?: StatusDtoEnum;
};

export type PrestationInformationsArticleModel = {
  __typename?: 'PrestationInformationsArticleModel';
  CodeArticle?: string;
  CodeBarre?: string;
  DateEvenement?: any;
  Description?: string;
  IdArticle?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  IsPrestationCadeau?: boolean;
  Libelle?: string;
  LibelleDateEvenement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Quotite?: number;
  RemarqueArticle?: string;
  Status?: StatusDtoEnum;
};

export type PrestationInformationsArticleModelInput = {
  CodeArticle?: string;
  CodeBarre?: string;
  DateEvenement?: any;
  Description?: string;
  IdArticle?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  IsPrestationCadeau?: boolean;
  Libelle?: string;
  LibelleDateEvenement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Quotite?: number;
  RemarqueArticle?: string;
  Status?: StatusDtoEnum;
};

export type PrestationModelDto = {
  __typename?: 'PrestationModelDTO';
  IdPrestation?: number;
  IsCloturee?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TextFamillePrestation?: string;
  TextPrestation?: string;
};

export type PrestationModelDtoInput = {
  IdPrestation?: number;
  IsCloturee?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TextFamillePrestation?: string;
  TextPrestation?: string;
};

export type PrestationPjArticleModel = {
  __typename?: 'PrestationPJArticleModel';
  IdPJ?: number;
  IsObligatoire?: boolean;
  LibellePJ?: string;
  LibelleTypePJ?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PrestationPjArticleModelInput = {
  IdPJ?: number;
  IsObligatoire?: boolean;
  LibellePJ?: string;
  LibelleTypePJ?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PrestationProduitVenteEnLigneModel = {
  __typename?: 'PrestationProduitVenteEnLigneModel';
  AutoriserCommandesEnLigne?: boolean;
  DateDebutVisibilite?: any;
  DateFinVisibilite?: any;
  IdElement?: number;
  IsAfficheEnLigne?: boolean;
  IsDateDebutObligatoire?: boolean;
  IsDateFinObligatoire?: boolean;
  IsDossierSimplifieEnLigne?: boolean;
  IsRefFactureObligatoire?: boolean;
  LibellePrestaDateDebutActivite?: string;
  LibellePrestaDateFacture?: string;
  LibellePrestaDateFinActivite?: string;
  LibellePrestaMontantPresente?: string;
  LibellePrestaMontantPrisEnCompte?: string;
  LibellePrestaReferenceFacture?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreVenteEnLigne?: boolean;
  Status?: StatusDtoEnum;
};

export type PrestationProduitVenteEnLigneModelInput = {
  AutoriserCommandesEnLigne?: boolean;
  DateDebutVisibilite?: any;
  DateFinVisibilite?: any;
  IdElement?: number;
  IsAfficheEnLigne?: boolean;
  IsDateDebutObligatoire?: boolean;
  IsDateFinObligatoire?: boolean;
  IsDossierSimplifieEnLigne?: boolean;
  IsRefFactureObligatoire?: boolean;
  LibellePrestaDateDebutActivite?: string;
  LibellePrestaDateFacture?: string;
  LibellePrestaDateFinActivite?: string;
  LibellePrestaMontantPresente?: string;
  LibellePrestaMontantPrisEnCompte?: string;
  LibellePrestaReferenceFacture?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreVenteEnLigne?: boolean;
  Status?: StatusDtoEnum;
};

export type PrestationRemboursementArticleModel = {
  __typename?: 'PrestationRemboursementArticleModel';
  IsProposerSaisieParticipants?: boolean;
  LibelleUniteDecompte?: string;
  LibelleUnitePresentee?: string;
  ModeRemboursement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  PlafondMontantFacture?: number;
  Quotite?: number;
  Status?: StatusDtoEnum;
};

export type PrestationRemboursementArticleModelInput = {
  IsProposerSaisieParticipants?: boolean;
  LibelleUniteDecompte?: string;
  LibelleUnitePresentee?: string;
  ModeRemboursement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  PlafondMontantFacture?: number;
  Quotite?: number;
  Status?: StatusDtoEnum;
};

export type PretsEtDonsImputationComptableModel = {
  __typename?: 'PretsEtDonsImputationComptableModel';
  IdCompteCharges?: number;
  IdCompteCollectifPret?: number;
  IdCompteFraisDossier?: number;
  IdElement?: number;
  IsApplicationSurEnfants?: boolean;
  ListePlanSectionAnalytique?: ArrayOfPlanWithSectionsAnalytiquesModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PretsEtDonsImputationComptableModelInput = {
  IdCompteCharges?: number;
  IdCompteCollectifPret?: number;
  IdCompteFraisDossier?: number;
  IdElement?: number;
  IsApplicationSurEnfants?: boolean;
  ListePlanSectionAnalytique?: ArrayOfPlanWithSectionsAnalytiquesModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type PretsEtDonsInformationsArticleModel = {
  __typename?: 'PretsEtDonsInformationsArticleModel';
  CodeArticle?: string;
  DureeMaximunArticle?: number;
  DureeMinimunOrFixeArticle?: number;
  IdArticle?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  IsDureeFixeArticle?: boolean;
  IsMontantFixeArticle?: boolean;
  IsTypeProduitPret?: boolean;
  LibelleArticle?: string;
  MontantFraisDossierArticle?: number;
  MontantMaximunArticle?: number;
  MontantMinimunOrFixeArticle?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  PourcentageFraisDossierArticle?: number;
  Quotite?: number;
  RemarqueArticle?: string;
  Status?: StatusDtoEnum;
};

export type PretsEtDonsInformationsArticleModelInput = {
  CodeArticle?: string;
  DureeMaximunArticle?: number;
  DureeMinimunOrFixeArticle?: number;
  IdArticle?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  IsDureeFixeArticle?: boolean;
  IsMontantFixeArticle?: boolean;
  IsTypeProduitPret?: boolean;
  LibelleArticle?: string;
  MontantFraisDossierArticle?: number;
  MontantMaximunArticle?: number;
  MontantMinimunOrFixeArticle?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  PourcentageFraisDossierArticle?: number;
  Quotite?: number;
  RemarqueArticle?: string;
  Status?: StatusDtoEnum;
};

export type PretsEtDonsInformationsProduitModel = {
  __typename?: 'PretsEtDonsInformationsProduitModel';
  CodeProduit?: string;
  CodeTypeMoyenPaiementRemboursementBenefPret?: string;
  DescriptionProduit?: string;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  IsTypeProduitBlocked?: boolean;
  IsTypeProduitPret?: boolean;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarqueProduit?: string;
  Status?: StatusDtoEnum;
};

export type PretsEtDonsInformationsProduitModelInput = {
  CodeProduit?: string;
  CodeTypeMoyenPaiementRemboursementBenefPret?: string;
  DescriptionProduit?: string;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  IsTypeProduitBlocked?: boolean;
  IsTypeProduitPret?: boolean;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarqueProduit?: string;
  Status?: StatusDtoEnum;
};

export type PrixArticleModel = {
  __typename?: 'PrixArticleModel';
  IdArticle?: number;
  IdFournisseurFavoris?: number;
  IsPrixPublicDisplayed?: boolean;
  ListePrixAchat?: ArrayOfanyType;
  ListePrixVente?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixPublic?: number;
  Status?: StatusDtoEnum;
};

export type PrixArticleModelInput = {
  IdArticle?: number;
  IdFournisseurFavoris?: number;
  IsPrixPublicDisplayed?: boolean;
  ListePrixAchat?: ArrayOfanyTypeInput;
  ListePrixVente?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixPublic?: number;
  Status?: StatusDtoEnum;
};

export type ProduitBaseAvecIdFamilleModel = {
  __typename?: 'ProduitBaseAvecIdFamilleModel';
  IdFamille?: number;
  IdProduit?: number;
  IsClos?: boolean;
  Libelle?: string;
};

export type ProduitBaseAvecIdFamilleModelInput = {
  IdFamille?: number;
  IdProduit?: number;
  IsClos?: boolean;
  Libelle?: string;
};

export type ProduitBaseClosModel = {
  __typename?: 'ProduitBaseClosModel';
  IdProduit?: number;
  Isclos?: boolean;
  Libelle?: string;
};

export type ProduitBaseClosModelInput = {
  IdProduit?: number;
  Isclos?: boolean;
  Libelle?: string;
};

export type ProduitDto = {
  __typename?: 'ProduitDTO';
  AfficherDirecto?: boolean;
  AnneeRef?: AnneeReferenceDto;
  Auteur?: ChampValeurDto;
  AutoriseCommEnLigne?: boolean;
  AutoriseQteDispoNegaVal?: boolean;
  AutoriseQteDispoNegativeAtt?: boolean;
  AutoriseQteNega?: boolean;
  AutoriserResaSupp?: boolean;
  CDU?: ChampValeurDto;
  CapaciteMax?: number;
  CapaciteMin?: number;
  Cible?: ChampValeurDto;
  Code?: string;
  Collection?: ChampValeurDto;
  Cote?: ChampValeurDto;
  CourrierAcceptation?: CourrierDto;
  CourrierContractLoc?: CourrierDto;
  CourrierRefus?: CourrierDto;
  Cpt512?: CompteDto;
  CptAchat?: CompteDto;
  CptCollectifClient?: CompteDto;
  CptCollectifFournisseur?: CompteDto;
  CptValidationStock?: CompteDto;
  CptVariationStock?: CompteDto;
  CptVente?: CompteDto;
  Critique?: ChampValeurDto;
  DEWAY?: ChampValeurDto;
  DateAchat?: ChampValeurDto;
  DateDebutManifestation?: any;
  DateDebutRmbMensuel?: any;
  DateDebutVente?: any;
  DateDebutVisibilite?: any;
  DateEdition?: ChampValeurDto;
  DateFinManifestation?: any;
  DateFinRmbMensuel?: any;
  DateFinVente?: any;
  DateFinVisibilite?: any;
  DateMaj?: any;
  DateNouveaute?: ChampValeurDto;
  DatePourReappro?: any;
  DateSortie?: ChampValeurDto;
  DateSubvention?: any;
  Description?: string;
  Duree?: ChampValeurDto;
  Editeur?: ChampValeurDto;
  Enveloppe?: EnveloppeQuotaDto;
  EnveloppePresta?: EnveloppeQuotaDto;
  Exercice?: ExerciceDto;
  Famille?: FamilleProduitDto;
  Format?: ChampValeurDto;
  Fournisseur?: FournisseurDto;
  Genre?: ChampValeurDto;
  GererAllotement?: boolean;
  IDCAmazon?: boolean;
  ISBN10?: ChampValeurDto;
  Id?: number;
  IdModeleTVA?: number;
  Image?: ChampValeurDto;
  IsAttenteValidationBenef?: boolean;
  IsAttenteValidationCE?: boolean;
  IsCloture?: boolean;
  IsCrediterEnveloppe?: boolean;
  IsFacturationCentralise?: boolean;
  IsFacturationManuelle?: boolean;
  IsGestionParticipant?: boolean;
  IsGroupe?: boolean;
  IsMediatheque?: boolean;
  IsNotGereEnStock?: boolean;
  IsNotProposerReservationIndispo?: boolean;
  IsRemboursementCadeau?: boolean;
  IsRemboursementMensuel?: boolean;
  IsRemboursementPartACharge?: boolean;
  IsRemboursementPrestation?: boolean;
  IsSaisieChronologiqueRmbMensuel?: boolean;
  IsToutOuRien?: boolean;
  Libelle?: string;
  LibelleBoutonDetailVenteEnLigne?: string;
  LibellePrestaDateDebutActivite?: string;
  LibellePrestaDateFacture?: string;
  LibellePrestaDateFinActivite?: string;
  LibellePrestaMontantPresente?: string;
  LibellePrestaMontantPrisEnCompte?: string;
  LibellePrestaReferenceFacture?: string;
  Libre?: ChampValeurDto;
  Lieu?: LieuDto;
  LieuAchat?: ChampValeurDto;
  ListDescriptionDirecto?: ArrayOfProduitDirectoDescriptionDto;
  ListDocument?: ArrayOfFichierModel;
  ListeArticles?: ArrayOfArticleDto;
  ListeChamps?: ArrayOfChampDto;
  ListeChampsValeur?: ArrayOfChampValeurDto;
  ListeCompteursPoints?: ArrayOfCompteurPointAfpaModel;
  ListeEnvImpProduit?: ArrayOfEnvImpProduitDto;
  ListeFournisseursConventionnes?: ArrayOfFournisseurDto;
  ListeModeleEcheancier?: ArrayOfModeleEcheancierGeneriqueModel;
  ListeMoteurRegleHeritageProduit?: ArrayOfMoteurRegleHeritageProduitDto;
  ListeMoteurRegleUseProduit?: ArrayOfMoteurRegleUseProduitDto;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementAfpaModel;
  ListeProduitModeLivraison?: ArrayOfProduitModelivraisonDto;
  ListeProduitSectionAnalytique?: ArrayOfProduitSectionAnalytiqueDto;
  LivretDispo?: ChampValeurDto;
  ModeAvanceCadeau?: boolean;
  ModeleFraisAnnulation?: FraisAnnulationFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Nationalite?: ChampValeurDto;
  NbDisque?: ChampValeurDto;
  NbPlaceDispo?: number;
  Note?: ChampValeurDto;
  Numerotation?: ChampValeurDto;
  Pays?: PaysDto;
  Picto?: FichierModel;
  PrixAchat?: ChampValeurDto;
  ProposerReservationIndispo?: boolean;
  Realisateur?: ChampValeurDto;
  Reference?: ChampValeurDto;
  Region?: RegionDto;
  Remarque?: string;
  RetourMediaNouv?: MediaRetourDto;
  RetourMediaPasNouv?: MediaRetourDto;
  SeCommandeSeul?: boolean;
  SessionChoix?: SessionChoixDto;
  SousCollec?: ChampValeurDto;
  SousTitre?: ChampValeurDto;
  Status?: StatusDtoEnum;
  StockTypeReappro?: StockTypeReapproDto;
  Synopsis?: ChampValeurDto;
  Theme?: ChampValeurDto;
  TypeComportementProduit?: string;
  TypeDocumentPresente?: string;
  TypeFonctionnement?: string;
  TypeMedia?: ChampValeurDto;
};

export type ProduitDtoInput = {
  AfficherDirecto?: boolean;
  AnneeRef?: AnneeReferenceDtoInput;
  Auteur?: ChampValeurDtoInput;
  AutoriseCommEnLigne?: boolean;
  AutoriseQteDispoNegaVal?: boolean;
  AutoriseQteDispoNegativeAtt?: boolean;
  AutoriseQteNega?: boolean;
  AutoriserResaSupp?: boolean;
  CDU?: ChampValeurDtoInput;
  CapaciteMax?: number;
  CapaciteMin?: number;
  Cible?: ChampValeurDtoInput;
  Code?: string;
  Collection?: ChampValeurDtoInput;
  Cote?: ChampValeurDtoInput;
  CourrierAcceptation?: CourrierDtoInput;
  CourrierContractLoc?: CourrierDtoInput;
  CourrierRefus?: CourrierDtoInput;
  Cpt512?: CompteDtoInput;
  CptAchat?: CompteDtoInput;
  CptCollectifClient?: CompteDtoInput;
  CptCollectifFournisseur?: CompteDtoInput;
  CptValidationStock?: CompteDtoInput;
  CptVariationStock?: CompteDtoInput;
  CptVente?: CompteDtoInput;
  Critique?: ChampValeurDtoInput;
  DEWAY?: ChampValeurDtoInput;
  DateAchat?: ChampValeurDtoInput;
  DateDebutManifestation?: any;
  DateDebutRmbMensuel?: any;
  DateDebutVente?: any;
  DateDebutVisibilite?: any;
  DateEdition?: ChampValeurDtoInput;
  DateFinManifestation?: any;
  DateFinRmbMensuel?: any;
  DateFinVente?: any;
  DateFinVisibilite?: any;
  DateMaj?: any;
  DateNouveaute?: ChampValeurDtoInput;
  DatePourReappro?: any;
  DateSortie?: ChampValeurDtoInput;
  DateSubvention?: any;
  Description?: string;
  Duree?: ChampValeurDtoInput;
  Editeur?: ChampValeurDtoInput;
  Enveloppe?: EnveloppeQuotaDtoInput;
  EnveloppePresta?: EnveloppeQuotaDtoInput;
  Exercice?: ExerciceDtoInput;
  Famille?: FamilleProduitDtoInput;
  Format?: ChampValeurDtoInput;
  Fournisseur?: FournisseurDtoInput;
  Genre?: ChampValeurDtoInput;
  GererAllotement?: boolean;
  IDCAmazon?: boolean;
  ISBN10?: ChampValeurDtoInput;
  Id?: number;
  IdModeleTVA?: number;
  Image?: ChampValeurDtoInput;
  IsAttenteValidationBenef?: boolean;
  IsAttenteValidationCE?: boolean;
  IsCloture?: boolean;
  IsCrediterEnveloppe?: boolean;
  IsFacturationCentralise?: boolean;
  IsFacturationManuelle?: boolean;
  IsGestionParticipant?: boolean;
  IsGroupe?: boolean;
  IsMediatheque?: boolean;
  IsNotGereEnStock?: boolean;
  IsNotProposerReservationIndispo?: boolean;
  IsRemboursementCadeau?: boolean;
  IsRemboursementMensuel?: boolean;
  IsRemboursementPartACharge?: boolean;
  IsRemboursementPrestation?: boolean;
  IsSaisieChronologiqueRmbMensuel?: boolean;
  IsToutOuRien?: boolean;
  Libelle?: string;
  LibelleBoutonDetailVenteEnLigne?: string;
  LibellePrestaDateDebutActivite?: string;
  LibellePrestaDateFacture?: string;
  LibellePrestaDateFinActivite?: string;
  LibellePrestaMontantPresente?: string;
  LibellePrestaMontantPrisEnCompte?: string;
  LibellePrestaReferenceFacture?: string;
  Libre?: ChampValeurDtoInput;
  Lieu?: LieuDtoInput;
  LieuAchat?: ChampValeurDtoInput;
  ListDescriptionDirecto?: ArrayOfProduitDirectoDescriptionDtoInput;
  ListDocument?: ArrayOfFichierModelInput;
  ListeArticles?: ArrayOfArticleDtoInput;
  ListeChamps?: ArrayOfChampDtoInput;
  ListeChampsValeur?: ArrayOfChampValeurDtoInput;
  ListeCompteursPoints?: ArrayOfCompteurPointAfpaModelInput;
  ListeEnvImpProduit?: ArrayOfEnvImpProduitDtoInput;
  ListeFournisseursConventionnes?: ArrayOfFournisseurDtoInput;
  ListeModeleEcheancier?: ArrayOfModeleEcheancierGeneriqueModelInput;
  ListeMoteurRegleHeritageProduit?: ArrayOfMoteurRegleHeritageProduitDtoInput;
  ListeMoteurRegleUseProduit?: ArrayOfMoteurRegleUseProduitDtoInput;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementAfpaModelInput;
  ListeProduitModeLivraison?: ArrayOfProduitModelivraisonDtoInput;
  ListeProduitSectionAnalytique?: ArrayOfProduitSectionAnalytiqueDtoInput;
  LivretDispo?: ChampValeurDtoInput;
  ModeAvanceCadeau?: boolean;
  ModeleFraisAnnulation?: FraisAnnulationFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Nationalite?: ChampValeurDtoInput;
  NbDisque?: ChampValeurDtoInput;
  NbPlaceDispo?: number;
  Note?: ChampValeurDtoInput;
  Numerotation?: ChampValeurDtoInput;
  Pays?: PaysDtoInput;
  Picto?: FichierModelInput;
  PrixAchat?: ChampValeurDtoInput;
  ProposerReservationIndispo?: boolean;
  Realisateur?: ChampValeurDtoInput;
  Reference?: ChampValeurDtoInput;
  Region?: RegionDtoInput;
  Remarque?: string;
  RetourMediaNouv?: MediaRetourDtoInput;
  RetourMediaPasNouv?: MediaRetourDtoInput;
  SeCommandeSeul?: boolean;
  SessionChoix?: SessionChoixDtoInput;
  SousCollec?: ChampValeurDtoInput;
  SousTitre?: ChampValeurDtoInput;
  Status?: StatusDtoEnum;
  StockTypeReappro?: StockTypeReapproDtoInput;
  Synopsis?: ChampValeurDtoInput;
  Theme?: ChampValeurDtoInput;
  TypeComportementProduit?: string;
  TypeDocumentPresente?: string;
  TypeFonctionnement?: string;
  TypeMedia?: ChampValeurDtoInput;
};

export type ProduitDirectoDescriptionDto = {
  __typename?: 'ProduitDirectoDescriptionDTO';
  DescriptionHTML?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Produit?: ProduitDto;
  Status?: StatusDtoEnum;
  Titre?: string;
};

export type ProduitDirectoDescriptionDtoInput = {
  DescriptionHTML?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Produit?: ProduitDtoInput;
  Status?: StatusDtoEnum;
  Titre?: string;
};

export type ProduitInformationBaseModel = {
  __typename?: 'ProduitInformationBaseModel';
  CodeProduit?: string;
  DescriptionProduit?: string;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarqueProduit?: string;
  Status?: StatusDtoEnum;
};

export type ProduitInformationBaseModelInput = {
  CodeProduit?: string;
  DescriptionProduit?: string;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  RemarqueProduit?: string;
  Status?: StatusDtoEnum;
};

export type ProduitLightModel = {
  __typename?: 'ProduitLightModel';
  IdProduit?: number;
  Libelle?: string;
};

export type ProduitLightModelInput = {
  IdProduit?: number;
  Libelle?: string;
};

export type ProduitModel = {
  __typename?: 'ProduitModel';
  ID?: number;
  IdParent?: number;
  IsCloture?: boolean;
  Libelle?: string;
  ListArticle?: ArrayOfArticleModel;
  MustValidate?: boolean;
  MyGuid?: string;
  NbArticle?: number;
  Status?: StatusDtoEnum;
};

export type ProduitModelInput = {
  ID?: number;
  IdParent?: number;
  IsCloture?: boolean;
  Libelle?: string;
  ListArticle?: ArrayOfArticleModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbArticle?: number;
  Status?: StatusDtoEnum;
};

export type ProduitModelivraisonDto = {
  __typename?: 'ProduitModelivraisonDTO';
  IsDefaut?: boolean;
  ModeLivraison?: ModeLivraisonDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Produit?: ProduitDto;
  Status?: StatusDtoEnum;
};

export type ProduitModelivraisonDtoInput = {
  IsDefaut?: boolean;
  ModeLivraison?: ModeLivraisonDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Produit?: ProduitDtoInput;
  Status?: StatusDtoEnum;
};

export type ProduitReservationResxPartModel = {
  __typename?: 'ProduitReservationResxPartModel';
  HeureDebutResaDefaut?: any;
  HeureFinResaDefaut?: any;
  IdProduit?: number;
  IsGereEnStock?: boolean;
  Libelle?: string;
  NombreHeuresEmprunt?: number;
  NombreJoursEmprunt?: number;
  NombreMinutesEmprunt?: number;
};

export type ProduitReservationResxPartModelInput = {
  HeureDebutResaDefaut?: any;
  HeureFinResaDefaut?: any;
  IdProduit?: number;
  IsGereEnStock?: boolean;
  Libelle?: string;
  NombreHeuresEmprunt?: number;
  NombreJoursEmprunt?: number;
  NombreMinutesEmprunt?: number;
};

export type ProduitSectionAnalytiqueDto = {
  __typename?: 'ProduitSectionAnalytiqueDTO';
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueDto;
  Pourcentage?: number;
  Produit?: ProduitDto;
  SectionAnalytique?: SectionAnalytiqueDto;
  Status?: StatusDtoEnum;
};

export type ProduitSectionAnalytiqueDtoInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  PlanAnalytique?: PlanAnalytiqueDtoInput;
  Pourcentage?: number;
  Produit?: ProduitDtoInput;
  SectionAnalytique?: SectionAnalytiqueDtoInput;
  Status?: StatusDtoEnum;
};

export type ProduitWithArticleInfosModelDto = {
  __typename?: 'ProduitWithArticleInfosModelDTO';
  MustValidate?: boolean;
  MyGuid?: string;
  ProdHaveArticleWithStkMvt?: boolean;
  Produit?: ProduitDto;
  Status?: StatusDtoEnum;
};

export type ProduitWithArticleInfosModelDtoInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  ProdHaveArticleWithStkMvt?: boolean;
  Produit?: ProduitDtoInput;
  Status?: StatusDtoEnum;
};

export type ProfilDroitDto = {
  __typename?: 'ProfilDroitDTO';
  CEDelegation?: CeDelegationDto;
  Code?: string;
  ID?: number;
  IsAdministrateur?: boolean;
  IsSupprime?: boolean;
  Libelle?: string;
  ListeCodesFonctionnalites?: ArrayOfstring;
  ListeCodesWidgets?: ArrayOfstring;
  ListeMenus?: ArrayOfMenuDto;
  ListeUsersCE?: ArrayOfUsersCeDelegationDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ProfilDroitDtoInput = {
  CEDelegation?: CeDelegationDtoInput;
  Code?: string;
  ID?: number;
  IsAdministrateur?: boolean;
  IsSupprime?: boolean;
  Libelle?: string;
  ListeCodesFonctionnalites?: ArrayOfstringInput;
  ListeCodesWidgets?: ArrayOfstringInput;
  ListeMenus?: ArrayOfMenuDtoInput;
  ListeUsersCE?: ArrayOfUsersCeDelegationDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ProfilDroitMenuTypeActiviteModelDto = {
  __typename?: 'ProfilDroitMenuTypeActiviteModelDTO';
  ID?: number;
  IdMenu?: number;
  IdProfilDroit?: number;
  IdTypeActivite?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ProfilDroitMenuTypeActiviteModelDtoInput = {
  ID?: number;
  IdMenu?: number;
  IdProfilDroit?: number;
  IdTypeActivite?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ProfilEspaceCse = {
  __typename?: 'ProfilEspaceCSE';
  IdProfile?: string;
  NomProfile?: string;
};

export type ProfilEspaceCseInput = {
  IdProfile?: string;
  NomProfile?: string;
};

export type ProfilKalideaModelDto = {
  __typename?: 'ProfilKalideaModelDTO';
  CodeProfilKalidea?: string;
  IdProfilKalidea?: number;
  LibelleProfilKalidea?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ProfilKalideaModelDtoInput = {
  CodeProfilKalidea?: string;
  IdProfilKalidea?: number;
  LibelleProfilKalidea?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ProfilSubventionModelDto = {
  __typename?: 'ProfilSubventionModelDTO';
  DateSynchroSynapse?: any;
  IdProfilSubvention?: number;
  IsClos?: boolean;
  Label?: string;
  UuidProfilSubvention?: string;
};

export type ProfilSubventionModelDtoInput = {
  DateSynchroSynapse?: any;
  IdProfilSubvention?: number;
  IsClos?: boolean;
  Label?: string;
  UuidProfilSubvention?: string;
};

export type ProgressionImportEnCoursModelDto = {
  __typename?: 'ProgressionImportEnCoursModelDTO';
  IdImport?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreLigneTot?: number;
  NombreLigneTraite?: number;
  Status?: StatusDtoEnum;
};

export type ProgressionImportEnCoursModelDtoInput = {
  IdImport?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreLigneTot?: number;
  NombreLigneTraite?: number;
  Status?: StatusDtoEnum;
};

export type ProgressionModel = {
  __typename?: 'ProgressionModel';
  Goal?: number;
  ProcessIdentifier?: number;
  ProcessType?: string;
  Step?: number;
};

export type ProgressionModelInput = {
  Goal?: number;
  ProcessIdentifier?: number;
  ProcessType?: string;
  Step?: number;
};

export type PubliChampsBaseModel = {
  __typename?: 'PubliChampsBaseModel';
  CodeChamps?: string;
  IdChamps?: number;
  LibelleChamps?: string;
};

export type PubliChampsBaseModelInput = {
  CodeChamps?: string;
  IdChamps?: number;
  LibelleChamps?: string;
};

export type PubliChampsGroupeAffichageModel = {
  __typename?: 'PubliChampsGroupeAffichageModel';
  IdGroupe?: number;
  LibelleGroupe?: string;
  ListeChamps?: ArrayOfanyType;
  Ordre?: number;
};

export type PubliChampsGroupeAffichageModelInput = {
  IdGroupe?: number;
  LibelleGroupe?: string;
  ListeChamps?: ArrayOfanyTypeInput;
  Ordre?: number;
};

export type PubliChampsVueModel = {
  __typename?: 'PubliChampsVueModel';
  CodeChamps?: string;
  IdChamps?: number;
  LibelleChamps?: string;
  OrdreChamps?: number;
};

export type PubliChampsVueModelInput = {
  CodeChamps?: string;
  IdChamps?: number;
  LibelleChamps?: string;
  OrdreChamps?: number;
};

export type PubliDocumentReportModel = {
  __typename?: 'PubliDocumentReportModel';
  CodeDocument?: string;
  IdDocumentContexte?: number;
  IdReport?: number;
  LibelleDocumentContexte?: string;
};

export type PubliDocumentReportModelInput = {
  CodeDocument?: string;
  IdDocumentContexte?: number;
  IdReport?: number;
  LibelleDocumentContexte?: string;
};

export type PubliRequeteListerModel = {
  __typename?: 'PubliRequeteListerModel';
  ContexteId?: number;
  DateDerniereUtilisation?: any;
  IsDeclencheurStatutPerso?: boolean;
  LibelleContexte?: string;
  RequeteDescription?: string;
  RequeteId?: number;
  RequeteLibelle?: string;
};

export type PubliRequeteListerModelInput = {
  ContexteId?: number;
  DateDerniereUtilisation?: any;
  IsDeclencheurStatutPerso?: boolean;
  LibelleContexte?: string;
  RequeteDescription?: string;
  RequeteId?: number;
  RequeteLibelle?: string;
};

export type PubliTypeCourrierPossibleModel = {
  __typename?: 'PubliTypeCourrierPossibleModel';
  CodeType?: string;
  IdType?: number;
  IsEnvoiCourrierPossible?: boolean;
  LibelleType?: string;
};

export type PubliTypeCourrierPossibleModelInput = {
  CodeType?: string;
  IdType?: number;
  IsEnvoiCourrierPossible?: boolean;
  LibelleType?: string;
};

export type PubliVueBaseInfoModel = {
  __typename?: 'PubliVueBaseInfoModel';
  CodeVue?: string;
  IdTypePublipostage?: number;
  IdVue?: number;
  IsClos?: boolean;
  IsDefautVUP?: boolean;
  IsNonSupprimable?: boolean;
  LibelleVue?: string;
};

export type PubliVueBaseInfoModelInput = {
  CodeVue?: string;
  IdTypePublipostage?: number;
  IdVue?: number;
  IsClos?: boolean;
  IsDefautVUP?: boolean;
  IsNonSupprimable?: boolean;
  LibelleVue?: string;
};

export type PublipostageCourrierPublipostageVueModel = {
  __typename?: 'PublipostageCourrierPublipostageVueModel';
  IdCourrier?: number;
  IdVueRattachee?: number;
  Titre?: string;
};

export type PublipostageCourrierPublipostageVueModelInput = {
  IdCourrier?: number;
  IdVueRattachee?: number;
  Titre?: string;
};

export type PublipostageCriteresCourrierPublipostageModelInput = {
  CodeTypeReport?: string;
  IdActivite?: number;
  IdContextePublipostage?: number;
  IdCourrier?: number;
  IsClos?: boolean;
  ListeCodeTypeReport?: ArrayOfstringInput;
};

export type QuantiteArticlesFournisseur = {
  __typename?: 'QuantiteArticlesFournisseur';
  QuantiteGenerique?: number;
  QuantiteReappro?: number;
};

export type QuantiteArticlesFournisseurInput = {
  QuantiteGenerique?: number;
  QuantiteReappro?: number;
};

export type Query = {};















































































































































































































































































































































































export type QuotaModeleRegleQuotaBaseInput = {
  IdModeleRegle?: number;
  IsForcageAutorise?: boolean;
  IsVenteSansSubvention?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  OrdreModeleRegle?: number;
  Status?: StatusDtoEnum;
  TypeModeleRegle?: string;
  TypeValeurModeleRegle?: string;
};

export type RadgridviewPagineModelDtoOfActualiteMobileListeModelDtoWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfActualiteMobileListeModelDTOWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfActualiteMobileListeModelDto;
};

export type RadgridviewPagineModelDtoOfActualiteMobileListeModelDtoWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfActualiteMobileListeModelDtoInput;
};

export type RadgridviewPagineModelDtoOfArreteEtRemiseCaisseListerModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfArreteEtRemiseCaisseListerModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfArreteEtRemiseCaisseListerModel;
};

export type RadgridviewPagineModelDtoOfArreteEtRemiseCaisseListerModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfArreteEtRemiseCaisseListerModelInput;
};

export type RadgridviewPagineModelDtoOfArticleAttributionAutoWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfArticleAttributionAutoWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfArticleAttributionAuto;
};

export type RadgridviewPagineModelDtoOfArticleAttributionAutoWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfArticleAttributionAutoInput;
};

export type RadgridviewPagineModelDtoOfArticleEditorielPortletModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfArticleEditorielPortletModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfArticleEditorielPortletModel;
};

export type RadgridviewPagineModelDtoOfArticleEditorielPortletModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfArticleEditorielPortletModelInput;
};

export type RadgridviewPagineModelDtoOfArticleImputationEnErreurModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfArticleImputationEnErreurModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfArticleImputationEnErreurModel;
};

export type RadgridviewPagineModelDtoOfArticleImputationEnErreurModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfArticleImputationEnErreurModelInput;
};

export type RadgridviewPagineModelDtoOfAttributionsLigneCommandeAttributionModel9TKbPa9D = {
  __typename?: 'RadgridviewPagineModelDTOOfAttributionsLigneCommandeAttributionModel9TKbPA9D';
  Count?: number;
  ListeElements?: ArrayOfAttributionsLigneCommandeAttributionModel;
};

export type RadgridviewPagineModelDtoOfAttributionsLigneCommandeAttributionModel9TKbPa9DInput = {
  Count?: number;
  ListeElements?: ArrayOfAttributionsLigneCommandeAttributionModelInput;
};

export type RadgridviewPagineModelDtoOfBlbrListModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfBLBRListModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfBlbrListModel;
};

export type RadgridviewPagineModelDtoOfBlbrListModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfBlbrListModelInput;
};

export type RadgridviewPagineModelDtoOfBenefDtoWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfBenefDTOWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfBenefDto;
};

export type RadgridviewPagineModelDtoOfBenefDtoWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfBenefDtoInput;
};

export type RadgridviewPagineModelDtoOfCadeauFpaModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfCadeauFPAModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfCadeauFpaModel;
};

export type RadgridviewPagineModelDtoOfCadeauFpaModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfCadeauFpaModelInput;
};

export type RadgridviewPagineModelDtoOfClotureReportDesTiersModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfClotureReportDesTiersModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfClotureReportDesTiersModel;
};

export type RadgridviewPagineModelDtoOfClotureReportDesTiersModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfClotureReportDesTiersModelInput;
};

export type RadgridviewPagineModelDtoOfClotureVariationStockModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfClotureVariationStockModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfClotureVariationStockModel;
};

export type RadgridviewPagineModelDtoOfClotureVariationStockModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfClotureVariationStockModelInput;
};

export type RadgridviewPagineModelDtoOfCommandeBeneficiairePartAChargeListingModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfCommandeBeneficiairePartAChargeListingModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfCommandeBeneficiairePartAChargeListingModel;
};

export type RadgridviewPagineModelDtoOfCommandeBeneficiairePartAChargeListingModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfCommandeBeneficiairePartAChargeListingModelInput;
};

export type RadgridviewPagineModelDtoOfCommandeFournisseurListingModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfCommandeFournisseurListingModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfCommandeFournisseurListingModel;
};

export type RadgridviewPagineModelDtoOfCommandeFournisseurListingModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfCommandeFournisseurListingModelInput;
};

export type RadgridviewPagineModelDtoOfCommandeFournisseurPartAChargeListingModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfCommandeFournisseurPartAChargeListingModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfCommandeFournisseurPartAChargeListingModel;
};

export type RadgridviewPagineModelDtoOfCommandeFournisseurPartAChargeListingModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfCommandeFournisseurPartAChargeListingModelInput;
};

export type RadgridviewPagineModelDtoOfCommandeLivraisonModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfCommandeLivraisonModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfCommandeLivraisonModel;
};

export type RadgridviewPagineModelDtoOfCommandeLivraisonModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfCommandeLivraisonModelInput;
};

export type RadgridviewPagineModelDtoOfCommentaireModerationModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfCommentaireModerationModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfCommentaireModerationModel;
};

export type RadgridviewPagineModelDtoOfCommentaireModerationModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfCommentaireModerationModelInput;
};

export type RadgridviewPagineModelDtoOfComptaMouvementComptableModelDtOnJ9m3fvh = {
  __typename?: 'RadgridviewPagineModelDTOOfComptaMouvementComptableModelDTOnJ9m3fvh';
  Count?: number;
  ListeElements?: ArrayOfComptaMouvementComptableModelDto;
};

export type RadgridviewPagineModelDtoOfComptaMouvementComptableModelDtOnJ9m3fvhInput = {
  Count?: number;
  ListeElements?: ArrayOfComptaMouvementComptableModelDtoInput;
};

export type RadgridviewPagineModelDtoOfCompteClotureForTresorieWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfCompteClotureForTresorieWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfCompteClotureForTresorie;
};

export type RadgridviewPagineModelDtoOfCompteClotureForTresorieWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfCompteClotureForTresorieInput;
};

export type RadgridviewPagineModelDtoOfConstantes_StatutsMediathquesLigneReservationModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfConstantes_StatutsMediathquesLigneReservationModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfConstantes_StatutsMediathquesLigneReservationModel;
};

export type RadgridviewPagineModelDtoOfConstantes_StatutsMediathquesLigneReservationModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfConstantes_StatutsMediathquesLigneReservationModelInput;
};

export type RadgridviewPagineModelDtoOfConsultationMouvementConsommationModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfConsultationMouvementConsommationModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfConsultationMouvementConsommationModel;
};

export type RadgridviewPagineModelDtoOfConsultationMouvementConsommationModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfConsultationMouvementConsommationModelInput;
};

export type RadgridviewPagineModelDtoOfCorrectionImputationArticleModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfCorrectionImputationArticleModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfCorrectionImputationArticleModel;
};

export type RadgridviewPagineModelDtoOfCorrectionImputationArticleModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfCorrectionImputationArticleModelInput;
};

export type RadgridviewPagineModelDtoOfCorrectionMontantMouvementModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfCorrectionMontantMouvementModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfCorrectionMontantMouvementModel;
};

export type RadgridviewPagineModelDtoOfCorrectionMontantMouvementModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfCorrectionMontantMouvementModelInput;
};

export type RadgridviewPagineModelDtoOfCorrectionRepartitionAnalytiqueModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfCorrectionRepartitionAnalytiqueModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfCorrectionRepartitionAnalytiqueModel;
};

export type RadgridviewPagineModelDtoOfCorrectionRepartitionAnalytiqueModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfCorrectionRepartitionAnalytiqueModelInput;
};

export type RadgridviewPagineModelDtoOfDevisCommandeDtoWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfDevisCommandeDTOWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfDevisCommandeDto;
};

export type RadgridviewPagineModelDtoOfDevisCommandeDtoWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfDevisCommandeDtoInput;
};

export type RadgridviewPagineModelDtoOfDevisCommandeListingModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfDevisCommandeListingModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfDevisCommandeListingModel;
};

export type RadgridviewPagineModelDtoOfDevisCommandeListingModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfDevisCommandeListingModelInput;
};

export type RadgridviewPagineModelDtoOfDevisCommandeModelDtoWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfDevisCommandeModelDTOWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfDevisCommandeModelDto;
};

export type RadgridviewPagineModelDtoOfDevisCommandeModelDtoWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfDevisCommandeModelDtoInput;
};

export type RadgridviewPagineModelDtoOfDossierEpargneListerModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfDossierEpargneListerModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfDossierEpargneListerModel;
};

export type RadgridviewPagineModelDtoOfDossierEpargneListerModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfDossierEpargneListerModelInput;
};

export type RadgridviewPagineModelDtoOfDossierPrestationPieceJustificativeForRechercheModelDtOgD04_PDwX = {
  __typename?: 'RadgridviewPagineModelDTOOfDossierPrestationPieceJustificativeForRechercheModelDTOgD04_PDwX';
  Count?: number;
  ListeElements?: ArrayOfDossierPrestationPieceJustificativeForRechercheModelDto;
};

export type RadgridviewPagineModelDtoOfDossierPrestationPieceJustificativeForRechercheModelDtOgD04_PDwXInput = {
  Count?: number;
  ListeElements?: ArrayOfDossierPrestationPieceJustificativeForRechercheModelDtoInput;
};

export type RadgridviewPagineModelDtoOfDossierPrestationPieceJustificativeForWidgetModelDtOgD04_PDwX = {
  __typename?: 'RadgridviewPagineModelDTOOfDossierPrestationPieceJustificativeForWidgetModelDTOgD04_PDwX';
  Count?: number;
  ListeElements?: ArrayOfDossierPrestationPieceJustificativeForWidgetModelDto;
};

export type RadgridviewPagineModelDtoOfDossierPrestationPieceJustificativeForWidgetModelDtOgD04_PDwXInput = {
  Count?: number;
  ListeElements?: ArrayOfDossierPrestationPieceJustificativeForWidgetModelDtoInput;
};

export type RadgridviewPagineModelDtoOfEcheancierModelDtoWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfEcheancierModelDTOWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfEcheancierModelDto;
};

export type RadgridviewPagineModelDtoOfEcheancierModelDtoWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfEcheancierModelDtoInput;
};

export type RadgridviewPagineModelDtoOfEcritureAnalytiqueEnErreurModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfEcritureAnalytiqueEnErreurModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfEcritureAnalytiqueEnErreurModel;
};

export type RadgridviewPagineModelDtoOfEcritureAnalytiqueEnErreurModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfEcritureAnalytiqueEnErreurModelInput;
};

export type RadgridviewPagineModelDtoOfEcritureBalanceOuvertureModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfEcritureBalanceOuvertureModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfEcritureBalanceOuvertureModel;
};

export type RadgridviewPagineModelDtoOfEcritureBalanceOuvertureModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfEcritureBalanceOuvertureModelInput;
};

export type RadgridviewPagineModelDtoOfEcritureDesequilibreeModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfEcritureDesequilibreeModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfEcritureDesequilibreeModel;
};

export type RadgridviewPagineModelDtoOfEcritureDesequilibreeModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfEcritureDesequilibreeModelInput;
};

export type RadgridviewPagineModelDtoOfEcritureExportModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfEcritureExportModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfEcritureExportModel;
};

export type RadgridviewPagineModelDtoOfEcritureExportModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfEcritureExportModelInput;
};

export type RadgridviewPagineModelDtoOfEcritureListingModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfEcritureListingModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfEcritureListingModel;
};

export type RadgridviewPagineModelDtoOfEcritureListingModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfEcritureListingModelInput;
};

export type RadgridviewPagineModelDtoOfExemplaireMediathequeRechercheMediaModelDtOs7iMPt1y = {
  __typename?: 'RadgridviewPagineModelDTOOfExemplaireMediathequeRechercheMediaModelDTOs7iMPt1y';
  Count?: number;
  ListeElements?: ArrayOfExemplaireMediathequeRechercheMediaModelDto;
};

export type RadgridviewPagineModelDtoOfExemplaireMediathequeRechercheMediaModelDtOs7iMPt1yInput = {
  Count?: number;
  ListeElements?: ArrayOfExemplaireMediathequeRechercheMediaModelDtoInput;
};

export type RadgridviewPagineModelDtoOfFactureHistoriqueModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfFactureHistoriqueModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfFactureHistoriqueModel;
};

export type RadgridviewPagineModelDtoOfFactureHistoriqueModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfFactureHistoriqueModelInput;
};

export type RadgridviewPagineModelDtoOfFactureInfosFactureModel8lIa1pkA = {
  __typename?: 'RadgridviewPagineModelDTOOfFactureInfosFactureModel8lIA1pkA';
  Count?: number;
  ListeElements?: ArrayOfFactureInfosFactureModel;
};

export type RadgridviewPagineModelDtoOfFactureInfosFactureModel8lIa1pkAInput = {
  Count?: number;
  ListeElements?: ArrayOfFactureInfosFactureModelInput;
};

export type RadgridviewPagineModelDtoOfHistoriqueCourrierHistoriquePublipostageModel_SnbEoFHh = {
  __typename?: 'RadgridviewPagineModelDTOOfHistoriqueCourrierHistoriquePublipostageModel_SnbEoFHh';
  Count?: number;
  ListeElements?: ArrayOfHistoriqueCourrierHistoriquePublipostageModel;
};

export type RadgridviewPagineModelDtoOfHistoriqueCourrierHistoriquePublipostageModel_SnbEoFHhInput = {
  Count?: number;
  ListeElements?: ArrayOfHistoriqueCourrierHistoriquePublipostageModelInput;
};

export type RadgridviewPagineModelDtoOfHistoriqueModifBenefsHistoriqueModifBenefForAffichageModelDjsizrkj = {
  __typename?: 'RadgridviewPagineModelDTOOfHistoriqueModifBenefsHistoriqueModifBenefForAffichageModelDjsizrkj';
  Count?: number;
  ListeElements?: ArrayOfHistoriqueModifBenefsHistoriqueModifBenefForAffichageModel;
};

export type RadgridviewPagineModelDtoOfHistoriqueModifBenefsHistoriqueModifBenefForAffichageModelDjsizrkjInput = {
  Count?: number;
  ListeElements?: ArrayOfHistoriqueModifBenefsHistoriqueModifBenefForAffichageModelInput;
};

export type RadgridviewPagineModelDtoOfImportHistoDetailsModelDtoWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfImportHistoDetailsModelDTOWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfImportHistoDetailsModelDto;
};

export type RadgridviewPagineModelDtoOfImportHistoDetailsModelDtoWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfImportHistoDetailsModelDtoInput;
};

export type RadgridviewPagineModelDtoOfImportLogsDetaillesModelDtoWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfImportLogsDetaillesModelDTOWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfImportLogsDetaillesModelDto;
};

export type RadgridviewPagineModelDtoOfImportLogsDetaillesModelDtoWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfImportLogsDetaillesModelDtoInput;
};

export type RadgridviewPagineModelDtoOfInfosArticleCadeaux5_PhkmGrb = {
  __typename?: 'RadgridviewPagineModelDTOOfInfosArticleCadeaux5_PhkmGrb';
  Count?: number;
  ListeElements?: ArrayOfInfosArticleCadeaux;
};

export type RadgridviewPagineModelDtoOfInfosArticleCadeaux5_PhkmGrbInput = {
  Count?: number;
  ListeElements?: ArrayOfInfosArticleCadeauxInput;
};

export type RadgridviewPagineModelDtoOfInfosDevisCdeInscriptionGroupeModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfInfosDevisCdeInscriptionGroupeModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfInfosDevisCdeInscriptionGroupeModel;
};

export type RadgridviewPagineModelDtoOfInfosDevisCdeInscriptionGroupeModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfInfosDevisCdeInscriptionGroupeModelInput;
};

export type RadgridviewPagineModelDtoOfInfosDossiersPretsEtDonsHistoriqueModelDtoWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfInfosDossiersPretsEtDonsHistoriqueModelDTOWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfInfosDossiersPretsEtDonsHistoriqueModelDto;
};

export type RadgridviewPagineModelDtoOfInfosDossiersPretsEtDonsHistoriqueModelDtoWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfInfosDossiersPretsEtDonsHistoriqueModelDtoInput;
};

export type RadgridviewPagineModelDtoOfLigneCessionStockDetailModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfLigneCessionStockDetailModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfLigneCessionStockDetailModel;
};

export type RadgridviewPagineModelDtoOfLigneCessionStockDetailModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfLigneCessionStockDetailModelInput;
};

export type RadgridviewPagineModelDtoOfLigneCommandeHistoriqueReservationRpModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfLigneCommandeHistoriqueReservationRPModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfLigneCommandeHistoriqueReservationRpModel;
};

export type RadgridviewPagineModelDtoOfLigneCommandeHistoriqueReservationRpModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfLigneCommandeHistoriqueReservationRpModelInput;
};

export type RadgridviewPagineModelDtoOfLigneInventaireStockModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfLigneInventaireStockModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfLigneInventaireStockModel;
};

export type RadgridviewPagineModelDtoOfLigneInventaireStockModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfLigneInventaireStockModelInput;
};

export type RadgridviewPagineModelDtoOfLigneReceptionCessionStockModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfLigneReceptionCessionStockModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfLigneReceptionCessionStockModel;
};

export type RadgridviewPagineModelDtoOfLigneReceptionCessionStockModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfLigneReceptionCessionStockModelInput;
};

export type RadgridviewPagineModelDtoOfListerRessourceModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfListerRessourceModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfListerRessourceModel;
};

export type RadgridviewPagineModelDtoOfListerRessourceModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfListerRessourceModelInput;
};

export type RadgridviewPagineModelDtoOfLocationTauxOccupationModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfLocationTauxOccupationModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfLocationTauxOccupationModel;
};

export type RadgridviewPagineModelDtoOfLocationTauxOccupationModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfLocationTauxOccupationModelInput;
};

export type RadgridviewPagineModelDtoOfMediathequeListeCatalogueMediaModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfMediathequeListeCatalogueMediaModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfMediathequeListeCatalogueMediaModel;
};

export type RadgridviewPagineModelDtoOfMediathequeListeCatalogueMediaModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfMediathequeListeCatalogueMediaModelInput;
};

export type RadgridviewPagineModelDtoOfMouvementAnalytiqueModelDtoWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfMouvementAnalytiqueModelDTOWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfMouvementAnalytiqueModelDto;
};

export type RadgridviewPagineModelDtoOfMouvementAnalytiqueModelDtoWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfMouvementAnalytiqueModelDtoInput;
};

export type RadgridviewPagineModelDtoOfMouvementCollectifSansTiersModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfMouvementCollectifSansTiersModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfMouvementCollectifSansTiersModel;
};

export type RadgridviewPagineModelDtoOfMouvementCollectifSansTiersModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfMouvementCollectifSansTiersModelInput;
};

export type RadgridviewPagineModelDtoOfMouvementComptableInfosGeneralesModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfMouvementComptableInfosGeneralesModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfMouvementComptableInfosGeneralesModel;
};

export type RadgridviewPagineModelDtoOfMouvementComptableInfosGeneralesModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfMouvementComptableInfosGeneralesModelInput;
};

export type RadgridviewPagineModelDtoOfMouvementSansTiersDetailModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfMouvementSansTiersDetailModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfMouvementSansTiersDetailModel;
};

export type RadgridviewPagineModelDtoOfMouvementSansTiersDetailModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfMouvementSansTiersDetailModelInput;
};

export type RadgridviewPagineModelDtoOfMouvementStockModelDtoWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfMouvementStockModelDTOWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfMouvementStockModelDto;
};

export type RadgridviewPagineModelDtoOfMouvementStockModelDtoWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfMouvementStockModelDtoInput;
};

export type RadgridviewPagineModelDtoOfPubliRequeteListerModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfPubliRequeteListerModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfPubliRequeteListerModel;
};

export type RadgridviewPagineModelDtoOfPubliRequeteListerModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfPubliRequeteListerModelInput;
};

export type RadgridviewPagineModelDtoOfPubliVueBaseInfoModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfPubliVueBaseInfoModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfPubliVueBaseInfoModel;
};

export type RadgridviewPagineModelDtoOfPubliVueBaseInfoModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfPubliVueBaseInfoModelInput;
};

export type RadgridviewPagineModelDtoOfRecetteDepenseEcritureRecetteDepenseModelDto5szyLq5Y = {
  __typename?: 'RadgridviewPagineModelDTOOfRecetteDepenseEcritureRecetteDepenseModelDTO5szyLQ5Y';
  Count?: number;
  ListeElements?: ArrayOfRecetteDepenseEcritureRecetteDepenseModelDto;
};

export type RadgridviewPagineModelDtoOfRecetteDepenseEcritureRecetteDepenseModelDto5szyLq5YInput = {
  Count?: number;
  ListeElements?: ArrayOfRecetteDepenseEcritureRecetteDepenseModelDtoInput;
};

export type RadgridviewPagineModelDtoOfRemiseEnBanqueModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfRemiseEnBanqueModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfRemiseEnBanqueModel;
};

export type RadgridviewPagineModelDtoOfRemiseEnBanqueModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfRemiseEnBanqueModelInput;
};

export type RadgridviewPagineModelDtoOfSoldePmvModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfSoldePMVModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfSoldePmvModel;
};

export type RadgridviewPagineModelDtoOfSoldePmvModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfSoldePmvModelInput;
};

export type RadgridviewPagineModelDtoOfTransfertStockPourListeModelWfN5Koph = {
  __typename?: 'RadgridviewPagineModelDTOOfTransfertStockPourListeModelWfN5Koph';
  Count?: number;
  ListeElements?: ArrayOfTransfertStockPourListeModel;
};

export type RadgridviewPagineModelDtoOfTransfertStockPourListeModelWfN5KophInput = {
  Count?: number;
  ListeElements?: ArrayOfTransfertStockPourListeModelInput;
};

export type RapportRegleModelDto = {
  __typename?: 'RapportRegleModelDTO';
  IdRegle?: number;
  LibelleRegle?: string;
  ListeReglesAFPA?: ArrayOfKeyValueModelDto;
  ListeReglesApplication?: ArrayOfKeyValueModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PossedeMouvementsEnveloppe?: boolean;
  Status?: StatusDtoEnum;
  TypeRegle?: TypesRegleEnum;
};

export type RapportRegleModelDtoInput = {
  IdRegle?: number;
  LibelleRegle?: string;
  ListeReglesAFPA?: ArrayOfKeyValueModelDtoInput;
  ListeReglesApplication?: ArrayOfKeyValueModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PossedeMouvementsEnveloppe?: boolean;
  Status?: StatusDtoEnum;
  TypeRegle?: TypesRegleEnum;
};

export type RapprochementDto = {
  __typename?: 'RapprochementDTO';
  DateArchive?: any;
  DateCreation?: any;
  DateValidation?: any;
  Id?: number;
  IsArchive?: boolean;
  IsValide?: boolean;
  ListeRapprochementLigne?: ArrayOfRapprochementLigneDto;
  MustValidate?: boolean;
  MyGuid?: string;
  ReleveBancaire?: ReleveBancaireDto;
  Remarque?: string;
  SoldeInitial512?: number;
  Status?: StatusDtoEnum;
  User?: UsersDto;
};

export type RapprochementDtoInput = {
  DateArchive?: any;
  DateCreation?: any;
  DateValidation?: any;
  Id?: number;
  IsArchive?: boolean;
  IsValide?: boolean;
  ListeRapprochementLigne?: ArrayOfRapprochementLigneDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  ReleveBancaire?: ReleveBancaireDtoInput;
  Remarque?: string;
  SoldeInitial512?: number;
  Status?: StatusDtoEnum;
  User?: UsersDtoInput;
};

export type RapprochementLigneDto = {
  __typename?: 'RapprochementLigneDTO';
  DateEcheance?: any;
  DateMouvement?: any;
  Id?: number;
  Libelle?: string;
  Montant?: number;
  Mouvement?: MouvementComptableDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanqueCheque?: string;
  NomTire?: string;
  NumPiece?: string;
  NumeroCheque?: string;
  NumeroReference?: string;
  Ordre?: number;
  Rapprochement?: RapprochementDto;
  Remarque?: string;
  SensEcriture?: string;
  Status?: StatusDtoEnum;
};

export type RapprochementLigneDtoInput = {
  DateEcheance?: any;
  DateMouvement?: any;
  Id?: number;
  Libelle?: string;
  Montant?: number;
  Mouvement?: MouvementComptableDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanqueCheque?: string;
  NomTire?: string;
  NumPiece?: string;
  NumeroCheque?: string;
  NumeroReference?: string;
  Ordre?: number;
  Rapprochement?: RapprochementDtoInput;
  Remarque?: string;
  SensEcriture?: string;
  Status?: StatusDtoEnum;
};

export type RecapitulatifCompteValorisationModel = {
  __typename?: 'RecapitulatifCompteValorisationModel';
  IdCompteValorisation?: number;
  LibelleCompteValorisation?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompteValorisation?: string;
  SommeValorisation?: number;
  Status?: StatusDtoEnum;
};

export type RecapitulatifCompteValorisationModelInput = {
  IdCompteValorisation?: number;
  LibelleCompteValorisation?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompteValorisation?: string;
  SommeValorisation?: number;
  Status?: StatusDtoEnum;
};

export type RecapitulatifCompteVariationModel = {
  __typename?: 'RecapitulatifCompteVariationModel';
  IdCompteVariation?: number;
  LibelleCompteVariation?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompteVariation?: string;
  SommeMouvementsCredit?: number;
  SommeMouvementsDebit?: number;
  Status?: StatusDtoEnum;
};

export type RecapitulatifCompteVariationModelInput = {
  IdCompteVariation?: number;
  LibelleCompteVariation?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroCompteVariation?: string;
  SommeMouvementsCredit?: number;
  SommeMouvementsDebit?: number;
  Status?: StatusDtoEnum;
};

export type RecetteDepenseEcritureRecetteDepenseModelDto = {
  __typename?: 'RecetteDepenseEcritureRecetteDepenseModelDTO';
  CodeMoyenPaiement?: string;
  DateEcriture?: any;
  Depense?: number;
  IdActivite?: number;
  IdBeneficiaire?: number;
  IdEcriture?: number;
  IdFournisseur?: number;
  Imputation?: string;
  ImputationAnalytique?: string;
  IsRapproche?: boolean;
  Libelle?: string;
  LibelleActivite?: string;
  LibelleMoyenPaiement?: string;
  ListePJ?: ArrayOfComptaPjComptableConsultationModel;
  NomBeneficiaire?: string;
  NomCECreePar?: string;
  NomCESource?: string;
  NomFournisseur?: string;
  NumeroCheque?: string;
  Recette?: number;
  Reference?: string;
  Remarque?: string;
  RibIBAN?: string;
};

export type RecetteDepenseEcritureRecetteDepenseModelDtoInput = {
  CodeMoyenPaiement?: string;
  DateEcriture?: any;
  Depense?: number;
  IdActivite?: number;
  IdBeneficiaire?: number;
  IdEcriture?: number;
  IdFournisseur?: number;
  Imputation?: string;
  ImputationAnalytique?: string;
  IsRapproche?: boolean;
  Libelle?: string;
  LibelleActivite?: string;
  LibelleMoyenPaiement?: string;
  ListePJ?: ArrayOfComptaPjComptableConsultationModelInput;
  NomBeneficiaire?: string;
  NomCECreePar?: string;
  NomCESource?: string;
  NomFournisseur?: string;
  NumeroCheque?: string;
  Recette?: number;
  Reference?: string;
  Remarque?: string;
  RibIBAN?: string;
};

export type RechercheSoldeConsommationsDto = {
  __typename?: 'RechercheSoldeConsommationsDTO';
  ListeActivite?: ArrayOfActiviteModel;
  ListeEnveloppe?: ArrayOfModeleEnveloppeDto;
  ListeFamille?: ArrayOfFamilleProduitModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RechercheSoldeConsommationsDtoInput = {
  ListeActivite?: ArrayOfActiviteModelInput;
  ListeEnveloppe?: ArrayOfModeleEnveloppeDtoInput;
  ListeFamille?: ArrayOfFamilleProduitModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RefCalcAgeSynAdModelDto = {
  __typename?: 'RefCalcAgeSynAdModelDTO';
  CodeRefAge?: string;
  LibelleRefAge?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RefCalcAgeSynAdModelDtoInput = {
  CodeRefAge?: string;
  LibelleRefAge?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RegionDto = {
  __typename?: 'RegionDTO';
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Pays?: PaysDto;
  Status?: StatusDtoEnum;
};

export type RegionDtoInput = {
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Pays?: PaysDtoInput;
  Status?: StatusDtoEnum;
};

export type RegleAfpaModel = {
  __typename?: 'RegleAFPAModel';
  IdModeleRegle?: number;
  IdRegle?: number;
  IsDeleted?: boolean;
  IsRegleActivite?: boolean;
  IsRegleArticle?: boolean;
  IsRegleAttribution?: boolean;
  IsRegleComplementaire?: boolean;
  IsRegleExpert?: boolean;
  IsRegleFamille?: boolean;
  IsRegleHeritage?: boolean;
  IsRegleProduit?: boolean;
  IsRegleTransverse?: boolean;
  IsUsedRegleHeritee?: boolean;
  LibelleAFPA?: LibelleAfpaModel;
  LibelleRegle?: string;
  ModeleRegle?: Union_37323748901697156950;
  ModeleRegleExpert?: MoteurRegleModelDto;
  ModeleRegleExpertSubventionComplementaire?: RegleComplementaireModelDto;
  ModeleSauvegarde?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  TypeRegleBase?: string;
  TypeValeur?: string;
};

export type RegleAfpaModelInput = {
  IdModeleRegle?: number;
  IdRegle?: number;
  IsDeleted?: boolean;
  IsRegleActivite?: boolean;
  IsRegleArticle?: boolean;
  IsRegleAttribution?: boolean;
  IsRegleComplementaire?: boolean;
  IsRegleExpert?: boolean;
  IsRegleFamille?: boolean;
  IsRegleHeritage?: boolean;
  IsRegleProduit?: boolean;
  IsRegleTransverse?: boolean;
  IsUsedRegleHeritee?: boolean;
  LibelleAFPA?: LibelleAfpaModelInput;
  LibelleRegle?: string;
  ModeleRegle?: ModeleRegleAfpaBaseInput;
  ModeleRegleExpert?: MoteurRegleModelDtoInput;
  ModeleRegleExpertSubventionComplementaire?: RegleComplementaireModelDtoInput;
  ModeleSauvegarde?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  TypeRegleBase?: string;
  TypeValeur?: string;
};

export type RegleAccListeValModelDto = {
  __typename?: 'RegleAccListeValModelDTO';
  AncienneteMaximum?: number;
  AncienneteMinimum?: number;
  Id?: number;
  IdValeurChamp?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RegleAccListeValModelDtoInput = {
  AncienneteMaximum?: number;
  AncienneteMinimum?: number;
  Id?: number;
  IdValeurChamp?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RegleAvanceeModelDto = {
  __typename?: 'RegleAvanceeModelDTO';
  CalculSubvention?: CalculRegleAvanceeModelDto;
  CalculSubventionDefaut?: CalculRegleAvanceeModelDto;
  Id?: number;
  IdEnveloppe?: number;
  IdOperateur?: number;
  IdRegleApplication?: number;
  IdRegleNonApplication?: number;
  IdTypeArrondi?: number;
  IdTypeDate?: number;
  IsComplementaire?: boolean;
  IsForcageAutorise?: boolean;
  IsGroupe?: boolean;
  IsSubChoisie?: boolean;
  IsTransverse?: boolean;
  IsVenteSansSubAutorise?: boolean;
  Jours?: number;
  Libelle?: string;
  Mois?: number;
  Molecule?: MoleculeRegleAvanceeModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  RegleParent?: RegleAvanceeModelDto;
  ReglesEnfants?: ArrayOfRegleAvanceeModelDto;
  Status?: StatusDtoEnum;
  Subvention?: number;
  SubventionDefaut?: number;
  TypeRegle?: TypesRegleEnum;
};

export type RegleAvanceeModelDtoInput = {
  CalculSubvention?: CalculRegleAvanceeModelDtoInput;
  CalculSubventionDefaut?: CalculRegleAvanceeModelDtoInput;
  Id?: number;
  IdEnveloppe?: number;
  IdOperateur?: number;
  IdRegleApplication?: number;
  IdRegleNonApplication?: number;
  IdTypeArrondi?: number;
  IdTypeDate?: number;
  IsComplementaire?: boolean;
  IsForcageAutorise?: boolean;
  IsGroupe?: boolean;
  IsSubChoisie?: boolean;
  IsTransverse?: boolean;
  IsVenteSansSubAutorise?: boolean;
  Jours?: number;
  Libelle?: string;
  Mois?: number;
  Molecule?: MoleculeRegleAvanceeModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RegleParent?: RegleAvanceeModelDtoInput;
  ReglesEnfants?: ArrayOfRegleAvanceeModelDtoInput;
  Status?: StatusDtoEnum;
  Subvention?: number;
  SubventionDefaut?: number;
  TypeRegle?: TypesRegleEnum;
};

export type RegleBaseModel = {
  __typename?: 'RegleBaseModel';
  IdRegle?: number;
  LibelleRegle?: string;
};

export type RegleBaseModelInput = {
  IdRegle?: number;
  LibelleRegle?: string;
};

export type RegleComplementaireModelDto = {
  __typename?: 'RegleComplementaireModelDTO';
  Id?: number;
  IdEnveloppe?: number;
  IsHeritee?: boolean;
  IsSelected?: boolean;
  Libelle?: string;
  MontantSubvention?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  PourcentageSubvention?: number;
  RegleAvancee?: RegleAvanceeModelDto;
  Status?: StatusDtoEnum;
};

export type RegleComplementaireModelDtoInput = {
  Id?: number;
  IdEnveloppe?: number;
  IsHeritee?: boolean;
  IsSelected?: boolean;
  Libelle?: string;
  MontantSubvention?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  PourcentageSubvention?: number;
  RegleAvancee?: RegleAvanceeModelDtoInput;
  Status?: StatusDtoEnum;
};

export type RegleExpertModel = {
  __typename?: 'RegleExpertModel';
  IdRegle?: number;
  IsAccessibilite?: boolean;
  IsEnveloppe?: boolean;
  IsHerite?: boolean;
  IsModeExpert?: boolean;
  IsQuota?: boolean;
  IsRegleHeritage?: boolean;
  IsRestantACharge?: boolean;
  IsSubvention?: boolean;
  IsSubventionComplementaire?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedsToBeDeleted?: boolean;
  Status?: StatusDtoEnum;
};

export type RegleExpertModelInput = {
  IdRegle?: number;
  IsAccessibilite?: boolean;
  IsEnveloppe?: boolean;
  IsHerite?: boolean;
  IsModeExpert?: boolean;
  IsQuota?: boolean;
  IsRegleHeritage?: boolean;
  IsRestantACharge?: boolean;
  IsSubvention?: boolean;
  IsSubventionComplementaire?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedsToBeDeleted?: boolean;
  Status?: StatusDtoEnum;
};

export type RegleModeleAccesDto = {
  __typename?: 'RegleModeleAccesDTO';
  Activite?: ActiviteDto;
  AgeEnfantMax?: number;
  AgeEnfantMin?: number;
  AncienneteFactureMax?: number;
  Article?: ArticleDto;
  Champ?: ChampDto;
  ChampAD?: ChampDto;
  DateRefJour?: number;
  DateRefJourAgeEnf?: number;
  DateRefMois?: number;
  DateRefMoisAgeEnf?: number;
  DelaiAvantFinContrat?: number;
  FamilleProduit?: FamilleProduitDto;
  Id?: number;
  IsConjointHandicape?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantDirect?: boolean;
  IsEnfantHandicape?: boolean;
  IsForcageAutorise?: boolean;
  IsNominative?: boolean;
  ListeRegleModeleAccesChampListVal?: ArrayOfRegleModeleAcces_ChampListValDto;
  ListeRegleModeleAccesChampListValAD?: ArrayOfChampListeValeurDto;
  ListeTypeBenef?: ArrayOfTypeBenefDto;
  ModeAccess?: string;
  MoteurRegle?: MoteurRegleDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreJoursDeRetardMaxSurEmpruntEnCours?: number;
  Produit?: ProduitDto;
  RgModAccesAnMax?: number;
  RgModAccesAnMin?: number;
  Status?: StatusDtoEnum;
  TypeDateRef?: MoteurRegleTypeDateRefDto;
  TypeDateRefAge?: MoteurRegleTypeDateRefDto;
};

export type RegleModeleAccesDtoInput = {
  Activite?: ActiviteDtoInput;
  AgeEnfantMax?: number;
  AgeEnfantMin?: number;
  AncienneteFactureMax?: number;
  Article?: ArticleDtoInput;
  Champ?: ChampDtoInput;
  ChampAD?: ChampDtoInput;
  DateRefJour?: number;
  DateRefJourAgeEnf?: number;
  DateRefMois?: number;
  DateRefMoisAgeEnf?: number;
  DelaiAvantFinContrat?: number;
  FamilleProduit?: FamilleProduitDtoInput;
  Id?: number;
  IsConjointHandicape?: boolean;
  IsEnfantACharge?: boolean;
  IsEnfantDirect?: boolean;
  IsEnfantHandicape?: boolean;
  IsForcageAutorise?: boolean;
  IsNominative?: boolean;
  ListeRegleModeleAccesChampListVal?: ArrayOfRegleModeleAcces_ChampListValDtoInput;
  ListeRegleModeleAccesChampListValAD?: ArrayOfChampListeValeurDtoInput;
  ListeTypeBenef?: ArrayOfTypeBenefDtoInput;
  ModeAccess?: string;
  MoteurRegle?: MoteurRegleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreJoursDeRetardMaxSurEmpruntEnCours?: number;
  Produit?: ProduitDtoInput;
  RgModAccesAnMax?: number;
  RgModAccesAnMin?: number;
  Status?: StatusDtoEnum;
  TypeDateRef?: MoteurRegleTypeDateRefDtoInput;
  TypeDateRefAge?: MoteurRegleTypeDateRefDtoInput;
};

export type RegleModeleAcces_ChampListValDto = {
  __typename?: 'RegleModeleAcces_ChampListValDTO';
  AncienneteMaximum?: number;
  AncienneteMinimum?: number;
  ChampListVal?: ChampListeValeurDto;
  MustValidate?: boolean;
  MyGuid?: string;
  RgModAcces?: RegleModeleAccesDto;
  Status?: StatusDtoEnum;
};

export type RegleModeleAcces_ChampListValDtoInput = {
  AncienneteMaximum?: number;
  AncienneteMinimum?: number;
  ChampListVal?: ChampListeValeurDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RgModAcces?: RegleModeleAccesDtoInput;
  Status?: StatusDtoEnum;
};

export type RegleSubQuotaListeValModelDto = {
  __typename?: 'RegleSubQuotaListeValModelDTO';
  A?: number;
  ChpLstValId?: number;
  Conjoint?: number;
  De?: number;
  Enfant?: number;
  Externe?: number;
  Id?: number;
  IdTypeBenef?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Od?: number;
  Status?: StatusDtoEnum;
  TypeVal?: string;
  ValMax?: number;
  ValMin?: number;
};

export type RegleSubQuotaListeValModelDtoInput = {
  A?: number;
  ChpLstValId?: number;
  Conjoint?: number;
  De?: number;
  Enfant?: number;
  Externe?: number;
  Id?: number;
  IdTypeBenef?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Od?: number;
  Status?: StatusDtoEnum;
  TypeVal?: string;
  ValMax?: number;
  ValMin?: number;
};

export type RegleTypeDateModel = {
  __typename?: 'RegleTypeDateModel';
  CodeTypeDate?: string;
  IdTypeDate?: number;
  LibelleTypeDate?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RegleTypeDateModelInput = {
  CodeTypeDate?: string;
  IdTypeDate?: number;
  LibelleTypeDate?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RegleUseAfpaModel = {
  __typename?: 'RegleUseAFPAModel';
  IdRegle?: number;
  LibelleRegle?: string;
  ListeIdActivites?: ArrayOfdecimal;
  ListeIdArticles?: ArrayOfdecimal;
  ListeIdFamilles?: ArrayOfdecimal;
  ListeIdProduits?: ArrayOfdecimal;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RegleUseAfpaModelInput = {
  IdRegle?: number;
  LibelleRegle?: string;
  ListeIdActivites?: ArrayOfdecimalInput;
  ListeIdArticles?: ArrayOfdecimalInput;
  ListeIdFamilles?: ArrayOfdecimalInput;
  ListeIdProduits?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReglementCommandeBaseModelInput = {
  ListeIdCommande?: ArrayOfdecimalInput;
};

export type ReglementEnregistrementReglementInput = {
  DateEcriture?: any;
  IdBeneficiaire?: number;
  IdCECible?: number;
  IdCECreePar?: number;
  IdCESource?: number;
  IdCaisse?: number;
  IdCommande?: number;
  IdCompte?: number;
  IdCompteBancaire?: number;
  IdEcriture?: number;
  IdIban?: number;
  IdJournal?: number;
  IdMoyenPaiement?: number;
  IdUtilisateur?: number;
  IsManuel?: boolean;
  Libelle?: string;
  Montant?: number;
  NomBanque?: string;
  NomTire?: string;
  NumeroCheque?: string;
  NumeroPiece?: string;
  TypeEcriture?: TypeEcritureInput;
};

export type ReglementFactureModelDtoInput = {
  Activite?: ActiviteDtoInput;
  Facture?: FactureDtoInput;
  IsEnableMonPaiement?: boolean;
  IsSelected?: boolean;
  LibelleEtInfoFacture?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  PaiementClient?: number;
  Status?: StatusDtoEnum;
};

export type ReglementModelDto = {
  __typename?: 'ReglementModelDTO';
  Banque?: string;
  Commentaire?: string;
  CompteAcompteCollectif?: CompteDto;
  CompteBancaire?: CompteBancaireDto;
  CompteCollectif?: CompteDto;
  DateEcheance?: any;
  DateReglement?: any;
  Echeancier?: EcheancierModelDto;
  Exercice?: ExerciceDto;
  Iban?: string;
  IdAcompte?: number;
  IdCompteReglement?: number;
  IdCompteTropPercu?: number;
  IdDelegation?: number;
  IdJournal?: number;
  IdTransaction?: number;
  IsEnableAcompteNotBaseDonnee?: boolean;
  IsFromEcritureManuelle?: boolean;
  IsReglementEnLigne?: boolean;
  IsVirementCptOriginal?: boolean;
  Journal?: JournalDto;
  Libelle?: string;
  ListePJ?: ArrayOfComptaPjComptablesModel;
  MontantReglement?: number;
  MontantTropPercu?: number;
  MoyenPaiement?: MoyenPaiementDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NomTire?: string;
  NumCheque?: string;
  NumPiece?: string;
  NumPieceAuto?: boolean;
  NumnRef?: string;
  Rib?: RibDto;
  RibMandat?: RibMandatDto;
  Status?: StatusDtoEnum;
};

export type ReglementModelDtoInput = {
  Banque?: string;
  Commentaire?: string;
  CompteAcompteCollectif?: CompteDtoInput;
  CompteBancaire?: CompteBancaireDtoInput;
  CompteCollectif?: CompteDtoInput;
  DateEcheance?: any;
  DateReglement?: any;
  Echeancier?: EcheancierModelDtoInput;
  Exercice?: ExerciceDtoInput;
  Iban?: string;
  IdAcompte?: number;
  IdCompteReglement?: number;
  IdCompteTropPercu?: number;
  IdDelegation?: number;
  IdJournal?: number;
  IdTransaction?: number;
  IsEnableAcompteNotBaseDonnee?: boolean;
  IsFromEcritureManuelle?: boolean;
  IsReglementEnLigne?: boolean;
  IsVirementCptOriginal?: boolean;
  Journal?: JournalDtoInput;
  Libelle?: string;
  ListePJ?: ArrayOfComptaPjComptablesModelInput;
  MontantReglement?: number;
  MontantTropPercu?: number;
  MoyenPaiement?: MoyenPaiementDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NomTire?: string;
  NumCheque?: string;
  NumPiece?: string;
  NumPieceAuto?: boolean;
  NumnRef?: string;
  Rib?: RibDtoInput;
  RibMandat?: RibMandatDtoInput;
  Status?: StatusDtoEnum;
};

export type ReglementMouvFacModelDto = {
  __typename?: 'ReglementMouvFacModelDTO';
  Caisse?: string;
  CmpEcriture?: CompteEcritureDto;
  DateEcheance?: any;
  DateMV?: any;
  IdFacture?: number;
  IsImprimableLettreCheque?: boolean;
  Journal?: string;
  Montant?: number;
  MoyenPaiement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomPrenomUser?: string;
  NomTire?: string;
  NomsBanques?: string;
  NumsCheques?: string;
  Piece?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type ReglementMouvFacModelDtoInput = {
  Caisse?: string;
  CmpEcriture?: CompteEcritureDtoInput;
  DateEcheance?: any;
  DateMV?: any;
  IdFacture?: number;
  IsImprimableLettreCheque?: boolean;
  Journal?: string;
  Montant?: number;
  MoyenPaiement?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomPrenomUser?: string;
  NomTire?: string;
  NomsBanques?: string;
  NumsCheques?: string;
  Piece?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type ReglementPretsEtDonsListerModel = {
  __typename?: 'ReglementPretsEtDonsListerModel';
  CodeTypeEcriture?: string;
  DateEcriture?: any;
  IdEcriture?: number;
  IsLieAFacture?: boolean;
  LibelleMoyenPaiement?: string;
  MontantEcriture?: number;
  NomPrenomUtilisateur?: string;
  Remarque?: string;
};

export type ReglementPretsEtDonsListerModelInput = {
  CodeTypeEcriture?: string;
  DateEcriture?: any;
  IdEcriture?: number;
  IsLieAFacture?: boolean;
  LibelleMoyenPaiement?: string;
  MontantEcriture?: number;
  NomPrenomUtilisateur?: string;
  Remarque?: string;
};

export type ReglementsMasseModel = {
  __typename?: 'ReglementsMasseModel';
  IdCompteBancaireParDefaut?: number;
  IdCompteCollectifParDefaut?: number;
  ListeCompteBancaire?: ArrayOfComptesBancairesCompteBancaireLightModel;
  ListeCompteCollectif?: ArrayOfCompteLightModel;
  ListeDevisCommandeInfosReglMasModel?: ArrayOfDevisCommandeInfosReglMasModel;
  ListeJournaux?: ArrayOfJournalBaseModel;
  ListeModelesEcheancier?: ArrayOfModeleEcheancierMntMinModel;
  ListeMoyenPaiement?: ArrayOfMoyensPaiementMoyenPaiementBaseModele;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReglementsMasseModelInput = {
  IdCompteBancaireParDefaut?: number;
  IdCompteCollectifParDefaut?: number;
  ListeCompteBancaire?: ArrayOfComptesBancairesCompteBancaireLightModelInput;
  ListeCompteCollectif?: ArrayOfCompteLightModelInput;
  ListeDevisCommandeInfosReglMasModel?: ArrayOfDevisCommandeInfosReglMasModelInput;
  ListeJournaux?: ArrayOfJournalBaseModelInput;
  ListeModelesEcheancier?: ArrayOfModeleEcheancierMntMinModelInput;
  ListeMoyenPaiement?: ArrayOfMoyensPaiementMoyenPaiementBaseModeleInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReglementsReglementModelInput = {
  Ecriture?: any;
  ListeMouvements?: ArrayOfanyTypeInput;
};

export type RelationOdadModel = {
  __typename?: 'RelationODADModel';
  DateNaissance?: any;
  IdBenef?: number;
  IsSelected?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomPrenomBenef?: string;
  Status?: StatusDtoEnum;
  TypeRelation?: string;
};

export type RelationOdadModelInput = {
  DateNaissance?: any;
  IdBenef?: number;
  IsSelected?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomPrenomBenef?: string;
  Status?: StatusDtoEnum;
  TypeRelation?: string;
};

export type ReleveBancaireDto = {
  __typename?: 'ReleveBancaireDTO';
  CompteBancaire?: CompteBancaireDto;
  DateReleve?: any;
  Id?: number;
  ListePJ?: ArrayOfComptaPjComptablesModel;
  ListeRapprochement?: ArrayOfRapprochementDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Numero?: string;
  Remarque?: string;
  Solde?: number;
  Status?: StatusDtoEnum;
  Statut?: string;
};

export type ReleveBancaireDtoInput = {
  CompteBancaire?: CompteBancaireDtoInput;
  DateReleve?: any;
  Id?: number;
  ListePJ?: ArrayOfComptaPjComptablesModelInput;
  ListeRapprochement?: ArrayOfRapprochementDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Numero?: string;
  Remarque?: string;
  Solde?: number;
  Status?: StatusDtoEnum;
  Statut?: string;
};

export type RemboursementAnticipePretsEtDonsModelInput = {
  DateEcriture?: any;
  DateRemiseEnBanque?: any;
  IdActivite?: number;
  IdBenef?: number;
  IdCaisse?: number;
  IdDelegation?: number;
  IdJournalFraisDossier?: number;
  IdJournalTresorerie?: number;
  IdMandat?: number;
  IdMoyenPaiement?: number;
  IdRib?: number;
  IdUtilisateur?: number;
  IsComptaSeparee?: boolean;
  IsFraisOffert?: boolean;
  Libelle?: string;
  ListeIdCommande?: ArrayOfdecimalInput;
  MontantFrais?: number;
  MontantRestantARembourser?: number;
  NomBanque?: string;
  NomTire?: string;
  NumCheque?: string;
  NumeroPiece?: string;
};

export type RemboursementPretsEtDonsListerModel = {
  __typename?: 'RemboursementPretsEtDonsListerModel';
  CodeTypeEcriture?: string;
  DateCreation?: any;
  DateEcheancePassee?: any;
  DateFacture?: any;
  DateProchaineEcheance?: any;
  IdDossier?: number;
  IdEcheancier?: number;
  IdEcriture?: number;
  IsModifiable?: boolean;
  IsRemisEnBanque?: boolean;
  IsSupprimable?: boolean;
  LibelleRemboursement?: string;
  MontantRemboursement?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreEcheance?: number;
  NombreEcheanceRemisesEnBanque?: number;
  Status?: StatusDtoEnum;
};

export type RemboursementPretsEtDonsListerModelInput = {
  CodeTypeEcriture?: string;
  DateCreation?: any;
  DateEcheancePassee?: any;
  DateFacture?: any;
  DateProchaineEcheance?: any;
  IdDossier?: number;
  IdEcheancier?: number;
  IdEcriture?: number;
  IsModifiable?: boolean;
  IsRemisEnBanque?: boolean;
  IsSupprimable?: boolean;
  LibelleRemboursement?: string;
  MontantRemboursement?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreEcheance?: number;
  NombreEcheanceRemisesEnBanque?: number;
  Status?: StatusDtoEnum;
};

export type RemiseCaisseCentraleModel = {
  __typename?: 'RemiseCaisseCentraleModel';
  DateCreation?: any;
  DateModification?: any;
  IdRemiseEnCaisseCentrale?: number;
  IdUserCreation?: number;
  IdUserModification?: number;
  IsAValider?: boolean;
  IsValide?: boolean;
  ListeLigneRemiseSurFidu?: ObservableCollectionDtoOfLigneRemiseEnCaisseForValidationFiduModelWfN5Koph;
  ListeLigneRemiseSurNonFidu?: ObservableCollectionDtoOfLigneRemiseEnCaisseForValidationNonFiduModelWfN5Koph;
  ListeMoyensPaiement?: ArrayOfArreteCaisseRecapitulatifMoyenPaiementModel;
  NomUserCreation?: string;
  NomUserModification?: string;
};

export type RemiseCaisseCentraleModelInput = {
  DateCreation?: any;
  DateModification?: any;
  IdRemiseEnCaisseCentrale?: number;
  IdUserCreation?: number;
  IdUserModification?: number;
  IsAValider?: boolean;
  IsValide?: boolean;
  ListeLigneRemiseSurFidu?: ObservableCollectionDtoOfLigneRemiseEnCaisseForValidationFiduModelWfN5KophInput;
  ListeLigneRemiseSurNonFidu?: ObservableCollectionDtoOfLigneRemiseEnCaisseForValidationNonFiduModelWfN5KophInput;
  ListeMoyensPaiement?: ArrayOfArreteCaisseRecapitulatifMoyenPaiementModelInput;
  NomUserCreation?: string;
  NomUserModification?: string;
};

export type RemiseEnBanqueModel = {
  __typename?: 'RemiseEnBanqueModel';
  CanDeleteRemiseEnBanque?: boolean;
  CodeMoyenPaiement?: string;
  CompteBancaire?: CompteBancaireDto;
  DateAnnulationEcriture?: any;
  DateRapprochement?: any;
  DateRemise?: any;
  HasLigneSansIBAN?: boolean;
  IdEcritureEspece?: number;
  IdEcritureNonFidu?: number;
  IdEcritureTresorie?: number;
  IsSupprime?: boolean;
  LibelleCaisse?: string;
  LibelleCompteBancaire?: string;
  LibelleMoyenPaiement?: string;
  LibelleRemise?: string;
  MontantRemise?: number;
  MoyenPaiementIsFiduciaire?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomCE?: string;
  NumeroBordereau?: string;
  RemarqueRemise?: string;
  RemiseEnBanqueId?: number;
  Status?: StatusDtoEnum;
  User?: string;
};

export type RemiseEnBanqueModelInput = {
  CanDeleteRemiseEnBanque?: boolean;
  CodeMoyenPaiement?: string;
  CompteBancaire?: CompteBancaireDtoInput;
  DateAnnulationEcriture?: any;
  DateRapprochement?: any;
  DateRemise?: any;
  HasLigneSansIBAN?: boolean;
  IdEcritureEspece?: number;
  IdEcritureNonFidu?: number;
  IdEcritureTresorie?: number;
  IsSupprime?: boolean;
  LibelleCaisse?: string;
  LibelleCompteBancaire?: string;
  LibelleMoyenPaiement?: string;
  LibelleRemise?: string;
  MontantRemise?: number;
  MoyenPaiementIsFiduciaire?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomCE?: string;
  NumeroBordereau?: string;
  RemarqueRemise?: string;
  RemiseEnBanqueId?: number;
  Status?: StatusDtoEnum;
  User?: string;
};

export type RemiseEnCaisseLigneRemiseEnCaisseFiduModelInput = {
  IdLigneRemiseEnCaisse?: number;
  MontantConstate?: number;
};

export type RemiseEnCaisseLigneRemiseEnCaisseNonFiduModelInput = {
  IdLigneRemiseCaisse?: number;
  IsValide?: boolean;
};

export type RemiseEnCaisseSaveRemiseEnCaisseModelInput = {
  IdRemiseEnCaisse?: number;
  ListeLigneRemiseEnCaisseFidu?: ArrayOfRemiseEnCaisseLigneRemiseEnCaisseFiduModelInput;
  ListeLigneRemiseEnCaisseNonFidu?: ArrayOfRemiseEnCaisseLigneRemiseEnCaisseNonFiduModelInput;
};

export type RemonterBaseReferenceModelDto = {
  __typename?: 'RemonterBaseReferenceModelDTO';
  InitialCatalogue?: string;
  IsBaseV2?: boolean;
  IsSelected?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBase?: string;
  PathBaseRefV2?: string;
  Status?: StatusDtoEnum;
};

export type RemonterBaseReferenceModelDtoInput = {
  InitialCatalogue?: string;
  IsBaseV2?: boolean;
  IsSelected?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBase?: string;
  PathBaseRefV2?: string;
  Status?: StatusDtoEnum;
};

export type ReponseChampModel = {
  __typename?: 'ReponseChampModel';
  CodeTypeChamp?: string;
  DateDefaut?: any;
  Description?: string;
  IdChamp?: number;
  IdDataFormulaire?: number;
  IdSectionParente?: number;
  IsChampObligatoire?: boolean;
  IsProproseEnLigne?: boolean;
  IsToDelete?: boolean;
  IsVisibleOD?: boolean;
  Libelle?: string;
  ListeChampValeurFormulaire?: ArrayOfValeurChampFormulaireModel;
  ListeIdValeurDefaut?: ArrayOfint;
  ListeIdValeurDefautFormulaire?: ArrayOfint;
  ListeValeursChamp?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroColonne?: number;
  NumeroLigne?: number;
  ReponseDate?: any;
  ReponseSimple?: string;
  ReponsesFormulaire?: SoumissionFormulaireModel;
  RequeteSQLListeValeur?: string;
  Status?: StatusDtoEnum;
  ValeurDefautDansFormulaire?: string;
  ValeurParDefaut?: string;
};

export type ReponseChampModelInput = {
  CodeTypeChamp?: string;
  DateDefaut?: any;
  Description?: string;
  IdChamp?: number;
  IdDataFormulaire?: number;
  IdSectionParente?: number;
  IsChampObligatoire?: boolean;
  IsProproseEnLigne?: boolean;
  IsToDelete?: boolean;
  IsVisibleOD?: boolean;
  Libelle?: string;
  ListeChampValeurFormulaire?: ArrayOfValeurChampFormulaireModelInput;
  ListeIdValeurDefaut?: ArrayOfintInput;
  ListeIdValeurDefautFormulaire?: ArrayOfintInput;
  ListeValeursChamp?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroColonne?: number;
  NumeroLigne?: number;
  ReponseDate?: any;
  ReponseSimple?: string;
  ReponsesFormulaire?: SoumissionFormulaireModelInput;
  RequeteSQLListeValeur?: string;
  Status?: StatusDtoEnum;
  ValeurDefautDansFormulaire?: string;
  ValeurParDefaut?: string;
};

export type ReponseFormulaireAPlatModel = {
  __typename?: 'ReponseFormulaireAPlatModel';
  IdChampData?: number;
  IdLigneCommande?: number;
  LibelleChampFormulaire?: string;
  ListeReponse?: ArrayOfstring;
  ReponseSimple?: string;
};

export type ReponseFormulaireAPlatModelInput = {
  IdChampData?: number;
  IdLigneCommande?: number;
  LibelleChampFormulaire?: string;
  ListeReponse?: ArrayOfstringInput;
  ReponseSimple?: string;
};

export type ReponseFormulaireBaseModel = {
  __typename?: 'ReponseFormulaireBaseModel';
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReponseFormulaireBaseModelInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReponseFormulaireModel = {
  __typename?: 'ReponseFormulaireModel';
  IdActivite?: number;
  IdDelegation?: number;
  IdFormulaire?: number;
  IsCloture?: boolean;
  LibelleFormulaire?: string;
  ListeChampSectionBase?: ArrayOfReponseFormulaireBaseModel;
  ListeLigneCommande?: ArrayOfLigneCommandeFormulaireModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReponseFormulaireModelInput = {
  IdActivite?: number;
  IdDelegation?: number;
  IdFormulaire?: number;
  IsCloture?: boolean;
  LibelleFormulaire?: string;
  ListeChampSectionBase?: ArrayOfReponseFormulaireBaseModelInput;
  ListeLigneCommande?: ArrayOfLigneCommandeFormulaireModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReponseFormulaireParticipantModel = {
  __typename?: 'ReponseFormulaireParticipantModel';
  IdActivite?: number;
  IdDelegation?: number;
  IdFormulaire?: number;
  IsCloture?: boolean;
  LibelleFormulaire?: string;
  ListeChampSectionBase?: ArrayOfReponseFormulaireBaseModel;
  ListeLigneCommande?: ArrayOfLigneCommandeFormulaireModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Participant?: RelationOdadModel;
  Status?: StatusDtoEnum;
};

export type ReponseFormulaireParticipantModelInput = {
  IdActivite?: number;
  IdDelegation?: number;
  IdFormulaire?: number;
  IsCloture?: boolean;
  LibelleFormulaire?: string;
  ListeChampSectionBase?: ArrayOfReponseFormulaireBaseModelInput;
  ListeLigneCommande?: ArrayOfLigneCommandeFormulaireModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Participant?: RelationOdadModelInput;
  Status?: StatusDtoEnum;
};

export type ReponseLigneChampModel = {
  __typename?: 'ReponseLigneChampModel';
  ChampDroite?: Union_32476590703626765597;
  ChampGauche?: Union_32476590703626765597;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReponseLigneChampModelInput = {
  ChampDroite?: ReponseChampModelInput;
  ChampGauche?: ReponseChampModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReponseSectionModel = {
  __typename?: 'ReponseSectionModel';
  DescriptionSection?: string;
  IdSection?: number;
  IsToDelete?: boolean;
  LibelleSection?: string;
  ListeChampFormulaire?: ArrayOfanyType;
  ListeChampFormulaireObservable?: ArrayOfChampsSectionFormulaireFullModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type ReponseSectionModelInput = {
  DescriptionSection?: string;
  IdSection?: number;
  IsToDelete?: boolean;
  LibelleSection?: string;
  ListeChampFormulaire?: ArrayOfanyTypeInput;
  ListeChampFormulaireObservable?: ArrayOfChampsSectionFormulaireFullModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type ReportBaseModel = {
  __typename?: 'ReportBaseModel';
  CodeReport?: string;
  IdReport?: number;
  LibelleReport?: string;
};

export type ReportBaseModelInput = {
  CodeReport?: string;
  IdReport?: number;
  LibelleReport?: string;
};

export type ReportBlocDataDto = {
  __typename?: 'ReportBlocDataDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  ListeReports?: ArrayOfReportDto;
  ListeTypeReports?: ArrayOfReportBlocData_ReportTypeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  ReportClassPath?: string;
  Status?: StatusDtoEnum;
};

export type ReportBlocDataDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  ListeReports?: ArrayOfReportDtoInput;
  ListeTypeReports?: ArrayOfReportBlocData_ReportTypeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  ReportClassPath?: string;
  Status?: StatusDtoEnum;
};

export type ReportBlocData_ReportTypeDto = {
  __typename?: 'ReportBlocData_ReportTypeDTO';
  BlocData?: ReportBlocDataDto;
  EstParDefaut?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: ReportTypeDto;
};

export type ReportBlocData_ReportTypeDtoInput = {
  BlocData?: ReportBlocDataDtoInput;
  EstParDefaut?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: ReportTypeDtoInput;
};

export type ReportDto = {
  __typename?: 'ReportDTO';
  AvecAdresseCE?: boolean;
  AvecLogo?: boolean;
  AvecSignatureCE?: boolean;
  BasDePage?: string;
  BlocData?: ReportBlocDataDto;
  Code?: string;
  Id?: number;
  Introduction?: string;
  Libelle?: string;
  ListeSubReport?: ArrayOfReportSubReportDto;
  ModeleAdresse?: ReportModeleAdrdto;
  ModeleMEP?: ReportModeleMepdto;
  MustValidate?: boolean;
  MyGuid?: string;
  Objet?: string;
  PiedDePage?: string;
  SignatureCE?: string;
  Status?: StatusDtoEnum;
  TypeReport?: ReportTypeDto;
};

export type ReportDtoInput = {
  AvecAdresseCE?: boolean;
  AvecLogo?: boolean;
  AvecSignatureCE?: boolean;
  BasDePage?: string;
  BlocData?: ReportBlocDataDtoInput;
  Code?: string;
  Id?: number;
  Introduction?: string;
  Libelle?: string;
  ListeSubReport?: ArrayOfReportSubReportDtoInput;
  ModeleAdresse?: ReportModeleAdrdtoInput;
  ModeleMEP?: ReportModeleMepdtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Objet?: string;
  PiedDePage?: string;
  SignatureCE?: string;
  Status?: StatusDtoEnum;
  TypeReport?: ReportTypeDtoInput;
};

export type ReportModeleAdrdto = {
  __typename?: 'ReportModeleADRDTO';
  Code?: string;
  EstCloture?: boolean;
  Id?: number;
  IsDefault?: boolean;
  IsVisibleAdrOrganisation?: boolean;
  IsVisibleAdrOrganisationPere?: boolean;
  IsVisibleAdrSite?: boolean;
  IsVisibleAdrSitePere?: boolean;
  IsVisibleAdresse?: boolean;
  IsVisibleOrganisation?: boolean;
  IsVisibleOrganisationPere?: boolean;
  IsVisiblePays?: boolean;
  IsVisibleSite?: boolean;
  IsVisibleSitePere?: boolean;
  Libelle?: string;
  ListeReports?: ArrayOfReportDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReportModeleAdrdtoInput = {
  Code?: string;
  EstCloture?: boolean;
  Id?: number;
  IsDefault?: boolean;
  IsVisibleAdrOrganisation?: boolean;
  IsVisibleAdrOrganisationPere?: boolean;
  IsVisibleAdrSite?: boolean;
  IsVisibleAdrSitePere?: boolean;
  IsVisibleAdresse?: boolean;
  IsVisibleOrganisation?: boolean;
  IsVisibleOrganisationPere?: boolean;
  IsVisiblePays?: boolean;
  IsVisibleSite?: boolean;
  IsVisibleSitePere?: boolean;
  Libelle?: string;
  ListeReports?: ArrayOfReportDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReportModeleMepdto = {
  __typename?: 'ReportModeleMEPDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  ListeReports?: ArrayOfReportDto;
  ListeTypesReports?: ArrayOfReportModeleMep_ReportTypeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  ReportClassPath?: string;
  Status?: StatusDtoEnum;
};

export type ReportModeleMepdtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  ListeReports?: ArrayOfReportDtoInput;
  ListeTypesReports?: ArrayOfReportModeleMep_ReportTypeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  ReportClassPath?: string;
  Status?: StatusDtoEnum;
};

export type ReportModeleMep_ReportTypeDto = {
  __typename?: 'ReportModeleMEP_ReportTypeDTO';
  EstParDefaut?: boolean;
  ModeleMEP?: ReportModeleMepdto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: ReportTypeDto;
};

export type ReportModeleMep_ReportTypeDtoInput = {
  EstParDefaut?: boolean;
  ModeleMEP?: ReportModeleMepdtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: ReportTypeDtoInput;
};

export type ReportPageBreakDto = {
  __typename?: 'ReportPageBreakDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReportPageBreakDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReportSubReportDto = {
  __typename?: 'ReportSubReportDTO';
  BlocData?: ReportBlocDataDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PageBreak?: ReportPageBreakDto;
  RepeatOnEveryPage?: boolean;
  Report?: ReportDto;
  Status?: StatusDtoEnum;
  TypeSubReport?: ReportTypeSubReportDto;
};

export type ReportSubReportDtoInput = {
  BlocData?: ReportBlocDataDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PageBreak?: ReportPageBreakDtoInput;
  RepeatOnEveryPage?: boolean;
  Report?: ReportDtoInput;
  Status?: StatusDtoEnum;
  TypeSubReport?: ReportTypeSubReportDtoInput;
};

export type ReportTypeDto = {
  __typename?: 'ReportTypeDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  ListeBlocsData?: ArrayOfReportBlocData_ReportTypeDto;
  ListeModelesMEP?: ArrayOfReportModeleMep_ReportTypeDto;
  ListeReports?: ArrayOfReportDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReportTypeDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  ListeBlocsData?: ArrayOfReportBlocData_ReportTypeDtoInput;
  ListeModelesMEP?: ArrayOfReportModeleMep_ReportTypeDtoInput;
  ListeReports?: ArrayOfReportDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReportTypeSubReportDto = {
  __typename?: 'ReportTypeSubReportDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReportTypeSubReportDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReqSpecifDto = {
  __typename?: 'ReqSpecifDTO';
  Code?: string;
  Description?: string;
  FormatExport?: string;
  Id?: number;
  IsSpecifiqueClient?: boolean;
  IsVisible?: boolean;
  IsVisibleComboMulitDeleg?: boolean;
  Libelle?: string;
  ListParam?: ArrayOfParamReqSpecifDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NomProcStock?: string;
  Status?: StatusDtoEnum;
  WithoutEntete?: boolean;
  WithoutGuillement?: boolean;
};

export type ReqSpecifDtoInput = {
  Code?: string;
  Description?: string;
  FormatExport?: string;
  Id?: number;
  IsSpecifiqueClient?: boolean;
  IsVisible?: boolean;
  IsVisibleComboMulitDeleg?: boolean;
  Libelle?: string;
  ListParam?: ArrayOfParamReqSpecifDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NomProcStock?: string;
  Status?: StatusDtoEnum;
  WithoutEntete?: boolean;
  WithoutGuillement?: boolean;
};

export type RequestModel = {
  __typename?: 'RequestModel';
  Content?: string;
  DataId?: number;
  Direction?: string;
  RequestDate?: any;
  Result?: string;
  Status?: string;
};

export type RequestModelInput = {
  Content?: string;
  DataId?: number;
  Direction?: string;
  RequestDate?: any;
  Result?: string;
  Status?: string;
};

export type RequetePubliRequeteAvecCriteresModel = {
  __typename?: 'RequetePubliRequeteAvecCriteresModel';
  ContexteId?: number;
  IsDeclencheurStatutPerso?: boolean;
  ListeCriteres?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  RequeteDescription?: string;
  RequeteId?: number;
  RequeteIsClos?: boolean;
  RequeteLibelle?: string;
  Status?: StatusDtoEnum;
};

export type RequetePubliRequeteAvecCriteresModelInput = {
  ContexteId?: number;
  IsDeclencheurStatutPerso?: boolean;
  ListeCriteres?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RequeteDescription?: string;
  RequeteId?: number;
  RequeteIsClos?: boolean;
  RequeteLibelle?: string;
  Status?: StatusDtoEnum;
};

export type RequetePubliRequeteBaseModel = {
  __typename?: 'RequetePubliRequeteBaseModel';
  ContexteId?: number;
  IsDeclencheurStatutPerso?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  RequeteDescription?: string;
  RequeteId?: number;
  RequeteLibelle?: string;
  Status?: StatusDtoEnum;
};

export type RequetePubliRequeteBaseModelInput = {
  ContexteId?: number;
  IsDeclencheurStatutPerso?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  RequeteDescription?: string;
  RequeteId?: number;
  RequeteLibelle?: string;
  Status?: StatusDtoEnum;
};

export type RessourceComptabiliteModel = {
  __typename?: 'RessourceComptabiliteModel';
  IdCompteProduit?: number;
  ListePlanSectionAnalytique?: ArrayOfPlanWithSectionsAnalytiquesModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RessourceComptabiliteModelInput = {
  IdCompteProduit?: number;
  ListePlanSectionAnalytique?: ArrayOfPlanWithSectionsAnalytiquesModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RessourceDescriptionModel = {
  __typename?: 'RessourceDescriptionModel';
  DescriptionRessource?: string;
  ListeImages?: ArrayOfFichierModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RessourceDescriptionModelInput = {
  DescriptionRessource?: string;
  ListeImages?: ArrayOfFichierModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RessourceInformationsModel = {
  __typename?: 'RessourceInformationsModel';
  CodeFamille?: string;
  DateDebutNouveaute?: any;
  DateFinNouveaute?: any;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdProduit?: number;
  Illustration?: FichierModel;
  IsCloture?: boolean;
  IsGereEnStock?: boolean;
  LibelleFamille?: string;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TokenIllustration?: string;
};

export type RessourceInformationsModelInput = {
  CodeFamille?: string;
  DateDebutNouveaute?: any;
  DateFinNouveaute?: any;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdProduit?: number;
  Illustration?: FichierModelInput;
  IsCloture?: boolean;
  IsGereEnStock?: boolean;
  LibelleFamille?: string;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TokenIllustration?: string;
};

export type RessourcesPartageesReservationModelInput = {
  Commentaire?: string;
  DateDebut?: any;
  DateFin?: any;
  ForcerRegle?: boolean;
  IdArticle?: number;
  IdBeneficiaire?: number;
  IdProduit?: number;
  IdReservation?: number;
  IdUtilisateur?: number;
  IsAcceptee?: boolean;
  ListeTarifs?: ArrayOfRessourcesPartageesTarifModelInput;
};

export type RessourcesPartageesTarifFactureModel = {
  __typename?: 'RessourcesPartageesTarifFactureModel';
  Commentaire?: string;
  DateCreation?: any;
  IdCompteCollectif?: number;
  IdCompteImputation?: number;
  IdTarif?: number;
  IsFacture?: boolean;
  IsRemoving?: boolean;
  Libelle?: string;
  LibelleCompteCollectif?: string;
  LibelleCompteImput?: string;
  ListeClesRepartitions?: ArrayOfCleRepartitionModel;
  Montant?: number;
};

export type RessourcesPartageesTarifFactureModelInput = {
  Commentaire?: string;
  DateCreation?: any;
  IdCompteCollectif?: number;
  IdCompteImputation?: number;
  IdTarif?: number;
  IsFacture?: boolean;
  IsRemoving?: boolean;
  Libelle?: string;
  LibelleCompteCollectif?: string;
  LibelleCompteImput?: string;
  ListeClesRepartitions?: ArrayOfCleRepartitionModelInput;
  Montant?: number;
};

export type RessourcesPartageesTarifModel = {
  __typename?: 'RessourcesPartageesTarifModel';
  Commentaire?: string;
  DateCreation?: any;
  IdCompteCollectif?: number;
  IdCompteImputation?: number;
  IdTarif?: number;
  IsRemoving?: boolean;
  Libelle?: string;
  LibelleCompteCollectif?: string;
  LibelleCompteImput?: string;
  ListeClesRepartitions?: ArrayOfCleRepartitionModel;
  Montant?: number;
};

export type RessourcesPartageesTarifModelInput = {
  Commentaire?: string;
  DateCreation?: any;
  IdCompteCollectif?: number;
  IdCompteImputation?: number;
  IdTarif?: number;
  IsRemoving?: boolean;
  Libelle?: string;
  LibelleCompteCollectif?: string;
  LibelleCompteImput?: string;
  ListeClesRepartitions?: ArrayOfCleRepartitionModelInput;
  Montant?: number;
};

export type ResultReqSpec = {
  __typename?: 'ResultReqSpec';
  MustValidate?: boolean;
  MyGuid?: string;
  NbTotalRow?: number;
  Result?: string;
  Status?: StatusDtoEnum;
};

export type ResultReqSpecInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  NbTotalRow?: number;
  Result?: string;
  Status?: StatusDtoEnum;
};

export type ResultatAffectationTiersModel = {
  __typename?: 'ResultatAffectationTiersModel';
  MustValidate?: boolean;
  MyGuid?: string;
  NbMouvementsAffectes?: number;
  NbMouvementsIgnores?: number;
  Status?: StatusDtoEnum;
};

export type ResultatAffectationTiersModelInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  NbMouvementsAffectes?: number;
  NbMouvementsIgnores?: number;
  Status?: StatusDtoEnum;
};

export type ResumeBenefEmpruntModel = {
  __typename?: 'ResumeBenefEmpruntModel';
  MustValidate?: boolean;
  MyGuid?: string;
  NbAutre?: number;
  NbCD?: number;
  NbDVD?: number;
  NbLivre?: number;
  NbLogiciel?: number;
  Status?: StatusDtoEnum;
};

export type ResumeBenefEmpruntModelInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  NbAutre?: number;
  NbCD?: number;
  NbDVD?: number;
  NbLivre?: number;
  NbLogiciel?: number;
  Status?: StatusDtoEnum;
};

export type RetouSaveCommandeFournisseurModelDto = {
  __typename?: 'RetouSaveCommandeFournisseurModelDTO';
  IdFacture?: number;
  ListeEcriture?: ArrayOfCompteEcritureDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RetouSaveCommandeFournisseurModelDtoInput = {
  IdFacture?: number;
  ListeEcriture?: ArrayOfCompteEcritureDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RetourAfpaModelDto = {
  __typename?: 'RetourAFPAModelDTO';
  ActiviteNew?: ActiviteDto;
  IdRetour?: number;
  ListeCadeaux?: ArrayOfCadeauFpaModel;
  ModeleAffichageRegle?: ModeleAffichageRegleDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RetourAfpaModelDtoInput = {
  ActiviteNew?: ActiviteDtoInput;
  IdRetour?: number;
  ListeCadeaux?: ArrayOfCadeauFpaModelInput;
  ModeleAffichageRegle?: ModeleAffichageRegleDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RetourApiMediaModel = {
  __typename?: 'RetourAPIMediaModel';
  Auteur?: string;
  CDU?: string;
  Cible?: string;
  Collection?: string;
  Cote?: string;
  CritiqueMedia?: string;
  DEWAY?: string;
  DateEdition?: string;
  DateSortie?: string;
  Duree?: string;
  Editeur?: string;
  Format?: string;
  Genre?: string;
  ISBN10?: string;
  Image?: string;
  ImageOrigine?: string;
  Libre?: string;
  LivretDispoMedia?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nationalite?: string;
  NbPageOrDisk?: string;
  Note?: string;
  Numerotation?: string;
  Realisateur?: string;
  Reference?: string;
  SousCollec?: string;
  SousTitre?: string;
  Status?: StatusDtoEnum;
  Synopsis?: string;
  Theme?: string;
  Titre?: string;
  Type?: string;
};

export type RetourApiMediaModelInput = {
  Auteur?: string;
  CDU?: string;
  Cible?: string;
  Collection?: string;
  Cote?: string;
  CritiqueMedia?: string;
  DEWAY?: string;
  DateEdition?: string;
  DateSortie?: string;
  Duree?: string;
  Editeur?: string;
  Format?: string;
  Genre?: string;
  ISBN10?: string;
  Image?: string;
  ImageOrigine?: string;
  Libre?: string;
  LivretDispoMedia?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nationalite?: string;
  NbPageOrDisk?: string;
  Note?: string;
  Numerotation?: string;
  Realisateur?: string;
  Reference?: string;
  SousCollec?: string;
  SousTitre?: string;
  Status?: StatusDtoEnum;
  Synopsis?: string;
  Theme?: string;
  Titre?: string;
  Type?: string;
};

export type RetourActionsGroupeesModel = {
  __typename?: 'RetourActionsGroupeesModel';
  NbDossiersCommandeGenere?: number;
  NbDossiersEcheancierGenere?: number;
  NbDossiersRefuses?: number;
  NbDossiersReglementEffectue?: number;
  NbDossiersValides?: number;
};

export type RetourActionsGroupeesModelInput = {
  NbDossiersCommandeGenere?: number;
  NbDossiersEcheancierGenere?: number;
  NbDossiersRefuses?: number;
  NbDossiersReglementEffectue?: number;
  NbDossiersValides?: number;
};

export type RetourActionsGroupeesPretsEtDonsModel = {
  __typename?: 'RetourActionsGroupeesPretsEtDonsModel';
  NombreDossierAccepte?: number;
  NombreDossierAvecEcheancierGenere?: number;
  NombreDossierRefuse?: number;
  NombreDossierRegle?: number;
};

export type RetourActionsGroupeesPretsEtDonsModelInput = {
  NombreDossierAccepte?: number;
  NombreDossierAvecEcheancierGenere?: number;
  NombreDossierRefuse?: number;
  NombreDossierRegle?: number;
};

export type RetourAnnulationRemboursementModelDto = {
  __typename?: 'RetourAnnulationRemboursementModelDTO';
  IdAvoir?: number;
  IdBenef?: number;
  IdFactureFraisAnnulation?: number;
  IdFournisseur?: number;
  IsProposeRemboursementAvoir?: boolean;
  IsReglerFraisAnnulation?: boolean;
  MontantFraisAnnulation?: number;
  MontantSoldeAvoir?: number;
};

export type RetourAnnulationRemboursementModelDtoInput = {
  IdAvoir?: number;
  IdBenef?: number;
  IdFactureFraisAnnulation?: number;
  IdFournisseur?: number;
  IsProposeRemboursementAvoir?: boolean;
  IsReglerFraisAnnulation?: boolean;
  MontantFraisAnnulation?: number;
  MontantSoldeAvoir?: number;
};

export type RetourAnnulationTransfertComptaModel = {
  __typename?: 'RetourAnnulationTransfertComptaModel';
  IdBenef?: number;
  IdFournisseur?: number;
  IdNewFactureBenef?: number;
  IdNewFactureFournisseur?: number;
  IsAnnulationOK?: boolean;
  IsDossierAnnule?: boolean;
};

export type RetourAnnulationTransfertComptaModelInput = {
  IdBenef?: number;
  IdFournisseur?: number;
  IdNewFactureBenef?: number;
  IdNewFactureFournisseur?: number;
  IsAnnulationOK?: boolean;
  IsDossierAnnule?: boolean;
};

export type RetourBenefMailPublipostage = {
  __typename?: 'RetourBenefMailPublipostage';
  ListeIdGenerationCourrier?: ArrayOfdecimal;
  NomUniqueContacte?: string;
  NomUniqueNonContacte?: string;
  NombreContacte?: number;
  NombreNonContacte?: number;
};

export type RetourBenefMailPublipostageInput = {
  ListeIdGenerationCourrier?: ArrayOfdecimalInput;
  NomUniqueContacte?: string;
  NomUniqueNonContacte?: string;
  NombreContacte?: number;
  NombreNonContacte?: number;
};

export type RetourCheckBeforeAnnulTransfertComptaModel = {
  __typename?: 'RetourCheckBeforeAnnulTransfertComptaModel';
  DateFacture?: any;
  IsTransfertAnnulable?: boolean;
  Message?: string;
};

export type RetourCheckBeforeAnnulTransfertComptaModelInput = {
  DateFacture?: any;
  IsTransfertAnnulable?: boolean;
  Message?: string;
};

export type RetourCreationCommandeDossierEpargneModel = {
  __typename?: 'RetourCreationCommandeDossierEpargneModel';
  Dossier?: DossierEpargneModel;
  MontantDossier?: MontantDossierEpargneModel;
  StatutDossier?: StatutDossierEpargneModel;
};

export type RetourCreationCommandeDossierEpargneModelInput = {
  Dossier?: DossierEpargneModelInput;
  MontantDossier?: MontantDossierEpargneModelInput;
  StatutDossier?: StatutDossierEpargneModelInput;
};

export type RetourEcritureComptableFactureAvoirModelDto = {
  __typename?: 'RetourEcritureComptableFactureAvoirModelDTO';
  Beneficiaire?: BenefDto;
  ListeIdFactureAvoir?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RetourEcritureComptableFactureAvoirModelDtoInput = {
  Beneficiaire?: BenefDtoInput;
  ListeIdFactureAvoir?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RetourEditerLigneDossierEpargneModel = {
  __typename?: 'RetourEditerLigneDossierEpargneModel';
  IdLigneDossier?: number;
  MontantDossier?: MontantDossierEpargneModel;
  RetourMoteur?: RetourMoteurModelDto;
  StatutDossier?: StatutDossierEpargneModel;
};

export type RetourEditerLigneDossierEpargneModelInput = {
  IdLigneDossier?: number;
  MontantDossier?: MontantDossierEpargneModelInput;
  RetourMoteur?: RetourMoteurModelDtoInput;
  StatutDossier?: StatutDossierEpargneModelInput;
};

export type RetourEditerLigneDossierPretsEtDonsModel = {
  __typename?: 'RetourEditerLigneDossierPretsEtDonsModel';
  IdLigneDossier?: number;
  ListePiecesJustificatives?: ArrayOfDossierPrestationPieceJustificativeModelDto;
  MontantDossier?: MontantDossierPretsEtDonsModel;
  NecessiteRenseignementFormulaire?: boolean;
  RetourMoteur?: RetourMoteurModelDto;
  StatutDossier?: StatutDossierPretsEtDonsModel;
};

export type RetourEditerLigneDossierPretsEtDonsModelInput = {
  IdLigneDossier?: number;
  ListePiecesJustificatives?: ArrayOfDossierPrestationPieceJustificativeModelDtoInput;
  MontantDossier?: MontantDossierPretsEtDonsModelInput;
  NecessiteRenseignementFormulaire?: boolean;
  RetourMoteur?: RetourMoteurModelDtoInput;
  StatutDossier?: StatutDossierPretsEtDonsModelInput;
};

export type RetourEditerRoomingListModel = {
  __typename?: 'RetourEditerRoomingListModel';
  ListeGroupes?: ArrayOfGroupeRoomingListModel;
  ListeOuvrantsDroits?: ArrayOfBenefBenefBaseModel;
  ListeParticipant?: ArrayOfRoomingListeParticipantsModel;
  MustValidate?: boolean;
  MyGuid?: string;
  RoomingListModel?: EditerRoomingListModel;
  Status?: StatusDtoEnum;
};

export type RetourEditerRoomingListModelInput = {
  ListeGroupes?: ArrayOfGroupeRoomingListModelInput;
  ListeOuvrantsDroits?: ArrayOfBenefBenefBaseModelInput;
  ListeParticipant?: ArrayOfRoomingListeParticipantsModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RoomingListModel?: EditerRoomingListModelInput;
  Status?: StatusDtoEnum;
};

export type RetourExecutionActionsGroupees = {
  __typename?: 'RetourExecutionActionsGroupees';
  ListeNumerosDossierRemboursementEchoue?: ArrayOfdecimal;
  ListeNumerosDossierTransfertComptabiliteEchoue?: ArrayOfdecimal;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RetourExecutionActionsGroupeesInput = {
  ListeNumerosDossierRemboursementEchoue?: ArrayOfdecimalInput;
  ListeNumerosDossierTransfertComptabiliteEchoue?: ArrayOfdecimalInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RetourFacturationModel = {
  __typename?: 'RetourFacturationModel';
  IdFacture?: number;
  IsSoldeParAcompte?: boolean;
  ListeIdBonLivraison?: ArrayOfdecimal;
  ListeIdCommande?: ArrayOfdecimal;
};

export type RetourFacturationModelInput = {
  IdFacture?: number;
  IsSoldeParAcompte?: boolean;
  ListeIdBonLivraison?: ArrayOfdecimalInput;
  ListeIdCommande?: ArrayOfdecimalInput;
};

export type RetourHistoriqueExecutionImportArticle = {
  __typename?: 'RetourHistoriqueExecutionImportArticle';
  Data?: ArrayOfLigneResultatImportArticle;
  ErrorCode?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Success?: boolean;
  TotalResult?: number;
};

export type RetourHistoriqueExecutionImportArticleInput = {
  Data?: ArrayOfLigneResultatImportArticleInput;
  ErrorCode?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Success?: boolean;
  TotalResult?: number;
};

export type RetourImportCatalogueModel = {
  __typename?: 'RetourImportCatalogueModel';
  ListeErreurImport?: ArrayOfKeyValueOfintstring;
  ListeIdMediaUpdatable?: ArrayOfdecimal;
};

export type RetourImportCatalogueModelInput = {
  ListeErreurImport?: ArrayOfKeyValueOfintstringInput;
  ListeIdMediaUpdatable?: ArrayOfdecimalInput;
};

export type RetourImportRestaurationModel = {
  __typename?: 'RetourImportRestaurationModel';
  ListeNumeroLigneEnErreur?: ArrayOfint;
  NombreArticlesAjoutees?: number;
  NombreFamillesAjoutees?: number;
  NombreProduitsAjoutees?: number;
};

export type RetourImportRestaurationModelInput = {
  ListeNumeroLigneEnErreur?: ArrayOfintInput;
  NombreArticlesAjoutees?: number;
  NombreFamillesAjoutees?: number;
  NombreProduitsAjoutees?: number;
};

export type RetourMoteurChoixUtilisateurModelDto = {
  __typename?: 'RetourMoteurChoixUtilisateurModelDTO';
  MustValidate?: boolean;
  MyGuid?: string;
  PrixUnitaireArticle?: number;
  QuantiteAcceptee?: number;
  QuantiteNonSubventionnee?: number;
  QuantitePassee?: number;
  SommeMontantAccepte?: number;
  SommeMontantMaximum?: number;
  Status?: StatusDtoEnum;
  TextLibelleArticle?: string;
  TextLibelleProduit?: string;
};

export type RetourMoteurChoixUtilisateurModelDtoInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  PrixUnitaireArticle?: number;
  QuantiteAcceptee?: number;
  QuantiteNonSubventionnee?: number;
  QuantitePassee?: number;
  SommeMontantAccepte?: number;
  SommeMontantMaximum?: number;
  Status?: StatusDtoEnum;
  TextLibelleArticle?: string;
  TextLibelleProduit?: string;
};

export type RetourMoteurModelDto = {
  __typename?: 'RetourMoteurModelDTO';
  Accepte?: boolean;
  AppelMoteur?: any;
  AutorisationQuantiteSansSubvention?: boolean;
  ChoixUtilisateurRetourMoteur?: RetourMoteurChoixUtilisateurModelDto;
  ForcageAutorise?: boolean;
  IdBenefLigne?: number;
  IsSubventionChoisie?: boolean;
  ListRaisonsRefusAccessibilite?: ArrayOfstring;
  ListeSubventionsAccordees?: ArrayOfanyType;
  Log?: string;
  MessageLimiteAtteinte?: string;
  MessageLimiteAtteinteBenef?: string;
  MessageRefusAccessibilite?: string;
  MessageRefusAccessibiliteBenef?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteAccepte?: number;
  QuantiteMaximum?: number;
  QuantiteNonSubventionnee?: number;
  RestantLimiteValeurFaciale?: number;
  Resultat?: boolean;
  Status?: StatusDtoEnum;
  SubventionAccordeeEnCours?: any;
  SubventionComplementaireMaxiAcceptee?: number;
  SubventionComplementaireMaxiAvecForcage?: number;
  SubventionComplementaireMaxiAvecNonSubventionnes?: number;
  Type?: TypeRetourMoteurEnum;
};

export type RetourMoteurModelDtoInput = {
  Accepte?: boolean;
  AppelMoteur?: any;
  AutorisationQuantiteSansSubvention?: boolean;
  ChoixUtilisateurRetourMoteur?: RetourMoteurChoixUtilisateurModelDtoInput;
  ForcageAutorise?: boolean;
  IdBenefLigne?: number;
  IsSubventionChoisie?: boolean;
  ListRaisonsRefusAccessibilite?: ArrayOfstringInput;
  ListeSubventionsAccordees?: ArrayOfanyTypeInput;
  Log?: string;
  MessageLimiteAtteinte?: string;
  MessageLimiteAtteinteBenef?: string;
  MessageRefusAccessibilite?: string;
  MessageRefusAccessibiliteBenef?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QuantiteAccepte?: number;
  QuantiteMaximum?: number;
  QuantiteNonSubventionnee?: number;
  RestantLimiteValeurFaciale?: number;
  Resultat?: boolean;
  Status?: StatusDtoEnum;
  SubventionAccordeeEnCours?: any;
  SubventionComplementaireMaxiAcceptee?: number;
  SubventionComplementaireMaxiAvecForcage?: number;
  SubventionComplementaireMaxiAvecNonSubventionnes?: number;
  Type?: TypeRetourMoteurEnum;
};

export type RetourReglementBaseModelInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RetourReglementDossierPretsEtDonsModel = {
  __typename?: 'RetourReglementDossierPretsEtDonsModel';
  ListeReglement?: ArrayOfReglementPretsEtDonsListerModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StatutDossier?: any;
};

export type RetourReglementDossierPretsEtDonsModelInput = {
  ListeReglement?: ArrayOfReglementPretsEtDonsListerModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  StatutDossier?: any;
};

export type RetourSaveProfilDroit = {
  __typename?: 'RetourSaveProfilDroit';
  IdProfil?: number;
  ListeCodesFonctionnalites?: ArrayOfstring;
  ListeCodesWidgets?: ArrayOfstring;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RetourSaveProfilDroitInput = {
  IdProfil?: number;
  ListeCodesFonctionnalites?: ArrayOfstringInput;
  ListeCodesWidgets?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RetourVerificationUniciteBeneficiaireModel = {
  __typename?: 'RetourVerificationUniciteBeneficiaireModel';
  BeneficiaireMatricule?: BenefBenefBaseModel;
  Homonymes?: BenefBenefTotalModel;
  PseudoExists?: boolean;
};

export type RetourVerificationUniciteBeneficiaireModelInput = {
  BeneficiaireMatricule?: BenefBenefBaseModelInput;
  Homonymes?: BenefBenefTotalModelInput;
  PseudoExists?: boolean;
};

export type ReturnModeleForVente = {
  __typename?: 'ReturnModeleForVente';
  Benef?: BenefDto;
  IdDevisCde?: number;
  IdFacture?: number;
  IsFactureTotalementSoldeParAcompte?: boolean;
  ListeidBlbr?: ArrayOfdecimal;
  MessageErreur?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type ReturnModeleForVenteInput = {
  Benef?: BenefDtoInput;
  IdDevisCde?: number;
  IdFacture?: number;
  IsFactureTotalementSoldeParAcompte?: boolean;
  ListeidBlbr?: ArrayOfdecimalInput;
  MessageErreur?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RibDto = {
  __typename?: 'RibDTO';
  AdresseCodePaysIBAN?: string;
  AdresseCodePostalIBAN?: string;
  AdresseLigne1IBAN?: string;
  AdresseLigne2IBAN?: string;
  AdresseVilleIBAN?: string;
  BBANEncrypted?: string;
  BICEncrypted?: string;
  Banque?: CompteBancaireDto;
  Beneficiaire?: BenefDto;
  BicIban?: string;
  CleIban?: string;
  CleRib?: string;
  CodeBanque?: string;
  CodeCompte?: string;
  CodeGuichet?: string;
  CodePays?: string;
  DateCloture?: any;
  DateCreation?: any;
  EstCloture?: boolean;
  EstRibParDefaut?: boolean;
  Fournisseur?: FournisseurDto;
  Iban?: string;
  Id?: number;
  IsValide?: boolean;
  LastUserModif?: UsersDto;
  ListePieceJustificative?: ArrayOfPieceJustificativeBenefModel;
  ListeRibMandat?: ArrayOfRibMandatDto;
  MouvementComptable?: MouvementComptableDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  Status?: StatusDtoEnum;
  TitulaireCompteIBAN?: string;
};

export type RibDtoInput = {
  AdresseCodePaysIBAN?: string;
  AdresseCodePostalIBAN?: string;
  AdresseLigne1IBAN?: string;
  AdresseLigne2IBAN?: string;
  AdresseVilleIBAN?: string;
  BBANEncrypted?: string;
  BICEncrypted?: string;
  Banque?: CompteBancaireDtoInput;
  Beneficiaire?: BenefDtoInput;
  BicIban?: string;
  CleIban?: string;
  CleRib?: string;
  CodeBanque?: string;
  CodeCompte?: string;
  CodeGuichet?: string;
  CodePays?: string;
  DateCloture?: any;
  DateCreation?: any;
  EstCloture?: boolean;
  EstRibParDefaut?: boolean;
  Fournisseur?: FournisseurDtoInput;
  Iban?: string;
  Id?: number;
  IsValide?: boolean;
  LastUserModif?: UsersDtoInput;
  ListePieceJustificative?: ArrayOfPieceJustificativeBenefModelInput;
  ListeRibMandat?: ArrayOfRibMandatDtoInput;
  MouvementComptable?: MouvementComptableDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  Status?: StatusDtoEnum;
  TitulaireCompteIBAN?: string;
};

export type RibMandatBanque = {
  __typename?: 'RibMandatBanque';
  IdCptBnq?: number;
  IdRibMandat?: number;
  LibelleCompteBancaire?: string;
  ReferenceMandat?: string;
};

export type RibMandatBanqueInput = {
  IdCptBnq?: number;
  IdRibMandat?: number;
  LibelleCompteBancaire?: string;
  ReferenceMandat?: string;
};

export type RibMandatDto = {
  __typename?: 'RibMandatDTO';
  BanqueRemise?: BanqueRemiseDto;
  CompteBancaire?: CompteBancaireDto;
  DateCreation?: any;
  DateDerniereOperation?: any;
  DateValeur?: any;
  Id?: number;
  IdRemisEnBanque?: number;
  IsClos?: boolean;
  IsUnique?: boolean;
  LastUserModif?: UsersDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroReference?: string;
  Remarque?: string;
  Rib?: RibDto;
  Status?: StatusDtoEnum;
};

export type RibMandatDtoInput = {
  BanqueRemise?: BanqueRemiseDtoInput;
  CompteBancaire?: CompteBancaireDtoInput;
  DateCreation?: any;
  DateDerniereOperation?: any;
  DateValeur?: any;
  Id?: number;
  IdRemisEnBanque?: number;
  IsClos?: boolean;
  IsUnique?: boolean;
  LastUserModif?: UsersDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroReference?: string;
  Remarque?: string;
  Rib?: RibDtoInput;
  Status?: StatusDtoEnum;
};

export type RibModelDto = {
  __typename?: 'RibModelDTO';
  BBAN?: string;
  BBAN_encrypt?: string;
  Cle?: string;
  Codpay?: string;
  IdRib?: number;
  IsCloture?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  Status?: StatusDtoEnum;
};

export type RibModelDtoInput = {
  BBAN?: string;
  BBAN_encrypt?: string;
  Cle?: string;
  Codpay?: string;
  IdRib?: number;
  IsCloture?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBanque?: string;
  Status?: StatusDtoEnum;
};

export type RoomingListeParticipantsModel = {
  __typename?: 'RoomingListeParticipantsModel';
  Civilite?: string;
  CodeStatutCommande?: string;
  ColorStatutCommande?: string;
  DateNaissanceBeneficiaire?: any;
  IdBeneficiaire?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdODCommande?: number;
  IdStatutCommande?: number;
  LibelleStatutCommande?: string;
  ListeReponsesFormulaires?: ArrayOfReponseFormulaireAPlatModel;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBeneficiaire?: string;
  PrenomBeneficiaire?: string;
  Status?: StatusDtoEnum;
  TypeBeneficiaire?: string;
};

export type RoomingListeParticipantsModelInput = {
  Civilite?: string;
  CodeStatutCommande?: string;
  ColorStatutCommande?: string;
  DateNaissanceBeneficiaire?: any;
  IdBeneficiaire?: number;
  IdCommande?: number;
  IdLigneCommande?: number;
  IdODCommande?: number;
  IdStatutCommande?: number;
  LibelleStatutCommande?: string;
  ListeReponsesFormulaires?: ArrayOfReponseFormulaireAPlatModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBeneficiaire?: string;
  PrenomBeneficiaire?: string;
  Status?: StatusDtoEnum;
  TypeBeneficiaire?: string;
};

export type RubriquageModelDto = {
  __typename?: 'RubriquageModelDTO';
  Id?: number;
  IdEtat?: number;
  IsDefault?: boolean;
  IsOfficial?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RubriquageModelDtoInput = {
  Id?: number;
  IdEtat?: number;
  IsDefault?: boolean;
  IsOfficial?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RubriquageTreeviewModelDto = {
  __typename?: 'RubriquageTreeviewModelDTO';
  Libelle?: string;
  ListeRubrique?: ArrayOfRubriquageTreeviewModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type RubriquageTreeviewModelDtoInput = {
  Libelle?: string;
  ListeRubrique?: ArrayOfRubriquageTreeviewModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SaisieEcrituresInitSaisieEcrituresModelDto = {
  __typename?: 'SaisieEcrituresInitSaisieEcrituresModelDTO';
  ListeBanque?: ArrayOfstring;
  ListeBeneficiaire?: ArrayOfBenefComboModel;
  ListeCEDelegation?: ArrayOfCommunCeDelegationModel;
  ListeCaisse?: ArrayOfComptaCaisseModelDto;
  ListeCompte?: ArrayOfComptaCompteModelDto;
  ListeCompteBancaire?: ArrayOfComptaCompteBancaireModelDto;
  ListeExercice?: ArrayOfComptaExerciceModelDto;
  ListeJournaux?: ArrayOfComptaJournalModel;
  ListeMoyenPaiement?: ArrayOfComptaMoyenPaiementModelDto;
};

export type SaisieEcrituresInitSaisieEcrituresModelDtoInput = {
  ListeBanque?: ArrayOfstringInput;
  ListeBeneficiaire?: ArrayOfBenefComboModelInput;
  ListeCEDelegation?: ArrayOfCommunCeDelegationModelInput;
  ListeCaisse?: ArrayOfComptaCaisseModelDtoInput;
  ListeCompte?: ArrayOfComptaCompteModelDtoInput;
  ListeCompteBancaire?: ArrayOfComptaCompteBancaireModelDtoInput;
  ListeExercice?: ArrayOfComptaExerciceModelDtoInput;
  ListeJournaux?: ArrayOfComptaJournalModelInput;
  ListeMoyenPaiement?: ArrayOfComptaMoyenPaiementModelDtoInput;
};

export type SaisieEcrituresModelSaveEcritureManuelleInput = {
  EcritureManuelle?: ComptaEcritureModelDtoInput;
  ListeMouvement?: ArrayOfComptaMouvementComptableModelDtoInput;
};

export type SaisieEcrituresModelSaveEcritureTiersInput = {
  EcritureFacturation?: ComptaEcritureModelDtoInput;
  EcritureReglement?: ComptaEcritureModelDtoInput;
  ListeClesRepartitions?: ArrayOfCleRepartitionModelDtoInput;
};

export type SaveActiviteModelDtoInput = {
  Activite?: ActiviteDtoInput;
  ComptabiliteEpargnes?: ComptabiliteEpargnesActiviteModelInput;
  CritereSaveActivite?: CriteresActiviteDtoInput;
  ListeActiviteCompteBancaireModel?: ArrayOfActiviteCompteBancaireModelDtoInput;
  ListeActiviteFraisPortAchatSectionAnalytique?: ArrayOfFpaSectionAnalytiqueModelDtoInput;
  ListeActiviteFraisPortVenteSectionAnalytique?: ArrayOfFpaSectionAnalytiqueModelDtoInput;
  ListeActiviteTropPercuSectionAnalytique?: ArrayOfFpaSectionAnalytiqueModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RedescendreFactureCentraliseSurTsProduit?: boolean;
  Status?: StatusDtoEnum;
};

export type SaveArticleModelDtoInput = {
  Article?: ArticleDtoInput;
  CadeauModel?: SaveCadeauxFpaModelInput;
  CritereSaveArticle?: CriteresSaveArticleDtoInput;
  ListeArticleSectionAnalytique?: ArrayOfFpaSectionAnalytiqueModelDtoInput;
  ListePJ?: ArrayOfPieceJustificativeBenefModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SaveBenefModelDtoInput = {
  Benef?: BenefDtoInput;
  ListePieceJustificative?: ArrayOfPieceJustificativeBenefModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SaveCeDelegationModelDto = {
  __typename?: 'SaveCEDelegationModelDTO';
  CritereCEDelegation?: CriteresCeDelegationDto;
  ListeCEDelegation?: ArrayOfCeDelegationDto;
  ListeCEDelegationRefacFraisCBSectionAnalytique?: ArrayOfFpaSectionAnalytiqueModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SaveCeDelegationModelDtoInput = {
  CritereCEDelegation?: CriteresCeDelegationDtoInput;
  ListeCEDelegation?: ArrayOfCeDelegationDtoInput;
  ListeCEDelegationRefacFraisCBSectionAnalytique?: ArrayOfFpaSectionAnalytiqueModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SaveCadeauxFpaModelInput = {
  ListeCadeaux?: ArrayOfCadeauFpaModelInput;
  ModeSimple?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SaveCessionStockModelInput = {
  GenererMouvementEntree?: boolean;
  GenererMouvementSortie?: boolean;
  ListeModeleLigneCession?: ArrayOfanyTypeInput;
  ModeleCession?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SaveCompteBancaireModelDto = {
  __typename?: 'SaveCompteBancaireModelDTO';
  CompteBancaire?: CompteBancaireDto;
  CritereBanque?: CriteresBanqueDto;
  ListeBanque?: ArrayOfBanqueDto;
  ListeCompte511Agreg?: ArrayOfCompte511AgregCompte511AgregModel;
  ListeCompteBancaireFraisCBSectionAnalytique?: ArrayOfFpaSectionAnalytiqueModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SaveCompteBancaireModelDtoInput = {
  CompteBancaire?: CompteBancaireDtoInput;
  CritereBanque?: CriteresBanqueDtoInput;
  ListeBanque?: ArrayOfBanqueDtoInput;
  ListeCompte511Agreg?: ArrayOfCompte511AgregCompte511AgregModelInput;
  ListeCompteBancaireFraisCBSectionAnalytique?: ArrayOfFpaSectionAnalytiqueModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SaveCompteEcritureModelDtoInput = {
  CompteEcriture?: CompteEcritureDtoInput;
  ListeMouvementClesRepartition?: ArrayOfMouvementComptableCleRepartitionModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SaveEtGenerationArtLocModelDtoInput = {
  AnneeRef?: AnneeReferenceDtoInput;
  Code?: string;
  HeureDebut?: any;
  HeureFin?: any;
  JourDebut?: number;
  JourFin?: number;
  Libelle?: string;
  LibellePeriode?: string;
  ListPlage?: ArrayOfGenerationArticleLocationModelInput;
  NBJour?: number;
  Produit?: ProduitDtoInput;
  SessionChoix?: SessionChoixDtoInput;
  UsersCurent?: UsersDtoInput;
};

export type SaveFamilleModelDtoInput = {
  CadeauModel?: SaveCadeauxFpaModelInput;
  CritereSaveFamille?: CriteresSaveFamilleDtoInput;
  Famille?: FamilleProduitDtoInput;
  ListeFamilleProduitSectionAnalytique?: ArrayOfFpaSectionAnalytiqueModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SaveLigneCessionStockModelInput = {
  IdLigneCessionStock?: number;
  QuantiteEntree?: number;
};

export type SaveModelImpressionDtoInput = {
  CodeReport?: string;
  Courrier?: CourrierDtoInput;
  IdBenef?: number;
  ListeParametresImpression?: ArrayOfParametreImpressionDtoInput;
};

export type SaveModeleSaisieModelDtoInput = {
  ListeModeleSaisieSectionAnaParPlan?: ArrayOfModeleSaisieSectionAnaParPlanModelDtoInput;
  ModeleSaisieLibre?: ModeleSaisieLibreDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SaveParamFicheProfileModelInput = {
  BlocModele?: BlocModelDtoInput;
  IdCE?: number;
  ListBlocModelUpdateOrder?: ArrayOfBlocModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SaveProduitModelDtoInput = {
  CadeauModel?: SaveCadeauxFpaModelInput;
  CritereSaveProduit?: CriteresSaveProduitDtoInput;
  ListeProduitSectionAnalytique?: ArrayOfFpaSectionAnalytiqueModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Produit?: ProduitDtoInput;
  Status?: StatusDtoEnum;
};

export type SaveRemiseEnBanqueBaseModelInput = {
  DateRemise?: any;
  IdCECible?: number;
  IdCECreePar?: number;
  IdCESource?: number;
  IdCaisse?: number;
  IdCompteBancaire?: number;
  IdJournalTresorerie?: number;
  IdMoyenPaiement?: number;
  IdUtilisateur?: number;
  LibelleEcriture?: string;
  NumeroBordereau?: string;
  NumeroPieceTresorerie?: string;
  Remarque?: string;
};

export type SaveRemiseEnBanqueFiduciaireModelInput = {
  DateRemise?: any;
  IdCECible?: number;
  IdCECreePar?: number;
  IdCESource?: number;
  IdCaisse?: number;
  IdCompteBancaire?: number;
  IdJournalEspece?: number;
  IdJournalTresorerie?: number;
  IdMoyenPaiement?: number;
  IdUtilisateur?: number;
  LibelleEcriture?: string;
  MontantARemettreEnBanque?: number;
  NumeroBordereau?: string;
  NumeroPieceEspece?: string;
  NumeroPieceTresorerie?: string;
  Remarque?: string;
};

export type SaveRemiseEnBanqueNonFiduciaireModelInput = {
  DateRemise?: any;
  IdCECible?: number;
  IdCECreePar?: number;
  IdCESource?: number;
  IdCaisse?: number;
  IdCompteBancaire?: number;
  IdJournalTresorerie?: number;
  IdMoyenPaiement?: number;
  IdUtilisateur?: number;
  LibelleEcriture?: string;
  ListeIdMouvementComptable?: ArrayOfdecimalInput;
  NumeroBordereau?: string;
  NumeroPieceTresorerie?: string;
  Remarque?: string;
};

export type SaveReponsesFormulaireModelInput = {
  IdCommande?: number;
  IdLigneCommande?: number;
  ListeSoumissionFormulaire?: ArrayOfSoumissionFormulaireModelInput;
};

export type SaveSessionChoixModel = {
  __typename?: 'SaveSessionChoixModel';
  IsUsedSessionChoix?: boolean;
  SessionChoix?: SessionChoixDto;
};

export type SaveSessionChoixModelInput = {
  IsUsedSessionChoix?: boolean;
  SessionChoix?: SessionChoixDtoInput;
};

export type SaveWidgetParamModelDto = {
  __typename?: 'SaveWidgetParamModelDTO';
  CodeWidget?: string;
  CooldownWidget?: number;
  IdWidgetAccueil?: number;
  ListeWidgetParam?: ArrayOfWidgetParametreModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  RessourceWidget?: string;
  Status?: StatusDtoEnum;
  TitreWidget?: string;
};

export type SaveWidgetParamModelDtoInput = {
  CodeWidget?: string;
  CooldownWidget?: number;
  IdWidgetAccueil?: number;
  ListeWidgetParam?: ArrayOfWidgetParametreModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  RessourceWidget?: string;
  Status?: StatusDtoEnum;
  TitreWidget?: string;
};

export type SectionAnalytiqueBaseModelInput = {
  IdSection?: number;
  IdSectionPere?: number;
  IsClos?: number;
  LibelleSection?: string;
  NiveauSection?: number;
};

export type SectionAnalytiqueDto = {
  __typename?: 'SectionAnalytiqueDTO';
  Code?: string;
  Description?: string;
  Id?: number;
  IsAffichCompte?: boolean;
  IsClos?: boolean;
  Libelle?: string;
  ListeLigneFactureSectionAnalytique?: ArrayOfLigneFactureSectionAnalytiqueDto;
  ListeMouvementAnalytique?: ArrayOfMouvementAnalytiqueDto;
  ListeSectionAnalytiqueEnfant?: ArrayOfSectionAnalytiqueDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Niveau?: number;
  Pere?: SectionAnalytiqueDto;
  Plan?: PlanAnalytiqueDto;
  Status?: StatusDtoEnum;
};

export type SectionAnalytiqueDtoInput = {
  Code?: string;
  Description?: string;
  Id?: number;
  IsAffichCompte?: boolean;
  IsClos?: boolean;
  Libelle?: string;
  ListeLigneFactureSectionAnalytique?: ArrayOfLigneFactureSectionAnalytiqueDtoInput;
  ListeMouvementAnalytique?: ArrayOfMouvementAnalytiqueDtoInput;
  ListeSectionAnalytiqueEnfant?: ArrayOfSectionAnalytiqueDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Niveau?: number;
  Pere?: SectionAnalytiqueDtoInput;
  Plan?: PlanAnalytiqueDtoInput;
  Status?: StatusDtoEnum;
};

export type SectionAnalytiqueLigneCommandeModelDto = {
  __typename?: 'SectionAnalytiqueLigneCommandeModelDTO';
  IdLigneCommande?: number;
  IdPlan?: number;
  IdSectionAnalytique?: number;
  Pourcentage?: number;
};

export type SectionAnalytiqueLigneCommandeModelDtoInput = {
  IdLigneCommande?: number;
  IdPlan?: number;
  IdSectionAnalytique?: number;
  Pourcentage?: number;
};

export type SectionAnalytiqueModelDto = {
  __typename?: 'SectionAnalytiqueModelDTO';
  Code?: string;
  Description?: string;
  Id?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytiquePere?: number;
  IdSectionAnalytiquePere2?: number;
  IdSectionAnalytiquePere3?: number;
  IsAffichCompte?: boolean;
  Libelle?: string;
  LibellePosteBDG?: string;
  LibelleSectionAnalytiquePere?: string;
  LibelleSectionAnalytiquePere2?: string;
  LibelleSectionAnalytiquePere3?: string;
  LibelleSectionPereFille?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Niveau?: number;
  Pourcentage?: number;
  Status?: StatusDtoEnum;
};

export type SectionAnalytiqueModelDtoInput = {
  Code?: string;
  Description?: string;
  Id?: number;
  IdPlanAnalytique?: number;
  IdSectionAnalytiquePere?: number;
  IdSectionAnalytiquePere2?: number;
  IdSectionAnalytiquePere3?: number;
  IsAffichCompte?: boolean;
  Libelle?: string;
  LibellePosteBDG?: string;
  LibelleSectionAnalytiquePere?: string;
  LibelleSectionAnalytiquePere2?: string;
  LibelleSectionAnalytiquePere3?: string;
  LibelleSectionPereFille?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Niveau?: number;
  Pourcentage?: number;
  Status?: StatusDtoEnum;
};

export type SelectedModeleEcheancierArticleModel = {
  __typename?: 'SelectedModeleEcheancierArticleModel';
  DelaiPremiereEcheance?: number;
  IdModeleEcheancier?: number;
  IsClos?: boolean;
  IsDeclenchementAvant?: boolean;
  IsDefaut?: boolean;
  IsSelected?: boolean;
  JourDansMois?: number;
  Libelle?: string;
  MoisPremiereEcheance?: number;
  MontantMinimal?: number;
  MontantPremiereEcheance?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreEcheance?: number;
  NombreJoursDeclenchement?: number;
  Periodicite?: number;
  PourcentagePremiereEcheance?: number;
  Status?: StatusDtoEnum;
};

export type SelectedModeleEcheancierArticleModelInput = {
  DelaiPremiereEcheance?: number;
  IdModeleEcheancier?: number;
  IsClos?: boolean;
  IsDeclenchementAvant?: boolean;
  IsDefaut?: boolean;
  IsSelected?: boolean;
  JourDansMois?: number;
  Libelle?: string;
  MoisPremiereEcheance?: number;
  MontantMinimal?: number;
  MontantPremiereEcheance?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreEcheance?: number;
  NombreJoursDeclenchement?: number;
  Periodicite?: number;
  PourcentagePremiereEcheance?: number;
  Status?: StatusDtoEnum;
};

export type SelectionModeleEchancierModel = {
  __typename?: 'SelectionModeleEchancierModel';
  DelaiPremiereEcheance?: number;
  IdModeleEcheancier?: number;
  IsClos?: boolean;
  IsDeclenchementAvant?: boolean;
  JourDansMois?: number;
  Libelle?: string;
  MoisPremiereEcheance?: number;
  MontantMinimal?: number;
  MontantPremiereEcheance?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreEcheance?: number;
  NombreJoursDeclenchement?: number;
  Periodicite?: number;
  PourcentagePremiereEcheance?: number;
  Status?: StatusDtoEnum;
};

export type SelectionModeleEchancierModelInput = {
  DelaiPremiereEcheance?: number;
  IdModeleEcheancier?: number;
  IsClos?: boolean;
  IsDeclenchementAvant?: boolean;
  JourDansMois?: number;
  Libelle?: string;
  MoisPremiereEcheance?: number;
  MontantMinimal?: number;
  MontantPremiereEcheance?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreEcheance?: number;
  NombreJoursDeclenchement?: number;
  Periodicite?: number;
  PourcentagePremiereEcheance?: number;
  Status?: StatusDtoEnum;
};

export type SessionChoixBaseModel = {
  __typename?: 'SessionChoixBaseModel';
  Id?: number;
  Libelle?: string;
  NbChoix?: number;
};

export type SessionChoixBaseModelInput = {
  Id?: number;
  Libelle?: string;
  NbChoix?: number;
};

export type SessionChoixDto = {
  __typename?: 'SessionChoixDTO';
  Activite?: ActiviteDto;
  Code?: string;
  DateDebut?: any;
  DateFin?: any;
  Id?: number;
  IsClos?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbChoixPossible?: number;
  Status?: StatusDtoEnum;
};

export type SessionChoixDtoInput = {
  Activite?: ActiviteDtoInput;
  Code?: string;
  DateDebut?: any;
  DateFin?: any;
  Id?: number;
  IsClos?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NbChoixPossible?: number;
  Status?: StatusDtoEnum;
};

export type SessionChoixDevisBenefModelDto = {
  __typename?: 'SessionChoixDevisBenefModelDTO';
  IdArticleOrigine?: number;
  IdBenefOrigine?: number;
  IdSession?: number;
  Libelle?: string;
  ListNumeroChoix?: ArrayOfNumeroChoixModelDto;
  MaxNum?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumPremierChoixDispo?: number;
  Status?: StatusDtoEnum;
};

export type SessionChoixDevisBenefModelDtoInput = {
  IdArticleOrigine?: number;
  IdBenefOrigine?: number;
  IdSession?: number;
  Libelle?: string;
  ListNumeroChoix?: ArrayOfNumeroChoixModelDtoInput;
  MaxNum?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumPremierChoixDispo?: number;
  Status?: StatusDtoEnum;
};

export type SimulationChequierDynamiqueModel = {
  __typename?: 'SimulationChequierDynamiqueModel';
  CompositionChequierString?: ArrayOfstring;
  MontantChequier?: number;
  MontantSubvention?: number;
};

export type SimulationChequierDynamiqueModelInput = {
  CompositionChequierString?: ArrayOfstringInput;
  MontantChequier?: number;
  MontantSubvention?: number;
};

export type SiteBaseModel = {
  __typename?: 'SiteBaseModel';
  IdSite?: number;
  NomSite?: string;
};

export type SiteBaseModelInput = {
  IdSite?: number;
  NomSite?: string;
};

export type SiteDto = {
  __typename?: 'SiteDTO';
  ANCVModeEnvoi?: AncvModeEnvoiDto;
  Adresse?: AdresseDto;
  CEDelegation?: CeDelegationDto;
  Code?: string;
  CodeANCV?: string;
  CodeAnalytique?: string;
  CodeModeEnvoiANCV?: string;
  CodeSuccursale?: string;
  FaxSite?: string;
  Id?: number;
  IdSiteLivraison?: number;
  IsCloture?: boolean;
  LibelleAdresseANCV?: string;
  ListeSiteFils?: ArrayOfSiteDto;
  MailSite?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  SiteParent?: SiteDto;
  Status?: StatusDtoEnum;
  TelSite?: string;
};

export type SiteDtoInput = {
  ANCVModeEnvoi?: AncvModeEnvoiDtoInput;
  Adresse?: AdresseDtoInput;
  CEDelegation?: CeDelegationDtoInput;
  Code?: string;
  CodeANCV?: string;
  CodeAnalytique?: string;
  CodeModeEnvoiANCV?: string;
  CodeSuccursale?: string;
  FaxSite?: string;
  Id?: number;
  IdSiteLivraison?: number;
  IsCloture?: boolean;
  LibelleAdresseANCV?: string;
  ListeSiteFils?: ArrayOfSiteDtoInput;
  MailSite?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  SiteParent?: SiteDtoInput;
  Status?: StatusDtoEnum;
  TelSite?: string;
};

export type SiteForExportAncvModelDto = {
  __typename?: 'SiteForExportANCVModelDTO';
  CodeANCVSite?: string;
  IdBenef?: number;
  IsAllArticlePrixPublicCorrect?: boolean;
  IsBenefSansSite?: boolean;
  LibelleANCVSite?: string;
  MatriculeBenef?: string;
  ModeFicheANCVSite?: string;
  NomBenef?: string;
  PrenomBenef?: string;
};

export type SiteForExportAncvModelDtoInput = {
  CodeANCVSite?: string;
  IdBenef?: number;
  IsAllArticlePrixPublicCorrect?: boolean;
  IsBenefSansSite?: boolean;
  LibelleANCVSite?: string;
  MatriculeBenef?: string;
  ModeFicheANCVSite?: string;
  NomBenef?: string;
  PrenomBenef?: string;
};

export type SiteLivraison = {
  __typename?: 'SiteLivraison';
  DateSynchroSynapse?: any;
  IdSiteLivraison?: number;
  IsClos?: boolean;
  Label?: string;
  UuidSiteLivraison?: string;
};

export type SiteLivraisonInput = {
  DateSynchroSynapse?: any;
  IdSiteLivraison?: number;
  IsClos?: boolean;
  Label?: string;
  UuidSiteLivraison?: string;
};

export type SiteOrganisationBaseModel = {
  __typename?: 'SiteOrganisationBaseModel';
  IdSiteOrganisation?: number;
  NomSiteOrganisation?: string;
};

export type SiteOrganisationBaseModelInput = {
  IdSiteOrganisation?: number;
  NomSiteOrganisation?: string;
};

export type SoldeConsommationModelDto = {
  __typename?: 'SoldeConsommationModelDTO';
  ListeSoldeConsommation?: ArrayOfSoldeConsommationsDto;
  NbElements?: number;
};

export type SoldeConsommationModelDtoInput = {
  ListeSoldeConsommation?: ArrayOfSoldeConsommationsDtoInput;
  NbElements?: number;
};

export type SoldeConsommationsDto = {
  __typename?: 'SoldeConsommationsDTO';
  ActiviteId?: number;
  BenefId?: number;
  EnveloppeId?: number;
  FamilleProduitId?: number;
  LibelleActivite?: string;
  LibelleEnveloppe?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  MatriculeBenef?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBenef?: string;
  PrenomBenef?: string;
  ProduitId?: number;
  Site?: string;
  SoldeQuantiteQuota?: number;
  SoldeSubventionMontant?: number;
  SoldeValeurFaciale?: number;
  Status?: StatusDtoEnum;
  TypeContrat?: string;
};

export type SoldeConsommationsDtoInput = {
  ActiviteId?: number;
  BenefId?: number;
  EnveloppeId?: number;
  FamilleProduitId?: number;
  LibelleActivite?: string;
  LibelleEnveloppe?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  MatriculeBenef?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBenef?: string;
  PrenomBenef?: string;
  ProduitId?: number;
  Site?: string;
  SoldeQuantiteQuota?: number;
  SoldeSubventionMontant?: number;
  SoldeValeurFaciale?: number;
  Status?: StatusDtoEnum;
  TypeContrat?: string;
};

export type SoldeNonRapprocheModel = {
  __typename?: 'SoldeNonRapprocheModel';
  IdReleveBancaire?: number;
  Solde?: number;
};

export type SoldeNonRapprocheModelInput = {
  IdReleveBancaire?: number;
  Solde?: number;
};

export type SoldePmvModel = {
  __typename?: 'SoldePMVModel';
  CodePMV?: string;
  DateDerniereEcriture?: any;
  IdBenef?: number;
  IdCptPMV?: number;
  IsCloture?: boolean;
  LibellePMV?: string;
  NomPrenomBenef?: string;
  Solde?: number;
};

export type SoldePmvModelInput = {
  CodePMV?: string;
  DateDerniereEcriture?: any;
  IdBenef?: number;
  IdCptPMV?: number;
  IsCloture?: boolean;
  LibellePMV?: string;
  NomPrenomBenef?: string;
  Solde?: number;
};

export type SolderReglerPartiellementModeleInput = {
  DateReglement?: any;
  IdCompteBancaire?: number;
  IdCompteCollectif?: number;
  IdJournal?: number;
  IdModeleEcheancier?: number;
  IdMoyenPaiement?: number;
  ListeIdCommandes?: ArrayOfdecimalInput;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  PourcentageFacture?: number;
  Status?: StatusDtoEnum;
};

export type SommeCompteurPointModelDto = {
  __typename?: 'SommeCompteurPointModelDTO';
  IdBenef?: number;
  IdCompteurPoint?: number;
  LibelleCompteurPoint?: string;
  MatriculeBenef?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBenef?: string;
  NomPrenomBenef?: string;
  PrenomBenef?: string;
  Somme?: number;
  Status?: StatusDtoEnum;
};

export type SommeCompteurPointModelDtoInput = {
  IdBenef?: number;
  IdCompteurPoint?: number;
  LibelleCompteurPoint?: string;
  MatriculeBenef?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  NomBenef?: string;
  NomPrenomBenef?: string;
  PrenomBenef?: string;
  Somme?: number;
  Status?: StatusDtoEnum;
};

export type SondageSondageQuestionPortletModel = {
  __typename?: 'SondageSondageQuestionPortletModel';
  DateDebut?: any;
  DateFin?: any;
  Id?: number;
  IdSondage?: number;
  IsMultiple?: boolean;
  IsUnique?: boolean;
  Libelle?: string;
};

export type SondageSondageQuestionPortletModelInput = {
  DateDebut?: any;
  DateFin?: any;
  Id?: number;
  IdSondage?: number;
  IsMultiple?: boolean;
  IsUnique?: boolean;
  Libelle?: string;
};

export type SoumissionFormulaireModel = {
  __typename?: 'SoumissionFormulaireModel';
  IdFormulaire?: number;
  IdParticipant?: number;
  ListeReponseObservable?: ArrayOfValeurReponseModel;
  ListeReponses?: ArrayOfanyType;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SoumissionFormulaireModelInput = {
  IdFormulaire?: number;
  IdParticipant?: number;
  ListeReponseObservable?: ArrayOfValeurReponseModelInput;
  ListeReponses?: ArrayOfanyTypeInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SousBudgetListingModel = {
  __typename?: 'SousBudgetListingModel';
  Id?: number;
  IdExercice?: number;
  IdPlanAnalytique?: number;
  IsAnalytique?: boolean;
  Libelle?: string;
  ListePostesBudgetaires?: ArrayOfanyType;
  TypeBudget?: string;
};

export type SousBudgetListingModelInput = {
  Id?: number;
  IdExercice?: number;
  IdPlanAnalytique?: number;
  IsAnalytique?: boolean;
  Libelle?: string;
  ListePostesBudgetaires?: ArrayOfanyTypeInput;
  TypeBudget?: string;
};

export enum StatistiqueActiviteEnum {
  Benef = 'Benef',
  Ca = 'CA',
  Qte = 'Qte'
}

export enum StatusDtoEnum {
  Deleted = 'DELETED',
  Inserted = 'INSERTED',
  None = 'NONE',
  Referenced = 'REFERENCED',
  Unchanged = 'UNCHANGED',
  Updated = 'UPDATED'
}

export type StatutCommandeDto = {
  __typename?: 'StatutCommandeDTO';
  Code?: string;
  Couleur?: string;
  Id?: number;
  IsEnteteDevis?: boolean;
  IsLigneDevis?: boolean;
  Libelle?: string;
  ListeHistoStatut?: ArrayOfHistoStatutCommandeDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type StatutCommandeDtoInput = {
  Code?: string;
  Couleur?: string;
  Id?: number;
  IsEnteteDevis?: boolean;
  IsLigneDevis?: boolean;
  Libelle?: string;
  ListeHistoStatut?: ArrayOfHistoStatutCommandeDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type StatutCommandeLibelleModel = {
  __typename?: 'StatutCommandeLibelleModel';
  CodeStatut?: string;
  IdStatutCommande?: number;
  LibelleStatut?: string;
};

export type StatutCommandeLibelleModelInput = {
  CodeStatut?: string;
  IdStatutCommande?: number;
  LibelleStatut?: string;
};

export type StatutCourrierDto = {
  __typename?: 'StatutCourrierDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type StatutCourrierDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type StatutDossierEpargneModel = {
  __typename?: 'StatutDossierEpargneModel';
  AReglerSurCommandeGeneree?: number;
  CodeStatut?: string;
  HasArticleAssocie?: boolean;
  IdCommandeGeneree?: number;
  IdDossier?: number;
  IdStatutCommande?: number;
  IdStatutPerso?: number;
  IsAllEcheancesRemisEnBanque?: boolean;
  IsDossierClotureAvantTerme?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  RestantAEpargner?: number;
  Status?: StatusDtoEnum;
};

export type StatutDossierEpargneModelInput = {
  AReglerSurCommandeGeneree?: number;
  CodeStatut?: string;
  HasArticleAssocie?: boolean;
  IdCommandeGeneree?: number;
  IdDossier?: number;
  IdStatutCommande?: number;
  IdStatutPerso?: number;
  IsAllEcheancesRemisEnBanque?: boolean;
  IsDossierClotureAvantTerme?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  RestantAEpargner?: number;
  Status?: StatusDtoEnum;
};

export type StatutDossierPretsEtDonsModel = {
  __typename?: 'StatutDossierPretsEtDonsModel';
  CodeStatut?: string;
  IdDossier?: number;
  IdStatutCommande?: number;
  IdStatutPerso?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type StatutDossierPretsEtDonsModelInput = {
  CodeStatut?: string;
  IdDossier?: number;
  IdStatutCommande?: number;
  IdStatutPerso?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type StatutFactureBaseModel = {
  __typename?: 'StatutFactureBaseModel';
  IdStatutFacture?: number;
  LibelleStatutFacture?: string;
};

export type StatutFactureBaseModelInput = {
  IdStatutFacture?: number;
  LibelleStatutFacture?: string;
};

export type StatutFactureDto = {
  __typename?: 'StatutFactureDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  ListeHistoStatutFacture?: ArrayOfHistoStatutFactureDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type StatutFactureDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  ListeHistoStatutFacture?: ArrayOfHistoStatutFactureDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type StatutPersoActionModel = {
  __typename?: 'StatutPersoActionModel';
  ComplementLibelleDeclencheur?: string;
  IdStatutCommande?: number;
  IdStatutPerso?: number;
  IdTrigger?: number;
  LibelleDeclencheur?: string;
  ListeLibelleAction?: ArrayOfanyType;
  ListeValeursListeCriteres?: ArrayOfanyType;
  ListeValeursTexteCriteres?: ArrayOfstring;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreJour?: number;
  Status?: StatusDtoEnum;
};

export type StatutPersoActionModelInput = {
  ComplementLibelleDeclencheur?: string;
  IdStatutCommande?: number;
  IdStatutPerso?: number;
  IdTrigger?: number;
  LibelleDeclencheur?: string;
  ListeLibelleAction?: ArrayOfanyTypeInput;
  ListeValeursListeCriteres?: ArrayOfanyTypeInput;
  ListeValeursTexteCriteres?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreJour?: number;
  Status?: StatusDtoEnum;
};

export type StatutPersoActionTypeModel = {
  __typename?: 'StatutPersoActionTypeModel';
  CodeTypeAction?: string;
  IdTypeAction?: number;
  LibelleTypeAction?: string;
};

export type StatutPersoActionTypeModelInput = {
  CodeTypeAction?: string;
  IdTypeAction?: number;
  LibelleTypeAction?: string;
};

export type StatutPersoBaseModel = {
  __typename?: 'StatutPersoBaseModel';
  IdStatutPerso?: number;
  LibelleStatutPerso?: string;
};

export type StatutPersoBaseModelInput = {
  IdStatutPerso?: number;
  LibelleStatutPerso?: string;
};

export type StatutPersoCommandeDto = {
  __typename?: 'StatutPersoCommandeDTO';
  Code?: string;
  Couleur?: string;
  Description?: string;
  Id?: number;
  IsClos?: boolean;
  IsModificationManuelPossible?: boolean;
  IsVisibleEnLigne?: boolean;
  Libelle?: string;
  LibelleEnLigne?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type StatutPersoCommandeDtoInput = {
  Code?: string;
  Couleur?: string;
  Description?: string;
  Id?: number;
  IsClos?: boolean;
  IsModificationManuelPossible?: boolean;
  IsVisibleEnLigne?: boolean;
  Libelle?: string;
  LibelleEnLigne?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type StatutPersoCouleurModel = {
  __typename?: 'StatutPersoCouleurModel';
  Couleur?: string;
  IdStatutPerso?: number;
  IsModifManuellePossible?: boolean;
  LibelleStatutPerso?: string;
};

export type StatutPersoCouleurModelInput = {
  Couleur?: string;
  IdStatutPerso?: number;
  IsModifManuellePossible?: boolean;
  LibelleStatutPerso?: string;
};

export type StatutPersoModel = {
  __typename?: 'StatutPersoModel';
  CodeStatutPere?: string;
  CodeStatutPerso?: string;
  IdStatutPerso?: number;
  IsModificationManuelPossible?: boolean;
  IsStatutPerso?: boolean;
  LibelleStatutPerso?: string;
};

export type StatutPersoModelInput = {
  CodeStatutPere?: string;
  CodeStatutPerso?: string;
  IdStatutPerso?: number;
  IsModificationManuelPossible?: boolean;
  IsStatutPerso?: boolean;
  LibelleStatutPerso?: string;
};

export type StatutPersoParamModel = {
  __typename?: 'StatutPersoParamModel';
  CodeStatutPere?: string;
  CodeStatutPerso?: string;
  Couleur?: string;
  Description?: string;
  IdActivite?: number;
  IdStatutPere?: number;
  IdStatutPerso?: number;
  IsCloture?: boolean;
  IsPassageManuel?: boolean;
  IsStatutPerso?: boolean;
  IsVisibleEnLigne?: boolean;
  LibelleEnLigne?: string;
  LibelleStatutPerso?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type StatutPersoParamModelInput = {
  CodeStatutPere?: string;
  CodeStatutPerso?: string;
  Couleur?: string;
  Description?: string;
  IdActivite?: number;
  IdStatutPere?: number;
  IdStatutPerso?: number;
  IsCloture?: boolean;
  IsPassageManuel?: boolean;
  IsStatutPerso?: boolean;
  IsVisibleEnLigne?: boolean;
  LibelleEnLigne?: string;
  LibelleStatutPerso?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type StatutPersoTriggerTypeBaseModel = {
  __typename?: 'StatutPersoTriggerTypeBaseModel';
  CodeTypeTrigger?: string;
  IdTypeTrigger?: number;
  LibelleTypeTrigger?: string;
};

export type StatutPersoTriggerTypeBaseModelInput = {
  CodeTypeTrigger?: string;
  IdTypeTrigger?: number;
  LibelleTypeTrigger?: string;
};

export type StatutWithOrdreModel = {
  __typename?: 'StatutWithOrdreModel';
  CodeStatut?: string;
  Couleur?: string;
  IdStatut?: number;
  IdStatutPere?: number;
  IsCloture?: boolean;
  IsStatutPerso?: boolean;
  IsSupprimable?: boolean;
  LibelleStatut?: string;
  NombreDeclencheurLie?: number;
  Ordre?: number;
  OrdreMax?: number;
};

export type StatutWithOrdreModelInput = {
  CodeStatut?: string;
  Couleur?: string;
  IdStatut?: number;
  IdStatutPere?: number;
  IsCloture?: boolean;
  IsStatutPerso?: boolean;
  IsSupprimable?: boolean;
  LibelleStatut?: string;
  NombreDeclencheurLie?: number;
  Ordre?: number;
  OrdreMax?: number;
};

export type StatutsCommandeModel = {
  __typename?: 'StatutsCommandeModel';
  DateLivraison?: any;
  DateRetourPrevu?: any;
  DateRetourReel?: any;
  Id?: number;
  IdStatutAdministratif?: number;
  IdStatutPerso?: number;
  StatutAdministratif?: string;
  StatutAdministratifCode?: string;
  StatutLivraison?: string;
  StatutLivraisonCode?: string;
};

export type StatutsCommandeModelInput = {
  DateLivraison?: any;
  DateRetourPrevu?: any;
  DateRetourReel?: any;
  Id?: number;
  IdStatutAdministratif?: number;
  IdStatutPerso?: number;
  StatutAdministratif?: string;
  StatutAdministratifCode?: string;
  StatutLivraison?: string;
  StatutLivraisonCode?: string;
};

export type StockArticleDto = {
  __typename?: 'StockArticleDTO';
  Article?: ArticleDto;
  DateDerInv?: any;
  IsCloture?: boolean;
  IsQteDispoNega?: boolean;
  IsQteDispoNegaVal?: boolean;
  IsQteDispoNegativeAtt?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Qte?: number;
  QteCmd?: number;
  QteDerInv?: number;
  QteDispo?: number;
  QteDispoEnAttente?: number;
  QteEnOption?: number;
  QteEnReappro?: number;
  QteEnReapproEnAttente?: number;
  QteMini?: number;
  QteReserve?: number;
  QteReserveEnAttente?: number;
  Status?: StatusDtoEnum;
  Stock?: StockDto;
};

export type StockArticleDtoInput = {
  Article?: ArticleDtoInput;
  DateDerInv?: any;
  IsCloture?: boolean;
  IsQteDispoNega?: boolean;
  IsQteDispoNegaVal?: boolean;
  IsQteDispoNegativeAtt?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  Qte?: number;
  QteCmd?: number;
  QteDerInv?: number;
  QteDispo?: number;
  QteDispoEnAttente?: number;
  QteEnOption?: number;
  QteEnReappro?: number;
  QteEnReapproEnAttente?: number;
  QteMini?: number;
  QteReserve?: number;
  QteReserveEnAttente?: number;
  Status?: StatusDtoEnum;
  Stock?: StockDtoInput;
};

export type StockArticleModelDto = {
  __typename?: 'StockArticleModelDTO';
  CodeLibelleStock?: string;
  DateDernierInventaire?: any;
  IdArticle?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsArticleCloture?: boolean;
  IsProduitCloture?: boolean;
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixAchatUnitaire?: number;
  QuantiteCommande?: number;
  QuantiteDernierInventaire?: number;
  QuantiteDispo?: number;
  QuantiteEnAttente?: number;
  QuantiteOption?: number;
  QuantiteReapproEnAttente?: number;
  QuantiteReapproValidee?: number;
  QuantiteRelle?: number;
  QuantiteReserveeEnAttente?: number;
  QuantiteReserveeValidee?: number;
  Status?: StatusDtoEnum;
  ValorisationStockArticle?: number;
};

export type StockArticleModelDtoInput = {
  CodeLibelleStock?: string;
  DateDernierInventaire?: any;
  IdArticle?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsArticleCloture?: boolean;
  IsProduitCloture?: boolean;
  LibelleActivite?: string;
  LibelleArticle?: string;
  LibelleFamille?: string;
  LibelleProduit?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  PrixAchatUnitaire?: number;
  QuantiteCommande?: number;
  QuantiteDernierInventaire?: number;
  QuantiteDispo?: number;
  QuantiteEnAttente?: number;
  QuantiteOption?: number;
  QuantiteReapproEnAttente?: number;
  QuantiteReapproValidee?: number;
  QuantiteRelle?: number;
  QuantiteReserveeEnAttente?: number;
  QuantiteReserveeValidee?: number;
  Status?: StatusDtoEnum;
  ValorisationStockArticle?: number;
};

export type StockDto = {
  __typename?: 'StockDTO';
  CeDelegation?: CeDelegationDto;
  Code?: string;
  Id?: number;
  IsBloque?: boolean;
  IsCloture?: boolean;
  IsStockCentral?: boolean;
  IsStockDeleg?: boolean;
  Libelle?: string;
  ListInventaire?: ArrayOfInventaireDto;
  ListMouvementStock?: ArrayOfMouvementStockDto;
  ListStockArticles?: ArrayOfStockArticleDto;
  ListeCaisses?: ArrayOfCaisseDto;
  ListeUsers?: ArrayOfUsersDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PV?: PointVenteDto;
  Status?: StatusDtoEnum;
};

export type StockDtoInput = {
  CeDelegation?: CeDelegationDtoInput;
  Code?: string;
  Id?: number;
  IsBloque?: boolean;
  IsCloture?: boolean;
  IsStockCentral?: boolean;
  IsStockDeleg?: boolean;
  Libelle?: string;
  ListInventaire?: ArrayOfInventaireDtoInput;
  ListMouvementStock?: ArrayOfMouvementStockDtoInput;
  ListStockArticles?: ArrayOfStockArticleDtoInput;
  ListeCaisses?: ArrayOfCaisseDtoInput;
  ListeUsers?: ArrayOfUsersDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PV?: PointVenteDtoInput;
  Status?: StatusDtoEnum;
};

export type StockLightModel = {
  __typename?: 'StockLightModel';
  Id?: number;
  Libelle?: string;
};

export type StockLightModelInput = {
  Id?: number;
  Libelle?: string;
};

export type StockModeleDto = {
  __typename?: 'StockModeleDTO';
  IdStock?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type StockModeleDtoInput = {
  IdStock?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type StockTypeReapproDto = {
  __typename?: 'StockTypeReapproDTO';
  Code?: string;
  Description?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type StockTypeReapproDtoInput = {
  Code?: string;
  Description?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: string;
};

export type StockTypeReapproModel = {
  __typename?: 'StockTypeReapproModel';
  CodeStockTypeReappro?: string;
  IdStockTypeReappro?: number;
  LibelleStockTypeReappro?: string;
};

export type StockTypeReapproModelInput = {
  CodeStockTypeReappro?: string;
  IdStockTypeReappro?: number;
  LibelleStockTypeReappro?: string;
};

export type StockWithDelegetPvModel = {
  __typename?: 'StockWithDelegetPVModel';
  Id?: number;
  IdDelegation?: number;
  IdDelegationPointVente?: number;
  IdPointVente?: number;
  Libelle?: string;
};

export type StockWithDelegetPvModelInput = {
  Id?: number;
  IdDelegation?: number;
  IdDelegationPointVente?: number;
  IdPointVente?: number;
  Libelle?: string;
};

export type SubventionAccordeeModelDtoInput = {
  IdEnveloppeSpecifique?: number;
  IsSubventionChoisie?: boolean;
  LibelleEnveloppeSpecifique?: string;
  MontantAccepte?: number;
  MontantMaximum?: number;
  MontantSubComplementairePrisEnLigne?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SubventionModeleRegleSubventionBaseInput = {
  AgeEnfantMaximum?: number;
  AgeEnfantMinimum?: number;
  IdChamp?: number;
  IdModeleRegle?: number;
  IdPeriodeNbDossier?: number;
  IsForcageAutorise?: boolean;
  IsNominatif?: boolean;
  IsVenteSansSubvention?: boolean;
  LibelleRegle?: string;
  ListeValeursCriteres?: ArrayOfanyTypeInput;
  Montant?: number;
  MontantDefaut?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  OrdreModeleRegle?: number;
  Status?: StatusDtoEnum;
  TypeModeleRegle?: string;
  TypeValeurLimite?: string;
  TypeValeurModeleRegle?: string;
};

export type SubventionValeurCritereModele = {
  __typename?: 'SubventionValeurCritereModele';
  BorneMaximum?: number;
  BorneMinimum?: number;
  IdBorne?: number;
  IdChampValeur?: number;
  IdModeleRegle?: number;
  IdValeur?: number;
  LibelleChamp?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SubventionValeurCritereModeleInput = {
  BorneMaximum?: number;
  BorneMinimum?: number;
  IdBorne?: number;
  IdChampValeur?: number;
  IdModeleRegle?: number;
  IdValeur?: number;
  LibelleChamp?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SuiviTresorerieModelDto = {
  __typename?: 'SuiviTresorerieModelDTO';
  AnneeTresorerie?: number;
  DateTresorerie?: any;
  IdCompteBancaire?: number;
  LibelleCompteBancaire?: string;
  MoisTresorerie?: number;
  MontantCompteBancaire?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SuiviTresorerieModelDtoInput = {
  AnneeTresorerie?: number;
  DateTresorerie?: any;
  IdCompteBancaire?: number;
  LibelleCompteBancaire?: string;
  MoisTresorerie?: number;
  MontantCompteBancaire?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type SynchDataModel = {
  __typename?: 'SynchDataModel';
  Action?: string;
  Data?: string;
  EventDate?: any;
  Message?: string;
  OrganizationId?: string;
  Requests?: ArrayOfRequestModel;
  ResourceId?: string;
  Status?: string;
  Type?: string;
};

export type SynchDataModelInput = {
  Action?: string;
  Data?: string;
  EventDate?: any;
  Message?: string;
  OrganizationId?: string;
  Requests?: ArrayOfRequestModelInput;
  ResourceId?: string;
  Status?: string;
  Type?: string;
};

export type SynchroBenefInput = {
  action?: string;
  benef_id?: number;
  benef_uuid?: string;
};

export type SynchroOrganisationModelDto = {
  __typename?: 'SynchroOrganisationModelDTO';
  CodeBusiness?: string;
  IdAssoConnexion?: number;
  IsSynchroPartielle?: boolean;
  IsSynchroSub?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomCE?: string;
  Status?: StatusDtoEnum;
  Uuid?: string;
};

export type SynchroOrganisationModelDtoInput = {
  CodeBusiness?: string;
  IdAssoConnexion?: number;
  IsSynchroPartielle?: boolean;
  IsSynchroSub?: boolean;
  MustValidate?: boolean;
  MyGuid?: string;
  NomCE?: string;
  Status?: StatusDtoEnum;
  Uuid?: string;
};

export type SynchroSiteLivraisonInput = {
  action?: string;
  site_livraison_id?: number;
  site_livraison_uuid?: string;
};

export type SynchroSynapseHistoModelDto = {
  __typename?: 'SynchroSynapseHistoModelDTO';
  DateSynchro?: any;
  IdHistoSynchro?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeSynchro?: string;
  User?: UsersDto;
};

export type SynchroSynapseHistoModelDtoInput = {
  DateSynchro?: any;
  IdHistoSynchro?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeSynchro?: string;
  User?: UsersDtoInput;
};

export type TvaEtatPreparatoireDetailModel = {
  __typename?: 'TVAEtatPreparatoireDetailModel';
  DateCreation?: any;
  DateDeclaration?: any;
  DateGeneration?: any;
  EtatWithoutLine?: boolean;
  IdEcritureDecaissement?: number;
  IdEtat?: number;
  IsGenere?: boolean;
  IsLastDeclaration?: boolean;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomPrenomUserCreation?: string;
  Status?: StatusDtoEnum;
};

export type TvaEtatPreparatoireDetailModelInput = {
  DateCreation?: any;
  DateDeclaration?: any;
  DateGeneration?: any;
  EtatWithoutLine?: boolean;
  IdEcritureDecaissement?: number;
  IdEtat?: number;
  IsGenere?: boolean;
  IsLastDeclaration?: boolean;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NomPrenomUserCreation?: string;
  Status?: StatusDtoEnum;
};

export type TvaEtatPreparatoireHistoModel = {
  __typename?: 'TVAEtatPreparatoireHistoModel';
  DateCreation?: any;
  DateDeclaration?: any;
  IdEtat?: number;
  IsGenere?: boolean;
  IsLastDeclaration?: boolean;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type TvaEtatPreparatoireHistoModelInput = {
  DateCreation?: any;
  DateDeclaration?: any;
  IdEtat?: number;
  IsGenere?: boolean;
  IsLastDeclaration?: boolean;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type TempsReservationModel = {
  __typename?: 'TempsReservationModel';
  DateDebut?: any;
  DateFin?: any;
  IdLigneCommande?: number;
};

export type TempsReservationModelInput = {
  DateDebut?: any;
  DateFin?: any;
  IdLigneCommande?: number;
};

export type TransfertEnComptabiliteModelInput = {
  DateFacturationBenef?: any;
  DateFacturationFour?: any;
  DateTransfertCompta?: any;
  IDExerciceBenef?: number;
  IDJournalBenef?: number;
  IdDossier?: number;
  IdExerciceFournisseur?: number;
  IdJournalFournisseur?: number;
  IsNumPieceAuto?: boolean;
  NumPieceBenef?: string;
  NumPieceFournisseur?: string;
  NumeroDeFactureFournisseur?: string;
};

export type TransfertStockPourListeModel = {
  __typename?: 'TransfertStockPourListeModel';
  DateEnvoi?: any;
  IdCessionStock?: number;
  IdStockEntree?: number;
  IdStockSortie?: number;
  IdUtilisateur?: number;
  IsAnnule?: boolean;
  IsEnAttente?: boolean;
  IsNonReceptionne?: boolean;
  IsPartiellementReceptionne?: boolean;
  IsReceptionne?: boolean;
  LibelleCessionStock?: string;
  Remarque?: string;
  StockEntree?: string;
  StockSortie?: string;
};

export type TransfertStockPourListeModelInput = {
  DateEnvoi?: any;
  IdCessionStock?: number;
  IdStockEntree?: number;
  IdStockSortie?: number;
  IdUtilisateur?: number;
  IsAnnule?: boolean;
  IsEnAttente?: boolean;
  IsNonReceptionne?: boolean;
  IsPartiellementReceptionne?: boolean;
  IsReceptionne?: boolean;
  LibelleCessionStock?: string;
  Remarque?: string;
  StockEntree?: string;
  StockSortie?: string;
};

export type TransformerEnDonModelInput = {
  IdDossier?: number;
  IdJournalFraisDossier?: number;
  MontantFraisDossierOffert?: number;
  idCaisse?: number;
  idDelegation?: number;
  idUtilisateur?: number;
  isComptaSeparee?: boolean;
};

export type TreeviewAfpaModel = {
  __typename?: 'TreeviewAFPAModel';
  DateLocArticle?: any;
  Id?: number;
  IdElementParent?: number;
  IsCloture?: boolean;
  Libelle?: string;
  LibelleElementParent?: string;
  ListeEnfants?: ArrayOfTreeviewAfpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: TypeAfpaEnum;
};

export type TreeviewAfpaModelInput = {
  DateLocArticle?: any;
  Id?: number;
  IdElementParent?: number;
  IsCloture?: boolean;
  Libelle?: string;
  LibelleElementParent?: string;
  ListeEnfants?: ArrayOfTreeviewAfpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Type?: TypeAfpaEnum;
};

export type TrombinoscopeInitialiationTrombinoscopeFicheModel = {
  __typename?: 'TrombinoscopeInitialiationTrombinoscopeFicheModel';
  Adresse?: AdresseDto;
  ListeCommission?: ArrayOfCommissionCommissionModel;
  ListeResponsables?: ArrayOfTrombinoscopeTrombinoscopeModel;
  Photo?: FichierModel;
  Trombinoscope?: TrombinoscopeTrombinoscopeFicheModel;
};

export type TrombinoscopeInitialiationTrombinoscopeFicheModelInput = {
  Adresse?: AdresseDtoInput;
  ListeCommission?: ArrayOfCommissionCommissionModelInput;
  ListeResponsables?: ArrayOfTrombinoscopeTrombinoscopeModelInput;
  Photo?: FichierModelInput;
  Trombinoscope?: TrombinoscopeTrombinoscopeFicheModelInput;
};

export type TrombinoscopeInitialiationTrombinoscopeModel = {
  __typename?: 'TrombinoscopeInitialiationTrombinoscopeModel';
  ListeTrombinoscope?: ArrayOfTrombinoscopeTrombinoscopeModel;
  NbElementTotal?: number;
};

export type TrombinoscopeInitialiationTrombinoscopeModelInput = {
  ListeTrombinoscope?: ArrayOfTrombinoscopeTrombinoscopeModelInput;
  NbElementTotal?: number;
};

export type TrombinoscopeTrombinoscopeFicheModel = {
  __typename?: 'TrombinoscopeTrombinoscopeFicheModel';
  Adresse?: AdresseDto;
  Email?: string;
  Fonction?: string;
  Id?: number;
  IdAdresse?: number;
  IdCommission?: number;
  IdFilelinkPhoto?: number;
  IdResponsable?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Photo?: FichierModel;
  Prenom?: string;
  SelectedCommission?: CommissionCommissionModel;
  SelectedResponsable?: TrombinoscopeTrombinoscopeModel;
  Status?: StatusDtoEnum;
  Telephone?: string;
};

export type TrombinoscopeTrombinoscopeFicheModelInput = {
  Adresse?: AdresseDtoInput;
  Email?: string;
  Fonction?: string;
  Id?: number;
  IdAdresse?: number;
  IdCommission?: number;
  IdFilelinkPhoto?: number;
  IdResponsable?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Photo?: FichierModelInput;
  Prenom?: string;
  SelectedCommission?: CommissionCommissionModelInput;
  SelectedResponsable?: TrombinoscopeTrombinoscopeModelInput;
  Status?: StatusDtoEnum;
  Telephone?: string;
};

export type TrombinoscopeTrombinoscopeModel = {
  __typename?: 'TrombinoscopeTrombinoscopeModel';
  Commission?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Prenom?: string;
  Status?: StatusDtoEnum;
};

export type TrombinoscopeTrombinoscopeModelInput = {
  Commission?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Prenom?: string;
  Status?: StatusDtoEnum;
};

export type TupleOfstringstring = {
  __typename?: 'TupleOfstringstring';
  m_Item1?: string;
  m_Item2?: string;
};

export type TupleOfstringstringInput = {
  m_Item1?: string;
  m_Item2?: string;
};

export enum TypeAfpaEnum {
  Activite = 'Activite',
  Article = 'Article',
  Aucun = 'Aucun',
  Famille = 'Famille',
  Produit = 'Produit'
}

export enum TypeActionReglesEtPjEnum {
  AccepterDossier = 'AccepterDossier',
  LaisserEnAttente = 'LaisserEnAttente',
  RefuserDossier = 'RefuserDossier'
}

export type TypeActiviteDto = {
  __typename?: 'TypeActiviteDTO';
  Code?: string;
  CodeMod?: string;
  Comportement?: string;
  DirectoModule?: string;
  Id?: number;
  IsDisponiblePortail?: boolean;
  Libelle?: string;
  ListeChamps?: ArrayOfChampDto;
  ListeMenuPages?: ArrayOfMenuPageDto;
  ListeMenus?: ArrayOfMenuDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type TypeActiviteDtoInput = {
  Code?: string;
  CodeMod?: string;
  Comportement?: string;
  DirectoModule?: string;
  Id?: number;
  IsDisponiblePortail?: boolean;
  Libelle?: string;
  ListeChamps?: ArrayOfChampDtoInput;
  ListeMenuPages?: ArrayOfMenuPageDtoInput;
  ListeMenus?: ArrayOfMenuDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type TypeActiviteWithListeActiviteModel = {
  __typename?: 'TypeActiviteWithListeActiviteModel';
  IdTypeActivite?: number;
  LibelleTypeActivite?: string;
  ListeLibelleActivite?: ArrayOfstring;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type TypeActiviteWithListeActiviteModelInput = {
  IdTypeActivite?: number;
  LibelleTypeActivite?: string;
  ListeLibelleActivite?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type TypeAnalyseIaModel = {
  __typename?: 'TypeAnalyseIAModel';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type TypeAnalyseIaModelInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type TypeArrondiModel = {
  __typename?: 'TypeArrondiModel';
  Code?: string;
  IdTypeArrondi?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeArrondi?: string;
  TypeSP?: string;
  Valeur?: number;
};

export type TypeArrondiModelInput = {
  Code?: string;
  IdTypeArrondi?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeArrondi?: string;
  TypeSP?: string;
  Valeur?: number;
};

export enum TypeAuteurArticleUpKonnectEnum {
  Organization = 'Organization',
  User = 'User'
}

export type TypeBenefDto = {
  __typename?: 'TypeBenefDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  ListeRegleModeleAcces?: ArrayOfRegleModeleAccesDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type TypeBenefDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  ListeRegleModeleAcces?: ArrayOfRegleModeleAccesDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type TypeCalculModeLivraisonDto = {
  __typename?: 'TypeCalculModeLivraisonDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type TypeCalculModeLivraisonDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type TypeChampFormulaireModel = {
  __typename?: 'TypeChampFormulaireModel';
  CodeTypeChampFormulaire?: string;
  IdTypeChampFormulaire?: number;
  LibelleTypeChampFormulaire?: string;
};

export type TypeChampFormulaireModelInput = {
  CodeTypeChampFormulaire?: string;
  IdTypeChampFormulaire?: number;
  LibelleTypeChampFormulaire?: string;
};

export enum TypeCleRepartitionEnum {
  AvecCle = 'AvecCle',
  SansCle = 'SansCle',
  Toutes = 'Toutes'
}

export type TypeConsoMouvementPointDto = {
  __typename?: 'TypeConsoMouvementPointDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type TypeConsoMouvementPointDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type TypeCritereSyncAdModelDto = {
  __typename?: 'TypeCritereSyncAdModelDTO';
  CodeCritere?: string;
  IdCritere?: number;
  LibelleCritere?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeValeur?: string;
};

export type TypeCritereSyncAdModelDtoInput = {
  CodeCritere?: string;
  IdCritere?: number;
  LibelleCritere?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeValeur?: string;
};

export type TypeEcritureDto = {
  __typename?: 'TypeEcritureDTO';
  Code?: string;
  CompteEcriture?: CompteEcritureDto;
  Id?: number;
  Libelle?: string;
  ListeEcriture?: ArrayOfCompteEcritureDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type TypeEcritureDtoInput = {
  Code?: string;
  CompteEcriture?: CompteEcritureDtoInput;
  Id?: number;
  Libelle?: string;
  ListeEcriture?: ArrayOfCompteEcritureDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type TypeEcritureInput = {
  Key?: string;
};

export enum TypeFichierEnum {
  Cfonb = 'CFONB',
  Sepa = 'SEPA'
}

export enum TypeGrapheEnum {
  BarreHorrizontale = 'BarreHorrizontale',
  BarreVerticale = 'BarreVerticale',
  Camembert = 'Camembert'
}

export enum TypeMouvementRechEnum {
  Commande = 'Commande',
  Options = 'Options',
  Reappro = 'Reappro',
  Reel = 'Reel',
  Reservation = 'Reservation'
}

export type TypeMoyenPaiementDto = {
  __typename?: 'TypeMoyenPaiementDTO';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type TypeMoyenPaiementDtoInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type TypePjAffichageModele = {
  __typename?: 'TypePJAffichageModele';
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type TypePjAffichageModeleInput = {
  Code?: string;
  Id?: number;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export enum TypePictoEnum {
  Article = 'ARTICLE',
  Benef = 'BENEF',
  Deleg = 'DELEG',
  Doc = 'DOC',
  EditArt = 'EDIT_ART',
  Pj = 'PJ'
}

export enum TypeRemonterModelEnum {
  CommandeBilletterie = 'CommandeBilletterie',
  ConsultationReservation = 'ConsultationReservation',
  DossierPrestation = 'DossierPrestation',
  DossierPrestationVueSimple = 'DossierPrestationVueSimple',
  LivraisonBilletterie = 'LivraisonBilletterie',
  ModelTotal = 'ModelTotal'
}

export enum TypeRetourMoteurEnum {
  Accepte = 'Accepte',
  AccepteAvecSubvComplPossible = 'AccepteAvecSubvComplPossible',
  DepassementLimiteAvecVenteSansSubvention = 'DepassementLimiteAvecVenteSansSubvention',
  DepassementLimiteSansVenteSansSubvention = 'DepassementLimiteSansVenteSansSubvention',
  Refus = 'Refus',
  RefusAvecForcage = 'RefusAvecForcage'
}

export enum TypeStatutCommandeDtoEnum {
  Anb = 'ANB',
  Anc = 'ANC',
  Atc = 'ATC',
  Env = 'ENV',
  Faac = 'FAAC',
  Faaf = 'FAAF',
  Facc = 'FACC',
  Facf = 'FACF',
  Fap = 'FAP',
  Lia = 'LIA',
  Lip = 'LIP',
  Liv = 'LIV',
  Nli = 'NLI',
  Repc = 'REPC',
  Repf = 'REPF',
  Retc = 'RETC',
  Retf = 'RETF',
  Rfc = 'RFC',
  Sai = 'SAI',
  Sob = 'SOB'
}

export enum TypeStatutPieceJustificativeEnum {
  Abs = 'ABS',
  Env = 'ENV',
  Rec = 'REC'
}

export enum TypeSynchroEnum {
  Bpart = 'BPART',
  Btous = 'BTOUS',
  Subpart = 'SUBPART',
  Subtous = 'SUBTOUS'
}

export enum TypesRegleEnum {
  Accessibilite = 'Accessibilite',
  Enveloppe = 'Enveloppe',
  None = 'None',
  Quota = 'Quota',
  QuotaFaciale = 'QuotaFaciale',
  QuotaNombre = 'QuotaNombre',
  RestantACharge = 'RestantACharge',
  Subvention = 'Subvention'
}

export enum TypesValeursEnum {
  Bool = 'Bool',
  Date = 'Date',
  Decimal = 'Decimal',
  Entier = 'Entier',
  ListeValeurs = 'ListeValeurs',
  Texte = 'Texte'
}

export type UcListeMouvementsComptablesListeMouvementModelEtNbLignesDto = {
  __typename?: 'UCListeMouvementsComptablesListeMouvementModelEtNbLignesDTO';
  ListeMouvementModel?: ArrayOfComptaMouvementComptableModelDto;
  NbLignesTotal?: number;
};

export type UcListeMouvementsComptablesListeMouvementModelEtNbLignesDtoInput = {
  ListeMouvementModel?: ArrayOfComptaMouvementComptableModelDtoInput;
  NbLignesTotal?: number;
};

export type UcRechercheRemiseEnBanqueDto = {
  __typename?: 'UCRechercheRemiseEnBanqueDTO';
  ListeCaisse?: ArrayOfCaisseDto;
  ListeCompteBancaire?: ArrayOfCompteBancaireDto;
  ListeDelegation?: ArrayOfCeDelegationDto;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementDto;
  ListeUser?: ArrayOfUsersDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type UcRechercheRemiseEnBanqueDtoInput = {
  ListeCaisse?: ArrayOfCaisseDtoInput;
  ListeCompteBancaire?: ArrayOfCompteBancaireDtoInput;
  ListeDelegation?: ArrayOfCeDelegationDtoInput;
  ListeMoyenPaiement?: ArrayOfMoyenPaiementDtoInput;
  ListeUser?: ArrayOfUsersDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type Union_50922305263755211 = ParamCotisationFamilleModel | ParamGroupesFamilleModel | ParamLocationFamilleModel | ParamPrestationFamilleModel | ParamPretsEtDonsFamilleModel | ParamVentesChequesFamilleModel;

export type Union_66859388350133979 = BudgetInformationsListingModel | BudgetListingModel | SousBudgetListingModel;

export type Union_238092739497534820 = PrestationFamilleVenteEnLigneModel;

export type Union_266707523219680728 = ComptabiliteEpargnesActiviteModel | ComptabiliteEpargnesArticleModel | ComptabiliteEpargnesBaseModel;

export type Union_554281857723606794 = ArreteCaisseArreteCaisseModel | ArreteCaisseArreteCaissePostRafraichissementModel;

export type Union_570005100139003652 = RetourReglementDossierPretsEtDonsModel;

export type Union_872526003726237120 = ModelEmailPjEtPubliTypModel | ModelesModelEmailPieceJointeModel;

export type Union_1058209019463210040 = StatutPersoBaseModel | StatutPersoCouleurModel;

export type Union_1112417812603935575 = CadeauFpaModel | CadeauxBaseModel;

export type Union_1187615723202011850 = SelectionModeleEchancierModel;

export type Union_1767873430737490976 = LigneCessionStockModel | LigneCessionStockTransfertStockModel;

export type Union_2051424951178096057 = ReponseFormulaireParticipantModel;

export type Union_2668492363200023698 = InformationsActiviteHomeNotification | InformationsHomeNotification;

export type Union_2735844942145325600 = ExemplaireMediathequeRechercheMediaModelDto;

export type Union_3045481246475108235 = ReponseChampModel | ReponseLigneChampModel | ReponseSectionModel;

export type Union_3065088916602497858 = ArreteCaisseInfosPopupPaiementFiduciaireModel | ArreteCaisseLigneArreteCaisseCommunModel | ArreteCaisseLigneArreteCaisseFiduModel | ArreteCaisseLigneArreteCaisseNonFiduModel;

export type Union_3803064933304944068 = HomeNotification;

export type Union_4045752991927786863 = CeDelegIsGlobaleModel | DelegationBaseModel;

export type Union_5208800993651906122 = GroupePubliGroupeOrdreModel | PubliChampsGroupeAffichageModel;

export type Union_5765410771066838971 = ConsultationEcritureBaseModel | EcritureExportModel | EcritureListingModel;

export type Union_5965143003362621529 = MediathequeLigneCommandeBaseModel | MediathequeLigneCommandeInfosResaMdkModel;

export type Union_6304623401004649514 = LocationTauxOccupationModel;

export type Union_6714739481622726207 = ArticleAttributionAuto | LocationTauxOccupationModel;

export type Union_6816468911052124524 = IbanBeneficiaireModel | IbanFournisseurModel | IbanParametrageBaseModel;

export type Union_7257672451169240978 = FicheMediaMediathequeModel | RetourApiMediaModel;

export type Union_7392513492403361798 = ParamCotisationArticleModel | ParamGroupesArticleModel | ParamLocationArticleModel | ParamPrestationArticleModel | ParamPretsEtDonsArticleModel | ParamVentesChequesArticleModel;

export type Union_11308712901971539728 = ParamModeleEchancierModel | SelectionModeleEchancierModel;

export type Union_11709815821493216246 = IbanBeneficiaireModel | IbanFournisseurModel;

export type Union_13090543331405214352 = BaseRaisePropertyChanged | CleRepartitionModel;

export type Union_13441779963965314999 = PermanencePermanenceBaseModel | PermanencePermanenceModel;

export type Union_13510198731919550967 = DossierPretsEtDonsDonModel | DossierPretsEtDonsPretModel;

export type Union_13581429883425318489 = InfosRetourLivraison | InfosRetourLivraisonOuReceptionTotaleGroupeeCommande;

export type Union_13632114401662173441 = MoyenPaiementMoyenPaiementBaseModel | MoyenPaiementMoyenPaiementSelectionableModel;

export type Union_14140848403245432200 = FraisAnnulationBaseModel | FraisAnnulationSupprimableModel;

export type Union_15979101523990191512 = ImputationComptableEditerImputationFpaCharge | ImputationComptableEditerImputationFpaProduit | ImputationComptableEditerImputationFpaProduitCharge | ImputationComptableEditerImputationFpaTousComptes | ImputationComptableEditerImputationFpaVariationValorisation;

export type Union_16290039003644539366 = ArreteCaisseInfosPopupPaiementFiduciaireModel | ArreteCaisseLigneArreteCaisseFiduModel;

export type Union_16949638073194317644 = ArticleClotureModel | ArticleModeleEpargneModel;

export type Union_17133887752228243661 = BenefCriteresSociauxModel;

export type Union_18613001183674656693 = ChampsCritereBooleenPubliChampsModel | ChampsCritereDatePubliChampsModel | ChampsCritereLibellePubliChampsModel | ChampsCritereListeValeursPubliChampsModel | ChampsCritereNumeriquePubliChampsModel | ChampsCriterePubliChampsModel;

export type Union_19883118252375799467 = DossierPrestationPieceJustificativeForRechercheModelDto | DossierPrestationPieceJustificativeModelDto;

export type Union_20780602624083161499 = ComptabiliteEpargnesActiviteModel | ComptabiliteEpargnesArticleModel | ComptabiliteEpargnesBaseModel;

export type Union_21781205322457394155 = FpaVenteEnLigneBaseModel | PrestationFamilleVenteEnLigneModel;

export type Union_22110153801956302235 = ReponseFormulaireModel | ReponseFormulaireParticipantModel;

export type Union_23800276143883885461 = ExemplaireMediathequeRechercheMediaModelDto | MediathequeExemplaireCatalogueMediaModel;

export type Union_25557305492872672030 = RessourcesPartageesTarifFactureModel | RessourcesPartageesTarifModel;

export type Union_27071403723942099383 = RequetePubliRequeteAvecCriteresModel;

export type Union_28547402483733559094 = CadeauxBaseModel | InfosArticleCadeaux;

export type Union_29326972383394260837 = EnveloppeBaseModel | EnveloppeBaseSelectedModel;

export type Union_29816689623692486759 = BenefBenefBaseModel | BenefBenefPourAccesPortailModel;

export type Union_30188432553199321036 = ParamCotisationProduitModel | ParamGroupesProduitModel | ParamLocationProduitModel | ParamPrestationProduitModel | ParamPretsEtDonsProduitModel | ParamVentesChequesProduitModel;

export type Union_31594117503382787490 = ModeleEcheancierBaseModel | ModelesModeleEcheancierArticlesModel;

export type Union_32476590703626765597 = ReponseChampModel | ReponseFormulaireBaseModel | ReponseLigneChampModel | ReponseSectionModel;

export type Union_33497648392782579495 = LivraisonsCommandesInfosLivraisonBaseModel | LivraisonsInfosLigneCdeForLivraisonReceptionModele;

export type Union_33595702961915738127 = ArreteCaisseArreteCaissePostRafraichissementModel;

export type Union_33818115703809269357 = RequetePubliRequeteAvecCriteresModel | RequetePubliRequeteBaseModel;

export type Union_36261109274052828904 = JourModel | JourWithDateModel | PermanenceParametrageJourModel | PermanencePermanenceListeHeuresModel;

export type Union_37323748901697156950 = ModeleRegleAfpaAccessibiliteConjoint | ModeleRegleAfpaAccessibiliteEnfant | ModeleRegleAfpaAccessibiliteOdad | ModeleRegleAfpaAccessibiliteOuvrantDroit | ModeleRegleAfpaAccessibiliteTousBeneficiaires | ModeleRegleAfpaEnveloppe | ModeleRegleAfpaEnveloppeAttribution | ModeleRegleAfpaEnveloppeBase | ModeleRegleAfpaEnveloppePrestation | ModeleRegleAfpaPrestationAccessibiliteConjoint | ModeleRegleAfpaPrestationAccessibiliteEnfant | ModeleRegleAfpaPrestationAccessibiliteOdad | ModeleRegleAfpaPrestationAccessibiliteOuvrantDroit | ModeleRegleAfpaPrestationAccessibiliteTousBeneficiaires | ModeleRegleAfpaQuota | ModeleRegleAfpaQuotaBase | ModeleRegleAfpaQuotaPrestation | ModeleRegleAfpaSubvention | ModeleRegleAfpaSubventionBase | ModeleRegleAfpaSubventionComplementaire | ModeleRegleAfpaSubventionRestantACharge;

export type Union_37395321602086970009 = ArticleAttributionAuto | FpaPrestaArticleBaseModel | FpaPrestaArticleIsGereStockComptaModel | LocationTauxOccupationModel;

export type Union_37769932661730027886 = BenefCriteresSociauxModel | ChampPersoBeneficiaireModel;

export type Union_39409527161397698042 = ArreteCaisseArreteCaisseBaseModel | ArreteCaisseArreteCaisseModel;

export type Union_41558956911207852964 = BaseRaisePropertyChanged | CleRepartitionModel | RessourcesPartageesTarifFactureModel | RessourcesPartageesTarifModel;

export type Union_41875787341757271086 = CadeauxEditerLignedossierPrestaEvenementsFamilliauxGestionModelDto | DossierPrestationEditerLigneCommandeBaseModelDto | DossierPrestationEditerLigneDossierPrestationModelDto | MoteurTraitementRetourMoteurModelDto;

export type Union_42311842012658979327 = Constantes_StatutsMediathquesLigneReservationModel | LigneCommandeHistoriqueReservationRpModel;

export type UnhandledExceptionModelInput = {
  ApplicationName?: string;
  Message?: string;
  StackTrace?: string;
};

export type UpdateLigneCommandePrestationModelDtoInput = {
  DateDebutLocation?: any;
  DateFacture?: any;
  DateFinLocation?: any;
  IdArticle?: number;
  IdLigneCommande?: number;
  IsAccepte?: boolean;
  ListePieceJustificative?: ArrayOfPieceJustificativeBenefModelInput;
  ListeSubComplementaire?: ArrayOfSubventionAccordeeModelDtoInput;
  MontantPresente?: number;
  MontantPrisEnCompte?: number;
  MontantRembourse?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NombreUnitePresente?: number;
  NombreUnitePrisEnCompte?: number;
  QuantitePresente?: number;
  QuantitePrisEnCompte?: number;
  QuantiteRemboursee?: number;
  ReferenceFacture?: string;
  RemarquePrivee?: string;
  RemarquePublique?: string;
  Status?: StatusDtoEnum;
};

export type UpdateProfilFonctionnalitesModelInput = {
  IdProfil?: number;
  ListeCodesFonctionnalites?: ArrayOfstringInput;
  ListeCodesWidgets?: ArrayOfstringInput;
};

export type UserBaseModel = {
  __typename?: 'UserBaseModel';
  IdUtilisateur?: number;
  NomUtilisateur?: string;
  PrenomUtilisateur?: string;
};

export type UserBaseModelInput = {
  IdUtilisateur?: number;
  NomUtilisateur?: string;
  PrenomUtilisateur?: string;
};

export type UserCommissionDto = {
  __typename?: 'UserCommissionDTO';
  Commission?: CommissionDto;
  DateDeb?: any;
  DateFin?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Users?: UsersDto;
};

export type UserCommissionDtoInput = {
  Commission?: CommissionDtoInput;
  DateDeb?: any;
  DateFin?: any;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Users?: UsersDtoInput;
};

export type UserCommissionDroit = {
  __typename?: 'UserCommissionDroit';
  CodeDroitSurCommission?: string;
  IdCommission?: number;
};

export type UserCommissionDroitInput = {
  CodeDroitSurCommission?: string;
  IdCommission?: number;
};

export type UserCommissionModel = {
  __typename?: 'UserCommissionModel';
  CodeDroitPortail?: string;
  DateDebutCommission?: any;
  DateFinCommission?: any;
  IdCommission?: number;
  IdDroitsPortail?: number;
  IdUser?: number;
  LibelleDroitPortail?: string;
  NomUser?: string;
  PrenomUser?: string;
};

export type UserCommissionModelInput = {
  CodeDroitPortail?: string;
  DateDebutCommission?: any;
  DateFinCommission?: any;
  IdCommission?: number;
  IdDroitsPortail?: number;
  IdUser?: number;
  LibelleDroitPortail?: string;
  NomUser?: string;
  PrenomUser?: string;
};

export type UserEmailModel = {
  __typename?: 'UserEmailModel';
  EmailPersoUtilisateur?: string;
  EmailProUtilisateur?: string;
  IdUtilisateur?: number;
  NomUtilisateur?: string;
  PrenomUtilisateur?: string;
};

export type UserEmailModelInput = {
  EmailPersoUtilisateur?: string;
  EmailProUtilisateur?: string;
  IdUtilisateur?: number;
  NomUtilisateur?: string;
  PrenomUtilisateur?: string;
};

export type UserEtDateCreationModificationCommandeModel = {
  __typename?: 'UserEtDateCreationModificationCommandeModel';
  CreerPar?: string;
  DateCreation?: any;
  DateDerniereModif?: any;
  DerniereModifPar?: string;
};

export type UserEtDateCreationModificationCommandeModelInput = {
  CreerPar?: string;
  DateCreation?: any;
  DateDerniereModif?: any;
  DerniereModifPar?: string;
};

export type UserHistoriqueModel = {
  __typename?: 'UserHistoriqueModel';
  DateHeureModif?: any;
  IdUser?: number;
  ModifiePar?: string;
  NewProfil?: string;
  OldProfil?: string;
};

export type UserHistoriqueModelInput = {
  DateHeureModif?: any;
  IdUser?: number;
  ModifiePar?: string;
  NewProfil?: string;
  OldProfil?: string;
};

export type UserNoteVersionModel = {
  __typename?: 'UserNoteVersionModel';
  DateVote?: any;
  IdUserNote?: number;
  IdUtilisateur?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Note?: number;
  NumeroVersion?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type UserNoteVersionModelInput = {
  DateVote?: any;
  IdUserNote?: number;
  IdUtilisateur?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Note?: number;
  NumeroVersion?: string;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type UsersCeDelegationDto = {
  __typename?: 'UsersCEDelegationDTO';
  CEDelegation?: CeDelegationDto;
  MustValidate?: boolean;
  MyGuid?: string;
  ProfilDroit?: ProfilDroitDto;
  Status?: StatusDtoEnum;
  USRCE_IDCDEF?: boolean;
  Users?: UsersDto;
};

export type UsersCeDelegationDtoInput = {
  CEDelegation?: CeDelegationDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  ProfilDroit?: ProfilDroitDtoInput;
  Status?: StatusDtoEnum;
  USRCE_IDCDEF?: boolean;
  Users?: UsersDtoInput;
};

export type UsersDto = {
  __typename?: 'UsersDTO';
  Adresse?: AdresseDto;
  Benef?: BenefDto;
  CompteEcriture?: CompteEcritureDto;
  DateUpdateMDP?: any;
  HasMDPSecurise?: boolean;
  Id?: number;
  IsCloturer?: boolean;
  IsGenerique?: boolean;
  IsUserDirecto?: boolean;
  ListeArticle?: ArrayOfArticleDto;
  ListeCaisse?: ArrayOfCaisseDto;
  ListeHistoEnvoi?: ArrayOfCourrierHistoEnvoiDto;
  ListeParametresAppli?: ArrayOfParametresAppliDto;
  ListeStock?: ArrayOfStockDto;
  ListeUsersCE?: ArrayOfUsersCeDelegationDto;
  ListeUsersCommission?: ArrayOfUserCommissionDto;
  ListeUsersPV?: ArrayOfUsersPointVenteDto;
  Login?: string;
  MailPerso?: string;
  MailPro?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Password?: string;
  PasswordInitial?: string;
  PhotoNom?: string;
  Prenom?: string;
  Status?: StatusDtoEnum;
  TelDom?: string;
  TelGSM?: string;
  TelPro?: string;
};

export type UsersDtoInput = {
  Adresse?: AdresseDtoInput;
  Benef?: BenefDtoInput;
  CompteEcriture?: CompteEcritureDtoInput;
  DateUpdateMDP?: any;
  HasMDPSecurise?: boolean;
  Id?: number;
  IsCloturer?: boolean;
  IsGenerique?: boolean;
  IsUserDirecto?: boolean;
  ListeArticle?: ArrayOfArticleDtoInput;
  ListeCaisse?: ArrayOfCaisseDtoInput;
  ListeHistoEnvoi?: ArrayOfCourrierHistoEnvoiDtoInput;
  ListeParametresAppli?: ArrayOfParametresAppliDtoInput;
  ListeStock?: ArrayOfStockDtoInput;
  ListeUsersCE?: ArrayOfUsersCeDelegationDtoInput;
  ListeUsersCommission?: ArrayOfUserCommissionDtoInput;
  ListeUsersPV?: ArrayOfUsersPointVenteDtoInput;
  Login?: string;
  MailPerso?: string;
  MailPro?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Nom?: string;
  Password?: string;
  PasswordInitial?: string;
  PhotoNom?: string;
  Prenom?: string;
  Status?: StatusDtoEnum;
  TelDom?: string;
  TelGSM?: string;
  TelPro?: string;
};

export type UsersPointVenteDto = {
  __typename?: 'UsersPointVenteDTO';
  MustValidate?: boolean;
  MyGuid?: string;
  PointVente?: PointVenteDto;
  Status?: StatusDtoEnum;
  USRPV_IDCDEF?: boolean;
  Users?: UsersDto;
};

export type UsersPointVenteDtoInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  PointVente?: PointVenteDtoInput;
  Status?: StatusDtoEnum;
  USRPV_IDCDEF?: boolean;
  Users?: UsersDtoInput;
};

export type ValeurChampFormulaireModel = {
  __typename?: 'ValeurChampFormulaireModel';
  IdValeurChamp?: number;
  IsCloture?: boolean;
  IsDefaut?: boolean;
  LibelleValeur?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type ValeurChampFormulaireModelInput = {
  IdValeurChamp?: number;
  IsCloture?: boolean;
  IsDefaut?: boolean;
  LibelleValeur?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
};

export type ValeurCriteresAyantsDroitModelInput = {
  BorneMaximum?: number;
  BorneMinimum?: number;
  IdBorne?: number;
  IdChamp?: number;
  IdChampValeur?: number;
  IdModeleRegle?: number;
  IdValeur?: number;
  LibelleChamp?: string;
  ListeValeursBeneficiaires?: ArrayOfanyTypeInput;
  Montant?: number;
  MontantConjoint?: number;
  MontantEnfant?: number;
  MontantExterne?: number;
  MontantOuvrantDroit?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ValeurMax?: number;
  ValeurMin?: number;
};

export type ValeurCriteresLimiteModelInput = {
  BorneMaximum?: number;
  BorneMinimum?: number;
  IdBorne?: number;
  IdChampValeur?: number;
  IdModeleRegle?: number;
  IdValeur?: number;
  LibelleChamp?: string;
  Montant?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeBeneficiaire?: string;
  ValeurMax?: number;
  ValeurMin?: number;
};

export type ValeurReponseModel = {
  __typename?: 'ValeurReponseModel';
  IdChampData?: number;
  Reponse?: ArrayOfstring;
};

export type ValeurReponseModelInput = {
  IdChampData?: number;
  Reponse?: ArrayOfstringInput;
};

export type VentesChequesInformationsArticleModel = {
  __typename?: 'VentesChequesInformationsArticleModel';
  CodeArticle?: string;
  CodeBarre?: string;
  DatePriseEnCompteSub?: any;
  Description?: string;
  IdArticle?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdProduit?: number;
  IsANCVConnect?: boolean;
  IsChequierDynamique?: boolean;
  IsChequierDynamiqueConnect?: boolean;
  IsCloture?: boolean;
  IsECesu?: boolean;
  IsGenerique?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QteStockMiniPourAlerte?: number;
  Quotite?: number;
  RemarqueArticle?: string;
  Status?: StatusDtoEnum;
};

export type VentesChequesInformationsArticleModelInput = {
  CodeArticle?: string;
  CodeBarre?: string;
  DatePriseEnCompteSub?: any;
  Description?: string;
  IdArticle?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdProduit?: number;
  IsANCVConnect?: boolean;
  IsChequierDynamique?: boolean;
  IsChequierDynamiqueConnect?: boolean;
  IsCloture?: boolean;
  IsECesu?: boolean;
  IsGenerique?: boolean;
  Libelle?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  QteStockMiniPourAlerte?: number;
  Quotite?: number;
  RemarqueArticle?: string;
  Status?: StatusDtoEnum;
};

export type VentesChequesInformationsFamilleModel = {
  __typename?: 'VentesChequesInformationsFamilleModel';
  CodeFamille?: string;
  Description?: string;
  IdActivite?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IsCloture?: boolean;
  IsFacturationManuelle?: boolean;
  LibelleFamille?: string;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedAcceptationCE?: boolean;
  RedescendreAcceptation?: boolean;
  RedescendreParametrageAcompte?: boolean;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type VentesChequesInformationsFamilleModelInput = {
  CodeFamille?: string;
  Description?: string;
  IdActivite?: number;
  IdDelegation?: number;
  IdEnveloppe?: number;
  IdFamille?: number;
  IsCloture?: boolean;
  IsFacturationManuelle?: boolean;
  LibelleFamille?: string;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedAcceptationCE?: boolean;
  RedescendreAcceptation?: boolean;
  RedescendreParametrageAcompte?: boolean;
  Remarque?: string;
  Status?: StatusDtoEnum;
};

export type VentesChequesInformationsProduitModel = {
  __typename?: 'VentesChequesInformationsProduitModel';
  CodeProduit?: string;
  DatePriseEnCompteSub?: any;
  DescriptionProduit?: string;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  IsFacturationManuelle?: boolean;
  IsProduitCommandeSeul?: boolean;
  LibelleProduit?: string;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedAcceptationCE?: boolean;
  RemarqueProduit?: string;
  Status?: StatusDtoEnum;
};

export type VentesChequesInformationsProduitModelInput = {
  CodeProduit?: string;
  DatePriseEnCompteSub?: any;
  DescriptionProduit?: string;
  IdEnveloppe?: number;
  IdFamille?: number;
  IdProduit?: number;
  IsCloture?: boolean;
  IsFacturationManuelle?: boolean;
  IsProduitCommandeSeul?: boolean;
  LibelleProduit?: string;
  MontantAcompteEuro?: number;
  MontantAcomptePourcentage?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NeedAcceptationCE?: boolean;
  RemarqueProduit?: string;
  Status?: StatusDtoEnum;
};

export type VentesChequesVenteEnLigneArticleModel = {
  __typename?: 'VentesChequesVenteEnLigneArticleModel';
  ListeModeLivraison?: ArrayOfModeLivraisonFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  VenteEnLigneModel?: Union_238092739497534820;
};

export type VentesChequesVenteEnLigneArticleModelInput = {
  ListeModeLivraison?: ArrayOfModeLivraisonFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  VenteEnLigneModel?: FpaVenteEnLigneBaseModelInput;
};

export type VentesChequesVenteEnLigneFamilleProduitModel = {
  __typename?: 'VentesChequesVenteEnLigneFamilleProduitModel';
  ListeModeLivraison?: ArrayOfModeLivraisonFpaModel;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  VenteEnLigneModel?: FpaVenteEnLigneWithAcompteModel;
};

export type VentesChequesVenteEnLigneFamilleProduitModelInput = {
  ListeModeLivraison?: ArrayOfModeLivraisonFpaModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  VenteEnLigneModel?: FpaVenteEnLigneWithAcompteModelInput;
};

export type VentesClientsModeleDto = {
  __typename?: 'VentesClientsModeleDTO';
  Banque?: string;
  EnteteDevisModel?: EnteteDevisCommandeForVentesModeleDto;
  HasProduitWithModalitesReglement?: boolean;
  IdBenef?: number;
  IdCompteCBDelegation?: number;
  IdJournal?: number;
  InitModel?: InitModeleForVente;
  IsChqBons?: boolean;
  IsCotisation?: boolean;
  IsEnCour?: boolean;
  IsFactureCentralisee?: boolean;
  IsInscriptionGrp?: boolean;
  IsLocation?: boolean;
  IsPaiementDifeereAutoriseGestion?: boolean;
  IsVente?: boolean;
  ListeArticleModele?: ArrayOfArticleVenteModeleDto;
  ListeBanque?: ArrayOfstring;
  ListeIDEnteteDevisModele?: ArrayOfdecimal;
  ListeLigneDevisModel?: ArrayOfLigneDevisModeleDto;
  ListeMoyenPaiementModele?: ArrayOfMoyenPaiementForVenteModeleDto;
  ModalitesReglementAffichage?: CommandeModaliteReglementAffichageModel;
  MustValidate?: boolean;
  MyGuid?: string;
  NomTire?: string;
  NumCheque?: string;
  NumPiece?: number;
  SelectedExercice?: ExerciceForVenteModeleDto;
  SelectedMoyenPaiement?: MoyenPaiementForVenteModeleDto;
  Status?: StatusDtoEnum;
  TypeCommande?: string;
  TypeEcriture?: string;
  sessionChoixModel?: SessionChoixDevisBenefModelDto;
};

export type VentesClientsModeleDtoInput = {
  Banque?: string;
  EnteteDevisModel?: EnteteDevisCommandeForVentesModeleDtoInput;
  HasProduitWithModalitesReglement?: boolean;
  IdBenef?: number;
  IdCompteCBDelegation?: number;
  IdJournal?: number;
  InitModel?: InitModeleForVenteInput;
  IsChqBons?: boolean;
  IsCotisation?: boolean;
  IsEnCour?: boolean;
  IsFactureCentralisee?: boolean;
  IsInscriptionGrp?: boolean;
  IsLocation?: boolean;
  IsPaiementDifeereAutoriseGestion?: boolean;
  IsVente?: boolean;
  ListeArticleModele?: ArrayOfArticleVenteModeleDtoInput;
  ListeBanque?: ArrayOfstringInput;
  ListeIDEnteteDevisModele?: ArrayOfdecimalInput;
  ListeLigneDevisModel?: ArrayOfLigneDevisModeleDtoInput;
  ListeMoyenPaiementModele?: ArrayOfMoyenPaiementForVenteModeleDtoInput;
  ModalitesReglementAffichage?: CommandeModaliteReglementAffichageModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NomTire?: string;
  NumCheque?: string;
  NumPiece?: number;
  SelectedExercice?: ExerciceForVenteModeleDtoInput;
  SelectedMoyenPaiement?: MoyenPaiementForVenteModeleDtoInput;
  Status?: StatusDtoEnum;
  TypeCommande?: string;
  TypeEcriture?: string;
  sessionChoixModel?: SessionChoixDevisBenefModelDtoInput;
};

export type VerifCoherenceLivraisonModel = {
  __typename?: 'VerifCoherenceLivraisonModel';
  IdCommande?: number;
  IdLigneCommande?: number;
  Raison?: string;
};

export type VerifCoherenceLivraisonModelInput = {
  IdCommande?: number;
  IdLigneCommande?: number;
  Raison?: string;
};

export type VerifEtAjoutLigneDevisModelDtoInput = {
  ArticleModel?: ArticleVenteModeleDtoInput;
  DateReapproFamille?: any;
  DateReapproProduit?: any;
  EnteteDevis?: EnteteDevisCommandeForVentesModeleDtoInput;
  IdBenef?: number;
  IdStock?: number;
  IsContexteLocation?: boolean;
  ListeSoumissionFormulaire?: ArrayOfSoumissionFormulaireModelInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbLigneDevis?: number;
  QteDevis?: number;
  QteTotale?: number;
  Status?: StatusDtoEnum;
  StatutLigne?: string;
};

export type VerifGeneUniqueExpAncvModelDto = {
  __typename?: 'VerifGeneUniqueExpANCVModelDTO';
  IsAllArticleHaveModeEnvoi?: boolean;
  IsAllArticlePrixPublicCorrect?: boolean;
  IsCodeClientFourParam?: boolean;
  LengthCodeClientFournisseur?: number;
  ListeBenefInvalideANCVConnect?: ArrayOfLigneCommandeValidationAncvConnectModel;
};

export type VerifGeneUniqueExpAncvModelDtoInput = {
  IsAllArticleHaveModeEnvoi?: boolean;
  IsAllArticlePrixPublicCorrect?: boolean;
  IsCodeClientFourParam?: boolean;
  LengthCodeClientFournisseur?: number;
  ListeBenefInvalideANCVConnect?: ArrayOfLigneCommandeValidationAncvConnectModelInput;
};

export type VerifMontatRestantAvoirDto = {
  __typename?: 'VerifMontatRestantAvoirDTO';
  DifferenceFactureAvoir?: number;
  ListeNumAvoirEtMontant?: ArrayOfstring;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type VerifMontatRestantAvoirDtoInput = {
  DifferenceFactureAvoir?: number;
  ListeNumAvoirEtMontant?: ArrayOfstringInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type VerifRepartitionMouvementModelInput = {
  CodeJournalEcriture?: string;
  DateEcriture?: any;
  IdMouvement?: number;
  LibelleMouvement?: string;
  MontantMouvement?: number;
  MontantRepartition?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  SensMouvement?: string;
  Status?: StatusDtoEnum;
};

export type VerifSiteForExportAncvModel = {
  __typename?: 'VerifSiteForExportANCVModel';
  ListeBenefInvalideANCVConnect?: ArrayOfLigneCommandeValidationAncvConnectModel;
  ListeSiteInfos?: ArrayOfSiteForExportAncvModelDto;
};

export type VerifSiteForExportAncvModelInput = {
  ListeBenefInvalideANCVConnect?: ArrayOfLigneCommandeValidationAncvConnectModelInput;
  ListeSiteInfos?: ArrayOfSiteForExportAncvModelDtoInput;
};

export type VerificationRepartitionModel = {
  __typename?: 'VerificationRepartitionModel';
  ListeArticleErreur?: ArrayOfanyType;
  ListeEcritureWithLettrageError?: ArrayOfdecimal;
  ListeMouvementCollectifSansTiers?: ArrayOfanyType;
  ListeMouvementErreur?: ArrayOfanyType;
  MessageErreur?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type VerificationRepartitionModelInput = {
  ListeArticleErreur?: ArrayOfanyTypeInput;
  ListeEcritureWithLettrageError?: ArrayOfdecimalInput;
  ListeMouvementCollectifSansTiers?: ArrayOfanyTypeInput;
  ListeMouvementErreur?: ArrayOfanyTypeInput;
  MessageErreur?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type VerificationSuppresionPlanEtSectionModelDto = {
  __typename?: 'VerificationSuppresionPlanEtSectionModelDTO';
  MessageCloturable?: string;
  MessageSupprimable?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type VerificationSuppresionPlanEtSectionModelDtoInput = {
  MessageCloturable?: string;
  MessageSupprimable?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type VerificationUniciteBeneficiaireModelInput = {
  IdBeneficiaire?: number;
  Login?: string;
  Matricule?: string;
  Nom?: string;
  Prenom?: string;
};

export type VilleDto = {
  __typename?: 'VilleDTO';
  Cloture?: boolean;
  CodeInsee?: string;
  CodePostal?: string;
  Departement?: DepartementDto;
  Id?: number;
  Latitude?: number;
  Libelle?: string;
  Longitude?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Pays?: PaysDto;
  Status?: StatusDtoEnum;
};

export type VilleDtoInput = {
  Cloture?: boolean;
  CodeInsee?: string;
  CodePostal?: string;
  Departement?: DepartementDtoInput;
  Id?: number;
  Latitude?: number;
  Libelle?: string;
  Longitude?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Pays?: PaysDtoInput;
  Status?: StatusDtoEnum;
};

export enum VisionPlanComptableEnum {
  A = 'A',
  Beneficiaire = 'Beneficiaire',
  C = 'C',
  Ct = 'Ct',
  Fournisseur = 'Fournisseur'
}

export type VueChampVueDto = {
  __typename?: 'VueChampVueDTO';
  DataProfil?: FicheProfilDataDirectoDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Vue?: VueDto;
  Width?: number;
};

export type VueChampVueDtoInput = {
  DataProfil?: FicheProfilDataDirectoDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Ordre?: number;
  Status?: StatusDtoEnum;
  Vue?: VueDtoInput;
  Width?: number;
};

export type VueDto = {
  __typename?: 'VueDTO';
  Code?: string;
  Delegation?: CeDelegationDto;
  Desc?: string;
  Id?: number;
  IdcPriv?: boolean;
  IsSupprime?: boolean;
  IsVueAdministrateur?: boolean;
  Libelle?: string;
  ListeChampVue?: ArrayOfVueChampVueDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: UsersDto;
};

export type VueDtoInput = {
  Code?: string;
  Delegation?: CeDelegationDtoInput;
  Desc?: string;
  Id?: number;
  IdcPriv?: boolean;
  IsSupprime?: boolean;
  IsVueAdministrateur?: boolean;
  Libelle?: string;
  ListeChampVue?: ArrayOfVueChampVueDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  User?: UsersDtoInput;
};

export type VuePubliVueChampModel = {
  __typename?: 'VuePubliVueChampModel';
  IdTypePublipostage?: number;
  IdVue?: number;
  IsDefaut?: boolean;
  LibelleVue?: string;
  ListeChamps?: ArrayOfanyType;
};

export type VuePubliVueChampModelInput = {
  IdTypePublipostage?: number;
  IdVue?: number;
  IsDefaut?: boolean;
  LibelleVue?: string;
  ListeChamps?: ArrayOfanyTypeInput;
};

export type WidgetAccueilDto = {
  __typename?: 'WidgetAccueilDTO';
  Cooldown?: number;
  Delegation?: CeDelegationDto;
  Id?: number;
  ListeParamsDefinis?: ArrayOfWidgetAccueilParamDto;
  MustValidate?: boolean;
  MyGuid?: string;
  PositionX?: number;
  PositionY?: number;
  Ressource?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
  User?: UsersDto;
  Widget?: WidgetDto;
};

export type WidgetAccueilDtoInput = {
  Cooldown?: number;
  Delegation?: CeDelegationDtoInput;
  Id?: number;
  ListeParamsDefinis?: ArrayOfWidgetAccueilParamDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  PositionX?: number;
  PositionY?: number;
  Ressource?: string;
  Status?: StatusDtoEnum;
  Titre?: string;
  User?: UsersDtoInput;
  Widget?: WidgetDtoInput;
};

export type WidgetAccueilParamDto = {
  __typename?: 'WidgetAccueilParamDTO';
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
  WidgetAccueil?: WidgetAccueilDto;
  WidgetParam?: WidgetParamDto;
};

export type WidgetAccueilParamDtoInput = {
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
  WidgetAccueil?: WidgetAccueilDtoInput;
  WidgetParam?: WidgetParamDtoInput;
};

export type WidgetDto = {
  __typename?: 'WidgetDTO';
  CheminImage?: PictoDto;
  CodeM?: string;
  Cooldown?: number;
  Description?: string;
  Id?: number;
  Libelle?: string;
  ListeParams?: ArrayOfWidgetParamDto;
  ListeWidgetsAccueil?: ArrayOfWidgetAccueilDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NomClasse?: string;
  NombreCasesX?: number;
  NombreCasesY?: number;
  Ressource?: string;
  Status?: StatusDtoEnum;
};

export type WidgetDtoInput = {
  CheminImage?: PictoDtoInput;
  CodeM?: string;
  Cooldown?: number;
  Description?: string;
  Id?: number;
  Libelle?: string;
  ListeParams?: ArrayOfWidgetParamDtoInput;
  ListeWidgetsAccueil?: ArrayOfWidgetAccueilDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NomClasse?: string;
  NombreCasesX?: number;
  NombreCasesY?: number;
  Ressource?: string;
  Status?: StatusDtoEnum;
};

export type WidgetFacturesModelDto = {
  __typename?: 'WidgetFacturesModelDTO';
  BenefConcerne?: string;
  DateFacture?: any;
  IdFacture?: number;
  MontantFacture?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroFacture?: string;
  ObjetFacture?: string;
  SoldeRestant?: number;
  Status?: StatusDtoEnum;
};

export type WidgetFacturesModelDtoInput = {
  BenefConcerne?: string;
  DateFacture?: any;
  IdFacture?: number;
  MontantFacture?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  NumeroFacture?: string;
  ObjetFacture?: string;
  SoldeRestant?: number;
  Status?: StatusDtoEnum;
};

export type WidgetInfosBeneficiairesDto = {
  __typename?: 'WidgetInfosBeneficiairesDTO';
  ListeParametres?: ArrayOfWidgetParametreModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  WidgetInfosBenefModel?: WidgetInfosBeneficiairesModelDto;
};

export type WidgetInfosBeneficiairesDtoInput = {
  ListeParametres?: ArrayOfWidgetParametreModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  WidgetInfosBenefModel?: WidgetInfosBeneficiairesModelDtoInput;
};

export type WidgetInfosBeneficiairesModelDto = {
  __typename?: 'WidgetInfosBeneficiairesModelDTO';
  ListeInfosBeneficiairesModel?: ArrayOfInfosBeneficiairesModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  NbAD?: number;
  NbConjoints?: number;
  NbEnfants?: number;
  NbEntrant?: number;
  NbExternes?: number;
  NbOD?: number;
  NbSortant?: number;
  Status?: StatusDtoEnum;
};

export type WidgetInfosBeneficiairesModelDtoInput = {
  ListeInfosBeneficiairesModel?: ArrayOfInfosBeneficiairesModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  NbAD?: number;
  NbConjoints?: number;
  NbEnfants?: number;
  NbEntrant?: number;
  NbExternes?: number;
  NbOD?: number;
  NbSortant?: number;
  Status?: StatusDtoEnum;
};

export type WidgetListeFacturesDto = {
  __typename?: 'WidgetListeFacturesDTO';
  ListeFactures?: ArrayOfWidgetFacturesModelDto;
  ListeParametres?: ArrayOfWidgetParametreModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TotalFactures?: number;
};

export type WidgetListeFacturesDtoInput = {
  ListeFactures?: ArrayOfWidgetFacturesModelDtoInput;
  ListeParametres?: ArrayOfWidgetParametreModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TotalFactures?: number;
};

export type WidgetParamDto = {
  __typename?: 'WidgetParamDTO';
  CodeL?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ValeurDefaut?: string;
  Widget?: WidgetDto;
};

export type WidgetParamDtoInput = {
  CodeL?: string;
  Id?: number;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  ValeurDefaut?: string;
  Widget?: WidgetDtoInput;
};

export type WidgetParametreModelDto = {
  __typename?: 'WidgetParametreModelDTO';
  CodeParametre?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type WidgetParametreModelDtoInput = {
  CodeParametre?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  Valeur?: string;
};

export type WidgetProfilModel = {
  __typename?: 'WidgetProfilModel';
  CodeWidget?: string;
  DescriptionWidget?: string;
  IdWidget?: number;
  ImageWidget?: string;
  IsChecked?: boolean;
  LibelleWidget?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type WidgetProfilModelInput = {
  CodeWidget?: string;
  DescriptionWidget?: string;
  IdWidget?: number;
  ImageWidget?: string;
  IsChecked?: boolean;
  LibelleWidget?: string;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
};

export type WidgetStatsBeneficiairesDto = {
  __typename?: 'WidgetStatsBeneficiairesDTO';
  CurrenteCritere?: string;
  ListeDonnees?: ArrayOfGraphiqueModelDto;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeGraph?: TypeGrapheEnum;
};

export type WidgetStatsBeneficiairesDtoInput = {
  CurrenteCritere?: string;
  ListeDonnees?: ArrayOfGraphiqueModelDtoInput;
  MustValidate?: boolean;
  MyGuid?: string;
  Status?: StatusDtoEnum;
  TypeGraph?: TypeGrapheEnum;
};
